(function (scope) {
  'use strict';

  function F(arity, fun, wrapper) {
    wrapper.a = arity;
    wrapper.f = fun;
    return wrapper;
  }
  function F2(fun) {
    return F(2, fun, function (a) {
      return function (b) {
        return fun(a, b);
      };
    });
  }
  function F3(fun) {
    return F(3, fun, function (a) {
      return function (b) {
        return function (c) {
          return fun(a, b, c);
        };
      };
    });
  }
  function F4(fun) {
    return F(4, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return fun(a, b, c, d);
          };
        };
      };
    });
  }
  function F5(fun) {
    return F(5, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return function (e) {
              return fun(a, b, c, d, e);
            };
          };
        };
      };
    });
  }
  function F6(fun) {
    return F(6, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return function (e) {
              return function (f) {
                return fun(a, b, c, d, e, f);
              };
            };
          };
        };
      };
    });
  }
  function F7(fun) {
    return F(7, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return function (e) {
              return function (f) {
                return function (g) {
                  return fun(a, b, c, d, e, f, g);
                };
              };
            };
          };
        };
      };
    });
  }
  function F8(fun) {
    return F(8, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return function (e) {
              return function (f) {
                return function (g) {
                  return function (h) {
                    return fun(a, b, c, d, e, f, g, h);
                  };
                };
              };
            };
          };
        };
      };
    });
  }
  function F9(fun) {
    return F(9, fun, function (a) {
      return function (b) {
        return function (c) {
          return function (d) {
            return function (e) {
              return function (f) {
                return function (g) {
                  return function (h) {
                    return function (i) {
                      return fun(a, b, c, d, e, f, g, h, i);
                    };
                  };
                };
              };
            };
          };
        };
      };
    });
  }
  function A2(fun, a, b) {
    return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
  }
  function A3(fun, a, b, c) {
    return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
  }
  function A4(fun, a, b, c, d) {
    return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
  }
  function A5(fun, a, b, c, d, e) {
    return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
  }
  function A6(fun, a, b, c, d, e, f) {
    return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
  }
  function A7(fun, a, b, c, d, e, f, g) {
    return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
  }
  function A8(fun, a, b, c, d, e, f, g, h) {
    return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
  }
  function A9(fun, a, b, c, d, e, f, g, h, i) {
    return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
  }
  var _JsArray_empty = [];
  function _JsArray_singleton(value) {
    return [value];
  }
  function _JsArray_length(array) {
    return array.length;
  }
  var _JsArray_initialize = F3(function (size, offset, func) {
    var result = new Array(size);
    for (var i = 0; i < size; i++) {
      result[i] = func(offset + i);
    }
    return result;
  });
  var _JsArray_initializeFromList = F2(function (max, ls) {
    var result = new Array(max);
    for (var i = 0; i < max && ls.b; i++) {
      result[i] = ls.a;
      ls = ls.b;
    }
    result.length = i;
    return _Utils_Tuple2(result, ls);
  });
  var _JsArray_unsafeGet = F2(function (index, array) {
    return array[index];
  });
  var _JsArray_unsafeSet = F3(function (index, value, array) {
    var length = array.length;
    var result = new Array(length);
    for (var i = 0; i < length; i++) {
      result[i] = array[i];
    }
    result[index] = value;
    return result;
  });
  var _JsArray_push = F2(function (value, array) {
    var length = array.length;
    var result = new Array(length + 1);
    for (var i = 0; i < length; i++) {
      result[i] = array[i];
    }
    result[length] = value;
    return result;
  });
  var _JsArray_foldl = F3(function (func, acc, array) {
    var length = array.length;
    for (var i = 0; i < length; i++) {
      acc = A2(func, array[i], acc);
    }
    return acc;
  });
  var _JsArray_foldr = F3(function (func, acc, array) {
    for (var i = array.length - 1; i >= 0; i--) {
      acc = A2(func, array[i], acc);
    }
    return acc;
  });
  var _JsArray_map = F2(function (func, array) {
    var length = array.length;
    var result = new Array(length);
    for (var i = 0; i < length; i++) {
      result[i] = func(array[i]);
    }
    return result;
  });
  var _JsArray_indexedMap = F3(function (func, offset, array) {
    var length = array.length;
    var result = new Array(length);
    for (var i = 0; i < length; i++) {
      result[i] = A2(func, offset + i, array[i]);
    }
    return result;
  });
  var _JsArray_slice = F3(function (from, to, array) {
    return array.slice(from, to);
  });
  var _JsArray_appendN = F3(function (n, dest, source) {
    var destLen = dest.length;
    var itemsToCopy = n - destLen;
    if (itemsToCopy > source.length) {
      itemsToCopy = source.length;
    }
    var size = destLen + itemsToCopy;
    var result = new Array(size);
    for (var i = 0; i < destLen; i++) {
      result[i] = dest[i];
    }
    for (var i = 0; i < itemsToCopy; i++) {
      result[i + destLen] = source[i];
    }
    return result;
  });

  // LOG

  var _Debug_log = F2(function (tag, value) {
    return value;
  });
  var _Debug_log_UNUSED = F2(function (tag, value) {
    console.log(tag + ': ' + _Debug_toString(value));
    return value;
  });

  // TODOS

  function _Debug_todo(moduleName, region) {
    return function (message) {
      _Debug_crash(8, moduleName, region, message);
    };
  }
  function _Debug_todoCase(moduleName, region, value) {
    return function (message) {
      _Debug_crash(9, moduleName, region, value, message);
    };
  }

  // TO STRING

  function _Debug_toString(value) {
    return '<internals>';
  }
  function _Debug_toString_UNUSED(value) {
    return _Debug_toAnsiString(false, value);
  }
  function _Debug_toAnsiString(ansi, value) {
    if (typeof value === 'function') {
      return _Debug_internalColor(ansi, '<function>');
    }
    if (typeof value === 'boolean') {
      return _Debug_ctorColor(ansi, value ? 'True' : 'False');
    }
    if (typeof value === 'number') {
      return _Debug_numberColor(ansi, value + '');
    }
    if (value instanceof String) {
      return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
    }
    if (typeof value === 'string') {
      return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
    }
    if (typeof value === 'object' && '$' in value) {
      var tag = value.$;
      if (typeof tag === 'number') {
        return _Debug_internalColor(ansi, '<internals>');
      }
      if (tag[0] === '#') {
        var output = [];
        for (var k in value) {
          if (k === '$') continue;
          output.push(_Debug_toAnsiString(ansi, value[k]));
        }
        return '(' + output.join(',') + ')';
      }
      if (tag === 'Set_elm_builtin') {
        return _Debug_ctorColor(ansi, 'Set') + _Debug_fadeColor(ansi, '.fromList') + ' ' + _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
      }
      if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin') {
        return _Debug_ctorColor(ansi, 'Dict') + _Debug_fadeColor(ansi, '.fromList') + ' ' + _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
      }
      if (tag === 'Array_elm_builtin') {
        return _Debug_ctorColor(ansi, 'Array') + _Debug_fadeColor(ansi, '.fromList') + ' ' + _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
      }
      if (tag === '::' || tag === '[]') {
        var output = '[';
        value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b);
        for (; value.b; value = value.b)
        // WHILE_CONS
        {
          output += ',' + _Debug_toAnsiString(ansi, value.a);
        }
        return output + ']';
      }
      var output = '';
      for (var i in value) {
        if (i === '$') continue;
        var str = _Debug_toAnsiString(ansi, value[i]);
        var c0 = str[0];
        var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
        output += ' ' + (parenless ? str : '(' + str + ')');
      }
      return _Debug_ctorColor(ansi, tag) + output;
    }
    if (typeof DataView === 'function' && value instanceof DataView) {
      return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
    }
    if (typeof File !== 'undefined' && value instanceof File) {
      return _Debug_internalColor(ansi, '<' + value.name + '>');
    }
    if (typeof value === 'object') {
      var output = [];
      for (var key in value) {
        var field = key[0] === '_' ? key.slice(1) : key;
        output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
      }
      if (output.length === 0) {
        return '{}';
      }
      return '{ ' + output.join(', ') + ' }';
    }
    return _Debug_internalColor(ansi, '<internals>');
  }
  function _Debug_addSlashes(str, isChar) {
    var s = str.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/\t/g, '\\t').replace(/\r/g, '\\r').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
    if (isChar) {
      return s.replace(/\'/g, '\\\'');
    } else {
      return s.replace(/\"/g, '\\"');
    }
  }
  function _Debug_ctorColor(ansi, string) {
    return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
  }
  function _Debug_numberColor(ansi, string) {
    return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
  }
  function _Debug_stringColor(ansi, string) {
    return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
  }
  function _Debug_charColor(ansi, string) {
    return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
  }
  function _Debug_fadeColor(ansi, string) {
    return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
  }
  function _Debug_internalColor(ansi, string) {
    return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
  }
  function _Debug_toHexDigit(n) {
    return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
  }

  // CRASH

  function _Debug_crash(identifier) {
    throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
  }
  function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4) {
    switch (identifier) {
      case 0:
        throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');
      case 1:
        throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');
      case 2:
        var jsonErrorString = fact1;
        throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);
      case 3:
        var portName = fact1;
        throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');
      case 4:
        var portName = fact1;
        var problem = fact2;
        throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);
      case 5:
        throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');
      case 6:
        var moduleName = fact1;
        throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');
      case 8:
        var moduleName = fact1;
        var region = fact2;
        var message = fact3;
        throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);
      case 9:
        var moduleName = fact1;
        var region = fact2;
        var value = fact3;
        var message = fact4;
        throw new Error('TODO in module `' + moduleName + '` from the `case` expression ' + _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    ' + _Debug_toString(value).replace('\n', '\n    ') + '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    '));
      case 10:
        throw new Error('Bug in https://github.com/elm/virtual-dom/issues');
      case 11:
        throw new Error('Cannot perform mod 0. Division by zero error.');
    }
  }
  function _Debug_regionToString(region) {
    if (region.eL.xI === region.dY.xI) {
      return 'on line ' + region.eL.xI;
    }
    return 'on lines ' + region.eL.xI + ' through ' + region.dY.xI;
  }

  // EQUALITY

  function _Utils_eq(x, y) {
    for (var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack); isEqual && (pair = stack.pop()); isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)) {}
    return isEqual;
  }
  function _Utils_eqHelp(x, y, depth, stack) {
    if (x === y) {
      return true;
    }
    if (typeof x !== 'object' || x === null || y === null) {
      typeof x === 'function' && _Debug_crash(5);
      return false;
    }
    if (depth > 100) {
      stack.push(_Utils_Tuple2(x, y));
      return true;
    }

    /**_UNUSED/
    if (x.$ === 'Set_elm_builtin')
    {
    	x = $elm$core$Set$toList(x);
    	y = $elm$core$Set$toList(y);
    }
    if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
    {
    	x = $elm$core$Dict$toList(x);
    	y = $elm$core$Dict$toList(y);
    }
    //*/

    /**/
    if (x.$ < 0) {
      x = $elm$core$Dict$toList(x);
      y = $elm$core$Dict$toList(y);
    }
    //*/

    for (var key in x) {
      if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack)) {
        return false;
      }
    }
    return true;
  }
  var _Utils_equal = F2(_Utils_eq);
  var _Utils_notEqual = F2(function (a, b) {
    return !_Utils_eq(a, b);
  });

  // COMPARISONS

  // Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
  // the particular integer values assigned to LT, EQ, and GT.

  function _Utils_cmp(x, y, ord) {
    if (typeof x !== 'object') {
      return x === y ? /*EQ*/0 : x < y ? /*LT*/-1 : /*GT*/1;
    }

    /**_UNUSED/
    if (x instanceof String)
    {
    	var a = x.valueOf();
    	var b = y.valueOf();
    	return a === b ? 0 : a < b ? -1 : 1;
    }
    //*/

    /**/
    if (typeof x.$ === 'undefined')
      //*/
      /**_UNUSED/
      if (x.$[0] === '#')
      //*/
      {
        return (ord = _Utils_cmp(x.a, y.a)) ? ord : (ord = _Utils_cmp(x.b, y.b)) ? ord : _Utils_cmp(x.c, y.c);
      }

    // traverse conses until end of a list or a mismatch
    for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
    return ord || (x.b ? /*GT*/1 : y.b ? /*LT*/-1 : /*EQ*/0);
  }
  var _Utils_lt = F2(function (a, b) {
    return _Utils_cmp(a, b) < 0;
  });
  var _Utils_le = F2(function (a, b) {
    return _Utils_cmp(a, b) < 1;
  });
  var _Utils_gt = F2(function (a, b) {
    return _Utils_cmp(a, b) > 0;
  });
  var _Utils_ge = F2(function (a, b) {
    return _Utils_cmp(a, b) >= 0;
  });
  var _Utils_compare = F2(function (x, y) {
    var n = _Utils_cmp(x, y);
    return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
  });

  // COMMON VALUES

  var _Utils_Tuple0 = 0;
  var _Utils_Tuple0_UNUSED = {
    $: '#0'
  };
  function _Utils_Tuple2(a, b) {
    return {
      a: a,
      b: b
    };
  }
  function _Utils_Tuple2_UNUSED(a, b) {
    return {
      $: '#2',
      a: a,
      b: b
    };
  }
  function _Utils_Tuple3(a, b, c) {
    return {
      a: a,
      b: b,
      c: c
    };
  }
  function _Utils_Tuple3_UNUSED(a, b, c) {
    return {
      $: '#3',
      a: a,
      b: b,
      c: c
    };
  }
  function _Utils_chr(c) {
    return c;
  }
  function _Utils_chr_UNUSED(c) {
    return new String(c);
  }

  // RECORDS

  function _Utils_update(oldRecord, updatedFields) {
    var newRecord = {};
    for (var key in oldRecord) {
      newRecord[key] = oldRecord[key];
    }
    for (var key in updatedFields) {
      newRecord[key] = updatedFields[key];
    }
    return newRecord;
  }

  // APPEND

  var _Utils_append = F2(_Utils_ap);
  function _Utils_ap(xs, ys) {
    // append Strings
    if (typeof xs === 'string') {
      return xs + ys;
    }

    // append Lists
    if (!xs.b) {
      return ys;
    }
    var root = _List_Cons(xs.a, ys);
    xs = xs.b;
    for (var curr = root; xs.b; xs = xs.b)
    // WHILE_CONS
    {
      curr = curr.b = _List_Cons(xs.a, ys);
    }
    return root;
  }
  var _List_Nil = {
    $: 0
  };
  var _List_Nil_UNUSED = {
    $: '[]'
  };
  function _List_Cons(hd, tl) {
    return {
      $: 1,
      a: hd,
      b: tl
    };
  }
  function _List_Cons_UNUSED(hd, tl) {
    return {
      $: '::',
      a: hd,
      b: tl
    };
  }
  var _List_cons = F2(_List_Cons);
  function _List_fromArray(arr) {
    var out = _List_Nil;
    for (var i = arr.length; i--;) {
      out = _List_Cons(arr[i], out);
    }
    return out;
  }
  function _List_toArray(xs) {
    for (var out = []; xs.b; xs = xs.b)
    // WHILE_CONS
    {
      out.push(xs.a);
    }
    return out;
  }
  var _List_map2 = F3(function (f, xs, ys) {
    for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b)
    // WHILE_CONSES
    {
      arr.push(A2(f, xs.a, ys.a));
    }
    return _List_fromArray(arr);
  });
  var _List_map3 = F4(function (f, xs, ys, zs) {
    for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b)
    // WHILE_CONSES
    {
      arr.push(A3(f, xs.a, ys.a, zs.a));
    }
    return _List_fromArray(arr);
  });
  var _List_map4 = F5(function (f, ws, xs, ys, zs) {
    for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b)
    // WHILE_CONSES
    {
      arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
    }
    return _List_fromArray(arr);
  });
  var _List_map5 = F6(function (f, vs, ws, xs, ys, zs) {
    for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b)
    // WHILE_CONSES
    {
      arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
    }
    return _List_fromArray(arr);
  });
  var _List_sortBy = F2(function (f, xs) {
    return _List_fromArray(_List_toArray(xs).sort(function (a, b) {
      return _Utils_cmp(f(a), f(b));
    }));
  });
  var _List_sortWith = F2(function (f, xs) {
    return _List_fromArray(_List_toArray(xs).sort(function (a, b) {
      var ord = A2(f, a, b);
      return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
    }));
  });

  // MATH

  var _Basics_add = F2(function (a, b) {
    return a + b;
  });
  var _Basics_sub = F2(function (a, b) {
    return a - b;
  });
  var _Basics_mul = F2(function (a, b) {
    return a * b;
  });
  var _Basics_fdiv = F2(function (a, b) {
    return a / b;
  });
  var _Basics_idiv = F2(function (a, b) {
    return a / b | 0;
  });
  var _Basics_pow = F2(Math.pow);
  var _Basics_remainderBy = F2(function (b, a) {
    return a % b;
  });

  // https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
  var _Basics_modBy = F2(function (modulus, x) {
    var answer = x % modulus;
    return modulus === 0 ? _Debug_crash(11) : answer > 0 && modulus < 0 || answer < 0 && modulus > 0 ? answer + modulus : answer;
  });

  // TRIGONOMETRY

  var _Basics_pi = Math.PI;
  var _Basics_e = Math.E;
  var _Basics_cos = Math.cos;
  var _Basics_sin = Math.sin;
  var _Basics_tan = Math.tan;
  var _Basics_acos = Math.acos;
  var _Basics_asin = Math.asin;
  var _Basics_atan = Math.atan;
  var _Basics_atan2 = F2(Math.atan2);

  // MORE MATH

  function _Basics_toFloat(x) {
    return x;
  }
  function _Basics_truncate(n) {
    return n | 0;
  }
  function _Basics_isInfinite(n) {
    return n === Infinity || n === -Infinity;
  }
  var _Basics_ceiling = Math.ceil;
  var _Basics_floor = Math.floor;
  var _Basics_round = Math.round;
  var _Basics_sqrt = Math.sqrt;
  var _Basics_log = Math.log;
  var _Basics_isNaN = isNaN;

  // BOOLEANS

  function _Basics_not(bool) {
    return !bool;
  }
  var _Basics_and = F2(function (a, b) {
    return a && b;
  });
  var _Basics_or = F2(function (a, b) {
    return a || b;
  });
  var _Basics_xor = F2(function (a, b) {
    return a !== b;
  });
  var _String_cons = F2(function (chr, str) {
    return chr + str;
  });
  function _String_uncons(string) {
    var word = string.charCodeAt(0);
    return !isNaN(word) ? $elm$core$Maybe$Just(0xD800 <= word && word <= 0xDBFF ? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2)) : _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))) : $elm$core$Maybe$Nothing;
  }
  var _String_append = F2(function (a, b) {
    return a + b;
  });
  function _String_length(str) {
    return str.length;
  }
  var _String_map = F2(function (func, string) {
    var len = string.length;
    var array = new Array(len);
    var i = 0;
    while (i < len) {
      var word = string.charCodeAt(i);
      if (0xD800 <= word && word <= 0xDBFF) {
        array[i] = func(_Utils_chr(string[i] + string[i + 1]));
        i += 2;
        continue;
      }
      array[i] = func(_Utils_chr(string[i]));
      i++;
    }
    return array.join('');
  });
  var _String_filter = F2(function (isGood, str) {
    var arr = [];
    var len = str.length;
    var i = 0;
    while (i < len) {
      var char = str[i];
      var word = str.charCodeAt(i);
      i++;
      if (0xD800 <= word && word <= 0xDBFF) {
        char += str[i];
        i++;
      }
      if (isGood(_Utils_chr(char))) {
        arr.push(char);
      }
    }
    return arr.join('');
  });
  function _String_reverse(str) {
    var len = str.length;
    var arr = new Array(len);
    var i = 0;
    while (i < len) {
      var word = str.charCodeAt(i);
      if (0xD800 <= word && word <= 0xDBFF) {
        arr[len - i] = str[i + 1];
        i++;
        arr[len - i] = str[i - 1];
        i++;
      } else {
        arr[len - i] = str[i];
        i++;
      }
    }
    return arr.join('');
  }
  var _String_foldl = F3(function (func, state, string) {
    var len = string.length;
    var i = 0;
    while (i < len) {
      var char = string[i];
      var word = string.charCodeAt(i);
      i++;
      if (0xD800 <= word && word <= 0xDBFF) {
        char += string[i];
        i++;
      }
      state = A2(func, _Utils_chr(char), state);
    }
    return state;
  });
  var _String_foldr = F3(function (func, state, string) {
    var i = string.length;
    while (i--) {
      var char = string[i];
      var word = string.charCodeAt(i);
      if (0xDC00 <= word && word <= 0xDFFF) {
        i--;
        char = string[i] + char;
      }
      state = A2(func, _Utils_chr(char), state);
    }
    return state;
  });
  var _String_split = F2(function (sep, str) {
    return str.split(sep);
  });
  var _String_join = F2(function (sep, strs) {
    return strs.join(sep);
  });
  var _String_slice = F3(function (start, end, str) {
    return str.slice(start, end);
  });
  function _String_trim(str) {
    return str.trim();
  }
  function _String_trimLeft(str) {
    return str.replace(/^\s+/, '');
  }
  function _String_trimRight(str) {
    return str.replace(/\s+$/, '');
  }
  function _String_words(str) {
    return _List_fromArray(str.trim().split(/\s+/g));
  }
  function _String_lines(str) {
    return _List_fromArray(str.split(/\r\n|\r|\n/g));
  }
  function _String_toUpper(str) {
    return str.toUpperCase();
  }
  function _String_toLower(str) {
    return str.toLowerCase();
  }
  var _String_any = F2(function (isGood, string) {
    var i = string.length;
    while (i--) {
      var char = string[i];
      var word = string.charCodeAt(i);
      if (0xDC00 <= word && word <= 0xDFFF) {
        i--;
        char = string[i] + char;
      }
      if (isGood(_Utils_chr(char))) {
        return true;
      }
    }
    return false;
  });
  var _String_all = F2(function (isGood, string) {
    var i = string.length;
    while (i--) {
      var char = string[i];
      var word = string.charCodeAt(i);
      if (0xDC00 <= word && word <= 0xDFFF) {
        i--;
        char = string[i] + char;
      }
      if (!isGood(_Utils_chr(char))) {
        return false;
      }
    }
    return true;
  });
  var _String_contains = F2(function (sub, str) {
    return str.indexOf(sub) > -1;
  });
  var _String_startsWith = F2(function (sub, str) {
    return str.indexOf(sub) === 0;
  });
  var _String_endsWith = F2(function (sub, str) {
    return str.length >= sub.length && str.lastIndexOf(sub) === str.length - sub.length;
  });
  var _String_indexes = F2(function (sub, str) {
    var subLen = sub.length;
    if (subLen < 1) {
      return _List_Nil;
    }
    var i = 0;
    var is = [];
    while ((i = str.indexOf(sub, i)) > -1) {
      is.push(i);
      i = i + subLen;
    }
    return _List_fromArray(is);
  });

  // TO STRING

  function _String_fromNumber(number) {
    return number + '';
  }

  // INT CONVERSIONS

  function _String_toInt(str) {
    var total = 0;
    var code0 = str.charCodeAt(0);
    var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;
    for (var i = start; i < str.length; ++i) {
      var code = str.charCodeAt(i);
      if (code < 0x30 || 0x39 < code) {
        return $elm$core$Maybe$Nothing;
      }
      total = 10 * total + code - 0x30;
    }
    return i == start ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
  }

  // FLOAT CONVERSIONS

  function _String_toFloat(s) {
    // check if it is a hex, octal, or binary number
    if (s.length === 0 || /[\sxbo]/.test(s)) {
      return $elm$core$Maybe$Nothing;
    }
    var n = +s;
    // faster isNaN check
    return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
  }
  function _String_fromList(chars) {
    return _List_toArray(chars).join('');
  }
  function _Char_toCode(char) {
    var code = char.charCodeAt(0);
    if (0xD800 <= code && code <= 0xDBFF) {
      return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000;
    }
    return code;
  }
  function _Char_fromCode(code) {
    return _Utils_chr(code < 0 || 0x10FFFF < code ? '\uFFFD' : code <= 0xFFFF ? String.fromCharCode(code) : (code -= 0x10000, String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)));
  }
  function _Char_toUpper(char) {
    return _Utils_chr(char.toUpperCase());
  }
  function _Char_toLower(char) {
    return _Utils_chr(char.toLowerCase());
  }
  function _Char_toLocaleUpper(char) {
    return _Utils_chr(char.toLocaleUpperCase());
  }
  function _Char_toLocaleLower(char) {
    return _Utils_chr(char.toLocaleLowerCase());
  }

  /**_UNUSED/
  function _Json_errorToString(error)
  {
  	return $elm$json$Json$Decode$errorToString(error);
  }
  //*/

  // CORE DECODERS

  function _Json_succeed(msg) {
    return {
      $: 0,
      a: msg
    };
  }
  function _Json_fail(msg) {
    return {
      $: 1,
      a: msg
    };
  }
  function _Json_decodePrim(decoder) {
    return {
      $: 2,
      b: decoder
    };
  }
  var _Json_decodeInt = _Json_decodePrim(function (value) {
    return typeof value !== 'number' ? _Json_expecting('an INT', value) : -2147483647 < value && value < 2147483647 && (value | 0) === value ? $elm$core$Result$Ok(value) : isFinite(value) && !(value % 1) ? $elm$core$Result$Ok(value) : _Json_expecting('an INT', value);
  });
  var _Json_decodeBool = _Json_decodePrim(function (value) {
    return typeof value === 'boolean' ? $elm$core$Result$Ok(value) : _Json_expecting('a BOOL', value);
  });
  var _Json_decodeFloat = _Json_decodePrim(function (value) {
    return typeof value === 'number' ? $elm$core$Result$Ok(value) : _Json_expecting('a FLOAT', value);
  });
  var _Json_decodeValue = _Json_decodePrim(function (value) {
    return $elm$core$Result$Ok(_Json_wrap(value));
  });
  var _Json_decodeString = _Json_decodePrim(function (value) {
    return typeof value === 'string' ? $elm$core$Result$Ok(value) : value instanceof String ? $elm$core$Result$Ok(value + '') : _Json_expecting('a STRING', value);
  });
  function _Json_decodeList(decoder) {
    return {
      $: 3,
      b: decoder
    };
  }
  function _Json_decodeArray(decoder) {
    return {
      $: 4,
      b: decoder
    };
  }
  function _Json_decodeNull(value) {
    return {
      $: 5,
      c: value
    };
  }
  var _Json_decodeField = F2(function (field, decoder) {
    return {
      $: 6,
      d: field,
      b: decoder
    };
  });
  var _Json_decodeIndex = F2(function (index, decoder) {
    return {
      $: 7,
      e: index,
      b: decoder
    };
  });
  function _Json_decodeKeyValuePairs(decoder) {
    return {
      $: 8,
      b: decoder
    };
  }
  function _Json_mapMany(f, decoders) {
    return {
      $: 9,
      f: f,
      g: decoders
    };
  }
  var _Json_andThen = F2(function (callback, decoder) {
    return {
      $: 10,
      b: decoder,
      h: callback
    };
  });
  function _Json_oneOf(decoders) {
    return {
      $: 11,
      g: decoders
    };
  }

  // DECODING OBJECTS

  var _Json_map1 = F2(function (f, d1) {
    return _Json_mapMany(f, [d1]);
  });
  var _Json_map2 = F3(function (f, d1, d2) {
    return _Json_mapMany(f, [d1, d2]);
  });
  var _Json_map3 = F4(function (f, d1, d2, d3) {
    return _Json_mapMany(f, [d1, d2, d3]);
  });
  var _Json_map4 = F5(function (f, d1, d2, d3, d4) {
    return _Json_mapMany(f, [d1, d2, d3, d4]);
  });
  var _Json_map5 = F6(function (f, d1, d2, d3, d4, d5) {
    return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
  });
  var _Json_map6 = F7(function (f, d1, d2, d3, d4, d5, d6) {
    return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
  });
  var _Json_map7 = F8(function (f, d1, d2, d3, d4, d5, d6, d7) {
    return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
  });
  var _Json_map8 = F9(function (f, d1, d2, d3, d4, d5, d6, d7, d8) {
    return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
  });

  // DECODE

  var _Json_runOnString = F2(function (decoder, string) {
    try {
      var value = JSON.parse(string);
      return _Json_runHelp(decoder, value);
    } catch (e) {
      return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
    }
  });
  var _Json_run = F2(function (decoder, value) {
    return _Json_runHelp(decoder, _Json_unwrap(value));
  });
  function _Json_runHelp(decoder, value) {
    switch (decoder.$) {
      case 2:
        return decoder.b(value);
      case 5:
        return value === null ? $elm$core$Result$Ok(decoder.c) : _Json_expecting('null', value);
      case 3:
        if (!_Json_isArray(value)) {
          return _Json_expecting('a LIST', value);
        }
        return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
      case 4:
        if (!_Json_isArray(value)) {
          return _Json_expecting('an ARRAY', value);
        }
        return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
      case 6:
        var field = decoder.d;
        if (typeof value !== 'object' || value === null || !(field in value)) {
          return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
        }
        var result = _Json_runHelp(decoder.b, value[field]);
        return $elm$core$Result$isOk(result) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));
      case 7:
        var index = decoder.e;
        if (!_Json_isArray(value)) {
          return _Json_expecting('an ARRAY', value);
        }
        if (index >= value.length) {
          return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
        }
        var result = _Json_runHelp(decoder.b, value[index]);
        return $elm$core$Result$isOk(result) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));
      case 8:
        if (typeof value !== 'object' || value === null || _Json_isArray(value)) {
          return _Json_expecting('an OBJECT', value);
        }
        var keyValuePairs = _List_Nil;
        // TODO test perf of Object.keys and switch when support is good enough
        for (var key in value) {
          if (value.hasOwnProperty(key)) {
            var result = _Json_runHelp(decoder.b, value[key]);
            if (!$elm$core$Result$isOk(result)) {
              return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
            }
            keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
          }
        }
        return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));
      case 9:
        var answer = decoder.f;
        var decoders = decoder.g;
        for (var i = 0; i < decoders.length; i++) {
          var result = _Json_runHelp(decoders[i], value);
          if (!$elm$core$Result$isOk(result)) {
            return result;
          }
          answer = answer(result.a);
        }
        return $elm$core$Result$Ok(answer);
      case 10:
        var result = _Json_runHelp(decoder.b, value);
        return !$elm$core$Result$isOk(result) ? result : _Json_runHelp(decoder.h(result.a), value);
      case 11:
        var errors = _List_Nil;
        for (var temp = decoder.g; temp.b; temp = temp.b)
        // WHILE_CONS
        {
          var result = _Json_runHelp(temp.a, value);
          if ($elm$core$Result$isOk(result)) {
            return result;
          }
          errors = _List_Cons(result.a, errors);
        }
        return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));
      case 1:
        return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));
      case 0:
        return $elm$core$Result$Ok(decoder.a);
    }
  }
  function _Json_runArrayDecoder(decoder, value, toElmValue) {
    var len = value.length;
    var array = new Array(len);
    for (var i = 0; i < len; i++) {
      var result = _Json_runHelp(decoder, value[i]);
      if (!$elm$core$Result$isOk(result)) {
        return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
      }
      array[i] = result.a;
    }
    return $elm$core$Result$Ok(toElmValue(array));
  }
  function _Json_isArray(value) {
    return Array.isArray(value) || typeof FileList !== 'undefined' && value instanceof FileList;
  }
  function _Json_toElmArray(array) {
    return A2($elm$core$Array$initialize, array.length, function (i) {
      return array[i];
    });
  }
  function _Json_expecting(type, value) {
    return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
  }

  // EQUALITY

  function _Json_equality(x, y) {
    if (x === y) {
      return true;
    }
    if (x.$ !== y.$) {
      return false;
    }
    switch (x.$) {
      case 0:
      case 1:
        return x.a === y.a;
      case 2:
        return x.b === y.b;
      case 5:
        return x.c === y.c;
      case 3:
      case 4:
      case 8:
        return _Json_equality(x.b, y.b);
      case 6:
        return x.d === y.d && _Json_equality(x.b, y.b);
      case 7:
        return x.e === y.e && _Json_equality(x.b, y.b);
      case 9:
        return x.f === y.f && _Json_listEquality(x.g, y.g);
      case 10:
        return x.h === y.h && _Json_equality(x.b, y.b);
      case 11:
        return _Json_listEquality(x.g, y.g);
    }
  }
  function _Json_listEquality(aDecoders, bDecoders) {
    var len = aDecoders.length;
    if (len !== bDecoders.length) {
      return false;
    }
    for (var i = 0; i < len; i++) {
      if (!_Json_equality(aDecoders[i], bDecoders[i])) {
        return false;
      }
    }
    return true;
  }

  // ENCODE

  var _Json_encode = F2(function (indentLevel, value) {
    return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
  });
  function _Json_wrap_UNUSED(value) {
    return {
      $: 0,
      a: value
    };
  }
  function _Json_unwrap_UNUSED(value) {
    return value.a;
  }
  function _Json_wrap(value) {
    return value;
  }
  function _Json_unwrap(value) {
    return value;
  }
  function _Json_emptyArray() {
    return [];
  }
  function _Json_emptyObject() {
    return {};
  }
  var _Json_addField = F3(function (key, value, object) {
    object[key] = _Json_unwrap(value);
    return object;
  });
  function _Json_addEntry(func) {
    return F2(function (entry, array) {
      array.push(_Json_unwrap(func(entry)));
      return array;
    });
  }
  var _Json_encodeNull = _Json_wrap(null);

  // TASKS

  function _Scheduler_succeed(value) {
    return {
      $: 0,
      a: value
    };
  }
  function _Scheduler_fail(error) {
    return {
      $: 1,
      a: error
    };
  }
  function _Scheduler_binding(callback) {
    return {
      $: 2,
      b: callback,
      c: null
    };
  }
  var _Scheduler_andThen = F2(function (callback, task) {
    return {
      $: 3,
      b: callback,
      d: task
    };
  });
  var _Scheduler_onError = F2(function (callback, task) {
    return {
      $: 4,
      b: callback,
      d: task
    };
  });
  function _Scheduler_receive(callback) {
    return {
      $: 5,
      b: callback
    };
  }

  // PROCESSES

  var _Scheduler_guid = 0;
  function _Scheduler_rawSpawn(task) {
    var proc = {
      $: 0,
      e: _Scheduler_guid++,
      f: task,
      g: null,
      h: []
    };
    _Scheduler_enqueue(proc);
    return proc;
  }
  function _Scheduler_spawn(task) {
    return _Scheduler_binding(function (callback) {
      callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
    });
  }
  function _Scheduler_rawSend(proc, msg) {
    proc.h.push(msg);
    _Scheduler_enqueue(proc);
  }
  var _Scheduler_send = F2(function (proc, msg) {
    return _Scheduler_binding(function (callback) {
      _Scheduler_rawSend(proc, msg);
      callback(_Scheduler_succeed(_Utils_Tuple0));
    });
  });
  function _Scheduler_kill(proc) {
    return _Scheduler_binding(function (callback) {
      var task = proc.f;
      if (task.$ === 2 && task.c) {
        task.c();
      }
      proc.f = null;
      callback(_Scheduler_succeed(_Utils_Tuple0));
    });
  }

  /* STEP PROCESSES
  
  type alias Process =
    { $ : tag
    , id : unique_id
    , root : Task
    , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
    , mailbox : [msg]
    }
  
  */

  var _Scheduler_working = false;
  var _Scheduler_queue = [];
  function _Scheduler_enqueue(proc) {
    _Scheduler_queue.push(proc);
    if (_Scheduler_working) {
      return;
    }
    _Scheduler_working = true;
    while (proc = _Scheduler_queue.shift()) {
      _Scheduler_step(proc);
    }
    _Scheduler_working = false;
  }
  function _Scheduler_step(proc) {
    while (proc.f) {
      var rootTag = proc.f.$;
      if (rootTag === 0 || rootTag === 1) {
        while (proc.g && proc.g.$ !== rootTag) {
          proc.g = proc.g.i;
        }
        if (!proc.g) {
          return;
        }
        proc.f = proc.g.b(proc.f.a);
        proc.g = proc.g.i;
      } else if (rootTag === 2) {
        proc.f.c = proc.f.b(function (newRoot) {
          proc.f = newRoot;
          _Scheduler_enqueue(proc);
        });
        return;
      } else if (rootTag === 5) {
        if (proc.h.length === 0) {
          return;
        }
        proc.f = proc.f.b(proc.h.shift());
      } else
        // if (rootTag === 3 || rootTag === 4)
        {
          proc.g = {
            $: rootTag === 3 ? 0 : 1,
            b: proc.f.b,
            i: proc.g
          };
          proc.f = proc.f.d;
        }
    }
  }
  function _Process_sleep(time) {
    return _Scheduler_binding(function (callback) {
      var id = setTimeout(function () {
        callback(_Scheduler_succeed(_Utils_Tuple0));
      }, time);
      return function () {
        clearTimeout(id);
      };
    });
  }

  // PROGRAMS

  var _Platform_worker = F4(function (impl, flagDecoder, debugMetadata, args) {
    return _Platform_initialize(flagDecoder, args, impl.wM, impl.C5, impl.Co, function () {
      return function () {};
    });
  });

  // INITIALIZE A PROGRAM

  function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder) {
    var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
    $elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
    var managers = {};
    var initPair = init(result.a);
    var model = initPair.a;
    var stepper = stepperBuilder(sendToApp, model);
    var ports = _Platform_setupEffects(managers, sendToApp);
    function sendToApp(msg, viewMetadata) {
      var pair = A2(update, msg, model);
      stepper(model = pair.a, viewMetadata);
      _Platform_enqueueEffects(managers, pair.b, subscriptions(model));
    }
    _Platform_enqueueEffects(managers, initPair.b, subscriptions(model));
    return ports ? {
      ports: ports
    } : {};
  }

  // TRACK PRELOADS
  //
  // This is used by code in elm/browser and elm/http
  // to register any HTTP requests that are triggered by init.
  //

  var _Platform_preload;
  function _Platform_registerPreload(url) {
    _Platform_preload.add(url);
  }

  // EFFECT MANAGERS

  var _Platform_effectManagers = {};
  function _Platform_setupEffects(managers, sendToApp) {
    var ports;

    // setup all necessary effect managers
    for (var key in _Platform_effectManagers) {
      var manager = _Platform_effectManagers[key];
      if (manager.a) {
        ports = ports || {};
        ports[key] = manager.a(key, sendToApp);
      }
      managers[key] = _Platform_instantiateManager(manager, sendToApp);
    }
    return ports;
  }
  function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap) {
    return {
      b: init,
      c: onEffects,
      d: onSelfMsg,
      e: cmdMap,
      f: subMap
    };
  }
  function _Platform_instantiateManager(info, sendToApp) {
    var router = {
      g: sendToApp,
      h: undefined
    };
    var onEffects = info.c;
    var onSelfMsg = info.d;
    var cmdMap = info.e;
    var subMap = info.f;
    function loop(state) {
      return A2(_Scheduler_andThen, loop, _Scheduler_receive(function (msg) {
        var value = msg.a;
        if (msg.$ === 0) {
          return A3(onSelfMsg, router, value, state);
        }
        return cmdMap && subMap ? A4(onEffects, router, value.i, value.j, state) : A3(onEffects, router, cmdMap ? value.i : value.j, state);
      }));
    }
    return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
  }

  // ROUTING

  var _Platform_sendToApp = F2(function (router, msg) {
    return _Scheduler_binding(function (callback) {
      router.g(msg);
      callback(_Scheduler_succeed(_Utils_Tuple0));
    });
  });
  var _Platform_sendToSelf = F2(function (router, msg) {
    return A2(_Scheduler_send, router.h, {
      $: 0,
      a: msg
    });
  });

  // BAGS

  function _Platform_leaf(home) {
    return function (value) {
      return {
        $: 1,
        k: home,
        l: value
      };
    };
  }
  function _Platform_batch(list) {
    return {
      $: 2,
      m: list
    };
  }
  var _Platform_map = F2(function (tagger, bag) {
    return {
      $: 3,
      n: tagger,
      o: bag
    };
  });

  // PIPE BAGS INTO EFFECT MANAGERS
  //
  // Effects must be queued!
  //
  // Say your init contains a synchronous command, like Time.now or Time.here
  //
  //   - This will produce a batch of effects (FX_1)
  //   - The synchronous task triggers the subsequent `update` call
  //   - This will produce a batch of effects (FX_2)
  //
  // If we just start dispatching FX_2, subscriptions from FX_2 can be processed
  // before subscriptions from FX_1. No good! Earlier versions of this code had
  // this problem, leading to these reports:
  //
  //   https://github.com/elm/core/issues/980
  //   https://github.com/elm/core/pull/981
  //   https://github.com/elm/compiler/issues/1776
  //
  // The queue is necessary to avoid ordering issues for synchronous commands.

  // Why use true/false here? Why not just check the length of the queue?
  // The goal is to detect "are we currently dispatching effects?" If we
  // are, we need to bail and let the ongoing while loop handle things.
  //
  // Now say the queue has 1 element. When we dequeue the final element,
  // the queue will be empty, but we are still actively dispatching effects.
  // So you could get queue jumping in a really tricky category of cases.
  //
  var _Platform_effectsQueue = [];
  var _Platform_effectsActive = false;
  function _Platform_enqueueEffects(managers, cmdBag, subBag) {
    _Platform_effectsQueue.push({
      p: managers,
      q: cmdBag,
      r: subBag
    });
    if (_Platform_effectsActive) return;
    _Platform_effectsActive = true;
    for (var fx; fx = _Platform_effectsQueue.shift();) {
      _Platform_dispatchEffects(fx.p, fx.q, fx.r);
    }
    _Platform_effectsActive = false;
  }
  function _Platform_dispatchEffects(managers, cmdBag, subBag) {
    var effectsDict = {};
    _Platform_gatherEffects(true, cmdBag, effectsDict, null);
    _Platform_gatherEffects(false, subBag, effectsDict, null);
    for (var home in managers) {
      _Scheduler_rawSend(managers[home], {
        $: 'fx',
        a: effectsDict[home] || {
          i: _List_Nil,
          j: _List_Nil
        }
      });
    }
  }
  function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers) {
    switch (bag.$) {
      case 1:
        var home = bag.k;
        var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
        effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
        return;
      case 2:
        for (var list = bag.m; list.b; list = list.b)
        // WHILE_CONS
        {
          _Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
        }
        return;
      case 3:
        _Platform_gatherEffects(isCmd, bag.o, effectsDict, {
          s: bag.n,
          t: taggers
        });
        return;
    }
  }
  function _Platform_toEffect(isCmd, home, taggers, value) {
    function applyTaggers(x) {
      for (var temp = taggers; temp; temp = temp.t) {
        x = temp.s(x);
      }
      return x;
    }
    var map = isCmd ? _Platform_effectManagers[home].e : _Platform_effectManagers[home].f;
    return A2(map, applyTaggers, value);
  }
  function _Platform_insert(isCmd, newEffect, effects) {
    effects = effects || {
      i: _List_Nil,
      j: _List_Nil
    };
    isCmd ? effects.i = _List_Cons(newEffect, effects.i) : effects.j = _List_Cons(newEffect, effects.j);
    return effects;
  }

  // PORTS

  function _Platform_checkPortName(name) {
    if (_Platform_effectManagers[name]) {
      _Debug_crash(3, name);
    }
  }

  // OUTGOING PORTS

  function _Platform_outgoingPort(name, converter) {
    _Platform_checkPortName(name);
    _Platform_effectManagers[name] = {
      e: _Platform_outgoingPortMap,
      u: converter,
      a: _Platform_setupOutgoingPort
    };
    return _Platform_leaf(name);
  }
  var _Platform_outgoingPortMap = F2(function (tagger, value) {
    return value;
  });
  function _Platform_setupOutgoingPort(name) {
    var subs = [];
    var converter = _Platform_effectManagers[name].u;

    // CREATE MANAGER

    var init = _Process_sleep(0);
    _Platform_effectManagers[name].b = init;
    _Platform_effectManagers[name].c = F3(function (router, cmdList, state) {
      for (; cmdList.b; cmdList = cmdList.b)
      // WHILE_CONS
      {
        // grab a separate reference to subs in case unsubscribe is called
        var currentSubs = subs;
        var value = _Json_unwrap(converter(cmdList.a));
        for (var i = 0; i < currentSubs.length; i++) {
          currentSubs[i](value);
        }
      }
      return init;
    });

    // PUBLIC API

    function subscribe(callback) {
      subs.push(callback);
    }
    function unsubscribe(callback) {
      // copy subs into a new array in case unsubscribe is called within a
      // subscribed callback
      subs = subs.slice();
      var index = subs.indexOf(callback);
      if (index >= 0) {
        subs.splice(index, 1);
      }
    }
    return {
      subscribe: subscribe,
      unsubscribe: unsubscribe
    };
  }

  // INCOMING PORTS

  function _Platform_incomingPort(name, converter) {
    _Platform_checkPortName(name);
    _Platform_effectManagers[name] = {
      f: _Platform_incomingPortMap,
      u: converter,
      a: _Platform_setupIncomingPort
    };
    return _Platform_leaf(name);
  }
  var _Platform_incomingPortMap = F2(function (tagger, finalTagger) {
    return function (value) {
      return tagger(finalTagger(value));
    };
  });
  function _Platform_setupIncomingPort(name, sendToApp) {
    var subs = _List_Nil;
    var converter = _Platform_effectManagers[name].u;

    // CREATE MANAGER

    var init = _Scheduler_succeed(null);
    _Platform_effectManagers[name].b = init;
    _Platform_effectManagers[name].c = F3(function (router, subList, state) {
      subs = subList;
      return init;
    });

    // PUBLIC API

    function send(incomingValue) {
      var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
      $elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
      var value = result.a;
      for (var temp = subs; temp.b; temp = temp.b)
      // WHILE_CONS
      {
        sendToApp(temp.a(value));
      }
    }
    return {
      send: send
    };
  }

  // EXPORT ELM MODULES
  //
  // Have DEBUG and PROD versions so that we can (1) give nicer errors in
  // debug mode and (2) not pay for the bits needed for that in prod mode.
  //

  function _Platform_export(exports) {
    scope['Elm'] ? _Platform_mergeExportsProd(scope['Elm'], exports) : scope['Elm'] = exports;
  }
  function _Platform_mergeExportsProd(obj, exports) {
    for (var name in exports) {
      name in obj ? name == 'init' ? _Debug_crash(6) : _Platform_mergeExportsProd(obj[name], exports[name]) : obj[name] = exports[name];
    }
  }
  function _Platform_export_UNUSED(exports) {
    scope['Elm'] ? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports) : scope['Elm'] = exports;
  }
  function _Platform_mergeExportsDebug(moduleName, obj, exports) {
    for (var name in exports) {
      name in obj ? name == 'init' ? _Debug_crash(6, moduleName) : _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name]) : obj[name] = exports[name];
    }
  }

  // HELPERS

  var _VirtualDom_divertHrefToApp;
  var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};
  function _VirtualDom_appendChild(parent, child) {
    parent.appendChild(child);
  }
  var _VirtualDom_init = F4(function (virtualNode, flagDecoder, debugMetadata, args) {
    // NOTE: this function needs _Platform_export available to work

    /**/
    var node = args['node'];
    //*/
    /**_UNUSED/
    var node = args && args['node'] ? args['node'] : _Debug_crash(0);
    //*/

    node.parentNode.replaceChild(_VirtualDom_render(virtualNode, function () {}), node);
    return {};
  });

  // TEXT

  function _VirtualDom_text(string) {
    return {
      $: 0,
      a: string
    };
  }

  // NODE

  var _VirtualDom_nodeNS = F2(function (namespace, tag) {
    return F2(function (factList, kidList) {
      for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b)
      // WHILE_CONS
      {
        var kid = kidList.a;
        descendantsCount += kid.b || 0;
        kids.push(kid);
      }
      descendantsCount += kids.length;
      return {
        $: 1,
        c: tag,
        d: _VirtualDom_organizeFacts(factList),
        e: kids,
        f: namespace,
        b: descendantsCount
      };
    });
  });
  var _VirtualDom_node = _VirtualDom_nodeNS(undefined);

  // KEYED NODE

  var _VirtualDom_keyedNodeNS = F2(function (namespace, tag) {
    return F2(function (factList, kidList) {
      for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b)
      // WHILE_CONS
      {
        var kid = kidList.a;
        descendantsCount += kid.b.b || 0;
        kids.push(kid);
      }
      descendantsCount += kids.length;
      return {
        $: 2,
        c: tag,
        d: _VirtualDom_organizeFacts(factList),
        e: kids,
        f: namespace,
        b: descendantsCount
      };
    });
  });
  var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);

  // CUSTOM

  function _VirtualDom_custom(factList, model, render, diff) {
    return {
      $: 3,
      d: _VirtualDom_organizeFacts(factList),
      g: model,
      h: render,
      i: diff
    };
  }

  // MAP

  var _VirtualDom_map = F2(function (tagger, node) {
    return {
      $: 4,
      j: tagger,
      k: node,
      b: 1 + (node.b || 0)
    };
  });

  // LAZY

  function _VirtualDom_thunk(refs, thunk) {
    return {
      $: 5,
      l: refs,
      m: thunk,
      k: undefined
    };
  }
  var _VirtualDom_lazy = F2(function (func, a) {
    return _VirtualDom_thunk([func, a], function () {
      return func(a);
    });
  });
  var _VirtualDom_lazy2 = F3(function (func, a, b) {
    return _VirtualDom_thunk([func, a, b], function () {
      return A2(func, a, b);
    });
  });
  var _VirtualDom_lazy3 = F4(function (func, a, b, c) {
    return _VirtualDom_thunk([func, a, b, c], function () {
      return A3(func, a, b, c);
    });
  });
  var _VirtualDom_lazy4 = F5(function (func, a, b, c, d) {
    return _VirtualDom_thunk([func, a, b, c, d], function () {
      return A4(func, a, b, c, d);
    });
  });
  var _VirtualDom_lazy5 = F6(function (func, a, b, c, d, e) {
    return _VirtualDom_thunk([func, a, b, c, d, e], function () {
      return A5(func, a, b, c, d, e);
    });
  });
  var _VirtualDom_lazy6 = F7(function (func, a, b, c, d, e, f) {
    return _VirtualDom_thunk([func, a, b, c, d, e, f], function () {
      return A6(func, a, b, c, d, e, f);
    });
  });
  var _VirtualDom_lazy7 = F8(function (func, a, b, c, d, e, f, g) {
    return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function () {
      return A7(func, a, b, c, d, e, f, g);
    });
  });
  var _VirtualDom_lazy8 = F9(function (func, a, b, c, d, e, f, g, h) {
    return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function () {
      return A8(func, a, b, c, d, e, f, g, h);
    });
  });

  // FACTS

  var _VirtualDom_on = F2(function (key, handler) {
    return {
      $: 'a0',
      n: key,
      o: handler
    };
  });
  var _VirtualDom_style = F2(function (key, value) {
    return {
      $: 'a1',
      n: key,
      o: value
    };
  });
  var _VirtualDom_property = F2(function (key, value) {
    return {
      $: 'a2',
      n: key,
      o: value
    };
  });
  var _VirtualDom_attribute = F2(function (key, value) {
    return {
      $: 'a3',
      n: key,
      o: value
    };
  });
  var _VirtualDom_attributeNS = F3(function (namespace, key, value) {
    return {
      $: 'a4',
      n: key,
      o: {
        f: namespace,
        o: value
      }
    };
  });

  // XSS ATTACK VECTOR CHECKS

  function _VirtualDom_noScript(tag) {
    return tag == 'script' ? 'p' : tag;
  }
  function _VirtualDom_noOnOrFormAction(key) {
    return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
  }
  function _VirtualDom_noInnerHtmlOrFormAction(key) {
    return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
  }
  function _VirtualDom_noJavaScriptUri(value) {
    return /^javascript:/i.test(value.replace(/\s/g, '')) ? '' : value;
  }
  function _VirtualDom_noJavaScriptUri_UNUSED(value) {
    return /^javascript:/i.test(value.replace(/\s/g, '')) ? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")' : value;
  }
  function _VirtualDom_noJavaScriptOrHtmlUri(value) {
    return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
  }
  function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value) {
    return /^\s*(javascript:|data:text\/html)/i.test(value) ? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")' : value;
  }

  // MAP FACTS

  var _VirtualDom_mapAttribute = F2(function (func, attr) {
    return attr.$ === 'a0' ? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o)) : attr;
  });
  function _VirtualDom_mapHandler(func, handler) {
    var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

    // 0 = Normal
    // 1 = MayStopPropagation
    // 2 = MayPreventDefault
    // 3 = Custom

    return {
      $: handler.$,
      a: !tag ? A2($elm$json$Json$Decode$map, func, handler.a) : A3($elm$json$Json$Decode$map2, tag < 3 ? _VirtualDom_mapEventTuple : _VirtualDom_mapEventRecord, $elm$json$Json$Decode$succeed(func), handler.a)
    };
  }
  var _VirtualDom_mapEventTuple = F2(function (func, tuple) {
    return _Utils_Tuple2(func(tuple.a), tuple.b);
  });
  var _VirtualDom_mapEventRecord = F2(function (func, record) {
    return {
      f0: func(record.f0),
      k8: record.k8,
      kd: record.kd
    };
  });

  // ORGANIZE FACTS

  function _VirtualDom_organizeFacts(factList) {
    for (var facts = {}; factList.b; factList = factList.b)
    // WHILE_CONS
    {
      var entry = factList.a;
      var tag = entry.$;
      var key = entry.n;
      var value = entry.o;
      if (tag === 'a2') {
        key === 'className' ? _VirtualDom_addClass(facts, key, _Json_unwrap(value)) : facts[key] = _Json_unwrap(value);
        continue;
      }
      var subFacts = facts[tag] || (facts[tag] = {});
      tag === 'a3' && key === 'class' ? _VirtualDom_addClass(subFacts, key, value) : subFacts[key] = value;
    }
    return facts;
  }
  function _VirtualDom_addClass(object, key, newClass) {
    var classes = object[key];
    object[key] = classes ? classes + ' ' + newClass : newClass;
  }

  // RENDER

  function _VirtualDom_render(vNode, eventNode) {
    var tag = vNode.$;
    if (tag === 5) {
      return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
    }
    if (tag === 0) {
      return _VirtualDom_doc.createTextNode(vNode.a);
    }
    if (tag === 4) {
      var subNode = vNode.k;
      var tagger = vNode.j;
      while (subNode.$ === 4) {
        typeof tagger !== 'object' ? tagger = [tagger, subNode.j] : tagger.push(subNode.j);
        subNode = subNode.k;
      }
      var subEventRoot = {
        j: tagger,
        p: eventNode
      };
      var domNode = _VirtualDom_render(subNode, subEventRoot);
      domNode.elm_event_node_ref = subEventRoot;
      return domNode;
    }
    if (tag === 3) {
      var domNode = vNode.h(vNode.g);
      _VirtualDom_applyFacts(domNode, eventNode, vNode.d);
      return domNode;
    }

    // at this point `tag` must be 1 or 2

    var domNode = vNode.f ? _VirtualDom_doc.createElementNS(vNode.f, vNode.c) : _VirtualDom_doc.createElement(vNode.c);
    if (_VirtualDom_divertHrefToApp && vNode.c == 'a') {
      domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
    }
    _VirtualDom_applyFacts(domNode, eventNode, vNode.d);
    for (var kids = vNode.e, i = 0; i < kids.length; i++) {
      _VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
    }
    return domNode;
  }

  // APPLY FACTS

  function _VirtualDom_applyFacts(domNode, eventNode, facts) {
    for (var key in facts) {
      var value = facts[key];
      key === 'a1' ? _VirtualDom_applyStyles(domNode, value) : key === 'a0' ? _VirtualDom_applyEvents(domNode, eventNode, value) : key === 'a3' ? _VirtualDom_applyAttrs(domNode, value) : key === 'a4' ? _VirtualDom_applyAttrsNS(domNode, value) : (key !== 'value' && key !== 'checked' || domNode[key] !== value) && (domNode[key] = value);
    }
  }

  // APPLY STYLES

  function _VirtualDom_applyStyles(domNode, styles) {
    var domNodeStyle = domNode.style;
    for (var key in styles) {
      domNodeStyle[key] = styles[key];
    }
  }

  // APPLY ATTRS

  function _VirtualDom_applyAttrs(domNode, attrs) {
    for (var key in attrs) {
      var value = attrs[key];
      typeof value !== 'undefined' ? domNode.setAttribute(key, value) : domNode.removeAttribute(key);
    }
  }

  // APPLY NAMESPACED ATTRS

  function _VirtualDom_applyAttrsNS(domNode, nsAttrs) {
    for (var key in nsAttrs) {
      var pair = nsAttrs[key];
      var namespace = pair.f;
      var value = pair.o;
      typeof value !== 'undefined' ? domNode.setAttributeNS(namespace, key, value) : domNode.removeAttributeNS(namespace, key);
    }
  }

  // APPLY EVENTS

  function _VirtualDom_applyEvents(domNode, eventNode, events) {
    var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
    for (var key in events) {
      var newHandler = events[key];
      var oldCallback = allCallbacks[key];
      if (!newHandler) {
        domNode.removeEventListener(key, oldCallback);
        allCallbacks[key] = undefined;
        continue;
      }
      if (oldCallback) {
        var oldHandler = oldCallback.q;
        if (oldHandler.$ === newHandler.$) {
          oldCallback.q = newHandler;
          continue;
        }
        domNode.removeEventListener(key, oldCallback);
      }
      oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
      domNode.addEventListener(key, oldCallback, _VirtualDom_passiveSupported && {
        passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2
      });
      allCallbacks[key] = oldCallback;
    }
  }

  // PASSIVE EVENTS

  var _VirtualDom_passiveSupported;
  try {
    window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
      get: function () {
        _VirtualDom_passiveSupported = true;
      }
    }));
  } catch (e) {}

  // EVENT HANDLERS

  function _VirtualDom_makeCallback(eventNode, initialHandler) {
    function callback(event) {
      var handler = callback.q;
      var result = _Json_runHelp(handler.a, event);
      if (!$elm$core$Result$isOk(result)) {
        return;
      }
      var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

      // 0 = Normal
      // 1 = MayStopPropagation
      // 2 = MayPreventDefault
      // 3 = Custom

      var value = result.a;
      var message = !tag ? value : tag < 3 ? value.a : value.f0;
      var stopPropagation = tag == 1 ? value.b : tag == 3 && value.k8;
      var currentEventNode = (stopPropagation && event.stopPropagation(), (tag == 2 ? value.b : tag == 3 && value.kd) && event.preventDefault(), eventNode);
      var tagger;
      var i;
      while (tagger = currentEventNode.j) {
        if (typeof tagger == 'function') {
          message = tagger(message);
        } else {
          for (var i = tagger.length; i--;) {
            message = tagger[i](message);
          }
        }
        currentEventNode = currentEventNode.p;
      }
      currentEventNode(message, stopPropagation); // stopPropagation implies isSync
    }

    callback.q = initialHandler;
    return callback;
  }
  function _VirtualDom_equalEvents(x, y) {
    return x.$ == y.$ && _Json_equality(x.a, y.a);
  }

  // DIFF

  // TODO: Should we do patches like in iOS?
  //
  // type Patch
  //   = At Int Patch
  //   | Batch (List Patch)
  //   | Change ...
  //
  // How could it not be better?
  //
  function _VirtualDom_diff(x, y) {
    var patches = [];
    _VirtualDom_diffHelp(x, y, patches, 0);
    return patches;
  }
  function _VirtualDom_pushPatch(patches, type, index, data) {
    var patch = {
      $: type,
      r: index,
      s: data,
      t: undefined,
      u: undefined
    };
    patches.push(patch);
    return patch;
  }
  function _VirtualDom_diffHelp(x, y, patches, index) {
    if (x === y) {
      return;
    }
    var xType = x.$;
    var yType = y.$;

    // Bail if you run into different types of nodes. Implies that the
    // structure has changed significantly and it's not worth a diff.
    if (xType !== yType) {
      if (xType === 1 && yType === 2) {
        y = _VirtualDom_dekey(y);
        yType = 1;
      } else {
        _VirtualDom_pushPatch(patches, 0, index, y);
        return;
      }
    }

    // Now we know that both nodes are the same $.
    switch (yType) {
      case 5:
        var xRefs = x.l;
        var yRefs = y.l;
        var i = xRefs.length;
        var same = i === yRefs.length;
        while (same && i--) {
          same = xRefs[i] === yRefs[i];
        }
        if (same) {
          y.k = x.k;
          return;
        }
        y.k = y.m();
        var subPatches = [];
        _VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
        subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
        return;
      case 4:
        // gather nested taggers
        var xTaggers = x.j;
        var yTaggers = y.j;
        var nesting = false;
        var xSubNode = x.k;
        while (xSubNode.$ === 4) {
          nesting = true;
          typeof xTaggers !== 'object' ? xTaggers = [xTaggers, xSubNode.j] : xTaggers.push(xSubNode.j);
          xSubNode = xSubNode.k;
        }
        var ySubNode = y.k;
        while (ySubNode.$ === 4) {
          nesting = true;
          typeof yTaggers !== 'object' ? yTaggers = [yTaggers, ySubNode.j] : yTaggers.push(ySubNode.j);
          ySubNode = ySubNode.k;
        }

        // Just bail if different numbers of taggers. This implies the
        // structure of the virtual DOM has changed.
        if (nesting && xTaggers.length !== yTaggers.length) {
          _VirtualDom_pushPatch(patches, 0, index, y);
          return;
        }

        // check if taggers are "the same"
        if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers) {
          _VirtualDom_pushPatch(patches, 2, index, yTaggers);
        }

        // diff everything below the taggers
        _VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
        return;
      case 0:
        if (x.a !== y.a) {
          _VirtualDom_pushPatch(patches, 3, index, y.a);
        }
        return;
      case 1:
        _VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
        return;
      case 2:
        _VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
        return;
      case 3:
        if (x.h !== y.h) {
          _VirtualDom_pushPatch(patches, 0, index, y);
          return;
        }
        var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
        factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
        var patch = y.i(x.g, y.g);
        patch && _VirtualDom_pushPatch(patches, 5, index, patch);
        return;
    }
  }

  // assumes the incoming arrays are the same length
  function _VirtualDom_pairwiseRefEqual(as, bs) {
    for (var i = 0; i < as.length; i++) {
      if (as[i] !== bs[i]) {
        return false;
      }
    }
    return true;
  }
  function _VirtualDom_diffNodes(x, y, patches, index, diffKids) {
    // Bail if obvious indicators have changed. Implies more serious
    // structural changes such that it's not worth it to diff.
    if (x.c !== y.c || x.f !== y.f) {
      _VirtualDom_pushPatch(patches, 0, index, y);
      return;
    }
    var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
    factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
    diffKids(x, y, patches, index);
  }

  // DIFF FACTS

  // TODO Instead of creating a new diff object, it's possible to just test if
  // there *is* a diff. During the actual patch, do the diff again and make the
  // modifications directly. This way, there's no new allocations. Worth it?
  function _VirtualDom_diffFacts(x, y, category) {
    var diff;

    // look for changes and removals
    for (var xKey in x) {
      if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4') {
        var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
        if (subDiff) {
          diff = diff || {};
          diff[xKey] = subDiff;
        }
        continue;
      }

      // remove if not in the new facts
      if (!(xKey in y)) {
        diff = diff || {};
        diff[xKey] = !category ? typeof x[xKey] === 'string' ? '' : null : category === 'a1' ? '' : category === 'a0' || category === 'a3' ? undefined : {
          f: x[xKey].f,
          o: undefined
        };
        continue;
      }
      var xValue = x[xKey];
      var yValue = y[xKey];

      // reference equal, so don't worry about it
      if (xValue === yValue && xKey !== 'value' && xKey !== 'checked' || category === 'a0' && _VirtualDom_equalEvents(xValue, yValue)) {
        continue;
      }
      diff = diff || {};
      diff[xKey] = yValue;
    }

    // add new stuff
    for (var yKey in y) {
      if (!(yKey in x)) {
        diff = diff || {};
        diff[yKey] = y[yKey];
      }
    }
    return diff;
  }

  // DIFF KIDS

  function _VirtualDom_diffKids(xParent, yParent, patches, index) {
    var xKids = xParent.e;
    var yKids = yParent.e;
    var xLen = xKids.length;
    var yLen = yKids.length;

    // FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

    if (xLen > yLen) {
      _VirtualDom_pushPatch(patches, 6, index, {
        v: yLen,
        i: xLen - yLen
      });
    } else if (xLen < yLen) {
      _VirtualDom_pushPatch(patches, 7, index, {
        v: xLen,
        e: yKids
      });
    }

    // PAIRWISE DIFF EVERYTHING ELSE

    for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++) {
      var xKid = xKids[i];
      _VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
      index += xKid.b || 0;
    }
  }

  // KEYED DIFF

  function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex) {
    var localPatches = [];
    var changes = {}; // Dict String Entry
    var inserts = []; // Array { index : Int, entry : Entry }
    // type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

    var xKids = xParent.e;
    var yKids = yParent.e;
    var xLen = xKids.length;
    var yLen = yKids.length;
    var xIndex = 0;
    var yIndex = 0;
    var index = rootIndex;
    while (xIndex < xLen && yIndex < yLen) {
      var x = xKids[xIndex];
      var y = yKids[yIndex];
      var xKey = x.a;
      var yKey = y.a;
      var xNode = x.b;
      var yNode = y.b;
      var newMatch = undefined;
      var oldMatch = undefined;

      // check if keys match

      if (xKey === yKey) {
        index++;
        _VirtualDom_diffHelp(xNode, yNode, localPatches, index);
        index += xNode.b || 0;
        xIndex++;
        yIndex++;
        continue;
      }

      // look ahead 1 to detect insertions and removals.

      var xNext = xKids[xIndex + 1];
      var yNext = yKids[yIndex + 1];
      if (xNext) {
        var xNextKey = xNext.a;
        var xNextNode = xNext.b;
        oldMatch = yKey === xNextKey;
      }
      if (yNext) {
        var yNextKey = yNext.a;
        var yNextNode = yNext.b;
        newMatch = xKey === yNextKey;
      }

      // swap x and y
      if (newMatch && oldMatch) {
        index++;
        _VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
        _VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
        index += xNode.b || 0;
        index++;
        _VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
        index += xNextNode.b || 0;
        xIndex += 2;
        yIndex += 2;
        continue;
      }

      // insert y
      if (newMatch) {
        index++;
        _VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
        _VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
        index += xNode.b || 0;
        xIndex += 1;
        yIndex += 2;
        continue;
      }

      // remove x
      if (oldMatch) {
        index++;
        _VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
        index += xNode.b || 0;
        index++;
        _VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
        index += xNextNode.b || 0;
        xIndex += 2;
        yIndex += 1;
        continue;
      }

      // remove x, insert y
      if (xNext && xNextKey === yNextKey) {
        index++;
        _VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
        _VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
        index += xNode.b || 0;
        index++;
        _VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
        index += xNextNode.b || 0;
        xIndex += 2;
        yIndex += 2;
        continue;
      }
      break;
    }

    // eat up any remaining nodes with removeNode and insertNode

    while (xIndex < xLen) {
      index++;
      var x = xKids[xIndex];
      var xNode = x.b;
      _VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
      index += xNode.b || 0;
      xIndex++;
    }
    while (yIndex < yLen) {
      var endInserts = endInserts || [];
      var y = yKids[yIndex];
      _VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
      yIndex++;
    }
    if (localPatches.length > 0 || inserts.length > 0 || endInserts) {
      _VirtualDom_pushPatch(patches, 8, rootIndex, {
        w: localPatches,
        x: inserts,
        y: endInserts
      });
    }
  }

  // CHANGES FROM KEYED DIFF

  var _VirtualDom_POSTFIX = '_elmW6BL';
  function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts) {
    var entry = changes[key];

    // never seen this key before
    if (!entry) {
      entry = {
        c: 0,
        z: vnode,
        r: yIndex,
        s: undefined
      };
      inserts.push({
        r: yIndex,
        A: entry
      });
      changes[key] = entry;
      return;
    }

    // this key was removed earlier, a match!
    if (entry.c === 1) {
      inserts.push({
        r: yIndex,
        A: entry
      });
      entry.c = 2;
      var subPatches = [];
      _VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
      entry.r = yIndex;
      entry.s.s = {
        w: subPatches,
        A: entry
      };
      return;
    }

    // this key has already been inserted or moved, a duplicate!
    _VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
  }
  function _VirtualDom_removeNode(changes, localPatches, key, vnode, index) {
    var entry = changes[key];

    // never seen this key before
    if (!entry) {
      var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
      changes[key] = {
        c: 1,
        z: vnode,
        r: index,
        s: patch
      };
      return;
    }

    // this key was inserted earlier, a match!
    if (entry.c === 0) {
      entry.c = 2;
      var subPatches = [];
      _VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
      _VirtualDom_pushPatch(localPatches, 9, index, {
        w: subPatches,
        A: entry
      });
      return;
    }

    // this key has already been removed or moved, a duplicate!
    _VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
  }

  // ADD DOM NODES
  //
  // Each DOM node has an "index" assigned in order of traversal. It is important
  // to minimize our crawl over the actual DOM, so these indexes (along with the
  // descendantsCount of virtual nodes) let us skip touching entire subtrees of
  // the DOM if we know there are no patches there.

  function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode) {
    _VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
  }

  // assumes `patches` is non-empty and indexes increase monotonically.
  function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode) {
    var patch = patches[i];
    var index = patch.r;
    while (index === low) {
      var patchType = patch.$;
      if (patchType === 1) {
        _VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
      } else if (patchType === 8) {
        patch.t = domNode;
        patch.u = eventNode;
        var subPatches = patch.s.w;
        if (subPatches.length > 0) {
          _VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
        }
      } else if (patchType === 9) {
        patch.t = domNode;
        patch.u = eventNode;
        var data = patch.s;
        if (data) {
          data.A.s = domNode;
          var subPatches = data.w;
          if (subPatches.length > 0) {
            _VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
          }
        }
      } else {
        patch.t = domNode;
        patch.u = eventNode;
      }
      i++;
      if (!(patch = patches[i]) || (index = patch.r) > high) {
        return i;
      }
    }
    var tag = vNode.$;
    if (tag === 4) {
      var subNode = vNode.k;
      while (subNode.$ === 4) {
        subNode = subNode.k;
      }
      return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
    }

    // tag must be 1 or 2 at this point

    var vKids = vNode.e;
    var childNodes = domNode.childNodes;
    for (var j = 0; j < vKids.length; j++) {
      low++;
      var vKid = tag === 1 ? vKids[j] : vKids[j].b;
      var nextLow = low + (vKid.b || 0);
      if (low <= index && index <= nextLow) {
        i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
        if (!(patch = patches[i]) || (index = patch.r) > high) {
          return i;
        }
      }
      low = nextLow;
    }
    return i;
  }

  // APPLY PATCHES

  function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode) {
    if (patches.length === 0) {
      return rootDomNode;
    }
    _VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
    return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
  }
  function _VirtualDom_applyPatchesHelp(rootDomNode, patches) {
    for (var i = 0; i < patches.length; i++) {
      var patch = patches[i];
      var localDomNode = patch.t;
      var newNode = _VirtualDom_applyPatch(localDomNode, patch);
      if (localDomNode === rootDomNode) {
        rootDomNode = newNode;
      }
    }
    return rootDomNode;
  }
  function _VirtualDom_applyPatch(domNode, patch) {
    switch (patch.$) {
      case 0:
        return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
      case 4:
        _VirtualDom_applyFacts(domNode, patch.u, patch.s);
        return domNode;
      case 3:
        domNode.replaceData(0, domNode.length, patch.s);
        return domNode;
      case 1:
        return _VirtualDom_applyPatchesHelp(domNode, patch.s);
      case 2:
        if (domNode.elm_event_node_ref) {
          domNode.elm_event_node_ref.j = patch.s;
        } else {
          domNode.elm_event_node_ref = {
            j: patch.s,
            p: patch.u
          };
        }
        return domNode;
      case 6:
        var data = patch.s;
        for (var i = 0; i < data.i; i++) {
          domNode.removeChild(domNode.childNodes[data.v]);
        }
        return domNode;
      case 7:
        var data = patch.s;
        var kids = data.e;
        var i = data.v;
        var theEnd = domNode.childNodes[i];
        for (; i < kids.length; i++) {
          domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
        }
        return domNode;
      case 9:
        var data = patch.s;
        if (!data) {
          domNode.parentNode.removeChild(domNode);
          return domNode;
        }
        var entry = data.A;
        if (typeof entry.r !== 'undefined') {
          domNode.parentNode.removeChild(domNode);
        }
        entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
        return domNode;
      case 8:
        return _VirtualDom_applyPatchReorder(domNode, patch);
      case 5:
        return patch.s(domNode);
      default:
        _Debug_crash(10);
      // 'Ran into an unknown patch!'
    }
  }

  function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode) {
    var parentNode = domNode.parentNode;
    var newNode = _VirtualDom_render(vNode, eventNode);
    if (!newNode.elm_event_node_ref) {
      newNode.elm_event_node_ref = domNode.elm_event_node_ref;
    }
    if (parentNode && newNode !== domNode) {
      parentNode.replaceChild(newNode, domNode);
    }
    return newNode;
  }
  function _VirtualDom_applyPatchReorder(domNode, patch) {
    var data = patch.s;

    // remove end inserts
    var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

    // removals
    domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

    // inserts
    var inserts = data.x;
    for (var i = 0; i < inserts.length; i++) {
      var insert = inserts[i];
      var entry = insert.A;
      var node = entry.c === 2 ? entry.s : _VirtualDom_render(entry.z, patch.u);
      domNode.insertBefore(node, domNode.childNodes[insert.r]);
    }

    // add end inserts
    if (frag) {
      _VirtualDom_appendChild(domNode, frag);
    }
    return domNode;
  }
  function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch) {
    if (!endInserts) {
      return;
    }
    var frag = _VirtualDom_doc.createDocumentFragment();
    for (var i = 0; i < endInserts.length; i++) {
      var insert = endInserts[i];
      var entry = insert.A;
      _VirtualDom_appendChild(frag, entry.c === 2 ? entry.s : _VirtualDom_render(entry.z, patch.u));
    }
    return frag;
  }
  function _VirtualDom_virtualize(node) {
    // TEXT NODES

    if (node.nodeType === 3) {
      return _VirtualDom_text(node.textContent);
    }

    // WEIRD NODES

    if (node.nodeType !== 1) {
      return _VirtualDom_text('');
    }

    // ELEMENT NODES

    var attrList = _List_Nil;
    var attrs = node.attributes;
    for (var i = attrs.length; i--;) {
      var attr = attrs[i];
      var name = attr.name;
      var value = attr.value;
      attrList = _List_Cons(A2(_VirtualDom_attribute, name, value), attrList);
    }
    var tag = node.tagName.toLowerCase();
    var kidList = _List_Nil;
    var kids = node.childNodes;
    for (var i = kids.length; i--;) {
      kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
    }
    return A3(_VirtualDom_node, tag, attrList, kidList);
  }
  function _VirtualDom_dekey(keyedNode) {
    var keyedKids = keyedNode.e;
    var len = keyedKids.length;
    var kids = new Array(len);
    for (var i = 0; i < len; i++) {
      kids[i] = keyedKids[i].b;
    }
    return {
      $: 1,
      c: keyedNode.c,
      d: keyedNode.d,
      e: kids,
      f: keyedNode.f,
      b: keyedNode.b
    };
  }

  // ELEMENT

  var _Debugger_element;
  var _Browser_element = _Debugger_element || F4(function (impl, flagDecoder, debugMetadata, args) {
    return _Platform_initialize(flagDecoder, args, impl.wM, impl.C5, impl.Co, function (sendToApp, initialModel) {
      var view = impl.Dl;
      /**/
      var domNode = args['node'];
      //*/
      /**_UNUSED/
      var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
      //*/
      var currNode = _VirtualDom_virtualize(domNode);
      return _Browser_makeAnimator(initialModel, function (model) {
        var nextNode = view(model);
        var patches = _VirtualDom_diff(currNode, nextNode);
        domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
        currNode = nextNode;
      });
    });
  });

  // DOCUMENT

  var _Debugger_document;
  var _Browser_document = _Debugger_document || F4(function (impl, flagDecoder, debugMetadata, args) {
    return _Platform_initialize(flagDecoder, args, impl.wM, impl.C5, impl.Co, function (sendToApp, initialModel) {
      var divertHrefToApp = impl.kP && impl.kP(sendToApp);
      var view = impl.Dl;
      var title = _VirtualDom_doc.title;
      var bodyNode = _VirtualDom_doc.body;
      var currNode = _VirtualDom_virtualize(bodyNode);
      return _Browser_makeAnimator(initialModel, function (model) {
        _VirtualDom_divertHrefToApp = divertHrefToApp;
        var doc = view(model);
        var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.aU);
        var patches = _VirtualDom_diff(currNode, nextNode);
        bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
        currNode = nextNode;
        _VirtualDom_divertHrefToApp = 0;
        title !== doc.lh && (_VirtualDom_doc.title = title = doc.lh);
      });
    });
  });

  // ANIMATION

  var _Browser_cancelAnimationFrame = typeof cancelAnimationFrame !== 'undefined' ? cancelAnimationFrame : function (id) {
    clearTimeout(id);
  };
  var _Browser_requestAnimationFrame = typeof requestAnimationFrame !== 'undefined' ? requestAnimationFrame : function (callback) {
    return setTimeout(callback, 1000 / 60);
  };
  function _Browser_makeAnimator(model, draw) {
    draw(model);
    var state = 0;
    function updateIfNeeded() {
      state = state === 1 ? 0 : (_Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1);
    }
    return function (nextModel, isSync) {
      model = nextModel;
      isSync ? (draw(model), state === 2 && (state = 1)) : (state === 0 && _Browser_requestAnimationFrame(updateIfNeeded), state = 2);
    };
  }

  // APPLICATION

  function _Browser_application(impl) {
    var onUrlChange = impl.zU;
    var onUrlRequest = impl.zV;
    var key = function () {
      key.a(onUrlChange(_Browser_getUrl()));
    };
    return _Browser_document({
      kP: function (sendToApp) {
        key.a = sendToApp;
        _Browser_window.addEventListener('popstate', key);
        _Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
        return F2(function (domNode, event) {
          if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download')) {
            event.preventDefault();
            var href = domNode.href;
            var curr = _Browser_getUrl();
            var next = $elm$url$Url$fromString(href).a;
            sendToApp(onUrlRequest(next && curr.ke === next.ke && curr.ik === next.ik && curr.kc.a === next.kc.a ? $elm$browser$Browser$Internal(next) : $elm$browser$Browser$External(href)));
          }
        });
      },
      wM: function (flags) {
        return A3(impl.wM, flags, _Browser_getUrl(), key);
      },
      Dl: impl.Dl,
      C5: impl.C5,
      Co: impl.Co
    });
  }
  function _Browser_getUrl() {
    return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
  }
  var _Browser_go = F2(function (key, n) {
    return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function () {
      n && history.go(n);
      key();
    }));
  });
  var _Browser_pushUrl = F2(function (key, url) {
    return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function () {
      history.pushState({}, '', url);
      key();
    }));
  });
  var _Browser_replaceUrl = F2(function (key, url) {
    return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function () {
      history.replaceState({}, '', url);
      key();
    }));
  });

  // GLOBAL EVENTS

  var _Browser_fakeNode = {
    addEventListener: function () {},
    removeEventListener: function () {}
  };
  var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
  var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;
  var _Browser_on = F3(function (node, eventName, sendToSelf) {
    return _Scheduler_spawn(_Scheduler_binding(function (callback) {
      function handler(event) {
        _Scheduler_rawSpawn(sendToSelf(event));
      }
      node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && {
        passive: true
      });
      return function () {
        node.removeEventListener(eventName, handler);
      };
    }));
  });
  var _Browser_decodeEvent = F2(function (decoder, event) {
    var result = _Json_runHelp(decoder, event);
    return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
  });

  // PAGE VISIBILITY

  function _Browser_visibilityInfo() {
    return typeof _VirtualDom_doc.hidden !== 'undefined' ? {
      wz: 'hidden',
      uf: 'visibilitychange'
    } : typeof _VirtualDom_doc.mozHidden !== 'undefined' ? {
      wz: 'mozHidden',
      uf: 'mozvisibilitychange'
    } : typeof _VirtualDom_doc.msHidden !== 'undefined' ? {
      wz: 'msHidden',
      uf: 'msvisibilitychange'
    } : typeof _VirtualDom_doc.webkitHidden !== 'undefined' ? {
      wz: 'webkitHidden',
      uf: 'webkitvisibilitychange'
    } : {
      wz: 'hidden',
      uf: 'visibilitychange'
    };
  }

  // ANIMATION FRAMES

  function _Browser_rAF() {
    return _Scheduler_binding(function (callback) {
      var id = _Browser_requestAnimationFrame(function () {
        callback(_Scheduler_succeed(Date.now()));
      });
      return function () {
        _Browser_cancelAnimationFrame(id);
      };
    });
  }
  function _Browser_now() {
    return _Scheduler_binding(function (callback) {
      callback(_Scheduler_succeed(Date.now()));
    });
  }

  // DOM STUFF

  function _Browser_withNode(id, doStuff) {
    return _Scheduler_binding(function (callback) {
      _Browser_requestAnimationFrame(function () {
        var node = document.getElementById(id);
        callback(node ? _Scheduler_succeed(doStuff(node)) : _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id)));
      });
    });
  }
  function _Browser_withWindow(doStuff) {
    return _Scheduler_binding(function (callback) {
      _Browser_requestAnimationFrame(function () {
        callback(_Scheduler_succeed(doStuff()));
      });
    });
  }

  // FOCUS and BLUR

  var _Browser_call = F2(function (functionName, id) {
    return _Browser_withNode(id, function (node) {
      node[functionName]();
      return _Utils_Tuple0;
    });
  });

  // WINDOW VIEWPORT

  function _Browser_getViewport() {
    return {
      rn: _Browser_getScene(),
      Dm: {
        s7: _Browser_window.pageXOffset,
        s9: _Browser_window.pageYOffset,
        lt: _Browser_doc.documentElement.clientWidth,
        ij: _Browser_doc.documentElement.clientHeight
      }
    };
  }
  function _Browser_getScene() {
    var body = _Browser_doc.body;
    var elem = _Browser_doc.documentElement;
    return {
      lt: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
      ij: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
    };
  }
  var _Browser_setViewport = F2(function (x, y) {
    return _Browser_withWindow(function () {
      _Browser_window.scroll(x, y);
      return _Utils_Tuple0;
    });
  });

  // ELEMENT VIEWPORT

  function _Browser_getViewportOf(id) {
    return _Browser_withNode(id, function (node) {
      return {
        rn: {
          lt: node.scrollWidth,
          ij: node.scrollHeight
        },
        Dm: {
          s7: node.scrollLeft,
          s9: node.scrollTop,
          lt: node.clientWidth,
          ij: node.clientHeight
        }
      };
    });
  }
  var _Browser_setViewportOf = F3(function (id, x, y) {
    return _Browser_withNode(id, function (node) {
      node.scrollLeft = x;
      node.scrollTop = y;
      return _Utils_Tuple0;
    });
  });

  // ELEMENT

  function _Browser_getElement(id) {
    return _Browser_withNode(id, function (node) {
      var rect = node.getBoundingClientRect();
      var x = _Browser_window.pageXOffset;
      var y = _Browser_window.pageYOffset;
      return {
        rn: _Browser_getScene(),
        Dm: {
          s7: x,
          s9: y,
          lt: _Browser_doc.documentElement.clientWidth,
          ij: _Browser_doc.documentElement.clientHeight
        },
        vH: {
          s7: x + rect.left,
          s9: y + rect.top,
          lt: rect.width,
          ij: rect.height
        }
      };
    });
  }

  // LOAD and RELOAD

  function _Browser_reload(skipCache) {
    return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function (callback) {
      _VirtualDom_doc.location.reload(skipCache);
    }));
  }
  function _Browser_load(url) {
    return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function (callback) {
      try {
        _Browser_window.location = url;
      } catch (err) {
        // Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
        // Other browsers reload the page, so let's be consistent about that.
        _VirtualDom_doc.location.reload(false);
      }
    }));
  }
  var _Bitwise_and = F2(function (a, b) {
    return a & b;
  });
  var _Bitwise_or = F2(function (a, b) {
    return a | b;
  });
  var _Bitwise_xor = F2(function (a, b) {
    return a ^ b;
  });
  function _Bitwise_complement(a) {
    return ~a;
  }
  ;
  var _Bitwise_shiftLeftBy = F2(function (offset, a) {
    return a << offset;
  });
  var _Bitwise_shiftRightBy = F2(function (offset, a) {
    return a >> offset;
  });
  var _Bitwise_shiftRightZfBy = F2(function (offset, a) {
    return a >>> offset;
  });
  function _Url_percentEncode(string) {
    return encodeURIComponent(string);
  }
  function _Url_percentDecode(string) {
    try {
      return $elm$core$Maybe$Just(decodeURIComponent(string));
    } catch (e) {
      return $elm$core$Maybe$Nothing;
    }
  }
  function _Time_now(millisToPosix) {
    return _Scheduler_binding(function (callback) {
      callback(_Scheduler_succeed(millisToPosix(Date.now())));
    });
  }
  var _Time_setInterval = F2(function (interval, task) {
    return _Scheduler_binding(function (callback) {
      var id = setInterval(function () {
        _Scheduler_rawSpawn(task);
      }, interval);
      return function () {
        clearInterval(id);
      };
    });
  });
  function _Time_here() {
    return _Scheduler_binding(function (callback) {
      callback(_Scheduler_succeed(A2($elm$time$Time$customZone, -new Date().getTimezoneOffset(), _List_Nil)));
    });
  }
  function _Time_getZoneName() {
    return _Scheduler_binding(function (callback) {
      try {
        var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
      } catch (e) {
        var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
      }
      callback(_Scheduler_succeed(name));
    });
  }

  // CREATE

  var _Regex_never = /.^/;
  var _Regex_fromStringWith = F2(function (options, string) {
    var flags = 'g';
    if (options.yx) {
      flags += 'm';
    }
    if (options.t9) {
      flags += 'i';
    }
    try {
      return $elm$core$Maybe$Just(new RegExp(string, flags));
    } catch (error) {
      return $elm$core$Maybe$Nothing;
    }
  });

  // USE

  var _Regex_contains = F2(function (re, string) {
    return string.match(re) !== null;
  });
  var _Regex_findAtMost = F3(function (n, re, str) {
    var out = [];
    var number = 0;
    var string = str;
    var lastIndex = re.lastIndex;
    var prevLastIndex = -1;
    var result;
    while (number++ < n && (result = re.exec(string))) {
      if (prevLastIndex == re.lastIndex) break;
      var i = result.length - 1;
      var subs = new Array(i);
      while (i > 0) {
        var submatch = result[i];
        subs[--i] = submatch ? $elm$core$Maybe$Just(submatch) : $elm$core$Maybe$Nothing;
      }
      out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
      prevLastIndex = re.lastIndex;
    }
    re.lastIndex = lastIndex;
    return _List_fromArray(out);
  });
  var _Regex_replaceAtMost = F4(function (n, re, replacer, string) {
    var count = 0;
    function jsReplacer(match) {
      if (count++ >= n) {
        return match;
      }
      var i = arguments.length - 3;
      var submatches = new Array(i);
      while (i > 0) {
        var submatch = arguments[i];
        submatches[--i] = submatch ? $elm$core$Maybe$Just(submatch) : $elm$core$Maybe$Nothing;
      }
      return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
    }
    return string.replace(re, jsReplacer);
  });
  var _Regex_splitAtMost = F3(function (n, re, str) {
    var string = str;
    var out = [];
    var start = re.lastIndex;
    var restoreLastIndex = re.lastIndex;
    while (n--) {
      var result = re.exec(string);
      if (!result) break;
      out.push(string.slice(start, result.index));
      start = re.lastIndex;
    }
    out.push(string.slice(start));
    re.lastIndex = restoreLastIndex;
    return _List_fromArray(out);
  });
  var _Regex_infinity = Infinity;

  // SEND REQUEST

  var _Http_toTask = F3(function (router, toTask, request) {
    return _Scheduler_binding(function (callback) {
      function done(response) {
        callback(toTask(request.nv.a(response)));
      }
      var xhr = new XMLHttpRequest();
      xhr.addEventListener('error', function () {
        done($elm$http$Http$NetworkError_);
      });
      xhr.addEventListener('timeout', function () {
        done($elm$http$Http$Timeout_);
      });
      xhr.addEventListener('load', function () {
        done(_Http_toResponse(request.nv.b, xhr));
      });
      $elm$core$Maybe$isJust(request.sC) && _Http_track(router, xhr, request.sC.a);
      try {
        xhr.open(request.em, request.eZ, true);
      } catch (e) {
        return done($elm$http$Http$BadUrl_(request.eZ));
      }
      _Http_configureRequest(xhr, request);
      request.aU.a && xhr.setRequestHeader('Content-Type', request.aU.a);
      xhr.send(request.aU.b);
      return function () {
        xhr.c = true;
        xhr.abort();
      };
    });
  });

  // CONFIGURE

  function _Http_configureRequest(xhr, request) {
    for (var headers = request.wx; headers.b; headers = headers.b)
    // WHILE_CONS
    {
      xhr.setRequestHeader(headers.a.a, headers.a.b);
    }
    xhr.timeout = request.lf.a || 0;
    xhr.responseType = request.nv.d;
    xhr.withCredentials = request.tr;
  }

  // RESPONSES

  function _Http_toResponse(toBody, xhr) {
    return A2(200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_, _Http_toMetadata(xhr), toBody(xhr.response));
  }

  // METADATA

  function _Http_toMetadata(xhr) {
    return {
      eZ: xhr.responseURL,
      Ce: xhr.status,
      Cf: xhr.statusText,
      wx: _Http_parseHeaders(xhr.getAllResponseHeaders())
    };
  }

  // HEADERS

  function _Http_parseHeaders(rawHeaders) {
    if (!rawHeaders) {
      return $elm$core$Dict$empty;
    }
    var headers = $elm$core$Dict$empty;
    var headerPairs = rawHeaders.split('\r\n');
    for (var i = headerPairs.length; i--;) {
      var headerPair = headerPairs[i];
      var index = headerPair.indexOf(': ');
      if (index > 0) {
        var key = headerPair.substring(0, index);
        var value = headerPair.substring(index + 2);
        headers = A3($elm$core$Dict$update, key, function (oldValue) {
          return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue) ? value + ', ' + oldValue.a : value);
        }, headers);
      }
    }
    return headers;
  }

  // EXPECT

  var _Http_expect = F3(function (type, toBody, toValue) {
    return {
      $: 0,
      d: type,
      b: toBody,
      a: toValue
    };
  });
  var _Http_mapExpect = F2(function (func, expect) {
    return {
      $: 0,
      d: expect.d,
      b: expect.b,
      a: function (x) {
        return func(expect.a(x));
      }
    };
  });
  function _Http_toDataView(arrayBuffer) {
    return new DataView(arrayBuffer);
  }

  // BODY and PARTS

  var _Http_emptyBody = {
    $: 0
  };
  var _Http_pair = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  function _Http_toFormData(parts) {
    for (var formData = new FormData(); parts.b; parts = parts.b)
    // WHILE_CONS
    {
      var part = parts.a;
      formData.append(part.a, part.b);
    }
    return formData;
  }
  var _Http_bytesToBlob = F2(function (mime, bytes) {
    return new Blob([bytes], {
      type: mime
    });
  });

  // PROGRESS

  function _Http_track(router, xhr, tracker) {
    // TODO check out lengthComputable on loadstart event

    xhr.upload.addEventListener('progress', function (event) {
      if (xhr.c) {
        return;
      }
      _Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
        BS: event.loaded,
        B3: event.total
      }))));
    });
    xhr.addEventListener('progress', function (event) {
      if (xhr.c) {
        return;
      }
      _Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
        AS: event.loaded,
        B3: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
      }))));
    });
  }

  // STRINGS

  var _Parser_isSubString = F5(function (smallString, offset, row, col, bigString) {
    var smallLength = smallString.length;
    var isGood = offset + smallLength <= bigString.length;
    for (var i = 0; isGood && i < smallLength;) {
      var code = bigString.charCodeAt(offset);
      isGood = smallString[i++] === bigString[offset++] && (code === 0x000A /* \n */ ? (row++, col = 1) : (col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1));
    }
    return _Utils_Tuple3(isGood ? offset : -1, row, col);
  });

  // CHARS

  var _Parser_isSubChar = F3(function (predicate, offset, string) {
    return string.length <= offset ? -1 : (string.charCodeAt(offset) & 0xF800) === 0xD800 ? predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1 : predicate(_Utils_chr(string[offset])) ? string[offset] === '\n' ? -2 : offset + 1 : -1;
  });
  var _Parser_isAsciiCode = F3(function (code, offset, string) {
    return string.charCodeAt(offset) === code;
  });

  // NUMBERS

  var _Parser_chompBase10 = F2(function (offset, string) {
    for (; offset < string.length; offset++) {
      var code = string.charCodeAt(offset);
      if (code < 0x30 || 0x39 < code) {
        return offset;
      }
    }
    return offset;
  });
  var _Parser_consumeBase = F3(function (base, offset, string) {
    for (var total = 0; offset < string.length; offset++) {
      var digit = string.charCodeAt(offset) - 0x30;
      if (digit < 0 || base <= digit) break;
      total = base * total + digit;
    }
    return _Utils_Tuple2(offset, total);
  });
  var _Parser_consumeBase16 = F2(function (offset, string) {
    for (var total = 0; offset < string.length; offset++) {
      var code = string.charCodeAt(offset);
      if (0x30 <= code && code <= 0x39) {
        total = 16 * total + code - 0x30;
      } else if (0x41 <= code && code <= 0x46) {
        total = 16 * total + code - 55;
      } else if (0x61 <= code && code <= 0x66) {
        total = 16 * total + code - 87;
      } else {
        break;
      }
    }
    return _Utils_Tuple2(offset, total);
  });

  // FIND STRING

  var _Parser_findSubString = F5(function (smallString, offset, row, col, bigString) {
    var newOffset = bigString.indexOf(smallString, offset);
    var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;
    while (offset < target) {
      var code = bigString.charCodeAt(offset++);
      code === 0x000A /* \n */ ? (col = 1, row++) : (col++, (code & 0xF800) === 0xD800 && offset++);
    }
    return _Utils_Tuple3(newOffset, row, col);
  });
  var $elm$core$Maybe$Just = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $elm$core$Maybe$Nothing = {
    $: 1
  };
  var $elm$core$List$cons = _List_cons;
  var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
  var $elm$core$Array$foldr = F3(function (func, baseCase, _v0) {
    var tree = _v0.c;
    var tail = _v0.d;
    var helper = F2(function (node, acc) {
      if (!node.$) {
        var subTree = node.a;
        return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
      } else {
        var values = node.a;
        return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
      }
    });
    return A3($elm$core$Elm$JsArray$foldr, helper, A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail), tree);
  });
  var $elm$core$Array$toList = function (array) {
    return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
  };
  var $elm$core$Dict$foldr = F3(function (func, acc, t) {
    foldr: while (true) {
      if (t.$ === -2) {
        return acc;
      } else {
        var key = t.b;
        var value = t.c;
        var left = t.d;
        var right = t.e;
        var $temp$func = func,
          $temp$acc = A3(func, key, value, A3($elm$core$Dict$foldr, func, acc, right)),
          $temp$t = left;
        func = $temp$func;
        acc = $temp$acc;
        t = $temp$t;
        continue foldr;
      }
    }
  });
  var $elm$core$Dict$toList = function (dict) {
    return A3($elm$core$Dict$foldr, F3(function (key, value, list) {
      return A2($elm$core$List$cons, _Utils_Tuple2(key, value), list);
    }), _List_Nil, dict);
  };
  var $elm$core$Dict$keys = function (dict) {
    return A3($elm$core$Dict$foldr, F3(function (key, value, keyList) {
      return A2($elm$core$List$cons, key, keyList);
    }), _List_Nil, dict);
  };
  var $elm$core$Set$toList = function (_v0) {
    var dict = _v0;
    return $elm$core$Dict$keys(dict);
  };
  var $elm$core$Basics$EQ = 1;
  var $elm$core$Basics$GT = 2;
  var $elm$core$Basics$LT = 0;
  var $elm$core$Result$Err = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $elm$json$Json$Decode$Failure = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $elm$json$Json$Decode$Field = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $elm$json$Json$Decode$Index = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $elm$core$Result$Ok = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $elm$json$Json$Decode$OneOf = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $elm$core$Basics$False = 1;
  var $elm$core$Basics$add = _Basics_add;
  var $elm$core$String$all = _String_all;
  var $elm$core$Basics$and = _Basics_and;
  var $elm$core$Basics$append = _Utils_append;
  var $elm$json$Json$Encode$encode = _Json_encode;
  var $elm$core$String$fromInt = _String_fromNumber;
  var $elm$core$String$join = F2(function (sep, chunks) {
    return A2(_String_join, sep, _List_toArray(chunks));
  });
  var $elm$core$String$split = F2(function (sep, string) {
    return _List_fromArray(A2(_String_split, sep, string));
  });
  var $elm$json$Json$Decode$indent = function (str) {
    return A2($elm$core$String$join, '\n    ', A2($elm$core$String$split, '\n', str));
  };
  var $elm$core$List$foldl = F3(function (func, acc, list) {
    foldl: while (true) {
      if (!list.b) {
        return acc;
      } else {
        var x = list.a;
        var xs = list.b;
        var $temp$func = func,
          $temp$acc = A2(func, x, acc),
          $temp$list = xs;
        func = $temp$func;
        acc = $temp$acc;
        list = $temp$list;
        continue foldl;
      }
    }
  });
  var $elm$core$List$length = function (xs) {
    return A3($elm$core$List$foldl, F2(function (_v0, i) {
      return i + 1;
    }), 0, xs);
  };
  var $elm$core$List$map2 = _List_map2;
  var $elm$core$Basics$le = _Utils_le;
  var $elm$core$Basics$sub = _Basics_sub;
  var $elm$core$List$rangeHelp = F3(function (lo, hi, list) {
    rangeHelp: while (true) {
      if (_Utils_cmp(lo, hi) < 1) {
        var $temp$lo = lo,
          $temp$hi = hi - 1,
          $temp$list = A2($elm$core$List$cons, hi, list);
        lo = $temp$lo;
        hi = $temp$hi;
        list = $temp$list;
        continue rangeHelp;
      } else {
        return list;
      }
    }
  });
  var $elm$core$List$range = F2(function (lo, hi) {
    return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
  });
  var $elm$core$List$indexedMap = F2(function (f, xs) {
    return A3($elm$core$List$map2, f, A2($elm$core$List$range, 0, $elm$core$List$length(xs) - 1), xs);
  });
  var $elm$core$Char$toCode = _Char_toCode;
  var $elm$core$Char$isLower = function (_char) {
    var code = $elm$core$Char$toCode(_char);
    return 97 <= code && code <= 122;
  };
  var $elm$core$Char$isUpper = function (_char) {
    var code = $elm$core$Char$toCode(_char);
    return code <= 90 && 65 <= code;
  };
  var $elm$core$Basics$or = _Basics_or;
  var $elm$core$Char$isAlpha = function (_char) {
    return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
  };
  var $elm$core$Char$isDigit = function (_char) {
    var code = $elm$core$Char$toCode(_char);
    return code <= 57 && 48 <= code;
  };
  var $elm$core$Char$isAlphaNum = function (_char) {
    return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char);
  };
  var $elm$core$List$reverse = function (list) {
    return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
  };
  var $elm$core$String$uncons = _String_uncons;
  var $elm$json$Json$Decode$errorOneOf = F2(function (i, error) {
    return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent($elm$json$Json$Decode$errorToString(error))));
  });
  var $elm$json$Json$Decode$errorToString = function (error) {
    return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
  };
  var $elm$json$Json$Decode$errorToStringHelp = F2(function (error, context) {
    errorToStringHelp: while (true) {
      switch (error.$) {
        case 0:
          var f = error.a;
          var err = error.b;
          var isSimple = function () {
            var _v1 = $elm$core$String$uncons(f);
            if (_v1.$ === 1) {
              return false;
            } else {
              var _v2 = _v1.a;
              var _char = _v2.a;
              var rest = _v2.b;
              return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
            }
          }();
          var fieldName = isSimple ? '.' + f : '[\'' + (f + '\']');
          var $temp$error = err,
            $temp$context = A2($elm$core$List$cons, fieldName, context);
          error = $temp$error;
          context = $temp$context;
          continue errorToStringHelp;
        case 1:
          var i = error.a;
          var err = error.b;
          var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
          var $temp$error = err,
            $temp$context = A2($elm$core$List$cons, indexName, context);
          error = $temp$error;
          context = $temp$context;
          continue errorToStringHelp;
        case 2:
          var errors = error.a;
          if (!errors.b) {
            return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
              if (!context.b) {
                return '!';
              } else {
                return ' at json' + A2($elm$core$String$join, '', $elm$core$List$reverse(context));
              }
            }();
          } else {
            if (!errors.b.b) {
              var err = errors.a;
              var $temp$error = err,
                $temp$context = context;
              error = $temp$error;
              context = $temp$context;
              continue errorToStringHelp;
            } else {
              var starter = function () {
                if (!context.b) {
                  return 'Json.Decode.oneOf';
                } else {
                  return 'The Json.Decode.oneOf at json' + A2($elm$core$String$join, '', $elm$core$List$reverse(context));
                }
              }();
              var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt($elm$core$List$length(errors)) + ' ways:'));
              return A2($elm$core$String$join, '\n\n', A2($elm$core$List$cons, introduction, A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
            }
          }
        default:
          var msg = error.a;
          var json = error.b;
          var introduction = function () {
            if (!context.b) {
              return 'Problem with the given value:\n\n';
            } else {
              return 'Problem with the value at json' + (A2($elm$core$String$join, '', $elm$core$List$reverse(context)) + ':\n\n    ');
            }
          }();
          return introduction + ($elm$json$Json$Decode$indent(A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
      }
    }
  });
  var $elm$core$Array$branchFactor = 32;
  var $elm$core$Array$Array_elm_builtin = F4(function (a, b, c, d) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $elm$core$Elm$JsArray$empty = _JsArray_empty;
  var $elm$core$Basics$ceiling = _Basics_ceiling;
  var $elm$core$Basics$fdiv = _Basics_fdiv;
  var $elm$core$Basics$logBase = F2(function (base, number) {
    return _Basics_log(number) / _Basics_log(base);
  });
  var $elm$core$Basics$toFloat = _Basics_toFloat;
  var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
  var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
  var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
  var $elm$core$Array$Leaf = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $elm$core$Basics$apL = F2(function (f, x) {
    return f(x);
  });
  var $elm$core$Basics$apR = F2(function (x, f) {
    return f(x);
  });
  var $elm$core$Basics$eq = _Utils_equal;
  var $elm$core$Basics$floor = _Basics_floor;
  var $elm$core$Elm$JsArray$length = _JsArray_length;
  var $elm$core$Basics$gt = _Utils_gt;
  var $elm$core$Basics$max = F2(function (x, y) {
    return _Utils_cmp(x, y) > 0 ? x : y;
  });
  var $elm$core$Basics$mul = _Basics_mul;
  var $elm$core$Array$SubTree = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
  var $elm$core$Array$compressNodes = F2(function (nodes, acc) {
    compressNodes: while (true) {
      var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
      var node = _v0.a;
      var remainingNodes = _v0.b;
      var newAcc = A2($elm$core$List$cons, $elm$core$Array$SubTree(node), acc);
      if (!remainingNodes.b) {
        return $elm$core$List$reverse(newAcc);
      } else {
        var $temp$nodes = remainingNodes,
          $temp$acc = newAcc;
        nodes = $temp$nodes;
        acc = $temp$acc;
        continue compressNodes;
      }
    }
  });
  var $elm$core$Tuple$first = function (_v0) {
    var x = _v0.a;
    return x;
  };
  var $elm$core$Array$treeFromBuilder = F2(function (nodeList, nodeListSize) {
    treeFromBuilder: while (true) {
      var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
      if (newNodeSize === 1) {
        return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
      } else {
        var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
          $temp$nodeListSize = newNodeSize;
        nodeList = $temp$nodeList;
        nodeListSize = $temp$nodeListSize;
        continue treeFromBuilder;
      }
    }
  });
  var $elm$core$Array$builderToArray = F2(function (reverseNodeList, builder) {
    if (!builder.y) {
      return A4($elm$core$Array$Array_elm_builtin, $elm$core$Elm$JsArray$length(builder.C), $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, builder.C);
    } else {
      var treeLen = builder.y * $elm$core$Array$branchFactor;
      var depth = $elm$core$Basics$floor(A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
      var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.D) : builder.D;
      var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.y);
      return A4($elm$core$Array$Array_elm_builtin, $elm$core$Elm$JsArray$length(builder.C) + treeLen, A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep), tree, builder.C);
    }
  });
  var $elm$core$Basics$idiv = _Basics_idiv;
  var $elm$core$Basics$lt = _Utils_lt;
  var $elm$core$Array$initializeHelp = F5(function (fn, fromIndex, len, nodeList, tail) {
    initializeHelp: while (true) {
      if (fromIndex < 0) {
        return A2($elm$core$Array$builderToArray, false, {
          D: nodeList,
          y: len / $elm$core$Array$branchFactor | 0,
          C: tail
        });
      } else {
        var leaf = $elm$core$Array$Leaf(A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
        var $temp$fn = fn,
          $temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
          $temp$len = len,
          $temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
          $temp$tail = tail;
        fn = $temp$fn;
        fromIndex = $temp$fromIndex;
        len = $temp$len;
        nodeList = $temp$nodeList;
        tail = $temp$tail;
        continue initializeHelp;
      }
    }
  });
  var $elm$core$Basics$remainderBy = _Basics_remainderBy;
  var $elm$core$Array$initialize = F2(function (len, fn) {
    if (len <= 0) {
      return $elm$core$Array$empty;
    } else {
      var tailLen = len % $elm$core$Array$branchFactor;
      var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
      var initialFromIndex = len - tailLen - $elm$core$Array$branchFactor;
      return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
    }
  });
  var $elm$core$Basics$True = 0;
  var $elm$core$Result$isOk = function (result) {
    if (!result.$) {
      return true;
    } else {
      return false;
    }
  };
  var $elm$json$Json$Decode$andThen = _Json_andThen;
  var $elm$json$Json$Decode$map = _Json_map1;
  var $elm$json$Json$Decode$map2 = _Json_map2;
  var $elm$json$Json$Decode$succeed = _Json_succeed;
  var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
    switch (handler.$) {
      case 0:
        return 0;
      case 1:
        return 1;
      case 2:
        return 2;
      default:
        return 3;
    }
  };
  var $elm$browser$Browser$External = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $elm$browser$Browser$Internal = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $elm$core$Basics$identity = function (x) {
    return x;
  };
  var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
  var $elm$url$Url$Http = 0;
  var $elm$url$Url$Https = 1;
  var $elm$url$Url$Url = F6(function (protocol, host, port_, path, query, fragment) {
    return {
      nK: fragment,
      ik: host,
      cb: path,
      kc: port_,
      ke: protocol,
      qR: query
    };
  });
  var $elm$core$String$contains = _String_contains;
  var $elm$core$String$length = _String_length;
  var $elm$core$String$slice = _String_slice;
  var $elm$core$String$dropLeft = F2(function (n, string) {
    return n < 1 ? string : A3($elm$core$String$slice, n, $elm$core$String$length(string), string);
  });
  var $elm$core$String$indexes = _String_indexes;
  var $elm$core$String$isEmpty = function (string) {
    return string === '';
  };
  var $elm$core$String$left = F2(function (n, string) {
    return n < 1 ? '' : A3($elm$core$String$slice, 0, n, string);
  });
  var $elm$core$String$toInt = _String_toInt;
  var $elm$url$Url$chompBeforePath = F5(function (protocol, path, params, frag, str) {
    if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
      return $elm$core$Maybe$Nothing;
    } else {
      var _v0 = A2($elm$core$String$indexes, ':', str);
      if (!_v0.b) {
        return $elm$core$Maybe$Just(A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
      } else {
        if (!_v0.b.b) {
          var i = _v0.a;
          var _v1 = $elm$core$String$toInt(A2($elm$core$String$dropLeft, i + 1, str));
          if (_v1.$ === 1) {
            return $elm$core$Maybe$Nothing;
          } else {
            var port_ = _v1;
            return $elm$core$Maybe$Just(A6($elm$url$Url$Url, protocol, A2($elm$core$String$left, i, str), port_, path, params, frag));
          }
        } else {
          return $elm$core$Maybe$Nothing;
        }
      }
    }
  });
  var $elm$url$Url$chompBeforeQuery = F4(function (protocol, params, frag, str) {
    if ($elm$core$String$isEmpty(str)) {
      return $elm$core$Maybe$Nothing;
    } else {
      var _v0 = A2($elm$core$String$indexes, '/', str);
      if (!_v0.b) {
        return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
      } else {
        var i = _v0.a;
        return A5($elm$url$Url$chompBeforePath, protocol, A2($elm$core$String$dropLeft, i, str), params, frag, A2($elm$core$String$left, i, str));
      }
    }
  });
  var $elm$url$Url$chompBeforeFragment = F3(function (protocol, frag, str) {
    if ($elm$core$String$isEmpty(str)) {
      return $elm$core$Maybe$Nothing;
    } else {
      var _v0 = A2($elm$core$String$indexes, '?', str);
      if (!_v0.b) {
        return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
      } else {
        var i = _v0.a;
        return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Just(A2($elm$core$String$dropLeft, i + 1, str)), frag, A2($elm$core$String$left, i, str));
      }
    }
  });
  var $elm$url$Url$chompAfterProtocol = F2(function (protocol, str) {
    if ($elm$core$String$isEmpty(str)) {
      return $elm$core$Maybe$Nothing;
    } else {
      var _v0 = A2($elm$core$String$indexes, '#', str);
      if (!_v0.b) {
        return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
      } else {
        var i = _v0.a;
        return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Just(A2($elm$core$String$dropLeft, i + 1, str)), A2($elm$core$String$left, i, str));
      }
    }
  });
  var $elm$core$String$startsWith = _String_startsWith;
  var $elm$url$Url$fromString = function (str) {
    return A2($elm$core$String$startsWith, 'http://', str) ? A2($elm$url$Url$chompAfterProtocol, 0, A2($elm$core$String$dropLeft, 7, str)) : A2($elm$core$String$startsWith, 'https://', str) ? A2($elm$url$Url$chompAfterProtocol, 1, A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing;
  };
  var $elm$core$Basics$never = function (_v0) {
    never: while (true) {
      var nvr = _v0;
      var $temp$_v0 = nvr;
      _v0 = $temp$_v0;
      continue never;
    }
  };
  var $elm$core$Task$Perform = $elm$core$Basics$identity;
  var $elm$core$Task$succeed = _Scheduler_succeed;
  var $elm$core$Task$init = $elm$core$Task$succeed(0);
  var $elm$core$List$foldrHelper = F4(function (fn, acc, ctr, ls) {
    if (!ls.b) {
      return acc;
    } else {
      var a = ls.a;
      var r1 = ls.b;
      if (!r1.b) {
        return A2(fn, a, acc);
      } else {
        var b = r1.a;
        var r2 = r1.b;
        if (!r2.b) {
          return A2(fn, a, A2(fn, b, acc));
        } else {
          var c = r2.a;
          var r3 = r2.b;
          if (!r3.b) {
            return A2(fn, a, A2(fn, b, A2(fn, c, acc)));
          } else {
            var d = r3.a;
            var r4 = r3.b;
            var res = ctr > 500 ? A3($elm$core$List$foldl, fn, acc, $elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
            return A2(fn, a, A2(fn, b, A2(fn, c, A2(fn, d, res))));
          }
        }
      }
    }
  });
  var $elm$core$List$foldr = F3(function (fn, acc, ls) {
    return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
  });
  var $elm$core$List$map = F2(function (f, xs) {
    return A3($elm$core$List$foldr, F2(function (x, acc) {
      return A2($elm$core$List$cons, f(x), acc);
    }), _List_Nil, xs);
  });
  var $elm$core$Task$andThen = _Scheduler_andThen;
  var $elm$core$Task$map = F2(function (func, taskA) {
    return A2($elm$core$Task$andThen, function (a) {
      return $elm$core$Task$succeed(func(a));
    }, taskA);
  });
  var $elm$core$Task$map2 = F3(function (func, taskA, taskB) {
    return A2($elm$core$Task$andThen, function (a) {
      return A2($elm$core$Task$andThen, function (b) {
        return $elm$core$Task$succeed(A2(func, a, b));
      }, taskB);
    }, taskA);
  });
  var $elm$core$Task$sequence = function (tasks) {
    return A3($elm$core$List$foldr, $elm$core$Task$map2($elm$core$List$cons), $elm$core$Task$succeed(_List_Nil), tasks);
  };
  var $elm$core$Platform$sendToApp = _Platform_sendToApp;
  var $elm$core$Task$spawnCmd = F2(function (router, _v0) {
    var task = _v0;
    return _Scheduler_spawn(A2($elm$core$Task$andThen, $elm$core$Platform$sendToApp(router), task));
  });
  var $elm$core$Task$onEffects = F3(function (router, commands, state) {
    return A2($elm$core$Task$map, function (_v0) {
      return 0;
    }, $elm$core$Task$sequence(A2($elm$core$List$map, $elm$core$Task$spawnCmd(router), commands)));
  });
  var $elm$core$Task$onSelfMsg = F3(function (_v0, _v1, _v2) {
    return $elm$core$Task$succeed(0);
  });
  var $elm$core$Task$cmdMap = F2(function (tagger, _v0) {
    var task = _v0;
    return A2($elm$core$Task$map, tagger, task);
  });
  _Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
  var $elm$core$Task$command = _Platform_leaf('Task');
  var $elm$core$Task$perform = F2(function (toMessage, task) {
    return $elm$core$Task$command(A2($elm$core$Task$map, toMessage, task));
  });
  var $elm$browser$Browser$element = _Browser_element;
  var $author$project$ElmFramework$Msg$AppMsg = function (a) {
    return {
      $: 8,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$UnknownPushPermissions = {
    $: 0
  };
  var $elm$core$Platform$Cmd$batch = _Platform_batch;
  var $wernerdegroot$listzipper$List$Zipper$current = function (_v0) {
    var x = _v0.b;
    return x;
  };
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$current = function (_v0) {
    var routeHistory = _v0.a;
    return $wernerdegroot$listzipper$List$Zipper$current(routeHistory);
  };
  var $elm$time$Time$Zone = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $elm$time$Time$customZone = $elm$time$Time$Zone;
  var $author$project$ElmFramework$Lib$MsgAnything$dispatchMessages = F2(function (mainUpdate, _v0) {
    var state = _v0.aC;
    var commands = _v0.uA;
    var messages = _v0.yn;
    var runMessages = F2(function (currMsg, _v2) {
      var newState = _v2.a;
      var newCmd = _v2.b;
      return function (_v1) {
        var newestState = _v1.a;
        var newestCmd = _v1.b;
        return _Utils_Tuple2(newestState, $elm$core$Platform$Cmd$batch(_List_fromArray([newCmd, newestCmd])));
      }(A2(mainUpdate, currMsg, newState));
    });
    return A3($elm$core$List$foldl, runMessages, _Utils_Tuple2(state, commands), messages);
  });
  var $folkertdev$elm_deque$BoundedDeque$BoundedDeque = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $folkertdev$elm_deque$Internal$empty = {
    ab: _List_Nil,
    ae: _List_Nil,
    V: 0,
    W: 0
  };
  var $folkertdev$elm_deque$BoundedDeque$empty = function (size) {
    return A2($folkertdev$elm_deque$BoundedDeque$BoundedDeque, $folkertdev$elm_deque$Internal$empty, size);
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$init = function (isHybrid) {
    return {
      g$: false,
      h0: false,
      ig: false,
      gA: false
    };
  };
  var $author$project$ElmFramework$Feature$Toaster$Toaster$init = {
    b$: 0,
    aQ: $elm$core$Array$empty,
    O: 0
  };
  var $elm$random$Random$Seed = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
  var $elm$random$Random$next = function (_v0) {
    var state0 = _v0.a;
    var incr = _v0.b;
    return A2($elm$random$Random$Seed, state0 * 1664525 + incr >>> 0, incr);
  };
  var $elm$random$Random$initialSeed = function (x) {
    var _v0 = $elm$random$Random$next(A2($elm$random$Random$Seed, 0, 1013904223));
    var state1 = _v0.a;
    var incr = _v0.b;
    var state2 = state1 + x >>> 0;
    return $elm$random$Random$next(A2($elm$random$Random$Seed, state2, incr));
  };
  var $elm$json$Json$Encode$null = _Json_encodeNull;
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$loadSocialLibraries = _Platform_outgoingPort('loadSocialLibraries', function ($) {
    return $elm$json$Json$Encode$null;
  });
  var $elm$core$Platform$Cmd$map = _Platform_map;
  var $elm$time$Time$Posix = $elm$core$Basics$identity;
  var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
  var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory = F3(function (a, b, c) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c
    };
  });
  var $wernerdegroot$listzipper$List$Zipper$Zipper = F3(function (a, b, c) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c
    };
  });
  var $wernerdegroot$listzipper$List$Zipper$singleton = function (x) {
    return A3($wernerdegroot$listzipper$List$Zipper$Zipper, _List_Nil, x, _List_Nil);
  };
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$singleton = function (route) {
    return A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, $wernerdegroot$listzipper$List$Zipper$singleton(route), $elm$core$Maybe$Nothing, false);
  };
  var $author$project$ElmFramework$Feature$Pwa$Pwa$PwaInstalled = 2;
  var $author$project$ElmFramework$Feature$Pwa$Pwa$PwaNotInstalled = 0;
  var $author$project$ElmFramework$InitArgs$toEnv = function (envArg) {
    return {
      e9: envArg.e9,
      fa: envArg.fa,
      fL: envArg.fL,
      fM: envArg.fM,
      fN: envArg.fN,
      xd: envArg.xd,
      fO: envArg.fO,
      fP: envArg.fP,
      fQ: envArg.fQ,
      fR: envArg.fR,
      fS: envArg.fS,
      f7: envArg.f7,
      gi: envArg.gi ? 2 : 0,
      c8: envArg.c8,
      gD: envArg.gD,
      Cs: envArg.Cs
    };
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$DeniedGeoPermissions = {
    $: 4
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$ReceivingGeoLocation = {
    $: 1
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnknownGeoPermissionStatus = {
    $: 0
  };
  var $elm$json$Json$Encode$bool = _Json_wrap;
  var $elm$core$Maybe$destruct = F3(function (_default, func, maybe) {
    if (!maybe.$) {
      var a = maybe.a;
      return func(a);
    } else {
      return _default;
    }
  });
  var $elm$json$Json$Encode$int = _Json_wrap;
  var $elm$json$Json$Encode$object = function (pairs) {
    return _Json_wrap(A3($elm$core$List$foldl, F2(function (_v0, obj) {
      var k = _v0.a;
      var v = _v0.b;
      return A3(_Json_addField, k, v, obj);
    }), _Json_emptyObject(0), pairs));
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$requestGeolocation = _Platform_outgoingPort('requestGeolocation', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('enableHighAccuracy', $elm$json$Json$Encode$bool($.hP)), _Utils_Tuple2('explicitRequest', $elm$json$Json$Encode$bool($.hZ)), _Utils_Tuple2('maximumAge', function ($) {
      return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$int, $);
    }($.i_)), _Utils_Tuple2('timeout', function ($) {
      return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$int, $);
    }($.lf))]));
  });
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$simpleGeolocationReq = function (isExplicitRequest) {
    return $author$project$ElmFramework$Feature$Geolocation$Geolocation$requestGeolocation({
      hP: false,
      hZ: isExplicitRequest,
      i_: $elm$core$Maybe$Nothing,
      lf: $elm$core$Maybe$Just(15000)
    });
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$toInitGeoPermissions = F2(function (status, shouldGetGeolocationOnInit) {
    if (!status.$) {
      if (status.a) {
        return _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, false, $author$project$ElmFramework$Feature$Geolocation$Geolocation$ReceivingGeoLocation), shouldGetGeolocationOnInit ? $author$project$ElmFramework$Feature$Geolocation$Geolocation$simpleGeolocationReq(true) : $elm$core$Platform$Cmd$none);
      } else {
        return _Utils_Tuple2($author$project$ElmFramework$Feature$Geolocation$Geolocation$DeniedGeoPermissions, $elm$core$Platform$Cmd$none);
      }
    } else {
      return _Utils_Tuple2($author$project$ElmFramework$Feature$Geolocation$Geolocation$UnknownGeoPermissionStatus, $elm$core$Platform$Cmd$none);
    }
  });
  var $author$project$ElmFramework$Lib$StateCmd$addCmd = F2(function (newCmd, _v0) {
    var state = _v0.a;
    var cmd = _v0.b;
    return _Utils_Tuple2(state, $elm$core$Platform$Cmd$batch(_List_fromArray([cmd, newCmd])));
  });
  var $elm$core$Basics$composeL = F3(function (g, f, x) {
    return g(f(x));
  });
  var $elm$core$String$concat = function (strings) {
    return A2($elm$core$String$join, '', strings);
  };
  var $elm$core$List$filter = F2(function (isGood, list) {
    return A3($elm$core$List$foldr, F2(function (x, xs) {
      return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
    }), _List_Nil, list);
  });
  var $elm$core$List$maybeCons = F3(function (f, mx, xs) {
    var _v0 = f(mx);
    if (!_v0.$) {
      var x = _v0.a;
      return A2($elm$core$List$cons, x, xs);
    } else {
      return xs;
    }
  });
  var $elm$core$List$filterMap = F2(function (f, xs) {
    return A3($elm$core$List$foldr, $elm$core$List$maybeCons(f), _List_Nil, xs);
  });
  var $elm$core$Dict$RBEmpty_elm_builtin = {
    $: -2
  };
  var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
  var $elm$core$Dict$Black = 1;
  var $elm$core$Dict$RBNode_elm_builtin = F5(function (a, b, c, d, e) {
    return {
      $: -1,
      a: a,
      b: b,
      c: c,
      d: d,
      e: e
    };
  });
  var $elm$core$Dict$Red = 0;
  var $elm$core$Dict$balance = F5(function (color, key, value, left, right) {
    if (right.$ === -1 && !right.a) {
      var _v1 = right.a;
      var rK = right.b;
      var rV = right.c;
      var rLeft = right.d;
      var rRight = right.e;
      if (left.$ === -1 && !left.a) {
        var _v3 = left.a;
        var lK = left.b;
        var lV = left.c;
        var lLeft = left.d;
        var lRight = left.e;
        return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
      } else {
        return A5($elm$core$Dict$RBNode_elm_builtin, color, rK, rV, A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft), rRight);
      }
    } else {
      if (left.$ === -1 && !left.a && left.d.$ === -1 && !left.d.a) {
        var _v5 = left.a;
        var lK = left.b;
        var lV = left.c;
        var _v6 = left.d;
        var _v7 = _v6.a;
        var llK = _v6.b;
        var llV = _v6.c;
        var llLeft = _v6.d;
        var llRight = _v6.e;
        var lRight = left.e;
        return A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight), A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
      } else {
        return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
      }
    }
  });
  var $elm$core$Basics$compare = _Utils_compare;
  var $elm$core$Dict$insertHelp = F3(function (key, value, dict) {
    if (dict.$ === -2) {
      return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
    } else {
      var nColor = dict.a;
      var nKey = dict.b;
      var nValue = dict.c;
      var nLeft = dict.d;
      var nRight = dict.e;
      var _v1 = A2($elm$core$Basics$compare, key, nKey);
      switch (_v1) {
        case 0:
          return A5($elm$core$Dict$balance, nColor, nKey, nValue, A3($elm$core$Dict$insertHelp, key, value, nLeft), nRight);
        case 1:
          return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
        default:
          return A5($elm$core$Dict$balance, nColor, nKey, nValue, nLeft, A3($elm$core$Dict$insertHelp, key, value, nRight));
      }
    }
  });
  var $elm$core$Dict$insert = F3(function (key, value, dict) {
    var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
    if (_v0.$ === -1 && !_v0.a) {
      var _v1 = _v0.a;
      var k = _v0.b;
      var v = _v0.c;
      var l = _v0.d;
      var r = _v0.e;
      return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
    } else {
      var x = _v0;
      return x;
    }
  });
  var $elm$core$Dict$fromList = function (assocs) {
    return A3($elm$core$List$foldl, F2(function (_v0, dict) {
      var key = _v0.a;
      var value = _v0.b;
      return A3($elm$core$Dict$insert, key, value, dict);
    }), $elm$core$Dict$empty, assocs);
  };
  var $author$project$ElmFramework$Lib$Util$ifElse = F3(function (forTrue, forFalse, bool) {
    return bool ? forTrue : forFalse;
  });
  var $elm$core$Maybe$map2 = F3(function (func, ma, mb) {
    if (ma.$ === 1) {
      return $elm$core$Maybe$Nothing;
    } else {
      var a = ma.a;
      if (mb.$ === 1) {
        return $elm$core$Maybe$Nothing;
      } else {
        var b = mb.a;
        return $elm$core$Maybe$Just(A2(func, a, b));
      }
    }
  });
  var $elm$core$Tuple$mapBoth = F3(function (funcA, funcB, _v0) {
    var x = _v0.a;
    var y = _v0.b;
    return _Utils_Tuple2(funcA(x), funcB(y));
  });
  var $elm$core$Basics$not = _Basics_not;
  var $elm$core$Tuple$pair = F2(function (a, b) {
    return _Utils_Tuple2(a, b);
  });
  var $elm$url$Url$percentDecode = _Url_percentDecode;
  var $TSFoster$elm_tuple_extra$Tuple2$uncurry = F2(function (fn, _v0) {
    var a = _v0.a;
    var b = _v0.b;
    return A2(fn, a, b);
  });
  var $author$project$ElmFramework$Lib$Url$fromNavigationLocation = function (location) {
    var splitAndFilterEmpty = F2(function (delimiter, string) {
      return A2($elm$core$List$filter, A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty), A2($elm$core$String$split, delimiter, string));
    });
    var removeQuestionMarkPrefix = function (string) {
      return A3($author$project$ElmFramework$Lib$Util$ifElse, A2($elm$core$String$dropLeft, 1, string), string, A2($elm$core$String$startsWith, '?', string));
    };
    var pathList = A2(splitAndFilterEmpty, '/', location.j9);
    var listToTuple = function (list) {
      var maybeList = A3($author$project$ElmFramework$Lib$Util$ifElse, $elm$core$Maybe$Just(list), $elm$core$Maybe$Nothing, $elm$core$List$length(list) === 2);
      if (!maybeList.$ && maybeList.a.b && maybeList.a.b.b && !maybeList.a.b.b.b) {
        var _v1 = maybeList.a;
        var key = _v1.a;
        var _v2 = _v1.b;
        var value = _v2.a;
        return $elm$core$Maybe$Just(_Utils_Tuple2(key, value));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    };
    var decodeQueryParams = function (list) {
      return A2($elm$core$List$filterMap, $TSFoster$elm_tuple_extra$Tuple2$uncurry($elm$core$Maybe$map2($elm$core$Tuple$pair)), A2($elm$core$List$map, A2($elm$core$Tuple$mapBoth, $elm$url$Url$percentDecode, $elm$url$Url$percentDecode), list));
    };
    var addDefaultValueIfEmpty = F2(function (_default, string) {
      return A3($author$project$ElmFramework$Lib$Util$ifElse, string, $elm$core$String$concat(_List_fromArray([string, '=', _default])), A2($elm$core$String$contains, '=', string));
    });
    var queryDict = $elm$core$Dict$fromList(decodeQueryParams(A2($elm$core$List$filterMap, listToTuple, A2($elm$core$List$map, splitAndFilterEmpty('='), A2($elm$core$List$map, addDefaultValueIfEmpty('true'), A2(splitAndFilterEmpty, '&', removeQuestionMarkPrefix(location.kH)))))));
    return {
      cb: pathList,
      ex: queryDict
    };
  };
  var $elm$core$Maybe$map = F2(function (f, maybe) {
    if (!maybe.$) {
      var value = maybe.a;
      return $elm$core$Maybe$Just(f(value));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$PushState = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$ReplaceState = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $wernerdegroot$listzipper$List$Zipper$before = function (_v0) {
    var ls = _v0.a;
    return $elm$core$List$reverse(ls);
  };
  var $wernerdegroot$listzipper$List$Zipper$from = F3(function (bef, curr, aft) {
    return A3($wernerdegroot$listzipper$List$Zipper$Zipper, $elm$core$List$reverse(bef), curr, aft);
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$newRoute = F2(function (route, _v0) {
    var routeHistory = _v0.a;
    return A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, A3($wernerdegroot$listzipper$List$Zipper$from, _Utils_ap($wernerdegroot$listzipper$List$Zipper$before(routeHistory), _List_fromArray([$wernerdegroot$listzipper$List$Zipper$current(routeHistory)])), route, _List_Nil), $elm$core$Maybe$Nothing, false);
  });
  var $elm$core$Basics$always = F2(function (a, _v0) {
    return a;
  });
  var $wernerdegroot$listzipper$List$Zipper$mapCurrent = F2(function (f, _v0) {
    var ls = _v0.a;
    var x = _v0.b;
    var rs = _v0.c;
    return A3($wernerdegroot$listzipper$List$Zipper$Zipper, ls, f(x), rs);
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$replaceRoute = F2(function (route, _v0) {
    var routeHistory = _v0.a;
    var isBack = _v0.c;
    return A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, A2($wernerdegroot$listzipper$List$Zipper$mapCurrent, $elm$core$Basics$always(route), routeHistory), $elm$core$Maybe$Nothing, isBack);
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$toZipperHistoryIndex = function (zipperHistory) {
    return $elm$core$List$length($wernerdegroot$listzipper$List$Zipper$before(zipperHistory));
  };
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$toCurrIndex = function (_v0) {
    var routeHistory = _v0.a;
    return $author$project$ElmFramework$Feature$Navigation$RouteHistory$toZipperHistoryIndex(routeHistory);
  };
  var $elm$json$Json$Encode$list = F2(function (func, entries) {
    return _Json_wrap(A3($elm$core$List$foldl, _Json_addEntry(func), _Json_emptyArray(0), entries));
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$routingCommands = _Platform_outgoingPort('routingCommands', $elm$json$Json$Encode$list($elm$core$Basics$identity));
  var $elm$json$Json$Encode$string = _Json_wrap;
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands = function (commands) {
    var toCommand = function (cmd) {
      switch (cmd.$) {
        case 0:
          var routeState = cmd.a;
          return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('kind', $elm$json$Json$Encode$string('pushState')), _Utils_Tuple2('stateIndex', $elm$json$Json$Encode$int(routeState.a5)), _Utils_Tuple2('title', $elm$json$Json$Encode$string(routeState.lh)), _Utils_Tuple2('url', $elm$json$Json$Encode$string(routeState.eZ))]));
        case 1:
          var routeState = cmd.a;
          return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('kind', $elm$json$Json$Encode$string('replaceState')), _Utils_Tuple2('stateIndex', $elm$json$Json$Encode$int(routeState.a5)), _Utils_Tuple2('title', $elm$json$Json$Encode$string(routeState.lh)), _Utils_Tuple2('url', $elm$json$Json$Encode$string(routeState.eZ))]));
        default:
          var _int = cmd.a;
          return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('kind', $elm$json$Json$Encode$string('go')), _Utils_Tuple2('steps', $elm$json$Json$Encode$int(_int))]));
      }
    };
    return $author$project$ElmFramework$Feature$Navigation$RouteHistory$routingCommands(A2($elm$core$List$map, toCommand, commands));
  };
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$replaceCurrentAndRouteTo = function (config) {
    var theRoutingCommands = _List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$ReplaceState({
      a5: $author$project$ElmFramework$Feature$Navigation$RouteHistory$toCurrIndex(config.ci),
      lh: config.A1,
      eZ: config.A2
    }), $author$project$ElmFramework$Feature$Navigation$RouteHistory$PushState({
      a5: $author$project$ElmFramework$Feature$Navigation$RouteHistory$toCurrIndex(config.ci) + 1,
      lh: config.Bw,
      eZ: config.By
    })]);
    var routeHistory = A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$newRoute, config.Bt, A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$replaceRoute, config.A0, config.ci));
    return _Utils_Tuple2(routeHistory, $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(theRoutingCommands));
  };
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError = _Platform_outgoingPort('generalError', $elm$json$Json$Encode$string);
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$toGeneralErrorString = function (description) {
    return '' + description;
  };
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr = F2(function (description, err) {
    return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$toGeneralErrorString(description) + (': ' + err));
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$setRoute = function (config) {
    return config.kR ? _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$replaceRoute, config.rh, config.ci), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$ReplaceState({
      a5: $author$project$ElmFramework$Feature$Navigation$RouteHistory$toCurrIndex(config.ci),
      lh: config.lh,
      eZ: config.eZ
    })]))) : _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$newRoute, config.rh, config.ci), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$PushState({
      a5: $author$project$ElmFramework$Feature$Navigation$RouteHistory$toCurrIndex(config.ci) + 1,
      lh: config.lh,
      eZ: config.eZ
    })])));
  };
  var $author$project$ElmFramework$Feature$Platform$Platform$setTitleAndDescription = _Platform_outgoingPort('setTitleAndDescription', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('description', $elm$json$Json$Encode$string($.vn)), _Utils_Tuple2('title', $elm$json$Json$Encode$string($.lh))]));
  });
  var $elm$core$Dict$isEmpty = function (dict) {
    if (dict.$ === -2) {
      return true;
    } else {
      return false;
    }
  };
  var $elm$url$Url$percentEncode = _Url_percentEncode;
  var $author$project$ElmFramework$Lib$Url$toUrlString = function (url) {
    var foldToQueryString = F3(function (key, value, result) {
      var prepend = A3($author$project$ElmFramework$Lib$Util$ifElse, '', '&', result === '?');
      var encodedValue = $elm$url$Url$percentEncode(value);
      var encodedKey = $elm$url$Url$percentEncode(key);
      return $elm$core$String$concat(_List_fromArray([result, prepend, encodedKey, '=', encodedValue]));
    });
    var toQueryString = function (queryParams) {
      return A3($author$project$ElmFramework$Lib$Util$ifElse, '', A3($elm$core$Dict$foldr, foldToQueryString, '?', queryParams), $elm$core$Dict$isEmpty(queryParams));
    };
    return $elm$core$String$concat(_List_fromArray([A2($elm$core$String$join, '/', url.cb), toQueryString(url.ex)]));
  };
  var $elm$core$Maybe$withDefault = F2(function (_default, maybe) {
    if (!maybe.$) {
      var value = maybe.a;
      return value;
    } else {
      return _default;
    }
  });
  var $author$project$ElmFramework$Feature$Navigation$Routing$toInitialRoute = F3(function (config, programArgs, appState) {
    var setTitleAndDesc = function (route) {
      return $author$project$ElmFramework$Feature$Platform$Platform$setTitleAndDescription(A2(config.Bx, appState, route));
    };
    var reportUnsupportedFirstRoute = function (_v0) {
      var history = _v0.a;
      var cmd = _v0.b;
      return _Utils_Tuple2(history, $elm$core$Platform$Cmd$batch(_List_fromArray([cmd, programArgs.hN.yA.j9 === '/' ? $elm$core$Platform$Cmd$none : A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'replaceWithHomeRouteAndReportErr', programArgs.hN.yA.j9)])));
    };
    var replaceWithHomeRoute = A2($author$project$ElmFramework$Lib$StateCmd$addCmd, setTitleAndDesc(config.wB), $author$project$ElmFramework$Feature$Navigation$RouteHistory$setRoute({
      rh: config.wB,
      ci: $author$project$ElmFramework$Feature$Navigation$RouteHistory$singleton(config.wB),
      kR: true,
      lh: A2(config.Bx, appState, config.wB).lh,
      eZ: $author$project$ElmFramework$Lib$Url$toUrlString(config.By(config.wB))
    }));
    var replaceWithHomeAndRouteToAuthRoute = A2($author$project$ElmFramework$Lib$StateCmd$addCmd, setTitleAndDesc(config.tC), $author$project$ElmFramework$Feature$Navigation$RouteHistory$replaceCurrentAndRouteTo({
      A0: config.wB,
      A1: A2(config.Bx, appState, config.wB).lh,
      A2: $author$project$ElmFramework$Lib$Url$toUrlString(config.By(config.wB)),
      ci: $author$project$ElmFramework$Feature$Navigation$RouteHistory$singleton(config.wB),
      Bt: config.tC,
      Bw: A2(config.Bx, appState, config.tC).lh,
      By: $author$project$ElmFramework$Lib$Url$toUrlString(config.By(config.tC))
    }));
    var replaceWithDefaultRouteAndReportErr = config.Bs(config.wB) ? reportUnsupportedFirstRoute(replaceWithHomeAndRouteToAuthRoute) : reportUnsupportedFirstRoute(replaceWithHomeRoute);
    var decideFirstAndSecondRoute = function (route) {
      return config.Bs(route) && _Utils_eq(config.w8(appState), $elm$core$Maybe$Just(false)) ? A2($author$project$ElmFramework$Lib$StateCmd$addCmd, setTitleAndDesc(config.tC), $author$project$ElmFramework$Feature$Navigation$RouteHistory$replaceCurrentAndRouteTo({
        A0: route,
        A1: A2(config.Bx, appState, route).lh,
        A2: $author$project$ElmFramework$Lib$Url$toUrlString(config.By(route)),
        ci: $author$project$ElmFramework$Feature$Navigation$RouteHistory$singleton(route),
        Bt: config.tC,
        Bw: A2(config.Bx, appState, config.tC).lh,
        By: $author$project$ElmFramework$Lib$Url$toUrlString(config.By(config.tC))
      })) : _Utils_eq(route, config.wB) ? replaceWithHomeRoute : A2($author$project$ElmFramework$Lib$StateCmd$addCmd, setTitleAndDesc(route), $author$project$ElmFramework$Feature$Navigation$RouteHistory$replaceCurrentAndRouteTo({
        A0: config.wB,
        A1: A2(config.Bx, appState, config.wB).lh,
        A2: $author$project$ElmFramework$Lib$Url$toUrlString(config.By(config.wB)),
        ci: $author$project$ElmFramework$Feature$Navigation$RouteHistory$singleton(config.wB),
        Bt: route,
        Bw: A2(config.Bx, appState, route).lh,
        By: $author$project$ElmFramework$Lib$Url$toUrlString(config.By(route))
      }));
    };
    return A2($elm$core$Maybe$withDefault, replaceWithDefaultRouteAndReportErr, A2($elm$core$Maybe$map, decideFirstAndSecondRoute, config.C7($author$project$ElmFramework$Lib$Url$fromNavigationLocation(programArgs.hN.yA))));
  });
  var $author$project$ElmFramework$Util$toVirtualPageViewCmd = F3(function (config, topState, route) {
    return $elm$core$Platform$Cmd$none;
  });
  var $author$project$ElmFramework$Feature$Navigation$Msg$RouteBackWhileDroppingWithMaybeDefault = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Feature$Navigation$Msg$RouteTo = F3(function (a, b, c) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$ElmFramework$Msg$RoutingMsg = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$ElmFramework$Msg$EnoughInitialCpuIdle = {
    $: 6
  };
  var $author$project$ElmFramework$Feature$Pwa$Pwa$PwaReadyToInstall = 1;
  var $author$project$ElmFramework$Msg$ReceiveGeolocation = function (a) {
    return {
      $: 18,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$ReceivedGeoLocation = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$ElmFramework$Msg$RestartApp = {
    $: 1
  };
  var $author$project$ElmFramework$Msg$ToasterMsg = function (a) {
    return {
      $: 12,
      a: a
    };
  };
  var $author$project$ElmFramework$Msg$TrackingMsg = function (a) {
    return {
      $: 24,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation = {
    $: 0
  };
  var $author$project$ElmFramework$Feature$Platform$Platform$enoughInitialCpuIdle = _Platform_outgoingPort('enoughInitialCpuIdle', function ($) {
    return $elm$json$Json$Encode$null;
  });
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$AskingForLocation = {
    $: 1
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$locateMe = F2(function (tag, geolocationAndPermissions) {
    if (geolocationAndPermissions.$ === 2) {
      if (geolocationAndPermissions.b.$ === 2) {
        var geolocation = geolocationAndPermissions.b.a;
        return _Utils_Tuple2(geolocationAndPermissions, A2($elm$core$Task$perform, tag, $elm$core$Task$succeed({
          fH: $elm$core$Result$Ok(geolocation),
          aL: true
        })));
      } else {
        var evenInBack = geolocationAndPermissions.a;
        return _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, evenInBack, $author$project$ElmFramework$Feature$Geolocation$Geolocation$ReceivingGeoLocation), $author$project$ElmFramework$Feature$Geolocation$Geolocation$simpleGeolocationReq(true));
      }
    } else {
      return _Utils_Tuple2($author$project$ElmFramework$Feature$Geolocation$Geolocation$AskingForLocation, $author$project$ElmFramework$Feature$Geolocation$Geolocation$simpleGeolocationReq(true));
    }
  });
  var $elm$core$List$any = F2(function (isOkay, list) {
    any: while (true) {
      if (!list.b) {
        return false;
      } else {
        var x = list.a;
        var xs = list.b;
        if (isOkay(x)) {
          return true;
        } else {
          var $temp$isOkay = isOkay,
            $temp$list = xs;
          isOkay = $temp$isOkay;
          list = $temp$list;
          continue any;
        }
      }
    }
  });
  var $elm$core$List$member = F2(function (x, xs) {
    return A2($elm$core$List$any, function (a) {
      return _Utils_eq(a, x);
    }, xs);
  });
  var $folkertdev$elm_deque$Internal$member = F2(function (elem, deque) {
    return A2($elm$core$List$member, elem, deque.ab) || A2($elm$core$List$member, elem, deque.ae);
  });
  var $folkertdev$elm_deque$BoundedDeque$member = F2(function (elem, _v0) {
    var deque = _v0.a;
    return A2($folkertdev$elm_deque$Internal$member, elem, deque);
  });
  var $author$project$ElmFramework$Feature$Navigation$Msg$DropWhileAndRouteTo = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Msg$LocateMe = {
    $: 0
  };
  var $author$project$ElmFramework$Msg$MultiMsg = function (a) {
    return {
      $: 9,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Navigation$Msg$RouteBack = {
    $: 5
  };
  var $author$project$ElmFramework$Feature$Navigation$Msg$RouteBackTo = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Feature$Navigation$Msg$RouteForward = {
    $: 6
  };
  var $author$project$ElmFramework$Feature$Navigation$Msg$RouteForwardTo = F2(function (a, b) {
    return {
      $: 4,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Msg$Share = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Toaster$Toaster$NewToast = function (a) {
    return {
      $: 5,
      a: a
    };
  };
  var $author$project$Icon$Messages = 4;
  var $author$project$ElmFramework$Feature$Toaster$Toaster$ActionTap = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $elm$html$Html$Attributes$stringProperty = F2(function (key, string) {
    return A2(_VirtualDom_property, key, $elm$json$Json$Encode$string(string));
  });
  var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
  var $elm$core$Tuple$second = function (_v0) {
    var y = _v0.b;
    return y;
  };
  var $elm$html$Html$Attributes$classList = function (classes) {
    return $elm$html$Html$Attributes$class(A2($elm$core$String$join, ' ', A2($elm$core$List$map, $elm$core$Tuple$first, A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
  };
  var $elm$html$Html$div = _VirtualDom_node('div');
  var $elm$html$Html$i = _VirtualDom_node('i');
  var $elm$virtual_dom$VirtualDom$attribute = F2(function (key, value) {
    return A2(_VirtualDom_attribute, _VirtualDom_noOnOrFormAction(key), _VirtualDom_noJavaScriptOrHtmlUri(value));
  });
  var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
  var $author$project$ElmFramework$Lib$Util$noOpAttr = A2($elm$html$Html$Attributes$attribute, 'no-op-attr', 'no-op-attr');
  var $elm$virtual_dom$VirtualDom$Custom = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
  var $elm$html$Html$Events$custom = F2(function (event, decoder) {
    return A2($elm$virtual_dom$VirtualDom$on, event, $elm$virtual_dom$VirtualDom$Custom(decoder));
  });
  var $author$project$ElmFramework$Lib$Util$noBubble = function (msg) {
    return $elm$json$Json$Decode$succeed({
      f0: msg,
      kd: true,
      k8: true
    });
  };
  var $author$project$ElmFramework$Lib$Util$onTap = function (msg) {
    return A2($elm$html$Html$Events$custom, 'customTap', $author$project$ElmFramework$Lib$Util$noBubble(msg));
  };
  var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(function (_default, f, m) {
    if (m.$ === 1) {
      return _default;
    } else {
      var a = m.a;
      return f(a);
    }
  });
  var $author$project$Icon$iconConstructor = F3(function (maybeMsg, iconName, classes) {
    return A2($elm$html$Html$i, _List_fromArray([$elm$html$Html$Attributes$class('icon-' + iconName), $elm$html$Html$Attributes$class('icon'), $elm$html$Html$Attributes$class(classes), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$Util$noOpAttr, $author$project$ElmFramework$Lib$Util$onTap, maybeMsg)]), _List_Nil);
  });
  var $author$project$Icon$toStrFromIcon = function (theIcon) {
    switch (theIcon) {
      case 0:
        return 'info';
      case 1:
        return 'arrow_left';
      case 2:
        return 'check';
      case 3:
        return 'close';
      case 4:
        return 'messages';
      default:
        return 'report';
    }
  };
  var $author$project$Icon$iconConstructorFromIcon = F3(function (maybeMsg, theIcon, classes) {
    return A3($author$project$Icon$iconConstructor, maybeMsg, $author$project$Icon$toStrFromIcon(theIcon), classes);
  });
  var $author$project$Icon$iconNoOp = $author$project$Icon$iconConstructorFromIcon($elm$core$Maybe$Nothing);
  var $elm$virtual_dom$VirtualDom$node = function (tag) {
    return _VirtualDom_node(_VirtualDom_noScript(tag));
  };
  var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
  var $author$project$ElmFramework$Lib$Ui$Lay$Lay$inlineFlexRow = F2(function (classes, children) {
    return A3($elm$html$Html$node, 'lay-inlineFlex-row', _List_fromArray([$elm$html$Html$Attributes$class(classes)]), children);
  });
  var $elm$core$List$isEmpty = function (xs) {
    if (!xs.b) {
      return true;
    } else {
      return false;
    }
  };
  var $elm$html$Html$li = _VirtualDom_node('li');
  var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
  var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
  var $author$project$ElmFramework$Feature$Toaster$Toasts$listMessageView = function (msg) {
    return A2($elm$html$Html$li, _List_fromArray([$elm$html$Html$Attributes$class('marTop0h fontSize1 breakWord')]), _List_fromArray([$elm$html$Html$text(msg)]));
  };
  var $elm$html$Html$span = _VirtualDom_node('span');
  var $elm$html$Html$ul = _VirtualDom_node('ul');
  var $author$project$ElmFramework$Feature$Toaster$Toasts$toast = F5(function (maybeActionMsg, icon, color, msg, messages) {
    var tapHandler = function () {
      if (!maybeActionMsg.$) {
        var actionMsg = maybeActionMsg.a;
        return $author$project$ElmFramework$Lib$Util$onTap($author$project$ElmFramework$Feature$Toaster$Toaster$ActionTap(actionMsg));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpAttr;
      }
    }();
    return {
      l$: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absolute top0 right0 bottom0 left0 toastBackground')]), _List_Nil),
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('center padTop1'), tapHandler]), _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$Lay$Lay$inlineFlexRow, 'flexAlignCenter pad2 ' + color, _List_fromArray([A2($author$project$Icon$iconNoOp, icon, 'inlineBlock fontSize4 marRight1'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('left')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('fontSize2 weight700 lineHeightNormal breakWord')]), _List_fromArray([$elm$html$Html$text(msg)])), A2($elm$html$Html$ul, _List_fromArray([$elm$html$Html$Attributes$class('pad0 mar0 noListStyle'), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('hidden', $elm$core$List$isEmpty(messages))]))]), A2($elm$core$List$map, $author$project$ElmFramework$Feature$Toaster$Toasts$listMessageView, messages))]))]))])),
      rH: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('shadeBlur absoluteSpread toastBackgroundShade o2')]), _List_Nil)
    };
  });
  var $author$project$ElmFramework$Feature$Toaster$Toasts$chat = function (maybeActionMsg) {
    return A3($author$project$ElmFramework$Feature$Toaster$Toasts$toast, maybeActionMsg, 4, 'primary80');
  };
  var $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastChat = F3(function (actionMsg, userName, message) {
    return $author$project$ElmFramework$Msg$ToasterMsg($author$project$ElmFramework$Feature$Toaster$Toaster$NewToast(A3($author$project$ElmFramework$Feature$Toaster$Toasts$chat, $elm$core$Maybe$Just(actionMsg), userName, _List_fromArray([message]))));
  });
  var $author$project$Icon$Report = 5;
  var $author$project$ElmFramework$Feature$Toaster$Toasts$error = function (maybeActionMsg) {
    return A3($author$project$ElmFramework$Feature$Toaster$Toasts$toast, maybeActionMsg, 5, 'primary80');
  };
  var $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastErr = F3(function (maybeActionMsg, notifMsg, messages) {
    return $author$project$ElmFramework$Msg$ToasterMsg($author$project$ElmFramework$Feature$Toaster$Toaster$NewToast(A3($author$project$ElmFramework$Feature$Toaster$Toasts$error, maybeActionMsg, notifMsg, messages)));
  });
  var $author$project$Icon$Info = 0;
  var $author$project$ElmFramework$Feature$Toaster$Toasts$info = function (maybeActionMsg) {
    return A3($author$project$ElmFramework$Feature$Toaster$Toasts$toast, maybeActionMsg, 0, 'primary80');
  };
  var $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastInfo = F3(function (maybeActionMsg, notifMsg, messages) {
    return $author$project$ElmFramework$Msg$ToasterMsg($author$project$ElmFramework$Feature$Toaster$Toaster$NewToast(A3($author$project$ElmFramework$Feature$Toaster$Toasts$info, maybeActionMsg, notifMsg, messages)));
  });
  var $author$project$Icon$Check = 2;
  var $author$project$ElmFramework$Feature$Toaster$Toasts$success = function (maybeActionMsg) {
    return A3($author$project$ElmFramework$Feature$Toaster$Toasts$toast, maybeActionMsg, 2, 'primary80');
  };
  var $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess = F3(function (maybeActionMsg, notifMsg, messages) {
    return $author$project$ElmFramework$Msg$ToasterMsg($author$project$ElmFramework$Feature$Toaster$Toaster$NewToast(A3($author$project$ElmFramework$Feature$Toaster$Toasts$success, maybeActionMsg, notifMsg, messages)));
  });
  var $author$project$ElmFramework$MsgCmd$msgCmd = {
    vB: F2(function (dropper, route) {
      return $author$project$ElmFramework$Msg$RoutingMsg(A2($author$project$ElmFramework$Feature$Navigation$Msg$DropWhileAndRouteTo, dropper, route));
    }),
    xM: $author$project$ElmFramework$Msg$LocateMe,
    yw: $author$project$ElmFramework$Msg$MultiMsg,
    Bb: $author$project$ElmFramework$Msg$RestartApp,
    Bl: $author$project$ElmFramework$Msg$RoutingMsg($author$project$ElmFramework$Feature$Navigation$Msg$RouteBack),
    Bm: A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$RoutingMsg, $author$project$ElmFramework$Feature$Navigation$Msg$RouteBackWhileDroppingWithMaybeDefault($elm$core$Maybe$Nothing)),
    Bn: F2(function (_default, dropper) {
      return $author$project$ElmFramework$Msg$RoutingMsg(A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteBackWhileDroppingWithMaybeDefault, $elm$core$Maybe$Just(_default), dropper));
    }),
    Bo: function (_v0) {
      var _default = _v0.a;
      var dropper = _v0.b;
      return $author$project$ElmFramework$Msg$RoutingMsg(A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteBackWhileDroppingWithMaybeDefault, _default, dropper));
    },
    Bp: function (route) {
      return $author$project$ElmFramework$Msg$RoutingMsg(A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteBackTo, $elm$core$Maybe$Just(route), route));
    },
    Bq: $author$project$ElmFramework$Msg$RoutingMsg($author$project$ElmFramework$Feature$Navigation$Msg$RouteForward),
    Br: function (route) {
      return $author$project$ElmFramework$Msg$RoutingMsg(A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteForwardTo, $elm$core$Maybe$Just(route), route));
    },
    Bt: A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$RoutingMsg, A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteTo, false, false)),
    Bu: A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$RoutingMsg, A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteTo, true, false)),
    Bv: A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$RoutingMsg, A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteTo, true, true)),
    BV: $author$project$ElmFramework$Msg$Share,
    CO: $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastChat,
    al: $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastErr,
    CP: $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastInfo,
    CQ: $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess
  };
  var $elm$core$Tuple$mapSecond = F2(function (func, _v0) {
    var x = _v0.a;
    var y = _v0.b;
    return _Utils_Tuple2(x, func(y));
  });
  var $elm$core$List$drop = F2(function (n, list) {
    drop: while (true) {
      if (n <= 0) {
        return list;
      } else {
        if (!list.b) {
          return list;
        } else {
          var x = list.a;
          var xs = list.b;
          var $temp$n = n - 1,
            $temp$list = xs;
          n = $temp$n;
          list = $temp$list;
          continue drop;
        }
      }
    }
  });
  var $elm$core$List$takeReverse = F3(function (n, list, kept) {
    takeReverse: while (true) {
      if (n <= 0) {
        return kept;
      } else {
        if (!list.b) {
          return kept;
        } else {
          var x = list.a;
          var xs = list.b;
          var $temp$n = n - 1,
            $temp$list = xs,
            $temp$kept = A2($elm$core$List$cons, x, kept);
          n = $temp$n;
          list = $temp$list;
          kept = $temp$kept;
          continue takeReverse;
        }
      }
    }
  });
  var $elm$core$List$takeTailRec = F2(function (n, list) {
    return $elm$core$List$reverse(A3($elm$core$List$takeReverse, n, list, _List_Nil));
  });
  var $elm$core$List$takeFast = F3(function (ctr, n, list) {
    if (n <= 0) {
      return _List_Nil;
    } else {
      var _v0 = _Utils_Tuple2(n, list);
      _v0$1: while (true) {
        _v0$5: while (true) {
          if (!_v0.b.b) {
            return list;
          } else {
            if (_v0.b.b.b) {
              switch (_v0.a) {
                case 1:
                  break _v0$1;
                case 2:
                  var _v2 = _v0.b;
                  var x = _v2.a;
                  var _v3 = _v2.b;
                  var y = _v3.a;
                  return _List_fromArray([x, y]);
                case 3:
                  if (_v0.b.b.b.b) {
                    var _v4 = _v0.b;
                    var x = _v4.a;
                    var _v5 = _v4.b;
                    var y = _v5.a;
                    var _v6 = _v5.b;
                    var z = _v6.a;
                    return _List_fromArray([x, y, z]);
                  } else {
                    break _v0$5;
                  }
                default:
                  if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
                    var _v7 = _v0.b;
                    var x = _v7.a;
                    var _v8 = _v7.b;
                    var y = _v8.a;
                    var _v9 = _v8.b;
                    var z = _v9.a;
                    var _v10 = _v9.b;
                    var w = _v10.a;
                    var tl = _v10.b;
                    return ctr > 1000 ? A2($elm$core$List$cons, x, A2($elm$core$List$cons, y, A2($elm$core$List$cons, z, A2($elm$core$List$cons, w, A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2($elm$core$List$cons, x, A2($elm$core$List$cons, y, A2($elm$core$List$cons, z, A2($elm$core$List$cons, w, A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
                  } else {
                    break _v0$5;
                  }
              }
            } else {
              if (_v0.a === 1) {
                break _v0$1;
              } else {
                break _v0$5;
              }
            }
          }
        }
        return list;
      }
      var _v1 = _v0.b;
      var x = _v1.a;
      return _List_fromArray([x]);
    }
  });
  var $elm$core$List$take = F2(function (n, list) {
    return A3($elm$core$List$takeFast, 0, n, list);
  });
  var $folkertdev$elm_deque$Internal$rebalance = function (deque) {
    var sizeF = deque.V;
    var sizeR = deque.W;
    var front = deque.ab;
    var rear = deque.ae;
    var size1 = (sizeF + sizeR) / 2 | 0;
    var size2 = sizeF + sizeR - size1;
    var balanceConstant = 4;
    if (sizeF + sizeR < 2) {
      return deque;
    } else {
      if (_Utils_cmp(sizeF, balanceConstant * sizeR + 1) > 0) {
        var newRear = _Utils_ap(rear, $elm$core$List$reverse(A2($elm$core$List$drop, size1, front)));
        var newFront = A2($elm$core$List$take, size1, front);
        return {
          ab: newFront,
          ae: newRear,
          V: size1,
          W: size2
        };
      } else {
        if (_Utils_cmp(sizeR, balanceConstant * sizeF + 1) > 0) {
          var newRear = A2($elm$core$List$take, size1, rear);
          var newFront = _Utils_ap(front, $elm$core$List$reverse(A2($elm$core$List$drop, size1, rear)));
          return {
            ab: newFront,
            ae: newRear,
            V: size1,
            W: size2
          };
        } else {
          return deque;
        }
      }
    }
  };
  var $folkertdev$elm_deque$Internal$popBack = function (deque) {
    var front = deque.ab;
    var rear = deque.ae;
    var _v0 = _Utils_Tuple2(front, rear);
    if (!_v0.b.b) {
      if (!_v0.a.b) {
        return _Utils_Tuple2($elm$core$Maybe$Nothing, $folkertdev$elm_deque$Internal$empty);
      } else {
        if (!_v0.a.b.b) {
          var _v1 = _v0.a;
          var x = _v1.a;
          return _Utils_Tuple2($elm$core$Maybe$Just(x), $folkertdev$elm_deque$Internal$empty);
        } else {
          return _Utils_Tuple2($elm$core$Maybe$Nothing, $folkertdev$elm_deque$Internal$empty);
        }
      }
    } else {
      var _v2 = _v0.b;
      var r = _v2.a;
      var rs = _v2.b;
      return _Utils_Tuple2($elm$core$Maybe$Just(r), $folkertdev$elm_deque$Internal$rebalance({
        ab: deque.ab,
        ae: rs,
        V: deque.V,
        W: deque.W - 1
      }));
    }
  };
  var $folkertdev$elm_deque$BoundedDeque$popBack = function (_v0) {
    var deque = _v0.a;
    var maxSize = _v0.b;
    return A2($elm$core$Tuple$mapSecond, function (newDeque) {
      return A2($folkertdev$elm_deque$BoundedDeque$BoundedDeque, newDeque, maxSize);
    }, $folkertdev$elm_deque$Internal$popBack(deque));
  };
  var $folkertdev$elm_deque$BoundedDeque$reachedMaxSize = function (_v0) {
    var sizeF = _v0.a.V;
    var sizeR = _v0.a.W;
    var maxSize = _v0.b;
    return _Utils_eq(sizeF + sizeR, maxSize);
  };
  var $folkertdev$elm_deque$BoundedDeque$pushFront = F2(function (elem, deque) {
    var maxSize = deque.b;
    if (!maxSize) {
      return deque;
    } else {
      var _v0 = $folkertdev$elm_deque$BoundedDeque$reachedMaxSize(deque) ? $folkertdev$elm_deque$BoundedDeque$popBack(deque).b : deque;
      var newDeque = _v0.a;
      var newMaxSize = _v0.b;
      var newerDeque = {
        ab: A2($elm$core$List$cons, elem, newDeque.ab),
        ae: newDeque.ae,
        V: newDeque.V + 1,
        W: newDeque.W
      };
      return A2($folkertdev$elm_deque$BoundedDeque$BoundedDeque, $folkertdev$elm_deque$Internal$rebalance(newerDeque), newMaxSize);
    }
  });
  var $author$project$ElmFramework$Feature$Platform$Platform$reloadApp = _Platform_outgoingPort('reloadApp', $elm$json$Json$Encode$bool);
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportMessage = function (description) {
    return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$toGeneralErrorString(description));
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$setLocationAccessAllowed = _Platform_outgoingPort('setLocationAccessAllowed', $elm$json$Json$Encode$bool);
  var $author$project$ElmFramework$Feature$Clipboard$Clipboard$copyToClipboard = _Platform_outgoingPort('copyToClipboard', $elm$json$Json$Encode$string);
  var $author$project$ElmFramework$Feature$Share$Share$shareThroughHybridApi = _Platform_outgoingPort('shareThroughHybridApi', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('body', $elm$json$Json$Encode$string($.aU)), _Utils_Tuple2('title', $elm$json$Json$Encode$string($.lh)), _Utils_Tuple2('url', $elm$json$Json$Encode$string($.eZ))]));
  });
  var $author$project$ElmFramework$Feature$Share$Share$shareThroughWebApi = _Platform_outgoingPort('shareThroughWebApi', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('body', $elm$json$Json$Encode$string($.aU)), _Utils_Tuple2('title', $elm$json$Json$Encode$string($.lh)), _Utils_Tuple2('url', $elm$json$Json$Encode$string($.eZ))]));
  });
  var $author$project$ElmFramework$Feature$Share$Share$shareDialog = F4(function (_v0, title, body, url) {
    var isHybrid = _v0.xd;
    var supportsWebShare = _v0.Cs;
    return isHybrid ? _Utils_Tuple2($author$project$ElmFramework$Feature$Share$Share$shareThroughHybridApi({
      aU: body,
      lh: title,
      eZ: url
    }), false) : supportsWebShare ? _Utils_Tuple2($author$project$ElmFramework$Feature$Share$Share$shareThroughWebApi({
      aU: body,
      lh: title,
      eZ: url
    }), false) : _Utils_Tuple2($author$project$ElmFramework$Feature$Clipboard$Clipboard$copyToClipboard(url), true);
  });
  var $elm$core$Process$sleep = _Process_sleep;
  var $author$project$ElmFramework$Feature$Pwa$Pwa$toPwaInstallStatus = function (isInstalled) {
    return isInstalled ? 2 : 0;
  };
  var $author$project$ElmFramework$Lib$MsgAnything$topmostHandler = F2(function (mainUpdate, _v0) {
    var updated = _v0.sN;
    var stateSetter = _v0.r4;
    var msgTag = _v0.py;
    var runOutMsg = F2(function (outMsg, _v4) {
      var latestParentState = _v4.a;
      var parentCmd = _v4.b;
      return function (_v3) {
        var latestestParentState = _v3.a;
        var latestParentCmd = _v3.b;
        return _Utils_Tuple2(latestestParentState, $elm$core$Platform$Cmd$batch(_List_fromArray([latestParentCmd, parentCmd])));
      }(A2(mainUpdate, outMsg, latestParentState));
    });
    var _v1 = function (_v2) {
      var newChildState = _v2.a;
      var cmd = _v2.b;
      var theOutMsgs = _v2.c;
      return _Utils_Tuple3(stateSetter(newChildState), A2($elm$core$Platform$Cmd$map, msgTag, cmd), theOutMsgs);
    }(updated);
    var newParentState = _v1.a;
    var taggedChildCmd = _v1.b;
    var outMsgs = _v1.c;
    return A3($elm$core$List$foldl, runOutMsg, _Utils_Tuple2(newParentState, taggedChildCmd), outMsgs);
  });
  var $author$project$ElmFramework$Feature$Analytics$Analytics$sendDetailedEvent = _Platform_outgoingPort('sendDetailedEvent', $elm$core$Basics$identity);
  var $author$project$ElmFramework$Feature$Analytics$Analytics$sendEventCustom = F2(function (eventName, parameters) {
    return $author$project$ElmFramework$Feature$Analytics$Analytics$sendDetailedEvent($elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('event', $elm$json$Json$Encode$string(eventName)), parameters)));
  });
  var $author$project$ElmFramework$Feature$Analytics$Analytics$sendEvent = F2(function (eventName, parameters) {
    return A2($author$project$ElmFramework$Feature$Analytics$Analytics$sendEventCustom, eventName, A2($elm$core$List$map, $elm$core$Tuple$mapSecond($elm$json$Json$Encode$string), parameters));
  });
  var $author$project$ElmFramework$Feature$Analytics$Analytics$logIn = function (userId) {
    return A2($author$project$ElmFramework$Feature$Analytics$Analytics$sendEvent, 'login', _List_fromArray([_Utils_Tuple2('user_id', userId)]));
  };
  var $author$project$ElmFramework$Feature$Analytics$Analytics$logOut = A2($author$project$ElmFramework$Feature$Analytics$Analytics$sendEventCustom, 'log_out', _List_fromArray([_Utils_Tuple2('user_id', $elm$json$Json$Encode$null)]));
  var $author$project$ElmFramework$Feature$Analytics$Analytics$sendSimpleEvent = function (eventName) {
    return A2($author$project$ElmFramework$Feature$Analytics$Analytics$sendEvent, eventName, _List_Nil);
  };
  var $author$project$ElmFramework$Feature$Analytics$Analytics$sendVirtualPageView = F2(function (url, title) {
    return A2($author$project$ElmFramework$Feature$Analytics$Analytics$sendEvent, 'virtual_page_view', _List_fromArray([_Utils_Tuple2('virtual_page_url', url), _Utils_Tuple2('virtual_page_title', title)]));
  });
  var $author$project$ElmFramework$Feature$Analytics$Analytics$signUp = function (userId) {
    return A2($author$project$ElmFramework$Feature$Analytics$Analytics$sendEvent, 'sign_up', _List_fromArray([_Utils_Tuple2('user_id', userId)]));
  };
  var $author$project$ElmFramework$Feature$Analytics$Analytics$trackingEvents = {
    tm: $author$project$ElmFramework$Feature$Analytics$Analytics$sendSimpleEvent('addedToHomeScreen'),
    vM: $author$project$ElmFramework$Feature$Analytics$Analytics$sendSimpleEvent('enablePushNotifications'),
    xR: $author$project$ElmFramework$Feature$Analytics$Analytics$logIn,
    xT: $author$project$ElmFramework$Feature$Analytics$Analytics$logOut,
    B1: $author$project$ElmFramework$Feature$Analytics$Analytics$signUp,
    Dn: $author$project$ElmFramework$Feature$Analytics$Analytics$sendVirtualPageView
  };
  var $author$project$ElmFramework$Feature$Navigation$Routing$NewRoute = F3(function (a, b, c) {
    return {
      $: 2,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$ElmFramework$Feature$Navigation$Routing$UserWantsBack = {
    $: 0
  };
  var $author$project$ElmFramework$Feature$Navigation$Routing$UserWantsForward = {
    $: 1
  };
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$Go = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$NavigatingBackward = 1;
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingPopStateResponse = F4(function (a, b, c, d) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $wernerdegroot$listzipper$List$Zipper$next = function (_v0) {
    var ls = _v0.a;
    var x = _v0.b;
    var rs = _v0.c;
    if (!rs.b) {
      return $elm$core$Maybe$Nothing;
    } else {
      var y = rs.a;
      var ys = rs.b;
      return $elm$core$Maybe$Just(A3($wernerdegroot$listzipper$List$Zipper$Zipper, A2($elm$core$List$cons, x, ls), y, ys));
    }
  };
  var $wernerdegroot$listzipper$List$Zipper$previous = function (_v0) {
    var ls = _v0.a;
    var x = _v0.b;
    var rs = _v0.c;
    if (!ls.b) {
      return $elm$core$Maybe$Nothing;
    } else {
      var y = ls.a;
      var ys = ls.b;
      return $elm$core$Maybe$Just(A3($wernerdegroot$listzipper$List$Zipper$Zipper, ys, y, A2($elm$core$List$cons, x, rs)));
    }
  };
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhile = F3(function (direction, theDropper, theRouteHistory) {
    var moveAStep = function () {
      if (!direction) {
        return $wernerdegroot$listzipper$List$Zipper$next;
      } else {
        return $wernerdegroot$listzipper$List$Zipper$previous;
      }
    }();
    var drop = F2(function (currStep, currHistory) {
      drop: while (true) {
        var _v0 = moveAStep(currHistory);
        if (!_v0.$) {
          var movedHistory = _v0.a;
          if (theDropper($wernerdegroot$listzipper$List$Zipper$current(movedHistory))) {
            var $temp$currStep = currStep + 1,
              $temp$currHistory = movedHistory;
            currStep = $temp$currStep;
            currHistory = $temp$currHistory;
            continue drop;
          } else {
            return $elm$core$Maybe$Just(_Utils_Tuple2(movedHistory, currStep + 1));
          }
        } else {
          return $elm$core$Maybe$Nothing;
        }
      }
    });
    return A2(drop, 0, theRouteHistory);
  });
  var $elm$core$Basics$negate = function (n) {
    return -n;
  };
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhileAndRouteTo = F3(function (dropper, route, _v0) {
    var routeHistory = _v0.a;
    var isBack = _v0.c;
    var _v1 = A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhile, 1, dropper, routeHistory);
    if (!_v1.$) {
      var _v2 = _v1.a;
      var pendingRouteHistory = _v2.a;
      var steps = _v2.b;
      return $elm$core$Maybe$Just(_Utils_Tuple2(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Just(A4($author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingPopStateResponse, false, pendingRouteHistory, $elm$core$Maybe$Just(route), false)), isBack), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$Go(-steps)]))));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$ElmFramework$Feature$Platform$Platform$exitApp = _Platform_outgoingPort('exitApp', function ($) {
    return $elm$json$Json$Encode$null;
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$NothingSpecial = F2(function (a, b) {
    return {
      $: 5,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingRouteCorrectionPopStateResponse = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateError = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateSuccess = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateSuccessAndRouteTo = F3(function (a, b, c) {
    return {
      $: 1,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$UserWantsBack = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$UserWantsForward = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$handlePopState = F2(function (popStateIndex, _v0) {
    var routeHistory = _v0.a;
    var maybePendingPopState = _v0.b;
    var isBack_curr = _v0.c;
    if (!maybePendingPopState.$) {
      if (!maybePendingPopState.a.$) {
        var _v2 = maybePendingPopState.a;
        var shouldSilent = _v2.a;
        var pendingHistory = _v2.b;
        var maybeRouteToAfterSuccessfulPopState = _v2.c;
        var isBack_new = _v2.d;
        if (_Utils_eq(popStateIndex, $author$project$ElmFramework$Feature$Navigation$RouteHistory$toZipperHistoryIndex(pendingHistory))) {
          if (maybeRouteToAfterSuccessfulPopState.$ === 1) {
            return A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateSuccess, shouldSilent, A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, pendingHistory, $elm$core$Maybe$Nothing, isBack_new));
          } else {
            var route = maybeRouteToAfterSuccessfulPopState.a;
            return A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateSuccessAndRouteTo, shouldSilent, A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, pendingHistory, $elm$core$Maybe$Nothing, false), route);
          }
        } else {
          return $author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateError('Unexpected pendingIndex:' + $elm$core$String$fromInt($author$project$ElmFramework$Feature$Navigation$RouteHistory$toZipperHistoryIndex(pendingHistory)));
        }
      } else {
        var _v4 = maybePendingPopState.a;
        var pendingTargetStateIndex = _v4.a;
        var isBack_new = _v4.b;
        return _Utils_eq(popStateIndex, $author$project$ElmFramework$Feature$Navigation$RouteHistory$toZipperHistoryIndex(routeHistory)) ? _Utils_cmp(pendingTargetStateIndex, popStateIndex) > 0 ? $author$project$ElmFramework$Feature$Navigation$RouteHistory$UserWantsForward(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Nothing, isBack_new)) : _Utils_cmp(pendingTargetStateIndex, popStateIndex) < 0 ? $author$project$ElmFramework$Feature$Navigation$RouteHistory$UserWantsBack(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Nothing, isBack_new)) : $author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateError('PendingRouteCorrectionPopStateResponse: index same as current: ' + $elm$core$String$fromInt(popStateIndex)) : $author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateError('PendingRouteCorrectionPopStateResponse: Unexpected popStateIndex:' + $elm$core$String$fromInt(popStateIndex));
      }
    } else {
      var currIndex = $author$project$ElmFramework$Feature$Navigation$RouteHistory$toCurrIndex(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, maybePendingPopState, isBack_curr));
      return _Utils_cmp(popStateIndex, currIndex) < 0 ? A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$NothingSpecial, A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Just(A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingRouteCorrectionPopStateResponse, popStateIndex, true)), isBack_curr), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$Go(currIndex - popStateIndex)]))) : _Utils_cmp(popStateIndex, currIndex) > 0 ? A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$NothingSpecial, A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Just(A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingRouteCorrectionPopStateResponse, popStateIndex, false)), isBack_curr), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$Go(-(popStateIndex - currIndex))]))) : $author$project$ElmFramework$Feature$Navigation$RouteHistory$PopStateError('index same as current: ' + $elm$core$String$fromInt(popStateIndex));
    }
  });
  var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
    if (m.$ === 1) {
      return false;
    } else {
      return true;
    }
  };
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction = function (_v0) {
    var maybePending = _v0.b;
    return $elm_community$maybe_extra$Maybe$Extra$isJust(maybePending);
  };
  var $elm$core$Basics$neq = _Utils_notEqual;
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$routeBackTo = F2(function (targetRoute, _v0) {
    var routeHistory = _v0.a;
    var isBack = _v0.c;
    var _v1 = A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhile, 1, $elm$core$Basics$neq(targetRoute), routeHistory);
    if (!_v1.$) {
      var _v2 = _v1.a;
      var pendingRouteHistory = _v2.a;
      var steps = _v2.b;
      return $elm$core$Maybe$Just(_Utils_Tuple2(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Just(A4($author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingPopStateResponse, false, pendingRouteHistory, $elm$core$Maybe$Nothing, true)), isBack), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$Go(-steps)]))));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$routeBackWhileDropping = F2(function (dropper, _v0) {
    var routeHistory = _v0.a;
    var isBack = _v0.c;
    var _v1 = A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhile, 1, dropper, routeHistory);
    if (!_v1.$) {
      var _v2 = _v1.a;
      var pendingRouteHistory = _v2.a;
      var steps = _v2.b;
      return $elm$core$Maybe$Just(_Utils_Tuple2(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Just(A4($author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingPopStateResponse, false, pendingRouteHistory, $elm$core$Maybe$Nothing, true)), isBack), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$Go(-steps)]))));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$NavigatingForward = 0;
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$routeForwardTo = F2(function (targetRoute, _v0) {
    var routeHistory = _v0.a;
    var isBack = _v0.c;
    var _v1 = A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhile, 0, $elm$core$Basics$neq(targetRoute), routeHistory);
    if (!_v1.$) {
      var _v2 = _v1.a;
      var pendingRouteHistory = _v2.a;
      var steps = _v2.b;
      return $elm$core$Maybe$Just(_Utils_Tuple2(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Just(A4($author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingPopStateResponse, false, pendingRouteHistory, $elm$core$Maybe$Nothing, false)), isBack), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$Go(steps)]))));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$routeForwardWhileDropping = F2(function (dropper, _v0) {
    var routeHistory = _v0.a;
    var isBack = _v0.c;
    var _v1 = A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhile, 0, dropper, routeHistory);
    if (!_v1.$) {
      var _v2 = _v1.a;
      var pendingRouteHistory = _v2.a;
      var steps = _v2.b;
      return $elm$core$Maybe$Just(_Utils_Tuple2(A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$RouteHistory, routeHistory, $elm$core$Maybe$Just(A4($author$project$ElmFramework$Feature$Navigation$RouteHistory$PendingPopStateResponse, false, pendingRouteHistory, $elm$core$Maybe$Nothing, false)), isBack), $author$project$ElmFramework$Feature$Navigation$RouteHistory$toRoutingCommands(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$Go(steps)]))));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$ElmFramework$Feature$Navigation$Routing$routeTo = function (_v0) {
    var config = _v0.ar;
    var newRoute = _v0.aA;
    var shouldReplace = _v0.kR;
    var state = _v0.aC;
    var isUnauthenticated_and_routeNeedsAuth = _Utils_eq(config.Bz.w8(state.lL), $elm$core$Maybe$Just(false)) && config.Bz.Bs(newRoute);
    if (isUnauthenticated_and_routeNeedsAuth) {
      return $author$project$ElmFramework$Feature$Navigation$RouteHistory$setRoute({
        rh: config.Bz.tC,
        ci: state.rh,
        kR: false,
        lh: A2(config.Bz.Bx, state.lL, config.Bz.tC).lh,
        eZ: $author$project$ElmFramework$Lib$Url$toUrlString(config.Bz.By(config.Bz.tC))
      });
    } else {
      return $author$project$ElmFramework$Feature$Navigation$RouteHistory$setRoute({
        rh: newRoute,
        ci: state.rh,
        kR: shouldReplace,
        lh: A2(config.Bz.Bx, state.lL, newRoute).lh,
        eZ: $author$project$ElmFramework$Lib$Url$toUrlString(config.Bz.By(newRoute))
      });
    }
  };
  var $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg = function (_v0) {
    var config = _v0.ar;
    var newRoute = _v0.aA;
    var shouldReplace = _v0.kR;
    var shouldSilent = _v0.rN;
    var state = _v0.aC;
    var _v1 = $author$project$ElmFramework$Feature$Navigation$Routing$routeTo({
      ar: config,
      aA: newRoute,
      kR: shouldReplace,
      rN: shouldSilent,
      aC: state
    });
    var routeHistory = _v1.a;
    var cmd = _v1.b;
    return _Utils_Tuple3(routeHistory, cmd, $elm$core$Maybe$Just(A3($author$project$ElmFramework$Feature$Navigation$Routing$NewRoute, shouldSilent, state.rh, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(routeHistory))));
  };
  var $author$project$ElmFramework$Feature$Navigation$Routing$update = F3(function (config, msg, state) {
    switch (msg.$) {
      case 0:
        var shouldReplace = msg.a;
        var shouldSilent = msg.b;
        var route = msg.c;
        return $author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction(state.rh) ? _Utils_Tuple3(state.rh, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing) : $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg({
          ar: config,
          aA: route,
          kR: shouldReplace,
          rN: shouldSilent,
          aC: state
        });
      case 1:
        var dropper = msg.a;
        var route = msg.b;
        if ($author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction(state.rh)) {
          return _Utils_Tuple3(state.rh, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        } else {
          var _v1 = A3($author$project$ElmFramework$Feature$Navigation$RouteHistory$dropWhileAndRouteTo, dropper, route, state.rh);
          if (!_v1.$) {
            var _v2 = _v1.a;
            var newRouteHistory = _v2.a;
            var cmd = _v2.b;
            return _Utils_Tuple3(newRouteHistory, cmd, $elm$core$Maybe$Nothing);
          } else {
            return _Utils_Tuple3(state.rh, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'DropWhileAndRouteTo', 'not enough lee-way'), $elm$core$Maybe$Nothing);
          }
        }
      case 2:
        var maybeDefault = msg.a;
        var dropper = msg.b;
        if ($author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction(state.rh)) {
          return _Utils_Tuple3(state.rh, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        } else {
          var _v3 = _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$routeBackWhileDropping, dropper, state.rh), maybeDefault);
          if (!_v3.a.$) {
            var _v4 = _v3.a.a;
            var newRouteHistory = _v4.a;
            var cmd = _v4.b;
            return _Utils_Tuple3(newRouteHistory, cmd, $elm$core$Maybe$Nothing);
          } else {
            if (!_v3.b.$) {
              var _v5 = _v3.a;
              var defaultRoute = _v3.b.a;
              return $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg({
                ar: config,
                aA: defaultRoute,
                kR: false,
                rN: false,
                aC: state
              });
            } else {
              var _v6 = _v3.a;
              var _v7 = _v3.b;
              return _Utils_Tuple3(state.rh, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'RouteBackWhileDropping', 'not enough lee-way'), $elm$core$Maybe$Nothing);
            }
          }
        }
      case 3:
        var maybeDefault = msg.a;
        var targetRoute = msg.b;
        var _v8 = _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$routeBackTo, targetRoute, state.rh), maybeDefault);
        if (!_v8.a.$) {
          var _v9 = _v8.a.a;
          var newRouteHistory = _v9.a;
          var cmd = _v9.b;
          return _Utils_Tuple3(newRouteHistory, cmd, $elm$core$Maybe$Nothing);
        } else {
          if (!_v8.b.$) {
            var _v10 = _v8.a;
            var defaultRoute = _v8.b.a;
            return $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg({
              ar: config,
              aA: defaultRoute,
              kR: true,
              rN: false,
              aC: state
            });
          } else {
            var _v11 = _v8.a;
            var _v12 = _v8.b;
            return _Utils_Tuple3(state.rh, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'RouteBackTo', 'not enough lee-way'), $elm$core$Maybe$Nothing);
          }
        }
      case 4:
        var maybeDefault = msg.a;
        var targetRoute = msg.b;
        var _v13 = _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$routeForwardTo, targetRoute, state.rh), maybeDefault);
        if (!_v13.a.$) {
          var _v14 = _v13.a.a;
          var newRouteHistory = _v14.a;
          var cmd = _v14.b;
          return _Utils_Tuple3(newRouteHistory, cmd, $elm$core$Maybe$Nothing);
        } else {
          if (!_v13.b.$) {
            var _v15 = _v13.a;
            var defaultRoute = _v13.b.a;
            return $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg({
              ar: config,
              aA: defaultRoute,
              kR: true,
              rN: false,
              aC: state
            });
          } else {
            var _v16 = _v13.a;
            var _v17 = _v13.b;
            return _Utils_Tuple3(state.rh, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'RouteBackTo', 'not enough lee-way'), $elm$core$Maybe$Nothing);
          }
        }
      case 5:
        var isAuthenticated = _Utils_eq(config.Bz.w8(state.lL), $elm$core$Maybe$Just(true));
        var goingBack = isAuthenticated ? A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$routeBackWhileDropping, config.Bz.w7, state.rh) : A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$routeBackWhileDropping, config.Bz.Bs, state.rh);
        if ($author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction(state.rh)) {
          return _Utils_Tuple3(state.rh, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        } else {
          if (!goingBack.$) {
            var _v19 = goingBack.a;
            var newHistory = _v19.a;
            var cmd = _v19.b;
            return _Utils_Tuple3(newHistory, cmd, $elm$core$Maybe$Nothing);
          } else {
            return _Utils_Tuple3(state.rh, $author$project$ElmFramework$Feature$Platform$Platform$exitApp(0), $elm$core$Maybe$Nothing);
          }
        }
      case 6:
        var isAuthenticated = _Utils_eq(config.Bz.w8(state.lL), $elm$core$Maybe$Just(true));
        var goingForward = isAuthenticated ? A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$routeForwardWhileDropping, config.Bz.w7, state.rh) : A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$routeForwardWhileDropping, config.Bz.Bs, state.rh);
        if ($author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction(state.rh)) {
          return _Utils_Tuple3(state.rh, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        } else {
          if (!goingForward.$) {
            var _v21 = goingForward.a;
            var newHistory = _v21.a;
            var cmd = _v21.b;
            return _Utils_Tuple3(newHistory, cmd, $elm$core$Maybe$Nothing);
          } else {
            return _Utils_Tuple3(state.rh, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'RouteForward', 'not enough lee-way'), $elm$core$Maybe$Nothing);
          }
        }
      case 7:
        var payload = msg.a;
        var _v22 = A2($author$project$ElmFramework$Feature$Navigation$RouteHistory$handlePopState, payload.a5, state.rh);
        switch (_v22.$) {
          case 0:
            var shouldSilent = _v22.a;
            var newRouteHistory = _v22.b;
            return _Utils_Tuple3(newRouteHistory, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(A3($author$project$ElmFramework$Feature$Navigation$Routing$NewRoute, shouldSilent, state.rh, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(newRouteHistory))));
          case 1:
            var shouldSilent = _v22.a;
            var newRouteHistory = _v22.b;
            var newRoute = _v22.c;
            return $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg({
              ar: config,
              aA: newRoute,
              kR: false,
              rN: shouldSilent,
              aC: _Utils_update(state, {
                rh: newRouteHistory
              })
            });
          case 2:
            var err = _v22.a;
            return _Utils_Tuple3(state.rh, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'PopStateError for pathname:' + payload.iT.j9, err), $elm$core$Maybe$Nothing);
          case 3:
            var routeHistory = _v22.a;
            return _Utils_Tuple3(routeHistory, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$ElmFramework$Feature$Navigation$Routing$UserWantsBack));
          case 4:
            var routeHistory = _v22.a;
            return _Utils_Tuple3(routeHistory, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$ElmFramework$Feature$Navigation$Routing$UserWantsForward));
          default:
            var routeHistory = _v22.a;
            var cmd = _v22.b;
            return _Utils_Tuple3(routeHistory, cmd, $elm$core$Maybe$Nothing);
        }
      case 8:
        var navigationLocation = msg.a.yA;
        var shouldReplace = msg.a.kR;
        var shouldSilent = msg.a.rN;
        if ($author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction(state.rh)) {
          return _Utils_Tuple3(state.rh, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        } else {
          var _v23 = config.Bz.C7($author$project$ElmFramework$Lib$Url$fromNavigationLocation(navigationLocation));
          if (!_v23.$) {
            var route = _v23.a;
            return $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg({
              ar: config,
              aA: route,
              kR: shouldReplace,
              rN: shouldSilent,
              aC: state
            });
          } else {
            return _Utils_Tuple3(state.rh, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'NavToFromLoopback: unexpected pathname:', navigationLocation.j9), $elm$core$Maybe$Nothing);
          }
        }
      case 9:
        return _Utils_Tuple3(state.rh, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$ElmFramework$Feature$Navigation$Routing$UserWantsBack));
      case 10:
        return _Utils_Tuple3(state.rh, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'HardwareForward', 'unimplemented'), $elm$core$Maybe$Nothing);
      default:
        return $author$project$ElmFramework$Feature$Navigation$Routing$routeToOutMsg({
          ar: config,
          aA: config.Bz.tC,
          kR: false,
          rN: false,
          aC: state
        });
    }
  });
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$AppleAuthSuccess = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$FacebookAuthSuccess = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$GoogleAuthSuccess = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowClosed = {
    $: 4
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowOpened = {
    $: 3
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$update = F2(function (msg, state) {
    switch (msg.$) {
      case 0:
        return _Utils_Tuple2(_Utils_update(state, {
          ig: true
        }), $elm$core$Maybe$Nothing);
      case 1:
        return _Utils_Tuple2(_Utils_update(state, {
          g$: true
        }), $elm$core$Maybe$Nothing);
      case 2:
        return _Utils_Tuple2(_Utils_update(state, {
          h0: true
        }), $elm$core$Maybe$Nothing);
      case 3:
        return _Utils_Tuple2(_Utils_update(state, {
          gA: false
        }), $elm$core$Maybe$Just($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowClosed));
      case 4:
        return _Utils_Tuple2(_Utils_update(state, {
          gA: true
        }), $elm$core$Maybe$Just($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowOpened));
      case 5:
        var googleAuthSuccess = msg.a;
        return _Utils_Tuple2(state, $elm$core$Maybe$Just($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$GoogleAuthSuccess(googleAuthSuccess)));
      case 6:
        var appleAuthSuccess = msg.a;
        return _Utils_Tuple2(state, $elm$core$Maybe$Just($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$AppleAuthSuccess(appleAuthSuccess)));
      default:
        var facebookAuthSuccess = msg.a;
        return _Utils_Tuple2(state, $elm$core$Maybe$Just($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$FacebookAuthSuccess(facebookAuthSuccess)));
    }
  });
  var $author$project$ElmFramework$Feature$Toaster$Toaster$ToastTimerDone = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Toaster$Toaster$areTooManyToasts = F2(function (theToastsHeight, windowHeight) {
    return _Utils_cmp(theToastsHeight, windowHeight / 3 | 0) > 0;
  });
  var $elm$core$Basics$composeR = F3(function (f, g, x) {
    return g(f(x));
  });
  var $elm_community$list_extra$List$Extra$find = F2(function (predicate, list) {
    find: while (true) {
      if (!list.b) {
        return $elm$core$Maybe$Nothing;
      } else {
        var first = list.a;
        var rest = list.b;
        if (predicate(first)) {
          return $elm$core$Maybe$Just(first);
        } else {
          var $temp$predicate = predicate,
            $temp$list = rest;
          predicate = $temp$predicate;
          list = $temp$list;
          continue find;
        }
      }
    }
  });
  var $author$project$ElmFramework$Feature$Toaster$Toaster$ToastHidingDone = {
    $: 1
  };
  var $author$project$ElmFramework$Lib$Util$timeInterval = {
    mO: 1000 * 60 * 60 * 24,
    wC: 1000 * 60 * 60,
    yu: 1000 * 60,
    rt: 1000
  };
  var $author$project$ElmFramework$Feature$Toaster$Toaster$hideOldestVisibleToast = function (model) {
    var sleeper = A2($elm$core$Task$perform, $elm$core$Basics$always($author$project$ElmFramework$Feature$Toaster$Toaster$ToastHidingDone), $elm$core$Process$sleep(2 * $author$project$ElmFramework$Lib$Util$timeInterval.rt));
    return model.O > 0 ? _Utils_Tuple3(_Utils_update(model, {
      b$: model.b$ + 1,
      O: model.O - 1
    }), sleeper, _List_Nil) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
  };
  var $elm$core$Array$length = function (_v0) {
    var len = _v0.a;
    return len;
  };
  var $author$project$ElmFramework$Feature$Toaster$Toaster$isToastIdxVisible = F2(function (_v0, toastIdx) {
    var toasts = _v0.aQ;
    var visibleToasts = _v0.O;
    return _Utils_cmp($elm$core$Array$length(toasts) - visibleToasts - 1, toastIdx) < 0;
  });
  var $elm$core$Elm$JsArray$push = _JsArray_push;
  var $elm$core$Bitwise$and = _Bitwise_and;
  var $elm$core$Array$bitMask = 4294967295 >>> 32 - $elm$core$Array$shiftStep;
  var $elm$core$Basics$ge = _Utils_ge;
  var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
  var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
  var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
  var $elm$core$Array$insertTailInTree = F4(function (shift, index, tail, tree) {
    var pos = $elm$core$Array$bitMask & index >>> shift;
    if (_Utils_cmp(pos, $elm$core$Elm$JsArray$length(tree)) > -1) {
      if (shift === 5) {
        return A2($elm$core$Elm$JsArray$push, $elm$core$Array$Leaf(tail), tree);
      } else {
        var newSub = $elm$core$Array$SubTree(A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
        return A2($elm$core$Elm$JsArray$push, newSub, tree);
      }
    } else {
      var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
      if (!value.$) {
        var subTree = value.a;
        var newSub = $elm$core$Array$SubTree(A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
        return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
      } else {
        var newSub = $elm$core$Array$SubTree(A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$singleton(value)));
        return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
      }
    }
  });
  var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
  var $elm$core$Array$unsafeReplaceTail = F2(function (newTail, _v0) {
    var len = _v0.a;
    var startShift = _v0.b;
    var tree = _v0.c;
    var tail = _v0.d;
    var originalTailLen = $elm$core$Elm$JsArray$length(tail);
    var newTailLen = $elm$core$Elm$JsArray$length(newTail);
    var newArrayLen = len + (newTailLen - originalTailLen);
    if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
      var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
      if (overflow) {
        var newShift = startShift + $elm$core$Array$shiftStep;
        var newTree = A4($elm$core$Array$insertTailInTree, newShift, len, newTail, $elm$core$Elm$JsArray$singleton($elm$core$Array$SubTree(tree)));
        return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
      } else {
        return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree), $elm$core$Elm$JsArray$empty);
      }
    } else {
      return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
    }
  });
  var $elm$core$Array$push = F2(function (a, array) {
    var tail = array.d;
    return A2($elm$core$Array$unsafeReplaceTail, A2($elm$core$Elm$JsArray$push, a, tail), array);
  });
  var $elm$core$Array$getHelp = F3(function (shift, index, tree) {
    getHelp: while (true) {
      var pos = $elm$core$Array$bitMask & index >>> shift;
      var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
      if (!_v0.$) {
        var subTree = _v0.a;
        var $temp$shift = shift - $elm$core$Array$shiftStep,
          $temp$index = index,
          $temp$tree = subTree;
        shift = $temp$shift;
        index = $temp$index;
        tree = $temp$tree;
        continue getHelp;
      } else {
        var values = _v0.a;
        return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
      }
    }
  });
  var $elm$core$Array$tailIndex = function (len) {
    return len >>> 5 << 5;
  };
  var $elm$core$Array$get = F2(function (index, _v0) {
    var len = _v0.a;
    var startShift = _v0.b;
    var tree = _v0.c;
    var tail = _v0.d;
    return index < 0 || _Utils_cmp(index, len) > -1 ? $elm$core$Maybe$Nothing : _Utils_cmp(index, $elm$core$Array$tailIndex(len)) > -1 ? $elm$core$Maybe$Just(A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(A3($elm$core$Array$getHelp, startShift, index, tree));
  });
  var $elm$core$Array$setHelp = F4(function (shift, index, value, tree) {
    var pos = $elm$core$Array$bitMask & index >>> shift;
    var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
    if (!_v0.$) {
      var subTree = _v0.a;
      var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
      return A3($elm$core$Elm$JsArray$unsafeSet, pos, $elm$core$Array$SubTree(newSub), tree);
    } else {
      var values = _v0.a;
      var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
      return A3($elm$core$Elm$JsArray$unsafeSet, pos, $elm$core$Array$Leaf(newLeaf), tree);
    }
  });
  var $elm$core$Array$set = F3(function (index, value, array) {
    var len = array.a;
    var startShift = array.b;
    var tree = array.c;
    var tail = array.d;
    return index < 0 || _Utils_cmp(index, len) > -1 ? array : _Utils_cmp(index, $elm$core$Array$tailIndex(len)) > -1 ? A4($elm$core$Array$Array_elm_builtin, len, startShift, tree, A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4($elm$core$Array$Array_elm_builtin, len, startShift, A4($elm$core$Array$setHelp, startShift, index, value, tree), tail);
  });
  var $author$project$ElmFramework$Lib$Util$updateArray = F3(function (n, f, a) {
    var element = A2($elm$core$Array$get, n, a);
    if (element.$ === 1) {
      return a;
    } else {
      var element_ = element.a;
      return A3($elm$core$Array$set, n, f(element_), a);
    }
  });
  var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
  var $elm$core$Array$foldl = F3(function (func, baseCase, _v0) {
    var tree = _v0.c;
    var tail = _v0.d;
    var helper = F2(function (node, acc) {
      if (!node.$) {
        var subTree = node.a;
        return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
      } else {
        var values = node.a;
        return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
      }
    });
    return A3($elm$core$Elm$JsArray$foldl, func, A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree), tail);
  });
  var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
  var $elm$core$Elm$JsArray$slice = _JsArray_slice;
  var $elm$core$Array$appendHelpBuilder = F2(function (tail, builder) {
    var tailLen = $elm$core$Elm$JsArray$length(tail);
    var notAppended = $elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.C) - tailLen;
    var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.C, tail);
    return notAppended < 0 ? {
      D: A2($elm$core$List$cons, $elm$core$Array$Leaf(appended), builder.D),
      y: builder.y + 1,
      C: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
    } : !notAppended ? {
      D: A2($elm$core$List$cons, $elm$core$Array$Leaf(appended), builder.D),
      y: builder.y + 1,
      C: $elm$core$Elm$JsArray$empty
    } : {
      D: builder.D,
      y: builder.y,
      C: appended
    };
  });
  var $elm$core$Array$sliceLeft = F2(function (from, array) {
    var len = array.a;
    var tree = array.c;
    var tail = array.d;
    if (!from) {
      return array;
    } else {
      if (_Utils_cmp(from, $elm$core$Array$tailIndex(len)) > -1) {
        return A4($elm$core$Array$Array_elm_builtin, len - from, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, A3($elm$core$Elm$JsArray$slice, from - $elm$core$Array$tailIndex(len), $elm$core$Elm$JsArray$length(tail), tail));
      } else {
        var skipNodes = from / $elm$core$Array$branchFactor | 0;
        var helper = F2(function (node, acc) {
          if (!node.$) {
            var subTree = node.a;
            return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
          } else {
            var leaf = node.a;
            return A2($elm$core$List$cons, leaf, acc);
          }
        });
        var leafNodes = A3($elm$core$Elm$JsArray$foldr, helper, _List_fromArray([tail]), tree);
        var nodesToInsert = A2($elm$core$List$drop, skipNodes, leafNodes);
        if (!nodesToInsert.b) {
          return $elm$core$Array$empty;
        } else {
          var head = nodesToInsert.a;
          var rest = nodesToInsert.b;
          var firstSlice = from - skipNodes * $elm$core$Array$branchFactor;
          var initialBuilder = {
            D: _List_Nil,
            y: 0,
            C: A3($elm$core$Elm$JsArray$slice, firstSlice, $elm$core$Elm$JsArray$length(head), head)
          };
          return A2($elm$core$Array$builderToArray, true, A3($elm$core$List$foldl, $elm$core$Array$appendHelpBuilder, initialBuilder, rest));
        }
      }
    }
  });
  var $elm$core$Array$fetchNewTail = F4(function (shift, end, treeEnd, tree) {
    fetchNewTail: while (true) {
      var pos = $elm$core$Array$bitMask & treeEnd >>> shift;
      var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
      if (!_v0.$) {
        var sub = _v0.a;
        var $temp$shift = shift - $elm$core$Array$shiftStep,
          $temp$end = end,
          $temp$treeEnd = treeEnd,
          $temp$tree = sub;
        shift = $temp$shift;
        end = $temp$end;
        treeEnd = $temp$treeEnd;
        tree = $temp$tree;
        continue fetchNewTail;
      } else {
        var values = _v0.a;
        return A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, values);
      }
    }
  });
  var $elm$core$Array$hoistTree = F3(function (oldShift, newShift, tree) {
    hoistTree: while (true) {
      if (_Utils_cmp(oldShift, newShift) < 1 || !$elm$core$Elm$JsArray$length(tree)) {
        return tree;
      } else {
        var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, 0, tree);
        if (!_v0.$) {
          var sub = _v0.a;
          var $temp$oldShift = oldShift - $elm$core$Array$shiftStep,
            $temp$newShift = newShift,
            $temp$tree = sub;
          oldShift = $temp$oldShift;
          newShift = $temp$newShift;
          tree = $temp$tree;
          continue hoistTree;
        } else {
          return tree;
        }
      }
    }
  });
  var $elm$core$Array$sliceTree = F3(function (shift, endIdx, tree) {
    var lastPos = $elm$core$Array$bitMask & endIdx >>> shift;
    var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, lastPos, tree);
    if (!_v0.$) {
      var sub = _v0.a;
      var newSub = A3($elm$core$Array$sliceTree, shift - $elm$core$Array$shiftStep, endIdx, sub);
      return !$elm$core$Elm$JsArray$length(newSub) ? A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3($elm$core$Elm$JsArray$unsafeSet, lastPos, $elm$core$Array$SubTree(newSub), A3($elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
    } else {
      return A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree);
    }
  });
  var $elm$core$Array$sliceRight = F2(function (end, array) {
    var len = array.a;
    var startShift = array.b;
    var tree = array.c;
    var tail = array.d;
    if (_Utils_eq(end, len)) {
      return array;
    } else {
      if (_Utils_cmp(end, $elm$core$Array$tailIndex(len)) > -1) {
        return A4($elm$core$Array$Array_elm_builtin, end, startShift, tree, A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, tail));
      } else {
        var endIdx = $elm$core$Array$tailIndex(end);
        var depth = $elm$core$Basics$floor(A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, A2($elm$core$Basics$max, 1, endIdx - 1)));
        var newShift = A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep);
        return A4($elm$core$Array$Array_elm_builtin, end, newShift, A3($elm$core$Array$hoistTree, startShift, newShift, A3($elm$core$Array$sliceTree, startShift, endIdx, tree)), A4($elm$core$Array$fetchNewTail, startShift, end, endIdx, tree));
      }
    }
  });
  var $elm$core$Array$translateIndex = F2(function (index, _v0) {
    var len = _v0.a;
    var posIndex = index < 0 ? len + index : index;
    return posIndex < 0 ? 0 : _Utils_cmp(posIndex, len) > 0 ? len : posIndex;
  });
  var $elm$core$Array$slice = F3(function (from, to, array) {
    var correctTo = A2($elm$core$Array$translateIndex, to, array);
    var correctFrom = A2($elm$core$Array$translateIndex, from, array);
    return _Utils_cmp(correctFrom, correctTo) > 0 ? $elm$core$Array$empty : A2($elm$core$Array$sliceLeft, correctFrom, A2($elm$core$Array$sliceRight, correctTo, array));
  });
  var $author$project$ElmFramework$Feature$Toaster$Toaster$toastsHeight = F3(function (toasts, fromIndex, toIndex) {
    var heightSumCalculator = F2(function (_v0, sum) {
      var maybeHeight = _v0.b;
      return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, sum, $elm$core$Basics$add(sum), maybeHeight);
    });
    return A3($elm$core$Array$foldl, heightSumCalculator, 0, A3($elm$core$Array$slice, fromIndex, toIndex, toasts));
  });
  var $author$project$ElmFramework$Feature$Toaster$Toaster$visibleToastsHeight = F2(function (toasts, visibleToasts) {
    return A3($author$project$ElmFramework$Feature$Toaster$Toaster$toastsHeight, toasts, -visibleToasts, $elm$core$Array$length(toasts));
  });
  var $author$project$ElmFramework$Feature$Toaster$Toaster$update = F3(function (_v0, msg, model) {
    var windowHeight = _v0.s4;
    switch (msg.$) {
      case 0:
        var toastIdx = msg.a;
        return A2($author$project$ElmFramework$Feature$Toaster$Toaster$isToastIdxVisible, model, toastIdx) ? $author$project$ElmFramework$Feature$Toaster$Toaster$hideOldestVisibleToast(model) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
      case 1:
        var _v2 = _Utils_Tuple2(model.O, model.b$ - 1);
        if (!_v2.a && !_v2.b) {
          return _Utils_Tuple3($author$project$ElmFramework$Feature$Toaster$Toaster$init, $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
          return _Utils_Tuple3(_Utils_update(model, {
            b$: model.b$ - 1
          }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 2:
        var toastIdx = msg.a;
        var height = msg.b.ij;
        var toasts = A3($author$project$ElmFramework$Lib$Util$updateArray, toastIdx, function (_v3) {
          var t = _v3.a;
          return _Utils_Tuple2(t, $elm$core$Maybe$Just(height));
        }, model.aQ);
        var visibleHeight = A2($author$project$ElmFramework$Feature$Toaster$Toaster$visibleToastsHeight, toasts, model.O);
        var visibleToasts = model.O > 1 && A2($author$project$ElmFramework$Feature$Toaster$Toaster$areTooManyToasts, visibleHeight, windowHeight) ? model.O - 1 : model.O;
        return _Utils_Tuple3(_Utils_update(model, {
          aQ: toasts,
          O: visibleToasts
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 3:
        return $author$project$ElmFramework$Feature$Toaster$Toaster$hideOldestVisibleToast(model);
      case 4:
        var actionMsg = msg.a;
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([actionMsg]));
      default:
        var toastItem = msg.a;
        var toastItemExists = $elm_community$maybe_extra$Maybe$Extra$isJust(A2($elm_community$list_extra$List$Extra$find, A2($elm$core$Basics$composeR, $elm$core$Tuple$first, A2($elm$core$Basics$composeR, function ($) {
          return $.fn;
        }, $elm$core$Basics$eq(toastItem.fn))), $elm$core$Array$toList(model.aQ)));
        var cbMsg = $author$project$ElmFramework$Feature$Toaster$Toaster$ToastTimerDone($elm$core$Array$length(model.aQ));
        var cmd = A2($elm$core$Task$perform, $elm$core$Basics$always(cbMsg), $elm$core$Process$sleep(5 * $author$project$ElmFramework$Lib$Util$timeInterval.rt));
        return !toastItemExists ? _Utils_Tuple3(_Utils_update(model, {
          aQ: A2($elm$core$Array$push, _Utils_Tuple2(toastItem, $elm$core$Maybe$Nothing), model.aQ),
          O: model.O + 1
        }), cmd, _List_Nil) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$ElmFramework$Feature$Tracking$Ports$requestTrackingPermissions = _Platform_outgoingPort('requestTrackingPermissions', function ($) {
    return $elm$json$Json$Encode$null;
  });
  var $author$project$ElmFramework$Feature$Tracking$Update$update = F3(function (env, msg, state) {
    return env.xd ? _Utils_Tuple2(0, $author$project$ElmFramework$Feature$Tracking$Ports$requestTrackingPermissions(0)) : _Utils_Tuple2(0, $elm$core$Platform$Cmd$none);
  });
  var $author$project$ElmFramework$Update$updaterRecursive = F3(function (config, msg, state) {
    switch (msg.$) {
      case 8:
        var appMsg = msg.a;
        return A2($author$project$ElmFramework$Lib$MsgAnything$topmostHandler, $author$project$ElmFramework$Update$updaterRecursive(config), {
          py: $author$project$ElmFramework$Msg$AppMsg,
          r4: function (childState) {
            return _Utils_update(state, {
              lL: childState
            });
          },
          sN: A2(config.C5, appMsg, state)
        });
      case 3:
        var theMsg = msg.a;
        var _v1 = A3($author$project$ElmFramework$Feature$Navigation$Routing$update, config, theMsg, state);
        var newRouteHistory = _v1.a;
        var cmd = _v1.b;
        var outMsg = _v1.c;
        if (!outMsg.$) {
          switch (outMsg.a.$) {
            case 0:
              var _v3 = outMsg.a;
              return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
                uA: cmd,
                yn: A2(config.Bz.Dd, state.lL, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(newRouteHistory)),
                aC: _Utils_update(state, {
                  rh: newRouteHistory
                })
              });
            case 1:
              var _v4 = outMsg.a;
              return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
                uA: cmd,
                yn: A2(config.Bz.De, state.lL, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(newRouteHistory)),
                aC: _Utils_update(state, {
                  rh: newRouteHistory
                })
              });
            default:
              var _v5 = outMsg.a;
              var shouldSilent = _v5.a;
              var oldHistory = _v5.b;
              var newRoute = _v5.c;
              return shouldSilent ? _Utils_Tuple2(_Utils_update(state, {
                rh: newRouteHistory
              }), cmd) : A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
                uA: $elm$core$Platform$Cmd$batch(_List_fromArray([cmd, A3($author$project$ElmFramework$Util$toVirtualPageViewCmd, config, state, newRoute)])),
                yn: A3(config.Bz.zm, state, oldHistory, newRoute),
                aC: _Utils_update(state, {
                  rh: newRouteHistory
                })
              });
          }
        } else {
          return _Utils_Tuple2(_Utils_update(state, {
            rh: newRouteHistory
          }), cmd);
        }
      case 10:
        var pressedKeys = msg.a;
        var mainMsgs = msg.b;
        return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
          uA: $elm$core$Platform$Cmd$none,
          yn: mainMsgs,
          aC: _Utils_update(state, {
            qD: pressedKeys
          })
        });
      case 12:
        var theMsg = msg.a;
        return A2($author$project$ElmFramework$Lib$MsgAnything$topmostHandler, $author$project$ElmFramework$Update$updaterRecursive(config), {
          py: $author$project$ElmFramework$Msg$ToasterMsg,
          r4: function (childState) {
            return _Utils_update(state, {
              CR: childState
            });
          },
          sN: A3($author$project$ElmFramework$Feature$Toaster$Toaster$update, {
            s4: state.t_.ij
          }, theMsg, state.CR)
        });
      case 11:
        var visibility = msg.a;
        if (visibility === 1) {
          return _Utils_Tuple2(_Utils_update(state, {
            qD: _List_Nil
          }), $elm$core$Platform$Cmd$none);
        } else {
          return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
        }
      case 13:
        var browser = msg.a;
        return _Utils_Tuple2(_Utils_update(state, {
          t_: browser
        }), $elm$core$Platform$Cmd$none);
      case 0:
        return function (_v7) {
          var geoPermission = _v7.a;
          var cmd = _v7.b;
          return _Utils_Tuple2(_Utils_update(state, {
            wm: geoPermission
          }), cmd);
        }(A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$locateMe, $author$project$ElmFramework$Msg$ReceiveGeolocation, state.wm));
      case 1:
        return _Utils_Tuple2(state, $author$project$ElmFramework$Feature$Platform$Platform$reloadApp(false));
      case 15:
        var permissionsResult = msg.a;
        if (permissionsResult.$ === 1) {
          var err = permissionsResult.a;
          return _Utils_Tuple2(state, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'permissionsResult problem: ', err));
        } else {
          var permissions = permissionsResult.a;
          var _v9 = function () {
            var _v10 = _Utils_Tuple2(state.wm, permissions);
            if (_v10.b.$ === 2) {
              if (_v10.a.$ === 2) {
                var _v11 = _v10.a;
                var oldStatus = _v11.b;
                var _v12 = _v10.b;
                var newBackground = _v12.a;
                return _Utils_Tuple2(A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, newBackground, oldStatus), $author$project$ElmFramework$Feature$Geolocation$Geolocation$simpleGeolocationReq(true));
              } else {
                var _v13 = _v10.b;
                return _Utils_Tuple2(permissions, $author$project$ElmFramework$Feature$Geolocation$Geolocation$simpleGeolocationReq(true));
              }
            } else {
              return _Utils_Tuple2(permissions, $elm$core$Platform$Cmd$none);
            }
          }();
          var newGeo = _v9.a;
          var cmd = _v9.b;
          return _Utils_Tuple2(_Utils_update(state, {
            wm: newGeo
          }), cmd);
        }
      case 18:
        var geolocationResult = msg.a.fH;
        var isExplicitlyRequested = msg.a.aL;
        var _v14 = _Utils_Tuple2(geolocationResult, isExplicitlyRequested);
        if (!_v14.a.$) {
          if (_v14.b) {
            var geolocationValue = _v14.a.a;
            var geolocation = function () {
              var _v15 = state.wm;
              if (_v15.$ === 2) {
                var background = _v15.a;
                return A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, background, $author$project$ElmFramework$Feature$Geolocation$Geolocation$ReceivedGeoLocation(geolocationValue));
              } else {
                return A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, false, $author$project$ElmFramework$Feature$Geolocation$Geolocation$ReceivedGeoLocation(geolocationValue));
              }
            }();
            var newState = _Utils_update(state, {
              wm: geolocation
            });
            return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
              uA: $author$project$ElmFramework$Feature$Geolocation$Geolocation$setLocationAccessAllowed(true),
              yn: A2(config.y8, geolocationValue, newState),
              aC: newState
            });
          } else {
            var geolocationValue = _v14.a.a;
            var backgroundAccess = function () {
              var _v16 = state.wm;
              if (_v16.$ === 2) {
                var background = _v16.a;
                return background;
              } else {
                return false;
              }
            }();
            var newState = _Utils_update(state, {
              wm: A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, backgroundAccess, $author$project$ElmFramework$Feature$Geolocation$Geolocation$ReceivedGeoLocation(geolocationValue))
            });
            return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
              uA: $author$project$ElmFramework$Feature$Geolocation$Geolocation$setLocationAccessAllowed(true),
              yn: A2(config.zl, geolocationValue, newState),
              aC: newState
            });
          }
        } else {
          switch (_v14.a.a.$) {
            case 0:
              var err = _v14.a.a.a;
              return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
                uA: $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$Geolocation$Geolocation$setLocationAccessAllowed(false), A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'ReceiveMyExplicitlyRequestedLocation: PermissionDenied', err)])),
                yn: _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, config.Ar(state).nQ, _List_fromArray(['Enable precise location on your device to use this feature']))]),
                aC: _Utils_update(state, {
                  wm: $author$project$ElmFramework$Feature$Geolocation$Geolocation$DeniedGeoPermissions
                })
              });
            case 2:
              var err = _v14.a.a.a;
              var phrases = config.Ar(state);
              return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
                uA: A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'ReceiveMyExplicitlyRequestedLocation: Timeout', err),
                yn: _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Nothing, phrases.nT, _List_fromArray([phrases.nS]))]),
                aC: _Utils_update(state, {
                  wm: function () {
                    var _v17 = state.wm;
                    if (_v17.$ === 2) {
                      if (_v17.b.$ === 2) {
                        return state.wm;
                      } else {
                        var evenInBackground = _v17.a;
                        return A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, evenInBackground, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation);
                      }
                    } else {
                      return A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, false, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation);
                    }
                  }()
                })
              });
            case 1:
              var err = _v14.a.a.a;
              return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
                uA: A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'ReceiveMyExplicitlyRequestedLocation: LocationUnavailable', err),
                yn: _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, config.Ar(state).nR, _List_fromArray([err]))]),
                aC: _Utils_update(state, {
                  wm: function () {
                    var _v18 = state.wm;
                    if (_v18.$ === 2) {
                      if (_v18.b.$ === 2) {
                        return state.wm;
                      } else {
                        var evenInBackground = _v18.a;
                        return A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, evenInBackground, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation);
                      }
                    } else {
                      return A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, false, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation);
                    }
                  }()
                })
              });
            default:
              var err = _v14.a.a.a;
              return _Utils_Tuple2(_Utils_update(state, {
                wm: function () {
                  var _v19 = state.wm;
                  if (_v19.$ === 2) {
                    if (_v19.b.$ === 2) {
                      return state.wm;
                    } else {
                      var evenInBackground = _v19.a;
                      return A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, evenInBackground, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation);
                    }
                  } else {
                    return $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnknownGeoPermissionStatus;
                  }
                }()
              }), A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, 'ReceiveMyExplicitlyRequestedLocation: UnknownGeoErr:', err));
          }
        }
      case 16:
        var result = msg.a;
        if (!result.$) {
          var pushPermissions = result.a;
          var newState = _Utils_update(state, {
            AO: pushPermissions
          });
          return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
            uA: function () {
              if (pushPermissions.$ === 3 && pushPermissions.b) {
                return $author$project$ElmFramework$Feature$Analytics$Analytics$trackingEvents.vM;
              } else {
                return $elm$core$Platform$Cmd$none;
              }
            }(),
            yn: A2(config.zt, pushPermissions, newState),
            aC: newState
          });
        } else {
          var err = result.a;
          return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
            uA: $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportMessage(err),
            yn: _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, config.Ar(state).qQ, _List_fromArray([err]))]),
            aC: state
          });
        }
      case 19:
        var env = state.vS;
        return _Utils_Tuple2(_Utils_update(state, {
          vS: _Utils_update(env, {
            gD: false
          })
        }), $elm$core$Platform$Cmd$none);
      case 20:
        var env = state.vS;
        return _Utils_Tuple2(_Utils_update(state, {
          vS: _Utils_update(env, {
            gi: 1
          })
        }), $elm$core$Platform$Cmd$none);
      case 21:
        var isInstalled = msg.a;
        var env = state.vS;
        return _Utils_Tuple2(_Utils_update(state, {
          vS: _Utils_update(env, {
            gi: $author$project$ElmFramework$Feature$Pwa$Pwa$toPwaInstallStatus(isInstalled)
          })
        }), isInstalled ? $author$project$ElmFramework$Feature$Analytics$Analytics$trackingEvents.tm : $elm$core$Platform$Cmd$none);
      case 22:
        var phrases = config.Ar(state);
        return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
          uA: $elm$core$Platform$Cmd$none,
          yn: _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CQ, $elm$core$Maybe$Just($author$project$ElmFramework$Msg$RestartApp), phrases.lN, _List_fromArray([phrases.lM]))]),
          aC: state
        });
      case 14:
        var posix = msg.a;
        return _Utils_Tuple2(_Utils_update(state, {
          Cy: posix
        }), $elm$core$Platform$Cmd$none);
      case 2:
        var title = msg.a.lh;
        var body = msg.a.aU;
        var url = msg.a.eZ;
        var toastMsg = A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Nothing, config.Ar(state).rL, _List_Nil);
        var _v22 = A4($author$project$ElmFramework$Feature$Share$Share$shareDialog, state.vS, title, body, url);
        var shareCmd = _v22.a;
        var isCopiedToClipboard = _v22.b;
        var _v23 = isCopiedToClipboard ? A3($author$project$ElmFramework$Update$updaterRecursive, config, toastMsg, state) : _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
        var newState = _v23.a;
        var toastCmd = _v23.b;
        return _Utils_Tuple2(newState, $elm$core$Platform$Cmd$batch(_List_fromArray([shareCmd, toastCmd])));
      case 4:
        var event = msg.a;
        switch (event.$) {
          case 0:
            return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
              uA: $elm$core$Platform$Cmd$none,
              yn: A2(config.zz, state, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.rh)),
              aC: state
            });
          case 1:
            return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
              uA: $elm$core$Platform$Cmd$none,
              yn: A2(config.zp, state, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.rh)),
              aC: state
            });
          default:
            var theEvent = event.a;
            return _Utils_Tuple2(state, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('handleLifecycleEvent: unexpected event: ' + theEvent));
        }
      case 5:
        return _Utils_Tuple2(state, A2($elm$core$Task$perform, $elm$core$Basics$always($author$project$ElmFramework$Msg$EnoughInitialCpuIdle), $elm$core$Process$sleep(5000)));
      case 6:
        return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
          uA: $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$Platform$Platform$enoughInitialCpuIdle(0), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$loadSocialLibraries(0)])),
          yn: A2(config.y6, state, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.rh)),
          aC: state
        });
      case 7:
        return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
          uA: $elm$core$Platform$Cmd$none,
          yn: A2(config.yZ, state, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.rh)),
          aC: state
        });
      case 17:
        var pushMessage = msg.a;
        return A2($folkertdev$elm_deque$BoundedDeque$member, pushMessage, state.AM) ? _Utils_Tuple2(state, $elm$core$Platform$Cmd$none) : A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
          uA: $elm$core$Platform$Cmd$none,
          yn: config.zs(pushMessage),
          aC: _Utils_update(state, {
            AM: A2($folkertdev$elm_deque$BoundedDeque$pushFront, pushMessage, state.AM)
          })
        });
      case 23:
        var theMsg = msg.a;
        var _v25 = A2($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$update, theMsg, state.B7);
        if (!_v25.b.$) {
          var newState = _v25.a;
          var socialAuthEvent = _v25.b.a;
          return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
            uA: $elm$core$Platform$Cmd$none,
            yn: A3(config.zJ, state, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.rh), socialAuthEvent),
            aC: _Utils_update(state, {
              B7: newState
            })
          });
        } else {
          var newState = _v25.a;
          var _v26 = _v25.b;
          return _Utils_Tuple2(_Utils_update(state, {
            B7: newState
          }), $elm$core$Platform$Cmd$none);
        }
      case 9:
        var msgs = msg.a;
        return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
          uA: $elm$core$Platform$Cmd$none,
          yn: msgs,
          aC: state
        });
      case 24:
        var theMsg = msg.a;
        var _v27 = A3($author$project$ElmFramework$Feature$Tracking$Update$update, state.vS, theMsg, 0);
        var cmd = _v27.b;
        return _Utils_Tuple2(state, A2($elm$core$Platform$Cmd$map, $author$project$ElmFramework$Msg$TrackingMsg, cmd));
      default:
        var seeds = msg.a;
        return _Utils_Tuple2(_Utils_update(state, {
          BM: seeds
        }), $elm$core$Platform$Cmd$none);
    }
  });
  var $author$project$ElmFramework$Update$executeStateWatchers = function (cfg) {
    var execWatcher = F2(function (watcher, _v2) {
      var topState = _v2.a;
      var cmd = _v2.b;
      var _v0 = watcher({
        a2: cfg.i7,
        b8: cfg.pQ
      });
      if (!_v0.$) {
        var _v1 = _v0.a;
        var appState = _v1.a;
        var appCmd = _v1.b;
        var topMsgs = _v1.c;
        return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(cfg.iW), {
          uA: $elm$core$Platform$Cmd$batch(_List_fromArray([cmd, A2($elm$core$Platform$Cmd$map, $author$project$ElmFramework$Msg$AppMsg, appCmd)])),
          yn: topMsgs,
          aC: _Utils_update(topState, {
            lL: appState
          })
        });
      } else {
        return _Utils_Tuple2(topState, cmd);
      }
    });
    return A3($elm$core$List$foldl, execWatcher, _Utils_Tuple2(cfg.i7, $elm$core$Platform$Cmd$none), cfg.iW.Cb);
  };
  var $author$project$ElmFramework$Update$maybeRedirect = F2(function (config, state) {
    var _v0 = A2(config.Bz.AV, state.lL, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.rh));
    if (!_v0.$) {
      var redirectTo = _v0.a;
      var _v1 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$setRoute({
        rh: redirectTo.rh,
        ci: state.rh,
        kR: redirectTo.kR,
        lh: A2(config.Bz.Bx, state.lL, redirectTo.rh).lh,
        eZ: $author$project$ElmFramework$Lib$Url$toUrlString(config.Bz.By(redirectTo.rh))
      });
      var routeHistory = _v1.a;
      var routeCmds = _v1.b;
      return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$updaterRecursive(config), {
        uA: $elm$core$Platform$Cmd$batch(_List_fromArray([routeCmds, A3($author$project$ElmFramework$Util$toVirtualPageViewCmd, config, state, redirectTo.rh)])),
        yn: A3(config.Bz.zm, state, state.rh, redirectTo.rh),
        aC: _Utils_update(state, {
          rh: routeHistory
        })
      });
    } else {
      return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
    }
  });
  var $author$project$ElmFramework$Feature$Platform$Platform$setNotificationBadgeCount = _Platform_outgoingPort('setNotificationBadgeCount', $elm$json$Json$Encode$int);
  var $author$project$ElmFramework$Feature$Platform$Platform$toSetNotificationBadgeCount = function (count) {
    return $author$project$ElmFramework$Feature$Platform$Platform$setNotificationBadgeCount(A2($elm$core$Basics$max, 0, count));
  };
  var $author$project$ElmFramework$Update$update = F3(function (config, msg, state) {
    var _v0 = A3($author$project$ElmFramework$Update$updaterRecursive, config, msg, state);
    var newState = _v0.a;
    var cmd = _v0.b;
    var _v1 = function () {
      var isAuthenticatedInNewState = config.Bz.w8(newState.lL);
      var authStateChanged = !_Utils_eq(config.Bz.w8(state.lL), isAuthenticatedInNewState);
      if ($author$project$ElmFramework$Feature$Navigation$RouteHistory$isPendingRoutingAction(state.rh)) {
        return _Utils_Tuple2(newState, $elm$core$Platform$Cmd$none);
      } else {
        if (authStateChanged) {
          if (!isAuthenticatedInNewState.$) {
            if (isAuthenticatedInNewState.a) {
              return config.Bz.w7($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(newState.rh)) ? A3($author$project$ElmFramework$Update$updaterRecursive, config, $author$project$ElmFramework$Msg$RoutingMsg(A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteBackWhileDroppingWithMaybeDefault, $elm$core$Maybe$Nothing, config.Bz.w7)), newState) : A2($author$project$ElmFramework$Update$maybeRedirect, config, newState);
            } else {
              return config.Bz.Bs($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(newState.rh)) ? A3($author$project$ElmFramework$Update$updaterRecursive, config, $author$project$ElmFramework$Msg$RoutingMsg(A3($author$project$ElmFramework$Feature$Navigation$Msg$RouteTo, false, false, config.Bz.tC)), newState) : A2($author$project$ElmFramework$Update$maybeRedirect, config, newState);
            }
          } else {
            return A2($author$project$ElmFramework$Update$maybeRedirect, config, newState);
          }
        } else {
          return A2($author$project$ElmFramework$Update$maybeRedirect, config, newState);
        }
      }
    }();
    var newStateWithUpdatedRouting = _v1.a;
    var updatedRoutingCmd = _v1.b;
    var _v3 = $author$project$ElmFramework$Update$executeStateWatchers({
      iW: config,
      i7: newStateWithUpdatedRouting,
      pQ: state
    });
    var newStateUpdatedByStateWatchers = _v3.a;
    var stateWatchersCmd = _v3.b;
    var setBadgeCountCmd = !_Utils_eq(config.tM(state.lL), config.tM(newState.lL)) ? $author$project$ElmFramework$Feature$Platform$Platform$toSetNotificationBadgeCount(config.tM(newState.lL)) : $elm$core$Platform$Cmd$none;
    var setTitleAndDescriptionCmd = function () {
      var oldMeta = A2(config.Bz.Bx, state.lL, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.rh));
      var newMeta = A2(config.Bz.Bx, newState.lL, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(newState.rh));
      return !_Utils_eq(oldMeta, newMeta) ? $author$project$ElmFramework$Feature$Platform$Platform$setTitleAndDescription(newMeta) : $elm$core$Platform$Cmd$none;
    }();
    return _Utils_Tuple2(newStateUpdatedByStateWatchers, $elm$core$Platform$Cmd$batch(_List_fromArray([cmd, setBadgeCountCmd, setTitleAndDescriptionCmd, updatedRoutingCmd, stateWatchersCmd])));
  });
  var $author$project$ElmFramework$Main$init = F2(function (config, programArgs) {
    var loadSocialLibrariesForHybrid = programArgs.hN.vS.xd ? $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$loadSocialLibraries(0) : $elm$core$Platform$Cmd$none;
    var definiteInitialHistory = $author$project$ElmFramework$Feature$Navigation$RouteHistory$singleton(config.Bz.wB);
    var _v0 = config.wM(programArgs);
    var appState = _v0.a;
    var appCmd = _v0.b;
    var initMsgs = _v0.c;
    var _v1 = A3($author$project$ElmFramework$Feature$Navigation$Routing$toInitialRoute, config.Bz, programArgs, appState);
    var initialRouteHistory = _v1.a;
    var initialRouteCmd = _v1.b;
    var _v2 = A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$toInitGeoPermissions, programArgs.hN.wl, config.wo);
    var geoPermissions = _v2.a;
    var geoPermissionsCmd = _v2.b;
    var initState = {
      lL: appState,
      t_: programArgs.hN.t_,
      vS: $author$project$ElmFramework$InitArgs$toEnv(programArgs.hN.vS),
      wm: geoPermissions,
      qD: _List_Nil,
      AM: $folkertdev$elm_deque$BoundedDeque$empty(15),
      AO: $author$project$ElmFramework$Feature$PushMessages$PushMessages$UnknownPushPermissions,
      rh: initialRouteHistory,
      BM: A2($elm$core$List$map, $elm$random$Random$initialSeed, programArgs.hN.BM),
      B7: $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$init(programArgs.hN.vS.xd),
      Cy: $elm$time$Time$millisToPosix(programArgs.hN.u2),
      CR: $author$project$ElmFramework$Feature$Toaster$Toaster$init,
      DJ: A2($elm$time$Time$customZone, programArgs.hN.CB, _List_Nil)
    };
    var initCmds = $elm$core$Platform$Cmd$batch(_List_fromArray([A2($elm$core$Platform$Cmd$map, $author$project$ElmFramework$Msg$AppMsg, appCmd), initialRouteCmd, geoPermissionsCmd, loadSocialLibrariesForHybrid, A3($author$project$ElmFramework$Util$toVirtualPageViewCmd, config, initState, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(initialRouteHistory))]));
    return A2($author$project$ElmFramework$Lib$MsgAnything$dispatchMessages, $author$project$ElmFramework$Update$update(config), {
      uA: initCmds,
      yn: _Utils_ap(initMsgs, A3(config.Bz.zm, initState, definiteInitialHistory, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(initialRouteHistory))),
      aC: initState
    });
  });
  var $author$project$ElmFramework$Msg$AppLoaded = {
    $: 5
  };
  var $author$project$ElmFramework$Msg$AppUpdated = {
    $: 22
  };
  var $author$project$ElmFramework$Msg$KeyEvent = F2(function (a, b) {
    return {
      $: 10,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Msg$LifeCycleEvent = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $author$project$ElmFramework$Msg$OnPushMessage = function (a) {
    return {
      $: 17,
      a: a
    };
  };
  var $author$project$ElmFramework$Msg$PushNotificationsPermissionsStatus = function (a) {
    return {
      $: 16,
      a: a
    };
  };
  var $author$project$ElmFramework$Msg$ReceiveBeforeInstallPromptEvent = {
    $: 20
  };
  var $author$project$ElmFramework$Msg$ReceiveDetailedGeolocationPermissions = function (a) {
    return {
      $: 15,
      a: a
    };
  };
  var $author$project$ElmFramework$Msg$ReceiveInstallPwaResult = function (a) {
    return {
      $: 21,
      a: a
    };
  };
  var $author$project$ElmFramework$Msg$SocialAuthMsg = function (a) {
    return {
      $: 23,
      a: a
    };
  };
  var $author$project$ElmFramework$Msg$UpdateCurrTime = function (a) {
    return {
      $: 14,
      a: a
    };
  };
  var $author$project$ElmFramework$Msg$UserCouldNotProvidePaymentCard = {
    $: 19
  };
  var $author$project$ElmFramework$Msg$VisibilityChange = function (a) {
    return {
      $: 11,
      a: a
    };
  };
  var $author$project$ElmFramework$Msg$WeAreOnline = {
    $: 7
  };
  var $author$project$ElmFramework$Msg$WindowResize = function (a) {
    return {
      $: 13,
      a: a
    };
  };
  var $elm$json$Json$Decode$null = _Json_decodeNull;
  var $author$project$ElmFramework$Feature$Platform$Platform$appLoaded = _Platform_incomingPort('appLoaded', $elm$json$Json$Decode$null(0));
  var $author$project$ElmFramework$Feature$Pwa$Pwa$appUpdated = _Platform_incomingPort('appUpdated', $elm$json$Json$Decode$null(0));
  var $elm$core$Platform$Sub$batch = _Platform_batch;
  var $ohanhi$keyboard$Keyboard$Escape = {
    $: 62
  };
  var $wernerdegroot$listzipper$List$Zipper$isFirst = function (_v0) {
    var ls = _v0.a;
    return $elm$core$List$isEmpty(ls);
  };
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$isFirst = function (_v0) {
    var routeHistory = _v0.a;
    return $wernerdegroot$listzipper$List$Zipper$isFirst(routeHistory);
  };
  var $ohanhi$keyboard$Keyboard$rawValue = function (_v0) {
    var key = _v0;
    return key;
  };
  var $author$project$ElmFramework$Main$escKeyboardHandler = F2(function (config, state) {
    var isMobileOs = function (_v2) {
      var isAndroid = _v2.fM;
      var isIos = _v2.fQ;
      return isAndroid || isIos;
    }(state.vS);
    var isFirstRoute = $author$project$ElmFramework$Feature$Navigation$RouteHistory$isFirst(state.rh);
    var escParser = function (rawKey) {
      return $ohanhi$keyboard$Keyboard$rawValue(rawKey) === 'Escape' ? $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Escape) : $elm$core$Maybe$Nothing;
    };
    var escEventHandler = F2(function (pressedKeys, maybeKeyChange) {
      var _v0 = _Utils_Tuple2(pressedKeys, maybeKeyChange);
      if (!_v0.a.b && !_v0.b.$ && _v0.b.a.$ === 1 && _v0.b.a.a.$ === 62) {
        var _v1 = _v0.b.a.a;
        return A2(config.Bz.Dd, state.lL, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(state.rh));
      } else {
        return _List_Nil;
      }
    });
    return !isMobileOs && !isFirstRoute ? _List_fromArray([{
      nr: escEventHandler,
      p9: escParser
    }]) : _List_Nil;
  });
  var $elm$time$Time$Every = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $elm$time$Time$State = F2(function (taggers, processes) {
    return {
      qH: processes,
      si: taggers
    };
  });
  var $elm$time$Time$init = $elm$core$Task$succeed(A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
  var $elm$core$Dict$get = F2(function (targetKey, dict) {
    get: while (true) {
      if (dict.$ === -2) {
        return $elm$core$Maybe$Nothing;
      } else {
        var key = dict.b;
        var value = dict.c;
        var left = dict.d;
        var right = dict.e;
        var _v1 = A2($elm$core$Basics$compare, targetKey, key);
        switch (_v1) {
          case 0:
            var $temp$targetKey = targetKey,
              $temp$dict = left;
            targetKey = $temp$targetKey;
            dict = $temp$dict;
            continue get;
          case 1:
            return $elm$core$Maybe$Just(value);
          default:
            var $temp$targetKey = targetKey,
              $temp$dict = right;
            targetKey = $temp$targetKey;
            dict = $temp$dict;
            continue get;
        }
      }
    }
  });
  var $elm$time$Time$addMySub = F2(function (_v0, state) {
    var interval = _v0.a;
    var tagger = _v0.b;
    var _v1 = A2($elm$core$Dict$get, interval, state);
    if (_v1.$ === 1) {
      return A3($elm$core$Dict$insert, interval, _List_fromArray([tagger]), state);
    } else {
      var taggers = _v1.a;
      return A3($elm$core$Dict$insert, interval, A2($elm$core$List$cons, tagger, taggers), state);
    }
  });
  var $elm$core$Process$kill = _Scheduler_kill;
  var $elm$core$Dict$foldl = F3(function (func, acc, dict) {
    foldl: while (true) {
      if (dict.$ === -2) {
        return acc;
      } else {
        var key = dict.b;
        var value = dict.c;
        var left = dict.d;
        var right = dict.e;
        var $temp$func = func,
          $temp$acc = A3(func, key, value, A3($elm$core$Dict$foldl, func, acc, left)),
          $temp$dict = right;
        func = $temp$func;
        acc = $temp$acc;
        dict = $temp$dict;
        continue foldl;
      }
    }
  });
  var $elm$core$Dict$merge = F6(function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
    var stepState = F3(function (rKey, rValue, _v0) {
      stepState: while (true) {
        var list = _v0.a;
        var result = _v0.b;
        if (!list.b) {
          return _Utils_Tuple2(list, A3(rightStep, rKey, rValue, result));
        } else {
          var _v2 = list.a;
          var lKey = _v2.a;
          var lValue = _v2.b;
          var rest = list.b;
          if (_Utils_cmp(lKey, rKey) < 0) {
            var $temp$rKey = rKey,
              $temp$rValue = rValue,
              $temp$_v0 = _Utils_Tuple2(rest, A3(leftStep, lKey, lValue, result));
            rKey = $temp$rKey;
            rValue = $temp$rValue;
            _v0 = $temp$_v0;
            continue stepState;
          } else {
            if (_Utils_cmp(lKey, rKey) > 0) {
              return _Utils_Tuple2(list, A3(rightStep, rKey, rValue, result));
            } else {
              return _Utils_Tuple2(rest, A4(bothStep, lKey, lValue, rValue, result));
            }
          }
        }
      }
    });
    var _v3 = A3($elm$core$Dict$foldl, stepState, _Utils_Tuple2($elm$core$Dict$toList(leftDict), initialResult), rightDict);
    var leftovers = _v3.a;
    var intermediateResult = _v3.b;
    return A3($elm$core$List$foldl, F2(function (_v4, result) {
      var k = _v4.a;
      var v = _v4.b;
      return A3(leftStep, k, v, result);
    }), intermediateResult, leftovers);
  });
  var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
  var $elm$time$Time$Name = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $elm$time$Time$Offset = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $elm$time$Time$setInterval = _Time_setInterval;
  var $elm$core$Process$spawn = _Scheduler_spawn;
  var $elm$time$Time$spawnHelp = F3(function (router, intervals, processes) {
    if (!intervals.b) {
      return $elm$core$Task$succeed(processes);
    } else {
      var interval = intervals.a;
      var rest = intervals.b;
      var spawnTimer = $elm$core$Process$spawn(A2($elm$time$Time$setInterval, interval, A2($elm$core$Platform$sendToSelf, router, interval)));
      var spawnRest = function (id) {
        return A3($elm$time$Time$spawnHelp, router, rest, A3($elm$core$Dict$insert, interval, id, processes));
      };
      return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
    }
  });
  var $elm$time$Time$onEffects = F3(function (router, subs, _v0) {
    var processes = _v0.qH;
    var rightStep = F3(function (_v6, id, _v7) {
      var spawns = _v7.a;
      var existing = _v7.b;
      var kills = _v7.c;
      return _Utils_Tuple3(spawns, existing, A2($elm$core$Task$andThen, function (_v5) {
        return kills;
      }, $elm$core$Process$kill(id)));
    });
    var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
    var leftStep = F3(function (interval, taggers, _v4) {
      var spawns = _v4.a;
      var existing = _v4.b;
      var kills = _v4.c;
      return _Utils_Tuple3(A2($elm$core$List$cons, interval, spawns), existing, kills);
    });
    var bothStep = F4(function (interval, taggers, id, _v3) {
      var spawns = _v3.a;
      var existing = _v3.b;
      var kills = _v3.c;
      return _Utils_Tuple3(spawns, A3($elm$core$Dict$insert, interval, id, existing), kills);
    });
    var _v1 = A6($elm$core$Dict$merge, leftStep, bothStep, rightStep, newTaggers, processes, _Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, $elm$core$Task$succeed(0)));
    var spawnList = _v1.a;
    var existingDict = _v1.b;
    var killTask = _v1.c;
    return A2($elm$core$Task$andThen, function (newProcesses) {
      return $elm$core$Task$succeed(A2($elm$time$Time$State, newTaggers, newProcesses));
    }, A2($elm$core$Task$andThen, function (_v2) {
      return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
    }, killTask));
  });
  var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
  var $elm$time$Time$onSelfMsg = F3(function (router, interval, state) {
    var _v0 = A2($elm$core$Dict$get, interval, state.si);
    if (_v0.$ === 1) {
      return $elm$core$Task$succeed(state);
    } else {
      var taggers = _v0.a;
      var tellTaggers = function (time) {
        return $elm$core$Task$sequence(A2($elm$core$List$map, function (tagger) {
          return A2($elm$core$Platform$sendToApp, router, tagger(time));
        }, taggers));
      };
      return A2($elm$core$Task$andThen, function (_v1) {
        return $elm$core$Task$succeed(state);
      }, A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
    }
  });
  var $elm$time$Time$subMap = F2(function (f, _v0) {
    var interval = _v0.a;
    var tagger = _v0.b;
    return A2($elm$time$Time$Every, interval, A2($elm$core$Basics$composeL, f, tagger));
  });
  _Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
  var $elm$time$Time$subscription = _Platform_leaf('Time');
  var $elm$time$Time$every = F2(function (interval, tagger) {
    return $elm$time$Time$subscription(A2($elm$time$Time$Every, interval, tagger));
  });
  var $elm$json$Json$Decode$bool = _Json_decodeBool;
  var $author$project$ElmFramework$Feature$Pwa$Pwa$installPwaResult = _Platform_incomingPort('installPwaResult', $elm$json$Json$Decode$bool);
  var $elm$json$Json$Decode$string = _Json_decodeString;
  var $author$project$ElmFramework$Feature$Platform$Platform$lifeCycleEvent = _Platform_incomingPort('lifeCycleEvent', $elm$json$Json$Decode$string);
  var $author$project$ElmFramework$Feature$Platform$Platform$Pause = {
    $: 1
  };
  var $author$project$ElmFramework$Feature$Platform$Platform$Resume = {
    $: 0
  };
  var $author$project$ElmFramework$Feature$Platform$Platform$Unexpected = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Platform$Platform$toLifeCycleEvent = function (eventString) {
    switch (eventString) {
      case 'Resume':
        return $author$project$ElmFramework$Feature$Platform$Platform$Resume;
      case 'Pause':
        return $author$project$ElmFramework$Feature$Platform$Platform$Pause;
      default:
        var unexpected = eventString;
        return $author$project$ElmFramework$Feature$Platform$Platform$Unexpected(unexpected);
    }
  };
  var $author$project$ElmFramework$Feature$Platform$Platform$listenLifeCycleEvents = function (tag) {
    return $author$project$ElmFramework$Feature$Platform$Platform$lifeCycleEvent(A2($elm$core$Basics$composeL, tag, $author$project$ElmFramework$Feature$Platform$Platform$toLifeCycleEvent));
  };
  var $elm$core$Platform$Sub$map = _Platform_map;
  var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnknownGeoErr = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $elm$json$Json$Decode$decodeValue = _Json_run;
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$LocationUnavailable = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$PermissionDenied = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$Timeout = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $elm$json$Json$Decode$fail = _Json_fail;
  var $elm$json$Json$Decode$field = _Json_decodeField;
  var $elm$json$Json$Decode$oneOf = _Json_oneOf;
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$geolocationErrorDecoder = function () {
    var unionType = F2(function (discriminant, constructor) {
      return A3($elm$json$Json$Decode$map2, F2(function (_v0, val) {
        return constructor(val);
      }), A2($elm$json$Json$Decode$andThen, function (kind) {
        return _Utils_eq(kind, discriminant) ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$fail('geo error: bad kind: ' + kind);
      }, A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string)), A2($elm$json$Json$Decode$field, 'details', $elm$json$Json$Decode$string));
    });
    return $elm$json$Json$Decode$oneOf(_List_fromArray([A2(unionType, 'PermissionDenied', $author$project$ElmFramework$Feature$Geolocation$Geolocation$PermissionDenied), A2(unionType, 'LocationUnavailable', $author$project$ElmFramework$Feature$Geolocation$Geolocation$LocationUnavailable), A2(unionType, 'Timeout', $author$project$ElmFramework$Feature$Geolocation$Geolocation$Timeout)]));
  }();
  var $elm$core$Result$mapError = F2(function (f, result) {
    if (!result.$) {
      var v = result.a;
      return $elm$core$Result$Ok(v);
    } else {
      var e = result.a;
      return $elm$core$Result$Err(f(e));
    }
  });
  var $elm$json$Json$Decode$value = _Json_decodeValue;
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$receiveGeolocationFailure = _Platform_incomingPort('receiveGeolocationFailure', A2($elm$json$Json$Decode$andThen, function (isExplicitlyRequested) {
    return A2($elm$json$Json$Decode$andThen, function (geolocationError) {
      return $elm$json$Json$Decode$succeed({
        ic: geolocationError,
        aL: isExplicitlyRequested
      });
    }, A2($elm$json$Json$Decode$field, 'geolocationError', $elm$json$Json$Decode$value));
  }, A2($elm$json$Json$Decode$field, 'isExplicitlyRequested', $elm$json$Json$Decode$bool)));
  var $elm$json$Json$Decode$float = _Json_decodeFloat;
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$receiveGeolocationSuccess = _Platform_incomingPort('receiveGeolocationSuccess', A2($elm$json$Json$Decode$andThen, function (isExplicitlyRequested) {
    return A2($elm$json$Json$Decode$andThen, function (geolocationSuccess) {
      return $elm$json$Json$Decode$succeed({
        id: geolocationSuccess,
        aL: isExplicitlyRequested
      });
    }, A2($elm$json$Json$Decode$field, 'geolocationSuccess', A2($elm$json$Json$Decode$andThen, function (longitude) {
      return A2($elm$json$Json$Decode$andThen, function (latitude) {
        return A2($elm$json$Json$Decode$andThen, function (accuracy) {
          return $elm$json$Json$Decode$succeed({
            gV: accuracy,
            fU: latitude,
            fX: longitude
          });
        }, A2($elm$json$Json$Decode$field, 'accuracy', $elm$json$Json$Decode$float));
      }, A2($elm$json$Json$Decode$field, 'latitude', $elm$json$Json$Decode$float));
    }, A2($elm$json$Json$Decode$field, 'longitude', $elm$json$Json$Decode$float))));
  }, A2($elm$json$Json$Decode$field, 'isExplicitlyRequested', $elm$json$Json$Decode$bool)));
  var $author$project$ElmFramework$Lib$Util$unwrapResult = function (result) {
    if (!result.$) {
      var a = result.a;
      return a;
    } else {
      var a = result.a;
      return a;
    }
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$onReceiveGeolocation = function (tag) {
    var successToPayload = function (_v1) {
      var geolocationSuccess = _v1.id;
      var isExplicitlyRequested = _v1.aL;
      return {
        fH: $elm$core$Result$Ok(geolocationSuccess),
        aL: isExplicitlyRequested
      };
    };
    var failureToPayload = function (_v0) {
      var geolocationError = _v0.ic;
      var isExplicitlyRequested = _v0.aL;
      return {
        fH: $elm$core$Result$Err($author$project$ElmFramework$Lib$Util$unwrapResult(A2($elm$core$Result$mapError, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnknownGeoErr, $elm$json$Json$Decode$errorToString), A2($elm$json$Json$Decode$decodeValue, $author$project$ElmFramework$Feature$Geolocation$Geolocation$geolocationErrorDecoder, geolocationError)))),
        aL: isExplicitlyRequested
      };
    };
    return $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$Geolocation$Geolocation$receiveGeolocationSuccess(A2($elm$core$Basics$composeR, successToPayload, tag)), $author$project$ElmFramework$Feature$Geolocation$Geolocation$receiveGeolocationFailure(A2($elm$core$Basics$composeR, failureToPayload, tag))]));
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$DeniedAlwaysGeoPermissions = {
    $: 3
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$decodeLocationPermissions = function (locationPermissions) {
    switch (locationPermissions) {
      case 'NOT_REQUESTED':
        return $elm$core$Result$Ok($author$project$ElmFramework$Feature$Geolocation$Geolocation$UnknownGeoPermissionStatus);
      case 'GRANTED':
        return $elm$core$Result$Ok(A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, true, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation));
      case 'GRANTED_WHEN_IN_USE':
        return $elm$core$Result$Ok(A2($author$project$ElmFramework$Feature$Geolocation$Geolocation$GrantedGeoPermission, false, $author$project$ElmFramework$Feature$Geolocation$Geolocation$UnavailableGeoLocation));
      case 'RESTRICTED':
        return $elm$core$Result$Ok($author$project$ElmFramework$Feature$Geolocation$Geolocation$DeniedAlwaysGeoPermissions);
      case 'DENIED_ALWAYS':
        return $elm$core$Result$Ok($author$project$ElmFramework$Feature$Geolocation$Geolocation$DeniedAlwaysGeoPermissions);
      case 'DENIED':
        return $elm$core$Result$Ok($author$project$ElmFramework$Feature$Geolocation$Geolocation$DeniedGeoPermissions);
      default:
        return $elm$core$Result$Err('decodeLocationPermissions: unexpected locationPermissions: ' + locationPermissions);
    }
  };
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$receiveLocationPermissions = _Platform_incomingPort('receiveLocationPermissions', $elm$json$Json$Decode$string);
  var $author$project$ElmFramework$Feature$Geolocation$Geolocation$onReceiveLocationPermissions = function (tag) {
    return $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$Geolocation$Geolocation$receiveLocationPermissions(A2($elm$core$Basics$composeR, $author$project$ElmFramework$Feature$Geolocation$Geolocation$decodeLocationPermissions, tag))]));
  };
  var $elm$browser$Browser$Events$Document = 0;
  var $elm$browser$Browser$Events$MySub = F3(function (a, b, c) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c
    };
  });
  var $elm$browser$Browser$Events$State = F2(function (subs, pids) {
    return {
      qr: pids,
      sb: subs
    };
  });
  var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
  var $elm$browser$Browser$Events$nodeToKey = function (node) {
    if (!node) {
      return 'd_';
    } else {
      return 'w_';
    }
  };
  var $elm$browser$Browser$Events$addKey = function (sub) {
    var node = sub.a;
    var name = sub.b;
    return _Utils_Tuple2(_Utils_ap($elm$browser$Browser$Events$nodeToKey(node), name), sub);
  };
  var $elm$browser$Browser$Events$Event = F2(function (key, event) {
    return {
      np: event,
      xr: key
    };
  });
  var $elm$browser$Browser$Events$spawn = F3(function (router, key, _v0) {
    var node = _v0.a;
    var name = _v0.b;
    var actualNode = function () {
      if (!node) {
        return _Browser_doc;
      } else {
        return _Browser_window;
      }
    }();
    return A2($elm$core$Task$map, function (value) {
      return _Utils_Tuple2(key, value);
    }, A3(_Browser_on, actualNode, name, function (event) {
      return A2($elm$core$Platform$sendToSelf, router, A2($elm$browser$Browser$Events$Event, key, event));
    }));
  });
  var $elm$core$Dict$union = F2(function (t1, t2) {
    return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
  });
  var $elm$browser$Browser$Events$onEffects = F3(function (router, subs, state) {
    var stepRight = F3(function (key, sub, _v6) {
      var deads = _v6.a;
      var lives = _v6.b;
      var news = _v6.c;
      return _Utils_Tuple3(deads, lives, A2($elm$core$List$cons, A3($elm$browser$Browser$Events$spawn, router, key, sub), news));
    });
    var stepLeft = F3(function (_v4, pid, _v5) {
      var deads = _v5.a;
      var lives = _v5.b;
      var news = _v5.c;
      return _Utils_Tuple3(A2($elm$core$List$cons, pid, deads), lives, news);
    });
    var stepBoth = F4(function (key, pid, _v2, _v3) {
      var deads = _v3.a;
      var lives = _v3.b;
      var news = _v3.c;
      return _Utils_Tuple3(deads, A3($elm$core$Dict$insert, key, pid, lives), news);
    });
    var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
    var _v0 = A6($elm$core$Dict$merge, stepLeft, stepBoth, stepRight, state.qr, $elm$core$Dict$fromList(newSubs), _Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
    var deadPids = _v0.a;
    var livePids = _v0.b;
    var makeNewPids = _v0.c;
    return A2($elm$core$Task$andThen, function (pids) {
      return $elm$core$Task$succeed(A2($elm$browser$Browser$Events$State, newSubs, A2($elm$core$Dict$union, livePids, $elm$core$Dict$fromList(pids))));
    }, A2($elm$core$Task$andThen, function (_v1) {
      return $elm$core$Task$sequence(makeNewPids);
    }, $elm$core$Task$sequence(A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
  });
  var $elm$browser$Browser$Events$onSelfMsg = F3(function (router, _v0, state) {
    var key = _v0.xr;
    var event = _v0.np;
    var toMessage = function (_v2) {
      var subKey = _v2.a;
      var _v3 = _v2.b;
      var node = _v3.a;
      var name = _v3.b;
      var decoder = _v3.c;
      return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
    };
    var messages = A2($elm$core$List$filterMap, toMessage, state.sb);
    return A2($elm$core$Task$andThen, function (_v1) {
      return $elm$core$Task$succeed(state);
    }, $elm$core$Task$sequence(A2($elm$core$List$map, $elm$core$Platform$sendToApp(router), messages)));
  });
  var $elm$browser$Browser$Events$subMap = F2(function (func, _v0) {
    var node = _v0.a;
    var name = _v0.b;
    var decoder = _v0.c;
    return A3($elm$browser$Browser$Events$MySub, node, name, A2($elm$json$Json$Decode$map, func, decoder));
  });
  _Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
  var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
  var $elm$browser$Browser$Events$on = F3(function (node, name, decoder) {
    return $elm$browser$Browser$Events$subscription(A3($elm$browser$Browser$Events$MySub, node, name, decoder));
  });
  var $elm$browser$Browser$Events$Hidden = 1;
  var $elm$browser$Browser$Events$Visible = 0;
  var $elm$browser$Browser$Events$withHidden = F2(function (func, isHidden) {
    return func(isHidden ? 1 : 0);
  });
  var $elm$browser$Browser$Events$onVisibilityChange = function (func) {
    var info = _Browser_visibilityInfo(0);
    return A3($elm$browser$Browser$Events$on, 0, info.uf, A2($elm$json$Json$Decode$map, $elm$browser$Browser$Events$withHidden(func), A2($elm$json$Json$Decode$field, 'target', A2($elm$json$Json$Decode$field, info.wz, $elm$json$Json$Decode$bool))));
  };
  var $author$project$ElmFramework$Feature$Pwa$Pwa$receiveBeforeInstallPromptEvent = _Platform_incomingPort('receiveBeforeInstallPromptEvent', $elm$json$Json$Decode$null(0));
  var $elm$json$Json$Decode$list = _Json_decodeList;
  var $author$project$ElmFramework$Feature$Toaster$Notifier$listenNotif = _Platform_incomingPort('listenNotif', A2($elm$json$Json$Decode$andThen, function (title) {
    return A2($elm$json$Json$Decode$andThen, function (kind) {
      return A2($elm$json$Json$Decode$andThen, function (bodies) {
        return $elm$json$Json$Decode$succeed({
          aT: bodies,
          xu: kind,
          lh: title
        });
      }, A2($elm$json$Json$Decode$field, 'bodies', $elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
    }, A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string));
  }, A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string)));
  var $author$project$ElmFramework$Feature$Toaster$Notifier$notifKind = {
    dZ: 'error',
    wL: 'info',
    eP: 'success'
  };
  var $author$project$ElmFramework$Feature$Toaster$Notifier$receiveNotifs = function (config) {
    var transformer = function (notif) {
      return _Utils_eq(notif.xu, $author$project$ElmFramework$Feature$Toaster$Notifier$notifKind.eP) ? A2(config.eP, notif.lh, notif.aT) : _Utils_eq(notif.xu, $author$project$ElmFramework$Feature$Toaster$Notifier$notifKind.dZ) ? A2(config.dZ, notif.lh, notif.aT) : A2(config.wL, notif.lh, notif.aT);
    };
    return $author$project$ElmFramework$Feature$Toaster$Notifier$listenNotif(transformer);
  };
  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$receivePushMsg = _Platform_incomingPort('receivePushMsg', $elm$json$Json$Decode$value);
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$FacebookSdkLoaded = {
    $: 2
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$GoogleOauthSdkLoaded = {
    $: 0
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$ReceiveAppleAuthSuccess = function (a) {
    return {
      $: 6,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$ReceiveFacebookAuthSuccess = function (a) {
    return {
      $: 7,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$ReceiveGoogleAuthSuccess = function (a) {
    return {
      $: 5,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowClosedInternal = {
    $: 3
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowOpenedInternal = {
    $: 4
  };
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$appleOauthSdkLoaded = _Platform_incomingPort('appleOauthSdkLoaded', $elm$json$Json$Decode$null(0));
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$facebookSdkLoaded = _Platform_incomingPort('facebookSdkLoaded', $elm$json$Json$Decode$null(0));
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$googleOauthSdkLoaded = _Platform_incomingPort('googleOauthSdkLoaded', $elm$json$Json$Decode$null(0));
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$receiveAppleAuth = _Platform_incomingPort('receiveAppleAuth', A2($elm$json$Json$Decode$andThen, function (idToken) {
    return $elm$json$Json$Decode$succeed({
      oe: idToken
    });
  }, A2($elm$json$Json$Decode$field, 'idToken', $elm$json$Json$Decode$string)));
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$receiveFacebookAuth = _Platform_incomingPort('receiveFacebookAuth', A2($elm$json$Json$Decode$andThen, function (authResponse) {
    return $elm$json$Json$Decode$succeed({
      lW: authResponse
    });
  }, A2($elm$json$Json$Decode$field, 'authResponse', A2($elm$json$Json$Decode$andThen, function (userID) {
    return A2($elm$json$Json$Decode$andThen, function (accessToken) {
      return $elm$json$Json$Decode$succeed({
        tf: accessToken,
        Da: userID
      });
    }, A2($elm$json$Json$Decode$field, 'accessToken', $elm$json$Json$Decode$string));
  }, A2($elm$json$Json$Decode$field, 'userID', $elm$json$Json$Decode$string)))));
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$receiveGoogleAuth = _Platform_incomingPort('receiveGoogleAuth', A2($elm$json$Json$Decode$andThen, function (idToken) {
    return $elm$json$Json$Decode$succeed({
      oe: idToken
    });
  }, A2($elm$json$Json$Decode$field, 'idToken', $elm$json$Json$Decode$string)));
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$socialWindowClosed = _Platform_incomingPort('socialWindowClosed', $elm$json$Json$Decode$null(0));
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$socialWindowOpened = _Platform_incomingPort('socialWindowOpened', $elm$json$Json$Decode$null(0));
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$socialAuthEventsSubscriptions = $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$SocialAuth$SocialAuth$googleOauthSdkLoaded($elm$core$Basics$always($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$GoogleOauthSdkLoaded)), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$appleOauthSdkLoaded($elm$core$Basics$always($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$GoogleOauthSdkLoaded)), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$facebookSdkLoaded($elm$core$Basics$always($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$FacebookSdkLoaded)), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$socialWindowClosed($elm$core$Basics$always($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowClosedInternal)), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$socialWindowOpened($elm$core$Basics$always($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$SocialWindowOpenedInternal)), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$receiveGoogleAuth($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$ReceiveGoogleAuthSuccess), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$receiveAppleAuth($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$ReceiveAppleAuthSuccess), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$receiveFacebookAuth($author$project$ElmFramework$Feature$SocialAuth$SocialAuth$ReceiveFacebookAuthSuccess)]));
  var $author$project$ElmFramework$Feature$Navigation$Msg$AuthError = {
    $: 11
  };
  var $author$project$ElmFramework$Feature$Navigation$Msg$HardwareBack = {
    $: 9
  };
  var $author$project$ElmFramework$Feature$Navigation$Msg$HardwareForward = {
    $: 10
  };
  var $author$project$ElmFramework$Feature$Navigation$Msg$NavToFromLoopback = function (a) {
    return {
      $: 8,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Navigation$Msg$PopState = function (a) {
    return {
      $: 7,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Auth$Extra$authErrorLoopbackSub = _Platform_incomingPort('authErrorLoopbackSub', $elm$json$Json$Decode$null(0));
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$hardwareNavBack = _Platform_incomingPort('hardwareNavBack', $elm$json$Json$Decode$null(0));
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$hardwareNavForward = _Platform_incomingPort('hardwareNavForward', $elm$json$Json$Decode$null(0));
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$navToLoopbackSub = _Platform_incomingPort('navToLoopbackSub', A2($elm$json$Json$Decode$andThen, function (shouldSilent) {
    return A2($elm$json$Json$Decode$andThen, function (shouldReplace) {
      return A2($elm$json$Json$Decode$andThen, function (navigationLocation) {
        return $elm$json$Json$Decode$succeed({
          yA: navigationLocation,
          kR: shouldReplace,
          rN: shouldSilent
        });
      }, A2($elm$json$Json$Decode$field, 'navigationLocation', A2($elm$json$Json$Decode$andThen, function (search) {
        return A2($elm$json$Json$Decode$andThen, function (protocol) {
          return A2($elm$json$Json$Decode$andThen, function (port_) {
            return A2($elm$json$Json$Decode$andThen, function (pathname) {
              return A2($elm$json$Json$Decode$andThen, function (origin) {
                return A2($elm$json$Json$Decode$andThen, function (href) {
                  return A2($elm$json$Json$Decode$andThen, function (hostname) {
                    return A2($elm$json$Json$Decode$andThen, function (host) {
                      return A2($elm$json$Json$Decode$andThen, function (hash) {
                        return $elm$json$Json$Decode$succeed({
                          ii: hash,
                          ik: host,
                          il: hostname,
                          im: href,
                          j_: origin,
                          j9: pathname,
                          kc: port_,
                          ke: protocol,
                          kH: search
                        });
                      }, A2($elm$json$Json$Decode$field, 'hash', $elm$json$Json$Decode$string));
                    }, A2($elm$json$Json$Decode$field, 'host', $elm$json$Json$Decode$string));
                  }, A2($elm$json$Json$Decode$field, 'hostname', $elm$json$Json$Decode$string));
                }, A2($elm$json$Json$Decode$field, 'href', $elm$json$Json$Decode$string));
              }, A2($elm$json$Json$Decode$field, 'origin', $elm$json$Json$Decode$string));
            }, A2($elm$json$Json$Decode$field, 'pathname', $elm$json$Json$Decode$string));
          }, A2($elm$json$Json$Decode$field, 'port_', $elm$json$Json$Decode$string));
        }, A2($elm$json$Json$Decode$field, 'protocol', $elm$json$Json$Decode$string));
      }, A2($elm$json$Json$Decode$field, 'search', $elm$json$Json$Decode$string))));
    }, A2($elm$json$Json$Decode$field, 'shouldReplace', $elm$json$Json$Decode$bool));
  }, A2($elm$json$Json$Decode$field, 'shouldSilent', $elm$json$Json$Decode$bool)));
  var $elm$json$Json$Decode$int = _Json_decodeInt;
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$popState = _Platform_incomingPort('popState', A2($elm$json$Json$Decode$andThen, function (stateIndex) {
    return A2($elm$json$Json$Decode$andThen, function (location) {
      return $elm$json$Json$Decode$succeed({
        iT: location,
        a5: stateIndex
      });
    }, A2($elm$json$Json$Decode$field, 'location', A2($elm$json$Json$Decode$andThen, function (search) {
      return A2($elm$json$Json$Decode$andThen, function (protocol) {
        return A2($elm$json$Json$Decode$andThen, function (port_) {
          return A2($elm$json$Json$Decode$andThen, function (pathname) {
            return A2($elm$json$Json$Decode$andThen, function (origin) {
              return A2($elm$json$Json$Decode$andThen, function (href) {
                return A2($elm$json$Json$Decode$andThen, function (hostname) {
                  return A2($elm$json$Json$Decode$andThen, function (host) {
                    return A2($elm$json$Json$Decode$andThen, function (hash) {
                      return $elm$json$Json$Decode$succeed({
                        ii: hash,
                        ik: host,
                        il: hostname,
                        im: href,
                        j_: origin,
                        j9: pathname,
                        kc: port_,
                        ke: protocol,
                        kH: search
                      });
                    }, A2($elm$json$Json$Decode$field, 'hash', $elm$json$Json$Decode$string));
                  }, A2($elm$json$Json$Decode$field, 'host', $elm$json$Json$Decode$string));
                }, A2($elm$json$Json$Decode$field, 'hostname', $elm$json$Json$Decode$string));
              }, A2($elm$json$Json$Decode$field, 'href', $elm$json$Json$Decode$string));
            }, A2($elm$json$Json$Decode$field, 'origin', $elm$json$Json$Decode$string));
          }, A2($elm$json$Json$Decode$field, 'pathname', $elm$json$Json$Decode$string));
        }, A2($elm$json$Json$Decode$field, 'port_', $elm$json$Json$Decode$string));
      }, A2($elm$json$Json$Decode$field, 'protocol', $elm$json$Json$Decode$string));
    }, A2($elm$json$Json$Decode$field, 'search', $elm$json$Json$Decode$string))));
  }, A2($elm$json$Json$Decode$field, 'stateIndex', $elm$json$Json$Decode$int)));
  var $author$project$ElmFramework$Feature$Navigation$RouteHistory$subscriptions = function (config) {
    return $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$popState(config.Av), $author$project$ElmFramework$Feature$Navigation$RouteHistory$hardwareNavBack($elm$core$Basics$always(config.wu)), $author$project$ElmFramework$Feature$Navigation$RouteHistory$hardwareNavForward($elm$core$Basics$always(config.wv)), $author$project$ElmFramework$Feature$Navigation$RouteHistory$navToLoopbackSub(config.yz)]));
  };
  var $author$project$ElmFramework$Feature$Navigation$Routing$subscriptions = $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$Navigation$RouteHistory$subscriptions({
    wu: $author$project$ElmFramework$Feature$Navigation$Msg$HardwareBack,
    wv: $author$project$ElmFramework$Feature$Navigation$Msg$HardwareForward,
    yz: $author$project$ElmFramework$Feature$Navigation$Msg$NavToFromLoopback,
    Av: $author$project$ElmFramework$Feature$Navigation$Msg$PopState
  }), $author$project$ElmFramework$Feature$Auth$Extra$authErrorLoopbackSub($elm$core$Basics$always($author$project$ElmFramework$Feature$Navigation$Msg$AuthError))]));
  var $ohanhi$keyboard$Keyboard$Down = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $ohanhi$keyboard$Keyboard$Up = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $ohanhi$keyboard$Keyboard$RawKey = $elm$core$Basics$identity;
  var $ohanhi$keyboard$Keyboard$eventKeyDecoder = A2($elm$json$Json$Decode$field, 'key', A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string));
  var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
  var $ohanhi$keyboard$Keyboard$downs = function (toMsg) {
    return $elm$browser$Browser$Events$onKeyDown(A2($elm$json$Json$Decode$map, toMsg, $ohanhi$keyboard$Keyboard$eventKeyDecoder));
  };
  var $elm$browser$Browser$Events$onKeyUp = A2($elm$browser$Browser$Events$on, 0, 'keyup');
  var $ohanhi$keyboard$Keyboard$ups = function (toMsg) {
    return $elm$browser$Browser$Events$onKeyUp(A2($elm$json$Json$Decode$map, toMsg, $ohanhi$keyboard$Keyboard$eventKeyDecoder));
  };
  var $ohanhi$keyboard$Keyboard$subscriptions = $elm$core$Platform$Sub$batch(_List_fromArray([$ohanhi$keyboard$Keyboard$downs($ohanhi$keyboard$Keyboard$Down), $ohanhi$keyboard$Keyboard$ups($ohanhi$keyboard$Keyboard$Up)]));
  var $elm$core$List$append = F2(function (xs, ys) {
    if (!ys.b) {
      return xs;
    } else {
      return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
    }
  });
  var $elm$core$List$concat = function (lists) {
    return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
  };
  var $ohanhi$keyboard$Keyboard$oneOf = F2(function (fns, key) {
    oneOf: while (true) {
      if (!fns.b) {
        return $elm$core$Maybe$Nothing;
      } else {
        var fn = fns.a;
        var rest = fns.b;
        var _v1 = fn(key);
        if (!_v1.$) {
          var a = _v1.a;
          return $elm$core$Maybe$Just(a);
        } else {
          var $temp$fns = rest,
            $temp$key = key;
          fns = $temp$fns;
          key = $temp$key;
          continue oneOf;
        }
      }
    }
  });
  var $ohanhi$keyboard$Keyboard$KeyDown = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $ohanhi$keyboard$Keyboard$KeyUp = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $ohanhi$keyboard$Keyboard$insert = F3(function (keyParser, rawKey, list) {
    var _v0 = keyParser(rawKey);
    if (!_v0.$) {
      var key = _v0.a;
      return A2($elm$core$List$cons, key, A2($elm$core$List$filter, $elm$core$Basics$neq(key), list));
    } else {
      return list;
    }
  });
  var $ohanhi$keyboard$Keyboard$remove = F3(function (keyParser, rawKey, list) {
    var _v0 = keyParser(rawKey);
    if (!_v0.$) {
      var key = _v0.a;
      return A2($elm$core$List$filter, $elm$core$Basics$neq(key), list);
    } else {
      return list;
    }
  });
  var $ohanhi$keyboard$Keyboard$updateWithKeyChange = F3(function (keyParser, msg, state) {
    if (!msg.$) {
      var key = msg.a;
      var nextState = A3($ohanhi$keyboard$Keyboard$insert, keyParser, key, state);
      var change = !_Utils_eq($elm$core$List$length(nextState), $elm$core$List$length(state)) ? A2($elm$core$Maybe$map, $ohanhi$keyboard$Keyboard$KeyDown, keyParser(key)) : $elm$core$Maybe$Nothing;
      return _Utils_Tuple2(nextState, change);
    } else {
      var key = msg.a;
      var nextState = A3($ohanhi$keyboard$Keyboard$remove, keyParser, key, state);
      var change = !_Utils_eq($elm$core$List$length(nextState), $elm$core$List$length(state)) ? A2($elm$core$Maybe$map, $ohanhi$keyboard$Keyboard$KeyUp, keyParser(key)) : $elm$core$Maybe$Nothing;
      return _Utils_Tuple2(nextState, change);
    }
  });
  var $author$project$ElmFramework$Lib$Keyboard$toMsg = F4(function (tag, keyboardHandlers, oldPressedKeys, theMsg) {
    var keyParser = $ohanhi$keyboard$Keyboard$oneOf(A2($elm$core$List$map, function ($) {
      return $.p9;
    }, keyboardHandlers));
    var _v0 = A3($ohanhi$keyboard$Keyboard$updateWithKeyChange, keyParser, theMsg, oldPressedKeys);
    var pressedKeys = _v0.a;
    var keyChange = _v0.b;
    var messages = $elm$core$List$concat(A2($elm$core$List$map, A2($elm$core$Basics$composeR, function ($) {
      return $.nr;
    }, function (handler) {
      return A2(handler, pressedKeys, keyChange);
    }), keyboardHandlers));
    return A2(tag, pressedKeys, messages);
  });
  var $elm$json$Json$Decode$index = _Json_decodeIndex;
  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$receivePushStatus = _Platform_incomingPort('receivePushStatus', A2($elm$json$Json$Decode$andThen, function (_v0) {
    return A2($elm$json$Json$Decode$andThen, function (_v1) {
      return A2($elm$json$Json$Decode$andThen, function (_v2) {
        return $elm$json$Json$Decode$succeed(_Utils_Tuple3(_v0, _v1, _v2));
      }, A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool)]))));
    }, A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)]))));
  }, A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$DisabledPushPermissions = {
    $: 2
  };
  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$EnabledPushPermissions = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$UnregisteredPushPermissions = {
    $: 1
  };
  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$UnsupportedPushPermissions = {
    $: 4
  };
  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$toPushStatusResult = function (_v0) {
    var status = _v0.a;
    var maybeToken = _v0.b;
    var isMaybeReq = _v0.c;
    var _v1 = _Utils_Tuple2(status, maybeToken);
    _v1$4: while (true) {
      switch (_v1.a) {
        case 'Unregistered':
          return $elm$core$Result$Ok($author$project$ElmFramework$Feature$PushMessages$PushMessages$UnregisteredPushPermissions);
        case 'Disabled':
          return $elm$core$Result$Ok($author$project$ElmFramework$Feature$PushMessages$PushMessages$DisabledPushPermissions);
        case 'Unsupported':
          return $elm$core$Result$Ok($author$project$ElmFramework$Feature$PushMessages$PushMessages$UnsupportedPushPermissions);
        case 'Enabled':
          if (!_v1.b.$) {
            var token = _v1.b.a;
            return $elm$core$Result$Ok(A2($author$project$ElmFramework$Feature$PushMessages$PushMessages$EnabledPushPermissions, token, A2($elm$core$Maybe$withDefault, false, isMaybeReq)));
          } else {
            break _v1$4;
          }
        default:
          break _v1$4;
      }
    }
    return $elm$core$Result$Err(status);
  };
  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$toReceivePushStatusSub = function (tag) {
    return $author$project$ElmFramework$Feature$PushMessages$PushMessages$receivePushStatus(A2($elm$core$Basics$composeL, tag, $author$project$ElmFramework$Feature$PushMessages$PushMessages$toPushStatusResult));
  };
  var $author$project$ElmFramework$Feature$Payments$Payments$userCouldNotProvidePaymentCard = _Platform_incomingPort('userCouldNotProvidePaymentCard', $elm$json$Json$Decode$null(0));
  var $author$project$ElmFramework$Feature$Platform$Platform$weAreOnline = _Platform_incomingPort('weAreOnline', $elm$json$Json$Decode$null(0));
  var $author$project$ElmFramework$Feature$Browser$Browser$windowResize = _Platform_incomingPort('windowResize', A2($elm$json$Json$Decode$andThen, function (width) {
    return A2($elm$json$Json$Decode$andThen, function (unitSize) {
      return A2($elm$json$Json$Decode$andThen, function (pixelRatio) {
        return A2($elm$json$Json$Decode$andThen, function (height) {
          return $elm$json$Json$Decode$succeed({
            ij: height,
            qs: pixelRatio,
            gO: unitSize,
            lt: width
          });
        }, A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int));
      }, A2($elm$json$Json$Decode$field, 'pixelRatio', $elm$json$Json$Decode$float));
    }, A2($elm$json$Json$Decode$field, 'unitSize', $elm$json$Json$Decode$int));
  }, A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int)));
  var $author$project$ElmFramework$Main$subscriptions = F2(function (config, state) {
    var keyboardHandlers = function () {
      var _v0 = _Utils_ap(config.xt(state), A2($author$project$ElmFramework$Main$escKeyboardHandler, config, state));
      if (!_v0.b) {
        return $elm$core$Platform$Sub$none;
      } else {
        var theKeyboardHandlers = _v0;
        return A2($elm$core$Platform$Sub$map, A3($author$project$ElmFramework$Lib$Keyboard$toMsg, $author$project$ElmFramework$Msg$KeyEvent, theKeyboardHandlers, state.qD), $ohanhi$keyboard$Keyboard$subscriptions);
      }
    }();
    return $elm$core$Platform$Sub$batch(_List_fromArray([config.Co(state), keyboardHandlers, $elm$browser$Browser$Events$onVisibilityChange($author$project$ElmFramework$Msg$VisibilityChange), $author$project$ElmFramework$Feature$Browser$Browser$windowResize($author$project$ElmFramework$Msg$WindowResize), A2($elm$time$Time$every, config.Cz, $author$project$ElmFramework$Msg$UpdateCurrTime), $author$project$ElmFramework$Feature$Geolocation$Geolocation$onReceiveLocationPermissions($author$project$ElmFramework$Msg$ReceiveDetailedGeolocationPermissions), $author$project$ElmFramework$Feature$Geolocation$Geolocation$onReceiveGeolocation($author$project$ElmFramework$Msg$ReceiveGeolocation), $author$project$ElmFramework$Feature$PushMessages$PushMessages$toReceivePushStatusSub($author$project$ElmFramework$Msg$PushNotificationsPermissionsStatus), $author$project$ElmFramework$Feature$Payments$Payments$userCouldNotProvidePaymentCard($elm$core$Basics$always($author$project$ElmFramework$Msg$UserCouldNotProvidePaymentCard)), $author$project$ElmFramework$Feature$Pwa$Pwa$receiveBeforeInstallPromptEvent($elm$core$Basics$always($author$project$ElmFramework$Msg$ReceiveBeforeInstallPromptEvent)), $author$project$ElmFramework$Feature$Pwa$Pwa$installPwaResult($author$project$ElmFramework$Msg$ReceiveInstallPwaResult), $author$project$ElmFramework$Feature$Pwa$Pwa$appUpdated($elm$core$Basics$always($author$project$ElmFramework$Msg$AppUpdated)), $author$project$ElmFramework$Feature$Platform$Platform$appLoaded($elm$core$Basics$always($author$project$ElmFramework$Msg$AppLoaded)), $author$project$ElmFramework$Feature$Platform$Platform$weAreOnline($elm$core$Basics$always($author$project$ElmFramework$Msg$WeAreOnline)), $author$project$ElmFramework$Feature$Platform$Platform$listenLifeCycleEvents($author$project$ElmFramework$Msg$LifeCycleEvent), $author$project$ElmFramework$Feature$PushMessages$PushMessages$receivePushMsg($author$project$ElmFramework$Msg$OnPushMessage), $author$project$ElmFramework$Feature$Toaster$Notifier$receiveNotifs({
      dZ: $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastErr($elm$core$Maybe$Nothing),
      wL: $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastInfo($elm$core$Maybe$Nothing),
      eP: $author$project$ElmFramework$Feature$Toaster$MsgToasts$toastSuccess($elm$core$Maybe$Nothing)
    }), A2($elm$core$Platform$Sub$map, $author$project$ElmFramework$Msg$SocialAuthMsg, $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$socialAuthEventsSubscriptions), A2($elm$core$Platform$Sub$map, $author$project$ElmFramework$Msg$RoutingMsg, $author$project$ElmFramework$Feature$Navigation$Routing$subscriptions)]));
  });
  var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
  var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
  var $author$project$ElmFramework$View$topBarOffset = function (isHybridIos) {
    return isHybridIos ? 20 : 0;
  };
  var $author$project$ElmFramework$Feature$Toaster$Toaster$Tap = {
    $: 3
  };
  var $author$project$ElmFramework$Feature$Toaster$Toaster$hiddenToastsHeight = F2(function (toasts, visibleToasts) {
    return A3($author$project$ElmFramework$Feature$Toaster$Toaster$toastsHeight, toasts, 0, $elm$core$Array$length(toasts) - visibleToasts);
  });
  var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
    return _VirtualDom_keyedNode(_VirtualDom_noScript(tag));
  };
  var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
  var $elm$virtual_dom$VirtualDom$Normal = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $elm$html$Html$Events$on = F2(function (event, decoder) {
    return A2($elm$virtual_dom$VirtualDom$on, event, $elm$virtual_dom$VirtualDom$Normal(decoder));
  });
  var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
  var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
  var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
  var $elm$core$Array$indexedMap = F2(function (func, _v0) {
    var len = _v0.a;
    var tree = _v0.c;
    var tail = _v0.d;
    var initialBuilder = {
      D: _List_Nil,
      y: 0,
      C: A3($elm$core$Elm$JsArray$indexedMap, func, $elm$core$Array$tailIndex(len), tail)
    };
    var helper = F2(function (node, builder) {
      if (!node.$) {
        var subTree = node.a;
        return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
      } else {
        var leaf = node.a;
        var offset = builder.y * $elm$core$Array$branchFactor;
        var mappedLeaf = $elm$core$Array$Leaf(A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
        return {
          D: A2($elm$core$List$cons, mappedLeaf, builder.D),
          y: builder.y + 1,
          C: builder.C
        };
      }
    });
    return A2($elm$core$Array$builderToArray, true, A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
  });
  var $author$project$ElmFramework$Feature$Toaster$Toaster$ReceiveToastHeight = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Lib$Ui$EventFull$eventFull = F2(function (eventHandlers, attrs) {
    var toAttrs = function (_v0) {
      var eventEmitterAttributes = _v0;
      return eventEmitterAttributes;
    };
    var normalizedHandlers = $elm$core$List$concat(A2($elm$core$List$map, toAttrs, eventHandlers));
    var defaultAttrs = _List_fromArray([$elm$html$Html$Attributes$class('block')]);
    return A2($elm$html$Html$node, 'event-full', _Utils_ap(defaultAttrs, _Utils_ap(normalizedHandlers, attrs)));
  });
  var $author$project$ElmFramework$Lib$Ui$EventFull$EventEmitter = $elm$core$Basics$identity;
  var $author$project$ElmFramework$Lib$Ui$EventFull$Size = F4(function (width, height, contentWidth, contentHeight) {
    return {
      uM: contentHeight,
      uN: contentWidth,
      ij: height,
      lt: width
    };
  });
  var $elm$json$Json$Decode$map4 = _Json_map4;
  var $author$project$ElmFramework$Lib$Util$preventer = function (decoder) {
    return A2($elm$json$Json$Decode$map, function (msg) {
      return {
        f0: msg,
        kd: true,
        k8: true
      };
    }, decoder);
  };
  var $author$project$ElmFramework$Lib$Util$onLocal = F2(function (eventName, decoder) {
    return A2($elm$html$Html$Events$custom, eventName, $author$project$ElmFramework$Lib$Util$preventer(decoder));
  });
  var $author$project$ElmFramework$Lib$Ui$EventFull$onSizeEmitter = function (tag) {
    return A2($author$project$ElmFramework$Lib$Util$onLocal, 'onSize', A2($elm$json$Json$Decode$map, tag, A2($elm$json$Json$Decode$field, 'detail', A5($elm$json$Json$Decode$map4, $author$project$ElmFramework$Lib$Ui$EventFull$Size, A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$field, 'contentWidth', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$field, 'contentHeight', $elm$json$Json$Decode$int)))));
  };
  var $author$project$ElmFramework$Lib$Ui$EventFull$onFirstChildSize = function (tag) {
    return _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'emit-first-child-size', 'true'), $author$project$ElmFramework$Lib$Ui$EventFull$onSizeEmitter(tag)]);
  };
  var $author$project$ElmFramework$Feature$Toaster$Toaster$toastView = F4(function (idx, _v0, isHidden, topBarOffset) {
    var shade = _v0.rH;
    var content = _v0.fn;
    var background = _v0.l$;
    var moveOver = isHidden ? topBarOffset : 0;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('aToast'), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('outOfSight', isHidden)])), A2($elm$html$Html$Attributes$style, 'transform', 'translateY(-' + ($elm$core$String$fromInt(moveOver) + 'px)'))]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative'), A2($elm$html$Html$Attributes$style, 'margin-top', '-' + ($elm$core$String$fromInt(topBarOffset) + 'px'))]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$style, 'height', $elm$core$String$fromInt(topBarOffset) + 'px')]), _List_Nil), background, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('shade absoluteSpread')]), _List_fromArray([shade])), A3($author$project$ElmFramework$Lib$Ui$EventFull$eventFull, _List_fromArray([$author$project$ElmFramework$Lib$Ui$EventFull$onFirstChildSize($author$project$ElmFramework$Feature$Toaster$Toaster$ReceiveToastHeight(idx))]), _List_fromArray([$elm$html$Html$Attributes$class('relative')]), _List_fromArray([content]))]))]));
  });
  var $author$project$ElmFramework$Feature$Toaster$Toaster$toKeyedToasts = F3(function (toasts, visibleToasts, topBarOffset) {
    var oldestVisibleToastIndex = $elm$core$Array$length(toasts) - visibleToasts;
    var foldToKeyed = F2(function (_v1, keyedList) {
      var toastIndex = _v1.a;
      var toast = _v1.b;
      return A2($elm$core$List$cons, _Utils_Tuple2($elm$core$String$fromInt(toastIndex), A4($author$project$ElmFramework$Feature$Toaster$Toaster$toastView, toastIndex, toast, _Utils_cmp(toastIndex, oldestVisibleToastIndex) < 0, topBarOffset)), keyedList);
    });
    return $elm$core$List$reverse(A3($elm$core$Array$foldl, foldToKeyed, _List_Nil, A2($elm$core$Array$indexedMap, F2(function (idx, _v0) {
      var toast = _v0.a;
      return _Utils_Tuple2(idx, toast);
    }), toasts)));
  });
  var $author$project$ElmFramework$Feature$Toaster$Toaster$view = F2(function (_v0, topBarOffset) {
    var toasts = _v0.aQ;
    var visibleToasts = _v0.O;
    var offset = A2($author$project$ElmFramework$Feature$Toaster$Toaster$hiddenToastsHeight, toasts, visibleToasts);
    return A3($elm$html$Html$node, 'toaster', _List_fromArray([$elm$html$Html$Attributes$class('absolute right0 left0 z10'), A2($elm$html$Html$Attributes$style, 'top', $elm$core$String$fromInt(topBarOffset) + 'px'), A2($elm$html$Html$Events$on, 'mousedown', $elm$json$Json$Decode$succeed($author$project$ElmFramework$Feature$Toaster$Toaster$Tap))]), _List_fromArray([A3($elm$html$Html$Keyed$node, 'div', _List_fromArray([$elm$html$Html$Attributes$class('toastsSlidingWrap relative'), A2($elm$html$Html$Attributes$style, 'transform', 'translateY(-' + ($elm$core$String$fromInt(offset) + 'px)'))]), A3($author$project$ElmFramework$Feature$Toaster$Toaster$toKeyedToasts, toasts, visibleToasts, topBarOffset))]));
  });
  var $author$project$ElmFramework$View$view = F2(function (config, state) {
    return A3($elm$html$Html$node, 'elm-framework', _List_Nil, _List_fromArray([config.Dl(state), A2($elm$html$Html$map, $author$project$ElmFramework$Msg$ToasterMsg, A2($author$project$ElmFramework$Feature$Toaster$Toaster$view, state.CR, $author$project$ElmFramework$View$topBarOffset(state.vS.fP)))]));
  });
  var $author$project$ElmFramework$Main$app = function (config) {
    return $elm$browser$Browser$element({
      wM: $author$project$ElmFramework$Main$init(config),
      Co: $author$project$ElmFramework$Main$subscriptions(config),
      C5: $author$project$ElmFramework$Update$update(config),
      Dl: $author$project$ElmFramework$View$view(config)
    });
  };
  var $author$project$Msg$AuthMsg = function (a) {
    return {
      $: 5,
      a: a
    };
  };
  var $author$project$Model$Geo$GpsTypeGeolocation = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$Auth$UserSession$Msg$ReceivePushPermissionsStatus = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $author$project$Ui$Auth$Msg$ReceiveSocialAuthEvent = function (a) {
    return {
      $: 25,
      a: a
    };
  };
  var $author$project$Remote$RequestMsg$RefreshToken = {
    $: 44
  };
  var $author$project$Msg$UserSessionMsg = function (a) {
    return {
      $: 24,
      a: a
    };
  };
  var $author$project$Ui$Matchmaking$Single$Msg$ReceivedGeolocation = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Ui$OnboardUser$Msg$ReceivedGeolocation = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$Matchmaking$Msg$SingleMsgReceived = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Msg$MatchmakingMsg = function (a) {
    return {
      $: 14,
      a: a
    };
  };
  var $author$project$TopMsg$msgMatchmaking = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$MatchmakingMsg);
  var $author$project$TopMsg$msgMatchmakingSingle = A2($elm$core$Basics$composeL, $author$project$TopMsg$msgMatchmaking, $author$project$Ui$Matchmaking$Msg$SingleMsgReceived);
  var $author$project$Msg$OnboardUserMsg = function (a) {
    return {
      $: 6,
      a: a
    };
  };
  var $author$project$TopMsg$msgOnboardUser = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$OnboardUserMsg);
  var $author$project$MainModule$explicitlyRequestedGeolocation = F2(function (route, geolocation) {
    var _v0 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(route);
    switch (_v0.$) {
      case 16:
        return _List_fromArray([$author$project$TopMsg$msgOnboardUser($author$project$Ui$OnboardUser$Msg$ReceivedGeolocation(geolocation))]);
      case 18:
        return _List_fromArray([$author$project$TopMsg$msgMatchmakingSingle($author$project$Ui$Matchmaking$Single$Msg$ReceivedGeolocation(geolocation))]);
      default:
        return _List_Nil;
    }
  });
  var $author$project$Msg$GlobalMsg = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $author$project$Msg$RemoteRequestMsg = function (a) {
    return {
      $: 11,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Tracking$Msg$RequestTrackingPermissions = 0;
  var $author$project$Types$EditingUserProfile$empty = {
    bZ: '',
    nF: '',
    nM: $elm$core$Maybe$Nothing,
    oU: '',
    iT: $elm$core$Maybe$Nothing,
    qo: '',
    qq: $elm$core$Maybe$Nothing,
    gj: 30
  };
  var $author$project$Global$Model$FromPersistence = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$Util$T4 = F4(function (a, b, c, d) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $elm$core$Maybe$andThen = F2(function (callback, maybeValue) {
    if (!maybeValue.$) {
      var value = maybeValue.a;
      return callback(value);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $elm$json$Json$Decode$decodeString = _Json_runOnString;
  var $author$project$ElmFramework$Lib$Util$decodeString = F2(function (decoder, string) {
    return A2($elm$core$Result$mapError, $elm$json$Json$Decode$errorToString, A2($elm$json$Json$Decode$decodeString, decoder, string));
  });
  var $author$project$Language$LanguageDetails = F5(function (longName, shortName, countryFlagEmoji, longNameNative, countryShortName) {
    return {
      hy: countryFlagEmoji,
      hz: countryShortName,
      xW: longName,
      iV: longNameNative,
      BW: shortName
    };
  });
  var $elm$json$Json$Decode$map5 = _Json_map5;
  var $author$project$Model$CommonStaticFile$languageDetailsDecoder = A6($elm$json$Json$Decode$map5, $author$project$Language$LanguageDetails, A2($elm$json$Json$Decode$field, 'longName', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'shortName', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'countryFlagEmoji', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'longNameNative', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'countryShortName', $elm$json$Json$Decode$string));
  var $author$project$Model$CommonStaticFile$decodeJustTheLanguage = $author$project$ElmFramework$Lib$Util$decodeString(A2($elm$json$Json$Decode$field, 'language', $author$project$Model$CommonStaticFile$languageDetailsDecoder));
  var $author$project$Persistence$setCommonStaticFile = _Platform_outgoingPort('setCommonStaticFile', $elm$json$Json$Encode$string);
  var $elm$core$Result$toMaybe = function (result) {
    if (!result.$) {
      var v = result.a;
      return $elm$core$Maybe$Just(v);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };
  var $author$project$Global$Global$decideCurrLanguage = F2(function (maybePreFetchedCommonStaticFile, maybePersistedCommonStaticFile) {
    var decodeLang = function (maybeString) {
      return A2($elm$core$Maybe$andThen, $elm$core$Result$toMaybe, A2($elm$core$Maybe$map, $author$project$Model$CommonStaticFile$decodeJustTheLanguage, maybeString));
    };
    var _v0 = A4($author$project$ElmFramework$Lib$Util$T4, decodeLang(maybePreFetchedCommonStaticFile), decodeLang(maybePersistedCommonStaticFile), maybePreFetchedCommonStaticFile, maybePersistedCommonStaticFile);
    _v0$3: while (true) {
      if (!_v0.c.$) {
        if (!_v0.a.$ && !_v0.b.$) {
          var preFetchedLang = _v0.a.a;
          var persistedLang = _v0.b.a;
          var preFetchedFile = _v0.c.a;
          return _Utils_eq(preFetchedLang.xW, persistedLang.xW) ? _Utils_Tuple2(maybePreFetchedCommonStaticFile, _Utils_eq(maybePersistedCommonStaticFile, maybePreFetchedCommonStaticFile) ? $elm$core$Platform$Cmd$none : $author$project$Persistence$setCommonStaticFile(preFetchedFile)) : _Utils_Tuple2(maybePersistedCommonStaticFile, $elm$core$Platform$Cmd$none);
        } else {
          if (_v0.d.$ === 1) {
            var preFetchedFile = _v0.c.a;
            var _v1 = _v0.d;
            return _Utils_Tuple2(maybePreFetchedCommonStaticFile, $author$project$Persistence$setCommonStaticFile(preFetchedFile));
          } else {
            break _v0$3;
          }
        }
      } else {
        if (!_v0.d.$) {
          var _v2 = _v0.c;
          return _Utils_Tuple2(maybePersistedCommonStaticFile, $elm$core$Platform$Cmd$none);
        } else {
          break _v0$3;
        }
      }
    }
    return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
  });
  var $author$project$Language$authDefault = {
    g7: '______________',
    g8: '______________',
    hl: '______________',
    hm: '______________',
    hv: 'Account registered successfully, you can now login into app',
    hw: '______________',
    h$: 'Facebook',
    h6: 'Forgot Password?',
    h7: '______________',
    ia: '______________',
    ib: '______________',
    ie: 'Google',
    $9: 'I\'ve read and I accept the ',
    io: 'Terms & Policies',
    i6: 'New password',
    kl: 'Register',
    km: '[ I\'m New ]',
    kn: 'Enter your details',
    kp: 'Let\'s get productive',
    kq: 'Register',
    ks: '______________',
    kt: '______________',
    ku: '______________',
    kw: '______________',
    kS: '______________',
    kT: '[ I have a Profile ]',
    kU: 'Enter your details',
    kV: 'Welcome back',
    kW: 'Sign In',
    kX: '______________',
    kY: '______________',
    lj: 'Twitter'
  };
  var $author$project$Language$baseDefault = {
    hu: 'Confirm',
    hO: 'Email',
    hQ: 'Let us notify you when relevant information occurs',
    hR: 'Enable Notifications',
    h5: 'First name',
    iJ: 'Last name',
    j8: 'Password',
    k9: 'Submit'
  };
  var $author$project$Language$calendarDefault = {
    g0: 'April',
    g1: 'Apr',
    g4: 'August',
    g5: 'Aug',
    hG: 'December',
    hH: 'Dec',
    h1: 'February',
    h2: 'Feb',
    iA: 'January',
    iB: 'Jan',
    iF: 'July',
    iG: 'Jul',
    iH: 'June',
    iI: 'Jun',
    iX: 'March',
    iY: 'Mar',
    i$: 'May',
    i0: 'May',
    ja: 'November',
    jb: 'Nov',
    jd: 'October',
    je: 'Oct',
    kL: 'September',
    kM: 'Sep'
  };
  var $author$project$Language$chatDefault = {
    ka: 'This person does not accept messages',
    ki: '{{name}} sent an image'
  };
  var $author$project$Language$defaultPhrases = {
    bN: $author$project$Language$authDefault,
    hb: $author$project$Language$baseDefault,
    hd: $author$project$Language$calendarDefault,
    hk: $author$project$Language$chatDefault
  };
  var $turboMaCk$any_dict$Dict$Any$AnyDict = $elm$core$Basics$identity;
  var $turboMaCk$any_dict$Dict$Any$empty = function (toKey) {
    return {
      B: $elm$core$Dict$empty,
      a8: toKey
    };
  };
  var $author$project$Model$CommonStaticFile$LanguageDetailsWithCommonStaticFile = F2(function (language, commonStatic) {
    return {
      uB: commonStatic,
      ac: language
    };
  });
  var $author$project$Language$AuthPhrases = function (signInHeadTitle) {
    return function (signInHeadSubtitle) {
      return function (signInContentTitle) {
        return function (registerHeadTitle) {
          return function (registerHeadSubtitle) {
            return function (registerContentTitle) {
              return function (registerBtnLabel) {
                return function (registerBtnLabelDescription) {
                  return function (iAcceptTheTermsOfUse1) {
                    return function (iAcceptTheTermsOfUse2) {
                      return function (authSuccessTitle) {
                        return function (authSuccessSubtitle) {
                          return function (forgotPasswordTitle) {
                            return function (forgotPasswordSubtitle) {
                              return function (forgotPasswordProvideCode) {
                                return function (forgotPassworQuestiondBtnLabel) {
                                  return function (newPasswordInputLabel) {
                                    return function (registrationVerificationTitle) {
                                      return function (registrationVerificationLine1) {
                                        return function (registrationVerificationLine2) {
                                          return function (chooseSignInMethodTitle) {
                                            return function (chooseSignInMethodSubtitle) {
                                              return function (signUpToContinue) {
                                                return function (signUpToContinueReason) {
                                                  return function (confirmationCodeInputLabel) {
                                                    return function (resendConfirmationCodeBtnLabel) {
                                                      return function (confirmRegistrationSuccessMsg) {
                                                        return function (signInBtnLabel) {
                                                          return function (signInBtnLabelExplanation) {
                                                            return function (facebook) {
                                                              return function (google) {
                                                                return function (twitter) {
                                                                  return {
                                                                    g7: authSuccessSubtitle,
                                                                    g8: authSuccessTitle,
                                                                    hl: chooseSignInMethodSubtitle,
                                                                    hm: chooseSignInMethodTitle,
                                                                    hv: confirmRegistrationSuccessMsg,
                                                                    hw: confirmationCodeInputLabel,
                                                                    h$: facebook,
                                                                    h6: forgotPassworQuestiondBtnLabel,
                                                                    h7: forgotPasswordProvideCode,
                                                                    ia: forgotPasswordSubtitle,
                                                                    ib: forgotPasswordTitle,
                                                                    ie: google,
                                                                    $9: iAcceptTheTermsOfUse1,
                                                                    io: iAcceptTheTermsOfUse2,
                                                                    i6: newPasswordInputLabel,
                                                                    kl: registerBtnLabel,
                                                                    km: registerBtnLabelDescription,
                                                                    kn: registerContentTitle,
                                                                    kp: registerHeadSubtitle,
                                                                    kq: registerHeadTitle,
                                                                    ks: registrationVerificationLine1,
                                                                    kt: registrationVerificationLine2,
                                                                    ku: registrationVerificationTitle,
                                                                    kw: resendConfirmationCodeBtnLabel,
                                                                    kS: signInBtnLabel,
                                                                    kT: signInBtnLabelExplanation,
                                                                    kU: signInContentTitle,
                                                                    kV: signInHeadSubtitle,
                                                                    kW: signInHeadTitle,
                                                                    kX: signUpToContinue,
                                                                    kY: signUpToContinueReason,
                                                                    lj: twitter
                                                                  };
                                                                };
                                                              };
                                                            };
                                                          };
                                                        };
                                                      };
                                                    };
                                                  };
                                                };
                                              };
                                            };
                                          };
                                        };
                                      };
                                    };
                                  };
                                };
                              };
                            };
                          };
                        };
                      };
                    };
                  };
                };
              };
            };
          };
        };
      };
    };
  };
  var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
  var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(function (pathDecoder, valDecoder, fallback) {
    var nullOr = function (decoder) {
      return $elm$json$Json$Decode$oneOf(_List_fromArray([decoder, $elm$json$Json$Decode$null(fallback)]));
    };
    var handleResult = function (input) {
      var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
      if (!_v0.$) {
        var rawValue = _v0.a;
        var _v1 = A2($elm$json$Json$Decode$decodeValue, nullOr(valDecoder), rawValue);
        if (!_v1.$) {
          var finalResult = _v1.a;
          return $elm$json$Json$Decode$succeed(finalResult);
        } else {
          var finalErr = _v1.a;
          return $elm$json$Json$Decode$fail($elm$json$Json$Decode$errorToString(finalErr));
        }
      } else {
        return $elm$json$Json$Decode$succeed(fallback);
      }
    };
    return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
  });
  var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(function (key, valDecoder, fallback, decoder) {
    return A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder, A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value), valDecoder, fallback), decoder);
  });
  var $author$project$Language$authDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'twitter', $elm$json$Json$Decode$string, $author$project$Language$authDefault.lj, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'google', $elm$json$Json$Decode$string, $author$project$Language$authDefault.ie, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'facebook', $elm$json$Json$Decode$string, $author$project$Language$authDefault.h$, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'signInBtnLabelExplanation', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kT, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'signInBtnLabel', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kS, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'resendConfirmationCodeBtnLabel', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kw, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'confirmRegistrationSuccessMsg', $elm$json$Json$Decode$string, $author$project$Language$authDefault.hv, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'confirmationCodeInputLabel', $elm$json$Json$Decode$string, $author$project$Language$authDefault.hw, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'signUpToContinueReason', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kY, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'signUpToContinue', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kX, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'chooseSignInMethodSubtitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.hl, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'chooseSignInMethodTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.hm, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registrationVerificationLine2', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kt, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registrationVerificationLine1', $elm$json$Json$Decode$string, $author$project$Language$authDefault.ks, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registrationVerificationTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.ku, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'newPasswordInputLabel', $elm$json$Json$Decode$string, $author$project$Language$authDefault.i6, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'forgotPasswordBtnLabel', $elm$json$Json$Decode$string, $author$project$Language$authDefault.h6, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'forgotPasswordProvideCode', $elm$json$Json$Decode$string, $author$project$Language$authDefault.h7, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'forgotPasswordSubtitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.ia, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'forgotPasswordTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.ib, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'authSuccessSubtitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.g7, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'authSuccessTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.g8, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'iAcceptTheTermsOfUse2', $elm$json$Json$Decode$string, $author$project$Language$authDefault.io, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'iAcceptTheTermsOfUse1', $elm$json$Json$Decode$string, $author$project$Language$authDefault.$9, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registerBtnLabelDescription', $elm$json$Json$Decode$string, $author$project$Language$authDefault.km, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registerBtnLabel', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kl, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registerContentTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kn, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registerHeadSubtitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kp, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registerHeadTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kq, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'signInContentTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kU, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'signInHeadSubtitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kV, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'signInHeadTitle', $elm$json$Json$Decode$string, $author$project$Language$authDefault.kW, $elm$json$Json$Decode$succeed($author$project$Language$AuthPhrases)))))))))))))))))))))))))))))))));
  var $author$project$Language$BasePhrases = F8(function (emailInputLabel, passwordInputLabel, submitBtnLabel, confirmBtnLabel, enablePushNotificationsLabel, enablePushNotificationsDescription, firstNameInputLabel, lastNameInputLabel) {
    return {
      hu: confirmBtnLabel,
      hO: emailInputLabel,
      hQ: enablePushNotificationsDescription,
      hR: enablePushNotificationsLabel,
      h5: firstNameInputLabel,
      iJ: lastNameInputLabel,
      j8: passwordInputLabel,
      k9: submitBtnLabel
    };
  });
  var $author$project$Language$baseDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'lastNameInputLabel', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.iJ, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'firstNameInputLabel', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.h5, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'enablePushNotificationsDescription', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.hQ, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'enablePushNotificationsLabel', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.hR, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'confirmBtnLabel', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.hu, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'submitBtnLabel', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.k9, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'passwordInputLabel', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.j8, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'emailInputLabel', $elm$json$Json$Decode$string, $author$project$Language$baseDefault.hO, $elm$json$Json$Decode$succeed($author$project$Language$BasePhrases)))))))));
  var $author$project$Language$CalendarPhrases = function (january) {
    return function (february) {
      return function (march) {
        return function (april) {
          return function (may) {
            return function (june) {
              return function (july) {
                return function (august) {
                  return function (september) {
                    return function (october) {
                      return function (november) {
                        return function (december) {
                          return function (january_short) {
                            return function (february_short) {
                              return function (march_short) {
                                return function (april_short) {
                                  return function (may_short) {
                                    return function (june_short) {
                                      return function (july_short) {
                                        return function (august_short) {
                                          return function (september_short) {
                                            return function (october_short) {
                                              return function (november_short) {
                                                return function (december_short) {
                                                  return {
                                                    g0: april,
                                                    g1: april_short,
                                                    g4: august,
                                                    g5: august_short,
                                                    hG: december,
                                                    hH: december_short,
                                                    h1: february,
                                                    h2: february_short,
                                                    iA: january,
                                                    iB: january_short,
                                                    iF: july,
                                                    iG: july_short,
                                                    iH: june,
                                                    iI: june_short,
                                                    iX: march,
                                                    iY: march_short,
                                                    i$: may,
                                                    i0: may_short,
                                                    ja: november,
                                                    jb: november_short,
                                                    jd: october,
                                                    je: october_short,
                                                    kL: september,
                                                    kM: september_short
                                                  };
                                                };
                                              };
                                            };
                                          };
                                        };
                                      };
                                    };
                                  };
                                };
                              };
                            };
                          };
                        };
                      };
                    };
                  };
                };
              };
            };
          };
        };
      };
    };
  };
  var $author$project$Language$calendarDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'december_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.hH, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'november_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.jb, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'october_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.je, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'september_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.kM, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'august_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.g5, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'july_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.iG, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'june_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.iI, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'may_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.i0, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'april_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.g1, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'march_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.iY, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'february_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.h2, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'january_short', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.iB, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'december', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.hG, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'november', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.ja, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'october', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.jd, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'september', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.kL, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'august', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.g4, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'july', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.iF, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'june', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.iH, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'may', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.i$, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'april', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.g0, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'march', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.iX, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'february', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.h1, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'january', $elm$json$Json$Decode$string, $author$project$Language$calendarDefault.iA, $elm$json$Json$Decode$succeed($author$project$Language$CalendarPhrases)))))))))))))))))))))))));
  var $author$project$Language$ChatPhrases = F2(function (receivedImage, personDoesNotAcceptMessages) {
    return {
      ka: personDoesNotAcceptMessages,
      ki: receivedImage
    };
  });
  var $author$project$Language$chatDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'personDoesNotAcceptMessages', $elm$json$Json$Decode$string, $author$project$Language$chatDefault.ka, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'receivedImage', $elm$json$Json$Decode$string, $author$project$Language$chatDefault.ki, $elm$json$Json$Decode$succeed($author$project$Language$ChatPhrases)));
  var $elm$core$Result$withDefault = F2(function (def, result) {
    if (!result.$) {
      var a = result.a;
      return a;
    } else {
      return def;
    }
  });
  var $author$project$Language$decodePhrasesGroup = F3(function (_default, decoder, commonFileStaticJsonString) {
    return A2($elm$core$Result$withDefault, _default, A2($author$project$ElmFramework$Lib$Util$decodeString, A2($elm$json$Json$Decode$field, 'phrases', decoder), commonFileStaticJsonString));
  });
  var $author$project$Language$toPhrases = function (staticFileJsonString) {
    return {
      bN: A3($author$project$Language$decodePhrasesGroup, $author$project$Language$authDefault, $author$project$Language$authDecoder, staticFileJsonString),
      hb: A3($author$project$Language$decodePhrasesGroup, $author$project$Language$baseDefault, $author$project$Language$baseDecoder, staticFileJsonString),
      hd: A3($author$project$Language$decodePhrasesGroup, $author$project$Language$calendarDefault, $author$project$Language$calendarDecoder, staticFileJsonString),
      hk: A3($author$project$Language$decodePhrasesGroup, $author$project$Language$chatDefault, $author$project$Language$chatDecoder, staticFileJsonString)
    };
  };
  var $author$project$Model$CommonStaticFile$decodeCommonStatic = function (staticJsonString) {
    return $elm$core$Result$Ok({
      Ar: $author$project$Language$toPhrases(staticJsonString),
      Cc: staticJsonString
    });
  };
  var $author$project$ElmFramework$Lib$Util$resultToDecoder = function (res) {
    if (!res.$) {
      var decoded = res.a;
      return $elm$json$Json$Decode$succeed(decoded);
    } else {
      var err = res.a;
      return $elm$json$Json$Decode$fail(err);
    }
  };
  var $author$project$Model$CommonStaticFile$persistedCommonStaticDecoder = A3($elm$json$Json$Decode$map2, $author$project$Model$CommonStaticFile$LanguageDetailsWithCommonStaticFile, A2($elm$json$Json$Decode$field, 'language', $author$project$Model$CommonStaticFile$languageDetailsDecoder), A2($elm$json$Json$Decode$andThen, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Lib$Util$resultToDecoder, $author$project$Model$CommonStaticFile$decodeCommonStatic), A2($elm$json$Json$Decode$field, 'commonStaticFile', $elm$json$Json$Decode$string)));
  var $author$project$Model$CommonStaticFile$decodePersistedCommonStatic = function (string) {
    return A2($author$project$ElmFramework$Lib$Util$decodeString, $author$project$Model$CommonStaticFile$persistedCommonStaticDecoder, string);
  };
  var $author$project$Language$defaultLanguage = {
    hy: '🇬🇧',
    hz: 'GB',
    xW: 'English',
    iV: 'English',
    BW: 'en'
  };
  var $elm$core$Result$map = F2(function (func, ra) {
    if (!ra.$) {
      var a = ra.a;
      return $elm$core$Result$Ok(func(a));
    } else {
      var e = ra.a;
      return $elm$core$Result$Err(e);
    }
  });
  var $author$project$Model$CommonStaticFile$toCommonStaticTuple = function (val) {
    return A2($elm$core$Result$withDefault, _Utils_Tuple2($author$project$Language$defaultLanguage, $author$project$Language$defaultPhrases), A2($elm$core$Result$map, function (_v0) {
      var language = _v0.ac;
      var commonStatic = _v0.uB;
      return _Utils_Tuple2(language, commonStatic.Ar);
    }, $author$project$Model$CommonStaticFile$decodePersistedCommonStatic(val)));
  };
  var $author$project$Model$ProgramArgs$ApiEndpoint = $elm$core$Basics$identity;
  var $author$project$Model$ProgramArgs$toConfig = function (configArgs) {
    return {
      ts: configArgs.ts,
      tv: configArgs.tv,
      tx: configArgs.tx,
      v9: configArgs.v9,
      wf: {
        Y: configArgs.wf.Y
      },
      wq: configArgs.wq,
      AB: configArgs.AB,
      Cx: configArgs.Cx
    };
  };
  var $author$project$Types$User$unwrapUserId = function (_v0) {
    var id = _v0;
    return id;
  };
  var $author$project$Global$Global$init = function (_v0) {
    var appArgs = _v0.tt;
    var theConfig = $author$project$Model$ProgramArgs$toConfig(appArgs.uF);
    var _v1 = function () {
      var _v2 = A2($author$project$Global$Global$decideCurrLanguage, appArgs.Ax, appArgs.Ap);
      var maybeChosenStaticFile = _v2.a;
      var persistCmd = _v2.b;
      return function (record) {
        return _Utils_Tuple2(record, persistCmd);
      }(A2($elm$core$Maybe$withDefault, {
        ac: $elm$core$Maybe$Nothing,
        Ar: $author$project$Language$defaultPhrases
      }, A2($elm$core$Maybe$map, function (_v3) {
        var lan = _v3.a;
        var thePhrases = _v3.b;
        return {
          ac: $elm$core$Maybe$Just($author$project$Global$Model$FromPersistence(lan)),
          Ar: thePhrases
        };
      }, A2($elm$core$Maybe$map, $author$project$Model$CommonStaticFile$toCommonStaticTuple, maybeChosenStaticFile))));
    }();
    var language = _v1.a.ac;
    var phrases = _v1.a.Ar;
    var persistCommonStaticCmd = _v1.b;
    return _Utils_Tuple2({
      dt: $elm$core$Maybe$Nothing,
      ar: theConfig,
      hD: language,
      iy: $elm$core$Maybe$Nothing,
      xv: _List_fromArray([{
        hy: '🇪🇸',
        hz: 'ES',
        xW: 'Spanish',
        iV: 'Español',
        BW: 'es'
      }, {
        hy: '🇬🇧',
        hz: 'GB',
        xW: 'English',
        iV: 'English',
        BW: 'en'
      }, {
        hy: '🇲🇰',
        hz: 'MK',
        xW: 'Macedonian',
        iV: 'Македонски',
        BW: 'mk'
      }]),
      yl: $elm$core$Maybe$Nothing,
      Ar: phrases,
      lo: $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$User$unwrapUserId),
      gT: $elm$core$Maybe$Nothing
    }, $elm$core$Platform$Cmd$batch(_List_fromArray([persistCommonStaticCmd])));
  };
  var $author$project$PushMessages$PushMessages$init = {};
  var $author$project$Types$Auth$Auth = F3(function (idToken, refreshToken, expiresIn) {
    return {
      v3: expiresIn,
      oe: idToken,
      qW: refreshToken
    };
  });
  var $author$project$Types$Auth$IdToken = $elm$core$Basics$identity;
  var $author$project$Remote$RequestMsg$InitializeUserSession = F3(function (a, b, c) {
    return {
      $: 5,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Types$Auth$RefreshToken = $elm$core$Basics$identity;
  var $author$project$Types$UserSessionStatus$UserAuthenticating = {
    $: 1
  };
  var $author$project$Types$UserSessionStatus$Unauthenticated = {
    $: 0
  };
  var $author$project$Remote$Model$initClean = {
    ms: _List_Nil,
    b9: _List_Nil,
    se: _List_Nil,
    sX: $author$project$Types$UserSessionStatus$Unauthenticated
  };
  var $author$project$Remote$Model$init = function (appArgs) {
    return A2($elm$core$Maybe$withDefault, _Utils_Tuple2($author$project$Remote$Model$initClean, $elm$core$Platform$Cmd$none), A2($elm$core$Maybe$map, function (rawPersistedAuth) {
      var persistedAuth = A3($author$project$Types$Auth$Auth, rawPersistedAuth.oe, rawPersistedAuth.qW, rawPersistedAuth.v3);
      return _Utils_Tuple2(_Utils_update($author$project$Remote$Model$initClean, {
        sX: $author$project$Types$UserSessionStatus$UserAuthenticating
      }), A2($elm$core$Task$perform, $elm$core$Basics$identity, $elm$core$Task$succeed(A3($author$project$Remote$RequestMsg$InitializeUserSession, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, persistedAuth))));
    }, appArgs.Ao.bN));
  };
  var $turboMaCk$any_set$Set$Any$AnySet = $elm$core$Basics$identity;
  var $turboMaCk$any_set$Set$Any$empty = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $turboMaCk$any_dict$Dict$Any$empty);
  var $author$project$Ui$AddPlayers$AddPlayers$init = {
    kG: {
      yM: 1,
      BG: 0
    },
    gr: '',
    gx: $turboMaCk$any_set$Set$Any$empty($author$project$Types$User$unwrapUserId)
  };
  var $author$project$Ui$Auth$Auth$initEmpty = {
    hh: '',
    hi: '',
    hj: '',
    ff: false,
    fg: false,
    fh: false,
    nH: '',
    nI: '',
    nJ: '',
    h8: false,
    h9: false,
    xl: false,
    xm: false,
    z9: '',
    gm: false,
    ko: '',
    AX: '',
    AY: '',
    kr: '',
    cg: $elm$core$Maybe$Nothing,
    AZ: '',
    kz: false,
    kA: false,
    cm: $elm$core$Maybe$Nothing,
    rS: '',
    rT: ''
  };
  var $author$project$Ui$Auth$Auth$init = F2(function (_v0, appArgs) {
    return _Utils_Tuple2($author$project$Ui$Auth$Auth$initEmpty, $elm$core$Platform$Cmd$none);
  });
  var $author$project$Api$GraphqlSchema$Enum$DifficultyRating$Easy = 0;
  var $author$project$Api$GraphqlSchema$Enum$SkillRating$Intermediate = 2;
  var $author$project$Ui$ResultCard$PadelResults = 0;
  var $author$project$Ui$ComponentsPreview$Model$Val1 = 0;
  var $author$project$Ui$ComponentsPreview$ComponentsPreview$init = {
    e6: 0,
    lC: 30,
    cB: false,
    fy: 0,
    nM: $elm$core$Maybe$Nothing,
    I: '',
    kb: 0,
    c7: false,
    gk: _Utils_Tuple2(0.0, 0.0),
    kx: 0,
    gt: false,
    cl: false,
    gu: false,
    gv: false,
    a3: $elm$core$Maybe$Nothing,
    k4: 2,
    r7: $elm$core$Maybe$Nothing,
    ai: false,
    gK: _Utils_Tuple2({
      mO: 0,
      wC: 0,
      yu: 0,
      pt: 0,
      ta: 0
    }, {
      mO: 0,
      wC: 0,
      yu: 0,
      pt: 0,
      ta: 0
    })
  };
  var $author$project$Types$Activity$activityToSuffix = function (activity) {
    switch (activity) {
      case 1:
        return '(indoor)';
      case 3:
        return '(outdoor)';
      case 2:
        return '';
      default:
        return '(indoor)';
    }
  };
  var $author$project$Types$Activity$toString = F2(function (withSuffix, activity) {
    var suffix = withSuffix ? ' ' + $author$project$Types$Activity$activityToSuffix(activity) : '';
    switch (activity) {
      case 1:
        return 'Padel Tennis' + suffix;
      case 3:
        return 'Tennis' + suffix;
      case 2:
        return 'Squash';
      default:
        return 'Badminton' + suffix;
    }
  });
  var $author$project$Types$Sport$toString = function (sport) {
    switch (sport) {
      case 0:
        return 'Padel Tennis';
      case 1:
        return 'Tennis';
      case 2:
        return 'Squash';
      case 3:
        return 'Football';
      case 4:
        return 'Basketball';
      case 5:
        return 'Volleyball';
      case 6:
        return 'Cricket';
      case 7:
        return 'Table Tennis';
      default:
        return 'Badminton';
    }
  };
  var $author$project$Ui$EditUserActivities$Model$init = {
    lz: $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$Activity$toString(false)),
    fl: $turboMaCk$any_set$Set$Any$empty($author$project$Types$Sport$toString),
    k5: ''
  };
  var $author$project$Ui$Feedback$Model$init = {
    mw: '',
    BB: $elm$core$Maybe$Nothing
  };
  var $krisajenkins$remotedata$RemoteData$NotAsked = {
    $: 0
  };
  var $author$project$Ui$Invitation$Model$init = {
    qZ: $krisajenkins$remotedata$RemoteData$NotAsked
  };
  var $author$project$Ui$Legal$Legal$init = {
    AB: 'https://docs.google.com/document/d/e/2PACX-1vSvUKS-a4Zssca6qpTLPNTKZyZcIWwN4EAfZ1uMTPz0qpvMUu9nk_ymktXFw7M05qxh1e2pMZ6rtWC4/pub?embedded=true',
    Cw: 'https://docs.google.com/document/d/e/2PACX-1vTK2D1X78DmLaKj-S0X-RMlLmRUn7Q9vSLf3N-UZPwLL3J5FC1RdPAuEl470-GLwayFl0pIfh4-2ANy/pub?embedded=true'
  };
  var $author$project$Api$GraphqlSchema$Enum$DifficultyRating$Medium = 1;
  var $author$project$Ui$Match$Model$init = {
    l9: $elm$core$Maybe$Nothing,
    ma: $krisajenkins$remotedata$RemoteData$NotAsked,
    oy: false,
    oA: false,
    oB: false,
    qi: $elm$core$Maybe$Nothing,
    AQ: 1,
    rf: 0
  };
  var $author$project$Ui$Matchmaking$Checkout$Model$init = {
    mz: false,
    oz: false,
    qi: $elm$core$Maybe$Nothing
  };
  var $author$project$Types$CreateOrEditSearchParams$empty = {
    du: $elm$core$Maybe$Nothing,
    tF: _List_fromArray([$elm$core$Maybe$Nothing]),
    ox: _List_Nil,
    iT: $elm$core$Maybe$Nothing,
    ye: $elm$core$Maybe$Nothing,
    gj: 30
  };
  var $author$project$Ui$Matchmaking$Single$Model$init = {
    mE: $author$project$Types$CreateOrEditSearchParams$empty
  };
  var $author$project$Ui$Matchmaking$Model$init = {
    mj: $author$project$Ui$Matchmaking$Checkout$Model$init,
    B2: $author$project$Ui$Matchmaking$Single$Model$init
  };
  var $author$project$Ui$MoreOptions$Model$init = {
    n1: false
  };
  var $author$project$Api$GraphqlSchema$Enum$DateOrder$RecentFirst = 0;
  var $author$project$Ui$MyPlayerStatus$Model$init = {
    cF: 0,
    oF: false,
    oG: false,
    oK: false,
    qS: 0,
    sn: ''
  };
  var $author$project$Ui$NotificationsSettings$Model$init = function (active) {
    var allActivated = {
      bZ: active,
      ew: active
    };
    return {
      mb: allActivated,
      pC: allActivated,
      pE: allActivated,
      qT: allActivated,
      rs: allActivated
    };
  };
  var $author$project$Ui$OnboardUser$Model$init = {
    rc: $elm$core$Maybe$Nothing
  };
  var $author$project$Ui$PaymentMethods$Edit$Model$init = {
    iz: false,
    oJ: true,
    pd: $elm$core$Maybe$Nothing,
    qg: $elm$core$Maybe$Nothing
  };
  var $author$project$Ui$PaymentMethods$Model$init = {
    vE: $author$project$Ui$PaymentMethods$Edit$Model$init,
    Ah: $elm$core$Maybe$Nothing,
    qm: $elm$core$Maybe$Nothing
  };
  var $author$project$Ui$ProvideLocation$Model$LocationSearchComplete = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$ProvideLocation$Model$init = {
    gW: '',
    iz: false,
    xO: $author$project$Ui$ProvideLocation$Model$LocationSearchComplete(_List_Nil)
  };
  var $author$project$Ui$Support$Model$init = {
    mw: '',
    oL: false,
    qv: '',
    sd: $elm$core$Maybe$Nothing,
    sf: $krisajenkins$remotedata$RemoteData$NotAsked
  };
  var $author$project$MainModule$init = function (programArgs) {
    var appArgs = programArgs.tt;
    var _v0 = $author$project$Remote$Model$init(appArgs);
    var remoteState = _v0.a;
    var remoteCmd = _v0.b;
    var _v1 = $author$project$Global$Global$init(programArgs);
    var global = _v1.a;
    var globalCmd = _v1.b;
    var _v2 = A2($author$project$Ui$Auth$Auth$init, global.ar, appArgs);
    var authState = _v2.a;
    var authCmd = _v2.b;
    var theState = {
      tl: $author$project$Ui$AddPlayers$AddPlayers$init,
      tD: authState,
      uE: $author$project$Ui$ComponentsPreview$ComponentsPreview$init,
      vF: $author$project$Ui$EditUserActivities$Model$init,
      vG: $author$project$Types$EditingUserProfile$empty,
      wd: $author$project$Ui$Feedback$Model$init,
      nV: global,
      wY: $author$project$Ui$Invitation$Model$init,
      xF: $author$project$Ui$Legal$Legal$init,
      xZ: $author$project$Ui$Match$Model$init,
      x3: $author$project$Ui$Matchmaking$Model$init,
      yv: $author$project$Ui$MoreOptions$Model$init,
      yy: $author$project$Ui$MyPlayerStatus$Model$init,
      yL: $author$project$Ui$NotificationsSettings$Model$init(true),
      z$: $author$project$Ui$OnboardUser$Model$init,
      Ae: $author$project$Ui$PaymentMethods$Model$init,
      AJ: $author$project$Ui$ProvideLocation$Model$init,
      AN: $author$project$PushMessages$PushMessages$init,
      A$: remoteState,
      Cq: $author$project$Ui$Support$Model$init
    };
    return _Utils_Tuple3(theState, $elm$core$Platform$Cmd$batch(_List_fromArray([A2($elm$core$Platform$Cmd$map, $author$project$Msg$GlobalMsg, globalCmd), A2($elm$core$Platform$Cmd$map, $author$project$Msg$AuthMsg, authCmd), A2($elm$core$Platform$Cmd$map, $author$project$Msg$RemoteRequestMsg, remoteCmd)])), _List_fromArray([$author$project$ElmFramework$Msg$TrackingMsg(0)]));
  };
  var $author$project$Remote$Model$isAuthenticated = function (_v0) {
    var userSessionStatus = _v0.sX;
    switch (userSessionStatus.$) {
      case 0:
        return false;
      case 1:
        return false;
      case 2:
        return true;
      default:
        var userSession = userSessionStatus.a;
        return true;
    }
  };
  var $author$project$MulticastMessages$onNewGeolocation = function (anyTypeOfGeolocation) {
    return _List_Nil;
  };
  var $author$project$Msg$AddPlayersMsg = function (a) {
    return {
      $: 23,
      a: a
    };
  };
  var $author$project$Ui$Matchmaking$Msg$CheckoutMsgReceived = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$PaymentMethods$Msg$EditMsgReceived = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Msg$EditPersonalDetailsMsg = function (a) {
    return {
      $: 20,
      a: a
    };
  };
  var $author$project$Msg$InvitationMsg = function (a) {
    return {
      $: 25,
      a: a
    };
  };
  var $author$project$Msg$MatchMsg = function (a) {
    return {
      $: 19,
      a: a
    };
  };
  var $author$project$Msg$MyPlayerStatusMsg = function (a) {
    return {
      $: 18,
      a: a
    };
  };
  var $author$project$Msg$NotificationsSettingsMsg = function (a) {
    return {
      $: 17,
      a: a
    };
  };
  var $author$project$Ui$Invitation$Msg$OnAuthOrRoute = {
    $: 0
  };
  var $author$project$Global$Msg$OnRoute = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$Msg$OnRoute = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$AddPlayers$Msg$OnRoute = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$Auth$UserSession$Msg$OnRoute = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Match$Msg$OnRoute = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Matchmaking$Checkout$Msg$OnRoute = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Matchmaking$Single$Msg$OnRoute = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$MyPlayerStatus$Msg$OnRoute = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$NotificationsSettings$Msg$OnRoute = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$OnboardUser$Msg$OnRoute = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$PaymentMethods$Edit$Msg$OnRoute = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$ProvideLocation$Msg$OnRoute = function (a) {
    return {
      $: 5,
      a: a
    };
  };
  var $author$project$Ui$Support$Msg$OnRoute = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$EditPersonalDetails$Msg$OnRouteOrAuth = 0;
  var $author$project$Ui$PaymentMethods$Msg$OnRouteOrAuth = {
    $: 0
  };
  var $author$project$Msg$PaymentMethodsMsg = function (a) {
    return {
      $: 15,
      a: a
    };
  };
  var $author$project$Msg$ProvideLocationMsg = function (a) {
    return {
      $: 13,
      a: a
    };
  };
  var $author$project$Msg$RemoteMsg = function (a) {
    return {
      $: 10,
      a: a
    };
  };
  var $author$project$Msg$SupportMsg = function (a) {
    return {
      $: 8,
      a: a
    };
  };
  var $author$project$MainModule$onNewRouteMsgs = F3(function (_v0, oldHistory, route) {
    return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg(A2($author$project$Global$Msg$OnRoute, oldHistory, route))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$RemoteMsg(A2($author$project$Remote$Msg$OnRoute, oldHistory, route))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$ProvideLocationMsg($author$project$Ui$ProvideLocation$Msg$OnRoute(route))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$MatchMsg(A2($author$project$Ui$Match$Msg$OnRoute, oldHistory, route))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$SupportMsg($author$project$Ui$Support$Msg$OnRoute(route))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$NotificationsSettingsMsg(A2($author$project$Ui$NotificationsSettings$Msg$OnRoute, oldHistory, route))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$AddPlayersMsg($author$project$Ui$AddPlayers$Msg$OnRoute(route))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$InvitationMsg($author$project$Ui$Invitation$Msg$OnAuthOrRoute)), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$OnboardUserMsg(A2($author$project$Ui$OnboardUser$Msg$OnRoute, oldHistory, route))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$MatchmakingMsg($author$project$Ui$Matchmaking$Msg$SingleMsgReceived(A2($author$project$Ui$Matchmaking$Single$Msg$OnRoute, oldHistory, route)))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$MatchmakingMsg($author$project$Ui$Matchmaking$Msg$CheckoutMsgReceived(A2($author$project$Ui$Matchmaking$Checkout$Msg$OnRoute, oldHistory, route)))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$EditPersonalDetailsMsg(0)), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$PaymentMethodsMsg($author$project$Ui$PaymentMethods$Msg$OnRouteOrAuth)), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$PaymentMethodsMsg($author$project$Ui$PaymentMethods$Msg$EditMsgReceived(A2($author$project$Ui$PaymentMethods$Edit$Msg$OnRoute, oldHistory, route)))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$UserSessionMsg(A2($author$project$Ui$Auth$UserSession$Msg$OnRoute, oldHistory, route))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$MyPlayerStatusMsg($author$project$Ui$MyPlayerStatus$Msg$OnRoute(route)))]);
  });
  var $author$project$Remote$Msg$OnSearchActivationNotification = function (a) {
    return {
      $: 9,
      a: a
    };
  };
  var $author$project$Ui$Auth$UserSession$Msg$ReceiveNotification = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });
  var $author$project$Global$Msg$ReportErr = F2(function (a, b) {
    return {
      $: 9,
      a: a,
      b: b
    };
  });
  var $author$project$TopMsg$remoteMsg = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$RemoteMsg);
  var $author$project$ElmFramework$Lib$Util$decodeValue = F2(function (decoder, value) {
    return A2($elm$core$Result$mapError, $elm$json$Json$Decode$errorToString, A2($elm$json$Json$Decode$decodeValue, decoder, value));
  });
  var $elm$json$Json$Decode$at = F2(function (fields, decoder) {
    return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
  });
  var $elm$json$Json$Decode$maybe = function (decoder) {
    return $elm$json$Json$Decode$oneOf(_List_fromArray([A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder), $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)]));
  };
  var $author$project$Api$GraphqlSchema$Enum$NotificationAction$MatchCancellation = 3;
  var $author$project$Api$GraphqlSchema$Enum$NotificationAction$MatchJoined = 2;
  var $author$project$Api$GraphqlSchema$Enum$NotificationAction$MatchNotFound = 0;
  var $author$project$Api$GraphqlSchema$Enum$NotificationAction$MatchRate = 5;
  var $author$project$Api$GraphqlSchema$Enum$NotificationAction$Matched = 1;
  var $author$project$Api$GraphqlSchema$Enum$NotificationAction$SearchInvite = 6;
  var $author$project$PushMessages$NotificationPayloadDecoder$notificationActionDecoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'match-not-found':
        return $elm$json$Json$Decode$succeed(0);
      case 'matched':
        return $elm$json$Json$Decode$succeed(1);
      case 'match-cancellation':
        return $elm$json$Json$Decode$succeed(3);
      case 'match-rate':
        return $elm$json$Json$Decode$succeed(5);
      case 'match_joined':
        return $elm$json$Json$Decode$succeed(2);
      case 'search_invite':
        return $elm$json$Json$Decode$succeed(6);
      default:
        return $elm$json$Json$Decode$fail('Invalid NotificationAction type');
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$PushMessages$Model$GeneralPushPayload = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$PushMessages$Model$NotificationPayload = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Types$UserNotification$SearchActivation = 0;
  var $author$project$Types$Search$SearchId = $elm$core$Basics$identity;
  var $author$project$Types$User$UserId = $elm$core$Basics$identity;
  var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(function (key, valDecoder, decoder) {
    return A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A2($elm$json$Json$Decode$field, key, valDecoder), decoder);
  });
  var $author$project$PushMessages$GeneralPushPayloadDecoder$dataNotificationPayloadDecoder = function (dataNotificationAction) {
    return A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'action', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'userId', A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'searchId', A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed(F3(function (searchId, userId, actionDuplicate) {
      return {
        tg: dataNotificationAction,
        by: searchId,
        e_: userId
      };
    })))));
  };
  var $author$project$PushMessages$GeneralPushPayloadDecoder$generalPushPayloadDecoder = function (actionString) {
    if (actionString === 'search-activation') {
      return $author$project$PushMessages$GeneralPushPayloadDecoder$dataNotificationPayloadDecoder(0);
    } else {
      return $elm$json$Json$Decode$fail('Unknown notification type: unknown action');
    }
  };
  var $author$project$Types$Match$MatchId = $elm$core$Basics$identity;
  var $author$project$Types$UserNotification$NotificationId = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$Unread = 1;
  var $author$project$PushMessages$NotificationPayloadDecoder$notificationPayloadDecoder = function (_v0) {
    var title = _v0.lh;
    var message = _v0.f0;
    var longMessage = _v0.o4;
    var action = _v0.tg;
    return A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'action', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'userId', A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'searchId', A2($elm$json$Json$Decode$map, A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Basics$identity), $elm$json$Json$Decode$string), A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'matchId', A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string)), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'notificationId', A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed(F5(function (id, matchId, searchId, userId, actionDuplicate) {
      return {
        tg: action,
        uV: $elm$time$Time$millisToPosix(0),
        od: id,
        o4: longMessage,
        br: matchId,
        f0: message,
        qU: 1,
        by: searchId,
        lh: title,
        e_: userId
      };
    })))))));
  };
  var $author$project$PushMessages$Decoders$pushNotificationPayloadDecoder = function (_v0) {
    var maybeNotificationAction = _v0.pb;
    var actionString = _v0.e5;
    var title = _v0.lh;
    var message = _v0.f0;
    var longMessage = _v0.o4;
    if (!maybeNotificationAction.$) {
      var action = maybeNotificationAction.a;
      return A2($elm$json$Json$Decode$map, $author$project$PushMessages$Model$NotificationPayload, $author$project$PushMessages$NotificationPayloadDecoder$notificationPayloadDecoder({
        tg: action,
        o4: longMessage,
        f0: message,
        lh: title
      }));
    } else {
      return A2($elm$json$Json$Decode$map, $author$project$PushMessages$Model$GeneralPushPayload, $author$project$PushMessages$GeneralPushPayloadDecoder$generalPushPayloadDecoder(actionString));
    }
  };
  var $author$project$PushMessages$Model$NotifTapped = 2;
  var $author$project$PushMessages$Model$NotifWhenAppFocused = 0;
  var $author$project$PushMessages$Model$NotifWhenAppInBackground = 1;
  var $author$project$PushMessages$Decoders$toReceivingCircumstances = function (string) {
    switch (string) {
      case 'focused':
        return $elm$json$Json$Decode$succeed(0);
      case 'background':
        return $elm$json$Json$Decode$succeed(1);
      case 'tapped':
        return $elm$json$Json$Decode$succeed(2);
      default:
        var res = string;
        return $elm$json$Json$Decode$fail('unexpected receivingCircumstances: ' + res);
    }
  };
  var $author$project$PushMessages$Decoders$pushMsgDecoder = A2($elm$json$Json$Decode$andThen, function (_v0) {
    var receivingCircumstances = _v0.kj;
    var maybeTitle = _v0.pf;
    var maybeBody = _v0.pa;
    var actionString = _v0.e5;
    var payloadString = _v0.qe;
    var maybeNotificationAction = $elm$core$Result$toMaybe(A2($elm$json$Json$Decode$decodeString, $author$project$PushMessages$NotificationPayloadDecoder$notificationActionDecoder, '\"' + (actionString + '\"')));
    var decodePayload = A2($elm$json$Json$Decode$decodeString, $author$project$PushMessages$Decoders$pushNotificationPayloadDecoder({
      e5: actionString,
      o4: $elm$core$Maybe$Nothing,
      pb: maybeNotificationAction,
      f0: A2($elm$core$Maybe$withDefault, '', maybeBody),
      lh: A2($elm$core$Maybe$withDefault, '', maybeTitle)
    }), payloadString);
    if (!decodePayload.$) {
      var pushPayload = decodePayload.a;
      return $elm$json$Json$Decode$succeed({
        aU: A2($elm$core$Maybe$withDefault, '', maybeBody),
        Ab: pushPayload,
        kj: receivingCircumstances,
        lh: A2($elm$core$Maybe$withDefault, '', maybeTitle)
      });
    } else {
      var err = decodePayload.a;
      return $elm$json$Json$Decode$fail($elm$json$Json$Decode$errorToString(err));
    }
  }, A6($elm$json$Json$Decode$map5, F5(function (receivingCircumstances, maybeTitle, maybeBody, actionString, payloadString) {
    return {
      e5: actionString,
      pa: maybeBody,
      pf: maybeTitle,
      qe: payloadString,
      kj: receivingCircumstances
    };
  }), A2($elm$json$Json$Decode$andThen, $author$project$PushMessages$Decoders$toReceivingCircumstances, A2($elm$json$Json$Decode$field, 'receivingCircumstances', $elm$json$Json$Decode$string)), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$at, _List_fromArray(['data', 'notification', 'title']), $elm$json$Json$Decode$string)), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$at, _List_fromArray(['data', 'notification', 'body']), $elm$json$Json$Decode$string)), A2($elm$json$Json$Decode$at, _List_fromArray(['data', 'data', 'action']), $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$at, _List_fromArray(['data', 'data', 'payload']), $elm$json$Json$Decode$string)));
  var $author$project$PushMessages$Decoders$toPushNotification = $author$project$ElmFramework$Lib$Util$decodeValue($author$project$PushMessages$Decoders$pushMsgDecoder);
  var $author$project$PushMsgRouter$pushMsgRouter = function (pushMsg) {
    var _v0 = $author$project$PushMessages$Decoders$toPushNotification(pushMsg);
    if (!_v0.$) {
      var thePushMsg = _v0.a;
      var _v1 = thePushMsg.Ab;
      if (!_v1.$) {
        var payload = _v1.a;
        return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$UserSessionMsg(A2($author$project$Ui$Auth$UserSession$Msg$ReceiveNotification, thePushMsg.kj, payload)))]);
      } else {
        var payload = _v1.a;
        var _v2 = payload.tg;
        return _List_fromArray([$author$project$TopMsg$remoteMsg($author$project$Remote$Msg$OnSearchActivationNotification(payload.by))]);
      }
    } else {
      var error = _v0.a;
      return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg(A2($author$project$Global$Msg$ReportErr, 'pushMsgRouter', error))), A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil)]);
    }
  };
  var $author$project$TopMsg$requestMsg = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$RemoteRequestMsg);
  var $author$project$Route$Route$Auth = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Route$Route$DefaultRegistration = {
    $: 0
  };
  var $author$project$Route$Route$Register = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Matchmaking$Single$Route$Main = {
    $: 0
  };
  var $author$project$Route$Route$Matchmaking = function (a) {
    return {
      $: 18,
      a: a
    };
  };
  var $author$project$Ui$Matchmaking$Route$Single = $elm$core$Basics$identity;
  var $author$project$Route$Route$homeRoute = $author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$Main);
  var $author$project$Route$RouteUtil$isAuthRoute = function (route) {
    switch (route.$) {
      case 0:
        if (route.a.$ === 3 && route.a.a.$ === 1) {
          return false;
        } else {
          return true;
        }
      case 1:
        return true;
      case 2:
        return false;
      case 3:
        var legalRoute = route.a;
        return false;
      case 4:
        return false;
      case 5:
        var notificationInRoute = route.a;
        return false;
      case 6:
        return false;
      case 7:
        return false;
      case 8:
        return false;
      case 9:
        return false;
      case 10:
        return false;
      case 11:
        return false;
      case 12:
        return false;
      case 13:
        var userId = route.a;
        return false;
      case 14:
        return false;
      case 15:
        var appIntroRoute = route.a;
        return false;
      case 16:
        var onboardUserRoute = route.a;
        return false;
      case 17:
        var paymentMethodsRoute = route.a;
        return false;
      case 18:
        var matchMakingRoute = route.a;
        return false;
      case 19:
        var myPlayerStatusRoute = route.a;
        return false;
      case 20:
        var userId = route.a;
        return false;
      case 21:
        var matchId = route.a;
        var matchRoute = route.b;
        return false;
      case 22:
        return false;
      default:
        var uuid = route.a;
        return false;
    }
  };
  var $author$project$Types$UserSessionStatus$isAuthenticated = function (userSessionStatus) {
    switch (userSessionStatus.$) {
      case 0:
        return $elm$core$Maybe$Just(false);
      case 1:
        return $elm$core$Maybe$Nothing;
      case 2:
        return $elm$core$Maybe$Just(true);
      default:
        return $elm$core$Maybe$Just(true);
    }
  };
  var $author$project$Global$Msg$OnUserWantsBack = {
    $: 2
  };
  var $author$project$MainModule$onUserWantsBack = F2(function (state, route) {
    if ($elm_community$maybe_extra$Maybe$Extra$isJust(state.nV.dt)) {
      return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg($author$project$Global$Msg$OnUserWantsBack))]);
    } else {
      switch (route.$) {
        case 0:
          return _List_Nil;
        case 1:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 2:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 3:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 5:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 4:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 6:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 7:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 8:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 9:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 10:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 11:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 12:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 13:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 14:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 15:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 16:
          return _List_Nil;
        case 17:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 18:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 19:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 20:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 21:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        case 22:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
        default:
          return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]);
      }
    }
  });
  var $author$project$MainModule$onUserWantsForward = F2(function (state, route) {
    switch (route.$) {
      case 0:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 1:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 2:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 3:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 5:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 4:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 6:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 7:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 8:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 9:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 10:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 11:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 12:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 13:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 14:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 15:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 16:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 17:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 18:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 19:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 20:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 21:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      case 22:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
      default:
        return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]);
    }
  });
  var $author$project$MainModule$redirect = F2(function (appState, route) {
    return $elm$core$Maybe$Nothing;
  });
  var $author$project$Route$RouteUtil$requiresAuthentication = function (route) {
    switch (route.$) {
      case 0:
        return false;
      case 1:
        return false;
      case 2:
        return true;
      case 3:
        return false;
      case 5:
        return true;
      case 4:
        return false;
      case 6:
        return true;
      case 7:
        return true;
      case 8:
        return true;
      case 9:
        return true;
      case 10:
        return true;
      case 11:
        return true;
      case 12:
        return true;
      case 13:
        return true;
      case 14:
        return true;
      case 15:
        return true;
      case 16:
        return true;
      case 17:
        return true;
      case 18:
        return true;
      case 19:
        return true;
      case 20:
        return true;
      case 21:
        return true;
      case 22:
        return true;
      default:
        var subRoute = route.a;
        if (!subRoute.$) {
          var uuid = subRoute.a;
          return false;
        } else {
          var searchId = subRoute.a;
          return true;
        }
    }
  };
  var $author$project$Route$Route$AcceptTermsOfUseDialog = 0;
  var $author$project$Route$Route$AccountCreationSuccess = {
    $: 5
  };
  var $author$project$Route$Route$AppIntro = function (a) {
    return {
      $: 15,
      a: a
    };
  };
  var $author$project$Route$Route$AuthAction = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Route$Route$BanUser = function (a) {
    return {
      $: 13,
      a: a
    };
  };
  var $author$project$Route$Route$BannedUsers = {
    $: 14
  };
  var $author$project$Route$Route$ChangePassword = {
    $: 10
  };
  var $author$project$Route$Route$ChooseSignInMethod = {
    $: 0
  };
  var $author$project$Route$Route$ComponentsPreview = {
    $: 4
  };
  var $author$project$Route$Route$ConfirmRegistration = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $author$project$Route$Route$DefaultSignIn = {
    $: 0
  };
  var $author$project$Route$Route$EditPersonalDetails = {
    $: 9
  };
  var $author$project$Route$Route$Feedback = {
    $: 12
  };
  var $author$project$Route$Route$ForgotPassword = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Route$Route$ForgotPasswordEnterEmail = {
    $: 0
  };
  var $author$project$Route$Route$FromNotification = function (a) {
    return {
      $: 5,
      a: a
    };
  };
  var $author$project$Route$Route$Invitation = function (a) {
    return {
      $: 23,
      a: a
    };
  };
  var $author$project$Route$Route$Legal = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Route$Route$LegalRoutePrivacyPolicy = 1;
  var $author$project$Route$Route$LegalRouteTermsOfUse = 0;
  var $author$project$Route$Route$Match = F2(function (a, b) {
    return {
      $: 21,
      a: a,
      b: b
    };
  });
  var $author$project$Route$Route$MoreOptions = {
    $: 6
  };
  var $author$project$Route$Route$MyPlayerStatus = function (a) {
    return {
      $: 19,
      a: a
    };
  };
  var $author$project$Route$Route$Notifications = {
    $: 11
  };
  var $author$project$Route$Route$NotificationsSettings = {
    $: 8
  };
  var $author$project$Route$Route$OnboardUser = function (a) {
    return {
      $: 16,
      a: a
    };
  };
  var $author$project$Route$Route$OtherNotificationInRoute = 0;
  var $author$project$Route$Route$PaymentMethods = function (a) {
    return {
      $: 17,
      a: a
    };
  };
  var $author$project$Route$Route$PlayerProfile = function (a) {
    return {
      $: 20,
      a: a
    };
  };
  var $author$project$Route$Route$PrivacySettings = {
    $: 7
  };
  var $author$project$Ui$Invitation$Route$Search = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Route$Route$SignInWithCredentials = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Route$Route$Support = {
    $: 2
  };
  var $author$project$Ui$Invitation$Route$Token = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Types$Uuid$Uuid = $elm$core$Basics$identity;
  var $author$project$Route$RouteMappers$keysGetters = {
    Ab: $elm$core$Dict$get('payload'),
    BI: $elm$core$Dict$get('search-phrase')
  };
  var $author$project$ElmFramework$Lib$Url$path = function (thePath) {
    return {
      cb: thePath,
      ex: $elm$core$Dict$empty
    };
  };
  var $author$project$Ui$AppIntro$Route$HistoryIntro = 2;
  var $author$project$Ui$AppIntro$Route$Locations = 0;
  var $author$project$Ui$AppIntro$Route$Players = 1;
  var $author$project$Ui$AppIntro$Route$toRoute = function (url) {
    var _v0 = url.cb;
    _v0$3: while (true) {
      if (_v0.b && !_v0.b.b) {
        switch (_v0.a) {
          case 'locations':
            return $elm$core$Maybe$Just(0);
          case 'players':
            return $elm$core$Maybe$Just(1);
          case 'history':
            return $elm$core$Maybe$Just(2);
          default:
            break _v0$3;
        }
      } else {
        break _v0$3;
      }
    }
    return $elm$core$Maybe$Nothing;
  };
  var $author$project$Ui$Match$Route$Cancel = {
    $: 2
  };
  var $author$project$Ui$Match$Route$Details = {
    $: 0
  };
  var $author$project$Ui$Match$Route$Invoice = {
    $: 3
  };
  var $author$project$Ui$Match$Route$toRoute = function (url) {
    var _v0 = url.cb;
    _v0$3: while (true) {
      if (_v0.b && !_v0.b.b) {
        switch (_v0.a) {
          case 'details':
            return $elm$core$Maybe$Just($author$project$Ui$Match$Route$Details);
          case 'cancel':
            return $elm$core$Maybe$Just($author$project$Ui$Match$Route$Cancel);
          case 'invoice':
            return $elm$core$Maybe$Just($author$project$Ui$Match$Route$Invoice);
          default:
            break _v0$3;
        }
      } else {
        break _v0$3;
      }
    }
    return $elm$core$Maybe$Nothing;
  };
  var $author$project$Ui$Matchmaking$Single$Route$AddPlayers = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Ui$Matchmaking$Single$Route$Checkout = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$Matchmaking$Single$Route$ProvideLocation = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$AddPlayers$Route$ContactsAccessOverlay = {
    $: 1
  };
  var $author$project$Types$CreateOrEditSearch$Create = {
    $: 0
  };
  var $author$project$Types$CreateOrEditSearch$Edit = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$AddPlayers$Route$Main = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$AddPlayers$Route$toRoute = function (url) {
    var _v0 = url.cb;
    _v0$3: while (true) {
      if (_v0.b) {
        if (_v0.b.b) {
          if (_v0.a === 'main' && !_v0.b.b.b) {
            var _v1 = _v0.b;
            var id = _v1.a;
            return $elm$core$Maybe$Just($author$project$Ui$AddPlayers$Route$Main($author$project$Types$CreateOrEditSearch$Edit(id)));
          } else {
            break _v0$3;
          }
        } else {
          switch (_v0.a) {
            case 'main':
              return $elm$core$Maybe$Just($author$project$Ui$AddPlayers$Route$Main($author$project$Types$CreateOrEditSearch$Create));
            case 'contacts-access':
              return $elm$core$Maybe$Just($author$project$Ui$AddPlayers$Route$ContactsAccessOverlay);
            default:
              break _v0$3;
          }
        }
      } else {
        break _v0$3;
      }
    }
    return $elm$core$Maybe$Nothing;
  };
  var $author$project$Ui$Matchmaking$Checkout$Route$Payment = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Types$PaymentMethod$PaymentMethodId = $elm$core$Basics$identity;
  var $author$project$Ui$Matchmaking$Checkout$Route$Review = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$PaymentMethods$Route$Add = 1;
  var $author$project$Ui$PaymentMethods$Route$Browse = 0;
  var $author$project$Ui$PaymentMethods$Route$toRoute = function (url) {
    var _v0 = url.cb;
    _v0$2: while (true) {
      if (_v0.b && !_v0.b.b) {
        switch (_v0.a) {
          case 'browse':
            return $elm$core$Maybe$Just(0);
          case 'add':
            return $elm$core$Maybe$Just(1);
          default:
            break _v0$2;
        }
      } else {
        break _v0$2;
      }
    }
    return $elm$core$Maybe$Nothing;
  };
  var $author$project$Ui$Matchmaking$Checkout$Route$toRoute = function (url) {
    var _v0 = url.cb;
    _v0$2: while (true) {
      if (_v0.b) {
        switch (_v0.a) {
          case 'payment':
            var branchRoute = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Ui$Matchmaking$Checkout$Route$Payment, $author$project$Ui$PaymentMethods$Route$toRoute($author$project$ElmFramework$Lib$Url$path(branchRoute)));
          case 'review':
            if (_v0.b.b && !_v0.b.b.b) {
              var _v1 = _v0.b;
              var paymentMethodId = _v1.a;
              return $elm$core$Maybe$Just($author$project$Ui$Matchmaking$Checkout$Route$Review(paymentMethodId));
            } else {
              break _v0$2;
            }
          default:
            break _v0$2;
        }
      } else {
        break _v0$2;
      }
    }
    return $elm$core$Maybe$Nothing;
  };
  var $author$project$Ui$ProvideLocation$DrawerBranch$Route$EnterAddress = 1;
  var $author$project$Ui$ProvideLocation$DrawerBranch$Route$Radius = 0;
  var $author$project$Ui$ProvideLocation$DrawerBranch$Route$toRoute = function (url) {
    var _v0 = url.cb;
    _v0$2: while (true) {
      if (_v0.b && !_v0.b.b) {
        switch (_v0.a) {
          case 'radius':
            return $elm$core$Maybe$Just(0);
          case 'address':
            return $elm$core$Maybe$Just(1);
          default:
            break _v0$2;
        }
      } else {
        break _v0$2;
      }
    }
    return $elm$core$Maybe$Nothing;
  };
  var $author$project$Ui$Matchmaking$Single$Route$toRoute = function (url) {
    var _v0 = url.cb;
    _v0$4: while (true) {
      if (_v0.b) {
        switch (_v0.a) {
          case 'single':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Ui$Matchmaking$Single$Route$Main);
            } else {
              break _v0$4;
            }
          case 'checkout':
            var branchRoute = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Ui$Matchmaking$Single$Route$Checkout, $author$project$Ui$Matchmaking$Checkout$Route$toRoute($author$project$ElmFramework$Lib$Url$path(branchRoute)));
          case 'provide-location':
            var branchRoute = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Ui$Matchmaking$Single$Route$ProvideLocation, $author$project$Ui$ProvideLocation$DrawerBranch$Route$toRoute($author$project$ElmFramework$Lib$Url$path(branchRoute)));
          case 'add-players':
            var branchRoute = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Ui$Matchmaking$Single$Route$AddPlayers, $author$project$Ui$AddPlayers$Route$toRoute($author$project$ElmFramework$Lib$Url$path(branchRoute)));
          default:
            break _v0$4;
        }
      } else {
        break _v0$4;
      }
    }
    return $elm$core$Maybe$Nothing;
  };
  var $author$project$Ui$Matchmaking$Route$toRoute = function (url) {
    var _v0 = url.cb;
    if (_v0.b && _v0.a === 'single') {
      var branchRoute = _v0.b;
      return A2($elm$core$Maybe$map, $elm$core$Basics$identity, $author$project$Ui$Matchmaking$Single$Route$toRoute($author$project$ElmFramework$Lib$Url$path(branchRoute)));
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };
  var $author$project$Ui$MyPlayerStatus$Route$History = {
    $: 1
  };
  var $author$project$Ui$MyPlayerStatus$Route$Searches = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$MyPlayerStatus$Searches$Route$SearchesList = {
    $: 0
  };
  var $author$project$Ui$MyPlayerStatus$Route$Upcoming = {
    $: 0
  };
  var $author$project$Ui$MyPlayerStatus$Searches$Route$Cancel = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$MyPlayerStatus$Searches$Route$Edit = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$MyPlayerStatus$Searches$Route$toRoute = function (url) {
    _v0$3: while (true) {
      if (url.b) {
        if (!url.b.b) {
          if (url.a === 'searches') {
            return $elm$core$Maybe$Just($author$project$Ui$MyPlayerStatus$Searches$Route$SearchesList);
          } else {
            break _v0$3;
          }
        } else {
          if (!url.b.b.b) {
            switch (url.a) {
              case 'edit':
                var _v1 = url.b;
                var id = _v1.a;
                return $elm$core$Maybe$Just($author$project$Ui$MyPlayerStatus$Searches$Route$Edit(id));
              case 'cancel':
                var _v2 = url.b;
                var id = _v2.a;
                return $elm$core$Maybe$Just($author$project$Ui$MyPlayerStatus$Searches$Route$Cancel(id));
              default:
                break _v0$3;
            }
          } else {
            break _v0$3;
          }
        }
      } else {
        break _v0$3;
      }
    }
    return $elm$core$Maybe$Nothing;
  };
  var $author$project$Ui$MyPlayerStatus$Route$toRoute = function (url) {
    var _v0 = url.cb;
    _v0$3: while (true) {
      if (_v0.b) {
        switch (_v0.a) {
          case 'upcoming-matches':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Ui$MyPlayerStatus$Route$Upcoming);
            } else {
              break _v0$3;
            }
          case 'match-history':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Ui$MyPlayerStatus$Route$History);
            } else {
              break _v0$3;
            }
          case 'searches':
            var subRoute = _v0.b;
            return $elm$core$List$isEmpty(subRoute) ? $elm$core$Maybe$Just($author$project$Ui$MyPlayerStatus$Route$Searches($author$project$Ui$MyPlayerStatus$Searches$Route$SearchesList)) : $elm$core$Maybe$Just($author$project$Ui$MyPlayerStatus$Route$Searches(A2($elm$core$Maybe$withDefault, $author$project$Ui$MyPlayerStatus$Searches$Route$SearchesList, $author$project$Ui$MyPlayerStatus$Searches$Route$toRoute(subRoute))));
          default:
            break _v0$3;
        }
      } else {
        break _v0$3;
      }
    }
    return $elm$core$Maybe$Nothing;
  };
  var $author$project$Ui$OnboardUser$Route$EditUserActivities = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$EditUserActivities$Route$Level = 1;
  var $author$project$Ui$OnboardUser$Route$Personal = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$EditUserActivities$Route$Sports = 0;
  var $author$project$Ui$OnboardUser$Route$toRoute = function (url) {
    var _v0 = url.cb;
    _v0$3: while (true) {
      if (_v0.b) {
        switch (_v0.a) {
          case 'personal':
            var rest = _v0.b;
            return $elm$core$Maybe$Just($author$project$Ui$OnboardUser$Route$Personal($author$project$Ui$ProvideLocation$DrawerBranch$Route$toRoute($author$project$ElmFramework$Lib$Url$path(rest))));
          case 'sports':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Ui$OnboardUser$Route$EditUserActivities(0));
            } else {
              break _v0$3;
            }
          case 'level':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Ui$OnboardUser$Route$EditUserActivities(1));
            } else {
              break _v0$3;
            }
          default:
            break _v0$3;
        }
      } else {
        break _v0$3;
      }
    }
    return $elm$core$Maybe$Nothing;
  };
  var $author$project$Route$RouteMappers$routeFor = function (url) {
    var _v0 = url.cb;
    _v0$34: while (true) {
      if (_v0.b) {
        switch (_v0.a) {
          case 'register':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$Auth(A2($author$project$Route$Route$Register, $elm$core$Maybe$Nothing, $author$project$Route$Route$DefaultRegistration)));
            } else {
              if (_v0.b.a === 'accept-terms' && !_v0.b.b.b) {
                var _v1 = _v0.b;
                return $elm$core$Maybe$Just($author$project$Route$Route$Auth(A2($author$project$Route$Route$Register, $elm$core$Maybe$Just(0), $author$project$Route$Route$DefaultRegistration)));
              } else {
                break _v0$34;
              }
            }
          case 'sign-in':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$Auth($author$project$Route$Route$ChooseSignInMethod));
            } else {
              if (_v0.b.a === 'credentials' && !_v0.b.b.b) {
                var _v2 = _v0.b;
                return $elm$core$Maybe$Just($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials($author$project$Route$Route$DefaultSignIn)));
              } else {
                break _v0$34;
              }
            }
          case 'forgot-password':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$Auth($author$project$Route$Route$ForgotPassword($author$project$Route$Route$ForgotPasswordEnterEmail)));
            } else {
              if (_v0.b.a === 'pending-code' && !_v0.b.b.b) {
                var _v3 = _v0.b;
                return $elm$core$Maybe$Just($author$project$Route$Route$Auth($author$project$Route$Route$ForgotPassword($author$project$Route$Route$ForgotPasswordEnterEmail)));
              } else {
                break _v0$34;
              }
            }
          case 'confirm-registration':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$Auth($author$project$Route$Route$ConfirmRegistration($elm$core$Maybe$Nothing)));
            } else {
              if (_v0.b.b.b && !_v0.b.b.b.b) {
                var _v4 = _v0.b;
                var username = _v4.a;
                var _v5 = _v4.b;
                var code = _v5.a;
                return $elm$core$Maybe$Just($author$project$Route$Route$Auth($author$project$Route$Route$ConfirmRegistration($elm$core$Maybe$Just({
                  uo: code,
                  sZ: username
                }))));
              } else {
                break _v0$34;
              }
            }
          case 'account-created':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$Auth($author$project$Route$Route$AccountCreationSuccess));
            } else {
              break _v0$34;
            }
          case 'support':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$Support);
            } else {
              break _v0$34;
            }
          case 'legal':
            if (_v0.b.b && !_v0.b.b.b) {
              switch (_v0.b.a) {
                case 'terms-of-use':
                  var _v6 = _v0.b;
                  return $elm$core$Maybe$Just($author$project$Route$Route$Legal(0));
                case 'privacy-policy':
                  var _v7 = _v0.b;
                  return $elm$core$Maybe$Just($author$project$Route$Route$Legal(1));
                default:
                  break _v0$34;
              }
            } else {
              break _v0$34;
            }
          case 'from-notification':
            if (!_v0.b.b) {
              var notifTypeDecoders = $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$succeed(0)]));
              return A2($elm$core$Maybe$map, $author$project$Route$Route$FromNotification, A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, $author$project$ElmFramework$Lib$Util$decodeString(notifTypeDecoders), $elm$core$Result$toMaybe), A2($elm$core$Maybe$andThen, $elm$url$Url$percentDecode, $author$project$Route$RouteMappers$keysGetters.Ab(url.ex))));
            } else {
              break _v0$34;
            }
          case 'components-preview':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$ComponentsPreview);
            } else {
              break _v0$34;
            }
          case 'more-options':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$MoreOptions);
            } else {
              break _v0$34;
            }
          case 'privacy-settings':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$PrivacySettings);
            } else {
              break _v0$34;
            }
          case 'notifications-settings':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$NotificationsSettings);
            } else {
              break _v0$34;
            }
          case 'edit-personal-details':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$EditPersonalDetails);
            } else {
              break _v0$34;
            }
          case 'change-password':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$ChangePassword);
            } else {
              break _v0$34;
            }
          case 'notifications':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$Notifications);
            } else {
              break _v0$34;
            }
          case 'feedback':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$Feedback);
            } else {
              break _v0$34;
            }
          case 'ban-user':
            if (_v0.b.b && !_v0.b.b.b) {
              var _v8 = _v0.b;
              var id = _v8.a;
              return $elm$core$Maybe$Just($author$project$Route$Route$BanUser(id));
            } else {
              break _v0$34;
            }
          case 'banned-users':
            if (!_v0.b.b) {
              return $elm$core$Maybe$Just($author$project$Route$Route$BannedUsers);
            } else {
              break _v0$34;
            }
          case 'intro':
            var branchRoute = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$Route$AppIntro, $author$project$Ui$AppIntro$Route$toRoute($author$project$ElmFramework$Lib$Url$path(branchRoute)));
          case 'onboard':
            var branchRoute = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$Route$OnboardUser, $author$project$Ui$OnboardUser$Route$toRoute($author$project$ElmFramework$Lib$Url$path(branchRoute)));
          case 'payment-methods':
            var branchRoute = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$Route$PaymentMethods, $author$project$Ui$PaymentMethods$Route$toRoute($author$project$ElmFramework$Lib$Url$path(branchRoute)));
          case 'match-making':
            var branchRoute = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$Route$Matchmaking, $author$project$Ui$Matchmaking$Route$toRoute($author$project$ElmFramework$Lib$Url$path(branchRoute)));
          case 'my-player-status':
            var branchRoute = _v0.b;
            return A2($elm$core$Maybe$map, $author$project$Route$Route$MyPlayerStatus, $author$project$Ui$MyPlayerStatus$Route$toRoute($author$project$ElmFramework$Lib$Url$path(branchRoute)));
          case 'player-profile':
            if (_v0.b.b) {
              if (!_v0.b.b.b) {
                var _v9 = _v0.b;
                var userId = _v9.a;
                return $elm$core$Maybe$Just($author$project$Route$Route$PlayerProfile($elm$core$Maybe$Just(userId)));
              } else {
                break _v0$34;
              }
            } else {
              return $elm$core$Maybe$Just($author$project$Route$Route$PlayerProfile($elm$core$Maybe$Nothing));
            }
          case 'match':
            if (_v0.b.b) {
              var _v10 = _v0.b;
              var matchId = _v10.a;
              var branchRoute = _v10.b;
              return A2($elm$core$Maybe$map, $author$project$Route$Route$Match(matchId), $author$project$Ui$Match$Route$toRoute($author$project$ElmFramework$Lib$Url$path(branchRoute)));
            } else {
              break _v0$34;
            }
          case 'auth':
            if (_v0.b.b && _v0.b.a === 'action' && !_v0.b.b.b) {
              var _v11 = _v0.b;
              var mode = A2($elm$core$Dict$get, 'mode', url.ex);
              var code = A2($elm$core$Dict$get, 'oobCode', url.ex);
              var args = A3($elm$core$Maybe$map2, F2(function (m, c) {
                return {
                  tg: m,
                  uo: c
                };
              }), mode, code);
              return $elm$core$Maybe$Just($author$project$Route$Route$AuthAction(args));
            } else {
              break _v0$34;
            }
          case 'invitation':
            if (_v0.b.b && _v0.b.b.b && !_v0.b.b.b.b) {
              switch (_v0.b.a) {
                case 'search':
                  var _v12 = _v0.b;
                  var _v13 = _v12.b;
                  var searchId = _v13.a;
                  return $elm$core$Maybe$Just($author$project$Route$Route$Invitation($author$project$Ui$Invitation$Route$Search(searchId)));
                case 'token':
                  var _v14 = _v0.b;
                  var _v15 = _v14.b;
                  var uuid = _v15.a;
                  return $elm$core$Maybe$Just($author$project$Route$Route$Invitation($author$project$Ui$Invitation$Route$Token(uuid)));
                default:
                  break _v0$34;
              }
            } else {
              break _v0$34;
            }
          default:
            break _v0$34;
        }
      } else {
        break _v0$34;
      }
    }
    return $elm$core$Maybe$Nothing;
  };
  var $author$project$Types$WebPageMetadata$cons = F2(function (theTitle, webPageMetadata) {
    return _Utils_update(webPageMetadata, {
      lh: _Utils_ap(theTitle, webPageMetadata.lh)
    });
  });
  var $author$project$Types$WebPageMetadata$title = function (theTitle) {
    return {
      vn: '',
      p4: _List_Nil,
      lh: theTitle
    };
  };
  var $author$project$Ui$AppIntro$Route$toRouteMetadata = function (onboardUserRoute) {
    switch (onboardUserRoute) {
      case 0:
        return $author$project$Types$WebPageMetadata$title('Locations');
      case 1:
        return $author$project$Types$WebPageMetadata$title('Players');
      default:
        return $author$project$Types$WebPageMetadata$title('History');
    }
  };
  var $author$project$Ui$EditUserActivities$Route$toRouteMetadata = function (editUserActivityRoute) {
    if (!editUserActivityRoute) {
      return $author$project$Types$WebPageMetadata$title('Sports');
    } else {
      return $author$project$Types$WebPageMetadata$title('Level');
    }
  };
  var $author$project$Ui$PaymentMethods$Route$toStringForRouteMetadata = function (onboardUserRoute) {
    if (!onboardUserRoute) {
      return 'Browse Payment Methods';
    } else {
      return 'Add Payment Method';
    }
  };
  var $author$project$Ui$Match$Route$toRouteMetadata = function (onboardUserRoute) {
    switch (onboardUserRoute.$) {
      case 0:
        return $author$project$Types$WebPageMetadata$title('Details');
      case 2:
        return $author$project$Types$WebPageMetadata$title('Cancel');
      case 3:
        return $author$project$Types$WebPageMetadata$title('Invoice');
      default:
        var paymentMethodsRoute = onboardUserRoute.a;
        return $author$project$Types$WebPageMetadata$title('Pay Match' + (' ' + $author$project$Ui$PaymentMethods$Route$toStringForRouteMetadata(paymentMethodsRoute)));
    }
  };
  var $author$project$Ui$AddPlayers$Route$toRouteMetadata = function (onboardUserRoute) {
    if (!onboardUserRoute.$) {
      return $author$project$Types$WebPageMetadata$title('Main');
    } else {
      return $author$project$Types$WebPageMetadata$title('Contacts Access');
    }
  };
  var $author$project$Ui$PaymentMethods$Route$toRouteMetadata = function (onboardUserRoute) {
    return $author$project$Types$WebPageMetadata$title($author$project$Ui$PaymentMethods$Route$toStringForRouteMetadata(onboardUserRoute));
  };
  var $author$project$Ui$Matchmaking$Checkout$Route$toRouteMetadata = function (onboardUserRoute) {
    if (!onboardUserRoute.$) {
      var sub = onboardUserRoute.a;
      return $author$project$Ui$PaymentMethods$Route$toRouteMetadata(sub);
    } else {
      return $author$project$Types$WebPageMetadata$title('Review');
    }
  };
  var $author$project$Ui$ProvideLocation$DrawerBranch$Route$toRouteMetadata = function (drawerBranchRoute) {
    if (!drawerBranchRoute) {
      return $author$project$Types$WebPageMetadata$title('Set Radius');
    } else {
      return $author$project$Types$WebPageMetadata$title('Enter Address');
    }
  };
  var $author$project$Ui$Matchmaking$Single$Route$toRouteMetadata = function (onboardUserRoute) {
    switch (onboardUserRoute.$) {
      case 0:
        return $author$project$Types$WebPageMetadata$title('New Search');
      case 1:
        var sub = onboardUserRoute.a;
        return A2($author$project$Types$WebPageMetadata$cons, 'Checkout - ', $author$project$Ui$Matchmaking$Checkout$Route$toRouteMetadata(sub));
      case 2:
        var sub = onboardUserRoute.a;
        return A2($author$project$Types$WebPageMetadata$cons, 'ProvideLocation', $author$project$Ui$ProvideLocation$DrawerBranch$Route$toRouteMetadata(sub));
      default:
        var sub = onboardUserRoute.a;
        return A2($author$project$Types$WebPageMetadata$cons, 'AddPlayers', $author$project$Ui$AddPlayers$Route$toRouteMetadata(sub));
    }
  };
  var $author$project$Ui$Matchmaking$Route$toRouteMetadata = function (onboardUserRoute) {
    var sub = onboardUserRoute;
    return $author$project$Ui$Matchmaking$Single$Route$toRouteMetadata(sub);
  };
  var $author$project$Ui$MyPlayerStatus$Route$toRouteMetadata = function (onboardUserRoute) {
    switch (onboardUserRoute.$) {
      case 0:
        return $author$project$Types$WebPageMetadata$title('Upcoming Matches');
      case 1:
        return $author$project$Types$WebPageMetadata$title('Match History');
      default:
        var subRoute = onboardUserRoute.a;
        return $author$project$Types$WebPageMetadata$title('Searches');
    }
  };
  var $author$project$Ui$OnboardUser$Route$toRouteMetadata = function (onboardUserRoute) {
    if (!onboardUserRoute.$) {
      if (onboardUserRoute.a.$ === 1) {
        var _v1 = onboardUserRoute.a;
        return $author$project$Types$WebPageMetadata$title('Personal');
      } else {
        var drawerBranchRoute = onboardUserRoute.a.a;
        return $author$project$Ui$ProvideLocation$DrawerBranch$Route$toRouteMetadata(drawerBranchRoute);
      }
    } else {
      var editUserActivityRoute = onboardUserRoute.a;
      return $author$project$Ui$EditUserActivities$Route$toRouteMetadata(editUserActivityRoute);
    }
  };
  var $author$project$Route$Route$toRouteMetadataFromLegalRoute = function (legalRoute) {
    if (!legalRoute) {
      return $author$project$Types$WebPageMetadata$title('Terms of use');
    } else {
      return $author$project$Types$WebPageMetadata$title('Privacy policy');
    }
  };
  var $author$project$Route$Route$toRouteMetadataFromSignInAction = function (signInAction) {
    switch (signInAction.$) {
      case 0:
        return $author$project$Types$WebPageMetadata$title('Sign In');
      case 1:
        return $author$project$Types$WebPageMetadata$title('Sign In: Resend email verification');
      case 2:
        var invitationRoute = signInAction.a;
        var respondSearchInviteOption = signInAction.b;
        return $author$project$Types$WebPageMetadata$title('Sign In: Respond to invitation');
      default:
        var invitationRoute = signInAction.a;
        var respondSearchInviteOption = signInAction.b;
        return $author$project$Types$WebPageMetadata$title('Sign In: Respond to invitation after creating user');
    }
  };
  var $author$project$Route$RouteUtil$toMetadata = F2(function (state, route) {
    switch (route.$) {
      case 0:
        switch (route.a.$) {
          case 1:
            if (route.a.a.$ === 1) {
              var _v1 = route.a;
              var _v2 = _v1.a;
              return $author$project$Types$WebPageMetadata$title('Register');
            } else {
              var _v3 = route.a;
              var _v4 = _v3.a.a;
              return $author$project$Types$WebPageMetadata$title('Register');
            }
          case 0:
            var _v5 = route.a;
            return $author$project$Types$WebPageMetadata$title('Choose Sign In Method');
          case 2:
            var sub = route.a.a;
            return $author$project$Route$Route$toRouteMetadataFromSignInAction(sub);
          case 3:
            var forgotPasswordStep = route.a.a;
            if (!forgotPasswordStep.$) {
              return $author$project$Types$WebPageMetadata$title('Forgot Password');
            } else {
              return $author$project$Types$WebPageMetadata$title('Forgot Password > Create New Password');
            }
          case 4:
            if (route.a.a.$ === 1) {
              var _v7 = route.a.a;
              return $author$project$Types$WebPageMetadata$title('Confirm Registration');
            } else {
              return $author$project$Types$WebPageMetadata$title('Confirm Registration From Link');
            }
          default:
            var _v8 = route.a;
            return $author$project$Types$WebPageMetadata$title('Account Created');
        }
      case 1:
        return $author$project$Types$WebPageMetadata$title('Authentication Actions');
      case 2:
        return $author$project$Types$WebPageMetadata$title('Support');
      case 3:
        var sub = route.a;
        return $author$project$Route$Route$toRouteMetadataFromLegalRoute(sub);
      case 5:
        var notificationInRoute = route.a;
        return $author$project$Types$WebPageMetadata$title('From notification');
      case 4:
        return $author$project$Types$WebPageMetadata$title('Components');
      case 6:
        return $author$project$Types$WebPageMetadata$title('More Options');
      case 7:
        return $author$project$Types$WebPageMetadata$title('Privacy Settings');
      case 8:
        return $author$project$Types$WebPageMetadata$title('Notifications Settings');
      case 9:
        return $author$project$Types$WebPageMetadata$title('Edit Personal Details');
      case 10:
        return $author$project$Types$WebPageMetadata$title('Change Password');
      case 11:
        return $author$project$Types$WebPageMetadata$title('Notifications');
      case 12:
        return $author$project$Types$WebPageMetadata$title('Feedback');
      case 13:
        return $author$project$Types$WebPageMetadata$title('Ban User');
      case 14:
        return $author$project$Types$WebPageMetadata$title('Banned Users');
      case 15:
        var sub = route.a;
        return A2($author$project$Types$WebPageMetadata$cons, 'Introduction: ', $author$project$Ui$AppIntro$Route$toRouteMetadata(sub));
      case 16:
        var sub = route.a;
        return A2($author$project$Types$WebPageMetadata$cons, 'Onboarding: ', $author$project$Ui$OnboardUser$Route$toRouteMetadata(sub));
      case 17:
        var sub = route.a;
        return A2($author$project$Types$WebPageMetadata$cons, 'Payment Methods: ', $author$project$Ui$PaymentMethods$Route$toRouteMetadata(sub));
      case 18:
        var sub = route.a;
        return A2($author$project$Types$WebPageMetadata$cons, 'Match Making: ', $author$project$Ui$Matchmaking$Route$toRouteMetadata(sub));
      case 19:
        var sub = route.a;
        return A2($author$project$Types$WebPageMetadata$cons, 'My Player Status: ', $author$project$Ui$MyPlayerStatus$Route$toRouteMetadata(sub));
      case 20:
        return $author$project$Types$WebPageMetadata$title('Player Profile');
      case 21:
        var sub = route.b;
        return A2($author$project$Types$WebPageMetadata$cons, 'Match: ', $author$project$Ui$Match$Route$toRouteMetadata(sub));
      case 22:
        var sub = route.a;
        return A2($author$project$Types$WebPageMetadata$cons, 'Edit Sports: ', $author$project$Ui$EditUserActivities$Route$toRouteMetadata(sub));
      default:
        var uuid = route.a;
        return $author$project$Types$WebPageMetadata$title('Invitation');
    }
  });
  var $author$project$ElmFramework$Lib$Url$appendQueryParams = F2(function (queryParams, url) {
    return _Utils_update(url, {
      ex: queryParams
    });
  });
  var $author$project$ElmFramework$Lib$Url$cons = F2(function (base, url) {
    return _Utils_update(url, {
      cb: _Utils_ap(base, url.cb)
    });
  });
  var $author$project$Ui$AppIntro$Route$toUrl = function (route) {
    switch (route) {
      case 0:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['locations']));
      case 1:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['players']));
      default:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['history']));
    }
  };
  var $author$project$Ui$EditUserActivities$Route$toUrl = function (route) {
    if (!route) {
      return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['sport']));
    } else {
      return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['level']));
    }
  };
  var $author$project$Ui$PaymentMethods$Route$toListStringForUrl = function (route) {
    if (!route) {
      return _List_fromArray(['browse']);
    } else {
      return _List_fromArray(['add']);
    }
  };
  var $author$project$Ui$Match$Route$toUrl = function (route) {
    switch (route.$) {
      case 0:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['details']));
      case 2:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['cancel']));
      case 3:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['invoice']));
      default:
        var paymentMethodsRoute = route.a;
        if (!paymentMethodsRoute) {
          return $author$project$ElmFramework$Lib$Url$path(_Utils_ap(_List_fromArray(['payment']), $author$project$Ui$PaymentMethods$Route$toListStringForUrl(paymentMethodsRoute)));
        } else {
          return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['payment', 'add']));
        }
    }
  };
  var $author$project$Ui$AddPlayers$Route$toUrl = function (route) {
    if (!route.$) {
      var creatOrEdit = route.a;
      return $author$project$ElmFramework$Lib$Url$path(function () {
        if (!creatOrEdit.$) {
          return _List_fromArray(['main']);
        } else {
          var id = creatOrEdit.a;
          return _List_fromArray(['main', id]);
        }
      }());
    } else {
      return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['contacts-access']));
    }
  };
  var $author$project$Ui$PaymentMethods$Route$toUrl = function (route) {
    return $author$project$ElmFramework$Lib$Url$path($author$project$Ui$PaymentMethods$Route$toListStringForUrl(route));
  };
  var $author$project$Ui$Matchmaking$Checkout$Route$toUrl = function (route) {
    if (!route.$) {
      var branchRoute = route.a;
      return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['payment']), $author$project$Ui$PaymentMethods$Route$toUrl(branchRoute));
    } else {
      var paymentMethodId = route.a;
      return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['review', paymentMethodId]));
    }
  };
  var $author$project$Ui$ProvideLocation$DrawerBranch$Route$toUrl = function (route) {
    if (!route) {
      return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['radius']));
    } else {
      return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['address']));
    }
  };
  var $author$project$Ui$Matchmaking$Single$Route$toUrl = function (route) {
    switch (route.$) {
      case 0:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['single']));
      case 1:
        var branchRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['checkout']), $author$project$Ui$Matchmaking$Checkout$Route$toUrl(branchRoute));
      case 2:
        var branchRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['provide-location']), $author$project$Ui$ProvideLocation$DrawerBranch$Route$toUrl(branchRoute));
      default:
        var branchRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['add-players']), $author$project$Ui$AddPlayers$Route$toUrl(branchRoute));
    }
  };
  var $author$project$Ui$Matchmaking$Route$toUrl = function (route) {
    var branchRoute = route;
    return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['single']), $author$project$Ui$Matchmaking$Single$Route$toUrl(branchRoute));
  };
  var $author$project$Ui$MyPlayerStatus$Searches$Route$toUrlString = function (route) {
    switch (route.$) {
      case 0:
        return _List_fromArray(['searches']);
      case 1:
        var id = route.a;
        return _List_fromArray(['edit', id]);
      default:
        var id = route.a;
        return _List_fromArray(['cancel', id]);
    }
  };
  var $author$project$Ui$MyPlayerStatus$Route$toUrl = function (route) {
    switch (route.$) {
      case 0:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['upcoming-matches']));
      case 1:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['match-history']));
      default:
        var subRoute = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_Utils_ap(_List_fromArray(['searches']), $author$project$Ui$MyPlayerStatus$Searches$Route$toUrlString(subRoute)));
    }
  };
  var $author$project$Ui$OnboardUser$Route$toUrl = function (route) {
    if (!route.$) {
      var maybeSubroute = route.a;
      return A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['personal'])), A2($elm$core$Maybe$map, $author$project$ElmFramework$Lib$Url$cons(_List_fromArray(['personal'])), A2($elm$core$Maybe$map, $author$project$Ui$ProvideLocation$DrawerBranch$Route$toUrl, maybeSubroute)));
    } else {
      var editUserActivityRoute = route.a;
      return $author$project$Ui$EditUserActivities$Route$toUrl(editUserActivityRoute);
    }
  };
  var $author$project$Route$RouteMappers$urlFor = function (route) {
    switch (route.$) {
      case 0:
        switch (route.a.$) {
          case 1:
            if (!route.a.a.$) {
              var _v1 = route.a;
              var _v2 = _v1.a.a;
              return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['register', 'accept-terms']));
            } else {
              var _v3 = route.a;
              return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['register']));
            }
          case 0:
            var _v4 = route.a;
            return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['sign-in']));
          case 2:
            return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['sign-in', 'credentials']));
          case 3:
            var forgotPasswordStep = route.a.a;
            if (!forgotPasswordStep.$) {
              return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['forgot-password']));
            } else {
              var codeString = forgotPasswordStep.a;
              return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['forgot-password', 'create-new-password']));
            }
          case 4:
            if (route.a.a.$ === 1) {
              var _v6 = route.a.a;
              return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['confirm-registration']));
            } else {
              var username = route.a.a.a.sZ;
              var code = route.a.a.a.uo;
              return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['confirm-registration', username, code]));
            }
          default:
            var _v7 = route.a;
            return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['account-created']));
        }
      case 1:
        if (!route.a.$) {
          var action = route.a.a.tg;
          var code = route.a.a.uo;
          return A2($author$project$ElmFramework$Lib$Url$appendQueryParams, $elm$core$Dict$fromList(_List_fromArray([_Utils_Tuple2('mode', action), _Utils_Tuple2('oobCode', code)])), $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['auth', 'action'])));
        } else {
          var _v8 = route.a;
          return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['auth', 'action']));
        }
      case 2:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['/support']));
      case 3:
        var subRoute = route.a;
        if (!subRoute) {
          return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['legal', 'terms-of-use']));
        } else {
          return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['legal', 'privacy-policy']));
        }
      case 5:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['from-notification']));
      case 4:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['components-preview']));
      case 6:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['more-options']));
      case 7:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['privacy-settings']));
      case 8:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['notifications-settings']));
      case 9:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['edit-personal-details']));
      case 10:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['change-password']));
      case 11:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['notifications']));
      case 12:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['feedback']));
      case 13:
        var userId = route.a;
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['ban-user', userId]));
      case 14:
        return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['banned-users']));
      case 15:
        var branchRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['intro']), $author$project$Ui$AppIntro$Route$toUrl(branchRoute));
      case 16:
        var branchRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['onboard']), $author$project$Ui$OnboardUser$Route$toUrl(branchRoute));
      case 17:
        var branchRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['payment-methods']), $author$project$Ui$PaymentMethods$Route$toUrl(branchRoute));
      case 18:
        var branchRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['match-making']), $author$project$Ui$Matchmaking$Route$toUrl(branchRoute));
      case 19:
        var branchRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['my-player-status']), $author$project$Ui$MyPlayerStatus$Route$toUrl(branchRoute));
      case 20:
        var maybeUserId = route.a;
        return $author$project$ElmFramework$Lib$Url$path(function () {
          if (maybeUserId.$ === 1) {
            return _List_fromArray(['player-profile']);
          } else {
            var userId = maybeUserId.a;
            return _List_fromArray(['player-profile', $author$project$Types$User$unwrapUserId(userId)]);
          }
        }());
      case 21:
        var matchId = route.a;
        var branchRoute = route.b;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['match', matchId]), $author$project$Ui$Match$Route$toUrl(branchRoute));
      case 22:
        var branchRoute = route.a;
        return A2($author$project$ElmFramework$Lib$Url$cons, _List_fromArray(['edit-user-sports']), $author$project$Ui$EditUserActivities$Route$toUrl(branchRoute));
      default:
        var subRoute = route.a;
        if (!subRoute.$) {
          var uuid = subRoute.a;
          return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['invitation', 'token', uuid]));
        } else {
          var searchId = subRoute.a;
          return $author$project$ElmFramework$Lib$Url$path(_List_fromArray(['invitation', 'search', searchId]));
        }
    }
  };
  var $author$project$MainModule$routingConfig = function () {
    var toTitleDescription = function (_v0) {
      var title = _v0.lh;
      var description = _v0.vn;
      return {
        vn: description,
        lh: title
      };
    };
    return {
      tC: $author$project$Route$Route$Auth(A2($author$project$Route$Route$Register, $elm$core$Maybe$Nothing, $author$project$Route$Route$DefaultRegistration)),
      wB: $author$project$Route$Route$homeRoute,
      w7: $author$project$Route$RouteUtil$isAuthRoute,
      w8: function (appState) {
        return $author$project$Types$UserSessionStatus$isAuthenticated(appState.A$.sX);
      },
      zm: $author$project$MainModule$onNewRouteMsgs,
      AV: $author$project$MainModule$redirect,
      Bs: $author$project$Route$RouteUtil$requiresAuthentication,
      Bx: F2(function (state, route) {
        return toTitleDescription(A2($author$project$Route$RouteUtil$toMetadata, state, route));
      }),
      By: $author$project$Route$RouteMappers$urlFor,
      C7: $author$project$Route$RouteMappers$routeFor,
      Dd: $author$project$MainModule$onUserWantsBack,
      De: $author$project$MainModule$onUserWantsForward
    };
  }();
  var $author$project$Ui$AddPlayers$Msg$FailedToReceiveContactsFromDevice = {
    $: 9
  };
  var $author$project$Ui$Auth$UserSession$Msg$ReceiveContactsPermissionsStatus = function (a) {
    return {
      $: 5,
      a: a
    };
  };
  var $author$project$Ui$AddPlayers$Msg$ReceivedContactsFromDevice = function (a) {
    return {
      $: 8,
      a: a
    };
  };
  var $author$project$Global$Msg$ReceivePreFetchedCommonStaticFile = function (a) {
    return {
      $: 8,
      a: a
    };
  };
  var $author$project$Global$Msg$ReceiveVault = function (a) {
    return {
      $: 6,
      a: a
    };
  };
  var $author$project$Global$Model$emptyVault = {
    qf: _List_Nil
  };
  var $author$project$Global$Model$VaultModel = function (paymentCards) {
    return {
      qf: paymentCards
    };
  };
  var $author$project$Model$Payments$PaymentCardNoCode = F3(function (cardNo, expMonth, expYear) {
    return {
      he: cardNo,
      hW: expMonth,
      hX: expYear
    };
  });
  var $elm$json$Json$Decode$map3 = _Json_map3;
  var $author$project$Model$Payments$paymentCardDecoder = A4($elm$json$Json$Decode$map3, $author$project$Model$Payments$PaymentCardNoCode, A2($elm$json$Json$Decode$field, 'cardNo', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'expMonth', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'expYear', $elm$json$Json$Decode$string));
  var $author$project$Global$Model$vaultDecoder = A2($elm$json$Json$Decode$map, $author$project$Global$Model$VaultModel, A2($elm$json$Json$Decode$field, 'paymentCards', $elm$json$Json$Decode$list($author$project$Model$Payments$paymentCardDecoder)));
  var $author$project$Global$Model$decodeVault = function (_v0) {
    var isSupported = _v0.xk;
    var vault = _v0.gT;
    return isSupported ? $elm$core$Maybe$Just(A2($elm$core$Maybe$withDefault, $author$project$Global$Model$emptyVault, A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeL, $elm$core$Result$toMaybe, $elm$json$Json$Decode$decodeString($author$project$Global$Model$vaultDecoder)), vault))) : $elm$core$Maybe$Nothing;
  };
  var $author$project$Persistence$receivePreFetchedCommonStaticFile = _Platform_incomingPort('receivePreFetchedCommonStaticFile', $elm$json$Json$Decode$string);
  var $author$project$Global$Ports$receiveVault = _Platform_incomingPort('receiveVault', A2($elm$json$Json$Decode$andThen, function (vault) {
    return A2($elm$json$Json$Decode$andThen, function (isSupported) {
      return $elm$json$Json$Decode$succeed({
        xk: isSupported,
        gT: vault
      });
    }, A2($elm$json$Json$Decode$field, 'isSupported', $elm$json$Json$Decode$bool));
  }, A2($elm$json$Json$Decode$field, 'vault', $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)])))));
  var $author$project$Global$Global$subscriptions = function (_v0) {
    return $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$Persistence$receivePreFetchedCommonStaticFile(A2($elm$core$Basics$composeL, $author$project$Global$Msg$ReceivePreFetchedCommonStaticFile, $author$project$Model$CommonStaticFile$decodePersistedCommonStatic)), $author$project$Global$Ports$receiveVault(A2($elm$core$Basics$composeL, $author$project$Global$Msg$ReceiveVault, $author$project$Global$Model$decodeVault))]));
  };
  var $author$project$Ui$Match$Msg$RefreshMatch = function (a) {
    return {
      $: 8,
      a: a
    };
  };
  var $author$project$Ui$Match$Update$subscriptions = F2(function (model, route) {
    var refreshMatch = function () {
      var _v0 = _Utils_Tuple2(route, model.rf > 0);
      if (_v0.a.$ === 21) {
        if (!_v0.b) {
          var _v1 = _v0.a;
          var matchId = _v1.a;
          return A2($elm$time$Time$every, 10 * $author$project$ElmFramework$Lib$Util$timeInterval.rt, $elm$core$Basics$always($author$project$Ui$Match$Msg$RefreshMatch(matchId)));
        } else {
          var _v2 = _v0.a;
          var matchId = _v2.a;
          return A2($elm$time$Time$every, 990, $elm$core$Basics$always($author$project$Ui$Match$Msg$RefreshMatch(matchId)));
        }
      } else {
        return $elm$core$Platform$Sub$none;
      }
    }();
    return refreshMatch;
  });
  var $author$project$Remote$Msg$HistoryMatchesEndlessListMsg = F4(function (a, b, c, d) {
    return {
      $: 4,
      a: a,
      b: b,
      c: c,
      d: d
    };
  });
  var $author$project$Remote$Msg$NextMatchesEndlessListMsg = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$RefetchContent = {
    $: 1
  };
  var $author$project$Remote$Msg$SearchesEndlessListMsg = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$MyPlayerStatus$Msg$Ticked = {
    $: 6
  };
  var $author$project$TopMsg$msgMyPlayerStatus = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$MyPlayerStatusMsg);
  var $elm_community$string_extra$String$Extra$nonEmpty = function (string) {
    return $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
  };
  var $author$project$Ui$MyPlayerStatus$Update$subscriptions = F2(function (_v0, route) {
    var rapidPollTicker = _v0.qS;
    var dateOrder = _v0.cF;
    var textSearch = _v0.sn;
    var maybeSearch = $elm_community$string_extra$String$Extra$nonEmpty(textSearch);
    var refetchAllContent = $author$project$ElmFramework$MsgCmd$msgCmd.yw(_List_fromArray([$author$project$TopMsg$remoteMsg(A2($author$project$Remote$Msg$SearchesEndlessListMsg, false, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$RefetchContent)), $author$project$TopMsg$remoteMsg(A2($author$project$Remote$Msg$NextMatchesEndlessListMsg, false, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$RefetchContent)), $author$project$TopMsg$remoteMsg(A4($author$project$Remote$Msg$HistoryMatchesEndlessListMsg, false, maybeSearch, dateOrder, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$RefetchContent))]));
    var refreshSearchesList = function () {
      var _v1 = _Utils_Tuple2(route, rapidPollTicker > 0);
      _v1$4: while (true) {
        if (_v1.a.$ === 19) {
          switch (_v1.a.a.$) {
            case 2:
              if (!_v1.a.a.a.$) {
                if (!_v1.b) {
                  var _v2 = _v1.a.a.a;
                  return A2($elm$time$Time$every, 10 * $author$project$ElmFramework$Lib$Util$timeInterval.rt, $elm$core$Basics$always(refetchAllContent));
                } else {
                  var _v3 = _v1.a.a.a;
                  return A2($elm$time$Time$every, 1 * $author$project$ElmFramework$Lib$Util$timeInterval.rt, $elm$core$Basics$always($author$project$ElmFramework$MsgCmd$msgCmd.yw(_List_fromArray([$author$project$TopMsg$remoteMsg(A2($author$project$Remote$Msg$SearchesEndlessListMsg, false, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$RefetchContent)), $author$project$TopMsg$msgMyPlayerStatus($author$project$Ui$MyPlayerStatus$Msg$Ticked)]))));
                }
              } else {
                break _v1$4;
              }
            case 0:
              var _v4 = _v1.a.a;
              return A2($elm$time$Time$every, 10 * $author$project$ElmFramework$Lib$Util$timeInterval.rt, $elm$core$Basics$always(refetchAllContent));
            default:
              var _v5 = _v1.a.a;
              return A2($elm$time$Time$every, 10 * $author$project$ElmFramework$Lib$Util$timeInterval.rt, $elm$core$Basics$always(refetchAllContent));
          }
        } else {
          break _v1$4;
        }
      }
      return $elm$core$Platform$Sub$none;
    }();
    return refreshSearchesList;
  });
  var $author$project$Ui$PaymentMethods$Edit$Msg$OnSavePaymentMethodResult = function (a) {
    return {
      $: 6,
      a: a
    };
  };
  var $author$project$Ui$PaymentMethods$Edit$Msg$OnSubmitPaymentResult = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $author$project$Ui$PaymentMethods$Edit$Update$paymentStatusToResult = function (status) {
    return status === 'succeeded' ? $elm$core$Result$Ok(0) : $elm$core$Result$Err('Your payment was not completed. The status of your payment is: ' + (status + '.'));
  };
  var $author$project$ElmFramework$Lib$Stripe$StripePorts$receiveStripeConfirmPaymentFailure = _Platform_incomingPort('receiveStripeConfirmPaymentFailure', $elm$json$Json$Decode$string);
  var $author$project$ElmFramework$Lib$Stripe$StripePorts$receiveStripeConfirmPaymentSuccess = _Platform_incomingPort('receiveStripeConfirmPaymentSuccess', $elm$json$Json$Decode$string);
  var $author$project$ElmFramework$Lib$Stripe$StripePorts$receiveStripeConfirmSetupFailure = _Platform_incomingPort('receiveStripeConfirmSetupFailure', $elm$json$Json$Decode$string);
  var $author$project$ElmFramework$Lib$Stripe$StripePorts$receiveStripeConfirmSetupSuccess = _Platform_incomingPort('receiveStripeConfirmSetupSuccess', $elm$json$Json$Decode$null(0));
  var $author$project$Ui$PaymentMethods$Edit$Update$subscriptions = $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Lib$Stripe$StripePorts$receiveStripeConfirmPaymentSuccess(A2($elm$core$Basics$composeL, $author$project$Ui$PaymentMethods$Edit$Msg$OnSubmitPaymentResult, $author$project$Ui$PaymentMethods$Edit$Update$paymentStatusToResult)), $author$project$ElmFramework$Lib$Stripe$StripePorts$receiveStripeConfirmPaymentFailure(A2($elm$core$Basics$composeL, $author$project$Ui$PaymentMethods$Edit$Msg$OnSubmitPaymentResult, $elm$core$Result$Err)), $author$project$ElmFramework$Lib$Stripe$StripePorts$receiveStripeConfirmSetupSuccess(A2($elm$core$Basics$composeL, $author$project$Ui$PaymentMethods$Edit$Msg$OnSavePaymentMethodResult, $elm$core$Basics$always($elm$core$Result$Ok(0)))), $author$project$ElmFramework$Lib$Stripe$StripePorts$receiveStripeConfirmSetupFailure(A2($elm$core$Basics$composeL, $author$project$Ui$PaymentMethods$Edit$Msg$OnSavePaymentMethodResult, $elm$core$Result$Err))]));
  var $author$project$Ui$PaymentMethods$Msg$SubmitPaymentWithSelectedPaymentMethodForMatchResult = function (a) {
    return {
      $: 7,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$Stripe$StripePorts$receiveStripeConfirmCardPaymentFailure = _Platform_incomingPort('receiveStripeConfirmCardPaymentFailure', $elm$json$Json$Decode$string);
  var $author$project$ElmFramework$Lib$Stripe$StripePorts$receiveStripeConfirmCardPaymentSuccess = _Platform_incomingPort('receiveStripeConfirmCardPaymentSuccess', $elm$json$Json$Decode$string);
  var $author$project$Ui$PaymentMethods$Update$subscriptions = function (route) {
    return $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Lib$Stripe$StripePorts$receiveStripeConfirmCardPaymentSuccess(A2($elm$core$Basics$composeL, $author$project$Ui$PaymentMethods$Msg$SubmitPaymentWithSelectedPaymentMethodForMatchResult, $author$project$Ui$PaymentMethods$Edit$Update$paymentStatusToResult)), $author$project$ElmFramework$Lib$Stripe$StripePorts$receiveStripeConfirmCardPaymentFailure(A2($elm$core$Basics$composeL, $author$project$Ui$PaymentMethods$Msg$SubmitPaymentWithSelectedPaymentMethodForMatchResult, $elm$core$Result$Err))]));
  };
  var $author$project$Ui$ProvideLocation$Msg$ReceivedPlacePredictions = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Places$Places$receivePlacePredictions = _Platform_incomingPort('receivePlacePredictions', A2($elm$json$Json$Decode$andThen, function (maybePlacePredictions) {
    return A2($elm$json$Json$Decode$andThen, function (input) {
      return $elm$json$Json$Decode$succeed({
        t: input,
        pe: maybePlacePredictions
      });
    }, A2($elm$json$Json$Decode$field, 'input', $elm$json$Json$Decode$string));
  }, A2($elm$json$Json$Decode$field, 'maybePlacePredictions', $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$list(A2($elm$json$Json$Decode$andThen, function (types) {
    return A2($elm$json$Json$Decode$andThen, function (placeId) {
      return A2($elm$json$Json$Decode$andThen, function (placeDescription) {
        return $elm$json$Json$Decode$succeed({
          qt: placeDescription,
          qu: placeId,
          sF: types
        });
      }, A2($elm$json$Json$Decode$field, 'placeDescription', $elm$json$Json$Decode$string));
    }, A2($elm$json$Json$Decode$field, 'placeId', $elm$json$Json$Decode$string));
  }, A2($elm$json$Json$Decode$field, 'types', $elm$json$Json$Decode$list($elm$json$Json$Decode$string)))))])))));
  var $author$project$ElmFramework$Feature$Places$Places$subscriptions = function (tag) {
    return $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$Places$Places$receivePlacePredictions(tag)]));
  };
  var $author$project$Ui$ProvideLocation$Subscriptions$subscriptions = $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$Places$Places$subscriptions($author$project$Ui$ProvideLocation$Msg$ReceivedPlacePredictions)]));
  var $author$project$ElmFramework$Feature$Contacts$Contacts$receiveContacts = _Platform_incomingPort('receiveContacts', $elm$json$Json$Decode$list(A2($elm$json$Json$Decode$andThen, function (phoneNumbers) {
    return A2($elm$json$Json$Decode$andThen, function (emails) {
      return $elm$json$Json$Decode$succeed({
        ne: emails,
        qp: phoneNumbers
      });
    }, A2($elm$json$Json$Decode$field, 'emails', $elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
  }, A2($elm$json$Json$Decode$field, 'phoneNumbers', $elm$json$Json$Decode$list($elm$json$Json$Decode$string)))));
  var $author$project$ElmFramework$Feature$Contacts$Contacts$subscriptionsContacts = function (tag) {
    return $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$Contacts$Contacts$receiveContacts(tag)]));
  };
  var $author$project$ElmFramework$Feature$Contacts$Contacts$ContactsPermissionsDeniedAlways = 2;
  var $author$project$ElmFramework$Feature$Contacts$Contacts$ContactsPermissionsDeniedOnce = 3;
  var $author$project$ElmFramework$Feature$Contacts$Contacts$ContactsPermissionsGranted = 1;
  var $author$project$ElmFramework$Feature$Contacts$Contacts$ContactsPermissionsRestricted = 4;
  var $author$project$ElmFramework$Feature$Contacts$Contacts$ContactsPermissionsUnknown = 0;
  var $author$project$ElmFramework$Feature$Contacts$Contacts$decodeContactsPermissions = function (locationPermissions) {
    switch (locationPermissions) {
      case 'NOT_REQUESTED':
        return $elm$core$Result$Ok(0);
      case 'GRANTED':
        return $elm$core$Result$Ok(1);
      case 'GRANTED_WHEN_IN_USE':
        return $elm$core$Result$Ok(1);
      case 'RESTRICTED':
        return $elm$core$Result$Ok(4);
      case 'DENIED_ALWAYS':
        return $elm$core$Result$Ok(2);
      case 'DENIED':
        return $elm$core$Result$Ok(3);
      default:
        return $elm$core$Result$Err('decodeLocationPermissions: unexpected locationPermissions: ' + locationPermissions);
    }
  };
  var $author$project$ElmFramework$Feature$Contacts$Contacts$receiveContactsPermissionsStatus = _Platform_incomingPort('receiveContactsPermissionsStatus', $elm$json$Json$Decode$string);
  var $author$project$ElmFramework$Feature$Contacts$Contacts$subscriptionsContactsPermissions = function (tag) {
    return $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$Contacts$Contacts$receiveContactsPermissionsStatus(A2($elm$core$Basics$composeR, $author$project$ElmFramework$Feature$Contacts$Contacts$decodeContactsPermissions, tag))]));
  };
  var $author$project$ElmFramework$Feature$Contacts$Contacts$failedToReceiveContacts = _Platform_incomingPort('failedToReceiveContacts', $elm$json$Json$Decode$null(0));
  var $author$project$ElmFramework$Feature$Contacts$Contacts$subscriptionsFailedToReceiveContacts = function (tag) {
    return $elm$core$Platform$Sub$batch(_List_fromArray([$author$project$ElmFramework$Feature$Contacts$Contacts$failedToReceiveContacts(tag)]));
  };
  var $author$project$MainModule$subscriptions = function (_v0) {
    var appState = _v0.lL;
    var route = _v0.rh;
    return $elm$core$Platform$Sub$batch(_List_fromArray([A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$GlobalMsg), $author$project$Global$Global$subscriptions(appState.nV)), A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$ProvideLocationMsg), $author$project$Ui$ProvideLocation$Subscriptions$subscriptions), A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$PaymentMethodsMsg), $author$project$Ui$PaymentMethods$Msg$EditMsgReceived), $author$project$Ui$PaymentMethods$Edit$Update$subscriptions), A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$PaymentMethodsMsg), $author$project$Ui$PaymentMethods$Update$subscriptions($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(route))), A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$AddPlayersMsg), $author$project$ElmFramework$Feature$Contacts$Contacts$subscriptionsContacts($author$project$Ui$AddPlayers$Msg$ReceivedContactsFromDevice)), A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$AddPlayersMsg), $author$project$ElmFramework$Feature$Contacts$Contacts$subscriptionsFailedToReceiveContacts($elm$core$Basics$always($author$project$Ui$AddPlayers$Msg$FailedToReceiveContactsFromDevice))), A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$UserSessionMsg), $author$project$ElmFramework$Feature$Contacts$Contacts$subscriptionsContactsPermissions($author$project$Ui$Auth$UserSession$Msg$ReceiveContactsPermissionsStatus)), A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$MatchMsg), A2($author$project$Ui$Match$Update$subscriptions, appState.xZ, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(route))), A2($author$project$Ui$MyPlayerStatus$Update$subscriptions, appState.yy, $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(route))]));
  };
  var $author$project$Ui$Auth$Model$toBadgeCount = 0;
  var $author$project$Msg$ComponentsPreviewMsg = function (a) {
    return {
      $: 9,
      a: a
    };
  };
  var $author$project$Msg$EditingUserActivitiesMsg = function (a) {
    return {
      $: 22,
      a: a
    };
  };
  var $author$project$Msg$EditingUserProfileMsg = function (a) {
    return {
      $: 21,
      a: a
    };
  };
  var $author$project$Msg$FeedbackMsg = function (a) {
    return {
      $: 16,
      a: a
    };
  };
  var $author$project$Msg$LegalMsg = function (a) {
    return {
      $: 7,
      a: a
    };
  };
  var $author$project$Msg$MoreOptionsMsg = function (a) {
    return {
      $: 26,
      a: a
    };
  };
  var $author$project$Types$UserSessionStatus$Onboarded = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Msg$PushMessagesMsg = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Msg$RemoteResponseMsg = F2(function (a, b) {
    return {
      $: 12,
      a: a,
      b: b
    };
  });
  var $author$project$Util$outMsgHandlerTopmost = function (_v0) {
    var updated = _v0.sN;
    var msgTag = _v0.py;
    var stateSetter = _v0.r4;
    return function (_v1) {
      var childState = _v1.a;
      var childCmd = _v1.b;
      var msgs = _v1.c;
      return _Utils_Tuple3(stateSetter(childState), A2($elm$core$Platform$Cmd$map, msgTag, childCmd), msgs);
    }(updated);
  };
  var $author$project$Types$UserSessionStatus$toSession = function (userSessionStatus) {
    switch (userSessionStatus.$) {
      case 0:
        return $elm$core$Maybe$Nothing;
      case 1:
        return $elm$core$Maybe$Nothing;
      case 2:
        return $elm$core$Maybe$Nothing;
      default:
        var userSession = userSessionStatus.a;
        return $elm$core$Maybe$Just(userSession);
    }
  };
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$FetchPage = {
    $: 0
  };
  var $author$project$Model$Geo$IpTypeGeolocation = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Global$Msg$ReceiveCommonStaticFile = F2(function (a, b) {
    return {
      $: 7,
      a: a,
      b: b
    };
  });
  var $author$project$Route$Route$authEntryRoute = $author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials($author$project$Route$Route$DefaultSignIn));
  var $author$project$Global$Global$defaultIpGeolocation = {
    ug: $elm$core$Maybe$Just('Skopje'),
    uR: 'MK',
    uS: 'Macedonia',
    wk: {
      oV: 42.0062,
      o_: 21.4125
    },
    w6: '',
    ac: $elm$core$Maybe$Just('mk'),
    DI: $elm$core$Maybe$Just('1000')
  };
  var $author$project$Language$encodeLangDetails = function (lang) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('longName', $elm$json$Json$Encode$string(lang.xW)), _Utils_Tuple2('shortName', $elm$json$Json$Encode$string(lang.BW)), _Utils_Tuple2('countryFlagEmoji', $elm$json$Json$Encode$string(lang.hy)), _Utils_Tuple2('longNameNative', $elm$json$Json$Encode$string(lang.iV)), _Utils_Tuple2('countryShortName', $elm$json$Json$Encode$string(lang.hz))]));
  };
  var $author$project$Model$CommonStaticFile$encodeCommonStaticFile = F2(function (lang, phrasesString) {
    return A2($elm$json$Json$Encode$encode, 0, $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('language', $author$project$Language$encodeLangDetails(lang)), _Utils_Tuple2('commonStaticFile', $elm$json$Json$Encode$string(phrasesString))])));
  });
  var $author$project$Model$Payments$encodePaymentCard = function (card) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('cardNo', $elm$json$Json$Encode$string(card.he)), _Utils_Tuple2('expMonth', $elm$json$Json$Encode$string(card.hW)), _Utils_Tuple2('expYear', $elm$json$Json$Encode$string(card.hX))]));
  };
  var $author$project$Global$Model$encodeVault = function (vault) {
    return A2($elm$json$Json$Encode$encode, 0, $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('paymentCards', A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, A2($elm$core$List$map, $author$project$Model$Payments$encodePaymentCard, vault.qf)))])));
  };
  var $turboMaCk$any_dict$Dict$Any$removeAll = function (_v0) {
    var inner = _v0;
    return {
      B: $elm$core$Dict$empty,
      a8: inner.a8
    };
  };
  var $elm$core$Dict$getMin = function (dict) {
    getMin: while (true) {
      if (dict.$ === -1 && dict.d.$ === -1) {
        var left = dict.d;
        var $temp$dict = left;
        dict = $temp$dict;
        continue getMin;
      } else {
        return dict;
      }
    }
  };
  var $elm$core$Dict$moveRedLeft = function (dict) {
    if (dict.$ === -1 && dict.d.$ === -1 && dict.e.$ === -1) {
      if (dict.e.d.$ === -1 && !dict.e.d.a) {
        var clr = dict.a;
        var k = dict.b;
        var v = dict.c;
        var _v1 = dict.d;
        var lClr = _v1.a;
        var lK = _v1.b;
        var lV = _v1.c;
        var lLeft = _v1.d;
        var lRight = _v1.e;
        var _v2 = dict.e;
        var rClr = _v2.a;
        var rK = _v2.b;
        var rV = _v2.c;
        var rLeft = _v2.d;
        var _v3 = rLeft.a;
        var rlK = rLeft.b;
        var rlV = rLeft.c;
        var rlL = rLeft.d;
        var rlR = rLeft.e;
        var rRight = _v2.e;
        return A5($elm$core$Dict$RBNode_elm_builtin, 0, rlK, rlV, A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight), rlL), A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
      } else {
        var clr = dict.a;
        var k = dict.b;
        var v = dict.c;
        var _v4 = dict.d;
        var lClr = _v4.a;
        var lK = _v4.b;
        var lV = _v4.c;
        var lLeft = _v4.d;
        var lRight = _v4.e;
        var _v5 = dict.e;
        var rClr = _v5.a;
        var rK = _v5.b;
        var rV = _v5.c;
        var rLeft = _v5.d;
        var rRight = _v5.e;
        if (clr === 1) {
          return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
        } else {
          return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
        }
      }
    } else {
      return dict;
    }
  };
  var $elm$core$Dict$moveRedRight = function (dict) {
    if (dict.$ === -1 && dict.d.$ === -1 && dict.e.$ === -1) {
      if (dict.d.d.$ === -1 && !dict.d.d.a) {
        var clr = dict.a;
        var k = dict.b;
        var v = dict.c;
        var _v1 = dict.d;
        var lClr = _v1.a;
        var lK = _v1.b;
        var lV = _v1.c;
        var _v2 = _v1.d;
        var _v3 = _v2.a;
        var llK = _v2.b;
        var llV = _v2.c;
        var llLeft = _v2.d;
        var llRight = _v2.e;
        var lRight = _v1.e;
        var _v4 = dict.e;
        var rClr = _v4.a;
        var rK = _v4.b;
        var rV = _v4.c;
        var rLeft = _v4.d;
        var rRight = _v4.e;
        return A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight), A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, lRight, A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
      } else {
        var clr = dict.a;
        var k = dict.b;
        var v = dict.c;
        var _v5 = dict.d;
        var lClr = _v5.a;
        var lK = _v5.b;
        var lV = _v5.c;
        var lLeft = _v5.d;
        var lRight = _v5.e;
        var _v6 = dict.e;
        var rClr = _v6.a;
        var rK = _v6.b;
        var rV = _v6.c;
        var rLeft = _v6.d;
        var rRight = _v6.e;
        if (clr === 1) {
          return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
        } else {
          return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
        }
      }
    } else {
      return dict;
    }
  };
  var $elm$core$Dict$removeHelpPrepEQGT = F7(function (targetKey, dict, color, key, value, left, right) {
    if (left.$ === -1 && !left.a) {
      var _v1 = left.a;
      var lK = left.b;
      var lV = left.c;
      var lLeft = left.d;
      var lRight = left.e;
      return A5($elm$core$Dict$RBNode_elm_builtin, color, lK, lV, lLeft, A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
    } else {
      _v2$2: while (true) {
        if (right.$ === -1 && right.a === 1) {
          if (right.d.$ === -1) {
            if (right.d.a === 1) {
              var _v3 = right.a;
              var _v4 = right.d;
              var _v5 = _v4.a;
              return $elm$core$Dict$moveRedRight(dict);
            } else {
              break _v2$2;
            }
          } else {
            var _v6 = right.a;
            var _v7 = right.d;
            return $elm$core$Dict$moveRedRight(dict);
          }
        } else {
          break _v2$2;
        }
      }
      return dict;
    }
  });
  var $elm$core$Dict$removeMin = function (dict) {
    if (dict.$ === -1 && dict.d.$ === -1) {
      var color = dict.a;
      var key = dict.b;
      var value = dict.c;
      var left = dict.d;
      var lColor = left.a;
      var lLeft = left.d;
      var right = dict.e;
      if (lColor === 1) {
        if (lLeft.$ === -1 && !lLeft.a) {
          var _v3 = lLeft.a;
          return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, $elm$core$Dict$removeMin(left), right);
        } else {
          var _v4 = $elm$core$Dict$moveRedLeft(dict);
          if (_v4.$ === -1) {
            var nColor = _v4.a;
            var nKey = _v4.b;
            var nValue = _v4.c;
            var nLeft = _v4.d;
            var nRight = _v4.e;
            return A5($elm$core$Dict$balance, nColor, nKey, nValue, $elm$core$Dict$removeMin(nLeft), nRight);
          } else {
            return $elm$core$Dict$RBEmpty_elm_builtin;
          }
        }
      } else {
        return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, $elm$core$Dict$removeMin(left), right);
      }
    } else {
      return $elm$core$Dict$RBEmpty_elm_builtin;
    }
  };
  var $elm$core$Dict$removeHelp = F2(function (targetKey, dict) {
    if (dict.$ === -2) {
      return $elm$core$Dict$RBEmpty_elm_builtin;
    } else {
      var color = dict.a;
      var key = dict.b;
      var value = dict.c;
      var left = dict.d;
      var right = dict.e;
      if (_Utils_cmp(targetKey, key) < 0) {
        if (left.$ === -1 && left.a === 1) {
          var _v4 = left.a;
          var lLeft = left.d;
          if (lLeft.$ === -1 && !lLeft.a) {
            var _v6 = lLeft.a;
            return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, A2($elm$core$Dict$removeHelp, targetKey, left), right);
          } else {
            var _v7 = $elm$core$Dict$moveRedLeft(dict);
            if (_v7.$ === -1) {
              var nColor = _v7.a;
              var nKey = _v7.b;
              var nValue = _v7.c;
              var nLeft = _v7.d;
              var nRight = _v7.e;
              return A5($elm$core$Dict$balance, nColor, nKey, nValue, A2($elm$core$Dict$removeHelp, targetKey, nLeft), nRight);
            } else {
              return $elm$core$Dict$RBEmpty_elm_builtin;
            }
          }
        } else {
          return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, A2($elm$core$Dict$removeHelp, targetKey, left), right);
        }
      } else {
        return A2($elm$core$Dict$removeHelpEQGT, targetKey, A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
      }
    }
  });
  var $elm$core$Dict$removeHelpEQGT = F2(function (targetKey, dict) {
    if (dict.$ === -1) {
      var color = dict.a;
      var key = dict.b;
      var value = dict.c;
      var left = dict.d;
      var right = dict.e;
      if (_Utils_eq(targetKey, key)) {
        var _v1 = $elm$core$Dict$getMin(right);
        if (_v1.$ === -1) {
          var minKey = _v1.b;
          var minValue = _v1.c;
          return A5($elm$core$Dict$balance, color, minKey, minValue, left, $elm$core$Dict$removeMin(right));
        } else {
          return $elm$core$Dict$RBEmpty_elm_builtin;
        }
      } else {
        return A5($elm$core$Dict$balance, color, key, value, left, A2($elm$core$Dict$removeHelp, targetKey, right));
      }
    } else {
      return $elm$core$Dict$RBEmpty_elm_builtin;
    }
  });
  var $elm$core$Dict$remove = F2(function (key, dict) {
    var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
    if (_v0.$ === -1 && !_v0.a) {
      var _v1 = _v0.a;
      var k = _v0.b;
      var v = _v0.c;
      var l = _v0.d;
      var r = _v0.e;
      return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
    } else {
      var x = _v0;
      return x;
    }
  });
  var $turboMaCk$any_dict$Dict$Any$remove = F2(function (k, _v0) {
    var inner = _v0;
    return _Utils_update(inner, {
      B: A2($elm$core$Dict$remove, inner.a8(k), inner.B)
    });
  });
  var $author$project$Global$Model$removeUsers = F2(function (userIds, global) {
    var remover = F2(function (id, acc) {
      return A2($turboMaCk$any_dict$Dict$Any$remove, id, acc);
    });
    return _Utils_update(global, {
      lo: A3($elm$core$List$foldl, remover, global.lo, userIds)
    });
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportHttpErr = function (httpErr) {
    switch (httpErr.$) {
      case 3:
        var code = httpErr.a;
        return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Http.BadStatus: ' + $elm$core$String$fromInt(code));
      case 4:
        var body = httpErr.a;
        return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Http.BadBody: ' + body);
      case 2:
        return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Http.NetworkError');
      case 0:
        var string = httpErr.a;
        return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Http.BadUrl: ' + string);
      default:
        return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Http.Timeout');
    }
  };
  var $elm$core$List$head = function (list) {
    if (list.b) {
      var x = list.a;
      var xs = list.b;
      return $elm$core$Maybe$Just(x);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };
  var $author$project$Types$Participant$isPrivateParticipant = function (participant) {
    if (!participant.$) {
      var participantPublic = participant.a;
      return false;
    } else {
      var participantPrivate = participant.a;
      return true;
    }
  };
  var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
    if (!mx.$) {
      var x = mx.a;
      return x;
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };
  var $elm_community$maybe_extra$Maybe$Extra$cons = F2(function (item, list) {
    if (!item.$) {
      var v = item.a;
      return A2($elm$core$List$cons, v, list);
    } else {
      return list;
    }
  });
  var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
  var $author$project$Types$Match$hasThisUserJoined = function (participants) {
    return $elm_community$maybe_extra$Maybe$Extra$isJust($elm_community$maybe_extra$Maybe$Extra$join(A2($elm$core$Maybe$map, function (participant) {
      if (participant.$ === 1) {
        var privateParticipant = participant.a;
        return $elm$core$Maybe$Just(privateParticipant);
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }, $elm$core$List$head(A2($elm$core$List$filter, $author$project$Types$Participant$isPrivateParticipant, $elm_community$maybe_extra$Maybe$Extra$values(participants))))));
  };
  var $author$project$ElmFramework$Lib$OrderedCollection$head = function (_v0) {
    var list = _v0.e;
    return $elm$core$List$head(list);
  };
  var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
    if (m.$ === 1) {
      return true;
    } else {
      return false;
    }
  };
  var $author$project$ElmFramework$Lib$OrderedCollection$isEmpty = function (col) {
    return $elm_community$maybe_extra$Maybe$Extra$isNothing($author$project$ElmFramework$Lib$OrderedCollection$head(col));
  };
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$isEmpty = function (endlessList) {
    var _v0 = endlessList.Cd;
    switch (_v0.$) {
      case 0:
        var maybe = _v0.a;
        return $author$project$ElmFramework$Lib$OrderedCollection$isEmpty(endlessList.c) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(false);
      case 1:
        return $elm$core$Maybe$Just($author$project$ElmFramework$Lib$OrderedCollection$isEmpty(endlessList.c));
      default:
        var maybe = _v0.a;
        return $author$project$ElmFramework$Lib$OrderedCollection$isEmpty(endlessList.c) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(false);
    }
  };
  var $author$project$Types$Match$participantsToPrivateParticipant = function (participants) {
    return $elm_community$maybe_extra$Maybe$Extra$join(A2($elm$core$Maybe$map, function (participant) {
      if (participant.$ === 1) {
        var privateParticipant = participant.a;
        return $elm$core$Maybe$Just(privateParticipant);
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }, $elm$core$List$head(A2($elm$core$List$filter, $author$project$Types$Participant$isPrivateParticipant, $elm_community$maybe_extra$Maybe$Extra$values(participants)))));
  };
  var $author$project$Types$Match$isPaid = function (_v0) {
    var participants = _v0.z8;
    var _v1 = $author$project$Types$Match$participantsToPrivateParticipant(participants);
    if (!_v1.$) {
      var participantPrivate = _v1.a;
      var _v2 = participantPrivate.z7;
      switch (_v2.$) {
        case 0:
          return $elm$core$Maybe$Just(false);
        case 9:
          return $elm$core$Maybe$Just(false);
        case 4:
          return $elm$core$Maybe$Just(false);
        case 2:
          return $elm$core$Maybe$Just(false);
        case 7:
          return $elm$core$Maybe$Just(false);
        case 8:
          return $elm$core$Maybe$Just(true);
        case 1:
          var record = _v2.a;
          return $elm$core$Maybe$Nothing;
        case 3:
          return $elm$core$Maybe$Just(true);
        case 5:
          return $elm$core$Maybe$Nothing;
        case 6:
          return $elm$core$Maybe$Just(true);
        default:
          return $elm$core$Maybe$Just(false);
      }
    } else {
      return $elm$core$Maybe$Just(false);
    }
  };
  var $author$project$TopMsg$routeTo = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$RoutingMsg, A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteTo, false, false));
  var $author$project$ElmFramework$Lib$OrderedCollection$toList = function (_v0) {
    var list = _v0.e;
    return list;
  };
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$toList = function (endlessList) {
    return $author$project$ElmFramework$Lib$OrderedCollection$toList(endlessList.c);
  };
  var $elm$core$Dict$values = function (dict) {
    return A3($elm$core$Dict$foldr, F3(function (key, value, valueList) {
      return A2($elm$core$List$cons, value, valueList);
    }), _List_Nil, dict);
  };
  var $turboMaCk$any_dict$Dict$Any$toList = function (_v0) {
    var dict = _v0.B;
    return $elm$core$Dict$values(dict);
  };
  var $turboMaCk$any_dict$Dict$Any$keys = A2($elm$core$Basics$composeL, $elm$core$List$map($elm$core$Tuple$first), $turboMaCk$any_dict$Dict$Any$toList);
  var $turboMaCk$any_set$Set$Any$toList = function (_v0) {
    var dict = _v0;
    return $turboMaCk$any_dict$Dict$Any$keys(dict);
  };
  var $author$project$Global$RouteAuthHandler$routeAuthHandler = function (_v0) {
    var state = _v0.aC;
    var session = _v0.rG;
    var route = _v0.rh;
    var maybeUnratedMatchId = $elm$core$List$head($turboMaCk$any_set$Set$Any$toList(session.Am));
    var maybeIsEmptyToBool = function (maybeBool) {
      return A2($elm$core$Maybe$withDefault, true, maybeBool);
    };
    var routingLogic = !maybeIsEmptyToBool($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$isEmpty(session.yC)) ? _List_fromArray([$author$project$TopMsg$routeTo($author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Upcoming))]) : !maybeIsEmptyToBool($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$isEmpty(session.BK)) ? _List_fromArray([$author$project$TopMsg$routeTo($author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Searches($author$project$Ui$MyPlayerStatus$Searches$Route$SearchesList)))]) : _List_Nil;
    var initialMatchesList = _Utils_ap($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$toList(session.wA), $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$toList(session.yC));
    var maybeUnpaidMatchId = A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
      return $.xX;
    }, function ($) {
      return $.od;
    }), $elm$core$List$head(A2($elm$core$List$filter, function (match) {
      return $author$project$Types$Match$hasThisUserJoined(match.z8) ? A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $elm$core$Basics$not, $author$project$Types$Match$isPaid(match))) : false;
    }, initialMatchesList)));
    var _v1 = _Utils_Tuple2(maybeUnpaidMatchId, maybeUnratedMatchId);
    if (!_v1.b.$) {
      var unratedMatchId = _v1.b.a;
      _v2$2: while (true) {
        switch (route.$) {
          case 0:
            if (route.a.$ === 3 && route.a.a.$ === 1) {
              return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
            } else {
              break _v2$2;
            }
          case 23:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          default:
            break _v2$2;
        }
      }
      return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$routeTo(A2($author$project$Route$Route$Match, unratedMatchId, $author$project$Ui$Match$Route$Details)), A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Nothing, 'Please rate this match', _List_Nil)]));
    } else {
      if (!_v1.a.$) {
        var unpaidMatchId = _v1.a.a;
        _v3$2: while (true) {
          switch (route.$) {
            case 0:
              if (route.a.$ === 3 && route.a.a.$ === 1) {
                return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
              } else {
                break _v3$2;
              }
            case 23:
              return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
              break _v3$2;
          }
        }
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$routeTo(A2($author$project$Route$Route$Match, unpaidMatchId, $author$project$Ui$Match$Route$Details)), A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Nothing, 'Payment is due for this match', _List_Nil)]));
      } else {
        _v4$2: while (true) {
          switch (route.$) {
            case 0:
              if (route.a.$ === 3 && route.a.a.$ === 1) {
                return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
              } else {
                break _v4$2;
              }
            case 23:
              return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
              break _v4$2;
          }
        }
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, routingLogic);
      }
    }
  };
  var $author$project$Global$Ports$setVault = _Platform_outgoingPort('setVault', $elm$json$Json$Encode$string);
  var $author$project$Ui$Auth$Auth$unauthenticate = _Platform_outgoingPort('unauthenticate', function ($) {
    return $elm$json$Json$Encode$null;
  });
  var $author$project$Global$Global$update = F5(function (currTime, currRoute, maybeSession, msg, global) {
    var config = global.ar;
    var phrases = global.Ar;
    switch (msg.$) {
      case 1:
        var theNewRoute = msg.b;
        if (!maybeSession.$) {
          var session = maybeSession.a;
          return $author$project$Global$RouteAuthHandler$routeAuthHandler({
            u2: currTime,
            nV: global,
            rh: theNewRoute,
            rG: session,
            aC: global
          });
        } else {
          return _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 0:
        var step = msg.a;
        var session = msg.b;
        if (!step) {
          return _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$remoteMsg(A2($author$project$Remote$Msg$NextMatchesEndlessListMsg, true, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$FetchPage))]));
        } else {
          return $author$project$Global$RouteAuthHandler$routeAuthHandler({
            u2: currTime,
            nV: global,
            rh: currRoute,
            rG: session,
            aC: global
          });
        }
      case 4:
        return _Utils_Tuple3(_Utils_update(global, {
          lo: $turboMaCk$any_dict$Dict$Any$removeAll(global.lo)
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$Ui$Auth$Auth$unauthenticate(0), $author$project$ElmFramework$Feature$Analytics$Analytics$trackingEvents.xT])), _List_fromArray([$author$project$TopMsg$routeTo($author$project$Route$Route$authEntryRoute)]));
      case 3:
        var result = msg.a;
        if (!result.$) {
          var geolocation = result.a;
          return _Utils_Tuple3(_Utils_update(global, {
            iy: $elm$core$Maybe$Just($elm$core$Result$Ok(geolocation))
          }), $elm$core$Platform$Cmd$none, $author$project$MulticastMessages$onNewGeolocation($author$project$Model$Geo$IpTypeGeolocation(geolocation)));
        } else {
          var err = result.a;
          return _Utils_Tuple3(_Utils_update(global, {
            iy: $elm$core$Maybe$Just($elm$core$Result$Ok($author$project$Global$Global$defaultIpGeolocation))
          }), $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportHttpErr(err), $author$project$MulticastMessages$onNewGeolocation($author$project$Model$Geo$IpTypeGeolocation($author$project$Global$Global$defaultIpGeolocation)));
        }
      case 5:
        var paymentCard = msg.a;
        var _v4 = global.gT;
        if (!_v4.$) {
          var vault = _v4.a;
          var newVault = _Utils_update(vault, {
            qf: A2($elm$core$List$cons, paymentCard, vault.qf)
          });
          return _Utils_Tuple3(_Utils_update(global, {
            gT: $elm$core$Maybe$Just(newVault)
          }), $author$project$Global$Ports$setVault($author$project$Global$Model$encodeVault(newVault)), _List_Nil);
        } else {
          return _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 6:
        var maybeVault = msg.a;
        return _Utils_Tuple3(_Utils_update(global, {
          gT: maybeVault
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 7:
        var lang = msg.a;
        var commonStatic = msg.b;
        return _Utils_Tuple3(_Utils_update(global, {
          hD: $elm$core$Maybe$Just($author$project$Global$Model$FromPersistence(lang)),
          Ar: commonStatic.Ar
        }), $author$project$Persistence$setCommonStaticFile(A2($author$project$Model$CommonStaticFile$encodeCommonStaticFile, lang, commonStatic.Cc)), _List_Nil);
      case 8:
        var result = msg.a;
        if (!result.$) {
          var language = result.a.ac;
          var commonStatic = result.a.uB;
          var _v6 = global.hD;
          if (!_v6.$) {
            if (!_v6.a.$) {
              return _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg(A2($author$project$Global$Msg$ReceiveCommonStaticFile, language, commonStatic)))]));
            } else {
              var currLang = _v6.a.a;
              return _Utils_eq(currLang.xW, language.xW) ? _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg(A2($author$project$Global$Msg$ReceiveCommonStaticFile, language, commonStatic)))])) : _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_Nil);
            }
          } else {
            return _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg(A2($author$project$Global$Msg$ReceiveCommonStaticFile, language, commonStatic)))]));
          }
        } else {
          var err = result.a;
          return _Utils_Tuple3(global, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportErr, err, ''), _List_Nil);
        }
      case 9:
        var label = msg.a;
        var err = msg.b;
        return _Utils_Tuple3(global, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError(label + (': ' + err)), _List_Nil);
      case 10:
        var users = msg.a;
        return _Utils_Tuple3(A2($author$project$Global$Model$removeUsers, users, global), $elm$core$Platform$Cmd$none, _List_Nil);
      case 11:
        var dialogWindow = msg.a;
        return _Utils_Tuple3(_Utils_update(global, {
          dt: $elm$core$Maybe$Just(dialogWindow)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 2:
        return $elm_community$maybe_extra$Maybe$Extra$isJust(global.dt) ? _Utils_Tuple3(_Utils_update(global, {
          dt: $elm$core$Maybe$Nothing
        }), $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]));
      case 12:
        return _Utils_Tuple3(_Utils_update(global, {
          dt: $elm$core$Maybe$Nothing
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      default:
        return _Utils_Tuple3(global, $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$enablePushNotifications = _Platform_outgoingPort('enablePushNotifications', function ($) {
    return $elm$json$Json$Encode$null;
  });
  var $author$project$PushMessages$PushMessages$update = F5(function (currRoute, global, maybeIdToken, msg, state) {
    switch (msg.$) {
      case 0:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 1:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 2:
        return _Utils_Tuple3($author$project$PushMessages$PushMessages$init, $elm$core$Platform$Cmd$none, _List_Nil);
      default:
        return _Utils_Tuple3(state, $author$project$ElmFramework$Feature$PushMessages$PushMessages$enablePushNotifications(0), _List_Nil);
    }
  });
  var $author$project$Api$GraphqlSchema$Enum$SearchState$Active = 0;
  var $author$project$Global$Msg$GlobalOnAuthRouteHandler = 1;
  var $author$project$Global$Msg$OnAuthSuccess = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Types$Participant$ParticipantPaymentStatusSuccess = {
    $: 3
  };
  var $author$project$Types$Participant$ParticipantTypePrivate = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Remote$Msg$ReadNotificationsEndlessListMsg = function (a) {
    return {
      $: 5,
      a: a
    };
  };
  var $author$project$Ui$MyPlayerStatus$Msg$SetIsHistoryMatchesUpdated = function (a) {
    return {
      $: 9,
      a: a
    };
  };
  var $author$project$Ui$MyPlayerStatus$Msg$SetIsNextMatchesUpdated = function (a) {
    return {
      $: 8,
      a: a
    };
  };
  var $author$project$Ui$MyPlayerStatus$Msg$SetIsSearchesUpdated = function (a) {
    return {
      $: 7,
      a: a
    };
  };
  var $author$project$Remote$RequestMsg$VerifyEmailOobCode = function (a) {
    return {
      $: 7,
      a: a
    };
  };
  var $author$project$Remote$RequestMsg$VerifyResetPasswordCode = function (a) {
    return {
      $: 8,
      a: a
    };
  };
  var $turboMaCk$any_dict$Dict$Any$get = F2(function (k, _v0) {
    var dict = _v0.B;
    var toKey = _v0.a8;
    return A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm$core$Dict$get, toKey(k), dict));
  });
  var $author$project$ElmFramework$Lib$OrderedCollection$get = F2(function (id, _v0) {
    var dict = _v0.B;
    return A2($turboMaCk$any_dict$Dict$Any$get, id, dict);
  });
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$get = F2(function (id, endlessList) {
    return A2($author$project$ElmFramework$Lib$OrderedCollection$get, id, endlessList.c);
  });
  var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent = {
    $: 1
  };
  var $author$project$Api$GraphqlSchema$Enum$CursorDirection$After = 1;
  var $author$project$Api$GraphqlSchema$Enum$SearchState$AwaitingUsers = 2;
  var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet = F3(function (a, b, c) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c
    };
  });
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment = F2(function (fragmentTypeName, _v0) {
    var fields = _v0.a;
    var decoder = _v0.b;
    return A3($dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet, fragmentTypeName, fields, decoder);
  });
  var $dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $dillonkearns$elm_graphql$Graphql$RawField$Composite = F3(function (a, b, c) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c
    };
  });
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite = F3(function (fieldName, args, fields) {
    return A3($dillonkearns$elm_graphql$Graphql$RawField$Composite, fieldName, args, fields);
  });
  var $elm$core$String$dropRight = F2(function (n, string) {
    return n < 1 ? string : A3($elm$core$String$slice, 0, -n, string);
  });
  var $lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation = F2(function (replacements, _v0) {
    var match = _v0.xX;
    var ordinalString = A2($elm$core$Basics$composeL, $elm$core$String$dropLeft(1), $elm$core$String$dropRight(1))(match);
    return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, function (value) {
      return A2($elm$core$Array$get, value, replacements);
    }, $elm$core$String$toInt(ordinalString)));
  });
  var $elm$core$Array$fromListHelp = F3(function (list, nodeList, nodeListSize) {
    fromListHelp: while (true) {
      var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
      var jsArray = _v0.a;
      var remainingItems = _v0.b;
      if (_Utils_cmp($elm$core$Elm$JsArray$length(jsArray), $elm$core$Array$branchFactor) < 0) {
        return A2($elm$core$Array$builderToArray, true, {
          D: nodeList,
          y: nodeListSize,
          C: jsArray
        });
      } else {
        var $temp$list = remainingItems,
          $temp$nodeList = A2($elm$core$List$cons, $elm$core$Array$Leaf(jsArray), nodeList),
          $temp$nodeListSize = nodeListSize + 1;
        list = $temp$list;
        nodeList = $temp$nodeList;
        nodeListSize = $temp$nodeListSize;
        continue fromListHelp;
      }
    }
  });
  var $elm$core$Array$fromList = function (list) {
    if (!list.b) {
      return $elm$core$Array$empty;
    } else {
      return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
    }
  };
  var $elm$regex$Regex$Match = F4(function (match, index, number, submatches) {
    return {
      ed: index,
      xX: match,
      jc: number,
      Cl: submatches
    };
  });
  var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
  var $elm$regex$Regex$fromString = function (string) {
    return A2($elm$regex$Regex$fromStringWith, {
      t9: false,
      yx: false
    }, string);
  };
  var $elm$regex$Regex$never = _Regex_never;
  var $lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex = A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, $elm$regex$Regex$fromString('\\{\\d+\\}'));
  var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
  var $lukewestby$elm_string_interpolate$String$Interpolate$interpolate = F2(function (string, args) {
    var asArray = $elm$core$Array$fromList(args);
    return A3($elm$regex$Regex$replace, $lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex, $lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation(asArray), string);
  });
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage = F2(function (typeSpecificSelections, typeName) {
    return A2($lukewestby$elm_string_interpolate$String$Interpolate$interpolate, 'Unhandled type `{0}` in exhaustive fragment handling. The following types had handlers registered to handle them: [{1}]. This happens if you are parsing either a Union or Interface. Do you need to rerun the `@dillonkearns/elm-graphql` command line tool?', _List_fromArray([typeName, A2($elm$core$String$join, ', ', A2($elm$core$List$map, function (_v0) {
      var fragmentType = _v0.a;
      var fields = _v0.b;
      var decoder = _v0.c;
      return fragmentType;
    }, typeSpecificSelections))]));
  });
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$HashData = F4(function (shift, seed, hash, charsProcessed) {
    return {
      cA: charsProcessed,
      ii: hash,
      ck: seed,
      dd: shift
    };
  });
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$c1 = 3432918353;
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$c2 = 461845907;
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy = F2(function (b, a) {
    return (a & 65535) * b + (((a >>> 16) * b & 65535) << 16);
  });
  var $elm$core$Bitwise$or = _Bitwise_or;
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy = F2(function (b, a) {
    return a << b | a >>> 32 - b;
  });
  var $elm$core$Bitwise$xor = _Bitwise_xor;
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize = function (data) {
    var acc = !!data.ii ? data.ck ^ A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c2, A2($dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy, 15, A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, data.ii))) : data.ck;
    var h0 = acc ^ data.cA;
    var h1 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 2246822507, h0 ^ h0 >>> 16);
    var h2 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 3266489909, h1 ^ h1 >>> 13);
    return (h2 ^ h2 >>> 16) >>> 0;
  };
  var $elm$core$String$foldl = _String_foldl;
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$mix = F2(function (h1, k1) {
    return A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 5, A2($dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy, 13, h1 ^ A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c2, A2($dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy, 15, A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, k1))))) + 3864292196;
  });
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold = F2(function (c, data) {
    var res = data.ii | (255 & $elm$core$Char$toCode(c)) << data.dd;
    var _v0 = data.dd;
    if (_v0 === 24) {
      return {
        cA: data.cA + 1,
        ii: 0,
        ck: A2($dillonkearns$elm_graphql$Graphql$Document$Hash$mix, data.ck, res),
        dd: 0
      };
    } else {
      return {
        cA: data.cA + 1,
        ii: res,
        ck: data.ck,
        dd: data.dd + 8
      };
    }
  });
  var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashString = F2(function (seed, str) {
    return $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize(A3($elm$core$String$foldl, $dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold, A4($dillonkearns$elm_graphql$Graphql$Document$Hash$HashData, 0, seed, 0, 0), str));
  });
  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize = function (value) {
    switch (value.$) {
      case 0:
        var enumValue = value.a;
        return enumValue;
      case 1:
        var json = value.a;
        return A2($elm$json$Json$Encode$encode, 0, json);
      case 2:
        var values = value.a;
        return '[' + (A2($elm$core$String$join, ', ', A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize, values)) + ']');
      default:
        var keyValuePairs = value.a;
        return '{' + (A2($elm$core$String$join, ', ', A2($elm$core$List$map, function (_v1) {
          var key = _v1.a;
          var objectValue = _v1.b;
          return key + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(objectValue));
        }, keyValuePairs)) + '}');
    }
  };
  var $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString = function (_v0) {
    var name = _v0.a;
    var value = _v0.b;
    return name + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(value));
  };
  var $dillonkearns$elm_graphql$Graphql$Document$Argument$serialize = function (args) {
    if (!args.b) {
      return '';
    } else {
      var nonemptyArgs = args;
      return '(' + (A2($elm$core$String$join, ', ', A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString, nonemptyArgs)) + ')');
    }
  };
  var $elm$core$List$singleton = function (value) {
    return _List_fromArray([value]);
  };
  var $dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash = function (field) {
    return A2($elm$core$Maybe$map, $dillonkearns$elm_graphql$Graphql$Document$Hash$hashString(0), function () {
      if (!field.$) {
        var name = field.a;
        var _arguments = field.b;
        var children = field.c;
        return $elm$core$List$isEmpty(_arguments) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments));
      } else {
        var typeString = field.a.C_;
        var fieldName = field.a.nC;
        var _arguments = field.b;
        return fieldName === '__typename' ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($elm$core$String$concat(A2($elm$core$List$append, _List_fromArray([typeString]), $elm$core$List$singleton($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments)))));
      }
    }());
  };
  var $dillonkearns$elm_graphql$Graphql$RawField$name = function (field) {
    if (!field.$) {
      var fieldName = field.a;
      var argumentList = field.b;
      var fieldList = field.c;
      return fieldName;
    } else {
      var typeString = field.a.C_;
      var fieldName = field.a.nC;
      var argumentList = field.b;
      return fieldName;
    }
  };
  var $dillonkearns$elm_graphql$Graphql$Document$Field$alias = function (field) {
    return A2($elm$core$Maybe$map, function (aliasHash) {
      return _Utils_ap($dillonkearns$elm_graphql$Graphql$RawField$name(field), $elm$core$String$fromInt(aliasHash));
    }, $dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash(field));
  };
  var $dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName = function (field) {
    return A2($elm$core$Maybe$withDefault, $dillonkearns$elm_graphql$Graphql$RawField$name(field), $dillonkearns$elm_graphql$Graphql$Document$Field$alias(field));
  };
  var $dillonkearns$elm_graphql$Graphql$RawField$Leaf = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $dillonkearns$elm_graphql$Graphql$RawField$typename = A2($dillonkearns$elm_graphql$Graphql$RawField$Leaf, {
    nC: '__typename',
    C_: ''
  }, _List_Nil);
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection = function (typeSpecificSelections) {
    var selections = A2($elm$core$List$map, function (_v1) {
      var typeName = _v1.a;
      var fields = _v1.b;
      var decoder = _v1.c;
      return A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, '...on ' + typeName, _List_Nil, fields);
    }, typeSpecificSelections);
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, selections), A2($elm$json$Json$Decode$andThen, function (typeName) {
      return A2($elm$core$Maybe$withDefault, $elm$json$Json$Decode$fail(A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage, typeSpecificSelections, typeName)), A2($elm$core$Dict$get, typeName, $elm$core$Dict$fromList(A2($elm$core$List$map, function (_v0) {
        var thisTypeName = _v0.a;
        var fields = _v0.b;
        var decoder = _v0.c;
        return _Utils_Tuple2(thisTypeName, decoder);
      }, typeSpecificSelections))));
    }, A2($elm$json$Json$Decode$field, $dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName($dillonkearns$elm_graphql$Graphql$RawField$typename), $elm$json$Json$Decode$string)));
  };
  var $author$project$Api$GraphqlSchema$Union$ListSearchesPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ListSearchesSuccess', selections____.zh), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k)]));
  };
  var $dillonkearns$elm_graphql$Graphql$SelectionSet$map = F2(function (mapFunction, _v0) {
    var selectionFields = _v0.a;
    var selectionDecoder = _v0.b;
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, selectionFields, A2($elm$json$Json$Decode$map, mapFunction, selectionDecoder));
  });
  var $author$project$Api$Schema$mapField = $dillonkearns$elm_graphql$Graphql$SelectionSet$map;
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf = F2(function (details, args) {
    return A2($dillonkearns$elm_graphql$Graphql$RawField$Leaf, details, args);
  });
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField = F4(function (typeString, fieldName, args, decoder) {
    var newLeaf = A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf, {
      nC: fieldName,
      C_: typeString
    }, args);
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, _List_fromArray([newLeaf]), A2($elm$json$Json$Decode$field, $dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(newLeaf), decoder));
  });
  var $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$GenericError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$InvalidInputError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$RateLimitError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $dillonkearns$elm_graphql$Graphql$Http$Query = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $dillonkearns$elm_graphql$Graphql$Http$Request = $elm$core$Basics$identity;
  var $dillonkearns$elm_graphql$Graphql$Document$decoder = function (_v0) {
    var fields = _v0.a;
    var decoder_ = _v0.b;
    return A2($elm$json$Json$Decode$field, 'data', decoder_);
  };
  var $dillonkearns$elm_graphql$Graphql$Http$queryRequest = F2(function (baseUrl, query) {
    return {
      dH: baseUrl,
      vp: A2($dillonkearns$elm_graphql$Graphql$Http$Query, $elm$core$Maybe$Nothing, query),
      nv: $dillonkearns$elm_graphql$Graphql$Document$decoder(query),
      wx: _List_Nil,
      c2: $elm$core$Maybe$Nothing,
      ex: _List_Nil,
      lf: $elm$core$Maybe$Nothing,
      cv: false
    };
  });
  var $elm$core$Task$fail = _Scheduler_fail;
  var $elm$core$Task$onError = _Scheduler_onError;
  var $elm$core$Task$mapError = F2(function (convert, task) {
    return A2($elm$core$Task$onError, A2($elm$core$Basics$composeL, $elm$core$Task$fail, convert), task);
  });
  var $elm$http$Http$Header = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $elm$http$Http$header = $elm$http$Http$Header;
  var $dillonkearns$elm_graphql$Graphql$Http$withHeader = F3(function (key, value, _v0) {
    var request = _v0;
    return _Utils_update(request, {
      wx: A2($elm$core$List$cons, A2($elm$http$Http$header, key, value), request.wx)
    });
  });
  var $author$project$Api$Api$requestCore = F4(function (requester, _v0, maybeIdToken, query) {
    var apiEndpoint = _v0;
    var withAccessToken = function (theQuery) {
      return A2($elm$core$Maybe$withDefault, theQuery, A2($elm$core$Maybe$map, function (_v1) {
        var token = _v1;
        return A3($dillonkearns$elm_graphql$Graphql$Http$withHeader, 'Authorization', 'Bearer ' + token, theQuery);
      }, maybeIdToken));
    };
    return withAccessToken(A2(requester, apiEndpoint, query));
  });
  var $dillonkearns$elm_graphql$Graphql$Http$HttpError = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $dillonkearns$elm_graphql$Graphql$Http$failTaskOnHttpSuccessWithErrors = function (successOrError) {
    if (!successOrError.$) {
      var value = successOrError.a;
      return $elm$core$Task$succeed(value);
    } else {
      var _v1 = successOrError.a;
      var possiblyParsedData = _v1.a;
      var graphqlErrorGraphqlErrorList = _v1.b;
      return $elm$core$Task$fail(A2($dillonkearns$elm_graphql$Graphql$Http$GraphqlError, possiblyParsedData, graphqlErrorGraphqlErrorList));
    }
  };
  var $dillonkearns$elm_graphql$Graphql$Http$BadPayload = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $dillonkearns$elm_graphql$Graphql$Http$BadStatus = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $dillonkearns$elm_graphql$Graphql$Http$BadUrl = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $dillonkearns$elm_graphql$Graphql$Http$NetworkError = {
    $: 2
  };
  var $dillonkearns$elm_graphql$Graphql$Http$Timeout = {
    $: 1
  };
  var $elm$http$Http$BadStatus_ = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $elm$http$Http$BadUrl_ = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $elm$http$Http$GoodStatus_ = F2(function (a, b) {
    return {
      $: 4,
      a: a,
      b: b
    };
  });
  var $elm$http$Http$NetworkError_ = {
    $: 2
  };
  var $elm$http$Http$Receiving = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $elm$http$Http$Sending = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $elm$http$Http$Timeout_ = {
    $: 1
  };
  var $elm$core$Maybe$isJust = function (maybe) {
    if (!maybe.$) {
      return true;
    } else {
      return false;
    }
  };
  var $elm$core$Dict$update = F3(function (targetKey, alter, dictionary) {
    var _v0 = alter(A2($elm$core$Dict$get, targetKey, dictionary));
    if (!_v0.$) {
      var value = _v0.a;
      return A3($elm$core$Dict$insert, targetKey, value, dictionary);
    } else {
      return A2($elm$core$Dict$remove, targetKey, dictionary);
    }
  });
  var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
  var $dillonkearns$elm_graphql$Graphql$Http$jsonResolver = function (decoder) {
    return $elm$http$Http$stringResolver(function (response) {
      switch (response.$) {
        case 0:
          var url = response.a;
          return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$BadUrl(url));
        case 1:
          return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$Timeout);
        case 2:
          return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$NetworkError);
        case 3:
          var metadata = response.a;
          var body = response.b;
          return $elm$core$Result$Err(A2($dillonkearns$elm_graphql$Graphql$Http$BadStatus, metadata, body));
        default:
          var metadata = response.a;
          var body = response.b;
          var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
          if (!_v1.$) {
            var value = _v1.a;
            return $elm$core$Result$Ok(value);
          } else {
            var err = _v1.a;
            return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$BadPayload(err));
          }
      }
    });
  };
  var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Get = 0;
  var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Post = 1;
  var $elm$http$Http$emptyBody = _Http_emptyBody;
  var $elm$http$Http$jsonBody = function (value) {
    return A2(_Http_pair, 'application/json', A2($elm$json$Json$Encode$encode, 0, value));
  };
  var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength = 2000;
  var $dillonkearns$elm_graphql$Graphql$Document$Indent$spaces = function (n) {
    return n > 0 ? ' ' + $dillonkearns$elm_graphql$Graphql$Document$Indent$spaces(n - 1) : '';
  };
  var $dillonkearns$elm_graphql$Graphql$Document$Indent$generate = function (indentationLevel) {
    return $dillonkearns$elm_graphql$Graphql$Document$Indent$spaces(indentationLevel * 2);
  };
  var $dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren = function (children) {
    return $elm$core$List$isEmpty(children) ? A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, children) : children;
  };
  var $dillonkearns$elm_graphql$Graphql$Document$Field$serialize = F3(function (aliasName, mIndentationLevel, field) {
    var prefix = function () {
      if (!aliasName.$) {
        var aliasName_ = aliasName.a;
        return _Utils_ap(aliasName_, function () {
          if (!mIndentationLevel.$) {
            return ': ';
          } else {
            return ':';
          }
        }());
      } else {
        return '';
      }
    }();
    return A2($elm$core$Maybe$map, function (string) {
      return _Utils_ap($dillonkearns$elm_graphql$Graphql$Document$Indent$generate(A2($elm$core$Maybe$withDefault, 0, mIndentationLevel)), _Utils_ap(prefix, string));
    }, function () {
      if (!field.$) {
        var fieldName = field.a;
        var args = field.b;
        var children = field.c;
        if (mIndentationLevel.$ === 1) {
          return $elm$core$Maybe$Just(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + ('{' + A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, children))) + '}');
        } else {
          var indentationLevel = mIndentationLevel.a;
          return $elm$core$Maybe$Just(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + (' {\n' + A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Just(indentationLevel), children))) + ('\n' + ($dillonkearns$elm_graphql$Graphql$Document$Indent$generate(indentationLevel) + '}')));
        }
      } else {
        var fieldName = field.a.nC;
        var args = field.b;
        return $elm$core$Maybe$Just(_Utils_ap(fieldName, $dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args)));
      }
    }());
  });
  var $dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren = F2(function (indentationLevel, children) {
    return A2($elm$core$String$join, function () {
      if (!indentationLevel.$) {
        return '\n';
      } else {
        return ' ';
      }
    }(), A2($elm$core$List$filterMap, $elm$core$Basics$identity, A2($elm$core$List$map, function (field) {
      return A3($dillonkearns$elm_graphql$Graphql$Document$Field$serialize, $dillonkearns$elm_graphql$Graphql$Document$Field$alias(field), A2($elm$core$Maybe$map, $elm$core$Basics$add(1), indentationLevel), field);
    }, $dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren(children))));
  });
  var $dillonkearns$elm_graphql$Graphql$Document$serialize = F2(function (operationType, queries) {
    return A2($lukewestby$elm_string_interpolate$String$Interpolate$interpolate, '{0} {\n{1}\n}', _List_fromArray([operationType, A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Just(0), queries)]));
  });
  var $dillonkearns$elm_graphql$Graphql$Document$serializeQuery = function (_v0) {
    var fields = _v0.a;
    var decoder_ = _v0.b;
    return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'query', fields);
  };
  var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl = function (_v0) {
    var fields = _v0.a;
    var decoder_ = _v0.b;
    return '{' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}');
  };
  var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName = F2(function (operationName, _v0) {
    var fields = _v0.a;
    var decoder_ = _v0.b;
    return 'query ' + (operationName + (' {' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}')));
  });
  var $dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName = F3(function (operationType, operationName, queries) {
    return A2($lukewestby$elm_string_interpolate$String$Interpolate$interpolate, '{0} {1} {\n{2}\n}', _List_fromArray([operationType, operationName, A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Just(0), queries)]));
  });
  var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName = F2(function (operationName, _v0) {
    var fields = _v0.a;
    var decoder_ = _v0.b;
    return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'query', operationName, fields);
  });
  var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace = F2(function (old, _new) {
    return A2($elm$core$Basics$composeR, $elm$core$String$split(old), $elm$core$String$join(_new));
  });
  var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape = A2($elm$core$Basics$composeR, $elm$url$Url$percentEncode, A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace, '%20', '+'));
  var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair = function (_v0) {
    var key = _v0.a;
    var value = _v0.b;
    return $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(key) + ('=' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(value));
  };
  var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded = function (args) {
    return A2($elm$core$String$join, '&', A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair, args));
  };
  var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams = F2(function (queryParams, url) {
    return $elm$core$List$isEmpty(queryParams) ? url : url + ('?' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded(queryParams));
  });
  var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build = F5(function (forceMethod, url, queryParams, maybeOperationName, queryDocument) {
    var _v0 = function () {
      if (!maybeOperationName.$) {
        var operationName = maybeOperationName.a;
        return _Utils_Tuple2(A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName, operationName, queryDocument), _List_fromArray([_Utils_Tuple2('operationName', operationName)]));
      } else {
        return _Utils_Tuple2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl(queryDocument), _List_Nil);
      }
    }();
    var serializedQueryForGetRequest = _v0.a;
    var operationNameParamForGetRequest = _v0.b;
    var urlForGetRequest = A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, _Utils_ap(queryParams, _Utils_ap(_List_fromArray([_Utils_Tuple2('query', serializedQueryForGetRequest)]), operationNameParamForGetRequest)), url);
    if (_Utils_eq(forceMethod, $elm$core$Maybe$Just(1)) || _Utils_cmp($elm$core$String$length(urlForGetRequest), $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength) > -1 && !_Utils_eq(forceMethod, $elm$core$Maybe$Just(0))) {
      var _v2 = function () {
        if (!maybeOperationName.$) {
          var operationName = maybeOperationName.a;
          return _Utils_Tuple2(A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName, operationName, queryDocument), _List_fromArray([_Utils_Tuple2('operationName', $elm$json$Json$Encode$string(operationName))]));
        } else {
          return _Utils_Tuple2($dillonkearns$elm_graphql$Graphql$Document$serializeQuery(queryDocument), _List_Nil);
        }
      }();
      var serializedQuery = _v2.a;
      var operationNameParamForPostRequest = _v2.b;
      return {
        aU: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_Utils_ap(_List_fromArray([_Utils_Tuple2('query', $elm$json$Json$Encode$string(serializedQuery))]), operationNameParamForPostRequest))),
        em: 1,
        eZ: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, _List_Nil, url)
      };
    } else {
      return {
        aU: $elm$http$Http$emptyBody,
        em: 0,
        eZ: urlForGetRequest
      };
    }
  });
  var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError = F3(function (message, locations, details) {
    return {
      vp: details,
      xQ: locations,
      f0: message
    };
  });
  var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
  var $elm$json$Json$Decode$dict = function (decoder) {
    return A2($elm$json$Json$Decode$map, $elm$core$Dict$fromList, $elm$json$Json$Decode$keyValuePairs(decoder));
  };
  var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location = F2(function (line, column) {
    return {
      uz: column,
      xI: line
    };
  });
  var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder = A3($elm$json$Json$Decode$map2, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location, A2($elm$json$Json$Decode$field, 'line', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$field, 'column', $elm$json$Json$Decode$int));
  var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder = A2($elm$json$Json$Decode$field, 'errors', $elm$json$Json$Decode$list(A4($elm$json$Json$Decode$map3, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError, A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'locations', $elm$json$Json$Decode$list($dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder))), A2($elm$json$Json$Decode$map, $elm$core$Dict$remove('locations'), A2($elm$json$Json$Decode$map, $elm$core$Dict$remove('message'), $elm$json$Json$Decode$dict($elm$json$Json$Decode$value))))));
  var $dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData = function (data) {
    return A2($elm$json$Json$Decode$map, $elm$core$Result$Err, A2($elm$json$Json$Decode$map, $elm$core$Tuple$pair(data), $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder));
  };
  var $dillonkearns$elm_graphql$Graphql$Http$nullJsonValue = function (a) {
    nullJsonValue: while (true) {
      var _v0 = A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, 'null');
      if (!_v0.$) {
        var value = _v0.a;
        return value;
      } else {
        var $temp$a = 0;
        a = $temp$a;
        continue nullJsonValue;
      }
    }
  };
  var $dillonkearns$elm_graphql$Graphql$Http$errorDecoder = function (decoder) {
    return $elm$json$Json$Decode$oneOf(_List_fromArray([A2($elm$json$Json$Decode$andThen, $dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData, A2($elm$json$Json$Decode$map, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData, decoder)), A2($elm$json$Json$Decode$andThen, $dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData, A2($elm$json$Json$Decode$map, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData, A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value))), A2($elm$json$Json$Decode$andThen, $dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData, $elm$json$Json$Decode$succeed($dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData($dillonkearns$elm_graphql$Graphql$Http$nullJsonValue(0))))]));
  };
  var $dillonkearns$elm_graphql$Graphql$Http$decoderOrError = function (decoder) {
    return $elm$json$Json$Decode$oneOf(_List_fromArray([$dillonkearns$elm_graphql$Graphql$Http$errorDecoder(decoder), A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, decoder)]));
  };
  var $dillonkearns$elm_graphql$Graphql$Document$serializeMutation = function (_v0) {
    var fields = _v0.a;
    var decoder_ = _v0.b;
    return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'mutation', fields);
  };
  var $dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName = F2(function (operationName, _v0) {
    var fields = _v0.a;
    var decoder_ = _v0.b;
    return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'mutation', operationName, fields);
  });
  var $dillonkearns$elm_graphql$Graphql$Http$toReadyRequest = function (_v0) {
    var request = _v0;
    var _v1 = request.vp;
    if (!_v1.$) {
      var forcedRequestMethod = _v1.a;
      var querySelectionSet = _v1.b;
      var queryRequestDetails = A5($dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build, function () {
        if (!forcedRequestMethod.$) {
          if (!forcedRequestMethod.a) {
            var _v4 = forcedRequestMethod.a;
            return $elm$core$Maybe$Just(0);
          } else {
            var _v5 = forcedRequestMethod.a;
            return $elm$core$Maybe$Nothing;
          }
        } else {
          return $elm$core$Maybe$Just(1);
        }
      }(), request.dH, request.ex, request.c2, querySelectionSet);
      return {
        aU: queryRequestDetails.aU,
        fu: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.nv),
        wx: request.wx,
        em: function () {
          var _v2 = queryRequestDetails.em;
          if (!_v2) {
            return 'GET';
          } else {
            return 'Post';
          }
        }(),
        lf: request.lf,
        eZ: queryRequestDetails.eZ
      };
    } else {
      var mutationSelectionSet = _v1.a;
      var serializedMutation = function () {
        var _v6 = request.c2;
        if (!_v6.$) {
          var operationName = _v6.a;
          return A2($dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName, operationName, mutationSelectionSet);
        } else {
          return $dillonkearns$elm_graphql$Graphql$Document$serializeMutation(mutationSelectionSet);
        }
      }();
      return {
        aU: $elm$http$Http$jsonBody($elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('query', $elm$json$Json$Encode$string(serializedMutation))]))),
        fu: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.nv),
        wx: request.wx,
        em: 'POST',
        lf: request.lf,
        eZ: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, request.ex, request.dH)
      };
    }
  };
  var $dillonkearns$elm_graphql$Graphql$Http$resolver = function (request) {
    return $dillonkearns$elm_graphql$Graphql$Http$jsonResolver($dillonkearns$elm_graphql$Graphql$Http$toReadyRequest(request).fu);
  };
  var $elm$http$Http$resultToTask = function (result) {
    if (!result.$) {
      var a = result.a;
      return $elm$core$Task$succeed(a);
    } else {
      var x = result.a;
      return $elm$core$Task$fail(x);
    }
  };
  var $elm$http$Http$riskyTask = function (r) {
    return A3(_Http_toTask, 0, $elm$http$Http$resultToTask, {
      tr: true,
      aU: r.aU,
      nv: r.A4,
      wx: r.wx,
      em: r.em,
      lf: r.lf,
      sC: $elm$core$Maybe$Nothing,
      eZ: r.eZ
    });
  };
  var $elm$http$Http$task = function (r) {
    return A3(_Http_toTask, 0, $elm$http$Http$resultToTask, {
      tr: false,
      aU: r.aU,
      nv: r.A4,
      wx: r.wx,
      em: r.em,
      lf: r.lf,
      sC: $elm$core$Maybe$Nothing,
      eZ: r.eZ
    });
  };
  var $dillonkearns$elm_graphql$Graphql$Http$toTask = function (fullRequest) {
    var request = fullRequest;
    return A2($elm$core$Task$andThen, $dillonkearns$elm_graphql$Graphql$Http$failTaskOnHttpSuccessWithErrors, A2($elm$core$Task$mapError, $dillonkearns$elm_graphql$Graphql$Http$HttpError, function (readyRequest) {
      return (request.cv ? $elm$http$Http$riskyTask : $elm$http$Http$task)({
        aU: readyRequest.aU,
        wx: readyRequest.wx,
        em: readyRequest.em,
        A4: $dillonkearns$elm_graphql$Graphql$Http$resolver(fullRequest),
        lf: readyRequest.lf,
        eZ: readyRequest.eZ
      });
    }($dillonkearns$elm_graphql$Graphql$Http$toReadyRequest(fullRequest))));
  };
  var $author$project$Api$Api$transformOutdatedAppVersionErrors = function (rawError) {
    var outdatedAppVersionMessage = _List_fromArray([{
      vp: $elm$core$Dict$empty,
      xQ: $elm$core$Maybe$Nothing,
      f0: 'Please update your application'
    }]);
    var outdatedAppVersionError = A2($dillonkearns$elm_graphql$Graphql$Http$GraphqlError, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData($elm$json$Json$Encode$string('')), outdatedAppVersionMessage);
    if (!rawError.$) {
      var possiblyParsedData = rawError.a;
      var graphqlErrors = rawError.b;
      return A2($elm$core$Maybe$withDefault, rawError, A2($elm$core$Maybe$map, $elm$core$Basics$always(outdatedAppVersionError), A2($elm_community$list_extra$List$Extra$find, function (_v1) {
        var message = _v1.f0;
        return A2($elm$core$String$startsWith, 'Validation error', message);
      }, graphqlErrors)));
    } else {
      var httpError = rawError.a;
      if (httpError.$ === 4) {
        return outdatedAppVersionError;
      } else {
        return rawError;
      }
    }
  };
  var $dillonkearns$elm_graphql$Graphql$Http$withOperationName = F2(function (operationName, _v0) {
    var request = _v0;
    return _Utils_update(request, {
      c2: $elm$core$Maybe$Just(operationName)
    });
  });
  var $author$project$Api$Api$requestTask = F5(function (operationName, requester, apiEndpoint, maybeAccessToken, query) {
    var withName = function () {
      if (!operationName.$) {
        var name = operationName.a;
        return $dillonkearns$elm_graphql$Graphql$Http$withOperationName(name);
      } else {
        return $elm$core$Basics$identity;
      }
    }();
    return A2($elm$core$Task$mapError, $author$project$Api$Api$transformOutdatedAppVersionErrors, $dillonkearns$elm_graphql$Graphql$Http$toTask(withName(A4($author$project$Api$Api$requestCore, requester, apiEndpoint, maybeAccessToken, query))));
  });
  var $author$project$Api$Api$queryRequestTask = A2($author$project$Api$Api$requestTask, $elm$core$Maybe$Nothing, $dillonkearns$elm_graphql$Graphql$Http$queryRequest);
  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum = F2(function (enumToString, value) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue(enumToString(value));
  });
  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject = function (maybeValues) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object(A2($elm$core$List$filterMap, function (_v0) {
      var key = _v0.a;
      var value = _v0.b;
      if (!value.$) {
        var actualValue = value.a;
        return $elm$core$Maybe$Just(_Utils_Tuple2(key, actualValue));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }, maybeValues));
  };
  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$string = function (value) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$string(value));
  };
  var $author$project$Api$GraphqlSchema$Enum$CursorDirection$toString = function (enum____) {
    if (!enum____) {
      return 'BEFORE';
    } else {
      return 'AFTER';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeCursorInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('direction', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$CursorDirection$toString, input____.hL))), _Utils_Tuple2('id', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.od)))]));
  };
  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$int = function (value) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$int(value));
  };
  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$null = $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$null);
  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$optional = F2(function (optionalValue, toValue) {
    switch (optionalValue.$) {
      case 0:
        var value = optionalValue.a;
        return $elm$core$Maybe$Just(toValue(value));
      case 1:
        return $elm$core$Maybe$Nothing;
      default:
        return $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$null);
    }
  });
  var $author$project$Api$GraphqlSchema$InputObject$encodePaginationInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('cursor', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cE, $author$project$Api$GraphqlSchema$InputObject$encodeCursorInput)), _Utils_Tuple2('limit', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$int(input____.cW)))]));
  };
  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool = function (value) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$bool(value));
  };
  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$List = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$list = F2(function (toValue, value) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$List(A2($elm$core$List$map, toValue, value));
  });
  var $author$project$Api$GraphqlSchema$Enum$SearchState$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'ACTIVE';
      case 1:
        return 'AWAITING_PAYMENT';
      case 2:
        return 'AWAITING_USERS';
      case 3:
        return 'CANCELED';
      case 4:
        return 'EXPIRED';
      default:
        return 'COMPLETE';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeSearchStateModifierOneOfInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('all', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dx, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('except', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$SearchState$toString)))), _Utils_Tuple2('specific', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eK, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$SearchState$toString))))]));
  };
  var $author$project$Api$GraphqlSchema$Enum$DateOrder$toString = function (enum____) {
    if (!enum____) {
      return 'RECENT_FIRST';
    } else {
      return 'OLD_FIRST';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeSearchListModifiersInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('dateOrder', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cF, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$DateOrder$toString))), _Utils_Tuple2('searchId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.by, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('searchStateOneOf', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.BJ, $author$project$Api$GraphqlSchema$InputObject$encodeSearchStateModifierOneOfInput))]));
  };
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional = F3(function (fieldName, maybeValue, toValue) {
    switch (maybeValue.$) {
      case 0:
        var value = maybeValue.a;
        return $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument, fieldName, toValue(value)));
      case 1:
        return $elm$core$Maybe$Nothing;
      default:
        return $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument, fieldName, $dillonkearns$elm_graphql$Graphql$Internal$Encode$null));
    }
  });
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField = F4(function (fieldName, args, _v0, decoderTransform) {
    var fields = _v0.a;
    var decoder = _v0.b;
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)]), A2($elm$json$Json$Decode$field, $dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)), decoderTransform(decoder)));
  });
  var $author$project$Api$GraphqlSchema$Object$SearchQuery$searches = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      cZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      f9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'pagination', filledInOptionals____.f9, $author$project$Api$GraphqlSchema$InputObject$encodePaginationInput), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'modifiers', filledInOptionals____.cZ, $author$project$Api$GraphqlSchema$InputObject$encodeSearchListModifiersInput)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'searches', optionalArgs____, object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Query$searches = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'searches', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$Paged = F2(function (items, nextPagePointer) {
    return {
      xn: items,
      yD: nextPagePointer
    };
  });
  var $elm$json$Json$Decode$nullable = function (decoder) {
    return $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)]));
  };
  var $author$project$Api$GraphqlSchema$Object$ListSearchesSuccess$cursorIds = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'cursorIds', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };
  var $author$project$Types$Cursor$CursorId = $elm$core$Basics$identity;
  var $author$project$Types$Cursor$CursorIds = F2(function (before, after) {
    return {
      tq: after,
      tN: before
    };
  });
  var $author$project$Api$GraphqlSchema$Object$CursorIds$after = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'after', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$CursorIds$before = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'before', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed = function (constructor) {
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, _List_Nil, $elm$json$Json$Decode$succeed(constructor));
  };
  var $dillonkearns$elm_graphql$Graphql$SelectionSet$with = F2(function (_v0, _v1) {
    var selectionFields1 = _v0.a;
    var selectionDecoder1 = _v0.b;
    var selectionFields2 = _v1.a;
    var selectionDecoder2 = _v1.b;
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, _Utils_ap(selectionFields1, selectionFields2), A3($elm$json$Json$Decode$map2, $elm$core$Basics$apR, selectionDecoder1, selectionDecoder2));
  });
  var $author$project$Api$Schema$withMap = F3(function (field, mapper, query) {
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($author$project$Api$Schema$mapField, mapper, field), query);
  });
  var $author$project$Api$Schema$cursorIds = A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$CursorIds$after, $elm$core$Maybe$map($elm$core$Basics$identity), A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$CursorIds$before, $elm$core$Maybe$map($elm$core$Basics$identity), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Cursor$CursorIds)));
  var $author$project$Types$Search$SearchDetails = F3(function (createdAt, createdBy, search) {
    return {
      uV: createdAt,
      uW: createdBy,
      kH: search
    };
  });
  var $elm$parser$Parser$deadEndsToString = function (deadEnds) {
    return 'TODO deadEndsToString';
  };
  var $elm$parser$Parser$Advanced$Bad = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $elm$parser$Parser$Advanced$Good = F3(function (a, b, c) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c
    };
  });
  var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
  var $elm$parser$Parser$Advanced$andThen = F2(function (callback, _v0) {
    var parseA = _v0;
    return function (s0) {
      var _v1 = parseA(s0);
      if (_v1.$ === 1) {
        var p = _v1.a;
        var x = _v1.b;
        return A2($elm$parser$Parser$Advanced$Bad, p, x);
      } else {
        var p1 = _v1.a;
        var a = _v1.b;
        var s1 = _v1.c;
        var _v2 = callback(a);
        var parseB = _v2;
        var _v3 = parseB(s1);
        if (_v3.$ === 1) {
          var p2 = _v3.a;
          var x = _v3.b;
          return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
        } else {
          var p2 = _v3.a;
          var b = _v3.b;
          var s2 = _v3.c;
          return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
        }
      }
    };
  });
  var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
  var $elm$parser$Parser$ExpectingEnd = {
    $: 10
  };
  var $elm$parser$Parser$Advanced$AddRight = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $elm$parser$Parser$Advanced$DeadEnd = F4(function (row, col, problem, contextStack) {
    return {
      mv: col,
      uP: contextStack,
      qF: problem,
      ri: row
    };
  });
  var $elm$parser$Parser$Advanced$Empty = {
    $: 0
  };
  var $elm$parser$Parser$Advanced$fromState = F2(function (s, x) {
    return A2($elm$parser$Parser$Advanced$AddRight, $elm$parser$Parser$Advanced$Empty, A4($elm$parser$Parser$Advanced$DeadEnd, s.ri, s.mv, x, s.uO));
  });
  var $elm$parser$Parser$Advanced$end = function (x) {
    return function (s) {
      return _Utils_eq($elm$core$String$length(s.b), s.jf) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2($elm$parser$Parser$Advanced$Bad, false, A2($elm$parser$Parser$Advanced$fromState, s, x));
    };
  };
  var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
  var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
  var $elm$parser$Parser$Advanced$chompWhileHelp = F5(function (isGood, offset, row, col, s0) {
    chompWhileHelp: while (true) {
      var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.b);
      if (_Utils_eq(newOffset, -1)) {
        return A3($elm$parser$Parser$Advanced$Good, _Utils_cmp(s0.jf, offset) < 0, 0, {
          mv: col,
          uO: s0.uO,
          s: s0.s,
          jf: offset,
          ri: row,
          b: s0.b
        });
      } else {
        if (_Utils_eq(newOffset, -2)) {
          var $temp$isGood = isGood,
            $temp$offset = offset + 1,
            $temp$row = row + 1,
            $temp$col = 1,
            $temp$s0 = s0;
          isGood = $temp$isGood;
          offset = $temp$offset;
          row = $temp$row;
          col = $temp$col;
          s0 = $temp$s0;
          continue chompWhileHelp;
        } else {
          var $temp$isGood = isGood,
            $temp$offset = newOffset,
            $temp$row = row,
            $temp$col = col + 1,
            $temp$s0 = s0;
          isGood = $temp$isGood;
          offset = $temp$offset;
          row = $temp$row;
          col = $temp$col;
          s0 = $temp$s0;
          continue chompWhileHelp;
        }
      }
    }
  });
  var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
    return function (s) {
      return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.jf, s.ri, s.mv, s);
    };
  };
  var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
  var $elm$parser$Parser$Advanced$mapChompedString = F2(function (func, _v0) {
    var parse = _v0;
    return function (s0) {
      var _v1 = parse(s0);
      if (_v1.$ === 1) {
        var p = _v1.a;
        var x = _v1.b;
        return A2($elm$parser$Parser$Advanced$Bad, p, x);
      } else {
        var p = _v1.a;
        var a = _v1.b;
        var s1 = _v1.c;
        return A3($elm$parser$Parser$Advanced$Good, p, A2(func, A3($elm$core$String$slice, s0.jf, s1.jf, s0.b), a), s1);
      }
    };
  });
  var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
    return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
  };
  var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
  var $elm$parser$Parser$Problem = function (a) {
    return {
      $: 12,
      a: a
    };
  };
  var $elm$parser$Parser$Advanced$problem = function (x) {
    return function (s) {
      return A2($elm$parser$Parser$Advanced$Bad, false, A2($elm$parser$Parser$Advanced$fromState, s, x));
    };
  };
  var $elm$parser$Parser$problem = function (msg) {
    return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem(msg));
  };
  var $elm$core$Basics$round = _Basics_round;
  var $elm$parser$Parser$Advanced$succeed = function (a) {
    return function (s) {
      return A3($elm$parser$Parser$Advanced$Good, false, a, s);
    };
  };
  var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
  var $elm$core$String$toFloat = _String_toFloat;
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2($elm$parser$Parser$andThen, function (str) {
    if ($elm$core$String$length(str) <= 9) {
      var _v0 = $elm$core$String$toFloat('0.' + str);
      if (!_v0.$) {
        var floatVal = _v0.a;
        return $elm$parser$Parser$succeed($elm$core$Basics$round(floatVal * 1000));
      } else {
        return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
      }
    } else {
      return $elm$parser$Parser$problem('Expected at most 9 digits, but got ' + $elm$core$String$fromInt($elm$core$String$length(str)));
    }
  }, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
    return $elm$time$Time$millisToPosix(monthYearDayMs + hour * 60 * 60 * 1000 + (minute - utcOffsetMinutes) * 60 * 1000 + second * 1000 + ms);
  });
  var $elm$parser$Parser$Advanced$map2 = F3(function (func, _v0, _v1) {
    var parseA = _v0;
    var parseB = _v1;
    return function (s0) {
      var _v2 = parseA(s0);
      if (_v2.$ === 1) {
        var p = _v2.a;
        var x = _v2.b;
        return A2($elm$parser$Parser$Advanced$Bad, p, x);
      } else {
        var p1 = _v2.a;
        var a = _v2.b;
        var s1 = _v2.c;
        var _v3 = parseB(s1);
        if (_v3.$ === 1) {
          var p2 = _v3.a;
          var x = _v3.b;
          return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
        } else {
          var p2 = _v3.a;
          var b = _v3.b;
          var s2 = _v3.c;
          return A3($elm$parser$Parser$Advanced$Good, p1 || p2, A2(func, a, b), s2);
        }
      }
    };
  });
  var $elm$parser$Parser$Advanced$ignorer = F2(function (keepParser, ignoreParser) {
    return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
  });
  var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
  var $elm$parser$Parser$Advanced$keeper = F2(function (parseFunc, parseArg) {
    return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
  });
  var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
  var $elm$parser$Parser$Advanced$Append = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });
  var $elm$parser$Parser$Advanced$oneOfHelp = F3(function (s0, bag, parsers) {
    oneOfHelp: while (true) {
      if (!parsers.b) {
        return A2($elm$parser$Parser$Advanced$Bad, false, bag);
      } else {
        var parse = parsers.a;
        var remainingParsers = parsers.b;
        var _v1 = parse(s0);
        if (!_v1.$) {
          var step = _v1;
          return step;
        } else {
          var step = _v1;
          var p = step.a;
          var x = step.b;
          if (p) {
            return step;
          } else {
            var $temp$s0 = s0,
              $temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
              $temp$parsers = remainingParsers;
            s0 = $temp$s0;
            bag = $temp$bag;
            parsers = $temp$parsers;
            continue oneOfHelp;
          }
        }
      }
    }
  });
  var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
    return function (s) {
      return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
    };
  };
  var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
  var $elm$parser$Parser$Done = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $elm$parser$Parser$Loop = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $elm$core$String$append = _String_append;
  var $elm$parser$Parser$UnexpectedChar = {
    $: 11
  };
  var $elm$parser$Parser$Advanced$chompIf = F2(function (isGood, expecting) {
    return function (s) {
      var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.jf, s.b);
      return _Utils_eq(newOffset, -1) ? A2($elm$parser$Parser$Advanced$Bad, false, A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : _Utils_eq(newOffset, -2) ? A3($elm$parser$Parser$Advanced$Good, true, 0, {
        mv: 1,
        uO: s.uO,
        s: s.s,
        jf: s.jf + 1,
        ri: s.ri + 1,
        b: s.b
      }) : A3($elm$parser$Parser$Advanced$Good, true, 0, {
        mv: s.mv + 1,
        uO: s.uO,
        s: s.s,
        jf: newOffset,
        ri: s.ri,
        b: s.b
      });
    };
  });
  var $elm$parser$Parser$chompIf = function (isGood) {
    return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
  };
  var $elm$parser$Parser$Advanced$loopHelp = F4(function (p, state, callback, s0) {
    loopHelp: while (true) {
      var _v0 = callback(state);
      var parse = _v0;
      var _v1 = parse(s0);
      if (!_v1.$) {
        var p1 = _v1.a;
        var step = _v1.b;
        var s1 = _v1.c;
        if (!step.$) {
          var newState = step.a;
          var $temp$p = p || p1,
            $temp$state = newState,
            $temp$callback = callback,
            $temp$s0 = s1;
          p = $temp$p;
          state = $temp$state;
          callback = $temp$callback;
          s0 = $temp$s0;
          continue loopHelp;
        } else {
          var result = step.a;
          return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
        }
      } else {
        var p1 = _v1.a;
        var x = _v1.b;
        return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
      }
    }
  });
  var $elm$parser$Parser$Advanced$loop = F2(function (state, callback) {
    return function (s) {
      return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
    };
  });
  var $elm$parser$Parser$Advanced$map = F2(function (func, _v0) {
    var parse = _v0;
    return function (s0) {
      var _v1 = parse(s0);
      if (!_v1.$) {
        var p = _v1.a;
        var a = _v1.b;
        var s1 = _v1.c;
        return A3($elm$parser$Parser$Advanced$Good, p, func(a), s1);
      } else {
        var p = _v1.a;
        var x = _v1.b;
        return A2($elm$parser$Parser$Advanced$Bad, p, x);
      }
    };
  });
  var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
  var $elm$parser$Parser$Advanced$Done = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $elm$parser$Parser$Advanced$Loop = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $elm$parser$Parser$toAdvancedStep = function (step) {
    if (!step.$) {
      var s = step.a;
      return $elm$parser$Parser$Advanced$Loop(s);
    } else {
      var a = step.a;
      return $elm$parser$Parser$Advanced$Done(a);
    }
  };
  var $elm$parser$Parser$loop = F2(function (state, callback) {
    return A2($elm$parser$Parser$Advanced$loop, state, function (s) {
      return A2($elm$parser$Parser$map, $elm$parser$Parser$toAdvancedStep, callback(s));
    });
  });
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
    var helper = function (str) {
      if (_Utils_eq($elm$core$String$length(str), quantity)) {
        var _v0 = $elm$core$String$toInt(str);
        if (!_v0.$) {
          var intVal = _v0.a;
          return A2($elm$parser$Parser$map, $elm$parser$Parser$Done, $elm$parser$Parser$succeed(intVal));
        } else {
          return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
        }
      } else {
        return A2($elm$parser$Parser$map, function (nextChar) {
          return $elm$parser$Parser$Loop(A2($elm$core$String$append, str, nextChar));
        }, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
      }
    };
    return A2($elm$parser$Parser$loop, '', helper);
  };
  var $elm$parser$Parser$ExpectingSymbol = function (a) {
    return {
      $: 8,
      a: a
    };
  };
  var $elm$parser$Parser$Advanced$Token = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
  var $elm$parser$Parser$Advanced$token = function (_v0) {
    var str = _v0.a;
    var expecting = _v0.b;
    var progress = !$elm$core$String$isEmpty(str);
    return function (s) {
      var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.jf, s.ri, s.mv, s.b);
      var newOffset = _v1.a;
      var newRow = _v1.b;
      var newCol = _v1.c;
      return _Utils_eq(newOffset, -1) ? A2($elm$parser$Parser$Advanced$Bad, false, A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3($elm$parser$Parser$Advanced$Good, progress, 0, {
        mv: newCol,
        uO: s.uO,
        s: s.s,
        jf: newOffset,
        ri: newRow,
        b: s.b
      });
    };
  };
  var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
  var $elm$parser$Parser$symbol = function (str) {
    return $elm$parser$Parser$Advanced$symbol(A2($elm$parser$Parser$Advanced$Token, str, $elm$parser$Parser$ExpectingSymbol(str)));
  };
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
    return $elm$parser$Parser$problem('Invalid day: ' + $elm$core$String$fromInt(day));
  };
  var $elm$core$Basics$modBy = _Basics_modBy;
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
    return !A2($elm$core$Basics$modBy, 4, year) && (!!A2($elm$core$Basics$modBy, 100, year) || !A2($elm$core$Basics$modBy, 400, year));
  };
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
    var y = y1 - 1;
    return (y / 4 | 0) - (y / 100 | 0) + (y / 400 | 0);
  };
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
    var year = _v0.a;
    var month = _v0.b;
    var dayInMonth = _v0.c;
    if (dayInMonth < 0) {
      return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
    } else {
      var succeedWith = function (extraMs) {
        var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
        var days = month < 3 || !$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year) ? dayInMonth - 1 : dayInMonth;
        var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
        return $elm$parser$Parser$succeed(extraMs + yearMs + dayMs);
      };
      switch (month) {
        case 1:
          return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
        case 2:
          return dayInMonth > 29 || dayInMonth === 29 && !$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
        case 3:
          return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
        case 4:
          return dayInMonth > 30 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
        case 5:
          return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
        case 6:
          return dayInMonth > 30 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
        case 7:
          return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
        case 8:
          return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
        case 9:
          return dayInMonth > 30 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
        case 10:
          return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
        case 11:
          return dayInMonth > 30 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
        case 12:
          return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
        default:
          return $elm$parser$Parser$problem('Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
      }
    }
  };
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2($elm$parser$Parser$andThen, $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed(F3(function (year, month, day) {
    return _Utils_Tuple3(year, month, day);
  })), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol('-')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)]))), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol('-')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)]))));
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
    var utcOffsetMinutesFromParts = F3(function (multiplier, hours, minutes) {
      return multiplier * (hours * 60) + minutes;
    });
    return A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$map, function (_v0) {
      return 0;
    }, $elm$parser$Parser$symbol('Z')), A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed(utcOffsetMinutesFromParts), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$map, function (_v1) {
      return 1;
    }, $elm$parser$Parser$symbol('+')), A2($elm$parser$Parser$map, function (_v2) {
      return -1;
    }, $elm$parser$Parser$symbol('-'))]))), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol(':')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2), $elm$parser$Parser$succeed(0)]))), A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(0), $elm$parser$Parser$end)])));
  }();
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2($elm$parser$Parser$andThen, function (datePart) {
    return $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)), $elm$parser$Parser$symbol('T')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol(':')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)]))), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol(':')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)]))), $elm$parser$Parser$oneOf(_List_fromArray([A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol('.')), $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs), $elm$parser$Parser$succeed(0)]))), A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)), A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)), $elm$parser$Parser$end)]));
  }, $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
  var $elm$parser$Parser$DeadEnd = F3(function (row, col, problem) {
    return {
      mv: col,
      qF: problem,
      ri: row
    };
  });
  var $elm$parser$Parser$problemToDeadEnd = function (p) {
    return A3($elm$parser$Parser$DeadEnd, p.ri, p.mv, p.qF);
  };
  var $elm$parser$Parser$Advanced$bagToList = F2(function (bag, list) {
    bagToList: while (true) {
      switch (bag.$) {
        case 0:
          return list;
        case 1:
          var bag1 = bag.a;
          var x = bag.b;
          var $temp$bag = bag1,
            $temp$list = A2($elm$core$List$cons, x, list);
          bag = $temp$bag;
          list = $temp$list;
          continue bagToList;
        default:
          var bag1 = bag.a;
          var bag2 = bag.b;
          var $temp$bag = bag1,
            $temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
          bag = $temp$bag;
          list = $temp$list;
          continue bagToList;
      }
    }
  });
  var $elm$parser$Parser$Advanced$run = F2(function (_v0, src) {
    var parse = _v0;
    var _v1 = parse({
      mv: 1,
      uO: _List_Nil,
      s: 1,
      jf: 0,
      ri: 1,
      b: src
    });
    if (!_v1.$) {
      var value = _v1.b;
      return $elm$core$Result$Ok(value);
    } else {
      var bag = _v1.b;
      return $elm$core$Result$Err(A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
    }
  });
  var $elm$parser$Parser$run = F2(function (parser, source) {
    var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
    if (!_v0.$) {
      var a = _v0.a;
      return $elm$core$Result$Ok(a);
    } else {
      var problems = _v0.a;
      return $elm$core$Result$Err(A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
    }
  });
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
    return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
  };
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2($elm$json$Json$Decode$andThen, function (str) {
    var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
    if (_v0.$ === 1) {
      var deadEnds = _v0.a;
      return $elm$json$Json$Decode$fail($elm$parser$Parser$deadEndsToString(deadEnds));
    } else {
      var time = _v0.a;
      return $elm$json$Json$Decode$succeed(time);
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Scalar$Instant = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Interval = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Kilometers = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Markdown = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Meters = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Money = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$MoneyRange = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Point = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$TimeZone = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$Uuid = $elm$core$Basics$identity;
  var $elm$core$String$fromFloat = _String_fromNumber;
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$string, A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float), A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$map, function (bool) {
    if (bool) {
      return 'true';
    } else {
      return 'false';
    }
  }, $elm$json$Json$Decode$bool)]));
  var $author$project$Api$GraphqlSchema$Scalar$defaultCodecs = {
    up: {
      fu: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      aw: function (_v0) {
        var raw = _v0;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    uq: {
      fu: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      aw: function (_v1) {
        var raw = _v1;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    mu: {
      fu: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      aw: function (_v2) {
        var raw = _v2;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    hr: {
      fu: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      aw: function (_v3) {
        var raw = _v3;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    ur: {
      fu: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      aw: function (_v4) {
        var raw = _v4;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    us: {
      fu: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      aw: function (_v5) {
        var raw = _v5;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    ut: {
      fu: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      aw: function (_v6) {
        var raw = _v6;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    hs: {
      fu: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      aw: function (_v7) {
        var raw = _v7;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    uu: {
      fu: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      aw: function (_v8) {
        var raw = _v8;
        return $elm$json$Json$Encode$string(raw);
      }
    },
    uv: {
      fu: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
      aw: function (_v9) {
        var raw = _v9;
        return $elm$json$Json$Encode$string(raw);
      }
    }
  };
  var $author$project$Api$GraphqlSchema$Scalar$Codecs = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Scalar$defineCodecs = function (definitions) {
    return definitions;
  };
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
    switch (month) {
      case 0:
        return 1;
      case 1:
        return 2;
      case 2:
        return 3;
      case 3:
        return 4;
      case 4:
        return 5;
      case 5:
        return 6;
      case 6:
        return 7;
      case 7:
        return 8;
      case 8:
        return 9;
      case 9:
        return 10;
      case 10:
        return 11;
      default:
        return 12;
    }
  };
  var $elm$time$Time$flooredDiv = F2(function (numerator, denominator) {
    return $elm$core$Basics$floor(numerator / denominator);
  });
  var $elm$time$Time$posixToMillis = function (_v0) {
    var millis = _v0;
    return millis;
  };
  var $elm$time$Time$toAdjustedMinutesHelp = F3(function (defaultOffset, posixMinutes, eras) {
    toAdjustedMinutesHelp: while (true) {
      if (!eras.b) {
        return posixMinutes + defaultOffset;
      } else {
        var era = eras.a;
        var olderEras = eras.b;
        if (_Utils_cmp(era.eL, posixMinutes) < 0) {
          return posixMinutes + era.jf;
        } else {
          var $temp$defaultOffset = defaultOffset,
            $temp$posixMinutes = posixMinutes,
            $temp$eras = olderEras;
          defaultOffset = $temp$defaultOffset;
          posixMinutes = $temp$posixMinutes;
          eras = $temp$eras;
          continue toAdjustedMinutesHelp;
        }
      }
    }
  });
  var $elm$time$Time$toAdjustedMinutes = F2(function (_v0, time) {
    var defaultOffset = _v0.a;
    var eras = _v0.b;
    return A3($elm$time$Time$toAdjustedMinutesHelp, defaultOffset, A2($elm$time$Time$flooredDiv, $elm$time$Time$posixToMillis(time), 60000), eras);
  });
  var $elm$time$Time$toCivil = function (minutes) {
    var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
    var era = (rawDay >= 0 ? rawDay : rawDay - 146096) / 146097 | 0;
    var dayOfEra = rawDay - era * 146097;
    var yearOfEra = (dayOfEra - (dayOfEra / 1460 | 0) + (dayOfEra / 36524 | 0) - (dayOfEra / 146096 | 0)) / 365 | 0;
    var dayOfYear = dayOfEra - (365 * yearOfEra + (yearOfEra / 4 | 0) - (yearOfEra / 100 | 0));
    var mp = (5 * dayOfYear + 2) / 153 | 0;
    var month = mp + (mp < 10 ? 3 : -9);
    var year = yearOfEra + era * 400;
    return {
      mO: dayOfYear - ((153 * mp + 2) / 5 | 0) + 1,
      pt: month,
      ta: year + (month <= 2 ? 1 : 0)
    };
  };
  var $elm$time$Time$toDay = F2(function (zone, time) {
    return $elm$time$Time$toCivil(A2($elm$time$Time$toAdjustedMinutes, zone, time)).mO;
  });
  var $elm$time$Time$toHour = F2(function (zone, time) {
    return A2($elm$core$Basics$modBy, 24, A2($elm$time$Time$flooredDiv, A2($elm$time$Time$toAdjustedMinutes, zone, time), 60));
  });
  var $elm$time$Time$toMillis = F2(function (_v0, time) {
    return A2($elm$core$Basics$modBy, 1000, $elm$time$Time$posixToMillis(time));
  });
  var $elm$time$Time$toMinute = F2(function (zone, time) {
    return A2($elm$core$Basics$modBy, 60, A2($elm$time$Time$toAdjustedMinutes, zone, time));
  });
  var $elm$time$Time$Apr = 3;
  var $elm$time$Time$Aug = 7;
  var $elm$time$Time$Dec = 11;
  var $elm$time$Time$Feb = 1;
  var $elm$time$Time$Jan = 0;
  var $elm$time$Time$Jul = 6;
  var $elm$time$Time$Jun = 5;
  var $elm$time$Time$Mar = 2;
  var $elm$time$Time$May = 4;
  var $elm$time$Time$Nov = 10;
  var $elm$time$Time$Oct = 9;
  var $elm$time$Time$Sep = 8;
  var $elm$time$Time$toMonth = F2(function (zone, time) {
    var _v0 = $elm$time$Time$toCivil(A2($elm$time$Time$toAdjustedMinutes, zone, time)).pt;
    switch (_v0) {
      case 1:
        return 0;
      case 2:
        return 1;
      case 3:
        return 2;
      case 4:
        return 3;
      case 5:
        return 4;
      case 6:
        return 5;
      case 7:
        return 6;
      case 8:
        return 7;
      case 9:
        return 8;
      case 10:
        return 9;
      case 11:
        return 10;
      default:
        return 11;
    }
  });
  var $elm$core$String$cons = _String_cons;
  var $elm$core$String$fromChar = function (_char) {
    return A2($elm$core$String$cons, _char, '');
  };
  var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
  var $elm$core$String$repeatHelp = F3(function (n, chunk, result) {
    return n <= 0 ? result : A3($elm$core$String$repeatHelp, n >> 1, _Utils_ap(chunk, chunk), !(n & 1) ? result : _Utils_ap(result, chunk));
  });
  var $elm$core$String$repeat = F2(function (n, chunk) {
    return A3($elm$core$String$repeatHelp, n, chunk, '');
  });
  var $elm$core$String$padLeft = F3(function (n, _char, string) {
    return _Utils_ap(A2($elm$core$String$repeat, n - $elm$core$String$length(string), $elm$core$String$fromChar(_char)), string);
  });
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(function (digits, time) {
    return A3($elm$core$String$padLeft, digits, '0', $elm$core$String$fromInt(time));
  });
  var $elm$time$Time$toSecond = F2(function (_v0, time) {
    return A2($elm$core$Basics$modBy, 60, A2($elm$time$Time$flooredDiv, $elm$time$Time$posixToMillis(time), 1000));
  });
  var $elm$time$Time$toYear = F2(function (zone, time) {
    return $elm$time$Time$toCivil(A2($elm$time$Time$toAdjustedMinutes, zone, time)).ta;
  });
  var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
    return A2($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString, 4, A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString, 2, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString, 2, A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString, 2, A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString, 2, A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString, 2, A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2($rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString, 3, A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
  };
  var $rtfeldman$elm_iso8601_date_strings$Iso8601$encode = A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, $elm$json$Json$Encode$string);
  var $author$project$Api$ScalarCodecs$encodeInterval = function (_v0) {
    var from = _v0.wh;
    var to = _v0.CC;
    var toPaddedString = F2(function (digits, time) {
      return A3($elm$core$String$padLeft, digits, '0', $elm$core$String$fromInt(time));
    });
    var fromTime = function (_v1) {
      var year = _v1.ta;
      var month = _v1.pt;
      var day = _v1.mO;
      var hour = _v1.wC;
      var minute = _v1.yu;
      return A2(toPaddedString, 4, year) + ('-' + (A2(toPaddedString, 2, month) + ('-' + (A2(toPaddedString, 2, day) + ('T' + (A2(toPaddedString, 2, hour) + (':' + (A2(toPaddedString, 2, minute) + (':' + A2(toPaddedString, 2, 0))))))))));
    };
    return $elm$json$Json$Encode$string(fromTime(from) + ('..' + fromTime(to)));
  };
  var $author$project$Api$ScalarCodecs$encodeMoneyRange = function (_v0) {
    var from = _v0.wh;
    var to = _v0.CC;
    return $elm$json$Json$Encode$string($elm$core$String$fromInt(from) + ('..' + $elm$core$String$fromInt(to)));
  };
  var $author$project$Api$ScalarCodecs$encodePoint = function (_v0) {
    var lat = _v0.oV;
    var lng = _v0.o_;
    return $elm$json$Json$Encode$string('[' + ($elm$core$String$fromFloat(lng) + (', ' + ($elm$core$String$fromFloat(lat) + ']'))));
  };
  var $author$project$ElmFramework$Lib$Util$toNumberFromMonth = function (month) {
    switch (month) {
      case 0:
        return 1;
      case 1:
        return 2;
      case 2:
        return 3;
      case 3:
        return 4;
      case 4:
        return 5;
      case 5:
        return 6;
      case 6:
        return 7;
      case 7:
        return 8;
      case 8:
        return 9;
      case 9:
        return 10;
      case 10:
        return 11;
      default:
        return 12;
    }
  };
  var $author$project$ElmFramework$Lib$Util$toMonthAsNumber = F2(function (zone, posix) {
    return $author$project$ElmFramework$Lib$Util$toNumberFromMonth(A2($elm$time$Time$toMonth, zone, posix));
  });
  var $author$project$Api$ScalarCodecs$intervalDecoder = A2($elm$json$Json$Decode$andThen, function (intervalString) {
    var posixToLocalDateTime = function (posix) {
      return {
        mO: A2($elm$time$Time$toDay, $elm$time$Time$utc, posix),
        wC: A2($elm$time$Time$toHour, $elm$time$Time$utc, posix),
        yu: A2($elm$time$Time$toMinute, $elm$time$Time$utc, posix),
        pt: A2($author$project$ElmFramework$Lib$Util$toMonthAsNumber, $elm$time$Time$utc, posix),
        ta: A2($elm$time$Time$toYear, $elm$time$Time$utc, posix)
      };
    };
    var _v0 = function () {
      var _v1 = A2($elm$core$String$split, '..', intervalString);
      if (_v1.b && _v1.b.b && !_v1.b.b.b) {
        var from = _v1.a;
        var _v2 = _v1.b;
        var to = _v2.a;
        return _Utils_Tuple2(from, to);
      } else {
        return _Utils_Tuple2('', '');
      }
    }();
    var fromIncompleteIsoString = _v0.a;
    var toIncompleteIsoString = _v0.b;
    var decodeFrom = function (addMilliseconds) {
      var ms = addMilliseconds ? ':00' : '';
      return A2($elm$json$Json$Decode$decodeString, $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder, '\"' + (fromIncompleteIsoString + (ms + ('Z' + '\"'))));
    };
    var decodeTo = function (addMilliseconds) {
      var ms = addMilliseconds ? ':00' : '';
      return A2($elm$json$Json$Decode$decodeString, $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder, '\"' + (toIncompleteIsoString + (ms + ('Z' + '\"'))));
    };
    var _v3 = _Utils_Tuple2(decodeFrom(true), decodeTo(true));
    if (!_v3.a.$) {
      if (!_v3.b.$) {
        var fromPosix = _v3.a.a;
        var toPosix = _v3.b.a;
        return $elm$json$Json$Decode$succeed({
          wh: posixToLocalDateTime(fromPosix),
          CC: posixToLocalDateTime(toPosix)
        });
      } else {
        var fromPosix = _v3.a.a;
        var _v5 = decodeTo(false);
        if (!_v5.$) {
          var toPosix = _v5.a;
          return $elm$json$Json$Decode$succeed({
            wh: posixToLocalDateTime(fromPosix),
            CC: posixToLocalDateTime(toPosix)
          });
        } else {
          return $elm$json$Json$Decode$fail('Failed decoding time: invalid time format');
        }
      }
    } else {
      if (!_v3.b.$) {
        var toPosix = _v3.b.a;
        var _v4 = decodeFrom(false);
        if (!_v4.$) {
          var fromPosix = _v4.a;
          return $elm$json$Json$Decode$succeed({
            wh: posixToLocalDateTime(fromPosix),
            CC: posixToLocalDateTime(toPosix)
          });
        } else {
          return $elm$json$Json$Decode$fail('Failed decoding time: invalid time format');
        }
      } else {
        var _v6 = _Utils_Tuple2(decodeFrom(false), decodeTo(false));
        if (!_v6.a.$ && !_v6.b.$) {
          var fromPosix = _v6.a.a;
          var toPosix = _v6.b.a;
          return $elm$json$Json$Decode$succeed({
            wh: posixToLocalDateTime(fromPosix),
            CC: posixToLocalDateTime(toPosix)
          });
        } else {
          return $elm$json$Json$Decode$fail('Failed decoding time: invalid time format');
        }
      }
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$ScalarCodecs$moneyRangeDecoder = A2($elm$json$Json$Decode$andThen, function (intervalString) {
    var _v0 = function () {
      var _v1 = A2($elm$core$String$split, '..', intervalString);
      if (_v1.b && _v1.b.b && !_v1.b.b.b) {
        var fromString = _v1.a;
        var _v2 = _v1.b;
        var toString = _v2.a;
        return _Utils_Tuple2(fromString, toString);
      } else {
        return _Utils_Tuple2('', '');
      }
    }();
    var from = _v0.a;
    var to = _v0.b;
    var _v3 = _Utils_Tuple2($elm$core$String$toInt(from), $elm$core$String$toInt(to));
    if (!_v3.a.$ && !_v3.b.$) {
      var fromMoney = _v3.a.a;
      var toMoney = _v3.b.a;
      return $elm$json$Json$Decode$succeed({
        wh: fromMoney,
        CC: toMoney
      });
    } else {
      return $elm$json$Json$Decode$fail('Failed decoding money range: invalid format');
    }
  }, $elm$json$Json$Decode$string);
  var $elm$core$String$replace = F3(function (before, after, string) {
    return A2($elm$core$String$join, after, A2($elm$core$String$split, before, string));
  });
  var $author$project$Api$ScalarCodecs$pointDecoder = A2($elm$json$Json$Decode$andThen, function (pointString) {
    var simplifiedString = A3($elm$core$String$replace, ' ', '', A2($elm$core$String$dropRight, 1, A2($elm$core$String$dropLeft, 1, pointString)));
    var _v0 = function () {
      var _v1 = A2($elm$core$String$split, ',', simplifiedString);
      if (_v1.b && _v1.b.b && !_v1.b.b.b) {
        var lat = _v1.a;
        var _v2 = _v1.b;
        var lng = _v2.a;
        return _Utils_Tuple2(lat, lng);
      } else {
        return _Utils_Tuple2('', '');
      }
    }();
    var longitudeString = _v0.a;
    var latitudeString = _v0.b;
    var decodeLatitude = A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$float, latitudeString);
    var decodeLongitude = A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$float, longitudeString);
    var _v3 = _Utils_Tuple2(decodeLatitude, decodeLongitude);
    if (!_v3.a.$ && !_v3.b.$) {
      var lat = _v3.a.a;
      var lng = _v3.b.a;
      return $elm$json$Json$Decode$succeed({
        oV: lat,
        o_: lng
      });
    } else {
      return $elm$json$Json$Decode$fail('Failed decoding time: invalid time format');
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$ScalarCodecs$codecs = $author$project$Api$GraphqlSchema$Scalar$defineCodecs({
    up: {
      fu: $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
      aw: $rtfeldman$elm_iso8601_date_strings$Iso8601$encode
    },
    uq: {
      fu: $author$project$Api$ScalarCodecs$intervalDecoder,
      aw: $author$project$Api$ScalarCodecs$encodeInterval
    },
    mu: {
      fu: $elm$json$Json$Decode$int,
      aw: $elm$json$Json$Encode$int
    },
    hr: {
      fu: $elm$json$Json$Decode$string,
      aw: $elm$json$Json$Encode$string
    },
    ur: {
      fu: $elm$json$Json$Decode$int,
      aw: $elm$json$Json$Encode$int
    },
    us: {
      fu: $elm$json$Json$Decode$int,
      aw: $elm$json$Json$Encode$int
    },
    ut: {
      fu: $author$project$Api$ScalarCodecs$moneyRangeDecoder,
      aw: $author$project$Api$ScalarCodecs$encodeMoneyRange
    },
    hs: {
      fu: $author$project$Api$ScalarCodecs$pointDecoder,
      aw: $author$project$Api$ScalarCodecs$encodePoint
    },
    uu: {
      fu: $elm$json$Json$Decode$string,
      aw: $elm$json$Json$Encode$string
    },
    uv: $author$project$Api$GraphqlSchema$Scalar$defaultCodecs.uv
  });
  var $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs = function (_v0) {
    var unwrappedCodecs = _v0;
    return unwrappedCodecs;
  };
  var $author$project$Api$GraphqlSchema$Object$SearchDetails$createdAt = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Instant', 'createdAt', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).up.fu);
  var $author$project$Api$GraphqlSchema$Object$SearchDetails$createdBy = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'createdBy', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$ParticipantPublic$profile = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'profile', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$ParticipantPublic$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'userId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Interface$UserProfileLimited$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Enum$Gender$Female = 0;
  var $author$project$Api$GraphqlSchema$Enum$Gender$Male = 1;
  var $author$project$Api$GraphqlSchema$Enum$Gender$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'FEMALE':
        return $elm$json$Json$Decode$succeed(0);
      case 'MALE':
        return $elm$json$Json$Decode$succeed(1);
      default:
        return $elm$json$Json$Decode$fail('Invalid Gender type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Interface$UserProfileLimited$gender = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Gender.Gender', 'gender', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Gender$decoder);
  var $author$project$Api$GraphqlSchema$Interface$UserProfileLimited$lastNameOrInitial = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastNameOrInitial', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Interface$UserProfileLimited$photo = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'photo', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };
  var $author$project$Api$GraphqlSchema$Object$Photo$url = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'url', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$userProfileLimited = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Interface$UserProfileLimited$photo($author$project$Api$GraphqlSchema$Object$Photo$url), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Interface$UserProfileLimited$gender, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Interface$UserProfileLimited$lastNameOrInitial, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Interface$UserProfileLimited$firstName, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F4(function (firstName, lastNameOrInitial, gender, photo) {
    return {
      nF: firstName,
      nM: gender,
      fT: $elm$core$String$length(lastNameOrInitial) === 1 ? lastNameOrInitial + '.' : lastNameOrInitial,
      qq: photo
    };
  }))))));
  var $author$project$Api$Schema$participantPublic = A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$ParticipantPublic$userId, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ParticipantPublic$profile($author$project$Api$Schema$userProfileLimited), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F2(function (_v0, userId) {
    var firstName = _v0.nF;
    var lastNameOrInitial = _v0.fT;
    var gender = _v0.nM;
    var photoUrl = _v0.qq;
    return {
      nF: firstName,
      nM: gender,
      fT: $elm$core$String$length(lastNameOrInitial) === 1 ? lastNameOrInitial + '.' : lastNameOrInitial,
      c5: photoUrl,
      e_: userId
    };
  }))));
  var $author$project$Api$GraphqlSchema$Object$SearchDetails$search = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'search', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Types$Search$Search = F5(function (id, params, state, invites, externalInvites) {
    return {
      v7: externalInvites,
      od: id,
      w5: invites,
      p8: params,
      aC: state
    };
  });
  var $author$project$Api$GraphqlSchema$Object$Search$externalInvites = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'externalInvites', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };
  var $author$project$Api$GraphqlSchema$Object$Search$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Search$invites = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'invites', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };
  var $author$project$Api$GraphqlSchema$Object$Search$params = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'params', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Types$Search$SearchExternalInvites = F4(function (created, accepted, rejected, maybeInviteToken) {
    return {
      td: accepted,
      uU: created,
      ye: maybeInviteToken,
      A_: rejected
    };
  });
  var $author$project$Api$GraphqlSchema$Object$SearchExternalInvites$accepted = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'accepted', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Object$SearchExternalInvites$created = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'created', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Object$SearchExternalInvites$inviteToken = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'inviteToken', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$SearchExternalInvites$rejected = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'rejected', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$Schema$searchExternalIInvites = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchExternalInvites$inviteToken, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchExternalInvites$rejected, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchExternalInvites$accepted, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchExternalInvites$created, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Search$SearchExternalInvites)))));
  var $author$project$Types$Search$SearchInvite = F3(function (userId, profile, inviteStatus) {
    return {
      ow: inviteStatus,
      qI: profile,
      e_: userId
    };
  });
  var $author$project$Api$GraphqlSchema$Enum$SearchInviteStatus$Accepted = 2;
  var $author$project$Api$GraphqlSchema$Enum$SearchInviteStatus$Invited = 1;
  var $author$project$Api$GraphqlSchema$Enum$SearchInviteStatus$Pending = 0;
  var $author$project$Api$GraphqlSchema$Enum$SearchInviteStatus$Rejected = 3;
  var $author$project$Api$GraphqlSchema$Enum$SearchInviteStatus$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'PENDING':
        return $elm$json$Json$Decode$succeed(0);
      case 'INVITED':
        return $elm$json$Json$Decode$succeed(1);
      case 'ACCEPTED':
        return $elm$json$Json$Decode$succeed(2);
      case 'REJECTED':
        return $elm$json$Json$Decode$succeed(3);
      default:
        return $elm$json$Json$Decode$fail('Invalid SearchInviteStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$SearchInvite$inviteStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.SearchInviteStatus.SearchInviteStatus', 'inviteStatus', _List_Nil, $author$project$Api$GraphqlSchema$Enum$SearchInviteStatus$decoder);
  var $author$project$Api$GraphqlSchema$Object$SearchInvite$profile = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'profile', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$SearchInvite$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'userId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$searchInvites = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchInvite$inviteStatus, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchInvite$profile($author$project$Api$Schema$userProfileLimited), A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$SearchInvite$userId, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Search$SearchInvite))));
  var $author$project$Types$Search$SearchParams = F6(function (invitedPlayers, activity, availability, location, address, withinDistance) {
    return {
      du: activity,
      cy: address,
      tF: availability,
      ox: invitedPlayers,
      iT: location,
      Dr: withinDistance
    };
  });
  var $author$project$Api$GraphqlSchema$Enum$Activity$Badminton = 0;
  var $author$project$Api$GraphqlSchema$Enum$Activity$Padel = 1;
  var $author$project$Api$GraphqlSchema$Enum$Activity$Squash = 2;
  var $author$project$Api$GraphqlSchema$Enum$Activity$Tennis = 3;
  var $author$project$Api$GraphqlSchema$Enum$Activity$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'BADMINTON':
        return $elm$json$Json$Decode$succeed(0);
      case 'PADEL':
        return $elm$json$Json$Decode$succeed(1);
      case 'SQUASH':
        return $elm$json$Json$Decode$succeed(2);
      case 'TENNIS':
        return $elm$json$Json$Decode$succeed(3);
      default:
        return $elm$json$Json$Decode$fail('Invalid Activity type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$SearchParams$activity = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Activity.Activity', 'activity', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Activity$decoder);
  var $author$project$Api$GraphqlSchema$Object$SearchParams$address = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'address', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };
  var $author$project$Types$GeoLocation$Address = F2(function (title, subtitle) {
    return {
      lb: subtitle,
      lh: title
    };
  });
  var $author$project$Api$GraphqlSchema$Object$FormattedAddress$subtitle = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'subtitle', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$FormattedAddress$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$address = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$FormattedAddress$subtitle, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$FormattedAddress$title, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$GeoLocation$Address)));
  var $author$project$Api$GraphqlSchema$Object$SearchParams$availability = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(List Api.ScalarCodecs.Interval)', 'availability', _List_Nil, $elm$json$Json$Decode$list($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).uq.fu));
  var $author$project$Api$GraphqlSchema$Object$SearchParams$location = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Point', 'location', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).hs.fu);
  var $author$project$Api$GraphqlSchema$Object$SearchParams$withinDistance = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Kilometers', 'withinDistance', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).mu.fu);
  var $author$project$Api$Schema$searchParams = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchParams$withinDistance, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$SearchParams$address($author$project$Api$Schema$address), function (maybeAddress) {
    return A2($elm$core$Maybe$withDefault, {
      lb: '',
      lh: ''
    }, maybeAddress);
  }, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchParams$location, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchParams$availability, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchParams$activity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Search$SearchParams(_List_Nil)))))));
  var $author$project$Api$GraphqlSchema$Enum$SearchState$AwaitingPayment = 1;
  var $author$project$Api$GraphqlSchema$Enum$SearchState$Canceled = 3;
  var $author$project$Api$GraphqlSchema$Enum$SearchState$Complete = 5;
  var $author$project$Api$GraphqlSchema$Enum$SearchState$Expired = 4;
  var $author$project$Api$GraphqlSchema$Enum$SearchState$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'ACTIVE':
        return $elm$json$Json$Decode$succeed(0);
      case 'AWAITING_PAYMENT':
        return $elm$json$Json$Decode$succeed(1);
      case 'AWAITING_USERS':
        return $elm$json$Json$Decode$succeed(2);
      case 'CANCELED':
        return $elm$json$Json$Decode$succeed(3);
      case 'EXPIRED':
        return $elm$json$Json$Decode$succeed(4);
      case 'COMPLETE':
        return $elm$json$Json$Decode$succeed(5);
      default:
        return $elm$json$Json$Decode$fail('Invalid SearchState type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Search$state = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.SearchState.SearchState', 'state', _List_Nil, $author$project$Api$GraphqlSchema$Enum$SearchState$decoder);
  var $author$project$Api$Schema$search = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Search$externalInvites($author$project$Api$Schema$searchExternalIInvites), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Search$invites($author$project$Api$Schema$searchInvites), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Search$state, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Search$params($author$project$Api$Schema$searchParams), A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$Search$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Search$Search))))));
  var $author$project$Api$Schema$searchDetails = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchDetails$search($author$project$Api$Schema$search), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchDetails$createdBy($author$project$Api$Schema$participantPublic), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchDetails$createdAt, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Search$SearchDetails))));
  var $author$project$Api$GraphqlSchema$Object$ListSearchesSuccess$searches = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'searches', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };
  var $author$project$Api$Schema$selectAfterCursor = A2($elm$core$Basics$composeR, $elm$core$Maybe$map(function ($) {
    return $.tq;
  }), $elm_community$maybe_extra$Maybe$Extra$join);
  var $author$project$Api$Schema$searches = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ListSearchesSuccess$cursorIds($author$project$Api$Schema$cursorIds), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ListSearchesSuccess$searches($author$project$Api$Schema$searchDetails), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F2(function (searches_, maybeCursorIds) {
    return A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$Paged, searches_, $author$project$Api$Schema$selectAfterCursor(maybeCursorIds));
  }))));
  var $author$project$ElmFramework$Feature$Auth$Extra$authErrorLoopback = _Platform_outgoingPort('authErrorLoopback', function ($) {
    return $elm$json$Json$Encode$null;
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$authRejectCmds = $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$Auth$Extra$authErrorLoopback(0)]));
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$detailedError = _Platform_outgoingPort('detailedError', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('extra', $elm$core$Basics$identity($.d1)), _Utils_Tuple2('msg', $elm$json$Json$Encode$string($.c_))]));
  });
  var $author$project$ElmFramework$Feature$Toaster$Notifier$emitNotif = _Platform_outgoingPort('emitNotif', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('bodies', $elm$json$Json$Encode$list($elm$json$Json$Encode$string)($.aT)), _Utils_Tuple2('kind', $elm$json$Json$Encode$string($.xu)), _Utils_Tuple2('title', $elm$json$Json$Encode$string($.lh))]));
  });
  var $author$project$ElmFramework$Feature$Toaster$Notifier$info = F2(function (title, bodies) {
    return $author$project$ElmFramework$Feature$Toaster$Notifier$emitNotif({
      aT: bodies,
      xu: $author$project$ElmFramework$Feature$Toaster$Notifier$notifKind.wL,
      lh: title
    });
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$graphqlErrToCmd = F2(function (shouldToast, _v0) {
    var message = _v0.f0;
    var details = _v0.vp;
    var massagedMessage = A3($elm$core$String$replace, 'Unexpected error value: ', '', message);
    return message === 'Authentication Error' ? $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$authRejectCmds : $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$detailedError({
      d1: $elm$json$Json$Encode$object($elm$core$Dict$toList(details)),
      c_: message
    }), A3($author$project$ElmFramework$Lib$Util$ifElse, A2($author$project$ElmFramework$Feature$Toaster$Notifier$info, massagedMessage, _List_Nil), $elm$core$Platform$Cmd$none, shouldToast)]));
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$StructuredHttpError = F3(function (status, message, errors) {
    return {
      hU: errors,
      f0: message,
      Cd: status
    };
  });
  var $elm$core$Dict$map = F2(function (func, dict) {
    if (dict.$ === -2) {
      return $elm$core$Dict$RBEmpty_elm_builtin;
    } else {
      var color = dict.a;
      var key = dict.b;
      var value = dict.c;
      var left = dict.d;
      var right = dict.e;
      return A5($elm$core$Dict$RBNode_elm_builtin, color, key, A2(func, key, value), A2($elm$core$Dict$map, func, left), A2($elm$core$Dict$map, func, right));
    }
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$toErrorMessage = F2(function (fieldId, errMessage) {
    return fieldId + (': ' + errMessage);
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$httpErrorBodyErrorsDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([A2($elm$json$Json$Decode$map, $elm$core$Dict$map(F2(function (fieldId, errMessage) {
    return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$toErrorMessage, fieldId, errMessage);
  })), $elm$json$Json$Decode$dict($elm$json$Json$Decode$string)), A2($elm$json$Json$Decode$map, $elm$core$Dict$map(F2(function (fieldId, fieldErrors) {
    return A2($elm$core$String$join, '\n', A2($elm$core$List$map, function (_v0) {
      var errType = _v0.a;
      var errMessage = _v0.b;
      return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$toErrorMessage, fieldId, errMessage);
    }, $elm$core$Dict$toList(fieldErrors)));
  })), $elm$json$Json$Decode$dict($elm$json$Json$Decode$dict($elm$json$Json$Decode$string))), $elm$json$Json$Decode$succeed($elm$core$Dict$empty)]));
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$httpErrorBodyDecoder = A4($elm$json$Json$Decode$map3, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$StructuredHttpError, $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string)), A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string), $elm$json$Json$Decode$oneOf(_List_fromArray([A2($elm$json$Json$Decode$field, 'errors', $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$httpErrorBodyErrorsDecoder), A2($elm$json$Json$Decode$field, 'err', $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$httpErrorBodyErrorsDecoder), $elm$json$Json$Decode$succeed($elm$core$Dict$empty)])));
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$sendStructuredHttpError = function (structuredHttpError) {
    return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$detailedError({
      d1: $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('errors', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, $elm$core$Dict$values(structuredHttpError.hU)))])),
      c_: structuredHttpError.f0
    });
  };
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleHttpBadStatus = F3(function (shouldToast, meta, body) {
    var _v0 = A2($author$project$ElmFramework$Lib$Util$decodeString, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$httpErrorBodyDecoder, body);
    if (!_v0.$) {
      var decodedResponse = _v0.a;
      return $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$sendStructuredHttpError(decodedResponse), A3($author$project$ElmFramework$Lib$Util$ifElse, A2($author$project$ElmFramework$Feature$Toaster$Notifier$info, decodedResponse.f0, $elm$core$Dict$values(decodedResponse.hU)), $elm$core$Platform$Cmd$none, shouldToast)]));
    } else {
      return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$detailedError({
        d1: $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('body', $elm$json$Json$Encode$string(body))])),
        c_: 'unexpected http status: ' + ($elm$core$String$fromInt(meta.Ce) + (' ' + meta.Cf))
      });
    }
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleGraphqlHttpErr = F2(function (shouldToast, httpErr) {
    switch (httpErr.$) {
      case 3:
        var meta = httpErr.a;
        var body = httpErr.b;
        return meta.Ce === 401 ? $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$authRejectCmds : A3($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleHttpBadStatus, shouldToast, meta, body);
      case 4:
        var jdErr = httpErr.a;
        return $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('handleGraphqlHttpErr: BadPayload: ' + $elm$json$Json$Decode$errorToString(jdErr)), A3($author$project$ElmFramework$Lib$Util$ifElse, A2($author$project$ElmFramework$Feature$Toaster$Notifier$info, 'Bad payload / Unexpected response', _List_fromArray([A2($elm$core$String$left, 200, $elm$json$Json$Decode$errorToString(jdErr))])), $elm$core$Platform$Cmd$none, shouldToast)]));
      case 2:
        return $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('handleGraphqlHttpErr: NetworkError'), A3($author$project$ElmFramework$Lib$Util$ifElse, A2($author$project$ElmFramework$Feature$Toaster$Notifier$info, 'NetworkError', _List_Nil), $elm$core$Platform$Cmd$none, shouldToast)]));
      case 1:
        return $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('handleGraphqlHttpErr: Timeout'), A3($author$project$ElmFramework$Lib$Util$ifElse, A2($author$project$ElmFramework$Feature$Toaster$Notifier$info, 'Request timed out', _List_fromArray(['Try again maybe?'])), $elm$core$Platform$Cmd$none, shouldToast)]));
      default:
        var string = httpErr.a;
        return $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('handleGraphqlHttpErr: BadUrl: ' + string), A3($author$project$ElmFramework$Lib$Util$ifElse, A2($author$project$ElmFramework$Feature$Toaster$Notifier$info, 'Bad URL', _List_fromArray([string])), $elm$core$Platform$Cmd$none, shouldToast)]));
    }
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleGraphqlErr = F2(function (shouldToast, err) {
    if (!err.$) {
      var errors = err.b;
      return $elm$core$Platform$Cmd$batch(A2($elm$core$List$map, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$graphqlErrToCmd(shouldToast), errors));
    } else {
      var theErr = err.a;
      return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleGraphqlHttpErr, shouldToast, theErr);
    }
  });
  var $author$project$Api$Api$transformToFetchPageTask = function (task) {
    var handleGraphqlSuccessResult = function (result) {
      if (!result.$) {
        var r = result.a;
        return $elm$core$Task$succeed(r);
      } else {
        var err = result.a;
        return $elm$core$Task$fail($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError(err));
      }
    };
    return A2($elm$core$Task$andThen, handleGraphqlSuccessResult, A2($elm$core$Task$mapError, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleGraphqlErr(true), task));
  };
  var $author$project$Api$Api$getActiveAndAwaitingUsersSearches = F4(function (apiEndpoint, limit, idToken, maybeNextPagePointer) {
    var payload = $author$project$Api$GraphqlSchema$Union$ListSearchesPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      zh: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Ok, $author$project$Api$Schema$searches),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message)
    });
    var optionalArguments = function (optionalArguments_) {
      var pagination = function () {
        if (!maybeNextPagePointer.$) {
          var nextPagePointer = maybeNextPagePointer.a;
          return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
            cE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
              hL: 1,
              od: nextPagePointer
            }),
            cW: limit
          });
        } else {
          return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
            cE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            cW: limit
          });
        }
      }();
      return {
        cZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
          cF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          by: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          BJ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
            dx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            d$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            eK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(_List_fromArray([2, 0]))
          })
        }),
        f9: pagination
      };
    };
    return $author$project$Api$Api$transformToFetchPageTask(A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$searches(A2($author$project$Api$GraphqlSchema$Object$SearchQuery$searches, optionalArguments, payload))));
  });
  var $author$project$Api$Api$HistoryMatches = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$Api$GraphqlSchema$Enum$MatchAttribute$Historical = 0;
  var $author$project$Api$GraphqlSchema$Enum$MatchAttribute$Upcoming = 2;
  var $author$project$Api$GraphqlSchema$Union$ListMatchesPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ListMatchesSuccess', selections____.jr), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k)]));
  };
  var $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe = function (maybeValue) {
    if (!maybeValue.$) {
      var value = maybeValue.a;
      return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(value);
    } else {
      return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
    }
  };
  var $author$project$Api$GraphqlSchema$Object$ListMatchesSuccess$cursorIds = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'cursorIds', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };
  var $author$project$Types$Match$MatchDetails = F8(function (category, createdAt, match, participants, venue, pendingParticipantsCount, joiningParticipants, suggestedParticipantsCount) {
    return {
      ua: category,
      uV: createdAt,
      xq: joiningParticipants,
      xX: match,
      z8: participants,
      Ai: pendingParticipantsCount,
      Cp: suggestedParticipantsCount,
      Dh: venue
    };
  });
  var $author$project$Api$GraphqlSchema$Enum$MatchCategory$Historical = 1;
  var $author$project$Api$GraphqlSchema$Enum$MatchCategory$Upcoming = 0;
  var $author$project$Api$GraphqlSchema$Enum$MatchCategory$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'UPCOMING':
        return $elm$json$Json$Decode$succeed(0);
      case 'HISTORICAL':
        return $elm$json$Json$Decode$succeed(1);
      default:
        return $elm$json$Json$Decode$fail('Invalid MatchCategory type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchDetails$category = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.MatchCategory.MatchCategory', 'category', _List_Nil, $author$project$Api$GraphqlSchema$Enum$MatchCategory$decoder);
  var $author$project$Api$GraphqlSchema$Object$MatchDetails$createdAt = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Instant', 'createdAt', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).up.fu);
  var $author$project$Api$GraphqlSchema$Object$MatchDetails$joiningParticipants = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'joiningParticipants', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };
  var $author$project$Api$GraphqlSchema$Object$MatchDetails$match = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'match', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Types$Match$Match = F4(function (activity, courtTime, status, id) {
    return {
      du: activity,
      dM: courtTime,
      od: id,
      Cd: status
    };
  });
  var $author$project$Api$GraphqlSchema$Object$Match$activity = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Activity.Activity', 'activity', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Activity$decoder);
  var $author$project$Api$GraphqlSchema$Object$Match$courtTime = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'courtTime', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Types$CourtTime$CourtTime = F6(function (courtName, price, timeSlot, timeZone, id, venueId) {
    return {
      hA: courtName,
      od: id,
      aO: price,
      le: timeSlot,
      dl: timeZone,
      e1: venueId
    };
  });
  var $author$project$Types$CourtTime$CourtTimeId = $elm$core$Basics$identity;
  var $author$project$Types$Venue$VenueId = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Object$CourtTime$courtName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'courtName', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$CourtTime$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$CourtTime$priceWithCurrency = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'priceWithCurrency', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$Price$amount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Money', 'amount', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).us.fu);
  var $author$project$Api$GraphqlSchema$Enum$Currency$Aed = 0;
  var $author$project$Api$GraphqlSchema$Enum$Currency$Usd = 1;
  var $author$project$Api$GraphqlSchema$Enum$Currency$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'AED':
        return $elm$json$Json$Decode$succeed(0);
      case 'USD':
        return $elm$json$Json$Decode$succeed(1);
      default:
        return $elm$json$Json$Decode$fail('Invalid Currency type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Price$currency = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Currency.Currency', 'currency', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Currency$decoder);
  var $author$project$Api$Schema$priceWithCurrency = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Price$currency, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Price$amount, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F2(function (amount, currency) {
    return amount;
  }))));
  var $author$project$Api$GraphqlSchema$Object$CourtTime$timeSlot = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Interval', 'timeSlot', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).uq.fu);
  var $author$project$Api$GraphqlSchema$Object$CourtTime$timeZone = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.TimeZone', 'timeZone', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).uu.fu);
  var $author$project$Api$GraphqlSchema$Object$CourtTime$venueId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'venueId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$courtTime = A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$CourtTime$venueId, $elm$core$Basics$identity, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$CourtTime$id, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CourtTime$timeZone, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CourtTime$timeSlot, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CourtTime$priceWithCurrency($author$project$Api$Schema$priceWithCurrency), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CourtTime$courtName, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$CourtTime$CourtTime)))))));
  var $author$project$Api$GraphqlSchema$Object$Match$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Types$Match$Filled = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Types$Match$PartialFill = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Types$Match$Unfilled = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Types$Match$UnfilledExpired = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $author$project$Api$GraphqlSchema$Object$UnfilledExpired$expiredAt = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Instant', 'expiredAt', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).up.fu);
  var $author$project$Api$GraphqlSchema$Interface$MatchStatus$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Filled', selections____.jp), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PartialFill', selections____.jB), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Unfilled', selections____.jS), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UnfilledExpired', selections____.jT)]));
  };
  var $dillonkearns$elm_graphql$Graphql$SelectionSet$map2 = F3(function (combine, _v0, _v1) {
    var selectionFields1 = _v0.a;
    var selectionDecoder1 = _v0.b;
    var selectionFields2 = _v1.a;
    var selectionDecoder2 = _v1.b;
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, _Utils_ap(selectionFields1, selectionFields2), A3($elm$json$Json$Decode$map2, combine, selectionDecoder1, selectionDecoder2));
  });
  var $author$project$Api$GraphqlSchema$Object$Filled$needed = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'needed', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Object$PartialFill$needed = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'needed', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Object$Unfilled$needed = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'needed', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Object$UnfilledExpired$needed = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'needed', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$Schema$matchStatus = $author$project$Api$GraphqlSchema$Interface$MatchStatus$fragments({
    jp: A2($author$project$Api$Schema$mapField, $author$project$Types$Match$Filled, $author$project$Api$GraphqlSchema$Object$Filled$needed),
    jB: A2($author$project$Api$Schema$mapField, $author$project$Types$Match$PartialFill, $author$project$Api$GraphqlSchema$Object$PartialFill$needed),
    jS: A2($author$project$Api$Schema$mapField, $author$project$Types$Match$Unfilled, $author$project$Api$GraphqlSchema$Object$Unfilled$needed),
    jT: A3($dillonkearns$elm_graphql$Graphql$SelectionSet$map2, $author$project$Types$Match$UnfilledExpired, $author$project$Api$GraphqlSchema$Object$UnfilledExpired$needed, $author$project$Api$GraphqlSchema$Object$UnfilledExpired$expiredAt)
  });
  var $author$project$Api$GraphqlSchema$Object$Match$status = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'status', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$Schema$match = A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$Match$id, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Match$status($author$project$Api$Schema$matchStatus), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Match$courtTime($author$project$Api$Schema$courtTime), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Match$activity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Match$Match)))));
  var $author$project$Types$Participant$ParticipantTypePublic = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Api$GraphqlSchema$Interface$Participant$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ParticipantPrivate', selections____.jC), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ParticipantPublic', selections____.jD)]));
  };
  var $author$project$Types$Participant$ParticipantPrivate = F6(function (actions, profile, rating, userId, participantPaymentStatus, price) {
    return {
      th: actions,
      z7: participantPaymentStatus,
      aO: price,
      qI: profile,
      AQ: rating,
      e_: userId
    };
  });
  var $author$project$Api$GraphqlSchema$Object$ParticipantPrivate$actions = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'actions', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };
  var $author$project$Api$GraphqlSchema$Enum$DifficultyRating$Hard = 2;
  var $author$project$Api$GraphqlSchema$Enum$DifficultyRating$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'EASY':
        return $elm$json$Json$Decode$succeed(0);
      case 'MEDIUM':
        return $elm$json$Json$Decode$succeed(1);
      case 'HARD':
        return $elm$json$Json$Decode$succeed(2);
      default:
        return $elm$json$Json$Decode$fail('Invalid DifficultyRating type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchRating$difficulty = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.DifficultyRating.DifficultyRating', 'difficulty', _List_Nil, $author$project$Api$GraphqlSchema$Enum$DifficultyRating$decoder);
  var $author$project$Api$Schema$matchRating = $author$project$Api$GraphqlSchema$Object$MatchRating$difficulty;
  var $author$project$Types$ParticipantHistory$ParticipantHistory = F2(function (actions, time) {
    return {
      th: actions,
      Cy: time
    };
  });
  var $author$project$Api$GraphqlSchema$Enum$ParticipantAction$Added = 0;
  var $author$project$Api$GraphqlSchema$Enum$ParticipantAction$Cancelled = 1;
  var $author$project$Api$GraphqlSchema$Enum$ParticipantAction$CancelledNonPayment = 3;
  var $author$project$Api$GraphqlSchema$Enum$ParticipantAction$CancelledNotFilled = 2;
  var $author$project$Api$GraphqlSchema$Enum$ParticipantAction$CancelledOtherUser = 4;
  var $author$project$Api$GraphqlSchema$Enum$ParticipantAction$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'ADDED':
        return $elm$json$Json$Decode$succeed(0);
      case 'CANCELLED':
        return $elm$json$Json$Decode$succeed(1);
      case 'CANCELLED_NOT_FILLED':
        return $elm$json$Json$Decode$succeed(2);
      case 'CANCELLED_NON_PAYMENT':
        return $elm$json$Json$Decode$succeed(3);
      case 'CANCELLED_OTHER_USER':
        return $elm$json$Json$Decode$succeed(4);
      default:
        return $elm$json$Json$Decode$fail('Invalid ParticipantAction type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$ParticipantHistory$action = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ParticipantAction.ParticipantAction', 'action', _List_Nil, $author$project$Api$GraphqlSchema$Enum$ParticipantAction$decoder);
  var $author$project$Api$GraphqlSchema$Object$ParticipantHistory$time = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Instant', 'time', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).up.fu);
  var $author$project$Api$Schema$participantHistory = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ParticipantHistory$time, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ParticipantHistory$action, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$ParticipantHistory$ParticipantHistory)));
  var $author$project$Types$Participant$ParticipantPaymentStatusCanceled = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Types$Participant$ParticipantPaymentStatusFailed = {
    $: 0
  };
  var $author$project$Types$Participant$ParticipantPaymentStatusNoPaymentRequired = {
    $: 5
  };
  var $author$project$Types$Participant$ParticipantPaymentStatusPaymentRequired = {
    $: 4
  };
  var $author$project$Types$Participant$ParticipantPaymentStatusPending = {
    $: 2
  };
  var $author$project$Types$Participant$ParticipantPaymentStatusProcessing = {
    $: 6
  };
  var $author$project$Types$Participant$ParticipantPaymentStatusRequiresAction = function (a) {
    return {
      $: 7,
      a: a
    };
  };
  var $author$project$Types$Participant$ParticipantPaymentStatusRequiresCapture = {
    $: 8
  };
  var $author$project$Types$Participant$ParticipantPaymentStatusRequiresPaymentMethod = {
    $: 9
  };
  var $author$project$Api$GraphqlSchema$Object$RequiresAction$action = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'action', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$Canceled$canceledAt = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Instant', 'canceledAt', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).up.fu);
  var $author$project$Api$GraphqlSchema$Interface$ParticipantPaymentStatus$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Canceled', selections____.jj), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Failed', selections____.jn), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NoPaymentRequired', selections____.jz), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PaymentRequired', selections____.jE), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Pending', selections____.jF), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Processing', selections____.jG), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RequiresAction', selections____.jH), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RequiresCapture', selections____.jI), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RequiresConfirmation', selections____.jJ), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RequiresPaymentMethod', selections____.jK), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Success', selections____.jR)]));
  };
  var $author$project$Api$GraphqlSchema$Object$Canceled$reason = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'reason', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$RequiresAction$type_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'type', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$Failed$underscore_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', '_', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$NoPaymentRequired$underscore_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', '_', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$PaymentRequired$underscore_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', '_', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Pending$underscore_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', '_', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Processing$underscore_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', '_', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$RequiresCapture$underscore_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', '_', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$RequiresConfirmation$underscore_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', '_', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$RequiresPaymentMethod$underscore_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', '_', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Success$underscore_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', '_', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$participantPaymentStatus = $author$project$Api$GraphqlSchema$Interface$ParticipantPaymentStatus$fragments({
    jj: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Canceled$canceledAt, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Canceled$reason, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F2(function (maybeReason, canceledAt) {
      return $author$project$Types$Participant$ParticipantPaymentStatusCanceled({
        t5: canceledAt,
        yg: maybeReason
      });
    })))),
    jn: A2($author$project$Api$Schema$mapField, $elm$core$Basics$always($author$project$Types$Participant$ParticipantPaymentStatusFailed), $author$project$Api$GraphqlSchema$Object$Failed$underscore_),
    jz: A2($author$project$Api$Schema$mapField, $elm$core$Basics$always($author$project$Types$Participant$ParticipantPaymentStatusNoPaymentRequired), $author$project$Api$GraphqlSchema$Object$NoPaymentRequired$underscore_),
    jE: A2($author$project$Api$Schema$mapField, $elm$core$Basics$always($author$project$Types$Participant$ParticipantPaymentStatusPaymentRequired), $author$project$Api$GraphqlSchema$Object$PaymentRequired$underscore_),
    jF: A2($author$project$Api$Schema$mapField, $elm$core$Basics$always($author$project$Types$Participant$ParticipantPaymentStatusPending), $author$project$Api$GraphqlSchema$Object$Pending$underscore_),
    jG: A2($author$project$Api$Schema$mapField, $elm$core$Basics$always($author$project$Types$Participant$ParticipantPaymentStatusProcessing), $author$project$Api$GraphqlSchema$Object$Processing$underscore_),
    jH: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$RequiresAction$type_, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$RequiresAction$action, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F2(function (maybeAction, maybeActionType) {
      return $author$project$Types$Participant$ParticipantPaymentStatusRequiresAction({
        yb: maybeAction,
        yc: maybeActionType
      });
    })))),
    jI: A2($author$project$Api$Schema$mapField, $elm$core$Basics$always($author$project$Types$Participant$ParticipantPaymentStatusRequiresCapture), $author$project$Api$GraphqlSchema$Object$RequiresCapture$underscore_),
    jJ: A2($author$project$Api$Schema$mapField, $elm$core$Basics$always($author$project$Types$Participant$ParticipantPaymentStatusPaymentRequired), $author$project$Api$GraphqlSchema$Object$RequiresConfirmation$underscore_),
    jK: A2($author$project$Api$Schema$mapField, $elm$core$Basics$always($author$project$Types$Participant$ParticipantPaymentStatusRequiresPaymentMethod), $author$project$Api$GraphqlSchema$Object$RequiresPaymentMethod$underscore_),
    jR: A2($author$project$Api$Schema$mapField, $elm$core$Basics$always($author$project$Types$Participant$ParticipantPaymentStatusSuccess), $author$project$Api$GraphqlSchema$Object$Success$underscore_)
  });
  var $author$project$Api$GraphqlSchema$Object$ParticipantPrivate$paymentStatus = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'paymentStatus', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$ParticipantPrivate$price = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'price', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$ParticipantPrivate$profile = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'profile', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$ParticipantPrivate$rating = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'rating', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };
  var $author$project$Api$GraphqlSchema$Object$ParticipantPrivate$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'userId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$participantPrivate = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ParticipantPrivate$price($author$project$Api$Schema$priceWithCurrency), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ParticipantPrivate$paymentStatus($author$project$Api$Schema$participantPaymentStatus), A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$ParticipantPrivate$userId, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ParticipantPrivate$rating($author$project$Api$Schema$matchRating), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ParticipantPrivate$profile($author$project$Api$Schema$userProfileLimited), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ParticipantPrivate$actions($author$project$Api$Schema$participantHistory), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Participant$ParticipantPrivate)))))));
  var $author$project$Api$Schema$participant = $author$project$Api$GraphqlSchema$Interface$Participant$fragments({
    jC: A2($author$project$Api$Schema$mapField, $author$project$Types$Participant$ParticipantTypePrivate, $author$project$Api$Schema$participantPrivate),
    jD: A2($author$project$Api$Schema$mapField, $author$project$Types$Participant$ParticipantTypePublic, $author$project$Api$Schema$participantPublic)
  });
  var $author$project$Api$GraphqlSchema$Object$MatchDetails$participants = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'participants', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, A2($elm$core$Basics$composeR, $elm$json$Json$Decode$nullable, $elm$json$Json$Decode$list)));
  };
  var $author$project$Api$GraphqlSchema$Object$MatchDetails$pendingParticipantsCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'pendingParticipantsCount', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Object$MatchDetails$suggestedParticipantsCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'suggestedParticipantsCount', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Object$MatchDetails$venue = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'venue', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };
  var $author$project$Types$Venue$Venue = F7(function (id, name, location, address, timeZone, photoUrl, placeId) {
    return {
      cy: address,
      od: id,
      iT: location,
      i5: name,
      qq: photoUrl,
      qu: placeId,
      dl: timeZone
    };
  });
  var $author$project$Api$GraphqlSchema$Object$Venue$address = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'address', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$Venue$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Venue$location = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Point', 'location', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).hs.fu);
  var $author$project$Api$GraphqlSchema$Object$Venue$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Venue$photo = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'photo', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };
  var $author$project$Api$GraphqlSchema$Object$Venue$placeId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'placeId', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$Venue$timeZone = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.TimeZone', 'timeZone', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).uu.fu);
  var $author$project$Api$Schema$venue = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Venue$placeId, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Venue$photo($author$project$Api$GraphqlSchema$Object$Photo$url), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Venue$timeZone, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Venue$address($author$project$Api$Schema$address), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Venue$location, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Venue$name, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$Venue$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Venue$Venue))))))));
  var $author$project$Api$Schema$matchDetails = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchDetails$suggestedParticipantsCount, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchDetails$joiningParticipants($author$project$Api$Schema$participant), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchDetails$pendingParticipantsCount, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchDetails$venue($author$project$Api$Schema$venue), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchDetails$participants($author$project$Api$Schema$participant), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchDetails$match($author$project$Api$Schema$match), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchDetails$createdAt, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchDetails$category, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Match$MatchDetails)))))))));
  var $author$project$Api$GraphqlSchema$Object$ListMatchesSuccess$matches = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'matches', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };
  var $author$project$Api$Schema$listMatchesSuccess = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ListMatchesSuccess$cursorIds($author$project$Api$Schema$cursorIds), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ListMatchesSuccess$matches($author$project$Api$Schema$matchDetails), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F2(function (matches, maybeCursorIds) {
    return A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$Paged, matches, $author$project$Api$Schema$selectAfterCursor(maybeCursorIds));
  }))));
  var $author$project$Api$GraphqlSchema$Enum$MatchAttribute$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'HISTORICAL';
      case 1:
        return 'PENDING_RATING';
      default:
        return 'UPCOMING';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeMatchAttributeModifierOneOfInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('all', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dx, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('except', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$MatchAttribute$toString)))), _Utils_Tuple2('specific', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eK, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$MatchAttribute$toString))))]));
  };
  var $author$project$Api$GraphqlSchema$Enum$MatchListOrder$toString = function (enum____) {
    if (!enum____) {
      return 'DATE';
    } else {
      return 'SEARCH_RELEVANCE';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeMatchListModifiersInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('attributesOneOf', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g3, $author$project$Api$GraphqlSchema$InputObject$encodeMatchAttributeModifierOneOfInput)), _Utils_Tuple2('dateOrder', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cF, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$DateOrder$toString))), _Utils_Tuple2('matchId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.br, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('order', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$MatchListOrder$toString))), _Utils_Tuple2('searchText', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.kJ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('userId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e_, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))]));
  };
  var $author$project$Api$GraphqlSchema$Object$MatchQuery$matches = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      cZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      f9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'pagination', filledInOptionals____.f9, $author$project$Api$GraphqlSchema$InputObject$encodePaginationInput), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'modifiers', filledInOptionals____.cZ, $author$project$Api$GraphqlSchema$InputObject$encodeMatchListModifiersInput)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'matches', optionalArgs____, object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Query$matches = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'matches', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$Api$getMatches = F5(function (specificMatches, apiEndpoint, limit, idToken, maybeNextPagePointer) {
    var payload = $author$project$Api$GraphqlSchema$Union$ListMatchesPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      jr: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$Schema$listMatchesSuccess),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message)
    });
    var optionalArguments = function (_v4) {
      var pagination = function () {
        if (!maybeNextPagePointer.$) {
          var nextPagePointer = maybeNextPagePointer.a;
          return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
            cE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
              hL: 1,
              od: nextPagePointer
            }),
            cW: limit
          });
        } else {
          return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
            cE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            cW: limit
          });
        }
      }();
      return {
        cZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
          g3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
            dx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            d$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            eK: function () {
              if (!specificMatches.$) {
                return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(_List_fromArray([2]));
              } else {
                return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(_List_fromArray([0]));
              }
            }()
          }),
          cF: function () {
            if (specificMatches.$ === 1) {
              var maybeSearchString = specificMatches.a;
              var dateOrder = specificMatches.b;
              return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(dateOrder);
            } else {
              return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(0);
            }
          }(),
          br: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          jY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          kJ: function () {
            if (specificMatches.$ === 1) {
              var maybeSearchString = specificMatches.a;
              var dateOrder = specificMatches.b;
              return $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(maybeSearchString);
            } else {
              return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
            }
          }(),
          e_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
        }),
        f9: pagination
      };
    };
    return $author$project$Api$Api$transformToFetchPageTask(A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$matches(A2($author$project$Api$GraphqlSchema$Object$MatchQuery$matches, optionalArguments, payload))));
  });
  var $author$project$Api$Api$getHistoryMatches = F2(function (maybeSearchString, dateOrder) {
    return $author$project$Api$Api$getMatches(A2($author$project$Api$Api$HistoryMatches, maybeSearchString, dateOrder));
  });
  var $author$project$Api$Api$NextMatches = {
    $: 0
  };
  var $author$project$Api$Api$getNextMatches = $author$project$Api$Api$getMatches($author$project$Api$Api$NextMatches);
  var $author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$Read = 0;
  var $author$project$Api$GraphqlSchema$Union$ListNotificationsPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ListNotificationsSuccess', selections____.pV), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k)]));
  };
  var $author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'READ';
      case 1:
        return 'UNREAD';
      default:
        return 'DELETED';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeNotificationReadStatusModifierOneOfInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('all', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dx, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)), _Utils_Tuple2('except', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$toString)))), _Utils_Tuple2('specific', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eK, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$toString))))]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeNotificationListModifiersInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('dateOrder', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cF, $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Api$GraphqlSchema$Enum$DateOrder$toString))), _Utils_Tuple2('notificationId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.pH, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('notificationReadStatusOneOf', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.pI, $author$project$Api$GraphqlSchema$InputObject$encodeNotificationReadStatusModifierOneOfInput))]));
  };
  var $author$project$Api$GraphqlSchema$Object$NotificationQuery$notifications = F2(function (fillInOptionals____, object____) {
    var filledInOptionals____ = fillInOptionals____({
      cZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      f9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    });
    var optionalArgs____ = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'pagination', filledInOptionals____.f9, $author$project$Api$GraphqlSchema$InputObject$encodePaginationInput), A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'modifiers', filledInOptionals____.cZ, $author$project$Api$GraphqlSchema$InputObject$encodeNotificationListModifiersInput)]));
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'notifications', optionalArgs____, object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Query$notifications = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'notifications', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$ListNotificationsSuccess$cursorIds = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'cursorIds', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };
  var $author$project$Api$GraphqlSchema$Interface$Notification$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'MatchCancelled', selections____.js), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'MatchJoined', selections____.jt), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'MatchRate', selections____.ju), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'MatchSuggestion', selections____.jv), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Matched', selections____.jw), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'MatchedResend', selections____.jx), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NoMatch', selections____.jy), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SearchInviteNotification', selections____.jO)]));
  };
  var $author$project$Api$GraphqlSchema$Enum$NotificationAction$MatchSuggestion = 4;
  var $author$project$Api$GraphqlSchema$Enum$NotificationAction$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'MATCH_NOT_FOUND':
        return $elm$json$Json$Decode$succeed(0);
      case 'MATCHED':
        return $elm$json$Json$Decode$succeed(1);
      case 'MATCH_JOINED':
        return $elm$json$Json$Decode$succeed(2);
      case 'MATCH_CANCELLATION':
        return $elm$json$Json$Decode$succeed(3);
      case 'MATCH_SUGGESTION':
        return $elm$json$Json$Decode$succeed(4);
      case 'MATCH_RATE':
        return $elm$json$Json$Decode$succeed(5);
      case 'SEARCH_INVITE':
        return $elm$json$Json$Decode$succeed(6);
      default:
        return $elm$json$Json$Decode$fail('Invalid NotificationAction type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchCancelled$action = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationAction.NotificationAction', 'action', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationAction$decoder);
  var $author$project$Api$GraphqlSchema$Object$MatchCancelled$createdAt = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Instant', 'createdAt', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).up.fu);
  var $author$project$Api$GraphqlSchema$Object$MatchCancelled$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchCancelled$longMessage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'longMessage', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$MatchCancelled$matchId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'matchId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchCancelled$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$notificationConstructorWithMatchId = function (notificationId) {
    return function (action) {
      return function (createdAt) {
        return function (title) {
          return function (message) {
            return function (longMessage) {
              return function (read) {
                return function (matchId_) {
                  return function (searchId) {
                    return function (userId) {
                      return {
                        tg: action,
                        uV: createdAt,
                        od: notificationId,
                        o4: longMessage,
                        br: $elm$core$Maybe$Just(matchId_),
                        f0: message,
                        qU: read,
                        by: searchId,
                        lh: title,
                        e_: userId
                      };
                    };
                  };
                };
              };
            };
          };
        };
      };
    };
  };
  var $author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$Deleted = 2;
  var $author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'READ':
        return $elm$json$Json$Decode$succeed(0);
      case 'UNREAD':
        return $elm$json$Json$Decode$succeed(1);
      case 'DELETED':
        return $elm$json$Json$Decode$succeed(2);
      default:
        return $elm$json$Json$Decode$fail('Invalid NotificationReadStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchCancelled$read = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationReadStatus.NotificationReadStatus', 'read', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$decoder);
  var $author$project$Api$GraphqlSchema$Object$MatchCancelled$searchId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'searchId', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$MatchCancelled$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchCancelled$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'userId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$matchCancelledNotification = A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchCancelled$userId, $elm$core$Basics$identity, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchCancelled$searchId, $elm$core$Maybe$map($elm$core$Basics$identity), A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchCancelled$matchId, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchCancelled$read, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchCancelled$longMessage, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchCancelled$message, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchCancelled$title, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchCancelled$createdAt, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchCancelled$action, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchCancelled$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Schema$notificationConstructorWithMatchId)))))))))));
  var $author$project$Api$GraphqlSchema$Object$MatchJoined$action = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationAction.NotificationAction', 'action', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationAction$decoder);
  var $author$project$Api$GraphqlSchema$Object$MatchJoined$createdAt = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Instant', 'createdAt', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).up.fu);
  var $author$project$Api$GraphqlSchema$Object$MatchJoined$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchJoined$longMessage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'longMessage', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$MatchJoined$matchId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'matchId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchJoined$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchJoined$read = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationReadStatus.NotificationReadStatus', 'read', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$decoder);
  var $author$project$Api$GraphqlSchema$Object$MatchJoined$searchId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'searchId', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$MatchJoined$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchJoined$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'userId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$matchJoined = A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchJoined$userId, $elm$core$Basics$identity, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchJoined$searchId, $elm$core$Maybe$map($elm$core$Basics$identity), A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchJoined$matchId, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchJoined$read, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchJoined$longMessage, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchJoined$message, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchJoined$title, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchJoined$createdAt, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchJoined$action, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchJoined$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Schema$notificationConstructorWithMatchId)))))))))));
  var $author$project$Api$GraphqlSchema$Object$MatchRate$action = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationAction.NotificationAction', 'action', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationAction$decoder);
  var $author$project$Api$GraphqlSchema$Object$MatchRate$createdAt = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Instant', 'createdAt', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).up.fu);
  var $author$project$Api$GraphqlSchema$Object$MatchRate$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchRate$longMessage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'longMessage', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$MatchRate$matchId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'matchId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchRate$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchRate$read = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationReadStatus.NotificationReadStatus', 'read', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$decoder);
  var $author$project$Api$GraphqlSchema$Object$MatchRate$searchId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'searchId', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$MatchRate$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchRate$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'userId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$matchRateNotification = A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchRate$userId, $elm$core$Basics$identity, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchRate$searchId, $elm$core$Maybe$map($elm$core$Basics$identity), A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchRate$matchId, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchRate$read, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchRate$longMessage, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchRate$message, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchRate$title, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchRate$createdAt, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchRate$action, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchRate$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Schema$notificationConstructorWithMatchId)))))))))));
  var $author$project$Api$GraphqlSchema$Object$MatchedResend$action = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationAction.NotificationAction', 'action', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationAction$decoder);
  var $author$project$Api$GraphqlSchema$Object$MatchedResend$createdAt = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Instant', 'createdAt', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).up.fu);
  var $author$project$Api$GraphqlSchema$Object$MatchedResend$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchedResend$longMessage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'longMessage', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$MatchedResend$matchId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'matchId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchedResend$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchedResend$read = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationReadStatus.NotificationReadStatus', 'read', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$decoder);
  var $author$project$Api$GraphqlSchema$Object$MatchedResend$searchId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'searchId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchedResend$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchedResend$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'userId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$matchResend = A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchedResend$userId, $elm$core$Basics$identity, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchedResend$searchId, A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Basics$identity), A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchedResend$matchId, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchedResend$read, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchedResend$longMessage, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchedResend$message, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchedResend$title, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchedResend$createdAt, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchedResend$action, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchedResend$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Schema$notificationConstructorWithMatchId)))))))))));
  var $author$project$Api$GraphqlSchema$Object$MatchSuggestion$action = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationAction.NotificationAction', 'action', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationAction$decoder);
  var $author$project$Api$GraphqlSchema$Object$MatchSuggestion$createdAt = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Instant', 'createdAt', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).up.fu);
  var $dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded = F2(function (constant, _v0) {
    var objectFields = _v0.a;
    var objectDecoder = _v0.b;
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet, objectFields, A3($elm$json$Json$Decode$map2, $elm$core$Basics$apR, $elm$json$Json$Decode$succeed(constant), objectDecoder));
  });
  var $author$project$Api$GraphqlSchema$Object$MatchSuggestion$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchSuggestion$longMessage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'longMessage', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$MatchSuggestion$matchId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'matchId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchSuggestion$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchSuggestion$read = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationReadStatus.NotificationReadStatus', 'read', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$decoder);
  var $author$project$Api$GraphqlSchema$Object$MatchSuggestion$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchSuggestion$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'userId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$matchSuggestion = A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchSuggestion$userId, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded, $elm$core$Maybe$Nothing, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchSuggestion$matchId, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchSuggestion$read, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchSuggestion$longMessage, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchSuggestion$message, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchSuggestion$title, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchSuggestion$createdAt, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$MatchSuggestion$action, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$MatchSuggestion$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Schema$notificationConstructorWithMatchId)))))))))));
  var $author$project$Api$GraphqlSchema$Object$Matched$action = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationAction.NotificationAction', 'action', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationAction$decoder);
  var $author$project$Api$GraphqlSchema$Object$Matched$createdAt = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Instant', 'createdAt', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).up.fu);
  var $author$project$Api$GraphqlSchema$Object$Matched$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Matched$longMessage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'longMessage', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$Matched$matchId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'matchId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Matched$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Matched$read = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationReadStatus.NotificationReadStatus', 'read', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$decoder);
  var $author$project$Api$GraphqlSchema$Object$Matched$searchId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'searchId', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$Matched$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Matched$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'userId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$matchedNotification = A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$Matched$userId, $elm$core$Basics$identity, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$Matched$searchId, $elm$core$Maybe$map($elm$core$Basics$identity), A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$Matched$matchId, $elm$core$Basics$identity, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Matched$read, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Matched$longMessage, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Matched$message, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Matched$title, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Matched$createdAt, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Matched$action, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$Matched$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Schema$notificationConstructorWithMatchId)))))))))));
  var $author$project$Api$GraphqlSchema$Object$NoMatch$action = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationAction.NotificationAction', 'action', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationAction$decoder);
  var $author$project$Api$GraphqlSchema$Object$NoMatch$createdAt = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Instant', 'createdAt', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).up.fu);
  var $author$project$Api$GraphqlSchema$Object$NoMatch$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$NoMatch$longMessage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'longMessage', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$NoMatch$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$notificationConstructorWithoutMatchId = F9(function (notificationId, action, createdAt, title, message, longMessage, read, searchId, userId) {
    return {
      tg: action,
      uV: createdAt,
      od: notificationId,
      o4: longMessage,
      br: $elm$core$Maybe$Nothing,
      f0: message,
      qU: read,
      by: searchId,
      lh: title,
      e_: userId
    };
  });
  var $author$project$Api$GraphqlSchema$Object$NoMatch$read = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationReadStatus.NotificationReadStatus', 'read', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$decoder);
  var $author$project$Api$GraphqlSchema$Object$NoMatch$searchId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'searchId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$NoMatch$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$NoMatch$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'userId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$noMatchNotification = A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$NoMatch$userId, $elm$core$Basics$identity, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$NoMatch$searchId, A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Basics$identity), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$NoMatch$read, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$NoMatch$longMessage, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$NoMatch$message, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$NoMatch$title, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$NoMatch$createdAt, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$NoMatch$action, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$NoMatch$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Schema$notificationConstructorWithoutMatchId))))))))));
  var $author$project$Api$GraphqlSchema$Object$ListNotificationsSuccess$notifications = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'notifications', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };
  var $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$action = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationAction.NotificationAction', 'action', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationAction$decoder);
  var $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$createdAt = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Instant', 'createdAt', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).up.fu);
  var $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$longMessage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'longMessage', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$read = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.NotificationReadStatus.NotificationReadStatus', 'read', _List_Nil, $author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$decoder);
  var $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$searchId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'searchId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'userId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$searchInviteNotification = A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$userId, $elm$core$Basics$identity, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$searchId, A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $elm$core$Basics$identity), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$read, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$longMessage, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$message, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$title, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$createdAt, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$action, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$SearchInviteNotification$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Schema$notificationConstructorWithoutMatchId))))))))));
  var $author$project$Api$Schema$pagedListNotificationsSuccess = function () {
    var notificationFragments = $author$project$Api$GraphqlSchema$Interface$Notification$fragments({
      js: $author$project$Api$Schema$matchCancelledNotification,
      jt: $author$project$Api$Schema$matchJoined,
      ju: $author$project$Api$Schema$matchRateNotification,
      jv: $author$project$Api$Schema$matchSuggestion,
      jw: $author$project$Api$Schema$matchedNotification,
      jx: $author$project$Api$Schema$matchResend,
      jy: $author$project$Api$Schema$noMatchNotification,
      jO: $author$project$Api$Schema$searchInviteNotification
    });
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ListNotificationsSuccess$cursorIds($author$project$Api$Schema$cursorIds), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ListNotificationsSuccess$notifications(notificationFragments), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F2(function (notifications, maybeCursorIds) {
      return A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$Paged, notifications, $author$project$Api$Schema$selectAfterCursor(maybeCursorIds));
    }))));
  }();
  var $author$project$Api$Api$getReadNotifications = F4(function (limit, apiEndpoint, idToken, maybeNextPagePointer) {
    var payload = $author$project$Api$GraphqlSchema$Union$ListNotificationsPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      pV: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$Schema$pagedListNotificationsSuccess),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message)
    });
    var optionalArguments = function (optionalArguments_) {
      var pagination = function () {
        if (!maybeNextPagePointer.$) {
          var nextPagePointer = maybeNextPagePointer.a;
          return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
            cE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
              hL: 1,
              od: nextPagePointer
            }),
            cW: limit
          });
        } else {
          return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
            cE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            cW: limit
          });
        }
      }();
      return {
        cZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
          cF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          pH: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          pI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
            dx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            d$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            eK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(_List_fromArray([0]))
          })
        }),
        f9: pagination
      };
    };
    return $author$project$Api$Api$transformToFetchPageTask(A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$notifications(A2($author$project$Api$GraphqlSchema$Object$NotificationQuery$notifications, optionalArguments, payload))));
  });
  var $author$project$ElmFramework$Lib$OrderedCollection$isEqual = F2(function (_v0, _v1) {
    var payload1 = _v0;
    var payload2 = _v1;
    return _Utils_eq(payload1.e, payload2.e);
  });
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$isEqual = F2(function (list1, list2) {
    return A2($author$project$ElmFramework$Lib$OrderedCollection$isEqual, list1.c, list2.c);
  });
  var $author$project$Remote$Model$mapSession = F2(function (mapper, remote) {
    var _v0 = remote.sX;
    switch (_v0.$) {
      case 0:
        return remote;
      case 1:
        return remote;
      case 2:
        return remote;
      default:
        var userSession = _v0.a;
        return _Utils_update(remote, {
          sX: $author$project$Types$UserSessionStatus$Onboarded(mapper(userSession))
        });
    }
  });
  var $author$project$TopMsg$msgGlobal = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$GlobalMsg);
  var $author$project$ElmFramework$Lib$OrderedCollection$OrderedCollection = $elm$core$Basics$identity;
  var $elm$core$Dict$member = F2(function (key, dict) {
    var _v0 = A2($elm$core$Dict$get, key, dict);
    if (!_v0.$) {
      return true;
    } else {
      return false;
    }
  });
  var $turboMaCk$any_dict$Dict$Any$member = F2(function (k, _v0) {
    var dict = _v0.B;
    var toKey = _v0.a8;
    return A2($elm$core$Dict$member, toKey(k), dict);
  });
  var $author$project$ElmFramework$Lib$OrderedCollection$remove = F2(function (id, _v0) {
    var list = _v0.e;
    var dict = _v0.B;
    var toId = _v0.G;
    var serializeId = _v0.U;
    var _v1 = A2($turboMaCk$any_dict$Dict$Any$member, id, dict) ? _Utils_Tuple2(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, toId, $elm$core$Basics$neq(id)), list), A2($turboMaCk$any_dict$Dict$Any$remove, id, dict)) : _Utils_Tuple2(list, dict);
    var newList = _v1.a;
    var newDict = _v1.b;
    return {
      B: newDict,
      e: newList,
      U: serializeId,
      G: toId
    };
  });
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$remove = F2(function (id, endlessList) {
    return {
      c: A2($author$project$ElmFramework$Lib$OrderedCollection$remove, id, endlessList.c),
      Cd: endlessList.Cd,
      x: endlessList.x
    };
  });
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$Idle = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$OrderedCollection$removeAll = function (_v0) {
    var list = _v0.e;
    var dict = _v0.B;
    var toId = _v0.G;
    var serializeId = _v0.U;
    return {
      B: $turboMaCk$any_dict$Dict$Any$removeAll(dict),
      e: _List_Nil,
      U: serializeId,
      G: toId
    };
  };
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$removeAll = function (endlessList) {
    return {
      c: $author$project$ElmFramework$Lib$OrderedCollection$removeAll(endlessList.c),
      Cd: $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$Idle($elm$core$Maybe$Nothing),
      x: endlessList.x
    };
  };
  var $author$project$ElmFramework$Lib$OrderedCollection$size = function (_v0) {
    var list = _v0.e;
    return $elm$core$List$length(list);
  };
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$size = function (endlessList) {
    return $author$project$ElmFramework$Lib$OrderedCollection$size(endlessList.c);
  };
  var $turboMaCk$any_dict$Dict$Any$update = F3(function (k, f, _v0) {
    var inner = _v0;
    var updateDict = A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Maybe$map(function (b) {
      return _Utils_Tuple2(k, b);
    }), f), $elm$core$Maybe$map($elm$core$Tuple$second));
    return _Utils_update(inner, {
      B: A3($elm$core$Dict$update, inner.a8(k), updateDict, inner.B)
    });
  });
  var $elm_community$list_extra$List$Extra$updateIf = F3(function (predicate, update, list) {
    return A2($elm$core$List$map, function (item) {
      return predicate(item) ? update(item) : item;
    }, list);
  });
  var $author$project$ElmFramework$Lib$OrderedCollection$update = F3(function (id, updater, _v0) {
    var payload = _v0;
    var dict = payload.B;
    var list = payload.e;
    var toId = payload.G;
    var newList = function () {
      var _v1 = updater(A2($turboMaCk$any_dict$Dict$Any$get, id, dict));
      if (!_v1.$) {
        var updated = _v1.a;
        return $elm_community$maybe_extra$Maybe$Extra$isJust(A2($elm_community$list_extra$List$Extra$find, A2($elm$core$Basics$composeR, toId, $elm$core$Basics$eq(id)), list)) ? A3($elm_community$list_extra$List$Extra$updateIf, A2($elm$core$Basics$composeR, toId, $elm$core$Basics$eq(id)), $elm$core$Basics$always(updated), list) : A2($elm$core$List$cons, updated, list);
      } else {
        return A2($elm$core$List$filter, A2($elm$core$Basics$composeR, toId, $elm$core$Basics$neq(id)), list);
      }
    }();
    return _Utils_update(payload, {
      B: A3($turboMaCk$any_dict$Dict$Any$update, id, updater, dict),
      e: newList
    });
  });
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$update = F3(function (id, mapper, endlessList) {
    return _Utils_update(endlessList, {
      c: A3($author$project$ElmFramework$Lib$OrderedCollection$update, id, mapper, endlessList.c)
    });
  });
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$FallbackToStatusIdle = {
    $: 4
  };
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Update$NewItems = $elm$core$Basics$identity;
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$ReceivedAllItems = {
    $: 1
  };
  var $turboMaCk$any_dict$Dict$Any$fromList = F2(function (f, xs) {
    return {
      B: $elm$core$Dict$fromList(A2($elm$core$List$map, function (_v0) {
        var k = _v0.a;
        var v = _v0.b;
        return _Utils_Tuple2(f(k), _Utils_Tuple2(k, v));
      }, xs)),
      a8: f
    };
  });
  var $author$project$ElmFramework$Lib$Util$uniqBy = F2(function (toId, list) {
    var consIfNotMember = F2(function (el, subList) {
      return $elm_community$maybe_extra$Maybe$Extra$isJust(A2($elm_community$list_extra$List$Extra$find, A2($elm$core$Basics$composeR, toId, $elm$core$Basics$eq(toId(el))), subList)) ? subList : A2($elm$core$List$cons, el, subList);
    });
    return A3($elm$core$List$foldr, consIfNotMember, _List_Nil, list);
  });
  var $author$project$ElmFramework$Lib$OrderedCollection$fromList = F3(function (toId, serializeId, list) {
    var uniqList = A2($author$project$ElmFramework$Lib$Util$uniqBy, toId, list);
    var dict = A2($turboMaCk$any_dict$Dict$Any$fromList, serializeId, A2($elm$core$List$map, function (i) {
      return _Utils_Tuple2(toId(i), i);
    }, uniqList));
    return {
      B: dict,
      e: uniqList,
      U: serializeId,
      G: toId
    };
  });
  var $author$project$ElmFramework$Lib$OrderedCollection$append = F2(function (newList, _v0) {
    var toId = _v0.G;
    var serializeId = _v0.U;
    var list = _v0.e;
    return A3($author$project$ElmFramework$Lib$OrderedCollection$fromList, toId, serializeId, _Utils_ap(list, newList));
  });
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$fallbackStatusToIdle = function (state) {
    return _Utils_update(state, {
      Cd: function () {
        var _v0 = state.Cd;
        switch (_v0.$) {
          case 2:
            var maybeNextPageToken = _v0.a;
            return $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$Idle(maybeNextPageToken);
          case 1:
            return state.Cd;
          default:
            return state.Cd;
        }
      }()
    });
  };
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$ReceivePage = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$ReceivingItems = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $elm$core$Task$attempt = F2(function (resultToMessage, task) {
    return $elm$core$Task$command(A2($elm$core$Task$onError, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage), $elm$core$Result$Err), A2($elm$core$Task$andThen, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage), $elm$core$Result$Ok), task)));
  });
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Update$fetchPage = F2(function (fetcher, state) {
    var maybeNextPagePointer = function () {
      var _v0 = state.Cd;
      switch (_v0.$) {
        case 0:
          var maybePointer = _v0.a;
          return maybePointer;
        case 2:
          var maybePointer = _v0.a;
          return maybePointer;
        default:
          return $elm$core$Maybe$Nothing;
      }
    }();
    return _Utils_Tuple2(_Utils_update(state, {
      Cd: $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$ReceivingItems(maybeNextPagePointer)
    }), A2($elm$core$Task$attempt, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$ReceivePage, fetcher(maybeNextPagePointer)));
  });
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$ReceiveRefreshedContent = function (a) {
    return {
      $: 5,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Update$refreshContent = F2(function (fetcher, state) {
    return _Utils_Tuple2(state, A2($elm$core$Task$attempt, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$ReceiveRefreshedContent, fetcher($elm$core$Maybe$Nothing)));
  });
  var $author$project$ElmFramework$Lib$OrderedCollection$replace = F2(function (newList, _v0) {
    var toId = _v0.G;
    var serializeId = _v0.U;
    return A3($author$project$ElmFramework$Lib$OrderedCollection$fromList, toId, serializeId, newList);
  });
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Update$update = F3(function (config, msg, state) {
    switch (msg.$) {
      case 0:
        var _v1 = state.Cd;
        switch (_v1.$) {
          case 0:
            var maybeNextPagePointer = _v1.a;
            return function (_v2) {
              var newState = _v2.a;
              var cmd = _v2.b;
              return _Utils_Tuple3(newState, cmd, $elm$core$Maybe$Nothing);
            }(A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$Update$fetchPage, config, state));
          case 1:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
          default:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }
      case 1:
        return function (_v3) {
          var newState = _v3.a;
          var cmd = _v3.b;
          return _Utils_Tuple3(newState, cmd, $elm$core$Maybe$Nothing);
        }(A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$Update$refreshContent, config, state));
      case 2:
        var _v4 = _Utils_Tuple2(state.Cd, $author$project$ElmFramework$Lib$OrderedCollection$isEmpty(state.c));
        if (!_v4.a.$ && _v4.b) {
          return function (_v5) {
            var newState = _v5.a;
            var cmd = _v5.b;
            return _Utils_Tuple3(newState, cmd, $elm$core$Maybe$Nothing);
          }(A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$Update$fetchPage, config, state));
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }
      case 3:
        if (!msg.a.$) {
          var pagedResponse = msg.a.a;
          return _Utils_Tuple3(_Utils_update(state, {
            c: A2($author$project$ElmFramework$Lib$OrderedCollection$append, pagedResponse.xn, state.c),
            Cd: function () {
              var _v6 = pagedResponse.yD;
              if (!_v6.$) {
                var token = _v6.a;
                return $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$Idle($elm$core$Maybe$Just(token));
              } else {
                return $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$ReceivedAllItems;
              }
            }(),
            x: false
          }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(pagedResponse.xn));
        } else {
          var cmd = msg.a.a;
          var shorErrorIfIsForFirstTime = !state.x ? cmd : $elm$core$Platform$Cmd$none;
          return _Utils_Tuple3(_Utils_update(state, {
            x: true
          }), $elm$core$Platform$Cmd$batch(_List_fromArray([shorErrorIfIsForFirstTime, A2($elm$core$Task$perform, $elm$core$Basics$always($author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$FallbackToStatusIdle), $elm$core$Process$sleep($author$project$ElmFramework$Lib$Util$timeInterval.rt))])), $elm$core$Maybe$Nothing);
        }
      case 4:
        return _Utils_Tuple3($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$fallbackStatusToIdle(state), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
      default:
        if (!msg.a.$) {
          var pagedResponse = msg.a.a;
          return _Utils_Tuple3(_Utils_update(state, {
            c: A2($author$project$ElmFramework$Lib$OrderedCollection$replace, pagedResponse.xn, state.c),
            Cd: function () {
              var _v7 = pagedResponse.yD;
              if (!_v7.$) {
                var token = _v7.a;
                return $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$Idle($elm$core$Maybe$Just(token));
              } else {
                return $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$ReceivedAllItems;
              }
            }()
          }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(pagedResponse.xn));
        } else {
          var cmd = msg.a.a;
          return _Utils_Tuple3($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$fallbackStatusToIdle(state), cmd, $elm$core$Maybe$Nothing);
        }
    }
  });
  var $author$project$Remote$Remote$update = F4(function (msg, global, state, route) {
    var config = global.ar;
    var limit = F2(function (endlessList, theMsg) {
      switch (theMsg.$) {
        case 0:
          return 5;
        case 1:
          return $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$size(endlessList) > 0 ? $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$size(endlessList) : 5;
        case 2:
          return 5;
        case 3:
          var fetchPageResult = theMsg.a;
          return 5;
        case 5:
          var fetchPageResult = theMsg.a;
          return 5;
        default:
          return 5;
      }
    });
    var firebaseApiKey = config.wf.Y;
    var apiEndpoint = config.ts;
    switch (msg.$) {
      case 0:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 1:
        var newRoute = msg.b;
        if (newRoute.$ === 1 && !newRoute.a.$) {
          var action = newRoute.a.a.tg;
          var code = newRoute.a.a.uo;
          var requestMsgs = function () {
            switch (action) {
              case 'verifyEmail':
                return _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$VerifyEmailOobCode(code))]);
              case 'resetPassword':
                return _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$VerifyResetPasswordCode(code))]);
              default:
                return _List_Nil;
            }
          }();
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, requestMsgs);
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 2:
        var isInit = msg.a;
        var theMsg = msg.b;
        return A2($elm$core$Maybe$withDefault, _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil), A2($elm$core$Maybe$map, function (session) {
          var searchesFetcher = A3($author$project$Api$Api$getActiveAndAwaitingUsersSearches, apiEndpoint, A2(limit, session.BK, theMsg), session.bN.oe);
          var _v3 = A3($author$project$ElmFramework$Lib$UiBehavior$EndlessList$Update$update, searchesFetcher, theMsg, session.BK);
          var searches = _v3.a;
          var cmd = _v3.b;
          var outMsg = _v3.c;
          var topMsgForIsSearchesUpdated = function () {
            if (theMsg.$ === 5) {
              return !A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$isEqual, searches, session.BK) && !_Utils_eq(route, $author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Searches($author$project$Ui$MyPlayerStatus$Searches$Route$SearchesList))) ? _List_fromArray([$author$project$TopMsg$msgMyPlayerStatus($author$project$Ui$MyPlayerStatus$Msg$SetIsSearchesUpdated(true))]) : _List_Nil;
            } else {
              return _List_Nil;
            }
          }();
          var nextSession = _Utils_update(session, {
            BK: searches
          });
          var topMsgForInit = function () {
            var _v4 = _Utils_Tuple2(isInit, outMsg);
            if (_v4.a && !_v4.b.$) {
              return _List_fromArray([$author$project$TopMsg$msgGlobal(A2($author$project$Global$Msg$OnAuthSuccess, 1, nextSession))]);
            } else {
              return _List_Nil;
            }
          }();
          return _Utils_Tuple3(_Utils_update(state, {
            sX: $author$project$Types$UserSessionStatus$Onboarded(nextSession)
          }), A2($elm$core$Platform$Cmd$map, $author$project$Remote$Msg$SearchesEndlessListMsg(isInit), cmd), _Utils_ap(topMsgForInit, topMsgForIsSearchesUpdated));
        }, $author$project$Types$UserSessionStatus$toSession(state.sX)));
      case 3:
        var isInit = msg.a;
        var theMsg = msg.b;
        return A2($elm$core$Maybe$withDefault, _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil), A2($elm$core$Maybe$map, function (session) {
          var nextMatchesFetcher = A3($author$project$Api$Api$getNextMatches, apiEndpoint, A2(limit, session.yC, theMsg), session.bN.oe);
          var _v6 = A3($author$project$ElmFramework$Lib$UiBehavior$EndlessList$Update$update, nextMatchesFetcher, theMsg, session.yC);
          var nextMatches = _v6.a;
          var cmd = _v6.b;
          var outMsg = _v6.c;
          var topMsgForIsNextMatchesUpdated = function () {
            if (theMsg.$ === 5) {
              return !A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$isEqual, nextMatches, session.yC) && !_Utils_eq(route, $author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Upcoming)) ? _List_fromArray([$author$project$TopMsg$msgMyPlayerStatus($author$project$Ui$MyPlayerStatus$Msg$SetIsNextMatchesUpdated(true))]) : _List_Nil;
            } else {
              return _List_Nil;
            }
          }();
          var topMsgForInit = function () {
            var _v7 = _Utils_Tuple2(isInit, outMsg);
            if (_v7.a && !_v7.b.$) {
              return _List_fromArray([$author$project$TopMsg$remoteMsg(A4($author$project$Remote$Msg$HistoryMatchesEndlessListMsg, true, $elm$core$Maybe$Nothing, 0, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$FetchPage))]);
            } else {
              return _List_Nil;
            }
          }();
          return _Utils_Tuple3(_Utils_update(state, {
            sX: $author$project$Types$UserSessionStatus$Onboarded(_Utils_update(session, {
              yC: nextMatches
            }))
          }), A2($elm$core$Platform$Cmd$map, $author$project$Remote$Msg$NextMatchesEndlessListMsg(isInit), cmd), _Utils_ap(topMsgForInit, topMsgForIsNextMatchesUpdated));
        }, $author$project$Types$UserSessionStatus$toSession(state.sX)));
      case 4:
        var isInit = msg.a;
        var maybeSearch = msg.b;
        var dateOrder = msg.c;
        var theMsg = msg.d;
        return A2($elm$core$Maybe$withDefault, _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil), A2($elm$core$Maybe$map, function (session) {
          var historyMatchesFetcher = A5($author$project$Api$Api$getHistoryMatches, maybeSearch, dateOrder, apiEndpoint, A2(limit, session.wA, theMsg), session.bN.oe);
          var _v9 = A3($author$project$ElmFramework$Lib$UiBehavior$EndlessList$Update$update, historyMatchesFetcher, theMsg, session.wA);
          var historyMatches = _v9.a;
          var cmd = _v9.b;
          var outMsg = _v9.c;
          var topMsgForIsHistoryMatchesUpdated = function () {
            if (theMsg.$ === 5) {
              return !A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$isEqual, historyMatches, session.wA) && !_Utils_eq(route, $author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$History)) ? _List_fromArray([$author$project$TopMsg$msgMyPlayerStatus($author$project$Ui$MyPlayerStatus$Msg$SetIsHistoryMatchesUpdated(true))]) : _List_Nil;
            } else {
              return _List_Nil;
            }
          }();
          var topMsgForInit = function () {
            var _v10 = _Utils_Tuple2(isInit, outMsg);
            if (_v10.a && !_v10.b.$) {
              return _List_fromArray([$author$project$TopMsg$remoteMsg(A2($author$project$Remote$Msg$SearchesEndlessListMsg, true, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$FetchPage))]);
            } else {
              return _List_Nil;
            }
          }();
          return _Utils_Tuple3(_Utils_update(state, {
            sX: $author$project$Types$UserSessionStatus$Onboarded(_Utils_update(session, {
              wA: historyMatches
            }))
          }), A2($elm$core$Platform$Cmd$map, A3($author$project$Remote$Msg$HistoryMatchesEndlessListMsg, isInit, maybeSearch, dateOrder), cmd), _Utils_ap(topMsgForInit, topMsgForIsHistoryMatchesUpdated));
        }, $author$project$Types$UserSessionStatus$toSession(state.sX)));
      case 5:
        var theMsg = msg.a;
        return A2($elm$core$Maybe$withDefault, _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil), A2($elm$core$Maybe$map, function (session) {
          var readNotificationsFetcher = A3($author$project$Api$Api$getReadNotifications, 5, apiEndpoint, session.bN.oe);
          var _v12 = A3($author$project$ElmFramework$Lib$UiBehavior$EndlessList$Update$update, readNotificationsFetcher, theMsg, session.AR);
          var readNotifications = _v12.a;
          var cmd = _v12.b;
          return _Utils_Tuple3(_Utils_update(state, {
            sX: $author$project$Types$UserSessionStatus$Onboarded(_Utils_update(session, {
              AR: readNotifications
            }))
          }), A2($elm$core$Platform$Cmd$map, $author$project$Remote$Msg$ReadNotificationsEndlessListMsg, cmd), _List_Nil);
        }, $author$project$Types$UserSessionStatus$toSession(state.sX)));
      case 6:
        return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
          return _Utils_update(session, {
            wA: $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$removeAll(session.wA)
          });
        }, state), $elm$core$Platform$Cmd$none, _List_Nil);
      case 7:
        var matchId = msg.a;
        return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
          return _Utils_update(session, {
            yC: A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$remove, matchId, session.yC)
          });
        }, state), $elm$core$Platform$Cmd$none, _List_Nil);
      case 8:
        var matchId = msg.a;
        return A2($elm$core$Maybe$withDefault, _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil), A2($elm$core$Maybe$map, function (session) {
          return _Utils_Tuple3(_Utils_update(state, {
            sX: $author$project$Types$UserSessionStatus$Onboarded(_Utils_update(session, {
              wA: $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$removeAll(session.wA),
              yC: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$removeAll(session.yC), function (_v13) {
                return A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$remove, matchId, session.yC);
              }, A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$get, matchId, session.yC))
            }))
          }), $elm$core$Platform$Cmd$none, _List_Nil);
        }, $author$project$Types$UserSessionStatus$toSession(state.sX)));
      case 9:
        var searchId = msg.a;
        return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
          return _Utils_update(session, {
            BK: A3($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$update, searchId, function (maybeSearchDetails) {
              if (!maybeSearchDetails.$) {
                var searchDetails = maybeSearchDetails.a;
                var search = searchDetails.kH;
                return $elm$core$Maybe$Just(_Utils_update(searchDetails, {
                  kH: _Utils_update(search, {
                    aC: 0
                  })
                }));
              } else {
                return $elm$core$Maybe$Nothing;
              }
            }, session.BK)
          });
        }, state), $elm$core$Platform$Cmd$none, _List_Nil);
      case 10:
        var searchId = msg.a;
        return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
          return _Utils_update(session, {
            BK: A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$remove, searchId, session.BK)
          });
        }, state), $elm$core$Platform$Cmd$none, _List_Nil);
      default:
        var matchId = msg.a;
        var updateParticipants = function (participants) {
          return A3($elm_community$list_extra$List$Extra$updateIf, function (participant) {
            if (!participant.$ && participant.a.$ === 1) {
              return true;
            } else {
              return false;
            }
          }, function (maybePrivateParticipant) {
            if (!maybePrivateParticipant.$ && maybePrivateParticipant.a.$ === 1) {
              var privateParticipant = maybePrivateParticipant.a.a;
              return $elm$core$Maybe$Just($author$project$Types$Participant$ParticipantTypePrivate(_Utils_update(privateParticipant, {
                z7: $author$project$Types$Participant$ParticipantPaymentStatusSuccess
              })));
            } else {
              return maybePrivateParticipant;
            }
          }, participants);
        };
        var updateMatches = function (matches) {
          return A3($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$update, matchId, function (maybeMatchDetails) {
            if (!maybeMatchDetails.$) {
              var matchDetails = maybeMatchDetails.a;
              return $elm$core$Maybe$Just(_Utils_update(matchDetails, {
                z8: updateParticipants(matchDetails.z8)
              }));
            } else {
              return maybeMatchDetails;
            }
          }, matches);
        };
        return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
          return _Utils_update(session, {
            wA: updateMatches(session.wA),
            yC: updateMatches(session.yC)
          });
        }, state), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$ElmFramework$Lib$Util$toggleMaybe = F2(function (a, maybe) {
    if (!maybe.$) {
      var b = maybe.a;
      return A3($author$project$ElmFramework$Lib$Util$ifElse, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(a), _Utils_eq(a, b));
    } else {
      return $elm$core$Maybe$Just(a);
    }
  });
  var $author$project$Types$EditingUserProfile$update = F2(function (msg, state) {
    update: while (true) {
      switch (msg.$) {
        case 0:
          var firstName = msg.a;
          return _Utils_update(state, {
            nF: firstName
          });
        case 1:
          var lastName = msg.a;
          return _Utils_update(state, {
            oU: lastName
          });
        case 2:
          var email = msg.a;
          return _Utils_update(state, {
            bZ: email
          });
        case 3:
          var phoneNumber = msg.a;
          return _Utils_update(state, {
            qo: phoneNumber
          });
        case 4:
          var gender = msg.a;
          return _Utils_update(state, {
            nM: A2($author$project$ElmFramework$Lib$Util$toggleMaybe, gender, state.nM)
          });
        case 5:
          var newState = msg.a;
          return newState;
        case 6:
          var radius = msg.a;
          return _Utils_update(state, {
            gj: radius
          });
        case 7:
          var location = msg.a;
          return _Utils_update(state, {
            iT: location
          });
        case 8:
          var editingUserProfile = msg.a;
          return editingUserProfile;
        default:
          var subMsg = msg.a;
          var $temp$msg = subMsg,
            $temp$state = state;
          msg = $temp$msg;
          state = $temp$state;
          continue update;
      }
    }
  });
  var $author$project$Remote$RequestMsg$SearchContacts = function (a) {
    return {
      $: 46,
      a: a
    };
  };
  var $author$project$ElmFramework$Feature$Hybrid$Hybrid$goToAppSettings = _Platform_outgoingPort('goToAppSettings', function ($) {
    return $elm$json$Json$Encode$null;
  });
  var $author$project$ElmFramework$Feature$Contacts$Contacts$requestContacts = _Platform_outgoingPort('requestContacts', function ($) {
    return $elm$json$Json$Encode$null;
  });
  var $author$project$ElmFramework$Feature$Contacts$Contacts$requestContactsPermissions = _Platform_outgoingPort('requestContactsPermissions', function ($) {
    return $elm$json$Json$Encode$null;
  });
  var $author$project$ElmFramework$Feature$Contacts$Contacts$requestContactsPermissionsStatus = _Platform_outgoingPort('requestContactsPermissionsStatus', function ($) {
    return $elm$json$Json$Encode$null;
  });
  var $turboMaCk$any_dict$Dict$Any$insert = F3(function (k, v, _v0) {
    var inner = _v0;
    return _Utils_update(inner, {
      B: A3($elm$core$Dict$insert, inner.a8(k), _Utils_Tuple2(k, v), inner.B)
    });
  });
  var $turboMaCk$any_set$Set$Any$insert = F2(function (a, _v0) {
    var dict = _v0;
    return A3($turboMaCk$any_dict$Dict$Any$insert, a, 0, dict);
  });
  var $turboMaCk$any_set$Set$Any$member = F2(function (a, _v0) {
    var dict = _v0;
    return A2($turboMaCk$any_dict$Dict$Any$member, a, dict);
  });
  var $turboMaCk$any_set$Set$Any$remove = F2(function (a, _v0) {
    var dict = _v0;
    return A2($turboMaCk$any_dict$Dict$Any$remove, a, dict);
  });
  var $turboMaCk$any_set$Set$Any$toggle = F2(function (a, set) {
    return A2($turboMaCk$any_set$Set$Any$member, a, set) ? A2($turboMaCk$any_set$Set$Any$remove, a, set) : A2($turboMaCk$any_set$Set$Any$insert, a, set);
  });
  var $author$project$TopMsg$userSessionMsg = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$UserSessionMsg);
  var $author$project$Ui$AddPlayers$AddPlayers$update = F3(function (msg, state, session) {
    switch (msg.$) {
      case 0:
        var route = msg.a;
        if (_Utils_eq(session.DC, $krisajenkins$remotedata$RemoteData$NotAsked) && function () {
          if (route.$ === 18 && route.a.$ === 3 && !route.a.a.$) {
            return true;
          } else {
            return false;
          }
        }() && session.uI === 1) {
          return _Utils_Tuple3(state, $author$project$ElmFramework$Feature$Contacts$Contacts$requestContacts(0), _List_Nil);
        } else {
          if (route.$ === 18 && route.a.$ === 3) {
            return _Utils_Tuple3(state, $author$project$ElmFramework$Feature$Contacts$Contacts$requestContactsPermissionsStatus(0), _List_Nil);
          } else {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }
        }
      case 1:
        var scrollCoordinates = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          kG: scrollCoordinates
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 2:
        return _Utils_Tuple3($author$project$Ui$AddPlayers$AddPlayers$init, $elm$core$Platform$Cmd$none, _List_Nil);
      case 3:
        var str = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          gr: str
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 4:
        return _Utils_Tuple3(_Utils_update(state, {
          gr: ''
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 5:
        var userId = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          gx: A2($turboMaCk$any_set$Set$Any$toggle, userId, state.gx)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 6:
        return _Utils_Tuple3($author$project$Ui$AddPlayers$AddPlayers$init, $elm$core$Platform$Cmd$none, _List_Nil);
      case 7:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$batch(_List_fromArray([$author$project$ElmFramework$Feature$Contacts$Contacts$requestContacts(0), $author$project$ElmFramework$Feature$Contacts$Contacts$requestContactsPermissions(0)])), _List_Nil);
      case 8:
        var addressBookContacts = msg.a;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$SearchContacts(addressBookContacts)), $author$project$TopMsg$userSessionMsg($author$project$Ui$Auth$UserSession$Msg$ReceiveContactsPermissionsStatus($elm$core$Result$Ok(1)))]));
      case 9:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      default:
        return _Utils_Tuple3(state, $author$project$ElmFramework$Feature$Hybrid$Hybrid$goToAppSettings(0), _List_Nil);
    }
  });
  var $author$project$Remote$ResponseMsg$EmailAndPasswordRegisterOrSignIn = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$OauthCredentialRegisterOrSignIn = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Remote$RequestMsg$RegisterNewUser = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$RequestMsg$SignInWithOauthCredential = F2(function (a, b) {
    return {
      $: 4,
      a: a,
      b: b
    };
  });
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$appleLogin = _Platform_outgoingPort('appleLogin', function ($) {
    return $elm$json$Json$Encode$null;
  });
  var $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$googleLogin = _Platform_outgoingPort('googleLogin', function ($) {
    return $elm$json$Json$Encode$null;
  });
  var $author$project$Ui$Auth$Auth$update = F7(function (env, pushNotificationsPermissions, currRoute, global, msg, state, authSdkLoaded) {
    var config = global.ar;
    var notifyIfNotLoadedYet = function (updateStateAndMsgs) {
      return authSdkLoaded ? updateStateAndMsgs : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Nothing, 'We are loading some code', _List_fromArray(['Please try again in few seconds']))]));
    };
    switch (msg.$) {
      case 0:
        var email = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          rS: email
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 1:
        var password = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          rT: password
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 3:
        var email = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          ko: email
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 4:
        var password = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          kr: password
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 7:
        return _Utils_Tuple3(_Utils_update(state, {
          gm: !state.gm
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 6:
        var email = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          nH: email
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 8:
        var pass = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          nI: pass
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 10:
        var pass = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          nJ: pass
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 12:
        var registrationAction = function () {
          if (!currRoute.$ && currRoute.a.$ === 1) {
            var _v5 = currRoute.a;
            var registrationAction_ = _v5.b;
            return registrationAction_;
          } else {
            return $author$project$Route$Route$DefaultRegistration;
          }
        }();
        var hasAcceptedTermsAndService = state.gm || function () {
          if (!currRoute.$ && currRoute.a.$ === 1 && !currRoute.a.a.$) {
            var _v2 = currRoute.a;
            var _v3 = _v2.a.a;
            return true;
          } else {
            return false;
          }
        }();
        var registerOrRouteToAcceptTerms = hasAcceptedTermsAndService ? _List_fromArray([$author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$RegisterNewUser, registrationAction, $author$project$Remote$ResponseMsg$EmailAndPasswordRegisterOrSignIn({
          bZ: state.ko,
          gb: state.kr
        })))]) : _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$Auth(A2($author$project$Route$Route$Register, $elm$core$Maybe$Just(0), registrationAction)))]);
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, registerOrRouteToAcceptTerms);
      case 2:
        return _Utils_Tuple3(_Utils_update(state, {
          kA: !state.kA
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 5:
        return _Utils_Tuple3(_Utils_update(state, {
          kz: !state.kz
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 9:
        return _Utils_Tuple3(_Utils_update(state, {
          h8: !state.h8
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 11:
        return _Utils_Tuple3(_Utils_update(state, {
          h9: !state.h9
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 13:
        var pass = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          hi: pass
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 15:
        var pass = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          hh: pass
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 17:
        var pass = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          hj: pass
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 14:
        return _Utils_Tuple3(_Utils_update(state, {
          fg: !state.fg
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 16:
        return _Utils_Tuple3(_Utils_update(state, {
          ff: !state.ff
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 18:
        return _Utils_Tuple3(_Utils_update(state, {
          fh: !state.fh
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 19:
        return _Utils_Tuple3(_Utils_update(state, {
          hh: '',
          hi: '',
          hj: '',
          ff: false,
          fg: false,
          fh: false
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 20:
        return _Utils_Tuple3($author$project$Ui$Auth$Auth$initEmpty, $elm$core$Platform$Cmd$none, _List_Nil);
      case 21:
        var signInAction = msg.a;
        return notifyIfNotLoadedYet(_Utils_Tuple3(_Utils_update(state, {
          cm: $elm$core$Maybe$Just(signInAction)
        }), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$googleLogin(0), _List_Nil));
      case 22:
        var registrationAction = msg.a;
        return notifyIfNotLoadedYet(_Utils_Tuple3(_Utils_update(state, {
          cg: $elm$core$Maybe$Just(registrationAction)
        }), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$googleLogin(0), _List_Nil));
      case 23:
        var signInAction = msg.a;
        return notifyIfNotLoadedYet(_Utils_Tuple3(_Utils_update(state, {
          cm: $elm$core$Maybe$Just(signInAction)
        }), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$appleLogin(0), _List_Nil));
      case 24:
        var registrationAction = msg.a;
        return notifyIfNotLoadedYet(_Utils_Tuple3(_Utils_update(state, {
          cg: $elm$core$Maybe$Just(registrationAction)
        }), $author$project$ElmFramework$Feature$SocialAuth$SocialAuth$appleLogin(0), _List_Nil));
      default:
        var event = msg.a;
        switch (event.$) {
          case 0:
            var idToken = event.a.oe;
            return _Utils_Tuple3(_Utils_update(state, {
              cg: $elm$core$Maybe$Nothing,
              cm: $elm$core$Maybe$Nothing
            }), $elm$core$Platform$Cmd$none, function () {
              var _v7 = _Utils_Tuple2(state.cm, state.cg);
              if (!_v7.a.$) {
                var sIAction = _v7.a.a;
                return _List_fromArray([$author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$SignInWithOauthCredential, sIAction, {
                  oe: idToken,
                  kf: 'google.com',
                  kv: config.tv
                }))]);
              } else {
                if (!_v7.b.$) {
                  var _v8 = _v7.a;
                  var rAction = _v7.b.a;
                  return _List_fromArray([$author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$RegisterNewUser, rAction, $author$project$Remote$ResponseMsg$OauthCredentialRegisterOrSignIn({
                    oe: idToken,
                    kf: 'google.com',
                    kv: config.tv
                  })))]);
                } else {
                  return _List_Nil;
                }
              }
            }());
          case 1:
            var idToken = event.a.oe;
            return _Utils_Tuple3(_Utils_update(state, {
              cg: $elm$core$Maybe$Nothing,
              cm: $elm$core$Maybe$Nothing
            }), $elm$core$Platform$Cmd$none, function () {
              var _v9 = _Utils_Tuple2(state.cm, state.cg);
              if (!_v9.a.$) {
                var sIAction = _v9.a.a;
                return _List_fromArray([$author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$SignInWithOauthCredential, sIAction, {
                  oe: idToken,
                  kf: 'apple.com',
                  kv: config.tv
                }))]);
              } else {
                if (!_v9.b.$) {
                  var _v10 = _v9.a;
                  var rAction = _v9.b.a;
                  return _List_fromArray([$author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$RegisterNewUser, rAction, $author$project$Remote$ResponseMsg$OauthCredentialRegisterOrSignIn({
                    oe: idToken,
                    kf: 'apple.com',
                    kv: config.tv
                  })))]);
                } else {
                  return _List_Nil;
                }
              }
            }());
          case 2:
            var facebookAuthSuccessPayload = event.a;
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          case 3:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          default:
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    }
  });
  var $author$project$Remote$RequestMsg$GetUnreadNotifications = {
    $: 31
  };
  var $author$project$Remote$RequestMsg$UpdatePushDevices = F2(function (a, b) {
    return {
      $: 35,
      a: a,
      b: b
    };
  });
  var $author$project$TopMsg$addPlayersMsg = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$AddPlayersMsg);
  var $author$project$Ui$Auth$UserSession$UserSession$addTappedNotification = F2(function (notif, state) {
    return _Utils_update(state, {
      C4: A2($elm$core$List$cons, notif, state.C4)
    });
  });
  var $author$project$Types$UserSettings$increaseUnreadNotifs = function (sett) {
    return _Utils_update(sett, {
      C3: sett.C3 + 1
    });
  };
  var $author$project$Ui$Auth$UserSession$UserSession$addUnreadNotification = F2(function (notif, state) {
    return _Utils_update(state, {
      kO: $author$project$Types$UserSettings$increaseUnreadNotifs(state.kO),
      C4: A2($elm$core$List$cons, notif, state.C4)
    });
  });
  var $author$project$Types$UserSettings$hasPushDevice = F2(function (token, _v0) {
    var pushDevices = _v0.qO;
    return $elm_community$maybe_extra$Maybe$Extra$isJust(A2($turboMaCk$any_dict$Dict$Any$get, token, pushDevices));
  });
  var $author$project$Remote$RequestMsg$UpdateTappedNotificationStatusAndRoute = F2(function (a, b) {
    return {
      $: 33,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Auth$UserSession$UserSession$onNotificationTap = function (notification) {
    var routeToMatch = function () {
      var _v1 = notification.br;
      if (!_v1.$) {
        var matchIdValue = _v1.a;
        return $elm$core$Maybe$Just(A2($author$project$Route$Route$Match, matchIdValue, $author$project$Ui$Match$Route$Details));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }();
    var routeToInvitationView = A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Route$Route$Invitation, $author$project$Ui$Invitation$Route$Search), notification.by);
    var _v0 = notification.tg;
    switch (_v0) {
      case 0:
        return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$UpdateTappedNotificationStatusAndRoute, notification.od, $elm$core$Maybe$Nothing));
      case 1:
        return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$UpdateTappedNotificationStatusAndRoute, notification.od, routeToMatch));
      case 3:
        return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$UpdateTappedNotificationStatusAndRoute, notification.od, $elm$core$Maybe$Nothing));
      case 5:
        return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$UpdateTappedNotificationStatusAndRoute, notification.od, routeToMatch));
      case 2:
        return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$UpdateTappedNotificationStatusAndRoute, notification.od, routeToMatch));
      case 4:
        return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$UpdateTappedNotificationStatusAndRoute, notification.od, routeToMatch));
      default:
        return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$UpdateTappedNotificationStatusAndRoute, notification.od, routeToInvitationView));
    }
  };
  var $author$project$Remote$Msg$ClearHistoryMatchesEndlessList = {
    $: 6
  };
  var $author$project$Remote$RequestMsg$GetMatch = function (a) {
    return {
      $: 27,
      a: a
    };
  };
  var $author$project$Remote$Msg$OnMatchRateNotification = function (a) {
    return {
      $: 8,
      a: a
    };
  };
  var $author$project$Remote$Msg$RemoveNextMatch = function (a) {
    return {
      $: 7,
      a: a
    };
  };
  var $author$project$Remote$Msg$RemoveSearch = function (a) {
    return {
      $: 10,
      a: a
    };
  };
  var $author$project$Ui$Auth$UserSession$UserSession$unwrapMaybeSearchId = F2(function (localMsg, maybeSearchId) {
    return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$List$singleton, $author$project$TopMsg$remoteMsg), localMsg), maybeSearchId);
  });
  var $author$project$Ui$Auth$UserSession$UserSession$stateUpdateOnNotificationReceived = function (notification) {
    var getMatchOrLatestMatches = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$TopMsg$remoteMsg(A2($author$project$Remote$Msg$NextMatchesEndlessListMsg, false, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$RefetchContent)), A2($elm$core$Basics$composeL, $author$project$TopMsg$requestMsg, $author$project$Remote$RequestMsg$GetMatch), notification.br);
    var _v0 = notification.tg;
    switch (_v0) {
      case 0:
        return A2($author$project$Ui$Auth$UserSession$UserSession$unwrapMaybeSearchId, $author$project$Remote$Msg$RemoveSearch, notification.by);
      case 1:
        return _Utils_ap(_List_fromArray([getMatchOrLatestMatches]), A2($author$project$Ui$Auth$UserSession$UserSession$unwrapMaybeSearchId, $author$project$Remote$Msg$RemoveSearch, notification.by));
      case 3:
        return _List_fromArray([A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$TopMsg$remoteMsg(A2($author$project$Remote$Msg$NextMatchesEndlessListMsg, false, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$RefetchContent)), A2($elm$core$Basics$composeL, $author$project$TopMsg$remoteMsg, $author$project$Remote$Msg$RemoveNextMatch), notification.br)]);
      case 5:
        return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_fromArray([$author$project$TopMsg$remoteMsg($author$project$Remote$Msg$ClearHistoryMatchesEndlessList), $author$project$TopMsg$remoteMsg(A2($author$project$Remote$Msg$NextMatchesEndlessListMsg, false, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$RefetchContent))]), A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$List$singleton, $author$project$TopMsg$remoteMsg), $author$project$Remote$Msg$OnMatchRateNotification), notification.br);
      case 2:
        return _Utils_ap(_List_fromArray([getMatchOrLatestMatches]), A2($author$project$Ui$Auth$UserSession$UserSession$unwrapMaybeSearchId, $author$project$Remote$Msg$RemoveSearch, notification.by));
      case 4:
        return _List_fromArray([getMatchOrLatestMatches]);
      default:
        return _Utils_ap(_List_fromArray([getMatchOrLatestMatches]), A2($author$project$Ui$Auth$UserSession$UserSession$unwrapMaybeSearchId, $author$project$Remote$Msg$RemoveSearch, notification.by));
    }
  };
  var $author$project$Ui$Auth$UserSession$UserSession$update = F4(function (topState, msg, state, route) {
    var time = topState.Cy;
    var pushNotificationsPermissions = topState.AO;
    var userProfile = state.Db;
    var settings = state.kO;
    switch (msg.$) {
      case 0:
        var newRoute = msg.b;
        if (newRoute.$ === 11) {
          return _Utils_Tuple3(_Utils_update(state, {
            AR: $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$removeAll(state.AR)
          }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetUnreadNotifications)]));
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 1:
        return _Utils_eq(route, $author$project$Route$Route$Notifications) ? _Utils_Tuple3(_Utils_update(state, {
          AR: $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$removeAll(state.AR)
        }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetUnreadNotifications), $author$project$TopMsg$userSessionMsg($author$project$Ui$Auth$UserSession$Msg$ReceivePushPermissionsStatus(pushNotificationsPermissions))])) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 2:
        var receivingCircumstances = msg.a;
        var decodedNotification = msg.b;
        var notification = _Utils_update(decodedNotification, {
          uV: time
        });
        switch (receivingCircumstances) {
          case 0:
            return _Utils_Tuple3(A2($author$project$Ui$Auth$UserSession$UserSession$addUnreadNotification, notification, state), $elm$core$Platform$Cmd$none, _Utils_ap(_List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Just($author$project$Ui$Auth$UserSession$UserSession$onNotificationTap(notification)), notification.f0, _List_Nil)]), $author$project$Ui$Auth$UserSession$UserSession$stateUpdateOnNotificationReceived(notification)));
          case 1:
            return _Utils_Tuple3(A2($author$project$Ui$Auth$UserSession$UserSession$addUnreadNotification, notification, state), $elm$core$Platform$Cmd$none, _Utils_ap(_List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Just($author$project$Ui$Auth$UserSession$UserSession$onNotificationTap(notification)), notification.f0, _List_Nil)]), $author$project$Ui$Auth$UserSession$UserSession$stateUpdateOnNotificationReceived(notification)));
          default:
            return _Utils_Tuple3(A2($author$project$Ui$Auth$UserSession$UserSession$addTappedNotification, notification, state), $elm$core$Platform$Cmd$none, _Utils_ap(_List_fromArray([$author$project$Ui$Auth$UserSession$UserSession$onNotificationTap(notification)]), $author$project$Ui$Auth$UserSession$UserSession$stateUpdateOnNotificationReceived(notification)));
        }
      case 3:
        var notification = msg.a;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$Ui$Auth$UserSession$UserSession$onNotificationTap(notification)]));
      case 4:
        var pushPermissions = msg.a;
        var _v3 = state;
        var userId = _v3.e_;
        if (pushPermissions.$ === 3) {
          var token = pushPermissions.a;
          return A2($author$project$Types$UserSettings$hasPushDevice, token, settings) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$UpdatePushDevices, userId, {
            i5: $elm$core$Maybe$Nothing,
            qY: $elm$core$Maybe$Just(time),
            li: token
          }))]));
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }
      default:
        var contactsPermissionsResult = msg.a;
        if (!contactsPermissionsResult.$) {
          var contactsPermissions = contactsPermissionsResult.a;
          var requestContacts = contactsPermissions === 1 ? _List_fromArray([$author$project$TopMsg$addPlayersMsg($author$project$Ui$AddPlayers$Msg$OnRoute(route))]) : _List_Nil;
          return _Utils_Tuple3(_Utils_update(state, {
            uI: contactsPermissions
          }), $elm$core$Platform$Cmd$none, requestContacts);
        } else {
          var error = contactsPermissionsResult.a;
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil)]));
        }
    }
  });
  var $author$project$Ui$ComponentsPreview$ComponentsPreview$update = F4(function (global, maybeSession, msg, state) {
    switch (msg.$) {
      case 0:
        var route = msg.a;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bt(route)]));
      case 1:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 2:
        var val = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          I: val
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 3:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 4:
        return _Utils_Tuple3(_Utils_update(state, {
          gu: !state.gu
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 5:
        return _Utils_Tuple3(_Utils_update(state, {
          gt: !state.gt
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 6:
        return _Utils_Tuple3(_Utils_update(state, {
          cl: !state.cl
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 8:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 9:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 10:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]));
      case 11:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 12:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 13:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 14:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 15:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 16:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 17:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 18:
        var gender = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          nM: gender
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 19:
        var age = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          lC: age
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 20:
        var input = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          r7: $elm$core$Maybe$Just(input)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 21:
        if (!maybeSession.$) {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Nothing, 'OnVideo error', _List_fromArray(['not authenticated']))]));
        }
      case 22:
        return _Utils_Tuple3(_Utils_update(state, {
          ai: !state.ai
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 7:
        return _Utils_Tuple3(_Utils_update(state, {
          gv: !state.gv
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 23:
        return _Utils_Tuple3(_Utils_update(state, {
          cB: !state.cB
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 24:
        return _Utils_Tuple3(_Utils_update(state, {
          c7: !state.c7
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 26:
        var itemId = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          e6: itemId
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 27:
        var itemId = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          kx: itemId
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 25:
        var id = msg.a;
        var _v2 = state.a3;
        if (!_v2.$) {
          var playerID = _v2.a;
          return _Utils_eq(playerID, id) ? _Utils_Tuple3(_Utils_update(state, {
            a3: $elm$core$Maybe$Nothing
          }), $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(_Utils_update(state, {
            a3: $elm$core$Maybe$Just(id)
          }), $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
          return _Utils_Tuple3(_Utils_update(state, {
            a3: $elm$core$Maybe$Just(id)
          }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 28:
        var val = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          kb: val
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 29:
        var _float = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          k4: _float
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 30:
        var _float = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          fy: _float
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 31:
        var resizedImage = msg.a;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 32:
        var rangeSliderValue = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          gk: rangeSliderValue
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 33:
        var timeRangeSliderValue = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          gK: timeRangeSliderValue
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      default:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Types$EditingUserProfile$SetState = function (a) {
    return {
      $: 5,
      a: a
    };
  };
  var $elm_community$maybe_extra$Maybe$Extra$filter = F2(function (f, m) {
    var _v0 = A2($elm$core$Maybe$map, f, m);
    if (!_v0.$ && _v0.a) {
      return m;
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$Types$EditingUserProfile$fromUserProfile = function (userProfile) {
    return {
      bZ: userProfile.bZ,
      nF: userProfile.nF,
      nM: $elm$core$Maybe$Just(userProfile.nM),
      oU: userProfile.oU,
      iT: userProfile.iT,
      qo: userProfile.qo,
      qq: userProfile.qq,
      gj: 30
    };
  };
  var $author$project$TopMsg$msgEditingUserProfile = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$EditingUserProfileMsg);
  var $author$project$Ui$EditPersonalDetails$Update$onRouteOrAuth = F2(function (maybeSession, route) {
    return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $elm$core$List$singleton, A2($elm$core$Maybe$map, $author$project$TopMsg$msgEditingUserProfile, A2($elm$core$Maybe$map, $author$project$Types$EditingUserProfile$SetState, A2($elm$core$Maybe$map, $author$project$Types$EditingUserProfile$fromUserProfile, A2($elm$core$Maybe$map, function ($) {
      return $.Db;
    }, A2($elm_community$maybe_extra$Maybe$Extra$filter, $elm$core$Basics$always(_Utils_eq(route, $author$project$Route$Route$EditPersonalDetails)), maybeSession))))));
  });
  var $author$project$Ui$EditPersonalDetails$Update$update = F3(function (msg, maybeSession, route) {
    return A2($author$project$Ui$EditPersonalDetails$Update$onRouteOrAuth, maybeSession, route);
  });
  var $author$project$Api$GraphqlSchema$Enum$SkillRating$Beginner = 1;
  var $author$project$ElmFramework$Lib$Util$toggleAnyDictItem = F3(function (id, item, dict) {
    return A2($turboMaCk$any_dict$Dict$Any$member, id, dict) ? A2($turboMaCk$any_dict$Dict$Any$remove, id, dict) : A3($turboMaCk$any_dict$Dict$Any$insert, id, item, dict);
  });
  var $author$project$Ui$EditUserActivities$EditUserActivities$update = F2(function (msg, state) {
    switch (msg.$) {
      case 0:
        var activity = msg.a;
        return _Utils_update(state, {
          lz: A3($author$project$ElmFramework$Lib$Util$toggleAnyDictItem, activity, 1, state.lz)
        });
      case 1:
        var sport = msg.a;
        return _Utils_update(state, {
          fl: A2($turboMaCk$any_set$Set$Any$toggle, sport, state.fl)
        });
      case 3:
        var newState = msg.a;
        return _Utils_update(state, {
          lz: newState
        });
      case 2:
        var activity = msg.a;
        var skillRating = msg.b;
        return _Utils_update(state, {
          lz: A3($turboMaCk$any_dict$Dict$Any$update, activity, $elm$core$Basics$always($elm$core$Maybe$Just(skillRating)), state.lz)
        });
      default:
        var sport = msg.a;
        return _Utils_update(state, {
          k5: sport
        });
    }
  });
  var $author$project$Remote$RequestMsg$SubmitFeedback = F2(function (a, b) {
    return {
      $: 28,
      a: a,
      b: b
    };
  });
  var $author$project$Global$Msg$NoOp = {
    $: 13
  };
  var $author$project$TopMsg$noOpMsg = $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg($author$project$Global$Msg$NoOp));
  var $author$project$Ui$Feedback$Update$update = F2(function (msg, state) {
    switch (msg.$) {
      case 0:
        var satisfaction = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          BB: $elm$core$Maybe$Just(satisfaction)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 1:
        var comment = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          mw: comment
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 2:
        var request = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$TopMsg$noOpMsg, function (satisfaction) {
          return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$SubmitFeedback, state.mw, satisfaction));
        }, state.BB);
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([request]));
      default:
        return _Utils_Tuple3(_Utils_update(state, {
          mw: '',
          BB: $elm$core$Maybe$Nothing
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $krisajenkins$remotedata$RemoteData$Success = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Remote$RequestMsg$GetSearchInvite = function (a) {
    return {
      $: 25,
      a: a
    };
  };
  var $krisajenkins$remotedata$RemoteData$Loading = {
    $: 1
  };
  var $author$project$Ui$Invitation$Update$onAuthOrOnRoute = F2(function (model, route) {
    if (route.$ === 23) {
      var subRoute = route.a;
      return _Utils_Tuple3(function () {
        var _v1 = model.qZ;
        switch (_v1.$) {
          case 3:
            return _Utils_update(model, {
              qZ: $krisajenkins$remotedata$RemoteData$Loading
            });
          case 0:
            return _Utils_update(model, {
              qZ: $krisajenkins$remotedata$RemoteData$Loading
            });
          default:
            return model;
        }
      }(), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetSearchInvite(subRoute))]));
    } else {
      return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Ui$Invitation$Update$update = F3(function (msg, model, route) {
    switch (msg.$) {
      case 0:
        return A2($author$project$Ui$Invitation$Update$onAuthOrOnRoute, model, route);
      case 1:
        var searchDetails = msg.a;
        return _Utils_Tuple3(_Utils_update(model, {
          qZ: $krisajenkins$remotedata$RemoteData$Success(searchDetails)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      default:
        return _Utils_Tuple3(_Utils_update(model, {
          qZ: $krisajenkins$remotedata$RemoteData$Failure(0)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Ui$Legal$Legal$update = F4(function (global, maybeIdToken, msg, state) {
    switch (msg.$) {
      case 0:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]));
      case 1:
        var route = msg.a;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bt(route)]));
      default:
        var route = msg.a;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bu(route)]));
    }
  });
  var $author$project$Remote$RequestMsg$GetCancelMatchReasons = {
    $: 17
  };
  var $author$project$Ui$Match$Msg$WaitingForUpdatedMatchPaymentStatus = F2(function (a, b) {
    return {
      $: 10,
      a: a,
      b: b
    };
  });
  var $author$project$Types$UserSession$getHistoryMatch = F2(function (matchId, session) {
    return A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$get, matchId, session.wA);
  });
  var $author$project$Types$UserSession$getNextMatch = F2(function (matchId, session) {
    return A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$get, matchId, session.yC);
  });
  var $elm_community$maybe_extra$Maybe$Extra$or = F2(function (ma, mb) {
    if (ma.$ === 1) {
      return mb;
    } else {
      return ma;
    }
  });
  var $author$project$Types$UserSession$findMatch = F2(function (session, matchId) {
    var maybeNextMatchDetails = A2($author$project$Types$UserSession$getNextMatch, matchId, session);
    var maybeHistoryMatchDetails = A2($author$project$Types$UserSession$getHistoryMatch, matchId, session);
    return A2($elm_community$maybe_extra$Maybe$Extra$or, maybeNextMatchDetails, maybeHistoryMatchDetails);
  });
  var $krisajenkins$remotedata$RemoteData$isNotAsked = function (data) {
    if (!data.$) {
      return true;
    } else {
      return false;
    }
  };
  var $author$project$Types$Participant$paymentStatusToString = F2(function (participantPaymentStatus, isForCardStatus) {
    switch (participantPaymentStatus.$) {
      case 0:
        return isForCardStatus ? 'Payment failed' : 'Failed';
      case 1:
        var maybeReason = participantPaymentStatus.a.yg;
        var canceledAt = participantPaymentStatus.a.t5;
        return isForCardStatus ? 'Payment cancelled' : 'Canceled' + A2($elm$core$Maybe$withDefault, '.', A2($elm$core$Maybe$map, function (reason) {
          return ' because: ' + reason;
        }, maybeReason));
      case 2:
        return isForCardStatus ? 'Payment pending' : 'Pending';
      case 3:
        return 'Paid';
      case 4:
        return isForCardStatus ? 'Unpaid' : 'Payment is required';
      case 5:
        return 'No payment due';
      case 6:
        return isForCardStatus ? 'Payment pending' : 'Processing';
      case 7:
        var maybeAction = participantPaymentStatus.a.yb;
        var maybeActionType = participantPaymentStatus.a.yc;
        return isForCardStatus ? 'Payment action required' : 'Additional action is required. ' + (A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function (actionType) {
          return 'Action type: ' + actionType;
        }, maybeActionType)) + A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function (action) {
          return 'Action: ' + action;
        }, maybeAction)));
      case 8:
        return 'Authorized';
      case 9:
        return isForCardStatus ? 'Payment incomplete' : 'Requires payment method';
      default:
        return isForCardStatus ? 'Payment incomplete' : 'Requires confirmation';
    }
  });
  var $krisajenkins$remotedata$RemoteData$succeed = $krisajenkins$remotedata$RemoteData$Success;
  var $author$project$Types$Match$toParticipantPaymentStatus = function (_v0) {
    var participants = _v0.z8;
    var _v1 = $author$project$Types$Match$participantsToPrivateParticipant(participants);
    if (!_v1.$) {
      var participantPaymentStatus = _v1.a.z7;
      return $elm$core$Maybe$Just(participantPaymentStatus);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };
  var $author$project$Ui$Match$Update$update = F4(function (session, topState, msg, state) {
    var onMatchDetailsRoute = function (matchId) {
      return _Utils_Tuple3(_Utils_update(state, {
        AQ: 1
      }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetMatch(matchId))]));
    };
    switch (msg.$) {
      case 0:
        var route = msg.b;
        _v1$2: while (true) {
          if (route.$ === 21) {
            switch (route.b.$) {
              case 2:
                var matchId = route.a;
                var _v2 = route.b;
                return $krisajenkins$remotedata$RemoteData$isNotAsked(state.ma) ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetCancelMatchReasons)])) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
              case 0:
                var matchId = route.a;
                var _v3 = route.b;
                return onMatchDetailsRoute(matchId);
              default:
                break _v1$2;
            }
          } else {
            break _v1$2;
          }
        }
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 1:
        var route = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.rh);
        if (route.$ === 21 && !route.b.$) {
          var matchId = route.a;
          var _v5 = route.b;
          return onMatchDetailsRoute(matchId);
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 2:
        var cancelReason = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          l9: cancelReason
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 3:
        var rating = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          AQ: rating
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 4:
        var cancelMatchReasonsList = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          ma: $krisajenkins$remotedata$RemoteData$succeed(cancelMatchReasonsList)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 5:
        var paymentMethodSelected = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          qi: $elm$core$Maybe$Just(paymentMethodSelected)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 6:
        return _Utils_Tuple3(_Utils_update(state, {
          oB: true
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 7:
        return _Utils_Tuple3(_Utils_update(state, {
          oA: true
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 8:
        var matchId = msg.a;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetMatch(matchId))]));
      case 9:
        return _Utils_Tuple3(_Utils_update(state, {
          oy: !state.oy
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      default:
        var oldPaymentStatus = msg.a;
        var retryNumber = msg.b;
        var _v6 = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.rh);
        if (_v6.$ === 21) {
          var matchId = _v6.a;
          return A2($elm$core$Maybe$withDefault, _Utils_Tuple3(_Utils_update(state, {
            rf: 0
          }), $elm$core$Platform$Cmd$none, _List_Nil), A2($elm$core$Maybe$andThen, function (currentParticipantPaymentStatus) {
            return (_Utils_eq(currentParticipantPaymentStatus, oldPaymentStatus) || _Utils_eq(currentParticipantPaymentStatus, $author$project$Types$Participant$ParticipantPaymentStatusProcessing)) && retryNumber > 0 ? $elm$core$Maybe$Just(_Utils_Tuple3(_Utils_update(state, {
              rf: retryNumber
            }), A2($elm$core$Task$perform, $elm$core$Basics$always(A2($author$project$Ui$Match$Msg$WaitingForUpdatedMatchPaymentStatus, oldPaymentStatus, retryNumber - 1)), $elm$core$Process$sleep($author$project$ElmFramework$Lib$Util$timeInterval.rt)), _List_Nil)) : !_Utils_eq(currentParticipantPaymentStatus, oldPaymentStatus) && !_Utils_eq(currentParticipantPaymentStatus, $author$project$Types$Participant$ParticipantPaymentStatusProcessing) && !_Utils_eq(currentParticipantPaymentStatus, $author$project$Types$Participant$ParticipantPaymentStatusSuccess) ? $elm$core$Maybe$Just(_Utils_Tuple3(_Utils_update(state, {
              rf: 0
            }), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Payment is still in process', _List_fromArray(['Current status of your payment is: ' + A2($author$project$Types$Participant$paymentStatusToString, currentParticipantPaymentStatus, false)]))]))) : $elm$core$Maybe$Nothing;
          }, A2($elm$core$Maybe$andThen, function (matchDetails) {
            return $author$project$Types$Match$toParticipantPaymentStatus(matchDetails);
          }, A2($author$project$Types$UserSession$findMatch, session, matchId))));
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    }
  });
  var $TSFoster$elm_tuple_extra$Tuple3$mapFirst = F2(function (fn, _v0) {
    var a = _v0.a;
    var b = _v0.b;
    var c = _v0.c;
    return _Utils_Tuple3(fn(a), b, c);
  });
  var $TSFoster$elm_tuple_extra$Tuple3$mapSecond = F2(function (fn, _v0) {
    var a = _v0.a;
    var b = _v0.b;
    var c = _v0.c;
    return _Utils_Tuple3(a, fn(b), c);
  });
  var $author$project$Ui$Matchmaking$Checkout$Update$onRouteOrAuth = F3(function (state, maybeSession, route) {
    return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
  });
  var $author$project$Ui$Matchmaking$Checkout$Update$update = F4(function (msg, state, maybeSession, route) {
    switch (msg.$) {
      case 0:
        return A3($author$project$Ui$Matchmaking$Checkout$Update$onRouteOrAuth, state, maybeSession, route);
      case 1:
        return A3($author$project$Ui$Matchmaking$Checkout$Update$onRouteOrAuth, state, maybeSession, route);
      case 2:
        var conditionsAccepted = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          mz: conditionsAccepted
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 3:
        var paymentMethodSelected = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          qi: $elm$core$Maybe$Just(paymentMethodSelected)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      default:
        return _Utils_Tuple3(_Utils_update(state, {
          oz: true
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Ui$Matchmaking$Single$Msg$CreateOrEditSearch = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Remote$RequestMsg$ReverseGeocoding = F2(function (a, b) {
    return {
      $: 45,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$CreateOrEditSearch$Msg$LocationSet = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $elm$core$Tuple$mapFirst = F2(function (func, _v0) {
    var x = _v0.a;
    var y = _v0.b;
    return _Utils_Tuple2(func(x), y);
  });
  var $author$project$TopMsg$msgSingleCreateOrEditSearch = A2($elm$core$Basics$composeL, $author$project$TopMsg$msgMatchmakingSingle, $author$project$Ui$Matchmaking$Single$Msg$CreateOrEditSearch);
  var $author$project$Ui$Matchmaking$Single$Update$onAuthSuccess = F3(function (state, session, route) {
    if (route.$ === 18 && !route.a.$) {
      var _v1 = route.a;
      var maybeDefaultLocation = A2($elm$core$Maybe$map, $elm$core$Tuple$mapFirst(function ($) {
        return $.es;
      }), session.Db.iT);
      return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgSingleCreateOrEditSearch($author$project$Ui$CreateOrEditSearch$Msg$LocationSet(maybeDefaultLocation))]));
    } else {
      return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Ui$Matchmaking$Single$Update$onRoute = F3(function (state, maybeSession, route) {
    var _v0 = _Utils_Tuple2(maybeSession, route);
    if (!_v0.a.$ && _v0.b.$ === 18 && !_v0.b.a.$) {
      var session = _v0.a.a;
      var _v1 = _v0.b.a;
      var _v2 = state.mE.iT;
      if (!_v2.$) {
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      } else {
        var maybeDefaultLocation = A2($elm$core$Maybe$map, $elm$core$Tuple$mapFirst(function ($) {
          return $.es;
        }), session.Db.iT);
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgSingleCreateOrEditSearch($author$project$Ui$CreateOrEditSearch$Msg$LocationSet(maybeDefaultLocation))]));
      }
    } else {
      return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Types$Search$EmptySlot = {
    $: 3
  };
  var $author$project$Types$Search$ExternalInvite = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Types$Search$InternalInvite = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$AddPlayers$Msg$OnTapXrivalsContact = function (a) {
    return {
      $: 5,
      a: a
    };
  };
  var $author$project$Ui$AddPlayers$Msg$ResetXrivalsContacsSelection = {
    $: 6
  };
  var $justinmimbs$time_extra$Time$Extra$Day = 11;
  var $justinmimbs$date$Date$Days = 3;
  var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
  var $justinmimbs$time_extra$Time$Extra$Month = 2;
  var $justinmimbs$date$Date$Months = 1;
  var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
  var $justinmimbs$date$Date$isLeapYear = function (y) {
    return !A2($elm$core$Basics$modBy, 4, y) && !!A2($elm$core$Basics$modBy, 100, y) || !A2($elm$core$Basics$modBy, 400, y);
  };
  var $justinmimbs$date$Date$daysBeforeMonth = F2(function (y, m) {
    var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
    switch (m) {
      case 0:
        return 0;
      case 1:
        return 31;
      case 2:
        return 59 + leapDays;
      case 3:
        return 90 + leapDays;
      case 4:
        return 120 + leapDays;
      case 5:
        return 151 + leapDays;
      case 6:
        return 181 + leapDays;
      case 7:
        return 212 + leapDays;
      case 8:
        return 243 + leapDays;
      case 9:
        return 273 + leapDays;
      case 10:
        return 304 + leapDays;
      default:
        return 334 + leapDays;
    }
  });
  var $justinmimbs$date$Date$floorDiv = F2(function (a, b) {
    return $elm$core$Basics$floor(a / b);
  });
  var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
    var y = y1 - 1;
    var leapYears = A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100) + A2($justinmimbs$date$Date$floorDiv, y, 400);
    return 365 * y + leapYears;
  };
  var $justinmimbs$date$Date$daysInMonth = F2(function (y, m) {
    switch (m) {
      case 0:
        return 31;
      case 1:
        return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
      case 2:
        return 31;
      case 3:
        return 30;
      case 4:
        return 31;
      case 5:
        return 30;
      case 6:
        return 31;
      case 7:
        return 31;
      case 8:
        return 30;
      case 9:
        return 31;
      case 10:
        return 30;
      default:
        return 31;
    }
  });
  var $elm$core$Basics$min = F2(function (x, y) {
    return _Utils_cmp(x, y) < 0 ? x : y;
  });
  var $justinmimbs$date$Date$monthToNumber = function (m) {
    switch (m) {
      case 0:
        return 1;
      case 1:
        return 2;
      case 2:
        return 3;
      case 3:
        return 4;
      case 4:
        return 5;
      case 5:
        return 6;
      case 6:
        return 7;
      case 7:
        return 8;
      case 8:
        return 9;
      case 9:
        return 10;
      case 10:
        return 11;
      default:
        return 12;
    }
  };
  var $justinmimbs$date$Date$numberToMonth = function (mn) {
    var _v0 = A2($elm$core$Basics$max, 1, mn);
    switch (_v0) {
      case 1:
        return 0;
      case 2:
        return 1;
      case 3:
        return 2;
      case 4:
        return 3;
      case 5:
        return 4;
      case 6:
        return 5;
      case 7:
        return 6;
      case 8:
        return 7;
      case 9:
        return 8;
      case 10:
        return 9;
      case 11:
        return 10;
      default:
        return 11;
    }
  };
  var $justinmimbs$date$Date$toCalendarDateHelp = F3(function (y, m, d) {
    toCalendarDateHelp: while (true) {
      var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
      var mn = $justinmimbs$date$Date$monthToNumber(m);
      if (mn < 12 && _Utils_cmp(d, monthDays) > 0) {
        var $temp$y = y,
          $temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
          $temp$d = d - monthDays;
        y = $temp$y;
        m = $temp$m;
        d = $temp$d;
        continue toCalendarDateHelp;
      } else {
        return {
          mO: d,
          pt: m,
          ta: y
        };
      }
    }
  });
  var $justinmimbs$date$Date$divWithRemainder = F2(function (a, b) {
    return _Utils_Tuple2(A2($justinmimbs$date$Date$floorDiv, a, b), A2($elm$core$Basics$modBy, b, a));
  });
  var $justinmimbs$date$Date$year = function (_v0) {
    var rd = _v0;
    var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
    var n400 = _v1.a;
    var r400 = _v1.b;
    var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
    var n100 = _v2.a;
    var r100 = _v2.b;
    var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
    var n4 = _v3.a;
    var r4 = _v3.b;
    var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
    var n1 = _v4.a;
    var r1 = _v4.b;
    var n = !r1 ? 0 : 1;
    return n400 * 400 + n100 * 100 + n4 * 4 + n1 + n;
  };
  var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
    var rd = _v0;
    var y = $justinmimbs$date$Date$year(rd);
    return {
      jZ: rd - $justinmimbs$date$Date$daysBeforeYear(y),
      ta: y
    };
  };
  var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
    var rd = _v0;
    var date = $justinmimbs$date$Date$toOrdinalDate(rd);
    return A3($justinmimbs$date$Date$toCalendarDateHelp, date.ta, 0, date.jZ);
  };
  var $justinmimbs$date$Date$add = F3(function (unit, n, _v0) {
    var rd = _v0;
    switch (unit) {
      case 0:
        return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
      case 1:
        var date = $justinmimbs$date$Date$toCalendarDate(rd);
        var wholeMonths = 12 * (date.ta - 1) + ($justinmimbs$date$Date$monthToNumber(date.pt) - 1) + n;
        var m = $justinmimbs$date$Date$numberToMonth(A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
        var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
        return $justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m) + A2($elm$core$Basics$min, date.mO, A2($justinmimbs$date$Date$daysInMonth, y, m));
      case 2:
        return rd + 7 * n;
      default:
        return rd + n;
    }
  });
  var $elm$core$Basics$clamp = F3(function (low, high, number) {
    return _Utils_cmp(number, low) < 0 ? low : _Utils_cmp(number, high) > 0 ? high : number;
  });
  var $justinmimbs$date$Date$fromCalendarDate = F3(function (y, m, d) {
    return $justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m) + A3($elm$core$Basics$clamp, 1, A2($justinmimbs$date$Date$daysInMonth, y, m), d);
  });
  var $justinmimbs$date$Date$fromPosix = F2(function (zone, posix) {
    return A3($justinmimbs$date$Date$fromCalendarDate, A2($elm$time$Time$toYear, zone, posix), A2($elm$time$Time$toMonth, zone, posix), A2($elm$time$Time$toDay, zone, posix));
  });
  var $justinmimbs$date$Date$toRataDie = function (_v0) {
    var rd = _v0;
    return rd;
  };
  var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
    var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
    return daysSinceEpoch * 86400000;
  };
  var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(function (hour, minute, second, millisecond) {
    return hour * 3600000 + minute * 60000 + second * 1000 + millisecond;
  });
  var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(function (zone, posix) {
    return A4($justinmimbs$time_extra$Time$Extra$timeFromClock, A2($elm$time$Time$toHour, zone, posix), A2($elm$time$Time$toMinute, zone, posix), A2($elm$time$Time$toSecond, zone, posix), A2($elm$time$Time$toMillis, zone, posix));
  });
  var $justinmimbs$time_extra$Time$Extra$toOffset = F2(function (zone, posix) {
    var millis = $elm$time$Time$posixToMillis(posix);
    var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
    return (localMillis - millis) / 60000 | 0;
  });
  var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(function (zone, date, time) {
    var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
    var offset0 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, $elm$time$Time$millisToPosix(millis));
    var posix1 = $elm$time$Time$millisToPosix(millis - offset0 * 60000);
    var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
    if (_Utils_eq(offset0, offset1)) {
      return posix1;
    } else {
      var posix2 = $elm$time$Time$millisToPosix(millis - offset1 * 60000);
      var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
      return _Utils_eq(offset1, offset2) ? posix2 : posix1;
    }
  });
  var $justinmimbs$time_extra$Time$Extra$add = F4(function (interval, n, zone, posix) {
    add: while (true) {
      switch (interval) {
        case 15:
          return $elm$time$Time$millisToPosix($elm$time$Time$posixToMillis(posix) + n);
        case 14:
          var $temp$interval = 15,
            $temp$n = n * 1000,
            $temp$zone = zone,
            $temp$posix = posix;
          interval = $temp$interval;
          n = $temp$n;
          zone = $temp$zone;
          posix = $temp$posix;
          continue add;
        case 13:
          var $temp$interval = 15,
            $temp$n = n * 60000,
            $temp$zone = zone,
            $temp$posix = posix;
          interval = $temp$interval;
          n = $temp$n;
          zone = $temp$zone;
          posix = $temp$posix;
          continue add;
        case 12:
          var $temp$interval = 15,
            $temp$n = n * 3600000,
            $temp$zone = zone,
            $temp$posix = posix;
          interval = $temp$interval;
          n = $temp$n;
          zone = $temp$zone;
          posix = $temp$posix;
          continue add;
        case 11:
          return A3($justinmimbs$time_extra$Time$Extra$posixFromDateTime, zone, A3($justinmimbs$date$Date$add, 3, n, A2($justinmimbs$date$Date$fromPosix, zone, posix)), A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
        case 2:
          return A3($justinmimbs$time_extra$Time$Extra$posixFromDateTime, zone, A3($justinmimbs$date$Date$add, 1, n, A2($justinmimbs$date$Date$fromPosix, zone, posix)), A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
        case 0:
          var $temp$interval = 2,
            $temp$n = n * 12,
            $temp$zone = zone,
            $temp$posix = posix;
          interval = $temp$interval;
          n = $temp$n;
          zone = $temp$zone;
          posix = $temp$posix;
          continue add;
        case 1:
          var $temp$interval = 2,
            $temp$n = n * 3,
            $temp$zone = zone,
            $temp$posix = posix;
          interval = $temp$interval;
          n = $temp$n;
          zone = $temp$zone;
          posix = $temp$posix;
          continue add;
        case 3:
          var $temp$interval = 11,
            $temp$n = n * 7,
            $temp$zone = zone,
            $temp$posix = posix;
          interval = $temp$interval;
          n = $temp$n;
          zone = $temp$zone;
          posix = $temp$posix;
          continue add;
        default:
          var weekday = interval;
          var $temp$interval = 11,
            $temp$n = n * 7,
            $temp$zone = zone,
            $temp$posix = posix;
          interval = $temp$interval;
          n = $temp$n;
          zone = $temp$zone;
          posix = $temp$posix;
          continue add;
      }
    }
  });
  var $author$project$Types$LocalDateTime$LocalDateTime = F5(function (year, month, day, hour, minute) {
    return {
      mO: day,
      wC: hour,
      yu: minute,
      pt: month,
      ta: year
    };
  });
  var $justinmimbs$time_extra$Time$Extra$posixToParts = F2(function (zone, posix) {
    return {
      mO: A2($elm$time$Time$toDay, zone, posix),
      wC: A2($elm$time$Time$toHour, zone, posix),
      i3: A2($elm$time$Time$toMillis, zone, posix),
      yu: A2($elm$time$Time$toMinute, zone, posix),
      pt: A2($elm$time$Time$toMonth, zone, posix),
      rt: A2($elm$time$Time$toSecond, zone, posix),
      ta: A2($elm$time$Time$toYear, zone, posix)
    };
  });
  var $author$project$Types$LocalDateTime$fromPosix = F2(function (zone, posix) {
    var _v0 = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, posix);
    var year = _v0.ta;
    var month = _v0.pt;
    var day = _v0.mO;
    var hour = _v0.wC;
    var minute = _v0.yu;
    return A5($author$project$Types$LocalDateTime$LocalDateTime, year, $author$project$ElmFramework$Lib$Util$toNumberFromMonth(month), day, hour, minute);
  });
  var $justinmimbs$time_extra$Time$Extra$Parts = F7(function (year, month, day, hour, minute, second, millisecond) {
    return {
      mO: day,
      wC: hour,
      i3: millisecond,
      yu: minute,
      pt: month,
      rt: second,
      ta: year
    };
  });
  var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(function (zone, _v0) {
    var year = _v0.ta;
    var month = _v0.pt;
    var day = _v0.mO;
    var hour = _v0.wC;
    var minute = _v0.yu;
    var second = _v0.rt;
    var millisecond = _v0.i3;
    return A3($justinmimbs$time_extra$Time$Extra$posixFromDateTime, zone, A3($justinmimbs$date$Date$fromCalendarDate, year, month, day), A4($justinmimbs$time_extra$Time$Extra$timeFromClock, A3($elm$core$Basics$clamp, 0, 23, hour), A3($elm$core$Basics$clamp, 0, 59, minute), A3($elm$core$Basics$clamp, 0, 59, second), A3($elm$core$Basics$clamp, 0, 999, millisecond)));
  });
  var $author$project$Types$LocalDateTime$toPosix = F2(function (zone, _v0) {
    var year = _v0.ta;
    var month = _v0.pt;
    var day = _v0.mO;
    var hour = _v0.wC;
    var minute = _v0.yu;
    return A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, A7($justinmimbs$time_extra$Time$Extra$Parts, year, $justinmimbs$date$Date$numberToMonth(month), day, hour, minute, 0, 0));
  });
  var $author$project$Types$LocalDateTime$addDay = function (amount) {
    return A2($elm$core$Basics$composeR, $author$project$Types$LocalDateTime$toPosix($elm$time$Time$utc), A2($elm$core$Basics$composeR, A3($justinmimbs$time_extra$Time$Extra$add, 11, amount, $elm$time$Time$utc), $author$project$Types$LocalDateTime$fromPosix($elm$time$Time$utc)));
  };
  var $author$project$Types$LocalDateTime$fromSimpleDate = function (simpleDate) {
    return {
      mO: simpleDate.mO,
      wC: 0,
      yu: 0,
      pt: $author$project$ElmFramework$Lib$Util$toNumberFromMonth(simpleDate.pt),
      ta: simpleDate.ta
    };
  };
  var $elm$core$Char$fromCode = _Char_fromCode;
  var $elm$random$Random$Generator = $elm$core$Basics$identity;
  var $elm$random$Random$peel = function (_v0) {
    var state = _v0.a;
    var word = (state ^ state >>> (state >>> 28) + 4) * 277803737;
    return (word >>> 22 ^ word) >>> 0;
  };
  var $elm$random$Random$int = F2(function (a, b) {
    return function (seed0) {
      var _v0 = _Utils_cmp(a, b) < 0 ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
      var lo = _v0.a;
      var hi = _v0.b;
      var range = hi - lo + 1;
      if (!(range - 1 & range)) {
        return _Utils_Tuple2(((range - 1 & $elm$random$Random$peel(seed0)) >>> 0) + lo, $elm$random$Random$next(seed0));
      } else {
        var threshhold = (-range >>> 0) % range >>> 0;
        var accountForBias = function (seed) {
          accountForBias: while (true) {
            var x = $elm$random$Random$peel(seed);
            var seedN = $elm$random$Random$next(seed);
            if (_Utils_cmp(x, threshhold) < 0) {
              var $temp$seed = seedN;
              seed = $temp$seed;
              continue accountForBias;
            } else {
              return _Utils_Tuple2(x % range + lo, seedN);
            }
          }
        };
        return accountForBias(seed0);
      }
    };
  });
  var $elm$random$Random$map = F2(function (func, _v0) {
    var genA = _v0;
    return function (seed0) {
      var _v1 = genA(seed0);
      var a = _v1.a;
      var seed1 = _v1.b;
      return _Utils_Tuple2(func(a), seed1);
    };
  });
  var $elm_community$random_extra$Random$Char$char = F2(function (start, end) {
    return A2($elm$random$Random$map, $elm$core$Char$fromCode, A2($elm$random$Random$int, start, end));
  });
  var $elm$core$Basics$abs = function (n) {
    return n < 0 ? -n : n;
  };
  var $elm$random$Random$andThen = F2(function (callback, _v0) {
    var genA = _v0;
    return function (seed) {
      var _v1 = genA(seed);
      var result = _v1.a;
      var newSeed = _v1.b;
      var _v2 = callback(result);
      var genB = _v2;
      return genB(newSeed);
    };
  });
  var $elm$random$Random$float = F2(function (a, b) {
    return function (seed0) {
      var seed1 = $elm$random$Random$next(seed0);
      var range = $elm$core$Basics$abs(b - a);
      var n1 = $elm$random$Random$peel(seed1);
      var n0 = $elm$random$Random$peel(seed0);
      var lo = (134217727 & n1) * 1.0;
      var hi = (67108863 & n0) * 1.0;
      var val = (hi * 134217728.0 + lo) / 9007199254740992.0;
      var scaled = val * range + a;
      return _Utils_Tuple2(scaled, $elm$random$Random$next(seed1));
    };
  });
  var $elm$core$List$sum = function (numbers) {
    return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
  };
  var $elm_community$random_extra$Random$Extra$frequency = F2(function (head, pairs) {
    var total = $elm$core$List$sum(A2($elm$core$List$map, A2($elm$core$Basics$composeL, $elm$core$Basics$abs, $elm$core$Tuple$first), A2($elm$core$List$cons, head, pairs)));
    var pick = F2(function (someChoices, n) {
      pick: while (true) {
        if (someChoices.b) {
          var _v1 = someChoices.a;
          var k = _v1.a;
          var g = _v1.b;
          var rest = someChoices.b;
          if (_Utils_cmp(n, k) < 1) {
            return g;
          } else {
            var $temp$someChoices = rest,
              $temp$n = n - k;
            someChoices = $temp$someChoices;
            n = $temp$n;
            continue pick;
          }
        } else {
          return head.b;
        }
      }
    });
    return A2($elm$random$Random$andThen, pick(A2($elm$core$List$cons, head, pairs)), A2($elm$random$Random$float, 0, total));
  });
  var $elm_community$random_extra$Random$Extra$choices = F2(function (hd, gens) {
    return A2($elm_community$random_extra$Random$Extra$frequency, _Utils_Tuple2(1, hd), A2($elm$core$List$map, function (g) {
      return _Utils_Tuple2(1, g);
    }, gens));
  });
  var $elm$core$String$fromList = _String_fromList;
  var $elm$random$Random$listHelp = F4(function (revList, n, gen, seed) {
    listHelp: while (true) {
      if (n < 1) {
        return _Utils_Tuple2(revList, seed);
      } else {
        var _v0 = gen(seed);
        var value = _v0.a;
        var newSeed = _v0.b;
        var $temp$revList = A2($elm$core$List$cons, value, revList),
          $temp$n = n - 1,
          $temp$gen = gen,
          $temp$seed = newSeed;
        revList = $temp$revList;
        n = $temp$n;
        gen = $temp$gen;
        seed = $temp$seed;
        continue listHelp;
      }
    }
  });
  var $elm$random$Random$list = F2(function (n, _v0) {
    var gen = _v0;
    return function (seed) {
      return A4($elm$random$Random$listHelp, _List_Nil, n, gen, seed);
    };
  });
  var $elm_community$random_extra$Random$String$string = F2(function (stringLength, charGenerator) {
    return A2($elm$random$Random$map, $elm$core$String$fromList, A2($elm$random$Random$list, stringLength, charGenerator));
  });
  var $author$project$ElmFramework$Lib$Uuid$alphaNumericGenerator = function (strLength) {
    return A2($elm_community$random_extra$Random$String$string, strLength, A2($elm_community$random_extra$Random$Extra$choices, A2($elm_community$random_extra$Random$Char$char, 48, 57), _List_fromArray([A2($elm_community$random_extra$Random$Char$char, 97, 122), A2($elm_community$random_extra$Random$Char$char, 65, 90)])));
  };
  var $elm$random$Random$step = F2(function (_v0, seed) {
    var generator = _v0;
    return generator(seed);
  });
  var $elm$core$List$unzip = function (pairs) {
    var step = F2(function (_v0, _v1) {
      var x = _v0.a;
      var y = _v0.b;
      var xs = _v1.a;
      var ys = _v1.b;
      return _Utils_Tuple2(A2($elm$core$List$cons, x, xs), A2($elm$core$List$cons, y, ys));
    });
    return A3($elm$core$List$foldr, step, _Utils_Tuple2(_List_Nil, _List_Nil), pairs);
  };
  var $author$project$ElmFramework$Lib$Uuid$generateUUID = function (seeds) {
    return A2($elm$core$Tuple$mapFirst, $elm$core$String$join(''), $elm$core$List$unzip(A2($elm$core$List$map, $elm$random$Random$step($author$project$ElmFramework$Lib$Uuid$alphaNumericGenerator(5)), seeds)));
  };
  var $elm_community$list_extra$List$Extra$getAt = F2(function (idx, xs) {
    return idx < 0 ? $elm$core$Maybe$Nothing : $elm$core$List$head(A2($elm$core$List$drop, idx, xs));
  });
  var $author$project$Types$LocalDateTime$initFromSimpleDateEnd = function (simpleDate) {
    return {
      mO: simpleDate.mO,
      wC: 18,
      yu: 0,
      pt: $author$project$ElmFramework$Lib$Util$toNumberFromMonth(simpleDate.pt),
      ta: simpleDate.ta
    };
  };
  var $author$project$Types$LocalDateTime$initFromSimpleDateStart = function (simpleDate) {
    return {
      mO: simpleDate.mO,
      wC: 10,
      yu: 0,
      pt: $author$project$ElmFramework$Lib$Util$toNumberFromMonth(simpleDate.pt),
      ta: simpleDate.ta
    };
  };
  var $author$project$Types$LocalTimeInterval$initializeFromSimpleDate = function (initDate) {
    return {
      wh: $author$project$Types$LocalDateTime$initFromSimpleDateStart(initDate),
      CC: $author$project$Types$LocalDateTime$initFromSimpleDateEnd(initDate)
    };
  };
  var $elm_community$list_extra$List$Extra$removeAt = F2(function (index, l) {
    if (index < 0) {
      return l;
    } else {
      var _v0 = A2($elm$core$List$drop, index, l);
      if (!_v0.b) {
        return l;
      } else {
        var rest = _v0.b;
        return _Utils_ap(A2($elm$core$List$take, index, l), rest);
      }
    }
  });
  var $elm$core$List$repeatHelp = F3(function (result, n, value) {
    repeatHelp: while (true) {
      if (n <= 0) {
        return result;
      } else {
        var $temp$result = A2($elm$core$List$cons, value, result),
          $temp$n = n - 1,
          $temp$value = value;
        result = $temp$result;
        n = $temp$n;
        value = $temp$value;
        continue repeatHelp;
      }
    }
  });
  var $elm$core$List$repeat = F2(function (n, value) {
    return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
  });
  var $elm_community$list_extra$List$Extra$findIndexHelp = F3(function (index, predicate, list) {
    findIndexHelp: while (true) {
      if (!list.b) {
        return $elm$core$Maybe$Nothing;
      } else {
        var x = list.a;
        var xs = list.b;
        if (predicate(x)) {
          return $elm$core$Maybe$Just(index);
        } else {
          var $temp$index = index + 1,
            $temp$predicate = predicate,
            $temp$list = xs;
          index = $temp$index;
          predicate = $temp$predicate;
          list = $temp$list;
          continue findIndexHelp;
        }
      }
    }
  });
  var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
  var $elm_community$list_extra$List$Extra$splitAt = F2(function (n, xs) {
    return _Utils_Tuple2(A2($elm$core$List$take, n, xs), A2($elm$core$List$drop, n, xs));
  });
  var $elm_community$list_extra$List$Extra$splitWhen = F2(function (predicate, list) {
    return A2($elm$core$Maybe$map, function (i) {
      return A2($elm_community$list_extra$List$Extra$splitAt, i, list);
    }, A2($elm_community$list_extra$List$Extra$findIndex, predicate, list));
  });
  var $author$project$Types$Activity$toNumberOfPlayers = function (activity) {
    switch (activity) {
      case 1:
        return 4;
      case 3:
        return 2;
      case 2:
        return 2;
      default:
        return 2;
    }
  };
  var $author$project$Types$Uuid$unwrapUuid = function (_v0) {
    var id = _v0;
    return id;
  };
  var $elm_community$list_extra$List$Extra$updateAt = F3(function (index, fn, list) {
    if (index < 0) {
      return list;
    } else {
      var tail = A2($elm$core$List$drop, index, list);
      var head = A2($elm$core$List$take, index, list);
      if (tail.b) {
        var x = tail.a;
        var xs = tail.b;
        return _Utils_ap(head, A2($elm$core$List$cons, fn(x), xs));
      } else {
        return list;
      }
    }
  });
  var $author$project$Types$LocalDateTime$updateDateOnly = F2(function (localDateTime, _v0) {
    var year = _v0.ta;
    var month = _v0.pt;
    var day = _v0.mO;
    return _Utils_update(localDateTime, {
      mO: day,
      pt: $author$project$ElmFramework$Lib$Util$toNumberFromMonth(month),
      ta: year
    });
  });
  var $author$project$ElmFramework$Msg$UpdateSeeds = function (a) {
    return {
      $: 25,
      a: a
    };
  };
  var $author$project$TopMsg$updateSeeds = function (seeds) {
    return $author$project$ElmFramework$Msg$UpdateSeeds(seeds);
  };
  var $author$project$Ui$CreateOrEditSearch$Update$update = F4(function (msg, state, seeds, env) {
    switch (msg.$) {
      case 0:
        var maybeLocation = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          iT: maybeLocation
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 1:
        var radius = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          gj: radius
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 2:
        var activity = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          du: A2($author$project$ElmFramework$Lib$Util$toggleMaybe, activity, state.du),
          ox: _Utils_eq($elm$core$Maybe$Just(activity), state.du) ? state.ox : A2($elm$core$List$repeat, $author$project$Types$Activity$toNumberOfPlayers(activity) - 1, $author$project$Types$Search$EmptySlot)
        }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$addPlayersMsg($author$project$Ui$AddPlayers$Msg$ResetXrivalsContacsSelection)]));
      case 3:
        var index = msg.a;
        var date = msg.b;
        var predicateTransformLocalDateTime = F3(function (predicate, transform, localDateTime) {
          return A3($author$project$ElmFramework$Lib$Util$ifElse, transform(localDateTime), localDateTime, predicate(localDateTime));
        });
        var newDate = $author$project$Types$LocalDateTime$fromSimpleDate(date);
        var isBetweenMidnightAnd3Am = function (_v2) {
          var hour = _v2.wC;
          var minute = _v2.yu;
          return hour * 60 + minute <= 180;
        };
        var defaultInterval = $author$project$Types$LocalTimeInterval$initializeFromSimpleDate(date);
        var addDayIfAfterMidnight = function (localDateTime) {
          return A3(predicateTransformLocalDateTime, isBetweenMidnightAnd3Am, $author$project$Types$LocalDateTime$addDay(1), localDateTime);
        };
        var updateAvailabilityValue = function (_v1) {
          var interval = _v1.b;
          return _Utils_Tuple2(newDate, _Utils_update(interval, {
            wh: addDayIfAfterMidnight(A2($author$project$Types$LocalDateTime$updateDateOnly, interval.wh, date)),
            CC: addDayIfAfterMidnight(A2($author$project$Types$LocalDateTime$updateDateOnly, interval.CC, date))
          }));
        };
        var updateList = A2($elm$core$Basics$composeR, $elm$core$Maybe$map(updateAvailabilityValue), A2($elm$core$Basics$composeR, $elm$core$Maybe$withDefault(_Utils_Tuple2(newDate, defaultInterval)), $elm$core$Maybe$Just));
        return _Utils_Tuple3(_Utils_update(state, {
          tF: A3($elm_community$list_extra$List$Extra$updateAt, index, updateList, state.tF)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 4:
        var index = msg.a;
        var _v3 = msg.b;
        var newFrom = _v3.a;
        var newTo = _v3.b;
        var updateAvailabilityValue = $elm$core$Tuple$mapSecond($elm$core$Basics$always({
          wh: newFrom,
          CC: newTo
        }));
        var updateList = $elm$core$Maybe$map(updateAvailabilityValue);
        return _Utils_Tuple3(_Utils_update(state, {
          tF: A3($elm_community$list_extra$List$Extra$updateAt, index, updateList, state.tF)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 5:
        return _Utils_Tuple3(_Utils_update(state, {
          tF: A2($elm$core$List$append, state.tF, _List_fromArray([$elm$core$Maybe$Nothing]))
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 6:
        var index = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          tF: A2($elm_community$list_extra$List$Extra$removeAt, index, state.tF)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 7:
        return _Utils_Tuple3($author$project$Types$CreateOrEditSearchParams$empty, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$addPlayersMsg($author$project$Ui$AddPlayers$Msg$ResetXrivalsContacsSelection)]));
      case 8:
        var editSearchParams = msg.a;
        return _Utils_Tuple3(editSearchParams, $elm$core$Platform$Cmd$none, _List_Nil);
      case 9:
        var index = msg.a;
        var _v4 = A2($elm$core$Maybe$withDefault, A2($elm$core$Tuple$mapFirst, $elm$core$Basics$identity, $author$project$ElmFramework$Lib$Uuid$generateUUID(seeds)), A2($elm$core$Maybe$map, function (inviteTokenExisting) {
          return _Utils_Tuple2(inviteTokenExisting, seeds);
        }, state.ye));
        var inviteToken = _v4.a;
        var updatedSeeds = _v4.b;
        var inviteTokenString = $author$project$Types$Uuid$unwrapUuid(inviteToken);
        var _v5 = A2($elm$core$Maybe$withDefault, _Utils_Tuple3(_Utils_update(state, {
          ye: $elm$core$Maybe$Just(inviteToken)
        }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$updateSeeds(updatedSeeds)])), A2($elm$core$Maybe$map, function (_v6) {
          var usedSlotsList = _v6.a;
          var emptySlotsList = _v6.b;
          if (emptySlotsList.b) {
            var emptySlotsTail = emptySlotsList.b;
            var urlPrefix = env.fR ? 'https://play.xrivals.com/invitation/token/' : 'https://play-test.xrivals.com/invitation/token/';
            var _v8 = A4($author$project$ElmFramework$Feature$Share$Share$shareDialog, env, 'Invitation to play with me on XRIVALS', 'You can now share your invitation', _Utils_ap(urlPrefix, inviteTokenString));
            var cmd = _v8.a;
            var isCopiedToClipboard = _v8.b;
            var toast = isCopiedToClipboard ? _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CQ, $elm$core$Maybe$Nothing, 'Your invitation is copied', _List_fromArray(['You can now paste your invitation url ']))]) : _List_Nil;
            return _Utils_Tuple3(_Utils_update(state, {
              ox: _Utils_ap(usedSlotsList, _Utils_ap(_List_fromArray([$author$project$Types$Search$ExternalInvite(inviteTokenString)]), emptySlotsTail)),
              ye: $elm$core$Maybe$Just(inviteToken)
            }), cmd, _Utils_ap(_List_fromArray([$author$project$TopMsg$updateSeeds(updatedSeeds)]), toast));
          } else {
            return _Utils_Tuple3(_Utils_update(state, {
              ye: $elm$core$Maybe$Just(inviteToken)
            }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$updateSeeds(updatedSeeds)]));
          }
        }, A2($elm_community$list_extra$List$Extra$splitWhen, $elm$core$Basics$eq($author$project$Types$Search$EmptySlot), state.ox)));
        var updatedState = _v5.a;
        var cmds = _v5.b;
        var topMsgs = _v5.c;
        return _Utils_Tuple3(updatedState, cmds, topMsgs);
      case 10:
        var userId = msg.a;
        var userProfilePublic = msg.b;
        var internalInvite = A2($author$project$Types$Search$InternalInvite, userId, userProfilePublic);
        var _v9 = A2($elm$core$List$member, internalInvite, state.ox) ? _Utils_Tuple2(function (list) {
          return _Utils_ap(list, _List_fromArray([$author$project$Types$Search$EmptySlot]));
        }(A2($elm$core$List$filter, $elm$core$Basics$neq(internalInvite), state.ox)), _List_fromArray([$author$project$TopMsg$addPlayersMsg($author$project$Ui$AddPlayers$Msg$OnTapXrivalsContact(userId))])) : A2($elm$core$Maybe$withDefault, _Utils_Tuple2(state.ox, _List_Nil), A2($elm$core$Maybe$map, function (_v10) {
          var usedSlotsList = _v10.a;
          var emptySlotsList = _v10.b;
          if (emptySlotsList.b) {
            var tails = emptySlotsList.b;
            return _Utils_Tuple2(_Utils_ap(usedSlotsList, _Utils_ap(_List_fromArray([internalInvite]), tails)), _List_fromArray([$author$project$TopMsg$addPlayersMsg($author$project$Ui$AddPlayers$Msg$OnTapXrivalsContact(userId))]));
          } else {
            return _Utils_Tuple2(state.ox, _List_Nil);
          }
        }, A2($elm_community$list_extra$List$Extra$splitWhen, $elm$core$Basics$eq($author$project$Types$Search$EmptySlot), state.ox)));
        var updatedInvitedPlayers = _v9.a;
        var topMsgs = _v9.b;
        return _Utils_Tuple3(_Utils_update(state, {
          ox: updatedInvitedPlayers
        }), $elm$core$Platform$Cmd$none, topMsgs);
      default:
        var index = msg.a;
        var topMsgs = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function (invitedPlayer) {
          if (invitedPlayer.$ === 1) {
            var userId = invitedPlayer.a;
            return _List_fromArray([$author$project$TopMsg$addPlayersMsg($author$project$Ui$AddPlayers$Msg$OnTapXrivalsContact(userId))]);
          } else {
            return _List_Nil;
          }
        }, A2($elm_community$list_extra$List$Extra$getAt, index, state.ox)));
        return _Utils_Tuple3(_Utils_update(state, {
          ox: function (list) {
            return _Utils_ap(list, _List_fromArray([$author$project$Types$Search$EmptySlot]));
          }(A2($elm_community$list_extra$List$Extra$removeAt, index, state.ox))
        }), $elm$core$Platform$Cmd$none, topMsgs);
    }
  });
  var $author$project$Ui$Matchmaking$Single$Update$update = F6(function (msg, state, maybeSession, route, seeds, env) {
    switch (msg.$) {
      case 0:
        return A3($author$project$Ui$Matchmaking$Single$Update$onRoute, state, maybeSession, route);
      case 1:
        var userSession = msg.a;
        return A3($author$project$Ui$Matchmaking$Single$Update$onAuthSuccess, state, userSession, route);
      case 2:
        var createSearchStateMsg = msg.a;
        return A2($TSFoster$elm_tuple_extra$Tuple3$mapSecond, $elm$core$Platform$Cmd$map($author$project$Ui$Matchmaking$Single$Msg$CreateOrEditSearch), A2($TSFoster$elm_tuple_extra$Tuple3$mapFirst, function (subState) {
          return _Utils_update(state, {
            mE: subState
          });
        }, A4($author$project$Ui$CreateOrEditSearch$Update$update, createSearchStateMsg, state.mE, seeds, env)));
      default:
        var geolocation = msg.a;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$ReverseGeocoding, {
          A3: $author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$Main)
        }, geolocation))]));
    }
  });
  var $author$project$Ui$Matchmaking$Update$update = F6(function (topState, msg, state, maybeSession, route, env) {
    if (!msg.$) {
      var subMsg = msg.a;
      return A2($TSFoster$elm_tuple_extra$Tuple3$mapSecond, $elm$core$Platform$Cmd$map($author$project$Ui$Matchmaking$Msg$SingleMsgReceived), A2($TSFoster$elm_tuple_extra$Tuple3$mapFirst, function (subState) {
        return _Utils_update(state, {
          B2: subState
        });
      }, A6($author$project$Ui$Matchmaking$Single$Update$update, subMsg, state.B2, maybeSession, route, topState.BM, env)));
    } else {
      var subMsg = msg.a;
      return A2($TSFoster$elm_tuple_extra$Tuple3$mapSecond, $elm$core$Platform$Cmd$map($author$project$Ui$Matchmaking$Msg$CheckoutMsgReceived), A2($TSFoster$elm_tuple_extra$Tuple3$mapFirst, function (subState) {
        return _Utils_update(state, {
          mj: subState
        });
      }, A4($author$project$Ui$Matchmaking$Checkout$Update$update, subMsg, state.mj, maybeSession, route)));
    }
  });
  var $author$project$Remote$RequestMsg$GetMeUserData = {
    $: 36
  };
  var $author$project$Ui$MoreOptions$Msg$HideTimerFinished = 1;
  var $author$project$Ui$MoreOptions$Update$update = F2(function (msg, state) {
    if (!msg) {
      return _Utils_Tuple3(_Utils_update(state, {
        n1: true
      }), A2($elm$core$Task$perform, $elm$core$Basics$always(1), $elm$core$Process$sleep(30000)), _List_Nil);
    } else {
      return _Utils_Tuple3(_Utils_update(state, {
        n1: false
      }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetMeUserData)]));
    }
  });
  var $author$project$Remote$RequestMsg$GetSearch = function (a) {
    return {
      $: 24,
      a: a
    };
  };
  var $author$project$Ui$CreateOrEditSearch$Msg$InitStateForEdit = function (a) {
    return {
      $: 8,
      a: a
    };
  };
  var $author$project$Types$Search$CreatorSlot = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Types$LocalDateTime$setToPreviousDayIfBefore3Am = function (localDateTime) {
    var hour = localDateTime.wC;
    var minute = localDateTime.yu;
    return A3($elm$core$Basics$apR, hour * 60 + minute <= 180, A2($author$project$ElmFramework$Lib$Util$ifElse, $author$project$Types$LocalDateTime$addDay(-1), $elm$core$Basics$identity), localDateTime);
  };
  var $author$project$Types$LocalDateTime$setToStartOfDay = function (localDateTime) {
    return _Utils_update(localDateTime, {
      wC: 0,
      yu: 0
    });
  };
  var $author$project$Types$ParticipantPublic$toUserProfileLimited = function (_v0) {
    var firstName = _v0.nF;
    var lastNameOrInitial = _v0.fT;
    var gender = _v0.nM;
    var photo = _v0.c5;
    return {
      nF: firstName,
      nM: gender,
      fT: lastNameOrInitial,
      qq: photo
    };
  };
  var $author$project$Types$CreateOrEditSearchParams$fromSearch = F2(function (maybeSession, _v0) {
    var search = _v0.kH;
    var createdBy = _v0.uW;
    var inviteToSlot = function (_v4) {
      var userId = _v4.e_;
      var inviteStatus = _v4.ow;
      var profile = _v4.qI;
      return inviteStatus === 3 ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A2($author$project$Types$Search$InternalInvite, userId, {
        nF: profile.nF,
        nM: profile.nM,
        xy: profile.fT,
        fT: profile.fT,
        qq: profile.qq
      }));
    };
    var creatorSlot = _List_fromArray([A2($author$project$Types$Search$CreatorSlot, createdBy.e_, $author$project$Types$ParticipantPublic$toUserProfileLimited(createdBy))]);
    var _v1 = search;
    var invites = _v1.w5;
    var externalInvites = _v1.v7;
    var params = _v1.p8;
    var numberOfExternalInvitesSlots = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, function (_v3) {
      var created = _v3.uU;
      var accepted = _v3.td;
      var rejected = _v3.A_;
      return created - rejected - accepted;
    }, externalInvites));
    var availableExternalInvitesSlots = function () {
      if (!externalInvites.$) {
        var maybeInviteToken = externalInvites.a.ye;
        return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function (inviteToken) {
          return A2($elm$core$List$repeat, numberOfExternalInvitesSlots, $author$project$Types$Search$ExternalInvite(inviteToken));
        }, maybeInviteToken));
      } else {
        return _List_Nil;
      }
    }();
    var unrejectedInvites = A2($elm$core$List$filterMap, inviteToSlot, invites);
    var toSearchPlayerSlots = function (filledSlots) {
      return _Utils_ap(filledSlots, A2($elm$core$List$repeat, $author$project$Types$Activity$toNumberOfPlayers(search.p8.du) - $elm$core$List$length(filledSlots), $author$project$Types$Search$EmptySlot));
    }(_Utils_ap(creatorSlot, _Utils_ap(unrejectedInvites, availableExternalInvitesSlots)));
    return {
      du: $elm$core$Maybe$Just(params.du),
      tF: A2($elm$core$List$map, function (interval) {
        return $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Types$LocalDateTime$setToStartOfDay($author$project$Types$LocalDateTime$setToPreviousDayIfBefore3Am(interval.wh)), interval));
      }, params.tF),
      ox: toSearchPlayerSlots,
      iT: $elm$core$Maybe$Just(_Utils_Tuple2(params.iT, params.cy)),
      ye: $elm$core$Maybe$Nothing,
      gj: params.Dr
    };
  });
  var $author$project$Ui$MyPlayerStatus$Update$update = F3(function (msg, state, session) {
    switch (msg.$) {
      case 0:
        var newRoute = msg.a;
        if (newRoute.$ === 19) {
          var myPlayerStatusRoute = newRoute.a;
          switch (myPlayerStatusRoute.$) {
            case 0:
              return _Utils_Tuple3(_Utils_update(state, {
                oG: false
              }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$remoteMsg(A2($author$project$Remote$Msg$NextMatchesEndlessListMsg, false, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$RefetchContent))]));
            case 1:
              return _Utils_Tuple3(_Utils_update(state, {
                oF: false
              }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$remoteMsg($author$project$Remote$Msg$ClearHistoryMatchesEndlessList)]));
            default:
              switch (myPlayerStatusRoute.a.$) {
                case 0:
                  var _v3 = myPlayerStatusRoute.a;
                  return _Utils_Tuple3(_Utils_update(state, {
                    oK: false
                  }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$remoteMsg(A2($author$project$Remote$Msg$SearchesEndlessListMsg, false, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$RefetchContent))]));
                case 1:
                  var searchId = myPlayerStatusRoute.a.a;
                  var maybeSearch = A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$get, searchId, session.BK);
                  if (!maybeSearch.$) {
                    var search = maybeSearch.a;
                    return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgSingleCreateOrEditSearch($author$project$Ui$CreateOrEditSearch$Msg$InitStateForEdit(A2($author$project$Types$CreateOrEditSearchParams$fromSearch, $elm$core$Maybe$Just(session), search)))]));
                  } else {
                    return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetSearch(searchId))]));
                  }
                default:
                  return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
              }
          }
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 1:
        var dateOrder = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          cF: dateOrder
        }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$remoteMsg($author$project$Remote$Msg$ClearHistoryMatchesEndlessList)]));
      case 2:
        var textSearch = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          sn: textSearch
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 3:
        return _Utils_Tuple3(_Utils_update(state, {
          sn: ''
        }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$remoteMsg($author$project$Remote$Msg$ClearHistoryMatchesEndlessList)]));
      case 4:
        var textSearch = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          sn: textSearch
        }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$remoteMsg($author$project$Remote$Msg$ClearHistoryMatchesEndlessList)]));
      case 5:
        return _Utils_Tuple3(_Utils_update(state, {
          qS: 7
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 6:
        return _Utils_Tuple3(_Utils_update(state, {
          qS: state.qS - 1
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 7:
        var isSearchesUpdated = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          oK: isSearchesUpdated
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 8:
        var isNextMatchesUpdated = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          oG: isNextMatchesUpdated
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      default:
        var isHistoryMatchesUpdated = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          oF: isHistoryMatchesUpdated
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Remote$RequestMsg$UpdateNotificationSettings = F2(function (a, b) {
    return {
      $: 30,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$NotificationsSettings$Update$onAuthRoute = F3(function (state, maybeSession, currentRoute) {
    if (!maybeSession.$) {
      var session = maybeSession.a;
      return _Utils_eq(currentRoute, $author$project$Route$Route$NotificationsSettings) ? _Utils_Tuple3(session.pJ, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
    } else {
      return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Ui$NotificationsSettings$Update$update = F4(function (msg, state, maybeSession, route) {
    switch (msg.$) {
      case 0:
        return A3($author$project$Ui$NotificationsSettings$Update$onAuthRoute, state, maybeSession, route);
      case 1:
        var session = msg.a;
        return A3($author$project$Ui$NotificationsSettings$Update$onAuthRoute, state, $elm$core$Maybe$Just(session), route);
      case 2:
        var notificationKind = msg.a;
        var newState = function () {
          var cancellation = state.mb;
          if (!notificationKind) {
            return _Utils_update(state, {
              mb: _Utils_update(cancellation, {
                bZ: !cancellation.bZ
              })
            });
          } else {
            return _Utils_update(state, {
              mb: _Utils_update(cancellation, {
                ew: !cancellation.ew
              })
            });
          }
        }();
        return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_Nil);
      case 3:
        var notificationKind = msg.a;
        var newState = function () {
          var newMatch = state.pC;
          if (!notificationKind) {
            return _Utils_update(state, {
              pC: _Utils_update(newMatch, {
                bZ: !newMatch.bZ
              })
            });
          } else {
            return _Utils_update(state, {
              pC: _Utils_update(newMatch, {
                ew: !newMatch.ew
              })
            });
          }
        }();
        return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_Nil);
      case 4:
        var notificationKind = msg.a;
        var newState = function () {
          var noMatch = state.pE;
          if (!notificationKind) {
            return _Utils_update(state, {
              pE: _Utils_update(noMatch, {
                bZ: !noMatch.bZ
              })
            });
          } else {
            return _Utils_update(state, {
              pE: _Utils_update(noMatch, {
                ew: !noMatch.ew
              })
            });
          }
        }();
        return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_Nil);
      case 5:
        var notificationKind = msg.a;
        var newState = function () {
          if (!notificationKind) {
            return _Utils_update(state, {
              rs: function (searchInvite) {
                return _Utils_update(searchInvite, {
                  bZ: !state.rs.bZ
                });
              }(state.rs)
            });
          } else {
            return _Utils_update(state, {
              rs: function (searchInvite) {
                return _Utils_update(searchInvite, {
                  ew: !state.rs.ew
                });
              }(state.rs)
            });
          }
        }();
        return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_Nil);
      case 6:
        var notificationKind = msg.a;
        var newState = function () {
          var rate = state.qT;
          if (!notificationKind) {
            return _Utils_update(state, {
              qT: _Utils_update(rate, {
                bZ: !rate.bZ
              })
            });
          } else {
            return _Utils_update(state, {
              qT: _Utils_update(rate, {
                ew: !rate.ew
              })
            });
          }
        }();
        return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_Nil);
      case 7:
        var allActivated = msg.a;
        return _Utils_Tuple3($author$project$Ui$NotificationsSettings$Model$init(allActivated), $elm$core$Platform$Cmd$none, _List_Nil);
      default:
        var msgs = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$List$singleton, $author$project$TopMsg$requestMsg), $author$project$Remote$RequestMsg$UpdateNotificationSettings(state)), A2($elm$core$Maybe$map, function ($) {
          return $.e_;
        }, maybeSession));
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, msgs);
    }
  });
  var $author$project$Ui$EditUserActivities$Msg$SetState = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Types$EditingUserActivities$fromSession = function (session) {
    return A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$Activity$toString(false), A2($elm$core$List$map, function (activity) {
      return _Utils_Tuple2(activity.du, activity.eH);
    }, session.lz));
  };
  var $author$project$TopMsg$msgEditingActivities = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$EditingUserActivitiesMsg);
  var $author$project$Ui$OnboardUser$Update$update = F5(function (msg, editingUserProfile, state, maybeSession, geolocationAndPermissions) {
    switch (msg.$) {
      case 0:
        var routeHistory = msg.a;
        var route = msg.b;
        _v1$2: while (true) {
          if (route.$ === 16) {
            if (!route.a.$) {
              if (route.a.a.$ === 1) {
                var _v2 = route.a.a;
                var initializeForm = function () {
                  if (!maybeSession.$) {
                    var session = maybeSession.a;
                    return _Utils_eq(editingUserProfile, $author$project$Types$EditingUserProfile$empty) ? _List_fromArray([$author$project$TopMsg$msgEditingUserProfile($author$project$Types$EditingUserProfile$SetState($author$project$Types$EditingUserProfile$fromUserProfile(session.Db)))]) : _List_Nil;
                  } else {
                    if (geolocationAndPermissions.$ === 2 && geolocationAndPermissions.b.$ === 2) {
                      var geolocation = geolocationAndPermissions.b.a;
                      return _Utils_eq(editingUserProfile.iT, $elm$core$Maybe$Nothing) ? _List_fromArray([$author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$ReverseGeocoding, {
                        A3: $author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$Personal($elm$core$Maybe$Nothing))
                      }, geolocation))]) : _List_Nil;
                    } else {
                      return _List_Nil;
                    }
                  }
                }();
                return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, initializeForm);
              } else {
                break _v1$2;
              }
            } else {
              if (!route.a.a) {
                var _v5 = route.a.a;
                var visibilityChanged = _Utils_eq($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(routeHistory), $author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$EditUserActivities(0)));
                var userNavigatedBack = _Utils_eq($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(routeHistory), $author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$EditUserActivities(1)));
                return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, A2($elm$core$Basics$composeR, $author$project$Types$EditingUserActivities$fromSession, A2($elm$core$Basics$composeR, $author$project$Ui$EditUserActivities$Msg$SetState, A2($elm$core$Basics$composeR, $author$project$TopMsg$msgEditingActivities, $elm$core$List$singleton))), A2($elm_community$maybe_extra$Maybe$Extra$filter, $elm$core$Basics$always(!visibilityChanged), A2($elm_community$maybe_extra$Maybe$Extra$filter, $elm$core$Basics$always(!userNavigatedBack), maybeSession))));
              } else {
                break _v1$2;
              }
            }
          } else {
            break _v1$2;
          }
        }
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 1:
        var geolocation = msg.a;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$ReverseGeocoding, {
          A3: $author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$Personal($elm$core$Maybe$Nothing))
        }, geolocation))]));
      case 2:
        var uuid = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          rc: $elm$core$Maybe$Just(uuid)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      default:
        return _Utils_Tuple3(_Utils_update(state, {
          rc: $elm$core$Maybe$Nothing
        }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgEditingUserProfile($author$project$Types$EditingUserProfile$SetState($author$project$Types$EditingUserProfile$empty))]));
    }
  });
  var $author$project$Global$Model$PostMatchPaymentConfirmationDialog = function (a) {
    return {
      $: 15,
      a: a
    };
  };
  var $author$project$Global$Model$RemovePaymentMethodDialog = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Global$Msg$ShowDialog = function (a) {
    return {
      $: 11,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$Stripe$StripePorts$confirmStripeCardPayment = _Platform_outgoingPort('confirmStripeCardPayment', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('card', $elm$core$Basics$identity($.t6)), _Utils_Tuple2('clientSecret', $elm$json$Json$Encode$string($.ul)), _Utils_Tuple2('setupFutureUsage', $elm$json$Json$Encode$bool($.BU))]));
  });
  var $elm$json$Json$Encode$float = _Json_wrap;
  var $author$project$Api$GraphqlSchema$Enum$Activity$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'BADMINTON';
      case 1:
        return 'PADEL';
      case 2:
        return 'SQUASH';
      default:
        return 'TENNIS';
    }
  };
  var $author$project$Api$GraphqlSchema$Enum$Currency$toString = function (enum____) {
    if (!enum____) {
      return 'AED';
    } else {
      return 'USD';
    }
  };
  var $author$project$Types$Search$unwrapSearchId = function (_v0) {
    var id = _v0;
    return id;
  };
  var $author$project$Analytics$holdSuccess = F2(function (_v0, _v1) {
    var id = _v0.od;
    var params = _v0.p8;
    var amount = _v1.lH;
    var currency = _v1.mH;
    var intent = _v1.ot;
    return A2($author$project$ElmFramework$Feature$Analytics$Analytics$sendEventCustom, 'purchase', _List_fromArray([_Utils_Tuple2('ecommerce', $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('currency', $elm$json$Json$Encode$string($author$project$Api$GraphqlSchema$Enum$Currency$toString(currency))), _Utils_Tuple2('transaction_search_id', $elm$json$Json$Encode$string($author$project$Types$Search$unwrapSearchId(id))), _Utils_Tuple2('value', $elm$json$Json$Encode$float(amount / 100)), _Utils_Tuple2('items', A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_fromArray([$elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('item_id', $elm$json$Json$Encode$string($author$project$Api$GraphqlSchema$Enum$Activity$toString(params.du))), _Utils_Tuple2('item_name', $elm$json$Json$Encode$string($author$project$Api$GraphqlSchema$Enum$Activity$toString(params.du))), _Utils_Tuple2('item_category4', $elm$json$Json$Encode$string(params.cy.lh)), _Utils_Tuple2('item_category5', $elm$json$Json$Encode$string(params.cy.lb))]))])))])))]));
  });
  var $author$project$TopMsg$msgMatch = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$MatchMsg);
  var $author$project$Remote$RequestMsg$CreateMatchPaymentIntent = function (a) {
    return {
      $: 40,
      a: a
    };
  };
  var $krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
    if (data.$ === 3) {
      var x = data.a;
      return true;
    } else {
      return false;
    }
  };
  var $author$project$Types$UserSession$isPaymentIntentForMatchFetched = F2(function (matchId, session) {
    var _v0 = A2($turboMaCk$any_dict$Dict$Any$get, matchId, session.Aj);
    if (!_v0.$) {
      var remotePaymentIntent = _v0.a;
      return $krisajenkins$remotedata$RemoteData$isSuccess(remotePaymentIntent);
    } else {
      return false;
    }
  });
  var $author$project$Ui$PaymentMethods$Update$onRouteOrAuth = F3(function (route, session, state) {
    var topMsgs = function () {
      if (route.$ === 21 && route.b.$ === 1) {
        var matchId = route.a;
        return A2($author$project$Types$UserSession$isPaymentIntentForMatchFetched, matchId, session) ? _List_Nil : _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$CreateMatchPaymentIntent(matchId))]);
      } else {
        return _List_Nil;
      }
    }();
    return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, topMsgs);
  });
  var $author$project$Types$Match$unwrapMatchId = function (_v0) {
    var id = _v0;
    return id;
  };
  var $author$project$Analytics$paymentIntentSuccess = F2(function (_v0, _v1) {
    var match = _v0.xX;
    var venue = _v0.Dh;
    var amount = _v1.lH;
    var currency = _v1.mH;
    var intent = _v1.ot;
    return A2($author$project$ElmFramework$Feature$Analytics$Analytics$sendEventCustom, 'purchase', _List_fromArray([_Utils_Tuple2('ecommerce', $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('currency', $elm$json$Json$Encode$string($author$project$Api$GraphqlSchema$Enum$Currency$toString(currency))), _Utils_Tuple2('transaction_match_id', $elm$json$Json$Encode$string($author$project$Types$Match$unwrapMatchId(match.od))), _Utils_Tuple2('value', $elm$json$Json$Encode$float(amount / 100)), _Utils_Tuple2('items', A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_fromArray([$elm$json$Json$Encode$object(_Utils_ap(_List_fromArray([_Utils_Tuple2('item_id', $elm$json$Json$Encode$string($author$project$Api$GraphqlSchema$Enum$Activity$toString(match.du))), _Utils_Tuple2('item_name', $elm$json$Json$Encode$string($author$project$Api$GraphqlSchema$Enum$Activity$toString(match.du)))]), A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function (venueValue) {
      return _List_fromArray([_Utils_Tuple2('item_category4', $elm$json$Json$Encode$string(venueValue.cy.lh)), _Utils_Tuple2('item_category5', $elm$json$Json$Encode$string(venueValue.cy.lb))]);
    }, venue))))])))])))]));
  });
  var $krisajenkins$remotedata$RemoteData$map = F2(function (f, data) {
    switch (data.$) {
      case 3:
        var value = data.a;
        return $krisajenkins$remotedata$RemoteData$Success(f(value));
      case 1:
        return $krisajenkins$remotedata$RemoteData$Loading;
      case 0:
        return $krisajenkins$remotedata$RemoteData$NotAsked;
      default:
        var error = data.a;
        return $krisajenkins$remotedata$RemoteData$Failure(error);
    }
  });
  var $krisajenkins$remotedata$RemoteData$withDefault = F2(function (_default, data) {
    if (data.$ === 3) {
      var x = data.a;
      return x;
    } else {
      return _default;
    }
  });
  var $krisajenkins$remotedata$RemoteData$toMaybe = A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just), $krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing));
  var $author$project$Types$PaymentMethod$unwrapPaymentMethodId = function (_v0) {
    var id = _v0;
    return id;
  };
  var $author$project$ElmFramework$Lib$Stripe$StripePorts$confirmStripePayment = _Platform_outgoingPort('confirmStripePayment', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('elementsInstance', $elm$core$Basics$identity($.m9))]));
  });
  var $author$project$ElmFramework$Lib$Stripe$StripePorts$confirmStripeSetup = _Platform_outgoingPort('confirmStripeSetup', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('elementsInstance', $elm$core$Basics$identity($.m9))]));
  });
  var $author$project$Remote$RequestMsg$SaveStripePaymentMethod = {
    $: 42
  };
  var $author$project$Ui$PaymentMethods$Edit$Update$onAuthSuccess = F2(function (route, state) {
    var shouldDoActionResult = function () {
      _v1$3: while (true) {
        switch (route.$) {
          case 17:
            if (route.a === 1) {
              var _v2 = route.a;
              return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
            } else {
              break _v1$3;
            }
          case 18:
            if (route.a.$ === 1 && !route.a.a.$ && route.a.a.a === 1) {
              var _v3 = route.a.a.a;
              return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
            } else {
              break _v1$3;
            }
          case 21:
            if (route.b.$ === 1) {
              var matchId = route.a;
              return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
            } else {
              break _v1$3;
            }
          default:
            break _v1$3;
        }
      }
      return $elm$core$Result$Err('');
    }();
    if (!shouldDoActionResult.$) {
      var maybeSearchId = shouldDoActionResult.a;
      return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$SaveStripePaymentMethod)]));
    } else {
      return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Ui$PaymentMethods$Edit$Update$onRoute = F3(function (maybePreviousRoute, route, state) {
    var isDifferentThanPreviousRoute = _Utils_eq($elm$core$Maybe$Just(route), maybePreviousRoute) ? false : true;
    var shouldDoAction = function () {
      _v0$3: while (true) {
        switch (route.$) {
          case 17:
            if (route.a === 1) {
              var _v1 = route.a;
              return isDifferentThanPreviousRoute;
            } else {
              break _v0$3;
            }
          case 18:
            if (route.a.$ === 1 && !route.a.a.$) {
              return isDifferentThanPreviousRoute;
            } else {
              break _v0$3;
            }
          case 21:
            if (route.b.$ === 1) {
              var matchId = route.a;
              return isDifferentThanPreviousRoute;
            } else {
              break _v0$3;
            }
          default:
            break _v0$3;
        }
      }
      return false;
    }();
    return shouldDoAction ? _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$SaveStripePaymentMethod)])) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$finalizeWithOutMsgList = F2(function (onFinal, _v0) {
    var nextState = _v0.a;
    var nextCmd = _v0.b;
    var nextOutMsg = _v0.c;
    return function (_v1) {
      var finalState = _v1.a;
      var finalCmd = _v1.b;
      var finalOutMsg = _v1.c;
      return _Utils_Tuple3(finalState, $elm$core$Platform$Cmd$batch(_List_fromArray([nextCmd, finalCmd])), _Utils_ap(nextOutMsg, finalOutMsg));
    }(onFinal(nextState));
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWith = F2(function (result, config) {
    if (!result.$) {
      var value = result.a;
      return config.w(config.jR(value));
    } else {
      var error = result.a;
      return config.w(config.E(error));
    }
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithResultToOutMsgList = F2(function (result, operations) {
    return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWith, result, {
      w: $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$finalizeWithOutMsgList(operations.w),
      E: operations.E,
      jR: operations.jR
    });
  });
  var $author$project$Ui$PaymentMethods$Edit$Update$update = F4(function (session, state, route, msg) {
    switch (msg.$) {
      case 0:
        var oldRouteHistory = msg.a;
        var route_ = msg.b;
        return A3($author$project$Ui$PaymentMethods$Edit$Update$onRoute, $elm$core$Maybe$Just($author$project$ElmFramework$Feature$Navigation$RouteHistory$current(oldRouteHistory)), route_, state);
      case 1:
        return A2($author$project$Ui$PaymentMethods$Edit$Update$onAuthSuccess, route, state);
      case 2:
        var stripeCardInputStatus = msg.a;
        if (!stripeCardInputStatus.$) {
          var string = stripeCardInputStatus.a;
          return _Utils_Tuple3(_Utils_update(state, {
            qg: $elm$core$Maybe$Nothing
          }), $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
          var value = stripeCardInputStatus.a;
          return _Utils_Tuple3(_Utils_update(state, {
            qg: $elm$core$Maybe$Just(value)
          }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 3:
        var _v2 = state.qg;
        if (!_v2.$) {
          var paymentInformation = _v2.a;
          return _Utils_Tuple3(_Utils_update(state, {
            iz: true
          }), $author$project$ElmFramework$Lib$Stripe$StripePorts$confirmStripePayment({
            m9: paymentInformation
          }), _List_Nil);
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 4:
        var result = msg.a;
        var maybeParticipantPaymentStatus = function (matchId) {
          return A2($elm$core$Maybe$andThen, function (matchDetails) {
            return $author$project$Types$Match$toParticipantPaymentStatus(matchDetails);
          }, A2($author$project$Types$UserSession$findMatch, session, matchId));
        };
        var waitForUpdatedPaymentStatus = function (matchId) {
          var _v6 = maybeParticipantPaymentStatus(matchId);
          if (!_v6.$) {
            var participantPaymentStatus = _v6.a;
            return _List_fromArray([$author$project$TopMsg$msgMatch(A2($author$project$Ui$Match$Msg$WaitingForUpdatedMatchPaymentStatus, participantPaymentStatus, 15))]);
          } else {
            return _List_Nil;
          }
        };
        var _v3 = function () {
          if (route.$ === 21) {
            var matchId = route.a;
            return _Utils_Tuple2(_Utils_ap(_List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetMeUserData), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$PostMatchPaymentConfirmationDialog(matchId)))]), waitForUpdatedPaymentStatus(matchId)), $elm$core$Maybe$Just(matchId));
          } else {
            return _Utils_Tuple2(_List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetMeUserData), $author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Upcoming))]), $elm$core$Maybe$Nothing);
          }
        }();
        var topMsgs = _v3.a;
        var maybeMatchId = _v3.b;
        var onErrorTopMsgs = function (error) {
          return _Utils_ap(_List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil)]), A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, waitForUpdatedPaymentStatus, maybeMatchId)));
        };
        return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithResultToOutMsgList, result, {
          w: function (nextState) {
            return _Utils_Tuple3(_Utils_update(nextState, {
              iz: false
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          },
          E: function (err) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, onErrorTopMsgs(err));
          },
          jR: function (_v5) {
            return _Utils_Tuple3(_Utils_update(state, {
              qg: $elm$core$Maybe$Nothing
            }), $elm$core$Platform$Cmd$none, topMsgs);
          }
        });
      case 5:
        var paymentMethodContext = msg.a;
        var _v7 = state.qg;
        if (!_v7.$) {
          var paymentInformation = _v7.a;
          return _Utils_Tuple3(_Utils_update(state, {
            iz: true,
            pd: $elm$core$Maybe$Just(paymentMethodContext)
          }), $author$project$ElmFramework$Lib$Stripe$StripePorts$confirmStripeSetup({
            m9: paymentInformation
          }), _List_Nil);
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 6:
        var result = msg.a;
        return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithResultToOutMsgList, result, {
          w: function (nextState) {
            return _Utils_Tuple3(_Utils_update(nextState, {
              iz: false,
              pd: $elm$core$Maybe$Nothing
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          },
          E: function (error) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil)]));
          },
          jR: function (_v8) {
            var topMsgs = _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$PaymentMethods(0)), A3($author$project$ElmFramework$MsgCmd$msgCmd.CQ, $elm$core$Maybe$Nothing, 'Payment method has been added!', _List_Nil), $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetMeUserData)]);
            return _Utils_Tuple3(_Utils_update(state, {
              qg: $elm$core$Maybe$Nothing
            }), $elm$core$Platform$Cmd$none, topMsgs);
          }
        });
      case 7:
        return _Utils_Tuple3(_Utils_update(state, {
          oJ: !state.oJ
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      default:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Ui$PaymentMethods$Update$update = F4(function (session, state, route, msg) {
    switch (msg.$) {
      case 0:
        return A3($author$project$Ui$PaymentMethods$Update$onRouteOrAuth, route, session, state);
      case 2:
        var paymentMethodId = msg.a;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$RemovePaymentMethodDialog(paymentMethodId)))]));
      case 3:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 1:
        var subMsg = msg.a;
        return A2($TSFoster$elm_tuple_extra$Tuple3$mapSecond, $elm$core$Platform$Cmd$map($author$project$Ui$PaymentMethods$Msg$EditMsgReceived), A2($TSFoster$elm_tuple_extra$Tuple3$mapFirst, function (subState) {
          return _Utils_update(state, {
            vE: subState
          });
        }, A4($author$project$Ui$PaymentMethods$Edit$Update$update, session, state.vE, route, subMsg)));
      case 4:
        var searchId = msg.a;
        var paymentMethodId = msg.b;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 5:
        var matchId = msg.a;
        var paymentMethodId = msg.b;
        var maybeMatchDetails = A2($elm_community$maybe_extra$Maybe$Extra$or, A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$get, matchId, session.yC), A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$get, matchId, session.wA));
        var maybeIntentSuccess = A2($elm$core$Maybe$andThen, $krisajenkins$remotedata$RemoteData$toMaybe, A2($turboMaCk$any_dict$Dict$Any$get, matchId, session.Aj));
        var _v1 = function () {
          var _v2 = _Utils_Tuple2(maybeIntentSuccess, maybeMatchDetails);
          if (!_v2.a.$ && !_v2.b.$) {
            var intentSuccess = _v2.a.a;
            var matchDetails = _v2.b.a;
            return _Utils_Tuple2($author$project$ElmFramework$Lib$Stripe$StripePorts$confirmStripeCardPayment({
              t6: $elm$json$Json$Encode$string($author$project$Types$PaymentMethod$unwrapPaymentMethodId(paymentMethodId)),
              ul: intentSuccess.ot.ul,
              BU: false
            }), $elm$core$Maybe$Just(_Utils_Tuple2(matchDetails, intentSuccess)));
          } else {
            return _Utils_Tuple2($elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
          }
        }();
        var cmd = _v1.a;
        var pendingPaymentIntentForMatch = _v1.b;
        return _Utils_Tuple3(_Utils_update(state, {
          qm: pendingPaymentIntentForMatch
        }), cmd, _List_Nil);
      case 6:
        var result = msg.a;
        var _v3 = function () {
          var _v4 = state.Ah;
          if (!_v4.$) {
            var _v5 = _v4.a;
            var search = _v5.a;
            var createPaymentIntentHoldForSearchSuccess = _v5.b;
            return _Utils_Tuple2(A2($author$project$Analytics$holdSuccess, search, createPaymentIntentHoldForSearchSuccess), _List_Nil);
          } else {
            return _Utils_Tuple2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('SubmitPaymentWithPaymentMethodResult: unexpected success'), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'SubmitPaymentWithPaymentMethodResult: unexpected success', _List_Nil)]));
          }
        }();
        var trackingCmd = _v3.a;
        var errToast = _v3.b;
        return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithResultToOutMsgList, result, {
          w: function (nextState) {
            return _Utils_Tuple3(_Utils_update(nextState, {
              Ah: $elm$core$Maybe$Nothing
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          },
          E: function (error) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil)]));
          },
          jR: function (_v6) {
            return _Utils_Tuple3(state, trackingCmd, _Utils_ap(_List_Nil, errToast));
          }
        });
      default:
        var result = msg.a;
        var maybeMatchId = function () {
          if (route.$ === 21) {
            var matchId = route.a;
            return $elm$core$Maybe$Just(matchId);
          } else {
            return $elm$core$Maybe$Nothing;
          }
        }();
        var maybeParticipantPaymentStatus = A2($elm$core$Maybe$andThen, function (matchDetails) {
          return $author$project$Types$Match$toParticipantPaymentStatus(matchDetails);
        }, A2($elm$core$Maybe$andThen, function (matchId) {
          return A2($author$project$Types$UserSession$findMatch, session, matchId);
        }, maybeMatchId));
        var waitForUpdatedPaymentStatus = function () {
          if (!maybeParticipantPaymentStatus.$) {
            var participantPaymentStatus = maybeParticipantPaymentStatus.a;
            return _List_fromArray([$author$project$TopMsg$msgMatch(A2($author$project$Ui$Match$Msg$WaitingForUpdatedMatchPaymentStatus, participantPaymentStatus, 15))]);
          } else {
            return _List_Nil;
          }
        }();
        var onErrorTopMsgs = function (error) {
          return _Utils_ap(_List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil)]), waitForUpdatedPaymentStatus);
        };
        return A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$updateWithResultToOutMsgList, result, {
          w: function (nextState) {
            return _Utils_Tuple3(_Utils_update(nextState, {
              qm: $elm$core$Maybe$Nothing
            }), $elm$core$Platform$Cmd$none, _List_Nil);
          },
          E: function (err) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, onErrorTopMsgs(err));
          },
          jR: function (_v7) {
            var _v8 = state.qm;
            if (!_v8.$) {
              var _v9 = _v8.a;
              var matchDetails = _v9.a;
              var pendingPaymentIntentForMatch = _v9.b;
              return _Utils_Tuple3(state, A2($author$project$Analytics$paymentIntentSuccess, matchDetails, pendingPaymentIntentForMatch), function () {
                if (!maybeMatchId.$) {
                  var matchId = maybeMatchId.a;
                  return _Utils_ap(_List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$PostMatchPaymentConfirmationDialog(matchId)))]), waitForUpdatedPaymentStatus);
                } else {
                  return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Upcoming))]);
                }
              }());
            } else {
              return _Utils_Tuple3(state, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('SubmitPaymentWithSelectedPaymentMethodForMatchResult: unexpected error'), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'SubmitPaymentWithSelectedPaymentMethodForMatchResult: unexpected error', _List_Nil)]));
            }
          }
        });
    }
  });
  var $author$project$Ui$ProvideLocation$Model$LocationSearchStarted = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Types$EditingUserProfile$LocationSet = function (a) {
    return {
      $: 7,
      a: a
    };
  };
  var $author$project$Ui$ProvideLocation$Msg$ReceivedAddressGeocoding = F3(function (a, b, c) {
    return {
      $: 4,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Api$GraphqlSchema$Enum$GeoAccuracyLevel$High = 1;
  var $author$project$Api$GraphqlSchema$Enum$GeoLocationMethod$UserProvided = 1;
  var $author$project$Types$GeoLocation$geoLocationFromAutocomplete = function (_v0) {
    var lat = _v0.oV;
    var lng = _v0.o_;
    return {
      ds: 1,
      cx: $elm$core$Maybe$Nothing,
      em: 1,
      es: {
        oV: lat,
        o_: lng
      }
    };
  };
  var $author$project$ElmFramework$Feature$Places$Places$getPlacePredictions = _Platform_outgoingPort('getPlacePredictions', $elm$json$Json$Encode$string);
  var $author$project$ElmFramework$Lib$Geocoding$PlaceId = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$Geocoding$ReverseGeocodingRequest = F5(function (requestInfo, language, resultType, locationType, apiKey) {
    return {
      Y: apiKey,
      ac: language,
      cX: locationType,
      af: requestInfo,
      eB: resultType
    };
  });
  var $author$project$ElmFramework$Lib$Geocoding$reverseRequestForPlaceId = F2(function (key, placeId) {
    return A5($author$project$ElmFramework$Lib$Geocoding$ReverseGeocodingRequest, $author$project$ElmFramework$Lib$Geocoding$PlaceId(placeId), $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, key);
  });
  var $elm$http$Http$expectStringResponse = F2(function (toMsg, toResult) {
    return A3(_Http_expect, '', $elm$core$Basics$identity, A2($elm$core$Basics$composeR, toResult, toMsg));
  });
  var $elm$http$Http$BadBody = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $elm$http$Http$BadStatus = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $elm$http$Http$BadUrl = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $elm$http$Http$NetworkError = {
    $: 2
  };
  var $elm$http$Http$Timeout = {
    $: 1
  };
  var $elm$http$Http$resolve = F2(function (toResult, response) {
    switch (response.$) {
      case 0:
        var url = response.a;
        return $elm$core$Result$Err($elm$http$Http$BadUrl(url));
      case 1:
        return $elm$core$Result$Err($elm$http$Http$Timeout);
      case 2:
        return $elm$core$Result$Err($elm$http$Http$NetworkError);
      case 3:
        var metadata = response.a;
        return $elm$core$Result$Err($elm$http$Http$BadStatus(metadata.Ce));
      default:
        var body = response.b;
        return A2($elm$core$Result$mapError, $elm$http$Http$BadBody, toResult(body));
    }
  });
  var $elm$http$Http$expectJson = F2(function (toMsg, decoder) {
    return A2($elm$http$Http$expectStringResponse, toMsg, $elm$http$Http$resolve(function (string) {
      return A2($elm$core$Result$mapError, $elm$json$Json$Decode$errorToString, A2($elm$json$Json$Decode$decodeString, decoder, string));
    }));
  });
  var $elm$http$Http$Request = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $elm$http$Http$State = F2(function (reqs, subs) {
    return {
      q1: reqs,
      sb: subs
    };
  });
  var $elm$http$Http$init = $elm$core$Task$succeed(A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
  var $elm$http$Http$updateReqs = F3(function (router, cmds, reqs) {
    updateReqs: while (true) {
      if (!cmds.b) {
        return $elm$core$Task$succeed(reqs);
      } else {
        var cmd = cmds.a;
        var otherCmds = cmds.b;
        if (!cmd.$) {
          var tracker = cmd.a;
          var _v2 = A2($elm$core$Dict$get, tracker, reqs);
          if (_v2.$ === 1) {
            var $temp$router = router,
              $temp$cmds = otherCmds,
              $temp$reqs = reqs;
            router = $temp$router;
            cmds = $temp$cmds;
            reqs = $temp$reqs;
            continue updateReqs;
          } else {
            var pid = _v2.a;
            return A2($elm$core$Task$andThen, function (_v3) {
              return A3($elm$http$Http$updateReqs, router, otherCmds, A2($elm$core$Dict$remove, tracker, reqs));
            }, $elm$core$Process$kill(pid));
          }
        } else {
          var req = cmd.a;
          return A2($elm$core$Task$andThen, function (pid) {
            var _v4 = req.sC;
            if (_v4.$ === 1) {
              return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
            } else {
              var tracker = _v4.a;
              return A3($elm$http$Http$updateReqs, router, otherCmds, A3($elm$core$Dict$insert, tracker, pid, reqs));
            }
          }, $elm$core$Process$spawn(A3(_Http_toTask, router, $elm$core$Platform$sendToApp(router), req)));
        }
      }
    }
  });
  var $elm$http$Http$onEffects = F4(function (router, cmds, subs, state) {
    return A2($elm$core$Task$andThen, function (reqs) {
      return $elm$core$Task$succeed(A2($elm$http$Http$State, reqs, subs));
    }, A3($elm$http$Http$updateReqs, router, cmds, state.q1));
  });
  var $elm$http$Http$maybeSend = F4(function (router, desiredTracker, progress, _v0) {
    var actualTracker = _v0.a;
    var toMsg = _v0.b;
    return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(A2($elm$core$Platform$sendToApp, router, toMsg(progress))) : $elm$core$Maybe$Nothing;
  });
  var $elm$http$Http$onSelfMsg = F3(function (router, _v0, state) {
    var tracker = _v0.a;
    var progress = _v0.b;
    return A2($elm$core$Task$andThen, function (_v1) {
      return $elm$core$Task$succeed(state);
    }, $elm$core$Task$sequence(A2($elm$core$List$filterMap, A3($elm$http$Http$maybeSend, router, tracker, progress), state.sb)));
  });
  var $elm$http$Http$Cancel = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $elm$http$Http$cmdMap = F2(function (func, cmd) {
    if (!cmd.$) {
      var tracker = cmd.a;
      return $elm$http$Http$Cancel(tracker);
    } else {
      var r = cmd.a;
      return $elm$http$Http$Request({
        tr: r.tr,
        aU: r.aU,
        nv: A2(_Http_mapExpect, func, r.nv),
        wx: r.wx,
        em: r.em,
        lf: r.lf,
        sC: r.sC,
        eZ: r.eZ
      });
    }
  });
  var $elm$http$Http$MySub = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $elm$http$Http$subMap = F2(function (func, _v0) {
    var tracker = _v0.a;
    var toMsg = _v0.b;
    return A2($elm$http$Http$MySub, tracker, A2($elm$core$Basics$composeR, toMsg, func));
  });
  _Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
  var $elm$http$Http$command = _Platform_leaf('Http');
  var $elm$http$Http$subscription = _Platform_leaf('Http');
  var $elm$http$Http$request = function (r) {
    return $elm$http$Http$command($elm$http$Http$Request({
      tr: false,
      aU: r.aU,
      nv: r.nv,
      wx: r.wx,
      em: r.em,
      lf: r.lf,
      sC: r.sC,
      eZ: r.eZ
    }));
  };
  var $elm$http$Http$get = function (r) {
    return $elm$http$Http$request({
      aU: $elm$http$Http$emptyBody,
      nv: r.nv,
      wx: _List_Nil,
      em: 'GET',
      lf: $elm$core$Maybe$Nothing,
      sC: $elm$core$Maybe$Nothing,
      eZ: r.eZ
    });
  };
  var $author$project$ElmFramework$Lib$Geocoding$Response = F2(function (status, results) {
    return {
      Bc: results,
      Cd: status
    };
  });
  var $author$project$ElmFramework$Lib$Geocoding$GeocodingResult = F5(function (addressComponents, formattedAddress, geometry, types, placeId) {
    return {
      bd: addressComponents,
      wg: formattedAddress,
      wn: geometry,
      qu: placeId,
      sF: types
    };
  });
  var $author$project$ElmFramework$Lib$Geocoding$AddressComponent = F3(function (longName, shortName, types) {
    return {
      xW: longName,
      BW: shortName,
      sF: types
    };
  });
  var $author$project$ElmFramework$Lib$Geocoding$OtherComponent = 37;
  var $author$project$ElmFramework$Lib$Geocoding$AdministrativeAreaLevel1 = 5;
  var $author$project$ElmFramework$Lib$Geocoding$AdministrativeAreaLevel2 = 6;
  var $author$project$ElmFramework$Lib$Geocoding$AdministrativeAreaLevel3 = 7;
  var $author$project$ElmFramework$Lib$Geocoding$AdministrativeAreaLevel4 = 8;
  var $author$project$ElmFramework$Lib$Geocoding$AdministrativeAreaLevel5 = 9;
  var $author$project$ElmFramework$Lib$Geocoding$Airport = 23;
  var $author$project$ElmFramework$Lib$Geocoding$BusStation = 33;
  var $author$project$ElmFramework$Lib$Geocoding$ColloquialArea = 10;
  var $author$project$ElmFramework$Lib$Geocoding$Country = 4;
  var $author$project$ElmFramework$Lib$Geocoding$Establishment = 29;
  var $author$project$ElmFramework$Lib$Geocoding$Floor = 27;
  var $author$project$ElmFramework$Lib$Geocoding$Intersection = 2;
  var $author$project$ElmFramework$Lib$Geocoding$Locality = 11;
  var $author$project$ElmFramework$Lib$Geocoding$NaturalFeature = 22;
  var $author$project$ElmFramework$Lib$Geocoding$Neighborhood = 18;
  var $author$project$ElmFramework$Lib$Geocoding$Park = 24;
  var $author$project$ElmFramework$Lib$Geocoding$Parking = 31;
  var $author$project$ElmFramework$Lib$Geocoding$PointOfInterest = 30;
  var $author$project$ElmFramework$Lib$Geocoding$Political = 3;
  var $author$project$ElmFramework$Lib$Geocoding$PostBox = 25;
  var $author$project$ElmFramework$Lib$Geocoding$PostalCode = 21;
  var $author$project$ElmFramework$Lib$Geocoding$PostalCodeSuffix = 36;
  var $author$project$ElmFramework$Lib$Geocoding$PostalTown = 32;
  var $author$project$ElmFramework$Lib$Geocoding$Premise = 19;
  var $author$project$ElmFramework$Lib$Geocoding$Room = 28;
  var $author$project$ElmFramework$Lib$Geocoding$Route = 1;
  var $author$project$ElmFramework$Lib$Geocoding$StreetAddress = 0;
  var $author$project$ElmFramework$Lib$Geocoding$StreetNumber = 26;
  var $author$project$ElmFramework$Lib$Geocoding$Sublocality = 12;
  var $author$project$ElmFramework$Lib$Geocoding$SublocalityLevel1 = 13;
  var $author$project$ElmFramework$Lib$Geocoding$SublocalityLevel2 = 14;
  var $author$project$ElmFramework$Lib$Geocoding$SublocalityLevel3 = 15;
  var $author$project$ElmFramework$Lib$Geocoding$SublocalityLevel4 = 16;
  var $author$project$ElmFramework$Lib$Geocoding$SublocalityLevel5 = 17;
  var $author$project$ElmFramework$Lib$Geocoding$Subpremise = 20;
  var $author$project$ElmFramework$Lib$Geocoding$TrainStation = 34;
  var $author$project$ElmFramework$Lib$Geocoding$TransitStation = 35;
  var $author$project$ElmFramework$Lib$Geocoding$componentTypeList = _List_fromArray([_Utils_Tuple2('street_address', 0), _Utils_Tuple2('route', 1), _Utils_Tuple2('intersection', 2), _Utils_Tuple2('political', 3), _Utils_Tuple2('country', 4), _Utils_Tuple2('administrative_area_level_1', 5), _Utils_Tuple2('administrative_area_level_2', 6), _Utils_Tuple2('administrative_area_level_3', 7), _Utils_Tuple2('administrative_area_level_4', 8), _Utils_Tuple2('administrative_area_level_5', 9), _Utils_Tuple2('colloquial_area', 10), _Utils_Tuple2('locality', 11), _Utils_Tuple2('sublocality', 12), _Utils_Tuple2('sublocality_level_1', 13), _Utils_Tuple2('sublocality_level_2', 14), _Utils_Tuple2('sublocality_level_3', 15), _Utils_Tuple2('sublocality_level_4', 16), _Utils_Tuple2('sublocality_level_5', 17), _Utils_Tuple2('neighborhood', 18), _Utils_Tuple2('premise', 19), _Utils_Tuple2('subpremise', 20), _Utils_Tuple2('postal_code', 21), _Utils_Tuple2('natural_feature', 22), _Utils_Tuple2('airport', 23), _Utils_Tuple2('park', 24), _Utils_Tuple2('post_box', 25), _Utils_Tuple2('street_number', 26), _Utils_Tuple2('floor', 27), _Utils_Tuple2('room', 28), _Utils_Tuple2('establishment', 29), _Utils_Tuple2('point_of_interest', 30), _Utils_Tuple2('parking', 31), _Utils_Tuple2('postal_town', 32), _Utils_Tuple2('bus_station', 33), _Utils_Tuple2('train_station', 34), _Utils_Tuple2('transit_station', 35), _Utils_Tuple2('postal_code_suffix', 36)]);
  var $author$project$ElmFramework$Lib$Geocoding$componentTypeMap = $elm$core$Dict$fromList($author$project$ElmFramework$Lib$Geocoding$componentTypeList);
  var $author$project$ElmFramework$Lib$Geocoding$stringToComponentType = function (str) {
    return A2($elm$core$Maybe$withDefault, 37, A2($elm$core$Dict$get, str, $author$project$ElmFramework$Lib$Geocoding$componentTypeMap));
  };
  var $author$project$ElmFramework$Lib$Geocoding$mapComponentType = A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$ElmFramework$Lib$Geocoding$stringToComponentType);
  var $author$project$ElmFramework$Lib$Geocoding$typeDecoder = A2($elm$json$Json$Decode$andThen, $author$project$ElmFramework$Lib$Geocoding$mapComponentType, $elm$json$Json$Decode$string);
  var $author$project$ElmFramework$Lib$Geocoding$typeListDecoder = $elm$json$Json$Decode$list($author$project$ElmFramework$Lib$Geocoding$typeDecoder);
  var $author$project$ElmFramework$Lib$Geocoding$addressComponentDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'types', $author$project$ElmFramework$Lib$Geocoding$typeListDecoder, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'short_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'long_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, $elm$json$Json$Decode$succeed($author$project$ElmFramework$Lib$Geocoding$AddressComponent))));
  var $author$project$ElmFramework$Lib$Geocoding$addressComponentListDecoder = $elm$json$Json$Decode$list($author$project$ElmFramework$Lib$Geocoding$addressComponentDecoder);
  var $author$project$ElmFramework$Lib$Geocoding$Geometry = F3(function (location, locationType, viewport) {
    return {
      iT: location,
      cX: locationType,
      Dm: viewport
    };
  });
  var $author$project$ElmFramework$Lib$Geocoding$Location = F2(function (latitude, longitude) {
    return {
      fU: latitude,
      fX: longitude
    };
  });
  var $author$project$ElmFramework$Lib$Geocoding$locationDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'lng', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'lat', $elm$json$Json$Decode$float, $elm$json$Json$Decode$succeed($author$project$ElmFramework$Lib$Geocoding$Location)));
  var $author$project$ElmFramework$Lib$Geocoding$OtherLocationType = 4;
  var $author$project$ElmFramework$Lib$Geocoding$Approximate = 3;
  var $author$project$ElmFramework$Lib$Geocoding$GeometricCenter = 2;
  var $author$project$ElmFramework$Lib$Geocoding$RangeInterpolated = 1;
  var $author$project$ElmFramework$Lib$Geocoding$Rooftop = 0;
  var $author$project$ElmFramework$Lib$Geocoding$locationTypeList = _List_fromArray([_Utils_Tuple2('ROOFTOP', 0), _Utils_Tuple2('RANGE_INTERPOLATED', 1), _Utils_Tuple2('GEOMETRIC_CENTER', 2), _Utils_Tuple2('APPROXIMATE', 3)]);
  var $author$project$ElmFramework$Lib$Geocoding$locationTypeMap = $elm$core$Dict$fromList($author$project$ElmFramework$Lib$Geocoding$locationTypeList);
  var $author$project$ElmFramework$Lib$Geocoding$stringToLocationType = function (str) {
    return A2($elm$core$Maybe$withDefault, 4, A2($elm$core$Dict$get, str, $author$project$ElmFramework$Lib$Geocoding$locationTypeMap));
  };
  var $author$project$ElmFramework$Lib$Geocoding$mapLocationType = A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$ElmFramework$Lib$Geocoding$stringToLocationType);
  var $author$project$ElmFramework$Lib$Geocoding$locationTypeDecoder = A2($elm$json$Json$Decode$andThen, $author$project$ElmFramework$Lib$Geocoding$mapLocationType, $elm$json$Json$Decode$string);
  var $author$project$ElmFramework$Lib$Geocoding$Viewport = F2(function (northeast, southwest) {
    return {
      pF: northeast,
      r1: southwest
    };
  });
  var $author$project$ElmFramework$Lib$Geocoding$viewportDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'southwest', $author$project$ElmFramework$Lib$Geocoding$locationDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'northeast', $author$project$ElmFramework$Lib$Geocoding$locationDecoder, $elm$json$Json$Decode$succeed($author$project$ElmFramework$Lib$Geocoding$Viewport)));
  var $author$project$ElmFramework$Lib$Geocoding$geometryDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'viewport', $author$project$ElmFramework$Lib$Geocoding$viewportDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location_type', $author$project$ElmFramework$Lib$Geocoding$locationTypeDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $author$project$ElmFramework$Lib$Geocoding$locationDecoder, $elm$json$Json$Decode$succeed($author$project$ElmFramework$Lib$Geocoding$Geometry))));
  var $author$project$ElmFramework$Lib$Geocoding$resultDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'place_id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'types', $author$project$ElmFramework$Lib$Geocoding$typeListDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'geometry', $author$project$ElmFramework$Lib$Geocoding$geometryDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'formatted_address', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address_components', $author$project$ElmFramework$Lib$Geocoding$addressComponentListDecoder, $elm$json$Json$Decode$succeed($author$project$ElmFramework$Lib$Geocoding$GeocodingResult))))));
  var $author$project$ElmFramework$Lib$Geocoding$resultListDecoder = $elm$json$Json$Decode$list($author$project$ElmFramework$Lib$Geocoding$resultDecoder);
  var $author$project$ElmFramework$Lib$Geocoding$GeocodingOk = 0;
  var $author$project$ElmFramework$Lib$Geocoding$InvalidRequest = 4;
  var $author$project$ElmFramework$Lib$Geocoding$OverQueryLimit = 2;
  var $author$project$ElmFramework$Lib$Geocoding$RequestDenied = 3;
  var $author$project$ElmFramework$Lib$Geocoding$UnknownError = 5;
  var $author$project$ElmFramework$Lib$Geocoding$ZeroResults = 1;
  var $author$project$ElmFramework$Lib$Geocoding$mapStatus = function (str) {
    switch (str) {
      case 'OK':
        return $elm$json$Json$Decode$succeed(0);
      case 'ZERO_RESULTS':
        return $elm$json$Json$Decode$succeed(1);
      case 'OVER_QUERY_LIMIT':
        return $elm$json$Json$Decode$succeed(2);
      case 'REQUEST_DENIED':
        return $elm$json$Json$Decode$succeed(3);
      case 'INVALID_REQUEST':
        return $elm$json$Json$Decode$succeed(4);
      case 'UNKNOWN_ERROR':
        return $elm$json$Json$Decode$succeed(5);
      default:
        return $elm$json$Json$Decode$fail('really, really, unknown error');
    }
  };
  var $author$project$ElmFramework$Lib$Geocoding$statusDecoder = A2($elm$json$Json$Decode$andThen, $author$project$ElmFramework$Lib$Geocoding$mapStatus, $elm$json$Json$Decode$string);
  var $author$project$ElmFramework$Lib$Geocoding$responseDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'results', $author$project$ElmFramework$Lib$Geocoding$resultListDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $author$project$ElmFramework$Lib$Geocoding$statusDecoder, $elm$json$Json$Decode$succeed($author$project$ElmFramework$Lib$Geocoding$Response)));
  var $author$project$ElmFramework$Lib$Geocoding$geocodingUrl = 'https://maps.googleapis.com/maps/api/geocode/json';
  var $author$project$ElmFramework$Lib$Geocoding$componentTypeToString = function (component) {
    return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$Tuple$first, $elm$core$List$head(A2($elm$core$List$filter, function (_v0) {
      var s = _v0.a;
      var c = _v0.b;
      return _Utils_eq(component, c);
    }, $author$project$ElmFramework$Lib$Geocoding$componentTypeList))));
  };
  var $author$project$ElmFramework$Lib$Geocoding$locationTypeToString = function (locationType) {
    return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$Tuple$first, $elm$core$List$head(A2($elm$core$List$filter, function (_v0) {
      var s = _v0.a;
      var loc = _v0.b;
      return _Utils_eq(locationType, loc);
    }, $author$project$ElmFramework$Lib$Geocoding$locationTypeList))));
  };
  var $author$project$ElmFramework$Lib$Geocoding$reverseRequestInfoParameter = function (info) {
    if (!info.$) {
      var _v1 = info.a;
      var lat = _v1.a;
      var lng = _v1.b;
      return _Utils_Tuple2('latlng', A2($elm$core$String$join, ',', A2($elm$core$List$map, $elm$core$String$fromFloat, _List_fromArray([lat, lng]))));
    } else {
      var id = info.a;
      return _Utils_Tuple2('place_id', id);
    }
  };
  var $author$project$ElmFramework$Lib$Geocoding$singleton = function (x) {
    return _List_fromArray([x]);
  };
  var $author$project$ElmFramework$Lib$Geocoding$toReverseRequestParameters = function (req) {
    return $elm$core$List$concat(_List_fromArray([_List_fromArray([_Utils_Tuple2('key', req.Y)]), _List_fromArray([$author$project$ElmFramework$Lib$Geocoding$reverseRequestInfoParameter(req.af)]), A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Lib$Geocoding$singleton, $elm$core$Tuple$pair('language')), req.ac)), A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Lib$Geocoding$singleton, $elm$core$Tuple$pair('result_type')), $elm$core$String$join('|')), $elm$core$List$map($author$project$ElmFramework$Lib$Geocoding$componentTypeToString)), req.eB)), A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Lib$Geocoding$singleton, $elm$core$Tuple$pair('location_type')), $elm$core$String$join('|')), $elm$core$List$map($author$project$ElmFramework$Lib$Geocoding$locationTypeToString)), req.cX))]));
  };
  var $author$project$ElmFramework$Lib$Geocoding$replace = F2(function (old, _new) {
    return A2($elm$core$Basics$composeR, $elm$core$String$split(old), $elm$core$String$join(_new));
  });
  var $author$project$ElmFramework$Lib$Geocoding$queryEscape = A2($elm$core$Basics$composeR, $elm$url$Url$percentEncode, A2($author$project$ElmFramework$Lib$Geocoding$replace, '%20', '+'));
  var $author$project$ElmFramework$Lib$Geocoding$queryPair = function (_v0) {
    var key = _v0.a;
    var value = _v0.b;
    return $author$project$ElmFramework$Lib$Geocoding$queryEscape(key) + ('=' + $author$project$ElmFramework$Lib$Geocoding$queryEscape(value));
  };
  var $author$project$ElmFramework$Lib$Geocoding$joinUrlEncoded = function (args) {
    return A2($elm$core$String$join, '&', A2($elm$core$List$map, $author$project$ElmFramework$Lib$Geocoding$queryPair, args));
  };
  var $author$project$ElmFramework$Lib$Geocoding$url = F2(function (base, params) {
    return $elm$core$List$isEmpty(params) ? base : base + ('?' + $author$project$ElmFramework$Lib$Geocoding$joinUrlEncoded(params));
  });
  var $author$project$ElmFramework$Lib$Geocoding$reverseRequestUrl = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Lib$Geocoding$url($author$project$ElmFramework$Lib$Geocoding$geocodingUrl), $author$project$ElmFramework$Lib$Geocoding$toReverseRequestParameters);
  var $author$project$ElmFramework$Lib$Geocoding$sendReverseRequest = F2(function (toMessage, req) {
    return $elm$http$Http$get({
      nv: A2($elm$http$Http$expectJson, toMessage, $author$project$ElmFramework$Lib$Geocoding$responseDecoder),
      eZ: $author$project$ElmFramework$Lib$Geocoding$reverseRequestUrl(req)
    });
  });
  var $author$project$Ui$ProvideLocation$Update$update = F3(function (msg, state, global) {
    switch (msg.$) {
      case 0:
        var input = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          gW: input,
          xO: $elm$core$String$isEmpty(input) ? $author$project$Ui$ProvideLocation$Model$LocationSearchComplete(_List_Nil) : $author$project$Ui$ProvideLocation$Model$LocationSearchStarted(input)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 1:
        var input = msg.a;
        return _Utils_Tuple3(state, $author$project$ElmFramework$Feature$Places$Places$getPlacePredictions(input), _List_Nil);
      case 2:
        var input = msg.a.t;
        var maybePlacePredictions = msg.a.pe;
        var autocompleteResults = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$map(function (_v1) {
          var placeId = _v1.qu;
          var placeDescription = _v1.qt;
          var types = _v1.sF;
          var isEstablishment = function () {
            var findEstablishment = A2($elm_community$list_extra$List$Extra$find, function (placeType) {
              return placeType === 'establishment';
            }, types);
            return !_Utils_eq(findEstablishment, $elm$core$Maybe$Nothing);
          }();
          var _v2 = function () {
            var placeDescriptionList = A2($elm$core$String$split, ', ', placeDescription);
            var splitAt = isEstablishment ? 1 : $elm$core$List$length(placeDescriptionList) / 2 | 0;
            return _Utils_Tuple2(A2($elm$core$String$join, ', ', A2($elm$core$List$take, splitAt, placeDescriptionList)), A2($elm$core$String$join, ', ', A2($elm$core$List$drop, splitAt, placeDescriptionList)));
          }();
          var title = _v2.a;
          var subtitle = _v2.b;
          return {
            qu: placeId,
            lb: subtitle,
            lh: title
          };
        }), maybePlacePredictions));
        return _Utils_Tuple3(_Utils_update(state, {
          xO: $author$project$Ui$ProvideLocation$Model$LocationSearchComplete(autocompleteResults)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 5:
        var route = msg.a;
        return _Utils_eq(route, $author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$ProvideLocation(1))) || _Utils_eq(route, $author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$Personal($elm$core$Maybe$Just(1)))) ? _Utils_Tuple3(_Utils_update(state, {
          gW: '',
          xO: $author$project$Ui$ProvideLocation$Model$LocationSearchComplete(_List_Nil)
        }), $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      case 3:
        var updateContext = msg.a;
        var title = msg.b.lh;
        var subtitle = msg.b.lb;
        var placeId = msg.b.qu;
        var geocodingCmd = A2($author$project$ElmFramework$Lib$Geocoding$sendReverseRequest, A2($author$project$Ui$ProvideLocation$Msg$ReceivedAddressGeocoding, updateContext, _Utils_Tuple2(title, subtitle)), A2($author$project$ElmFramework$Lib$Geocoding$reverseRequestForPlaceId, global.ar.wf.Y, placeId));
        return _Utils_Tuple3(_Utils_update(state, {
          iz: true
        }), geocodingCmd, _List_Nil);
      default:
        var context = msg.a;
        var _v3 = msg.b;
        var title = _v3.a;
        var subtitle = _v3.b;
        var geocodingResponse = msg.c;
        var newState = _Utils_update(state, {
          iz: false
        });
        if (!geocodingResponse.$) {
          var results = geocodingResponse.a.Bc;
          var status = geocodingResponse.a.Cd;
          var maybeNewResult = A2($elm$core$Maybe$map, function (geocodingResult) {
            return _Utils_Tuple2({
              oV: geocodingResult.wn.iT.fU,
              o_: geocodingResult.wn.iT.fX
            }, {
              lb: subtitle,
              lh: title
            });
          }, $elm$core$List$head(results));
          var updateContextMsgOrGeocodingError = function () {
            if (!maybeNewResult.$) {
              var newResult = maybeNewResult.a;
              return $elm$core$List$singleton(function () {
                if (!context) {
                  return $author$project$TopMsg$msgEditingUserProfile($author$project$Types$EditingUserProfile$LocationSet($elm$core$Maybe$Just(A2($elm$core$Tuple$mapFirst, $author$project$Types$GeoLocation$geoLocationFromAutocomplete, newResult))));
                } else {
                  return $author$project$TopMsg$msgSingleCreateOrEditSearch($author$project$Ui$CreateOrEditSearch$Msg$LocationSet($elm$core$Maybe$Just(newResult)));
                }
              }());
            } else {
              return _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Error in geocoding. Please try more specific or more general address.', _List_Nil)]);
            }
          }();
          return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _Utils_ap(_List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]), updateContextMsgOrGeocodingError));
        } else {
          var err = geocodingResponse.a;
          return _Utils_Tuple3(newState, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportHttpErr(err), _List_Nil);
        }
    }
  });
  var $author$project$Remote$RequestMsg$GetSupportReasons = {
    $: 14
  };
  var $author$project$Remote$RequestMsg$RequestSupport = F2(function (a, b) {
    return {
      $: 29,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Support$Update$update = F3(function (msg, state, currRoute) {
    var onRouteOrAuth = function () {
      if (_Utils_eq(currRoute, $author$project$Route$Route$Support)) {
        var getSupportReasons = !$krisajenkins$remotedata$RemoteData$isSuccess(state.sf) ? _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetSupportReasons)]) : _List_Nil;
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, getSupportReasons);
      } else {
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
      }
    }();
    switch (msg.$) {
      case 0:
        return onRouteOrAuth;
      case 1:
        return onRouteOrAuth;
      case 2:
        var maybeReason = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          qv: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
            return $.vn;
          }, function ($) {
            return $.mx;
          }), maybeReason)),
          sd: maybeReason
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 3:
        var comment = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          mw: comment
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      case 4:
        var request = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function (supportReason) {
          return _List_fromArray([$author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$RequestSupport, state.mw, supportReason.xu))]);
        }, state.sd));
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, request);
      case 5:
        var supportReasons = msg.a;
        return _Utils_Tuple3(_Utils_update(state, {
          sf: $krisajenkins$remotedata$RemoteData$succeed(supportReasons)
        }), $elm$core$Platform$Cmd$none, _List_Nil);
      default:
        return _Utils_Tuple3(_Utils_update(state, {
          oL: !state.oL
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Remote$ResponseMsg$CancelMatch = F2(function (a, b) {
    return {
      $: 18,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$CancelSearch = F2(function (a, b) {
    return {
      $: 19,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$ConfirmCredentialsForChangePassword = F2(function (a, b) {
    return {
      $: 10,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$CreateNewPasswordFromForgotPassword = function (a) {
    return {
      $: 9,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$CreatePaymentIntentForMatch = F2(function (a, b) {
    return {
      $: 41,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$CreateSearch = F2(function (a, b) {
    return {
      $: 20,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$CreateUser = F3(function (a, b, c) {
    return {
      $: 38,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$DisableUser = function (a) {
    return {
      $: 39,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$EditSearch = function (a) {
    return {
      $: 21,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$ForgotPassword = F2(function (a, b) {
    return {
      $: 5,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$GetCancelMatchReasons = function (a) {
    return {
      $: 17,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$GetMatch = function (a) {
    return {
      $: 27,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$GetMeUserData = function (a) {
    return {
      $: 36,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$GetSearch = function (a) {
    return {
      $: 24,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$GetSearchInvite = function (a) {
    return {
      $: 25,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$GetSupportReasons = function (a) {
    return {
      $: 14,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$GetUnreadNotifications = function (a) {
    return {
      $: 31,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$GetUserInfoPublic = F2(function (a, b) {
    return {
      $: 15,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$InitializeUserSessionStatus = F3(function (a, b, c) {
    return {
      $: 6,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$JoinMatch = F2(function (a, b) {
    return {
      $: 16,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$ListStripePaymentMethodSetupIntents = function (a) {
    return {
      $: 44,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$RefreshToken = function (a) {
    return {
      $: 45,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$RegisterNewUser = F3(function (a, b, c) {
    return {
      $: 1,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$RemoveStripePaymentMethod = F2(function (a, b) {
    return {
      $: 43,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$RequestSupport = function (a) {
    return {
      $: 29,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$ResendEmailVerificationCode = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$RespondSearchInvite = F3(function (a, b, c) {
    return {
      $: 26,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$ReverseGeocoding = F3(function (a, b, c) {
    return {
      $: 46,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$SaveStripePaymentMethod = function (a) {
    return {
      $: 42,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$SearchContacts = function (a) {
    return {
      $: 47,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$SearchPricing = function (a) {
    return {
      $: 23,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$SendEmailVerificationCode = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$SignIn = F3(function (a, b, c) {
    return {
      $: 4,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$SubmitChangePassword = function (a) {
    return {
      $: 11,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$SubmitFeedback = F2(function (a, b) {
    return {
      $: 28,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$SubmitMatchRating = F2(function (a, b) {
    return {
      $: 22,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$TestNotification = function (a) {
    return {
      $: 34,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$UpdateActivities = function (a) {
    return {
      $: 12,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$UpdateNotificationSettings = F2(function (a, b) {
    return {
      $: 30,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$UpdateNotificationsReadStatus = function (a) {
    return {
      $: 32,
      a: a
    };
  };
  var $author$project$Remote$ResponseMsg$UpdatePaymentPreferences = F2(function (a, b) {
    return {
      $: 13,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$UpdatePushDevices = F2(function (a, b) {
    return {
      $: 35,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$UpdateTappedNotificationStatusAndRoute = F2(function (a, b) {
    return {
      $: 33,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$UpdateUser = F3(function (a, b, c) {
    return {
      $: 37,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Remote$ResponseMsg$VerifyEmailOobCode = F2(function (a, b) {
    return {
      $: 7,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$ResponseMsg$VerifyResetPasswordCode = function (a) {
    return {
      $: 8,
      a: a
    };
  };
  var $author$project$Api$GraphqlSchema$Enum$CancelMatchReason$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'CANNOT_MAKE_IT';
      case 1:
        return 'VENUE_UNACCEPTABLE';
      case 2:
        return 'PLAYERS_CONCERN';
      case 3:
        return 'XRIVALS_EXPECTATION_MISMATCH';
      default:
        return 'OTHER_PERSONAL_REASONS';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeCancelMatchInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('matchId', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.br))), _Utils_Tuple2('reason', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$CancelMatchReason$toString, input____.qV)))]));
  };
  var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required = F3(function (fieldName, raw, encode) {
    return A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument, fieldName, encode(raw));
  });
  var $author$project$Api$GraphqlSchema$Object$MatchMutation$cancel = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'cancel', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeCancelMatchInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Union$CancelMatchPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CancelHistoricalMatchInvalid', selections____.yS), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CancelMatchSuccess', selections____.yT), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'MatchNotFoundError', selections____.f5), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotInMatch', selections____.zZ)]));
  };
  var $author$project$Api$GraphqlSchema$Mutation$match = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'match', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$CancelHistoricalMatchInvalid$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$MatchNotFoundError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$UserNotInMatch$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $dillonkearns$elm_graphql$Graphql$Http$Mutation = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $dillonkearns$elm_graphql$Graphql$Http$mutationRequest = F2(function (baseUrl, mutationSelectionSet) {
    return {
      dH: baseUrl,
      vp: $dillonkearns$elm_graphql$Graphql$Http$Mutation(mutationSelectionSet),
      nv: $dillonkearns$elm_graphql$Graphql$Document$decoder(mutationSelectionSet),
      wx: _List_Nil,
      c2: $elm$core$Maybe$Nothing,
      ex: _List_Nil,
      lf: $elm$core$Maybe$Nothing,
      cv: false
    };
  });
  var $author$project$Api$Api$mutationRequestTask = A2($author$project$Api$Api$requestTask, $elm$core$Maybe$Nothing, $dillonkearns$elm_graphql$Graphql$Http$mutationRequest);
  var $author$project$Api$GraphqlSchema$Object$CancelMatchSuccess$refund = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'refund', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Types$Refund$Failure = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Types$Refund$NoRefundDue = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Types$Refund$Success = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Api$GraphqlSchema$Union$RefundResult$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'FailureNoPayments', selections____.jo), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NoRefundDue', selections____.jA), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Scheduled', selections____.jN)]));
  };
  var $author$project$Api$GraphqlSchema$Object$FailureNoPayments$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$NoRefundDue$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Scheduled$refund = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'refund', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Types$Refund$Refund = F5(function (createdAt, onTotalCharge, percent, reason, updatedTotalCharge) {
    return {
      uV: createdAt,
      zR: onTotalCharge,
      An: percent,
      qV: reason,
      C6: updatedTotalCharge
    };
  });
  var $author$project$Api$GraphqlSchema$Object$Refund$createdAt = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Instant', 'createdAt', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).up.fu);
  var $author$project$Api$GraphqlSchema$Object$Refund$onTotalCharge = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Money', 'onTotalCharge', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).us.fu);
  var $author$project$Api$GraphqlSchema$Object$Refund$percent = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'percent', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Object$Refund$reason = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'reason', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$Refund$updatedTotalCharge = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Money', 'updatedTotalCharge', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).us.fu);
  var $author$project$Api$Schema$refund = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Refund$updatedTotalCharge, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Refund$reason, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Refund$percent, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Refund$onTotalCharge, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$Refund$createdAt, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Refund$Refund))))));
  var $author$project$Api$Schema$refundResult = $author$project$Api$GraphqlSchema$Union$RefundResult$fragments({
    jo: A2($author$project$Api$Schema$mapField, $author$project$Types$Refund$Failure, $author$project$Api$GraphqlSchema$Object$FailureNoPayments$message),
    jA: A2($author$project$Api$Schema$mapField, $author$project$Types$Refund$NoRefundDue, $author$project$Api$GraphqlSchema$Object$NoRefundDue$message),
    jN: A2($author$project$Api$Schema$mapField, $author$project$Types$Refund$Success, $author$project$Api$GraphqlSchema$Object$Scheduled$refund($author$project$Api$Schema$refund))
  });
  var $author$project$Api$Api$cancelMatch = F5(function (_v0, reason, apiEndpoint, tag, idToken) {
    var matchId = _v0;
    var payload = $author$project$Api$GraphqlSchema$Union$CancelMatchPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      yS: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$CancelHistoricalMatchInvalid$message),
      yT: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$GraphqlSchema$Object$CancelMatchSuccess$refund($author$project$Api$Schema$refundResult)),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      f5: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$MatchNotFoundError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message),
      zZ: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotInMatch$message)
    });
    var input = {
      br: matchId,
      qV: reason
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$match(A2($author$project$Api$GraphqlSchema$Object$MatchMutation$cancel, {
      t: input
    }, payload))));
  });
  var $author$project$Api$GraphqlSchema$InputObject$encodeCancelSearchInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('searchId', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.by)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$SearchMutation$cancel = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'cancel', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeCancelSearchInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Union$CancelSearchPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ActiveSearchNotFoundError', selections____.yO), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CancelSearchSuccess', selections____.yU), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericSuccess', selections____.T), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k)]));
  };
  var $author$project$Api$GraphqlSchema$Object$ActiveSearchNotFoundError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$CancelSearchSuccess$paymentIntentCanceled = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'paymentIntentCanceled', _List_Nil, $elm$json$Json$Decode$bool);
  var $author$project$Api$GraphqlSchema$Mutation$search = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'search', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$Api$cancelSearch = F4(function (_v0, apiEndpoint, tag, idToken) {
    var searchId = _v0;
    var payload = $author$project$Api$GraphqlSchema$Union$CancelSearchPayload$fragments({
      yO: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ActiveSearchNotFoundError$message),
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      yU: A2($author$project$Api$Schema$mapField, $elm$core$Basics$always($elm$core$Result$Ok(0)), $author$project$Api$GraphqlSchema$Object$CancelSearchSuccess$paymentIntentCanceled),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      T: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message)
    });
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$search(A2($author$project$Api$GraphqlSchema$Object$SearchMutation$cancel, {
      t: {
        by: searchId
      }
    }, payload))));
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$ChangeUserPasswordOutput = F5(function (userId, email, idToken, refreshToken, expiresIn) {
    return {
      bZ: email,
      v3: expiresIn,
      oe: idToken,
      qW: refreshToken,
      e_: userId
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$UpdateUserProfile = 10;
  var $author$project$ElmFramework$Lib$Firebase$Auth$ErrorBody = F2(function (statusCode, errorMessage) {
    return {
      nm: errorMessage,
      Ce: statusCode
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$ADMIN_ONLY_OPERATION = {
    $: 0
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$BLOCKING_FUNCTION_ERROR_RESPONSE = {
    $: 68
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$CAPTCHA_CHECK_FAILED = {
    $: 1
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$CORS_UNSUPPORTED = {
    $: 2
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$CREDENTIAL_MISMATCH = {
    $: 3
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$CREDENTIAL_TOO_OLD_LOGIN_AGAIN = {
    $: 4
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$DYNAMIC_LINK_NOT_ACTIVATED = {
    $: 5
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$EMAIL_CHANGE_NEEDS_VERIFICATION = {
    $: 6
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$EMAIL_EXISTS = {
    $: 7
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$EMAIL_NOT_FOUND = {
    $: 8
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$EXPIRED_OOB_CODE = {
    $: 9
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$FEDERATED_USER_ID_ALREADY_LINKED = {
    $: 10
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_APP_CREDENTIAL = {
    $: 11
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_APP_ID = {
    $: 12
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CERT_HASH = {
    $: 13
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CODE = {
    $: 14
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CONTINUE_URI = {
    $: 15
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CUSTOM_TOKEN = {
    $: 16
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_DYNAMIC_LINK_DOMAIN = {
    $: 17
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_EMAIL = {
    $: 18
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_IDENTIFIER = {
    $: 21
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_IDP_RESPONSE = {
    $: 20
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_ID_TOKEN = {
    $: 19
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_MESSAGE_PAYLOAD = {
    $: 22
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_MFA_PENDING_CREDENTIAL = {
    $: 23
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_OAUTH_CLIENT_ID = {
    $: 24
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_OOB_CODE = {
    $: 25
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PASSWORD = {
    $: 26
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PENDING_TOKEN = {
    $: 27
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PHONE_NUMBER = {
    $: 28
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PROVIDER_ID = {
    $: 29
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_RECIPIENT_EMAIL = {
    $: 30
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_SENDER = {
    $: 31
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_SESSION_INFO = {
    $: 32
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_TEMPORARY_PROOF = {
    $: 33
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_TENANT_ID = {
    $: 34
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MFA_ENROLLMENT_NOT_FOUND = {
    $: 35
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_ANDROID_PACKAGE_NAME = {
    $: 36
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_APP_CREDENTIAL = {
    $: 37
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_CODE = {
    $: 38
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_CONTINUE_URI = {
    $: 39
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_CUSTOM_TOKEN = {
    $: 40
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_IOS_BUNDLE_ID = {
    $: 41
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_MFA_ENROLLMENT_ID = {
    $: 42
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_MFA_PENDING_CREDENTIAL = {
    $: 43
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_OOB_CODE = {
    $: 44
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_OR_INVALID_NONCE = {
    $: 45
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_PASSWORD = {
    $: 46
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_PHONE_NUMBER = {
    $: 47
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_SESSION_INFO = {
    $: 48
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$OPERATION_NOT_ALLOWED = {
    $: 49
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$PASSWORD_LOGIN_DISABLED = {
    $: 50
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$QUOTA_EXCEEDED = {
    $: 51
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$REJECTED_CREDENTIAL = {
    $: 53
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$RESET_PASSWORD_EXCEED_LIMIT = {
    $: 52
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$SECOND_FACTOR_EXISTS = {
    $: 54
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$SECOND_FACTOR_LIMIT_EXCEEDED = {
    $: 55
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$SESSION_EXPIRED = {
    $: 56
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$TENANT_ID_MISMATCH = {
    $: 57
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$TOKEN_EXPIRED = {
    $: 58
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$TOO_MANY_ATTEMPTS_TRY_LATER = {
    $: 59
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$UNAUTHORIZED_DOMAIN = {
    $: 63
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$UNKNOWN_ERROR = function (a) {
    return {
      $: 69,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$UNSUPPORTED_FIRST_FACTOR = {
    $: 60
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$UNSUPPORTED_TENANT_OPERATION = {
    $: 61
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$UNVERIFIED_EMAIL = {
    $: 62
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$USER_CANCELLED = {
    $: 64
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$USER_DISABLED = {
    $: 65
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$USER_NOT_FOUND = {
    $: 66
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$WEAK_PASSWORD = {
    $: 67
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$decodeErrorCode = function (errorCode) {
    switch (errorCode) {
      case 'ADMIN_ONLY_OPERATION':
        return $author$project$ElmFramework$Lib$Firebase$Auth$ADMIN_ONLY_OPERATION;
      case 'CAPTCHA_CHECK_FAILED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$CAPTCHA_CHECK_FAILED;
      case 'CORS_UNSUPPORTED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$CORS_UNSUPPORTED;
      case 'CREDENTIAL_MISMATCH':
        return $author$project$ElmFramework$Lib$Firebase$Auth$CREDENTIAL_MISMATCH;
      case 'CREDENTIAL_TOO_OLD_LOGIN_AGAIN':
        return $author$project$ElmFramework$Lib$Firebase$Auth$CREDENTIAL_TOO_OLD_LOGIN_AGAIN;
      case 'DYNAMIC_LINK_NOT_ACTIVATED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$DYNAMIC_LINK_NOT_ACTIVATED;
      case 'EMAIL_CHANGE_NEEDS_VERIFICATION':
        return $author$project$ElmFramework$Lib$Firebase$Auth$EMAIL_CHANGE_NEEDS_VERIFICATION;
      case 'EMAIL_EXISTS':
        return $author$project$ElmFramework$Lib$Firebase$Auth$EMAIL_EXISTS;
      case 'EMAIL_NOT_FOUND':
        return $author$project$ElmFramework$Lib$Firebase$Auth$EMAIL_NOT_FOUND;
      case 'EXPIRED_OOB_CODE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$EXPIRED_OOB_CODE;
      case 'FEDERATED_USER_ID_ALREADY_LINKED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$FEDERATED_USER_ID_ALREADY_LINKED;
      case 'INVALID_APP_CREDENTIAL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_APP_CREDENTIAL;
      case 'INVALID_APP_ID':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_APP_ID;
      case 'INVALID_CERT_HASH':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CERT_HASH;
      case 'INVALID_CODE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CODE;
      case 'INVALID_CONTINUE_URI':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CONTINUE_URI;
      case 'INVALID_CUSTOM_TOKEN':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_CUSTOM_TOKEN;
      case 'INVALID_DYNAMIC_LINK_DOMAIN':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_DYNAMIC_LINK_DOMAIN;
      case 'INVALID_EMAIL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_EMAIL;
      case 'INVALID_ID_TOKEN':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_ID_TOKEN;
      case 'INVALID_IDP_RESPONSE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_IDP_RESPONSE;
      case 'INVALID_IDENTIFIER':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_IDENTIFIER;
      case 'INVALID_MESSAGE_PAYLOAD':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_MESSAGE_PAYLOAD;
      case 'INVALID_MFA_PENDING_CREDENTIAL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_MFA_PENDING_CREDENTIAL;
      case 'INVALID_OAUTH_CLIENT_ID':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_OAUTH_CLIENT_ID;
      case 'INVALID_OOB_CODE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_OOB_CODE;
      case 'INVALID_PASSWORD':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PASSWORD;
      case 'INVALID_PENDING_TOKEN':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PENDING_TOKEN;
      case 'INVALID_PHONE_NUMBER':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PHONE_NUMBER;
      case 'INVALID_PROVIDER_ID':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_PROVIDER_ID;
      case 'INVALID_RECIPIENT_EMAIL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_RECIPIENT_EMAIL;
      case 'INVALID_SENDER':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_SENDER;
      case 'INVALID_SESSION_INFO':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_SESSION_INFO;
      case 'INVALID_TEMPORARY_PROOF':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_TEMPORARY_PROOF;
      case 'INVALID_TENANT_ID':
        return $author$project$ElmFramework$Lib$Firebase$Auth$INVALID_TENANT_ID;
      case 'MFA_ENROLLMENT_NOT_FOUND':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MFA_ENROLLMENT_NOT_FOUND;
      case 'MISSING_ANDROID_PACKAGE_NAME':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_ANDROID_PACKAGE_NAME;
      case 'MISSING_APP_CREDENTIAL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_APP_CREDENTIAL;
      case 'MISSING_CODE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_CODE;
      case 'MISSING_CONTINUE_URI':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_CONTINUE_URI;
      case 'MISSING_CUSTOM_TOKEN':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_CUSTOM_TOKEN;
      case 'MISSING_IOS_BUNDLE_ID':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_IOS_BUNDLE_ID;
      case 'MISSING_MFA_ENROLLMENT_ID':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_MFA_ENROLLMENT_ID;
      case 'MISSING_MFA_PENDING_CREDENTIAL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_MFA_PENDING_CREDENTIAL;
      case 'MISSING_OOB_CODE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_OOB_CODE;
      case 'MISSING_OR_INVALID_NONCE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_OR_INVALID_NONCE;
      case 'MISSING_PASSWORD':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_PASSWORD;
      case 'MISSING_PHONE_NUMBER':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_PHONE_NUMBER;
      case 'MISSING_SESSION_INFO':
        return $author$project$ElmFramework$Lib$Firebase$Auth$MISSING_SESSION_INFO;
      case 'OPERATION_NOT_ALLOWED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$OPERATION_NOT_ALLOWED;
      case 'PASSWORD_LOGIN_DISABLED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$PASSWORD_LOGIN_DISABLED;
      case 'QUOTA_EXCEEDED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$QUOTA_EXCEEDED;
      case 'RESET_PASSWORD_EXCEED_LIMIT':
        return $author$project$ElmFramework$Lib$Firebase$Auth$RESET_PASSWORD_EXCEED_LIMIT;
      case 'REJECTED_CREDENTIAL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$REJECTED_CREDENTIAL;
      case 'SECOND_FACTOR_EXISTS':
        return $author$project$ElmFramework$Lib$Firebase$Auth$SECOND_FACTOR_EXISTS;
      case 'SECOND_FACTOR_LIMIT_EXCEEDED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$SECOND_FACTOR_LIMIT_EXCEEDED;
      case 'SESSION_EXPIRED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$SESSION_EXPIRED;
      case 'TENANT_ID_MISMATCH':
        return $author$project$ElmFramework$Lib$Firebase$Auth$TENANT_ID_MISMATCH;
      case 'TOKEN_EXPIRED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$TOKEN_EXPIRED;
      case 'TOO_MANY_ATTEMPTS_TRY_LATER':
        return $author$project$ElmFramework$Lib$Firebase$Auth$TOO_MANY_ATTEMPTS_TRY_LATER;
      case 'UNSUPPORTED_FIRST_FACTOR':
        return $author$project$ElmFramework$Lib$Firebase$Auth$UNSUPPORTED_FIRST_FACTOR;
      case 'UNSUPPORTED_TENANT_OPERATION':
        return $author$project$ElmFramework$Lib$Firebase$Auth$UNSUPPORTED_TENANT_OPERATION;
      case 'UNVERIFIED_EMAIL':
        return $author$project$ElmFramework$Lib$Firebase$Auth$UNVERIFIED_EMAIL;
      case 'UNAUTHORIZED_DOMAIN':
        return $author$project$ElmFramework$Lib$Firebase$Auth$UNAUTHORIZED_DOMAIN;
      case 'USER_CANCELLED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$USER_CANCELLED;
      case 'USER_DISABLED':
        return $author$project$ElmFramework$Lib$Firebase$Auth$USER_DISABLED;
      case 'USER_NOT_FOUND':
        return $author$project$ElmFramework$Lib$Firebase$Auth$USER_NOT_FOUND;
      case 'WEAK_PASSWORD':
        return $author$project$ElmFramework$Lib$Firebase$Auth$WEAK_PASSWORD;
      case 'BLOCKING_FUNCTION_ERROR_RESPONSE':
        return $author$project$ElmFramework$Lib$Firebase$Auth$BLOCKING_FUNCTION_ERROR_RESPONSE;
      default:
        return $author$project$ElmFramework$Lib$Firebase$Auth$UNKNOWN_ERROR(errorCode);
    }
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$getErrorMessage = function (errorCode) {
    switch (errorCode.$) {
      case 0:
        return 'Admin only operation';
      case 1:
        return 'Captcha check failed';
      case 2:
        return 'Cors unsupported';
      case 3:
        return 'Credential mismatch';
      case 4:
        return 'Credential too old login again';
      case 5:
        return 'Dynamic link not activated';
      case 6:
        return 'Email change needs verification';
      case 7:
        return 'Email already exists. Please try signing in.';
      case 8:
        return 'Email not found. Please try registering.';
      case 9:
        return 'Expired oob code';
      case 10:
        return 'Federated user id already linked';
      case 11:
        return 'Invalid app credential';
      case 12:
        return 'Invalid app id';
      case 13:
        return 'Invalid cert hash';
      case 14:
        return 'Invalid code';
      case 15:
        return 'Invalid continue uri';
      case 16:
        return 'Invalid custom token';
      case 17:
        return 'Invalid dynamic link domain';
      case 18:
        return 'Invalid email';
      case 19:
        return 'Invalid id token';
      case 20:
        return 'Invalid idp response';
      case 21:
        return 'Invalid identifier';
      case 22:
        return 'Invalid message payload';
      case 23:
        return 'Invalid mfa pending credential';
      case 24:
        return 'Invalid oauth client id';
      case 25:
        return 'Invalid oob code';
      case 26:
        return 'Invalid password';
      case 27:
        return 'Invalid pending token';
      case 28:
        return 'Invalid phone number';
      case 29:
        return 'Invalid provider id';
      case 30:
        return 'Invalid recipient email';
      case 31:
        return 'Invalid sender';
      case 32:
        return 'Invalid session info';
      case 33:
        return 'Invalid temporary proof';
      case 34:
        return 'Invalid tenant id';
      case 35:
        return 'Mfa enrollment not found';
      case 36:
        return 'Missing android package name';
      case 37:
        return 'Missing app credential';
      case 38:
        return 'Missing code';
      case 39:
        return 'Missing continue uri';
      case 40:
        return 'Missing custom token';
      case 41:
        return 'Missing ios bundle id';
      case 42:
        return 'Missing mfa enrollment id';
      case 43:
        return 'Missing mfa pending credential';
      case 44:
        return 'Missing oob code';
      case 45:
        return 'Missing or invalid nonce';
      case 46:
        return 'Missing password';
      case 47:
        return 'Missing phone number';
      case 48:
        return 'Missing session info';
      case 49:
        return 'Operation not allowed';
      case 50:
        return 'Password login disabled';
      case 51:
        return 'Quota exceeded';
      case 52:
        return 'Reset password exceed limit';
      case 53:
        return 'Rejected credential';
      case 54:
        return 'Second factor exists';
      case 55:
        return 'Second factor limit exceeded';
      case 56:
        return 'Session expired';
      case 57:
        return 'Tenant id mismatch';
      case 58:
        return 'Token expired';
      case 59:
        return 'Too many attempts try later';
      case 60:
        return 'Unsupported first factor';
      case 61:
        return 'Unsupported tenant operation';
      case 62:
        return 'Unverified email';
      case 63:
        return 'Unauthorized domain';
      case 64:
        return 'User cancelled';
      case 65:
        return 'User disabled';
      case 66:
        return 'User not found';
      case 67:
        return 'Weak password';
      case 69:
        var error = errorCode.a;
        return error;
      default:
        return 'Our systems are taking longer than usual. Please try again.';
    }
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$parseFullErrorMessage = function (error) {
    if (error === 'Error code: 47') {
      return 'There was an error while signing you in. Please try again later or contact support.';
    } else {
      return error;
    }
  };
  var $elm$core$String$words = _String_words;
  var $author$project$ElmFramework$Lib$Firebase$Auth$parseError = function (fullError) {
    var words = $elm$core$String$words(fullError);
    var maybeAdditionalInfo = function (maybeSecondWord) {
      if (!maybeSecondWord.$) {
        var secondWord = maybeSecondWord.a;
        return secondWord === ':' ? $elm$core$Maybe$Just(A2($elm$core$String$join, ' ', A2($elm$core$List$drop, 2, words))) : $elm$core$Maybe$Nothing;
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }($elm$core$List$head(A2($elm$core$List$drop, 1, words)));
    var errorCode = A2($elm$core$Maybe$withDefault, '', $elm$core$List$head(words));
    if (!maybeAdditionalInfo.$) {
      var errorText = maybeAdditionalInfo.a;
      return errorText;
    } else {
      var _v1 = $author$project$ElmFramework$Lib$Firebase$Auth$decodeErrorCode(errorCode);
      if (_v1.$ === 69) {
        return $author$project$ElmFramework$Lib$Firebase$Auth$parseFullErrorMessage(fullError);
      } else {
        return $author$project$ElmFramework$Lib$Firebase$Auth$getErrorMessage($author$project$ElmFramework$Lib$Firebase$Auth$decodeErrorCode(errorCode));
      }
    }
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$handleJsonResponse = F2(function (decoder, response) {
    switch (response.$) {
      case 0:
        var url = response.a;
        return $elm$core$Result$Err('Bad url: ' + url);
      case 1:
        return $elm$core$Result$Err('Timeout');
      case 3:
        var statusCode = response.a.Ce;
        var body = response.b;
        var errorBodyMessage = function (errorBodyDecodedResult) {
          if (!errorBodyDecodedResult.$) {
            var errorMessage = errorBodyDecodedResult.a.nm;
            return errorMessage;
          } else {
            return 'Unknown error, bad status: ' + $elm$core$String$fromInt(statusCode);
          }
        };
        var errorBodyDecoder = A2($elm$json$Json$Decode$field, 'error', A3($elm$json$Json$Decode$map2, $author$project$ElmFramework$Lib$Firebase$Auth$ErrorBody, A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$map, $author$project$ElmFramework$Lib$Firebase$Auth$parseError, A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string))));
        var errorBodyString = errorBodyMessage(A2($elm$json$Json$Decode$decodeString, errorBodyDecoder, body));
        return $elm$core$Result$Err(errorBodyString);
      case 2:
        return $elm$core$Result$Err('Network error');
      default:
        var body = response.b;
        var _v2 = A2($elm$json$Json$Decode$decodeString, decoder, body);
        if (_v2.$ === 1) {
          return $elm$core$Result$Err('Failed to decode server\'s json response');
        } else {
          var decodedResponse = _v2.a;
          return $elm$core$Result$Ok(decodedResponse);
        }
    }
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$createHttpJsonResolver = function (decoder) {
    return $elm$http$Http$stringResolver($author$project$ElmFramework$Lib$Firebase$Auth$handleJsonResponse(decoder));
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask = F3(function (url, requestEncoder, responseDecoder) {
    return $elm$http$Http$task({
      aU: $elm$http$Http$jsonBody(requestEncoder),
      wx: _List_Nil,
      em: 'POST',
      A4: $author$project$ElmFramework$Lib$Firebase$Auth$createHttpJsonResolver(responseDecoder),
      lf: $elm$core$Maybe$Nothing,
      eZ: url
    });
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl = F2(function (apiKey, action) {
    var tokenUrl = 'https://securetoken.googleapis.com/v1';
    var makeTokenUrl = function (actionKey) {
      return tokenUrl + ('/' + actionKey);
    };
    var identityUrl = 'https://identitytoolkit.googleapis.com/v1';
    var makeIdentityUrl = function (actionKey) {
      return identityUrl + ('/' + actionKey);
    };
    var actionUrl = function () {
      switch (action) {
        case 0:
          return makeIdentityUrl('accounts:signUp');
        case 9:
          return makeIdentityUrl('accounts:lookup');
        case 10:
          return makeIdentityUrl('accounts:update');
        case 11:
          return makeIdentityUrl('accounts:update');
        case 12:
          return makeIdentityUrl('accounts:update');
        case 1:
          return makeIdentityUrl('accounts:signInWithPassword');
        case 2:
          return makeIdentityUrl('accounts:sendOobCode');
        case 3:
          return makeIdentityUrl('accounts:update');
        case 4:
          return makeIdentityUrl('accounts:sendOobCode');
        case 5:
          return makeIdentityUrl('accounts:resetPassword');
        case 7:
          return makeIdentityUrl('accounts:resetPassword');
        case 8:
          return makeIdentityUrl('accounts:update');
        case 6:
          return makeIdentityUrl('accounts:resetPassword');
        case 13:
          return makeTokenUrl('token');
        case 14:
          return makeIdentityUrl('accounts:signInWithIdp');
        default:
          return makeIdentityUrl('accounts:signInWithIdp');
      }
    }();
    return actionUrl + ('?key=' + apiKey);
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$decodeIntFromString = function (str) {
    var _v0 = $elm$core$String$toInt(str);
    if (_v0.$ === 1) {
      return $elm$json$Json$Decode$fail('Not an int');
    } else {
      var i = _v0.a;
      return $elm$json$Json$Decode$succeed(i);
    }
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$integerStringDecoder = A2($elm$json$Json$Decode$andThen, $author$project$ElmFramework$Lib$Firebase$Auth$decodeIntFromString, $elm$json$Json$Decode$string);
  var $author$project$ElmFramework$Lib$Firebase$Auth$changeUserPassword = F2(function (apiKey, _v0) {
    var newPassword = _v0.f2;
    var idToken = _v0.oe;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 10);
    var responseDecoder = A6($elm$json$Json$Decode$map5, $author$project$ElmFramework$Lib$Firebase$Auth$ChangeUserPasswordOutput, A2($elm$json$Json$Decode$field, 'localId', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'idToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'refreshToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'expiresIn', $author$project$ElmFramework$Lib$Firebase$Auth$integerStringDecoder));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('idToken', $elm$json$Json$Encode$string(idToken)), _Utils_Tuple2('password', $elm$json$Json$Encode$string(newPassword)), _Utils_Tuple2('returnSecureToken', $elm$json$Json$Encode$bool(true))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$ConfirmEmailVerificationCode = 3;
  var $author$project$ElmFramework$Lib$Firebase$Auth$ConfirmEmailVerificationCodeOutput = F4(function (email, displayName, photoUrl, emailVerified) {
    return {
      cI: displayName,
      bZ: email,
      nd: emailVerified,
      qq: photoUrl
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$confirmEmailVerificationCode = F2(function (apiKey, _v0) {
    var verificationCode = _v0.s$;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 3);
    var responseDecoder = A5($elm$json$Json$Decode$map4, $author$project$ElmFramework$Lib$Firebase$Auth$ConfirmEmailVerificationCodeOutput, A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'displayName', $elm$json$Json$Decode$string)), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'photoUrl', $elm$json$Json$Decode$string)), A2($elm$json$Json$Decode$field, 'emailVerified', $elm$json$Json$Decode$bool));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('oobCode', $elm$json$Json$Encode$string(verificationCode))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$ConfirmPasswordResetCode = 6;
  var $author$project$ElmFramework$Lib$Firebase$Auth$confirmPasswordResetCode = F2(function (apiKey, _v0) {
    var passwordResetCode = _v0.qb;
    var newPassword = _v0.f2;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 6);
    var responseDecoder = $elm$json$Json$Decode$succeed(0);
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('newPassword', $elm$json$Json$Encode$string(newPassword)), _Utils_Tuple2('oobCode', $elm$json$Json$Encode$string(passwordResetCode))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$Types$Search$CreatePaymentIntentGeneralError = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Types$Search$CreatePaymentIntentHoldEmailUnverifiedError = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeCreatePaymentIntentForMatchInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('matchId', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.br))), _Utils_Tuple2('savePaymentMethod', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.BC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool))]));
  };
  var $author$project$Api$GraphqlSchema$Object$MatchMutation$createOrRetrievePaymentIntent = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'createOrRetrievePaymentIntent', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeCreatePaymentIntentForMatchInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Types$Payment$CreatePaymentIntentSuccess = F3(function (amount, currency, intent) {
    return {
      lH: amount,
      mH: currency,
      ot: intent
    };
  });
  var $author$project$Api$GraphqlSchema$Object$CreatePaymentIntentForMatchSuccess$amount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Money', 'amount', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).us.fu);
  var $author$project$Api$GraphqlSchema$Object$CreatePaymentIntentForMatchSuccess$currency = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Currency.Currency', 'currency', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Currency$decoder);
  var $author$project$Api$GraphqlSchema$Object$CreatePaymentIntentForMatchSuccess$intent = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'intent', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Types$Payment$StripeIntent = F3(function (clientSecret, intentId, status) {
    return {
      ul: clientSecret,
      wU: intentId,
      Cd: status
    };
  });
  var $author$project$Api$GraphqlSchema$Object$StripeIntent$clientSecret = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'clientSecret', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$StripeIntent$intentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'intentId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$StripeIntent$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'status', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$stripeIntent = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$StripeIntent$status, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$StripeIntent$intentId, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$StripeIntent$clientSecret, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Payment$StripeIntent))));
  var $author$project$Api$Schema$createPaymentIntentForMatchSuccess = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CreatePaymentIntentForMatchSuccess$intent($author$project$Api$Schema$stripeIntent), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CreatePaymentIntentForMatchSuccess$currency, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CreatePaymentIntentForMatchSuccess$amount, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Payment$CreatePaymentIntentSuccess))));
  var $author$project$Api$GraphqlSchema$Object$CreatePaymentIntentForMatchFailure$error = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'error', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Union$CreatePaymentIntentForMatchPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CreatePaymentIntentForMatchFailure', selections____.y$), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CreatePaymentIntentForMatchSuccess', selections____.y0), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'IdentityUndefinedError', selections____.f4), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'MatchNotFoundError', selections____.f5), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserEmailUnverifiedError', selections____.zW), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Api$GraphqlSchema$Object$IdentityUndefinedError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$UserEmailUnverifiedError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Api$createPaymentIntentForMatch = F5(function (_v0, _v1, apiEndpoint, tag, idToken) {
    var matchId = _v0;
    var shouldSaveCard = _v1.BZ;
    var payload = $author$project$Api$GraphqlSchema$Union$CreatePaymentIntentForMatchPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreatePaymentIntentGeneralError), $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreatePaymentIntentGeneralError), $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      y$: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreatePaymentIntentGeneralError), $author$project$Api$GraphqlSchema$Object$CreatePaymentIntentForMatchFailure$error),
      y0: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$Schema$createPaymentIntentForMatchSuccess),
      h: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreatePaymentIntentGeneralError), $author$project$Api$GraphqlSchema$Object$GenericError$message),
      f4: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreatePaymentIntentGeneralError), $author$project$Api$GraphqlSchema$Object$IdentityUndefinedError$message),
      i: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreatePaymentIntentGeneralError), $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      f5: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreatePaymentIntentGeneralError), $author$project$Api$GraphqlSchema$Object$MatchNotFoundError$message),
      j: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreatePaymentIntentGeneralError), $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreatePaymentIntentGeneralError), $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      zW: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreatePaymentIntentHoldEmailUnverifiedError), $author$project$Api$GraphqlSchema$Object$UserEmailUnverifiedError$message),
      z: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreatePaymentIntentGeneralError), $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    var input = {
      br: matchId,
      BC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(shouldSaveCard)
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$match(A2($author$project$Api$GraphqlSchema$Object$MatchMutation$createOrRetrievePaymentIntent, {
      t: input
    }, payload))));
  });
  var $author$project$Types$Search$CreateSearchDuplicate = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Types$Search$CreateSearchGeneralError = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Types$Search$UnpaidMatchesError = {
    $: 2
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeSearchInviteExternalApiInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('count', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$int(input____.uQ))), _Utils_Tuple2('inviteToken', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.ef)))]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeSearchInviteInternalApiInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('userId', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.e_)))]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeFormattedAddressInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('subtitle', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.lb))), _Utils_Tuple2('title', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.lh)))]));
  };
  var $dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson = function (jsonValue) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(jsonValue);
  };
  var $author$project$Api$GraphqlSchema$Scalar$unwrapEncoder = F2(function (getter, _v0) {
    var unwrappedCodecs = _v0;
    return A2($elm$core$Basics$composeR, getter(unwrappedCodecs).aw, $dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson);
  });
  var $author$project$Api$GraphqlSchema$InputObject$encodeSearchParamsInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('activity', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Activity$toString, input____.du))), _Utils_Tuple2('address', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cy, $author$project$Api$GraphqlSchema$InputObject$encodeFormattedAddressInput)), _Utils_Tuple2('availability', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$list(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.uq;
    }, $author$project$Api$ScalarCodecs$codecs))(input____.tF))), _Utils_Tuple2('location', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.hs;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.iT))), _Utils_Tuple2('timeZone', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dl, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.uu;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('withinDistance', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.mu;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.Dr)))]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeCreateSearchInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('externalInvites', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.v7, $author$project$Api$GraphqlSchema$InputObject$encodeSearchInviteExternalApiInput)), _Utils_Tuple2('internalInvites', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.wW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeSearchInviteInternalApiInput))), _Utils_Tuple2('search', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeSearchParamsInput(input____.kH)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$SearchMutation$create = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'create', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeCreateSearchInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Types$Search$CreateSearchSuccess = F2(function (pricing, search) {
    return {
      AA: pricing,
      kH: search
    };
  });
  var $author$project$Api$GraphqlSchema$Object$CreateSearchSuccess$createdSearch = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'createdSearch', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$CreateSearchSuccess$pricing = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'pricing', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Types$Search$SearchPricing = F2(function (currency, range) {
    return {
      mH: currency,
      AP: range
    };
  });
  var $author$project$Api$GraphqlSchema$Object$PricingEstimate$currency = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Currency.Currency', 'currency', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Currency$decoder);
  var $author$project$Api$GraphqlSchema$Object$PricingEstimate$range = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.MoneyRange', 'range', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).ut.fu);
  var $author$project$Api$Schema$pricingEstimate = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$PricingEstimate$range, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$PricingEstimate$currency, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Search$SearchPricing)));
  var $author$project$Api$Schema$createSearchSuccess = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CreateSearchSuccess$createdSearch($author$project$Api$Schema$search), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CreateSearchSuccess$pricing($author$project$Api$Schema$pricingEstimate), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Search$CreateSearchSuccess)));
  var $author$project$Api$GraphqlSchema$Union$CreateSearchPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CreateSearchSuccess', selections____.y1), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SearchDuplicateError', selections____.zC), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UnpaidMatchesError', selections____.zS), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Types$Search$SearchDuplicateErrorContent = F2(function (searchId, state) {
    return {
      by: searchId,
      aC: state
    };
  });
  var $author$project$Api$GraphqlSchema$Object$SearchDuplicateError$searchId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'searchId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$SearchDuplicateError$state = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.SearchState.SearchState', 'state', _List_Nil, $author$project$Api$GraphqlSchema$Enum$SearchState$decoder);
  var $author$project$Api$Schema$searchDuplicateErrorContent = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SearchDuplicateError$state, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$SearchDuplicateError$searchId, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Search$SearchDuplicateErrorContent)));
  var $author$project$Types$Search$toSearchParamsInput = function (_v0) {
    var activity = _v0.du;
    var availability = _v0.tF;
    var location = _v0.iT;
    var address = _v0.cy;
    var withinDistance = _v0.Dr;
    return {
      du: activity,
      cy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(address),
      tF: availability,
      iT: location,
      dl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      Dr: withinDistance
    };
  };
  var $author$project$Api$GraphqlSchema$Object$UnpaidMatchesError$matchIds = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(List String)', 'matchIds', _List_Nil, $elm$json$Json$Decode$list($elm$json$Json$Decode$string));
  var $author$project$Api$Schema$unpaidMatchesErrorContent = A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$UnpaidMatchesError$matchIds, $elm$core$List$map($elm$core$Basics$identity), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Basics$identity));
  var $author$project$Api$Api$createSearch = F4(function (searchParams, apiEndpoint, tag, idToken) {
    var payload = $author$project$Api$GraphqlSchema$Union$CreateSearchPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreateSearchGeneralError), $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreateSearchGeneralError), $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      y1: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$Schema$createSearchSuccess),
      h: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreateSearchGeneralError), $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreateSearchGeneralError), $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreateSearchGeneralError), $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreateSearchGeneralError), $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      zC: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreateSearchDuplicate), $author$project$Api$Schema$searchDuplicateErrorContent),
      zS: A2($author$project$Api$Schema$mapField, $elm$core$Basics$always($elm$core$Result$Err($author$project$Types$Search$UnpaidMatchesError)), $author$project$Api$Schema$unpaidMatchesErrorContent),
      z: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Search$CreateSearchGeneralError), $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    var internalInvitesUserIds = A2($elm$core$List$filterMap, function (invite) {
      if (invite.$ === 1) {
        var userId = invite.a;
        return $elm$core$Maybe$Just({
          e_: userId
        });
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }, searchParams.ox);
    var externalInvitesList = A2($elm$core$List$filter, function (invite) {
      if (invite.$ === 2) {
        return true;
      } else {
        return false;
      }
    }, searchParams.ox);
    var maybeUuidString = $elm_community$maybe_extra$Maybe$Extra$join(A2($elm$core$Maybe$map, function (invite) {
      if (invite.$ === 2) {
        var uuidString = invite.a;
        return $elm$core$Maybe$Just(uuidString);
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }, $elm$core$List$head(externalInvitesList)));
    var externalInviteCount = $elm$core$List$length(externalInvitesList);
    var input = {
      v7: function () {
        var _v0 = _Utils_Tuple2(externalInviteCount > 0, maybeUuidString);
        if (_v0.a && !_v0.b.$) {
          var uuidString = _v0.b.a;
          return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
            uQ: externalInviteCount,
            ef: uuidString
          });
        } else {
          return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
        }
      }(),
      wW: $elm$core$List$length(internalInvitesUserIds) > 0 ? $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(internalInvitesUserIds) : $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
      kH: $author$project$Types$Search$toSearchParamsInput(searchParams)
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$search(A2($author$project$Api$GraphqlSchema$Object$SearchMutation$create, {
      t: input
    }, payload))));
  });
  var $author$project$Api$GraphqlSchema$Enum$PlatformOs$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'ANDROID';
      case 1:
        return 'IOS';
      case 2:
        return 'WEB_CHROME';
      case 3:
        return 'WEB_FIREFOX';
      case 4:
        return 'WEB_SAFARI';
      default:
        return 'WEB_OTHER';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeAppPlatformInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('os', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$PlatformOs$toString, input____.eo))), _Utils_Tuple2('version', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.e3)))]));
  };
  var $author$project$Api$GraphqlSchema$Enum$GeoAccuracyLevel$toString = function (enum____) {
    if (!enum____) {
      return 'LOW';
    } else {
      return 'HIGH';
    }
  };
  var $author$project$Api$GraphqlSchema$Enum$GeoLocationMethod$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'CLIENT_DETECTION';
      case 1:
        return 'USER_PROVIDED';
      default:
        return 'GEO_IP';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeGeoLocationInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('accuracyLevel', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$GeoAccuracyLevel$toString, input____.ds))), _Utils_Tuple2('accuracyRadius', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cx, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.ur;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('method', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$GeoLocationMethod$toString, input____.em))), _Utils_Tuple2('point', $elm$core$Maybe$Just(A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.hs;
    }, $author$project$Api$ScalarCodecs$codecs)(input____.es)))]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodePhotoInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('url', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.eZ)))]));
  };
  var $author$project$Api$GraphqlSchema$Enum$Gender$toString = function (enum____) {
    if (!enum____) {
      return 'FEMALE';
    } else {
      return 'MALE';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeUserProfileInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('address', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cy, $author$project$Api$GraphqlSchema$InputObject$encodeFormattedAddressInput)), _Utils_Tuple2('email', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.bZ))), _Utils_Tuple2('firstName', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.nF))), _Utils_Tuple2('gender', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Gender$toString, input____.nM))), _Utils_Tuple2('lastName', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.oU))), _Utils_Tuple2('location', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iT, $author$project$Api$GraphqlSchema$InputObject$encodeGeoLocationInput)), _Utils_Tuple2('phoneNumber', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.qo))), _Utils_Tuple2('photo', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c5, $author$project$Api$GraphqlSchema$InputObject$encodePhotoInput)), _Utils_Tuple2('platform', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c6, $author$project$Api$GraphqlSchema$InputObject$encodeAppPlatformInput)), _Utils_Tuple2('referrer', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c8, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))]));
  };
  var $author$project$Api$GraphqlSchema$Mutation$createUser = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'createUser', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeUserProfileInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Union$CreateUserPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CreateUserSuccess', selections____.y2), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k)]));
  };
  var $author$project$Api$GraphqlSchema$Object$CreateUserSuccess$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$CreateUserSuccess$profile = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'profile', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Types$UserProfile$UserProfile = F7(function (email, firstName, gender, lastName, location, phoneNumber, photoUrl) {
    return {
      bZ: email,
      nF: firstName,
      nM: gender,
      oU: lastName,
      iT: location,
      qo: phoneNumber,
      qq: photoUrl
    };
  });
  var $author$project$Api$GraphqlSchema$Object$UserProfile$address = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'address', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };
  var $author$project$Api$GraphqlSchema$Object$UserProfile$email = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'email', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$UserProfile$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$UserProfile$gender = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Gender.Gender', 'gender', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Gender$decoder);
  var $author$project$Types$GeoLocation$RemoteGeoLocation = F4(function (accuracyLevel, accuracyRadius, method, point) {
    return {
      ds: accuracyLevel,
      cx: accuracyRadius,
      em: method,
      es: point
    };
  });
  var $author$project$Api$GraphqlSchema$Enum$GeoAccuracyLevel$Low = 0;
  var $author$project$Api$GraphqlSchema$Enum$GeoAccuracyLevel$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'LOW':
        return $elm$json$Json$Decode$succeed(0);
      case 'HIGH':
        return $elm$json$Json$Decode$succeed(1);
      default:
        return $elm$json$Json$Decode$fail('Invalid GeoAccuracyLevel type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$GeoLocation$accuracyLevel = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.GeoAccuracyLevel.GeoAccuracyLevel', 'accuracyLevel', _List_Nil, $author$project$Api$GraphqlSchema$Enum$GeoAccuracyLevel$decoder);
  var $author$project$Api$GraphqlSchema$Object$GeoLocation$accuracyRadius = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Meters)', 'accuracyRadius', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).ur.fu));
  var $author$project$Api$GraphqlSchema$Enum$GeoLocationMethod$ClientDetection = 0;
  var $author$project$Api$GraphqlSchema$Enum$GeoLocationMethod$GeoIp = 2;
  var $author$project$Api$GraphqlSchema$Enum$GeoLocationMethod$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'CLIENT_DETECTION':
        return $elm$json$Json$Decode$succeed(0);
      case 'USER_PROVIDED':
        return $elm$json$Json$Decode$succeed(1);
      case 'GEO_IP':
        return $elm$json$Json$Decode$succeed(2);
      default:
        return $elm$json$Json$Decode$fail('Invalid GeoLocationMethod type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$GeoLocation$method = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.GeoLocationMethod.GeoLocationMethod', 'method', _List_Nil, $author$project$Api$GraphqlSchema$Enum$GeoLocationMethod$decoder);
  var $author$project$Api$GraphqlSchema$Object$GeoLocation$point = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Api.ScalarCodecs.Point', 'point', _List_Nil, $author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).hs.fu);
  var $author$project$Api$Schema$geoLocationSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$GeoLocation$point, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$GeoLocation$method, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$GeoLocation$accuracyRadius, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$GeoLocation$accuracyLevel, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$GeoLocation$RemoteGeoLocation)))));
  var $author$project$Api$GraphqlSchema$Object$UserProfile$lastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastName', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$UserProfile$location = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'location', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };
  var $author$project$Api$GraphqlSchema$Object$UserProfile$phoneNumber = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'phoneNumber', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$UserProfile$photo = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'photo', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };
  var $author$project$Api$Schema$profile = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserProfile$photo($author$project$Api$GraphqlSchema$Object$Photo$url), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserProfile$phoneNumber, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserProfile$address($author$project$Api$Schema$address), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserProfile$location($author$project$Api$Schema$geoLocationSelectionSet), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F2(function (maybeGeolocation, maybeAddress) {
    return A3($elm$core$Maybe$map2, F2(function (geolocation, _v0) {
      var title = _v0.lh;
      var subtitle = _v0.lb;
      return _Utils_Tuple2(geolocation, {
        lb: subtitle,
        lh: title
      });
    }), maybeGeolocation, maybeAddress);
  })))), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserProfile$lastName, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserProfile$gender, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserProfile$firstName, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserProfile$email, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$UserProfile$UserProfile))))))));
  var $author$project$Api$GraphqlSchema$Enum$PlatformOs$Android = 0;
  var $author$project$Api$GraphqlSchema$Enum$PlatformOs$Ios = 1;
  var $author$project$Api$GraphqlSchema$InputObject$PhotoInput = function (url) {
    return {
      eZ: url
    };
  };
  var $author$project$Api$GraphqlSchema$Enum$PlatformOs$WebChrome = 2;
  var $author$project$Api$GraphqlSchema$Enum$PlatformOs$WebFirefox = 3;
  var $author$project$Api$GraphqlSchema$Enum$PlatformOs$WebOther = 5;
  var $author$project$Api$GraphqlSchema$Enum$PlatformOs$WebSafari = 4;
  var $author$project$Types$GeoLocation$toGeoLocationInput = function (geoLocation) {
    return {
      ds: geoLocation.ds,
      cx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(geoLocation.cx),
      em: geoLocation.em,
      es: geoLocation.es
    };
  };
  var $elm$core$String$toLower = _String_toLower;
  var $author$project$Types$UserProfile$toUserProfileInput = F2(function (userProfile, _v0) {
    var osVersion = _v0.f7;
    var referrer = _v0.c8;
    var isHybrid = _v0.xd;
    var isAndroid = _v0.fM;
    var isIos = _v0.fQ;
    var isWeb = _v0.fS;
    var browserName = _v0.e9;
    var browserVersion = _v0.fa;
    return {
      cy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, function (_v1) {
        var title = _v1.b.lh;
        var subtitle = _v1.b.lb;
        return {
          lb: subtitle,
          lh: title
        };
      }, userProfile.iT)),
      bZ: userProfile.bZ,
      nF: userProfile.nF,
      nM: userProfile.nM,
      oU: userProfile.oU,
      iT: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Types$GeoLocation$toGeoLocationInput), userProfile.iT)),
      qo: userProfile.qo,
      c5: A2($elm$core$Maybe$withDefault, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, A2($elm$core$Maybe$map, function (justPhotoUrl) {
        return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Api$GraphqlSchema$InputObject$PhotoInput(justPhotoUrl));
      }, userProfile.qq)),
      c6: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
        eo: isAndroid ? 0 : isIos ? 1 : $elm$core$String$toLower(browserName) === 'chrome' ? 2 : $elm$core$String$toLower(browserName) === 'firefox' ? 3 : $elm$core$String$toLower(browserName) === 'safari' ? 4 : 5,
        e3: isWeb ? browserVersion : osVersion
      }),
      c8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(referrer)
    };
  });
  var $author$project$Api$Api$createUser = F5(function (userProfile, env, _v0, tag, idToken) {
    var apiEndpoint = _v0.lJ;
    var firebaseApiKey = _v0.nE;
    var auth = _v0.bN;
    var payload = $author$project$Api$GraphqlSchema$Union$CreateUserPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      y2: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CreateUserSuccess$profile($author$project$Api$Schema$profile), A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$CreateUserSuccess$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F2(function (userId, profile) {
        return {
          od: userId,
          qI: profile
        };
      }))))),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message)
    });
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$createUser, {
      t: A2($author$project$Types$UserProfile$toUserProfileInput, userProfile, env)
    }, payload)));
  });
  var $author$project$Api$GraphqlSchema$InputObject$encodeDeleteStripePaymentMethodInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('paymentMethodId', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.Ad)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$PaymentMutation$deleteStripePaymentMethod = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'deleteStripePaymentMethod', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeDeleteStripePaymentMethodInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Union$DeleteStripePaymentMethodPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericSuccess', selections____.T), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PaymentMethodNotFoundError', selections____.zq), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Api$GraphqlSchema$Object$PaymentMethodNotFoundError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Mutation$payments = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'payments', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$Api$deleteStripePaymentMethod = F4(function (paymentMethodId, apiEndpoint, tag, idToken) {
    var payload = $author$project$Api$GraphqlSchema$Union$DeleteStripePaymentMethodPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      T: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      zq: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PaymentMethodNotFoundError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    var input = {
      Ad: $author$project$Types$PaymentMethod$unwrapPaymentMethodId(paymentMethodId)
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$payments(A2($author$project$Api$GraphqlSchema$Object$PaymentMutation$deleteStripePaymentMethod, {
      t: input
    }, payload))));
  });
  var $author$project$Api$GraphqlSchema$Object$UserMutation$disable = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'disable', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Union$DisableUserPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericSuccess', selections____.T), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Api$GraphqlSchema$Mutation$user = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'user', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.od, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$disableUser = F4(function (_v0, apiEndpoint, tag, idToken) {
    var userId = _v0;
    var payload = $author$project$Api$GraphqlSchema$Union$DisableUserPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      T: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$user, {
      od: userId
    }, $author$project$Api$GraphqlSchema$Object$UserMutation$disable(payload))));
  });
  var $author$project$Api$GraphqlSchema$Object$CancelMatchReasonDescription$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Enum$CancelMatchReason$CannotMakeIt = 0;
  var $author$project$Api$GraphqlSchema$Enum$CancelMatchReason$OtherPersonalReasons = 4;
  var $author$project$Api$GraphqlSchema$Enum$CancelMatchReason$PlayersConcern = 2;
  var $author$project$Api$GraphqlSchema$Enum$CancelMatchReason$VenueUnacceptable = 1;
  var $author$project$Api$GraphqlSchema$Enum$CancelMatchReason$XrivalsExpectationMismatch = 3;
  var $author$project$Api$GraphqlSchema$Enum$CancelMatchReason$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'CANNOT_MAKE_IT':
        return $elm$json$Json$Decode$succeed(0);
      case 'VENUE_UNACCEPTABLE':
        return $elm$json$Json$Decode$succeed(1);
      case 'PLAYERS_CONCERN':
        return $elm$json$Json$Decode$succeed(2);
      case 'XRIVALS_EXPECTATION_MISMATCH':
        return $elm$json$Json$Decode$succeed(3);
      case 'OTHER_PERSONAL_REASONS':
        return $elm$json$Json$Decode$succeed(4);
      default:
        return $elm$json$Json$Decode$fail('Invalid CancelMatchReason type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$CancelMatchReasonDescription$reason = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.CancelMatchReason.CancelMatchReason', 'reason', _List_Nil, $author$project$Api$GraphqlSchema$Enum$CancelMatchReason$decoder);
  var $author$project$Api$Schema$cancelMatchReason = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CancelMatchReasonDescription$description, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CancelMatchReasonDescription$reason, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F2(function (reason, description) {
    return _Utils_Tuple2(reason, description);
  }))));
  var $author$project$Api$GraphqlSchema$Object$MatchQuery$cancelReasons = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'cancelReasons', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };
  var $author$project$Api$Api$getCancelMatchReasons = F3(function (apiEndpoint, tag, idToken) {
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$matches($author$project$Api$GraphqlSchema$Object$MatchQuery$cancelReasons($author$project$Api$Schema$cancelMatchReason))));
  });
  var $author$project$Api$Api$getMatch = F4(function (_v0, apiEndpoint, tag, idToken) {
    var matchId = _v0;
    var payload = $author$project$Api$GraphqlSchema$Union$ListMatchesPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      jr: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$Schema$listMatchesSuccess),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message)
    });
    var optionalArguments = function (_v1) {
      return {
        cZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
          g3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          cF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          br: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(matchId),
          jY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          kJ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          e_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
        }),
        f9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
      };
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$matches(A2($author$project$Api$GraphqlSchema$Object$MatchQuery$matches, optionalArguments, payload))));
  });
  var $author$project$Api$GraphqlSchema$Union$SearchInvitePayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SearchInviteSuccess', selections____.zD), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SearchNotFoundError', selections____.f6)]));
  };
  var $author$project$Api$GraphqlSchema$Object$SearchNotFoundError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$InputObject$encodeOneOfSearchIdOrInviteTokenInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('inviteToken', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ef, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('searchId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.by, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeSearchInviteInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('inviteKey', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeOneOfSearchIdOrInviteTokenInput(input____.ou)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$SearchQuery$searchInvite = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'searchInvite', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeSearchInviteInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Object$SearchInviteSuccess$details = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'details', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$Schema$searchInvite = $author$project$Api$GraphqlSchema$Object$SearchInviteSuccess$details($author$project$Api$Schema$searchDetails);
  var $author$project$Api$Api$getSearchInvite = F4(function (invitationRoute, apiEndpoint, tag, maybeIdToken) {
    var payload = $author$project$Api$GraphqlSchema$Union$SearchInvitePayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      zD: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Ok, $author$project$Api$Schema$searchInvite),
      f6: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$SearchNotFoundError$message)
    });
    var input = {
      ou: function () {
        if (!invitationRoute.$) {
          var uuid = invitationRoute.a;
          return {
            ef: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(uuid),
            by: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
          };
        } else {
          var searchId = invitationRoute.a;
          return {
            ef: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            by: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(searchId)
          };
        }
      }()
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$queryRequestTask, apiEndpoint, maybeIdToken, $author$project$Api$GraphqlSchema$Query$searches(A2($author$project$Api$GraphqlSchema$Object$SearchQuery$searchInvite, {
      t: input
    }, payload))));
  });
  var $author$project$Api$GraphqlSchema$InputObject$SearchPricingInput = function (searchId) {
    return {
      by: searchId
    };
  };
  var $author$project$Api$GraphqlSchema$Union$SearchPricingPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SearchNotFoundError', selections____.f6), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SearchPricingSuccess', selections____.zE)]));
  };
  var $author$project$Api$GraphqlSchema$Object$SearchPricingSuccess$pricing = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'pricing', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeSearchPricingInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('searchId', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.by)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$SearchQuery$searchPricing = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'searchPricing', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeSearchPricingInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$getSearchPricing = F4(function (_v0, apiEndpoint, tag, idToken) {
    var matchSearchId = _v0;
    var payload = $author$project$Api$GraphqlSchema$Union$SearchPricingPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      f6: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$SearchNotFoundError$message),
      zE: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Ok, $author$project$Api$GraphqlSchema$Object$SearchPricingSuccess$pricing($author$project$Api$Schema$pricingEstimate))
    });
    var input = $author$project$Api$GraphqlSchema$InputObject$SearchPricingInput(matchSearchId);
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$searches(A2($author$project$Api$GraphqlSchema$Object$SearchQuery$searchPricing, {
      t: input
    }, payload))));
  });
  var $author$project$Api$GraphqlSchema$Object$SupportQuery$reasons = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'reasons', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };
  var $author$project$Api$GraphqlSchema$Query$support = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'support', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Types$SupportReason$SupportReasonTemplate = F2(function (description, kind) {
    return {
      vn: description,
      xu: kind
    };
  });
  var $author$project$Types$SupportReason$SupportReasonTemplateDescription = F2(function (commentTemplate, title) {
    return {
      mx: commentTemplate,
      lh: title
    };
  });
  var $author$project$Api$GraphqlSchema$Object$SupportReasonDescription$commentTemplate = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'commentTemplate', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$SupportReasonReasonDescription$description = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'description', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Enum$SupportReason$Billing = 0;
  var $author$project$Api$GraphqlSchema$Enum$SupportReason$CreditIncompleteGame = 1;
  var $author$project$Api$GraphqlSchema$Enum$SupportReason$General = 2;
  var $author$project$Api$GraphqlSchema$Enum$SupportReason$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'BILLING':
        return $elm$json$Json$Decode$succeed(0);
      case 'CREDIT_INCOMPLETE_GAME':
        return $elm$json$Json$Decode$succeed(1);
      case 'GENERAL':
        return $elm$json$Json$Decode$succeed(2);
      default:
        return $elm$json$Json$Decode$fail('Invalid SupportReason type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$SupportReasonReasonDescription$reason = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.SupportReason.SupportReason', 'reason', _List_Nil, $author$project$Api$GraphqlSchema$Enum$SupportReason$decoder);
  var $author$project$Api$GraphqlSchema$Object$SupportReasonDescription$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$supportReason = function () {
    var supportReasonDescription = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SupportReasonDescription$title, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SupportReasonDescription$commentTemplate, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$SupportReason$SupportReasonTemplateDescription)));
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SupportReasonReasonDescription$reason, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SupportReasonReasonDescription$description(supportReasonDescription), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$SupportReason$SupportReasonTemplate)));
  }();
  var $author$project$Api$Api$getSupportReasons = F3(function (apiEndpoint, tag, idToken) {
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$support($author$project$Api$GraphqlSchema$Object$SupportQuery$reasons($author$project$Api$Schema$supportReason))));
  });
  var $author$project$Api$Schema$listNotificationsSuccess = function () {
    var notificationFragments = $author$project$Api$GraphqlSchema$Interface$Notification$fragments({
      js: $author$project$Api$Schema$matchCancelledNotification,
      jt: $author$project$Api$Schema$matchJoined,
      ju: $author$project$Api$Schema$matchRateNotification,
      jv: $author$project$Api$Schema$matchSuggestion,
      jw: $author$project$Api$Schema$matchedNotification,
      jx: $author$project$Api$Schema$matchResend,
      jy: $author$project$Api$Schema$noMatchNotification,
      jO: $author$project$Api$Schema$searchInviteNotification
    });
    return $author$project$Api$GraphqlSchema$Object$ListNotificationsSuccess$notifications(notificationFragments);
  }();
  var $author$project$Api$Api$getUnreadNotifications = F3(function (apiEndpoint, tag, idToken) {
    var payload = $author$project$Api$GraphqlSchema$Union$ListNotificationsPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      pV: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$Schema$listNotificationsSuccess),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message)
    });
    var optionalArguments = function (optionalArguments_) {
      return _Utils_update(optionalArguments_, {
        cZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
          cF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          pH: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          pI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
            dx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            d$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            eK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(_List_fromArray([1]))
          })
        })
      });
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$notifications(A2($author$project$Api$GraphqlSchema$Object$NotificationQuery$notifications, optionalArguments, payload))));
  });
  var $author$project$Api$GraphqlSchema$Query$me = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'me', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Union$MeQueryPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserQuery', selections____.jW), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'IdentityUndefinedError', selections____.f4)]));
  };
  var $author$project$Api$Schema$UserQuery = F2(function (auth, info) {
    return {
      bN: auth,
      wL: info
    };
  });
  var $author$project$Api$GraphqlSchema$Object$UserQuery$auth = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'auth', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$Schema$AuthPayloadSuccess = F2(function (maybeUserId, identityMetadata) {
    return {
      wF: identityMetadata,
      yk: maybeUserId
    };
  });
  var $author$project$Api$GraphqlSchema$Object$AuthPayloadSuccess$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'id', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$AuthPayloadSuccess$identityMetadata = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'identityMetadata', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };
  var $author$project$Types$User$IdentityMetadata = F6(function (email, emailVerified, displayName, phone, photoUrl, disabled) {
    return {
      bY: disabled,
      cI: displayName,
      bZ: email,
      nd: emailVerified,
      Aq: phone,
      qq: photoUrl
    };
  });
  var $author$project$Api$GraphqlSchema$Object$IdentityMetadata$disabled = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'disabled', _List_Nil, $elm$json$Json$Decode$bool);
  var $author$project$Api$GraphqlSchema$Object$IdentityMetadata$displayName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'displayName', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$IdentityMetadata$email = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'email', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$IdentityMetadata$emailVerified = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'emailVerified', _List_Nil, $elm$json$Json$Decode$bool);
  var $author$project$Api$GraphqlSchema$Object$IdentityMetadata$phone = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'phone', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$IdentityMetadata$photoUrl = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'photoUrl', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$Schema$identityMetadata = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$IdentityMetadata$disabled, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$IdentityMetadata$photoUrl, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$IdentityMetadata$phone, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$IdentityMetadata$displayName, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$IdentityMetadata$emailVerified, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$IdentityMetadata$email, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$User$IdentityMetadata)))))));
  var $author$project$Api$Schema$authPayloadSuccess = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$AuthPayloadSuccess$identityMetadata($author$project$Api$Schema$identityMetadata), A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$AuthPayloadSuccess$id, $elm$core$Maybe$map($elm$core$Basics$identity), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Schema$AuthPayloadSuccess)));
  var $author$project$Api$GraphqlSchema$Union$AuthPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AuthPayloadSuccess', selections____.ji), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'IdentityUndefinedError', selections____.f4), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Api$Schema$authPayloadSelection = function () {
    var identityAvailable = function (payloadSuccess) {
      return $elm_community$maybe_extra$Maybe$Extra$isJust(payloadSuccess.yk) && $elm_community$maybe_extra$Maybe$Extra$isJust(payloadSuccess.wF) ? $elm$core$Result$Ok(payloadSuccess) : $elm$core$Result$Err('Uuid or identity metadata not present');
    };
    return $author$project$Api$GraphqlSchema$Union$AuthPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      ji: A2($author$project$Api$Schema$mapField, identityAvailable, $author$project$Api$Schema$authPayloadSuccess),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      f4: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$IdentityUndefinedError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
  }();
  var $author$project$Api$GraphqlSchema$Object$UserQuery$info = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'info', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Union$UserInfoPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserInfoPublicSuccess', selections____.zX), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserInfoSuccess', selections____.zY), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Types$UserSession$UserInfoPublic = F2(function (profile, statistics) {
    return {
      qI: profile,
      r5: statistics
    };
  });
  var $author$project$Api$GraphqlSchema$Object$UserInfoPublicSuccess$profile = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'profile', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$UserInfoPublicSuccess$statistics = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'statistics', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Types$UserInfoStatistics$UserStatistics = F2(function (activityStatistics, matchCount) {
    return {
      tj: activityStatistics,
      fZ: matchCount
    };
  });
  var $author$project$Api$GraphqlSchema$Object$UserStatistics$activityStatistics = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'activityStatistics', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };
  var $author$project$Api$GraphqlSchema$Object$UserStatistics$totalMatchCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'totalMatchCount', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Types$UserInfoStatistics$UserActivityStatistics = F2(function (activity, matchCount) {
    return {
      du: activity,
      fZ: matchCount
    };
  });
  var $author$project$Api$GraphqlSchema$Object$UserActivityStatistics$activity = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Activity.Activity', 'activity', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Activity$decoder);
  var $author$project$Api$GraphqlSchema$Object$UserActivityStatistics$matchCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'matchCount', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$Schema$userActivityStatisticsSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserActivityStatistics$matchCount, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserActivityStatistics$activity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$UserInfoStatistics$UserActivityStatistics)));
  var $author$project$Api$Schema$statistics = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserStatistics$totalMatchCount, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserStatistics$activityStatistics($author$project$Api$Schema$userActivityStatisticsSelectionSet), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$UserInfoStatistics$UserStatistics)));
  var $author$project$Api$GraphqlSchema$Object$UserProfilePublic$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$UserProfilePublic$gender = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Gender.Gender', 'gender', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Gender$decoder);
  var $author$project$Api$GraphqlSchema$Object$UserProfilePublic$lastInitial = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastInitial', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$UserProfilePublic$lastNameOrInitial = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastNameOrInitial', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$UserProfilePublic$photo = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'photo', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };
  var $author$project$Api$Schema$userProfilePublic = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserProfilePublic$photo($author$project$Api$GraphqlSchema$Object$Photo$url), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserProfilePublic$gender, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserProfilePublic$lastInitial, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserProfilePublic$lastNameOrInitial, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserProfilePublic$firstName, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(F5(function (firstName, lastNameOrInitial, lastInitial, gender, photoUrl) {
    return {
      nF: firstName,
      nM: gender,
      xy: lastInitial,
      fT: $elm$core$String$length(lastNameOrInitial) === 1 ? lastNameOrInitial + '.' : lastNameOrInitial,
      qq: photoUrl
    };
  })))))));
  var $author$project$Api$Schema$userInfoPublic = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserInfoPublicSuccess$statistics($author$project$Api$Schema$statistics), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserInfoPublicSuccess$profile($author$project$Api$Schema$userProfilePublic), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$UserSession$UserInfoPublic)));
  var $author$project$Types$UserSession$UserInfo = F9(function (activities, notificationSettings, paymentMethods, profile, statistics, unsupportedActivities, unreadNotifications, pushDevices, paymentPreferences) {
    return {
      lz: activities,
      pJ: notificationSettings,
      qj: paymentMethods,
      qk: paymentPreferences,
      qI: profile,
      qO: pushDevices,
      r5: statistics,
      C2: unreadNotifications,
      sL: unsupportedActivities
    };
  });
  var $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$activities = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'activities', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };
  var $author$project$Types$UserActivity$UserActivity = F2(function (activity, selfDeclaredSkillRating) {
    return {
      du: activity,
      eH: selfDeclaredSkillRating
    };
  });
  var $author$project$Api$GraphqlSchema$Object$UserActivity$activity = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Activity.Activity', 'activity', _List_Nil, $author$project$Api$GraphqlSchema$Enum$Activity$decoder);
  var $author$project$Api$GraphqlSchema$Enum$SkillRating$Advanced = 3;
  var $author$project$Api$GraphqlSchema$Enum$SkillRating$FirstTimer = 0;
  var $author$project$Api$GraphqlSchema$Enum$SkillRating$Pro = 4;
  var $author$project$Api$GraphqlSchema$Enum$SkillRating$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'FIRST_TIMER':
        return $elm$json$Json$Decode$succeed(0);
      case 'BEGINNER':
        return $elm$json$Json$Decode$succeed(1);
      case 'INTERMEDIATE':
        return $elm$json$Json$Decode$succeed(2);
      case 'ADVANCED':
        return $elm$json$Json$Decode$succeed(3);
      case 'PRO':
        return $elm$json$Json$Decode$succeed(4);
      default:
        return $elm$json$Json$Decode$fail('Invalid SkillRating type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$UserActivity$selfDeclaredSkillRating = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.SkillRating.SkillRating', 'selfDeclaredSkillRating', _List_Nil, $author$project$Api$GraphqlSchema$Enum$SkillRating$decoder);
  var $author$project$Api$Schema$activities = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserActivity$selfDeclaredSkillRating, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserActivity$activity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$UserActivity$UserActivity)));
  var $author$project$Api$GraphqlSchema$Object$PaymentPreferences$autoPay = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'autoPay', _List_Nil, $elm$json$Json$Decode$bool);
  var $author$project$Types$NotificationSettings$NotificationSettings = F5(function (cancellation, newMatch, noMatch, rate, searchInvite) {
    return {
      mb: cancellation,
      pC: newMatch,
      pE: noMatch,
      qT: rate,
      rs: searchInvite
    };
  });
  var $author$project$Api$GraphqlSchema$Object$NotificationPreferences$cancellation = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'cancellation', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$NotificationPreferences$newMatch = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'newMatch', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$NotificationPreferences$noMatch = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'noMatch', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Types$NotificationSettings$NotificationPreference = F2(function (email, push) {
    return {
      bZ: email,
      ew: push
    };
  });
  var $author$project$Api$GraphqlSchema$Object$NotificationPreference$email = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'email', _List_Nil, $elm$json$Json$Decode$bool);
  var $author$project$Api$GraphqlSchema$Object$NotificationPreference$push = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'push', _List_Nil, $elm$json$Json$Decode$bool);
  var $author$project$Api$Schema$notificationPreference = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$NotificationPreference$push, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$NotificationPreference$email, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$NotificationSettings$NotificationPreference)));
  var $author$project$Api$GraphqlSchema$Object$NotificationPreferences$rate = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'rate', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$NotificationPreferences$searchInvite = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'searchInvite', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$Schema$notificationPreferences = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$NotificationPreferences$searchInvite($author$project$Api$Schema$notificationPreference), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$NotificationPreferences$rate($author$project$Api$Schema$notificationPreference), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$NotificationPreferences$noMatch($author$project$Api$Schema$notificationPreference), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$NotificationPreferences$newMatch($author$project$Api$Schema$notificationPreference), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$NotificationPreferences$cancellation($author$project$Api$Schema$notificationPreference), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$NotificationSettings$NotificationSettings))))));
  var $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$notificationSettings = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'notificationSettings', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$paymentMethods = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'paymentMethods', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };
  var $author$project$Types$PaymentMethod$PaymentMethod = F2(function (id, stripePaymentMethod) {
    return {
      od: id,
      Cj: stripePaymentMethod
    };
  });
  var $author$project$Api$GraphqlSchema$Interface$PaymentMethod$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'StripePaymentMethod', selections____.jQ)]));
  };
  var $author$project$Api$GraphqlSchema$Interface$PaymentMethod$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Types$PaymentMethod$StripePaymentMethod = F3(function (id, type_, details) {
    return {
      vp: details,
      od: id,
      C$: type_
    };
  });
  var $author$project$Types$PaymentMethod$StripePaymentMethodId = $elm$core$Basics$identity;
  var $author$project$Api$GraphqlSchema$Object$StripePaymentMethod$details = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'details', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$StripePaymentMethod$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'id', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Types$PaymentMethod$Card = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Types$PaymentMethod$Other = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Api$GraphqlSchema$Interface$SavedPaymentMethodStripeDetails$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SavedPaymentMethodStripeCard', selections____.jL), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SavedPaymentMethodStripeOther', selections____.jM)]));
  };
  var $author$project$Types$PaymentMethod$SavedPaymentMethodStripeCard = F4(function (billingDetails, brand, expiry, last4) {
    return {
      tR: billingDetails,
      tZ: brand,
      v4: expiry,
      xw: last4
    };
  });
  var $author$project$Api$GraphqlSchema$Object$SavedPaymentMethodStripeCard$billingDetails = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'billingDetails', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Types$PaymentMethod$BillingDetails = F3(function (address, email, phone) {
    return {
      cy: address,
      bZ: email,
      Aq: phone
    };
  });
  var $author$project$Api$GraphqlSchema$Object$BillingDetails$address = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'address', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
  };
  var $author$project$Api$GraphqlSchema$Object$BillingDetails$email = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'email', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$BillingDetails$phone = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'phone', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Types$PaymentMethod$StripeAddress = F6(function (city, country, line1, line2, postalCode, province) {
    return {
      ug: city,
      mA: country,
      xJ: line1,
      xK: line2,
      Aw: postalCode,
      AL: province
    };
  });
  var $author$project$Api$GraphqlSchema$Object$StripeAddress$city = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'city', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$StripeAddress$country = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'country', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$StripeAddress$line1 = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'line1', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$StripeAddress$line2 = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'line2', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$StripeAddress$postalCode = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'postalCode', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$StripeAddress$province = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'province', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$Schema$stripeAddress = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$StripeAddress$province, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$StripeAddress$postalCode, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$StripeAddress$line2, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$StripeAddress$line1, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$StripeAddress$country, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$StripeAddress$city, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$PaymentMethod$StripeAddress)))))));
  var $author$project$Api$Schema$billingDetails = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$BillingDetails$phone, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$BillingDetails$email, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$BillingDetails$address($author$project$Api$Schema$stripeAddress), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$PaymentMethod$BillingDetails))));
  var $author$project$Api$GraphqlSchema$Object$SavedPaymentMethodStripeCard$brand = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'brand', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Types$PaymentMethod$CardExpiry = F2(function (month, year) {
    return {
      pt: month,
      ta: year
    };
  });
  var $author$project$Api$GraphqlSchema$Object$CardExpiry$month = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'month', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Object$CardExpiry$year = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'year', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$Schema$cardExpiry = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CardExpiry$year, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$CardExpiry$month, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$PaymentMethod$CardExpiry)));
  var $author$project$Api$GraphqlSchema$Object$SavedPaymentMethodStripeCard$expiry = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'expiry', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$SavedPaymentMethodStripeCard$last4 = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'last4', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$savedPaymentMethodStripeCard = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SavedPaymentMethodStripeCard$last4, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SavedPaymentMethodStripeCard$expiry($author$project$Api$Schema$cardExpiry), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SavedPaymentMethodStripeCard$brand, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SavedPaymentMethodStripeCard$billingDetails($author$project$Api$Schema$billingDetails), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$PaymentMethod$SavedPaymentMethodStripeCard)))));
  var $author$project$Types$PaymentMethod$SavedPaymentMethodStripeOther = function (billingDetails) {
    return {
      tR: billingDetails
    };
  };
  var $author$project$Api$GraphqlSchema$Object$SavedPaymentMethodStripeOther$billingDetails = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'billingDetails', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$Schema$savedPaymentMethodStripeOther = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SavedPaymentMethodStripeOther$billingDetails($author$project$Api$Schema$billingDetails), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$PaymentMethod$SavedPaymentMethodStripeOther));
  var $author$project$Api$Schema$savedPaymentMethodStripeDetails = $author$project$Api$GraphqlSchema$Interface$SavedPaymentMethodStripeDetails$fragments({
    jL: A2($author$project$Api$Schema$mapField, $author$project$Types$PaymentMethod$Card, $author$project$Api$Schema$savedPaymentMethodStripeCard),
    jM: A2($author$project$Api$Schema$mapField, $author$project$Types$PaymentMethod$Other, $author$project$Api$Schema$savedPaymentMethodStripeOther)
  });
  var $author$project$Api$GraphqlSchema$Object$StripePaymentMethod$type_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'type', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$stripePaymentMethod = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$StripePaymentMethod$details($author$project$Api$Schema$savedPaymentMethodStripeDetails), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$StripePaymentMethod$type_, A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$StripePaymentMethod$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$PaymentMethod$StripePaymentMethod))));
  var $author$project$Api$Schema$paymentMethods = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Interface$PaymentMethod$fragments({
    jQ: $author$project$Api$Schema$stripePaymentMethod
  }), A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Interface$PaymentMethod$id, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$PaymentMethod$PaymentMethod)));
  var $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$paymentSettings = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'paymentSettings', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$profile = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'profile', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Types$UserSettings$PushDevice = F3(function (name, token, registeredAt) {
    return {
      i5: name,
      qY: registeredAt,
      li: token
    };
  });
  var $author$project$Api$GraphqlSchema$Object$PushDevice$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe String)', 'name', _List_Nil, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$PushDevice$registeredAt = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(Maybe Api.ScalarCodecs.Instant)', 'registeredAt', _List_Nil, $elm$json$Json$Decode$nullable($author$project$Api$GraphqlSchema$Scalar$unwrapCodecs($author$project$Api$ScalarCodecs$codecs).up.fu));
  var $author$project$Api$GraphqlSchema$Object$PushDevice$token = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'token', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$pushDevice = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$PushDevice$registeredAt, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$PushDevice$token, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$PushDevice$name, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$UserSettings$PushDevice))));
  var $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$pushDevices = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'pushDevices', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };
  var $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$statistics = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'statistics', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$unreadNotifications = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'unreadNotifications', _List_Nil, $elm$json$Json$Decode$int);
  var $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$unsupportedActivities = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(List String)', 'unsupportedActivities', _List_Nil, $elm$json$Json$Decode$list($elm$json$Json$Decode$string));
  var $author$project$Api$Schema$userInfoSuccess = A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$paymentSettings($author$project$Api$GraphqlSchema$Object$PaymentPreferences$autoPay), function (autoPay) {
    return {
      w9: autoPay
    };
  }, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$pushDevices($author$project$Api$Schema$pushDevice), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$unreadNotifications, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$unsupportedActivities, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$statistics($author$project$Api$Schema$statistics), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$profile($author$project$Api$Schema$profile), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$paymentMethods($author$project$Api$Schema$paymentMethods), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$notificationSettings($author$project$Api$Schema$notificationPreferences), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserInfoSuccess$activities($author$project$Api$Schema$activities), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$UserSession$UserInfo))))))))));
  var $author$project$Api$Schema$userInfo = $author$project$Api$GraphqlSchema$Union$UserInfoPayload$fragments({
    f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
    g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
    h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
    i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
    j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
    k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
    zX: A2($author$project$Api$Schema$mapField, $elm$core$Basics$always($elm$core$Result$Err('Incomplete information received: public profile instead of the full profile')), $author$project$Api$Schema$userInfoPublic),
    zY: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$Schema$userInfoSuccess),
    z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
  });
  var $author$project$Api$Schema$user = function () {
    var resolveResult = F2(function (authResult, infoResult) {
      var _v0 = _Utils_Tuple2(authResult, infoResult);
      if (!_v0.a.$) {
        if (!_v0.b.$) {
          var authSuccess = _v0.a.a;
          var infoSuccess = _v0.b.a;
          return $elm$core$Result$Ok(A2($author$project$Api$Schema$UserQuery, authSuccess, infoSuccess));
        } else {
          var infoError = _v0.b.a;
          return $elm$core$Result$Err(infoError);
        }
      } else {
        if (!_v0.b.$) {
          var authError = _v0.a.a;
          return $elm$core$Result$Err(authError);
        } else {
          var authError = _v0.a.a;
          var infoError = _v0.b.a;
          return $elm$core$Result$Err('authError: ' + (authError + ('and infoError: ' + infoError)));
        }
      }
    });
    return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserQuery$info($author$project$Api$Schema$userInfo), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserQuery$auth($author$project$Api$Schema$authPayloadSelection), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(resolveResult)));
  }();
  var $author$project$Api$Schema$meUserQuery = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Union$MeQueryPayload$fragments({
    f4: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$IdentityUndefinedError$message),
    jW: $author$project$Api$Schema$user
  }), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Basics$identity));
  var $author$project$Api$Api$meQuery = F2(function (apiEndpoint, idToken) {
    return A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$me($author$project$Api$Schema$meUserQuery));
  });
  var $author$project$Api$Api$getUserAndUserInfo = F2(function (apiEndpoint, idToken) {
    var transformError = function (graphqlError) {
      if (graphqlError.$ === 1) {
        var httpError = graphqlError.a;
        if (httpError.$ === 3) {
          var statusCode = httpError.a.Ce;
          var statusText = httpError.a.Cf;
          return statusText;
        } else {
          return 'Getting user failed';
        }
      } else {
        var possiblyParsedData = graphqlError.a;
        var graphqlErrors = graphqlError.b;
        return $elm$core$String$concat(A2($elm$core$List$map, function ($) {
          return $.f0;
        }, graphqlErrors));
      }
    };
    return A2($elm$core$Task$mapError, transformError, A2($author$project$Api$Api$meQuery, apiEndpoint, idToken));
  });
  var $author$project$Api$GraphqlSchema$Query$user = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'user', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.od, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.uv;
    }, $author$project$Api$ScalarCodecs$codecs))]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$getUserInfoPublic = F3(function (_v0, apiEndpoint, tag) {
    var userId = _v0;
    var payload = $author$project$Api$GraphqlSchema$Union$UserInfoPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      zX: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$Schema$userInfoPublic),
      zY: A2($author$project$Api$Schema$mapField, $elm$core$Basics$always($elm$core$Result$Err('Incomplete information received: public profile instead of the full profile')), $author$project$Api$Schema$userInfoSuccess),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Nothing, A2($author$project$Api$GraphqlSchema$Query$user, {
      od: userId
    }, $author$project$Api$GraphqlSchema$Object$UserQuery$info(payload))));
  });
  var $author$project$Types$UserSessionStatus$Authenticated = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $TSFoster$elm_tuple_extra$Tuple2$double = function (a) {
    return _Utils_Tuple2(a, a);
  };
  var $author$project$ElmFramework$Lib$OrderedCollection$empty = F2(function (toId, serializeId) {
    return {
      B: $turboMaCk$any_dict$Dict$Any$empty(serializeId),
      e: _List_Nil,
      U: serializeId,
      G: toId
    };
  });
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$empty = F2(function (toId, serializeId) {
    return {
      c: A2($author$project$ElmFramework$Lib$OrderedCollection$empty, toId, serializeId),
      Cd: $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$Idle($elm$core$Maybe$Nothing),
      x: false
    };
  });
  var $turboMaCk$any_set$Set$Any$fromList = function (toComparable) {
    return A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $turboMaCk$any_dict$Dict$Any$fromList(toComparable)), $elm$core$List$map(function (a) {
      return _Utils_Tuple2(a, 0);
    }));
  };
  var $author$project$Api$GraphqlSchema$Enum$MatchAttribute$PendingRating = 1;
  var $author$project$Api$Schema$listMatchIds = $author$project$Api$GraphqlSchema$Object$ListMatchesSuccess$matches(A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Api$GraphqlSchema$Object$MatchDetails$match($author$project$Api$GraphqlSchema$Object$Match$id)));
  var $author$project$Api$Api$getPendingRatingMatches = F2(function (apiEndpoint, idToken) {
    var payload = $author$project$Api$GraphqlSchema$Union$ListMatchesPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      jr: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$Schema$listMatchIds),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message)
    });
    var optionalArguments = function (optionalArguments_) {
      return _Utils_update(optionalArguments_, {
        cZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
          g3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
            dx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            d$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            eK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(_List_fromArray([1]))
          }),
          cF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          br: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          jY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          kJ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
          e_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
        })
      });
    };
    return A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$matches(A2($author$project$Api$GraphqlSchema$Object$MatchQuery$matches, optionalArguments, payload)));
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$GetUserProfile = 9;
  var $author$project$ElmFramework$Lib$Firebase$Auth$GetUserProfileOutput = F5(function (userId, email, emailVerified, displayName, photoUrl) {
    return {
      cI: displayName,
      bZ: email,
      nd: emailVerified,
      qq: photoUrl,
      e_: userId
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$getUserProfile = F2(function (apiKey, _v0) {
    var idToken = _v0.oe;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 9);
    var responseDecoder = A2($elm$json$Json$Decode$andThen, function (user) {
      if (user.$ === 1) {
        return $elm$json$Json$Decode$fail('No user found for the id token');
      } else {
        var u = user.a;
        return $elm$json$Json$Decode$succeed(u);
      }
    }, A2($elm$json$Json$Decode$map, $elm$core$List$head, A2($elm$json$Json$Decode$field, 'users', $elm$json$Json$Decode$list(A6($elm$json$Json$Decode$map5, $author$project$ElmFramework$Lib$Firebase$Auth$GetUserProfileOutput, A2($elm$json$Json$Decode$field, 'localId', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'emailVerified', $elm$json$Json$Decode$bool), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'displayName', $elm$json$Json$Decode$string)), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'photoUrl', $elm$json$Json$Decode$string)))))));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('idToken', $elm$json$Json$Encode$string(idToken))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$Api$Api$getUserSessionStatus = function (_v0) {
    var firebaseApiKey = _v0.nE;
    var apiEndpoint = _v0.lJ;
    var auth = _v0.bN;
    var _v1 = auth;
    var idToken = _v1.oe;
    var refreshToken = _v1.qW;
    var expiresIn = _v1.v3;
    var _v2 = idToken;
    var idTokenRaw = _v2;
    return A2($elm$core$Task$andThen, function (firebaseUserProfile) {
      var buildUserSession = F4(function (userInfoSuccess, userId, pendingMatches, maybeIdentityMetadata) {
        var _v7 = userInfoSuccess;
        var activities = _v7.lz;
        var unsupportedActivities = _v7.sL;
        var notificationSettings = _v7.pJ;
        var paymentMethods = _v7.qj;
        var profile = _v7.qI;
        var statistics = _v7.r5;
        var unreadNotifications = _v7.C2;
        var pushDevices = _v7.qO;
        var paymentPreferences = _v7.qk;
        return $elm$core$Task$succeed($author$project$Types$UserSessionStatus$Onboarded({
          lz: activities,
          bN: auth,
          tH: $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$Search$unwrapSearchId),
          uI: 0,
          nd: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function ($) {
            return $.nd;
          }, maybeIdentityMetadata)),
          wA: A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$empty, A2($elm$core$Basics$composeR, function ($) {
            return $.xX;
          }, function ($) {
            return $.od;
          }), $author$project$Types$Match$unwrapMatchId),
          yC: A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$empty, A2($elm$core$Basics$composeR, function ($) {
            return $.xX;
          }, function ($) {
            return $.od;
          }), $author$project$Types$Match$unwrapMatchId),
          pJ: notificationSettings,
          qj: $krisajenkins$remotedata$RemoteData$succeed(A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$PaymentMethod$unwrapPaymentMethodId, A2($elm$core$List$map, function (method) {
            return _Utils_Tuple2(method.od, method);
          }, paymentMethods))),
          qk: paymentPreferences,
          Ag: $elm$core$Maybe$Nothing,
          Aj: $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$Match$unwrapMatchId),
          Ak: $turboMaCk$any_dict$Dict$Any$empty($author$project$Types$Search$unwrapSearchId),
          Al: $krisajenkins$remotedata$RemoteData$NotAsked,
          Am: A2($turboMaCk$any_set$Set$Any$fromList, $author$project$Types$Match$unwrapMatchId, pendingMatches),
          AR: A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$empty, function ($) {
            return $.uV;
          }, A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $elm$time$Time$posixToMillis)),
          BK: A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$empty, A2($elm$core$Basics$composeR, function ($) {
            return $.kH;
          }, function ($) {
            return $.od;
          }), $author$project$Types$Search$unwrapSearchId),
          kO: {
            qO: A2($turboMaCk$any_dict$Dict$Any$fromList, $elm$core$Basics$identity, A2($elm$core$List$map, A2($elm$core$Basics$composeR, $TSFoster$elm_tuple_extra$Tuple2$double, $elm$core$Tuple$mapFirst(function ($) {
              return $.li;
            })), pushDevices)),
            C1: 0,
            C3: unreadNotifications
          },
          r5: statistics,
          C4: _List_Nil,
          sL: unsupportedActivities,
          e_: userId,
          Db: {
            bZ: profile.bZ,
            nF: profile.nF,
            nM: profile.nM,
            oU: profile.oU,
            iT: profile.iT,
            qo: profile.qo,
            qq: profile.qq
          },
          DC: $krisajenkins$remotedata$RemoteData$NotAsked
        }));
      });
      return A2($elm$core$Task$onError, $elm$core$Task$fail, A2($elm$core$Task$andThen, function (result) {
        if (!result.$) {
          var userInfo = result.a;
          var _v4 = userInfo.bN.yk;
          if (_v4.$ === 1) {
            return $elm$core$Task$succeed($author$project$Types$UserSessionStatus$Authenticated({
              bN: auth,
              bZ: firebaseUserProfile.bZ
            }));
          } else {
            var userIdString = _v4.a;
            return A2($elm$core$Task$onError, $elm$core$Task$fail, A2($elm$core$Task$andThen, function (pendingRatingMatchesResult) {
              if (!pendingRatingMatchesResult.$) {
                var pendingMatchesList = pendingRatingMatchesResult.a;
                return A4(buildUserSession, userInfo.wL, userIdString, pendingMatchesList, userInfo.bN.wF);
              } else {
                var err = pendingRatingMatchesResult.a;
                return $elm$core$Task$fail(err);
              }
            }, A2($elm$core$Task$mapError, $elm$core$Basics$always('Getting pending rating match ids failed'), A2($author$project$Api$Api$getPendingRatingMatches, apiEndpoint, idToken))));
          }
        } else {
          var error = result.a;
          if (error === 'No identity available') {
            return $elm$core$Task$succeed($author$project$Types$UserSessionStatus$Authenticated({
              bN: auth,
              bZ: firebaseUserProfile.bZ
            }));
          } else {
            return $elm$core$Task$fail(error);
          }
        }
      }, A2($author$project$Api$Api$getUserAndUserInfo, apiEndpoint, idToken)));
    }, A2($author$project$ElmFramework$Lib$Firebase$Auth$getUserProfile, firebaseApiKey, {
      oe: idTokenRaw
    }));
  };
  var $author$project$Types$Match$JoinMatchNotEnoughRoom = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Types$Match$JoinMatchOtherError = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Api$GraphqlSchema$Union$JoinMatchPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'JoinMatchAlreadyJoined', selections____.ze), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'JoinMatchNotEnoughRoom', selections____.zf), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'JoinMatchSuccess', selections____.zg), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'MatchNotFoundError', selections____.f5), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k)]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeJoinMatchInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('matchId', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.br)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$MatchMutation$join = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'join', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeJoinMatchInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Object$JoinMatchAlreadyJoined$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$JoinMatchNotEnoughRoom$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Enum$JoinMatchPaymentProcess$Offline = 1;
  var $author$project$Api$GraphqlSchema$Enum$JoinMatchPaymentProcess$Online = 0;
  var $author$project$Api$GraphqlSchema$Enum$JoinMatchPaymentProcess$decoder = A2($elm$json$Json$Decode$andThen, function (string) {
    switch (string) {
      case 'ONLINE':
        return $elm$json$Json$Decode$succeed(0);
      case 'OFFLINE':
        return $elm$json$Json$Decode$succeed(1);
      default:
        return $elm$json$Json$Decode$fail('Invalid JoinMatchPaymentProcess type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
    }
  }, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$JoinMatchSuccess$paymentProcess = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.JoinMatchPaymentProcess.JoinMatchPaymentProcess', 'paymentProcess', _List_Nil, $author$project$Api$GraphqlSchema$Enum$JoinMatchPaymentProcess$decoder);
  var $author$project$Api$Api$joinMatch = F4(function (_v0, apiEndpoint, tag, idToken) {
    var matchId = _v0;
    var payload = $author$project$Api$GraphqlSchema$Union$JoinMatchPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Match$JoinMatchOtherError), $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Match$JoinMatchOtherError), $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Match$JoinMatchOtherError), $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Match$JoinMatchOtherError), $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      ze: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Match$JoinMatchOtherError), $author$project$Api$GraphqlSchema$Object$JoinMatchAlreadyJoined$message),
      zf: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Match$JoinMatchNotEnoughRoom), $author$project$Api$GraphqlSchema$Object$JoinMatchNotEnoughRoom$message),
      zg: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$GraphqlSchema$Object$JoinMatchSuccess$paymentProcess),
      f5: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Match$JoinMatchOtherError), $author$project$Api$GraphqlSchema$Object$MatchNotFoundError$message),
      j: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Match$JoinMatchOtherError), $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Types$Match$JoinMatchOtherError), $author$project$Api$GraphqlSchema$Object$RateLimitError$message)
    });
    var input = {
      br: matchId
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$match(A2($author$project$Api$GraphqlSchema$Object$MatchMutation$join, {
      t: input
    }, payload))));
  });
  var $author$project$Api$GraphqlSchema$Union$ListStripePaymentMethodSetupIntentsPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ListStripePaymentMethodSetupIntentsSuccess', selections____.zi), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Api$GraphqlSchema$Object$PaymentQuery$listStripePaymentMethodSetupIntents = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'listStripePaymentMethodSetupIntents', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Query$payments = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'payments', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$Api$listStripePaymentMethodSetupIntents = F3(function (apiEndpoint, tag, idToken) {
    var payload = $author$project$Api$GraphqlSchema$Union$ListStripePaymentMethodSetupIntentsPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      zi: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$payments($author$project$Api$GraphqlSchema$Object$PaymentQuery$listStripePaymentMethodSetupIntents(payload))));
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$FetchNewTokensFromRefreshToken = 13;
  var $author$project$ElmFramework$Lib$Firebase$Auth$FetchNewTokensOutput = F4(function (userId, idToken, refreshToken, expiresIn) {
    return {
      v3: expiresIn,
      oe: idToken,
      qW: refreshToken,
      e_: userId
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$fetchNewTokensFromRefreshToken = F2(function (apiKey, _v0) {
    var refreshToken = _v0.qW;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 13);
    var responseDecoder = A5($elm$json$Json$Decode$map4, $author$project$ElmFramework$Lib$Firebase$Auth$FetchNewTokensOutput, A2($elm$json$Json$Decode$field, 'user_id', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'id_token', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'refresh_token', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'expires_in', $author$project$ElmFramework$Lib$Firebase$Auth$integerStringDecoder));
    var grantType = 'refresh_token';
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('refresh_token', $elm$json$Json$Encode$string(refreshToken)), _Utils_Tuple2('grant_type', $elm$json$Json$Encode$string(grantType))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$Api$Api$refreshTokens = F2(function (apiKey, currentRefreshToken) {
    return A2($author$project$ElmFramework$Lib$Firebase$Auth$fetchNewTokensFromRefreshToken, apiKey, {
      qW: currentRefreshToken
    });
  });
  var $author$project$Api$GraphqlSchema$Union$RequestSupportPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericSuccess', selections____.T), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'IdentityUndefinedError', selections____.f4), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Api$GraphqlSchema$Enum$SupportReason$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'BILLING';
      case 1:
        return 'CREDIT_INCOMPLETE_GAME';
      default:
        return 'GENERAL';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeSupportRequestInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('comment', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.mw))), _Utils_Tuple2('reason', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$SupportReason$toString, input____.qV)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$SupportMutation$submit = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'submit', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeSupportRequestInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$GraphqlSchema$Mutation$support = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'support', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$Api$requestSupport = F5(function (comment, reason, apiEndpoint, tag, idToken) {
    var payload = $author$project$Api$GraphqlSchema$Union$RequestSupportPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      T: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      f4: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$IdentityUndefinedError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    var input = {
      mw: comment,
      qV: reason
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$support(A2($author$project$Api$GraphqlSchema$Object$SupportMutation$submit, {
      t: input
    }, payload))));
  });
  var $author$project$Api$GraphqlSchema$Union$RespondSearchInvitePayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericSuccess', selections____.T), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RespondSearchInviteError', selections____.zw), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RespondSearchNotInvitedError', selections____.zx), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RespondSearchParticipantsFullError', selections____.zy), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SearchNotFoundError', selections____.f6), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Api$GraphqlSchema$Object$RespondSearchInviteError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$RespondSearchNotInvitedError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$RespondSearchParticipantsFullError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Enum$RespondSearchInviteOption$toString = function (enum____) {
    if (!enum____) {
      return 'ACCEPT';
    } else {
      return 'REJECT';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeRespondSearchInviteInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('inviteKey', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeOneOfSearchIdOrInviteTokenInput(input____.ou))), _Utils_Tuple2('response', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$RespondSearchInviteOption$toString, input____.A5)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$SearchMutation$respondSearchInvite = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'respondSearchInvite', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeRespondSearchInviteInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$respondSearchInvite = F5(function (invitationRoute, response, apiEndpoint, tag, idToken) {
    var payload = $author$project$Api$GraphqlSchema$Union$RespondSearchInvitePayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      T: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      zw: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RespondSearchInviteError$message),
      zx: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RespondSearchNotInvitedError$message),
      zy: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RespondSearchParticipantsFullError$message),
      f6: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$SearchNotFoundError$message),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    var input = {
      ou: function () {
        if (!invitationRoute.$) {
          var uuid = invitationRoute.a;
          return {
            ef: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(uuid),
            by: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
          };
        } else {
          var searchId = invitationRoute.a;
          return {
            ef: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
            by: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(searchId)
          };
        }
      }(),
      A5: response
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$search(A2($author$project$Api$GraphqlSchema$Object$SearchMutation$respondSearchInvite, {
      t: input
    }, payload))));
  });
  var $author$project$ElmFramework$Lib$Geocoding$LatLng = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$Geocoding$reverseRequestForLatLng = F2(function (key, latLng) {
    return A5($author$project$ElmFramework$Lib$Geocoding$ReverseGeocodingRequest, $author$project$ElmFramework$Lib$Geocoding$LatLng(latLng), $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, key);
  });
  var $author$project$Api$GraphqlSchema$Union$SaveStripePaymentMethodIntentPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SavePaymentMethodSuccess', selections____.zA), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Types$Payment$SavePaymentMethodIntentSuccess = function (intent) {
    return {
      ot: intent
    };
  };
  var $author$project$Api$GraphqlSchema$Object$SavePaymentMethodSuccess$intent = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'intent', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$Schema$savePaymentMethodSuccess = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$SavePaymentMethodSuccess$intent($author$project$Api$Schema$stripeIntent), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Payment$SavePaymentMethodIntentSuccess));
  var $author$project$Api$GraphqlSchema$Object$PaymentMutation$saveStripePaymentMethod = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'saveStripePaymentMethod', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$Api$saveStripePaymentMethod = F3(function (apiEndpoint, tag, idToken) {
    var payload = $author$project$Api$GraphqlSchema$Union$SaveStripePaymentMethodIntentPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      zA: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$Schema$savePaymentMethodSuccess),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$payments($author$project$Api$GraphqlSchema$Object$PaymentMutation$saveStripePaymentMethod(payload))));
  });
  var $author$project$Api$GraphqlSchema$Query$contacts = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'contacts', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$SearchContactsSuccess$resolvedContacts = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'resolvedContacts', _List_Nil, object____, A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
  };
  var $author$project$Types$Contact$XrivalsContact = F3(function (userId, profile, contact) {
    return {
      uG: contact,
      qI: profile,
      e_: userId
    };
  });
  var $author$project$Api$GraphqlSchema$Object$ResolvedUserContact$contact = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'contact', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$ResolvedUserContact$profile = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'profile', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Types$Contact$UserContact = F3(function (contactId, emails, phoneNumbers) {
    return {
      uH: contactId,
      ne: emails,
      qp: phoneNumbers
    };
  });
  var $author$project$Api$GraphqlSchema$Object$UserContact$contactId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'contactId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Object$UserContact$emails = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(List String)', 'emails', _List_Nil, $elm$json$Json$Decode$list($elm$json$Json$Decode$string));
  var $author$project$Api$GraphqlSchema$Object$UserContact$phoneNumbers = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, '(List String)', 'phoneNumbers', _List_Nil, $elm$json$Json$Decode$list($elm$json$Json$Decode$string));
  var $author$project$Api$Schema$userContact = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserContact$phoneNumbers, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserContact$emails, A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UserContact$contactId, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Contact$UserContact))));
  var $author$project$Api$GraphqlSchema$Object$ResolvedUserContact$userId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'userId', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$Schema$resolvedUserContact = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ResolvedUserContact$contact($author$project$Api$Schema$userContact), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$ResolvedUserContact$profile($author$project$Api$Schema$userProfilePublic), A3($author$project$Api$Schema$withMap, $author$project$Api$GraphqlSchema$Object$ResolvedUserContact$userId, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Contact$XrivalsContact))));
  var $author$project$Api$Schema$contactsList = $author$project$Api$GraphqlSchema$Object$SearchContactsSuccess$resolvedContacts($author$project$Api$Schema$resolvedUserContact);
  var $author$project$Api$GraphqlSchema$Union$SearchContactsPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SearchContactsSuccess', selections____.zB)]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeUserContactInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('contactId', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.uH))), _Utils_Tuple2('emails', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string)(input____.ne))), _Utils_Tuple2('phoneNumbers', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string)(input____.qp)))]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeSearchContactsInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('users', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeUserContactInput)(input____.Df)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$ContactsQuery$search = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'search', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeSearchContactsInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$searchContacts = F4(function (contacts, apiEndpoint, tag, idToken) {
    var payload = $author$project$Api$GraphqlSchema$Union$SearchContactsPayload$fragments({
      zB: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$Schema$contactsList)
    });
    var input = {
      Df: A2($elm$core$List$indexedMap, F2(function (id, _v0) {
        var emails = _v0.ne;
        var phoneNumbers = _v0.qp;
        return {
          uH: $elm$core$String$fromInt(id),
          ne: emails,
          qp: phoneNumbers
        };
      }), contacts)
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$queryRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Query$contacts(A2($author$project$Api$GraphqlSchema$Object$ContactsQuery$search, {
      t: input
    }, payload))));
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$SendEmailVerificationCode = 2;
  var $author$project$ElmFramework$Lib$Firebase$Auth$sendEmailVerificationCode = F2(function (apiKey, _v0) {
    var idToken = _v0.oe;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 2);
    var responseDecoder = $elm$json$Json$Decode$succeed(0);
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('idToken', $elm$json$Json$Encode$string(idToken)), _Utils_Tuple2('requestType', $elm$json$Json$Encode$string('VERIFY_EMAIL'))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$SendPasswordResetCode = 4;
  var $author$project$ElmFramework$Lib$Firebase$Auth$sendPasswordResetCode = F2(function (apiKey, _v0) {
    var email = _v0.bZ;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 4);
    var responseDecoder = $elm$json$Json$Decode$succeed(0);
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('email', $elm$json$Json$Encode$string(email)), _Utils_Tuple2('requestType', $elm$json$Json$Encode$string('PASSWORD_RESET'))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$Remote$Model$sessionExpired = _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'User session expired please login again', _List_Nil), $author$project$TopMsg$routeTo($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials($author$project$Route$Route$DefaultSignIn)))]);
  var $author$project$ElmFramework$Lib$Firebase$Auth$SignInViaEmailAndPassword = 1;
  var $author$project$ElmFramework$Lib$Firebase$Auth$SignInViaEmailAndPasswordOutput = F5(function (userId, email, idToken, refreshToken, expiresIn) {
    return {
      bZ: email,
      v3: expiresIn,
      oe: idToken,
      qW: refreshToken,
      e_: userId
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$signInViaEmailAndPassword = F2(function (apiKey, _v0) {
    var email = _v0.bZ;
    var password = _v0.gb;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 1);
    var responseDecoder = A6($elm$json$Json$Decode$map5, $author$project$ElmFramework$Lib$Firebase$Auth$SignInViaEmailAndPasswordOutput, A2($elm$json$Json$Decode$field, 'localId', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'idToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'refreshToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'expiresIn', $author$project$ElmFramework$Lib$Firebase$Auth$integerStringDecoder));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('email', $elm$json$Json$Encode$string(email)), _Utils_Tuple2('password', $elm$json$Json$Encode$string(password)), _Utils_Tuple2('returnSecureToken', $elm$json$Json$Encode$bool(true))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$SignInWithOathCredential = 15;
  var $author$project$ElmFramework$Lib$Firebase$Auth$signInWithOauthCredential = F2(function (apiKey, input) {
    var providerId = input.kf;
    var requestUri = input.kv;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 15);
    var responseDecoder = A6($elm$json$Json$Decode$map5, $author$project$ElmFramework$Lib$Firebase$Auth$SignInViaEmailAndPasswordOutput, A2($elm$json$Json$Decode$field, 'localId', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'idToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'refreshToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'expiresIn', $author$project$ElmFramework$Lib$Firebase$Auth$integerStringDecoder));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('requestUri', $elm$json$Json$Encode$string('http://localhost')), _Utils_Tuple2('postBody', $elm$json$Json$Encode$string('id_token=' + (input.oe + ('&providerId=' + providerId)))), _Utils_Tuple2('returnSecureToken', $elm$json$Json$Encode$bool(true)), _Utils_Tuple2('returnIdpCredential', $elm$json$Json$Encode$bool(false))]));
    return A2($elm$core$Task$andThen, function (_v0) {
      var userId = _v0.e_;
      var idToken = _v0.oe;
      var refreshToken = _v0.qW;
      var expiresIn = _v0.v3;
      var email = _v0.bZ;
      return $elm$core$Task$succeed({
        bZ: email,
        v3: expiresIn,
        oe: idToken,
        qW: refreshToken,
        e_: userId
      });
    }, A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder));
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$SignUpOutput = F4(function (userId, idToken, refreshToken, expiresIn) {
    return {
      v3: expiresIn,
      oe: idToken,
      qW: refreshToken,
      e_: userId
    };
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$SignUpViaEmailAndPassword = 0;
  var $author$project$ElmFramework$Lib$Firebase$Auth$signUpViaEmailAndPassword = F2(function (apiKey, _v0) {
    var email = _v0.bZ;
    var password = _v0.gb;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 0);
    var responseDecoder = A5($elm$json$Json$Decode$map4, $author$project$ElmFramework$Lib$Firebase$Auth$SignUpOutput, A2($elm$json$Json$Decode$field, 'localId', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'idToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'refreshToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'expiresIn', $author$project$ElmFramework$Lib$Firebase$Auth$integerStringDecoder));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('email', $elm$json$Json$Encode$string(email)), _Utils_Tuple2('password', $elm$json$Json$Encode$string(password)), _Utils_Tuple2('returnSecureToken', $elm$json$Json$Encode$bool(true))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$SignUpWithOathCredential = 14;
  var $author$project$ElmFramework$Lib$Firebase$Auth$signUpWithOauthCredential = F2(function (apiKey, _v0) {
    var idToken = _v0.oe;
    var providerId = _v0.kf;
    var requestUri = _v0.kv;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 14);
    var responseDecoder = A5($elm$json$Json$Decode$map4, $author$project$ElmFramework$Lib$Firebase$Auth$SignUpOutput, A2($elm$json$Json$Decode$field, 'localId', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'idToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'refreshToken', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'expiresIn', $author$project$ElmFramework$Lib$Firebase$Auth$integerStringDecoder));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('requestUri', $elm$json$Json$Encode$string(requestUri)), _Utils_Tuple2('postBody', $elm$json$Json$Encode$string('id_token=' + (idToken + ('&providerId=' + providerId)))), _Utils_Tuple2('returnSecureToken', $elm$json$Json$Encode$bool(true)), _Utils_Tuple2('returnIdpCredential', $elm$json$Json$Encode$bool(false))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$Api$GraphqlSchema$Mutation$feedback = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'feedback', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Union$FeedbackPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'FeedbackSuccess', selections____.za), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k)]));
  };
  var $author$project$Api$GraphqlSchema$Enum$Satisfaction$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'GOOD';
      case 1:
        return 'NORMAL';
      default:
        return 'BAD';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeFeedbackInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('comment', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.mw))), _Utils_Tuple2('satisfaction', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Satisfaction$toString, input____.BB)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$FeedbackMutation$submit = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'submit', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeFeedbackInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$submitFeedback = F5(function (comment, satisfaction, apiEndpoint, tag, idToken) {
    var payload = $author$project$Api$GraphqlSchema$Union$FeedbackPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      za: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message)
    });
    var input = {
      mw: comment,
      BB: satisfaction
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$feedback(A2($author$project$Api$GraphqlSchema$Object$FeedbackMutation$submit, {
      t: input
    }, payload))));
  });
  var $author$project$Api$GraphqlSchema$Union$MatchRatingPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericSuccess', selections____.T), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'MatchNotFoundError', selections____.f5), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateUnfilledMatchInvalid', selections____.zu), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Api$GraphqlSchema$Object$RateUnfilledMatchInvalid$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$Enum$DifficultyRating$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'EASY';
      case 1:
        return 'MEDIUM';
      default:
        return 'HARD';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeMatchRatingInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('difficulty', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$DifficultyRating$toString, input____.vx))), _Utils_Tuple2('matchId', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.br)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$MatchMutation$submitRating = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'submitRating', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeMatchRatingInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$submitRating = F5(function (difficulty, _v0, apiEndpoint, tag, idToken) {
    var matchId = _v0;
    var payload = $author$project$Api$GraphqlSchema$Union$MatchRatingPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      T: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      f5: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$MatchNotFoundError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      zu: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateUnfilledMatchInvalid$message),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    var pastMatch = {
      vx: difficulty,
      br: matchId
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$match(A2($author$project$Api$GraphqlSchema$Object$MatchMutation$submitRating, {
      t: pastMatch
    }, payload))));
  });
  var $author$project$Api$GraphqlSchema$Union$TestNotificationPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericSuccess', selections____.T), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Api$GraphqlSchema$Mutation$notification = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'notification', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Enum$NotificationAction$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'MATCH_NOT_FOUND';
      case 1:
        return 'MATCHED';
      case 2:
        return 'MATCH_JOINED';
      case 3:
        return 'MATCH_CANCELLATION';
      case 4:
        return 'MATCH_SUGGESTION';
      case 5:
        return 'MATCH_RATE';
      default:
        return 'SEARCH_INVITE';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeTestNotificationInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('action', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$NotificationAction$toString, input____.tg))), _Utils_Tuple2('matchId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.br, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('searchId', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.by, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))]));
  };
  var $author$project$Api$GraphqlSchema$Object$NotificationMutation$testNotification = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'testNotification', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeTestNotificationInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$testNotification = F6(function (action, searchId, matchId, apiEndpoint, tag, idToken) {
    var payload = $author$project$Api$GraphqlSchema$Union$TestNotificationPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      T: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    var input = {
      tg: action,
      br: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, function (_v0) {
        var matchId_ = _v0;
        return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(matchId_);
      }, matchId),
      by: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, function (_v1) {
        var searchId_ = _v1;
        return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(searchId_);
      }, searchId)
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$notification(A2($author$project$Api$GraphqlSchema$Object$NotificationMutation$testNotification, {
      t: input
    }, payload))));
  });
  var $author$project$Remote$Model$toAuth = function (remote) {
    var _v0 = remote.sX;
    switch (_v0.$) {
      case 0:
        return $elm$core$Maybe$Nothing;
      case 1:
        return $elm$core$Maybe$Nothing;
      case 2:
        var authUser = _v0.a;
        return $elm$core$Maybe$Just(authUser.bN);
      default:
        var userSession = _v0.a;
        return $elm$core$Maybe$Just(userSession.bN);
    }
  };
  var $author$project$Remote$Model$toIdToken = function (remote) {
    var _v0 = remote.sX;
    switch (_v0.$) {
      case 0:
        return $elm$core$Maybe$Nothing;
      case 1:
        return $elm$core$Maybe$Nothing;
      case 2:
        var auth = _v0.a.bN;
        return $elm$core$Maybe$Just(auth.oe);
      default:
        var userSession = _v0.a;
        return $elm$core$Maybe$Just(userSession.bN.oe);
    }
  };
  var $author$project$Remote$Model$toRefreshToken = function (_v0) {
    var userSessionStatus = _v0.sX;
    switch (userSessionStatus.$) {
      case 2:
        var auth = userSessionStatus.a.bN;
        return $elm$core$Maybe$Just(auth.qW);
      case 3:
        var auth = userSessionStatus.a.bN;
        return $elm$core$Maybe$Just(auth.qW);
      default:
        return $elm$core$Maybe$Nothing;
    }
  };
  var $author$project$ElmFramework$Lib$RemoteModel$create_sendAuthenticatedRequest = F2(function (cfg, params) {
    var state = cfg.aC;
    var toAccessToken = cfg.sr;
    var _v0 = toAccessToken(state);
    if (!_v0.$) {
      var token = _v0.a;
      var internallyUpdatedRemoteState = _Utils_update(state, {
        b9: A2($elm$core$List$cons, {
          b3: params.b3,
          eA: cfg.c9
        }, state.b9)
      });
      return _Utils_Tuple3(params.fY(internallyUpdatedRemoteState), params.fk(token), _List_Nil);
    } else {
      return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$ElmFramework$Lib$RemoteModel$isRequestOngoing = function (cfg) {
    var state = cfg.aC;
    return A2($elm$core$List$member, cfg.c9, A2($elm$core$List$map, function ($) {
      return $.eA;
    }, state.b9));
  };
  var $author$project$ElmFramework$Lib$RemoteModel$isRequestNotOngoing = function (cfg) {
    return !$author$project$ElmFramework$Lib$RemoteModel$isRequestOngoing(cfg);
  };
  var $author$project$ElmFramework$Lib$RemoteModel$create_sendRequest = F2(function (cfg, params) {
    var state = cfg.aC;
    var internallyUpdatedRemoteState = _Utils_update(state, {
      b9: A2($elm$core$List$cons, {
        b3: params.b3,
        eA: cfg.c9
      }, state.b9)
    });
    return $author$project$ElmFramework$Lib$RemoteModel$isRequestNotOngoing(cfg) ? _Utils_Tuple3(params.fY(internallyUpdatedRemoteState), params.fk, _List_Nil) : _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
  });
  var $author$project$ElmFramework$Lib$RemoteModel$toRequestHelpers = function (cfg) {
    return {
      BQ: $author$project$ElmFramework$Lib$RemoteModel$create_sendAuthenticatedRequest(cfg),
      BR: $author$project$ElmFramework$Lib$RemoteModel$create_sendRequest(cfg)
    };
  };
  var $author$project$Remote$Model$toSession = function (_v0) {
    var userSessionStatus = _v0.sX;
    switch (userSessionStatus.$) {
      case 0:
        return $elm$core$Maybe$Nothing;
      case 1:
        return $elm$core$Maybe$Nothing;
      case 2:
        return $elm$core$Maybe$Nothing;
      default:
        var userSession = userSessionStatus.a;
        return $elm$core$Maybe$Just(userSession);
    }
  };
  var $author$project$Api$GraphqlSchema$Union$MeMutationPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserMutation', selections____.p1), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'IdentityUndefinedError', selections____.f4)]));
  };
  var $author$project$Api$GraphqlSchema$Union$UpdateActivitiesPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericSuccess', selections____.T), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Api$GraphqlSchema$Mutation$me = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'me', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Enum$SkillRating$toString = function (enum____) {
    switch (enum____) {
      case 0:
        return 'FIRST_TIMER';
      case 1:
        return 'BEGINNER';
      case 2:
        return 'INTERMEDIATE';
      case 3:
        return 'ADVANCED';
      default:
        return 'PRO';
    }
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeUserActivityInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('activity', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$Activity$toString, input____.du))), _Utils_Tuple2('selfDeclaredSkillRating', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$SkillRating$toString, input____.eH)))]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeUpdateActivitiesInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('activities', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodeUserActivityInput)(input____.lz))), _Utils_Tuple2('unsupportedActivities', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string)(input____.sL)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$UserMutation$updateActivities = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'updateActivities', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeUpdateActivitiesInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$updateActivities = F4(function (updateActivitiesInput, apiEndpoint, tag, idToken) {
    var updateActivitiesPayload = $author$project$Api$GraphqlSchema$Union$UpdateActivitiesPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      T: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    var requiredArguments = {
      t: updateActivitiesInput
    };
    var payload = {
      f4: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$IdentityUndefinedError$message),
      p1: A2($author$project$Api$GraphqlSchema$Object$UserMutation$updateActivities, requiredArguments, updateActivitiesPayload)
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$me($author$project$Api$GraphqlSchema$Union$MeMutationPayload$fragments(payload))));
  });
  var $author$project$Api$GraphqlSchema$Union$UpdateNotificationSettingsPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericSuccess', selections____.T), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeNotificationPreferenceInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('email', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.bZ))), _Utils_Tuple2('push', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.ew)))]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeNotificationPreferencesInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('cancellation', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeNotificationPreferenceInput(input____.mb))), _Utils_Tuple2('newMatch', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeNotificationPreferenceInput(input____.pC))), _Utils_Tuple2('noMatch', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeNotificationPreferenceInput(input____.pE))), _Utils_Tuple2('rate', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeNotificationPreferenceInput(input____.qT))), _Utils_Tuple2('searchInvite', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeNotificationPreferenceInput(input____.rs)))]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeNotificationSettingsInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('settings', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeNotificationPreferencesInput(input____.kO)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$UserMutation$updateNotificationSettings = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'updateNotificationSettings', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeNotificationSettingsInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$updateNotificationSettings = F5(function (notificationSettings, _v0, apiEndpoint, tag, idToken) {
    var userId = _v0;
    var settings = {
      mb: notificationSettings.mb,
      pC: notificationSettings.pC,
      pE: notificationSettings.pE,
      qT: notificationSettings.qT,
      rs: notificationSettings.rs
    };
    var payload = $author$project$Api$GraphqlSchema$Union$UpdateNotificationSettingsPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      T: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    var input = {
      kO: settings
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$user, {
      od: userId
    }, A2($author$project$Api$GraphqlSchema$Object$UserMutation$updateNotificationSettings, {
      t: input
    }, payload))));
  });
  var $author$project$Api$GraphqlSchema$Union$NotificationReadStatusPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericSuccess', selections____.T), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k)]));
  };
  var $author$project$Types$UserNotification$unwrapNotificationId = function (_v0) {
    var id = _v0;
    return id;
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodeNotificationReadStatusInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('notificationIds', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string)(input____.yI))), _Utils_Tuple2('status', $elm$core$Maybe$Just(A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Api$GraphqlSchema$Enum$NotificationReadStatus$toString, input____.Cd)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$NotificationMutation$updateReadStatus = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'updateReadStatus', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeNotificationReadStatusInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$updateNotificationsReadStatus = F4(function (notificationIdList, apiEndpoint, tag, idToken) {
    var payload = $author$project$Api$GraphqlSchema$Union$NotificationReadStatusPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      T: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message)
    });
    var input = {
      yI: A2($elm$core$List$map, $author$project$Types$UserNotification$unwrapNotificationId, notificationIdList),
      Cd: 0
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$notification(A2($author$project$Api$GraphqlSchema$Object$NotificationMutation$updateReadStatus, {
      t: input
    }, payload))));
  });
  var $author$project$Api$GraphqlSchema$Union$UpdatePaymentSettingsPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericSuccess', selections____.T), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodePaymentPreferencesInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('autoPay', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.tE)))]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodePaymentSettingsInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('settings', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodePaymentPreferencesInput(input____.kO)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$UserMutation$updatePaymentSettings = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'updatePaymentSettings', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodePaymentSettingsInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$updatePaymentPreferences = F4(function (isAutoPayEnabled, apiEndpoint, tag, idToken) {
    var updateActivitiesPayload = $author$project$Api$GraphqlSchema$Union$UpdatePaymentSettingsPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      T: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    var requiredArguments = {
      t: {
        kO: {
          tE: isAutoPayEnabled
        }
      }
    };
    var payload = {
      f4: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$IdentityUndefinedError$message),
      p1: A2($author$project$Api$GraphqlSchema$Object$UserMutation$updatePaymentSettings, requiredArguments, updateActivitiesPayload)
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$me($author$project$Api$GraphqlSchema$Union$MeMutationPayload$fragments(payload))));
  });
  var $author$project$Api$GraphqlSchema$Union$UpdatePushDevicesPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericSuccess', selections____.T), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodePushDeviceInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('name', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i5, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)), _Utils_Tuple2('registeredAt', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.qY, A2($author$project$Api$GraphqlSchema$Scalar$unwrapEncoder, function ($) {
      return $.up;
    }, $author$project$Api$ScalarCodecs$codecs))), _Utils_Tuple2('token', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.li)))]));
  };
  var $author$project$Api$GraphqlSchema$InputObject$encodePushDevicesInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('device', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.vq, $author$project$Api$GraphqlSchema$InputObject$encodePushDeviceInput)), _Utils_Tuple2('devices', A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.vw, $dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Api$GraphqlSchema$InputObject$encodePushDeviceInput)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$UserMutation$updatePushDevices = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'updatePushDevices', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodePushDevicesInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$updatePushDevices = F5(function (pushDevice, _v0, apiEndpoint, tag, idToken) {
    var userId = _v0;
    var payload = $author$project$Api$GraphqlSchema$Union$UpdatePushDevicesPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      T: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    var input = {
      vq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present({
        i5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(pushDevice.i5),
        qY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(pushDevice.qY),
        li: pushDevice.li
      }),
      vw: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$user, {
      od: userId
    }, A2($author$project$Api$GraphqlSchema$Object$UserMutation$updatePushDevices, {
      t: input
    }, payload))));
  });
  var $author$project$Api$GraphqlSchema$Union$UpdateSearchPayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SearchNotFoundError', selections____.f6), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SearchUpdateInvalid', selections____.zF), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UpdateSearchSuccess', selections____.zT), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Api$GraphqlSchema$Object$SearchUpdateInvalid$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
  var $author$project$Api$GraphqlSchema$InputObject$encodeUpdateSearchInput = function (input____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(_List_fromArray([_Utils_Tuple2('search', $elm$core$Maybe$Just($author$project$Api$GraphqlSchema$InputObject$encodeSearchParamsInput(input____.kH))), _Utils_Tuple2('searchId', $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.by)))]));
  };
  var $author$project$Api$GraphqlSchema$Object$SearchMutation$update = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'update', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeUpdateSearchInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Types$Search$SearchAndPricing = F2(function (pricing, search) {
    return {
      AA: pricing,
      kH: search
    };
  });
  var $author$project$Api$GraphqlSchema$Object$UpdateSearchSuccess$pricing = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'pricing', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$GraphqlSchema$Object$UpdateSearchSuccess$updatedSearch = function (object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'updatedSearch', _List_Nil, object____, $elm$core$Basics$identity);
  };
  var $author$project$Api$Schema$updateSearchSuccess = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UpdateSearchSuccess$updatedSearch($author$project$Api$Schema$search), A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Api$GraphqlSchema$Object$UpdateSearchSuccess$pricing($author$project$Api$Schema$pricingEstimate), $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Types$Search$SearchAndPricing)));
  var $author$project$Api$Api$updateSearch = F5(function (_v0, searchParams, apiEndpoint, tag, idToken) {
    var searchId = _v0;
    var payload = $author$project$Api$GraphqlSchema$Union$UpdateSearchPayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      f6: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$SearchNotFoundError$message),
      zF: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$SearchUpdateInvalid$message),
      zT: A2($author$project$Api$Schema$mapField, $elm$core$Result$Ok, $author$project$Api$Schema$updateSearchSuccess),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    var input = {
      kH: $author$project$Types$Search$toSearchParamsInput(searchParams),
      by: searchId
    };
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), $author$project$Api$GraphqlSchema$Mutation$search(A2($author$project$Api$GraphqlSchema$Object$SearchMutation$update, {
      t: input
    }, payload))));
  });
  var $author$project$Api$GraphqlSchema$Union$UpdateUserProfilePayload$fragments = function (selections____) {
    return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(_List_fromArray([A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ApplicationNeedsUpdate', selections____.f), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackendTimeoutError', selections____.g), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericError', selections____.h), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericSuccess', selections____.T), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInputError', selections____.i), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PermissionDeniedError', selections____.j), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RateLimitError', selections____.k), A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'UserNotFoundError', selections____.z)]));
  };
  var $author$project$Api$GraphqlSchema$Object$UserMutation$updateProfile = F2(function (requiredArgs____, object____) {
    return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'updateProfile', _List_fromArray([A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.t, $author$project$Api$GraphqlSchema$InputObject$encodeUserProfileInput)]), object____, $elm$core$Basics$identity);
  });
  var $author$project$Api$Api$updateUser = F6(function (userProfile, _v0, env, apiEndpoint, tag, idToken) {
    var userId = _v0;
    var payload = $author$project$Api$GraphqlSchema$Union$UpdateUserProfilePayload$fragments({
      f: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$ApplicationNeedsUpdate$message),
      g: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$BackendTimeoutError$message),
      h: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$GenericError$message),
      T: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Result$Ok(0)),
      i: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$InvalidInputError$message),
      j: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$PermissionDeniedError$message),
      k: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$RateLimitError$message),
      z: A2($author$project$Api$Schema$mapField, $elm$core$Result$Err, $author$project$Api$GraphqlSchema$Object$UserNotFoundError$message)
    });
    return A2($elm$core$Task$attempt, tag, A3($author$project$Api$Api$mutationRequestTask, apiEndpoint, $elm$core$Maybe$Just(idToken), A2($author$project$Api$GraphqlSchema$Mutation$user, {
      od: userId
    }, A2($author$project$Api$GraphqlSchema$Object$UserMutation$updateProfile, {
      t: A2($author$project$Types$UserProfile$toUserProfileInput, userProfile, env)
    }, payload))));
  });
  var $author$project$ElmFramework$Lib$Firebase$Auth$VerifyPasswordResetCode = 5;
  var $author$project$ElmFramework$Lib$Firebase$Auth$VerifyPasswordResetCodeOutput = function (email) {
    return {
      bZ: email
    };
  };
  var $author$project$ElmFramework$Lib$Firebase$Auth$verifyPasswordResetCode = F2(function (apiKey, _v0) {
    var resetCode = _v0.q9;
    var url = A2($author$project$ElmFramework$Lib$Firebase$Auth$getActionUrl, apiKey, 5);
    var responseDecoder = A2($elm$json$Json$Decode$map, $author$project$ElmFramework$Lib$Firebase$Auth$VerifyPasswordResetCodeOutput, A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string));
    var requestEncoder = $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('oobCode', $elm$json$Json$Encode$string(resetCode))]));
    return A3($author$project$ElmFramework$Lib$Firebase$Auth$createHttpPostTask, url, requestEncoder, responseDecoder);
  });
  var $author$project$Types$Auth$wrapAuth = function (authRaw) {
    return {
      v3: authRaw.v3,
      oe: authRaw.oe,
      qW: authRaw.qW
    };
  };
  var $author$project$Remote$UpdateRequest$updateRequest = F4(function (requestMsg, global, env, state) {
    var config = global.ar;
    var helpers = $author$project$ElmFramework$Lib$RemoteModel$toRequestHelpers({
      g6: $author$project$Route$Route$authEntryRoute,
      c9: requestMsg,
      aC: state,
      sr: $author$project$Remote$Model$toIdToken
    });
    var unauthenticatedRequest = function (_v16) {
      var cmd = _v16.fk;
      var mapState = _v16.fY;
      var isMutation = _v16.b3;
      var allowSimultaneousMultipleCalls = _v16.lF;
      return helpers.BR({
        lF: false,
        fk: cmd,
        b3: isMutation,
        fY: mapState
      });
    };
    var firebaseApiKey = config.wf.Y;
    var authenticatedRequest = function (_v15) {
      var cmd = _v15.fk;
      var mapState = _v15.fY;
      var isMutation = _v15.b3;
      var allowSimultaneousMultipleCalls = _v15.lF;
      return helpers.BQ({
        lF: false,
        fk: cmd,
        b3: isMutation,
        fY: mapState
      });
    };
    var apiEndpoint = config.ts;
    switch (requestMsg.$) {
      case 0:
        var registrationAction = requestMsg.a;
        var registerOrSignInType = requestMsg.b;
        var registerNewUserCmd = function () {
          if (!registerOrSignInType.$) {
            var credentials = registerOrSignInType.a;
            return A2($author$project$ElmFramework$Lib$Firebase$Auth$signUpViaEmailAndPassword, firebaseApiKey, credentials);
          } else {
            var oauthInput = registerOrSignInType.a;
            return A2($author$project$ElmFramework$Lib$Firebase$Auth$signUpWithOauthCredential, firebaseApiKey, oauthInput);
          }
        }();
        var getSessionAndSendVerificationEmail = function (_v1) {
          var idToken = _v1.oe;
          var refreshToken = _v1.qW;
          var expiresIn = _v1.v3;
          var auth = $author$project$Types$Auth$wrapAuth({
            v3: expiresIn,
            oe: idToken,
            qW: refreshToken
          });
          var getSessionTask = $author$project$Api$Api$getUserSessionStatus({
            lJ: config.ts,
            bN: auth,
            nE: config.wf.Y
          });
          return A2($elm$core$Task$andThen, $elm$core$Basics$always(getSessionTask), A2($author$project$ElmFramework$Lib$Firebase$Auth$sendEmailVerificationCode, firebaseApiKey, {
            oe: idToken
          }));
        };
        var cmd = A2($elm$core$Task$attempt, A2($author$project$Remote$ResponseMsg$RegisterNewUser, registrationAction, registerOrSignInType), A2($elm$core$Task$andThen, getSessionAndSendVerificationEmail, registerNewUserCmd));
        return unauthenticatedRequest({
          lF: false,
          fk: cmd,
          b3: true,
          fY: function (state_) {
            return _Utils_update(state_, {
              sX: $author$project$Types$UserSessionStatus$UserAuthenticating
            });
          }
        });
      case 1:
        var idToken = requestMsg.a;
        var resendEmailVerificationCodeCmd = A2($elm$core$Task$attempt, $author$project$Remote$ResponseMsg$ResendEmailVerificationCode, A2($author$project$ElmFramework$Lib$Firebase$Auth$sendEmailVerificationCode, firebaseApiKey, {
          oe: idToken
        }));
        return unauthenticatedRequest({
          lF: false,
          fk: resendEmailVerificationCodeCmd,
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 2:
        var shouldNotifySuccess = requestMsg.a;
        var sendEmailVerificationCodeCmd = function () {
          var _v3 = $author$project$Remote$Model$toSession(state);
          if (!_v3.$) {
            var session = _v3.a;
            var _v4 = session.bN.oe;
            var idToken = _v4;
            return A2($elm$core$Task$attempt, $author$project$Remote$ResponseMsg$SendEmailVerificationCode(shouldNotifySuccess), A2($author$project$ElmFramework$Lib$Firebase$Auth$sendEmailVerificationCode, firebaseApiKey, {
              oe: idToken
            }));
          } else {
            return $elm$core$Platform$Cmd$none;
          }
        }();
        return unauthenticatedRequest({
          lF: false,
          fk: sendEmailVerificationCodeCmd,
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 3:
        var signInAction = requestMsg.a;
        var email = requestMsg.b.bZ;
        var password = requestMsg.b.gb;
        var signInCmd = A2($elm$core$Task$attempt, A2($author$project$Remote$ResponseMsg$SignIn, signInAction, $author$project$Remote$ResponseMsg$EmailAndPasswordRegisterOrSignIn({
          bZ: email,
          gb: password
        })), A2($elm$core$Task$andThen, function (_v5) {
          var userId = _v5.e_;
          var idToken = _v5.oe;
          var refreshToken = _v5.qW;
          var expiresIn = _v5.v3;
          var auth = $author$project$Types$Auth$wrapAuth({
            v3: expiresIn,
            oe: idToken,
            qW: refreshToken
          });
          return $author$project$Api$Api$getUserSessionStatus({
            lJ: config.ts,
            bN: auth,
            nE: config.wf.Y
          });
        }, A2($author$project$ElmFramework$Lib$Firebase$Auth$signInViaEmailAndPassword, firebaseApiKey, {
          bZ: email,
          gb: password
        })));
        return unauthenticatedRequest({
          lF: false,
          fk: signInCmd,
          b3: false,
          fY: function (state_) {
            return _Utils_update(state_, {
              sX: $author$project$Types$UserSessionStatus$UserAuthenticating
            });
          }
        });
      case 4:
        var signInAction = requestMsg.a;
        var input = requestMsg.b;
        var signInCmd = A2($elm$core$Task$attempt, A2($author$project$Remote$ResponseMsg$SignIn, signInAction, $author$project$Remote$ResponseMsg$OauthCredentialRegisterOrSignIn(input)), A2($elm$core$Task$andThen, function (_v6) {
          var userId = _v6.e_;
          var idToken = _v6.oe;
          var refreshToken = _v6.qW;
          var expiresIn = _v6.v3;
          var auth = $author$project$Types$Auth$wrapAuth({
            v3: expiresIn,
            oe: idToken,
            qW: refreshToken
          });
          return $author$project$Api$Api$getUserSessionStatus({
            lJ: config.ts,
            bN: auth,
            nE: config.wf.Y
          });
        }, A2($author$project$ElmFramework$Lib$Firebase$Auth$signInWithOauthCredential, firebaseApiKey, input)));
        return unauthenticatedRequest({
          lF: false,
          fk: signInCmd,
          b3: false,
          fY: function (state_) {
            return _Utils_update(state_, {
              sX: $author$project$Types$UserSessionStatus$UserAuthenticating
            });
          }
        });
      case 5:
        var maybeRespondToInvitation = requestMsg.a;
        var maybeRouteCmd = requestMsg.b;
        var persistedAuth = requestMsg.c;
        var initializeUserSessionStatusCmd = function () {
          var _v7 = persistedAuth.qW;
          var rawRefreshToken = _v7;
          return A2($elm$core$Task$attempt, A2($author$project$Remote$ResponseMsg$InitializeUserSessionStatus, maybeRespondToInvitation, maybeRouteCmd), A2($elm$core$Task$andThen, function (_v8) {
            var userId = _v8.e_;
            var idToken = _v8.oe;
            var refreshToken = _v8.qW;
            var expiresIn = _v8.v3;
            return $author$project$Api$Api$getUserSessionStatus({
              lJ: apiEndpoint,
              bN: $author$project$Types$Auth$wrapAuth({
                v3: expiresIn,
                oe: idToken,
                qW: refreshToken
              }),
              nE: firebaseApiKey
            });
          }, A2($author$project$Api$Api$refreshTokens, firebaseApiKey, rawRefreshToken)));
        }();
        return unauthenticatedRequest({
          lF: false,
          fk: initializeUserSessionStatusCmd,
          b3: true,
          fY: function (state_) {
            return _Utils_update(state_, {
              sX: $author$project$Types$UserSessionStatus$UserAuthenticating
            });
          }
        });
      case 6:
        var maybeRoute = requestMsg.a;
        var email = requestMsg.b;
        var forgotPasswordCmd = A2($elm$core$Task$attempt, $author$project$Remote$ResponseMsg$ForgotPassword(maybeRoute), A2($author$project$ElmFramework$Lib$Firebase$Auth$sendPasswordResetCode, firebaseApiKey, {
          bZ: email
        }));
        return unauthenticatedRequest({
          lF: false,
          fk: forgotPasswordCmd,
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 7:
        var code = requestMsg.a;
        var verifyEmailCmd = A2($elm$core$Task$attempt, $author$project$Remote$ResponseMsg$VerifyEmailOobCode(1), A2($author$project$ElmFramework$Lib$Firebase$Auth$confirmEmailVerificationCode, firebaseApiKey, {
          s$: code
        }));
        return unauthenticatedRequest({
          lF: false,
          fk: verifyEmailCmd,
          b3: false,
          fY: $elm$core$Basics$identity
        });
      case 8:
        var code = requestMsg.a;
        var resetPasswordCmd = A2($elm$core$Task$attempt, $author$project$Remote$ResponseMsg$VerifyResetPasswordCode, A2($elm$core$Task$map, function (_v9) {
          var email = _v9.bZ;
          return {
            bZ: email,
            Di: code
          };
        }, A2($author$project$ElmFramework$Lib$Firebase$Auth$verifyPasswordResetCode, firebaseApiKey, {
          q9: code
        })));
        return unauthenticatedRequest({
          lF: false,
          fk: resetPasswordCmd,
          b3: false,
          fY: $elm$core$Basics$identity
        });
      case 9:
        var code = requestMsg.a.uo;
        var newPassword = requestMsg.a.f2;
        var resetPasswordCmd = A2($elm$core$Task$attempt, $author$project$Remote$ResponseMsg$CreateNewPasswordFromForgotPassword, A2($author$project$ElmFramework$Lib$Firebase$Auth$confirmPasswordResetCode, firebaseApiKey, {
          f2: newPassword,
          qb: code
        }));
        return unauthenticatedRequest({
          lF: false,
          fk: resetPasswordCmd,
          b3: false,
          fY: $elm$core$Basics$identity
        });
      case 10:
        var email = requestMsg.a.bZ;
        var password = requestMsg.a.gb;
        var newPassword = requestMsg.a.f2;
        var signInCmd = A2($elm$core$Task$attempt, $author$project$Remote$ResponseMsg$ConfirmCredentialsForChangePassword(newPassword), A2($elm$core$Task$andThen, function (_v10) {
          var userId = _v10.e_;
          var idToken = _v10.oe;
          var refreshToken = _v10.qW;
          var expiresIn = _v10.v3;
          var auth = $author$project$Types$Auth$wrapAuth({
            v3: expiresIn,
            oe: idToken,
            qW: refreshToken
          });
          return $author$project$Api$Api$getUserSessionStatus({
            lJ: config.ts,
            bN: auth,
            nE: config.wf.Y
          });
        }, A2($author$project$ElmFramework$Lib$Firebase$Auth$signInViaEmailAndPassword, firebaseApiKey, {
          bZ: email,
          gb: password
        })));
        return unauthenticatedRequest({
          lF: false,
          fk: signInCmd,
          b3: false,
          fY: function (state_) {
            return _Utils_update(state_, {
              sX: $author$project$Types$UserSessionStatus$UserAuthenticating
            });
          }
        });
      case 12:
        var updateActivitiesInput = requestMsg.a;
        return authenticatedRequest({
          lF: false,
          fk: A3($author$project$Api$Api$updateActivities, updateActivitiesInput, apiEndpoint, $author$project$Remote$ResponseMsg$UpdateActivities),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 13:
        var isAutoPayEnabled = requestMsg.a;
        return authenticatedRequest({
          lF: false,
          fk: A3($author$project$Api$Api$updatePaymentPreferences, isAutoPayEnabled, apiEndpoint, $author$project$Remote$ResponseMsg$UpdatePaymentPreferences(isAutoPayEnabled)),
          b3: true,
          fY: $author$project$Remote$Model$mapSession(function (session) {
            return _Utils_update(session, {
              qk: {
                w9: isAutoPayEnabled
              }
            });
          })
        });
      case 11:
        var idToken = requestMsg.a.oe;
        var newPassword = requestMsg.a.f2;
        var changePassCmd = function (dToken) {
          return A2($elm$core$Task$attempt, $author$project$Remote$ResponseMsg$SubmitChangePassword, A2($author$project$ElmFramework$Lib$Firebase$Auth$changeUserPassword, firebaseApiKey, {
            oe: idToken,
            f2: newPassword
          }));
        };
        return authenticatedRequest({
          lF: false,
          fk: changePassCmd,
          b3: false,
          fY: $elm$core$Basics$identity
        });
      case 14:
        return authenticatedRequest({
          lF: false,
          fk: A2($author$project$Api$Api$getSupportReasons, apiEndpoint, $author$project$Remote$ResponseMsg$GetSupportReasons),
          b3: false,
          fY: $elm$core$Basics$identity
        });
      case 15:
        var userId = requestMsg.a;
        return unauthenticatedRequest({
          lF: false,
          fk: A3($author$project$Api$Api$getUserInfoPublic, userId, apiEndpoint, $author$project$Remote$ResponseMsg$GetUserInfoPublic(userId)),
          b3: false,
          fY: $elm$core$Basics$identity
        });
      case 17:
        return authenticatedRequest({
          lF: false,
          fk: A2($author$project$Api$Api$getCancelMatchReasons, apiEndpoint, $author$project$Remote$ResponseMsg$GetCancelMatchReasons),
          b3: false,
          fY: $elm$core$Basics$identity
        });
      case 16:
        var matchId = requestMsg.a;
        return authenticatedRequest({
          lF: false,
          fk: A3($author$project$Api$Api$joinMatch, matchId, apiEndpoint, $author$project$Remote$ResponseMsg$JoinMatch(matchId)),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 18:
        var matchId = requestMsg.a;
        var reason = requestMsg.b;
        return authenticatedRequest({
          lF: false,
          fk: A4($author$project$Api$Api$cancelMatch, matchId, reason, apiEndpoint, $author$project$Remote$ResponseMsg$CancelMatch(matchId)),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 19:
        var searchId = requestMsg.a;
        return authenticatedRequest({
          lF: false,
          fk: A3($author$project$Api$Api$cancelSearch, searchId, apiEndpoint, $author$project$Remote$ResponseMsg$CancelSearch(searchId)),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 20:
        var searchParams = requestMsg.a;
        var isEmptyPaymentMethods = requestMsg.b;
        return authenticatedRequest({
          lF: false,
          fk: A3($author$project$Api$Api$createSearch, searchParams, apiEndpoint, $author$project$Remote$ResponseMsg$CreateSearch(isEmptyPaymentMethods)),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 21:
        var searchId = requestMsg.a;
        var matchSearchParams = requestMsg.b;
        return authenticatedRequest({
          lF: false,
          fk: A4($author$project$Api$Api$updateSearch, searchId, matchSearchParams, apiEndpoint, $author$project$Remote$ResponseMsg$EditSearch),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 22:
        var difficultyRating = requestMsg.a;
        var matchId = requestMsg.b;
        return authenticatedRequest({
          lF: false,
          fk: A4($author$project$Api$Api$submitRating, difficultyRating, matchId, apiEndpoint, $author$project$Remote$ResponseMsg$SubmitMatchRating(matchId)),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 23:
        var matchSearchId = requestMsg.a;
        return authenticatedRequest({
          lF: false,
          fk: A3($author$project$Api$Api$getSearchPricing, matchSearchId, apiEndpoint, $author$project$Remote$ResponseMsg$SearchPricing),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 24:
        var searchId = requestMsg.a;
        return authenticatedRequest({
          lF: false,
          fk: A2($elm$core$Basics$composeL, A3($author$project$Api$Api$getSearchInvite, $author$project$Ui$Invitation$Route$Search(searchId), apiEndpoint, $author$project$Remote$ResponseMsg$GetSearch), $elm$core$Maybe$Just),
          b3: false,
          fY: $elm$core$Basics$identity
        });
      case 25:
        var invitationRoute = requestMsg.a;
        if (!invitationRoute.$) {
          return unauthenticatedRequest({
            lF: false,
            fk: A4($author$project$Api$Api$getSearchInvite, invitationRoute, apiEndpoint, $author$project$Remote$ResponseMsg$GetSearchInvite, $elm$core$Maybe$Nothing),
            b3: false,
            fY: $elm$core$Basics$identity
          });
        } else {
          return authenticatedRequest({
            lF: false,
            fk: A2($elm$core$Basics$composeL, A3($author$project$Api$Api$getSearchInvite, invitationRoute, apiEndpoint, $author$project$Remote$ResponseMsg$GetSearchInvite), $elm$core$Maybe$Just),
            b3: false,
            fY: $elm$core$Basics$identity
          });
        }
      case 26:
        var routeToSearches = requestMsg.a;
        var invitationRoute = requestMsg.b;
        var response = requestMsg.c;
        return authenticatedRequest({
          lF: false,
          fk: A4($author$project$Api$Api$respondSearchInvite, invitationRoute, response, apiEndpoint, A2($author$project$Remote$ResponseMsg$RespondSearchInvite, routeToSearches, response)),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 27:
        var matchId = requestMsg.a;
        return authenticatedRequest({
          lF: false,
          fk: A3($author$project$Api$Api$getMatch, matchId, apiEndpoint, $author$project$Remote$ResponseMsg$GetMatch),
          b3: false,
          fY: $elm$core$Basics$identity
        });
      case 28:
        var commment = requestMsg.a;
        var satisfaction = requestMsg.b;
        return authenticatedRequest({
          lF: false,
          fk: A4($author$project$Api$Api$submitFeedback, commment, satisfaction, apiEndpoint, $author$project$Remote$ResponseMsg$SubmitFeedback(satisfaction)),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 29:
        var commment = requestMsg.a;
        var reason = requestMsg.b;
        return authenticatedRequest({
          lF: false,
          fk: A4($author$project$Api$Api$requestSupport, commment, reason, apiEndpoint, $author$project$Remote$ResponseMsg$RequestSupport),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 30:
        var notificationSettings = requestMsg.a;
        var userId = requestMsg.b;
        return authenticatedRequest({
          lF: false,
          fk: A4($author$project$Api$Api$updateNotificationSettings, notificationSettings, userId, apiEndpoint, $author$project$Remote$ResponseMsg$UpdateNotificationSettings(notificationSettings)),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 31:
        return authenticatedRequest({
          lF: false,
          fk: A2($author$project$Api$Api$getUnreadNotifications, apiEndpoint, $author$project$Remote$ResponseMsg$GetUnreadNotifications),
          b3: false,
          fY: $elm$core$Basics$identity
        });
      case 32:
        var notificationIdList = requestMsg.a;
        return authenticatedRequest({
          lF: false,
          fk: A3($author$project$Api$Api$updateNotificationsReadStatus, notificationIdList, apiEndpoint, $author$project$Remote$ResponseMsg$UpdateNotificationsReadStatus),
          b3: false,
          fY: $elm$core$Basics$identity
        });
      case 33:
        var notificationId = requestMsg.a;
        var maybeRoute = requestMsg.b;
        return authenticatedRequest({
          lF: false,
          fk: A3($author$project$Api$Api$updateNotificationsReadStatus, _List_fromArray([notificationId]), apiEndpoint, $author$project$Remote$ResponseMsg$UpdateTappedNotificationStatusAndRoute(maybeRoute)),
          b3: false,
          fY: $elm$core$Basics$identity
        });
      case 34:
        var action = requestMsg.a;
        var searchId = requestMsg.b;
        var matchId = requestMsg.c;
        return authenticatedRequest({
          lF: false,
          fk: A5($author$project$Api$Api$testNotification, action, searchId, matchId, apiEndpoint, $author$project$Remote$ResponseMsg$TestNotification),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 35:
        var userId = requestMsg.a;
        var pushDevice = requestMsg.b;
        return authenticatedRequest({
          lF: false,
          fk: A4($author$project$Api$Api$updatePushDevices, pushDevice, userId, apiEndpoint, $author$project$Remote$ResponseMsg$UpdatePushDevices(pushDevice)),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 36:
        var cmd = function (idToken) {
          return A2($elm$core$Task$attempt, $author$project$Remote$ResponseMsg$GetMeUserData, A2($elm$core$Task$andThen, function (result) {
            if (!result.$) {
              var r = result.a;
              return $elm$core$Task$succeed(r.wL);
            } else {
              var e = result.a;
              return $elm$core$Task$fail(e);
            }
          }, A2($author$project$Api$Api$getUserAndUserInfo, apiEndpoint, idToken)));
        };
        return authenticatedRequest({
          lF: false,
          fk: cmd,
          b3: false,
          fY: $elm$core$Basics$identity
        });
      case 37:
        var userId = requestMsg.a;
        var userProfile = requestMsg.b;
        var maybeRoute = requestMsg.c;
        return authenticatedRequest({
          lF: false,
          fk: A5($author$project$Api$Api$updateUser, userProfile, userId, env, apiEndpoint, A2($author$project$Remote$ResponseMsg$UpdateUser, maybeRoute, userProfile)),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 38:
        var maybeRespondToInvitation = requestMsg.a;
        var userProfile = requestMsg.b;
        var maybeRoute = requestMsg.c;
        var _v13 = $author$project$Remote$Model$toAuth(state);
        if (!_v13.$) {
          var auth = _v13.a;
          return authenticatedRequest({
            lF: false,
            fk: A4($author$project$Api$Api$createUser, userProfile, env, {
              lJ: apiEndpoint,
              bN: auth,
              nE: firebaseApiKey
            }, A2($author$project$Remote$ResponseMsg$CreateUser, maybeRespondToInvitation, maybeRoute)),
            b3: true,
            fY: $elm$core$Basics$identity
          });
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $author$project$Remote$Model$sessionExpired);
        }
      case 39:
        var userId = requestMsg.a;
        return authenticatedRequest({
          lF: false,
          fk: A3($author$project$Api$Api$disableUser, userId, apiEndpoint, $author$project$Remote$ResponseMsg$DisableUser),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 40:
        var matchId = requestMsg.a;
        return authenticatedRequest({
          lF: false,
          fk: A4($author$project$Api$Api$createPaymentIntentForMatch, matchId, {
            BZ: true
          }, apiEndpoint, $author$project$Remote$ResponseMsg$CreatePaymentIntentForMatch(matchId)),
          b3: true,
          fY: $author$project$Remote$Model$mapSession(function (session) {
            return _Utils_update(session, {
              Aj: A3($turboMaCk$any_dict$Dict$Any$insert, matchId, $krisajenkins$remotedata$RemoteData$Loading, session.Aj)
            });
          })
        });
      case 41:
        return authenticatedRequest({
          lF: false,
          fk: A2($author$project$Api$Api$listStripePaymentMethodSetupIntents, apiEndpoint, $author$project$Remote$ResponseMsg$ListStripePaymentMethodSetupIntents),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 42:
        return authenticatedRequest({
          lF: false,
          fk: A2($author$project$Api$Api$saveStripePaymentMethod, apiEndpoint, $author$project$Remote$ResponseMsg$SaveStripePaymentMethod),
          b3: true,
          fY: $author$project$Remote$Model$mapSession(function (session) {
            return _Utils_update(session, {
              Al: $krisajenkins$remotedata$RemoteData$Loading
            });
          })
        });
      case 43:
        var paymentMethodId = requestMsg.a;
        return authenticatedRequest({
          lF: false,
          fk: A3($author$project$Api$Api$deleteStripePaymentMethod, paymentMethodId, apiEndpoint, $author$project$Remote$ResponseMsg$RemoveStripePaymentMethod(paymentMethodId)),
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 44:
        var _v14 = $author$project$Remote$Model$toRefreshToken(state);
        if (!_v14.$) {
          var refreshTokenString = _v14.a;
          return unauthenticatedRequest({
            lF: false,
            fk: A2($elm$core$Task$attempt, $author$project$Remote$ResponseMsg$RefreshToken, A2($author$project$Api$Api$refreshTokens, firebaseApiKey, refreshTokenString)),
            b3: true,
            fY: $elm$core$Basics$identity
          });
        } else {
          return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $author$project$Remote$Model$sessionExpired);
        }
      case 45:
        var requestedFrom = requestMsg.a;
        var geolocation = requestMsg.b;
        var latitude = geolocation.fU;
        var longitude = geolocation.fX;
        var reverseGeocodingCmd = A2($author$project$ElmFramework$Lib$Geocoding$sendReverseRequest, A2($author$project$Remote$ResponseMsg$ReverseGeocoding, requestedFrom, geolocation), A2($author$project$ElmFramework$Lib$Geocoding$reverseRequestForLatLng, global.ar.wf.Y, _Utils_Tuple2(latitude, longitude)));
        return unauthenticatedRequest({
          lF: false,
          fk: reverseGeocodingCmd,
          b3: true,
          fY: $elm$core$Basics$identity
        });
      case 46:
        var addressBookContacts = requestMsg.a;
        return authenticatedRequest({
          lF: false,
          fk: A3($author$project$Api$Api$searchContacts, addressBookContacts, apiEndpoint, $author$project$Remote$ResponseMsg$SearchContacts),
          b3: false,
          fY: $elm$core$Basics$identity
        });
      default:
        return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
    }
  });
  var $author$project$Api$GraphqlSchema$Enum$RespondSearchInviteOption$Accept = 0;
  var $author$project$Ui$Match$Msg$CancelMatchReasonsFetched = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $author$project$Ui$Auth$Msg$ClearChangePasswordState = {
    $: 19
  };
  var $author$project$Ui$Feedback$Msg$ClearState = {
    $: 3
  };
  var $author$project$Route$Route$CreateNewPassword = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Global$Model$EmailNotVerifiedDialog = {
    $: 17
  };
  var $author$project$Global$Model$FeedbackSentDialog = {
    $: 2
  };
  var $author$project$Global$Model$FeedbackSentSuggestAppstoreReviewDialog = {
    $: 1
  };
  var $author$project$ElmFramework$Lib$RemoteModel$GeneralErrHandler_DefaultToast = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Api$GraphqlSchema$Enum$Satisfaction$Good = 0;
  var $author$project$Global$Msg$HideDialog = {
    $: 12
  };
  var $author$project$Ui$MoreOptions$Msg$HideEmailUnverifiedNoticeAndButton = 0;
  var $author$project$Global$Model$JoinMatchNotEnoughRoom = {
    $: 20
  };
  var $author$project$Global$Model$MatchSlotCanceled = function (a) {
    return {
      $: 8,
      a: a
    };
  };
  var $author$project$Remote$RequestMsg$NoOp = {
    $: 47
  };
  var $author$project$Global$Model$PostPaymentActiveSearchConfirmationDialog = F2(function (a, b) {
    return {
      $: 14,
      a: a,
      b: b
    };
  });
  var $author$project$Util$OnRouteCmd$ReplaceRoute = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $author$project$Remote$RequestMsg$ResendEmailVerificationCode = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Route$Route$ResendEmailVerificationLink = {
    $: 1
  };
  var $author$project$Ui$CreateOrEditSearch$Msg$ResetState = {
    $: 7
  };
  var $author$project$Ui$OnboardUser$Msg$ResetState = {
    $: 3
  };
  var $author$project$Remote$RequestMsg$RespondSearchInvite = F3(function (a, b, c) {
    return {
      $: 26,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Route$Route$RespondToInviteAfterCreatingUser = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$OnboardUser$Msg$RespondToInviteAfterCreatingUser = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$Invitation$Msg$SearchInviteFetchError = {
    $: 2
  };
  var $author$project$Ui$Invitation$Msg$SearchInviteFetched = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Remote$RequestMsg$SendEmailVerificationCode = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$MyPlayerStatus$Msg$SetRapidTicker = {
    $: 5
  };
  var $author$project$Remote$RequestMsg$SignInWithEmail = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$RequestMsg$SubmitChangePassword = function (a) {
    return {
      $: 11,
      a: a
    };
  };
  var $author$project$Ui$Support$Msg$SupportReasonsFetched = function (a) {
    return {
      $: 5,
      a: a
    };
  };
  var $author$project$Global$Model$SupportRequestSentDialog = {
    $: 3
  };
  var $author$project$TopMsg$authMsg = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$AuthMsg);
  var $author$project$Types$NotificationSettings$enablePushPreference = function (preference) {
    return _Utils_update(preference, {
      ew: true
    });
  };
  var $author$project$Types$NotificationSettings$enablePushForAll = function (notificationSettings) {
    var cancellation = notificationSettings.mb;
    var newMatch = notificationSettings.pC;
    var noMatch = notificationSettings.pE;
    var rate = notificationSettings.qT;
    var searchInvite = notificationSettings.rs;
    return _Utils_update(notificationSettings, {
      mb: $author$project$Types$NotificationSettings$enablePushPreference(cancellation),
      pC: $author$project$Types$NotificationSettings$enablePushPreference(newMatch),
      pE: $author$project$Types$NotificationSettings$enablePushPreference(noMatch),
      qT: $author$project$Types$NotificationSettings$enablePushPreference(rate),
      rs: $author$project$Types$NotificationSettings$enablePushPreference(searchInvite)
    });
  };
  var $author$project$Types$ParticipantPublic$fromUserProfile = F2(function (userId, userProfile) {
    return {
      nF: userProfile.nF,
      nM: userProfile.nM,
      fT: userProfile.oU,
      c5: userProfile.qq,
      e_: userId
    };
  });
  var $author$project$Types$GeoLocation$geoLocationFromGps = function (_v0) {
    var latitude = _v0.fU;
    var longitude = _v0.fX;
    var accuracy = _v0.gV;
    return {
      ds: accuracy < 1000 ? 0 : 1,
      cx: $elm$core$Maybe$Just($elm$core$Basics$round(accuracy)),
      em: 0,
      es: {
        oV: latitude,
        o_: longitude
      }
    };
  };
  var $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName = function (_v0) {
    var shortName = _v0.BW;
    var longName = _v0.xW;
    return A3($elm$core$Maybe$map2, F2(function (shortName_, longName_) {
      return _Utils_Tuple2(shortName_, longName_);
    }), shortName, longName);
  };
  var $author$project$ElmFramework$Lib$GeoCodingHelpers$ifNotFoundThenTry = F3(function (addressComponents, componentType, maybe) {
    if (!maybe.$) {
      return maybe;
    } else {
      return A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
        return $.sF;
      }, $elm$core$List$member(componentType)), addressComponents)));
    }
  });
  var $author$project$ElmFramework$Lib$GeoCodingHelpers$getCity = function (_v0) {
    var addressComponents = _v0.bd;
    return A3($author$project$ElmFramework$Lib$GeoCodingHelpers$ifNotFoundThenTry, addressComponents, 15, A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
      return $.sF;
    }, $elm$core$List$member(11)), addressComponents))));
  };
  var $author$project$ElmFramework$Lib$GeoCodingHelpers$getCountry = function (_v0) {
    var addressComponents = _v0.bd;
    return A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
      return $.sF;
    }, $elm$core$List$member(4)), addressComponents)));
  };
  var $author$project$ElmFramework$Lib$GeoCodingHelpers$getEstablishmentOrPremise = function (_v0) {
    var addressComponents = _v0.bd;
    return A3($author$project$ElmFramework$Lib$GeoCodingHelpers$ifNotFoundThenTry, addressComponents, 19, A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
      return $.sF;
    }, $elm$core$List$member(29)), addressComponents))));
  };
  var $author$project$ElmFramework$Lib$GeoCodingHelpers$getRegion = function (_v0) {
    var addressComponents = _v0.bd;
    return A3($author$project$ElmFramework$Lib$GeoCodingHelpers$ifNotFoundThenTry, addressComponents, 6, A3($author$project$ElmFramework$Lib$GeoCodingHelpers$ifNotFoundThenTry, addressComponents, 5, A3($author$project$ElmFramework$Lib$GeoCodingHelpers$ifNotFoundThenTry, addressComponents, 12, A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
      return $.sF;
    }, $elm$core$List$member(11)), addressComponents))))));
  };
  var $author$project$ElmFramework$Lib$GeoCodingHelpers$getState = function (_v0) {
    var addressComponents = _v0.bd;
    return A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
      return $.sF;
    }, $elm$core$List$member(5)), addressComponents)));
  };
  var $author$project$ElmFramework$Lib$GeoCodingHelpers$getStreetAddress = function (_v0) {
    var addressComponents = _v0.bd;
    return A3($author$project$ElmFramework$Lib$GeoCodingHelpers$ifNotFoundThenTry, addressComponents, 12, A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
      return $.sF;
    }, $elm$core$List$any(function (addressType) {
      return A2($elm$core$List$member, addressType, _List_fromArray([0, 1]));
    })), addressComponents))));
  };
  var $author$project$ElmFramework$Lib$GeoCodingHelpers$getStreetNumber = function (_v0) {
    var addressComponents = _v0.bd;
    return A2($elm$core$Maybe$andThen, $author$project$ElmFramework$Lib$GeoCodingHelpers$extractShortNameAndLongName, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function ($) {
      return $.sF;
    }, $elm$core$List$member(26)), addressComponents)));
  };
  var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(function (ma, mb) {
    if (mb.$ === 1) {
      return ma;
    } else {
      return mb;
    }
  });
  var $author$project$Ui$ProvideLocation$Helpers$geocodingResultToTitleAndSubtitle = function (geocodingResult) {
    var tryLongName = function (_v5) {
      var first = _v5.a;
      var second = _v5.b;
      return second === '' ? first : second;
    };
    var maybeStreetAndNumberOrRegion = function () {
      var maybeStreetAndNumber = A2($elm$core$Maybe$map, function (street) {
        var maybeStreetNumber = A2($elm$core$Maybe$map, tryLongName, $author$project$ElmFramework$Lib$GeoCodingHelpers$getStreetNumber(geocodingResult));
        if (!maybeStreetNumber.$) {
          var streetNumber = maybeStreetNumber.a;
          return street + (' ' + streetNumber);
        } else {
          return street;
        }
      }, A2($elm$core$Maybe$map, tryLongName, $author$project$ElmFramework$Lib$GeoCodingHelpers$getStreetAddress(geocodingResult)));
      if (!maybeStreetAndNumber.$) {
        var streetAndNumber = maybeStreetAndNumber.a;
        return $elm$core$Maybe$Just(streetAndNumber);
      } else {
        return A2($elm$core$Maybe$map, tryLongName, $author$project$ElmFramework$Lib$GeoCodingHelpers$getRegion(geocodingResult));
      }
    }();
    var maybeEstablishmentOrPremise = A2($elm$core$Maybe$map, tryLongName, $author$project$ElmFramework$Lib$GeoCodingHelpers$getEstablishmentOrPremise(geocodingResult));
    var maybeCityAndCountry = function () {
      var maybeCountry = A2($elm$core$Maybe$map, tryLongName, $author$project$ElmFramework$Lib$GeoCodingHelpers$getCountry(geocodingResult));
      var maybeCityOrState = A2($elm$core$Maybe$map, tryLongName, function (maybeCity) {
        if (!maybeCity.$) {
          return maybeCity;
        } else {
          return $author$project$ElmFramework$Lib$GeoCodingHelpers$getState(geocodingResult);
        }
      }($author$project$ElmFramework$Lib$GeoCodingHelpers$getCity(geocodingResult)));
      if (!maybeCountry.$) {
        var country = maybeCountry.a;
        if (!maybeCityOrState.$) {
          var cityOrState = maybeCityOrState.a;
          return $elm$core$Maybe$Just(cityOrState + (', ' + country));
        } else {
          return $elm$core$Maybe$Just(country);
        }
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }();
    return A3($elm$core$Maybe$map2, F2(function (title, subtitle) {
      return {
        lb: subtitle,
        lh: title
      };
    }), A2($elm_community$maybe_extra$Maybe$Extra$orElse, maybeStreetAndNumberOrRegion, maybeEstablishmentOrPremise), maybeCityAndCountry);
  };
  var $author$project$Remote$UpdateResponse$newUserAuthenticated = _Platform_outgoingPort('newUserAuthenticated', function ($) {
    return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('expiresIn', $elm$json$Json$Encode$int($.v3)), _Utils_Tuple2('idToken', $elm$json$Json$Encode$string($.oe)), _Utils_Tuple2('refreshToken', $elm$json$Json$Encode$string($.qW))]));
  });
  var $author$project$Remote$Model$updateUserAuth = F2(function (remoteState, newUserAuth) {
    return _Utils_update(remoteState, {
      sX: newUserAuth
    });
  });
  var $author$project$Remote$Model$updateTokens = F2(function (newAuthTokens, remoteState) {
    var _v0 = remoteState.sX;
    switch (_v0.$) {
      case 0:
        return remoteState;
      case 1:
        return remoteState;
      case 2:
        var authDetails = _v0.a;
        return A2($author$project$Remote$Model$updateUserAuth, remoteState, $author$project$Types$UserSessionStatus$Authenticated(_Utils_update(authDetails, {
          bN: newAuthTokens
        })));
      default:
        var userSession = _v0.a;
        return A2($author$project$Remote$Model$updateUserAuth, remoteState, $author$project$Types$UserSessionStatus$Onboarded(_Utils_update(userSession, {
          bN: newAuthTokens
        })));
    }
  });
  var $author$project$Remote$UpdateResponse$handleNewTokens = function (topMsgs) {
    return F2(function (successfulResult, state) {
      var userId = successfulResult.e_;
      var idToken = successfulResult.oe;
      var refreshToken = successfulResult.qW;
      var expiresIn = successfulResult.v3;
      return _Utils_Tuple3(A2($author$project$Remote$Model$updateTokens, $author$project$Types$Auth$wrapAuth(successfulResult), state), $author$project$Remote$UpdateResponse$newUserAuthenticated({
        v3: expiresIn,
        oe: idToken,
        qW: refreshToken
      }), topMsgs);
    });
  };
  var $author$project$Route$Route$matchMakingSingleCheckoutPaymentRoute = A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Route$Route$Matchmaking, $elm$core$Basics$identity), $author$project$Ui$Matchmaking$Single$Route$Checkout), $author$project$Ui$Matchmaking$Checkout$Route$Payment);
  var $author$project$Route$Route$matchMakingSingleCheckoutSelectPaymentMethodRoute = $author$project$Route$Route$matchMakingSingleCheckoutPaymentRoute(0);
  var $author$project$TopMsg$moreOptionsMsg = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$MoreOptionsMsg);
  var $author$project$TopMsg$msgFeedback = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$FeedbackMsg);
  var $author$project$Msg$RouteCmd = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$TopMsg$msgRouteCmd = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$RouteCmd);
  var $author$project$TopMsg$msgSupport = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$SupportMsg);
  var $author$project$Route$Route$myPlayerStatusRoute = $author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Upcoming);
  var $author$project$Route$Route$myPlayerStatusRouteSearches = $author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Searches($author$project$Ui$MyPlayerStatus$Searches$Route$SearchesList));
  var $author$project$Global$Msg$GlobalOnAuthInitStateForRouteHandler = 0;
  var $author$project$Ui$Matchmaking$Checkout$Msg$OnAuth = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$NotificationsSettings$Msg$OnAuth = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$Support$Msg$OnAuth = {
    $: 1
  };
  var $author$project$Ui$Auth$UserSession$Msg$OnAuthSuccess = {
    $: 1
  };
  var $author$project$Ui$Match$Msg$OnAuthSuccess = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$Matchmaking$Single$Msg$OnAuthSuccess = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$PaymentMethods$Edit$Msg$OnAuthSuccess = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$Auth$Msg$ResetState = {
    $: 20
  };
  var $author$project$MulticastMessages$onAuthSuccess = function (session) {
    return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg(A2($author$project$Global$Msg$OnAuthSuccess, 0, session))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$AuthMsg($author$project$Ui$Auth$Msg$ResetState)), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$NotificationsSettingsMsg($author$project$Ui$NotificationsSettings$Msg$OnAuth(session))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$MatchmakingMsg($author$project$Ui$Matchmaking$Msg$SingleMsgReceived($author$project$Ui$Matchmaking$Single$Msg$OnAuthSuccess(session)))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$MatchmakingMsg($author$project$Ui$Matchmaking$Msg$CheckoutMsgReceived($author$project$Ui$Matchmaking$Checkout$Msg$OnAuth(session)))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$EditPersonalDetailsMsg(0)), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$PaymentMethodsMsg($author$project$Ui$PaymentMethods$Msg$OnRouteOrAuth)), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$PaymentMethodsMsg($author$project$Ui$PaymentMethods$Msg$EditMsgReceived($author$project$Ui$PaymentMethods$Edit$Msg$OnAuthSuccess(session)))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$UserSessionMsg($author$project$Ui$Auth$UserSession$Msg$OnAuthSuccess)), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$MatchMsg($author$project$Ui$Match$Msg$OnAuthSuccess(session))), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$SupportMsg($author$project$Ui$Support$Msg$OnAuth)), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$InvitationMsg($author$project$Ui$Invitation$Msg$OnAuthOrRoute))]);
  };
  var $author$project$Global$Msg$OnUnauth = {
    $: 4
  };
  var $author$project$PushMessages$Msg$OnUnauth = {
    $: 2
  };
  var $author$project$MulticastMessages$onUnauth = _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$PushMessagesMsg($author$project$PushMessages$Msg$OnUnauth)), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$GlobalMsg($author$project$Global$Msg$OnUnauth)), $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$AuthMsg($author$project$Ui$Auth$Msg$ResetState))]);
  var $author$project$ElmFramework$Lib$OrderedCollection$prepend = F2(function (newList, _v0) {
    var toId = _v0.G;
    var serializeId = _v0.U;
    var list = _v0.e;
    return A3($author$project$ElmFramework$Lib$OrderedCollection$fromList, toId, serializeId, _Utils_ap(newList, list));
  });
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$prepend = F2(function (items, endlessList) {
    return {
      c: A2($author$project$ElmFramework$Lib$OrderedCollection$prepend, items, endlessList.c),
      Cd: endlessList.Cd,
      x: endlessList.x
    };
  });
  var $author$project$Remote$UpdateResponse$resetAuthState = $author$project$TopMsg$authMsg($author$project$Ui$Auth$Msg$ResetState);
  var $author$project$Ui$Match$Route$PayMatch = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $turboMaCk$any_dict$Dict$Any$isEmpty = function (_v0) {
    var dict = _v0.B;
    return $elm$core$Dict$isEmpty(dict);
  };
  var $author$project$TopMsg$routeToPayment = F2(function (session, matchId) {
    var _v0 = session.qj;
    if (_v0.$ === 3) {
      var anydictMethods = _v0.a;
      return $turboMaCk$any_dict$Dict$Any$isEmpty(anydictMethods) ? $author$project$TopMsg$routeTo(A2($author$project$Route$Route$Match, matchId, $author$project$Ui$Match$Route$PayMatch(1))) : $author$project$TopMsg$routeTo(A2($author$project$Route$Route$Match, matchId, $author$project$Ui$Match$Route$PayMatch(0)));
    } else {
      return $author$project$TopMsg$noOpMsg;
    }
  });
  var $author$project$TopMsg$routeToReplace = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$RoutingMsg, A2($author$project$ElmFramework$Feature$Navigation$Msg$RouteTo, true, false));
  var $author$project$Types$LocalDateTime$toDurationMinutes = F2(function (from, to) {
    var millisTo = $elm$time$Time$posixToMillis(A2($author$project$Types$LocalDateTime$toPosix, $elm$time$Time$utc, to));
    var millisFrom = $elm$time$Time$posixToMillis(A2($author$project$Types$LocalDateTime$toPosix, $elm$time$Time$utc, from));
    return $elm$core$Basics$round((millisTo - millisFrom) / 1000 / 60 / 60);
  });
  var $author$project$Analytics$searchCreated = F2(function (location_currentTime, _v0) {
    var params = _v0.p8;
    var toAvailability = function (_v2) {
      var from = _v2.wh;
      var to = _v2.CC;
      var toHour = function (_v1) {
        var hour = _v1.wC;
        var minute = _v1.yu;
        return hour + minute / 60;
      };
      var startsIn = A2($author$project$Types$LocalDateTime$toDurationMinutes, location_currentTime, from) / 60;
      return $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('availability_period_from_hour', $elm$json$Json$Encode$float(toHour(from))), _Utils_Tuple2('availability_period_to_hour', $elm$json$Json$Encode$float(toHour(to))), _Utils_Tuple2('availability_period_duration_hours', $elm$json$Json$Encode$float(toHour(to) - toHour(from))), _Utils_Tuple2('availability_period_starts_in_hours', $elm$json$Json$Encode$float(startsIn))]));
    };
    return A2($author$project$ElmFramework$Feature$Analytics$Analytics$sendEventCustom, 'search_created', _List_fromArray([_Utils_Tuple2('the_search_activity', $elm$json$Json$Encode$string(A2($author$project$Types$Activity$toString, false, params.du))), _Utils_Tuple2('the_search_availability_periods', A2($elm$json$Json$Encode$list, toAvailability, params.tF)), _Utils_Tuple2('the_search_location', $elm$json$Json$Encode$string(params.cy.lh + (' ' + params.cy.lb))), _Utils_Tuple2('the_search_radius_km', $elm$json$Json$Encode$int(params.Dr))]));
  });
  var $author$project$TopMsg$searchInviteMsg = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$InvitationMsg);
  var $author$project$Route$Route$searchesRoute = $author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Searches($author$project$Ui$MyPlayerStatus$Searches$Route$SearchesList));
  var $author$project$Analytics$signUpAttempt = A2($author$project$ElmFramework$Feature$Analytics$Analytics$sendEvent, 'sign_up_attempt', _List_Nil);
  var $author$project$Analytics$signUpAttemptInvitation = A2($author$project$ElmFramework$Feature$Analytics$Analytics$sendEvent, 'invite_signup', _List_Nil);
  var $author$project$ElmFramework$Lib$Util$dropFirstThatSatisfies = F2(function (predicate, list) {
    if (!list.b) {
      return _List_Nil;
    } else {
      var a = list.a;
      var rest = list.b;
      return predicate(a) ? rest : A2($elm$core$List$cons, a, A2($author$project$ElmFramework$Lib$Util$dropFirstThatSatisfies, predicate, rest));
    }
  });
  var $author$project$ElmFramework$Lib$RemoteModel$dropOngoingRequest = function (cfg) {
    var state = cfg.aC;
    return _Utils_update(state, {
      b9: A2($author$project$ElmFramework$Lib$Util$dropFirstThatSatisfies, A2($elm$core$Basics$composeR, function ($) {
        return $.eA;
      }, $elm$core$Basics$eq(cfg.c9)), state.b9)
    });
  };
  var $author$project$ElmFramework$Lib$StateUpdater$mergeTupleFromState = F2(function (fromState, _v0) {
    var state = _v0.a;
    var cmd = _v0.b;
    var list = _v0.c;
    var _v1 = fromState(state);
    var newState = _v1.a;
    var newCmd = _v1.b;
    var newList = _v1.c;
    return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$batch(_List_fromArray([newCmd, cmd])), _Utils_ap(list, newList));
  });
  var $author$project$ElmFramework$Lib$RemoteModel$create_handleResponse = F2(function (cfg, params) {
    var state = cfg.aC;
    var newState = $author$project$ElmFramework$Lib$RemoteModel$dropOngoingRequest(cfg);
    var handledTuple = function () {
      var _v0 = params.ag;
      if (!_v0.$) {
        var value = _v0.a;
        return A2(params.jR, value, newState);
      } else {
        var error = _v0.a;
        return A2(params.c1, error, newState);
      }
    }();
    return A2($author$project$ElmFramework$Lib$StateUpdater$mergeTupleFromState, params.c0, handledTuple);
  });
  var $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportDetailsAsString = function (record) {
    return $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$detailedError({
      d1: $elm$json$Json$Encode$string(record.vp),
      c_: record.c_
    });
  };
  var $author$project$ElmFramework$Lib$RemoteModel$handleHttpBadStatus = F4(function (cfg, meta, responseBody, remoteState) {
    var _v0 = cfg.nO;
    switch (_v0.$) {
      case 0:
        var string = _v0.a;
        var strings = _v0.b;
        return _Utils_Tuple3(remoteState, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportDetailsAsString({
          vp: responseBody,
          c_: 'Response error'
        }), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, string, strings)]));
      case 1:
        var decoder = _v0.a;
        var defaultErrMsg = _v0.b;
        var _v1 = A2($author$project$ElmFramework$Lib$Util$decodeString, decoder, responseBody);
        if (!_v1.$) {
          var value = _v1.a;
          return _Utils_Tuple3(remoteState, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportDetailsAsString({
            vp: A2($elm$core$String$join, ', ', value.yn),
            c_: 'Response error: ' + value.nk
          }), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, value.nk, value.yn)]));
        } else {
          return _Utils_Tuple3(remoteState, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportDetailsAsString({
            vp: responseBody,
            c_: 'Undecodable error'
          }), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, defaultErrMsg, _List_Nil)]));
        }
      default:
        var handleResponseBody = _v0.a;
        return A2(handleResponseBody, responseBody, remoteState);
    }
  });
  var $author$project$ElmFramework$Lib$RemoteModel$handleGqlHttpError = F3(function (cfg, httpError, remoteState) {
    switch (httpError.$) {
      case 0:
        var string = httpError.a;
        return _Utils_Tuple3(remoteState, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Graphql.Http.BadUrl: ' + string), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Bad URL', _List_fromArray([string]))]));
      case 1:
        return _Utils_Tuple3(remoteState, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Graphql.Http.Timeout'), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Request timed out', _List_fromArray(['Try again maybe?']))]));
      case 2:
        return _Utils_Tuple3(remoteState, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Graphql.Http.NetworkError'), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Network error', _List_fromArray(['Please check whether your network is on and functional']))]));
      case 3:
        var meta = httpError.a;
        var responseBody = httpError.b;
        return meta.Ce === 401 ? _Utils_Tuple3(remoteState, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportDetailsAsString({
          vp: responseBody,
          c_: 'Graphql.Http.BadStatus: Not Authenticated: 401'
        }), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Error: Not authenticated', _List_fromArray(['Please log in first'])), $author$project$ElmFramework$MsgCmd$msgCmd.Bt(cfg.g6)])) : A4($author$project$ElmFramework$Lib$RemoteModel$handleHttpBadStatus, cfg, meta, responseBody, remoteState);
      default:
        var jdErr = httpError.a;
        return _Utils_Tuple3(remoteState, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError('Graphql.Http.BadPayload: ' + $elm$json$Json$Decode$errorToString(jdErr)), _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Bad payload / Unexpected response', _List_fromArray([A2($elm$core$String$left, 200, $elm$json$Json$Decode$errorToString(jdErr))]))]));
    }
  });
  var $author$project$ElmFramework$Lib$RemoteModel$handleGraphqlError = F3(function (cfg, error, remoteState) {
    var toastAndReportGraphqlError = function (gqlErr) {
      return _Utils_Tuple2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$generalError(gqlErr.f0), A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, gqlErr.f0, _List_Nil));
    };
    if (!error.$) {
      var graphqlErrors = error.b;
      return function (errs) {
        return _Utils_Tuple3(remoteState, A3($elm$core$List$foldl, F2(function (_v1, acc) {
          var reportCmd = _v1.a;
          return $elm$core$Platform$Cmd$batch(_List_fromArray([reportCmd, acc]));
        }), $elm$core$Platform$Cmd$none, errs), A2($elm$core$List$map, $elm$core$Tuple$second, errs));
      }(A2($elm$core$List$map, toastAndReportGraphqlError, graphqlErrors));
    } else {
      var httpError = error.a;
      return A3($author$project$ElmFramework$Lib$RemoteModel$handleGqlHttpError, cfg, httpError, remoteState);
    }
  });
  var $author$project$ElmFramework$Lib$RemoteModel$create_handleResponseSuccess = F2(function (cfg, params) {
    var state = cfg.aC;
    var newState = $author$project$ElmFramework$Lib$RemoteModel$dropOngoingRequest(cfg);
    var _v0 = params.ag;
    if (!_v0.$) {
      var value = _v0.a;
      return A2(params.jR, value, newState);
    } else {
      var error = _v0.a;
      return A3($author$project$ElmFramework$Lib$RemoteModel$handleGraphqlError, cfg, error, newState);
    }
  });
  var $author$project$ElmFramework$Lib$RemoteModel$create_handleResponseWithExpectedErr = F2(function (cfg, params) {
    var state = cfg.aC;
    var newState = $author$project$ElmFramework$Lib$RemoteModel$dropOngoingRequest(cfg);
    var handledTuple = function () {
      var _v0 = params.ag;
      if (!_v0.$) {
        if (!_v0.a.$) {
          var value = _v0.a.a;
          return A2(params.jR, value, newState);
        } else {
          var err = _v0.a.a;
          return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, err, _List_Nil)]));
        }
      } else {
        var error = _v0.a;
        return A2($author$project$ElmFramework$Lib$StateUpdater$mergeTupleFromState, A2($author$project$ElmFramework$Lib$RemoteModel$handleGraphqlError, cfg, error), A2(params.c1, error, newState));
      }
    }();
    return A2($author$project$ElmFramework$Lib$StateUpdater$mergeTupleFromState, params.c0, handledTuple);
  });
  var $author$project$ElmFramework$Lib$RemoteModel$create_handleResponseWithExpectedErr_success = F2(function (cfg, params) {
    var state = cfg.aC;
    var newState = $author$project$ElmFramework$Lib$RemoteModel$dropOngoingRequest(cfg);
    var _v0 = params.ag;
    if (!_v0.$) {
      if (!_v0.a.$) {
        var value = _v0.a.a;
        return A2(params.jR, value, newState);
      } else {
        var err = _v0.a.a;
        return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, err, _List_Nil)]));
      }
    } else {
      var error = _v0.a;
      return A3($author$project$ElmFramework$Lib$RemoteModel$handleGraphqlError, cfg, error, newState);
    }
  });
  var $author$project$ElmFramework$Lib$RemoteModel$create_handleResultResponse = F2(function (cfg, params) {
    var state = cfg.aC;
    var newState = $author$project$ElmFramework$Lib$RemoteModel$dropOngoingRequest(cfg);
    var handledTuple = function () {
      var _v0 = params.ag;
      if (!_v0.$) {
        var value = _v0.a;
        return A2(params.jR, value, newState);
      } else {
        var error = _v0.a;
        return A2(params.c1, error, newState);
      }
    }();
    return A2($author$project$ElmFramework$Lib$StateUpdater$mergeTupleFromState, params.c0, handledTuple);
  });
  var $author$project$ElmFramework$Lib$RemoteModel$create_handleResultResponseSuccess = F2(function (cfg, params) {
    var state = cfg.aC;
    var newState = $author$project$ElmFramework$Lib$RemoteModel$dropOngoingRequest(cfg);
    var _v0 = params.ag;
    if (!_v0.$) {
      var value = _v0.a;
      return A2(params.jR, value, newState);
    } else {
      var error = _v0.a;
      return _Utils_Tuple3(newState, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, params.nn(error), _List_Nil)]));
    }
  });
  var $author$project$ElmFramework$Lib$RemoteModel$toResponseHandlers = function (cfg) {
    return {
      A5: $author$project$ElmFramework$Lib$RemoteModel$create_handleResponse(cfg),
      A6: $author$project$ElmFramework$Lib$RemoteModel$create_handleResultResponse(cfg),
      A7: $author$project$ElmFramework$Lib$RemoteModel$create_handleResultResponseSuccess(cfg),
      A8: $author$project$ElmFramework$Lib$RemoteModel$create_handleResponseSuccess(cfg),
      A9: $author$project$ElmFramework$Lib$RemoteModel$create_handleResponseWithExpectedErr(cfg),
      Ba: $author$project$ElmFramework$Lib$RemoteModel$create_handleResponseWithExpectedErr_success(cfg)
    };
  };
  var $author$project$Types$Auth$unwrapIdToken = function (_v0) {
    var token = _v0;
    return token;
  };
  var $author$project$Types$Auth$unwrapRefreshToken = function (_v0) {
    var token = _v0;
    return token;
  };
  var $author$project$Types$Auth$unwrapAuth = function (auth) {
    return {
      v3: auth.v3,
      oe: $author$project$Types$Auth$unwrapIdToken(auth.oe),
      qW: $author$project$Types$Auth$unwrapRefreshToken(auth.qW)
    };
  };
  var $author$project$Remote$UpdateResponse$updateResponse = F6(function (zone, currTime, env, currentState, requestMsg, responseMsg) {
    var handleMaybeRouteCmd = function (maybeRouteCmd) {
      if (!maybeRouteCmd.$) {
        var routeCmd = maybeRouteCmd.a;
        return $author$project$TopMsg$msgRouteCmd(routeCmd);
      } else {
        return $author$project$TopMsg$noOpMsg;
      }
    };
    var handle = $author$project$ElmFramework$Lib$RemoteModel$toResponseHandlers({
      g6: $author$project$Route$Route$authEntryRoute,
      nO: A2($author$project$ElmFramework$Lib$RemoteModel$GeneralErrHandler_DefaultToast, 'Unexpected response', _List_fromArray(['Try again, maybe?'])),
      c9: requestMsg,
      aC: currentState
    });
    switch (responseMsg.$) {
      case 0:
        return _Utils_Tuple3(currentState, $elm$core$Platform$Cmd$none, _List_Nil);
      case 1:
        var registrationAction = responseMsg.a;
        var registerType = responseMsg.b;
        var result = responseMsg.c;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            return _Utils_Tuple3(_Utils_update(state, {
              sX: $author$project$Types$UserSessionStatus$Unauthenticated
            }), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil)]));
          }),
          jR: F2(function (userSessionStatus, state) {
            var trackingEvent = function () {
              if (!registrationAction.$) {
                return $author$project$Analytics$signUpAttempt;
              } else {
                var invitationRoute = registrationAction.a;
                var response = registrationAction.b;
                return $author$project$Analytics$signUpAttemptInvitation;
              }
            }();
            var signInAction = function () {
              if (!registrationAction.$) {
                return $author$project$Route$Route$DefaultSignIn;
              } else {
                var invitationRoute = registrationAction.a;
                var response = registrationAction.b;
                return A2($author$project$Route$Route$RespondToInviteAfterCreatingUser, invitationRoute, response);
              }
            }();
            var signInMsg = $author$project$ElmFramework$Msg$AppMsg(A2($author$project$Msg$RemoteResponseMsg, $author$project$Remote$RequestMsg$NoOp, A3($author$project$Remote$ResponseMsg$SignIn, signInAction, registerType, $elm$core$Result$Ok(userSessionStatus))));
            return _Utils_Tuple3(_Utils_update(state, {
              sX: $author$project$Types$UserSessionStatus$Unauthenticated
            }), trackingEvent, _List_fromArray([signInMsg]));
          }),
          ag: result
        });
      case 2:
        var result = responseMsg.a;
        return handle.A7({
          nn: $elm$core$Basics$identity,
          jR: F2(function (_v3, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Nothing, 'We have sent you a new verification link to your email', _List_Nil)]));
          }),
          ag: result
        });
      case 3:
        var shouldNotifySuccess = responseMsg.a;
        var result = responseMsg.b;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            var displayErrorOrNoOp = error === 'Too many attempts try later' && !shouldNotifySuccess ? _List_Nil : _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil)]);
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _Utils_ap(displayErrorOrNoOp, _List_fromArray([$author$project$TopMsg$moreOptionsMsg(0)])));
          }),
          jR: F2(function (_v4, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, shouldNotifySuccess ? _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Nothing, 'We have sent you a new verification link to your email.', _List_Nil)]) : _List_Nil);
          }),
          ag: result
        });
      case 4:
        var signInAction = responseMsg.a;
        var signInType = responseMsg.b;
        var result = responseMsg.c;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            var tryAgainOrDisplayError = function () {
              if (error === 'Cloud function deadline exceeded') {
                if (!signInType.$) {
                  var email = signInType.a.bZ;
                  var password = signInType.a.gb;
                  return $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$RemoteRequestMsg(A2($author$project$Remote$RequestMsg$SignInWithEmail, signInAction, {
                    bZ: email,
                    gb: password
                  })));
                } else {
                  var input = signInType.a;
                  return $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$RemoteRequestMsg(A2($author$project$Remote$RequestMsg$SignInWithOauthCredential, signInAction, input)));
                }
              } else {
                return A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil);
              }
            }();
            return _Utils_Tuple3(_Utils_update(state, {
              sX: $author$project$Types$UserSessionStatus$Unauthenticated
            }), $elm$core$Platform$Cmd$none, _List_fromArray([tryAgainOrDisplayError]));
          }),
          jR: F2(function (userSessionStatus, state) {
            var _v6 = function () {
              var signInActionMsgs = function (idToken) {
                switch (signInAction.$) {
                  case 0:
                    return _List_Nil;
                  case 1:
                    return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$RemoteRequestMsg($author$project$Remote$RequestMsg$ResendEmailVerificationCode(idToken)))]);
                  case 2:
                    var invitationRoute = signInAction.a;
                    var respondSearchInviteOption = signInAction.b;
                    return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$RemoteRequestMsg(A3($author$project$Remote$RequestMsg$RespondSearchInvite, true, invitationRoute, respondSearchInviteOption)))]);
                  default:
                    var invitationRoute = signInAction.a;
                    var respondSearchInviteOption = signInAction.b;
                    if (!invitationRoute.$) {
                      var uuid = invitationRoute.a;
                      return _List_fromArray([$author$project$TopMsg$msgOnboardUser($author$project$Ui$OnboardUser$Msg$RespondToInviteAfterCreatingUser(uuid))]);
                    } else {
                      var searchId = invitationRoute.a;
                      return _List_Nil;
                    }
                }
              };
              var persistAuth = function (auth) {
                return $author$project$Remote$UpdateResponse$newUserAuthenticated($author$project$Types$Auth$unwrapAuth(auth));
              };
              switch (userSessionStatus.$) {
                case 0:
                  return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_Nil);
                case 1:
                  return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_Nil);
                case 2:
                  var authUser = userSessionStatus.a;
                  var routeToOnboardUser = $author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$Personal($elm$core$Maybe$Nothing)));
                  return _Utils_Tuple2(persistAuth(authUser.bN), A2($elm$core$List$cons, $author$project$Remote$UpdateResponse$resetAuthState, A2($elm$core$List$cons, routeToOnboardUser, signInActionMsgs(authUser.bN.oe))));
                default:
                  var session = userSessionStatus.a;
                  var trackingEvent = $author$project$ElmFramework$Feature$Analytics$Analytics$trackingEvents.xR($author$project$Types$User$unwrapUserId(session.e_));
                  var routeToOnboardActivities = $author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$EditUserActivities(0));
                  var newRoute = $author$project$Route$Route$myPlayerStatusRoute;
                  var initializeEditingUserProfile = $author$project$TopMsg$msgEditingUserProfile($author$project$Types$EditingUserProfile$SetState($author$project$Types$EditingUserProfile$fromUserProfile(session.Db)));
                  return _Utils_Tuple2($elm$core$Platform$Cmd$batch(_List_fromArray([persistAuth(session.bN), trackingEvent])), _Utils_ap(_List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bu(newRoute), initializeEditingUserProfile]), _Utils_ap($author$project$MulticastMessages$onAuthSuccess(session), signInActionMsgs(session.bN.oe))));
              }
            }();
            var persistAuthCmd = _v6.a;
            var routeAndInitializeMsgs = _v6.b;
            return _Utils_Tuple3(_Utils_update(state, {
              sX: userSessionStatus
            }), persistAuthCmd, routeAndInitializeMsgs);
          }),
          ag: result
        });
      case 6:
        var maybeRespondToInvitation = responseMsg.a;
        var maybeRouteCmd = responseMsg.b;
        var result = responseMsg.c;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            var topMsgs = error !== 'Token expired' ? _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil)]) : _List_Nil;
            return _Utils_Tuple3(_Utils_update(state, {
              sX: $author$project$Types$UserSessionStatus$Unauthenticated
            }), $elm$core$Platform$Cmd$none, topMsgs);
          }),
          jR: F2(function (userSessionStatus, state) {
            var _v10 = function () {
              var persistAuth = function (auth) {
                return $author$project$Remote$UpdateResponse$newUserAuthenticated($author$project$Types$Auth$unwrapAuth(auth));
              };
              switch (userSessionStatus.$) {
                case 0:
                  return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_Nil);
                case 1:
                  return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_Nil);
                case 2:
                  var authUser = userSessionStatus.a;
                  var routeToOnboardUser = _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$Personal($elm$core$Maybe$Nothing)))]);
                  return _Utils_Tuple2(persistAuth(authUser.bN), A2($elm$core$List$cons, $author$project$Remote$UpdateResponse$resetAuthState, routeToOnboardUser));
                default:
                  var session = userSessionStatus.a;
                  var respondToInvitation = function () {
                    if (!maybeRespondToInvitation.$) {
                      var uuid = maybeRespondToInvitation.a;
                      return $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$RespondSearchInvite, false, $author$project$Ui$Invitation$Route$Token(uuid), 0));
                    } else {
                      return $author$project$TopMsg$noOpMsg;
                    }
                  }();
                  var initializeOnboarding = $elm$core$List$isEmpty(session.lz) ? $author$project$TopMsg$msgEditingUserProfile($author$project$Types$EditingUserProfile$SetState($author$project$Types$EditingUserProfile$fromUserProfile(session.Db))) : $author$project$TopMsg$noOpMsg;
                  return _Utils_Tuple2($elm$core$Platform$Cmd$batch(_List_fromArray([persistAuth(session.bN), $author$project$ElmFramework$Feature$Contacts$Contacts$requestContactsPermissions(0)])), A2($elm$core$List$cons, initializeOnboarding, A2($elm$core$List$cons, respondToInvitation, $author$project$MulticastMessages$onAuthSuccess(session))));
              }
            }();
            var cmds = _v10.a;
            var topMsgs = _v10.b;
            return _Utils_Tuple3(_Utils_update(state, {
              sX: userSessionStatus
            }), cmds, A2($elm$core$List$cons, handleMaybeRouteCmd(maybeRouteCmd), topMsgs));
          }),
          ag: result
        });
      case 5:
        var maybeRoute = responseMsg.a;
        var result = responseMsg.b;
        return handle.A7({
          nn: $elm$core$Basics$identity,
          jR: F2(function (_v13, state) {
            var maybeRouteMsg = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function (route) {
              return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bt(route)]);
            }, maybeRoute));
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _Utils_ap(_List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CQ, $elm$core$Maybe$Nothing, 'We have sent you an email, please use the link on it to proceed with your new password creation.', _List_Nil)]), maybeRouteMsg));
          }),
          ag: result
        });
      case 7:
        var attempt = responseMsg.a;
        var result = responseMsg.b;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            if (error === 'Invalid oob code' && attempt < 5) {
              if (_Utils_eq(state.sX, $author$project$Types$UserSessionStatus$UserAuthenticating)) {
                return _Utils_Tuple3(state, A2($elm$core$Task$perform, $elm$core$Basics$always(A2($author$project$Remote$ResponseMsg$VerifyEmailOobCode, attempt + 1, result)), $elm$core$Process$sleep(300)), _List_Nil);
              } else {
                var _v14 = $author$project$Remote$Model$toSession(state);
                if (!_v14.$) {
                  var session = _v14.a;
                  return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$RemoteRequestMsg($author$project$Remote$RequestMsg$SendEmailVerificationCode(false))), $author$project$TopMsg$routeTo($author$project$Route$Route$homeRoute), A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Nothing, 'Email verification link has expired and we have sent a new email with verification link', _List_Nil)]));
                } else {
                  return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Nothing, 'Email verification link has expired', _List_fromArray(['Please sign in and we will automatically send a new email'])), $author$project$TopMsg$routeTo($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials($author$project$Route$Route$ResendEmailVerificationLink)))]));
                }
              }
            } else {
              return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Please try again, email verification failed', _List_Nil), $author$project$TopMsg$moreOptionsMsg(0)]));
            }
          }),
          jR: F2(function (_v15, state) {
            var routeToEntry = function () {
              var _v16 = $author$project$Remote$Model$toSession(state);
              if (!_v16.$) {
                var session = _v16.a;
                return $author$project$TopMsg$routeTo($author$project$Route$Route$homeRoute);
              } else {
                return $author$project$TopMsg$routeTo($author$project$Route$Route$authEntryRoute);
              }
            }();
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
              return _Utils_update(session, {
                nd: true
              });
            }, state), $elm$core$Platform$Cmd$none, _List_fromArray([routeToEntry, A3($author$project$ElmFramework$MsgCmd$msgCmd.CQ, $elm$core$Maybe$Nothing, 'Email verified successfully', _List_Nil)]));
          }),
          ag: result
        });
      case 8:
        var result = responseMsg.a;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil)]));
          }),
          jR: F2(function (_v17, state) {
            var email = _v17.bZ;
            var verifiedPasswordResetCode = _v17.Di;
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CQ, $elm$core$Maybe$Nothing, 'Code verified successfully, please enter a new password', _List_Nil), $author$project$TopMsg$routeToReplace($author$project$Route$Route$Auth($author$project$Route$Route$ForgotPassword($author$project$Route$Route$CreateNewPassword(verifiedPasswordResetCode))))]));
          }),
          ag: result
        });
      case 9:
        var result = responseMsg.a;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CQ, $elm$core$Maybe$Nothing, 'Failed to reset password, error: ' + (error + ', please try again'), _List_Nil)]));
          }),
          jR: F2(function (_v18, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CQ, $elm$core$Maybe$Nothing, 'Password reset successfully, please sign in with your new password', _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials($author$project$Route$Route$DefaultSignIn)))]));
          }),
          ag: result
        });
      case 10:
        var newPassword = responseMsg.a;
        var result = responseMsg.b;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            return _Utils_Tuple3(_Utils_update(state, {
              sX: $author$project$Types$UserSessionStatus$Unauthenticated
            }), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil)]));
          }),
          jR: F2(function (userSessionStatus, state) {
            var routeAndInitializeMsgs = function () {
              if (userSessionStatus.$ === 3) {
                var session = userSessionStatus.a;
                return _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$SubmitChangePassword({
                  oe: $author$project$Types$Auth$unwrapIdToken(session.bN.oe),
                  f2: newPassword
                }))]);
              } else {
                return _List_Nil;
              }
            }();
            return _Utils_Tuple3(_Utils_update(state, {
              sX: userSessionStatus
            }), $elm$core$Platform$Cmd$none, routeAndInitializeMsgs);
          }),
          ag: result
        });
      case 12:
        var gqlResult = responseMsg.a;
        return handle.Ba({
          jR: F2(function (_v20, state) {
            var maybeAuth = $author$project$Remote$Model$toAuth(state);
            if (!maybeAuth.$) {
              var auth = maybeAuth.a;
              return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$InitializeUserSession, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just($author$project$Util$OnRouteCmd$ReplaceRoute($author$project$Route$Route$homeRoute)), auth)), $author$project$TopMsg$msgOnboardUser($author$project$Ui$OnboardUser$Msg$ResetState)]));
            } else {
              return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _Utils_ap(_List_fromArray([$author$project$TopMsg$routeTo($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials($author$project$Route$Route$DefaultSignIn)))]), $author$project$Remote$Model$sessionExpired));
            }
          }),
          ag: gqlResult
        });
      case 13:
        var isAutoPayEnabled = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(A2($elm$core$Maybe$withDefault, state, A2($elm$core$Maybe$map, function (session) {
              return _Utils_update(state, {
                sX: $author$project$Types$UserSessionStatus$Onboarded(_Utils_update(session, {
                  qk: {
                    w9: isAutoPayEnabled
                  }
                }))
              });
            }, $author$project$Remote$Model$toSession(state))), $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Error updating auto pay', _List_Nil)]));
          }),
          jR: F2(function (_v22, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ag: gqlResult
        });
      case 11:
        var result = responseMsg.a;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil)]));
          }),
          jR: $author$project$Remote$UpdateResponse$handleNewTokens(_List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'You have successfully changed your password.', _List_Nil), $author$project$TopMsg$routeTo($author$project$Route$Route$MoreOptions), $author$project$TopMsg$authMsg($author$project$Ui$Auth$Msg$ClearChangePasswordState)])),
          ag: result
        });
      case 14:
        var gqlResult = responseMsg.a;
        return handle.A7({
          nn: $elm$core$Basics$always('Fetching support reasons failed'),
          jR: F2(function (supportReasonsList, state) {
            return _Utils_Tuple3(_Utils_update(state, {
              se: supportReasonsList
            }), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgSupport($author$project$Ui$Support$Msg$SupportReasonsFetched(supportReasonsList))]));
          }),
          ag: gqlResult
        });
      case 15:
        var userId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.Ba({
          jR: F2(function (publicInfo, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ag: gqlResult
        });
      case 17:
        var gqlResult = responseMsg.a;
        return handle.A7({
          nn: $elm$core$Basics$always('Fetching cancel match reasons failed'),
          jR: F2(function (cancelMatchReasons, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgMatch($author$project$Ui$Match$Msg$CancelMatchReasonsFetched(cancelMatchReasons))]));
          }),
          ag: gqlResult
        });
      case 18:
        var matchId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.Ba({
          jR: F2(function (refundResult, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
              return _Utils_update(session, {
                yC: A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$remove, matchId, session.yC)
              });
            }, state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$MatchSlotCanceled(refundResult)))]));
          }),
          ag: gqlResult
        });
      case 16:
        var matchId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            return _Utils_Tuple3(state, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleGraphqlErr, true, error), _List_Nil);
          }),
          jR: F2(function (result, state) {
            var reloadMatch = $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetMatch(matchId));
            var _v23 = _Utils_Tuple2(result, $author$project$Remote$Model$toSession(state));
            if (!_v23.a.$) {
              if (!_v23.b.$) {
                var paymentProcess = _v23.a.a;
                var session = _v23.b.a;
                if (!paymentProcess) {
                  return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A2($author$project$TopMsg$routeToPayment, session, matchId)]));
                } else {
                  var maybeParticipantPaymentStatus = A2($elm$core$Maybe$andThen, function (matchDetails) {
                    return $author$project$Types$Match$toParticipantPaymentStatus(matchDetails);
                  }, A2($author$project$Types$UserSession$findMatch, session, matchId));
                  var waitForUpdatedPaymentStatus = function () {
                    if (!maybeParticipantPaymentStatus.$) {
                      var participantPaymentStatus = maybeParticipantPaymentStatus.a;
                      return _List_fromArray([$author$project$TopMsg$msgMatch(A2($author$project$Ui$Match$Msg$WaitingForUpdatedMatchPaymentStatus, participantPaymentStatus, 15))]);
                    } else {
                      return _List_Nil;
                    }
                  }();
                  return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _Utils_ap(_List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CQ, $elm$core$Maybe$Nothing, 'You have joined the match', _List_Nil)]), waitForUpdatedPaymentStatus));
                }
              } else {
                var _v26 = _v23.b;
                return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$routeTo($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials($author$project$Route$Route$DefaultSignIn)))]));
              }
            } else {
              if (_v23.a.a.$ === 1) {
                var error = _v23.a.a.a;
                return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([reloadMatch, A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil)]));
              } else {
                var error = _v23.a.a.a;
                return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$JoinMatchNotEnoughRoom)), reloadMatch]));
              }
            }
          }),
          ag: gqlResult
        });
      case 19:
        var searchId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.Ba({
          jR: F2(function (_v27, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
              return _Utils_update(session, {
                BK: A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$remove, searchId, session.BK)
              });
            }, state), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CQ, $elm$core$Maybe$Nothing, 'Your search in progress has been cancelled.', _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Bu($author$project$Route$Route$searchesRoute), $author$project$TopMsg$msgMatchmakingSingle($author$project$Ui$Matchmaking$Single$Msg$CreateOrEditSearch($author$project$Ui$CreateOrEditSearch$Msg$ResetState))]));
          }),
          ag: gqlResult
        });
      case 20:
        var isEmptyPaymentMethods = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            return _Utils_Tuple3(state, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleGraphqlErr, true, error), _List_Nil);
          }),
          jR: function () {
            var routeToSelectPaymentMethod = $author$project$TopMsg$routeTo($author$project$Route$Route$matchMakingSingleCheckoutSelectPaymentMethodRoute);
            return F2(function (createSearchResult, state) {
              if (!createSearchResult.$) {
                var search = createSearchResult.a.kH;
                var pricing = createSearchResult.a.AA;
                var trackingEvent = A2($author$project$Analytics$searchCreated, A2($author$project$Types$LocalDateTime$fromPosix, zone, currTime), search);
                var prependSearch = function (session) {
                  return _Utils_update(session, {
                    BK: A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$prepend, _List_fromArray([{
                      uV: currTime,
                      uW: A2($author$project$Types$ParticipantPublic$fromUserProfile, session.e_, session.Db),
                      kH: search
                    }]), session.BK)
                  });
                };
                var isAutoPayEnabled = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
                  return $.qk;
                }, function ($) {
                  return $.w9;
                }), $author$project$Remote$Model$toSession(state)));
                var topMsgs = _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(A2($author$project$Global$Model$PostPaymentActiveSearchConfirmationDialog, isEmptyPaymentMethods, isAutoPayEnabled))), $author$project$TopMsg$msgMatchmakingSingle($author$project$Ui$Matchmaking$Single$Msg$CreateOrEditSearch($author$project$Ui$CreateOrEditSearch$Msg$ResetState))]);
                return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, prependSearch, state), trackingEvent, topMsgs);
              } else {
                var error = createSearchResult.a;
                switch (error.$) {
                  case 0:
                    var err = error.a;
                    return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, err, _List_Nil)]));
                  case 1:
                    var errorContent = error.a;
                    var topMsgs = function () {
                      var _v30 = errorContent.aC;
                      switch (_v30) {
                        case 0:
                          return _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'The same search preferences are already active', _List_Nil)]);
                        case 1:
                          return _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'The same search preferences are already active', _List_Nil)]);
                        case 3:
                          return _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'The same search preferences were created previously, and then cancelled — please enter new preferences', _List_Nil)]);
                        case 5:
                          return _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'This search has been created and has been scheduled. Please take a look at the upcoming matches.', _List_Nil)]);
                        case 2:
                          return _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'This search has been created. We are waiting for responses from the invited players.', _List_Nil)]);
                        default:
                          return _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'This search has been created and it has expired.', _List_Nil)]);
                      }
                    }();
                    return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, topMsgs);
                  default:
                    return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'You have unpaid matches. Please pay your past matches first.', _List_Nil), $author$project$TopMsg$routeTo($author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$History))]));
                }
              }
            });
          }(),
          ag: gqlResult
        });
      case 21:
        var gqlResult = responseMsg.a;
        return handle.Ba({
          jR: F2(function (searchAndPricing, state) {
            var paymentAction = function (searchId) {
              return _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CQ, $elm$core$Maybe$Nothing, 'Your search has been updated successfully.', _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Bu($author$project$Route$Route$matchMakingSingleCheckoutSelectPaymentMethodRoute)]);
            };
            var defaultAction = _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CQ, $elm$core$Maybe$Nothing, 'Your search has been updated successfully.', _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Bu($author$project$Route$Route$searchesRoute)]);
            var topMsgs = A2($elm$core$List$cons, $author$project$TopMsg$msgMatchmakingSingle($author$project$Ui$Matchmaking$Single$Msg$CreateOrEditSearch($author$project$Ui$CreateOrEditSearch$Msg$ResetState)), defaultAction);
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, topMsgs);
          }),
          ag: gqlResult
        });
      case 22:
        var matchId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.Ba({
          jR: F2(function (_v31, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
              return _Utils_update(session, {
                Am: A2($turboMaCk$any_set$Set$Any$remove, matchId, session.Am)
              });
            }, state), $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CQ, $elm$core$Maybe$Nothing, 'Your rating has been received', _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$History))]));
          }),
          ag: gqlResult
        });
      case 23:
        var gqlResult = responseMsg.a;
        return handle.Ba({
          jR: F2(function (_v32, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ag: gqlResult
        });
      case 24:
        var gqlResult = responseMsg.a;
        return handle.Ba({
          jR: F2(function (search, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgSingleCreateOrEditSearch($author$project$Ui$CreateOrEditSearch$Msg$InitStateForEdit(A2($author$project$Types$CreateOrEditSearchParams$fromSearch, $author$project$Remote$Model$toSession(state), search)))]));
          }),
          ag: gqlResult
        });
      case 25:
        var gqlResult = responseMsg.a;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$searchInviteMsg($author$project$Ui$Invitation$Msg$SearchInviteFetchError)]));
          }),
          jR: F2(function (searchInviteSuccessResult, state) {
            if (!searchInviteSuccessResult.$) {
              var searchInviteSuccess = searchInviteSuccessResult.a;
              return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$searchInviteMsg($author$project$Ui$Invitation$Msg$SearchInviteFetched(searchInviteSuccess))]));
            } else {
              var err = searchInviteSuccessResult.a;
              return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$searchInviteMsg($author$project$Ui$Invitation$Msg$SearchInviteFetchError)]));
            }
          }),
          ag: gqlResult
        });
      case 26:
        var shouldRouteToSearches = responseMsg.a;
        var response = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.Ba({
          jR: F2(function (_v34, state) {
            var routeToSearches = shouldRouteToSearches ? $author$project$TopMsg$routeTo($author$project$Route$Route$myPlayerStatusRouteSearches) : $author$project$TopMsg$noOpMsg;
            var notificationText = function () {
              if (!response) {
                return 'Invitation has been accepted';
              } else {
                return 'Invitation has been rejected';
              }
            }();
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, function () {
              if (!response) {
                return _List_fromArray([routeToSearches, A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Nothing, notificationText, _List_Nil), $author$project$TopMsg$msgMyPlayerStatus($author$project$Ui$MyPlayerStatus$Msg$SetRapidTicker)]);
              } else {
                return _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl, A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Nothing, notificationText, _List_Nil)]);
              }
            }());
          }),
          ag: gqlResult
        });
      case 27:
        var gqlResult = responseMsg.a;
        return handle.Ba({
          jR: F2(function (paged, state) {
            var _v37 = paged.xn;
            if (!_v37.b) {
              return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'This match has expired or doesn\'t exist.', _List_Nil), $author$project$TopMsg$routeTo($author$project$Route$Route$myPlayerStatusRoute)]));
            } else {
              var item = _v37.a;
              var sessionUpdateFn = function () {
                var _v38 = item.ua;
                if (_v38 === 1) {
                  return function (session) {
                    return _Utils_update(session, {
                      wA: A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$prepend, _List_fromArray([item]), A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$remove, item.xX.od, session.wA)),
                      yC: A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$remove, item.xX.od, session.yC)
                    });
                  };
                } else {
                  return function (session) {
                    return _Utils_update(session, {
                      yC: A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$prepend, _List_fromArray([item]), A2($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$remove, item.xX.od, session.yC))
                    });
                  };
                }
              }();
              return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, sessionUpdateFn, state), $elm$core$Platform$Cmd$none, _List_Nil);
            }
          }),
          ag: gqlResult
        });
      case 28:
        var satisfaction = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.Ba({
          jR: F2(function (_v39, state) {
            var overlay = !satisfaction && env.xd ? $author$project$Global$Model$FeedbackSentSuggestAppstoreReviewDialog : $author$project$Global$Model$FeedbackSentDialog;
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog(overlay)), $author$project$TopMsg$msgFeedback($author$project$Ui$Feedback$Msg$ClearState)]));
          }),
          ag: gqlResult
        });
      case 29:
        var gqlResult = responseMsg.a;
        return handle.Ba({
          jR: F2(function (_v40, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$SupportRequestSentDialog))]));
          }),
          ag: gqlResult
        });
      case 30:
        var notificationSettings = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.Ba({
          jR: F2(function (_v41, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
              return _Utils_update(session, {
                pJ: notificationSettings
              });
            }, state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ag: gqlResult
        });
      case 31:
        var gqlResult = responseMsg.a;
        return handle.Ba({
          jR: F2(function (unreadNotifications, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
              var settings = session.kO;
              return _Utils_update(session, {
                kO: _Utils_update(settings, {
                  C3: $elm$core$List$length(unreadNotifications)
                }),
                C4: unreadNotifications
              });
            }, state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ag: gqlResult
        });
      case 33:
        var maybeRoute = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.Ba({
          jR: F2(function (_v42, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
              return _Utils_update(session, {
                AR: $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$removeAll(session.AR),
                C4: _List_Nil
              });
            }, state), $elm$core$Platform$Cmd$none, _Utils_ap(_List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetUnreadNotifications)]), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, function (route) {
              return _List_fromArray([$author$project$TopMsg$routeTo(route)]);
            }, maybeRoute)));
          }),
          ag: gqlResult
        });
      case 32:
        var gqlResult = responseMsg.a;
        return handle.Ba({
          jR: F2(function (_v43, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
              return _Utils_update(session, {
                AR: $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$removeAll(session.AR),
                C4: _List_Nil
              });
            }, state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$GetUnreadNotifications)]));
          }),
          ag: gqlResult
        });
      case 34:
        var gqlResult = responseMsg.a;
        return handle.Ba({
          jR: F2(function (_v44, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ag: gqlResult
        });
      case 35:
        var device = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.Ba({
          jR: F2(function (_v45, state) {
            var updatePushDevices = function (session) {
              var settings = session.kO;
              return _Utils_update(session, {
                kO: _Utils_update(settings, {
                  qO: A3($turboMaCk$any_dict$Dict$Any$insert, device.li, device, settings.qO)
                })
              });
            };
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, updatePushDevices, state), $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function (session) {
              return _List_fromArray([$author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$UpdateNotificationSettings, $author$project$Types$NotificationSettings$enablePushForAll(session.pJ), session.e_))]);
            }, $author$project$Remote$Model$toSession(state))));
          }),
          ag: gqlResult
        });
      case 36:
        var userInfoSuccessResult = responseMsg.a;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil)]));
          }),
          jR: F2(function (userInfoSuccess, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
              return _Utils_update(session, {
                lz: userInfoSuccess.lz,
                pJ: userInfoSuccess.pJ,
                qj: $krisajenkins$remotedata$RemoteData$succeed(A2($turboMaCk$any_dict$Dict$Any$fromList, $author$project$Types$PaymentMethod$unwrapPaymentMethodId, A2($elm$core$List$map, function (p) {
                  return _Utils_Tuple2(p.od, p);
                }, userInfoSuccess.qj))),
                r5: userInfoSuccess.r5,
                sL: userInfoSuccess.sL,
                Db: userInfoSuccess.qI
              });
            }, state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ag: userInfoSuccessResult
        });
      case 37:
        var maybeRouteCmd = responseMsg.a;
        var userProfile = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.Ba({
          jR: F2(function (_v46, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
              return _Utils_update(session, {
                Db: userProfile
              });
            }, state), $elm$core$Platform$Cmd$none, _List_fromArray([handleMaybeRouteCmd(maybeRouteCmd)]));
          }),
          ag: gqlResult
        });
      case 38:
        var maybeRespondToInvitation = responseMsg.a;
        var maybeRoute = responseMsg.b;
        var gqlResult = responseMsg.c;
        return handle.Ba({
          jR: F2(function (_v47, state) {
            var id = _v47.od;
            var _v48 = $author$project$Remote$Model$toAuth(state);
            if (!_v48.$) {
              var auth = _v48.a;
              return _Utils_Tuple3(state, $author$project$ElmFramework$Feature$Analytics$Analytics$trackingEvents.B1($author$project$Types$User$unwrapUserId(id)), _List_fromArray([handleMaybeRouteCmd(maybeRoute), $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$InitializeUserSession, maybeRespondToInvitation, $elm$core$Maybe$Nothing, auth)), $author$project$TopMsg$msgOnboardUser($author$project$Ui$OnboardUser$Msg$ResetState)]));
            } else {
              return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $author$project$Remote$Model$sessionExpired);
            }
          }),
          ag: gqlResult
        });
      case 39:
        var gqlResult = responseMsg.a;
        return handle.Ba({
          jR: F2(function (_v49, state) {
            return _Utils_Tuple3($author$project$Remote$Model$initClean, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.CQ, $elm$core$Maybe$Nothing, 'Your account has been removed', _List_Nil), $author$project$ElmFramework$MsgCmd$msgCmd.yw($author$project$MulticastMessages$onUnauth), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]));
          }),
          ag: gqlResult
        });
      case 40:
        var searchId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            return _Utils_Tuple3(state, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleGraphqlErr, true, error), _List_Nil);
          }),
          jR: F2(function (result, state) {
            if (!result.$) {
              var successResult = result.a;
              var updatePendingSearchPaymentIntentHolds = function (session) {
                var updatedPendingSearchPaymentIntentHolds = A3($turboMaCk$any_dict$Dict$Any$insert, searchId, $krisajenkins$remotedata$RemoteData$succeed(successResult), session.Ak);
                return _Utils_update(session, {
                  Ak: updatedPendingSearchPaymentIntentHolds
                });
              };
              return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, updatePendingSearchPaymentIntentHolds, state), $elm$core$Platform$Cmd$none, _List_Nil);
            } else {
              var err = result.a;
              if (!err.$) {
                var generalError = err.a;
                return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, generalError, _List_Nil)]));
              } else {
                var emailUnverifiedError = err.a;
                return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$RemoteRequestMsg($author$project$Remote$RequestMsg$SendEmailVerificationCode(false))), $author$project$TopMsg$routeTo($author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Searches($author$project$Ui$MyPlayerStatus$Searches$Route$SearchesList))), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$EmailNotVerifiedDialog))]));
              }
            }
          }),
          ag: gqlResult
        });
      case 41:
        var matchId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            return _Utils_Tuple3(state, A2($author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$handleGraphqlErr, true, error), _List_Nil);
          }),
          jR: F2(function (result, state) {
            if (!result.$) {
              var successResult = result.a;
              var updatePendingPaymentIntentsForMatch = function (session) {
                var updatedPendingPaymentIntentsForMatch = A3($turboMaCk$any_dict$Dict$Any$insert, matchId, $krisajenkins$remotedata$RemoteData$succeed(successResult), session.Aj);
                return _Utils_update(session, {
                  Aj: updatedPendingPaymentIntentsForMatch
                });
              };
              return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, updatePendingPaymentIntentsForMatch, state), $elm$core$Platform$Cmd$none, _List_Nil);
            } else {
              var err = result.a;
              if (!err.$) {
                var generalError = err.a;
                return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, generalError, _List_Nil)]));
              } else {
                var emailUnverifiedError = err.a;
                return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$RemoteRequestMsg($author$project$Remote$RequestMsg$SendEmailVerificationCode(false))), $author$project$TopMsg$routeTo(A2($author$project$Route$Route$Match, matchId, $author$project$Ui$Match$Route$Details)), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$EmailNotVerifiedDialog))]));
              }
            }
          }),
          ag: gqlResult
        });
      case 44:
        var gqlResult = responseMsg.a;
        return handle.Ba({
          jR: F2(function (_v54, state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ag: gqlResult
        });
      case 42:
        var gqlResult = responseMsg.a;
        return handle.Ba({
          jR: F2(function (successResult, state) {
            var updatePendingPaymentMethodSaveIntent = function (userSession) {
              return _Utils_update(userSession, {
                Al: $krisajenkins$remotedata$RemoteData$succeed(successResult.ot)
              });
            };
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, updatePendingPaymentMethodSaveIntent, state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ag: gqlResult
        });
      case 43:
        var paymentMethodId = responseMsg.a;
        var gqlResult = responseMsg.b;
        return handle.Ba({
          jR: F2(function (_v55, state) {
            var updatePaymentMethodsDict = function (dict) {
              return A2($turboMaCk$any_dict$Dict$Any$remove, paymentMethodId, dict);
            };
            var updatePaymentMethodsInUserSession = function (userSession) {
              return _Utils_update(userSession, {
                qj: A2($krisajenkins$remotedata$RemoteData$map, updatePaymentMethodsDict, userSession.qj)
              });
            };
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, updatePaymentMethodsInUserSession, state), $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog), A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Nothing, 'Payment method has been removed', _List_Nil)]));
          }),
          ag: gqlResult
        });
      case 45:
        var result = responseMsg.a;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            var topMsgs = error === 'Token expired' ? A2($elm$core$List$cons, A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Please login again', _List_Nil), $author$project$MulticastMessages$onUnauth) : _List_fromArray([A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil)]);
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, topMsgs);
          }),
          jR: $author$project$Remote$UpdateResponse$handleNewTokens(_List_Nil),
          ag: result
        });
      case 46:
        var requestedFrom = responseMsg.a.A3;
        var geolocation = responseMsg.b;
        var result = responseMsg.c;
        return handle.A6({
          c0: function (state) {
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, _List_Nil);
          },
          c1: F2(function (error, state) {
            return _Utils_Tuple3(state, $author$project$ElmFramework$Feature$ErrorReporter$ErrorReporter$reportHttpErr(error), _List_Nil);
          }),
          jR: F2(function (_v56, state) {
            var results = _v56.Bc;
            var status = _v56.Cd;
            var maybeAddress = $elm_community$maybe_extra$Maybe$Extra$join(A2($elm$core$Maybe$map, $author$project$Ui$ProvideLocation$Helpers$geocodingResultToTitleAndSubtitle, $elm$core$List$head(results)));
            var newLocationForMatchmaking = function () {
              if (!maybeAddress.$) {
                var address = maybeAddress.a;
                return $elm$core$Maybe$Just(_Utils_Tuple2({
                  oV: geolocation.fU,
                  o_: geolocation.fX
                }, {
                  lb: address.lb,
                  lh: address.lh
                }));
              } else {
                return $elm$core$Maybe$Nothing;
              }
            }();
            var newLocationForOnboarding = function () {
              if (!maybeAddress.$) {
                var address = maybeAddress.a;
                return $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Types$GeoLocation$geoLocationFromGps(geolocation), {
                  lb: address.lb,
                  lh: address.lh
                }));
              } else {
                return $elm$core$Maybe$Nothing;
              }
            }();
            var updateState = function () {
              switch (requestedFrom.$) {
                case 16:
                  return _List_fromArray([$author$project$TopMsg$msgEditingUserProfile($author$project$Types$EditingUserProfile$LocationSet(newLocationForOnboarding)), $author$project$ElmFramework$MsgCmd$msgCmd.Bu($author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$Personal($elm$core$Maybe$Nothing)))]);
                case 18:
                  return _List_fromArray([$author$project$TopMsg$msgMatchmakingSingle($author$project$Ui$Matchmaking$Single$Msg$CreateOrEditSearch($author$project$Ui$CreateOrEditSearch$Msg$LocationSet(newLocationForMatchmaking))), $author$project$ElmFramework$MsgCmd$msgCmd.Bu($author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$Main))]);
                default:
                  return _List_Nil;
              }
            }();
            return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, updateState);
          }),
          ag: result
        });
      default:
        var gqlResult2 = responseMsg.a;
        return handle.Ba({
          jR: F2(function (contacts, state) {
            return _Utils_Tuple3(A2($author$project$Remote$Model$mapSession, function (session) {
              return _Utils_update(session, {
                DC: $krisajenkins$remotedata$RemoteData$Success(contacts)
              });
            }, state), $elm$core$Platform$Cmd$none, _List_Nil);
          }),
          ag: gqlResult2
        });
    }
  });
  var $author$project$Update$update = F2(function (msg, topState) {
    var maybeSession = $author$project$Types$UserSessionStatus$toSession(topState.lL.A$.sX);
    var currRoute = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(topState.rh);
    var appState = topState.lL;
    switch (msg.$) {
      case 0:
        var route = msg.a;
        return _Utils_Tuple3(topState.lL, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bt(route)]));
      case 1:
        var route = msg.a;
        switch (route.$) {
          case 0:
            return _Utils_Tuple3(appState, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bl]));
          case 1:
            return _Utils_Tuple3(appState, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bq]));
          case 2:
            var theRoute = route.a;
            return _Utils_Tuple3(appState, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bt(theRoute)]));
          case 3:
            var theRoute = route.a;
            return _Utils_Tuple3(appState, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bp(theRoute)]));
          default:
            var theRoute = route.a;
            return _Utils_Tuple3(appState, $elm$core$Platform$Cmd$none, _List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bu(theRoute)]));
        }
      case 4:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$GlobalMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              nV: childState
            });
          },
          sN: A5($author$project$Global$Global$update, topState.Cy, currRoute, $elm$core$Maybe$Nothing, theMsg, appState.nV)
        });
      case 6:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$OnboardUserMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              z$: childState
            });
          },
          sN: A5($author$project$Ui$OnboardUser$Update$update, theMsg, appState.vG, appState.z$, maybeSession, topState.wm)
        });
      case 5:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$AuthMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              tD: childState
            });
          },
          sN: A7($author$project$Ui$Auth$Auth$update, topState.vS, topState.AO, currRoute, appState.nV, theMsg, appState.tD, topState.B7.ig)
        });
      case 8:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$SupportMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              Cq: childState
            });
          },
          sN: A3($author$project$Ui$Support$Update$update, theMsg, appState.Cq, currRoute)
        });
      case 7:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$LegalMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              xF: childState
            });
          },
          sN: A4($author$project$Ui$Legal$Legal$update, appState.nV, $elm$core$Maybe$Nothing, theMsg, appState.xF)
        });
      case 3:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$PushMessagesMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              AN: childState
            });
          },
          sN: A5($author$project$PushMessages$PushMessages$update, currRoute, appState.nV, $elm$core$Maybe$Nothing, theMsg, appState.AN)
        });
      case 9:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$ComponentsPreviewMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              uE: childState
            });
          },
          sN: A4($author$project$Ui$ComponentsPreview$ComponentsPreview$update, appState.nV, $elm$core$Maybe$Nothing, theMsg, appState.uE)
        });
      case 10:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$RemoteMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              A$: childState
            });
          },
          sN: A4($author$project$Remote$Remote$update, theMsg, appState.nV, appState.A$, currRoute)
        });
      case 11:
        var requestMsg = msg.a;
        var _v2 = A4($author$project$Remote$UpdateRequest$updateRequest, requestMsg, appState.nV, topState.vS, appState.A$);
        var remote = _v2.a;
        var cmd = _v2.b;
        var outMsgs = _v2.c;
        return _Utils_Tuple3(_Utils_update(appState, {
          A$: remote
        }), A2($elm$core$Platform$Cmd$map, $author$project$Msg$RemoteResponseMsg(requestMsg), cmd), outMsgs);
      case 12:
        var requestMsg = msg.a;
        var responseMsg = msg.b;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$RemoteResponseMsg(requestMsg),
          r4: function (childState) {
            return _Utils_update(appState, {
              A$: childState
            });
          },
          sN: A6($author$project$Remote$UpdateResponse$updateResponse, topState.DJ, topState.Cy, topState.vS, appState.A$, requestMsg, responseMsg)
        });
      case 2:
        return _Utils_Tuple3(appState, $elm$core$Platform$Cmd$none, _List_Nil);
      case 13:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$ProvideLocationMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              AJ: childState
            });
          },
          sN: A3($author$project$Ui$ProvideLocation$Update$update, theMsg, appState.AJ, appState.nV)
        });
      case 14:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$MatchmakingMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              x3: childState
            });
          },
          sN: A6($author$project$Ui$Matchmaking$Update$update, topState, theMsg, appState.x3, maybeSession, currRoute, topState.vS)
        });
      case 15:
        var theMsg = msg.a;
        if (!maybeSession.$) {
          var session = maybeSession.a;
          return $author$project$Util$outMsgHandlerTopmost({
            py: $author$project$Msg$PaymentMethodsMsg,
            r4: function (childState) {
              return _Utils_update(appState, {
                Ae: childState
              });
            },
            sN: A4($author$project$Ui$PaymentMethods$Update$update, session, topState.lL.Ae, currRoute, theMsg)
          });
        } else {
          return _Utils_Tuple3(topState.lL, $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 16:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$FeedbackMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              wd: childState
            });
          },
          sN: A2($author$project$Ui$Feedback$Update$update, theMsg, appState.wd)
        });
      case 17:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$NotificationsSettingsMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              yL: childState
            });
          },
          sN: A4($author$project$Ui$NotificationsSettings$Update$update, theMsg, appState.yL, maybeSession, currRoute)
        });
      case 18:
        var theMsg = msg.a;
        if (!maybeSession.$) {
          var session = maybeSession.a;
          return $author$project$Util$outMsgHandlerTopmost({
            py: $author$project$Msg$MyPlayerStatusMsg,
            r4: function (childState) {
              return _Utils_update(appState, {
                yy: childState
              });
            },
            sN: A3($author$project$Ui$MyPlayerStatus$Update$update, theMsg, appState.yy, session)
          });
        } else {
          return _Utils_Tuple3(topState.lL, $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 19:
        var theMsg = msg.a;
        if (!maybeSession.$) {
          var session = maybeSession.a;
          return $author$project$Util$outMsgHandlerTopmost({
            py: $author$project$Msg$MatchMsg,
            r4: function (childState) {
              return _Utils_update(appState, {
                xZ: childState
              });
            },
            sN: A4($author$project$Ui$Match$Update$update, session, topState, theMsg, appState.xZ)
          });
        } else {
          return _Utils_Tuple3(topState.lL, $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 20:
        var theMsg = msg.a;
        return _Utils_Tuple3(appState, $elm$core$Platform$Cmd$none, A3($author$project$Ui$EditPersonalDetails$Update$update, theMsg, maybeSession, currRoute));
      case 21:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$EditingUserProfileMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              vG: childState
            });
          },
          sN: _Utils_Tuple3(A2($author$project$Types$EditingUserProfile$update, theMsg, appState.vG), $elm$core$Platform$Cmd$none, _List_Nil)
        });
      case 22:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$EditingUserActivitiesMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              vF: childState
            });
          },
          sN: _Utils_Tuple3(A2($author$project$Ui$EditUserActivities$EditUserActivities$update, theMsg, appState.vF), $elm$core$Platform$Cmd$none, _List_Nil)
        });
      case 23:
        var theMsg = msg.a;
        if (!maybeSession.$) {
          var session = maybeSession.a;
          return $author$project$Util$outMsgHandlerTopmost({
            py: $author$project$Msg$AddPlayersMsg,
            r4: function (childState) {
              return _Utils_update(appState, {
                tl: childState
              });
            },
            sN: A3($author$project$Ui$AddPlayers$AddPlayers$update, theMsg, appState.tl, session)
          });
        } else {
          return _Utils_Tuple3(topState.lL, $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 24:
        var theMsg = msg.a;
        if (!maybeSession.$) {
          var session = maybeSession.a;
          return $author$project$Util$outMsgHandlerTopmost({
            py: $author$project$Msg$UserSessionMsg,
            r4: function (childState) {
              var remote = topState.lL.A$;
              return _Utils_update(appState, {
                A$: _Utils_update(remote, {
                  sX: $author$project$Types$UserSessionStatus$Onboarded(childState)
                })
              });
            },
            sN: A4($author$project$Ui$Auth$UserSession$UserSession$update, topState, theMsg, session, currRoute)
          });
        } else {
          return _Utils_Tuple3(topState.lL, $elm$core$Platform$Cmd$none, _List_Nil);
        }
      case 25:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$InvitationMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              wY: childState
            });
          },
          sN: A3($author$project$Ui$Invitation$Update$update, theMsg, appState.wY, currRoute)
        });
      case 26:
        var theMsg = msg.a;
        return $author$project$Util$outMsgHandlerTopmost({
          py: $author$project$Msg$MoreOptionsMsg,
          r4: function (childState) {
            return _Utils_update(appState, {
              yv: childState
            });
          },
          sN: A2($author$project$Ui$MoreOptions$Update$update, theMsg, appState.yv)
        });
      default:
        var cmd = msg.a;
        return _Utils_Tuple3(topState.lL, cmd, _List_Nil);
    }
  });
  var $author$project$Types$Role$NoRole = 0;
  var $author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer = {
    $: 0
  };
  var $author$project$UiWrappers$HeaderAndBodyView$BlackBackground = {
    $: 0
  };
  var $author$project$UiWrappers$HeaderAndBodyView$CustomBar = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$TopLevelViewsUtil$FillBtnStyle = 0;
  var $author$project$Ui$TopLevelViewsUtil$OutlineBtnStyle = 1;
  var $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$TopLevelViewsUtil$RadiusWrappedPairButtons = function (a) {
    return {
      $: 11,
      a: a
    };
  };
  var $author$project$Remote$RequestMsg$RemoveStripePaymentMethod = function (a) {
    return {
      $: 43,
      a: a
    };
  };
  var $author$project$UiWrappers$HeaderAndBodyView$StripesTopLeftAndBottomRight = 1;
  var $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$Ui$Button$Button = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$SpecialSearchBar$DefaultSearch = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $elm$svg$Svg$Attributes$clipRule = _VirtualDom_attribute('clip-rule');
  var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
  var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
  var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
  var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
  var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
  var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
  var $author$project$IconSvg$back_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M16.1579 28.4088C16.3525 28.6035 16.599 28.6943 16.8455 28.6943C17.092 28.6943 17.3515 28.6035 17.5332 28.4088C17.9094 28.0326 17.9094 27.4098 17.5332 27.0335L11.3183 20.8186H31.0269C31.5588 20.8186 32 20.3775 32 19.8455C32 19.3135 31.5588 18.8724 31.0269 18.8724H11.3183L17.5332 12.6575C17.9094 12.2813 17.9094 11.6585 17.5332 11.2822C17.1569 10.9059 16.5341 10.9059 16.1579 11.2822L8.2822 19.1579C7.90593 19.5341 7.90593 20.1569 8.2822 20.5332L16.1579 28.4088Z')]), _List_Nil)]));
  };
  var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
  var $author$project$IconSvg$back = function (classes) {
    return $author$project$IconSvg$back_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
  var $elm$svg$Svg$Attributes$fillOpacity = _VirtualDom_attribute('fill-opacity');
  var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
  var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
  var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
  var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
  var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
  var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
  var $author$project$AssetsSvg$lines_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 128 260'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-123.907'), $elm$svg$Svg$Attributes$y('137.588'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -123.907 137.588)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-115.813'), $elm$svg$Svg$Attributes$y('145.681'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -115.813 145.681)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-107.72'), $elm$svg$Svg$Attributes$y('153.774'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -107.72 153.774)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-99.6265'), $elm$svg$Svg$Attributes$y('161.868'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -99.6265 161.868)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-91.5331'), $elm$svg$Svg$Attributes$y('169.961'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -91.5331 169.961)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-83.4397'), $elm$svg$Svg$Attributes$y('178.054'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -83.4397 178.054)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-75.3463'), $elm$svg$Svg$Attributes$y('186.148'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -75.3463 186.148)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-67.2529'), $elm$svg$Svg$Attributes$y('194.241'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -67.2529 194.241)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-59.1595'), $elm$svg$Svg$Attributes$y('202.335'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -59.1595 202.335)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-51.0662'), $elm$svg$Svg$Attributes$y('210.428'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -51.0662 210.428)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-42.9728'), $elm$svg$Svg$Attributes$y('218.521'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -42.9728 218.521)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-34.8794'), $elm$svg$Svg$Attributes$y('226.615'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -34.8794 226.615)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-26.786'), $elm$svg$Svg$Attributes$y('234.708'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -26.786 234.708)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-18.6926'), $elm$svg$Svg$Attributes$y('242.802'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -18.6926 242.802)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-10.5992'), $elm$svg$Svg$Attributes$y('250.895'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -10.5992 250.895)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-2.50586'), $elm$svg$Svg$Attributes$y('258.988'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -2.50586 258.988)'), $elm$svg$Svg$Attributes$fill('white'), $elm$svg$Svg$Attributes$fillOpacity('0.2')]), _List_Nil)]));
  };
  var $author$project$Ui$Background$backgroundBottomLeft = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('  absoluteSpread noPointerEvents noOverflow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w22h h22h absolute left0 bottom0  '), A2($elm$html$Html$Attributes$style, 'transform', 'translateX(-51%)')]), _List_fromArray([$author$project$AssetsSvg$lines_custom(_List_fromArray([$elm$svg$Svg$Attributes$class('  w33 h22h ')]))]))]));
  var $author$project$AssetsSvg$linesNoFill_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 128 260'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-123.907'), $elm$svg$Svg$Attributes$y('137.588'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -123.907 137.588)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-115.813'), $elm$svg$Svg$Attributes$y('145.681'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -115.813 145.681)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-107.72'), $elm$svg$Svg$Attributes$y('153.774'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -107.72 153.774)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-99.6265'), $elm$svg$Svg$Attributes$y('161.868'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -99.6265 161.868)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-91.5331'), $elm$svg$Svg$Attributes$y('169.961'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -91.5331 169.961)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-83.4397'), $elm$svg$Svg$Attributes$y('178.054'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -83.4397 178.054)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-75.3463'), $elm$svg$Svg$Attributes$y('186.148'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -75.3463 186.148)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-67.2529'), $elm$svg$Svg$Attributes$y('194.241'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -67.2529 194.241)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-59.1595'), $elm$svg$Svg$Attributes$y('202.335'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -59.1595 202.335)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-51.0662'), $elm$svg$Svg$Attributes$y('210.428'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -51.0662 210.428)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-42.9728'), $elm$svg$Svg$Attributes$y('218.521'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -42.9728 218.521)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-34.8794'), $elm$svg$Svg$Attributes$y('226.615'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -34.8794 226.615)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-26.786'), $elm$svg$Svg$Attributes$y('234.708'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -26.786 234.708)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-18.6926'), $elm$svg$Svg$Attributes$y('242.802'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -18.6926 242.802)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-10.5992'), $elm$svg$Svg$Attributes$y('250.895'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -10.5992 250.895)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('-2.50586'), $elm$svg$Svg$Attributes$y('258.988'), $elm$svg$Svg$Attributes$width('183.132'), $elm$svg$Svg$Attributes$height('1.43072'), $elm$svg$Svg$Attributes$transform('rotate(-45 -2.50586 258.988)'), $elm$svg$Svg$Attributes$fill('')]), _List_Nil)]));
  };
  var $author$project$Ui$Background$backgroundCenteredLeft = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('  absoluteSpread  noPointerEvents noOverflow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w22h h22h fixed left0 top29  '), A2($elm$html$Html$Attributes$style, 'transform', 'translateX(-50%)')]), _List_fromArray([$author$project$AssetsSvg$linesNoFill_custom(_List_fromArray([$elm$svg$Svg$Attributes$class('  w33 h22h primary80Fill')]))]))]));
  var $author$project$Ui$Background$backgroundSmallTopLeftAndBottomRight = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('  absoluteSpread  noPointerEvents noOverflow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w22h h22h absolute left0 top1 '), A2($elm$html$Html$Attributes$style, 'transform', 'translateX(-50%)')]), _List_fromArray([$author$project$AssetsSvg$lines_custom(_List_fromArray([$elm$svg$Svg$Attributes$class('  w33 h22h ')]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w22h h22h absolute right0 bottom0  '), A2($elm$html$Html$Attributes$style, 'transform', 'translateX(50%) translateY(50%)')]), _List_fromArray([$author$project$AssetsSvg$lines_custom(_List_fromArray([$elm$svg$Svg$Attributes$class('  w33 h22h ')]))]))]));
  var $author$project$Ui$Background$backgroundSmallTopLeftAndBottomRight15 = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('  absoluteSpread  noPointerEvents noOverflow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w22h h22h fixed left0 top15h '), A2($elm$html$Html$Attributes$style, 'transform', 'translateX(-50%)')]), _List_fromArray([$author$project$AssetsSvg$lines_custom(_List_fromArray([$elm$svg$Svg$Attributes$class('  w33 h22h ')]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w22h h22h fixed right0 bottom25  '), A2($elm$html$Html$Attributes$style, 'transform', 'translateX(50%) translateY(50%)')]), _List_fromArray([$author$project$AssetsSvg$lines_custom(_List_fromArray([$elm$svg$Svg$Attributes$class('  w33 h22h ')]))]))]));
  var $author$project$Ui$Background$backgroundTopLeftAndBottomRight = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('  absoluteSpread  noPointerEvents noOverflow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w32h h32h absolute left0 top0 '), A2($elm$html$Html$Attributes$style, 'transform', 'translateX(-50%)')]), _List_fromArray([$author$project$AssetsSvg$lines_custom(_List_fromArray([$elm$svg$Svg$Attributes$class('  w48 h32 ')]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w32h h32h absolute right0 bottom0  '), A2($elm$html$Html$Attributes$style, 'transform', 'translateX(50%) translateY(50%)')]), _List_fromArray([$author$project$AssetsSvg$lines_custom(_List_fromArray([$elm$svg$Svg$Attributes$class('  w48 h32 ')]))]))]));
  var $author$project$Ui$Background$backgroundTopRightOnly = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('  absoluteSpread noPointerEvents noOverflow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w22h h22h fixed right0 top-7h  '), A2($elm$html$Html$Attributes$style, 'transform', 'translateX(51%)')]), _List_fromArray([$author$project$AssetsSvg$lines_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(' o5 w33 h22h ')]))]))]));
  var $author$project$Ui$Background$bodyBackgroundBottomLeft = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread noPointerEvents noOverflow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w22h h22h absolute left0 bottom5h  '), A2($elm$html$Html$Attributes$style, 'transform', 'translateX(-15rem) ')]), _List_fromArray([$author$project$AssetsSvg$linesNoFill_custom(_List_fromArray([$elm$svg$Svg$Attributes$class('  w33 h22h gray10Fill ')]))]))]));
  var $author$project$Ui$Button$PrimaryColor = 0;
  var $author$project$Ui$Button$SecondaryColor = 1;
  var $elm$html$Html$a = _VirtualDom_node('a');
  var $elm$html$Html$button = _VirtualDom_node('button');
  var $elm$html$Html$Attributes$href = function (url) {
    return A2($elm$html$Html$Attributes$stringProperty, 'href', _VirtualDom_noJavaScriptUri(url));
  };
  var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
  var $author$project$ElmFramework$Lib$Ui$Button$button = F3(function (buttonKind, attrList, childList) {
    var _v0 = function () {
      switch (buttonKind.$) {
        case 0:
          return _Utils_Tuple2($elm$html$Html$button, _List_fromArray([$elm$html$Html$Attributes$type_('submit')]));
        case 1:
          var msg = buttonKind.a;
          return _Utils_Tuple2($elm$html$Html$button, _List_fromArray([$elm$html$Html$Attributes$type_('button'), $author$project$ElmFramework$Lib$Util$onTap(msg)]));
        case 2:
          return _Utils_Tuple2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'onclick', 'return false')]));
        default:
          var string = buttonKind.a;
          return _Utils_Tuple2($elm$html$Html$a, _List_fromArray([$elm$html$Html$Attributes$href(string)]));
      }
    }();
    var btnEl = _v0.a;
    var handlerAttrs = _v0.b;
    return A2(btnEl, _Utils_ap(attrList, handlerAttrs), childList);
  });
  var $elm$html$Html$Attributes$boolProperty = F2(function (key, bool) {
    return A2(_VirtualDom_property, key, $elm$json$Json$Encode$bool(bool));
  });
  var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
  var $author$project$Ui$Button$styledButton = function (config) {
    var buttonStyleClass = function () {
      var _v0 = config.cD;
      switch (_v0) {
        case 0:
          return 'primary0Back gray0 gray0Fill btnShadow primary0Border radius7  ';
        case 1:
          return 'gray0Back primary0 primary0Border radius7  ';
        case 2:
          return 'secondary100 gray0Back noBorder radius7  ';
        default:
          return 'gradient500Back gray0 btnShadow noBorder radius7 ';
      }
    }();
    return A3($author$project$ElmFramework$Lib$Ui$Button$button, config.xu, _List_fromArray([$elm$html$Html$Attributes$class(buttonStyleClass), $elm$html$Html$Attributes$class(A3($author$project$ElmFramework$Lib$Util$ifElse, 'o2 btnShadowNone ', ' ', config.xa)), $elm$html$Html$Attributes$class('opacityTransition minH6 '), $elm$html$Html$Attributes$class(config.bh), $elm$html$Html$Attributes$disabled(config.xa)]), _List_fromArray([config.fn]));
  };
  var $author$project$Ui$Button$basicButton = function (config) {
    return $author$project$Ui$Button$styledButton({
      bh: '  hairLineBorderWidth borderSolid padRight2 padLeft2  flexCenter   heading5Bold ' + config.bh,
      cD: config.cD,
      fn: config.fn,
      xa: config.xa,
      xu: config.xu
    });
  };
  var $author$project$Ui$Button$button = function (config) {
    return A3($author$project$ElmFramework$Lib$Ui$Button$button, config.xu, _List_fromArray([$elm$html$Html$Attributes$class(config.bh)]), _List_fromArray([config.fn]));
  };
  var $author$project$IconSvg$moveLeftMed_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M8.29289 20.7071C7.90237 20.3166 7.90237 19.6834 8.29289 19.2929L19.2929 8.29289C19.6834 7.90237 20.3166 7.90237 20.7071 8.29289C21.0976 8.68342 21.0976 9.31658 20.7071 9.70711L11.4142 19L31 19C31.5523 19 32 19.4477 32 20C32 20.5523 31.5523 21 31 21L11.4142 21L20.7071 30.2929C21.0976 30.6834 21.0976 31.3166 20.7071 31.7071C20.3166 32.0976 19.6834 32.0976 19.2929 31.7071L8.29289 20.7071Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$moveLeftMed = function (classes) {
    return $author$project$IconSvg$moveLeftMed_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$Button$multipleIconBtn = function (cfg) {
    var rightIcon = function () {
      var _v1 = cfg.Bh;
      if (!_v1.$) {
        var icon = _v1.a;
        return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('flexCenter w3 h3 marLeft1')]), _List_fromArray([icon('w3')]));
      } else {
        return A2($elm$html$Html$div, _List_Nil, _List_Nil);
      }
    }();
    var leftIcon = function () {
      var _v0 = cfg.xD;
      if (!_v0.$) {
        var icon = _v0.a;
        return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('flexCenter w3 h3 marRight1')]), _List_fromArray([icon('w3')]));
      } else {
        return A2($elm$html$Html$div, _List_Nil, _List_Nil);
      }
    }();
    return $author$project$Ui$Button$styledButton({
      bh: '  hairLineBorderWidth borderSolid minH6 ' + cfg.bh,
      cD: cfg.cD,
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexCenter')]), _List_fromArray([leftIcon, A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([$elm$html$Html$text(cfg.oR)])), rightIcon])),
      xa: cfg.xa,
      xu: cfg.xu
    });
  };
  var $author$project$ElmFramework$Lib$Util$bottomAppSpacer = A3($elm$html$Html$node, 'spacer', _List_fromArray([$elm$html$Html$Attributes$class('block'), A2($elm$html$Html$Attributes$attribute, 'style', 'height: env(safe-area-inset-bottom); height: constant(safe-area-inset-bottom)')]), _List_Nil);
  var $author$project$ElmFramework$Feature$Browser$Browser$toHeightInUnits = function (_v0) {
    var height = _v0.ij;
    var unitSize = _v0.gO;
    return height / unitSize;
  };
  var $author$project$ElmFramework$Feature$Browser$Browser$toWidthInUnits = function (_v0) {
    var width = _v0.lt;
    var unitSize = _v0.gO;
    return width / unitSize;
  };
  var $author$project$ElmFramework$Feature$Browser$Browser$isLargerThan = F2(function (browser, _v0) {
    var minWidth = _v0.a;
    var minHeight = _v0.b;
    return _Utils_cmp($author$project$ElmFramework$Feature$Browser$Browser$toWidthInUnits(browser), minWidth) > 0 && _Utils_cmp($author$project$ElmFramework$Feature$Browser$Browser$toHeightInUnits(browser), minHeight) > 0;
  });
  var $author$project$ElmFramework$Lib$Ui$NavBarBottom$shouldDetachFromEdges = function (browser) {
    return A2($author$project$ElmFramework$Feature$Browser$Browser$isLargerThan, browser, _Utils_Tuple2(54, 60));
  };
  var $author$project$ElmFramework$Lib$Ui$NavBarBottom$navBarBottomSpacer = F2(function (heightUnits, browser) {
    var heightClass = $author$project$ElmFramework$Lib$Ui$NavBarBottom$shouldDetachFromEdges(browser) ? 'h' + $elm$core$String$fromInt(heightUnits + 2) : 'h' + $elm$core$String$fromInt(heightUnits);
    return A3($elm$html$Html$node, 'nav-bar-bottom-spacer', _List_fromArray([$elm$html$Html$Attributes$class('block')]), _List_fromArray([$author$project$ElmFramework$Lib$Util$bottomAppSpacer, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(heightClass)]), _List_Nil)]));
  });
  var $author$project$Ui$NavBarBottom$navBarHeight = 7;
  var $author$project$Ui$NavBarBottom$navBarBottomSpacer = $author$project$ElmFramework$Lib$Ui$NavBarBottom$navBarBottomSpacer($author$project$Ui$NavBarBottom$navBarHeight);
  var $author$project$ElmFramework$Lib$Util$noOpEl = A3($elm$html$Html$node, 'no-op-el', _List_Nil, _List_Nil);
  var $author$project$Ui$TopLevelViewsUtil$bottomSpacerContent = function (cfg) {
    var stickyBottomContent = F2(function (classes, content) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('sticky bottom0 fullWidth pad2 phoneWidthCenter '), $elm$html$Html$Attributes$class(classes)]), content);
    });
    var inlineContent = F2(function (classes, content) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth phoneWidthCenter pad2 '), $elm$html$Html$Attributes$class(classes)]), content);
    });
    var btnStyle = function (style) {
      if (!style) {
        return 0;
      } else {
        return 1;
      }
    };
    var bottomContent = function () {
      var _v0 = cfg.l5;
      if (!_v0.$) {
        switch (_v0.a.$) {
          case 0:
            var btnCfg = _v0.a.a;
            return A2(stickyBottomContent, ' gray0Back ', _List_fromArray([$author$project$Ui$Button$basicButton({
              bh: 'fullWidth ',
              cD: btnStyle(btnCfg.r8),
              fn: $elm$html$Html$text(btnCfg.oR),
              xa: btnCfg.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(btnCfg.p_)
            })]));
          case 1:
            var btnCfg = _v0.a.a;
            return A2(stickyBottomContent, ' radiusTopRight5 radiusTopLeft5 ', _List_fromArray([$author$project$Ui$Button$basicButton({
              bh: 'fullWidth ',
              cD: btnStyle(btnCfg.r8),
              fn: $elm$html$Html$text(btnCfg.oR),
              xa: btnCfg.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(btnCfg.p_)
            })]));
          case 3:
            var _v1 = _v0.a.a;
            var onGoBack = _v1.a;
            var btnCfg = _v1.b;
            return A2(stickyBottomContent, 'flexRow spaceBetween flexAlignCenter  gray0Back ', _List_fromArray([$author$project$Ui$Button$button({
              bh: ' w5 h5 flexCenter ',
              fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w3 h3 ')]), _List_fromArray([$author$project$IconSvg$moveLeftMed(' gray60Fill w3  ')])),
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onGoBack)
            }), $author$project$Ui$Button$basicButton({
              bh: 'takeHalf ',
              cD: btnStyle(btnCfg.r8),
              fn: $elm$html$Html$text(btnCfg.oR),
              xa: btnCfg.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(btnCfg.p_)
            })]));
          case 6:
            var btnCfg = _v0.a.a;
            return A2(inlineContent, ' relative gray0Back', _List_fromArray([$author$project$Ui$Button$basicButton({
              bh: 'fullWidth ',
              cD: btnStyle(btnCfg.r8),
              fn: $elm$html$Html$text(btnCfg.oR),
              xa: btnCfg.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(btnCfg.p_)
            })]));
          case 7:
            var btnCfg = _v0.a.a;
            return A2(inlineContent, ' relative gray0Back', _List_fromArray([$author$project$Ui$Button$multipleIconBtn({
              bh: 'fullWidth  heading5Bold marTop1 marBottom1 flexCenter block',
              cD: btnStyle(btnCfg.r8),
              xa: btnCfg.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(btnCfg.p_),
              oR: btnCfg.oR,
              xD: btnCfg.xD,
              Bh: btnCfg.Bh
            })]));
          case 12:
            var btnCfg = _v0.a.a;
            return A2(inlineContent, 'gray0Back ', _List_fromArray([$author$project$Ui$Button$basicButton({
              bh: 'fullWidth ',
              cD: btnStyle(btnCfg.r8),
              fn: $elm$html$Html$text(btnCfg.oR),
              xa: btnCfg.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(btnCfg.p_)
            })]));
          case 8:
            var _v2 = _v0.a.a;
            var first = _v2.a;
            var second = _v2.b;
            return A2(inlineContent, ' relative gray0Back  ', _List_fromArray([$author$project$Ui$Button$basicButton({
              bh: 'fullWidth marBottom2  ',
              cD: btnStyle(first.r8),
              fn: $elm$html$Html$text(first.oR),
              xa: first.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(first.p_)
            }), $author$project$Ui$Button$basicButton({
              bh: ' fullWidth ',
              cD: btnStyle(second.r8),
              fn: $elm$html$Html$text(second.oR),
              xa: second.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(second.p_)
            })]));
          case 9:
            var _v3 = _v0.a.a;
            var first = _v3.a;
            var second = _v3.b;
            return A2(inlineContent, ' flexRow relative gray0Back  ', _List_fromArray([$author$project$Ui$Button$basicButton({
              bh: 'fullWidth marBottom2 marRight1 ',
              cD: btnStyle(first.r8),
              fn: $elm$html$Html$text(first.oR),
              xa: first.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(first.p_)
            }), $author$project$Ui$Button$basicButton({
              bh: ' fullWidth marBottom2 marLeft1 ',
              cD: btnStyle(second.r8),
              fn: $elm$html$Html$text(second.oR),
              xa: second.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(second.p_)
            })]));
          case 10:
            var btnCfg = _v0.a.a;
            return A2(inlineContent, ' relative gray0Back radiusTopRight5 radiusTopLeft5 ', _List_fromArray([$author$project$Ui$Button$basicButton({
              bh: ' fullWidth ',
              cD: btnStyle(btnCfg.r8),
              fn: $elm$html$Html$text(btnCfg.oR),
              xa: btnCfg.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(btnCfg.p_)
            })]));
          case 11:
            var _v4 = _v0.a.a;
            var first = _v4.a;
            var second = _v4.b;
            return A2(inlineContent, ' relative gray0Back radiusTopRight5 radiusTopLeft5 ', _List_fromArray([$author$project$Ui$Button$basicButton({
              bh: 'fullWidth marBottom2  ',
              cD: btnStyle(first.r8),
              fn: $elm$html$Html$text(first.oR),
              xa: first.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(first.p_)
            }), $author$project$Ui$Button$basicButton({
              bh: ' fullWidth ',
              cD: btnStyle(second.r8),
              fn: $elm$html$Html$text(second.oR),
              xa: second.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(second.p_)
            })]));
          case 2:
            var _v5 = _v0.a.a;
            var first = _v5.a;
            var second = _v5.b;
            return A2(stickyBottomContent, '', _List_fromArray([$author$project$Ui$Button$basicButton({
              bh: 'fullWidth marBottom2  ',
              cD: btnStyle(first.r8),
              fn: $elm$html$Html$text(first.oR),
              xa: first.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(first.p_)
            }), $author$project$Ui$Button$basicButton({
              bh: ' fullWidth ',
              cD: btnStyle(second.r8),
              fn: $elm$html$Html$text(second.oR),
              xa: second.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(second.p_)
            })]));
          case 5:
            var barCfg = _v0.a.a;
            return A2(inlineContent, ' flexRow ', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' marRight2 gray80 heading5Regular')]), _List_fromArray([$elm$html$Html$text(barCfg.eS)])), $author$project$Ui$Button$basicButton({
              bh: ' ',
              cD: btnStyle(barCfg.fb.r8),
              fn: $elm$html$Html$text(barCfg.fb.oR),
              xa: barCfg.fb.xa,
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(barCfg.fb.p_)
            })]));
          default:
            var _v6 = _v0.a;
            return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray0Back phoneWidthCenter fullWidth z0 ')]), _List_fromArray([$author$project$Ui$NavBarBottom$navBarBottomSpacer(cfg.t_)]));
        }
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();
    return bottomContent;
  };
  var $author$project$Ui$DupleTextSlider$toHiddenStateView = function (_v0) {
    var label = _v0.oR;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' o0')]), _List_fromArray([$elm$html$Html$text(label)]));
  };
  var $author$project$Ui$DupleTextSlider$toHotSpot = F2(function (onSelectTag, _v0) {
    var id = _v0.od;
    var label = _v0.oR;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' pointer marRight2 o0 '), $author$project$ElmFramework$Lib$Util$onTap(onSelectTag(id))]), _List_fromArray([$elm$html$Html$text(label)]));
  });
  var $author$project$Ui$DupleTextSlider$toOptionView = F2(function (_v0, currItemId) {
    var id = _v0.od;
    var label = _v0.oR;
    var viewclasses = _Utils_eq(id, currItemId) ? 'gray0' : 'gray40';
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' marRight2 itemTrans  '), $elm$html$Html$Attributes$class(viewclasses)]), _List_fromArray([$elm$html$Html$text(label)]));
  });
  var $author$project$Ui$DupleTextSlider$dupleTextSlider = function (config) {
    var items = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow ')]), _List_fromArray([A2($author$project$Ui$DupleTextSlider$toOptionView, config.xn.a, config.u$), A2($author$project$Ui$DupleTextSlider$toOptionView, config.xn.b, config.u$)]));
    var isFirstSelected = _Utils_eq(config.xn.a.od, config.u$);
    var selectedItem = function () {
      var line = function () {
        var movement = isFirstSelected ? '0' : ' calc(100% + 2rem) ';
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w2 hairLineHeight secondary0Back absolute radius2 bottom0 itemTrans'), A2($elm$html$Html$Attributes$style, 'left', movement)]), _List_Nil);
      }();
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('selectedItem absolute top0 left0 fullHeight  '), $elm$html$Html$Attributes$class(config.BP)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('selectedItems relative fullHeight')]), _List_fromArray([$author$project$Ui$DupleTextSlider$toHiddenStateView(config.xn.a), line]))]));
    }();
    var hotSpots = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow absoluteSpread ')]), _List_fromArray([A2($author$project$Ui$DupleTextSlider$toHotSpot, config.zG, config.xn.a), A2($author$project$Ui$DupleTextSlider$toHotSpot, config.zG, config.xn.b)]));
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(config.bh)]), _List_fromArray([A3($elm$html$Html$node, 'duple-text-slider', _List_fromArray([$elm$html$Html$Attributes$class('block relative padBottom1 ')]), _List_fromArray([items, selectedItem, hotSpots]))]));
  };
  var $elm$html$Html$form = _VirtualDom_node('form');
  var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
    return _Utils_Tuple2(msg, true);
  };
  var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $elm$html$Html$Events$preventDefaultOn = F2(function (event, decoder) {
    return A2($elm$virtual_dom$VirtualDom$on, event, $elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
  });
  var $elm$html$Html$Events$onSubmit = function (msg) {
    return A2($elm$html$Html$Events$preventDefaultOn, 'submit', A2($elm$json$Json$Decode$map, $elm$html$Html$Events$alwaysPreventDefault, $elm$json$Json$Decode$succeed(msg)));
  };
  var $author$project$Model$Image$distance = F2(function (imgWidth, goalUnitWidth) {
    return $elm$core$Basics$abs(imgWidth - goalUnitWidth);
  });
  var $elm_community$list_extra$List$Extra$minimumBy = F2(function (f, ls) {
    var minBy = F2(function (x, _v1) {
      var y = _v1.a;
      var fy = _v1.b;
      var fx = f(x);
      return _Utils_cmp(fx, fy) < 0 ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
    });
    if (ls.b) {
      if (!ls.b.b) {
        var l_ = ls.a;
        return $elm$core$Maybe$Just(l_);
      } else {
        var l_ = ls.a;
        var ls_ = ls.b;
        return $elm$core$Maybe$Just(A3($elm$core$List$foldl, minBy, _Utils_Tuple2(l_, f(l_)), ls_).a);
      }
    } else {
      return $elm$core$Maybe$Nothing;
    }
  });
  var $author$project$Model$Image$fromPhysicalWidthPixels = F3(function (image, sizer, goalWidth) {
    return A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm_community$list_extra$List$Extra$minimumBy, $elm$core$Tuple$first, A2($elm$core$List$map, function (transformation) {
      return _Utils_Tuple2(A2($author$project$Model$Image$distance, sizer(transformation), goalWidth), transformation);
    }, image)));
  });
  var $author$project$Model$Image$goalFromUnits = F2(function (_v0, goalUnitSize) {
    var unitSize = _v0.gO;
    var pixelRatio = _v0.qs;
    return $elm$core$Basics$round(goalUnitSize * unitSize * pixelRatio);
  });
  var $author$project$Model$Image$transformationFromUnitWidth = F3(function (browser, goalWidth, image) {
    return A3($author$project$Model$Image$fromPhysicalWidthPixels, image, function ($) {
      return $.lt;
    }, A2($author$project$Model$Image$goalFromUnits, browser, goalWidth));
  });
  var $author$project$Model$Image$fromUnitWidth = F3(function (browser, goalWidth, image) {
    return A2($elm$core$Maybe$map, function ($) {
      return $.eZ;
    }, A3($author$project$Model$Image$transformationFromUnitWidth, browser, goalWidth, image));
  });
  var $author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImg = F3(function (wrapClasses, classes, imgUrl) {
    return A3($elm$html$Html$node, 'patient-background-image', _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'wait-for-image', imgUrl), $elm$html$Html$Attributes$class(wrapClasses)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread coverBack hidden fadeInAnimation'), $elm$html$Html$Attributes$class(classes)]), _List_Nil)]));
  });
  var $author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart = function (cfg) {
    return A3($author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImg, cfg.s5, cfg.uj, A2($elm$core$Maybe$withDefault, '', A3($author$project$Model$Image$fromUnitWidth, cfg.t_, cfg.Dq, cfg.wG)));
  };
  var $author$project$ElmFramework$Lib$Ui$Input$Text = {
    $: 0
  };
  var $author$project$IconSvg$close1_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M20 32C13.3805 32 8 26.6195 8 20C8 13.3805 13.3805 8 20 8C26.6195 8 32 13.3805 32 20C32 26.6195 26.6195 32 20 32ZM20 9.67442C14.307 9.67442 9.67442 14.307 9.67442 20C9.67442 25.693 14.307 30.3256 20 30.3256C25.693 30.3256 30.3256 25.693 30.3256 20C30.3256 14.307 25.693 9.67442 20 9.67442ZM16.8408 23.9961C16.6287 23.9961 16.4166 23.918 16.2492 23.7505C15.9254 23.4268 15.9254 22.891 16.2492 22.5673L18.8166 19.9998L16.2492 17.4324C15.9254 17.1087 15.9254 16.5729 16.2492 16.2491C16.5729 15.9254 17.1087 15.9254 17.4324 16.2491L19.9998 18.8166L22.5673 16.2491C22.891 15.9254 23.4268 15.9254 23.7505 16.2491C24.0743 16.5729 24.0743 17.1087 23.7505 17.4324L21.1831 19.9998L23.7505 22.5673C24.0743 22.891 24.0743 23.4268 23.7505 23.7505C23.5831 23.918 23.371 23.9961 23.1589 23.9961C22.9468 23.9961 22.7347 23.918 22.5673 23.7505L19.9998 21.1831L17.4324 23.7505C17.2761 23.918 17.0529 23.9961 16.8408 23.9961Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$close1 = function (classes) {
    return $author$project$IconSvg$close1_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
  var $elm$html$Html$input = _VirtualDom_node('input');
  var $author$project$ElmFramework$Lib$Ui$DebouncedInput$onDebouncedInput = function (tag) {
    return A2($author$project$ElmFramework$Lib$Util$onLocal, 'debouncedInput', A2($elm$json$Json$Decode$map, tag, A2($elm$json$Json$Decode$field, 'detail', $elm$json$Json$Decode$string)));
  };
  var $elm$html$Html$Events$onFocus = function (msg) {
    return A2($elm$html$Html$Events$on, 'focus', $elm$json$Json$Decode$succeed(msg));
  };
  var $elm$html$Html$Events$alwaysStop = function (x) {
    return _Utils_Tuple2(x, true);
  };
  var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $elm$html$Html$Events$stopPropagationOn = F2(function (event, decoder) {
    return A2($elm$virtual_dom$VirtualDom$on, event, $elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
  });
  var $elm$html$Html$Events$targetValue = A2($elm$json$Json$Decode$at, _List_fromArray(['target', 'value']), $elm$json$Json$Decode$string);
  var $elm$html$Html$Events$onInput = function (tagger) {
    return A2($elm$html$Html$Events$stopPropagationOn, 'input', A2($elm$json$Json$Decode$map, $elm$html$Html$Events$alwaysStop, A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
  };
  var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
  var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
  var $author$project$ElmFramework$Lib$Ui$DebouncedInput$debouncedInput = function (_v0) {
    var id = _v0.od;
    var debounceTime = _v0.mP;
    var inputTag = _v0.or;
    var debouncedInputTag = _v0.mQ;
    var maybeOnFocusMsg = _v0.pc;
    var value = _v0.s_;
    var placeholderText = _v0.qv;
    var wrapClasses = _v0.s5;
    var inputClasses = _v0.oq;
    return A3($elm$html$Html$node, 'debounced-input', _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'debounce-time', $elm$core$String$fromInt(debounceTime)), $elm$html$Html$Attributes$class('block fullWidth'), $elm$html$Html$Attributes$class(wrapClasses), $author$project$ElmFramework$Lib$Ui$DebouncedInput$onDebouncedInput(debouncedInputTag)]), _List_fromArray([A2($elm$html$Html$input, _List_fromArray([$elm$html$Html$Attributes$id(id), $elm$html$Html$Attributes$class('block fullWidth'), $elm$html$Html$Attributes$class(inputClasses), $elm$html$Html$Attributes$value(value), $elm$html$Html$Attributes$placeholder(placeholderText), $elm$html$Html$Events$onInput(inputTag), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$Util$noOpAttr, $elm$html$Html$Events$onFocus, maybeOnFocusMsg)]), _List_Nil)]));
  };
  var $author$project$IconSvg$filter_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M18.8837 18.3721H25.5814C27.5014 18.3721 28.6512 17.2223 28.6512 15.3023V15.0233H31.1628C31.6205 15.0233 32 14.6437 32 14.186C32 13.7284 31.6205 13.3488 31.1628 13.3488H28.6512V13.0698C28.6512 11.1498 27.5014 10 25.5814 10H18.8837C16.9637 10 15.814 11.1498 15.814 13.0698V13.3488H8.83721C8.37953 13.3488 8 13.7284 8 14.186C8 14.6437 8.37953 15.0233 8.83721 15.0233H15.814V15.3023C15.814 17.2223 16.9637 18.3721 18.8837 18.3721ZM17.4884 14.186V15.3023C17.4884 16.2958 17.8902 16.6977 18.8837 16.6977H25.5814C26.5749 16.6977 26.9767 16.2958 26.9767 15.3023V14.1878C26.9767 14.1872 26.9767 14.1866 26.9767 14.186C26.9767 14.1855 26.9767 14.1849 26.9767 14.1843V13.0698C26.9767 12.0763 26.5749 11.6744 25.5814 11.6744H18.8837C17.8902 11.6744 17.4884 12.0763 17.4884 13.0698V14.186ZM8.83721 27.3023H11.3488V27.5814C11.3488 29.5014 12.4986 30.6512 14.4186 30.6512H21.1163C23.0363 30.6512 24.186 29.5014 24.186 27.5814V27.3023H31.1628C31.6205 27.3023 32 26.9228 32 26.4651C32 26.0074 31.6205 25.6279 31.1628 25.6279H24.186V25.3488C24.186 23.4288 23.0363 22.2791 21.1163 22.2791H14.4186C12.4986 22.2791 11.3488 23.4288 11.3488 25.3488V25.6279H8.83721C8.37953 25.6279 8 26.0074 8 26.4651C8 26.9228 8.37953 27.3023 8.83721 27.3023ZM13.0233 27.5814V26.466V26.4651V26.4642V25.3488C13.0233 24.3553 13.4251 23.9535 14.4186 23.9535H21.1163C22.1098 23.9535 22.5116 24.3553 22.5116 25.3488V26.4651V27.5814C22.5116 28.5749 22.1098 28.9767 21.1163 28.9767H14.4186C13.4251 28.9767 13.0233 28.5749 13.0233 27.5814Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$filter = function (classes) {
    return $author$project$IconSvg$filter_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$gps_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M19.1628 8.83721V10.8284C14.7505 11.2276 11.2276 14.7505 10.8284 19.1628H8.83721C8.37953 19.1628 8 19.5423 8 20C8 20.4577 8.37953 20.8372 8.83721 20.8372H10.8284C11.2276 25.2495 14.7505 28.7724 19.1628 29.1716V31.1628C19.1628 31.6205 19.5423 32 20 32C20.4577 32 20.8372 31.6205 20.8372 31.1628V29.1716C25.2495 28.7724 28.7724 25.2495 29.1716 20.8372H31.1628C31.6205 20.8372 32 20.4577 32 20C32 19.5423 31.6205 19.1628 31.1628 19.1628H29.1716C28.7724 14.7505 25.2495 11.2276 20.8372 10.8284V8.83721C20.8372 8.37953 20.4577 8 20 8C19.5423 8 19.1628 8.37953 19.1628 8.83721ZM12.4651 20C12.4651 15.8474 15.8474 12.4651 20 12.4651C24.1526 12.4651 27.5349 15.8474 27.5349 20C27.5349 24.1526 24.1526 27.5349 20 27.5349C15.8474 27.5349 12.4651 24.1526 12.4651 20ZM15.814 20C15.814 22.3107 17.6893 24.186 20 24.186C22.3107 24.186 24.186 22.3107 24.186 20C24.186 17.6893 22.3107 15.814 20 15.814C17.6893 15.814 15.814 17.6893 15.814 20ZM17.4884 20C17.4884 18.6158 18.6158 17.4884 20 17.4884C21.3842 17.4884 22.5116 18.6158 22.5116 20C22.5116 21.3842 21.3842 22.5116 20 22.5116C18.6158 22.5116 17.4884 21.3842 17.4884 20Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$gps = function (classes) {
    return $author$project$IconSvg$gps_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
  var $author$project$ElmFramework$Lib$Ui$Input$toAutocompleteString = function (maybeAutoComplete) {
    if (maybeAutoComplete.$ === 1) {
      return 'off';
    } else {
      switch (maybeAutoComplete.a) {
        case 0:
          var _v1 = maybeAutoComplete.a;
          return 'username';
        case 1:
          var _v2 = maybeAutoComplete.a;
          return 'new-password';
        case 2:
          var _v3 = maybeAutoComplete.a;
          return 'current-password';
        case 3:
          var _v4 = maybeAutoComplete.a;
          return 'one-time-code';
        case 4:
          var _v5 = maybeAutoComplete.a;
          return 'given-name';
        default:
          var _v6 = maybeAutoComplete.a;
          return 'family-name';
      }
    }
  };
  var $author$project$ElmFramework$Lib$Ui$Input$toInputTypeString = function (inputType) {
    switch (inputType.$) {
      case 0:
        return 'text';
      case 1:
        return 'email';
      default:
        var msg = inputType.a;
        return 'password';
    }
  };
  var $author$project$ElmFramework$Lib$Ui$Input$input_custom = function (config) {
    return A2($elm$html$Html$input, _List_fromArray([$elm$html$Html$Attributes$class(config.bh), A3($author$project$ElmFramework$Lib$Util$ifElse, $author$project$ElmFramework$Lib$Util$noOpAttr, $elm$html$Html$Attributes$id(config.od), $elm$core$String$isEmpty(config.od)), $elm$html$Html$Attributes$type_($author$project$ElmFramework$Lib$Ui$Input$toInputTypeString(config.wQ)), $elm$html$Html$Attributes$required(config.ch), $elm$html$Html$Attributes$disabled(config.bY), $elm$html$Html$Attributes$placeholder(config.bv), $elm$html$Html$Attributes$value(config.s_), $elm$html$Html$Events$onInput(config.bu), A2($elm$html$Html$Attributes$attribute, 'autocomplete', $author$project$ElmFramework$Lib$Ui$Input$toAutocompleteString(config.bP))]), _List_Nil);
  };
  var $author$project$IconSvg$search_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M8 19.4419C8 25.7488 13.1349 30.8837 19.4419 30.8837C25.7488 30.8837 30.8837 25.7488 30.8837 19.4419C30.8837 13.1349 25.7488 8 19.4419 8C13.1349 8 8 13.1349 8 19.4419ZM9.67442 19.4419C9.67442 14.0614 14.0502 9.67442 19.4419 9.67442C24.8335 9.67442 29.2093 14.0614 29.2093 19.4419C29.2093 24.8223 24.8335 29.2093 19.4419 29.2093C14.0502 29.2093 9.67442 24.8223 9.67442 19.4419ZM30.5711 31.7544C30.7385 31.9218 30.9506 31.9999 31.1627 31.9999C31.3748 31.9999 31.5869 31.9218 31.7544 31.7544C32.0781 31.4306 32.0781 30.8948 31.7544 30.5711L29.5218 28.3385C29.1981 28.0148 28.6623 28.0148 28.3385 28.3385C28.0148 28.6623 28.0148 29.1981 28.3385 29.5218L30.5711 31.7544Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$search = function (classes) {
    return $author$project$IconSvg$search_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$SpecialSearchBar$specialSearchBar = function (cfg) {
    var rightbtnWithFilter = function (_v3) {
      var onFilter = _v3.zb;
      var onClear = _v3.yW;
      var btnStatus = $elm$core$String$isEmpty(cfg.s_) ? _Utils_Tuple2($author$project$IconSvg$filter, onFilter) : _Utils_Tuple2($author$project$IconSvg$close1, onClear);
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight1 h4 hairLineWidth secondary800Back ')]), _List_Nil), $author$project$Ui$Button$button({
        bh: 'padRight1 ',
        fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w4 h4')]), _List_fromArray([A2($elm$core$Tuple$first, btnStatus, 'w4 gray80Fill')])),
        xu: $author$project$ElmFramework$Lib$Ui$Button$Button(btnStatus.b)
      })]));
    };
    var locationBtn = F2(function (onToggleLocation, isLocationOn) {
      var styleClasses = isLocationOn ? ' gradient10Back ' : ' secondary800Back';
      return $author$project$Ui$Button$button({
        bh: ' marLeft2  ',
        fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' hairLinePad w6 h6 radius7 ' + styleClasses)]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('  secondary800Back radius18 fullWidth fullHeight flexCenter ')]), _List_fromArray([$author$project$IconSvg$gps('w3 primary0Fill ')]))])),
        xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onToggleLocation)
      });
    });
    var inputOrDebouncedInput = function () {
      var _v2 = cfg.i1;
      if (!_v2.$) {
        var debounceTime = _v2.a.mP;
        var debouncedInputTag = _v2.a.mQ;
        return $author$project$ElmFramework$Lib$Ui$DebouncedInput$debouncedInput({
          mP: debounceTime,
          mQ: debouncedInputTag,
          od: cfg.od,
          oq: 'bodyRegular padTop1h padBottom1h padLeft6h padRight1 relative flex1 sticky ' + 'styles.inputClasses',
          or: cfg.bu,
          pc: $elm$core$Maybe$Nothing,
          qv: cfg.bv,
          s_: cfg.s_,
          s5: ''
        });
      } else {
        return $author$project$ElmFramework$Lib$Ui$Input$input_custom({
          bP: $elm$core$Maybe$Nothing,
          bh: 'bodyRegular padTop1h padBottom1h padLeft6h padRight1 relative flex1 sticky ' + 'styles.inputClasses',
          bY: false,
          od: cfg.od,
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          bu: cfg.bu,
          bv: cfg.bv,
          ch: false,
          s_: cfg.s_
        });
      }
    }();
    var clearBtn = function (onClear) {
      var btn = $elm$core$String$isEmpty(cfg.s_) ? $author$project$ElmFramework$Lib$Util$noOpEl : A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight1 h4 hairLineWidth secondary800Back ')]), _List_Nil), $author$project$Ui$Button$button({
        bh: 'padRight1 ',
        fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w4 h4')]), _List_fromArray([$author$project$IconSvg$close1('w4 gray80Fill')])),
        xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onClear)
      })]));
      return btn;
    };
    var backBtn = function (maybeOnBack) {
      if (!maybeOnBack.$) {
        var onBack = maybeOnBack.a;
        return $author$project$Ui$Button$button({
          bh: ' marRight2h ',
          fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w6 h6 flexCenter radius7 backBtnBackground ')]), _List_fromArray([$author$project$IconSvg$back(' gray0Fill w5')])),
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onBack)
        });
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    };
    var style = function () {
      var _v0 = cfg.kI;
      switch (_v0.$) {
        case 0:
          var clearMsg = _v0.a;
          return {
            dF: 'gray0Back specialSearchShadow ',
            dG: backBtn(cfg.jq),
            ej: $author$project$ElmFramework$Lib$Util$noOpEl,
            Bg: clearBtn(clearMsg)
          };
        case 1:
          var searchMsgs = _v0.a;
          return {
            dF: 'gray0Back specialSearchShadow ',
            dG: backBtn(cfg.jq),
            ej: $author$project$ElmFramework$Lib$Util$noOpEl,
            Bg: rightbtnWithFilter(searchMsgs)
          };
        case 2:
          var onToggleLocation = _v0.a;
          var isLocationOn = _v0.b;
          return {
            dF: 'secondary800Back',
            dG: $author$project$ElmFramework$Lib$Util$noOpEl,
            ej: A2(locationBtn, onToggleLocation, isLocationOn),
            Bg: $author$project$ElmFramework$Lib$Util$noOpEl
          };
        default:
          var onFilter = _v0.a.zb;
          var onClear = _v0.a.yW;
          return {
            dF: 'secondary800Back',
            dG: $author$project$ElmFramework$Lib$Util$noOpEl,
            ej: $author$project$ElmFramework$Lib$Util$noOpEl,
            Bg: rightbtnWithFilter({
              yW: onClear,
              zb: onFilter
            })
          };
      }
    }();
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.bh), $elm$html$Html$Attributes$class('flexRow ')]), _List_fromArray([style.dG, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative radius7 flexRow flexAlignCenter spaceBetween flex1 '), $elm$html$Html$Attributes$class(style.dF)]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w5 h5 absoluteCenterY left0h radius9 secondary800Back flexCenter ')]), _List_fromArray([$author$project$IconSvg$search('w4 gray80Fill ')])), inputOrDebouncedInput, style.Bg])), style.ej]));
  };
  var $author$project$ElmFramework$Lib$Ui$Button$NoAction = {
    $: 2
  };
  var $author$project$Ui$Tags$dotToBackgroundClass = function (dot) {
    switch (dot) {
      case 0:
        return 'backgroundOrange';
      case 1:
        return 'backgroundGreen';
      case 2:
        return 'backgroundBlue';
      default:
        return 'backgroundRed';
    }
  };
  var $author$project$Ui$Tags$dotToHtml = function (dot) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class($author$project$Ui$Tags$dotToBackgroundClass(dot)), A2($elm$html$Html$Attributes$style, 'width', '7px'), A2($elm$html$Html$Attributes$style, 'height', '7px'), A2($elm$html$Html$Attributes$style, 'background', '7px'), A2($elm$html$Html$Attributes$style, 'margin-right', '7px'), A2($elm$html$Html$Attributes$style, 'border-radius', '100%')]), _List_Nil);
  };
  var $author$project$Ui$Tags$tag = function (cfg) {
    var sizeSet = function () {
      var _v3 = cfg.B3;
      switch (_v3) {
        case 0:
          return {
            bU: '  radius2 ',
            wE: ' w2 h2',
            oR: ' heading6Regular ',
            s6: 'miniTagPad radius8'
          };
        case 1:
          var _v4 = cfg.wE;
          if (!_v4.$) {
            var icon = _v4.a;
            return {
              bU: '  radius2 ',
              wE: 'w2 h2 ',
              oR: ' heading6Bold ',
              s6: ' smallTagPad radius8 '
            };
          } else {
            return {
              bU: '  radius2 ',
              wE: 'w2 h2 ',
              oR: ' heading5Bold ',
              s6: ' smallTextTagPad radius8 '
            };
          }
        case 2:
          var _v5 = cfg.wE;
          if (!_v5.$) {
            var icon = _v5.a;
            return {
              bU: '  radius2 ',
              wE: 'w2 h2 ',
              oR: ' heading6Bold ',
              s6: ' smallTagLowPad radius8 '
            };
          } else {
            return {
              bU: '  radius2 ',
              wE: 'w2 h2 ',
              oR: ' heading5Bold ',
              s6: ' smallTextTagLowPad radius8 '
            };
          }
        default:
          return {
            bU: '  radius7 ',
            wE: 'w4 h4 ',
            oR: ' heading5Bold ',
            s6: ' BigTagPad radius7 '
          };
      }
    }();
    var dot = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, A2($elm$core$Basics$composeL, $elm$core$List$singleton, $author$project$Ui$Tags$dotToHtml), cfg.av);
    var colorSet = function () {
      var _v2 = cfg.cD;
      switch (_v2) {
        case 0:
          return {
            aS: ' primary80Back ',
            bg: 'primary80Back ',
            bn: ' secondary0Fill ',
            eS: 'gray0'
          };
        case 1:
          return {
            aS: ' backgroundBlack ',
            bg: 'backgroundBlack ',
            bn: 'gray40Fill ',
            eS: 'gray40'
          };
        case 2:
          return {
            aS: ' gray10Back ',
            bg: 'gray10Back ',
            bn: 'gray40Fill ',
            eS: 'gray40'
          };
        case 3:
          return {
            aS: ' secondary0Back ',
            bg: 'secondary0Back ',
            bn: 'primary0Fill ',
            eS: 'primary0'
          };
        case 4:
          return {
            aS: ' gray0Back ',
            bg: 'gray0Back ',
            bn: 'gray40Fill ',
            eS: 'gray80'
          };
        case 6:
          return {
            aS: ' primary0Back ',
            bg: 'primary0Back ',
            bn: 'gray80Fill ',
            eS: 'gray0'
          };
        default:
          return {
            aS: ' gray0Back ',
            bg: ' gradient10Back ',
            bn: '',
            eS: ''
          };
      }
    }();
    var iconBox = function () {
      var _v1 = cfg.wE;
      if (!_v1.$) {
        var icon = _v1.a;
        return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('marRight0h ' + sizeSet.wE)]), _List_fromArray([icon(_Utils_ap(sizeSet.wE, colorSet.bn))]));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();
    return $author$project$Ui$Button$button({
      bh: ' hairLinePad ' + (colorSet.bg + (sizeSet.bU + (cfg.uj + ' inlineBlock  '))),
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter ' + (sizeSet.s6 + colorSet.aS))]), _List_fromArray([iconBox, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexCenter ' + sizeSet.oR), $elm$html$Html$Attributes$class(colorSet.eS)]), _Utils_ap(dot, _List_fromArray([$elm$html$Html$text(cfg.oR)])))])),
      xu: function () {
        var _v0 = cfg.p_;
        if (!_v0.$) {
          var onTap = _v0.a;
          return $author$project$ElmFramework$Lib$Ui$Button$Button(onTap);
        } else {
          return $author$project$ElmFramework$Lib$Ui$Button$NoAction;
        }
      }()
    });
  };
  var $author$project$ElmFramework$Lib$Util$topAppSpacerCssOnly = A3($elm$html$Html$node, 'spacer', _List_fromArray([$elm$html$Html$Attributes$class('block'), A2($elm$html$Html$Attributes$attribute, 'style', 'height: env(safe-area-inset-top); height: constant(safe-area-inset-top)')]), _List_Nil);
  var $author$project$UiWrappers$HeaderAndBodyView$body = function (cfg) {
    var topBar = function () {
      var _v25 = cfg.CT;
      if (!_v25.$) {
        switch (_v25.a.$) {
          case 0:
            var config = _v25.a.a;
            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$SpecialSearchBar$specialSearchBar({
              bh: '',
              od: '',
              i1: config.i1,
              jq: $elm$core$Maybe$Just(config.yQ),
              bu: config.bu,
              bv: 'Search',
              kI: $author$project$Ui$SpecialSearchBar$DefaultSearch(config.yX),
              s_: config.wR
            })]));
          case 1:
            var config = _v25.a.a;
            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$DupleTextSlider$dupleTextSlider({
              bh: 'heading4Bold marTop1',
              u$: config.u$,
              xn: config.xn,
              zG: config.zG,
              BP: ''
            })]));
          default:
            var config = _v25.a.a;
            var rightBtn = function () {
              var _v28 = config.Bg;
              if (!_v28.$) {
                if (!_v28.a.$) {
                  var btnCfg = _v28.a.a;
                  var _v29 = btnCfg.xa ? _Utils_Tuple2(' noPointerEvents  ', ' gray40 ') : _Utils_Tuple2('   ', '  ');
                  var disabledBtnClasses = _v29.a;
                  var disabledColorClasses = _v29.b;
                  return $author$project$Ui$Button$button({
                    bh: '  radius2 noOverflow padTop0h padBottom0h padRight1 padLeft1 backBtnBackground ' + disabledBtnClasses,
                    fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' h6 heading5Bold radius7  gray0 '), $elm$html$Html$Attributes$class(disabledColorClasses)]), _List_fromArray([$elm$html$Html$text(btnCfg.oR)])),
                    xu: $author$project$ElmFramework$Lib$Ui$Button$Button(btnCfg.p_)
                  });
                } else {
                  var btnCfg = _v28.a.a;
                  return $author$project$Ui$Button$button({
                    bh: ' w4 h4 flexCenter radius2 noOverflow padTop0h padBottom0h padRight1 padLeft1 backBtnBackground ',
                    fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' w3 h3 heading5Bold radius7  gray0 ')]), _List_fromArray([btnCfg.wE('w3 gray0Fill ')])),
                    xu: $author$project$ElmFramework$Lib$Ui$Button$Button(btnCfg.p_)
                  });
                }
              } else {
                return $author$project$ElmFramework$Lib$Util$noOpEl;
              }
            }();
            var middleBarEl = function () {
              var _v27 = config.yo;
              if (!_v27.$) {
                if (!_v27.a.$) {
                  var title = _v27.a.a;
                  return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading5Bold gray0 absoluteCenter ')]), _List_fromArray([$elm$html$Html$text(title)]));
                } else {
                  var tagConfig = _v27.a.a;
                  return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' absoluteCenter ')]), _List_fromArray([$author$project$Ui$Tags$tag(tagConfig)]));
                }
              } else {
                return $author$project$ElmFramework$Lib$Util$noOpEl;
              }
            }();
            var backBtn = function () {
              var _v26 = config.xC;
              if (!_v26.$) {
                var onBack = _v26.a;
                return $author$project$Ui$Button$button({
                  bh: 'radius2 noOverflow pad0h backBtnBackground ',
                  fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w3 h3 block ')]), _List_fromArray([$author$project$IconSvg$back(' gray0Fill w3')])),
                  xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onBack)
                });
              } else {
                return $author$project$ElmFramework$Lib$Util$noOpEl;
              }
            }();
            return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow flexAlignCenter spaceBetween relative fullWidth minH4  ')]), _List_fromArray([backBtn, middleBarEl, rightBtn]));
        }
      } else {
        return A2($elm$html$Html$div, _List_Nil, _List_Nil);
      }
    }();
    var theBottomSpacerContent = $author$project$Ui$TopLevelViewsUtil$bottomSpacerContent({
      l5: cfg.l5,
      t_: cfg.t_
    });
    var maybeSubmitHandler = function () {
      var _v14 = cfg.l5;
      if (!_v14.$) {
        switch (_v14.a.$) {
          case 0:
            var btnConfig = _v14.a.a;
            return $elm$core$Maybe$Just($elm$html$Html$Events$onSubmit(btnConfig.p_));
          case 1:
            var btnConfig = _v14.a.a;
            return $elm$core$Maybe$Just($elm$html$Html$Events$onSubmit(btnConfig.p_));
          case 2:
            var _v15 = _v14.a.a;
            var leftBtnConfig = _v15.a;
            var btnConfig = _v15.b;
            return $elm$core$Maybe$Just($elm$html$Html$Events$onSubmit(btnConfig.p_));
          case 3:
            var _v16 = _v14.a.a;
            var msg = _v16.a;
            var btnConfig = _v16.b;
            return $elm$core$Maybe$Just($elm$html$Html$Events$onSubmit(btnConfig.p_));
          case 4:
            var _v17 = _v14.a;
            return $elm$core$Maybe$Nothing;
          case 5:
            var text = _v14.a.a.eS;
            var button = _v14.a.a.fb;
            return $elm$core$Maybe$Just($elm$html$Html$Events$onSubmit(button.p_));
          case 6:
            var btnConfig = _v14.a.a;
            return $elm$core$Maybe$Just($elm$html$Html$Events$onSubmit(btnConfig.p_));
          case 7:
            var btnConfig = _v14.a.a;
            return $elm$core$Maybe$Just($elm$html$Html$Events$onSubmit(btnConfig.p_));
          case 8:
            var _v18 = _v14.a.a;
            var leftBtnConfig = _v18.a;
            var btnConfig = _v18.b;
            return $elm$core$Maybe$Just($elm$html$Html$Events$onSubmit(btnConfig.p_));
          case 9:
            var _v19 = _v14.a.a;
            var leftBtnConfig = _v19.a;
            var btnConfig = _v19.b;
            return $elm$core$Maybe$Just($elm$html$Html$Events$onSubmit(btnConfig.p_));
          case 10:
            var btnConfig = _v14.a.a;
            return $elm$core$Maybe$Just($elm$html$Html$Events$onSubmit(btnConfig.p_));
          case 11:
            var _v20 = _v14.a.a;
            var leftBtnConfig = _v20.a;
            var btnConfig = _v20.b;
            return $elm$core$Maybe$Just($elm$html$Html$Events$onSubmit(btnConfig.p_));
          default:
            var btnConfig = _v14.a.a;
            return $elm$core$Maybe$Just($elm$html$Html$Events$onSubmit(btnConfig.p_));
        }
      } else {
        var _v21 = cfg.CT;
        if (!_v21.$) {
          var topBarValue = _v21.a;
          switch (topBarValue.$) {
            case 0:
              var record = topBarValue.a;
              return $elm$core$Maybe$Nothing;
            case 1:
              var sliderOptionCfg = topBarValue.a;
              return $elm$core$Maybe$Nothing;
            default:
              var rightBtn = topBarValue.a.Bg;
              if (!rightBtn.$) {
                var button = rightBtn.a;
                if (!button.$) {
                  var onTap = button.a.p_;
                  return $elm$core$Maybe$Just($elm$html$Html$Events$onSubmit(onTap));
                } else {
                  var record = button.a;
                  return $elm$core$Maybe$Nothing;
                }
              } else {
                return $elm$core$Maybe$Nothing;
              }
          }
        } else {
          return $elm$core$Maybe$Nothing;
        }
      }
    }();
    var wrapperElement = function () {
      if (!maybeSubmitHandler.$) {
        var submit = maybeSubmitHandler.a;
        return $elm$html$Html$form(_List_fromArray([$elm$html$Html$Attributes$class('flexColumn fullMinHeight relative '), submit]));
      } else {
        return $elm$html$Html$div(_List_fromArray([$elm$html$Html$Attributes$class('flexColumn fullMinHeight relative ')]));
      }
    }();
    var bodyBackgroundStripes = function () {
      var _v11 = cfg.Ck;
      if (!_v11.$ && _v11.a === 6) {
        var _v12 = _v11.a;
        return $author$project$Ui$Background$bodyBackgroundBottomLeft;
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();
    var backgroundStripes = function () {
      var _v3 = cfg.Ck;
      if (!_v3.$) {
        switch (_v3.a) {
          case 0:
            var _v4 = _v3.a;
            return $author$project$Ui$Background$backgroundTopRightOnly;
          case 1:
            var _v5 = _v3.a;
            return $author$project$Ui$Background$backgroundTopLeftAndBottomRight;
          case 2:
            var _v6 = _v3.a;
            return $author$project$Ui$Background$backgroundSmallTopLeftAndBottomRight;
          case 3:
            var _v7 = _v3.a;
            return $author$project$Ui$Background$backgroundSmallTopLeftAndBottomRight15;
          case 6:
            var _v8 = _v3.a;
            return $author$project$Ui$Background$backgroundTopLeftAndBottomRight;
          case 4:
            var _v9 = _v3.a;
            return $author$project$Ui$Background$backgroundCenteredLeft;
          default:
            var _v10 = _v3.a;
            return $author$project$Ui$Background$backgroundBottomLeft;
        }
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();
    var blackBackground = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread primary0Back ')]), _List_fromArray([backgroundStripes]));
    var backgroundImage = function () {
      var _v2 = cfg.l$;
      switch (_v2.$) {
        case 1:
          var image = _v2.a;
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' absoluteSpread ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
            t_: cfg.t_,
            uj: ' backgroundTop ',
            wG: image,
            Dq: 1,
            s5: ' relative block fullHeight  '
          }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread headerBackgroundOverlayGradient')]), _List_Nil)]));
        case 2:
          var image = _v2.a;
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' absoluteSpread o4')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
            t_: cfg.t_,
            uj: '  ',
            wG: image,
            Dq: 1,
            s5: ' relative block fullHeight   '
          }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread headerBackgroundOverlayGradient')]), _List_Nil)]));
        case 3:
          var opacity = _v2.a;
          var image = _v2.b;
          var imgOpacityclasses = 'o' + $elm$core$String$fromInt(opacity);
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' absoluteSpread ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread')]), _List_Nil), $author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
            t_: cfg.t_,
            uj: ' backgroundTop ',
            wG: image,
            Dq: 1,
            s5: ' relative block fullHeight ' + imgOpacityclasses
          })]));
        default:
          return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();
    var _v0 = function () {
      var _v1 = cfg.xB;
      if (!_v1.$) {
        return _Utils_Tuple3('', ' flex1 ', '');
      } else {
        var isHeaderContentVerticallyCentered = _v1.a.xc;
        return isHeaderContentVerticallyCentered ? _Utils_Tuple3(' flex1 flexAlignCenter ', '', ' flex1 flexCenterColumn ') : _Utils_Tuple3(' flex1 ', '', 'flex1');
      }
    }();
    var headerClasses = _v0.a;
    var bodyClasses = _v0.b;
    var innerHeaderClasses = _v0.c;
    var bodyContent = _Utils_eq(cfg.tU, _List_Nil) ? A2($elm$html$Html$div, _List_Nil, _List_Nil) : A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' fullWidth phoneWidthCenter gray0Back pad2 padTop3 radiusTopRight5 radiusTopLeft5 marTop-5 relative flexColumn '), $elm$html$Html$Attributes$class(bodyClasses)]), A2($elm$core$List$cons, bodyBackgroundStripes, cfg.tU));
    var header = F2(function (topbar, backImg) {
      return _List_fromArray([backImg, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padRight2 padLeft2 padTop1 fullHeight flexColumn flex1 fullWidth relative')]), _List_fromArray([$author$project$ElmFramework$Lib$Util$topAppSpacerCssOnly, topbar, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(innerHeaderClasses + '  ')]), cfg.ww)]))]);
    });
    return _List_fromArray([wrapperElement(A2($elm$core$List$cons, blackBackground, A2($elm$core$List$cons, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' fullWidth phoneWidthCenter padBottom5 relative flexColumn'), $elm$html$Html$Attributes$class(headerClasses)]), A2(header, topBar, backgroundImage)), A2($elm$core$List$cons, bodyContent, _List_fromArray([theBottomSpacerContent])))))]);
  };
  var $author$project$UiWrappers$HeaderAndBodyView$scrollerElementAttrs = _List_fromArray([$elm$html$Html$Attributes$class('block absoluteSpread scrollTarget')]);
  var $author$project$UiWrappers$HeaderAndBodyView$theWrap = function (content) {
    return A3($elm$html$Html$node, 'header-and-body-view', _List_fromArray([$elm$html$Html$Attributes$class('block absoluteSpread fullMinHeight ')]), _List_fromArray([content]));
  };
  var $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView = function (cfg) {
    return $author$project$UiWrappers$HeaderAndBodyView$theWrap(A3($author$project$ElmFramework$Lib$Ui$EventFull$eventFull, _List_Nil, $author$project$UiWrappers$HeaderAndBodyView$scrollerElementAttrs, $author$project$UiWrappers$HeaderAndBodyView$body({
      l$: cfg.l$,
      tU: cfg.tU,
      l5: cfg.l5,
      t_: cfg.t_,
      ww: cfg.ww,
      xB: cfg.xB,
      Ck: cfg.Ck,
      CT: cfg.CT
    })));
  };
  var $author$project$AssetsSvg$logoIconGradient_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 56 56'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M11.7471 56L1.3999 46.2845L18.5686 28L1.3999 9.7155L11.7471 0L28.3039 17.6321L44.8598 0L55.2069 9.7155L38.0382 28L28.3039 38.368L11.7471 56ZM55.2068 46.2843L44.8597 55.9998C37.0877 47.7229 37.6877 38.3014 40.5113 30.6344L55.2068 46.2843Z'), $elm$svg$Svg$Attributes$fill('url(#generatedSvgId_1mxat_23)')]), _List_Nil)]));
  };
  var $author$project$AssetsSvg$logoIconGradient = function (classes) {
    return $author$project$AssetsSvg$logoIconGradient_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$Overlays$overlayHeaderIconTextContent = F4(function (_v0, title, subTextParagraphList, isCenterAligned) {
    var icon = _v0.a;
    var iconWidthUnits = _v0.b;
    var iconWidthString = $elm$core$String$fromInt(iconWidthUnits);
    var iconWidthClasses = 'w' + (iconWidthString + (' ' + ('h' + iconWidthString)));
    var alignmentClass = isCenterAligned ? 'center ' : 'left ';
    var subText = A2($elm$core$List$map, function (paragraph) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bodyRegular gray10 marBottom1 ' + alignmentClass)]), _List_fromArray([$elm$html$Html$text(paragraph)]));
    }, subTextParagraphList);
    return _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn flexAlignCenter marTop9 marRight3 marLeft3 ')]), _Utils_ap(_List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(iconWidthClasses + ' marBottom2 ')]), _List_fromArray([icon(iconWidthClasses)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0 marBottom1 center ')]), _List_fromArray([$elm$html$Html$text(title)]))]), subText))]);
  });
  var $author$project$Ui$Overlays$confirmRemovePaymentMethodDialog = F2(function (paymentMethodId, browser) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$RadiusWrappedPairButtons(_Utils_Tuple2({
          xa: false,
          oR: 'Yes, remove payment method',
          p_: $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$RemoveStripePaymentMethod(paymentMethodId)),
          r8: 1
        }, {
          xa: false,
          oR: 'Cancel',
          p_: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
          r8: 0
        }))),
        t_: browser,
        ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$logoIconGradient, 6), 'Are you sure to remove this payment method?', _List_fromArray(['This action can not be undone']), true),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  });
  var $author$project$Remote$RequestMsg$DisableUser = function (a) {
    return {
      $: 39,
      a: a
    };
  };
  var $author$project$Ui$Overlays$deleteAccountDialog = F2(function (browser, userId) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$RadiusWrappedPairButtons(_Utils_Tuple2({
          xa: false,
          oR: 'Yes, delete account',
          p_: $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$DisableUser(userId)),
          r8: 1
        }, {
          xa: false,
          oR: 'Cancel',
          p_: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
          r8: 0
        }))),
        t_: browser,
        ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$logoIconGradient, 10), 'Are your sure you want to delete your account?', _List_fromArray(['This action cannot be undone. If you delete the account all the data and information will be permanently deleted.']), true),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  });
  var $author$project$Ui$TopLevelViewsUtil$RadiusWrappedButton = function (a) {
    return {
      $: 10,
      a: a
    };
  };
  var $author$project$Ui$Overlays$emailNotVerifiedOnPaymentDialog = function (browser) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$RadiusWrappedButton({
          xa: false,
          oR: 'Continue',
          p_: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
          r8: 0
        })),
        t_: browser,
        ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$logoIconGradient, 10), 'Email not verified', _List_fromArray(['Please verify your email before proceeding with payment.', 'We have sent a confirmation email to your email address.']), true),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  };
  var $author$project$AssetsSvg$xrivalsCheck_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 80 80'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M73.3 40C73.3 58.3911 58.3911 73.3 40 73.3C21.6089 73.3 6.7 58.3911 6.7 40C6.7 21.6089 21.6089 6.7 40 6.7C58.3911 6.7 73.3 21.6089 73.3 40ZM80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40ZM53.3462 27L58.2734 31.6264L50.0978 40.3333L45.462 45.2704L37.5782 53.6667L32.651 49.0402L40.8266 40.3333L45.462 35.3962L53.3462 27ZM30.9997 47.0008L35.6261 42.0736C31.6847 38.3726 27.1983 38.6583 23.5473 40.0029L30.9997 47.0008Z'), $elm$svg$Svg$Attributes$fill('url(#generatedSvgId_1mxat_10)')]), _List_Nil)]));
  };
  var $author$project$AssetsSvg$xrivalsCheck = function (classes) {
    return $author$project$AssetsSvg$xrivalsCheck_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$Overlays$feedbackNegativeDialog = function (browser) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$RadiusWrappedButton({
          xa: false,
          oR: 'Continue',
          p_: $author$project$ElmFramework$MsgCmd$msgCmd.yw(_List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$MoreOptions), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)])),
          r8: 0
        })),
        t_: browser,
        ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$xrivalsCheck, 10), 'Thanks for sharing!', _List_fromArray(['We really appreciate your feedback, it truly helps us to improve. ']), true),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  };
  var $author$project$Ui$ComponentsPreview$Msg$NoOp = {
    $: 34
  };
  var $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg = function (msg) {
    return $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$ComponentsPreviewMsg(msg));
  };
  var $author$project$Ui$Overlays$feedbackPositiveDialog = function (browser) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$RadiusWrappedPairButtons(_Utils_Tuple2({
          xa: false,
          oR: 'Leave for another moment',
          p_: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$OnUserWantsBack),
          r8: 1
        }, {
          xa: false,
          oR: 'Sure!',
          p_: $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$NoOp),
          r8: 0
        }))),
        t_: browser,
        ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$xrivalsCheck, 10), 'Thanks for sharing!', _List_fromArray(['Would you mind rating us in the App Store / Google Play?']), true),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  };
  var $author$project$AssetsSvg$xrivalsAlert_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 80 80'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M40 73.3C58.3911 73.3 73.3 58.3911 73.3 40C73.3 21.6089 58.3911 6.7 40 6.7C21.6089 6.7 6.7 21.6089 6.7 40C6.7 58.3911 21.6089 73.3 40 73.3ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80ZM36 51H44V59H36V51ZM44 21H36V49H44V21Z'), $elm$svg$Svg$Attributes$fill('url(#generatedSvgId_1mxat_9)')]), _List_Nil)]));
  };
  var $author$project$AssetsSvg$xrivalsAlert = function (classes) {
    return $author$project$AssetsSvg$xrivalsAlert_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$Overlays$joinMatchNotEnoughRoom = function (browser) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$RadiusWrappedButton({
          xa: false,
          oR: 'Continue',
          p_: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
          r8: 0
        })),
        t_: browser,
        ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$xrivalsAlert, 12), 'Oh no, it looks like someone else joined this match just before you!', _List_fromArray(['Don\'t worry, more match opportunities should be coming your way soon.']), true),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Just($author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)),
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  };
  var $author$project$TopMsg$multiMsg = function (list) {
    return $author$project$ElmFramework$Msg$MultiMsg(list);
  };
  var $author$project$Ui$Overlays$joinMatchWithInviteesDialog = F2(function (browser, matchId) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$RadiusWrappedButton({
          xa: false,
          oR: 'Continue to payment',
          p_: $author$project$TopMsg$multiMsg(_List_fromArray([$author$project$TopMsg$routeTo(A2($author$project$Route$Route$Match, matchId, $author$project$Ui$Match$Route$PayMatch(0))), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)])),
          r8: 0
        })),
        t_: browser,
        ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$xrivalsCheck, 10), 'You’re joining the match on behalf of the other players as well', _List_fromArray(['Keep in mind that the players you invited are also being committed to this match.']), true),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Just($author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)),
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  });
  var $author$project$Ui$MyPlayerStatus$Msg$DateOrderSet = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$TopLevelViewsUtil$InlineBelowContentBtn = function (a) {
    return {
      $: 6,
      a: a
    };
  };
  var $author$project$Ui$SelectItem$Label = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Api$GraphqlSchema$Enum$DateOrder$OldFirst = 1;
  var $author$project$UiWrappers$BottomDrawerOverlayView$body = function (cfg) {
    var theBottomSpacerContent = $author$project$Ui$TopLevelViewsUtil$bottomSpacerContent({
      l5: cfg.l5,
      t_: cfg.t_
    });
    var submitHandler = function () {
      var _v0 = cfg.l5;
      if (!_v0.$ && !_v0.a.$) {
        var btnConfig = _v0.a.a;
        return $elm$html$Html$Events$onSubmit(btnConfig.p_);
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpAttr;
      }
    }();
    var overlay = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth absoluteSpread primary0Back o8'), $author$project$ElmFramework$Lib$Util$onTap(cfg.pR)]), _List_Nil);
    var hr = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w5 h0h radius5 gray10Back absoluteCenterX top1'), A2($elm$html$Html$Attributes$style, 'transform', 'translateY(-50%) translateX(-50%)')]), _List_Nil);
    var bodyContent = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth phoneWidthCenter gray0Back pad2 relative radiusTopLeft5 radiusTopRight5')]), A2($elm$core$List$cons, hr, cfg.fn));
    return _List_fromArray([A2($elm$html$Html$form, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn fullMinHeight justifyEnd'), submitHandler]), A2($elm$core$List$cons, $author$project$ElmFramework$Lib$Util$topAppSpacerCssOnly, A2($elm$core$List$cons, overlay, A2($elm$core$List$cons, bodyContent, _List_fromArray([theBottomSpacerContent])))))]);
  };
  var $author$project$UiWrappers$BottomDrawerOverlayView$scrollerElementAttrs = _List_fromArray([$elm$html$Html$Attributes$class('block absoluteSpread scrollTarget')]);
  var $author$project$UiWrappers$BottomDrawerOverlayView$theWrap = function (content) {
    return A3($elm$html$Html$node, 'bottom-drawer-overlay-view', _List_fromArray([$elm$html$Html$Attributes$class('block absoluteSpread fullMinHeight z1')]), _List_fromArray([content]));
  };
  var $author$project$UiWrappers$BottomDrawerOverlayView$bottomDrawerOverlayView = function (cfg) {
    return $author$project$UiWrappers$BottomDrawerOverlayView$theWrap(A3($author$project$ElmFramework$Lib$Ui$EventFull$eventFull, _List_Nil, $author$project$UiWrappers$BottomDrawerOverlayView$scrollerElementAttrs, $author$project$UiWrappers$BottomDrawerOverlayView$body(cfg)));
  };
  var $author$project$UiWrappers$HeaderAndBodyView$multipleBodyContentMaybeTopbar = function (contentList) {
    var toContentWrapper = function (item) {
      if (!item.$) {
        var contentItem = item.a;
        var topbar = function () {
          var _v1 = contentItem.gL;
          if (!_v1.$) {
            var topBar = _v1.a;
            var rightBtn = function () {
              var _v2 = topBar.Bg;
              if (!_v2.$) {
                var _v3 = _v2.a;
                var label = _v3.a;
                var onTap = _v3.b;
                return $author$project$Ui$Button$button({
                  bh: 'heading4Bold secondary100 ',
                  fn: $elm$html$Html$text(label),
                  xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onTap)
                });
              } else {
                return $author$project$ElmFramework$Lib$Util$noOpEl;
              }
            }();
            return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter spaceBetween marBottom2 padTop1 noOverflow ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w4 h4 flexCenter marRight1 ')]), _List_fromArray([A2($elm$core$Tuple$first, topBar.wE, 'w4 gray80Fill ')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0 heading2Bold whiteSpaceNoWrap  ellipsis')]), _List_fromArray([$elm$html$Html$text(topBar.lh)]))])), rightBtn]));
          } else {
            return $author$project$ElmFramework$Lib$Util$noOpEl;
          }
        }();
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad2 radiusTopRight5 radiusTopLeft5 gray0Back  newWrapperShadow padBottom5 marTop-3 '), $elm$html$Html$Attributes$class(contentItem.uj)]), _List_fromArray([topbar, A2($elm$html$Html$div, _List_Nil, _List_fromArray([contentItem.fn]))]));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    };
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight-2 marLeft-2 flexColumn flex1 marBottom-2 ')]), A2($elm$core$List$map, toContentWrapper, contentList));
  };
  var $author$project$Ui$Button$selectButtonItem = function (config) {
    var selected = config.xj ? {
      uj: ' gradient10Back primary0'
    } : {
      uj: ' noBorder secondary800Back'
    };
    return $author$project$Ui$Button$button({
      bh: ' hairLinePad ' + (selected.uj + config.uj),
      fn: config.fn,
      xu: A3($author$project$ElmFramework$Lib$Util$ifElse, $author$project$ElmFramework$Lib$Ui$Button$NoAction, $author$project$ElmFramework$Lib$Ui$Button$Button(config.Cu), config.xa)
    });
  };
  var $author$project$IconSvg$wheelchair_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M18.9196 9.45455C17.5939 9.45455 16.5195 10.5398 16.5195 11.8788C16.5195 13.2178 17.5939 14.303 18.9196 14.303C20.2453 14.303 21.3197 13.2178 21.3197 11.8788C21.3197 10.5398 20.2453 9.45455 18.9196 9.45455ZM15.0795 11.8788C15.0795 9.73674 16.7989 8 18.9196 8C21.0403 8 22.7598 9.73674 22.7598 11.8788C22.7598 13.8565 21.2935 15.4891 19.3996 15.7277V17.4545C19.3996 17.8494 19.4446 18.1321 19.5084 18.3371C19.5853 18.5777 19.6884 18.7107 19.7803 18.7912L19.844 18.8409C19.8984 18.8793 19.9603 18.9129 20.0334 18.9422C20.2303 19.0232 20.5003 19.0729 20.8753 19.0919C21.1397 19.1051 21.4172 19.1027 21.7285 19.0999L21.7678 19.0994L22.066 19.0975C22.2947 19.0971 22.5347 19.1004 22.7729 19.1151C23.0673 19.1326 23.3785 19.1681 23.6898 19.2424C24.0967 19.3395 24.5036 19.5033 24.8711 19.7817C25.1899 20.0227 25.2536 20.4787 25.0155 20.8002C24.7773 21.1212 24.3254 21.1866 24.0086 20.9455C23.6973 20.7102 23.2698 20.6018 22.6866 20.5668C22.5647 20.5597 22.4391 20.5554 22.3116 20.5535L22.126 20.5521L21.7791 20.554L21.7266 20.5544C21.4285 20.5573 21.1116 20.5601 20.8041 20.5445C20.3615 20.5223 19.8609 20.4602 19.3996 20.25V22.303C19.3996 22.581 19.4203 22.8177 19.454 23.0194C19.5084 23.3433 19.6003 23.5781 19.7053 23.7495C19.8665 24.0151 20.0972 24.1903 20.4234 24.3078C20.7628 24.4313 21.1978 24.4858 21.7266 24.4934C22.1954 24.5 22.6923 24.4702 23.2248 24.438L23.4385 24.4257C24.0254 24.3911 24.6742 24.3551 25.3136 24.3963C25.9343 24.4361 26.5474 24.5483 27.0856 24.804C27.6668 25.0795 28.1637 25.5185 28.505 26.1742C28.8387 26.8163 29 27.6217 29 28.6061C29 29.0076 28.6775 29.3333 28.28 29.3333C28.1918 29.3333 28.1075 29.3177 28.0306 29.2883C27.9781 29.2685 27.9275 29.2424 27.8806 29.2107C27.6874 29.08 27.5599 28.858 27.5599 28.6061C27.5599 27.7723 27.4212 27.2192 27.2299 26.8504C27.1456 26.6875 27.0462 26.5526 26.9337 26.4394C26.8005 26.3054 26.6468 26.2022 26.4743 26.1203C26.0355 25.9124 25.4805 25.8409 24.8242 25.8343C24.4267 25.83 23.9917 25.8499 23.521 25.8774L23.311 25.8901C23.071 25.9048 22.8235 25.9195 22.576 25.9304C22.2854 25.9437 21.9929 25.9517 21.7078 25.9479C21.1116 25.9394 20.4965 25.8793 19.9359 25.6771C19.3621 25.4687 18.8427 25.1075 18.479 24.5137C18.1246 23.9332 17.9596 23.196 17.9596 22.303V17.4545V15.6354C16.3039 15.2045 15.0795 13.6861 15.0795 11.8788ZM15.7301 17.0795C16.1107 16.9195 16.5308 17.1468 16.6508 17.545C16.7708 17.9432 16.5476 18.3603 16.1708 18.5294C15.4713 18.8419 14.8357 19.2836 14.2938 19.8338C13.8344 20.2992 13.4538 20.8338 13.1613 21.4157C12.9963 21.7438 12.8594 22.0876 12.7544 22.4427C12.46 23.4271 12.4131 24.4692 12.6137 25.4768C12.8144 26.4844 13.2588 27.4261 13.9057 28.2192C14.5526 29.0123 15.3851 29.6316 16.3264 30.0227C17.2658 30.4138 18.2877 30.5644 19.3002 30.4612C19.9846 30.3916 20.6522 30.2069 21.2728 29.9176C21.5691 29.7789 21.856 29.6165 22.1297 29.4309C22.7673 28.9981 23.3185 28.4508 23.7554 27.8182C23.9186 27.5791 24.1886 27.437 24.4623 27.4408C24.5786 27.4422 24.6948 27.4702 24.8036 27.5289C25.1674 27.7244 25.308 28.1832 25.0811 28.5298C24.5223 29.3793 23.8042 30.1113 22.9623 30.6823C21.9141 31.3935 20.7084 31.8324 19.4503 31.9607C18.194 32.089 16.9264 31.902 15.7582 31.4167C14.5901 30.9313 13.5588 30.1624 12.7544 29.1785C11.95 28.1941 11.4006 27.0251 11.1512 25.7741C10.9487 24.758 10.9505 23.7135 11.1512 22.7026C11.1981 22.4692 11.2562 22.2377 11.3237 22.0085C11.6874 20.7869 12.3456 19.6747 13.2363 18.7704C13.9507 18.0445 14.7982 17.4706 15.7301 17.0795Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$wheelchair = function (classes) {
    return $author$project$IconSvg$wheelchair_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$SelectItem$selectOptionCard = function (cfg) {
    var selectedClasses = function () {
      var _v1 = cfg.fn;
      switch (_v1.$) {
        case 0:
          var date = _v1.a;
          var day = _v1.b;
          return ' radius7 ';
        case 1:
          var label = _v1.a;
          return ' radius8 ';
        default:
          var label = _v1.a;
          return ' radius8 ';
      }
    }();
    var showContent = function () {
      var classesCalendar = cfg.xj ? ' primary0' : A3($author$project$ElmFramework$Lib$Util$ifElse, 'gray20', 'gray80', cfg.xa);
      var classes = cfg.xj ? ' gray0Back primary0' : ' gray10Back gray40 gray40Fill';
      var _v0 = cfg.fn;
      switch (_v0.$) {
        case 0:
          var date = _v0.a;
          var day = _v0.b;
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(selectedClasses), $elm$html$Html$Attributes$class('w8 h9 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' radius17 fullHeight flexCenterColumn ' + classesCalendar), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('gray0Back', cfg.xa), _Utils_Tuple2('gray10Back', !cfg.xa)]))]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold')]), _List_fromArray([$elm$html$Html$text(date)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular ')]), _List_fromArray([$elm$html$Html$text(day)]))]))]));
        case 1:
          var label = _v0.a;
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(selectedClasses)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padLeft1h padRight1h padTop1 padBottom1 radius0 heading4Bold' + classes)]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text(label)]))]))]));
        default:
          var label = _v0.a;
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexCenter smallTagPad radius0' + classes)]), _List_fromArray([$author$project$IconSvg$wheelchair('w2' + classes), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold')]), _List_fromArray([$elm$html$Html$text(label)]))]));
      }
    }();
    return $author$project$Ui$Button$selectButtonItem({
      uj: ' flexCenter' + (selectedClasses + cfg.uj),
      fn: showContent,
      xa: cfg.xa,
      xj: cfg.xj,
      Cu: cfg.Cu
    });
  };
  var $author$project$Ui$Overlays$matchFiltersDialog = F2(function (browser, dateOrder) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$BottomDrawerOverlayView$bottomDrawerOverlayView({
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$InlineBelowContentBtn({
          xa: false,
          oR: 'Done',
          p_: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog),
          r8: 0
        })),
        t_: browser,
        fn: _List_fromArray([$author$project$UiWrappers$HeaderAndBodyView$multipleBodyContentMaybeTopbar(_List_fromArray([$elm$core$Maybe$Just({
          uj: 'flex1',
          fn: A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 heading3Bold primary0  fullWidth')]), _List_fromArray([$elm$html$Html$text('Sort by date')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop2')]), _List_fromArray([$author$project$Ui$SelectItem$selectOptionCard({
            uj: '',
            fn: $author$project$Ui$SelectItem$Label('Recent matches first'),
            xa: false,
            xj: !dateOrder,
            Cu: $author$project$TopMsg$msgMyPlayerStatus($author$project$Ui$MyPlayerStatus$Msg$DateOrderSet(0))
          }), $author$project$Ui$SelectItem$selectOptionCard({
            uj: 'marLeft2',
            fn: $author$project$Ui$SelectItem$Label('Old matches first'),
            xa: false,
            xj: dateOrder === 1,
            Cu: $author$project$TopMsg$msgMyPlayerStatus($author$project$Ui$MyPlayerStatus$Msg$DateOrderSet(1))
          })]))])),
          gL: $elm$core$Maybe$Just({
            wE: _Utils_Tuple2($author$project$IconSvg$filter, ''),
            Bg: $elm$core$Maybe$Just(_Utils_Tuple2('Reset', $author$project$TopMsg$msgMyPlayerStatus($author$project$Ui$MyPlayerStatus$Msg$DateOrderSet(0)))),
            lh: 'Filters'
          })
        })]))]),
        pR: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)
      })
    });
  });
  var $author$project$Ui$TopLevelViewsUtil$IconBtn = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$IconSvg$close_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M26.5703 28.4852C27.0857 29.0006 27.9405 29.0006 28.4559 28.4852C28.9713 27.9698 28.9713 27.115 28.4559 26.5996L21.8563 20L28.4559 13.4004C28.9713 12.885 28.9713 12.0302 28.4559 11.5148C27.9405 10.9994 27.0857 10.9994 26.5703 11.5148L19.9707 18.1144L13.371 11.5147C12.8556 10.9993 12.0007 10.9993 11.4853 11.5147C10.9699 12.0301 10.9699 12.8849 11.4853 13.4003L18.0851 20L11.4853 26.5997C10.9699 27.1151 10.9699 27.9699 11.4853 28.4853C12.0007 29.0007 12.8556 29.0007 13.371 28.4853L19.9707 21.8856L26.5703 28.4852Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$close = function (classes) {
    return $author$project$IconSvg$close_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Types$Refund$toString = function (refundResult) {
    switch (refundResult.$) {
      case 0:
        var error = refundResult.a;
        return 'We couldn\'t refund your payment because: ' + error;
      case 2:
        var createdAt = refundResult.a.uV;
        var reason = refundResult.a.qV;
        var onTotalCharge = refundResult.a.zR;
        var percent = refundResult.a.An;
        var updatedTotalCharge = refundResult.a.C6;
        return 'You have been refunded ' + ($elm$core$String$fromInt(percent) + ('% of what you paid for the following reason: ' + reason));
      default:
        var message = refundResult.a;
        return 'We couldn\'t refund your payment because no refund is due';
    }
  };
  var $author$project$Ui$Overlays$matchSlotCanceledDialog = F3(function (browser, zone, refundResult) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Nothing,
        t_: browser,
        ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$logoIconGradient, 6), 'Your slot has been canceled', _List_fromArray([$author$project$Types$Refund$toString(refundResult)]), true),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$IconBtn({
            wE: $author$project$IconSvg$close,
            xa: false,
            p_: $author$project$ElmFramework$MsgCmd$msgCmd.yw(_List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bp($author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Upcoming)), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]))
          }))
        }))
      })
    });
  });
  var $author$project$Ui$Overlays$matchSlotCanceledLessThan24HoursPriorDialog = function (browser) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Nothing,
        t_: browser,
        ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$logoIconGradient, 6), 'Your slot has been canceled', _List_fromArray(['We will refund 50% of what you paid in a period of 1 to 3 business days']), true),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$IconBtn({
            wE: $author$project$IconSvg$close,
            xa: false,
            p_: $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }))
        }))
      })
    });
  };
  var $author$project$Ui$Overlays$matchSlotCanceledMoreThan24HoursPriorDialog = function (browser) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Nothing,
        t_: browser,
        ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$logoIconGradient, 6), 'Your slot has been canceled', _List_fromArray(['We will refund the amount paid to your bank account in a period of 1 to 3 business days']), true),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$IconBtn({
            wE: $author$project$IconSvg$close,
            xa: false,
            p_: $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$NoOp)
          }))
        }))
      })
    });
  };
  var $author$project$Remote$RequestMsg$ForgotPassword = F2(function (a, b) {
    return {
      $: 6,
      a: a,
      b: b
    };
  });
  var $author$project$AssetsSvg$password_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 174 80'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M140 0V8.33333L173.333 8.33341L173.333 63.3334V66.5135V66.6667V70.0001H140V80H133.333V15L133.333 8.33333V0H140ZM140 63.3334V15H166.667V63.3334H140ZM1.01792e-05 8.33325H120V14.9999H6.66667L6.66666 63.3333H120V70H0V66.6667V66.5134V63.3333L2.54983e-06 8.33333H1.01792e-05V8.33325ZM18.2606 53.3334L13.3333 48.707L21.5089 40.0001L13.3333 31.2932L18.2606 26.6667L26.1448 35.063L34.0285 26.6667L38.9557 31.2932L30.7802 40.0001L26.1448 44.9372L18.2606 53.3334ZM38.9557 48.7068L34.0285 53.3333C30.3276 49.3919 30.6133 44.9055 31.9579 41.2545L38.9557 48.7068ZM58.883 53.3334L53.9557 48.707L62.1313 40.0001L53.9557 31.2932L58.883 26.6667L66.7672 35.063L74.6509 26.6667L79.5781 31.2932L71.4026 40.0001L66.7672 44.9372L58.883 53.3334ZM79.5781 48.7068L74.6509 53.3333C70.95 49.3919 71.2357 44.9055 72.5803 41.2545L79.5781 48.7068ZM94.5781 48.707L99.5053 53.3334L107.39 44.9372L112.025 40.0001L120.2 31.2932L115.273 26.6667L107.39 35.063L99.5053 26.6667L94.5781 31.2932L102.754 40.0001L94.5781 48.707ZM115.273 53.3333L120.2 48.7068L113.203 41.2545C111.858 44.9055 111.572 49.3919 115.273 53.3333Z'), $elm$svg$Svg$Attributes$fill('url(#generatedSvgId_1mxat_28)')]), _List_Nil)]));
  };
  var $author$project$AssetsSvg$password = function (classes) {
    return $author$project$AssetsSvg$password_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$TopMsg$routeBack = $author$project$ElmFramework$Msg$RoutingMsg($author$project$ElmFramework$Feature$Navigation$Msg$RouteBack);
  var $author$project$Ui$Overlays$passwordRecoveryDialog = F2(function (browser, email) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$RadiusWrappedButton({
          xa: false,
          oR: 'Confirm',
          p_: $author$project$ElmFramework$MsgCmd$msgCmd.yw(_List_fromArray([$author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$ForgotPassword, $elm$core$Maybe$Just($author$project$Route$Route$MoreOptions), email)), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)])),
          r8: 0
        })),
        t_: browser,
        ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn flexAlignCenter center marTop9 ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' h10 marBottom2 ')]), _List_fromArray([$author$project$AssetsSvg$password('h10')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0 marBottom1  ')]), _List_fromArray([$elm$html$Html$text('Forgot your password?')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bodyRegular gray10 ')]), _List_fromArray([$elm$html$Html$text('We will send you a password reset link to the following email ' + email)]))]))]),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Just($author$project$ElmFramework$MsgCmd$msgCmd.yw(_List_fromArray([$author$project$TopMsg$routeBack, $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)]))),
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  });
  var $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody = {
    $: 0
  };
  var $elm$html$Html$p = _VirtualDom_node('p');
  var $author$project$Ui$Overlays$paymentInformationDialog = function (browser) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: function () {
        var answerText = _List_fromArray(['First of all, we never charge your card until you are actually matched with other players. BUT, for the benefit of all our players, we want to ensure all players are able to pay when committing to play a match, so we take your payment info now and charge you once a match is made. This also makes the matchmaking process streamlined and efficient, allowing everyone to play their favorite sport as quickly and easily as possible.']);
        return $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
          l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
          tU: _List_fromArray([A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, function (info) {
            return A2($elm$html$Html$p, _List_fromArray([$elm$html$Html$Attributes$class('marTop0 marBottom3 bodyRegular gray80')]), _List_fromArray([$elm$html$Html$text(info)]));
          }, answerText))]),
          l5: $elm$core$Maybe$Nothing,
          t_: browser,
          ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading1Bold gray0 marTop2 marBottom3 ')]), _List_fromArray([$elm$html$Html$text('Why are we asking for payment information now?')]))]),
          xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
          Ck: $elm$core$Maybe$Just(1),
          CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
            xC: $elm$core$Maybe$Just($author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)),
            yo: $elm$core$Maybe$Nothing,
            Bg: $elm$core$Maybe$Nothing
          }))
        });
      }()
    });
  };
  var $author$project$Ui$Overlays$postMatchPaymentConfirmationDialog = F2(function (browser, matchId) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$RadiusWrappedButton({
          xa: false,
          oR: 'Continue',
          p_: $author$project$TopMsg$multiMsg(_List_fromArray([$author$project$TopMsg$routeTo(A2($author$project$Route$Route$Match, matchId, $author$project$Ui$Match$Route$Details)), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)])),
          r8: 0
        })),
        t_: browser,
        ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$xrivalsCheck, 10), 'All set!', _List_fromArray(['Your payment has been received and your match is confirmed']), true),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  });
  var $author$project$Ui$Overlays$postPaymentActiveSearchConfirmationDialog = F3(function (browser, isEmptyPaymentMethods, isAutoPayEnabled) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$RadiusWrappedButton({
          xa: false,
          oR: 'View search in progress',
          p_: $author$project$TopMsg$multiMsg(_List_fromArray([$author$project$TopMsg$routeTo($author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Searches($author$project$Ui$MyPlayerStatus$Searches$Route$SearchesList))), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)])),
          r8: 0
        })),
        t_: browser,
        ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$logoIconGradient, 6), 'Looking for a match based on your preferences', _Utils_ap(_List_fromArray(['We will send you a notification when we have found your match. While the XRIVALS matching algorithm does its magic, here are some things to note: ']), !isEmptyPaymentMethods ? _List_fromArray(['Remember to bring your gear: racket, balls, etc.', 'Be nice to fellow players, so we can keep matching you with players just as courteous as you.']) : isAutoPayEnabled ? _List_fromArray(['Once we find you a match to play, your payment method on file will be automatically charged with only your portion of the matched venue\'s charges.', 'XRIVALS charges your share of the exact venue cost, without any additional fees or charges.']) : _List_fromArray(['Once your match is found, make sure you join as soon as possible, because matches are filled on a first-come-first-served basis.', 'XRIVALS charges your share of the exact venue cost, without any additional fees or charges.'])), true),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  });
  var $author$project$Ui$Overlays$recurringMatchCreatedNotificationsDisabled = function (browser) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer;
  };
  var $author$project$Ui$Overlays$recurringMatchCreatedNotificationsEnabled = function (browser) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer;
  };
  var $author$project$Ui$Overlays$removePlayerDialog = function (browser) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer;
  };
  var $author$project$Ui$Overlays$supportRequestSentDialog = function (browser) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$RadiusWrappedButton({
          xa: false,
          oR: 'Go to matchmaking',
          p_: $author$project$ElmFramework$MsgCmd$msgCmd.yw(_List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$Main)), $author$project$TopMsg$msgGlobal($author$project$Global$Msg$HideDialog)])),
          r8: 0
        })),
        t_: browser,
        ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$xrivalsCheck, 10), 'We have received your message', _List_fromArray(['We will get in touch with you very soon.']), true),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  };
  var $author$project$Ui$Overlays$unBanUserDialog = F2(function (userId, browser) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$RadiusWrappedPairButtons(_Utils_Tuple2({
          xa: false,
          oR: 'Yes, remove player form the banned list',
          p_: $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$NoOp),
          r8: 1
        }, {
          xa: false,
          oR: 'Cancel',
          p_: $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$NoOp),
          r8: 0
        }))),
        t_: browser,
        ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$logoIconGradient, 10), 'Are you sure to remove the player from the banned list?', _List_fromArray(['This action can not be undone']), true),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  });
  var $author$project$Ui$Overlays$userBannedDialog = function (browser) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_Nil,
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$RadiusWrappedButton({
          xa: false,
          oR: 'Go to banned list',
          p_: $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$NoOp),
          r8: 0
        })),
        t_: browser,
        ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$logoIconGradient, 6), 'Player added to banned list', _List_fromArray(['You can manage the players on your banner list']), true),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: false
        }),
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  };
  var $author$project$MainModule$modal = F2(function (topState, browser) {
    var _v0 = topState.lL.nV.dt;
    if (_v0.$ === 1) {
      return $author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer;
    } else {
      var dialogType = _v0.a;
      switch (dialogType.$) {
        case 0:
          var paymentMethodId = dialogType.a;
          return A2($author$project$Ui$Overlays$confirmRemovePaymentMethodDialog, paymentMethodId, browser);
        case 1:
          return $author$project$Ui$Overlays$feedbackPositiveDialog(browser);
        case 2:
          return $author$project$Ui$Overlays$feedbackNegativeDialog(browser);
        case 3:
          return $author$project$Ui$Overlays$supportRequestSentDialog(browser);
        case 4:
          return $author$project$Ui$Overlays$userBannedDialog(browser);
        case 5:
          var userId = dialogType.a;
          return A2($author$project$Ui$Overlays$unBanUserDialog, userId, browser);
        case 6:
          return $author$project$Ui$Overlays$matchSlotCanceledMoreThan24HoursPriorDialog(browser);
        case 7:
          return $author$project$Ui$Overlays$matchSlotCanceledLessThan24HoursPriorDialog(browser);
        case 8:
          var refundResult = dialogType.a;
          return A3($author$project$Ui$Overlays$matchSlotCanceledDialog, browser, topState.DJ, refundResult);
        case 9:
          return A2($author$project$Ui$Overlays$matchFiltersDialog, browser, topState.lL.yy.cF);
        case 10:
          var userId = dialogType.a;
          return A2($author$project$Ui$Overlays$deleteAccountDialog, browser, userId);
        case 11:
          return $author$project$Ui$Overlays$removePlayerDialog(browser);
        case 12:
          return $author$project$Ui$Overlays$recurringMatchCreatedNotificationsEnabled(browser);
        case 13:
          return $author$project$Ui$Overlays$recurringMatchCreatedNotificationsDisabled(browser);
        case 14:
          var isEmptyPaymentMethods = dialogType.a;
          var isAutoPayEnabled = dialogType.b;
          return A3($author$project$Ui$Overlays$postPaymentActiveSearchConfirmationDialog, browser, isEmptyPaymentMethods, isAutoPayEnabled);
        case 15:
          var matchId = dialogType.a;
          return A2($author$project$Ui$Overlays$postMatchPaymentConfirmationDialog, browser, matchId);
        case 16:
          var email = dialogType.a;
          return A2($author$project$Ui$Overlays$passwordRecoveryDialog, browser, email);
        case 17:
          return $author$project$Ui$Overlays$emailNotVerifiedOnPaymentDialog(browser);
        case 18:
          return $author$project$Ui$Overlays$paymentInformationDialog(browser);
        case 19:
          var matchId = dialogType.a;
          return A2($author$project$Ui$Overlays$joinMatchWithInviteesDialog, browser, matchId);
        default:
          return $author$project$Ui$Overlays$joinMatchNotEnoughRoom(browser);
      }
    }
  });
  var $author$project$Ui$Legal$Msg$Close = {
    $: 0
  };
  var $author$project$Ui$Legal$Msg$RouteToReplace = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $elm$html$Html$iframe = _VirtualDom_node('iframe');
  var $author$project$TopMsg$msgLegal = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$LegalMsg);
  var $elm$html$Html$Attributes$src = function (url) {
    return A2($elm$html$Html$Attributes$stringProperty, 'src', _VirtualDom_noJavaScriptOrHtmlUri(url));
  };
  var $author$project$Ui$Legal$View$termsAndPolicyView = F3(function (legalRoute, browser, state) {
    var toText = function (paragraph) {
      return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('bodyRegular gray80 marBottom3 block')]), _List_fromArray([$elm$html$Html$text(paragraph)]));
    };
    var sliderConfig = function (itemId) {
      if (!itemId) {
        return {
          lh: 'Terms & Conditions',
          eZ: state.Cw
        };
      } else {
        return {
          lh: 'Privacy Policy',
          eZ: state.AB
        };
      }
    };
    var currItemData = sliderConfig(legalRoute);
    return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_fromArray([A3($elm$html$Html$Keyed$node, 'div', _List_fromArray([$elm$html$Html$Attributes$class('flexColumn flex1')]), _List_fromArray([_Utils_Tuple2(currItemData.eZ, A2($elm$html$Html$iframe, _List_fromArray([$elm$html$Html$Attributes$class('noBorder fullWidth flex1'), $elm$html$Html$Attributes$src(currItemData.eZ)]), _List_Nil))]))]),
        l5: $elm$core$Maybe$Nothing,
        t_: browser,
        ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop1 marBottom3 ')]), _List_fromArray([$author$project$Ui$DupleTextSlider$dupleTextSlider({
          bh: 'heading4Bold ',
          u$: legalRoute,
          xn: _Utils_Tuple2({
            od: 0,
            oR: 'Terms & Conditions'
          }, {
            od: 1,
            oR: 'Privacy Policy'
          }),
          zG: function (curr) {
            return $author$project$TopMsg$msgLegal($author$project$Ui$Legal$Msg$RouteToReplace($author$project$Route$Route$Legal(curr)));
          },
          BP: ''
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading1Bold gray0 marTop2 ')]), _List_fromArray([$elm$html$Html$text(currItemData.lh)]))]))]),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
        Ck: $elm$core$Maybe$Just(1),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Just($author$project$TopMsg$msgLegal($author$project$Ui$Legal$Msg$Close)),
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    })]);
  });
  var $author$project$Remote$RequestMsg$CreateNewPasswordFromForgotPassword = function (a) {
    return {
      $: 9,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$Ui$Input$InputDefault = {
    $: 0
  };
  var $author$project$ElmFramework$Lib$Ui$Input$Password = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Msg$RouteTo = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$Auth$Msg$SetNewPassword = function (a) {
    return {
      $: 8,
      a: a
    };
  };
  var $author$project$Ui$Auth$Msg$SetRepeatNewPassword = function (a) {
    return {
      $: 10,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$Ui$Button$Submit = {
    $: 0
  };
  var $author$project$Ui$Auth$Msg$ToggleRevealNewPassword = {
    $: 9
  };
  var $author$project$Ui$Auth$Msg$ToggleRevealRepeatNewPassword = {
    $: 11
  };
  var $author$project$TopMsg$appMsg = $author$project$ElmFramework$Msg$AppMsg;
  var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
  var $author$project$Ui$Input$inputStyles = F2(function (status, isTextarea) {
    var errorMessage = function (msg) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading6Regular secondary700 whiteSpaceNoWrap marTop0h  ellipsis '), $elm$html$Html$Attributes$class(A3($author$project$ElmFramework$Lib$Util$ifElse, 'marRight1h', 'marRight2', isTextarea))]), _List_fromArray([$elm$html$Html$text(msg)]));
    };
    switch (status.$) {
      case 0:
        return {
          aS: ' secondary800Back ',
          bQ: 'secondary800Border',
          bY: false,
          cJ: 'secondary800Border',
          dT: ' secondary100Fill ',
          bl: $author$project$ElmFramework$Lib$Util$noOpEl,
          oq: ' primary0 placeholderGray40',
          b6: 'gray60',
          eE: 'gray20Fill '
        };
      case 3:
        return {
          aS: 'gray0Back ',
          bQ: 'primary0Border',
          bY: false,
          cJ: ' secondary0Border ',
          dT: 'secondary500Fill ',
          bl: $author$project$ElmFramework$Lib$Util$noOpEl,
          oq: ' primary0 placeholderGray40',
          b6: 'gray60',
          eE: 'gray20Fill '
        };
      case 1:
        var message = status.a;
        return {
          aS: 'secondary710Back ',
          bQ: 'secondary700Border',
          bY: true,
          cJ: ' secondary700Border',
          dT: 'secondary700Fill',
          bl: errorMessage(message),
          oq: ' secondary700 placeholderSecondary700',
          b6: 'secondary700',
          eE: 'secondary700Fill'
        };
      default:
        return {
          aS: 'gray10Back ',
          bQ: 'gray10Border',
          bY: true,
          cJ: ' gray10Border ',
          dT: ' gray20Fill ',
          bl: $author$project$ElmFramework$Lib$Util$noOpEl,
          oq: ' gray20 placeholderGray20',
          b6: 'gray60',
          eE: 'gray20Fill '
        };
    }
  });
  var $elm$html$Html$label = _VirtualDom_node('label');
  var $author$project$IconSvg$viewMed_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M25.1219 13.846L31.5828 19.1004C32.0476 19.4784 32.1377 20.1876 31.7841 20.6844C31.7264 20.7655 31.6586 20.8379 31.5828 20.8996L25.1219 26.154C22.0955 28.6153 17.9045 28.6153 14.878 26.154L8.41722 20.8996C7.95245 20.5216 7.86232 19.8124 8.21592 19.3156C8.27364 19.2345 8.34135 19.1621 8.41722 19.1004L14.878 13.846C17.9045 11.3847 22.0955 11.3847 25.1219 13.846ZM16.1585 15.6452L11.3569 19.5502C11.1245 19.7392 11.0795 20.0938 11.2563 20.3422C11.2851 20.3828 11.319 20.4189 11.3569 20.4498L16.1585 24.3548C18.4284 26.2008 21.5716 26.2008 23.8415 24.3548L28.6431 20.4498C28.8755 20.2608 28.9205 19.9062 28.7437 19.6578C28.7149 19.6172 28.681 19.5811 28.6431 19.5502L23.8415 15.6452C21.5716 13.7992 18.4284 13.7992 16.1585 15.6452ZM20 17.7393C21.168 17.7393 22.1148 18.7515 22.1148 20C22.1148 21.2485 21.168 22.2607 20 22.2607C18.832 22.2607 17.8852 21.2485 17.8852 20C17.8852 18.7515 18.832 17.7393 20 17.7393Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$viewMed = function (classes) {
    return $author$project$IconSvg$viewMed_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$Input$labeledInput = function (cfg) {
    var viewPasswordBtn = function () {
      var _v1 = cfg.wQ;
      if (_v1.$ === 2) {
        var onTap = _v1.a.p_;
        var reveal = _v1.a.gn;
        return $author$project$Ui$Button$button({
          bh: '',
          fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' w3 h3 ')]), _List_fromArray([$author$project$IconSvg$viewMed(' w3 gray40Fill ')])),
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onTap)
        });
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();
    var styles = A2($author$project$Ui$Input$inputStyles, cfg.Cd, false);
    var inputType = function () {
      var _v0 = cfg.wQ;
      if (_v0.$ === 2) {
        var onTap = _v0.a.p_;
        var reveal = _v0.a.gn;
        return reveal ? $author$project$ElmFramework$Lib$Ui$Input$Text : cfg.wQ;
      } else {
        return cfg.wQ;
      }
    }();
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.bh), $elm$html$Html$Attributes$class('padTop1 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative radius7 flexRow flexAlignCenter spaceBetween  '), $elm$html$Html$Attributes$class(styles.aS)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread radius7  borderSolid   hairLineBorderWidth  ' + styles.bQ)]), _List_Nil), A2($elm$html$Html$label, _List_fromArray([$elm$html$Html$Attributes$class('absolute left1 top-1 right1 heading6Bold h2 fullMaxWidth  noOverflow  ' + styles.b6), $elm$html$Html$Attributes$for(cfg.od)]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' ellipsis gray0Back radius0 padRight1 padLeft1 fullMaxWidth inlineBlock  ')]), _List_fromArray([$elm$html$Html$text(cfg.oR)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter padTop1h padBottom1h padLeft2 padRight2 spaceBetween fullWidth sticky ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$Input$input_custom({
      bP: cfg.bP,
      bh: ' heading5Regular relative flex1 marRight1 transparentBack noPad    ' + styles.oq,
      bY: styles.bY,
      od: cfg.od,
      wQ: inputType,
      bu: cfg.bu,
      bv: cfg.bv,
      ch: cfg.ch,
      s_: cfg.s_
    }), viewPasswordBtn]))])), styles.bl]));
  };
  var $author$project$Ui$Auth$View$createNewPasswordView = F2(function (topState, code) {
    return {
      tU: function () {
        var state = topState.lL.tD;
        return _List_fromArray([A2($elm$html$Html$form, _List_fromArray([$elm$html$Html$Attributes$class('relative marBottom-1 '), $elm$html$Html$Events$onSubmit(_Utils_eq(state.nI, state.nJ) ? $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$CreateNewPasswordFromForgotPassword({
          uo: code,
          f2: state.nI
        })) : A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Password\'s don\'t match', _List_Nil))]), _List_fromArray([$author$project$Ui$Input$labeledInput({
          bP: $elm$core$Maybe$Nothing,
          bh: ' marBottom2 ',
          od: '01',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Password({
            p_: $author$project$TopMsg$authMsg($author$project$Ui$Auth$Msg$ToggleRevealNewPassword),
            gn: state.h8
          }),
          oR: 'New Password *',
          bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$Ui$Auth$Msg$SetNewPassword),
          bv: 'Enter your New password',
          ch: true,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: state.nI
        }), $author$project$Ui$Input$labeledInput({
          bP: $elm$core$Maybe$Nothing,
          bh: ' ',
          od: '02',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Password({
            p_: $author$project$TopMsg$authMsg($author$project$Ui$Auth$Msg$ToggleRevealRepeatNewPassword),
            gn: state.h9
          }),
          oR: 'Repeat New Password *',
          bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$Ui$Auth$Msg$SetRepeatNewPassword),
          bv: 'Repeat your New Password',
          ch: true,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: state.nJ
        }), $author$project$Ui$Button$basicButton({
          bh: '  fullWidth marTop3h marBottom3 ',
          cD: 0,
          fn: $elm$html$Html$text('Sign In'),
          xa: false,
          xu: $author$project$ElmFramework$Lib$Ui$Button$Submit
        })]))]);
      }(),
      l5: $elm$core$Maybe$Nothing,
      ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexCenterColumn')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('h10 marBottom2 ')]), _List_fromArray([$author$project$AssetsSvg$password('h10 ')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0 marBottom1 center ')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text('Create your')])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text('New password')]))]))]))]),
      xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
        xc: true
      }),
      Ck: $elm$core$Maybe$Just(1),
      CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
        xC: $elm$core$Maybe$Nothing,
        yo: $elm$core$Maybe$Nothing,
        Bg: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$IconBtn({
          wE: $author$project$IconSvg$close,
          xa: false,
          p_: $author$project$TopMsg$appMsg($author$project$Msg$RouteTo($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials($author$project$Route$Route$DefaultSignIn))))
        }))
      }))
    };
  });
  var $author$project$ElmFramework$Lib$Ui$Input$Email = {
    $: 1
  };
  var $author$project$Ui$ComponentsPreview$Msg$GoBack = {
    $: 10
  };
  var $author$project$Ui$Auth$Msg$SetForgotPasswordEmail = function (a) {
    return {
      $: 6,
      a: a
    };
  };
  var $author$project$TopMsg$msgComponentsPreview = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$ComponentsPreviewMsg);
  var $author$project$Ui$Auth$View$forgetPasswordView = function (topState) {
    var state = topState.lL.tD;
    return {
      tU: _List_fromArray([A2($elm$html$Html$form, _List_fromArray([$elm$html$Html$Attributes$class('relative marBottom-1 '), $elm$html$Html$Events$onSubmit($author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$ForgotPassword, $elm$core$Maybe$Just($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials($author$project$Route$Route$DefaultSignIn))), state.nH)))]), _List_fromArray([$author$project$Ui$Input$labeledInput({
        bP: $elm$core$Maybe$Nothing,
        bh: '',
        od: '01',
        wQ: $author$project$ElmFramework$Lib$Ui$Input$Email,
        oR: 'Email',
        bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$Ui$Auth$Msg$SetForgotPasswordEmail),
        bv: 'Type your email',
        ch: true,
        Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
        s_: state.nH
      }), $author$project$Ui$Button$basicButton({
        bh: '  fullWidth marTop3h marBottom3 ',
        cD: 0,
        fn: $elm$html$Html$text('Reset password'),
        xa: false,
        xu: $author$project$ElmFramework$Lib$Ui$Button$Submit
      })]))]),
      l5: $elm$core$Maybe$Nothing,
      ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexCenterColumn')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('h10 marBottom2 ')]), _List_fromArray([$author$project$AssetsSvg$password('h10 ')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0 marBottom1 center ')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text('Forgot')])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text('your password?')]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bodyRegular gray10 center ')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text('Please enter your information')])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text('below to create a new one.')]))]))]))]),
      xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
        xc: true
      }),
      Ck: $elm$core$Maybe$Just(1),
      CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
        xC: $elm$core$Maybe$Just($author$project$TopMsg$msgComponentsPreview($author$project$Ui$ComponentsPreview$Msg$GoBack)),
        yo: $elm$core$Maybe$Nothing,
        Bg: $elm$core$Maybe$Nothing
      }))
    };
  };
  var $author$project$Ui$Auth$Msg$RegisterWithApple = function (a) {
    return {
      $: 24,
      a: a
    };
  };
  var $author$project$Ui$Auth$Msg$RegisterWithGoogle = function (a) {
    return {
      $: 22,
      a: a
    };
  };
  var $author$project$Route$Route$RespondToInvite = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });
  var $author$project$Util$OnRouteCmd$RouteBack = {
    $: 0
  };
  var $author$project$Ui$Auth$Msg$SetRegisterEmail = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Ui$Auth$Msg$SetRegisterPassword = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $author$project$UiWrappers$HeaderAndBodyView$StripesTopLeftAndBottomRightAndBodyLeft = 6;
  var $author$project$Ui$Switch$SwitchColored = 0;
  var $author$project$Ui$Auth$Msg$ToggleRegisterAcceptTermsAndService = {
    $: 7
  };
  var $author$project$Ui$Auth$Msg$ToggleRevealRegisterPassword = {
    $: 5
  };
  var $author$project$Ui$Button$iconBtn = function (cfg) {
    var iconClasses = function () {
      var _v0 = cfg.cD;
      switch (_v0) {
        case 0:
          return ' gray0Fill  ';
        case 1:
          return ' primary0Fill  ';
        case 2:
          return ' secondary100Fill  ';
        default:
          return ' secondary700Fill   ';
      }
    }();
    return $author$project$Ui$Button$styledButton({
      bh: ' w6 h6  hairLineBorderWidth borderSolid ' + cfg.bh,
      cD: cfg.cD,
      fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([cfg.wE('w3 ' + iconClasses)])),
      xa: cfg.xa,
      xu: cfg.xu
    });
  };
  var $author$project$IconSvg$logoApple_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M29.5808 26.7038C29.2218 27.5423 28.7967 28.3141 28.3043 29.0237C27.633 29.9911 27.0834 30.6607 26.6598 31.0325C26.0032 31.6429 25.2997 31.9555 24.5464 31.9732C24.0056 31.9732 23.3534 31.8177 22.5942 31.5021C21.8325 31.1881 21.1325 31.0325 20.4925 31.0325C19.8212 31.0325 19.1013 31.1881 18.3312 31.5021C17.56 31.8177 16.9387 31.9821 16.4637 31.9984C15.7413 32.0295 15.0213 31.7081 14.3025 31.0325C13.8438 30.6281 13.27 29.9348 12.5826 28.9526C11.8451 27.9037 11.2388 26.6875 10.7637 25.3009C10.255 23.8031 10 22.3528 10 20.9487C10 19.3403 10.3438 17.9531 11.0325 16.7906C11.5738 15.8568 12.2939 15.1203 13.1951 14.5796C14.0963 14.0388 15.0701 13.7633 16.1187 13.7457C16.6925 13.7457 17.445 13.9251 18.38 14.2776C19.3125 14.6314 19.9112 14.8108 20.1737 14.8108C20.3699 14.8108 21.035 14.601 22.1625 14.1828C23.2288 13.795 24.1287 13.6344 24.8659 13.6977C26.8636 13.8606 28.3644 14.6566 29.3625 16.0906C27.5758 17.1848 26.6921 18.7174 26.7097 20.6834C26.7258 22.2147 27.2754 23.4891 28.3556 24.5009C28.8451 24.9705 29.3918 25.3334 30 25.5912C29.8681 25.9779 29.7289 26.3482 29.5808 26.7038ZM24.9993 8.48062C24.9993 9.6809 24.5654 10.8016 23.7007 11.8389C22.6572 13.072 21.395 13.7846 20.0262 13.6722C20.0088 13.5282 19.9987 13.3766 19.9987 13.2174C19.9987 12.0651 20.4949 10.832 21.3762 9.82369C21.8162 9.31319 22.3758 8.88872 23.0544 8.5501C23.7315 8.21654 24.372 8.03208 24.9744 8.00049C24.9919 8.16095 24.9993 8.32141 24.9993 8.48061V8.48062Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$logoApple = function (classes) {
    return $author$project$IconSvg$logoApple_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$logoGoogle_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M31.7631 17.75C31.9164 18.5524 32 19.3925 32 20.2699C32.0001 27.125 27.3169 32.0001 20.2452 32.0001C13.4798 32.0001 8 26.6299 8 20C8 13.3701 13.4798 8 20.2452 8C23.5516 8 26.314 9.1924 28.4343 11.1274L24.9821 14.5101V14.5024C23.6965 13.3023 22.0666 12.6874 20.2452 12.6874C16.2045 12.6874 12.9212 16.0324 12.9212 19.9927C12.9212 23.9521 16.2044 27.3051 20.2452 27.3051C23.9112 27.3051 26.4059 25.25 26.9194 22.4302H20.2452V17.75H31.7631Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$logoGoogle = function (classes) {
    return $author$project$IconSvg$logoGoogle_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$ElmFramework$Lib$Util$spacer = function (classes) {
    return A3($elm$html$Html$node, 'spacer', _List_fromArray([$elm$html$Html$Attributes$class(classes), $elm$html$Html$Attributes$class('block')]), _List_Nil);
  };
  var $author$project$Ui$Auth$View$socialLogin = function (cfg) {
    var googleBtn = $author$project$Ui$Button$iconBtn({
      bh: '',
      cD: 1,
      wE: $author$project$IconSvg$logoGoogle,
      xa: false,
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$appMsg($author$project$Msg$AuthMsg(cfg.$8)))
    });
    var appleBtn = $author$project$Ui$Button$iconBtn({
      bh: '',
      cD: 1,
      wE: $author$project$IconSvg$logoApple,
      xa: false,
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$appMsg($author$project$Msg$AuthMsg(cfg.g_)))
    });
    var authOptions = cfg.vS.fO ? _List_fromArray([googleBtn]) : _List_fromArray([googleBtn, $author$project$ElmFramework$Lib$Util$spacer('w2'), appleBtn]);
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexCenterColumn ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular gray60 marBottom2 ')]), _List_fromArray([$elm$html$Html$text('Or continue with')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexCenter')]), authOptions)]));
  };
  var $author$project$Ui$Switch$SwitchColoredBlackBackground = 1;
  var $author$project$Ui$Switch$SwitchWhiteBack = 2;
  var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
  var $author$project$ElmFramework$Lib$Ui$Switch$checkedStyleLayer = function (config) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread maxRadius opacityTransition'), $elm$html$Html$Attributes$class(config.mi), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('o0', !config.eh)]))]), _List_Nil);
  };
  var $author$project$ElmFramework$Lib$Ui$Switch$ratioToPercentageString = function (_float) {
    return $elm$core$String$fromFloat(_float * 100) + '%';
  };
  var $author$project$ElmFramework$Lib$Ui$Switch$toCheckedOffset = function (ratio) {
    return (1 - ratio) / ratio * 100;
  };
  var $author$project$ElmFramework$Lib$Ui$Switch$handle = function (config) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absolute top0 left0 square transformTransition'), A2($elm$html$Html$Attributes$style, 'width', $author$project$ElmFramework$Lib$Ui$Switch$ratioToPercentageString(config.gy)), config.eh ? A2($elm$html$Html$Attributes$style, 'transform', 'translateX(' + ($elm$core$String$fromFloat($author$project$ElmFramework$Lib$Ui$Switch$toCheckedOffset(config.gy)) + '%)')) : A2($elm$html$Html$Attributes$style, 'transform', 'translateX(0%)')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread circle'), $elm$html$Html$Attributes$class(config.sH), A2($elm$html$Html$Attributes$style, 'transform', 'scale(' + ($elm$core$String$fromFloat(config.ih) + ')'))]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread circle'), $elm$html$Html$Attributes$class(config.mh), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('o0', !config.eh)])), A2($elm$html$Html$Attributes$style, 'transform', 'scale(' + ($elm$core$String$fromFloat(config.ih) + ')'))]), _List_Nil)]));
  };
  var $author$project$ElmFramework$Lib$Ui$Switch$heightSetter = function (sizeRatio) {
    return A2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$style, 'padding-top', $author$project$ElmFramework$Lib$Ui$Switch$ratioToPercentageString(sizeRatio))]), _List_Nil);
  };
  var $author$project$ElmFramework$Lib$Ui$Switch$uncheckedStyleLayer = function (config) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread maxRadius'), $elm$html$Html$Attributes$class(config.sI)]), _List_Nil);
  };
  var $author$project$ElmFramework$Lib$Ui$Switch$switch = function (config) {
    return A3($elm$html$Html$node, 'switch-el', _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock relative noFontSize pointer'), $elm$html$Html$Attributes$class(config.uj), $author$project$ElmFramework$Lib$Util$onTap(config.Cu)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$Switch$heightSetter(config.gy), $author$project$ElmFramework$Lib$Ui$Switch$uncheckedStyleLayer(config), $author$project$ElmFramework$Lib$Ui$Switch$checkedStyleLayer(config), $author$project$ElmFramework$Lib$Ui$Switch$handle(config), A2($elm$html$Html$input, _List_fromArray([$elm$html$Html$Attributes$type_('checkbox'), $elm$html$Html$Attributes$class('absolute top0 left0 z1 o0 fullWidth fullHeight pointer'), $elm$html$Html$Attributes$checked(config.eh), $elm$html$Html$Attributes$required(config.xi)]), _List_Nil)]));
  };
  var $author$project$Ui$Switch$switch = function (config) {
    var styles = function () {
      var _v0 = config.ux;
      switch (_v0) {
        case 0:
          return {
            mh: 'whiteBack',
            mi: 'secondary0Back',
            sH: 'secondary0Back',
            sI: 'backgroundGrey'
          };
        case 1:
          return {
            mh: 'whiteBack',
            mi: 'secondary0Back',
            sH: 'secondary0Back',
            sI: 'primary80Back'
          };
        case 2:
          return {
            mh: 'whiteBack',
            mi: 'secondary0Back',
            sH: 'secondary0Back',
            sI: 'gray0Back '
          };
        case 3:
          return {
            mh: 'gray20Back',
            mi: 'backgroundGrey',
            sH: 'gray20Back',
            sI: 'backgroundGrey'
          };
        default:
          return {
            mh: 'gradient500Back',
            mi: 'gradient520Back',
            sH: 'gradient500Back',
            sI: 'gradient520Back'
          };
      }
    }();
    return $author$project$ElmFramework$Lib$Ui$Switch$switch({
      mh: styles.mh,
      mi: styles.mi,
      uj: 'w6 ' + (A3($author$project$ElmFramework$Lib$Util$ifElse, '  ', ' noPointerEvents ', !config.ux || config.ux === 2 || config.ux === 1) + config.uj),
      ih: 0.67,
      eh: config.eh,
      xi: config.xi,
      gy: 0.5,
      Cu: config.Cu,
      sH: styles.sH,
      sI: styles.sI
    });
  };
  var $author$project$Ui$Auth$View$registrationView = F3(function (registrationAction, maybeTermsAndPrivacy, topState) {
    return {
      tU: function () {
        var state = topState.lL.tD;
        return _List_fromArray([A2($elm$html$Html$form, _List_fromArray([$elm$html$Html$Attributes$class('relative '), $elm$html$Html$Events$onSubmit($author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$RegisterNewUser, registrationAction, $author$project$Remote$ResponseMsg$EmailAndPasswordRegisterOrSignIn({
          bZ: state.ko,
          gb: state.kr
        }))))]), _List_fromArray([$author$project$Ui$Input$labeledInput({
          bP: $elm$core$Maybe$Nothing,
          bh: ' marBottom2  ',
          od: '01',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Email,
          oR: 'Email',
          bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$Ui$Auth$Msg$SetRegisterEmail),
          bv: 'Type your email',
          ch: true,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: state.ko
        }), $author$project$Ui$Input$labeledInput({
          bP: $elm$core$Maybe$Nothing,
          bh: ' marBottom3h ',
          od: '02',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Password({
            p_: $author$project$TopMsg$authMsg($author$project$Ui$Auth$Msg$ToggleRevealRegisterPassword),
            gn: state.kz
          }),
          oR: 'Password',
          bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$Ui$Auth$Msg$SetRegisterPassword),
          bv: 'Enter your password',
          ch: true,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: state.kr
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth flexRow spaceBetween flexAlignCenter ')]), _List_fromArray([$author$project$Ui$Button$button({
          bh: '',
          fn: A2($elm$html$Html$span, _List_Nil, _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' bodyRegular primary0 ')]), _List_fromArray([$elm$html$Html$text('I accept ')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' bodyRegular secondary100 heading4Bold ')]), _List_fromArray([$elm$html$Html$text('Privacy Policy ')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' bodyRegular primary0 ')]), _List_fromArray([$elm$html$Html$text('and ')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' bodyRegular secondary100 heading4Bold ')]), _List_fromArray([$elm$html$Html$text('Terms of use')]))])),
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$appMsg($author$project$Msg$RouteTo($author$project$Route$Route$Legal(0))))
        }), $author$project$Ui$Switch$switch({
          uj: '',
          ux: 0,
          eh: state.gm,
          xi: true,
          Cu: $author$project$TopMsg$authMsg($author$project$Ui$Auth$Msg$ToggleRegisterAcceptTermsAndService)
        })])), $author$project$Ui$Button$basicButton({
          bh: '  fullWidth marTop3h marBottom3 ',
          cD: 0,
          fn: $elm$html$Html$text('Register'),
          xa: false,
          xu: $author$project$ElmFramework$Lib$Ui$Button$Submit
        }), $author$project$Ui$Auth$View$socialLogin({
          g_: $author$project$Ui$Auth$Msg$RegisterWithApple(registrationAction),
          vS: topState.vS,
          $8: $author$project$Ui$Auth$Msg$RegisterWithGoogle(registrationAction)
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth flexCenter marBottom3 marTop3')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' bodyRegular primary0 marRight1 ')]), _List_fromArray([$elm$html$Html$text('Already have an account?')])), $author$project$Ui$Button$button({
          bh: '',
          fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold secondary100 ')]), _List_fromArray([$elm$html$Html$text('Sign In')])),
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$appMsg($author$project$Msg$RouteTo($author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials(function () {
            if (!registrationAction.$) {
              return $author$project$Route$Route$DefaultSignIn;
            } else {
              var invitationRoute = registrationAction.a;
              var response = registrationAction.b;
              return A2($author$project$Route$Route$RespondToInvite, invitationRoute, response);
            }
          }())))))
        })]))]))]);
      }(),
      l5: $elm$core$Maybe$Nothing,
      ww: _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w6 h6 marBottom2 ')]), _List_fromArray([$author$project$AssetsSvg$logoIconGradient('w6 ')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0 marBottom1  ')]), _List_fromArray([$elm$html$Html$text('Register')]))]),
      xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
        xc: true
      }),
      Ck: $elm$core$Maybe$Just(6),
      CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
        xC: $elm$core$Maybe$Nothing,
        yo: $elm$core$Maybe$Nothing,
        Bg: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$IconBtn({
          wE: $author$project$IconSvg$close,
          xa: false,
          p_: $author$project$TopMsg$appMsg($author$project$Msg$RouteCmd($author$project$Util$OnRouteCmd$RouteBack))
        }))
      }))
    };
  });
  var $author$project$ElmFramework$Lib$Ui$Input$AutocompleteCurrPassword = 2;
  var $author$project$ElmFramework$Lib$Ui$Input$AutocompleteEmail = 0;
  var $author$project$Route$Route$RespondToInviteAfterRegistration = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Auth$Msg$SetSignInEmail = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$Auth$Msg$SetSignInPassword = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$Auth$Msg$SignInWithApple = function (a) {
    return {
      $: 23,
      a: a
    };
  };
  var $author$project$Ui$Auth$Msg$SignInWithGoogle = function (a) {
    return {
      $: 21,
      a: a
    };
  };
  var $author$project$Ui$Auth$Msg$ToggleRevealSignInPassword = {
    $: 2
  };
  var $author$project$Ui$Auth$View$signInView = F2(function (signInAction, topState) {
    return {
      tU: function () {
        var state = topState.lL.tD;
        return _List_fromArray([A2($elm$html$Html$form, _List_fromArray([$elm$html$Html$Attributes$class('relative '), $elm$html$Html$Events$onSubmit($author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$SignInWithEmail, signInAction, {
          bZ: state.rS,
          gb: state.rT
        })))]), _List_fromArray([$author$project$Ui$Input$labeledInput({
          bP: $elm$core$Maybe$Just(0),
          bh: ' marBottom2  ',
          od: '01',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Email,
          oR: 'Email',
          bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$Ui$Auth$Msg$SetSignInEmail),
          bv: 'Type your email',
          ch: true,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: state.rS
        }), $author$project$Ui$Input$labeledInput({
          bP: $elm$core$Maybe$Just(2),
          bh: ' marBottom3 ',
          od: '02',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Password({
            p_: $author$project$TopMsg$authMsg($author$project$Ui$Auth$Msg$ToggleRevealSignInPassword),
            gn: state.kA
          }),
          oR: 'Password',
          bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$Ui$Auth$Msg$SetSignInPassword),
          bv: 'Enter your password',
          ch: true,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: state.rT
        }), $author$project$Ui$Button$button({
          bh: '',
          fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold secondary100 ')]), _List_fromArray([$elm$html$Html$text('I forgot my password')])),
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$appMsg($author$project$Msg$RouteTo($author$project$Route$Route$Auth($author$project$Route$Route$ForgotPassword($author$project$Route$Route$ForgotPasswordEnterEmail)))))
        }), $author$project$Ui$Button$basicButton({
          bh: '  fullWidth marTop3h marBottom3 ',
          cD: 0,
          fn: $elm$html$Html$text('Sign In'),
          xa: false,
          xu: $author$project$ElmFramework$Lib$Ui$Button$Submit
        }), $author$project$Ui$Auth$View$socialLogin({
          g_: $author$project$Ui$Auth$Msg$SignInWithApple(signInAction),
          vS: topState.vS,
          $8: $author$project$Ui$Auth$Msg$SignInWithGoogle(signInAction)
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth flexCenter marBottom1 marTop3 marBottom2 ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' bodyRegular primary0 marRight1 ')]), _List_fromArray([$elm$html$Html$text('You don\'t have an account?')])), $author$project$Ui$Button$button({
          bh: '',
          fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold secondary100 ')]), _List_fromArray([$elm$html$Html$text('Register')])),
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$appMsg($author$project$Msg$RouteTo($author$project$Route$Route$Auth(A2($author$project$Route$Route$Register, $elm$core$Maybe$Nothing, function () {
            if (signInAction.$ === 2) {
              var invitationRoute = signInAction.a;
              var response = signInAction.b;
              return A2($author$project$Route$Route$RespondToInviteAfterRegistration, invitationRoute, response);
            } else {
              return $author$project$Route$Route$DefaultRegistration;
            }
          }())))))
        })]))]))]);
      }(),
      l5: $elm$core$Maybe$Nothing,
      ww: _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w6 h6 marBottom2 ')]), _List_fromArray([$author$project$AssetsSvg$logoIconGradient('w6 ')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0 marBottom1  ')]), _List_fromArray([$elm$html$Html$text('Sign In')]))]),
      xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
        xc: true
      }),
      Ck: $elm$core$Maybe$Just(1),
      CT: $elm$core$Maybe$Nothing
    };
  });
  var $author$project$Ui$Auth$View$view = F3(function (authStep, browser, topState) {
    var branchCfg = function () {
      switch (authStep.$) {
        case 0:
          return A2($author$project$Ui$Auth$View$signInView, $author$project$Route$Route$DefaultSignIn, topState);
        case 1:
          var termsAndPrivacy = authStep.a;
          var registrationAction = authStep.b;
          return A3($author$project$Ui$Auth$View$registrationView, registrationAction, termsAndPrivacy, topState);
        case 2:
          var signInAction = authStep.a;
          return A2($author$project$Ui$Auth$View$signInView, signInAction, topState);
        case 3:
          if (!authStep.a.$) {
            var _v1 = authStep.a;
            return $author$project$Ui$Auth$View$forgetPasswordView(topState);
          } else {
            var code = authStep.a.a;
            return A2($author$project$Ui$Auth$View$createNewPasswordView, topState, code);
          }
        case 4:
          return A2($author$project$Ui$Auth$View$signInView, $author$project$Route$Route$DefaultSignIn, topState);
        default:
          return A2($author$project$Ui$Auth$View$signInView, $author$project$Route$Route$DefaultSignIn, topState);
      }
    }();
    return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: branchCfg.tU,
        l5: branchCfg.l5,
        t_: browser,
        ww: branchCfg.ww,
        xB: branchCfg.xB,
        Ck: branchCfg.Ck,
        CT: branchCfg.CT
      })
    })]);
  });
  var $author$project$UiWrappers$HeaderAndBodyView$ImgOverlay = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnInput = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$UiWrappers$HeaderAndBodyView$StripesSmallTopLeftAndBottomRight15 = 3;
  var $author$project$AssetsImg$assets = {
    ty: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/apple-app-store.svg'),
    v5: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/Explore-01.png'),
    wr: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/google-play-store.svg'),
    wZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/invite_players/settings_android_allow.png'),
    w_: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/invite_players/settings_android_app_management.png'),
    w$: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/invite_players/settings_android_apps.png'),
    w0: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/invite_players/settings_android_contacts.png'),
    w1: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/invite_players/settings_android_permissions.png'),
    w2: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/invite_players/settings_ios_contacts.png'),
    w3: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/invite_players/settings_ios_privacy.png'),
    w4: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/invite_players/settings_ios_xrivals.png'),
    xG: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/Level_padel.png'),
    xH: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/Level_tennis.png'),
    x1: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/Matchmaking-01.png'),
    x2: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/Matchmaking-02.png'),
    yJ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/Notifications-01.png'),
    yK: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/Notifications-02.png'),
    z0: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/onboarding_1.png'),
    z1: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/onboarding_2.png'),
    z2: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/onboarding_3.png'),
    AC: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/Profile-01.png'),
    AD: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/Profile-02.png')
  };
  var $author$project$IconSvg$bannedList_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M22.2564 14.1395H17.7436C16.7829 14.1395 15.0856 14.1395 14.7141 11.9974C12.05 12.3066 10.6923 13.476 10.6923 17.7675V24.4651C10.6923 28.5954 11.5159 30.3256 16.6154 30.3256H23.3846C28.4841 30.3256 29.3077 28.5954 29.3077 24.4651V17.7675C29.3077 13.4893 27.9584 12.3139 25.3107 12.0003C25.1655 13.0147 24.5842 14.1395 22.2564 14.1395ZM23.6667 11.1285C23.6662 12.1852 23.6413 12.4651 22.2564 12.4651H17.7436C16.6448 12.4651 16.3431 12.4651 16.3336 11.1366C16.3347 11.1109 16.3346 11.0849 16.3333 11.0587C16.3349 9.67442 16.6296 9.67442 17.7436 9.67442H22.2564C23.3675 9.67442 23.6636 9.67442 23.6666 11.048C23.6653 11.0751 23.6653 11.1019 23.6667 11.1285ZM25.3124 10.3156C25.0042 8 23.2423 8 22.2564 8H17.7436C16.7563 8 14.9909 8 14.6864 10.3251C10.6557 10.7576 9 12.9669 9 17.7675V24.4651C9 29.12 10.2749 32 16.6154 32H23.3846C29.7251 32 31 29.12 31 24.454V17.7563C31 12.9657 29.3439 10.7571 25.3124 10.3156ZM14.5474 19.7958C14.6299 19.8782 14.7344 19.9167 14.8389 19.9167C14.9434 19.9167 15.0479 19.8727 15.1304 19.7958C15.2899 19.6363 15.2899 19.3725 15.1304 19.2131L14.333 18.416L15.1304 17.6189C15.2899 17.4595 15.2899 17.1957 15.1304 17.0362C14.9709 16.8768 14.7069 16.8768 14.5474 17.0362L13.75 17.8333L12.9526 17.0362C12.7931 16.8768 12.5291 16.8768 12.3696 17.0362C12.2101 17.1957 12.2101 17.4595 12.3696 17.6189L13.167 18.416L12.3696 19.2131C12.2101 19.3725 12.2101 19.6363 12.3696 19.7958C12.4521 19.8782 12.5566 19.9167 12.6611 19.9167C12.7656 19.9167 12.8701 19.8782 12.9526 19.7958L13.75 18.9987L14.5474 19.7958ZM26.7903 18.9158C26.9204 18.9158 27.0331 18.8592 27.1155 18.7696C27.1979 18.6801 27.2456 18.5528 27.25 18.4161C27.2501 18.1428 27.042 17.9166 26.7905 17.9167L16.7097 17.9175C16.4582 17.9176 16.2501 18.1439 16.25 18.4172C16.2499 18.6906 16.458 18.9167 16.7095 18.9167L26.7903 18.9158ZM27.1155 24.7696C27.0331 24.8592 26.9204 24.9158 26.7903 24.9158L16.7095 24.9167C16.458 24.9167 16.2499 24.6906 16.25 24.4172C16.2501 24.1439 16.4582 23.9176 16.7097 23.9175L26.7905 23.9167C27.042 23.9166 27.2501 24.1428 27.25 24.4161C27.2456 24.5528 27.1979 24.6801 27.1155 24.7696ZM14.5474 25.7958C14.6299 25.8782 14.7344 25.9167 14.8389 25.9167C14.9434 25.9167 15.0479 25.8727 15.1304 25.7958C15.2899 25.6363 15.2899 25.3725 15.1304 25.2131L14.333 24.416L15.1304 23.6189C15.2899 23.4595 15.2899 23.1957 15.1304 23.0362C14.9709 22.8768 14.7069 22.8768 14.5474 23.0362L13.75 23.8333L12.9526 23.0362C12.7931 22.8768 12.5291 22.8768 12.3696 23.0362C12.2101 23.1957 12.2101 23.4595 12.3696 23.6189L13.167 24.416L12.3696 25.2131C12.2101 25.3725 12.2101 25.6363 12.3696 25.7958C12.4521 25.8782 12.5566 25.9167 12.6611 25.9167C12.7656 25.9167 12.8701 25.8782 12.9526 25.7958L13.75 24.9987L14.5474 25.7958Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$bannedList = function (classes) {
    return $author$project$IconSvg$bannedList_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$UiWrappers$HeaderAndBodyView$multipleBodyContentWithIconAndLabel = function (contentList) {
    var toContentWrapper = function (item) {
      if (!item.$) {
        var contentItem = item.a;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad2 radiusTopRight5 radiusTopLeft5 gray0Back  newWrapperShadow padBottom5 marTop-3 '), $elm$html$Html$Attributes$class(contentItem.uj)]), _List_fromArray([A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, function (title) {
          var iconElement = A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, function (icon) {
            var iconClasses = icon.b === '' ? ' w4 ' : icon.b;
            return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w4 h4 flexCenter marRight1 ')]), _List_fromArray([A2($elm$core$Tuple$first, icon, ' gray80Fill ' + iconClasses)]));
          }, contentItem.wE));
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marBottom2 padTop1 noOverflow ')]), _List_fromArray([iconElement, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0 heading2Bold whiteSpaceNoWrap  ellipsis')]), _List_fromArray([$elm$html$Html$text(title)]))]));
        }, contentItem.lh)), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([contentItem.fn]))]));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    };
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight-2 marLeft-2 flexColumn flex1 marBottom-4')]), A2($elm$core$List$map, toContentWrapper, contentList));
  };
  var $elm$html$Html$textarea = _VirtualDom_node('textarea');
  var $author$project$Ui$Input$plainTextarea = function (cfg) {
    var styles = A2($author$project$Ui$Input$inputStyles, cfg.Cd, true);
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.bh)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative radius7 flexRow flexAlignCenter spaceBetween fullHeight '), $elm$html$Html$Attributes$class(styles.aS)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread radius7  borderSolid   hairLineBorderWidth fullHeight ' + styles.bQ)]), _List_Nil), A2($elm$html$Html$textarea, _List_fromArray([$elm$html$Html$Attributes$class('minH14 fullWidth noBorder transparentBack heading5Regular padTop1h padBottom1h padLeft2 padRight2 relative  flex1 sticky noResize noScrollbar ' + cfg.wO), $elm$html$Html$Attributes$class(styles.oq), $elm$html$Html$Attributes$id(cfg.od), $elm$html$Html$Attributes$value(cfg.s_), $elm$html$Html$Events$onInput(cfg.bu), $elm$html$Html$Attributes$placeholder(cfg.bv), $elm$html$Html$Attributes$required(cfg.ch), $elm$html$Html$Attributes$disabled(styles.bY)]), _List_Nil)])), styles.bl]));
  };
  var $author$project$Types$Gender$toString = function (gender) {
    if (gender === 1) {
      return 'Male';
    } else {
      return 'Female';
    }
  };
  var $author$project$Types$Sport$Padel = 0;
  var $author$project$Types$Sport$Squash = 2;
  var $author$project$Types$Sport$Tennis = 1;
  var $author$project$Types$Match_$Second = 1;
  var $author$project$Mock$specificLocation = {
    cy: 'Location address',
    mB: {
      om: _List_fromArray([{
        ij: 13,
        eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/photo.jpg'),
        lt: 13
      }]),
      i5: 'Court 7',
      gE: _List_fromArray(['Outdoor', 'Wall', 'Doubles'])
    },
    m5: _Utils_Tuple2(5, 'Km'),
    o1: 'Location name'
  };
  var $author$project$Mock$teams = {
    bm: _List_fromArray([$elm$core$Maybe$Just({
      nM: $elm$core$Maybe$Just(1),
      wG: _List_fromArray([{
        ij: 4,
        eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/04.jpg'),
        lt: 4
      }]),
      a_: 4.5,
      i5: 'Me',
      eq: $elm$core$Maybe$Nothing
    }), $elm$core$Maybe$Just({
      nM: $elm$core$Maybe$Just(1),
      wG: _List_fromArray([{
        ij: 4,
        eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/03.jpg'),
        lt: 4
      }]),
      a_: 4.5,
      i5: 'Name',
      eq: $elm$core$Maybe$Nothing
    })]),
    bz: _List_fromArray([$elm$core$Maybe$Just({
      nM: $elm$core$Maybe$Just(0),
      wG: _List_fromArray([{
        ij: 4,
        eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/avatar_44.jpg'),
        lt: 4
      }]),
      a_: 4.5,
      i5: 'Name',
      eq: $elm$core$Maybe$Nothing
    }), $elm$core$Maybe$Just({
      nM: $elm$core$Maybe$Just(1),
      wG: _List_fromArray([{
        ij: 4,
        eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/01.jpg'),
        lt: 4
      }]),
      a_: 4.5,
      i5: 'Name',
      eq: $elm$core$Maybe$Nothing
    })])
  };
  var $author$project$Mock$pastMatch = {
    e7: '',
    a_: 5.5,
    iT: $author$project$Mock$specificLocation,
    f_: $elm$time$Time$millisToPosix(1643644800000),
    ge: {
      bm: $author$project$Mock$teams.bm,
      bz: $author$project$Mock$teams.bz
    },
    aO: 30.85,
    ag: _Utils_Tuple2(_List_fromArray([_Utils_Tuple2(6, 2), _Utils_Tuple2(4, 6), _Utils_Tuple2(5, 7)]), 1),
    dh: 1,
    Cy: {
      dY: $elm$time$Time$millisToPosix(1643650200000),
      eL: $elm$time$Time$millisToPosix(1643644800000)
    }
  };
  var $author$project$Mock$userView = {
    tG: _List_fromArray([{
      ij: 8,
      eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/02.jpg'),
      lt: 8
    }]),
    bZ: 'email@example.com',
    nF: 'User',
    nM: 1,
    od: '',
    wV: A2($turboMaCk$any_set$Set$Any$fromList, $author$project$Types$Sport$toString, _List_fromArray([0, 1, 2])),
    oU: 'Name',
    a_: 5.5,
    Aa: A2($elm$core$List$repeat, 3, $author$project$Mock$pastMatch),
    eq: '',
    Az: _List_fromArray([_Utils_Tuple2(0, 135), _Utils_Tuple2(1, 22), _Utils_Tuple2(2, 5)])
  };
  var $author$project$Ui$BanUser$View$view = F3(function (browser, zone, userId) {
    var user = $author$project$Mock$userView;
    var myPlayerView = $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$ImgOverlay(_List_fromArray([{
          ij: browser.ij,
          eZ: $author$project$AssetsImg$assets.AC,
          lt: browser.lt
        }])),
        tU: _List_fromArray([$author$project$UiWrappers$HeaderAndBodyView$multipleBodyContentWithIconAndLabel(_List_fromArray([$elm$core$Maybe$Just({
          uj: ' flex1  ',
          fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Regular primary0 ')]), _List_fromArray([$elm$html$Html$text('Please, provide some reasons. This opinion will be private.')])), $author$project$Ui$Input$plainTextarea({
            bP: $elm$core$Maybe$Nothing,
            bh: ' marTop2  minH20  ',
            od: '03',
            wO: ' minH24 ',
            wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
            bu: A2($elm$core$Basics$composeL, $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg, $author$project$Ui$ComponentsPreview$Msg$OnInput),
            bv: 'Write here why you want to ban this user ',
            ch: false,
            Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
            s_: ''
          })])),
          wE: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$IconSvg$bannedList, '')),
          lh: $elm$core$Maybe$Just('Ban user')
        })]))]),
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$InlineBelowContentBtn({
          xa: true,
          oR: 'Send',
          p_: $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$NoOp),
          r8: 0
        })),
        t_: browser,
        ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' gray0  marTop3 marBottom3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold marBottom2 ')]), _List_fromArray([$elm$html$Html$text(user.nF + (' ' + user.oU))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight2 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
          t_: browser,
          uj: ' ',
          wG: user.tG,
          Dq: 8,
          s5: ' relative block w8 h8 radius7 noOverflow  '
        })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn justifyCenter')]), _List_fromArray([$author$project$Ui$Button$button({
          bh: '',
          fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter heading3Bold  ')]), _List_fromArray([$elm$html$Html$text('Level: ' + $elm$core$String$fromFloat(user.a_))])),
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$NoOp))
        }), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold gray60 ')]), _List_fromArray([$elm$html$Html$text($author$project$Types$Gender$toString(user.nM))]))]))]))]))]),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
        Ck: $elm$core$Maybe$Just(3),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Just($author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$GoBack)),
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
    return _List_fromArray([myPlayerView]);
  });
  var $author$project$UiWrappers$HeaderAndBodyView$StripesSmallTopLeftAndBottomRight = 2;
  var $author$project$Ui$BannedUsers$View$bannedUserRow = F3(function (browser, classes, user) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('radius2 secondary800Back pad2 flexRow spaceBetween'), $elm$html$Html$Attributes$class(classes)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
      t_: browser,
      uj: ' ',
      wG: user.tG,
      Dq: 5,
      s5: ' relative block w5 h5 circle noOverflow  '
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn marLeft1 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading5Bold primary0  ')]), _List_fromArray([$elm$html$Html$text(user.nF)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading6Regular gray80  ')]), _List_fromArray([$elm$html$Html$text($author$project$Types$Gender$toString(user.nM))]))]))])), $author$project$Ui$Button$button({
      bh: '',
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexCenter')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w3 h3 marRight1 ')]), _List_fromArray([$author$project$IconSvg$close1('w3 gray60Fill ')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' gray60 heading5Bold')]), _List_fromArray([$elm$html$Html$text('Remove')]))])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$NoOp))
    })]));
  });
  var $author$project$Ui$BannedUsers$View$view = function (browser) {
    var users = A2($elm$core$List$repeat, 5, $author$project$Mock$userView);
    return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_fromArray([A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, A2($author$project$Ui$BannedUsers$View$bannedUserRow, browser, 'marBottom2'), users))]),
        l5: $elm$core$Maybe$Nothing,
        t_: browser,
        ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 marBottom3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0 marBottom1 ')]), _List_fromArray([$elm$html$Html$text('Banned players list')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray10 bodyRegular ')]), _List_fromArray([$elm$html$Html$text('Manage your banned players')]))]))]),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
        Ck: $elm$core$Maybe$Just(2),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Just($author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$GoBack)),
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    })]);
  };
  var $author$project$Ui$Auth$Msg$ChangePassSetNewPassword = function (a) {
    return {
      $: 15,
      a: a
    };
  };
  var $author$project$Ui$Auth$Msg$ChangePassSetNewPasswordRp = function (a) {
    return {
      $: 17,
      a: a
    };
  };
  var $author$project$Ui$Auth$Msg$ChangePassSetOldPassword = function (a) {
    return {
      $: 13,
      a: a
    };
  };
  var $author$project$Remote$RequestMsg$ConfirmCredentialsForChangePassword = function (a) {
    return {
      $: 10,
      a: a
    };
  };
  var $author$project$Ui$TopLevelViewsUtil$InlineBelowContentTextIconBtn = function (a) {
    return {
      $: 7,
      a: a
    };
  };
  var $author$project$Global$Model$PasswordRecoveryDialog = function (a) {
    return {
      $: 16,
      a: a
    };
  };
  var $author$project$Ui$Auth$Msg$ToggleRevealChangeNewPassword = {
    $: 16
  };
  var $author$project$Ui$Auth$Msg$ToggleRevealChangeOldPassword = {
    $: 14
  };
  var $author$project$Ui$Auth$Msg$ToggleRevealRepeatChangeNewPassword = {
    $: 18
  };
  var $author$project$Ui$ChangePassword$View$view = F3(function (browser, state, maybeUserSession) {
    return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$Input$labeledInput({
          bP: $elm$core$Maybe$Nothing,
          bh: ' marBottom2 ',
          od: '02',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Password({
            p_: $author$project$TopMsg$authMsg($author$project$Ui$Auth$Msg$ToggleRevealChangeOldPassword),
            gn: state.fg
          }),
          oR: 'Current password *',
          bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$Ui$Auth$Msg$ChangePassSetOldPassword),
          bv: 'Enter your current password',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: state.hi
        }), $author$project$Ui$Button$button({
          bh: 'marBottom3',
          fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold secondary100 ')]), _List_fromArray([$elm$html$Html$text('I forgot my password')])),
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.yw(_List_fromArray([function () {
            if (!maybeUserSession.$) {
              var userSession = maybeUserSession.a;
              return $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$PasswordRecoveryDialog(userSession.Db.bZ)));
            } else {
              return $author$project$TopMsg$noOpMsg;
            }
          }()])))
        }), $author$project$Ui$Input$labeledInput({
          bP: $elm$core$Maybe$Nothing,
          bh: ' marBottom3 ',
          od: '02',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Password({
            p_: $author$project$TopMsg$authMsg($author$project$Ui$Auth$Msg$ToggleRevealChangeNewPassword),
            gn: state.ff
          }),
          oR: 'New password *',
          bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$Ui$Auth$Msg$ChangePassSetNewPassword),
          bv: 'Enter your new password',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: state.hh
        }), $author$project$Ui$Input$labeledInput({
          bP: $elm$core$Maybe$Nothing,
          bh: '',
          od: '02',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Password({
            p_: $author$project$TopMsg$authMsg($author$project$Ui$Auth$Msg$ToggleRevealRepeatChangeNewPassword),
            gn: state.fh
          }),
          oR: 'Repeat new password *',
          bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$authMsg, $author$project$Ui$Auth$Msg$ChangePassSetNewPasswordRp),
          bv: 'Repeat your new password',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: state.hj
        })]))]),
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$InlineBelowContentTextIconBtn({
          xa: $elm$core$String$isEmpty(state.hi) || $elm$core$String$isEmpty(state.hh) || $elm$core$String$isEmpty(state.hj),
          oR: 'Continue',
          xD: $elm$core$Maybe$Nothing,
          p_: function () {
            if (!maybeUserSession.$) {
              var session = maybeUserSession.a;
              return _Utils_eq(state.hh, state.hj) ? $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$ConfirmCredentialsForChangePassword({
                bZ: session.Db.bZ,
                f2: state.hh,
                gb: state.hi
              })) : A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'New Passwords don\'t match', _List_Nil);
            } else {
              return $author$project$TopMsg$noOpMsg;
            }
          }(),
          Bh: $elm$core$Maybe$Nothing,
          r8: 0
        })),
        t_: browser,
        ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 marBottom3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0 marBottom1 ')]), _List_fromArray([$elm$html$Html$text('Change my password')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray10 bodyRegular ')]), _List_fromArray([$elm$html$Html$text('For security reasons please first enter your current password.')]))]))]),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
        Ck: $elm$core$Maybe$Just(2),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Just($author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$GoBack)),
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    })]);
  });
  var $author$project$Ui$LocationCard$AddCourts = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Types$Match_$Around = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$Tags$Big = 3;
  var $author$project$Ui$Tags$Black = 6;
  var $author$project$Ui$SelectItem$Calendar = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$CheckBox$Colored = 0;
  var $author$project$Ui$Tags$DarkGrey = 0;
  var $author$project$Ui$Tags$DarkGrey2 = 1;
  var $author$project$Ui$LocationCard$Default = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$CheckBox$Disabled = 1;
  var $author$project$Route$Route$EditUserActivity = function (a) {
    return {
      $: 22,
      a: a
    };
  };
  var $author$project$Ui$CheckBox$Error = 2;
  var $author$project$Ui$Button$ErrorColor = 3;
  var $author$project$Ui$NotificationBar$ErrorTheme = 3;
  var $author$project$Ui$SpecialSearchBar$FilterSearch = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$Tags$Green = 3;
  var $author$project$Ui$Tags$Grey = 2;
  var $author$project$Ui$NotificationBar$InformationalTheme = 1;
  var $author$project$ElmFramework$Lib$Ui$Input$InputDisabled = {
    $: 2
  };
  var $author$project$ElmFramework$Lib$Ui$Input$InputError = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$Ui$Input$InputHightlight = {
    $: 3
  };
  var $author$project$Ui$SpecialSearchBar$LocationSearch = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Tags$Mini = 0;
  var $author$project$Ui$MatchmakingCards$Offline = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnImage = function (a) {
    return {
      $: 31,
      a: a
    };
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnRangeSliderChange = function (a) {
    return {
      $: 32,
      a: a
    };
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnSelectBar = {
    $: 5
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnSelectCard = {
    $: 6
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnSelectPlayer = function (a) {
    return {
      $: 25,
      a: a
    };
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnSelectResultSlider = function (a) {
    return {
      $: 27,
      a: a
    };
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnSelectSlider = function (a) {
    return {
      $: 26,
      a: a
    };
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnSelectUser = {
    $: 7
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnSlideDistance = function (a) {
    return {
      $: 30,
      a: a
    };
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnSlidePlayer = function (a) {
    return {
      $: 28,
      a: a
    };
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnSlideSport = function (a) {
    return {
      $: 29,
      a: a
    };
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnTap = {
    $: 3
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnTapPlayer = {
    $: 4
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnTimeRangeSliderChange = function (a) {
    return {
      $: 33,
      a: a
    };
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnToggleCheckBox = {
    $: 23
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnToggleRadioBtn = {
    $: 24
  };
  var $author$project$Ui$ComponentsPreview$Msg$OnToggleSwitch = {
    $: 22
  };
  var $author$project$Ui$MatchmakingCards$Online = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$BarButton$PlayerStaffBarAdminButton = F3(function (a, b, c) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Ui$BarButton$PlayerStaffBarBookingsButton = F3(function (a, b, c) {
    return {
      $: 1,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Ui$BarButton$PlayerStaffBarEditionButton = F3(function (a, b, c) {
    return {
      $: 2,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Ui$BarButton$PlayerStaffBarWithTextButton = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$SliderMultipleSelect$PrimaryDarkSelectWhiteBack = 0;
  var $author$project$Ui$LocationCard$Remove = F2(function (a, b) {
    return {
      $: 1,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Tags$Selected = 5;
  var $author$project$Ui$Tags$Small = 1;
  var $author$project$Types$Match_$Specific = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$NotificationBar$SuccessTheme = 0;
  var $author$project$Ui$Switch$SwitchDisabled = 3;
  var $author$project$Ui$Switch$SwitchError = 4;
  var $author$project$Ui$SelectItem$TagButton = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$Button$TertiaryColor = 2;
  var $author$project$Ui$ComponentsPreview$Model$Val2 = 1;
  var $author$project$Ui$NotificationBar$WarningTheme = 2;
  var $author$project$Ui$Tags$White = 4;
  var $author$project$Mock$activity = 1;
  var $elm$html$Html$h2 = _VirtualDom_node('h2');
  var $elm$html$Html$h3 = _VirtualDom_node('h3');
  var $author$project$IconSvg$location_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M15.8541 30.1369C17.1484 31.3754 18.8109 32.0003 20.4622 32.0003C22.1135 32.0003 23.776 31.3754 25.0703 30.1369C28.3619 26.9681 31.9993 21.9248 30.638 15.9108C29.3995 10.4435 24.6352 8 20.4734 8H20.4622C16.3004 8 11.536 10.4435 10.2975 15.8997C8.92511 21.9137 12.5625 26.9681 15.8541 30.1369ZM11.9377 16.2679C13.0423 11.4031 17.2153 9.67366 20.4622 9.67366C23.7091 9.67366 27.8932 11.4031 29.009 16.2679C30.1917 21.5232 26.889 26.0532 23.9099 28.9207C21.9796 30.7841 18.9559 30.7841 17.0256 28.9207C14.0353 26.0532 10.7327 21.5232 11.9377 16.2679ZM16.1438 18.0977C16.1438 20.4854 18.0853 22.4157 20.4619 22.4157C22.8385 22.4157 24.7799 20.4966 24.7799 18.1088C24.7799 15.7211 22.8385 13.7908 20.4619 13.7908C18.0853 13.7908 16.1438 15.7099 16.1438 18.0977ZM17.8175 18.1088C17.8175 16.6472 19.0114 15.4645 20.4619 15.4645C21.9124 15.4645 23.1063 16.6472 23.1063 18.1088C23.1063 19.5705 21.9235 20.7532 20.4619 20.7532C19.0002 20.7532 17.8175 19.5705 17.8175 18.1088Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$location = function (classes) {
    return $author$project$IconSvg$location_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$MatchmakingCards$playerRow = F3(function (classes, browser, info) {
    var phoneNum = function () {
      var _v0 = info.eq;
      if (!_v0.$) {
        var phone = _v0.a;
        return phone;
      } else {
        return '';
      }
    }();
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow  fullWidth  '), $elm$html$Html$Attributes$class(classes)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexCenter')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
      t_: browser,
      uj: '',
      wG: info.wG,
      Dq: 4,
      s5: ' relative block w4 h4 circle noOverflow '
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' marLeft1 flexColumn  noOverflow  ')]), _List_fromArray([A2($elm$html$Html$h3, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular primary0 ellipsis  ')]), _List_fromArray([$elm$html$Html$text(info.i5)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('notesRegular gray80 whiteSpaceNoWrap ellipsis')]), _List_fromArray([$elm$html$Html$text(phoneNum)]))]))]));
  });
  var $author$project$Ui$MatchmakingCards$section = F3(function (hasBorder, classes, content) {
    var borderClasses = hasBorder ? 'borderBottomSolid gray10Border borderBottomW125 ' : ' ';
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padLeft2 padRight2 padTop1h padBottom1h flexRow ' + borderClasses), $elm$html$Html$Attributes$class(classes)]), content);
  });
  var $elm$core$String$pad = F3(function (n, _char, string) {
    var half = (n - $elm$core$String$length(string)) / 2;
    return _Utils_ap(A2($elm$core$String$repeat, $elm$core$Basics$ceiling(half), $elm$core$String$fromChar(_char)), _Utils_ap(string, A2($elm$core$String$repeat, $elm$core$Basics$floor(half), $elm$core$String$fromChar(_char))));
  });
  var $author$project$Ui$TimeRepresentation$toClockTime = F2(function (zone, posix) {
    return A2($elm$core$String$join, ':', _List_fromArray([A3($elm$core$String$pad, 2, '0', $elm$core$String$fromInt(A2($elm$time$Time$toHour, zone, posix))), A3($elm$core$String$pad, 2, '0', $elm$core$String$fromInt(A2($elm$time$Time$toMinute, zone, posix)))]));
  });
  var $author$project$Ui$TimeRepresentation$toEnglishMonth = function (month) {
    switch (month) {
      case 0:
        return 'Jan';
      case 1:
        return 'Feb';
      case 2:
        return 'Mar';
      case 3:
        return 'Apr';
      case 4:
        return 'May';
      case 5:
        return 'Jun';
      case 6:
        return 'Jul';
      case 7:
        return 'Aug';
      case 8:
        return 'Sept';
      case 9:
        return 'Oct';
      case 10:
        return 'Nov';
      default:
        return 'Dec';
    }
  };
  var $author$project$Ui$TimeRepresentation$toDayMonth = F2(function (zone, posix) {
    return A2($elm$core$String$join, ' ', _List_fromArray([A3($elm$core$String$pad, 2, '0', $elm$core$String$fromInt(A2($elm$time$Time$toDay, zone, posix))), $author$project$Ui$TimeRepresentation$toEnglishMonth(A2($elm$time$Time$toMonth, zone, posix))]));
  });
  var $author$project$IconSvg$badminton_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M13.8847 9.43671C15.3052 9.64037 16.6682 10.3817 17.6531 11.3665C18.638 12.3514 19.3793 13.7145 19.5829 15.1349C19.7743 16.4699 19.4897 17.863 18.4801 19.014L20.0933 20.6199L21.7064 19.014C20.6968 17.863 20.4122 16.4699 20.6036 15.1349C20.8073 13.7145 21.5485 12.3514 22.5334 11.3665C23.5183 10.3817 24.8813 9.64037 26.3018 9.43671C27.7325 9.23157 29.2298 9.57316 30.4245 10.7678C31.6192 11.9625 31.9608 13.4599 31.7557 14.8906C31.552 16.311 30.8107 17.6741 29.8258 18.659C28.841 19.6438 27.4779 20.3851 26.0575 20.5888C24.7462 20.7768 23.3789 20.5056 22.24 19.5391L20.6175 21.1418L24.313 24.8206L27 26.5L30.4946 29.7681C30.9076 30.1543 30.9185 30.8058 30.5187 31.2056L30.2084 31.5158C29.8088 31.9154 29.1578 31.9048 28.7714 31.4924L25.5 28L23.8667 25.3867L20.0933 21.6596L16.3198 25.3867L14.6865 28L11.4151 31.4924C11.0288 31.9048 10.3777 31.9154 9.97816 31.5158L9.66786 31.2056C9.26806 30.8058 9.27897 30.1543 9.69193 29.7681L13.1865 26.5L15.8735 24.8206L19.569 21.1418L17.9465 19.5391C16.8076 20.5056 15.4403 20.7768 14.129 20.5888C12.7086 20.3851 11.3456 19.6438 10.3607 18.659C9.3758 17.6741 8.63452 16.311 8.43085 14.8906C8.22571 13.4599 8.5673 11.9625 9.76199 10.7678C10.9567 9.57316 12.454 9.23157 13.8847 9.43671ZM13.7783 10.1791C13.7516 10.1753 13.7249 10.1717 13.6981 10.1683L14.6804 11.1506L15.2287 10.6023C14.7622 10.3963 14.2722 10.2499 13.7783 10.1791ZM10.5718 11.042C11.2042 10.5123 11.9179 10.2344 12.6549 10.1549L14.1655 11.6655L12.6804 13.1505L10.5718 11.042ZM9.15023 13.6502C9.23141 12.9147 9.51068 12.2027 10.041 11.5719L12.15 13.6809L10.6654 15.1654L9.15023 13.6502ZM9.17326 14.7841C9.16884 14.7533 9.16472 14.7225 9.16089 14.6917L10.15 15.6808L9.59637 16.2345C9.3904 15.768 9.24408 15.2781 9.17326 14.7841ZM10.891 18.1286C10.5391 17.7768 10.2231 17.3715 9.95902 16.9325L10.6804 16.2112L13.0004 18.5312L12.3314 19.2003C11.7982 18.9109 11.3072 18.5449 10.891 18.1286ZM14.2355 19.8464C13.8366 19.7892 13.4403 19.6827 13.0569 19.5354L13.5307 19.0616L14.3279 19.8587C14.2971 19.8549 14.2663 19.8508 14.2355 19.8464ZM17.4478 18.9786C16.817 19.509 16.105 19.7882 15.3694 19.8694L14.0462 18.5462L15.5307 17.0616L17.4478 18.9786ZM18.8647 16.3647C18.7853 17.1017 18.5073 17.8154 17.9776 18.4478L16.0611 16.5312L17.5462 15.0462L18.8647 16.3647ZM18.8405 15.2414C18.8443 15.2681 18.848 15.2948 18.8513 15.3215L18.0611 14.5312L18.5296 14.0627C18.6769 14.4462 18.7833 14.8425 18.8405 15.2414ZM17.1228 11.8969C17.539 12.3131 17.9051 12.8041 18.1944 13.3372L17.5307 14.0009L15.2107 11.6809L15.9267 10.9649C16.3657 11.229 16.7709 11.545 17.1228 11.8969ZM17.0158 14.5158L14.6958 12.1958L13.2107 13.6809L15.5307 16.0009L17.0158 14.5158ZM15.0004 16.5312L12.6804 14.2112L11.1958 15.6958L13.5158 18.0158L15.0004 16.5312ZM26.4082 10.1791C26.435 10.1753 26.4617 10.1717 26.4884 10.1683L25.5061 11.1506L24.9578 10.6023C25.4243 10.3963 25.9143 10.2499 26.4082 10.1791ZM29.6147 11.042C28.9823 10.5123 28.2686 10.2344 27.5316 10.1549L26.0211 11.6655L27.5061 13.1505L29.6147 11.042ZM31.0363 13.6502C30.9551 12.9147 30.6758 12.2027 30.1455 11.5719L28.0365 13.6809L29.5211 15.1654L31.0363 13.6502ZM31.0133 14.7841C31.0177 14.7533 31.0218 14.7225 31.0256 14.6917L30.0365 15.6808L30.5902 16.2345C30.7961 15.768 30.9424 15.2781 31.0133 14.7841ZM29.2955 18.1286C29.6474 17.7768 29.9634 17.3715 30.2275 16.9325L29.5062 16.2112L27.1861 18.5312L27.8552 19.2003C28.3883 18.9109 28.8793 18.5449 29.2955 18.1286ZM25.951 19.8464C26.3499 19.7892 26.7462 19.6827 27.1296 19.5354L26.6558 19.0616L25.8586 19.8587C25.8894 19.8549 25.9202 19.8508 25.951 19.8464ZM22.7387 18.9786C23.3696 19.509 24.0816 19.7882 24.8171 19.8694L26.1404 18.5462L24.6558 17.0616L22.7387 18.9786ZM21.3218 16.3647C21.4012 17.1017 21.6792 17.8154 22.2089 18.4478L24.1255 16.5312L22.6404 15.0462L21.3218 16.3647ZM21.346 15.2414C21.3422 15.2681 21.3386 15.2948 21.3352 15.3215L22.1255 14.5312L21.657 14.0627C21.5096 14.4462 21.4032 14.8425 21.346 15.2414ZM23.0638 11.8969C22.6475 12.3131 22.2814 12.8041 21.9921 13.3372L22.6558 14.0009L24.9758 11.6809L24.2598 10.9649C23.8208 11.229 23.4156 11.545 23.0638 11.8969ZM23.1707 14.5158L25.4907 12.1958L26.9758 13.6809L24.6558 16.0009L23.1707 14.5158ZM25.1861 16.5312L27.5061 14.2112L28.9907 15.6958L26.6707 18.0158L25.1861 16.5312Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$badminton = function (classes) {
    return $author$project$IconSvg$badminton_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$basketball_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M19.9968 8C20.8697 7.99954 21.7456 8.09434 22.6091 8.28651C25.3873 8.9048 27.8551 10.4907 29.5718 12.7608C31.1531 14.8427 32.0062 17.3866 32 20.001C31.9999 20.1607 31.9967 20.3202 31.9903 20.4793C31.8976 22.9238 31.0549 25.2851 29.5705 27.2393C29.5593 27.2541 29.5476 27.2684 29.5353 27.2821C29.4089 27.4475 29.278 27.6099 29.1425 27.7692C27.2986 29.9379 24.7436 31.3802 21.9341 31.8384C21.3201 31.9386 20.7026 31.9903 20.0872 31.9946C20.0585 31.9982 20.0292 32 19.9996 32C19.9698 32 19.9404 31.9982 19.9116 31.9946C17.771 31.9782 15.6604 31.389 13.8063 30.2706C12.5203 29.4948 11.4018 28.491 10.4992 27.3194C10.4735 27.2944 10.4494 27.2672 10.4272 27.2379C8.85219 25.1537 8.00001 22.6125 8 20C8 20 8 20 8 19.9999C8 17.3874 8.85218 14.8462 10.4272 12.762C10.4445 12.7391 10.4629 12.7176 10.4825 12.6973C11.5281 11.3336 12.8625 10.2 14.4049 9.38626C16.1402 8.47071 18.0608 8.00103 19.9968 8ZM9.44141 20.7059C9.50164 21.6041 9.67663 22.4973 9.967 23.3632C10.2777 24.2896 10.7125 25.1613 11.2545 25.957C12.3362 25.4941 13.2749 24.7439 13.966 23.7836C14.6209 22.8735 15.0263 21.8125 15.148 20.7059H9.44141ZM15.148 19.2941H9.44108C9.51437 18.1933 9.75982 17.1024 10.1762 16.0624C10.4626 15.3472 10.8242 14.6703 11.2519 14.0418C12.3347 14.5046 13.2743 15.2552 13.966 16.2163C14.621 17.1264 15.0263 18.1874 15.148 19.2941ZM16.5667 19.2941C16.4402 17.8908 15.9398 16.5423 15.1119 15.3917C14.3434 14.3239 13.3237 13.4695 12.1495 12.8999C12.9744 11.9871 13.9585 11.218 15.0636 10.6349C16.3841 9.93822 17.8262 9.53414 19.2937 9.43556V19.2941H16.5667ZM16.5667 20.7059C16.4402 22.1091 15.9398 23.4577 15.1119 24.6082C14.3441 25.6751 13.3255 26.5289 12.1526 27.0985C12.8416 27.8602 13.6428 28.5232 14.5355 29.0617C15.9895 29.9388 17.6224 30.4471 19.2937 30.5593V20.7059H16.5667ZM20.7054 30.5598C21.0397 30.5376 21.3738 30.4994 21.7069 30.4451C24.0777 30.0584 26.2432 28.8774 27.8509 27.1011C26.6756 26.5319 25.655 25.6773 24.8861 24.6088C24.0581 23.4581 23.5579 22.1093 23.4318 20.7059H20.7054V30.5598ZM23.4318 19.2941H20.7054V9.43509C21.24 9.47065 21.7739 9.54693 22.3024 9.66456C24.4504 10.1426 26.3882 11.2762 27.854 12.8972C26.6775 13.4665 25.6557 14.3217 24.8861 15.3911C24.0581 16.5418 23.5579 17.8906 23.4318 19.2941ZM24.8505 20.7059C24.9718 21.8127 25.377 22.8739 26.032 23.7842C26.7243 24.7463 27.6653 25.4972 28.7497 25.9595C29.8103 24.4035 30.4382 22.5898 30.5645 20.7059H24.8505ZM30.5652 19.2941H24.8505C24.9718 18.1872 25.3769 17.126 26.032 16.2157C26.7249 15.2528 27.667 14.5013 28.7525 14.0392C29.8179 15.5972 30.4436 17.4128 30.5652 19.2941Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$basketball = function (classes) {
    return $author$project$IconSvg$basketball_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$cricket_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M13.0801 32C13.1881 32.0004 13.2943 31.9738 13.3879 31.9228C13.4816 31.8718 13.5593 31.7983 13.6133 31.7097L14.7859 29.7915C14.801 29.7722 14.8148 29.752 14.8273 29.7309L16.3227 27.3161C16.3477 27.2741 16.3671 27.2294 16.3804 27.183L16.8248 26.4562L19.8891 28.1396C20.3234 28.3755 20.8386 28.439 21.3221 28.316C21.8056 28.1931 22.2181 27.8938 22.4693 27.4837L22.6537 27.178C22.9495 27.2604 23.2586 27.3036 23.5725 27.3042C24.2215 27.3053 24.8563 27.124 25.3964 26.7832C25.9366 26.4424 26.3578 25.9574 26.6067 25.3896C26.8556 24.8219 26.9211 24.197 26.7948 23.594C26.6685 22.991 26.356 22.4371 25.8971 22.0024C25.8786 21.9849 25.8599 21.9676 25.841 21.9505L29.7379 15.5834C29.8659 15.3813 29.9493 15.1567 29.983 14.9232C30.0168 14.6897 30.0001 14.4522 29.934 14.225C29.8019 13.7673 29.4848 13.3774 29.0515 13.1394L20.0914 8.23417C19.656 8.00032 19.1407 7.93865 18.6576 8.06256C18.1745 8.18647 17.7625 8.48596 17.5112 8.89595L10.2609 20.7963C10.1337 20.9976 10.0508 21.2212 10.0171 21.4536C9.9834 21.686 9.99962 21.9225 10.0648 22.1488C10.128 22.3772 10.2386 22.5913 10.3901 22.7787C10.5416 22.966 10.7311 23.1229 10.9473 23.2402L13.9259 24.8714L10.7267 30.1308C10.6463 30.2634 10.6244 30.4207 10.6657 30.5685C10.707 30.7163 10.8082 30.8427 10.9473 30.9203L12.7859 31.9245C12.8757 31.9727 12.9769 31.9987 13.0801 32ZM24.8253 21.326L28.6777 14.997C28.7232 14.9276 28.7528 14.8498 28.7644 14.7688C28.776 14.6877 28.7694 14.6053 28.7451 14.5268C28.7234 14.4469 28.6852 14.3718 28.6326 14.3061C28.58 14.2403 28.514 14.1851 28.4386 14.1437L19.4785 9.24425C19.4034 9.2029 19.3204 9.1761 19.2342 9.1654C19.1481 9.1547 19.0606 9.16032 18.9768 9.18192C18.8929 9.20352 18.8145 9.24068 18.746 9.29125C18.6774 9.34181 18.6202 9.40476 18.5776 9.47645L11.3457 21.3826C11.3001 21.452 11.2706 21.5298 11.259 21.6109C11.2473 21.6919 11.2539 21.7743 11.2783 21.8528C11.3 21.9319 11.3384 22.0061 11.391 22.071C11.4436 22.1358 11.5095 22.1899 11.5847 22.2301L15.0965 24.1574C15.2315 24.2387 15.3276 24.3668 15.3642 24.5143C15.4009 24.6618 15.3752 24.8171 15.2926 24.9469L14.7606 25.8215L15.5447 26.2325L16.0709 25.3706C16.1244 25.2829 16.2012 25.21 16.2937 25.159C16.3861 25.1081 16.491 25.081 16.598 25.0804C16.7136 25.0754 16.8284 25.1016 16.9289 25.1559L20.5449 27.1354C20.697 27.2173 20.8771 27.2389 21.0459 27.1954C21.2147 27.1519 21.3585 27.0468 21.4458 26.9032L21.5926 26.6696C21.476 26.5856 21.3649 26.4937 21.2601 26.3945C20.6467 25.8135 20.3014 25.0259 20.2998 24.2043C20.2986 23.5895 20.49 22.9883 20.8498 22.4767C21.2096 21.965 21.7217 21.5661 22.321 21.3303C22.9204 21.0945 23.5802 21.0325 24.2168 21.1522C24.4261 21.1915 24.6298 21.2499 24.8253 21.326ZM24.7662 22.6234C25.0753 22.8336 25.3169 23.1215 25.4631 23.4552C25.6182 23.8091 25.6591 24.1986 25.5806 24.5746C25.5021 24.9505 25.3078 25.296 25.0221 25.5674C24.7364 25.8388 24.3723 26.0239 23.9756 26.0994C23.5789 26.1748 23.1675 26.1373 22.7934 25.9914C22.4192 25.8456 22.0991 25.5979 21.8735 25.2799C21.6478 24.9618 21.5267 24.5875 21.5255 24.2043C21.5231 23.9487 21.5743 23.6953 21.6762 23.4587C21.7782 23.2221 21.9288 23.007 22.1192 22.8261C22.3097 22.6451 22.5363 22.5018 22.7858 22.4046C23.0353 22.3073 23.3027 22.258 23.5725 22.2596C23.7175 22.2596 23.8613 22.2742 24.0016 22.3027C24.2479 22.3549 24.4828 22.4501 24.694 22.5842C24.7172 22.5989 24.7413 22.6119 24.7662 22.6234ZM12.8595 30.63L13.4506 29.662L12.6614 29.2724L12.0934 30.2062L12.8595 30.63ZM14.907 27.2464L14.1395 26.8425L13.2637 28.2824L14.0428 28.6744L14.907 27.2464Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$cricket = function (classes) {
    return $author$project$IconSvg$cricket_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$others_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M20 32C17.6266 32 15.3066 31.2962 13.3332 29.9776C12.3423 29.3155 11.4611 28.5134 10.7144 27.6012C10.6868 27.5743 10.6627 27.5444 10.6424 27.5123C9.93445 26.6305 9.3509 25.6483 8.91345 24.5922C8.0052 22.3995 7.76756 19.9867 8.23058 17.6589C8.68276 15.3856 9.78335 13.2932 11.3977 11.6334C11.4062 11.6196 11.4154 11.6062 11.4252 11.5933C11.461 11.5462 11.505 11.506 11.555 11.4746C13.2271 9.81829 15.3497 8.68991 17.6589 8.23058C19.9867 7.76756 22.3995 8.0052 24.5922 8.91345C25.7293 9.38444 26.7807 10.0248 27.7133 10.8074C27.7941 10.8454 27.8635 10.9047 27.9137 10.9792C28.6973 11.6667 29.3922 12.457 29.9776 13.3332C31.2962 15.3066 32 17.6266 32 20C31.9981 22.3654 31.2984 24.6584 30.015 26.6038C30.0084 26.6178 30.0012 26.6316 29.9933 26.645C29.9758 26.6747 29.9553 26.7025 29.9321 26.7278C29.5085 27.3528 29.024 27.9408 28.4824 28.4824C26.2325 30.7323 23.1818 31.9974 20 32ZM12.2102 27.7898C11.9656 27.5451 11.7334 27.2899 11.5141 27.025C11.1634 21.184 13.2697 18.6651 14.1015 17.907C14.9538 19.0658 15.7707 19.9591 16.1787 20.3937C15.6855 21.2534 14.647 23.6824 14.6717 28.7302C14.6711 28.7423 14.6711 28.7544 14.6714 28.7665L14.6719 28.7788C14.6737 29.0612 14.6788 29.3518 14.6875 29.6508C13.783 29.1529 12.9482 28.5277 12.2102 27.7898ZM12.1818 14.7218C12.5698 15.5654 13.0453 16.3719 13.5365 17.1038C12.636 17.8758 10.544 20.2434 10.5125 25.599C9.88578 24.5369 9.43843 23.3715 9.19529 22.1492C8.96062 20.9694 8.922 19.7659 9.07478 18.5857C9.82038 17.0872 10.8809 15.7695 12.1818 14.7218ZM12.7413 13.519C12.5655 13.0423 12.428 12.5599 12.3431 12.0796C12.815 11.6234 13.3288 11.2082 13.8796 10.8402C14.3734 10.5103 14.8909 10.2222 15.4266 9.97779C15.7214 10.5261 16.0351 11.1042 16.3607 11.698C17.8863 14.499 19.5957 17.6542 20.6105 20.277C19.5074 20.2822 18.3255 20.1688 17.0757 19.9038C16.6237 19.4476 14.1637 16.8908 12.9395 14.0172C12.9489 13.9704 12.9515 13.9223 12.947 13.8744C12.9402 13.8022 12.9175 13.7325 12.8806 13.6701C12.8453 13.6104 12.7979 13.559 12.7413 13.519ZM11.7998 13.7964C11.1063 14.3249 10.4728 14.9236 9.90855 15.5815C10.3256 14.6289 10.8735 13.7447 11.5325 12.9528C11.6082 13.2357 11.6981 13.5173 11.7998 13.7964ZM20 8.98361C18.7482 8.98361 17.5125 9.19688 16.3441 9.60793L17.2262 11.2259L17.2351 11.2421C18.84 14.1733 20.6495 17.478 21.6603 20.2355C22.971 20.1371 24.1538 19.8706 25.1877 19.4995C25.082 18.6388 24.1578 12.3003 20.9049 9.18999C20.8546 9.13935 20.8164 9.07889 20.7922 9.01313C20.5294 8.99387 20.2652 8.98397 20 8.98361ZM26.1316 19.1142C27.1523 18.6442 27.9884 18.074 28.6129 17.486C28.5552 16.6655 28.2752 13.792 27.1298 11.6099C25.7329 10.4223 24.0672 9.60642 22.2881 9.22661C25.0247 12.4661 25.9241 17.6386 26.1316 19.1142ZM29.3509 21.7332C29.3003 20.1522 29.082 19.1201 28.9089 18.5353C27.157 19.9883 24.2427 21.259 20.5263 21.259C19.35 21.2553 18.1773 21.1344 17.0255 20.8983C16.7931 21.322 16.3579 22.2837 16.0445 23.9785C21.1734 26.0605 26.9187 23.9129 29.3509 21.7332ZM30.3468 21.9815C30.3475 21.9746 30.3481 21.9678 30.3485 21.9609C30.3507 21.9226 30.3484 21.8843 30.3418 21.8467C30.2792 19.2345 29.7786 17.9285 29.6049 17.551C29.5814 17.1152 29.4574 15.4182 28.9417 13.575C30.2791 15.4351 31.0133 17.6795 31.0164 20C31.0164 21.3382 30.7727 22.658 30.3041 23.8969C30.3436 23.2009 30.3547 22.5691 30.3449 21.9978C30.3456 21.9924 30.3463 21.9869 30.3468 21.9815ZM29.3545 23.0033C29.3327 23.9068 29.2587 24.9461 29.1081 26.1329C28.021 26.8577 21.9832 30.6155 15.6764 28.4158C15.6791 27.0727 15.7619 25.9338 15.8876 24.9768C17.3583 25.5293 18.9188 25.8082 20.4918 25.7985C23.8641 25.7985 27.1752 24.6524 29.3545 23.0033ZM15.6899 29.457C17.0245 29.8827 18.419 30.0974 19.8229 30.0919C22.777 30.0919 25.3982 29.1836 27.2221 28.3188C26.3314 29.0921 25.3174 29.7215 24.2158 30.1778C22.2028 31.0116 19.9878 31.2298 17.8508 30.8047C17.1114 30.6576 16.3928 30.4358 15.7053 30.1448C15.7094 30.1194 15.7115 30.0935 15.7115 30.0674C15.7025 29.8599 15.6954 29.6564 15.6899 29.457Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$others = function (classes) {
    return $author$project$IconSvg$others_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$padel_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M30.1458 9.52487C28.3066 7.72631 26.1374 7.65785 24.6964 7.67225C23.2554 7.68665 21.1757 8.21324 19.6543 9.7688C18.0989 11.2903 17.1238 13.3073 16.8975 15.4713C16.8119 16.3859 16.8971 17.3085 17.1487 18.192C16.9222 19.2033 16.5649 20.1807 16.0857 21.0995C15.7877 21.6762 15.4521 22.2326 15.081 22.7653C15.0322 22.7871 14.9874 22.817 14.9484 22.8537L8.1307 29.3399C8.08926 29.3813 8.05639 29.4305 8.03397 29.4846C8.01154 29.5387 8 29.5967 8 29.6553C8 29.7139 8.01154 29.7719 8.03397 29.8261C8.05639 29.8802 8.08926 29.9294 8.1307 29.9708L9.7 31.5381C9.74115 31.58 9.79024 31.6133 9.84441 31.636C9.89857 31.6588 9.95673 31.6705 10.0155 31.6705C10.0742 31.6705 10.1324 31.6588 10.1865 31.636C10.2407 31.6133 10.2898 31.58 10.3309 31.5381L16.8171 24.7244C16.8538 24.6854 16.8837 24.6406 16.9055 24.5918C17.4384 24.2211 17.9948 23.8854 18.5713 23.5871C19.4904 23.1091 20.4678 22.7524 21.4788 22.5262C22.3625 22.7764 23.2851 22.8602 24.1995 22.7733C26.3638 22.5465 28.3808 21.5706 29.902 20.0145C31.4571 18.4936 31.9849 16.4162 31.9984 14.9742C32.0118 13.5323 31.9849 11.3234 30.1458 9.52487ZM18.0468 20.0667C18.2593 20.371 18.498 20.656 18.7602 20.9187C19.0229 21.1815 19.3087 21.4203 19.6141 21.632C19.0433 21.8396 18.4863 22.0832 17.9464 22.3614C17.4179 22.6349 16.9054 22.9382 16.4112 23.2696C16.7427 22.7754 17.0459 22.2629 17.3195 21.7345C17.5978 21.1949 17.8408 20.6378 18.0468 20.0667ZM22.8917 10.2327C23.0926 10.4336 23.4183 10.4336 23.6192 10.2327C23.8201 10.0318 23.8201 9.70612 23.6192 9.50524C23.4183 9.30435 23.0926 9.30435 22.8917 9.50524C22.6908 9.70612 22.6908 10.0318 22.8917 10.2327ZM26.529 10.9602C26.7299 11.161 27.0556 11.161 27.2565 10.9602C27.4574 10.7593 27.4574 10.4336 27.2565 10.2327C27.0556 10.0318 26.7299 10.0318 26.529 10.2327C26.3281 10.4336 26.3281 10.7593 26.529 10.9602ZM28.3477 11.3239C28.5486 11.5248 28.8743 11.5248 29.0751 11.3239C29.276 11.123 29.276 10.7973 29.0751 10.5964C28.8743 10.3955 28.5486 10.3955 28.3477 10.5964C28.1468 10.7973 28.1468 11.123 28.3477 11.3239ZM26.8928 12.7788C27.0936 12.9797 27.4193 12.9797 27.6202 12.7788C27.8211 12.5779 27.8211 12.2522 27.6202 12.0514C27.4193 11.8505 27.0936 11.8505 26.8928 12.0514C26.6919 12.2522 26.6919 12.5779 26.8928 12.7788ZM29.4389 13.1425C29.238 13.3434 28.9123 13.3434 28.7114 13.1425C28.5105 12.9417 28.5105 12.616 28.7114 12.4151C28.9123 12.2142 29.238 12.2142 29.4389 12.4151C29.6398 12.616 29.6398 12.9417 29.4389 13.1425ZM25.8016 12.4151C25.6007 12.616 25.275 12.616 25.0741 12.4151C24.8732 12.2142 24.8732 11.8885 25.0741 11.6876C25.275 11.4867 25.6007 11.4867 25.8016 11.6876C26.0024 11.8885 26.0024 12.2142 25.8016 12.4151ZM24.3466 13.87C24.1458 14.0709 23.8201 14.0709 23.6192 13.87C23.4183 13.6691 23.4183 13.3434 23.6192 13.1425C23.8201 12.9417 24.1458 12.9417 24.3466 13.1425C24.5475 13.3434 24.5475 13.6691 24.3466 13.87ZM22.1643 11.6876C21.9634 11.8885 21.6377 11.8885 21.4368 11.6876C21.2359 11.4867 21.2359 11.161 21.4368 10.9602C21.6377 10.7593 21.9634 10.7593 22.1643 10.9602C22.3651 11.161 22.3651 11.4867 22.1643 11.6876ZM22.8917 15.3249C22.6908 15.5258 22.3651 15.5258 22.1643 15.3249C21.9634 15.1241 21.9634 14.7984 22.1643 14.5975C22.3651 14.3966 22.6908 14.3966 22.8917 14.5975C23.0926 14.7984 23.0926 15.1241 22.8917 15.3249ZM22.528 16.4161C22.3271 16.617 22.3271 16.9427 22.528 17.1436C22.7289 17.3445 23.0546 17.3445 23.2554 17.1436C23.4563 16.9427 23.4563 16.617 23.2554 16.4161C23.0546 16.2152 22.7289 16.2152 22.528 16.4161ZM24.3466 17.5073C24.1458 17.3064 24.1458 16.9807 24.3466 16.7799C24.5475 16.579 24.8732 16.579 25.0741 16.7799C25.275 16.9807 25.275 17.3064 25.0741 17.5073C24.8732 17.7082 24.5475 17.7082 24.3466 17.5073ZM25.4378 14.2337C25.237 14.0329 25.237 13.7072 25.4378 13.5063C25.6387 13.3054 25.9644 13.3054 26.1653 13.5063C26.3662 13.7072 26.3662 14.0329 26.1653 14.2337C25.9644 14.4346 25.6387 14.4346 25.4378 14.2337ZM19.9819 13.1425C20.1828 13.3434 20.5084 13.3434 20.7093 13.1425C20.9102 12.9417 20.9102 12.616 20.7093 12.4151C20.5084 12.2142 20.1828 12.2142 19.9819 12.4151C19.781 12.616 19.781 12.9417 19.9819 13.1425ZM27.2565 19.6897C27.0556 19.8906 26.7299 19.8906 26.529 19.6897C26.3281 19.4888 26.3281 19.1631 26.529 18.9622C26.7299 18.7614 27.0556 18.7614 27.2565 18.9622C27.4574 19.1631 27.4574 19.4888 27.2565 19.6897ZM21.4368 16.7799C21.2359 16.9807 20.9102 16.9807 20.7093 16.7799C20.5084 16.579 20.5084 16.2533 20.7093 16.0524C20.9102 15.8515 21.2359 15.8515 21.4368 16.0524C21.6377 16.2533 21.6377 16.579 21.4368 16.7799ZM30.1663 16.7799C29.9655 16.9807 29.6398 16.9807 29.4389 16.7799C29.238 16.579 29.238 16.2533 29.4389 16.0524C29.6398 15.8515 29.9655 15.8515 30.1663 16.0524C30.3672 16.2533 30.3672 16.579 30.1663 16.7799ZM24.7104 10.5964C24.9113 10.7973 25.237 10.7973 25.4378 10.5964C25.6387 10.3955 25.6387 10.0699 25.4378 9.86897C25.237 9.66809 24.9113 9.66809 24.7104 9.86897C24.5095 10.0699 24.5095 10.3955 24.7104 10.5964ZM21.0731 17.8711C20.8722 18.0719 20.8722 18.3976 21.0731 18.5985C21.2739 18.7994 21.5996 18.7994 21.8005 18.5985C22.0014 18.3976 22.0014 18.0719 21.8005 17.8711C21.5996 17.6702 21.2739 17.6702 21.0731 17.8711ZM22.528 13.5063C22.3271 13.7072 22.0014 13.7072 21.8005 13.5063C21.5996 13.3054 21.5996 12.9797 21.8005 12.7788C22.0014 12.5779 22.3271 12.5779 22.528 12.7788C22.7289 12.9797 22.7289 13.3054 22.528 13.5063ZM20.3456 14.2337C20.1447 14.4346 20.1447 14.7603 20.3456 14.9612C20.5465 15.1621 20.8722 15.1621 21.0731 14.9612C21.2739 14.7603 21.2739 14.4346 21.0731 14.2337C20.8722 14.0329 20.5465 14.0329 20.3456 14.2337ZM27.984 17.5073C27.7831 17.7082 27.7831 18.0339 27.984 18.2348C28.1848 18.4357 28.5105 18.4357 28.7114 18.2348C28.9123 18.0339 28.9123 17.7082 28.7114 17.5073C28.5105 17.3064 28.1848 17.3064 27.984 17.5073ZM19.6181 15.6887C19.819 15.8895 19.819 16.2152 19.6181 16.4161C19.4173 16.617 19.0916 16.617 18.8907 16.4161C18.6898 16.2152 18.6898 15.8896 18.8907 15.6887C19.0916 15.4878 19.4173 15.4878 19.6181 15.6887ZM27.2565 14.5975C27.4574 14.7984 27.7831 14.7984 27.984 14.5975C28.1848 14.3966 28.1848 14.0709 27.984 13.87C27.7831 13.6691 27.4574 13.6691 27.2565 13.87C27.0556 14.0709 27.0556 14.3966 27.2565 14.5975ZM23.2554 12.0514C23.4563 12.2522 23.782 12.2522 23.9829 12.0514C24.1838 11.8505 24.1838 11.5248 23.9829 11.3239C23.782 11.123 23.4563 11.123 23.2554 11.3239C23.0546 11.5248 23.0546 11.8505 23.2554 12.0514ZM24.7104 15.6887C24.9113 15.4878 24.9113 15.1621 24.7104 14.9612C24.5095 14.7603 24.1838 14.7603 23.9829 14.9612C23.782 15.1621 23.782 15.4878 23.9829 15.6887C24.1838 15.8895 24.5095 15.8895 24.7104 15.6887ZM29.0751 14.9612C28.8743 14.7603 28.8743 14.4346 29.0751 14.2337C29.276 14.0329 29.6017 14.0329 29.8026 14.2337C30.0035 14.4346 30.0035 14.7603 29.8026 14.9612C29.6017 15.1621 29.276 15.1621 29.0751 14.9612ZM28.3477 16.4161C28.1468 16.617 27.8211 16.617 27.6202 16.4161C27.4193 16.2152 27.4193 15.8895 27.6202 15.6887C27.8211 15.4878 28.1468 15.4878 28.3477 15.6887C28.5486 15.8895 28.5486 16.2152 28.3477 16.4161ZM26.1653 17.8711C26.3662 18.0719 26.6919 18.0719 26.8928 17.8711C27.0936 17.6702 27.0936 17.3445 26.8928 17.1436C26.6919 16.9427 26.3662 16.9427 26.1653 17.1436C25.9644 17.3445 25.9644 17.6702 26.1653 17.8711ZM24.7104 19.326C24.5095 19.1251 24.5095 18.7994 24.7104 18.5985C24.9113 18.3976 25.2369 18.3976 25.4378 18.5985C25.6387 18.7994 25.6387 19.1251 25.4378 19.326C25.2369 19.5269 24.9113 19.5269 24.7104 19.326ZM25.8016 16.0524C26.0025 16.2533 26.3281 16.2533 26.529 16.0524C26.7299 15.8515 26.7299 15.5258 26.529 15.3249C26.3281 15.1241 26.0025 15.1241 25.8016 15.3249C25.6007 15.5258 25.6007 15.8515 25.8016 16.0524ZM23.9829 20.7809C24.1838 20.58 24.1838 20.2543 23.9829 20.0534C23.782 19.8526 23.4563 19.8526 23.2554 20.0534C23.0546 20.2543 23.0546 20.58 23.2554 20.7809C23.4563 20.9818 23.782 20.9818 23.9829 20.7809ZM22.8917 18.9622C23.0926 19.1631 23.4183 19.1631 23.6192 18.9622C23.8201 18.7614 23.8201 18.4357 23.6192 18.2348C23.4183 18.0339 23.0926 18.0339 22.8917 18.2348C22.6908 18.4357 22.6908 18.7614 22.8917 18.9622ZM19.2544 14.5975C19.0535 14.7984 18.7278 14.7984 18.5269 14.5975C18.3261 14.3966 18.3261 14.0709 18.5269 13.87C18.7278 13.6691 19.0535 13.6691 19.2544 13.87C19.4553 14.0709 19.4553 14.3966 19.2544 14.5975ZM25.0741 20.4172C24.8732 20.6181 24.8732 20.9438 25.0741 21.1446C25.275 21.3455 25.6007 21.3455 25.8016 21.1446C26.0024 20.9438 26.0024 20.6181 25.8016 20.4172C25.6007 20.2163 25.275 20.2163 25.0741 20.4172ZM19.6181 20.0534C19.4173 19.8526 19.4173 19.5269 19.6181 19.326C19.819 19.1251 20.1447 19.1251 20.3456 19.326C20.5465 19.5269 20.5465 19.8526 20.3456 20.0534C20.1447 20.2543 19.819 20.2543 19.6181 20.0534ZM21.4368 20.4172C21.6377 20.6181 21.9634 20.6181 22.1643 20.4172C22.3651 20.2163 22.3651 19.8906 22.1643 19.6897C21.9634 19.4888 21.6377 19.4888 21.4368 19.6897C21.2359 19.8906 21.2359 20.2163 21.4368 20.4172ZM19.9819 18.2348C19.781 18.4357 19.4553 18.4357 19.2544 18.2348C19.0535 18.0339 19.0535 17.7082 19.2544 17.5073C19.4553 17.3064 19.781 17.3064 19.9819 17.5073C20.1828 17.7082 20.1828 18.0339 19.9819 18.2348Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$padel = function (classes) {
    return $author$project$IconSvg$padel_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$soccer_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M20 8C13.373 8 8 13.3723 8 20C8 26.627 13.373 32 20 32C26.627 32 32 26.627 32 20C32 13.3723 26.627 8 20 8ZM28.6168 14.0165L25.6415 16.0077L22.5545 13.9483L22.736 9.8735C25.151 10.5275 27.2232 12.0155 28.6168 14.0165ZM9.5 20C9.5 18.2067 9.95375 16.5185 10.7495 15.041L13.061 14.0712L17.2887 16.6835L17.069 20.0907L12.845 22.9528L9.53825 20.747C9.52025 20.4995 9.5 20.252 9.5 20ZM13.3025 24.0928L17.3915 21.3207L20.7432 23.555L20.5468 28.2185L17.2542 30.1235C15.6777 29.6952 14.2505 28.9115 13.0603 27.8592L13.3025 24.0928ZM21.5465 9.62675L21.3575 13.8927L17.8558 15.6245L13.8717 13.1638L14.105 11.3165C15.7873 10.1712 17.816 9.5 20 9.5C20.5265 9.5 21.0402 9.55175 21.5465 9.62675ZM24.1752 29.6292L21.7475 28.2162L21.941 23.6315L25.4263 21.8015L28.0422 23.6442L28.3978 26.2767C27.3088 27.7295 25.8597 28.8958 24.1752 29.6292ZM30.2142 22.394L28.7623 22.6827L26.0413 20.7657L26.048 20.6458L26.2828 17.0225L29.2498 15.0365C30.0462 16.5155 30.5 18.2052 30.5 20C30.5 20.825 30.395 21.6237 30.2142 22.394Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$soccer = function (classes) {
    return $author$project$IconSvg$soccer_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$squash_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M28.3195 22.1354C30.4569 19.9981 34.3142 13.881 30.427 9.99374C26.5397 6.10651 20.4213 9.96247 18.2839 12.0998C13.6529 16.7308 15.1119 21.0354 15.1119 21.0354C14.8902 22.0257 14.3172 23.2407 13.8478 24.1407C13.5564 24.705 13.2276 25.2501 12.8642 25.7717C12.8162 25.7933 12.7727 25.8221 12.734 25.8586L8.21931 30.0464C8.17826 30.0875 8.14661 30.1351 8.12456 30.1882C8.11491 30.212 8.10673 30.2372 8.1013 30.2624C8.09443 30.2931 8.09095 30.3244 8.09134 30.3554C8.09147 30.4126 8.1026 30.4696 8.12408 30.5231C8.14626 30.5759 8.17879 30.6237 8.21936 30.6643L9.75599 32.1995C9.79669 32.2402 9.8447 32.2729 9.89766 32.2953C9.91501 32.3029 9.93336 32.3087 9.95197 32.3134C9.98872 32.3237 10.027 32.3286 10.0651 32.3291C10.1223 32.3293 10.1792 32.318 10.2328 32.2951C10.2858 32.2729 10.3339 32.2403 10.3739 32.1996L14.5645 27.6904C14.6003 27.6524 14.6298 27.6082 14.6507 27.5609C15.1726 27.1978 15.7176 26.869 16.2824 26.5766C17.1824 26.1087 18.3623 25.502 19.3526 25.2802C19.3526 25.2802 23.6886 26.7664 28.3195 22.1354ZM15.9918 22.8712C16.1996 23.1695 16.4331 23.4489 16.6901 23.7059C16.9474 23.9632 17.2273 24.1972 17.5264 24.4045C17.1541 24.54 16.6891 24.8051 16.2638 25.0475C16.0505 25.1691 15.8472 25.2851 15.6705 25.3761C15.1526 25.6444 14.6507 25.9412 14.1668 26.2658C14.4914 25.7819 14.7882 25.2801 15.0565 24.7621C15.123 24.6331 15.2008 24.4876 15.2834 24.3332C15.5386 23.856 15.8392 23.2938 15.9918 22.8712ZM16.227 18.7617C16.2062 19.1291 16.2162 19.4931 16.2569 19.8498L16.2524 19.8501L16.3603 19.958L17.3986 18.928L16.7306 18.2601L16.227 18.7617ZM16.3764 20.5888L16.3734 20.5858L16.3757 20.5857L16.3764 20.5888ZM16.3764 20.5888C16.4522 20.9071 16.5572 21.2138 16.6903 21.5053L16.9957 21.2081L16.3764 20.5888ZM17.9418 22.1518L17.2573 21.4673L16.8692 21.8554C17.0321 22.1417 17.225 22.4073 17.4452 22.6484L17.9418 22.1518ZM18.8919 23.1019L18.2073 22.4173L18.1961 22.4182L17.6995 22.9147C17.9424 23.1382 18.2109 23.3332 18.501 23.4968L18.8919 23.1019ZM19.1626 23.3726L19.1574 23.3674L19.1638 23.3714L19.1626 23.3726ZM19.1626 23.3726L18.86 23.6751C19.1523 23.809 19.4601 23.9142 19.7797 23.9897L19.1626 23.3726ZM20.3947 23.9949L20.5088 24.1089C20.8684 24.1453 21.235 24.1507 21.6047 24.1249L22.1063 23.6213L21.4361 22.9535L20.3947 23.9949ZM19.4727 23.0583L20.127 23.7295L20.1321 23.7202L21.1757 22.6787L20.5057 22.0087L19.4727 23.0583ZM18.5092 22.1093L19.1937 22.7938L20.235 21.7525L19.5505 21.0679L18.5092 22.1093ZM17.5636 21.1589L18.2481 21.8434L19.2895 20.8021L18.6049 20.1175L17.5636 21.1589ZM16.628 20.2234L17.2981 20.8934L18.3394 19.852L17.6694 19.182L16.628 20.2234ZM16.4682 17.9832L16.348 17.8606L16.3391 17.8613C16.3207 17.9281 16.3091 17.9936 16.3042 18.0579L16.297 18.1543L16.4682 17.9832ZM22.4964 24.009L22.3741 23.8866L22.3747 23.8777L22.2034 24.0511L22.2998 24.0438C22.3659 24.0344 22.4315 24.0228 22.4964 24.009ZM22.6826 23.5781L23.0021 23.8975C23.3488 23.8096 23.6929 23.7004 24.0322 23.5706L24.394 23.2068L23.7262 22.5366L22.6826 23.5781ZM21.7491 22.6446L22.4171 23.3126L22.4162 23.3238L23.4576 22.2824L22.7897 21.6145L21.7491 22.6446ZM20.8134 21.7113L21.4834 22.3814L22.525 21.3378L21.8548 20.67L20.8134 21.7113ZM19.868 20.7587L20.5479 21.4458L20.5526 21.4432L21.5939 20.4019L20.9094 19.7174L19.868 20.7587ZM18.9135 19.809L19.598 20.4935L20.6394 19.4522L19.9548 18.7676L18.9135 19.809ZM17.9779 18.8735L18.648 19.5435L19.6893 18.5021L19.0193 17.8321L17.9779 18.8735ZM17.0445 17.94L17.7124 18.6079L18.7538 17.5666L18.086 16.8964L17.0445 17.94ZM16.4595 17.355L16.7791 17.6722L17.8201 16.6354L17.1503 15.9631L16.7863 16.3271C16.6562 16.6656 16.5471 17.009 16.4595 17.355ZM24.0347 22.228L24.7025 22.8982L25.7439 21.8569L25.0761 21.1867L24.0347 22.228ZM23.0992 21.2925L23.7692 21.9625L24.8128 20.921L24.1428 20.251L23.0992 21.2925ZM22.1635 20.3592L22.8337 21.027L23.875 19.9856L23.2049 19.3178L22.1635 20.3592ZM21.2134 19.4091L21.898 20.0937L22.9393 19.0523L22.2548 18.3678L21.2134 19.4091ZM20.2634 18.4591L20.9479 19.1436L21.9893 18.1023L21.3047 17.4177L20.2634 18.4591ZM19.9937 18.1894L19.9979 18.1936L19.9889 18.1942L19.9937 18.1894ZM19.3301 17.5234L19.9937 18.1894L21.0303 17.1529L20.3714 16.482L19.3301 17.5234ZM18.3965 16.5922L19.0623 17.258L19.0642 17.2624L20.1078 16.2208L19.4378 15.5508L18.3965 16.5922ZM17.4588 15.6546L18.129 16.3223L19.1637 15.2815L18.5002 14.6132L17.4588 15.6546ZM18.2348 14.3455L17.9797 14.0903C17.6951 14.5005 17.4395 14.9274 17.215 15.3674L18.2348 14.3455ZM26.2645 22.3775L26.0094 22.1224L24.9897 23.142C25.4287 22.9172 25.8549 22.6616 26.2645 22.3775ZM26.3179 21.8138L26.6229 22.1188C27.016 21.8231 27.3911 21.5021 27.7451 21.1583L27.3593 20.7725L26.3179 21.8138ZM25.3824 20.8783L26.0524 21.5483L27.094 20.5047L26.4238 19.8369L25.3824 20.8783ZM24.4491 19.9426L25.1191 20.6126L26.16 19.578L25.4905 18.9012L24.4491 19.9426ZM23.5157 19.0091L24.1858 19.6769L25.2272 18.6356L24.5594 17.9654L23.5157 19.0091ZM22.563 18.0637L23.2503 18.7414L23.2477 18.746L24.2913 17.7045L23.6068 17.02L22.563 18.0637ZM21.6133 17.1092L22.298 17.7915L23.3416 16.75L22.6571 16.0654L21.6133 17.1092ZM20.68 16.1735L21.3479 16.8414L22.3915 15.7999L21.7213 15.1321L20.68 16.1735ZM19.7445 15.238L20.4145 15.908L21.4558 14.8666L20.7858 14.1966L19.7445 15.238ZM18.8089 14.3024L19.4789 14.9724L20.5203 13.9311L19.8503 13.2611L18.8089 14.3024ZM18.2385 13.732L18.5434 14.0369L19.5848 12.9956L19.1989 12.6097C18.8551 12.9638 18.5341 13.3389 18.2385 13.732ZM26.8516 9.45841L26.7438 9.35054C26.3838 9.31665 26.0171 9.31356 25.6474 9.3413L25.146 9.84269L25.8143 10.5061L26.8516 9.45841ZM27.7912 10.4003L27.1234 9.73015L26.082 10.7715L26.7498 11.4417L27.7912 10.4003ZM28.7412 11.3504L28.0567 10.6658L27.0129 11.7096L27.6999 12.3917L28.7412 11.3504ZM29.6913 12.3004L29.0067 11.6159L27.9654 12.6572L28.6499 13.3418L29.6913 12.3004ZM30.627 13.2337L29.9568 12.566L28.9154 13.6073L29.5856 14.2751L30.627 13.2337ZM31.0066 13.6133L30.8925 13.4992L29.8534 14.5404L30.5234 15.2104L31.0248 14.709C31.0485 14.3395 31.0424 13.9731 31.0066 13.6133ZM30.8756 12.8653L30.8816 12.8712L30.8771 12.8716C30.8766 12.8695 30.8761 12.8674 30.8756 12.8653ZM30.2593 12.2489L30.8756 12.8653C30.8005 12.5492 30.6956 12.2451 30.5622 11.9564L30.2593 12.2489ZM29.3148 11.3141L30 11.9896L29.9995 11.9964L30.3874 11.6105C30.2245 11.3242 30.0316 11.0586 29.8114 10.8175L29.3148 11.3141ZM28.3652 10.3573L29.0499 11.0396L29.0575 11.0279L29.5531 10.5448C29.3099 10.3243 29.042 10.1316 28.7533 9.9692L28.3652 10.3573ZM27.4776 9.46723L28.0916 10.0812L28.3929 9.77993C28.1017 9.64726 27.7955 9.54263 27.4776 9.46723ZM24.5719 9.88572L24.2528 9.56178C23.9058 9.65215 23.5615 9.7636 23.2221 9.89547L22.8604 10.2593L23.5306 10.9271L24.5719 9.88572ZM25.5057 10.8147L24.8379 10.1445L23.7964 11.1881L24.4644 11.856L25.5057 10.8147ZM26.4411 11.7525L25.7712 11.0802L24.7299 12.1216L25.3997 12.7938L26.4411 11.7525ZM27.3913 12.7003L26.7068 12.0157L25.6654 13.0571L26.35 13.7416L27.3913 12.7003ZM27.6579 12.9668L27.6568 12.9658L27.6591 12.9656L27.6579 12.9668ZM28.3414 13.6503L27.6579 12.9668L26.6177 14.007L27.3 14.6917L28.3414 13.6503ZM29.2771 14.5836L28.6069 13.9158L28.6066 13.9203L27.5652 14.9617L28.2352 15.6317L29.2771 14.5836ZM30.2126 15.5192L29.5424 14.8514L28.5011 15.8927L29.169 16.5607L30.2126 15.5192ZM30.795 16.1088L30.4781 15.7847L30.4778 15.7892L29.4342 16.8307L30.1042 17.5007L30.4658 17.1391C30.5972 16.7999 30.7071 16.4557 30.795 16.1088ZM30.7867 15.4761L30.9068 15.5987L30.9158 15.598C30.9409 15.5315 30.9457 15.4664 30.9504 15.4036L30.9578 15.305L30.7867 15.4761ZM24.8901 9.56755L24.8922 9.5696L24.8829 9.57476L24.8901 9.56755ZM24.7696 9.44946L24.8901 9.56755L25.054 9.40361L24.9554 9.41101L24.7696 9.44946ZM23.2223 11.2311L22.5523 10.5611L21.511 11.6025L22.1787 12.2726L23.2223 11.2311ZM24.1558 12.1646L23.4879 11.4966L23.4834 11.497L22.4398 12.5385L23.11 13.2063L24.1558 12.1646ZM25.0913 13.1001L24.4213 12.4301L23.38 13.4715L24.05 14.1415L25.0913 13.1001ZM26.0414 14.0502L25.3569 13.3656L24.3155 14.407L25.0001 15.0915L26.0414 14.0502ZM26.9915 15.0002L26.3069 14.3157L25.2656 15.357L25.9501 16.0416L26.9915 15.0002ZM27.9275 15.929L27.2575 15.259L26.2224 16.3066L26.8839 16.9706L27.9275 15.929ZM28.856 16.8696L28.193 16.1946L28.188 16.2016L27.1467 17.243L27.8146 17.9109L28.856 16.8696ZM29.7965 17.798L29.1265 17.128L29.1267 17.1258L28.0889 18.178L28.7552 18.8394L29.7965 17.798ZM20.9464 11.6381L20.6414 11.3332L20.6318 11.3428C20.2376 11.6379 19.8617 11.959 19.5073 12.3034L19.8931 12.6893L20.9464 11.6381ZM21.8671 12.5926L21.1993 11.9224L20.1611 12.9524L20.8288 13.6225L21.8671 12.5926ZM22.8028 13.5259L22.1326 12.8581L22.1359 12.8445L21.0945 13.8858L21.7645 14.5558L22.8028 13.5259ZM23.7365 14.4571L23.0663 13.7893L22.0299 14.8236L22.6951 15.4984L23.7365 14.4571ZM24.6865 15.4071L24.002 14.7226L22.9606 15.7639L23.6452 16.4485L24.6865 15.4071ZM25.6366 16.3572L24.952 15.6727L23.9107 16.714L24.5952 17.3985L25.6366 16.3572ZM26.5699 17.2929L25.9062 16.6269L24.8649 17.6682L25.5285 18.3342L26.5699 17.2929ZM27.5054 18.2284L26.8354 17.5584L26.8404 17.5513L25.799 18.5927L26.469 19.2627L27.5054 18.2284ZM28.4411 19.1617L27.773 18.496L27.7754 18.4936L27.7709 18.4939L27.773 18.496L26.7341 19.535L27.3998 20.2031L28.4411 19.1617ZM29.0116 19.7322L28.7066 19.4272L27.6653 20.4686L28.0509 20.8567C28.3948 20.5018 28.7159 20.126 29.0116 19.7322ZM29.2682 19.3838L29.2695 19.385L29.2672 19.3852L29.2682 19.3838ZM29.0143 19.1299L29.2682 19.3838C29.5536 18.9763 29.8088 18.5512 30.0316 18.1127L29.0143 19.1299ZM20.9881 11.082L21.2432 11.3371L22.2606 10.3176C21.822 10.5415 21.3965 10.7971 20.9881 11.082Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$squash = function (classes) {
    return $author$project$IconSvg$squash_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$tabletennis_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M12.7 16.1401C12.8462 15.0902 13.2302 14.0468 13.868 13.0831L14.4919 12.1403C16.4636 9.16097 20.5488 8.19919 23.6079 10.005L24.5205 10.5437C27.575 12.3469 28.8105 16.4417 27.2699 19.6836L26.7834 20.7074C26.286 21.7541 25.5939 22.6156 24.7839 23.2736L12.7 16.1401ZM12.636 17.3598C12.7153 19.6864 13.9441 21.9042 16.1432 23.2024L17.0748 23.7524C19.2709 25.0488 21.7645 25.0285 23.7758 23.9359L12.636 17.3598ZM15.7682 30.5287C15.5029 31.0652 14.8288 31.2285 14.3146 30.925L11.5476 29.2915C11.0255 28.9833 10.8363 28.31 11.1579 27.8071L14.1797 23.0819C11.2958 20.4164 10.6813 16.0268 12.9441 12.5413L13.5513 11.6061C15.8361 8.08659 20.5677 6.95289 24.1309 9.05634L25.0625 9.60631C28.6308 11.7128 30.0271 16.4748 28.1927 20.2494L27.7042 21.2547C25.8896 24.9884 21.8876 26.6409 18.1981 25.4438L15.7682 30.5287ZM15.0177 23.761C13.6909 25.8393 12.0855 28.3516 12.0801 28.3485L14.8471 29.9819C14.8395 29.9774 16.1316 27.277 17.2008 25.0458C16.9768 24.939 16.7549 24.821 16.5356 24.6915L15.6174 24.1495C15.41 24.027 15.2101 23.8974 15.0177 23.761ZM26.0056 30.9107C26.5938 29.869 26.2448 28.537 25.226 27.9356C24.2072 27.3341 22.9045 27.691 22.3163 28.7327C21.7281 29.7744 22.0771 31.1064 23.0959 31.7078C24.1147 32.3093 25.4174 31.9524 26.0056 30.9107ZM23.2386 29.2772C23.5327 28.7564 24.1841 28.5779 24.6935 28.8786C25.2028 29.1793 25.3774 29.8453 25.0833 30.3662C24.7892 30.887 24.1378 31.0655 23.6284 30.7648C23.119 30.4641 22.9445 29.7981 23.2386 29.2772Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$tabletennis = function (classes) {
    return $author$project$IconSvg$tabletennis_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$tennis_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M30.1681 9.83167C28.7774 8.44104 26.8556 7.85315 24.8712 8.03089C22.7677 8.25071 20.807 9.19855 19.3282 10.7106C17.8163 12.1895 16.8685 14.1501 16.6485 16.2535C16.5653 17.1426 16.6481 18.0393 16.8927 18.8981C16.6726 19.881 16.3253 20.8311 15.8595 21.7242C15.5698 22.2848 15.2436 22.8257 14.8829 23.3434C14.8354 23.3646 14.7919 23.3937 14.754 23.4293L8.12704 29.734C8.08676 29.7743 8.05481 29.8221 8.03302 29.8747C8.01122 29.9273 8 29.9837 8 30.0407C8 30.0976 8.01122 30.154 8.03302 30.2066C8.05481 30.2592 8.08676 30.307 8.12704 30.3473L9.65243 31.8707C9.69243 31.9115 9.74015 31.9438 9.7928 31.9659C9.84545 31.988 9.90197 31.9994 9.95907 31.9994C10.0162 31.9994 10.0727 31.988 10.1253 31.9659C10.178 31.9438 10.2257 31.9115 10.2657 31.8707L16.5704 25.2477C16.6061 25.2098 16.6351 25.1663 16.6563 25.1188C17.1743 24.7584 17.7151 24.4322 18.2755 24.1422C19.1689 23.6776 20.1189 23.3309 21.1017 23.111C21.9607 23.3542 22.8574 23.4357 23.7462 23.3512C25.8499 23.1307 27.8105 22.1822 29.2892 20.6696C30.8008 19.1912 31.7486 17.2314 31.9688 15.1285C32.1466 13.1442 31.5587 11.2223 30.1681 9.83167ZM18.0587 17.9391C17.9996 17.624 17.9669 17.3045 17.961 16.984L18.3692 16.5778L18.9981 17.2067L18.1563 18.0407L18.0548 17.9391H18.0587ZM18.2091 18.5914L18.795 19.1774L18.547 19.4176C18.4108 19.1527 18.2984 18.8762 18.211 18.5914H18.2091ZM19.0411 19.4215L19.6856 20.066L19.2833 20.4684C19.0746 20.2428 18.8881 19.9975 18.7267 19.736L19.0411 19.4215ZM19.9356 20.316L20.5802 20.9606L20.2638 21.2809C19.9989 21.1185 19.751 20.93 19.5235 20.7184L19.9259 20.316H19.9356ZM20.8302 21.2106L21.4161 21.7965C21.1312 21.7095 20.8547 21.597 20.5899 21.4606L20.836 21.2145L20.8302 21.2106ZM22.0626 21.9489L21.9552 21.8414L22.7989 20.9977L23.4298 21.6266L23.0235 22.0348C22.7014 22.0331 22.3799 22.0043 22.0626 21.9489ZM21.7032 21.5914L21.086 20.9606L21.922 20.109L22.5528 20.7399L21.7071 21.5836L21.7032 21.5914ZM20.8243 20.7106L20.1798 20.066L21.0235 19.2223L21.6681 19.8668L20.8243 20.7106ZM19.9337 19.816L19.2892 19.1715L20.1329 18.3278L20.7774 18.9723L19.9337 19.816ZM19.0392 18.9215L18.4083 18.2907L19.252 17.4469L19.8829 18.0778L19.0392 18.9215ZM18.0079 16.2028L18.1212 16.318L17.9825 16.4567V16.3727C17.9825 16.3167 17.9884 16.2601 18.0001 16.2028H18.0079ZM23.6817 21.8766L23.797 21.9918C23.741 21.9996 23.6843 22.0055 23.627 22.0094H23.5431L23.6817 21.8688V21.8766ZM24.2325 21.9274L23.9317 21.6266L24.7774 20.7828L25.4063 21.4137L25.1134 21.7086C24.8247 21.8001 24.5305 21.8732 24.2325 21.9274ZM23.6817 21.3766L23.0528 20.7477L23.8966 19.9137L24.5255 20.5426L23.6817 21.3864V21.3766ZM22.8028 20.4996L22.172 19.8688L23.0157 19.025L23.6466 19.6539L22.8028 20.4996ZM21.922 19.6188L21.2813 18.9723L22.1251 18.1285L22.7696 18.7731L21.9259 19.6168L21.922 19.6188ZM21.0274 18.7223L20.3829 18.0778L21.2267 17.234L21.8712 17.8785L21.0274 18.7223ZM20.1329 17.8278L19.502 17.1969L20.3458 16.3532L20.9767 16.984L20.1329 17.8278ZM19.252 16.9469L18.6231 16.318L19.4669 15.4723L20.0958 16.1032L19.252 16.9469ZM18.3731 16.066L18.0724 15.7672C18.1263 15.4699 18.1994 15.1763 18.2911 14.8883L18.586 14.5934L19.2169 15.2262L18.3731 16.066ZM25.6563 21.1637L25.0274 20.5328L25.8712 19.6891L26.5001 20.32L25.6563 21.1637ZM24.7774 20.2828L24.1466 19.652L24.9923 18.8082L25.6231 19.4391L24.7774 20.2828ZM23.8966 19.402L23.2657 18.7731L24.1095 17.9293L24.7403 18.5582L23.8966 19.402ZM23.0157 18.5231L22.3712 17.8785L23.2149 17.0348L23.8595 17.6793L23.0157 18.5231ZM22.1212 17.6285L21.4767 16.984L22.3204 16.1403L22.9649 16.7848L22.1212 17.6285ZM21.2267 16.734L20.5977 16.1032L21.4415 15.2594L22.0626 15.8903L21.2188 16.734H21.2267ZM20.3458 15.8532L19.7188 15.2262L20.5626 14.3824L21.1934 15.0133L20.3477 15.8571L20.3458 15.8532ZM19.4669 14.9723L18.836 14.3434L19.6798 13.4996L20.3048 14.1285L19.4669 14.9723ZM19.1895 13.0074L19.4298 13.2477L18.6036 14.0758C18.7713 13.7052 18.9672 13.3481 19.1895 13.0074ZM26.7501 20.5699L26.9903 20.8102C26.6501 21.0321 26.2937 21.228 25.9239 21.3961L26.7501 20.5699ZM27.2872 20.6071L27.0001 20.32L27.8438 19.4762L28.2071 19.8395C27.9196 20.1174 27.6121 20.3739 27.2872 20.6071ZM26.7501 20.0699L26.1192 19.4391L26.963 18.5953L27.5938 19.2242L26.7501 20.0699ZM25.8712 19.1891L25.2403 18.5582L26.0841 17.7145L26.7149 18.3512L25.8712 19.1891ZM24.9923 18.3082L24.3614 17.6793L25.2071 16.8336L25.836 17.4645L24.9923 18.3082ZM24.1114 17.4274L23.4649 16.7887L24.3106 15.943L24.9552 16.5875L24.1095 17.4313L24.1114 17.4274ZM23.2149 16.5328L22.5704 15.8903L23.4161 15.0446L24.0606 15.6891L23.2149 16.5328ZM22.3204 15.6383L21.6915 15.0094L22.5352 14.1657L23.1661 14.7946L22.3204 15.6383ZM21.4415 14.7594L20.8106 14.1285L21.6544 13.2848L22.2852 13.9157L21.4415 14.7594ZM20.5606 13.8785L19.9298 13.2477L20.7735 12.4039L21.4044 13.0348L20.5606 13.8785ZM19.6798 12.9977L19.3927 12.7106C19.6258 12.3857 19.8824 12.0782 20.1602 11.7907L20.5235 12.1539L19.6798 12.9977ZM26.5548 9.43128L26.6563 9.53284L25.8165 10.3824L25.1876 9.75745L25.5938 9.3512C25.9158 9.35118 26.2372 9.37796 26.5548 9.43128ZM26.9122 9.7887L27.5411 10.4196L26.6974 11.2633L26.0684 10.6324L26.9122 9.7887ZM27.7911 10.6696L28.4356 11.3141L27.5919 12.1578L26.9454 11.5153L27.7892 10.6715L27.7911 10.6696ZM28.6856 11.5641L29.3302 12.2086L28.4864 13.0524L27.8419 12.4078L28.6856 11.5641ZM29.5802 12.4586L30.211 13.0875L29.3673 13.9313L28.7364 13.3024L29.5802 12.4586ZM30.461 13.3375L30.5684 13.4449C30.6234 13.7624 30.6528 14.0837 30.6563 14.4059L30.2501 14.8121L29.6192 14.1813L30.461 13.3375ZM30.4102 12.7867L29.8243 12.2008L30.0704 11.9645C30.2071 12.2278 30.3196 12.503 30.4063 12.7867H30.4102ZM29.5802 11.9567L28.9356 11.3199L29.338 10.9176C29.5467 11.1432 29.7331 11.3885 29.8946 11.65L29.5802 11.9625V11.9567ZM28.6856 11.0621L28.0411 10.4196L28.3556 10.1051C28.6191 10.2663 28.8664 10.4527 29.0938 10.6617L28.6915 11.0524L28.6856 11.0621ZM27.7911 10.1676L27.2052 9.58167C27.4886 9.66858 27.7637 9.78034 28.0274 9.91565L27.7833 10.1598L27.7911 10.1676ZM24.3868 9.45276L24.6876 9.75745L23.8438 10.6012L23.213 9.97229L23.5059 9.67737C23.7946 9.58415 24.0888 9.50913 24.3868 9.45276ZM24.9376 10.0016L25.5665 10.6324L24.7227 11.4762L24.0938 10.8473L24.9376 10.0016ZM25.8165 10.8824L26.4474 11.5153L25.6036 12.359L24.9727 11.7262L25.8165 10.8824ZM26.6974 11.7633L27.3419 12.4078L26.4981 13.2516L25.8536 12.6071L26.6974 11.7633ZM27.5919 12.6578L28.2364 13.3024L27.3927 14.1461L26.7501 13.5016L27.5938 12.6578H27.5919ZM28.4864 13.5524L29.1173 14.1813L28.2735 15.0309L27.6427 14.4L28.4864 13.5563V13.5524ZM29.3673 14.4332L29.9981 15.0621L29.1524 15.9059L28.5235 15.277L29.3673 14.4332ZM30.2481 15.3121L30.547 15.6168C30.4928 15.915 30.419 16.2092 30.3263 16.4977L30.0333 16.7907L29.4024 16.1598L30.2481 15.316V15.3121ZM30.6114 15.1774L30.4981 15.0621L30.6368 14.9235V15.0094C30.6368 15.0641 30.6368 15.1207 30.6192 15.1774H30.6114ZM24.9474 9.50159L24.8321 9.38831L24.9923 9.36682H25.0782L24.9395 9.5055L24.9474 9.50159ZM22.963 10.2164L23.5938 10.8473L22.7481 11.691L22.1192 11.0602L22.963 10.2164ZM23.8438 11.0973L24.4727 11.7262L23.6251 12.5699L22.9942 11.941L23.8399 11.0973H23.8438ZM24.7227 11.9762L25.3536 12.6071L24.5099 13.4508L23.879 12.8199L24.7227 11.9762ZM25.6036 12.8571L26.2481 13.5016L25.4044 14.3453L24.7599 13.7008L25.6036 12.8571ZM26.4981 13.7516L27.1427 14.3961L26.2989 15.2399L25.6544 14.5953L26.4981 13.7516ZM27.3927 14.6403L28.0235 15.2711L27.1778 16.1149L26.5548 15.4899L27.3927 14.6403ZM28.2735 15.5211L28.8985 16.1559L28.0548 16.9996L27.4259 16.3707L28.2696 15.527L28.2735 15.5211ZM29.1524 16.4L29.7833 17.0309L28.9395 17.8746L28.3126 17.2516L29.1524 16.3981V16.4ZM21.3399 10.7672L21.627 11.0543L20.7735 11.9059L20.4102 11.5426C20.6981 11.2642 21.0062 11.0077 21.3321 10.775L21.3399 10.7672ZM21.8673 11.3199L22.4962 11.9508L21.6544 12.7848L21.0255 12.1539L21.8673 11.3199ZM22.7462 12.2008L23.377 12.8297L22.5352 13.6637L21.9044 13.0328L22.7481 12.1891L22.7462 12.2008ZM23.6251 13.0778L24.2559 13.7067L23.4122 14.5504L22.7852 13.9157L23.6251 13.0778ZM24.5059 13.9567L25.1505 14.6012L24.3067 15.4449L23.6622 14.8004L24.5059 13.9567ZM25.4005 14.8512L26.045 15.4957L25.2013 16.3395L24.5567 15.695L25.4005 14.8512ZM26.295 15.7457L26.9239 16.3766L26.0802 17.2203L25.4552 16.5934L26.2989 15.7496L26.295 15.7457ZM27.1739 16.6266L27.8048 17.2575L26.9649 18.0953L26.3341 17.4645L27.1778 16.6207L27.1739 16.6266ZM28.0548 17.5075L28.6856 18.1364L27.8419 18.9801L27.2149 18.3512L28.0587 17.5075H28.0548ZM28.9356 18.3864L29.2227 18.6735C28.9896 18.999 28.7331 19.3071 28.4552 19.5953L28.0919 19.2301L28.9356 18.3864ZM29.4259 18.3864L29.1856 18.1461L30.0099 17.3219C29.8434 17.6918 29.6474 18.0478 29.4239 18.3864H29.4259ZM21.8673 10.8102L21.627 10.5699C21.9661 10.3472 22.322 10.1513 22.6915 9.98401L21.8673 10.8102ZM17.7657 20.7203C17.9722 21.0161 18.2042 21.2932 18.4591 21.5485C18.7144 21.804 18.9923 22.036 19.2892 22.2418C18.7343 22.4436 18.1929 22.6804 17.6681 22.9508C17.1544 23.2167 16.6562 23.5114 16.1759 23.8336C16.4981 23.3533 16.7928 22.8551 17.0587 22.3414C17.3292 21.817 17.5654 21.2754 17.7657 20.7203Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$tennis = function (classes) {
    return $author$project$IconSvg$tennis_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Types$Sport$toIcon = function (sport) {
    switch (sport) {
      case 0:
        return $author$project$IconSvg$padel;
      case 1:
        return $author$project$IconSvg$tennis;
      case 2:
        return $author$project$IconSvg$squash;
      case 3:
        return $author$project$IconSvg$soccer;
      case 4:
        return $author$project$IconSvg$basketball;
      case 5:
        return $author$project$IconSvg$others;
      case 6:
        return $author$project$IconSvg$cricket;
      case 7:
        return $author$project$IconSvg$tabletennis;
      default:
        return $author$project$IconSvg$badminton;
    }
  };
  var $author$project$Ui$MatchmakingCards$verticalLine = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray10Back h5 hairLineWidth')]), _List_Nil);
  var $author$project$Ui$MatchmakingCards$bookedMatch = F2(function (_v0, cfg) {
    var classes = _v0.uj;
    var browser = _v0.t_;
    var zone = _v0.DJ;
    var sportName = $author$project$Types$Sport$toString(cfg.dh);
    var sportIcon = $author$project$Types$Sport$toIcon(cfg.dh);
    var playerMock = F2(function (classes1, info) {
      var _v2 = function () {
        if (!info.$) {
          var playerInfo = info.a;
          var gender = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Types$Gender$toString, playerInfo.nM));
          return _Utils_Tuple3($author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
            t_: browser,
            uj: ' circle ',
            wG: playerInfo.wG,
            Dq: 4,
            s5: ' relative block w4 h4 circle noOverflow '
          }), A2($elm$html$Html$h3, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular primary0 ellipsis fullWidth center ')]), _List_fromArray([$elm$html$Html$text(playerInfo.i5)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('notesRegular ')]), _List_Nil));
        } else {
          return _Utils_Tuple3(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w4 h4  circle borderDashed primary40Border borderW125 boxSizingBorder noOverflow gray0Back ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_Nil)])), A2($elm$html$Html$h3, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular primary0 ellipsis fullWidth center ')]), _List_fromArray([$elm$html$Html$text('Available')])), $author$project$ElmFramework$Lib$Util$noOpEl);
        }
      }();
      var playerAvatar = _v2.a;
      var name = _v2.b;
      var level = _v2.c;
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn w6 noOverflow flexAlignCenter '), $elm$html$Html$Attributes$class(classes1)]), _List_fromArray([playerAvatar, name, level]));
    });
    var players = function () {
      var _v1 = cfg.oH;
      if (!_v1.$) {
        var playersInfo = _v1.a;
        return A3($author$project$Ui$MatchmakingCards$section, true, ' spaceBetween flexAlignCenter  ', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flex1  padRight3 spaceBetween padLeft1hq gray80  ')]), A2($elm$core$List$map, playerMock(''), playersInfo.bm)), $author$project$Ui$MatchmakingCards$verticalLine, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flex1  padLeft3 spaceBetween padRight1hq gray80 ')]), A2($elm$core$List$map, playerMock(''), playersInfo.bz))]));
      } else {
        var playerInfo = _v1.a;
        return A3($author$project$Ui$MatchmakingCards$section, true, '  padTop2 padBottom2  ', _List_fromArray([A3($author$project$Ui$MatchmakingCards$playerRow, '', browser, playerInfo)]));
      }
    }();
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' radius5 flexColumn secondary800Back  noOverflow  '), $elm$html$Html$Attributes$class(classes)]), _List_fromArray([A3($author$project$Ui$MatchmakingCards$section, true, ' spaceBetween ', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow noOverflow  ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w2 h2 marRight0h ')]), _List_fromArray([sportIcon('w2 ')])), A2($elm$html$Html$h2, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold primary0 ellipsis marRight0h ')]), _List_fromArray([$elm$html$Html$text(sportName + (' match | ' + cfg.hA))]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray80 heading6Light whiteSpaceNoWrap  ')]), _List_fromArray([$elm$html$Html$text(A2($author$project$Ui$TimeRepresentation$toDayMonth, zone, cfg.Cy.eL) + (', ' + (A2($author$project$Ui$TimeRepresentation$toClockTime, zone, cfg.Cy.eL) + (' - ' + A2($author$project$Ui$TimeRepresentation$toClockTime, zone, cfg.Cy.dY)))))]))])), players, A3($author$project$Ui$MatchmakingCards$section, false, 'spaceBetween relative', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular gray80 flexCenter  minW0 padRight1 ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w2 h2 marRight0h  ')]), _List_fromArray([$author$project$IconSvg$location(' w2 gray80Fill ')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' ellipsis ')]), _List_fromArray([$elm$html$Html$text(cfg.cy)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold gray10Back pad2 padTop1 padBottom1 marTop-1h marBottom-1h marRight-2   h5    flexCenter ')]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(cfg.aO) + 'EAD')]))]))]));
  });
  var $author$project$Ui$CheckBox$checkedStyleLayer = function (config) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread  opacityTransition flexCenter'), $elm$html$Html$Attributes$class(config.mi), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('o0', !config.eh)]))]), _List_fromArray([function () {
      var _v0 = config.wE;
      if (!_v0.$) {
        var icon = _v0.a;
        return icon;
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }()]));
  };
  var $author$project$Ui$CheckBox$uncheckedStyleLayer = function (config) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread  '), $elm$html$Html$Attributes$class(config.sI)]), _List_Nil);
  };
  var $author$project$Ui$CheckBox$check = function (config) {
    return A3($elm$html$Html$node, 'checkBox-el', _List_fromArray([$elm$html$Html$Attributes$class('inlineBlock relative noFontSize pointer'), $elm$html$Html$Attributes$class(config.uj), $author$project$ElmFramework$Lib$Util$onTap(config.Cu)]), _List_fromArray([$author$project$Ui$CheckBox$uncheckedStyleLayer(config), $author$project$Ui$CheckBox$checkedStyleLayer(config), A2($elm$html$Html$input, _List_fromArray([$elm$html$Html$Attributes$type_('checkbox'), $elm$html$Html$Attributes$class(' z1 o0 fullWidth fullHeight pointer'), $elm$html$Html$Attributes$checked(config.eh), $elm$html$Html$Attributes$required(config.xi), $elm$html$Html$Attributes$id(config.od)]), _List_Nil)]));
  };
  var $author$project$IconSvg$checkBold_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M28.2729 11.6206C29.1256 10.7931 30.5079 10.7931 31.3605 11.6206C32.1683 12.4045 32.2108 13.6497 31.4881 14.4822L31.3605 14.617L17.1792 28.3794C16.3714 29.1633 15.0882 29.2046 14.2304 28.5032L14.0916 28.3794L8.63946 23.0884C7.78685 22.2609 7.78685 20.9194 8.63946 20.092C9.44721 19.3081 10.7304 19.2668 11.5882 19.9682L11.7271 20.092L14.8634 23.1356C15.2898 23.5493 15.9809 23.5493 16.4073 23.1356L28.2729 11.6206Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$checkBold = function (classes) {
    return $author$project$IconSvg$checkBold_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$CheckBox$checkBoxStyles = function (colorScheme) {
    switch (colorScheme) {
      case 0:
        return {
          mi: 'secondary0Back',
          ea: 'w2 gray0Fill ',
          sI: 'gray0Back hairLineBorderWidth borderSolid gray10Border '
        };
      case 1:
        return {
          mi: 'backgroundGrey',
          ea: 'w2 gray20Fill ',
          sI: 'backgroundGrey'
        };
      default:
        return {
          mi: 'gradient500Back',
          ea: ' o0 ',
          sI: ' gradient500Back '
        };
    }
  };
  var $author$project$Ui$CheckBox$checkBox = function (config) {
    var styles = $author$project$Ui$CheckBox$checkBoxStyles(config.ux);
    return $author$project$Ui$CheckBox$check({
      mi: styles.mi + ' radius2 ',
      uj: 'w3 h3 radius2 noOverflow ' + (A3($author$project$ElmFramework$Lib$Util$ifElse, '  ', ' noPointerEvents ', !config.ux) + config.uj),
      wE: $elm$core$Maybe$Just(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w2 ')]), _List_fromArray([$author$project$IconSvg$checkBold(styles.ea)]))),
      od: config.od,
      eh: config.eh,
      xi: config.xi,
      Cu: config.Cu,
      sI: styles.sI + ' radius2 '
    });
  };
  var $author$project$IconSvg$directright_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M12.6983 32C11.5055 32 10.3485 31.5348 9.42999 30.6402C7.93896 29.1849 7.58112 27.0379 8.51152 25.1771L10.4439 21.3123C10.8494 20.5012 10.8494 19.5231 10.4439 18.7001L8.51152 14.8234C7.58112 12.9626 7.93896 10.8155 9.42999 9.36029C10.921 7.90505 13.0681 7.58298 14.917 8.5611L28.7417 15.8373C30.2924 16.6484 31.2586 18.2468 31.2586 20.0002C31.2586 21.7537 30.2924 23.3521 28.7417 24.1632L14.917 31.4394C14.2013 31.8211 13.4498 32 12.6983 32ZM12.7102 9.7897C11.8872 9.7897 11.1715 10.1714 10.6824 10.6485C9.9429 11.3642 9.41806 12.6405 10.1099 14.0361L12.0423 17.9009C12.6983 19.2249 12.6983 20.7875 12.0423 22.1115L10.1099 25.9763C9.40613 27.3719 9.9429 28.6482 10.6824 29.3639C11.422 30.0796 12.6983 30.5925 14.082 29.8649L27.9068 22.5887C28.8849 22.0757 29.4694 21.1096 29.4694 20.0122C29.4694 18.9148 28.8849 17.9486 27.9068 17.4357L14.082 10.1356C13.6049 9.88513 13.1397 9.7897 12.7102 9.7897Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$directright = function (classes) {
    return $author$project$IconSvg$directright_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$MatchmakingCards$toTag = F3(function (classes, label, maybeDot) {
    return $author$project$Ui$Tags$tag({
      uj: classes,
      cD: 4,
      av: maybeDot,
      wE: $elm$core$Maybe$Nothing,
      oR: label,
      p_: $elm$core$Maybe$Nothing,
      B3: 0
    });
  });
  var $author$project$Ui$MatchmakingCards$confirmCard = function (cfg) {
    var sportName = $author$project$Types$Sport$toString(cfg.dh);
    var sportIcon = $author$project$Types$Sport$toIcon(cfg.dh);
    var imgbox = function (image) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight2 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
        t_: cfg.t_,
        uj: '',
        wG: image,
        Dq: 9,
        s5: ' relative block w9 h9 radius7 noOverflow '
      })]));
    };
    var addressDetails = F2(function (address, _v2) {
      var distance = _v2.a;
      var dUnit = _v2.b;
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading6Regular flexRow flexAlignCenter whiteSpaceNoWrap  ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('gray80 ellipsis ')]), _List_fromArray([$elm$html$Html$text(address + ' .')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w2 h2 marRight0h ')]), _List_fromArray([$author$project$IconSvg$directright('gray80Fill w2 ')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('gray60 ')]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(distance) + (' ' + dUnit))]))]));
    });
    var locationInfo = function () {
      var _v0 = cfg.iT;
      if (!_v0.$) {
        var distance = _v0.a.m5;
        var locationName = _v0.a.o1;
        var court = _v0.a.mB;
        var address = _v0.a.cy;
        return {
          cz: A2(addressDetails, address, distance),
          wG: imgbox(court.om),
          lh: locationName
        };
      } else {
        var _v1 = _v0.a;
        var distance = _v1.a;
        var dUnit = _v1.b;
        return {
          cz: $author$project$ElmFramework$Lib$Util$noOpEl,
          wG: $author$project$ElmFramework$Lib$Util$noOpEl,
          lh: $elm$core$String$fromInt(distance) + (dUnit + (' ' + 'around you'))
        };
      }
    }();
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' radius5 flexColumn secondary800Back  noOverflow  '), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A3($author$project$Ui$MatchmakingCards$section, true, ' spaceBetween ', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow noOverflow  ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w2 h2 marRight0h ')]), _List_fromArray([sportIcon('w2 ')])), A2($elm$html$Html$h2, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold primary0 ellipsis marRight0h ')]), _List_fromArray([$elm$html$Html$text(sportName + ' match')]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray80 heading6Light whiteSpaceNoWrap  ')]), _List_fromArray([$elm$html$Html$text(A2($author$project$Ui$TimeRepresentation$toDayMonth, cfg.DJ, cfg.Cy.eL) + (', ' + (A2($author$project$Ui$TimeRepresentation$toClockTime, cfg.DJ, cfg.Cy.eL) + (' - ' + A2($author$project$Ui$TimeRepresentation$toClockTime, cfg.DJ, cfg.Cy.dY)))))]))])), A3($author$project$Ui$MatchmakingCards$section, true, '', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop0h padBottom0h flexRow noOverflow ')]), _List_fromArray([locationInfo.wG, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn noOverflow ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold ellipsis ')]), _List_fromArray([$elm$html$Html$text(locationInfo.lh)])), locationInfo.cz, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('whiteSpaceNoWrap scrollTargetX noScrollbar marTop1 ')]), A2($elm$core$List$map, function (a) {
      return a($elm$core$Maybe$Nothing);
    }, A2($elm$core$List$map, $author$project$Ui$MatchmakingCards$toTag(' marRight1 '), cfg.gE)))]))]))])), A3($author$project$Ui$MatchmakingCards$section, false, 'spaceBetween relative', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular ')]), _List_fromArray([$elm$html$Html$text('Level: ' + $elm$core$String$fromFloat(cfg.a_))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold gray10Back pad2 h5 absolute right0 bottom0 flexCenter ')]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(cfg.aO) + 'EAD')]))]))]));
  };
  var $author$project$IconSvg$contactHelp_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M15.5349 31C15.2223 31 14.8986 30.922 14.6084 30.7659C13.9721 30.4315 13.5814 29.7625 13.5814 29.049V27.4659C10.2102 27.1203 8 24.6452 8 21.0998V14.4106C8 10.5754 10.5786 8 14.4186 8H25.5814C29.4214 8 32 10.5754 32 14.4106V21.0998C32 24.935 29.4214 27.5104 25.5814 27.5104H21.373L16.6176 30.6768C16.2939 30.8886 15.9144 31 15.5349 31ZM14.4186 9.66117C11.5386 9.66117 9.67442 11.523 9.67442 14.3994V21.0888C9.67442 23.9652 11.5386 25.8271 14.4186 25.8271C14.8763 25.8271 15.2558 26.2061 15.2558 26.6632V29.0379C15.2558 29.1829 15.3451 29.2497 15.4009 29.2832C15.4567 29.3166 15.5684 29.3501 15.6912 29.272L20.6586 25.972C20.7926 25.8828 20.96 25.8271 21.1275 25.8271H25.5926C28.4726 25.8271 30.3368 23.9652 30.3368 21.0888V14.3994C30.3368 11.523 28.4726 9.66117 25.5926 9.66117H14.4186ZM19.9998 19.6171C19.5422 19.6171 19.1626 19.2381 19.1626 18.781V18.5469C19.1626 17.269 20.0891 16.6333 20.4557 16.3817L20.4686 16.3729C20.8817 16.0941 21.0156 15.9046 21.0156 15.6148C21.0156 15.0573 20.558 14.6002 19.9998 14.6002C19.4417 14.6002 18.984 15.0573 18.984 15.6148C18.984 16.0719 18.6045 16.4509 18.1468 16.4509C17.6892 16.4509 17.3096 16.0719 17.3096 15.6148C17.3096 14.132 18.5152 12.9278 19.9998 12.9278C21.4845 12.9278 22.69 14.132 22.69 15.6148C22.69 16.8857 21.7524 17.5212 21.4063 17.7553C20.971 18.0452 20.837 18.2347 20.837 18.5469V18.781C20.837 19.2492 20.4575 19.6171 19.9998 19.6171ZM19.1628 21.557C19.1628 22.0141 19.5312 22.3932 20 22.3932C20.4688 22.3932 20.8372 22.0141 20.8372 21.557C20.8372 21.0999 20.4577 20.7209 20 20.7209C19.5423 20.7209 19.1628 21.0999 19.1628 21.557Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$contactHelp = function (classes) {
    return $author$project$IconSvg$contactHelp_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$arrowdown_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M20 25.9031C19.0309 25.9031 18.0617 25.5293 17.3279 24.7955L8.30112 15.7687C7.89963 15.3672 7.89963 14.7026 8.30112 14.3011C8.70262 13.8996 9.36718 13.8996 9.76868 14.3011L18.7955 23.3279C19.4601 23.9925 20.5399 23.9925 21.2045 23.3279L30.2313 14.3011C30.6328 13.8996 31.2974 13.8996 31.6989 14.3011C32.1004 14.7026 32.1004 15.3672 31.6989 15.7687L22.6721 24.7955C21.9383 25.5293 20.9691 25.9031 20 25.9031Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$arrowdown = function (classes) {
    return $author$project$IconSvg$arrowdown_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$CourtCard$courtCard = function (cfg) {
    var tags = function (label) {
      return $author$project$Ui$Tags$tag({
        uj: 'marRight1 marBottom1 ',
        cD: 4,
        av: $elm$core$Maybe$Nothing,
        wE: $elm$core$Maybe$Nothing,
        oR: label,
        p_: $elm$core$Maybe$Nothing,
        B3: 0
      });
    };
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('secondary800Back pad2 radius5 flexRow  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight2 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
      t_: cfg.t_,
      uj: ' ',
      wG: cfg.mC,
      Dq: 17,
      s5: ' relative block w17 h11 radius7 noOverflow marBottom2  '
    }), $author$project$Ui$Button$button({
      bh: ' radius7 noOverflow ',
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray0Back w17 h6 pad1h padLeft2 flexRow flexAlignCenter spaceBetween heading5Bold primary0 ')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text('17:00 pm')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w3 h3')]), _List_fromArray([$author$project$IconSvg$arrowdown('w3 secondary100Fill ')]))])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.zI)
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn spaceBetween flex1 noOverflow ')]), _List_fromArray([A2($elm$html$Html$h3, _List_fromArray([$elm$html$Html$Attributes$class('heading3Bold primary0 ellipsis  ')]), _List_fromArray([$elm$html$Html$text(cfg.lh)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop1 marBottom1 whiteSpaceNoWrap scrollTargetX noScrollbar ')]), A2($elm$core$List$map, tags, cfg.gE)), $author$project$Ui$Button$basicButton({
      bh: ' padTop1h padBottom1h heading5Bold   ',
      cD: 0,
      fn: $elm$html$Html$text('Book now'),
      xa: false,
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.yR)
    })]))]));
  };
  var $author$project$IconSvg$calendar_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M14.5814 12.186C14.5814 12.6437 14.9609 13.0233 15.4186 13.0233C15.8763 13.0233 16.2558 12.6437 16.2558 12.186V11.3488H23.5116V12.186C23.5116 12.6437 23.8912 13.0233 24.3488 13.0233C24.8065 13.0233 25.186 12.6437 25.186 12.186V11.3881C27.7585 11.6419 29.0393 13.1297 29.0914 15.9142H10.6761C10.7281 13.1297 12.009 11.6419 14.5814 11.3881V12.186ZM14.5814 9.70928C11.0247 10.0142 9 12.3064 9 16.093V25.5814C9 29.6558 11.3442 32 15.4186 32H24.3488C28.4233 32 30.7674 29.6558 30.7674 25.5814V16.093C30.7674 12.3064 28.7427 10.0142 25.186 9.70928V8.83721C25.186 8.37953 24.8065 8 24.3488 8C23.8912 8 23.5116 8.37953 23.5116 8.83721V9.67442H16.2558V8.83721C16.2558 8.37953 15.8763 8 15.4186 8C14.9609 8 14.5814 8.37953 14.5814 8.83721V9.70928ZM10.6744 17.5887V25.5814C10.6744 28.774 12.226 30.3256 15.4186 30.3256H24.3488C27.5414 30.3256 29.093 28.774 29.093 25.5814V17.5887H10.6744ZM15.9767 22.7905C15.8316 22.7905 15.6865 22.757 15.5526 22.7012C15.4074 22.6454 15.2958 22.5672 15.1842 22.4668C14.9833 22.2547 14.8605 21.9756 14.8605 21.6742C14.8605 21.5291 14.894 21.384 14.9498 21.25C15.0056 21.1161 15.0837 20.9933 15.1842 20.8817C15.2958 20.7812 15.4074 20.703 15.5526 20.6472C15.9544 20.4798 16.4567 20.5691 16.7693 20.8817C16.9702 21.0938 17.093 21.384 17.093 21.6742C17.093 21.7412 17.0819 21.8194 17.0707 21.8975C17.0595 21.9645 17.0372 22.0314 17.0037 22.0984C16.9814 22.1654 16.9479 22.2324 16.9033 22.2993C16.8809 22.3365 16.8487 22.3737 16.8164 22.4109C16.8003 22.4296 16.7842 22.4482 16.7693 22.4668C16.5572 22.6677 16.267 22.7905 15.9767 22.7905ZM19.4595 22.7013C19.5935 22.7571 19.7386 22.7906 19.8837 22.7906C20.174 22.7906 20.4642 22.6678 20.6763 22.4668C20.6912 22.4482 20.7073 22.4296 20.7234 22.411C20.7557 22.3738 20.7879 22.3366 20.8102 22.2994C20.8549 22.2324 20.8884 22.1654 20.9107 22.0985C20.9442 22.0315 20.9665 21.9645 20.9777 21.8975C20.9888 21.8194 21 21.7413 21 21.6743C21 21.384 20.8772 21.0938 20.6763 20.8817C20.3637 20.5692 19.8614 20.4687 19.4595 20.6473C19.3144 20.7031 19.2028 20.7813 19.0912 20.8817C18.9907 20.9934 18.9126 21.1161 18.8567 21.2501C18.8009 21.384 18.7674 21.5292 18.7674 21.6743C18.7674 21.9757 18.8902 22.2547 19.0912 22.4668C19.2028 22.5673 19.3144 22.6455 19.4595 22.7013ZM23.7907 22.7906C23.6456 22.7906 23.5005 22.7571 23.3665 22.7013C23.2214 22.6455 23.1098 22.5673 22.9981 22.4668L22.8642 22.2994C22.8195 22.2324 22.786 22.1654 22.7637 22.0985C22.7302 22.0315 22.7079 21.9645 22.6967 21.8975C22.6856 21.8194 22.6744 21.7413 22.6744 21.6743C22.6744 21.384 22.7972 21.0938 22.9981 20.8817C23.1098 20.7813 23.2214 20.7031 23.3665 20.6473C23.7795 20.4687 24.2707 20.5692 24.5833 20.8817C24.7842 21.0938 24.907 21.384 24.907 21.6743C24.907 21.7413 24.8958 21.8194 24.8847 21.8975C24.8735 21.9645 24.8512 22.0315 24.8177 22.0985C24.7953 22.1654 24.7619 22.2324 24.7172 22.2994C24.6949 22.3366 24.6626 22.3738 24.6304 22.411C24.6143 22.4296 24.5981 22.4482 24.5833 22.4668C24.3712 22.6678 24.0809 22.7906 23.7907 22.7906ZM15.5526 26.6086C15.6865 26.6644 15.8316 26.6979 15.9767 26.6979C16.267 26.6979 16.5572 26.5751 16.7693 26.3742C16.9702 26.1621 17.093 25.8718 17.093 25.5816C17.093 25.2914 16.9702 25.0011 16.7693 24.7891C16.3563 24.376 15.5972 24.376 15.1842 24.7891C15.0837 24.8895 15.0056 25.0123 14.9498 25.1574C14.894 25.2914 14.8605 25.4365 14.8605 25.5816C14.8605 25.8718 14.9833 26.1621 15.1842 26.3742C15.2958 26.4746 15.4186 26.5528 15.5526 26.6086ZM19.8837 26.6979C19.5935 26.6979 19.3033 26.5751 19.0912 26.3742C18.8902 26.1621 18.7674 25.8718 18.7674 25.5816C18.7674 25.4365 18.8009 25.2914 18.8567 25.1574C18.9126 25.0123 18.9907 24.8895 19.0912 24.7891C19.5042 24.376 20.2633 24.376 20.6763 24.7891C20.7767 24.8895 20.8549 25.0123 20.9107 25.1574C20.9665 25.2914 21 25.4365 21 25.5816C21 25.8718 20.8772 26.1621 20.6763 26.3742C20.4642 26.5751 20.174 26.6979 19.8837 26.6979ZM22.9981 26.3738C23.2102 26.5748 23.5005 26.6976 23.7907 26.6976C24.0809 26.6976 24.3712 26.5748 24.5833 26.3738C24.7842 26.1618 24.907 25.8715 24.907 25.5813C24.907 25.2911 24.7842 25.0008 24.5833 24.7887C24.5647 24.7739 24.5461 24.7578 24.5275 24.7417L24.5274 24.7416C24.4902 24.7094 24.453 24.6771 24.4158 24.6548C24.3488 24.6101 24.2819 24.5766 24.2149 24.5543C24.1479 24.5208 24.0809 24.4985 24.0028 24.4873C23.6456 24.4092 23.2549 24.532 22.9981 24.7887C22.8977 24.8892 22.8195 25.012 22.7637 25.1571C22.7079 25.2911 22.6744 25.4362 22.6744 25.5813C22.6744 25.7264 22.7079 25.8715 22.7637 26.0055C22.8195 26.1506 22.8977 26.2734 22.9981 26.3738Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$calendar = function (classes) {
    return $author$project$IconSvg$calendar_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$clock_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M8 20C8 26.6195 13.3805 32 20 32C26.6195 32 32 26.6195 32 20C32 13.3805 26.6195 8 20 8C13.3805 8 8 13.3805 8 20ZM9.67442 20C9.67442 14.307 14.307 9.67442 20 9.67442C25.693 9.67442 30.3256 14.307 30.3256 20C30.3256 25.693 25.693 30.3256 20 30.3256C14.307 30.3256 9.67442 25.693 9.67442 20ZM23.7168 24.2639C23.8508 24.3532 23.9959 24.3867 24.141 24.3867C24.4201 24.3867 24.6991 24.2416 24.8666 23.9737C25.101 23.5718 24.9782 23.0583 24.5764 22.8239L21.1159 20.7588C20.7698 20.5579 20.435 19.9662 20.435 19.5644V14.9876C20.435 14.53 20.0554 14.1504 19.5977 14.1504C19.1401 14.1504 18.7605 14.53 18.7605 14.9876V19.5644C18.7605 20.5579 19.3968 21.6853 20.2564 22.1988L23.7168 24.2639Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$clock = function (classes) {
    return $author$project$IconSvg$clock_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $elm$core$String$right = F2(function (n, string) {
    return n < 1 ? '' : A3($elm$core$String$slice, -n, $elm$core$String$length(string), string);
  });
  var $author$project$Ui$TimeRepresentation$toUSFormattedDateWithSlashesYear2Digits = F2(function (zone, posix) {
    return A2($elm$core$String$join, '/', _List_fromArray([A3($elm$core$String$pad, 2, '0', $elm$core$String$fromInt(A2($elm$time$Time$toDay, zone, posix))), A3($elm$core$String$pad, 2, '0', $elm$core$String$fromInt(A2($author$project$ElmFramework$Lib$Util$toMonthAsNumber, zone, posix))), A2($elm$core$String$right, 2, $elm$core$String$fromInt(A2($elm$time$Time$toYear, zone, posix)))]));
  });
  var $author$project$Ui$CourtCard$courtCardCheckout = function (cfg) {
    var tags = function (label) {
      return $author$project$Ui$Tags$tag({
        uj: 'marRight1 marBottom1 ',
        cD: 1,
        av: $elm$core$Maybe$Nothing,
        wE: $elm$core$Maybe$Nothing,
        oR: label,
        p_: $elm$core$Maybe$Nothing,
        B3: 0
      });
    };
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow  '), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight2 flex1 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
      t_: cfg.t_,
      uj: '',
      wG: cfg.mC,
      Dq: 17,
      s5: ' relative block fullWidth square radius7 noOverflow '
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn marTop3 noOverflow h13 relative justifyEnd  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absolute left0 top0 noOverflow fullWidth')]), _List_fromArray([A2($elm$html$Html$h3, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold gray60 ellipsis  ')]), _List_fromArray([$elm$html$Html$text(cfg.lh)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop1 marBottom1  whiteSpaceNoWrap scrollTargetX noScrollbar    ')]), A2($elm$core$List$map, tags, cfg.gE))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('widthMinContent  whiteSpaceNoWrap  ')]), _List_fromArray([$author$project$Ui$Tags$tag({
      uj: 'marRight1 ',
      cD: 0,
      av: $elm$core$Maybe$Nothing,
      wE: $elm$core$Maybe$Just($author$project$IconSvg$calendar),
      oR: A2($author$project$Ui$TimeRepresentation$toUSFormattedDateWithSlashesYear2Digits, cfg.DJ, cfg.x$.eL),
      p_: $elm$core$Maybe$Nothing,
      B3: 1
    }), $author$project$Ui$Tags$tag({
      uj: '',
      cD: 0,
      av: $elm$core$Maybe$Nothing,
      wE: $elm$core$Maybe$Just($author$project$IconSvg$clock),
      oR: A2($author$project$Ui$TimeRepresentation$toClockTime, cfg.DJ, cfg.x$.eL) + (' - ' + A2($author$project$Ui$TimeRepresentation$toClockTime, cfg.DJ, cfg.x$.dY)),
      p_: $elm$core$Maybe$Nothing,
      B3: 1
    })]))]))]));
  };
  var $author$project$Ui$MatchmakingCards$courtSportsCard = function (cfg) {
    var tags = function () {
      var _v2 = cfg.gE;
      if (!_v2.$) {
        var tag = _v2.a;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('whiteSpaceNoWrap scrollTargetX noScrollbar marTop1 ')]), A2($elm$core$List$map, function (a) {
          return a($elm$core$Maybe$Nothing);
        }, A2($elm$core$List$map, $author$project$Ui$MatchmakingCards$toTag(' marRight1 '), tag)));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();
    var sports = function (sport) {
      return _Utils_Tuple2($author$project$Types$Sport$toIcon(sport), $author$project$Types$Sport$toString(sport));
    };
    var sportBox = function (_v1) {
      var sportIcon = _v1.a;
      var sportName = _v1.b;
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter noOverflow marRight2  ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w2 h2 marRight0h ')]), _List_fromArray([sportIcon('w2 ')])), A2($elm$html$Html$h2, _List_fromArray([$elm$html$Html$Attributes$class(' bodyBold primary0 ')]), _List_fromArray([$elm$html$Html$text(sportName)]))]));
    };
    var address = function () {
      var _v0 = cfg.iT.cy;
      if (!_v0.$) {
        var addresS = _v0.a;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading6Regular flexAlignCenter whiteSpaceNoWrap  ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('gray80 ellipsis ')]), _List_fromArray([$elm$html$Html$text(addresS)]))]));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' radius5 flexColumn secondary800Back noOverflow  '), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' borderBottomSolid gray10Border borderBottomW125 flexRow flexAlignCenter padLeft2 padRight2 padTop1 padBottom1 ')]), A2($elm$core$List$map, A2($elm$core$Basics$composeL, sportBox, sports), cfg.r3)), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad2 flexRow noOverflow ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight2 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
      t_: cfg.t_,
      uj: '',
      wG: cfg.iT.om,
      Dq: 9,
      s5: ' relative block w9 h9 radius7 noOverflow '
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn noOverflow ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' bodyBold ellipsis marBottom1  ')]), _List_fromArray([$elm$html$Html$text(cfg.iT.lh)])), address, tags]))]))]));
  };
  var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
  var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
  var $elm$html$Html$Attributes$step = function (n) {
    return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
  };
  var $author$project$ElmFramework$Lib$Ui$Slider$sliderView = function (config) {
    var clampedValue = A2($elm$core$Basics$min, A2($elm$core$Basics$max, config.Q, config.s_), config.ay);
    var ratio = (clampedValue - config.Q) / (config.ay - config.Q);
    var thumbMovementStyle = A3($elm$core$Basics$apL, $elm$core$String$replace('{{verticalCorrection}}'), $elm$core$String$fromFloat(-100 + ratio * 100), A3($elm$core$Basics$apL, $elm$core$String$replace('{{horizontalCorrection}}'), $elm$core$String$fromFloat(ratio * -100), A3($elm$core$Basics$apR, config.b4, A2($author$project$ElmFramework$Lib$Util$ifElse, function ($) {
      return $.cs;
    }, function ($) {
      return $.b0;
    }), {
      b0: 'translateX({{horizontalCorrection}}%)',
      cs: 'translateY({{verticalCorrection}}%)'
    })));
    var thumbWrapperMovementStyle = A3($elm$core$Basics$apL, $elm$core$String$replace('{{verticalMovement}}'), $elm$core$String$fromFloat(100 - ratio * 100), A3($elm$core$Basics$apL, $elm$core$String$replace('{{horizontalMovement}}'), $elm$core$String$fromFloat(ratio * 100), A3($elm$core$Basics$apR, config.b4, A2($author$project$ElmFramework$Lib$Util$ifElse, function ($) {
      return $.cs;
    }, function ($) {
      return $.b0;
    }), {
      b0: 'translateX({{horizontalMovement}}%) translateZ(1px)',
      cs: 'translateY({{verticalMovement}}%) translateZ(1px)'
    })));
    var trackMovementStyle = A3($elm$core$Basics$apR, config.b4, A2($author$project$ElmFramework$Lib$Util$ifElse, A3($author$project$ElmFramework$Lib$Util$ifElse, A2($elm$core$Basics$composeR, function ($) {
      return $.cs;
    }, A2($elm$core$Basics$composeR, A2($elm$core$String$replace, '{{verticalMovement}}', $elm$core$String$fromFloat(ratio * 100)), A2($elm$core$String$replace, '{{verticalCorrection}}', $elm$core$String$fromFloat(ratio * -3 + 1.5)))), A2($elm$core$Basics$composeR, function ($) {
      return $.cs;
    }, A2($elm$core$Basics$composeR, A2($elm$core$String$replace, '{{verticalMovement}}', $elm$core$String$fromFloat(100 - ratio * 100)), A2($elm$core$String$replace, '{{verticalCorrection}}', $elm$core$String$fromFloat(ratio * 3 - 1.5)))), config.aK), A3($author$project$ElmFramework$Lib$Util$ifElse, A2($elm$core$Basics$composeR, function ($) {
      return $.b0;
    }, A2($elm$core$Basics$composeR, A2($elm$core$String$replace, '{{horizontalMovement}}', $elm$core$String$fromFloat(ratio * 100)), A2($elm$core$String$replace, '{{horizontalCorrection}}', $elm$core$String$fromFloat(ratio * -3)))), A2($elm$core$Basics$composeR, function ($) {
      return $.b0;
    }, A2($elm$core$Basics$composeR, A2($elm$core$String$replace, '{{horizontalMovement}}', $elm$core$String$fromFloat(-100 + ratio * 100)), A2($elm$core$String$replace, '{{horizontalCorrection}}', $elm$core$String$fromFloat(3 - ratio * 3)))), config.aK)), {
      b0: 'translateX({{horizontalMovement}}%) translateX({{horizontalCorrection}}px)',
      cs: 'translateY({{verticalMovement}}%) translateY({{verticalCorrection}}px)'
    });
    var _v0 = function () {
      var verticalClasses = {
        oq: 'block fullHeight o0 pointer',
        ah: 'inlineBlock relative fullHeight',
        aj: 'inlineBlock circle',
        ak: 'absoluteSpread noPointerEvents',
        am: 'block w1 fullHeight promoteLayerGpuLayer noOverflow',
        an: 'block fullWidth fullHeight',
        ao: 'absoluteSpread flexCenter noPointerEvents'
      };
      var horizontalClasses = {
        oq: 'block fullWidth o0 pointer',
        ah: 'block relative fullWidth fullHeight',
        aj: ' absoluteSpread inlineBlock circle',
        ak: 'absoluteSpread noPointerEvents',
        am: 'block h1 fullWidth promoteLayerGpuLayer noOverflow',
        an: 'block fullWidth fullHeight',
        ao: 'absoluteSpread flexCenter noPointerEvents'
      };
      return A3($author$project$ElmFramework$Lib$Util$ifElse, verticalClasses, horizontalClasses, config.b4);
    }();
    var sliderClasses = _v0.ah;
    var inputClasses = _v0.oq;
    var trackWrapperClasses = _v0.ao;
    var trackClasses = _v0.am;
    var trackFillClasses = _v0.an;
    var thumbWrapperClasses = _v0.ak;
    var thumbClasses = _v0.aj;
    return A3($elm$html$Html$node, 'slider-element', _List_fromArray([$elm$html$Html$Attributes$class(sliderClasses), $elm$html$Html$Attributes$class(config.ah)]), _List_fromArray([A2($elm$html$Html$input, A2($elm$core$List$cons, $elm$html$Html$Attributes$class(inputClasses), A2($elm$core$List$cons, $elm$html$Html$Attributes$class(config.oq), A2($elm$core$List$cons, $elm$html$Html$Attributes$type_('range'), A2($elm$core$List$cons, $elm$html$Html$Attributes$disabled(config.xa), A2($elm$core$List$cons, $elm$html$Html$Attributes$min($elm$core$String$fromFloat(config.Q)), A2($elm$core$List$cons, $elm$html$Html$Attributes$max($elm$core$String$fromFloat(config.ay)), A2($elm$core$List$cons, $elm$html$Html$Attributes$value($elm$core$String$fromFloat(config.s_)), A2($elm$core$List$cons, $elm$html$Html$Attributes$step($elm$core$String$fromFloat(config.a6)), A2($elm$core$List$cons, $elm$html$Html$Events$onInput(A2($elm$core$Basics$composeL, config.bu, A2($elm$core$Basics$composeL, $elm$core$Maybe$withDefault(config.s_), $elm$core$String$toFloat))), A3($author$project$ElmFramework$Lib$Util$ifElse, _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'orient', 'vertical')]), _List_Nil, config.b4)))))))))), _List_Nil), A3($elm$html$Html$node, 'track-wrapper', _List_fromArray([$elm$html$Html$Attributes$class(trackWrapperClasses), $elm$html$Html$Attributes$class(config.ao)]), _List_fromArray([A3($elm$html$Html$node, 'track-element', _List_fromArray([$elm$html$Html$Attributes$class(trackClasses), $elm$html$Html$Attributes$class(config.am)]), _List_fromArray([A3($elm$html$Html$node, 'fill-element', _List_fromArray([$elm$html$Html$Attributes$class(trackFillClasses), $elm$html$Html$Attributes$class(config.an), A2($elm$html$Html$Attributes$style, 'transform', trackMovementStyle)]), _List_Nil)]))])), A3($elm$html$Html$node, 'thumb-wrapper', _List_fromArray([$elm$html$Html$Attributes$class(thumbWrapperClasses), $elm$html$Html$Attributes$class(config.ak), A2($elm$html$Html$Attributes$style, 'transform', thumbWrapperMovementStyle)]), _List_fromArray([A3($elm$html$Html$node, 'thumb-element', _List_fromArray([$elm$html$Html$Attributes$class(thumbClasses), $elm$html$Html$Attributes$class(config.aj), A2($elm$html$Html$Attributes$style, 'transform', thumbMovementStyle)]), _List_fromArray([config.a7]))]))]));
  };
  var $author$project$ElmFramework$Lib$Ui$Slider$horizontalSlider = function (config) {
    return $author$project$ElmFramework$Lib$Ui$Slider$sliderView({
      oq: config.oq,
      aK: config.aK,
      xa: config.xa,
      b4: false,
      ay: config.ay,
      Q: config.Q,
      bu: config.bu,
      ah: config.ah,
      a6: config.a6,
      aj: config.aj,
      a7: config.a7,
      ak: config.ak,
      am: config.am,
      an: config.an,
      ao: config.ao,
      s_: config.s_
    });
  };
  var $author$project$IconSvg$menuBurgerBold_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M25 10C25 8.89543 25.8954 8 27 8C28.1046 8 29 8.89543 29 10V30C29 31.1046 28.1046 32 27 32C25.8954 32 25 31.1046 25 30V10ZM18 10C18 8.89543 18.8954 8 20 8C21.1046 8 22 8.89543 22 10V30C22 31.1046 21.1046 32 20 32C18.8954 32 18 31.1046 18 30V10ZM11 10C11 8.89543 11.8954 8 13 8C14.1046 8 15 8.89543 15 10L15 30C15 31.1046 14.1046 32 13 32C11.8954 32 11 31.1046 11 30L11 10Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$menuBurgerBold = function (classes) {
    return $author$project$IconSvg$menuBurgerBold_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$DistanceSlider$distanceSlider = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padBottom3'), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular gray80 padLeft1 padRight1 flexRow spaceBetween')]), _List_fromArray([A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text($elm$core$String$fromFloat(cfg.yp))])), A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text($elm$core$String$fromFloat(cfg.x4))]))])), $author$project$ElmFramework$Lib$Ui$Slider$horizontalSlider({
      oq: 'h3',
      aK: true,
      xa: false,
      ay: cfg.x4,
      Q: cfg.yp,
      bu: cfg.bu,
      ah: 'h3',
      a6: 1,
      aj: 'gray0Back w3 h3 flexCenter thumbShadow',
      a7: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w2 relative flexColumn')]), _List_fromArray([$author$project$IconSvg$menuBurgerBold('w2 h2 gray20Fill'), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('absolute top0 centerX  flexcolumn flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('marTop2h block primary0 heading5Bold')]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromFloat(cfg.s_) + 'Km')]))]))])),
      ak: 'flexCenter h3',
      am: 'gradient20Back radius1',
      an: 'gray10Back',
      ao: '',
      s_: cfg.s_
    })]));
  };
  var $author$project$Ui$MatchmakingCards$draftCard = F2(function (_v0, cfg) {
    var classes = _v0.uj;
    var browser = _v0.t_;
    var zone = _v0.DJ;
    var sportName = $author$project$Types$Sport$toString(cfg.dh);
    var sportIcon = $author$project$Types$Sport$toIcon(cfg.dh);
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' radius5 flexColumn secondary800Back noOverflow '), $elm$html$Html$Attributes$class(classes)]), _List_fromArray([A3($author$project$Ui$MatchmakingCards$section, true, ' spaceBetween whiteSpaceNoWrap ', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow noOverflow  ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w2 h2 marRight0h ')]), _List_fromArray([sportIcon('w2 ')])), A2($elm$html$Html$h2, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold primary0 ellipsis marRight0h ')]), _List_fromArray([$elm$html$Html$text(sportName + ' match')]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray80 heading6Light ')]), _List_fromArray([$elm$html$Html$text(A2($author$project$Ui$TimeRepresentation$toDayMonth, zone, cfg.Cy.eL) + (', ' + (A2($author$project$Ui$TimeRepresentation$toClockTime, zone, cfg.Cy.eL) + (' - ' + A2($author$project$Ui$TimeRepresentation$toClockTime, zone, cfg.Cy.dY)))))]))])), A3($author$project$Ui$MatchmakingCards$section, false, '  ', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop0h padBottom0h flexRow noOverflow fullWidth ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight2 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
      t_: browser,
      uj: '',
      wG: cfg.mB.om,
      Dq: 9,
      s5: ' relative block w9 h9 radius7 noOverflow '
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter spaceBetween fullWidth ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn noOverflow  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold ellipsis ')]), _List_fromArray([$elm$html$Html$text(cfg.mB.lh)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading6Regular gray60 marTop1 ')]), _List_fromArray([$elm$html$Html$text('Draft')]))])), $author$project$Ui$Switch$switch({
      uj: ' ',
      ux: 2,
      eh: cfg.eg,
      xi: false,
      Cu: cfg.zQ
    })]))]))]))]));
  });
  var $author$project$Ui$EmptyStates$emptyCard = F3(function (classes, hasSwitch, onTap) {
    var _switch = hasSwitch ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$Switch$switch({
      uj: '',
      ux: 3,
      eh: false,
      xi: false,
      Cu: onTap
    })])) : $author$project$ElmFramework$Lib$Util$noOpEl;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth  pad2 flexRow spaceBetween flexAlignCenter emptyCardShadow radius7 '), $elm$html$Html$Attributes$class(classes)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w8 h8 gray10Back radius9 marRight1')]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn spaceBetween ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w11 h3 radius0 gray10Back marTop0h ')]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marBottom0h ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' radius0 secondary800Back h3 w7 marRight1 ')]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('radius0 secondary800Back h3 w12 ')]), _List_Nil)]))]))])), _switch]));
  });
  var $author$project$Ui$EmptyStates$emptyResult = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' fullWidth flexColumn flexAlignCenter '), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, function (topIcon) {
      return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('marBottom2 w12 h12 ')]), _List_fromArray([topIcon('w12 gray40Fill ')]));
    }, cfg.CV)), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0 heading3Bold marBottom1 ')]), _List_fromArray([$elm$html$Html$text(cfg.lh)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray60 bodyRegular marBottom3 ')]), _List_fromArray([$elm$html$Html$text(cfg.eS)]))]));
  };
  var $author$project$Ui$EmptyStates$emptyState = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' fullWidth flexColumn flexAlignCenter '), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('marBottom3 w6 h6 ')]), _List_fromArray([$author$project$AssetsSvg$logoIconGradient('w6 ')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0 heading2Bold marBottom1 ')]), _List_fromArray([$elm$html$Html$text(cfg.lh)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray80 bodyRegular marBottom3 center ')]), _List_fromArray([$elm$html$Html$text(cfg.eS)])), $author$project$Ui$Button$basicButton({
      bh: ' padTop1h padBottom1h heading5Bold fullWidth ',
      cD: 0,
      fn: $elm$html$Html$text(cfg.t$),
      xa: false,
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.p_)
    })]));
  };
  var $author$project$AssetsSvg$genderFemale_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 38 48'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M31.6941 33.3735L31.6826 33.3764C31.71 32.5957 31.5556 31.8194 31.2316 31.1086C30.9077 30.3977 30.423 29.7719 29.8158 29.2804C29.2086 28.7889 28.4956 28.4452 27.7329 28.2764C26.9702 28.1076 26.1787 28.1183 25.4208 28.3076C24.6629 28.497 23.9594 28.8598 23.3658 29.3675C22.7721 29.8752 22.3045 30.5139 21.9999 31.2332C21.6952 31.9526 21.5619 32.7328 21.6103 33.5125C21.6587 34.2921 21.8876 35.0499 22.279 35.7259C24.8678 40.2099 31.2136 43.521 36.837 39.6266C36.8369 39.6266 31.4218 38.059 31.6941 33.3735Z'), $elm$svg$Svg$Attributes$fill('url(#generatedSvgId_1mxat_26)')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M13.8821 38.5277L11.6737 46.2572C11.6156 46.4606 11.6055 46.6748 11.6442 46.8828C11.6829 47.0908 11.7693 47.287 11.8967 47.4559C12.0241 47.6248 12.189 47.7619 12.3784 47.8562C12.5678 47.9506 12.7764 47.9997 12.988 47.9998H16.2047V35.7173C15.645 36.0007 15.1499 36.3966 14.7502 36.8801C14.3505 37.3637 14.055 37.9246 13.8821 38.5277Z'), $elm$svg$Svg$Attributes$fill('#FFC139')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M19.6021 35.2168H18.2717C17.5528 35.218 16.8444 35.3896 16.2046 35.7175V47.9999H21.6695V35.7175C21.0296 35.3896 20.3211 35.218 19.6021 35.2168Z'), $elm$svg$Svg$Attributes$fill('#0D263E')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M26.2002 46.2571L23.9918 38.5276C23.8189 37.9246 23.5234 37.3638 23.1238 36.8802C22.7242 36.3966 22.2291 36.0007 21.6694 35.7173V47.9997H24.8868C25.0983 47.9995 25.3069 47.9502 25.4961 47.8558C25.6853 47.7613 25.8501 47.6243 25.9774 47.4554C26.1047 47.2865 26.191 47.0904 26.2297 46.8825C26.2684 46.6746 26.2583 46.4605 26.2002 46.2571Z'), $elm$svg$Svg$Attributes$fill('#FFC139')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M33.7649 18.1225H32.4916C32.0483 14.8415 30.4306 11.8324 27.9382 9.65295C25.4458 7.47355 22.2478 6.27164 18.937 6.27002C15.6261 6.27164 12.4281 7.47354 9.9357 9.65295C7.44331 11.8324 5.82557 14.8415 5.38234 18.1225H4.10902C3.56942 18.1225 3.0351 18.2288 2.53657 18.4353C2.03804 18.6418 1.58506 18.9445 1.2035 19.326C0.821947 19.7076 0.519279 20.1606 0.312781 20.6591C0.106283 21.1576 0 21.6919 0 22.2315C0 22.7712 0.106283 23.3055 0.312781 23.804C0.519279 24.3025 0.821947 24.7555 1.2035 25.1371C1.58506 25.5186 2.03804 25.8213 2.53657 26.0278C3.0351 26.2343 3.56942 26.3406 4.10902 26.3406H5.38234C5.82559 29.6216 7.44334 32.6307 9.93572 34.8101C12.4281 36.9895 15.6261 38.1914 18.937 38.1931C22.2478 38.1914 25.4458 36.9895 27.9382 34.8101C30.4306 32.6307 32.0483 29.6216 32.4916 26.3406H33.7649C34.3045 26.3406 34.8388 26.2343 35.3373 26.0278C35.8359 25.8213 36.2888 25.5186 36.6704 25.1371C37.0519 24.7555 37.3546 24.3025 37.5611 23.804C37.7676 23.3055 37.8739 22.7712 37.8739 22.2315C37.8739 21.6919 37.7676 21.1576 37.5611 20.6591C37.3546 20.1606 37.0519 19.7076 36.6704 19.326C36.2888 18.9445 35.8359 18.6418 35.3373 18.4353C34.8388 18.2288 34.3045 18.1225 33.7649 18.1225Z'), $elm$svg$Svg$Attributes$fill('#F8C4B0')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M18.9369 34.0306C18.3371 34.0322 17.7429 33.9148 17.1887 33.6853C16.6345 33.4558 16.1313 33.1187 15.7082 32.6936C15.5368 32.5224 15.4405 32.2901 15.4404 32.0479C15.4403 31.8056 15.5365 31.5733 15.7077 31.402C15.8789 31.2306 16.1112 31.1343 16.3534 31.1342C16.5956 31.1342 16.828 31.2303 16.9993 31.4015C18.0363 32.4381 19.8402 32.4368 20.8736 31.402C20.9584 31.3169 21.059 31.2494 21.1699 31.2033C21.2807 31.1572 21.3995 31.1334 21.5196 31.1333C21.6396 31.1332 21.7585 31.1567 21.8694 31.2026C21.9804 31.2485 22.0812 31.3158 22.1661 31.4007C22.2509 31.4856 22.3182 31.5864 22.3641 31.6973C22.41 31.8082 22.4336 31.9271 22.4335 32.0472C22.4333 32.1672 22.4096 32.2861 22.3635 32.3969C22.3174 32.5077 22.2498 32.6084 22.1648 32.6931C21.742 33.1185 21.239 33.4558 20.6849 33.6854C20.1308 33.915 19.5367 34.0323 18.9369 34.0306Z'), $elm$svg$Svg$Attributes$fill('#FF4D4D')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M20.7632 25.7597C20.7632 24.7512 19.9456 23.9336 18.937 23.9336C17.9284 23.9336 17.1108 24.7512 17.1108 25.7597V27.5859C17.1108 28.5945 17.9284 29.4121 18.937 29.4121C19.9456 29.4121 20.7632 28.5945 20.7632 27.5859V25.7597Z'), $elm$svg$Svg$Attributes$fill('#EF9E8B')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M34.0901 19.7871H32.4468V24.6753H34.0901C34.6835 24.5977 35.2284 24.307 35.6231 23.8573C36.0179 23.4075 36.2356 22.8296 36.2356 22.2312C36.2356 21.6328 36.0179 21.0548 35.6231 20.6051C35.2284 20.1554 34.6835 19.8647 34.0901 19.7871H34.0901Z'), $elm$svg$Svg$Attributes$fill('#EF9E8B')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M28.6978 20.1689C28.613 20.0841 28.5124 20.0168 28.4016 19.9709C28.2909 19.925 28.1721 19.9014 28.0522 19.9014C27.9323 19.9014 27.8136 19.925 27.7028 19.9709C27.5921 20.0168 27.4914 20.0841 27.4067 20.1689L27.122 20.4535C26.5845 20.2171 25.9811 20.1759 25.4164 20.3372C24.8517 20.4985 24.3612 20.8521 24.0296 21.3369C23.698 21.8216 23.5463 22.407 23.6007 22.9917C23.655 23.5765 23.9121 24.1239 24.3274 24.5392C24.7426 24.9545 25.29 25.2116 25.8748 25.266C26.4595 25.3204 27.0449 25.1687 27.5297 24.8371C28.0144 24.5056 28.3681 24.015 28.5294 23.4503C28.6907 22.8856 28.6496 22.2823 28.4131 21.7447L28.6978 21.46C28.7826 21.3753 28.8499 21.2746 28.8958 21.1638C28.9417 21.0531 28.9653 20.9344 28.9653 20.8144C28.9653 20.6945 28.9417 20.5758 28.8958 20.465C28.8499 20.3543 28.7826 20.2536 28.6978 20.1689Z'), $elm$svg$Svg$Attributes$fill('#0D253D')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M26.6768 22.7515C27.1934 22.7515 27.6123 22.3326 27.6123 21.8159C27.6123 21.2992 27.1934 20.8804 26.6768 20.8804C26.1601 20.8804 25.7412 21.2992 25.7412 21.8159C25.7412 22.3326 26.1601 22.7515 26.6768 22.7515Z'), $elm$svg$Svg$Attributes$fill('#FFEFDC')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M11.7584 20.2401C11.4117 20.2405 11.0689 20.3131 10.7518 20.4532L10.4673 20.1688C10.3825 20.084 10.2818 20.0167 10.1711 19.9709C10.0603 19.925 9.94157 19.9014 9.82167 19.9014C9.70178 19.9014 9.58306 19.925 9.47229 19.9709C9.36152 20.0167 9.26088 20.084 9.1761 20.1688C9.09132 20.2536 9.02407 20.3542 8.97819 20.465C8.93231 20.5757 8.90869 20.6945 8.90869 20.8144C8.90869 20.9342 8.93231 21.053 8.97819 21.1637C9.02407 21.2745 9.09132 21.3751 9.1761 21.4599L9.46066 21.7444C9.24416 22.2396 9.19335 22.7915 9.3158 23.318C9.43824 23.8444 9.72739 24.3173 10.1402 24.6662C10.5531 25.0151 11.0675 25.2213 11.607 25.2543C12.1465 25.2872 12.6822 25.1451 13.1344 24.849C13.5867 24.553 13.9312 24.1188 14.1168 23.6112C14.3024 23.1035 14.3191 22.5495 14.1645 22.0316C14.0099 21.5137 13.6921 21.0596 13.2586 20.7368C12.8251 20.414 12.2989 20.2398 11.7584 20.2401Z'), $elm$svg$Svg$Attributes$fill('#0D253D')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M12.3198 22.7515C12.8365 22.7515 13.2554 22.3326 13.2554 21.8159C13.2554 21.2992 12.8365 20.8804 12.3198 20.8804C11.8031 20.8804 11.3843 21.2992 11.3843 21.8159C11.3843 22.3326 11.8031 22.7515 12.3198 22.7515Z'), $elm$svg$Svg$Attributes$fill('#FFEFDC')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M3.78361 19.7871H5.42697V24.6753H3.78361C3.19026 24.5977 2.64539 24.307 2.25063 23.8573C1.85587 23.4075 1.63818 22.8296 1.63818 22.2312C1.63818 21.6328 1.85587 21.0548 2.25063 20.6051C2.64539 20.1554 3.19026 19.8647 3.78361 19.7871Z'), $elm$svg$Svg$Attributes$fill('#EF9E8B')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M32.5069 18.1225H33.7648C34.2731 18.1251 34.7764 18.2227 35.2488 18.4102V16.3119C35.2488 11.9857 33.5302 7.83672 30.4712 4.77765C27.4121 1.71857 23.2631 0 18.9369 0C14.6107 0 10.4617 1.71857 7.40265 4.77765C4.34357 7.83672 2.625 11.9857 2.625 16.3119V18.4102C3.0974 18.2227 3.6007 18.1251 4.10897 18.1225H5.42699C16.2558 18.1225 18.9368 11.7117 18.9368 11.7117C18.9368 11.7117 21.6179 18.1225 32.4467 18.1225H32.5069Z'), $elm$svg$Svg$Attributes$fill('#521919')]), _List_Nil)]));
  };
  var $author$project$AssetsSvg$genderFemale = function (classes) {
    return $author$project$AssetsSvg$genderFemale_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$AssetsSvg$genderMale_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 37 48'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M24.0586 48H13.7648C13.4338 48 13.1142 47.8791 12.8661 47.66C12.618 47.441 12.4584 47.1389 12.4173 46.8104L11.5171 39.6087C11.4214 38.8435 11.4896 38.0667 11.7171 37.3299C11.9446 36.5931 12.3261 35.913 12.8365 35.3349C13.3468 34.7568 13.9743 34.2938 14.6772 33.9767C15.3801 33.6596 16.1425 33.4956 16.9136 33.4956H20.9097C21.6809 33.4956 22.4432 33.6596 23.1461 33.9767C23.8491 34.2938 24.4765 34.7568 24.9869 35.3349C25.4972 35.913 25.8788 36.5931 26.1063 37.3299C26.3337 38.0667 26.4019 38.8435 26.3063 39.6087L25.406 46.8104C25.365 47.1389 25.2054 47.441 24.9573 47.66C24.7091 47.8791 24.3896 48 24.0586 48Z'), $elm$svg$Svg$Attributes$fill('#8CA4BC')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M32.9121 17.3347H31.6035V17.3349C31.6035 13.9689 30.2664 10.7408 27.8863 8.36076C25.5062 5.98067 22.2781 4.64355 18.9122 4.64355C15.5462 4.64355 12.3181 5.98067 9.93803 8.36076C7.55794 10.7408 6.22082 13.9689 6.22082 17.3349V17.3347H4.91223C4.37591 17.3337 3.84467 17.4386 3.34891 17.6432C2.85315 17.8478 2.40259 18.1481 2.02303 18.527C1.64347 18.9059 1.34235 19.356 1.13689 19.8514C0.931437 20.3468 0.825684 20.8779 0.825684 21.4142C0.825684 21.9505 0.931437 22.4816 1.13689 22.977C1.34235 23.4724 1.64347 23.9224 2.02303 24.3013C2.40259 24.6802 2.85315 24.9806 3.34891 25.1852C3.84467 25.3898 4.37591 25.4946 4.91223 25.4937H6.22082V25.4936C6.22082 28.8595 7.55794 32.0876 9.93803 34.4677C12.3181 36.8478 15.5462 38.1849 18.9122 38.1849C22.2781 38.1849 25.5062 36.8478 27.8863 34.4677C30.2664 32.0876 31.6035 28.8595 31.6035 25.4936V25.4937H32.9121C33.4484 25.4946 33.9796 25.3898 34.4754 25.1852C34.9712 24.9806 35.4217 24.6802 35.8013 24.3013C36.1808 23.9224 36.482 23.4724 36.6874 22.977C36.8929 22.4816 36.9986 21.9505 36.9986 21.4142C36.9986 20.8779 36.8929 20.3468 36.6874 19.8514C36.482 19.356 36.1808 18.9059 35.8013 18.527C35.4217 18.1481 34.9712 17.8478 34.4754 17.6432C33.9796 17.4386 33.4484 17.3337 32.9121 17.3347Z'), $elm$svg$Svg$Attributes$fill('#F8C4B0')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M18.9118 34.0523C18.3164 34.054 17.7265 33.9375 17.1765 33.7096C16.6264 33.4818 16.1269 33.147 15.7071 32.7248C15.5377 32.5547 15.4426 32.3243 15.4429 32.0843C15.4431 31.8442 15.5386 31.614 15.7084 31.4442C15.8781 31.2744 16.1083 31.1789 16.3484 31.1787C16.5885 31.1785 16.8189 31.2735 16.989 31.4429C18.0159 32.4703 19.8086 32.4694 20.8355 31.4429C21.0057 31.274 21.2359 31.1793 21.4758 31.1798C21.7156 31.1802 21.9455 31.2757 22.1151 31.4453C22.2846 31.6149 22.3801 31.8447 22.3805 32.0846C22.381 32.3244 22.2864 32.5546 22.1174 32.7248C21.6974 33.147 21.1978 33.4818 20.6476 33.7096C20.0973 33.9375 19.5074 34.054 18.9118 34.0523Z'), $elm$svg$Svg$Attributes$fill('#F7725C')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M20.9191 24.5111C20.9191 23.4025 20.0205 22.5039 18.912 22.5039C17.8034 22.5039 16.9048 23.4025 16.9048 24.5111V27.7508C16.9048 28.8593 17.8034 29.758 18.912 29.758C20.0205 29.758 20.9191 28.8593 20.9191 27.7508V24.5111Z'), $elm$svg$Svg$Attributes$fill('#EF9E8B')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M33.2346 18.9873H31.603V23.8404H33.2346C33.8237 23.7634 34.3646 23.4747 34.7565 23.0282C35.1485 22.5818 35.3646 22.0079 35.3646 21.4138C35.3646 20.8198 35.1485 20.2459 34.7565 19.7995C34.3646 19.353 33.8237 19.0643 33.2346 18.9873Z'), $elm$svg$Svg$Attributes$fill('#EF9E8B')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M26.0388 23.5342C27.4156 23.5342 28.5318 22.4181 28.5318 21.0413C28.5318 19.6645 27.4156 18.5483 26.0388 18.5483C24.662 18.5483 23.5459 19.6645 23.5459 21.0413C23.5459 22.4181 24.662 23.5342 26.0388 23.5342Z'), $elm$svg$Svg$Attributes$fill('#0D253D')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M26.5958 21.0412C27.1088 21.0412 27.5246 20.6254 27.5246 20.1124C27.5246 19.5994 27.1088 19.1836 26.5958 19.1836C26.0828 19.1836 25.667 19.5994 25.667 20.1124C25.667 20.6254 26.0828 21.0412 26.5958 21.0412Z'), $elm$svg$Svg$Attributes$fill('#FFEFDC')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M11.7849 23.5342C13.1617 23.5342 14.2779 22.4181 14.2779 21.0413C14.2779 19.6645 13.1617 18.5483 11.7849 18.5483C10.4081 18.5483 9.29199 19.6645 9.29199 21.0413C9.29199 22.4181 10.4081 23.5342 11.7849 23.5342Z'), $elm$svg$Svg$Attributes$fill('#0D253D')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M12.3424 21.0412C12.8554 21.0412 13.2712 20.6254 13.2712 20.1124C13.2712 19.5994 12.8554 19.1836 12.3424 19.1836C11.8294 19.1836 11.4136 19.5994 11.4136 20.1124C11.4136 20.6254 11.8294 21.0412 12.3424 21.0412Z'), $elm$svg$Svg$Attributes$fill('#FFEFDC')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M4.58897 18.9873H6.22053V23.8404H4.58897C3.99989 23.7634 3.45894 23.4747 3.06702 23.0282C2.6751 22.5818 2.45898 22.0079 2.45898 21.4138C2.45898 20.8198 2.6751 20.2459 3.06702 19.7995C3.45894 19.353 3.99989 19.0643 4.58897 18.9873Z'), $elm$svg$Svg$Attributes$fill('#EF9E8B')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M29.3351 4.3078H25.709C25.709 3.74209 25.5976 3.18191 25.3811 2.65926C25.1646 2.13661 24.8473 1.66172 24.4473 1.2617C24.0473 0.861686 23.5724 0.544376 23.0497 0.327893C22.5271 0.111409 21.9669 -9.52338e-06 21.4012 6.10528e-10H2.59452C2.59662 1.46547 2.83889 2.92069 3.31171 4.3078H0V11.114C3.20564e-06 12.7638 0.655388 14.346 1.82198 15.5126C2.98857 16.6792 4.5708 17.3346 6.22061 17.3346H21.829C22.8581 17.3346 23.8449 16.9258 24.5726 16.1982C25.3002 15.4706 25.709 14.4837 25.709 13.4547C25.8954 14.5375 26.4574 15.52 27.2963 16.2296C28.1351 16.9391 29.1972 17.3304 30.296 17.3346H32.9158L34.602 11.2516C34.8295 10.4388 34.8658 9.58433 34.7081 8.75511C34.5504 7.92589 34.2028 7.14443 33.6927 6.47192C33.1826 5.7994 32.5238 5.25407 31.7678 4.87862C31.0118 4.50318 30.1792 4.30781 29.3351 4.3078Z'), $elm$svg$Svg$Attributes$fill('#0D263E')]), _List_Nil)]));
  };
  var $author$project$AssetsSvg$genderMale = function (classes) {
    return $author$project$AssetsSvg$genderMale_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$OptionLargeSelect$iconBtnRow = function (cfg) {
    return $author$project$Ui$Button$button({
      bh: ' fullWidth ' + cfg.uj,
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' secondary800Back radius2 pad1 flexRow flexAlignCenter spaceBetween fullWidth  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold secondary100 padLeft1  ')]), _List_fromArray([$elm$html$Html$text(cfg.oR)])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' w3 h3 ')]), _List_fromArray([cfg.wE(' secondary100Fill w3 ')]))])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.p_)
    });
  };
  var $author$project$Ui$Input$labeledDropdown = function (cfg) {
    var styles = A2($author$project$Ui$Input$inputStyles, cfg.Cd, false);
    var isSelectedValue = !$elm$core$String$isEmpty(cfg.gw);
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.bh), $elm$html$Html$Attributes$class('padTop1 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative radius7 flexRow flexAlignCenter spaceBetween  '), $elm$html$Html$Attributes$class(styles.aS)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread radius7  borderSolid   hairLineBorderWidth  ' + styles.cJ)]), _List_Nil), A2($elm$html$Html$label, _List_fromArray([$elm$html$Html$Attributes$class('absolute left1 top-1 right1 heading6Bold h2 fullMaxWidth  noOverflow  ' + styles.b6), $elm$html$Html$Attributes$for(cfg.od)]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' ellipsis gray0Back radius2 padRight1 padLeft1 fullMaxWidth inlineBlock  ')]), _List_fromArray([$elm$html$Html$text(cfg.oR)]))])), $author$project$Ui$Button$button({
      bh: 'heading5Regular padTop1h padBottom1h padLeft2 padRight2 fullWidth left sticky' + styles.oq,
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter spaceBetween fullWidth primary0 ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter spaceBetween flex1 '), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2(' gray40 ', !isSelectedValue)]))]), _List_fromArray([$elm$html$Html$text(A3($author$project$ElmFramework$Lib$Util$ifElse, cfg.gw, cfg.bv, isSelectedValue)), styles.bl])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w3 h3 ')]), _List_fromArray([$author$project$IconSvg$arrowdown('w3  ' + styles.dT)]))])),
      xu: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$Ui$Button$NoAction, $author$project$ElmFramework$Lib$Ui$Button$Button, cfg.p_)
    })]))]));
  };
  var $author$project$Ui$Input$labeledTextarea = function (cfg) {
    var styles = A2($author$project$Ui$Input$inputStyles, cfg.Cd, true);
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.bh), $elm$html$Html$Attributes$class('padTop1 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween ')]), _List_fromArray([A2($elm$html$Html$label, _List_fromArray([$elm$html$Html$Attributes$class(' heading6Bold gray0Back padRight1 padLeft1 h2 ellipsis ' + styles.b6), $elm$html$Html$Attributes$for(cfg.od)]), _List_fromArray([$elm$html$Html$text(cfg.oR)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative radius7 flexRow flexAlignCenter spaceBetween  '), $elm$html$Html$Attributes$class(styles.aS)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread radius7  borderSolid   hairLineBorderWidth  ' + styles.bQ)]), _List_Nil), A2($elm$html$Html$textarea, _List_fromArray([$elm$html$Html$Attributes$class('minH14 fullWidth noBorder transparentBack heading5Regular padTop1h padBottom1h padLeft2 padRight2 relative  flex1 sticky noResize noScrollbar '), $elm$html$Html$Attributes$class(styles.oq), $elm$html$Html$Attributes$id(cfg.od), $elm$html$Html$Attributes$value(cfg.s_), $elm$html$Html$Events$onInput(cfg.bu), $elm$html$Html$Attributes$placeholder(cfg.bv), $elm$html$Html$Attributes$required(cfg.ch), $elm$html$Html$Attributes$disabled(styles.bY)]), _List_Nil)])), styles.bl]));
  };
  var $author$project$IconSvg$plus_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M18.6375 30.6667C18.6375 31.3956 19.2419 32 19.9708 32C20.6997 32 21.3041 31.3956 21.3041 30.6667V21.3334H30.6374C31.3663 21.3334 31.9707 20.729 31.9707 20.0001C31.9707 19.2712 31.3663 18.6668 30.6374 18.6668H21.3041V9.33333C21.3041 8.60444 20.6997 8 19.9708 8C19.2419 8 18.6375 8.60444 18.6375 9.33333V18.6668H9.30404C8.57515 18.6668 7.9707 19.2712 7.9707 20.0001C7.9707 20.729 8.57515 21.3334 9.30404 21.3334H18.6375V30.6667Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$plus = function (classes) {
    return $author$project$IconSvg$plus_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$LocationCard$locationCard = function (cfg) {
    var locationBar = function (config) {
      return A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' bodyRegular gray60 flexAlignCenter lineH120 ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('secondary500 heading6Regular marRight1 ')]), _List_fromArray([$elm$html$Html$text('Open')])), $elm$html$Html$text('· ' + config.cy)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray60 heading6Regular flexRow marTop0h ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w2 h2 marRight0h ')]), _List_fromArray([$author$project$IconSvg$directright('gray80Fill w2 ')])), $elm$html$Html$text($elm$core$String$fromInt(config.m5) + (' ' + config.mL))]))]));
    };
    var _v0 = function () {
      var _v1 = cfg.hf;
      switch (_v1.$) {
        case 0:
          var locationsData = _v1.a;
          return _Utils_Tuple2($author$project$ElmFramework$Lib$Util$noOpEl, locationBar(locationsData));
        case 1:
          var locationsData = _v1.a;
          var onClose = _v1.b;
          return _Utils_Tuple2($author$project$Ui$Button$button({
            bh: 'w3 h3 ',
            fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w3 h3 ')]), _List_fromArray([$author$project$IconSvg$close('w3 gray80Fill  ')])),
            xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onClose)
          }), locationBar(locationsData));
        default:
          var onAddCourts = _v1.a;
          return _Utils_Tuple2($author$project$ElmFramework$Lib$Util$noOpEl, $author$project$Ui$Button$button({
            bh: ' marTop1 ',
            fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('secondary100 flexRow flexAlignCenter heading5Bold ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w3 h3 marRight1  ')]), _List_fromArray([$author$project$IconSvg$plus('w3 secondary100Fill')])), A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text('Add Courts')]))])),
            xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onAddCourts)
          }));
      }
    }();
    var closeBtn = _v0.a;
    var location = _v0.b;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' secondary800Back radius5 pad2 flexRow fullWidth spaceBetween '), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('radius7 gray0Back w8 h8 marRight2 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
      t_: cfg.t_,
      uj: '',
      wG: cfg.iU,
      Dq: 8,
      s5: ' relative block w8 h8 radius7 noOverflow '
    })])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$h2, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold primary0 ')]), _List_fromArray([$elm$html$Html$text(cfg.lh)])), location]))])), closeBtn]));
  };
  var $author$project$IconSvg$lockers_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M8 20C8 26.6195 13.3805 32 20 32C26.6195 32 32 26.6195 32 20C32 13.3805 26.6195 8 20 8C13.3805 8 8 13.3805 8 20ZM9.67442 20C9.67442 14.307 14.307 9.67442 20 9.67442C25.693 9.67442 30.3256 14.307 30.3256 20C30.3256 25.693 25.693 30.3256 20 30.3256C14.307 30.3256 9.67442 25.693 9.67442 20ZM24.186 17.7674V18.1645C25.8087 18.4907 26.4186 19.5264 26.4186 21.6744V22.7907C26.4186 25.4698 25.4698 26.4186 22.7907 26.4186H17.2093C14.5302 26.4186 13.5814 25.4698 13.5814 22.7907V21.6744C13.5814 19.5264 14.1913 18.4907 15.814 18.1645V17.7674C15.814 16.7293 15.814 13.5814 20 13.5814C24.186 13.5814 24.186 16.7293 24.186 17.7674ZM22.5116 18.0465H17.4884V17.7674C17.4884 16.1377 17.8902 15.2558 20 15.2558C22.1098 15.2558 22.5116 16.1377 22.5116 17.7674V18.0465ZM18.4929 22.233C18.4929 23.059 19.1738 23.74 19.9999 23.74C20.8259 23.74 21.5068 23.059 21.5068 22.233C21.5068 21.407 20.8259 20.726 19.9999 20.726C19.1738 20.726 18.4929 21.407 18.4929 22.233ZM19.8324 22.233C19.8324 22.1437 19.9106 22.0656 19.9999 22.0656C20.0892 22.0656 20.1673 22.1437 20.1673 22.233C20.1673 22.4228 19.8324 22.4228 19.8324 22.233ZM17.2093 19.7209C15.4344 19.7209 15.2558 19.8995 15.2558 21.6744V22.7907C15.2558 24.5656 15.4344 24.7442 17.2093 24.7442H22.7907C24.5656 24.7442 24.7442 24.5656 24.7442 22.7907V21.6744C24.7442 19.8995 24.5656 19.7209 22.7907 19.7209H17.2093Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$lockers = function (classes) {
    return $author$project$IconSvg$lockers_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$logoFacebook_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M21.8 21.02H25.34L25.88 16.76H21.8V14.06C21.8 12.8 22.16 11.96 23.84 11.96H26V8.18C25.64 8.12 24.32 8 22.82 8C19.7 8 17.54 9.98 17.54 13.64V16.76H14V21.02H17.54V31.94L21.8 32V21.02Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$logoFacebook = function (classes) {
    return $author$project$IconSvg$logoFacebook_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$MatchmakingCards$matchMakingCard = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexColumn secondary800Back   noOverflow  '), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A3($author$project$Ui$MatchmakingCards$section, false, '  ', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop0h padBottom0h flexRow noOverflow fullWidth ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight2 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
      t_: cfg.t_,
      uj: '',
      wG: cfg.t8.om,
      Dq: 9,
      s5: ' relative block w9 h9 radius7 noOverflow '
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter spaceBetween fullWidth ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn noOverflow  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold ellipsis ')]), _List_fromArray([$elm$html$Html$text(cfg.t8.lh)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading6Regular gray60 marTop1 ')]), _List_fromArray([$elm$html$Html$text(A2($elm$core$String$join, ',', cfg.u8))]))]))]))]))]))]));
  };
  var $author$project$Route$Route$matchMakingSingleCheckoutAddCreditCardRoute = $author$project$Route$Route$matchMakingSingleCheckoutPaymentRoute(1);
  var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
    return $elm_community$list_extra$List$Extra$findIndex($elm$core$Basics$eq(x));
  };
  var $author$project$Api$GraphqlSchema$Enum$DifficultyRating$list = _List_fromArray([0, 1, 2]);
  var $author$project$Ui$PlayerLevelSlider$matchRateSlider = function (cfg) {
    var selectLine = function (value) {
      var color = _Utils_eq(value, cfg.s_) ? 'primary0' : 'gray20';
      return $author$project$Ui$Button$button({
        bh: '',
        fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold flexCenter w3 h3 trans3'), $elm$html$Html$Attributes$class(color)]), _List_fromArray([$elm$html$Html$text('|')])),
        xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.bu(value))
      });
    };
    var levelLabel = function () {
      var _v0 = cfg.s_;
      switch (_v0) {
        case 0:
          return 'Too easy';
        case 1:
          return 'Good match';
        default:
          return 'Too tough';
      }
    }();
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold primary0')]), _List_fromArray([$elm$html$Html$text(levelLabel)])), $author$project$ElmFramework$Lib$Ui$Slider$horizontalSlider({
      oq: 'h3',
      aK: true,
      xa: false,
      ay: $elm$core$List$length($author$project$Api$GraphqlSchema$Enum$DifficultyRating$list),
      Q: 1,
      bu: function (input) {
        return cfg.bu(A2($elm$core$Maybe$withDefault, 0, A2($elm_community$list_extra$List$Extra$getAt, $elm$core$Basics$round(input) - 1, $author$project$Api$GraphqlSchema$Enum$DifficultyRating$list)));
      },
      ah: 'h3',
      a6: 1,
      aj: 'gray0Back w3 h3 flexCenter thumbShadow',
      a7: $author$project$IconSvg$menuBurgerBold('w2 h2 gray20Fill'),
      ak: 'flexCenter h3',
      am: 'gradient20Back radius1',
      an: 'gray10Back',
      ao: '',
      s_: A2($elm$core$Maybe$withDefault, 1, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$Basics$add(1), $elm$core$Basics$toFloat), A2($elm_community$list_extra$List$Extra$elemIndex, cfg.s_, $author$project$Api$GraphqlSchema$Enum$DifficultyRating$list)))
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth flexRow spaceBetween')]), A2($elm$core$List$map, selectLine, $author$project$Api$GraphqlSchema$Enum$DifficultyRating$list))]));
  };
  var $author$project$IconSvg$arrowRight_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M15.0433 32C14.7781 32 14.5129 31.9031 14.3036 31.6955C13.8988 31.294 13.8988 30.6296 14.3036 30.2281L23.4039 21.2026C24.0739 20.5381 24.0739 19.4584 23.4039 18.7939L14.3036 9.76842C13.8988 9.36698 13.8988 8.70252 14.3036 8.30108C14.7083 7.89964 15.3783 7.89964 15.7831 8.30108L24.8834 17.3266C25.5952 18.0326 26 18.9877 26 19.9983C26 21.0088 25.6092 21.964 24.8834 22.6699L15.7831 31.6955C15.5737 31.8893 15.3085 32 15.0433 32Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$arrowRight = function (classes) {
    return $author$project$IconSvg$arrowRight_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$NavBar$menuOptionBar = function (cfg) {
    return $author$project$Ui$Button$button({
      bh: 'fullWidth ' + cfg.uj,
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter fullWidth spaceBetween ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexCenter ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' w6 h6  radius7 secondary800Back  flexCenter ')]), _List_fromArray([cfg.jX(' w4 primary0Fill ')])), A2($elm$html$Html$h3, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold primary0 marLeft2 ')]), _List_fromArray([$elm$html$Html$text(cfg.lh)]))])), A2($elm$html$Html$span, _List_Nil, _List_fromArray([$author$project$IconSvg$arrowRight(' w3 primary0Fill ')]))])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.p_)
    });
  };
  var $author$project$IconSvg$explore02_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M8 20.0056C8 26.622 13.3805 32 20 32C26.6195 32 32 26.6109 32 19.9944C32 13.378 26.6195 8 20 8C17.3767 8 14.8874 8.83685 12.8 10.3989C12.4316 10.6779 12.3535 11.2022 12.6326 11.5704C12.9116 11.9386 13.4363 12.0167 13.8047 11.7378C15.6019 10.3877 17.7451 9.67364 20 9.67364C25.693 9.67364 30.3256 14.304 30.3256 19.9944C30.3256 25.6848 25.693 30.3152 20 30.3152C14.307 30.3152 9.67442 25.6848 9.67442 19.9944C9.67442 18.4658 10.0093 16.9707 10.6567 15.5983L13.0943 16.9962C12.6823 17.9411 12.4686 18.9701 12.4686 20.0057C12.4686 24.1564 15.8509 27.5371 20.0035 27.5371C24.156 27.5371 27.5384 24.1564 27.5384 20.0057C27.5384 15.8551 24.156 12.4744 20.0035 12.4744C18.8872 12.4744 17.8044 12.7199 16.7998 13.1885C16.3756 13.3893 16.197 13.8802 16.3979 14.3042C16.5988 14.7171 17.09 14.8956 17.5142 14.7059C18.3067 14.3377 19.144 14.148 20.0147 14.148C23.2407 14.148 25.8751 16.77 25.8751 20.0057C25.8751 23.2414 23.2407 25.8635 20.0147 25.8635C16.7886 25.8635 14.1542 23.2414 14.1542 20.0057C14.1542 19.2592 14.2956 18.524 14.5663 17.8404L19.587 20.7197C19.9888 20.9428 20.4912 20.8089 20.7256 20.4072C20.9488 20.0056 20.8149 19.5035 20.413 19.2692L14.9021 16.1052C14.8373 16.0201 14.7549 15.946 14.6565 15.8886C14.5544 15.8291 14.4452 15.7933 14.3351 15.7797L10.7349 13.7127C10.333 13.4895 9.83069 13.6235 9.59627 14.0251C8.54697 15.8438 8 17.908 8 20.0056Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$explore02 = function (classes) {
    return $author$project$IconSvg$explore02_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $elm$svg$Svg$Attributes$filter = _VirtualDom_attribute('filter');
  var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
  var $author$project$AssetsSvg$matchmaking_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 96 98'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$filter('url(#generatedSvgId_1mxat_21)')]), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M44 13.3094C46.4752 11.8803 49.5248 11.8803 52 13.3094L75.1769 26.6906C77.6521 28.1197 79.1769 30.7607 79.1769 33.6188V60.3812C79.1769 63.2393 77.6521 65.8803 75.1769 67.3094L52 80.6906C49.5248 82.1197 46.4752 82.1197 44 80.6906L20.8231 67.3094C18.3479 65.8803 16.8231 63.2393 16.8231 60.3812V33.6188C16.8231 30.7607 18.3479 28.1197 20.8231 26.6906L44 13.3094Z'), $elm$svg$Svg$Attributes$fill('#0E1116')]), _List_Nil)])), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M38.7134 63L32.8008 57.4483L42.6115 47L32.8008 36.5517L38.7134 31L48.1745 41.0755L57.635 31L63.5476 36.5517L53.737 47L48.1745 52.9245L38.7134 63ZM63.5476 57.4482L57.6349 62.9999C53.1938 58.2702 53.5366 52.8865 55.1502 48.5054L63.5476 57.4482Z'), $elm$svg$Svg$Attributes$fill('url(#generatedSvgId_1mxat_22)')]), _List_Nil)]));
  };
  var $author$project$AssetsSvg$matchmaking = function (classes) {
    return $author$project$AssetsSvg$matchmaking_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$more_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M8 20C8 26.6195 13.3805 32 20 32C26.6195 32 32 26.6195 32 20C32 13.3805 26.6195 8 20 8C13.3805 8 8 13.3805 8 20ZM9.67442 20C9.67442 14.307 14.307 9.67442 20 9.67442C25.693 9.67442 30.3256 14.307 30.3256 20C30.3256 25.693 25.693 30.3256 20 30.3256C14.307 30.3256 9.67442 25.693 9.67442 20ZM18.8837 20C18.8837 20.614 19.3749 21.1163 20 21.1163C20.6251 21.1163 21.1163 20.614 21.1163 20C21.1163 19.386 20.614 18.8837 20 18.8837C19.386 18.8837 18.8837 19.386 18.8837 20ZM24.4651 21.1163C23.84 21.1163 23.3488 20.614 23.3488 20C23.3488 19.386 23.8512 18.8837 24.4651 18.8837C25.0791 18.8837 25.5814 19.386 25.5814 20C25.5814 20.614 25.0902 21.1163 24.4651 21.1163ZM14.4186 20C14.4186 20.614 14.9098 21.1163 15.5349 21.1163C16.16 21.1163 16.6512 20.614 16.6512 20C16.6512 19.386 16.1488 18.8837 15.5349 18.8837C14.9209 18.8837 14.4186 19.386 14.4186 20Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$more = function (classes) {
    return $author$project$IconSvg$more_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$NavBar$navBarBtn = function (cfg) {
    var fillColor = cfg.xj ? ' primary0Fill ' : ' gray40Fill ';
    return $author$project$Ui$Button$button({
      bh: '',
      fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' w4 h4 flexCenter ')]), _List_fromArray([cfg.wE(' w4 ' + fillColor)])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.p_)
    });
  };
  var $author$project$IconSvg$notifications_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M8 23.3488C8 29.4102 10.5898 32 16.6512 32H23.3488C29.4102 32 32 29.4102 32 23.3488V17.7674C32 17.3098 31.6205 16.9302 31.1628 16.9302C30.7051 16.9302 30.3256 17.3098 30.3256 17.7674V23.3488C30.3256 28.4949 28.4949 30.3256 23.3488 30.3256H16.6512C11.5051 30.3256 9.67442 28.4949 9.67442 23.3488V16.6512C9.67442 11.5051 11.5051 9.67442 16.6512 9.67442H22.2326C22.6902 9.67442 23.0698 9.29488 23.0698 8.83721C23.0698 8.37953 22.6902 8 22.2326 8H16.6512C10.5898 8 8 10.5898 8 16.6512V23.3488ZM23.6279 12.186C23.6279 14.4967 25.5033 16.3721 27.814 16.3721C30.1247 16.3721 32 14.4967 32 12.186C32 9.87535 30.1247 8 27.814 8C25.5033 8 23.6279 9.87535 23.6279 12.186ZM25.3023 12.186C25.3023 10.8019 26.4298 9.67442 27.814 9.67442C29.1981 9.67442 30.3256 10.8019 30.3256 12.186C30.3256 13.5702 29.1981 14.6977 27.814 14.6977C26.4298 14.6977 25.3023 13.5702 25.3023 12.186ZM14.4186 21.9535H20C20.4577 21.9535 20.8372 21.574 20.8372 21.1163C20.8372 20.6586 20.4577 20.2791 20 20.2791H14.4186C13.9609 20.2791 13.5814 20.6586 13.5814 21.1163C13.5814 21.574 13.9609 21.9535 14.4186 21.9535ZM24.4651 26.4186H14.4186C13.9609 26.4186 13.5814 26.0391 13.5814 25.5814C13.5814 25.1237 13.9609 24.7442 14.4186 24.7442H24.4651C24.9228 24.7442 25.3023 25.1237 25.3023 25.5814C25.3023 26.0391 24.9228 26.4186 24.4651 26.4186Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$notifications = function (classes) {
    return $author$project$IconSvg$notifications_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$NavBar$navBar = function (cfg) {
    var mvpNavBar = _List_fromArray([{
      wE: $author$project$IconSvg$explore02,
      xj: true,
      p_: cfg.zd
    }, {
      wE: $author$project$IconSvg$notifications,
      xj: false,
      p_: cfg.zn
    }, {
      wE: $author$project$IconSvg$contactHelp,
      xj: false,
      p_: cfg.zL
    }, {
      wE: $author$project$IconSvg$more,
      xj: false,
      p_: cfg.zk
    }]);
    var matchMakingBtn = $author$project$Ui$Button$button({
      bh: 'marTop-2h marBottom-2h w9 h9 ',
      fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' w9 h9   flexCenter relative ')]), _List_fromArray([$author$project$AssetsSvg$matchmaking(' w12 h12q absoluteCenter noPointerEvents top53  ')])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.zj)
    });
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' radius7 gray0Back padLeft3 padRight3 marTop1 marBottom1 padTop1h padBottom1h flexRow spaceBetween specialSearchShadow  '), $elm$html$Html$Attributes$class(cfg.uj)]), A2($elm$core$List$append, A2($elm$core$List$map, $author$project$Ui$NavBar$navBarBtn, A2($elm$core$List$take, 2, mvpNavBar)), A2($elm$core$List$cons, matchMakingBtn, A2($elm$core$List$map, $author$project$Ui$NavBar$navBarBtn, A2($elm$core$List$drop, 2, mvpNavBar)))));
  };
  var $author$project$IconSvg$check_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M8 20C8 26.6195 13.3805 32 20 32C26.6195 32 32 26.6195 32 20C32 13.3805 26.6195 8 20 8C13.3805 8 8 13.3805 8 20ZM9.67442 20C9.67442 14.307 14.307 9.67442 20 9.67442C25.693 9.67442 30.3256 14.307 30.3256 20C30.3256 25.693 25.693 30.3256 20 30.3256C14.307 30.3256 9.67442 25.693 9.67442 20ZM17.8232 23.7508C17.9795 23.9071 18.1916 23.9964 18.4148 23.9964C18.6381 23.9964 18.8502 23.9071 19.0064 23.7508L25.3358 17.4215C25.6595 17.0978 25.6595 16.562 25.3358 16.2382C25.012 15.9145 24.4762 15.9145 24.1525 16.2382L18.4148 21.9759L15.8474 19.4085C15.5237 19.0848 14.9878 19.0848 14.6641 19.4085C14.3404 19.7322 14.3404 20.268 14.6641 20.5917L17.8232 23.7508Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$check = function (classes) {
    return $author$project$IconSvg$check_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$error_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M23.2372 32H16.7628C15.7693 32 14.4967 31.4753 13.8046 30.7721L9.22791 26.1953C8.52466 25.4921 8 24.2195 8 23.2372V16.7628C8 15.7693 8.52466 14.4968 9.22791 13.8047L13.8046 9.22791C14.5079 8.52466 15.7805 8 16.7628 8H23.2372C24.2307 8 25.5033 8.52466 26.1954 9.22791L30.7721 13.8047C31.4753 14.5079 32 15.7805 32 16.7628V23.2372C32 24.2307 31.4753 25.5032 30.7721 26.1953L26.1954 30.7721C25.4921 31.4753 24.2307 32 23.2372 32ZM16.7628 9.67442C16.2158 9.67442 15.3674 10.0205 14.9879 10.4112L10.4112 14.9879C10.0316 15.3786 9.67442 16.2158 9.67442 16.7628V23.2372C9.67442 23.7842 10.0205 24.6325 10.4112 25.0121L14.9879 29.5888C15.3786 29.9684 16.2158 30.3256 16.7628 30.3256H23.2372C23.7842 30.3256 24.6326 29.9795 25.0121 29.5888L29.5888 25.0121C29.9684 24.6214 30.3256 23.7842 30.3256 23.2372V16.7628C30.3256 16.2158 29.9795 15.3675 29.5888 14.9879L25.0121 10.4112C24.6214 10.0316 23.7842 9.67442 23.2372 9.67442H16.7628ZM16.093 24.7441C15.8809 24.7441 15.6688 24.666 15.5013 24.4985C15.1776 24.1748 15.1776 23.639 15.5013 23.3153L18.8167 19.9999L15.5013 16.6846C15.1776 16.3609 15.1776 15.8251 15.5013 15.5013C15.8251 15.1776 16.3609 15.1776 16.6846 15.5013L19.9999 18.8167L23.3153 15.5013C23.639 15.1776 24.1748 15.1776 24.4985 15.5013C24.8223 15.8251 24.8223 16.3609 24.4985 16.6846L21.1832 19.9999L24.4985 23.3153C24.8223 23.639 24.8223 24.1748 24.4985 24.4985C24.3311 24.666 24.119 24.7441 23.9069 24.7441C23.6948 24.7441 23.4827 24.666 23.3153 24.4985L19.9999 21.1832L16.6846 24.4985C16.5171 24.666 16.305 24.7441 16.093 24.7441Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$error = function (classes) {
    return $author$project$IconSvg$error_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$information_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M20 32C13.3805 32 8 26.6195 8 20C8 13.3805 13.3805 8 20 8C26.6195 8 32 13.3805 32 20C32 26.6195 26.6195 32 20 32ZM20 9.67442C14.307 9.67442 9.67442 14.307 9.67442 20C9.67442 25.693 14.307 30.3256 20 30.3256C25.693 30.3256 30.3256 25.693 30.3256 20C30.3256 14.307 25.693 9.67442 20 9.67442ZM20 21.9535C19.5423 21.9535 19.1628 21.574 19.1628 21.1163V15.5349C19.1628 15.0772 19.5423 14.6977 20 14.6977C20.4577 14.6977 20.8372 15.0772 20.8372 15.5349V21.1163C20.8372 21.574 20.4577 21.9535 20 21.9535ZM19.5758 25.492C19.7098 25.5478 19.8549 25.5813 20 25.5813C20.1451 25.5813 20.2902 25.5478 20.4242 25.492C20.5581 25.4361 20.6809 25.358 20.7926 25.2575C20.893 25.1459 20.9712 25.0343 21.027 24.8892C21.0828 24.7552 21.1163 24.6101 21.1163 24.465C21.1163 24.3199 21.0828 24.1748 21.027 24.0408C20.9712 23.9068 20.893 23.7841 20.7926 23.6724C20.6809 23.572 20.5581 23.4938 20.4242 23.438C20.1563 23.3264 19.8437 23.3264 19.5758 23.438C19.4419 23.4938 19.3191 23.572 19.2074 23.6724C19.107 23.7841 19.0288 23.9068 18.973 24.0408C18.9172 24.1748 18.8837 24.3199 18.8837 24.465C18.8837 24.6101 18.9172 24.7552 18.973 24.8892C19.0288 25.0343 19.107 25.1459 19.2074 25.2575C19.3191 25.358 19.4419 25.4361 19.5758 25.492Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$information = function (classes) {
    return $author$project$IconSvg$information_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$Button$textBtn = function (cfg) {
    return $author$project$Ui$Button$button({
      bh: cfg.uj,
      fn: A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text(cfg.eS)])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.p_)
    });
  };
  var $author$project$IconSvg$warning_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M13.2383 31.6651H26.757C28.9321 31.6651 30.594 30.8731 31.4417 29.4566C32.2894 28.0177 32.1667 26.1884 31.1071 24.2811L24.3478 12.112C23.2323 10.1043 21.6931 9 19.9977 9C18.3023 9 16.763 10.1043 15.6476 12.112L8.88822 24.2699C7.82859 26.1773 7.71705 28.0177 8.5536 29.4454C9.40131 30.8731 11.0633 31.6651 13.2383 31.6651ZM17.1088 12.9262C17.923 11.4762 18.9492 10.6731 19.9977 10.6731C21.0462 10.6731 22.0723 11.4762 22.8866 12.9262L29.6571 25.0953C30.4156 26.4673 30.5494 27.7054 30.014 28.6088C29.4786 29.5123 28.3298 30.0031 26.7682 30.0031H13.2495C11.6879 30.0031 10.5279 29.5123 10.0036 28.6088C9.47939 27.7054 9.60208 26.4561 10.3606 25.0953L17.1088 12.9262ZM19.9972 23.4001C19.5398 23.4001 19.1606 23.0208 19.1606 22.5635V16.9865C19.1606 16.5292 19.5398 16.1499 19.9972 16.1499C20.4545 16.1499 20.8337 16.5292 20.8337 16.9865V22.5635C20.8337 23.0208 20.4545 23.4001 19.9972 23.4001ZM19.9972 27.0252C19.9302 27.0252 19.8521 27.014 19.7741 27.0029C19.7071 26.9917 19.6402 26.9694 19.5733 26.936C19.5064 26.9137 19.4394 26.8802 19.3725 26.8356L19.2052 26.7017C19.0044 26.4898 18.8817 26.1998 18.8817 25.9098C18.8817 25.6198 19.0044 25.3298 19.2052 25.1179L19.3725 24.984C19.4394 24.9394 19.5064 24.9059 19.5733 24.8836C19.6402 24.8502 19.7071 24.8279 19.7741 24.8167C19.9191 24.7832 20.0752 24.7832 20.2091 24.8167C20.2872 24.8279 20.3541 24.8502 20.421 24.8836C20.4879 24.9059 20.5549 24.9394 20.6218 24.984L20.7891 25.1179C20.9899 25.3298 21.1126 25.6198 21.1126 25.9098C21.1126 26.1998 20.9899 26.4898 20.7891 26.7017L20.6218 26.8356C20.5549 26.8802 20.4879 26.9137 20.421 26.936C20.3541 26.9694 20.2872 26.9917 20.2091 27.0029C20.1422 27.014 20.0641 27.0252 19.9972 27.0252Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$warning = function (classes) {
    return $author$project$IconSvg$warning_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$NotificationBar$notificationBar = function (cfg) {
    var theme = function () {
      var _v2 = cfg.gI;
      switch (_v2) {
        case 1:
          return {
            l$: 'secondary410Back ',
            dL: 'secondary400Fill',
            wE: $author$project$IconSvg$information,
            eb: ' gradient300Back',
            eT: ' secondary400'
          };
        case 0:
          return {
            l$: 'secondary510Back ',
            dL: ' secondary500Fill',
            wE: $author$project$IconSvg$check,
            eb: ' gradient400Back',
            eT: ' secondary500'
          };
        case 2:
          return {
            l$: 'secondary610Back',
            dL: 'secondary600Fill',
            wE: $author$project$IconSvg$warning,
            eb: ' secondary600Back',
            eT: ' secondary600'
          };
        default:
          return {
            l$: 'secondary710Back',
            dL: 'secondary700Fill',
            wE: $author$project$IconSvg$error,
            eb: ' gradient500Back',
            eT: ' secondary700'
          };
      }
    }();
    var btn = function () {
      var _v0 = cfg.gH;
      if (!_v0.$) {
        var _v1 = _v0.a;
        var label = _v1.a;
        var onTap = _v1.b;
        return $author$project$Ui$Button$textBtn({
          uj: 'heading6Bold marTop0h ' + theme.eT,
          p_: onTap,
          eS: label
        });
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth flexRow spaceBetween flexAlignCenter pad1 radius5 ' + theme.l$), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('radius7 w5 h5 flexCenter marRight1  '), $elm$html$Html$Attributes$class(theme.eb)]), _List_fromArray([theme.wE('w3 gray0Fill ')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn  flexAlignStart ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('primary0 bodyRegular')]), _List_fromArray([$elm$html$Html$text(cfg.eS)])), btn]))])), $author$project$Ui$Button$button({
      bh: 'h3 w3 ',
      fn: A2($elm$html$Html$span, _List_Nil, _List_fromArray([$author$project$IconSvg$close('w3 ' + theme.dL)])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.pR)
    })]));
  };
  var $author$project$IconSvg$level_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M15.7707 23.3631C17.0165 24.0455 18.4607 24.436 20 24.436C21.5526 24.436 23.0083 24.0388 24.2614 23.3454V30.1737C24.2614 30.4082 24.1934 30.531 24.1594 30.5533C24.1367 30.5644 24.0347 30.5756 23.876 30.4974L20.8274 29.0798C20.34 28.8565 19.6713 28.8565 19.184 29.0798L16.1467 30.4974C15.988 30.5756 15.886 30.5644 15.8633 30.5533C15.8293 30.5421 15.7614 30.4193 15.7614 30.1737L15.7707 23.3631ZM14.0724 22.1408C12.4858 20.67 11.5 18.6149 11.5 16.343C11.5 11.8779 15.308 8.25 20 8.25C24.692 8.25 28.5 11.8779 28.5 16.343C28.5 18.5987 27.5281 20.6408 25.9614 22.1094V30.1737C25.9614 30.9663 25.6327 31.6137 25.066 31.9709C24.7713 32.1607 24.4427 32.25 24.1027 32.25C23.7853 32.25 23.468 32.1718 23.1393 32.0267L20.0907 30.6091C20.0567 30.5979 19.932 30.5979 19.8867 30.6091L16.8607 32.0156C16.192 32.3281 15.4894 32.317 14.9453 31.9709C14.3787 31.6137 14.05 30.9551 14.0614 30.1737L14.0724 22.1408ZM24.5704 21.092C25.9395 19.917 26.8 18.2229 26.8 16.343C26.8 12.8044 23.7513 9.92441 20 9.92441C16.2487 9.92441 13.2 12.8044 13.2 16.343C13.2 19.8816 16.2487 22.7616 20 22.7616C21.7459 22.7616 23.3396 22.1377 24.5447 21.114C24.5531 21.1065 24.5617 21.0992 24.5704 21.092Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$level = function (classes) {
    return $author$project$IconSvg$level_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$NotificationBtn$notificationTime = F3(function (zone, currentTime, createdAt) {
    var timeDiffToSeconds = ($elm$time$Time$posixToMillis(currentTime) - $elm$time$Time$posixToMillis(createdAt)) / 1000 | 0;
    var timeDiffToMins = timeDiffToSeconds / 60 | 0;
    var timeDiffToHours = timeDiffToMins / 60 | 0;
    var timeDiffToDays = timeDiffToHours / 24 | 0;
    var timeDiffToWeeks = timeDiffToDays / 7 | 0;
    return timeDiffToSeconds < 0 ? '' : timeDiffToSeconds < 60 ? $elm$core$String$fromInt(timeDiffToSeconds) + 's' : timeDiffToMins >= 1 && timeDiffToMins < 60 ? $elm$core$String$fromInt(timeDiffToMins) + 'm' : timeDiffToHours >= 1 && timeDiffToHours < 24 ? $elm$core$String$fromInt(timeDiffToHours) + 'h' : timeDiffToDays >= 1 && timeDiffToDays < 7 ? $elm$core$String$fromInt(timeDiffToDays) + 'd' : $elm$core$String$fromInt(timeDiffToWeeks) + 'w';
  });
  var $author$project$IconSvg$people_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M13.2664 15.431H13.2441C11.2357 15.3641 9.66248 13.7351 9.65132 11.7267C9.65132 9.67365 11.325 8 13.3668 8C15.4087 8 17.0824 9.67366 17.0824 11.7155C17.0824 13.7351 15.5091 15.3641 13.5007 15.431L13.2664 14.5942L13.3445 15.431H13.2664ZM13.378 13.7574H13.3781C13.445 13.7574 13.5008 13.7574 13.5677 13.7685C14.5607 13.7239 15.431 12.8313 15.431 11.7267C15.431 10.5997 14.5161 9.68481 13.3892 9.68481C12.2622 9.68481 11.3473 10.5997 11.3473 11.7267C11.3473 12.8201 12.1953 13.7016 13.2776 13.7685C13.2887 13.7574 13.3333 13.7574 13.3779 13.7574H13.378ZM26.5997 15.4308H26.689L26.6948 15.4309C26.6967 15.4311 26.698 15.4314 26.6988 15.4322C26.7001 15.4336 26.7001 15.4364 26.7001 15.4419C28.7085 15.375 30.2818 13.746 30.2929 11.7264C30.2929 9.68456 28.6193 8.0109 26.5774 8.0109C24.5356 8.0109 22.8619 9.6734 22.8619 11.7264C22.8619 13.7348 24.4351 15.3638 26.5439 15.4308H26.5997ZM24.5355 11.7153C24.5355 10.5883 25.4505 9.6734 26.5774 9.6734C27.7155 9.6734 28.6304 10.5883 28.6304 11.7153C28.6193 12.8087 27.7824 13.7013 26.7001 13.7571C26.5997 13.746 26.5105 13.746 26.4993 13.7571C25.3947 13.7125 24.5355 12.8199 24.5355 11.7153ZM25.3949 23.5423C25.83 23.6204 26.2652 23.6539 26.7003 23.6539C28.0727 23.6539 29.3894 23.2857 30.4047 22.6162C31.3977 21.9468 31.9556 20.9984 31.9556 20.0053C31.9556 19.0011 31.3866 18.0639 30.4047 17.4056C29.0658 16.513 27.1801 16.1671 25.3614 16.4907C24.904 16.5688 24.6027 17.0039 24.6808 17.4614C24.7589 17.9188 25.1941 18.2313 25.6515 18.142C27.0351 17.8965 28.5079 18.1531 29.4786 18.8003C29.9919 19.1462 30.282 19.5702 30.282 20.0053C30.282 20.4405 30.003 20.8756 29.4786 21.2215C28.5079 21.8687 27.0574 22.1253 25.685 21.891C25.2275 21.8129 24.7924 22.1141 24.7143 22.5716C24.6362 23.0291 24.9374 23.4642 25.3949 23.5423ZM9.55092 22.6162C10.5663 23.2857 11.8829 23.6539 13.2553 23.6539C13.6904 23.6539 14.1256 23.6204 14.5607 23.5423C15.0182 23.4642 15.3195 23.0291 15.2414 22.5716C15.1633 22.1253 14.7281 21.8129 14.2706 21.891C12.8982 22.1253 11.4477 21.8687 10.477 21.2215C9.96376 20.8756 9.67366 20.4405 9.67366 20.0053C9.67366 19.5702 9.9526 19.1462 10.477 18.8003C11.4589 18.1531 12.9206 17.8965 14.3041 18.142C14.7616 18.2313 15.1967 17.9188 15.2748 17.4614C15.3529 17.0039 15.0517 16.5688 14.5942 16.4907C12.7755 16.1671 10.8898 16.513 9.55092 17.4056C8.56904 18.0639 8 19.0123 8 20.0053C8 21.0095 8.56904 21.9579 9.55092 22.6162ZM19.9944 23.7664H19.9051H19.8493C17.7405 23.6994 16.1673 22.0704 16.1673 20.062C16.1673 18.009 17.8409 16.3465 19.8828 16.3465C21.9246 16.3465 23.5983 18.0202 23.5983 20.062C23.5871 22.0816 22.0139 23.7106 20.0055 23.7775C20.0055 23.772 20.0055 23.7692 20.0041 23.7678C20.0027 23.7664 19.9999 23.7664 19.9944 23.7664ZM19.8828 18.009C18.7559 18.009 17.8409 18.9239 17.8409 20.0509C17.8409 21.1555 18.7001 22.0481 19.8047 22.0927C19.8158 22.0816 19.9051 22.0816 20.0055 22.0927C21.0878 22.0369 21.9246 21.1443 21.9358 20.0509C21.9358 18.9351 21.0209 18.009 19.8828 18.009ZM16.2788 30.9511C17.3165 31.6541 18.6554 32 19.9943 32C21.3332 32 22.6722 31.6429 23.7098 30.9511C24.7029 30.2928 25.2608 29.3333 25.2608 28.3402C25.2608 27.336 24.6917 26.3988 23.7098 25.7405C21.6345 24.3569 18.3653 24.3569 16.2788 25.7405C15.2858 26.3988 14.7279 27.3584 14.7279 28.3514C14.7279 29.3556 15.2969 30.2928 16.2788 30.9511ZM16.4015 28.3625C16.4015 27.9274 16.6805 27.4922 17.2049 27.1464C18.7223 26.1422 21.2775 26.131 22.7726 27.1464C23.2858 27.4922 23.5759 27.9162 23.5759 28.3514C23.5759 28.7865 23.297 29.2217 22.7726 29.5676C21.2663 30.5829 18.7112 30.5829 17.2049 29.5676C16.6916 29.2217 16.4015 28.7977 16.4015 28.3625Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$people = function (classes) {
    return $author$project$IconSvg$people_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$radar_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M10.4 26.735C10.5674 26.9583 10.813 27.0699 11.0697 27.0699C11.2483 27.0699 11.4269 27.0141 11.5721 26.9025C11.9404 26.6234 12.0186 26.0987 11.7395 25.7304C10.3888 23.9332 9.6744 21.79 9.6744 19.5351C9.6744 17.2802 10.3888 15.137 11.7395 13.3398C12.0186 12.9715 11.9404 12.4468 11.5721 12.1677C11.2037 11.8887 10.679 11.9668 10.4 12.3352C8.82603 14.4226 8 16.9119 8 19.5351C8 22.1583 8.82603 24.6476 10.4 26.735ZM28.9303 27.0699C28.7517 27.0699 28.5842 27.0141 28.4279 26.9025C28.0596 26.6234 27.9814 26.0987 28.2605 25.7304C29.6112 23.9332 30.3256 21.79 30.3256 19.5351C30.3256 17.2802 29.6112 15.137 28.2605 13.3398C27.9814 12.9715 28.0596 12.4468 28.4279 12.1677C28.7963 11.8887 29.321 11.9668 29.6 12.3352C31.174 14.4226 32 16.9119 32 19.5351C32 22.1583 31.174 24.6476 29.6 26.735C29.4326 26.9583 29.187 27.0699 28.9303 27.0699ZM19.9998 22.6045C18.3031 22.6045 16.9301 21.2315 16.9301 19.5348C16.9301 17.8381 18.3031 16.4651 19.9998 16.4651C21.6966 16.4651 23.0696 17.8381 23.0696 19.5348C23.0696 21.2315 21.6966 22.6045 19.9998 22.6045ZM19.9998 18.1395C19.2296 18.1395 18.6045 18.7646 18.6045 19.5348C18.6045 20.305 19.2296 20.9301 19.9998 20.9301C20.7701 20.9301 21.3952 20.305 21.3952 19.5348C21.3952 18.7646 20.7701 18.1395 19.9998 18.1395ZM25.358 24.3907C25.1794 24.3907 25.012 24.3349 24.8557 24.2233C24.4873 23.9442 24.4092 23.4196 24.6882 23.0512C25.4585 22.0354 25.8603 20.8187 25.8603 19.535C25.8603 18.2513 25.4585 17.0346 24.6882 16.0188C24.4092 15.6504 24.4873 15.1257 24.8557 14.8467C25.224 14.5676 25.7487 14.6458 26.0277 15.0141C27.0101 16.3313 27.5347 17.8941 27.5347 19.535C27.5347 21.1759 27.0101 22.7498 26.0277 24.0558C25.8603 24.2791 25.6147 24.3907 25.358 24.3907ZM13.972 24.0558C14.1395 24.2791 14.385 24.3907 14.6418 24.3907C14.8204 24.3907 14.999 24.3349 15.1441 24.2233C15.5125 23.9442 15.5906 23.4196 15.3115 23.0512C14.5413 22.0354 14.1395 20.8187 14.1395 19.535C14.1395 18.2513 14.5413 17.0346 15.3115 16.0188C15.5906 15.6504 15.5125 15.1257 15.1441 14.8467C14.7757 14.5676 14.2511 14.6458 13.972 15.0141C12.9897 16.3202 12.4651 17.8941 12.4651 19.535C12.4651 21.1759 12.9897 22.7386 13.972 24.0558Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$radar = function (classes) {
    return $author$project$IconSvg$radar_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$NotificationBtn$notificationBtn = function (_v0) {
    var classes = _v0.uj;
    var browser = _v0.t_;
    var zone = _v0.DJ;
    var currentTime = _v0.fs;
    var onTap = _v0.p_;
    var cfg = _v0.fd;
    var unReadDot = function () {
      var _v2 = cfg.qU;
      if (_v2 === 1) {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('circle  w75 h75 marRight2 secondary0Back')]), _List_Nil);
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();
    var notificationImg = function (content) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w5 h5 flexCenter ')]), _List_fromArray([content]));
    };
    var iconBox = function (icon) {
      return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w5 h5 gray0Back circle flexCenter ')]), _List_fromArray([icon('w4 gray40Fill ')]));
    };
    var settings = function () {
      var _v1 = cfg.tg;
      switch (_v1) {
        case 1:
          return {
            l$: 'primary0Back',
            bt: notificationImg($author$project$AssetsSvg$logoIconGradient('w4')),
            bC: 'gray0',
            bD: 'gray0',
            lh: $elm$html$Html$text(cfg.lh),
            bF: 'gray0'
          };
        case 0:
          return {
            l$: 'secondary800Back',
            bt: notificationImg(iconBox($author$project$IconSvg$people)),
            bC: 'gray80',
            bD: 'gray40',
            lh: $elm$html$Html$text(cfg.lh),
            bF: 'primary0'
          };
        case 3:
          return {
            l$: 'secondary800Back',
            bt: notificationImg(iconBox($author$project$IconSvg$information)),
            bC: 'gray80',
            bD: 'gray40',
            lh: $elm$html$Html$text(cfg.lh),
            bF: 'primary0'
          };
        case 5:
          return {
            l$: 'secondary800Back',
            bt: notificationImg(iconBox($author$project$IconSvg$level)),
            bC: 'gray80',
            bD: 'gray40',
            lh: $elm$html$Html$text(cfg.lh),
            bF: 'primary0'
          };
        case 2:
          return {
            l$: 'primary0Back',
            bt: notificationImg($author$project$AssetsSvg$logoIconGradient('w4')),
            bC: 'gray0',
            bD: 'gray0',
            lh: $elm$html$Html$text(cfg.lh),
            bF: 'gray0'
          };
        case 4:
          return {
            l$: 'secondary800Back',
            bt: notificationImg(iconBox($author$project$IconSvg$radar)),
            bC: 'gray80',
            bD: 'gray40',
            lh: $elm$html$Html$text(cfg.lh),
            bF: 'primary0'
          };
        default:
          return {
            l$: 'primary0Back',
            bt: notificationImg($author$project$AssetsSvg$logoIconGradient('w4')),
            bC: 'gray0',
            bD: 'gray0',
            lh: $elm$html$Html$text(cfg.lh),
            bF: 'gray0'
          };
      }
    }();
    var avatar = function (img) {
      return A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
        t_: browser,
        uj: '',
        wG: img,
        Dq: 5,
        s5: ' relative block w5 h5 circle noOverflow '
      })]));
    };
    return $author$project$Ui$Button$button({
      bh: 'fullWidth ' + classes,
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('  pad2  radius5 flexRow flexAlignCenter fullWidth ' + settings.l$)]), _List_fromArray([unReadDot, settings.bt, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn gray0 marLeft2 fullWidth  fullMaxWidth noOverflow ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween flexAlignCenter noOverflow  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold flex1 noOverflow w10 left '), $elm$html$Html$Attributes$class(settings.bF)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([settings.lh]))]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading5Regular left  '), $elm$html$Html$Attributes$class(settings.bC)]), _List_fromArray([$elm$html$Html$text(cfg.f0)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading6Regular marLeft0h  '), $elm$html$Html$Attributes$class(settings.bD)]), _List_fromArray([$elm$html$Html$text(A3($author$project$Ui$NotificationBtn$notificationTime, zone, currentTime, cfg.uV))]))]))])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onTap)
    });
  };
  var $author$project$IconSvg$copy_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M25.3023 25.3023H25.693C30.0577 25.3023 32 23.36 32 18.9953V14.307C32 9.94233 30.0577 8 25.693 8H21.0047C16.64 8 14.6977 9.94233 14.6977 14.307V14.6977H14.307C9.94233 14.6977 8 16.64 8 21.0047V25.693C8 30.0577 9.94233 32 14.307 32H18.9953C23.36 32 25.3023 30.0577 25.3023 25.693V25.3023ZM23.6279 24.4664C23.6279 24.466 23.6279 24.4655 23.6279 24.4651V21.0047C23.6279 17.7605 22.5977 16.5275 19.6176 16.3861C19.419 16.3767 19.2116 16.3721 18.9953 16.3721H15.5349H14.307C10.8465 16.3721 9.67442 17.5442 9.67442 21.0047V25.693C9.67442 29.1535 10.8465 30.3256 14.307 30.3256H18.9953C22.4558 30.3256 23.6279 29.1535 23.6279 25.693V24.4664ZM25.3023 23.6279H25.693C29.1535 23.6279 30.3256 22.4558 30.3256 18.9953V14.307C30.3256 10.8465 29.1535 9.67442 25.693 9.67442H21.0047C17.5442 9.67442 16.3721 10.8465 16.3721 14.307V14.6977H18.9953C23.36 14.6977 25.3023 16.64 25.3023 21.0047V23.6279Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$copy = function (classes) {
    return $author$project$IconSvg$copy_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$OpeningHoursBar$openingHoursBar = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow flexAlignCenter padLeft2 padRight2 padTop1h padBottom1h secondary800Back spaceBetween whiteSpaceNoWrap relative  '), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow flexAlignCenter marRight1 noOverflow  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('  ')]), _List_fromArray([$author$project$Ui$Switch$switch({
      uj: 'marRight1',
      ux: 2,
      eh: cfg.eg,
      xi: false,
      Cu: cfg.jk
    })])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' bodyRegular primary0 ellipsis  ')]), _List_fromArray([$elm$html$Html$text(cfg.mO)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft1 flexRow flexAlignCenter ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' padLeft2 padRight2 padTop1h padBottom1h gray0Back radius7 heading5Regular primary0 marRight2  ')]), _List_fromArray([$elm$html$Html$text(cfg.Cy)])), $author$project$Ui$Button$button({
      bh: ' w4 h4 marRight1 ',
      fn: $author$project$IconSvg$plus('w4 secondary100Fill '),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.jh)
    }), $author$project$Ui$Button$button({
      bh: ' w4 h4  ',
      fn: $author$project$IconSvg$copy('w4 secondary100Fill '),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.jh)
    })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' absolute fullWidth hairLineHeight1 gray20Back bottom0 left0 ')]), _List_Nil)]));
  };
  var $author$project$Ui$OptionLargeSelect$optionLargeSelect = function (cfg) {
    var _v0 = cfg.xj ? {
      cQ: ' primary0Fill ',
      cS: ' gray10Back ',
      bC: ' primary0 ',
      dr: ' gradient10Back '
    } : {
      cQ: ' gray60Fill ',
      cS: ' secondary800Back ',
      bC: ' gray60 ',
      dr: ' secondary800Back '
    };
    var textColor = _v0.bC;
    var innerBackground = _v0.cS;
    var wrapperBackground = _v0.dr;
    var iconFill = _v0.cQ;
    return $author$project$Ui$Button$button({
      bh: ' radius5 maxW13  ' + cfg.uj,
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('radius5 hairLinePad w13 h16 '), $elm$html$Html$Attributes$class(wrapperBackground)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('  flexCenterColumn radius28 fullHeight  '), $elm$html$Html$Attributes$class(innerBackground)]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w8 h8 flexCenter ')]), _List_fromArray([cfg.wE('  w8  ' + (iconFill + cfg.ea))])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('bodyBold padRight1 padLeft1 '), $elm$html$Html$Attributes$class(textColor)]), _List_fromArray([$elm$html$Html$text(cfg.lh)]))]))])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.p_)
    });
  };
  var $author$project$Ui$BarButton$optionMatch = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray10Back radius7 flexRow flexCenter padTop1h padBottom1h padLeft2 padRight2 spaceBetween'), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold primary0')]), _List_fromArray([$elm$html$Html$text(cfg.z4)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray80 bodyRegular')]), _List_fromArray([$elm$html$Html$text(cfg.vn)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1')]), _List_Nil), $author$project$Ui$Button$button({
      bh: '',
      fn: $author$project$IconSvg$arrowRight('w4 secondary100Fill'),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.Cu)
    })]));
  };
  var $elm_community$maybe_extra$Maybe$Extra$andMap = $elm$core$Maybe$map2($elm$core$Basics$apR);
  var $author$project$ElmFramework$Lib$Util$flip = F3(function (_function, a, b) {
    return A2(_function, b, a);
  });
  var $elm_community$string_extra$String$Extra$regexFromString = A2($elm$core$Basics$composeR, $elm$regex$Regex$fromString, $elm$core$Maybe$withDefault($elm$regex$Regex$never));
  var $elm_community$string_extra$String$Extra$changeCase = F2(function (mutator, word) {
    return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function (_v0) {
      var head = _v0.a;
      var tail = _v0.b;
      return A2($elm$core$String$cons, mutator(head), tail);
    }, $elm$core$String$uncons(word)));
  });
  var $elm$core$Char$toUpper = _Char_toUpper;
  var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
    return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
  };
  var $elm$core$String$trim = _String_trim;
  var $elm_community$string_extra$String$Extra$humanize = function (string) {
    return $elm_community$string_extra$String$Extra$toSentenceCase($elm$core$String$toLower($elm$core$String$trim(A3($elm$regex$Regex$replace, $elm_community$string_extra$String$Extra$regexFromString('_id$|[-_\\s]+'), $elm$core$Basics$always(' '), A3($elm$regex$Regex$replace, $elm_community$string_extra$String$Extra$regexFromString('[A-Z]+'), A2($elm$core$Basics$composeR, function ($) {
      return $.xX;
    }, $elm$core$String$append('-')), string)))));
  };
  var $elm$core$List$intersperse = F2(function (sep, xs) {
    if (!xs.b) {
      return _List_Nil;
    } else {
      var hd = xs.a;
      var tl = xs.b;
      var step = F2(function (x, rest) {
        return A2($elm$core$List$cons, sep, A2($elm$core$List$cons, x, rest));
      });
      var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
      return A2($elm$core$List$cons, hd, spersed);
    }
  });
  var $author$project$AssetsSvg$mastercardLogo_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M20.0058 25.1854C21.271 26.3149 22.9701 27 24.8182 27C28.7872 27 31.9996 23.8636 31.9996 20.0059C31.9996 16.1366 28.7872 13 24.8182 13C22.9701 13 21.271 13.685 20.0058 14.8146C18.5546 16.1004 17.6367 17.951 17.6367 20.0059C17.6369 22.0608 18.5546 23.9116 20.0058 25.1854Z'), $elm$svg$Svg$Attributes$fill('white')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M31.0449 23.8994C31.0449 23.7791 31.1442 23.6831 31.2681 23.6831C31.4045 23.6831 31.5036 23.7793 31.5036 23.8994C31.5036 24.0317 31.4043 24.1278 31.2681 24.1278C31.1442 24.1278 31.0449 24.0317 31.0449 23.8994ZM31.2681 24.0798C31.3674 24.0798 31.454 23.9955 31.454 23.8995C31.454 23.8035 31.3672 23.7313 31.2681 23.7313C31.1811 23.7313 31.0946 23.8035 31.0946 23.8995C31.0946 23.9955 31.1813 24.0798 31.2681 24.0798ZM31.2433 24.0077H31.1937V23.8033H31.2804C31.2929 23.8033 31.3178 23.8033 31.33 23.8155C31.3548 23.8274 31.3548 23.8395 31.3548 23.8636C31.3548 23.8876 31.3426 23.9117 31.3178 23.9117L31.3674 24.0078H31.3052L31.2804 23.9235H31.2433V24.0077V23.8875H31.2929C31.3052 23.8875 31.3052 23.8753 31.3052 23.8634C31.3052 23.8513 31.3052 23.8513 31.2929 23.8394H31.2433V24.0077Z'), $elm$svg$Svg$Attributes$fill('white')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M22.3257 19.261C22.3009 19.0087 22.2512 18.7684 22.2016 18.5159H17.8108C17.8605 18.2636 17.9349 18.0233 18.0092 17.7829H21.9908C21.9044 17.5299 21.805 17.2812 21.6931 17.0378H18.3194C18.4435 16.7833 18.5801 16.5346 18.7287 16.2927H21.2716C21.1079 16.0361 20.9256 15.7911 20.7259 15.5597H19.2746C19.4991 15.2941 19.7437 15.045 20.0064 14.8146C18.7289 13.697 17.042 13 15.1814 13C11.2248 13 8 16.1366 8 20.0059C8 23.8636 11.2248 27 15.1814 27C17.042 27 18.7287 26.3149 20.0064 25.1854C20.265 24.959 20.5056 24.7139 20.7259 24.4522H19.2746C19.076 24.2119 18.9025 23.9716 18.7287 23.7071H21.2716C21.4314 23.4695 21.5724 23.2204 21.6933 22.9621H18.3194C18.2077 22.7218 18.0962 22.4815 18.0092 22.2289H21.9908C22.0775 21.9886 22.1397 21.7364 22.2014 21.4838C22.2511 21.2435 22.3007 20.9913 22.3255 20.7387C22.3507 20.4951 22.3631 20.2504 22.3629 20.0055C22.3629 19.7536 22.3505 19.5013 22.3257 19.261Z'), $elm$svg$Svg$Attributes$fill('white')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M31.0449 21.6283C31.0449 21.4962 31.1442 21.4001 31.2681 21.4001C31.4045 21.4001 31.5036 21.4963 31.5036 21.6283C31.5036 21.7485 31.4043 21.8567 31.2681 21.8567C31.1442 21.8567 31.0449 21.7484 31.0449 21.6283ZM31.2681 21.7964C31.3674 21.7964 31.454 21.7243 31.454 21.6283C31.454 21.5322 31.3672 21.4601 31.2681 21.4601C31.1811 21.4601 31.0946 21.5322 31.0946 21.6283C31.0946 21.7243 31.1813 21.7964 31.2681 21.7964ZM31.2433 21.7243H31.1937V21.5321H31.33C31.3548 21.5443 31.3548 21.5683 31.3548 21.5924C31.3548 21.6042 31.3426 21.6283 31.3178 21.6404L31.3674 21.7245H31.3052L31.2804 21.6523H31.2433V21.7243V21.6163H31.2681C31.2804 21.6163 31.2929 21.6163 31.2929 21.6041C31.3052 21.6041 31.3052 21.5922 31.3052 21.5801C31.3052 21.5801 31.3052 21.5682 31.2929 21.5682C31.2929 21.556 31.2804 21.5682 31.2681 21.5682H31.2433V21.7243Z'), $elm$svg$Svg$Attributes$fill('white')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M17.563 22.0249C17.3274 22.0849 17.1537 22.1211 16.9801 22.1211C16.608 22.1211 16.3846 21.8927 16.3846 21.4841C16.3846 21.4001 16.397 21.3159 16.4094 21.2197L16.4591 20.9435L16.4963 20.7151L16.8312 18.7444H17.5754L17.4885 19.177H17.9599L17.8482 19.898H17.3769L17.1785 21.0756C17.1661 21.1359 17.1661 21.1718 17.1661 21.1958C17.1661 21.3521 17.2405 21.4121 17.4265 21.4121C17.5133 21.4121 17.5876 21.4002 17.6621 21.388L17.563 22.0249ZM19.9693 22.0009C19.6965 22.073 19.4484 22.1089 19.1755 22.1089C18.332 22.1089 17.8482 21.6763 17.8482 20.8233C17.8482 19.8258 18.4189 19.1047 19.2125 19.1047C19.8451 19.1047 20.2544 19.5133 20.2544 20.1501C20.2544 20.3666 20.2296 20.5708 20.1677 20.8592H18.6172C18.6048 20.9073 18.6048 20.9313 18.6048 20.9554C18.6048 21.2919 18.8404 21.46 19.287 21.46C19.5722 21.46 19.8203 21.4001 20.0932 21.28L19.9693 22.0009ZM19.5103 20.2824V20.1382C19.5103 19.8979 19.3738 19.7656 19.1382 19.7656C18.8901 19.7656 18.7165 19.9458 18.6421 20.2823H19.5103V20.2824ZM11.6094 22.0608H10.8403L11.2869 19.3331L10.2823 22.0608H9.749L9.68696 19.3452L9.21559 22.0608H8.45898L9.0667 18.5159H10.1954L10.2202 20.7032L10.9768 18.5159H12.2172L11.6094 22.0608ZM13.4824 20.7752C13.408 20.763 13.3832 20.763 13.3335 20.763C12.887 20.763 12.6638 20.9312 12.6638 21.1957C12.6638 21.376 12.7754 21.4962 12.949 21.4962C13.3211 21.4962 13.4699 21.1957 13.4824 20.7752ZM14.1025 22.0608H13.4328L13.4452 21.7606C13.2715 21.9887 13.0359 22.1089 12.6265 22.1089C12.2544 22.1089 11.932 21.7846 11.932 21.3159C11.932 21.1838 11.9568 21.0637 11.994 20.9435C12.118 20.4987 12.5769 20.2225 13.2839 20.2103C13.3707 20.2103 13.5071 20.2103 13.6312 20.2225C13.6558 20.1263 13.6558 20.0901 13.6558 20.0301C13.6558 19.8378 13.4947 19.7777 13.135 19.7777C12.9118 19.7777 12.6636 19.8137 12.4901 19.8738L12.3784 19.8979L12.3287 19.9098L12.4404 19.2609C12.8001 19.1527 13.0605 19.1047 13.3459 19.1047C14.0157 19.1047 14.3754 19.4051 14.3754 19.9579C14.3754 20.1021 14.3878 20.2103 14.3382 20.5227L14.1646 21.5562L14.1398 21.7365L14.1274 21.8808L14.1149 21.977L14.1025 22.0608ZM23.7151 19.2009C23.9383 19.2009 24.1369 19.261 24.4097 19.3931L24.546 18.624C24.4716 18.5879 24.4468 18.5879 24.3477 18.5519L24.0377 18.4677C23.9385 18.4437 23.8145 18.4316 23.6779 18.4316C23.2932 18.4316 23.07 18.4437 22.8346 18.5759C22.7105 18.6601 22.5492 18.7683 22.3755 18.9605L22.2762 18.9364L21.4824 19.4771L21.5197 19.1767H20.7009L20.2175 22.0607H20.999L21.2841 20.5107C21.2841 20.5107 21.396 20.2942 21.4454 20.2223C21.5943 20.042 21.7183 20.042 21.8794 20.042H21.9416C21.9156 20.2252 21.9031 20.4099 21.9043 20.5947C21.9043 21.532 22.4499 22.1209 23.2934 22.1209C23.5043 22.1209 23.6906 22.0969 23.9757 22.0248L24.1123 21.2077C23.8643 21.3398 23.641 21.3999 23.4548 21.3999C22.996 21.3999 22.7229 21.0634 22.7229 20.5348C22.7226 19.7536 23.1321 19.2009 23.7151 19.2009ZM30.301 18.5159L30.1276 19.5254C29.9414 19.249 29.7181 19.1167 29.4204 19.1167C29.011 19.1167 28.6266 19.345 28.3908 19.7777V19.7658L27.8948 19.4773L27.9444 19.1769H27.1134L26.642 22.0608H27.411L27.6716 20.5109C27.6716 20.5109 27.87 20.2943 27.9196 20.2225C28.0437 20.0782 28.1676 20.054 28.2669 20.0422C28.1802 20.2824 28.1306 20.5708 28.1306 20.8954C28.1306 21.6165 28.5149 22.097 29.0854 22.097C29.3708 22.097 29.594 22.0009 29.8048 21.7725L29.7677 22.0608H30.4996L31.095 18.5159H30.301ZM29.3461 21.376C29.0856 21.376 28.9492 21.1838 28.9492 20.8111C28.9492 20.2462 29.1972 19.8378 29.5568 19.8378C29.8296 19.8378 29.9662 20.0422 29.9662 20.4027C29.9662 20.9794 29.7182 21.376 29.3461 21.376ZM25.7618 20.7752C25.6873 20.763 25.6625 20.763 25.6129 20.763C25.166 20.763 24.9428 20.9312 24.9428 21.1957C24.9428 21.376 25.0546 21.4962 25.2282 21.4962C25.6003 21.4962 25.7492 21.1957 25.7618 20.7752ZM26.3819 22.0608H25.6996L25.7244 21.7606C25.5508 21.9887 25.3149 22.1089 24.9059 22.1089C24.5212 22.1089 24.1865 21.7965 24.1865 21.3159C24.1865 20.6311 24.7196 20.2105 25.5631 20.2105C25.6501 20.2105 25.7863 20.2105 25.8981 20.2226C25.9229 20.1264 25.9355 20.0902 25.9355 20.0303C25.9355 19.8379 25.7742 19.7778 25.4021 19.7778C25.1911 19.7778 24.9307 19.8139 24.7571 19.874L24.6579 19.898L24.6082 19.9099L24.7198 19.261C25.0796 19.1528 25.3402 19.1049 25.6253 19.1049C26.295 19.1049 26.6423 19.4053 26.6423 19.958C26.6423 20.1023 26.6671 20.2105 26.6052 20.5229L26.4439 21.5563L26.4191 21.7367L26.3943 21.8809L26.382 21.9771V22.0608H26.3819ZM15.7273 19.7897C15.8762 19.7897 16.087 19.8017 16.3103 19.8378L16.422 19.1648C16.1987 19.1408 15.901 19.1047 15.7273 19.1047C14.8591 19.1047 14.5739 19.5614 14.5739 20.0901C14.5739 20.4387 14.7351 20.6909 15.1568 20.8831C15.4669 21.0274 15.5165 21.0513 15.5165 21.1837C15.5165 21.3637 15.3553 21.4721 15.0575 21.4721C14.8219 21.4721 14.5986 21.4358 14.3506 21.3518L14.2637 22.0126L14.276 22.0248L14.4249 22.0488C14.4745 22.0607 14.5365 22.0729 14.6234 22.0847C14.8094 22.0969 14.9707 22.1088 15.0699 22.1088C15.9382 22.1088 16.2979 21.7845 16.2979 21.1475C16.2979 20.751 16.0994 20.5107 15.7149 20.3426C15.38 20.1982 15.3428 20.1744 15.3428 20.042C15.3428 19.9099 15.4917 19.7897 15.7273 19.7897Z'), $elm$svg$Svg$Attributes$fill('#20508C')]), _List_Nil)]));
  };
  var $author$project$AssetsSvg$mastercardLogo = function (classes) {
    return $author$project$AssetsSvg$mastercardLogo_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $elm$svg$Svg$Attributes$mask = _VirtualDom_attribute('mask');
  var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');
  var $author$project$AssetsSvg$paymentMethod_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 288 168'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$mask('url(#generatedSvgId_1mxat_20)')]), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$width('288'), $elm$svg$Svg$Attributes$height('168'), $elm$svg$Svg$Attributes$rx('16'), $elm$svg$Svg$Attributes$fill('url(#generatedSvgId_1mxat_17)')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M-31.8862 -17.7188V178.5H146.057C62.0278 178.5 89.4852 -17.7188 -31.8862 -17.7188Z'), $elm$svg$Svg$Attributes$fill('url(#generatedSvgId_1mxat_18)')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M346.22 178.5V-17.7188H168.277C252.306 -17.7188 224.848 178.5 346.22 178.5Z'), $elm$svg$Svg$Attributes$fill('url(#generatedSvgId_1mxat_19)')]), _List_Nil)]))]));
  };
  var $author$project$AssetsSvg$paymentMethod = function (classes) {
    return $author$project$AssetsSvg$paymentMethod_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
  var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
  var $author$project$AssetsSvg$paymentMethodSelected_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 288 168'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$mask('url(#generatedSvgId_1mxat_15)')]), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$width('288'), $elm$svg$Svg$Attributes$height('168'), $elm$svg$Svg$Attributes$rx('16'), $elm$svg$Svg$Attributes$fill('url(#generatedSvgId_1mxat_11)')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M-31.8857 -17.7188V178.5H146.057C62.0283 178.5 89.4857 -17.7188 -31.8857 -17.7188Z'), $elm$svg$Svg$Attributes$fill('url(#generatedSvgId_1mxat_12)')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M346.22 178.5V-17.7188H168.277C252.306 -17.7188 224.848 178.5 346.22 178.5Z'), $elm$svg$Svg$Attributes$fill('url(#generatedSvgId_1mxat_13)')]), _List_Nil), A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$x('2'), $elm$svg$Svg$Attributes$y('2'), $elm$svg$Svg$Attributes$width('284'), $elm$svg$Svg$Attributes$height('164'), $elm$svg$Svg$Attributes$rx('14'), $elm$svg$Svg$Attributes$stroke('url(#generatedSvgId_1mxat_14)'), $elm$svg$Svg$Attributes$strokeWidth('4')]), _List_Nil)]))]));
  };
  var $author$project$AssetsSvg$paymentMethodSelected = function (classes) {
    return $author$project$AssetsSvg$paymentMethodSelected_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$ElmFramework$Lib$Ui$PreventClickPropagation$preventClickPropagationWithAttr = F2(function (attrs, content) {
    return A3($elm$html$Html$node, 'prevent-click-propagation', attrs, content);
  });
  var $author$project$Ui$CheckBox$radioBtn = function (config) {
    var styles = $author$project$Ui$CheckBox$checkBoxStyles(config.ux);
    return $author$project$Ui$CheckBox$check({
      mi: styles.mi + ' circle ',
      uj: 'w3 h3 circle noOverflow ' + (A3($author$project$ElmFramework$Lib$Util$ifElse, '  ', ' noPointerEvents ', !config.ux) + config.uj),
      wE: $elm$core$Maybe$Just(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w2 ')]), _List_fromArray([$author$project$IconSvg$checkBold(styles.ea)]))),
      od: config.od,
      eh: config.eh,
      xi: config.xi,
      Cu: config.Cu,
      sI: styles.sI + ' circle '
    });
  };
  var $author$project$AssetsSvg$visaLogo_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M18.4042 22.8833H16.4459L17.6698 16.1208H19.6284L18.4042 22.8833ZM14.7984 16.1208L12.9314 20.7721L12.7105 19.7705L12.7107 19.7709L12.0517 16.7297C12.0517 16.7297 11.972 16.1208 11.1227 16.1208H8.03622L8 16.2353C8 16.2353 8.94386 16.4119 10.0485 17.0083L11.7499 22.8835H13.7903L16.906 16.1208H14.7984ZM30.2018 22.8833H32L30.4322 16.1207H28.8579C28.131 16.1207 27.9539 16.6246 27.9539 16.6246L25.0332 22.8833H27.0746L27.4829 21.8788H29.9724L30.2018 22.8833ZM28.0469 20.4912L29.0759 17.9605L29.6547 20.4912H28.0469ZM25.1863 17.7471L25.4658 16.2949C25.4658 16.2949 24.6034 16 23.7044 16C22.7326 16 20.4247 16.3819 20.4247 18.2387C20.4247 19.9858 23.1334 20.0075 23.1334 20.9252C23.1334 21.8428 20.7038 21.6784 19.902 21.0997L19.6109 22.6181C19.6109 22.6181 20.4853 23 21.8213 23C23.1577 23 25.1738 22.3779 25.1738 20.6848C25.1738 18.9265 22.4408 18.7628 22.4408 17.9983C22.441 17.2337 24.3483 17.3319 25.1863 17.7471Z'), $elm$svg$Svg$Attributes$fill('white')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M12.7107 19.7741L12.0517 16.7297C12.0517 16.7297 11.972 16.1201 11.1227 16.1201H8.03622L8 16.2347C8 16.2347 9.4835 16.5114 10.9064 17.5482C12.267 18.5391 12.7107 19.7741 12.7107 19.7741Z'), $elm$svg$Svg$Attributes$fill('white')]), _List_Nil)]));
  };
  var $author$project$AssetsSvg$visaLogo = function (classes) {
    return $author$project$AssetsSvg$visaLogo_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$PaymentCard$paymentCard = function (cfg) {
    var removeButton = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$Util$noOpEl, function (onRemove) {
      return $author$project$Ui$Button$button({
        bh: 'w7q h3 backBtnBackground radius2 heading6Bold white',
        fn: $elm$html$Html$text('Remove'),
        xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onRemove)
      });
    }, A2($elm_community$maybe_extra$Maybe$Extra$andMap, cfg.Ad, cfg.pX));
    var maybeNetworkLogo = function (classes) {
      var icon = function () {
        var _v0 = A3($elm$core$String$replace, ' ', '', $elm$core$String$toLower($elm_community$string_extra$String$Extra$humanize(cfg.tZ)));
        switch (_v0) {
          case 'visa':
            return $elm$core$Maybe$Just($author$project$AssetsSvg$visaLogo);
          case 'mastercard':
            return $elm$core$Maybe$Just($author$project$AssetsSvg$mastercardLogo);
          case 'americanexpress':
            return $elm$core$Maybe$Nothing;
          case 'dinersclub':
            return $elm$core$Maybe$Nothing;
          case 'discover':
            return $elm$core$Maybe$Nothing;
          case 'jcb':
            return $elm$core$Maybe$Nothing;
          default:
            return $elm$core$Maybe$Nothing;
        }
      }();
      return A2($elm$core$Maybe$map, function (f) {
        return f(classes);
      }, icon);
    };
    var defaultBtn = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter')]), _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$PreventClickPropagation$preventClickPropagationWithAttr, _List_Nil, _List_fromArray([A2($elm$html$Html$label, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular gray0 marRight1 '), $elm$html$Html$Attributes$for(A3($elm_community$maybe_extra$Maybe$Extra$unwrap, 'payment-method-id', $author$project$Types$PaymentMethod$unwrapPaymentMethodId, cfg.Ad))]), _List_fromArray([$elm$html$Html$text('Default')]))])), $author$project$Ui$CheckBox$radioBtn({
      uj: '',
      ux: 0,
      od: '01',
      eh: cfg.oC,
      xi: false,
      Cu: cfg.p$
    })]));
    var cardBorder = cfg.xj ? $author$project$AssetsSvg$paymentMethodSelected : $author$project$AssetsSvg$paymentMethod;
    var accountNum = function () {
      var circle = function (circleClasses) {
        return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('smallCircleHeight smallCircleWidth gray0Back circle '), $elm$html$Html$Attributes$class(circleClasses)]), _List_Nil);
      };
      return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$Util$noOpEl, function (last4) {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marLeft-0h')]), $elm$core$List$concat(A2($elm$core$List$intersperse, _List_fromArray([$author$project$ElmFramework$Lib$Util$spacer('w2')]), A3($author$project$ElmFramework$Lib$Util$flip, $elm$core$List$append, _List_fromArray([_List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray0 heading4Bold')]), _List_fromArray([$elm$html$Html$text(last4)]))])]), A2($elm$core$List$repeat, 3, A2($elm$core$List$repeat, 4, circle('marLeft0h')))))));
      }, cfg.xw);
    }();
    return $author$project$Ui$Button$button({
      bh: 'fullWidth ' + cfg.uj,
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative')]), _List_fromArray([cardBorder('fullWidth'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread  flexColumn spaceBetween  pad3')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow')]), _List_fromArray([A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, maybeNetworkLogo('w5 h5 marTop-1h')), $author$project$ElmFramework$Lib$Util$spacer('flex1'), removeButton])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn spaceBetween flex1 marLeft1  noOverflow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop1 minH3 heading5Regular gray0 left ellipsis')]), _List_fromArray([$elm$html$Html$text(cfg.i5)])), accountNum, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow  flexAligncenter spaceBetween')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('notesBold gray0 o7 ')]), _List_fromArray([$elm$html$Html$text('Expiry date')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('minH3 gray0 heading6Regular left')]), _List_fromArray([$elm$html$Html$text(cfg.v4)]))]))]))]))]))])),
      xu: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$Ui$Button$NoAction, $author$project$ElmFramework$Lib$Ui$Button$Button, A2($elm_community$maybe_extra$Maybe$Extra$andMap, cfg.Ad, cfg.p_))
    });
  };
  var $author$project$Mock$email = 'name@domain.com';
  var $author$project$Mock$phone = '0123456789';
  var $author$project$Mock$stripeAddress = {
    ug: $elm$core$Maybe$Just('city'),
    mA: $elm$core$Maybe$Just('country'),
    xJ: $elm$core$Maybe$Just('line1'),
    xK: $elm$core$Maybe$Just('line2'),
    Aw: $elm$core$Maybe$Just('postalCode'),
    AL: $elm$core$Maybe$Just('province')
  };
  var $author$project$Mock$billingDetails = {
    cy: $elm$core$Maybe$Just($author$project$Mock$stripeAddress),
    bZ: $elm$core$Maybe$Just($author$project$Mock$email),
    Aq: $elm$core$Maybe$Just($author$project$Mock$phone)
  };
  var $author$project$Mock$cardExpiry = {
    pt: 7,
    ta: 2042
  };
  var $author$project$Mock$savedPaymentMethodStripeCard = {
    tR: $author$project$Mock$billingDetails,
    tZ: 'Master Card',
    v4: $author$project$Mock$cardExpiry,
    xw: '1234'
  };
  var $author$project$Mock$savedPaymentMethodStripeDetails = $author$project$Types$PaymentMethod$Card($author$project$Mock$savedPaymentMethodStripeCard);
  var $author$project$Mock$stripePaymentMethod = {
    vp: $author$project$Mock$savedPaymentMethodStripeDetails,
    od: 'stripe-payment-method-id',
    C$: 'StripePaymentMethodType'
  };
  var $author$project$Mock$paymentMethod = {
    od: 'payment-method-id',
    Cj: $author$project$Mock$stripePaymentMethod
  };
  var $author$project$Ui$MatchmakingCards$playerBigAvatar = function (cfg) {
    var _v0 = function () {
      var _v1 = cfg.fr;
      if (!_v1.$) {
        var id = _v1.a;
        return _Utils_eq(id, cfg.od) ? _Utils_Tuple3(A2($author$project$ElmFramework$Lib$Ui$PreventClickPropagation$preventClickPropagationWithAttr, _List_fromArray([$elm$html$Html$Attributes$class('absolute right0 bottom0  ')]), _List_fromArray([$author$project$Ui$Button$button({
          bh: ' w4 h4 pad0h primary80Back circle  ',
          fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' w3 h3 ')]), _List_fromArray([$author$project$IconSvg$close1('w3 gray0Fill ')])),
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.f3)
        })])), ' ', ' gradient10Back hairLinePad ') : _Utils_Tuple3($author$project$ElmFramework$Lib$Util$noOpEl, ' o5 ', 'borderDashed primary40Border borderW125 ');
      } else {
        return _Utils_Tuple3($author$project$ElmFramework$Lib$Util$noOpEl, ' ', 'borderDashed primary40Border borderW125 ');
      }
    }();
    var deleteBtn = _v0.a;
    var avatarClasses = _v0.b;
    var gradientBorder = _v0.c;
    var _v2 = function () {
      var _v3 = cfg.gd;
      if (!_v3.$) {
        var playerinfo = _v3.a;
        return _Utils_Tuple2(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' relative trans3  ' + avatarClasses)]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
          t_: cfg.t_,
          uj: '',
          wG: playerinfo.wG,
          Dq: 8,
          s5: ' relative block w8 h8 circle noOverflow '
        }), deleteBtn])), playerinfo.i5);
      } else {
        return _Utils_Tuple2(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w8 h8  circle  noOverflow primary80Back ' + gradientBorder)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' primary80Back fullWidth fullHeight circle ')]), _List_Nil)])), 'Available');
      }
    }();
    var avatar = _v2.a;
    var name = _v2.b;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexCenterColumn maxW8 noOverflow '), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([$author$project$Ui$Button$button({
      bh: '',
      fn: avatar,
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.p_)
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' bodyRegular secondary800 ellipsis fullWidth center ')]), _List_fromArray([$elm$html$Html$text(name)]))]));
  };
  var $author$project$Ui$BarButton$ArrowButton = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$BarButton$TextButton = {
    $: 1
  };
  var $elm$html$Html$img = _VirtualDom_node('img');
  var $author$project$Ui$BarButton$playerStaffBar = function (cfg) {
    var showContent = function () {
      var arrowOrTextButton = function (arrowOrText) {
        if (!arrowOrText.$) {
          var label = arrowOrText.a;
          return $author$project$Ui$Button$button({
            bh: '',
            fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexCenter pad1')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular primary0')]), _List_fromArray([$elm$html$Html$text(label)])), $author$project$IconSvg$arrowdown('w2 secondary100Fill')])),
            xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Ui$ComponentsPreview$Msg$OnTap)
          });
        } else {
          return $author$project$Ui$Button$textBtn({
            uj: ' heading5Bold secondary100 pad1',
            p_: $author$project$Ui$ComponentsPreview$Msg$OnTap,
            eS: 'RESEND'
          });
        }
      };
      var basePlayerStaffBar = function (arg) {
        var showLocationAddressButton = function () {
          var _v1 = arg.gF;
          if (!_v1.$) {
            var buttonMsg = _v1.a;
            return $author$project$Ui$Button$button({
              bh: '',
              fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marLeft-0h')]), _List_fromArray([$author$project$IconSvg$location('w2 secondary100Fill'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('secondary100 heading5Regular')]), _List_fromArray([$elm$html$Html$text('Location address')]))])),
              xu: $author$project$ElmFramework$Lib$Ui$Button$Button(buttonMsg)
            });
          } else {
            return $author$project$ElmFramework$Lib$Util$noOpEl;
          }
        }();
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular gray80 padBottom1')]), _List_fromArray([$elm$html$Html$text('PLAYER-STAFF')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray10Back radius7 flexRow padTop1h padBottom1h padLeft2 padRight1 spaceBetween flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$img, _List_fromArray([$elm$html$Html$Attributes$class('circle w5 h5'), $elm$html$Html$Attributes$src(arg.gc)]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn padLeft1')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular primary0')]), _List_fromArray([$elm$html$Html$text(arg.At)])), showLocationAddressButton])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1')]), _List_Nil), arrowOrTextButton($author$project$Ui$BarButton$ArrowButton(arg.fc))]))]));
      };
      var _v0 = cfg.Au;
      switch (_v0.$) {
        case 0:
          var playerImg = _v0.a;
          var playerName = _v0.b;
          var msg = _v0.c;
          return basePlayerStaffBar({
            fc: 'Admin',
            gc: playerImg,
            At: playerName,
            gF: msg
          });
        case 1:
          var playerImg = _v0.a;
          var playerName = _v0.b;
          var msg = _v0.c;
          return basePlayerStaffBar({
            fc: 'Bookings',
            gc: playerImg,
            At: playerName,
            gF: msg
          });
        case 2:
          var playerImg = _v0.a;
          var playerName = _v0.b;
          var msg = _v0.c;
          return basePlayerStaffBar({
            fc: 'Edition',
            gc: playerImg,
            At: playerName,
            gF: msg
          });
        default:
          var mail = _v0.a;
          var date = _v0.b;
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray10Back radius7 flexRow padTop1h padBottom1h padLeft2 padRight1 spaceBetween flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular primary0')]), _List_fromArray([$elm$html$Html$text(mail)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular gray80')]), _List_fromArray([$elm$html$Html$text(date)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1')]), _List_Nil), arrowOrTextButton($author$project$Ui$BarButton$TextButton)]));
      }
    }();
    return showContent;
  };
  var $author$project$Ui$ComponentsPreview$ComponentsPreview$playerMock = F3(function (classes1, browser, info) {
    var _v0 = function () {
      if (!info.$) {
        var playerInfo = info.a;
        var gender = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$GraphqlSchema$Enum$Gender$toString, playerInfo.nM));
        return _Utils_Tuple3($author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
          t_: browser,
          uj: ' circle ',
          wG: playerInfo.wG,
          Dq: 4,
          s5: ' relative block w4 h4 circle noOverflow '
        }), A2($elm$html$Html$h3, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular primary0 ellipsis fullWidth center ')]), _List_fromArray([$elm$html$Html$text(playerInfo.i5)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('notesRegular ')]), _List_Nil));
      } else {
        return _Utils_Tuple3(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w4 h4  circle borderDashed primary40Border borderW125 boxSizingBorder noOverflow gray0Back ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_Nil)])), A2($elm$html$Html$h3, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular primary0 ellipsis fullWidth center ')]), _List_fromArray([$elm$html$Html$text('Avaliable')])), $author$project$ElmFramework$Lib$Util$noOpEl);
      }
    }();
    var playerAvatar = _v0.a;
    var name = _v0.b;
    var level = _v0.c;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn w6 noOverflow flexAlignCenter '), $elm$html$Html$Attributes$class(classes1)]), _List_fromArray([playerAvatar, name, level]));
  });
  var $author$project$Ui$ComponentsPreview$ComponentsPreview$verticalLine = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray10Back h5 hairLineWidth')]), _List_Nil);
  var $author$project$Ui$ComponentsPreview$ComponentsPreview$playersRowMock = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('secondary800Back radius5 flexRow padTop2h padBottom2h padRight2 padLeft2 '), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flex1  padRight3 spaceBetween padLeft1hq padTop ')]), A2($elm$core$List$map, A2($author$project$Ui$ComponentsPreview$ComponentsPreview$playerMock, '', cfg.t_), cfg.ge.bm)), $author$project$Ui$ComponentsPreview$ComponentsPreview$verticalLine, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flex1  padLeft3 spaceBetween padRight1hq ')]), A2($elm$core$List$map, A2($author$project$Ui$ComponentsPreview$ComponentsPreview$playerMock, '', cfg.t_), cfg.ge.bz))]));
  };
  var $author$project$Ui$ResultCard$SquashResults = 2;
  var $author$project$Ui$ResultCard$TennisResults = 1;
  var $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$toHotSpot = F2(function (onSelectTag, _v0) {
    var id = _v0.od;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 pointer'), $author$project$ElmFramework$Lib$Util$onTap(onSelectTag(id))]), _List_Nil);
  });
  var $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$toOffStateView = function (_v0) {
    var offState = _v0.pP;
    var _v1 = offState;
    var attrs = _v1.a;
    var content = _v1.b;
    return A2($elm$html$Html$div, _Utils_ap(_List_fromArray([$elm$html$Html$Attributes$class('flex1 flexCenter')]), attrs), content);
  };
  var $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$toOnStateView = function (_v0) {
    var onState = _v0.pZ;
    var _v1 = onState;
    var attrs = _v1.a;
    var content = _v1.b;
    return A2($elm$html$Html$div, _Utils_ap(_List_fromArray([$elm$html$Html$Attributes$class('flex1 flexCenter padTop0h padBottom0h ')]), attrs), content);
  };
  var $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$radioSliderList = function (config) {
    var unselectedItems = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread flexRow ')]), A2($elm$core$List$map, $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$toOffStateView, config.xn));
    var itemsCount = $elm$core$List$length(config.xn);
    var itemPortion = 100 / itemsCount;
    var hotSpots = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread flexRow ')]), A2($elm$core$List$map, $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$toHotSpot(config.zG), config.xn));
    var currItemIndex = A2($elm$core$Maybe$withDefault, 0, A2($elm_community$list_extra$List$Extra$findIndex, function (_v0) {
      var id = _v0.od;
      return _Utils_eq(id, config.u$);
    }, config.xn));
    var selectedItem = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('selectedItem relative noOverflow  '), $elm$html$Html$Attributes$class(config.BP), A2($elm$html$Html$Attributes$style, 'width', $elm$core$String$fromFloat(itemPortion) + '%'), A2($elm$html$Html$Attributes$style, 'transform', 'translateX(' + ($elm$core$String$fromInt(currItemIndex) + '00%) translateZ(1px)'))]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('selectedItems flexRow'), A2($elm$html$Html$Attributes$style, 'width', $elm$core$String$fromInt(itemsCount) + '00%'), A2($elm$html$Html$Attributes$style, 'transform', 'translateX(-' + ($elm$core$String$fromFloat(currItemIndex * itemPortion) + '%)'))]), A2($elm$core$List$map, $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$toOnStateView, config.xn))]));
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(config.bh)]), _List_fromArray([A3($elm$html$Html$node, 'radio-slider', _List_fromArray([$elm$html$Html$Attributes$class('block relative')]), _List_fromArray([unselectedItems, selectedItem, hotSpots]))]));
  };
  var $author$project$Ui$SliderMultipleSelect$sliderMultipleSelect = function (cfg) {
    var colorToggleOption = function () {
      var _v2 = cfg.uy;
      if (!_v2.$) {
        var _v3 = _v2.a;
        return {
          uj: ' lineH5 ',
          pP: 'backgroundGrey  ',
          pZ: 'gray0Back primary0  '
        };
      } else {
        return {
          uj: '',
          pP: '',
          pZ: ''
        };
      }
    }();
    var toItem = function (_v1) {
      var itemId = _v1.a;
      var label = _v1.b;
      var maybeNotificationBadge = _v1.c;
      var notificationBadgeClass = function () {
        if (!maybeNotificationBadge.$ && maybeNotificationBadge.a) {
          return _List_fromArray([$elm$html$Html$Attributes$class('addNotificationCircle')]);
        } else {
          return _List_Nil;
        }
      }();
      return {
        od: itemId,
        pP: _Utils_Tuple2(_List_fromArray([$elm$html$Html$Attributes$class(colorToggleOption.pP)]), _List_fromArray([A2($elm$html$Html$span, notificationBadgeClass, _List_fromArray([$elm$html$Html$text(label)]))])),
        pZ: _Utils_Tuple2(_List_fromArray([$elm$html$Html$Attributes$class(colorToggleOption.pZ), $elm$html$Html$Attributes$class(cfg.zK)]), _List_fromArray([$elm$html$Html$text(label)]))
      };
    };
    return $author$project$ElmFramework$Lib$UiBehavior$RadioSlider$radioSliderList({
      bh: ' maxRadius noOverflow   ' + (colorToggleOption.uj + cfg.uj),
      u$: cfg.u$,
      xn: A2($elm$core$List$map, toItem, cfg.xn),
      zG: cfg.zG,
      BP: '  sliderSelectMultibleTrans maxRadius borderWidth5 borderSolid secondary800Border '
    });
  };
  var $author$project$Ui$ResultCard$resultCard = function (cfg) {
    var staticsBox = F2(function (num, label) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1 padLeft2 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0 heading1Bold  ')]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(num))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray80 heading6Regular ')]), _List_fromArray([$elm$html$Html$text(label)]))]));
    });
    var currSport = function () {
      var _v0 = cfg.u$;
      switch (_v0) {
        case 0:
          return cfg.Bc.z5;
        case 1:
          return cfg.Bc.Cv;
        default:
          return cfg.Bc.B9;
      }
    }();
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth'), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading2Bold primary0 marBottom2  ')]), _List_fromArray([$elm$html$Html$text('Results')])), $author$project$Ui$SliderMultipleSelect$sliderMultipleSelect({
      uj: ' fullWidth heading4Regular',
      uy: $elm$core$Maybe$Just(0),
      u$: cfg.u$,
      xn: _List_fromArray([_Utils_Tuple3(0, 'Padel', $elm$core$Maybe$Nothing), _Utils_Tuple3(1, 'Tennis', $elm$core$Maybe$Nothing), _Utils_Tuple3(2, 'Squash', $elm$core$Maybe$Nothing)]),
      zG: cfg.zG,
      zK: ''
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop2 flexRow spaceBetween ')]), _List_fromArray([A2(staticsBox, currSport.a + currSport.b, 'Total macthes'), A2(staticsBox, currSport.a, 'Won'), A2(staticsBox, currSport.b, 'Lost')]))]));
  };
  var $author$project$Ui$SwitchLeftLabel$roundedImgBox = function (cfg) {
    var extraImages = function () {
      var _v0 = cfg.h_;
      if (!_v0.$) {
        var num = _v0.a;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('secondary200 primary100Back  heading4Bold absoluteSpread flexCenter radius2 ')]), _List_fromArray([$elm$html$Html$text('+' + $elm$core$String$fromInt(num))]));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();
    return $author$project$Ui$Button$button({
      bh: '' + cfg.uj,
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
        t_: cfg.t_,
        uj: '',
        wG: cfg.om,
        Dq: 6,
        s5: ' relative block w6 h6 radius2  noOverflow '
      }), extraImages])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.p_)
    });
  };
  var $author$project$Ui$ComponentsPreview$Msg$RouteTo = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn = F2(function (label, route) {
    return $author$project$Ui$Button$button({
      bh: '  marBottom1h block heading5Regular left ',
      fn: $elm$html$Html$text(label),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Ui$ComponentsPreview$Msg$RouteTo(route))
    });
  });
  var $author$project$Ui$Input$searchBar = function (cfg) {
    var styles = A2($author$project$Ui$Input$inputStyles, cfg.Cd, false);
    var isFilled = cfg.s_ === '' ? false : true;
    var closeBtn = function () {
      var toggleClasses = isFilled ? '' : ' o0 noPointerEvents ';
      var _v0 = cfg.Cd;
      switch (_v0.$) {
        case 1:
          var message = _v0.a;
          return $author$project$ElmFramework$Lib$Util$noOpEl;
        case 2:
          return $author$project$ElmFramework$Lib$Util$noOpEl;
        default:
          return $author$project$Ui$Button$button({
            bh: 'w3 h3 absoluteCenterY right1 trans3 secondary100Fill  ' + toggleClasses,
            fn: A2($elm$html$Html$span, _List_Nil, _List_fromArray([$author$project$IconSvg$close1('w3 ')])),
            xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.pR)
          });
      }
    }();
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.bh), $elm$html$Html$Attributes$class('')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative radius7 flexRow flexAlignCenter spaceBetween  '), $elm$html$Html$Attributes$class(styles.aS)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread radius7  borderSolid   hairLineBorderWidth  ' + styles.cJ)]), _List_Nil), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w3 h3 absoluteCenterY left1 ')]), _List_fromArray([$author$project$IconSvg$search('w3 ' + styles.eE)])), $author$project$ElmFramework$Lib$Ui$Input$input_custom({
      bP: $elm$core$Maybe$Nothing,
      bh: 'heading5Regular padTop1h padBottom1h padLeft5 padRight5  relative  flex1 sticky  ' + styles.oq,
      bY: styles.bY,
      od: cfg.od,
      wQ: cfg.wQ,
      bu: cfg.bu,
      bv: cfg.bv,
      ch: cfg.ch,
      s_: cfg.s_
    }), closeBtn]))]));
  };
  var $author$project$Ui$SelectItem$selectOptionBar = function (cfg) {
    var selectOptionBarStatus = cfg.xa ? _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular gray80 padBottom1')]), _List_fromArray([$elm$html$Html$text('Disabled')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray10Back pad2 radius7 heading5Regular gray60')]), _List_fromArray([$elm$html$Html$text('Disabled')]))]) : _List_fromArray([$author$project$Ui$Button$selectButtonItem({
      uj: ' left fullWidth radius7',
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' radius18 padTop1h padBottom1h padLeft2 padRight2 heading5Regular '), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('primary0 gray10Back', cfg.xj), _Utils_Tuple2('gray60 secondary800Back ', !cfg.xj)]))]), _List_fromArray([$elm$html$Html$text(cfg.lh)])),
      xa: false,
      xj: cfg.xj,
      Cu: cfg.Cu
    })]);
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.uj)]), selectOptionBarStatus);
  };
  var $author$project$AssetsSvg$emptyAvatar_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 64 64'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$width('64'), $elm$svg$Svg$Attributes$height('64'), $elm$svg$Svg$Attributes$rx('16'), $elm$svg$Svg$Attributes$fill('#D1D6DC')]), _List_Nil), A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$mask('url(#generatedSvgId_1mxat_7)')]), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M31.9993 41.3333C37.8904 41.3333 42.666 36.5577 42.666 30.6667C42.666 24.7756 37.8904 20 31.9993 20C26.1083 20 21.3327 24.7756 21.3327 30.6667C21.3327 36.5577 26.1083 41.3333 31.9993 41.3333Z'), $elm$svg$Svg$Attributes$fill('white')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M31.9993 86.6667C43.7814 86.6667 53.3327 77.1154 53.3327 65.3333C53.3327 53.5513 43.7814 44 31.9993 44C20.2173 44 10.666 53.5513 10.666 65.3333C10.666 77.1154 20.2173 86.6667 31.9993 86.6667Z'), $elm$svg$Svg$Attributes$fill('white')]), _List_Nil)]))]));
  };
  var $author$project$AssetsSvg$emptyAvatar = function (classes) {
    return $author$project$AssetsSvg$emptyAvatar_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$SelectItem$selectXrivalsContact = function (cfg) {
    var noPointerEvents = cfg.xf ? ' noPointerEvents' : '';
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(_Utils_ap(cfg.uj, noPointerEvents))]), _List_fromArray([$author$project$Ui$Button$selectButtonItem({
      uj: ' left fullWidth radius7',
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('secondary800Back radius18 flexRow padTop1q padBottom1q padLeft2 padRight1hq spaceBetween flexAlignCenter')]), _List_fromArray([A2($elm$core$Maybe$withDefault, $author$project$AssetsSvg$emptyAvatar('circle w5 h5'), A2($elm$core$Maybe$map, function (photoUrl) {
        return A2($elm$html$Html$img, _List_fromArray([$elm$html$Html$Attributes$class('circle w5 h5'), $elm$html$Html$Attributes$src(photoUrl)]), _List_Nil);
      }, cfg.om)), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn padLeft1')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular primary0')]), _List_fromArray([$elm$html$Html$text(cfg.At)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray80 heading6Regular')]), _List_fromArray([$elm$html$Html$text($author$project$Types$Gender$toString(cfg.nM))]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1')]), _List_Nil)])),
      xa: false,
      xj: cfg.xj,
      Cu: cfg.Cu
    })]));
  };
  var $author$project$IconSvg$settings_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M22.8662 30.9051C23.1004 30.9615 23.3346 30.9954 23.5688 30.9954C24.0372 30.9954 24.4944 30.8713 24.9182 30.6343L26.8476 29.5171C27.539 29.1222 28.0297 28.4789 28.2305 27.7003C28.4424 26.933 28.3309 26.1205 27.9405 25.4321C27.6059 24.8566 27.5279 24.3375 27.7175 24.0103C27.9071 23.683 28.3866 23.4912 29.0446 23.4912C30.6729 23.4912 32 22.1483 32 20.5008V18.5147C32 16.8672 30.6729 15.5243 29.0446 15.5243C28.3866 15.5243 27.9071 15.3325 27.7175 15.0052C27.5279 14.678 27.6171 14.1589 27.9405 13.5834C28.3309 12.895 28.4312 12.0938 28.2305 11.3152C28.0186 10.5365 27.5279 9.89331 26.8476 9.49835L24.9294 8.38118C23.658 7.61383 21.9963 8.05392 21.2379 9.36293L21.1152 9.57734C20.4572 10.7284 19.5539 10.7284 18.8959 9.57734L18.7621 9.35165C18.0037 8.05392 16.342 7.61383 15.0818 8.36989L13.1524 9.48706C12.461 9.88202 11.9703 10.5252 11.7695 11.3039C11.5688 12.0712 11.6691 12.8837 12.0595 13.5721C12.3941 14.1476 12.4721 14.6667 12.2825 14.9939C12.0929 15.3212 11.6134 15.513 10.9554 15.513C9.32714 15.513 8 16.8559 8 18.5034V20.4895C8 22.137 9.32714 23.4799 10.9554 23.4799C11.6134 23.4799 12.0929 23.6717 12.2825 23.999C12.4721 24.3262 12.3829 24.8453 12.0595 25.4208C11.6691 26.1092 11.5688 26.9104 11.7695 27.689C11.9814 28.4677 12.4721 29.1109 13.1524 29.5058L15.0706 30.623C15.684 30.9954 16.4089 31.097 17.1115 30.9051C17.803 30.7246 18.3829 30.2732 18.7509 29.6413L18.8736 29.4268C19.5316 28.2758 20.4349 28.2758 21.0929 29.4268L21.2268 29.6525C21.5948 30.2732 22.1747 30.7133 22.8662 30.9051ZM22.5428 28.5692C21.9071 27.4521 20.9814 26.8201 19.9888 26.8201C18.9963 26.8201 18.0706 27.4633 17.4349 28.5692L17.3123 28.7836C17.1673 29.0206 16.9442 29.2012 16.6766 29.2689C16.4201 29.3366 16.1413 29.3027 15.9071 29.156L13.9777 28.0388C13.6877 27.8583 13.4758 27.5875 13.3866 27.2489C13.2974 26.9104 13.342 26.5606 13.5093 26.2672C14.145 25.1613 14.223 24.0216 13.7323 23.1526C13.2416 22.2837 12.2268 21.7872 10.9554 21.7872C10.2416 21.7872 9.67286 21.2004 9.67286 20.4895V18.5034C9.67286 17.7812 10.2416 17.2057 10.9554 17.2057C12.2268 17.2057 13.2416 16.7092 13.7323 15.8403C14.223 14.9713 14.145 13.8316 13.5093 12.7257C13.342 12.4323 13.2974 12.0825 13.3866 11.744C13.4758 11.4054 13.6989 11.1233 13.9888 10.9541L15.9182 9.8256C16.3978 9.54348 17.0223 9.71275 17.3011 10.1867L17.4238 10.4124C18.0595 11.5296 18.9851 12.1615 19.9777 12.1615C20.9703 12.1615 21.8959 11.5296 22.5316 10.4124L22.6543 10.198C22.9442 9.70147 23.5799 9.5322 24.0595 9.8256L25.9888 10.9428C26.2788 11.1233 26.4907 11.3941 26.5799 11.7327C26.6691 12.0712 26.6245 12.421 26.4572 12.7144C25.8216 13.8203 25.7435 14.9601 26.2342 15.829C26.7249 16.6979 27.7398 17.1944 29.0112 17.1944C29.7249 17.1944 30.2937 17.7812 30.2937 18.4921V20.4782C30.2937 21.2004 29.7249 21.7759 29.0112 21.7759C27.7398 21.7759 26.7249 22.2724 26.2342 23.1414C25.7435 24.0103 25.8216 25.15 26.4572 26.2559C26.6245 26.5493 26.6691 26.8991 26.5799 27.2376C26.4907 27.5762 26.2677 27.8583 25.9777 28.0276L24.0483 29.156C23.8253 29.2914 23.5576 29.3253 23.29 29.2576C23.0223 29.1899 22.7993 29.0206 22.6654 28.7836L22.5428 28.5692ZM15.8067 19.4964C15.8067 21.8323 17.6803 23.7281 19.9889 23.7281C22.2974 23.7281 24.171 21.8323 24.171 19.4964C24.171 17.1605 22.2974 15.2647 19.9889 15.2647C17.6803 15.2647 15.8067 17.1605 15.8067 19.4964ZM17.4796 19.4964C17.4796 18.0972 18.606 16.9574 19.9889 16.9574C21.3718 16.9574 22.4982 18.0972 22.4982 19.4964C22.4982 20.8957 21.3718 22.0355 19.9889 22.0355C18.606 22.0355 17.4796 20.8957 17.4796 19.4964Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$settings = function (classes) {
    return $author$project$IconSvg$settings_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('radius2 mar2 gray0Back blackBorder')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad1 fontSize0')]), _List_fromArray([$elm$html$Html$text(cfg.lh)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('pad1')]), _List_fromArray([cfg.a]))]));
  };
  var $author$project$Ui$PlayerLevelSlider$sliderBar = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padBottom3 '), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular gray80 padLeft1 padRight1  flexRow spaceBetween')]), _List_fromArray([A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text('0')])), A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text($elm$core$String$fromFloat(cfg.x7))]))])), $author$project$ElmFramework$Lib$Ui$Slider$horizontalSlider({
      oq: 'h3',
      aK: true,
      xa: false,
      ay: cfg.x7,
      Q: 0,
      bu: cfg.bu,
      ah: 'h3',
      a6: 1,
      aj: 'gray0Back w3 h3 flexCenter thumbShadow',
      a7: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w2 relative flexCenter')]), _List_fromArray([$author$project$IconSvg$menuBurgerBold('w2 h2 gray20Fill'), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('absolute top0')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('marTop2h block primary0 heading5Bold')]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromFloat(cfg.s_))]))]))])),
      ak: 'flexCenter h3',
      am: 'gradient20Back radius1',
      an: 'gray10Back',
      ao: '',
      s_: cfg.s_
    })]));
  };
  var $toastal$either$Either$Left = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $toastal$either$Either$Right = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$elementAppearanceToAttributes = F3(function (elementAppearance, isDisabled, defaultDisabledClasses) {
    var defaultDisabled = $elm$core$String$isEmpty(defaultDisabledClasses) ? '' : defaultDisabledClasses + ' ';
    return _List_fromArray([$elm$html$Html$Attributes$class(elementAppearance.nN), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2(elementAppearance.ly, !isDisabled), _Utils_Tuple2(_Utils_ap(defaultDisabled, elementAppearance.m4), isDisabled)]))]);
  });
  var $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$movementToLeftReducesAsRatioRises = function (ratio) {
    return -(100 - ratio * 100);
  };
  var $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$movementToRightIncreasesAsRatioRises = function (ratio) {
    return ratio * 100;
  };
  var $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$percentTranslateXAttribute = function (percent) {
    return A2($elm$html$Html$Attributes$style, 'transform', A3($elm$core$String$replace, '{{amount}}', $elm$core$String$fromFloat(percent), 'translateX({{amount}}%)'));
  };
  var $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$fill = F2(function (side, cfg) {
    var percentMovement = function () {
      if (!side.$) {
        return $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$movementToLeftReducesAsRatioRises;
      } else {
        return $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$movementToRightIncreasesAsRatioRises;
      }
    }()(cfg.h4);
    return A3($elm$html$Html$node, 'fill-element', A2($elm$core$List$cons, $elm$html$Html$Attributes$class('absolute fullWidth noPointerEvents'), A2($elm$core$List$cons, $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$percentTranslateXAttribute(percentMovement), A3($author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$elementAppearanceToAttributes, cfg.P, cfg.xa, ''))), _List_Nil);
  });
  var $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$eventDetailDecoder = A3($elm$json$Json$Decode$map2, $elm$core$Tuple$pair, A2($elm$json$Json$Decode$field, 'startValue', $elm$json$Json$Decode$float), A2($elm$json$Json$Decode$field, 'endValue', $elm$json$Json$Decode$float));
  var $author$project$ElmFramework$Lib$WebComponentsUtil$listenWebComponentEvent = F3(function (eventName, decoder, tag) {
    return A2($elm$html$Html$Events$on, eventName, A2($elm$json$Json$Decode$map, tag, A2($elm$json$Json$Decode$field, 'detail', decoder)));
  });
  var $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$toArithmeticProgressionElementNum = F3(function (n, min_, step) {
    return 1 + (n - min_) / step;
  });
  var $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$toRatioOfDistance = function (cfg) {
    var x = A3($author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$toArithmeticProgressionElementNum, cfg.s_, cfg.Q, cfg.a6);
    var n = A3($author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$toArithmeticProgressionElementNum, cfg.ay, cfg.Q, cfg.a6);
    return (x - 1) / (n - 1);
  };
  var $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$sliderRangeWrapper = F2(function (cfg, content) {
    var ratio = function (value) {
      return $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$toRatioOfDistance({
        ay: cfg.ay,
        Q: cfg.Q,
        a6: cfg.a6,
        s_: value
      });
    };
    return A3($elm$html$Html$node, 'slider-range', A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'step', $elm$core$String$fromFloat(cfg.a6)), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'min', $elm$core$String$fromFloat(cfg.Q)), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'max', $elm$core$String$fromFloat(cfg.ay)), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'start-value', $elm$core$String$fromFloat(cfg.k7)), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'end-value', $elm$core$String$fromFloat(cfg.hS)), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'min-range', $elm$core$String$fromFloat(cfg.yq)), A2($elm$core$List$cons, $elm$html$Html$Attributes$class('relative flexCenter'), A2($elm$core$List$cons, A3($author$project$ElmFramework$Lib$WebComponentsUtil$listenWebComponentEvent, 'onChange', $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$eventDetailDecoder, cfg.yV), A3($author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$elementAppearanceToAttributes, cfg.P.s6, cfg.xa, 'noPointerEvents'))))))))), content(_Utils_Tuple2(ratio(cfg.k7), ratio(cfg.hS))));
  });
  var $toastal$either$Either$isLeft = function (e) {
    if (!e.$) {
      return true;
    } else {
      return false;
    }
  };
  var $toastal$either$Either$isRight = function (e) {
    if (e.$ === 1) {
      return true;
    } else {
      return false;
    }
  };
  var $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$movementToLeftIncreasesAsRatioRises = function (ratio) {
    return ratio * -100;
  };
  var $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$movementToRightReducesAsRatioRises = function (ratio) {
    return 100 - ratio * 100;
  };
  var $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$thumb = F2(function (side, cfg) {
    var absolutePositionClass = $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('right0', $toastal$either$Either$isLeft(side)), _Utils_Tuple2('left0', $toastal$either$Either$isRight(side))]));
    var _v0 = function () {
      if (!side.$) {
        return _Utils_Tuple2($author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$movementToLeftReducesAsRatioRises(cfg.dk), $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$movementToRightReducesAsRatioRises(cfg.dk));
      } else {
        return _Utils_Tuple2($author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$movementToRightIncreasesAsRatioRises(cfg.dk), $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$movementToLeftIncreasesAsRatioRises(cfg.dk));
      }
    }();
    var percentMovementWrapper = _v0.a;
    var percentMovementThumb = _v0.b;
    return A3($elm$html$Html$node, 'thumb-wrapper', _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread flexCenter noPointerEvents'), $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$percentTranslateXAttribute(percentMovementWrapper)]), _List_fromArray([A3($elm$html$Html$node, 'thumb-element', A2($elm$core$List$cons, $elm$html$Html$Attributes$class('absolute'), A2($elm$core$List$cons, absolutePositionClass, A2($elm$core$List$cons, $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$percentTranslateXAttribute(percentMovementThumb), A3($author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$elementAppearanceToAttributes, cfg.P, cfg.xa, '')))), cfg.a7)]));
  });
  var $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$trackBackground = function (cfg) {
    return A3($elm$html$Html$node, 'track-background', A2($elm$core$List$cons, $elm$html$Html$Attributes$class('relative noOverflow fullWidth'), A3($author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$elementAppearanceToAttributes, cfg.P, cfg.xa, '')), cfg.fn);
  };
  var $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$sliderRange = function (cfg) {
    return A2($author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$sliderRangeWrapper, cfg, function (_v0) {
      var startRatio = _v0.a;
      var endRatio = _v0.b;
      return _List_fromArray([$author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$trackBackground({
        P: cfg.P.sB,
        fn: _List_fromArray([A2($author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$fill, $toastal$either$Either$Left(0), {
          P: cfg.P.h3,
          h4: startRatio,
          xa: cfg.xa
        }), A2($author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$fill, $toastal$either$Either$Right(0), {
          P: cfg.P.h3,
          h4: endRatio,
          xa: cfg.xa
        })]),
        xa: cfg.xa
      }), A2($author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$thumb, $toastal$either$Either$Left(0), {
        P: cfg.P.ld,
        xa: cfg.xa,
        a7: cfg.st($toastal$either$Either$Left(cfg.k7)),
        dk: startRatio
      }), A2($author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$thumb, $toastal$either$Either$Right(0), {
        P: cfg.P.ld,
        xa: cfg.xa,
        a7: cfg.st($toastal$either$Either$Right(cfg.hS)),
        dk: endRatio
      })]);
    });
  };
  var $author$project$Ui$SliderRange$sliderRangeAppearance = {
    h3: {
      ly: 'gray10Back',
      m4: 'gray10Back',
      nN: 'h1'
    },
    ld: {
      ly: 'gray0Back',
      m4: 'gray40Back',
      nN: 'inlineBlock circle w3 h3 flexCenter thumbShadow'
    },
    sB: {
      ly: 'gradient20Back',
      m4: 'gray20Back',
      nN: 'radius1 h1'
    },
    s6: {
      ly: '',
      m4: '',
      nN: 'h3 radius1'
    }
  };
  var $author$project$Ui$SliderRange$sliderRange = function (cfg) {
    return $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$sliderRange({
      P: $author$project$Ui$SliderRange$sliderRangeAppearance,
      hS: cfg.hS,
      xa: cfg.xa,
      ay: cfg.ay,
      Q: cfg.Q,
      yq: cfg.yq,
      yV: cfg.yV,
      k7: cfg.k7,
      a6: cfg.a6,
      st: $elm$core$Basics$always(_List_fromArray([$author$project$IconSvg$menuBurgerBold('w2 h2 gray20Fill')]))
    });
  };
  var $author$project$Api$GraphqlSchema$Enum$SkillRating$list = _List_fromArray([0, 1, 2, 3, 4]);
  var $author$project$Ui$SportLevelSlider$sportLevelSlider = function (cfg) {
    var valueIndex = A2($elm$core$Maybe$withDefault, 3, A2($elm$core$Maybe$map, $elm$core$Basics$add(1), A2($elm_community$list_extra$List$Extra$elemIndex, cfg.s_, $author$project$Api$GraphqlSchema$Enum$SkillRating$list)));
    var selectNum = F2(function (level, value) {
      var color = _Utils_eq(value, cfg.s_) ? 'primary0' : 'gray20';
      return $author$project$Ui$Button$button({
        bh: '',
        fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold flexCenter w3 h3 trans3'), $elm$html$Html$Attributes$class(color)]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(level + 1))])),
        xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.bu(value))
      });
    });
    var levelLabel = function (val) {
      return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Array$get, val - 1, $elm$core$Array$fromList(_List_fromArray(['First-timer', 'Beginner', 'Intermediate', 'Advanced', 'Pro']))));
    };
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading3Bold gray80 marBottom1')]), _List_fromArray([$elm$html$Html$text(A2($author$project$Types$Activity$toString, false, cfg.dh))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold primary0 marBottom1')]), _List_fromArray([$elm$html$Html$text(levelLabel(valueIndex))])), $author$project$ElmFramework$Lib$Ui$Slider$horizontalSlider({
      oq: 'h3',
      aK: true,
      xa: false,
      ay: 5,
      Q: 1,
      bu: function (input) {
        return cfg.bu(A2($elm$core$Maybe$withDefault, 2, A2($elm_community$list_extra$List$Extra$getAt, $elm$core$Basics$round(input) - 1, $author$project$Api$GraphqlSchema$Enum$SkillRating$list)));
      },
      ah: 'h3',
      a6: 1,
      aj: 'gray0Back w3 h3 flexCenter thumbShadow',
      a7: $author$project$IconSvg$menuBurgerBold('w2 h2 gray20Fill'),
      ak: 'flexCenter h3',
      am: 'gradient20Back radius1',
      an: 'gray10Back',
      ao: '',
      s_: valueIndex
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth flexRow spaceBetween')]), A2($elm$core$List$indexedMap, selectNum, $author$project$Api$GraphqlSchema$Enum$SkillRating$list))]));
  };
  var $author$project$IconSvg$starMed_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M20.4433 8.0981C20.6482 8.19589 20.8138 8.36023 20.9128 8.56419L23.8535 14.6194C23.9706 14.8604 24.1796 15.0445 24.4339 15.1305L31.319 17.4578C31.8433 17.635 32.1243 18.2027 31.9467 18.7258C31.888 18.8989 31.7828 19.0526 31.6426 19.1702L27.4692 22.6728C27.2103 22.8901 27.0788 23.223 27.1194 23.5581L28.0063 30.8765C28.0728 31.4248 27.6811 31.923 27.1316 31.9893C26.9517 32.011 26.7692 31.9836 26.6036 31.9101L20.4122 29.1603C20.1529 29.0451 19.8569 29.045 19.5976 29.16L13.4019 31.9072C12.8961 32.1315 12.3038 31.9042 12.0789 31.3996C12.0047 31.2329 11.9776 31.0492 12.0004 30.8683L12.9238 23.5643C12.9666 23.2259 12.8335 22.889 12.5707 22.6707L8.36098 19.1735C7.93558 18.8201 7.87787 18.1896 8.23208 17.7651C8.35092 17.6227 8.50708 17.5161 8.68314 17.4571L15.6235 15.1309C15.8805 15.0448 16.0916 14.8584 16.2085 14.6144L19.1066 8.56877C19.3455 8.07054 19.9439 7.85981 20.4433 8.0981ZM19.8813 11.5866L18.017 15.4773C17.6953 16.1484 17.1364 16.674 16.4517 16.956L16.2619 17.0268L11.2777 18.6969C11.199 18.7233 11.1566 18.8083 11.183 18.8869C11.1919 18.9132 11.208 18.9366 11.2294 18.9544L13.8534 21.1337C14.5891 21.745 14.986 22.6661 14.9313 23.6117L14.9126 23.8146L14.245 29.0947C14.2346 29.1769 14.293 29.2519 14.3754 29.2623C14.4026 29.2657 14.4302 29.2616 14.4552 29.2505L18.7834 27.3324C19.4966 27.0161 20.3024 26.99 21.0308 27.2539L21.2275 27.3331L25.561 29.2579C25.6369 29.2916 25.7258 29.2575 25.7595 29.1819C25.7706 29.1571 25.7747 29.1298 25.7714 29.1029L25.1293 23.7982C25.0156 22.86 25.3518 21.9274 26.0286 21.2772L26.1788 21.1423L28.7863 18.9529C28.8499 18.8996 28.858 18.8049 28.8046 18.7415C28.7869 18.7206 28.7638 18.7048 28.7377 18.6961L23.7906 17.0247C23.0915 16.7884 22.5062 16.3046 22.143 15.6686L22.0495 15.4915L20.1522 11.5859C20.116 11.5113 20.026 11.4802 19.9513 11.5163C19.9207 11.5311 19.896 11.5559 19.8813 11.5866Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$starMed = function (classes) {
    return $author$project$IconSvg$starMed_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$StepsBar$stepsBar = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn '), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular gray80 flexRow flexAlignCenter marBottom1')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w2 h2 marRight0h ')]), _List_fromArray([$author$project$IconSvg$starMed('gray80Fill w2')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(cfg.u1) + ('/' + ($elm$core$String$fromInt(cfg.Cg) + (': ' + cfg.oR))))]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray10Back radius7 h1 fullWidth relative ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' absolute fullHeight left0 top0 gradient20Back radius7 trans3 '), A2($elm$html$Html$Attributes$style, 'width', $elm$core$String$fromInt($elm$core$Basics$round(cfg.u1 / cfg.Cg * 100)) + '%'), A2($elm$html$Html$Attributes$style, 'maxWidth', '100%')]), _List_Nil)]))]));
  };
  var $author$project$Ui$SwitchLeftLabel$switchLeftLabel = F2(function (classes, cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth flexRow spaceBetween flexAlignCenter '), $elm$html$Html$Attributes$class(classes)]), _List_fromArray([A2($elm$html$Html$label, _List_fromArray([$elm$html$Html$Attributes$class(' bodyRegular primary0 ')]), _List_fromArray([$elm$html$Html$text(cfg.oR)])), $author$project$Ui$Switch$switch({
      uj: '',
      ux: 0,
      eh: cfg.eg,
      xi: false,
      Cu: cfg.zP
    })]));
  });
  var $author$project$ElmFramework$Lib$Ui$Button$Link = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Ui$Button$textLink = function (cfg) {
    var isDisabledClasses = cfg.xa ? ' noPointerEvents gray60 ' : ' secondary100 ';
    return $author$project$Ui$Button$button({
      bh: 'heading5Bold ' + (isDisabledClasses + cfg.uj),
      fn: $elm$html$Html$text(cfg.eS),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Link(cfg.im)
    });
  };
  var $author$project$Ui$TimeRangeSlider$floatToLocalDateTime = function (_float) {
    return A2($author$project$Types$LocalDateTime$fromPosix, $elm$time$Time$utc, $elm$time$Time$millisToPosix($elm$core$Basics$round(_float)));
  };
  var $author$project$Ui$TimeRangeSlider$hourAndMinuteToMillisInterval = function (_v0) {
    var hour = _v0.wC;
    var minute = _v0.yu;
    return (hour * 60 + minute) * 60 * 1000;
  };
  var $author$project$Ui$TimeRangeSlider$localDateTimeToFloat = function (localDateTime) {
    return $elm$time$Time$posixToMillis(A2($author$project$Types$LocalDateTime$toPosix, $elm$time$Time$utc, localDateTime));
  };
  var $author$project$Ui$TimeRangeSlider$timeRangeSliderAppearance = {
    h3: {
      ly: 'gray10Back',
      m4: 'gray10Back',
      nN: 'h1'
    },
    ld: {
      ly: 'gray0Back primary0',
      m4: 'gray40Back gray40',
      nN: 'relative inlineBlock circle w3 h3 flexCenter thumbShadow heading5Bold'
    },
    sB: {
      ly: 'gradient20Back',
      m4: 'gray20Back',
      nN: 'radius1 h1'
    },
    s6: {
      ly: '',
      m4: '',
      nN: 'h7 radius1'
    }
  };
  var $author$project$Types$LocalDateTime$toTimeString = function (_v0) {
    var hour = _v0.wC;
    var minute = _v0.yu;
    return A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt(hour)) + (':' + A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt(minute)));
  };
  var $elm$time$Time$Fri = 4;
  var $elm$time$Time$Mon = 0;
  var $elm$time$Time$Sat = 5;
  var $elm$time$Time$Sun = 6;
  var $elm$time$Time$Thu = 3;
  var $elm$time$Time$Tue = 1;
  var $elm$time$Time$Wed = 2;
  var $elm$time$Time$toWeekday = F2(function (zone, time) {
    var _v0 = A2($elm$core$Basics$modBy, 7, A2($elm$time$Time$flooredDiv, A2($elm$time$Time$toAdjustedMinutes, zone, time), 60 * 24));
    switch (_v0) {
      case 0:
        return 3;
      case 1:
        return 4;
      case 2:
        return 5;
      case 3:
        return 6;
      case 4:
        return 0;
      case 5:
        return 1;
      default:
        return 2;
    }
  });
  var $toastal$either$Either$unpack = F3(function (f, g, e) {
    if (e.$ === 1) {
      var b = e.a;
      return g(b);
    } else {
      var a = e.a;
      return f(a);
    }
  });
  var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
    switch (wd) {
      case 0:
        return 1;
      case 1:
        return 2;
      case 2:
        return 3;
      case 3:
        return 4;
      case 4:
        return 5;
      case 5:
        return 6;
      default:
        return 7;
    }
  };
  var $author$project$Ui$TimeRangeSlider$toThumbStringValue = function (thumbValue) {
    var weekday = A2($elm$core$Basics$composeR, $author$project$Types$LocalDateTime$toPosix($elm$time$Time$utc), A2($elm$core$Basics$composeR, $elm$time$Time$toWeekday($elm$time$Time$utc), A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayToNumber, A2($elm$core$Basics$composeR, $elm$core$Basics$add(-1), A2($elm$core$Basics$composeR, A2($author$project$ElmFramework$Lib$Util$flip, $elm_community$list_extra$List$Extra$getAt, _List_fromArray(['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'])), $elm$core$Maybe$withDefault(''))))));
    var predicateTransformString = F3(function (predicate, transform, localDateTime) {
      return A3($author$project$ElmFramework$Lib$Util$ifElse, transform(localDateTime), '', predicate(localDateTime));
    });
    var is3AmOrEarlier = function (_v0) {
      var hour = _v0.wC;
      var minute = _v0.yu;
      return hour * 60 + minute <= 180;
    };
    var addWeekDayStringIfNextDay = function (localDateTime) {
      return _Utils_ap($author$project$Types$LocalDateTime$toTimeString(localDateTime), A3(predicateTransformString, is3AmOrEarlier, A2($elm$core$Basics$composeR, weekday, $elm$core$String$cons(' ')), localDateTime));
    };
    return A3($toastal$either$Either$unpack, A2($elm$core$Basics$composeL, $author$project$Types$LocalDateTime$toTimeString, $author$project$Ui$TimeRangeSlider$floatToLocalDateTime), A2($elm$core$Basics$composeL, addWeekDayStringIfNextDay, $author$project$Ui$TimeRangeSlider$floatToLocalDateTime), thumbValue);
  };
  var $elm$core$Basics$pow = _Basics_pow;
  var $author$project$Ui$TimeRangeSlider$thumbTranslateFormula = F2(function (first, second) {
    var millisToHours = function (value) {
      return value / 1000 / 60 / 60;
    };
    return 1 / (A2($elm$core$Basics$pow, $elm$core$Basics$abs(millisToHours(first - second)), 1.5) + 1 / 0.7);
  });
  var $author$project$Ui$TimeRangeSlider$thumbTranslateXAttributeHelper = function (amount) {
    return A2($elm$html$Html$Attributes$style, 'transform', A3($elm$core$String$replace, '{{amount}}', $elm$core$String$fromFloat(amount), 'translateX({{amount}}%)'));
  };
  var $author$project$Ui$TimeRangeSlider$toThumbTranslateXAttribute = function (_v0) {
    var startValue = _v0.k7;
    var endValue = _v0.hS;
    var thumbValue = _v0.sp;
    return A3($toastal$either$Either$unpack, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Ui$TimeRangeSlider$thumbTranslateXAttributeHelper, $elm$core$Basics$mul(-100)), $author$project$Ui$TimeRangeSlider$thumbTranslateFormula($author$project$Ui$TimeRangeSlider$localDateTimeToFloat(endValue))), A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Ui$TimeRangeSlider$thumbTranslateXAttributeHelper, $elm$core$Basics$mul(100)), $author$project$Ui$TimeRangeSlider$thumbTranslateFormula($author$project$Ui$TimeRangeSlider$localDateTimeToFloat(startValue))), thumbValue);
  };
  var $author$project$Ui$TimeRangeSlider$timeRangeSlider = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative padBottom1'), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absolute top0 fullWidth flexRow spaceBetween padLeft1 padRight1 heading6Regular gray80')]), _List_fromArray([A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text($author$project$Types$LocalDateTime$toTimeString(cfg.Q))])), A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text($author$project$Types$LocalDateTime$toTimeString(cfg.ay))]))])), $author$project$ElmFramework$Lib$Ui$SliderRange$SliderRange$sliderRange({
      P: $author$project$Ui$TimeRangeSlider$timeRangeSliderAppearance,
      hS: $author$project$Ui$TimeRangeSlider$localDateTimeToFloat(cfg.hS),
      xa: cfg.xa,
      ay: $author$project$Ui$TimeRangeSlider$localDateTimeToFloat(cfg.ay),
      Q: $author$project$Ui$TimeRangeSlider$localDateTimeToFloat(cfg.Q),
      yq: $author$project$Ui$TimeRangeSlider$hourAndMinuteToMillisInterval(cfg.yq),
      yV: A2($elm$core$Basics$composeL, cfg.yV, A2($elm$core$Tuple$mapBoth, $author$project$Ui$TimeRangeSlider$floatToLocalDateTime, $author$project$Ui$TimeRangeSlider$floatToLocalDateTime)),
      k7: $author$project$Ui$TimeRangeSlider$localDateTimeToFloat(cfg.k7),
      a6: $author$project$Ui$TimeRangeSlider$hourAndMinuteToMillisInterval(cfg.a6),
      st: function (thumbValue) {
        return _List_fromArray([$author$project$IconSvg$menuBurgerBold('w2 h2 gray20Fill'), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('absolute top3 whiteSpaceNoWrap'), $author$project$Ui$TimeRangeSlider$toThumbTranslateXAttribute({
          hS: cfg.hS,
          k7: cfg.k7,
          sp: thumbValue
        })]), _List_fromArray([$elm$html$Html$text($author$project$Ui$TimeRangeSlider$toThumbStringValue(thumbValue))]))]);
      }
    })]));
  };
  var $elm$html$Html$h4 = _VirtualDom_node('h4');
  var $author$project$IconSvg$uploadImg_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M22.75 30.5H16.75C11.32 30.5 9 28.18 9 22.75V16.75C9 11.32 11.32 9 16.75 9H20.75C21.16 9 21.5 9.34 21.5 9.75C21.5 10.16 21.16 10.5 20.75 10.5H16.75C12.14 10.5 10.5 12.14 10.5 16.75V22.75C10.5 23.8431 10.5922 24.7692 10.7944 25.5461L14.9298 22.7696C16.0098 22.0496 17.4998 22.1296 18.4798 22.9596L18.8098 23.2496C19.3098 23.6796 20.1598 23.6796 20.6498 23.2496L24.8098 19.6796C25.8698 18.7696 27.5398 18.7696 28.6098 19.6796L29 20.0147V17.75C29 17.34 29.34 17 29.75 17C30.16 17 30.5 17.34 30.5 17.75V22.75C30.5 28.18 28.18 30.5 22.75 30.5ZM29 21.9964V22.75C29 27.36 27.36 29 22.75 29H16.75C14.0002 29 12.3071 28.4165 11.3885 26.9672L15.7698 24.0196C16.2798 23.6696 17.0398 23.7096 17.4998 24.0996L17.8298 24.3896C18.8998 25.2996 20.5698 25.2996 21.6298 24.3896L25.7898 20.8196C26.2898 20.3896 27.1298 20.3896 27.6298 20.8196L29 21.9964ZM16.75 18.5C15.23 18.5 14 17.27 14 15.75C14 14.23 15.23 13 16.75 13C18.27 13 19.5 14.23 19.5 15.75C19.5 17.27 18.27 18.5 16.75 18.5ZM16.75 14.5C16.06 14.5 15.5 15.06 15.5 15.75C15.5 16.44 16.06 17 16.75 17C17.44 17 18 16.44 18 15.75C18 15.06 17.44 14.5 16.75 14.5ZM25 15.7499C25 16.1599 25.34 16.4999 25.75 16.4999C26.16 16.4999 26.5 16.1599 26.5 15.7499V11.5599L27.22 12.2799C27.51 12.5699 27.99 12.5699 28.28 12.2799C28.57 11.9899 28.57 11.5099 28.28 11.2199L26.28 9.21994L26.2672 9.20803C26.0517 9.00259 25.738 8.95148 25.4737 9.05472L25.46 9.05994C25.3499 9.10318 25.2553 9.17268 25.181 9.25934L23.2199 11.2204C22.9299 11.5104 22.9299 11.9904 23.2199 12.2804C23.3699 12.4304 23.5599 12.5004 23.7499 12.5004C23.9399 12.5004 24.1299 12.4304 24.2799 12.2804L25 11.5604V15.7499Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$uploadImg = function (classes) {
    return $author$project$IconSvg$uploadImg_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$UploadBox$uploadBox = function (cfg) {
    var _v0 = function () {
      var _v1 = cfg.oM;
      if (!_v1.$) {
        var url = _v1.a;
        return _Utils_Tuple2(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w13 h13 radius7 marRight1  relative noOverflow  ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
          t_: cfg.t_,
          uj: '',
          wG: _List_fromArray([{
            ij: 13,
            eZ: url,
            lt: 13
          }]),
          Dq: 13,
          s5: ' relative fullHeight block '
        }), $author$project$Ui$Button$button({
          bh: ' absolute right1 bottom1 circle gray0Back w3 h3 noOverflow yesPointerEvents ',
          fn: $author$project$IconSvg$close1('w3 gray40Fill '),
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.pY)
        })])), ' noPointerEvents ');
      } else {
        return _Utils_Tuple2(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w13 h13 radius7 marRight1 flexColumn flexAlignCenter justifyCenter ')]), _List_fromArray([$author$project$IconSvg$uploadImg('gray60Fill w5 '), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bodyRegular gray40 ')]), _List_fromArray([$elm$html$Html$text(cfg.fo)]))])), '');
      }
    }();
    var leftContent = _v0.a;
    var btnClasses = _v0.b;
    return $author$project$Ui$Button$button({
      bh: _Utils_ap(btnClasses, cfg.uj),
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' fullWidth borderDashed gray20Border borderW125 radius7 flexRow spaceBetween pad1 ')]), _List_fromArray([leftContent, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' secondary800Back pad1h padLeft2 radius7 mar1 left flexColumn justifyCenter  ')]), _List_fromArray([A2($elm$html$Html$h4, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold ')]), _List_fromArray([$elm$html$Html$text(cfg.lh)])), A2($elm$html$Html$p, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular mar0 gray80 ')]), _List_fromArray([$elm$html$Html$text(cfg.eS)]))]))])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.p0)
    });
  };
  var $elm$html$Html$Attributes$accept = $elm$html$Html$Attributes$stringProperty('accept');
  var $author$project$ElmFramework$Lib$Ui$ImageInput$ResizedImage = F5(function (width, height, size, imgBlob, blobUrl) {
    return {
      l1: blobUrl,
      ij: height,
      wI: imgBlob,
      B3: size,
      lt: width
    };
  });
  var $author$project$ElmFramework$Lib$Ui$ImageInput$resizedImageDecoder = A6($elm$json$Json$Decode$map5, $author$project$ElmFramework$Lib$Ui$ImageInput$ResizedImage, A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$field, 'size', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$field, 'imgBlob', $elm$json$Json$Decode$value), A2($elm$json$Json$Decode$field, 'blobUrl', $elm$json$Json$Decode$string));
  var $author$project$ElmFramework$Lib$Ui$ImageInput$methodToString = function (resizeMethod) {
    if (!resizeMethod) {
      return 'cover';
    } else {
      return 'contain';
    }
  };
  var $author$project$ElmFramework$Lib$Ui$ImageInput$toResizeConfigAttr = function (config) {
    return A2($elm$html$Html$Attributes$attribute, 'resize-config', A2($elm$json$Json$Encode$encode, 0, $elm$json$Json$Encode$object(_List_fromArray([_Utils_Tuple2('width', $elm$json$Json$Encode$int(config.lt)), _Utils_Tuple2('height', $elm$json$Json$Encode$int(config.ij)), _Utils_Tuple2('quality', $elm$json$Json$Encode$float(config.kg)), _Utils_Tuple2('method', $elm$json$Json$Encode$string($author$project$ElmFramework$Lib$Ui$ImageInput$methodToString(config.em)))]))));
  };
  var $author$project$ElmFramework$Lib$Ui$ImageInput$imageInput = function (_v0) {
    var classes = _v0.uj;
    var resize = _v0.ra;
    var onImage = _v0.pT;
    var content = _v0.fn;
    return A3($elm$html$Html$node, 'bky-image-input', _List_fromArray([$elm$html$Html$Attributes$class(classes), $elm$html$Html$Attributes$class('relative'), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$Util$noOpAttr, $author$project$ElmFramework$Lib$Ui$ImageInput$toResizeConfigAttr, resize), A3($author$project$ElmFramework$Lib$WebComponentsUtil$listenWebComponentEvent, 'newResizedImage', $author$project$ElmFramework$Lib$Ui$ImageInput$resizedImageDecoder, onImage)]), _Utils_ap(content, _List_fromArray([A2($elm$html$Html$input, _List_fromArray([$elm$html$Html$Attributes$class('absolute top0 left0 fullWidth fullHeight o0'), $elm$html$Html$Attributes$type_('file'), $elm$html$Html$Attributes$accept('image/*')]), _List_Nil)])));
  };
  var $author$project$Ui$UploadBox$uploadImage = function (cfg) {
    var image = function () {
      var _v0 = cfg.om;
      if (!_v0.$) {
        var img = _v0.a;
        return $author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
          t_: cfg.t_,
          uj: '',
          wG: _List_fromArray([img]),
          Dq: 14,
          s5: ' relative block w14 h14'
        });
      } else {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w14 h14 radius7  borderDashed gray20Border borderW125 radius7 flexCenterColumn noOverflow  ')]), _List_fromArray([$author$project$IconSvg$uploadImg('gray60Fill w5 '), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bodyRegular gray40 ')]), _List_fromArray([$elm$html$Html$text(cfg.fo)]))]));
      }
    }();
    return $author$project$ElmFramework$Lib$Ui$ImageInput$imageInput({
      uj: cfg.uj + ' noOverflow radius7',
      fn: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('noOverflow radius7')]), _List_fromArray([image]))]),
      pT: cfg.pT,
      ra: $elm$core$Maybe$Nothing
    });
  };
  var $author$project$Ui$LocationCard$userLocation = function (cfg) {
    var closeBtn = function () {
      var _v0 = cfg.mr;
      if (!_v0.$) {
        var onClose = _v0.a;
        return $author$project$Ui$Button$button({
          bh: ' w3 h3  ',
          fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w3 h3   ')]), _List_fromArray([$author$project$IconSvg$close1('w3 gray80Fill')])),
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onClose)
        });
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();
    return $author$project$Ui$Button$button({
      bh: 'fullWidth ',
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' secondary800Back radius5 padTop1h padBottom1h padRight2 padLeft2 flexRow fullWidth spaceBetween flexAlignCenter '), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter noOverflow')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' w4 h4 marRight2 ')]), _List_fromArray([$author$project$IconSvg$location(' w4  primary0Filled ')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn noOverflow left ')]), _List_fromArray([A2($elm$html$Html$h4, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold primary0 ellipsis ')]), _List_fromArray([$elm$html$Html$text(cfg.lh)])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('gray60 bodyRegular ellipsis  ')]), _List_fromArray([$elm$html$Html$text(cfg.lb)]))]))])), closeBtn])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.p_)
    });
  };
  var $author$project$Ui$SelectItem$userSelectBar = function (cfg) {
    var notSelectedClasses = cfg.xj ? '' : ' o6';
    return $author$project$Ui$Button$selectButtonItem({
      uj: ' left fullWidth radius7 ' + notSelectedClasses,
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray10Back radius18 flexRow padTop1h padBottom1h padLeft2 padRight2 spaceBetween flexAlignCenter')]), _List_fromArray([A2($elm$html$Html$img, _List_fromArray([$elm$html$Html$Attributes$class('circle w5 h5'), $elm$html$Html$Attributes$src(cfg.om)]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn padLeft1')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular primary0')]), _List_fromArray([$elm$html$Html$text(cfg.At)]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flex1')]), _List_Nil), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular primary0')]), _List_fromArray([$elm$html$Html$text('Bookings')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray20')]), _List_Nil)])),
      xa: false,
      xj: cfg.xj,
      Cu: cfg.Cu
    });
  };
  var $author$project$UiPrimitives$ScrollTarget$behindBars = F5(function (browser, isViewport, background, env, content) {
    return A3($elm$html$Html$node, 'behind-bars', _List_fromArray([$elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('absoluteSpread scrollTarget', isViewport)]))]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative fullMinHeight'), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('noOverflow', !isViewport)]))]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread')]), _List_fromArray([background])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative')]), _Utils_ap(content, _List_fromArray([$author$project$Ui$NavBarBottom$navBarBottomSpacer(browser)])))]))]));
  });
  var $author$project$Ui$ComponentsPreview$ComponentsPreview$wrap = function (cfg) {
    return A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$ComponentsPreviewMsg), A5($author$project$UiPrimitives$ScrollTarget$behindBars, cfg.t_, true, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread gray0Back')]), _List_Nil), cfg.vS, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('phoneWidthCenter')]), cfg.my)])));
  };
  var $author$project$Ui$ComponentsPreview$ComponentsPreview$view = F3(function (env, browser, state) {
    return $author$project$Ui$ComponentsPreview$ComponentsPreview$wrap({
      t_: browser,
      my: _List_fromArray([$author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: $author$project$Ui$TimeRangeSlider$timeRangeSlider({
          uj: '',
          hS: state.gK.b,
          xa: false,
          ay: {
            mO: 6,
            wC: 22,
            yu: 0,
            pt: 6,
            ta: 2022
          },
          Q: {
            mO: 6,
            wC: 8,
            yu: 0,
            pt: 6,
            ta: 2022
          },
          yq: {
            wC: 0,
            yu: 30
          },
          yV: $author$project$Ui$ComponentsPreview$Msg$OnTimeRangeSliderChange,
          k7: state.gK.a,
          a6: {
            wC: 0,
            yu: 30
          }
        }),
        lh: 'Time range slider'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: $author$project$Ui$SliderRange$sliderRange({
          uj: '',
          hS: state.gk.b,
          xa: false,
          ay: 100.0,
          Q: 1.0,
          yq: 25.0,
          yV: $author$project$Ui$ComponentsPreview$Msg$OnRangeSliderChange,
          k7: state.gk.a,
          a6: 0.5
        }),
        lh: 'Range slider'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'AppIntro > Locations', $author$project$Route$Route$AppIntro(0)), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'AppIntro > Players', $author$project$Route$Route$AppIntro(1)), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'AppIntro > History', $author$project$Route$Route$AppIntro(2)), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'OnboardUser > Personal', $author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$Personal($elm$core$Maybe$Nothing))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'OnboardUser > Sports', $author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$EditUserActivities(0))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'OnboardUser > Level', $author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$EditUserActivities(1))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Auth > Register', $author$project$Route$Route$Auth(A2($author$project$Route$Route$Register, $elm$core$Maybe$Nothing, $author$project$Route$Route$DefaultRegistration))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Auth > Sign In', $author$project$Route$Route$Auth($author$project$Route$Route$SignInWithCredentials($author$project$Route$Route$DefaultSignIn))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Auth > Forget Password', $author$project$Route$Route$Auth($author$project$Route$Route$ForgotPassword($author$project$Route$Route$ForgotPasswordEnterEmail))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Auth > Create New Password', $author$project$Route$Route$Auth($author$project$Route$Route$ForgotPassword($author$project$Route$Route$CreateNewPassword('asdf')))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Match > Details', A2($author$project$Route$Route$Match, '001', $author$project$Ui$Match$Route$Details)), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Match > Cancel', A2($author$project$Route$Route$Match, '001', $author$project$Ui$Match$Route$Cancel)), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Match > Invoice', A2($author$project$Route$Route$Match, '001', $author$project$Ui$Match$Route$Invoice)), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Notifications', $author$project$Route$Route$Notifications), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Legal > Terms And Privacy', $author$project$Route$Route$Legal(0)), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'MyPlayerStatus > ScheduledMatches', $author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Upcoming)), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'MyPlayerStatus > MatchHistory', $author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$History)), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'MyPlayerStatus > Searches > Searches', $author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Searches($author$project$Ui$MyPlayerStatus$Searches$Route$SearchesList))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'MyPlayerStatus > Searches > Edit', $author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Searches($author$project$Ui$MyPlayerStatus$Searches$Route$Edit('')))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'MyPlayerStatus > Searches > Cancel', $author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Searches($author$project$Ui$MyPlayerStatus$Searches$Route$Cancel('')))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'PlayerProfile', $author$project$Route$Route$PlayerProfile($elm$core$Maybe$Just('001'))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'BanUser', $author$project$Route$Route$BanUser('001')), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'ChangePassword', $author$project$Route$Route$ChangePassword), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'EditPersonalDetails', $author$project$Route$Route$EditPersonalDetails), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'EditUserActivity > Sports', $author$project$Route$Route$EditUserActivity(0)), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'EditUserActivity > Level', $author$project$Route$Route$EditUserActivity(1)), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'NotificationsSettings', $author$project$Route$Route$NotificationsSettings), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'BannedUsers', $author$project$Route$Route$BannedUsers), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'PaymentMethods > Browse', $author$project$Route$Route$PaymentMethods(0)), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'PaymentMethods > Add', $author$project$Route$Route$PaymentMethods(1)), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'MoreOptions', $author$project$Route$Route$MoreOptions), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Feedback', $author$project$Route$Route$Feedback), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Support', $author$project$Route$Route$Support), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Matchmaking > Single > Main', $author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$Main)), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Matchmaking > Single > Checkout > SelectPaymentMethod', $author$project$Route$Route$matchMakingSingleCheckoutSelectPaymentMethodRoute), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Matchmaking > Single > Checkout > AddPaymentMethod', $author$project$Route$Route$matchMakingSingleCheckoutAddCreditCardRoute), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Matchmaking > Single > Checkout > Review', $author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$Checkout($author$project$Ui$Matchmaking$Checkout$Route$Review($author$project$Mock$paymentMethod.od)))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Matchmaking > Single > ProvideLocation > Radius', $author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$ProvideLocation(0))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Matchmaking > Single > ProvideLocation > EnterAddress', $author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$ProvideLocation(1))), A2($author$project$Ui$ComponentsPreview$ComponentsPreview$routeBtn, 'Matchmaking > Single > AddPlayers', $author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$AddPlayers($author$project$Ui$AddPlayers$Route$Main($author$project$Types$CreateOrEditSearch$Create))))])),
        lh: 'Routes'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([$author$project$Ui$Button$basicButton({
          bh: 'w17 padTop1h padBottom1h heading5Bold mar1',
          cD: 0,
          fn: $elm$html$Html$text('Primary'),
          xa: false,
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Ui$ComponentsPreview$Msg$NoOp)
        }), $author$project$Ui$Button$basicButton({
          bh: 'w17 heading5Bold mar1',
          cD: 1,
          fn: $elm$html$Html$text('Secondary'),
          xa: false,
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Ui$ComponentsPreview$Msg$NoOp)
        }), $author$project$Ui$Button$basicButton({
          bh: 'w17  heading5Bold mar1',
          cD: 2,
          fn: $elm$html$Html$text('Tertiary'),
          xa: false,
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Ui$ComponentsPreview$Msg$NoOp)
        }), $author$project$Ui$Button$basicButton({
          bh: 'w17  heading5Bold mar1',
          cD: 3,
          fn: $elm$html$Html$text('Error'),
          xa: false,
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Ui$ComponentsPreview$Msg$NoOp)
        })])),
        lh: 'basicButton'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexColumn ')]), _List_fromArray([$author$project$Ui$Button$iconBtn({
          bh: 'marBottom2 ',
          cD: 0,
          wE: $author$project$IconSvg$logoFacebook,
          xa: false,
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Ui$ComponentsPreview$Msg$NoOp)
        }), $author$project$Ui$Button$iconBtn({
          bh: '',
          cD: 1,
          wE: $author$project$IconSvg$logoGoogle,
          xa: false,
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Ui$ComponentsPreview$Msg$NoOp)
        })])),
        lh: 'iconBtn'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexColumn ')]), _List_fromArray([$author$project$Ui$Button$multipleIconBtn({
          bh: 'w26  heading5Bold marTop1 marBottom1 flexCenter block',
          cD: 0,
          xa: false,
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Ui$ComponentsPreview$Msg$NoOp),
          oR: 'Button',
          xD: $elm$core$Maybe$Just($author$project$IconSvg$plus),
          Bh: $elm$core$Maybe$Just($author$project$IconSvg$plus)
        }), $author$project$Ui$Button$multipleIconBtn({
          bh: 'fullWidth heading5Bold marTop1 marBottom1 flexCenter ',
          cD: 0,
          xa: false,
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Ui$ComponentsPreview$Msg$NoOp),
          oR: 'Start adding courts',
          xD: $elm$core$Maybe$Just($author$project$IconSvg$plus),
          Bh: $elm$core$Maybe$Nothing
        })])),
        lh: 'multipleIconBtn'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$Button$textLink({
          uj: '',
          im: '',
          xa: false,
          eS: 'Text link'
        }), $author$project$Ui$Button$textLink({
          uj: 'marLeft3 ',
          im: '',
          xa: true,
          eS: 'Text link'
        })])),
        lh: 'textLink'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$Tags$tag({
          uj: 'mar1',
          cD: 0,
          av: $elm$core$Maybe$Nothing,
          wE: $elm$core$Maybe$Nothing,
          oR: 'Mini Tag',
          p_: $elm$core$Maybe$Nothing,
          B3: 0
        }), $author$project$Ui$Tags$tag({
          uj: 'mar1',
          cD: 1,
          av: $elm$core$Maybe$Nothing,
          wE: $elm$core$Maybe$Nothing,
          oR: 'Mini Tag',
          p_: $elm$core$Maybe$Nothing,
          B3: 0
        }), $author$project$Ui$Tags$tag({
          uj: 'mar1',
          cD: 2,
          av: $elm$core$Maybe$Nothing,
          wE: $elm$core$Maybe$Nothing,
          oR: 'Mini Tag',
          p_: $elm$core$Maybe$Nothing,
          B3: 0
        }), $author$project$Ui$Tags$tag({
          uj: 'mar1',
          cD: 3,
          av: $elm$core$Maybe$Nothing,
          wE: $elm$core$Maybe$Nothing,
          oR: 'Mini Tag',
          p_: $elm$core$Maybe$Nothing,
          B3: 0
        }), $author$project$Ui$Tags$tag({
          uj: 'mar1',
          cD: 5,
          av: $elm$core$Maybe$Nothing,
          wE: $elm$core$Maybe$Nothing,
          oR: 'Mini Tag',
          p_: $elm$core$Maybe$Nothing,
          B3: 0
        }), $author$project$Ui$Tags$tag({
          uj: 'mar1',
          cD: 2,
          av: $elm$core$Maybe$Nothing,
          wE: $elm$core$Maybe$Just($author$project$IconSvg$lockers),
          oR: 'Small Tag',
          p_: $elm$core$Maybe$Nothing,
          B3: 1
        }), $author$project$Ui$Tags$tag({
          uj: 'mar1',
          cD: 4,
          av: $elm$core$Maybe$Nothing,
          wE: $elm$core$Maybe$Nothing,
          oR: 'Small Tag',
          p_: $elm$core$Maybe$Nothing,
          B3: 1
        }), $author$project$Ui$Tags$tag({
          uj: 'mar1',
          cD: 5,
          av: $elm$core$Maybe$Nothing,
          wE: $elm$core$Maybe$Just($author$project$IconSvg$lockers),
          oR: 'Small Tag',
          p_: $elm$core$Maybe$Nothing,
          B3: 1
        }), $author$project$Ui$Tags$tag({
          uj: 'mar1',
          cD: 0,
          av: $elm$core$Maybe$Nothing,
          wE: $elm$core$Maybe$Just($author$project$IconSvg$lockers),
          oR: 'Big Tag',
          p_: $elm$core$Maybe$Just($author$project$Ui$ComponentsPreview$Msg$NoOp),
          B3: 3
        }), $author$project$Ui$Tags$tag({
          uj: 'mar1',
          cD: 3,
          av: $elm$core$Maybe$Nothing,
          wE: $elm$core$Maybe$Just($author$project$IconSvg$lockers),
          oR: 'Big Tag',
          p_: $elm$core$Maybe$Just($author$project$Ui$ComponentsPreview$Msg$NoOp),
          B3: 3
        }), $author$project$Ui$Tags$tag({
          uj: 'mar1',
          cD: 6,
          av: $elm$core$Maybe$Nothing,
          wE: $elm$core$Maybe$Just($author$project$IconSvg$lockers),
          oR: 'Big Tag',
          p_: $elm$core$Maybe$Just($author$project$Ui$ComponentsPreview$Msg$NoOp),
          B3: 3
        })])),
        lh: 'tag'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([$author$project$Ui$Switch$switch({
          uj: 'marRight1',
          ux: 0,
          eh: state.ai,
          xi: false,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnToggleSwitch
        }), $author$project$Ui$Switch$switch({
          uj: 'marRight1',
          ux: 2,
          eh: state.ai,
          xi: false,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnToggleSwitch
        }), $author$project$Ui$Switch$switch({
          uj: 'marRight1',
          ux: 3,
          eh: state.ai,
          xi: false,
          Cu: $author$project$Ui$ComponentsPreview$Msg$NoOp
        }), $author$project$Ui$Switch$switch({
          uj: 'marRight1',
          ux: 4,
          eh: state.ai,
          xi: false,
          Cu: $author$project$Ui$ComponentsPreview$Msg$NoOp
        })])),
        lh: 'Switch'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([$author$project$Ui$CheckBox$checkBox({
          uj: 'marRight1',
          ux: 0,
          od: '',
          eh: state.cB,
          xi: false,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnToggleCheckBox
        }), $author$project$Ui$CheckBox$checkBox({
          uj: 'marRight1',
          ux: 1,
          od: '',
          eh: state.cB,
          xi: false,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnToggleCheckBox
        }), $author$project$Ui$CheckBox$checkBox({
          uj: 'marRight1',
          ux: 2,
          od: '',
          eh: state.cB,
          xi: false,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnToggleCheckBox
        })])),
        lh: 'CheckBox'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$CheckBox$radioBtn({
          uj: 'marRight1',
          ux: 0,
          od: '',
          eh: state.c7,
          xi: false,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnToggleRadioBtn
        }), $author$project$Ui$CheckBox$radioBtn({
          uj: 'marRight1',
          ux: 1,
          od: '',
          eh: state.c7,
          xi: false,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnToggleRadioBtn
        }), $author$project$Ui$CheckBox$radioBtn({
          uj: 'marRight1',
          ux: 2,
          od: '',
          eh: state.c7,
          xi: false,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnToggleRadioBtn
        })])),
        lh: 'RadioBtn'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexColumn ')]), _List_fromArray([$author$project$Ui$NotificationBar$notificationBar({
          uj: 'marBottom1',
          pR: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          eS: 'This is an informational toast',
          gH: $elm$core$Maybe$Nothing,
          gI: 1
        }), $author$project$Ui$NotificationBar$notificationBar({
          uj: 'marBottom1',
          pR: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          eS: 'Your account has been created!',
          gH: $elm$core$Maybe$Just(_Utils_Tuple2('Button text', $author$project$Ui$ComponentsPreview$Msg$NoOp)),
          gI: 0
        }), $author$project$Ui$NotificationBar$notificationBar({
          uj: 'marBottom1',
          pR: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          eS: 'This is a warning toast',
          gH: $elm$core$Maybe$Just(_Utils_Tuple2('Button text', $author$project$Ui$ComponentsPreview$Msg$NoOp)),
          gI: 2
        }), $author$project$Ui$NotificationBar$notificationBar({
          uj: 'marBottom1',
          pR: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          eS: 'This is a destructive toast',
          gH: $elm$core$Maybe$Just(_Utils_Tuple2('Button text', $author$project$Ui$ComponentsPreview$Msg$NoOp)),
          gI: 3
        })])),
        lh: 'notificationBar'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexColumn ')]), _List_fromArray([$author$project$Ui$SliderMultipleSelect$sliderMultipleSelect({
          uj: ' heading4Bold  ',
          uy: $elm$core$Maybe$Just(0),
          u$: state.e6,
          xn: _List_fromArray([_Utils_Tuple3(0, 'Tab 01', $elm$core$Maybe$Nothing), _Utils_Tuple3(1, 'Tab 02', $elm$core$Maybe$Nothing)]),
          zG: function (curr) {
            return $author$project$Ui$ComponentsPreview$Msg$OnSelectSlider(curr);
          },
          zK: ''
        })])),
        lh: 'selectSlider'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' primary0Back pad2 ')]), _List_fromArray([$author$project$Ui$DupleTextSlider$dupleTextSlider({
          bh: 'heading4Bold ',
          u$: state.e6,
          xn: _Utils_Tuple2({
            od: 0,
            oR: 'Look for a match'
          }, {
            od: 1,
            oR: 'Recurring'
          }),
          zG: function (curr) {
            return $author$project$Ui$ComponentsPreview$Msg$OnSelectSlider(curr);
          },
          BP: ''
        })])),
        lh: 'selectSlider'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$StepsBar$stepsBar({
          uj: '',
          u1: 2,
          oR: 'About You',
          Cg: 3
        })])),
        lh: 'stepsBar'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([$author$project$Ui$PlayerLevelSlider$matchRateSlider({
          uj: '',
          bu: $author$project$Ui$ComponentsPreview$Msg$OnSlidePlayer,
          s_: state.kb
        })])),
        lh: 'matchRateSlider'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$SportLevelSlider$sportLevelSlider({
          uj: '',
          bu: $author$project$Ui$ComponentsPreview$Msg$OnSlideSport,
          dh: $author$project$Mock$activity,
          s_: state.k4
        })])),
        lh: 'sportLevelSlider'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$PlayerLevelSlider$sliderBar({
          uj: '',
          x7: 10,
          bu: $author$project$Ui$ComponentsPreview$Msg$OnSlideDistance,
          s_: state.fy
        })])),
        lh: 'sliderBar'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$DistanceSlider$distanceSlider({
          uj: '',
          x4: 50,
          yp: 30,
          bu: $author$project$Ui$ComponentsPreview$Msg$OnSlideDistance,
          s_: state.fy
        })])),
        lh: 'distanceSlider'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$UploadBox$uploadBox({
          t_: browser,
          uj: 'marBottom1 ',
          fo: 'Logo',
          oM: $elm$core$Maybe$Just(require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/Explore-01.png')),
          pY: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          p0: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          eS: 'This is the logo that you are going to show in all your locations.',
          lh: 'Upload logo'
        }), $author$project$Ui$UploadBox$uploadBox({
          t_: browser,
          uj: 'marBottom1',
          fo: 'Pictures',
          oM: $elm$core$Maybe$Nothing,
          pY: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          p0: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          eS: 'This is the cover that you are going to show in your venue’s profile.',
          lh: 'Cover Picture'
        })])),
        lh: 'uploadBox'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_Nil, _List_fromArray([A3($author$project$Ui$EmptyStates$emptyCard, ' marBottom2 ', true, $author$project$Ui$ComponentsPreview$Msg$NoOp), A3($author$project$Ui$EmptyStates$emptyCard, '', false, $author$project$Ui$ComponentsPreview$Msg$NoOp)])),
        lh: 'emptyCard'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$EmptyStates$emptyResult({
          uj: '',
          eS: 'Please make sure you written correctly',
          lh: 'No Results Found',
          CV: $elm$core$Maybe$Just($author$project$IconSvg$search)
        })])),
        lh: 'emptyResult'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$EmptyStates$emptyState({
          t$: 'Add booking',
          uj: '',
          p_: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          eS: 'Here you will see the bookings of the courts and add bookings manually',
          lh: 'Still no bookings'
        })])),
        lh: 'emptyState'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow ')]), _List_fromArray([$author$project$Ui$UploadBox$uploadImage({
          t_: browser,
          uj: ' marRight2 ',
          fo: 'Picture',
          om: $elm$core$Maybe$Just({
            ij: 11,
            eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/photo.jpg'),
            lt: 17
          }),
          pT: $author$project$Ui$ComponentsPreview$Msg$OnImage
        }), $author$project$Ui$UploadBox$uploadImage({
          t_: browser,
          uj: '',
          fo: 'Picture',
          om: $elm$core$Maybe$Nothing,
          pT: $author$project$Ui$ComponentsPreview$Msg$OnImage
        })])),
        lh: 'uploadImage'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow ')]), _List_fromArray([$author$project$Ui$ResultCard$resultCard({
          uj: '',
          u$: state.kx,
          zG: function (curr) {
            return $author$project$Ui$ComponentsPreview$Msg$OnSelectResultSlider(curr);
          },
          Bc: {
            z5: _Utils_Tuple2(88, 12),
            B9: _Utils_Tuple2(125, 60),
            Cv: _Utils_Tuple2(46, 7)
          }
        })])),
        lh: 'resultCard'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$LocationCard$locationCard({
          t_: browser,
          hf: $author$project$Ui$LocationCard$Default({
            cy: 'This is the Location Address',
            mL: 'm',
            m5: 750
          }),
          uj: 'marBottom1 ',
          iU: _List_fromArray([{
            ij: 8,
            eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/photo.jpg'),
            lt: 8
          }]),
          lh: 'Ytad Padle'
        }), $author$project$Ui$LocationCard$locationCard({
          t_: browser,
          hf: A2($author$project$Ui$LocationCard$Remove, {
            cy: 'This is the Location Address',
            mL: 'm',
            m5: 750
          }, $author$project$Ui$ComponentsPreview$Msg$NoOp),
          uj: 'marBottom1',
          iU: _List_fromArray([{
            ij: 8,
            eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/photo.jpg'),
            lt: 8
          }]),
          lh: 'Ytad Padle'
        }), $author$project$Ui$LocationCard$locationCard({
          t_: browser,
          hf: $author$project$Ui$LocationCard$AddCourts($author$project$Ui$ComponentsPreview$Msg$NoOp),
          uj: '',
          iU: _List_fromArray([{
            ij: 8,
            eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/photo.jpg'),
            lt: 8
          }]),
          lh: 'Ytad Padle'
        })])),
        lh: 'locationCard'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$CourtCard$courtCard({
          t_: browser,
          mC: _List_fromArray([{
            ij: 11,
            eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/photo.jpg'),
            lt: 17
          }]),
          yR: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          zI: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          gE: _List_fromArray(['Outdoor', 'Wall', 'Doubles']),
          lh: 'Court1'
        })])),
        lh: 'courtCard'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$CourtCard$courtCardCheckout({
          t_: browser,
          uj: '',
          mC: _List_fromArray([{
            ij: 11,
            eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/photo.jpg'),
            lt: 17
          }]),
          x$: {
            dY: $elm$time$Time$millisToPosix(1610217031111),
            eL: $elm$time$Time$millisToPosix(1610211631111)
          },
          gE: _List_fromArray(['Outdoor', 'Wall', 'Doubles']),
          lh: 'Ytad Padle',
          DJ: $elm$time$Time$utc
        })])),
        lh: 'courtCardCheckout'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: $author$project$ElmFramework$Lib$Util$noOpEl,
        lh: 'nextMatchCard'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: $author$project$ElmFramework$Lib$Util$noOpEl,
        lh: 'pastMatchCard'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$Input$labeledInput({
          bP: $elm$core$Maybe$Nothing,
          bh: ' marBottom3  ',
          od: '01',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          oR: 'Default',
          bu: $author$project$Ui$ComponentsPreview$Msg$OnInput,
          bv: 'Placeholder',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: state.I
        }), $author$project$Ui$Input$labeledInput({
          bP: $elm$core$Maybe$Nothing,
          bh: ' marBottom3  ',
          od: '01',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Password({
            p_: $author$project$Ui$ComponentsPreview$Msg$NoOp,
            gn: false
          }),
          oR: 'Password',
          bu: $author$project$Ui$ComponentsPreview$Msg$OnInput,
          bv: 'Enter your password',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: state.I
        }), $author$project$Ui$Input$labeledInput({
          bP: $elm$core$Maybe$Nothing,
          bh: ' marBottom3 ',
          od: '02',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          oR: ' Hightlight ',
          bu: $author$project$Ui$ComponentsPreview$Msg$OnInput,
          bv: 'Placeholder',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputHightlight,
          s_: state.I
        }), $author$project$Ui$Input$labeledInput({
          bP: $elm$core$Maybe$Nothing,
          bh: ' marBottom3 ',
          od: '',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          oR: 'Error',
          bu: $author$project$Ui$ComponentsPreview$Msg$OnInput,
          bv: 'Placeholder',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputError('Error message'),
          s_: state.I
        }), $author$project$Ui$Input$labeledInput({
          bP: $elm$core$Maybe$Nothing,
          bh: '',
          od: '',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          oR: 'Disabled',
          bu: $author$project$Ui$ComponentsPreview$Msg$OnInput,
          bv: 'Placeholder',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDisabled,
          s_: state.I
        })])),
        lh: 'labeledInput'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$Input$labeledTextarea({
          bP: $elm$core$Maybe$Nothing,
          bh: ' marBottom3  ',
          od: '03',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          oR: 'Default',
          bu: $author$project$Ui$ComponentsPreview$Msg$OnInput,
          bv: 'Placeholder',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: state.I
        }), $author$project$Ui$Input$labeledTextarea({
          bP: $elm$core$Maybe$Nothing,
          bh: ' marBottom3 ',
          od: '',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          oR: 'Error',
          bu: $author$project$Ui$ComponentsPreview$Msg$OnInput,
          bv: 'Placeholder',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputError('Error message'),
          s_: state.I
        })])),
        lh: 'labeledTextarea'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$Input$labeledDropdown({
          bh: ' marBottom3  ',
          od: '',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          oR: 'Default',
          p_: $elm$core$Maybe$Nothing,
          bv: 'Placeholder',
          gw: '',
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault
        }), $author$project$Ui$Input$labeledDropdown({
          bh: ' marBottom3 ',
          od: '',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          oR: ' Hightlight ',
          p_: $elm$core$Maybe$Nothing,
          bv: 'Placeholder',
          gw: '',
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputHightlight
        }), $author$project$Ui$Input$labeledDropdown({
          bh: ' marBottom3 ',
          od: '',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          oR: 'Error',
          p_: $elm$core$Maybe$Nothing,
          bv: 'Placeholder',
          gw: '',
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputError('Error message')
        }), $author$project$Ui$Input$labeledDropdown({
          bh: '',
          od: '',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          oR: 'Disabled',
          p_: $elm$core$Maybe$Nothing,
          bv: 'Placeholder',
          gw: '',
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDisabled
        })])),
        lh: 'labeledDropdown'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$Input$searchBar({
          bh: ' marBottom3  ',
          od: '',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          pR: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          bu: $author$project$Ui$ComponentsPreview$Msg$OnInput,
          bv: 'Search',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: state.I
        }), $author$project$Ui$Input$searchBar({
          bh: ' marBottom3 ',
          od: '',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          pR: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          bu: $author$project$Ui$ComponentsPreview$Msg$OnInput,
          bv: 'Search',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputHightlight,
          s_: state.I
        }), $author$project$Ui$Input$searchBar({
          bh: ' marBottom3 ',
          od: '',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          pR: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          bu: $author$project$Ui$ComponentsPreview$Msg$OnInput,
          bv: 'Search',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputError('Error message'),
          s_: state.I
        }), $author$project$Ui$Input$searchBar({
          bh: '',
          od: '',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          pR: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          bu: $author$project$Ui$ComponentsPreview$Msg$OnInput,
          bv: 'Search',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDisabled,
          s_: state.I
        })])),
        lh: 'searchBar'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0Back pad1  ')]), _List_fromArray([$author$project$Ui$SpecialSearchBar$specialSearchBar({
          bh: ' marBottom3 ',
          od: '',
          i1: $elm$core$Maybe$Nothing,
          jq: $elm$core$Maybe$Just($author$project$Ui$ComponentsPreview$Msg$NoOp),
          bu: $author$project$Ui$ComponentsPreview$Msg$OnInput,
          bv: 'Search',
          kI: $author$project$Ui$SpecialSearchBar$DefaultSearch($author$project$Ui$ComponentsPreview$Msg$NoOp),
          s_: state.I
        }), $author$project$Ui$SpecialSearchBar$specialSearchBar({
          bh: ' marBottom3 ',
          od: '',
          i1: $elm$core$Maybe$Nothing,
          jq: $elm$core$Maybe$Just($author$project$Ui$ComponentsPreview$Msg$NoOp),
          bu: $author$project$Ui$ComponentsPreview$Msg$OnInput,
          bv: 'Search',
          kI: $author$project$Ui$SpecialSearchBar$FilterSearch({
            yW: $author$project$Ui$ComponentsPreview$Msg$NoOp,
            zb: $author$project$Ui$ComponentsPreview$Msg$NoOp
          }),
          s_: state.I
        }), $author$project$Ui$SpecialSearchBar$specialSearchBar({
          bh: ' marBottom3 ',
          od: '',
          i1: $elm$core$Maybe$Nothing,
          jq: $elm$core$Maybe$Just($author$project$Ui$ComponentsPreview$Msg$NoOp),
          bu: $author$project$Ui$ComponentsPreview$Msg$OnInput,
          bv: 'Enter location',
          kI: A2($author$project$Ui$SpecialSearchBar$LocationSearch, $author$project$Ui$ComponentsPreview$Msg$OnSelectCard, state.cl),
          s_: state.I
        })])),
        lh: 'specialSearchBar'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$SelectItem$selectOptionBar({
          uj: '',
          xa: false,
          xj: state.gt,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnSelectBar,
          lh: 'Padel'
        }), $author$project$ElmFramework$Lib$Util$spacer('h2'), $author$project$Ui$SelectItem$selectOptionBar({
          uj: '',
          xa: true,
          xj: false,
          Cu: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          lh: 'Padel'
        })])),
        lh: 'OptionBar'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexCenter')]), _List_fromArray([$author$project$Ui$SelectItem$selectOptionCard({
          uj: '',
          fn: A2($author$project$Ui$SelectItem$Calendar, '27', 'Wed'),
          xa: false,
          xj: state.cl,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnSelectCard
        }), $author$project$ElmFramework$Lib$Util$spacer('w2'), $author$project$Ui$SelectItem$selectOptionCard({
          uj: '',
          fn: $author$project$Ui$SelectItem$Label('All'),
          xa: false,
          xj: state.cl,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnSelectCard
        }), $author$project$ElmFramework$Lib$Util$spacer('w2'), $author$project$Ui$SelectItem$selectOptionCard({
          uj: '',
          fn: $author$project$Ui$SelectItem$TagButton('Special Access'),
          xa: false,
          xj: state.cl,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnSelectCard
        })])),
        lh: 'OptionSelect'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$BarButton$optionMatch({
          uj: '',
          vn: 'Padel',
          z4: 'Sport',
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnTap
        }), $author$project$ElmFramework$Lib$Util$spacer('h2'), $author$project$Ui$BarButton$optionMatch({
          uj: '',
          vn: 'Venue Name',
          z4: 'Location',
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnTap
        }), $author$project$ElmFramework$Lib$Util$spacer('h2'), $author$project$Ui$BarButton$optionMatch({
          uj: '',
          vn: 'Mon, Tues| 16:00h-19:00h',
          z4: 'Date & Time',
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnTap
        }), $author$project$ElmFramework$Lib$Util$spacer('h2'), $author$project$Ui$BarButton$optionMatch({
          uj: '',
          vn: 'Active',
          z4: 'Synchronization',
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnTap
        }), $author$project$ElmFramework$Lib$Util$spacer('h2'), $author$project$Ui$BarButton$optionMatch({
          uj: '',
          vn: 'Indoor|Outdoor',
          z4: 'Court type',
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnTap
        }), $author$project$ElmFramework$Lib$Util$spacer('h2'), $author$project$Ui$BarButton$optionMatch({
          uj: '',
          vn: 'Crystal',
          z4: 'Court Properties',
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnTap
        }), $author$project$ElmFramework$Lib$Util$spacer('h2'), $author$project$Ui$BarButton$optionMatch({
          uj: '',
          vn: 'Property',
          z4: 'Location Properties',
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnTap
        })])),
        lh: 'optionMatch'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$SelectItem$selectXrivalsContact({
          uj: 'marBottom1 ',
          nM: 1,
          om: $elm$core$Maybe$Just(require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/03.jpg')),
          xf: false,
          xj: state.gu,
          At: 'Name Surname',
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnTapPlayer
        }), $author$project$ElmFramework$Lib$Util$spacer('h2'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular gray80 padBottom1')]), _List_fromArray([$elm$html$Html$text('USER SELECT BAR')])), $author$project$Ui$SelectItem$userSelectBar({
          om: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/03.jpg'),
          xj: state.gv,
          At: 'Name Surname',
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnSelectUser
        })])),
        lh: 'Player'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$BarButton$playerStaffBar({
          Au: A3($author$project$Ui$BarButton$PlayerStaffBarAdminButton, require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/03.jpg'), 'Name Surname', $elm$core$Maybe$Nothing),
          gF: $author$project$Ui$ComponentsPreview$Msg$OnTap,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnTap
        }), $author$project$Ui$BarButton$playerStaffBar({
          Au: A3($author$project$Ui$BarButton$PlayerStaffBarBookingsButton, require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/03.jpg'), 'Name Surname', $elm$core$Maybe$Nothing),
          gF: $author$project$Ui$ComponentsPreview$Msg$OnTap,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnTap
        }), $author$project$Ui$BarButton$playerStaffBar({
          Au: A3($author$project$Ui$BarButton$PlayerStaffBarEditionButton, require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/03.jpg'), 'Name Surname', $elm$core$Maybe$Just($author$project$Ui$ComponentsPreview$Msg$OnTap)),
          gF: $author$project$Ui$ComponentsPreview$Msg$OnTap,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnTap
        }), $author$project$ElmFramework$Lib$Util$spacer('h2'), $author$project$Ui$BarButton$playerStaffBar({
          Au: A2($author$project$Ui$BarButton$PlayerStaffBarWithTextButton, 'sgdghwgh@gmail.com', 'sent on 12/05'),
          gF: $author$project$Ui$ComponentsPreview$Msg$OnTap,
          Cu: $author$project$Ui$ComponentsPreview$Msg$OnTap
        })])),
        lh: 'PlayerStaff'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$NotificationBtn$notificationBtn({
          t_: browser,
          fd: {
            tg: 1,
            uV: $elm$time$Time$millisToPosix(1610211631111),
            od: '',
            o4: $elm$core$Maybe$Just('Padel Match | 04 Sept, 2021 | 10:00'),
            br: $elm$core$Maybe$Nothing,
            f0: 'Padel Match | 04 Sept, 2021 | 10:00',
            qU: 1,
            by: $elm$core$Maybe$Nothing,
            lh: 'You have a match!',
            e_: ''
          },
          uj: 'marBottom2 ',
          fs: $elm$time$Time$millisToPosix(1610211631111),
          p_: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          DJ: $elm$time$Time$utc
        }), $author$project$Ui$NotificationBtn$notificationBtn({
          t_: browser,
          fd: {
            tg: 1,
            uV: $elm$time$Time$millisToPosix(1610211631111),
            od: '',
            o4: $elm$core$Maybe$Just('Padel Match | 04 Sept, 2021 | 10:00'),
            br: $elm$core$Maybe$Nothing,
            f0: 'Padel Match | 04 Sept, 2021 | 10:00',
            qU: 1,
            by: $elm$core$Maybe$Nothing,
            lh: 'You have a match!',
            e_: ''
          },
          uj: 'marBottom2 ',
          fs: $elm$time$Time$millisToPosix(1610211631111),
          p_: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          DJ: $elm$time$Time$utc
        }), $author$project$Ui$NotificationBtn$notificationBtn({
          t_: browser,
          fd: {
            tg: 0,
            uV: $elm$time$Time$millisToPosix(161021163675),
            od: '',
            o4: $elm$core$Maybe$Just('Padel Match | 04 Sept, 2021 | 10:00'),
            br: $elm$core$Maybe$Nothing,
            f0: 'Padel Match | 04 Sept, 2021 | 10:00',
            qU: 1,
            by: $elm$core$Maybe$Nothing,
            lh: 'No players have been found',
            e_: ''
          },
          uj: 'marBottom2 ',
          fs: $elm$time$Time$millisToPosix(1610211631111),
          p_: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          DJ: $elm$time$Time$utc
        }), $author$project$Ui$NotificationBtn$notificationBtn({
          t_: browser,
          fd: {
            tg: 1,
            uV: $elm$time$Time$millisToPosix(1610211631111),
            od: '',
            o4: $elm$core$Maybe$Just('Padel Match | 04 Sept, 2021 | 10:00'),
            br: $elm$core$Maybe$Nothing,
            f0: 'Padel Match | 04 Sept, 2021 | 10:00',
            qU: 1,
            by: $elm$core$Maybe$Nothing,
            lh: 'You have a match!',
            e_: ''
          },
          uj: 'marBottom2 ',
          fs: $elm$time$Time$millisToPosix(1610211631111),
          p_: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          DJ: $elm$time$Time$utc
        })])),
        lh: 'notificationBtn'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([A2($author$project$Ui$MatchmakingCards$draftCard, {
          t_: browser,
          uj: '',
          DJ: $elm$time$Time$utc
        }, {
          mB: {
            om: _List_fromArray([{
              ij: 9,
              eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/photo.jpg'),
              lt: 9
            }]),
            gE: _List_fromArray(['Indoor', 'Mixed match']),
            lh: 'Location Name'
          },
          eg: state.ai,
          zQ: $author$project$Ui$ComponentsPreview$Msg$OnToggleSwitch,
          dh: 1,
          Cy: {
            dY: $elm$time$Time$millisToPosix(1610217031111),
            eL: $elm$time$Time$millisToPosix(1610211631111)
          }
        })])),
        lh: 'draftCard'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$MatchmakingCards$matchMakingCard({
          t_: browser,
          t8: {
            om: _List_fromArray([{
              ij: 9,
              eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/Level_padel.png'),
              lt: 9
            }]),
            gE: _List_Nil,
            lh: 'Location Name'
          },
          uj: '',
          u8: _List_fromArray(['Monday', 'Tuesday', 'Friday'])
        })])),
        lh: 'matchMakingCard'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$MatchmakingCards$confirmCard({
          t_: browser,
          uj: ' marBottom2 ',
          a_: 7,
          iT: $author$project$Types$Match_$Specific({
            cy: 'This is the Location Address',
            mB: {
              om: _List_fromArray([{
                ij: 11,
                eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/photo.jpg'),
                lt: 17
              }]),
              i5: ' ',
              gE: _List_fromArray([', '])
            },
            m5: _Utils_Tuple2(750, 'm'),
            o1: 'Location Name'
          }),
          aO: 124,
          dh: 0,
          gE: _List_fromArray(['Indoor', 'Mixed match']),
          Cy: {
            dY: $elm$time$Time$millisToPosix(1610217031111),
            eL: $elm$time$Time$millisToPosix(1610211631111)
          },
          DJ: $elm$time$Time$utc
        }), $author$project$Ui$MatchmakingCards$confirmCard({
          t_: browser,
          uj: '',
          a_: 2,
          iT: $author$project$Types$Match_$Around(_Utils_Tuple2(18, 'k')),
          aO: 85,
          dh: 1,
          gE: _List_fromArray(['Indoor', 'Mixed match']),
          Cy: {
            dY: $elm$time$Time$millisToPosix(1610217031111),
            eL: $elm$time$Time$millisToPosix(1610211631111)
          },
          DJ: $elm$time$Time$utc
        })])),
        lh: 'confirmCard'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$NavBar$navBar({
          uj: '',
          zd: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          zj: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          zk: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          zn: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          zL: $author$project$Ui$ComponentsPreview$Msg$NoOp
        })])),
        lh: 'navBar'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([A2($author$project$Ui$MatchmakingCards$bookedMatch, {
          t_: browser,
          uj: '',
          DJ: $elm$time$Time$utc
        }, {
          cy: '3 Al Sheraa Street',
          hA: 'court1',
          oH: $author$project$Ui$MatchmakingCards$Online({
            bm: _List_fromArray([$elm$core$Maybe$Just({
              nM: $elm$core$Maybe$Nothing,
              wG: _List_fromArray([{
                ij: 4,
                eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/04.jpg'),
                lt: 4
              }]),
              a_: 4.5,
              i5: 'Me',
              eq: $elm$core$Maybe$Nothing
            }), $elm$core$Maybe$Just({
              nM: $elm$core$Maybe$Nothing,
              wG: _List_fromArray([{
                ij: 4,
                eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/03.jpg'),
                lt: 4
              }]),
              a_: 4.5,
              i5: 'Name',
              eq: $elm$core$Maybe$Nothing
            })]),
            bz: _List_fromArray([$elm$core$Maybe$Just({
              nM: $elm$core$Maybe$Nothing,
              wG: _List_fromArray([{
                ij: 4,
                eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/avatar_44.jpg'),
                lt: 4
              }]),
              a_: 4.5,
              i5: 'Name',
              eq: $elm$core$Maybe$Nothing
            }), $elm$core$Maybe$Just({
              nM: $elm$core$Maybe$Nothing,
              wG: _List_fromArray([{
                ij: 4,
                eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/01.jpg'),
                lt: 4
              }]),
              a_: 4.5,
              i5: 'Name',
              eq: $elm$core$Maybe$Nothing
            })])
          }),
          aO: 76,
          dh: 1,
          Cy: {
            dY: $elm$time$Time$millisToPosix(1610217031111),
            eL: $elm$time$Time$millisToPosix(1610211631111)
          }
        }), A2($author$project$Ui$MatchmakingCards$bookedMatch, {
          t_: browser,
          uj: ' marTop2 ',
          DJ: $elm$time$Time$utc
        }, {
          cy: '3 Al Sheraa Street',
          hA: 'court1',
          oH: $author$project$Ui$MatchmakingCards$Offline({
            nM: $elm$core$Maybe$Nothing,
            wG: _List_fromArray([{
              ij: 4,
              eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/04.jpg'),
              lt: 4
            }]),
            a_: 4.5,
            i5: 'Me',
            eq: $elm$core$Maybe$Just('+971 60 987 7876')
          }),
          aO: 76,
          dh: 1,
          Cy: {
            dY: $elm$time$Time$millisToPosix(1610217031111),
            eL: $elm$time$Time$millisToPosix(1610211631111)
          }
        })])),
        lh: 'bookedMatch'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('111')]), _List_fromArray([$author$project$Ui$PaymentCard$paymentCard({
          tZ: 'Visa',
          uj: ' marBottom1h ',
          v4: '07/2042',
          oC: true,
          xj: true,
          xw: $elm$core$Maybe$Just('1234'),
          i5: 'Dohn Joe',
          pX: $elm$core$Maybe$Nothing,
          p_: $elm$core$Maybe$Nothing,
          p$: $author$project$Ui$ComponentsPreview$Msg$OnToggleCheckBox,
          Ad: $elm$core$Maybe$Nothing
        }), $author$project$Ui$PaymentCard$paymentCard({
          tZ: 'Master Card',
          uj: ' marBottom1h ',
          v4: '07/2042',
          oC: false,
          xj: false,
          xw: $elm$core$Maybe$Just('5678'),
          i5: 'Dohn Joe',
          pX: $elm$core$Maybe$Nothing,
          p_: $elm$core$Maybe$Nothing,
          p$: $author$project$Ui$ComponentsPreview$Msg$OnToggleCheckBox,
          Ad: $elm$core$Maybe$Nothing
        })])),
        lh: 'paymentCard'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$MatchmakingCards$courtSportsCard({
          t_: browser,
          uj: ' marBottom2 ',
          iT: {
            cy: $elm$core$Maybe$Just('Address goes here'),
            om: _List_fromArray([{
              ij: 9,
              eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/image11.jpg'),
              lt: 9
            }]),
            lh: 'Court 1'
          },
          r3: _List_fromArray([0, 1, 2]),
          gE: $elm$core$Maybe$Nothing
        }), $author$project$Ui$MatchmakingCards$courtSportsCard({
          t_: browser,
          uj: 'marBottom2',
          iT: {
            cy: $elm$core$Maybe$Nothing,
            om: _List_fromArray([{
              ij: 9,
              eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/Notifications-01.png'),
              lt: 9
            }]),
            lh: 'Court 2'
          },
          r3: _List_fromArray([0]),
          gE: $elm$core$Maybe$Just(_List_fromArray(['Outdoor', 'Crystal', 'Double']))
        })])),
        lh: 'Court'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$OptionLargeSelect$optionLargeSelect({
          uj: 'mar1',
          wE: $author$project$AssetsSvg$genderMale,
          ea: ' h6',
          xj: state.ai,
          p_: $author$project$Ui$ComponentsPreview$Msg$OnToggleSwitch,
          lh: 'Male'
        }), $author$project$Ui$OptionLargeSelect$optionLargeSelect({
          uj: 'mar1',
          wE: $author$project$AssetsSvg$genderFemale,
          ea: 'h6',
          xj: !state.ai,
          p_: $author$project$Ui$ComponentsPreview$Msg$OnToggleSwitch,
          lh: 'Female'
        })])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$OptionLargeSelect$optionLargeSelect({
          uj: 'mar1',
          wE: $author$project$IconSvg$tennis,
          ea: '',
          xj: !state.ai,
          p_: $author$project$Ui$ComponentsPreview$Msg$OnToggleSwitch,
          lh: 'Tennis'
        }), $author$project$Ui$OptionLargeSelect$optionLargeSelect({
          uj: 'mar1',
          wE: $author$project$IconSvg$padel,
          ea: '',
          xj: state.ai,
          p_: $author$project$Ui$ComponentsPreview$Msg$OnToggleSwitch,
          lh: 'Padel'
        })]))])),
        lh: 'optionLargeSelect'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$OptionLargeSelect$iconBtnRow({
          uj: '',
          wE: $author$project$IconSvg$plus,
          oR: 'Add players',
          p_: $author$project$Ui$ComponentsPreview$Msg$NoOp
        })])),
        lh: 'iconBtnRow'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0Back flexRow ')]), _List_fromArray([$author$project$Ui$MatchmakingCards$playerBigAvatar({
          t_: browser,
          uj: ' mar1 ',
          fr: state.a3,
          od: '1',
          f3: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          p_: $author$project$Ui$ComponentsPreview$Msg$OnSelectPlayer('1'),
          gd: $elm$core$Maybe$Just({
            nM: $elm$core$Maybe$Nothing,
            wG: _List_fromArray([{
              ij: 4,
              eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/04.jpg'),
              lt: 4
            }]),
            a_: 4.5,
            i5: 'Me',
            eq: $elm$core$Maybe$Nothing
          })
        }), $author$project$Ui$MatchmakingCards$playerBigAvatar({
          t_: browser,
          uj: ' mar1 ',
          fr: state.a3,
          od: '2',
          f3: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          p_: $author$project$Ui$ComponentsPreview$Msg$OnSelectPlayer('2'),
          gd: $elm$core$Maybe$Just({
            nM: $elm$core$Maybe$Nothing,
            wG: _List_fromArray([{
              ij: 4,
              eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/02.jpg'),
              lt: 4
            }]),
            a_: 4.5,
            i5: 'Name',
            eq: $elm$core$Maybe$Nothing
          })
        }), $author$project$Ui$MatchmakingCards$playerBigAvatar({
          t_: browser,
          uj: ' mar1 ',
          fr: state.a3,
          od: '3',
          f3: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          p_: $author$project$Ui$ComponentsPreview$Msg$OnSelectPlayer('3'),
          gd: $elm$core$Maybe$Just({
            nM: $elm$core$Maybe$Nothing,
            wG: _List_fromArray([{
              ij: 4,
              eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/01.jpg'),
              lt: 4
            }]),
            a_: 4.5,
            i5: 'Name SurName',
            eq: $elm$core$Maybe$Nothing
          })
        }), $author$project$Ui$MatchmakingCards$playerBigAvatar({
          t_: browser,
          uj: ' mar1',
          fr: state.a3,
          od: '4',
          f3: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          p_: $author$project$Ui$ComponentsPreview$Msg$OnSelectPlayer('4'),
          gd: $elm$core$Maybe$Nothing
        })])),
        lh: 'playerAvatar'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([A2($author$project$Ui$SwitchLeftLabel$switchLeftLabel, '', {
          eg: true,
          oR: 'Activate all',
          zP: $author$project$Ui$ComponentsPreview$Msg$NoOp
        })])),
        lh: 'switchLeftLabel'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$SwitchLeftLabel$roundedImgBox({
          t_: browser,
          uj: ' mar1 ',
          h_: $elm$core$Maybe$Nothing,
          om: _List_fromArray([{
            ij: 9,
            eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/Notifications-01.png'),
            lt: 9
          }]),
          p_: $author$project$Ui$ComponentsPreview$Msg$NoOp
        }), $author$project$Ui$SwitchLeftLabel$roundedImgBox({
          t_: browser,
          uj: ' mar1 ',
          h_: $elm$core$Maybe$Nothing,
          om: _List_fromArray([{
            ij: 9,
            eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/photo.jpg'),
            lt: 9
          }]),
          p_: $author$project$Ui$ComponentsPreview$Msg$NoOp
        }), $author$project$Ui$SwitchLeftLabel$roundedImgBox({
          t_: browser,
          uj: ' mar1 ',
          h_: $elm$core$Maybe$Just(7),
          om: _List_fromArray([{
            ij: 9,
            eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/Matchmaking-02.png'),
            lt: 9
          }]),
          p_: $author$project$Ui$ComponentsPreview$Msg$NoOp
        })])),
        lh: 'roundedImgBox'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$ComponentsPreview$ComponentsPreview$playersRowMock({
          t_: browser,
          uj: '',
          ge: {
            bm: _List_fromArray([$elm$core$Maybe$Just({
              nM: $elm$core$Maybe$Just(1),
              wG: _List_fromArray([{
                ij: 4,
                eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/04.jpg'),
                lt: 4
              }]),
              a_: 4.5,
              i5: 'Me',
              eq: $elm$core$Maybe$Nothing
            }), $elm$core$Maybe$Just({
              nM: $elm$core$Maybe$Just(1),
              wG: _List_fromArray([{
                ij: 4,
                eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/03.jpg'),
                lt: 4
              }]),
              a_: 4.5,
              i5: 'Name',
              eq: $elm$core$Maybe$Nothing
            })]),
            bz: _List_fromArray([$elm$core$Maybe$Just({
              nM: $elm$core$Maybe$Just(0),
              wG: _List_fromArray([{
                ij: 4,
                eZ: require('/home/runner/work/xrivals-frontend/xrivals-frontend/src/assets/images/img/avatar_44.jpg'),
                lt: 4
              }]),
              a_: 4.5,
              i5: 'Name',
              eq: $elm$core$Maybe$Nothing
            }), $elm$core$Maybe$Nothing])
          }
        })])),
        lh: 'playersRow'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$LocationCard$userLocation({
          uj: ' marBottom1 ',
          mr: $elm$core$Maybe$Just($author$project$Ui$ComponentsPreview$Msg$NoOp),
          p_: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          lb: 'Dubai, United Arab Emirates',
          lh: 'Avenue Residence, 10'
        }), $author$project$Ui$LocationCard$userLocation({
          uj: '',
          mr: $elm$core$Maybe$Nothing,
          p_: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          lb: 'Dubai, United Arab Emirates',
          lh: 'Avenue Residence, 10'
        })])),
        lh: 'userLocation'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$NavBar$menuOptionBar({
          uj: 'marBottom3 ',
          p_: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          jX: $author$project$IconSvg$bannedList,
          lh: 'Players banned lists'
        }), $author$project$Ui$NavBar$menuOptionBar({
          uj: 'marBottom3',
          p_: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          jX: $author$project$IconSvg$settings,
          lh: 'Settings'
        }), $author$project$Ui$NavBar$menuOptionBar({
          uj: 'marBottom3',
          p_: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          jX: $author$project$IconSvg$contactHelp,
          lh: 'Contact & Help'
        })])),
        lh: 'menuOptionBar'
      }), $author$project$Ui$ComponentsPreview$ComponentsPreview$simpleWrap({
        a: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([$author$project$Ui$OpeningHoursBar$openingHoursBar({
          uj: '',
          mO: 'Wednesdays',
          eg: false,
          jh: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          jk: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          jm: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          Cy: '10:00-22:00'
        }), $author$project$Ui$OpeningHoursBar$openingHoursBar({
          uj: '',
          mO: 'Thursday',
          eg: true,
          jh: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          jk: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          jm: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          Cy: '10:00-22:00'
        }), $author$project$Ui$OpeningHoursBar$openingHoursBar({
          uj: '',
          mO: 'Fridays',
          eg: true,
          jh: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          jk: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          jm: $author$project$Ui$ComponentsPreview$Msg$NoOp,
          Cy: '10:00-22:00'
        })])),
        lh: 'openingHoursBar'
      })]),
      vS: env,
      aC: state
    });
  });
  var $author$project$Types$EditingUserProfile$EmailTyped = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Types$EditingUserProfile$FirstNameTyped = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Types$EditingUserProfile$LastNameTyped = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Types$EditingUserProfile$PhoneNumberTyped = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Ui$TopLevelViewsUtil$TextBtn = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Remote$RequestMsg$UpdateUser = F3(function (a, b, c) {
    return {
      $: 37,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Ui$EmptyStates$emptyUserAvatar = $author$project$AssetsSvg$emptyAvatar('');
  var $elm_community$result_extra$Result$Extra$andMap = F2(function (ra, rb) {
    var _v0 = _Utils_Tuple2(ra, rb);
    if (_v0.b.$ === 1) {
      var x = _v0.b.a;
      return $elm$core$Result$Err(x);
    } else {
      var o = _v0.a;
      var fn = _v0.b.a;
      return A2($elm$core$Result$map, fn, o);
    }
  });
  var $elm$core$Result$fromMaybe = F2(function (err, maybe) {
    if (!maybe.$) {
      var v = maybe.a;
      return $elm$core$Result$Ok(v);
    } else {
      return $elm$core$Result$Err(err);
    }
  });
  var $author$project$Types$EditingUserProfile$toUserProfile = function (editing) {
    var toUserProfile_ = function (gender) {
      return {
        bZ: editing.bZ,
        nF: editing.nF,
        nM: gender,
        oU: editing.oU,
        iT: editing.iT,
        qo: editing.qo,
        qq: editing.qq
      };
    };
    return A2($elm_community$result_extra$Result$Extra$andMap, A2($elm$core$Result$fromMaybe, 'error', editing.nM), $elm$core$Result$Ok(toUserProfile_));
  };
  var $elm_community$result_extra$Result$Extra$unpack = F3(function (errFunc, okFunc, result) {
    if (!result.$) {
      var ok = result.a;
      return okFunc(ok);
    } else {
      var err = result.a;
      return errFunc(err);
    }
  });
  var $author$project$Ui$EditPersonalDetails$View$view = F3(function (browser, state, maybeUserId) {
    return _List_fromArray([A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer, function (userId) {
      return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
        Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
          l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
          tU: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w11 h11 radius7 absoluteCenterX top0  '), A2($elm$html$Html$Attributes$style, 'transform', 'translateY(-50%) translateX(-50%)')]), _List_fromArray([$author$project$Ui$Button$button({
            bh: 'marBottom3 radius7 ',
            fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w11 h11 radius7 noOverflow ')]), _List_fromArray([A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Ui$EmptyStates$emptyUserAvatar, function (photoUrl) {
              return A2($elm$html$Html$img, _List_fromArray([$elm$html$Html$Attributes$src(photoUrl), $elm$html$Html$Attributes$class(' relative block w11 h11 radius7 noOverflow')]), _List_Nil);
            }, state.qq)])),
            xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$NoOp))
          })])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop7')]), _List_fromArray([$author$project$Ui$Input$labeledInput({
            bP: $elm$core$Maybe$Nothing,
            bh: ' marBottom3 ',
            od: '02',
            wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
            oR: 'First name',
            bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingUserProfile, $author$project$Types$EditingUserProfile$FirstNameTyped),
            bv: 'Enter your First Name',
            ch: false,
            Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
            s_: state.nF
          }), $author$project$Ui$Input$labeledInput({
            bP: $elm$core$Maybe$Nothing,
            bh: ' marBottom3 ',
            od: '02',
            wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
            oR: 'Last name',
            bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingUserProfile, $author$project$Types$EditingUserProfile$LastNameTyped),
            bv: 'Enter your Last Name',
            ch: false,
            Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
            s_: state.oU
          }), $author$project$Ui$Input$labeledInput({
            bP: $elm$core$Maybe$Nothing,
            bh: ' marBottom3 ',
            od: '03',
            wQ: $author$project$ElmFramework$Lib$Ui$Input$Email,
            oR: 'Email',
            bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingUserProfile, $author$project$Types$EditingUserProfile$EmailTyped),
            bv: 'Enter your Email',
            ch: false,
            Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
            s_: state.bZ
          }), $author$project$Ui$Input$labeledInput({
            bP: $elm$core$Maybe$Nothing,
            bh: ' marBottom3 ',
            od: '04',
            wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
            oR: 'Phone number',
            bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingUserProfile, $author$project$Types$EditingUserProfile$PhoneNumberTyped),
            bv: 'Enter your Phone number',
            ch: false,
            Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
            s_: state.qo
          })]))]),
          l5: $elm$core$Maybe$Nothing,
          t_: browser,
          ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop4 marBottom6 maxW43 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0  ')]), _List_fromArray([$elm$html$Html$text('Edit your personal details')]))]))]),
          xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
          Ck: $elm$core$Maybe$Just(3),
          CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
            xC: $elm$core$Maybe$Just($author$project$TopMsg$routeBack),
            yo: $elm$core$Maybe$Nothing,
            Bg: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$TextBtn({
              xa: false,
              oR: 'Save',
              p_: A3($elm_community$result_extra$Result$Extra$unpack, function (error) {
                return A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil);
              }, function (userProfile) {
                return $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$UpdateUser, userId, userProfile, $elm$core$Maybe$Just($author$project$Util$OnRouteCmd$RouteBack)));
              }, $author$project$Types$EditingUserProfile$toUserProfile(state))
            }))
          }))
        })
      });
    }, maybeUserId)]);
  });
  var $author$project$Ui$Feedback$Msg$CommentTyped = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$Feedback$Msg$FeedbackSubmitted = {
    $: 2
  };
  var $author$project$Ui$Feedback$View$feedbackAvatarBtn = F2(function (classes, _v0) {
    var onTap = _v0.p_;
    var icon = _v0.wE;
    var isSelected = _v0.xj;
    var selectionClasses = isSelected ? '' : 'o2';
    return $author$project$Ui$Button$button({
      bh: '' + (selectionClasses + classes),
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('w9 h9 ')]), _List_fromArray([icon('w9 ')])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onTap)
    });
  });
  var $author$project$Api$GraphqlSchema$Enum$Satisfaction$Bad = 2;
  var $author$project$Api$GraphqlSchema$Enum$Satisfaction$Normal = 1;
  var $author$project$Ui$Feedback$Msg$SatisfactionSelected = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$AssetsSvg$feedbackLove_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M20 32C13.3833 32 8 26.6169 8 20C8 13.3831 13.3833 8 20 8C26.6167 8 32 13.3831 32 20C32 26.6169 26.6167 32 20 32Z'), $elm$svg$Svg$Attributes$fill('#FFAC00')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M16.0599 18.8758C15.9303 18.8758 15.8007 18.8288 15.6981 18.7358L15.3944 18.4595C14.2525 17.4239 13.4292 16.6774 13.4292 15.6489C13.4292 14.7016 14.1709 13.9601 15.1175 13.9601C15.4495 13.9601 15.7787 14.0581 16.0599 14.2342C16.341 14.0579 16.6697 13.9601 17.0017 13.9601C17.9485 13.9601 18.6905 14.7018 18.6905 15.6489C18.6905 16.6746 17.8715 17.4196 16.7377 18.4504L16.4204 18.7371C16.3178 18.8296 16.1889 18.8758 16.0599 18.8758Z'), $elm$svg$Svg$Attributes$fill('#D0021B')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M23.9405 18.8758C23.8111 18.8758 23.6818 18.8288 23.5787 18.7358L23.275 18.4595C22.1316 17.4219 21.3101 16.6766 21.3101 15.6489C21.3101 14.7016 22.052 13.9601 22.9989 13.9601C23.3306 13.9601 23.6595 14.0581 23.9407 14.2342C24.2219 14.0579 24.5513 13.9601 24.883 13.9601C25.8299 13.9601 26.5714 14.7018 26.5714 15.6489C26.5714 16.6759 25.7503 17.4219 24.6142 18.4544L24.3015 18.7368C24.1984 18.8296 24.0698 18.8758 23.9405 18.8758Z'), $elm$svg$Svg$Attributes$fill('#D0021B')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M20.0023 27.4105H19.9972H19.9954C15.153 27.4069 13.8471 23.4242 13.8345 23.3835C13.7453 23.1003 13.903 22.7987 14.1862 22.7097C14.4689 22.6216 14.7697 22.7782 14.8592 23.0596C14.9021 23.1933 15.9614 26.3348 19.9997 26.336C24.0393 26.3348 25.0971 23.194 25.1403 23.0596C25.2315 22.7785 25.5346 22.6211 25.8148 22.712C26.097 22.8015 26.2536 23.1008 26.1654 23.3835C26.1526 23.4234 24.848 27.4072 20.004 27.4105H20.0023Z'), $elm$svg$Svg$Attributes$fill('black')]), _List_Nil)]));
  };
  var $author$project$AssetsSvg$feedbackLove = function (classes) {
    return $author$project$AssetsSvg$feedbackLove_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$AssetsSvg$feedbackMed_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M20 32C13.3833 32 8 26.6169 8 20C8 13.3831 13.3833 8 20 8C26.6167 8 32 13.3831 32 20C32 26.6169 26.6167 32 20 32Z'), $elm$svg$Svg$Attributes$fill('#FFAC00')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M25.4 23.6H14.6C14.2686 23.6 14 23.8686 14 24.2C14 24.5313 14.2686 24.8 14.6 24.8H25.4C25.7314 24.8 26 24.5313 26 24.2C26 23.8686 25.7314 23.6 25.4 23.6Z'), $elm$svg$Svg$Attributes$fill('black')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M15.8 17.6C16.7941 17.6 17.6 16.7941 17.6 15.8C17.6 14.8059 16.7941 14 15.8 14C14.8059 14 14 14.8059 14 15.8C14 16.7941 14.8059 17.6 15.8 17.6Z'), $elm$svg$Svg$Attributes$fill('black')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M24.1999 17.6C25.194 17.6 25.9999 16.7941 25.9999 15.8C25.9999 14.8059 25.194 14 24.1999 14C23.2058 14 22.3999 14.8059 22.3999 15.8C22.3999 16.7941 23.2058 17.6 24.1999 17.6Z'), $elm$svg$Svg$Attributes$fill('black')]), _List_Nil)]));
  };
  var $author$project$AssetsSvg$feedbackMed = function (classes) {
    return $author$project$AssetsSvg$feedbackMed_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$AssetsSvg$feedbackSad_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M20 32C13.3833 32 8 26.6169 8 20C8 13.3831 13.3833 8 20 8C26.6167 8 32 13.3831 32 20C32 26.6169 26.6167 32 20 32Z'), $elm$svg$Svg$Attributes$fill('#FFAC00')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M15.8 17.6C16.7941 17.6 17.6 16.7941 17.6 15.8C17.6 14.8059 16.7941 14 15.8 14C14.8059 14 14 14.8059 14 15.8C14 16.7941 14.8059 17.6 15.8 17.6Z'), $elm$svg$Svg$Attributes$fill('black')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M24.2004 17.6C25.1945 17.6 26.0004 16.7941 26.0004 15.8C26.0004 14.8059 25.1945 14 24.2004 14C23.2063 14 22.4004 14.8059 22.4004 15.8C22.4004 16.7941 23.2063 17.6 24.2004 17.6Z'), $elm$svg$Svg$Attributes$fill('black')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M19.9977 22.6851H20.0028H20.0046C24.847 22.6887 26.1529 26.6714 26.1655 26.7121C26.2547 26.9953 26.097 27.2969 25.8138 27.3858C25.5311 27.474 25.2303 27.3174 25.1408 27.0359C25.0979 26.9023 24.0386 23.7608 20.0003 23.7596C15.9607 23.7608 14.9029 26.9015 14.8597 27.0359C14.7685 27.3171 14.4654 27.4745 14.1852 27.3836C13.903 27.2941 13.7464 26.9948 13.8345 26.7121C13.8474 26.6721 15.152 22.6884 19.996 22.6851H19.9977Z'), $elm$svg$Svg$Attributes$fill('black')]), _List_Nil)]));
  };
  var $author$project$AssetsSvg$feedbackSad = function (classes) {
    return $author$project$AssetsSvg$feedbackSad_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$Feedback$View$feedbackAvatars = function (satisfaction) {
    return _List_fromArray([{
      wE: $author$project$AssetsSvg$feedbackLove,
      xj: _Utils_eq(satisfaction, $elm$core$Maybe$Just(0)),
      p_: $author$project$TopMsg$msgFeedback($author$project$Ui$Feedback$Msg$SatisfactionSelected(0))
    }, {
      wE: $author$project$AssetsSvg$feedbackMed,
      xj: _Utils_eq(satisfaction, $elm$core$Maybe$Just(1)),
      p_: $author$project$TopMsg$msgFeedback($author$project$Ui$Feedback$Msg$SatisfactionSelected(1))
    }, {
      wE: $author$project$AssetsSvg$feedbackSad,
      xj: _Utils_eq(satisfaction, $elm$core$Maybe$Just(2)),
      p_: $author$project$TopMsg$msgFeedback($author$project$Ui$Feedback$Msg$SatisfactionSelected(2))
    }]);
  };
  var $elm$regex$Regex$contains = _Regex_contains;
  var $elm_community$string_extra$String$Extra$isBlank = function (string) {
    return A2($elm$regex$Regex$contains, $elm_community$string_extra$String$Extra$regexFromString('^\\s*$'), string);
  };
  var $author$project$Ui$Feedback$View$feedbackView = F2(function (browser, state) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0 bodyRegular marBottom3 ')]), _List_fromArray([$elm$html$Html$text('How is your experience so far? What do you love or don\'t like that much? What would you like us to improve or to include in future releases?')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween padLeft3 padRight3 marBottom3 ')]), A2($elm$core$List$map, $author$project$Ui$Feedback$View$feedbackAvatarBtn(' '), $author$project$Ui$Feedback$View$feedbackAvatars(state.BB))), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$Input$plainTextarea({
          bP: $elm$core$Maybe$Nothing,
          bh: ' minH20  ',
          od: '03',
          wO: ' minH24 ',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgFeedback, $author$project$Ui$Feedback$Msg$CommentTyped),
          bv: 'Write a comment',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: state.mw
        })]))]))]),
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$InlineBelowContentTextIconBtn({
          xa: $elm_community$string_extra$String$Extra$isBlank(state.mw) || _Utils_eq(state.BB, $elm$core$Maybe$Nothing),
          oR: 'Send',
          xD: $elm$core$Maybe$Nothing,
          p_: $author$project$TopMsg$msgFeedback($author$project$Ui$Feedback$Msg$FeedbackSubmitted),
          Bh: $elm$core$Maybe$Nothing,
          r8: 0
        })),
        t_: browser,
        ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 marBottom3 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0 marBottom1 ')]), _List_fromArray([$elm$html$Html$text('Feedback')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Regular gray10 ')]), _List_fromArray([$elm$html$Html$text('Help us improve')]))]))]),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
        Ck: $elm$core$Maybe$Just(2),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Just($author$project$TopMsg$routeBack),
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  });
  var $author$project$Ui$Feedback$View$view = F2(function (browser, state) {
    return _List_fromArray([A2($author$project$Ui$Feedback$View$feedbackView, browser, state)]);
  });
  var $author$project$Ui$TopLevelViewsUtil$InlineBelowContentPairButtonsRow = function (a) {
    return {
      $: 9,
      a: a
    };
  };
  var $author$project$Api$GraphqlSchema$Enum$RespondSearchInviteOption$Reject = 1;
  var $author$project$Ui$MatchmakingCards$SearchCardInInvitation = 0;
  var $author$project$UiWrappers$HeaderAndBodyView$StripesTopRight = 0;
  var $author$project$Types$Search$AwaitingConfirmation = 1;
  var $author$project$Types$Search$AwaitingInvitees = 0;
  var $author$project$Types$Search$Confirmed = 0;
  var $author$project$Ui$MatchmakingCards$InvitedPlayersContextCard = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Types$Search$SearchingForPlayers = 1;
  var $author$project$Types$Activity$activityToSpace = function (activity) {
    switch (activity) {
      case 1:
        return 'Indoor';
      case 3:
        return 'Outdoor';
      case 2:
        return '';
      default:
        return 'Indoor';
    }
  };
  var $author$project$Types$Activity$activityToInfoTags = function (activity) {
    switch (activity) {
      case 1:
        return {
          er: $author$project$Types$Activity$activityToSpace(activity),
          eR: 'Doubles',
          le: '90 min.'
        };
      case 3:
        return {
          er: $author$project$Types$Activity$activityToSpace(activity),
          eR: 'Singles',
          le: '120 min.'
        };
      case 2:
        return {
          er: '',
          eR: '',
          le: ''
        };
      default:
        return {
          er: $author$project$Types$Activity$activityToSpace(activity),
          eR: 'Singles',
          le: '120 min.'
        };
    }
  };
  var $author$project$Types$Search$cardStatuses = F2(function (search, mySpot) {
    var _v0 = _Utils_Tuple2(search, mySpot);
    if (_v0.a === 1) {
      var _v1 = _v0.a;
      var allValues = _v0.b;
      return _Utils_Tuple2($elm$core$Maybe$Just(1), $elm$core$Maybe$Nothing);
    } else {
      if (!_v0.b) {
        var _v2 = _v0.a;
        var _v3 = _v0.b;
        return _Utils_Tuple2($elm$core$Maybe$Just(0), $elm$core$Maybe$Nothing);
      } else {
        var _v4 = _v0.a;
        var _v5 = _v0.b;
        return _Utils_Tuple2($elm$core$Maybe$Just(0), $elm$core$Maybe$Nothing);
      }
    }
  });
  var $author$project$Types$Search$mySpotStatusToString = function (status) {
    if (!status) {
      return 'Confirmed';
    } else {
      return 'Awaiting Confirmation';
    }
  };
  var $author$project$Types$Search$MeSlotWithoutSession = {
    $: 4
  };
  var $author$project$IconSvg$logoIconGrey_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M12.4345 32L8 27.8362L15.358 20L8 12.1638L12.4345 8L19.5303 15.5566L26.6257 8L31.0601 12.1638L23.7021 20L19.5303 24.4434L12.4345 32ZM31.0602 27.8362L26.6257 32C23.2948 28.4527 23.5519 24.415 24.7621 21.1291L31.0602 27.8362Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$logoIconGrey = function (classes) {
    return $author$project$IconSvg$logoIconGrey_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$peopleAddMed_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M20.5217 22C21.6387 22 22.6971 21.7597 23.6438 21.3302L23.6522 21.3301V21.3264C26.1199 20.2029 27.8261 17.7924 27.8261 15C27.8261 11.134 24.5558 8 20.5217 8C16.4877 8 13.2174 11.134 13.2174 15C13.2174 17.2298 14.3053 19.2162 16.0003 20.498C11.3677 21.9214 8 26.2341 8 31.3333C8 31.7015 8.29848 32 8.66667 32H23.6522C24.2285 32 24.6957 31.5523 24.6957 31C24.6957 30.4477 24.2285 30 23.6522 30L23.6318 30.0002H10.087C10.8646 25.7769 14.0997 22.526 18.1601 21.6261C18.9009 21.8685 19.6953 22 20.5217 22ZM25.7392 15C25.7392 17.7614 23.4033 20 20.5218 20C17.6404 20 15.3045 17.7614 15.3045 15C15.3045 12.2386 17.6404 10 20.5218 10C23.4033 10 25.7392 12.2386 25.7392 15ZM26.7824 23.0435C26.7824 22.4672 27.2496 22 27.8259 22C28.4022 22 28.8694 22.4672 28.8694 23.0435V25H31C31.5523 25 32 25.4477 32 26C32 26.5523 31.5523 27 31 27H28.8694V28.9565C28.8694 29.5328 28.4022 30 27.8259 30C27.2496 30 26.7824 29.5328 26.7824 28.9565V27H24.6522C24.0999 27 23.6522 26.5523 23.6522 26C23.6522 25.4477 24.0999 25 24.6522 25H26.7824V23.0435Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$peopleAddMed = function (classes) {
    return $author$project$IconSvg$peopleAddMed_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$peopleUserMed_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M20 8C23.866 8 27 11.134 27 15C27 17.3532 25.8388 19.4352 24.0582 20.7043C28.5978 22.3346 31.8697 26.6243 31.9962 31.695L32 32H8C8 26.7967 11.3117 22.3669 15.9424 20.7034C14.1612 19.4352 13 17.3532 13 15C13 11.134 16.134 8 20 8ZM20 22C15.226 22 11.2334 25.3453 10.2384 29.8196L10.2 30H29.799L29.7659 29.8377C28.7965 25.4366 24.9288 22.1318 20.2799 22.0038L20 22ZM20 10C17.2386 10 15 12.2386 15 15C15 17.7614 17.2386 20 20 20C22.7614 20 25 17.7614 25 15C25 12.2386 22.7614 10 20 10Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$peopleUserMed = function (classes) {
    return $author$project$IconSvg$peopleUserMed_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$MatchmakingCards$invitedPlayerAvatar = F2(function (_v0, searchPlayerSlot) {
    var classes = _v0.uj;
    var browser = _v0.t_;
    var context = _v0.uO;
    var index = _v0.ed;
    var maybeSession = _v0.yj;
    var isItMe = function (userId) {
      return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function (session) {
        return _Utils_eq(session.e_, userId);
      }, maybeSession));
    };
    var _v1 = function () {
      switch (context.$) {
        case 0:
          var onTapEmptySlot = context.a.zM;
          var onRemovePlayer = context.a.zv;
          return _Utils_Tuple3(_Utils_Tuple2(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w4 h4 pad0h primary80Back circle absolute bottom0 right0 ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' w3 h3 ')]), _List_fromArray([$author$project$IconSvg$close1('w3 gray0Fill ')]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w4 h4 pad0h secondary800Back circle absolute bottom0 right0 ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' w3 h3 ')]), _List_fromArray([$author$project$IconSvg$plus('w3 gray90Fill ')]))]))), function () {
            switch (searchPlayerSlot.$) {
              case 0:
                return $author$project$ElmFramework$Lib$Ui$Button$NoAction;
              case 3:
                return $author$project$ElmFramework$Lib$Ui$Button$Button(onTapEmptySlot(index));
              default:
                return $author$project$ElmFramework$Lib$Ui$Button$Button(onRemovePlayer(index));
            }
          }(), ' secondary800 ');
        case 1:
          return _Utils_Tuple3(_Utils_Tuple2($author$project$ElmFramework$Lib$Util$noOpEl, $author$project$ElmFramework$Lib$Util$noOpEl), $author$project$ElmFramework$Lib$Ui$Button$NoAction, ' gray90 ');
        default:
          var cardContext = context.a;
          return _Utils_Tuple3(_Utils_Tuple2($author$project$ElmFramework$Lib$Util$noOpEl, $author$project$ElmFramework$Lib$Util$noOpEl), $author$project$ElmFramework$Lib$Ui$Button$NoAction, ' gray90 ');
      }
    }();
    var _v2 = _v1.a;
    var removeBtn = _v2.a;
    var addBtn = _v2.b;
    var wrapperKind = _v1.b;
    var textColor = _v1.c;
    var _v5 = function () {
      if (context.$ === 2) {
        return _Utils_Tuple3(4, 13, _Utils_Tuple2(' w4 h4 ', ' w2 '));
      } else {
        return _Utils_Tuple3(8, 8, _Utils_Tuple2(' w8 h8 ', ' w5 '));
      }
    }();
    var widthUnits = _v5.a;
    var widthAndHeightValue = _v5.b;
    var _v6 = _v5.c;
    var widthAndHeightClasses = _v6.a;
    var iconWidthClass = _v6.b;
    var _v8 = function () {
      switch (searchPlayerSlot.$) {
        case 0:
          var userId = searchPlayerSlot.a;
          var userProfile = searchPlayerSlot.b;
          return _Utils_Tuple2(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' relative trans3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' circle noOverflow ' + widthAndHeightClasses)]), _List_fromArray([A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Ui$EmptyStates$emptyUserAvatar, function (photoUrl) {
            return $author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
              t_: browser,
              uj: '',
              wG: _List_fromArray([{
                ij: widthAndHeightValue,
                eZ: photoUrl,
                lt: widthAndHeightValue
              }]),
              Dq: widthUnits,
              s5: ' relative block circle noOverflow ' + widthAndHeightClasses
            });
          }, userProfile.qq)]))])), function () {
            switch (context.$) {
              case 0:
                return 'Me';
              case 1:
                return 'Me';
              default:
                return isItMe(userId) ? 'Me' : userProfile.nF;
            }
          }());
        case 1:
          var userId = searchPlayerSlot.a;
          var userProfilePublic = searchPlayerSlot.b;
          return _Utils_Tuple2(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' relative trans3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' circle noOverflow ' + widthAndHeightClasses)]), _List_fromArray([A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Ui$EmptyStates$emptyUserAvatar, function (photoUrl) {
            return $author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
              t_: browser,
              uj: '',
              wG: _List_fromArray([{
                ij: widthAndHeightValue,
                eZ: photoUrl,
                lt: widthAndHeightValue
              }]),
              Dq: widthUnits,
              s5: ' relative block circle noOverflow ' + widthAndHeightClasses
            });
          }, userProfilePublic.qq)])), removeBtn])), isItMe(userId) ? 'Me' : userProfilePublic.nF);
        case 2:
          return _Utils_Tuple2(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' relative trans3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('circle secondary800Back flexCenter ' + widthAndHeightClasses)]), _List_fromArray([$author$project$IconSvg$peopleUserMed(' primary0Fill ' + iconWidthClass)])), removeBtn])), 'Invited');
        case 3:
          var _v11 = _Utils_Tuple2('XRIVALS', A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' relative trans3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' circle primary0Back flexCenter ' + widthAndHeightClasses)]), _List_fromArray([$author$project$IconSvg$logoIconGrey(' primary20Fill ' + iconWidthClass)]))])));
          var previewTitle = _v11.a;
          var previewIcon = _v11.b;
          var _v12 = _Utils_Tuple2('Add', A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' relative trans3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' circle primary80Back borderDashed primary40Border borderW125 flexCenter ' + widthAndHeightClasses)]), _List_fromArray([$author$project$IconSvg$peopleAddMed(' gray0Fill ' + iconWidthClass)]))])));
          var createSearchTitle = _v12.a;
          var createSearchIcon = _v12.b;
          var _v13 = function () {
            switch (context.$) {
              case 0:
                var record = context.a;
                return _Utils_Tuple2(createSearchTitle, createSearchIcon);
              case 1:
                return _Utils_Tuple2(previewTitle, previewIcon);
              default:
                var searchCardContext = context.a;
                return _Utils_Tuple2(previewTitle, previewIcon);
            }
          }();
          var slotLabel = _v13.a;
          var emptySlotAvatar = _v13.b;
          return _Utils_Tuple2(emptySlotAvatar, slotLabel);
        default:
          return _Utils_Tuple2(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' relative trans3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' circle noOverflow ' + widthAndHeightClasses)]), _List_fromArray([$author$project$Ui$EmptyStates$emptyUserAvatar]))])), 'Me');
      }
    }();
    var avatar = _v8.a;
    var name = _v8.b;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexCenterColumn maxW8 noOverflow '), $elm$html$Html$Attributes$class(classes)]), _List_fromArray([$author$project$Ui$Button$button({
      bh: '',
      fn: avatar,
      xu: wrapperKind
    }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading6Regular ellipsis fullWidth center ' + textColor)]), _List_fromArray([$elm$html$Html$text(name)]))]));
  });
  var $author$project$Types$UserProfile$toUserProfilePublic = function (userProfile) {
    return {
      nF: userProfile.nF,
      nM: userProfile.nM,
      xy: A2($elm$core$String$left, 1, userProfile.oU) + '.',
      fT: userProfile.oU,
      qq: userProfile.qq
    };
  };
  var $author$project$Ui$MatchmakingCards$searchPlayersRow = function (_v0) {
    var browser = _v0.t_;
    var creatorProfile = _v0.uZ;
    var searchParams = _v0.BH;
    var context = _v0.uO;
    var classes = _v0.uj;
    var createdById = _v0.uX;
    var maybeSession = _v0.yj;
    var _v1 = searchParams.du;
    if (!_v1.$) {
      var activity = _v1.a;
      var isMyUserPresent = function () {
        if (!maybeSession.$) {
          var session = maybeSession.a;
          return $elm_community$maybe_extra$Maybe$Extra$isJust(A2($elm_community$list_extra$List$Extra$find, function (userId) {
            return _Utils_eq(session.e_, userId);
          }, A2($elm$core$List$cons, createdById, A2($elm$core$List$filterMap, function (invitedPlayer) {
            switch (invitedPlayer.$) {
              case 0:
                var userId = invitedPlayer.a;
                return $elm$core$Maybe$Just(userId);
              case 1:
                var userId = invitedPlayer.a;
                return $elm$core$Maybe$Just(userId);
              default:
                return $elm$core$Maybe$Nothing;
            }
          }, searchParams.ox))));
        } else {
          return false;
        }
      }();
      var maybeMeSlot = function () {
        if (context.$ === 2 && !context.a) {
          var _v4 = context.a;
          if ($elm_community$maybe_extra$Maybe$Extra$isNothing(maybeSession)) {
            return $elm$core$Maybe$Just(A2($author$project$Ui$MatchmakingCards$invitedPlayerAvatar, {
              t_: browser,
              uj: '',
              uO: context,
              uX: createdById,
              ed: 300,
              yj: $elm$core$Maybe$Nothing
            }, $author$project$Types$Search$MeSlotWithoutSession));
          } else {
            if (!isMyUserPresent) {
              if (!maybeSession.$) {
                var session = maybeSession.a;
                return $elm$core$Maybe$Just(A2($author$project$Ui$MatchmakingCards$invitedPlayerAvatar, {
                  t_: browser,
                  uj: '',
                  uO: context,
                  uX: createdById,
                  ed: 300,
                  yj: $elm$core$Maybe$Just(session)
                }, A2($author$project$Types$Search$InternalInvite, session.e_, $author$project$Types$UserProfile$toUserProfilePublic(session.Db))));
              } else {
                return $elm$core$Maybe$Nothing;
              }
            } else {
              return $elm$core$Maybe$Nothing;
            }
          }
        } else {
          return $elm$core$Maybe$Nothing;
        }
      }();
      var invitedPlayers = A2($elm$core$List$filter, function (invitedPlayer) {
        switch (invitedPlayer.$) {
          case 3:
            return false;
          case 0:
            return false;
          default:
            return true;
        }
      }, searchParams.ox);
      var emptySlots = A2($elm$core$List$repeat, $author$project$Types$Activity$toNumberOfPlayers(activity) - 1 - $elm$core$List$length(invitedPlayers) - A3($elm_community$maybe_extra$Maybe$Extra$unwrap, 0, $elm$core$Basics$always(1), maybeMeSlot), $author$project$Types$Search$EmptySlot);
      var creatorSlot = A2($author$project$Ui$MatchmakingCards$invitedPlayerAvatar, {
        t_: browser,
        uj: '',
        uO: context,
        uX: createdById,
        ed: 300,
        yj: maybeSession
      }, A2($author$project$Types$Search$CreatorSlot, createdById, creatorProfile));
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceAround scrollTargetX noScrollbar ' + classes)]), _Utils_ap(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$singleton, maybeMeSlot)), _Utils_ap(_List_fromArray([creatorSlot]), A2($elm$core$List$indexedMap, F2(function (index, avatar) {
        return A2($author$project$Ui$MatchmakingCards$invitedPlayerAvatar, {
          t_: browser,
          uj: '',
          uO: context,
          uX: createdById,
          ed: index,
          yj: maybeSession
        }, avatar);
      }), _Utils_ap(invitedPlayers, emptySlots)))));
    } else {
      return $author$project$ElmFramework$Lib$Util$noOpEl;
    }
  };
  var $author$project$Ui$Tags$DotGreen = 1;
  var $author$project$Ui$Tags$DotOrange = 0;
  var $author$project$Ui$MatchmakingCards$searchStatusToDot = function (searchStatus) {
    if (!searchStatus) {
      return 0;
    } else {
      return 1;
    }
  };
  var $author$project$Types$Search$statusForCardToString = function (status) {
    if (!status) {
      return 'Awaiting Invitees';
    } else {
      return 'Searching for players';
    }
  };
  var $author$project$Types$Activity$toIcon = function (activity) {
    switch (activity) {
      case 1:
        return $author$project$IconSvg$padel;
      case 3:
        return $author$project$IconSvg$tennis;
      case 2:
        return $author$project$IconSvg$squash;
      default:
        return $author$project$IconSvg$badminton;
    }
  };
  var $author$project$Ui$TimeRepresentation$toLocalClockTime = function (_v0) {
    var hour = _v0.wC;
    var minute = _v0.yu;
    return A2($elm$core$String$join, ':', _List_fromArray([A3($elm$core$String$pad, 2, '0', $elm$core$String$fromInt(hour)), A3($elm$core$String$pad, 2, '0', $elm$core$String$fromInt(minute))]));
  };
  var $author$project$Ui$TimeRepresentation$intToEnglishMonth = function (month) {
    switch (month) {
      case 1:
        return 'Jan';
      case 2:
        return 'Feb';
      case 3:
        return 'Mar';
      case 4:
        return 'Apr';
      case 5:
        return 'May';
      case 6:
        return 'Jun';
      case 7:
        return 'Jul';
      case 8:
        return 'Aug';
      case 9:
        return 'Sept';
      case 10:
        return 'Oct';
      case 11:
        return 'Nov';
      case 12:
        return 'Dec';
      default:
        return 'Invalid value for month';
    }
  };
  var $author$project$Ui$TimeRepresentation$toLocalDayMonth = function (_v0) {
    var month = _v0.pt;
    var day = _v0.mO;
    return A2($elm$core$String$join, ' ', _List_fromArray([$elm$core$String$fromInt(day), $author$project$Ui$TimeRepresentation$intToEnglishMonth(month)]));
  };
  var $author$project$Ui$MatchmakingCards$searchCard = F2(function (_v0, searchDetails) {
    var classes = _v0.uj;
    var browser = _v0.t_;
    var zone = _v0.DJ;
    var onTap = _v0.p_;
    var maybeSession = _v0.yj;
    var context = _v0.uO;
    var createdAt = searchDetails.uV;
    var search = searchDetails.kH;
    var createdBy = searchDetails.uW;
    var statusElement = F3(function (title, statusText, maybeDot) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold primary0 inlineFlexCenter ellipsis ')]), _List_fromArray([$elm$html$Html$text(title + ':'), A3($author$project$Ui$MatchmakingCards$toTag, ' marLeft1 ', statusText, maybeDot)]));
    });
    var status = function () {
      var _v18 = search.aC;
      switch (_v18) {
        case 0:
          return 1;
        case 2:
          return 0;
        case 1:
          return 0;
        case 3:
          return 0;
        case 5:
          return 0;
        default:
          return 0;
      }
    }();
    var sportName = A2($author$project$Types$Activity$toString, false, search.p8.du);
    var sportIcon = $author$project$Types$Activity$toIcon(search.p8.du);
    var placeTextInInvitation = function (placeText) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading6Regular flexRow flexAlignCenter whiteSpaceNoWrap left ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('gray80 ellipsis marRight0h ')]), _List_fromArray([$elm$html$Html$text(placeText)]))]));
    };
    var maybeThisUserInInvitees = function () {
      if (!maybeSession.$) {
        var session = maybeSession.a;
        return A2($elm_community$list_extra$List$Extra$find, A2($elm$core$Basics$composeR, function ($) {
          return $.e_;
        }, $elm$core$Basics$eq(session.e_)), search.w5);
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }();
    var mySpot = function () {
      if (!maybeThisUserInInvitees.$) {
        var userId = maybeThisUserInInvitees.a.e_;
        var profile = maybeThisUserInInvitees.a.qI;
        var inviteStatus = maybeThisUserInInvitees.a.ow;
        switch (inviteStatus) {
          case 0:
            return 1;
          case 1:
            return 1;
          case 2:
            return 0;
          default:
            return 1;
        }
      } else {
        return 1;
      }
    }();
    var statusRowSearch = function () {
      var _v10 = A2($author$project$Types$Search$cardStatuses, status, mySpot);
      if (!_v10.a.$) {
        if (!_v10.b.$) {
          var searchStatus = _v10.a.a;
          var mySpotStatus = _v10.b.a;
          return _List_fromArray([A3(statusElement, 'Status', $author$project$Types$Search$statusForCardToString(searchStatus), $elm$core$Maybe$Just($author$project$Ui$MatchmakingCards$searchStatusToDot(searchStatus))), A3(statusElement, 'My spot', $author$project$Types$Search$mySpotStatusToString(mySpotStatus), $elm$core$Maybe$Nothing)]);
        } else {
          var searchStatus = _v10.a.a;
          var _v11 = _v10.b;
          return _List_fromArray([A3(statusElement, 'Status', $author$project$Types$Search$statusForCardToString(searchStatus), $elm$core$Maybe$Just($author$project$Ui$MatchmakingCards$searchStatusToDot(searchStatus)))]);
        }
      } else {
        if (!_v10.b.$) {
          var _v12 = _v10.a;
          var mySpotStatus = _v10.b.a;
          return _List_fromArray([A3(statusElement, 'My spot', $author$project$Types$Search$mySpotStatusToString(mySpotStatus), $elm$core$Maybe$Nothing)]);
        } else {
          var _v13 = _v10.a;
          var _v14 = _v10.b;
          return _List_Nil;
        }
      }
    }();
    var endTimeString = function (_v9) {
      var from = _v9.wh;
      var to = _v9.CC;
      return !_Utils_eq(from.mO, to.mO) ? $author$project$Ui$TimeRepresentation$toLocalDayMonth(to) + (', ' + $author$project$Ui$TimeRepresentation$toLocalClockTime(to)) : $author$project$Ui$TimeRepresentation$toLocalClockTime(to);
    };
    var toSearchTime = function (availability) {
      var from = availability.wh;
      var to = availability.CC;
      return $author$project$Ui$TimeRepresentation$toLocalDayMonth(from) + (', ' + ($author$project$Ui$TimeRepresentation$toLocalClockTime(from) + (' - ' + endTimeString(availability))));
    };
    var toMultiMatchTime = F2(function (index, time) {
      if (!context) {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold primary0 inlineFlexCenter ellipsis marRight1 ')]), _List_fromArray([$elm$html$Html$text('Availability ' + ($elm$core$String$fromInt(index) + ':'))]));
      } else {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' marRight1 radius2 gray0Back gray80 heading6Light padRight1 padLeft1 padTop0h padBottom0h ')]), _List_fromArray([$elm$html$Html$text(toSearchTime(time))]));
      }
    });
    var toSingleTime = function (time) {
      if (!context) {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold primary0 inlineFlexCenter ellipsis marRight1 ')]), _List_fromArray([$elm$html$Html$text('Availability:')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading6Light gray80 inlineFlexCenter ellipsis ')]), _List_fromArray([$elm$html$Html$text(toSearchTime(time))]))]));
      } else {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray80 heading6Light whiteSpaceNoWrap  ')]), _List_fromArray([$elm$html$Html$text(toSearchTime(time))]));
      }
    };
    var searchTimeRangesRow = $elm$core$List$length(search.p8.tF) === 1 ? {
      hx: function () {
        if (context === 1) {
          return 'flexRow ';
        } else {
          return 'flexColumn ';
        }
      }(),
      kK: '',
      gJ: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow padRight2 ')]), A2($elm$core$List$map, toSingleTime, search.p8.tF))
    } : {
      hx: 'flexColumn',
      kK: 'pPadBottom1',
      gJ: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow whiteSpaceNoWrap marTop0h scrollTargetX noScrollbar padLeft2 padRight1  ')]), A2($elm$core$List$indexedMap, toMultiMatchTime, search.p8.tF))
    };
    var creatorProfile = $author$project$Types$ParticipantPublic$toUserProfileLimited(createdBy);
    var addressDetails = F2(function (address, _v5) {
      var distance = _v5.a;
      var dUnit = _v5.b;
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading6Regular flexRow flexAlignCenter whiteSpaceNoWrap left ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('gray80 ellipsis marRight0h ')]), _List_fromArray([$elm$html$Html$text(address)])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w2 h2 marRight0h ')]), _List_fromArray([$author$project$IconSvg$directright('gray80Fill w2 ')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('gray60 ')]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(distance) + (' ' + dUnit))]))]));
    });
    var locationInfo = {
      cz: A2(addressDetails, search.p8.cy.lb, _Utils_Tuple2(search.p8.Dr, 'Km')),
      wG: $author$project$ElmFramework$Lib$Util$noOpEl,
      lh: search.p8.cy.lh
    };
    var _v1 = _Utils_Tuple2('', '');
    var awaitingPaymentTextColorClass = _v1.a;
    var awaitingPaymentText = _v1.b;
    return $author$project$Ui$Button$button({
      bh: ' fullWidth ' + classes,
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' radius5 flexColumn secondary800Back noOverflow ' + awaitingPaymentTextColorClass)]), _List_fromArray([A3($author$project$Ui$MatchmakingCards$section, true, ' marRight-2 marLeft-2  ' + searchTimeRangesRow.kK, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padLeft2 spaceBetween fullWidth noOverflow  ' + searchTimeRangesRow.hx)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w2 h2 marRight0h ')]), _List_fromArray([sportIcon('w2 ')])), A2($elm$html$Html$h2, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold primary0 ellipsis marRight0h ' + awaitingPaymentTextColorClass)]), _List_fromArray([$elm$html$Html$text(_Utils_ap(sportName, awaitingPaymentText))]))])), function () {
        if (context === 1) {
          return searchTimeRangesRow.gJ;
        } else {
          return A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ellipsis flexRow marTop1 ')]), _List_fromArray([placeTextInInvitation(locationInfo.lh), locationInfo.cz])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ellipsis flexRow marTop1 ')]), _List_fromArray([A3($author$project$Ui$MatchmakingCards$toTag, '', $author$project$Types$Activity$activityToInfoTags(search.p8.du).er, $elm$core$Maybe$Nothing), A3($author$project$Ui$MatchmakingCards$toTag, ' marLeft1 ', $author$project$Types$Activity$activityToInfoTags(search.p8.du).eR, $elm$core$Maybe$Nothing), A3($author$project$Ui$MatchmakingCards$toTag, ' marLeft1 ', $author$project$Types$Activity$activityToInfoTags(search.p8.du).le, $elm$core$Maybe$Nothing)]))]));
        }
      }()]))])), A3($author$project$Ui$MatchmakingCards$section, true, ' spaceBetween ', statusRowSearch), function () {
        if (context === 1) {
          return $author$project$ElmFramework$Lib$Util$noOpEl;
        } else {
          return A3($author$project$Ui$MatchmakingCards$section, true, '', _List_fromArray([searchTimeRangesRow.gJ]));
        }
      }(), A3($author$project$Ui$MatchmakingCards$section, true, ' spaceBetween flexAlignCenter ', _List_fromArray([$author$project$Ui$MatchmakingCards$searchPlayersRow({
        t_: browser,
        uj: ' flex1 ',
        uO: $author$project$Ui$MatchmakingCards$InvitedPlayersContextCard(context),
        uX: createdBy.e_,
        uZ: creatorProfile,
        yj: maybeSession,
        BH: A2($author$project$Types$CreateOrEditSearchParams$fromSearch, maybeSession, searchDetails)
      })])), function () {
        if (context === 1) {
          return A3($author$project$Ui$MatchmakingCards$section, false, '', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop0h padBottom0h flexRow noOverflow   ')]), _List_fromArray([locationInfo.wG, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn noOverflow left ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold ellipsis ')]), _List_fromArray([$elm$html$Html$text(locationInfo.lh)])), locationInfo.cz]))]))]));
        } else {
          return $author$project$ElmFramework$Lib$Util$noOpEl;
        }
      }()])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onTap)
    });
  });
  var $author$project$Ui$Invitation$View$view = F3(function (browser, topState, invitationRoute) {
    var _v0 = topState.lL.wY.qZ;
    switch (_v0.$) {
      case 3:
        var searchDetails = _v0.a;
        var maybeSession = $author$project$Remote$Model$toSession(topState.lL.A$);
        var isUserJoined = function () {
          var _v8 = topState.lL.A$.sX;
          if (_v8.$ === 3) {
            var session = _v8.a;
            return $elm$core$Maybe$Just(A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function (_v9) {
              var inviteStatus = _v9.ow;
              return inviteStatus === 2;
            }, A2($elm_community$list_extra$List$Extra$find, A2($elm$core$Basics$composeR, function ($) {
              return $.e_;
            }, $elm$core$Basics$eq(session.e_)), searchDetails.kH.w5))) || _Utils_eq(searchDetails.uW.e_, session.e_));
          } else {
            return $elm_community$maybe_extra$Maybe$Extra$join($elm$core$Maybe$Nothing);
          }
        }();
        var bottomInteraction = function () {
          var buttons = $author$project$Ui$TopLevelViewsUtil$InlineBelowContentPairButtonsRow(_Utils_Tuple2({
            xa: false,
            oR: 'Reject',
            p_: $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$RespondSearchInvite, true, invitationRoute, 1)),
            r8: 1
          }, {
            xa: false,
            oR: 'Accept',
            p_: $elm_community$maybe_extra$Maybe$Extra$isJust(maybeSession) ? $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$RespondSearchInvite, true, invitationRoute, 0)) : $author$project$TopMsg$multiMsg(_List_fromArray([$author$project$TopMsg$routeTo($author$project$Route$Route$Auth(A2($author$project$Route$Route$Register, $elm$core$Maybe$Nothing, A2($author$project$Route$Route$RespondToInviteAfterRegistration, invitationRoute, 0)))), A3($author$project$ElmFramework$MsgCmd$msgCmd.CP, $elm$core$Maybe$Nothing, 'Please register or sign in first', _List_Nil)])),
            r8: 0
          }));
          var _v4 = _Utils_Tuple2(searchDetails.kH.aC, isUserJoined);
          _v4$2: while (true) {
            if (_v4.a === 2) {
              if (!_v4.b.$) {
                if (!_v4.b.a) {
                  var _v5 = _v4.a;
                  return $elm$core$Maybe$Just(buttons);
                } else {
                  break _v4$2;
                }
              } else {
                var _v6 = _v4.a;
                var _v7 = _v4.b;
                return $elm$core$Maybe$Just(buttons);
              }
            } else {
              break _v4$2;
            }
          }
          return $elm$core$Maybe$Nothing;
        }();
        var _v1 = topState;
        var zone = _v1.DJ;
        var bodyContent = _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([A2($author$project$Ui$MatchmakingCards$searchCard, {
          t_: browser,
          uj: ' marBottom2 noPointerEvents ',
          uO: 0,
          yj: maybeSession,
          p_: $author$project$TopMsg$routeTo($author$project$Route$Route$Invitation(invitationRoute)),
          DJ: zone
        }, searchDetails)]))]);
        var _v2 = topState.lL.wY;
        var remoteSearchDetails = _v2.qZ;
        var _v3 = $author$project$Types$ParticipantPublic$toUserProfileLimited(searchDetails.uW);
        var firstName = _v3.nF;
        var lastNameOrInitial = _v3.fT;
        var gender = _v3.nM;
        var photoUrl = _v3.qq;
        var headerContent = _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop3 padBottom3 ')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight2 w8 h8')]), _List_fromArray([A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Ui$EmptyStates$emptyUserAvatar, function (photo) {
          return A2($elm$html$Html$img, _List_fromArray([$elm$html$Html$Attributes$src(photo), $elm$html$Html$Attributes$class('relative block w8 h8 radius7 noOverflow')]), _List_Nil);
        }, photoUrl)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold marTop2 gray0')]), _List_fromArray([$elm$html$Html$text(firstName + (' ' + lastNameOrInitial) + (' ' + 'invited you for a match'))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray10 bodyRegular marTop1  ')]), _List_fromArray([$elm$html$Html$text('Once accepted, XRIVALS will look for other players to fill the match.')]))]))]))]))]);
        return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
          Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
            l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
            tU: bodyContent,
            l5: bottomInteraction,
            t_: browser,
            ww: headerContent,
            xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
            Ck: $elm$core$Maybe$Just(0),
            CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
              xC: $elm$core$Maybe$Just($author$project$ElmFramework$MsgCmd$msgCmd.Bl),
              yo: $elm$core$Maybe$Nothing,
              Bg: $elm$core$Maybe$Nothing
            }))
          })
        })]);
      case 1:
        return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
          Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
            l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
            tU: _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_Nil)]),
            l5: $elm$core$Maybe$Nothing,
            t_: browser,
            ww: _List_Nil,
            xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
              xc: false
            }),
            Ck: $elm$core$Maybe$Just(0),
            CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
              xC: $elm$core$Maybe$Just($author$project$TopMsg$routeTo($author$project$Route$Route$homeRoute)),
              yo: $elm$core$Maybe$Nothing,
              Bg: $elm$core$Maybe$Nothing
            }))
          })
        })]);
      default:
        return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
          Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
            l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
            tU: _List_Nil,
            l5: $elm$core$Maybe$Nothing,
            t_: browser,
            ww: A4($author$project$Ui$Overlays$overlayHeaderIconTextContent, _Utils_Tuple2($author$project$AssetsSvg$xrivalsAlert, 10), 'The invitation is not operational right now', _List_fromArray(['Please try again in a few minutes or contact the person who invited you to send you a new invitation.']), true),
            xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
              xc: false
            }),
            Ck: $elm$core$Maybe$Just(2),
            CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
              xC: $elm$core$Maybe$Just($author$project$TopMsg$routeBack),
              yo: $elm$core$Maybe$Nothing,
              Bg: $elm$core$Maybe$Nothing
            }))
          })
        })]);
    }
  });
  var $author$project$Global$Model$DeleteAccountDialog = function (a) {
    return {
      $: 10,
      a: a
    };
  };
  var $author$project$Ui$TopLevelViewsUtil$NavBar = {
    $: 4
  };
  var $author$project$IconSvg$email_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M14.4186 30.6512H25.5814C29.6558 30.6512 32 28.307 32 24.2326V16.4186C32 12.3442 29.6558 10 25.5814 10H14.4186C10.3442 10 8 12.3442 8 16.4186C8 16.8763 8.37953 17.2558 8.83721 17.2558C9.29488 17.2558 9.67442 16.8763 9.67442 16.4186C9.67442 13.226 11.226 11.6744 14.4186 11.6744H25.5814C28.774 11.6744 30.3256 13.226 30.3256 16.4186V24.2326C30.3256 27.4251 28.774 28.9767 25.5814 28.9767H14.4186C13.9609 28.9767 13.5814 29.3563 13.5814 29.814C13.5814 30.2716 13.9609 30.6512 14.4186 30.6512ZM17.3877 20.4149C18.1132 21.0065 19.0621 21.2967 19.9998 21.2967C20.9374 21.2967 21.8862 21.0065 22.6007 20.4149L26.0946 17.6242C26.463 17.3451 26.5188 16.8093 26.2286 16.4521C25.9495 16.0837 25.4137 16.0279 25.0565 16.3181L21.5625 19.1088C20.7142 19.7897 19.2742 19.7897 18.4258 19.1088L14.9318 16.3181C14.5746 16.0279 14.05 16.0948 13.7598 16.4521C13.4695 16.8093 13.5365 17.3339 13.8937 17.6242L17.3877 20.4149ZM16.3721 25.3488C16.3721 25.8065 15.9926 26.186 15.5349 26.186H8.83721C8.37953 26.186 8 25.8065 8 25.3488C8 24.8912 8.37953 24.5116 8.83721 24.5116H15.5349C15.9926 24.5116 16.3721 24.8912 16.3721 25.3488ZM8.83721 21.7209H12.186C12.6437 21.7209 13.0233 21.3414 13.0233 20.8837C13.0233 20.426 12.6437 20.0465 12.186 20.0465H8.83721C8.37953 20.0465 8 20.426 8 20.8837C8 21.3414 8.37953 21.7209 8.83721 21.7209Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$password_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M23.0244 31.1628C23.0244 31.6205 23.4059 32 23.8659 32C24.3259 32 24.7073 31.6205 24.7073 31.1628V29.2093H25.5487C26.3902 29.2093 27.0073 29.1758 27.5009 29.1088C31.2595 28.6958 32 26.4744 32 22.7907V17.2093C32 13.5256 31.2707 11.3153 27.5346 10.9023C27.0073 10.8242 26.3902 10.7907 25.5487 10.7907H24.7073V8.83721C24.7073 8.37953 24.3259 8 23.8659 8C23.4059 8 23.0244 8.37953 23.0244 8.83721V31.1628ZM24.7073 12.4651V27.5349H25.5487C26.3117 27.5349 26.8502 27.5014 27.2878 27.4456C29.5653 27.2 30.317 26.4856 30.317 22.7907V17.2093C30.317 13.5144 29.5653 12.8111 27.3214 12.5544C26.8502 12.4874 26.3117 12.4651 25.5487 12.4651H24.7073ZM19.4005 29.2093H15.4512C14.6098 29.2093 13.9927 29.1758 13.4654 29.0977C9.72927 28.6846 9 26.4744 9 22.7907V17.2093C9 13.5256 9.74049 11.3042 13.499 10.8912C13.9927 10.8242 14.6098 10.7907 15.4512 10.7907H19.3332C19.7932 10.7907 20.1746 11.1702 20.1746 11.6279C20.1746 12.0856 19.7932 12.4651 19.3332 12.4651H15.4512C14.6883 12.4651 14.1498 12.4986 13.7122 12.5544C11.4346 12.8 10.6829 13.5144 10.6829 17.2093V22.7907C10.6829 26.4856 11.4346 27.1888 13.6785 27.4456C14.1498 27.5126 14.6883 27.5349 15.4512 27.5349H19.4005C19.8605 27.5349 20.242 27.9144 20.242 28.3721C20.242 28.8298 19.8605 29.2093 19.4005 29.2093ZM14.5537 21.1163C14.4078 21.1163 14.262 21.0828 14.1273 21.027C13.9927 20.9712 13.8693 20.893 13.7571 20.7926C13.6561 20.6809 13.5663 20.5581 13.5102 20.4242C13.4541 20.2902 13.4317 20.1451 13.4317 20C13.4317 19.7098 13.5551 19.4195 13.7571 19.2074C14.1722 18.7944 14.9239 18.7944 15.3502 19.2074C15.5522 19.4195 15.6756 19.7098 15.6756 20C15.6756 20.1451 15.642 20.2902 15.5859 20.4242C15.5298 20.5581 15.4512 20.6809 15.3502 20.7926C15.2381 20.893 15.1146 20.9712 14.98 21.027C14.8454 21.0828 14.6995 21.1163 14.5537 21.1163ZM18.6151 21.027C18.7497 21.0828 18.8956 21.1163 19.0414 21.1163C19.1873 21.1163 19.3332 21.0828 19.4678 21.027C19.6024 20.9712 19.7258 20.893 19.838 20.7926C19.939 20.6809 20.0175 20.5581 20.0736 20.4242C20.1297 20.2902 20.1634 20.1451 20.1634 20C20.1634 19.7098 20.04 19.4195 19.838 19.2074C19.4229 18.7944 18.66 18.7944 18.2449 19.2074C18.0429 19.4195 17.9195 19.7098 17.9195 20C17.9195 20.1451 17.9532 20.2902 17.998 20.4242C18.0653 20.5581 18.1439 20.6809 18.2449 20.7926C18.3571 20.893 18.4805 20.9712 18.6151 21.027Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$password = function (classes) {
    return $author$project$IconSvg$password_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$paymentMethod_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M19.5034 29.3488H13.8019C9.36123 29.3488 8 28.0281 8 23.6921V14.6457C8 11.179 8.74754 9.25313 12.7308 9.02202C13.0655 9.01101 13.4226 9 13.8019 9H26.1979C30.6386 9 31.9999 10.3206 31.9999 14.6567V16.9539L32 16.9679L31.9999 16.9818V19.51C31.9999 19.9613 31.6205 20.3354 31.1631 20.3354C30.7056 20.3354 30.3262 19.9613 30.3262 19.51V17.7933H9.67363V23.703C9.67363 27.1037 10.2873 27.709 13.8019 27.709H19.5034C19.9609 27.709 20.3402 28.0831 20.3402 28.5344C20.3402 28.9856 19.972 29.3488 19.5034 29.3488ZM30.3262 14.6567V16.1425H9.67363V14.6567C9.67363 11.3551 10.3877 10.8159 12.8089 10.6728C13.1213 10.6618 13.4449 10.6508 13.8019 10.6508H26.1979C29.7126 10.6508 30.3262 11.2561 30.3262 14.6567ZM13.3109 24.3964H17.7739C18.2314 24.3964 18.6108 24.0223 18.6108 23.571C18.6108 23.1198 18.2314 22.7457 17.7739 22.7457H13.3109C12.8535 22.7457 12.4741 23.1198 12.4741 23.571C12.4741 24.0223 12.8535 24.3964 13.3109 24.3964ZM26.7002 31C24.848 31 23.1074 30.0315 22.1702 28.4578C21.6681 27.6654 21.4003 26.73 21.4003 25.7725C21.4003 22.8891 23.7769 20.545 26.7002 20.545C29.6234 20.545 32 22.8891 32 25.7725C32 26.73 31.7322 27.6654 31.2301 28.4688C30.2929 30.0315 28.5523 31 26.7002 31ZM26.7002 22.1958C24.703 22.1958 23.074 23.8025 23.074 25.7725C23.074 26.4218 23.2525 27.0601 23.5983 27.6104C24.2455 28.6889 25.4394 29.3492 26.7002 29.3492C27.961 29.3492 29.1549 28.6889 29.802 27.6214C30.1479 27.0601 30.3264 26.4328 30.3264 25.7725C30.3264 23.8025 28.6974 22.1958 26.7002 22.1958ZM25.4721 27.4452C25.6394 27.6103 25.8514 27.6873 26.0634 27.6873C26.2642 27.6873 26.4651 27.6103 26.6324 27.4672L29.009 25.2992C29.3437 24.991 29.366 24.4628 29.0536 24.1326C28.7412 23.8025 28.2056 23.7805 27.8709 24.0886L26.0857 25.7174L25.5501 25.1891C25.2265 24.87 24.691 24.87 24.3674 25.1891C24.0438 25.5083 24.0438 26.0365 24.3674 26.3557L25.4721 27.4452Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$paymentMethod = function (classes) {
    return $author$project$IconSvg$paymentMethod_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$termsPrivacy_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M20 32C19.7267 32 19.4534 31.9666 19.1915 31.8885C13.2816 30.2931 9 24.8823 9 19.0141V14.1164C9 12.8669 9.92237 11.5171 11.1066 11.0373L17.4493 8.49367C19.1004 7.83544 20.911 7.83544 22.5507 8.49367L28.8934 11.0373C30.0776 11.5171 31 12.8669 31 14.1164V19.0141C31 24.8711 26.707 30.282 20.8085 31.8885C20.5466 31.9666 20.2733 32 20 32ZM20 9.6874C19.3509 9.6874 18.7132 9.81014 18.0983 10.0556L11.7557 12.5992C11.2091 12.8223 10.7081 13.5475 10.7081 14.1276V19.0252C10.7081 24.146 14.4658 28.8763 19.647 30.282C19.8747 30.3489 20.1253 30.3489 20.353 30.282C25.5342 28.8763 29.2919 24.146 29.2919 19.0252V14.1276C29.2919 13.5475 28.7909 12.8223 28.2443 12.5992L21.9017 10.0556C21.2868 9.81014 20.6491 9.6874 20 9.6874ZM19.1461 21.2862C17.831 20.9224 16.8687 19.7391 16.8687 18.3335C16.8687 16.6377 18.2693 15.2655 20.0002 15.2655C21.731 15.2655 23.1316 16.6377 23.1316 18.3335C23.1316 19.7391 22.1693 20.9224 20.8542 21.2862V23.9116C20.8542 24.369 20.467 24.7483 20.0002 24.7483C19.5333 24.7483 19.1461 24.369 19.1461 23.9116V21.2862ZM20.0002 16.9389C19.2144 16.9389 18.5768 17.5637 18.5768 18.3335C18.5768 19.1032 19.2144 19.728 20.0002 19.728C20.7859 19.728 21.4236 19.1032 21.4236 18.3335C21.4236 17.5637 20.7859 16.9389 20.0002 16.9389Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$termsPrivacy = function (classes) {
    return $author$project$IconSvg$termsPrivacy_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$MoreOptions$View$menuList = _List_fromArray([{
    wE: $author$project$IconSvg$paymentMethod,
    p_: $author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$PaymentMethods(0)),
    lh: 'Payment methods'
  }, {
    wE: $author$project$IconSvg$password,
    p_: $author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$ChangePassword),
    lh: 'Change password'
  }, {
    wE: $author$project$IconSvg$settings,
    p_: $author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$NotificationsSettings),
    lh: 'Notifications settings'
  }, {
    wE: $author$project$IconSvg$termsPrivacy,
    p_: $author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$Legal(0)),
    lh: 'Terms of use & privacy policy'
  }]);
  var $author$project$Ui$MoreOptions$View$removeBtn = F3(function (classes, onTap, label) {
    return $author$project$Ui$Button$button({
      bh: 'fullWidth ' + classes,
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow flexAlignCenter fullWidth pad1')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w4 h4 marRight3 ')]), _List_fromArray([$author$project$IconSvg$close1('w4 gray60Fill ')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' gray60 heading4Bold')]), _List_fromArray([$elm$html$Html$text(label)]))])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onTap)
    });
  });
  var $author$project$Ui$MoreOptions$View$moreOptionsView = F3(function (browser, _v0, session) {
    var hideEmailUnverified = _v0.n1;
    var user = session.Db;
    var toMenuRow = function (_v1) {
      var onTap = _v1.p_;
      var icon = _v1.wE;
      var title = _v1.lh;
      return $author$project$Ui$NavBar$menuOptionBar({
        uj: 'marBottom3 ',
        p_: onTap,
        jX: icon,
        lh: title
      });
    };
    var emailUnverifiedNoticeAndButton = session.nd ? $author$project$ElmFramework$Lib$Util$noOpEl : !hideEmailUnverified ? A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom2 secondary800Back radius5 padTop2h padBottom2h padRight2 padLeft2 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter primary60Fill ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('backgroundWhite maxRadius marRight1'), A2($elm$html$Html$Attributes$style, 'width', '32px')]), _List_fromArray([$author$project$IconSvg$email_custom(_List_Nil)])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('primary0 heading3Bold whiteSpaceNoWrap ellipsis')]), _List_fromArray([$elm$html$Html$text('Email has not been verified yet!')]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bodyRegular primary60 marTop1 ')]), _List_fromArray([$elm$html$Html$text('Please verify your email so we can reach out to you with important information about your matches.')])), $author$project$Ui$Button$basicButton({
      bh: 'marTop2 ',
      cD: 0,
      fn: $elm$html$Html$text('Verify now'),
      xa: false,
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.yw(_List_fromArray([$author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$SendEmailVerificationCode(true)), $author$project$TopMsg$moreOptionsMsg(0)])))
    })])) : $author$project$ElmFramework$Lib$Util$noOpEl;
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn ')]), _List_fromArray([emailUnverifiedNoticeAndButton, A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, toMenuRow, $author$project$Ui$MoreOptions$View$menuList)), $author$project$Ui$Button$basicButton({
          bh: 'fullWidth ',
          cD: 1,
          fn: $elm$html$Html$text('Rate app'),
          xa: false,
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$Feedback))
        }), A3($author$project$Ui$MoreOptions$View$removeBtn, ' marTop3 marBottom3 ', $author$project$ElmFramework$MsgCmd$msgCmd.yw($author$project$MulticastMessages$onUnauth), 'Sign out'), A3($author$project$Ui$MoreOptions$View$removeBtn, 'marBottom3', $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$DeleteAccountDialog(session.e_))), 'Delete account')]))]),
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$NavBar),
        t_: browser,
        ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 gray0 marBottom2 noOverflow whiteSpaceNoWrap flexRow ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading1Regular marRight0h ')]), _List_fromArray([$elm$html$Html$text('Hi, ')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold ellipsis whiteSpaceNoWrap ')]), _List_fromArray([$elm$html$Html$text(user.nF + (' ' + (user.oU + '!')))]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow marBottom3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight2 w8 h8 radius7 noOverflow ')]), _List_fromArray([A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Ui$EmptyStates$emptyUserAvatar, function (photoUrl) {
          return A2($elm$html$Html$img, _List_fromArray([$elm$html$Html$Attributes$src(photoUrl), $elm$html$Html$Attributes$class(' relative block w8 h8 radius7 noOverflow')]), _List_Nil);
        }, user.qq)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn justifyCenter noOverflow')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading3Bold gray0 ellipsis whiteSpaceNoWrap ')]), _List_fromArray([$elm$html$Html$text(user.bZ)])), $author$project$Ui$Button$button({
          bh: ' inlineFlex',
          fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading4Bold secondary100 ')]), _List_fromArray([$elm$html$Html$text('Personal details')])),
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$EditPersonalDetails))
        })]))]))]),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
        Ck: $elm$core$Maybe$Just(3),
        CT: $elm$core$Maybe$Nothing
      })
    });
  });
  var $author$project$Ui$MoreOptions$View$view = F3(function (browser, model, maybeUserSession) {
    return _List_fromArray([A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer, A2($author$project$Ui$MoreOptions$View$moreOptionsView, browser, model), maybeUserSession)]);
  });
  var $author$project$Ui$Auth$UserSession$Msg$NotificationTappedInNotificationView = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Remote$RequestMsg$UpdateNotificationsReadStatus = function (a) {
    return {
      $: 32,
      a: a
    };
  };
  var $author$project$IconSvg$alert_fussy_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 30 30')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M14.4313 25.033C14.8687 25.4079 15.4312 25.5954 15.9937 25.5954C16.5562 25.5954 17.1186 25.4079 17.5561 25.024L18.9668 23.8098C19.1096 23.6937 19.4667 23.5598 19.6542 23.5598H21.172C22.4934 23.5598 23.5648 22.4884 23.5648 21.1671V19.6493C23.5648 19.4618 23.6987 19.1047 23.8237 18.9618L25.0379 17.5512C25.7879 16.6762 25.7879 15.3102 25.0379 14.4352L23.8237 13.0246C23.6987 12.8817 23.5648 12.5246 23.5648 12.3371V10.8193C23.5648 9.49797 22.4934 8.42659 21.172 8.42659H19.6542C19.4667 8.42659 19.1096 8.3016 18.9668 8.17661L17.5561 6.96238C16.6812 6.21241 15.3152 6.21241 14.4402 6.96238L13.0295 8.17661C12.8867 8.29267 12.5296 8.42659 12.3421 8.42659H10.7975C9.47614 8.42659 8.40476 9.49797 8.40476 10.8193V12.355C8.40476 12.5425 8.27977 12.8907 8.15477 13.0335L6.94947 14.4531C6.21736 15.3191 6.21736 16.6851 6.94947 17.5512L8.15477 18.9707C8.27977 19.1136 8.40476 19.4618 8.40476 19.6493V21.176C8.40476 22.4974 9.47614 23.5687 10.7975 23.5687H12.3332C12.5206 23.5687 12.8778 23.6937 13.0206 23.8187L14.4313 25.033ZM9.74398 10.8193C9.74398 10.239 10.2172 9.76582 10.7975 9.76582H12.3421C12.851 9.76582 13.5117 9.52476 13.9045 9.19442L15.3152 7.97126C15.6812 7.65877 16.324 7.65877 16.6901 7.97126L18.1007 9.18549C18.4936 9.52476 19.1453 9.76582 19.6632 9.76582H21.181C21.7613 9.76582 22.2345 10.239 22.2345 10.8193V12.3282C22.2345 12.846 22.4755 13.4978 22.8148 13.8906L24.029 15.3013C24.3415 15.6673 24.3415 16.3102 24.029 16.6762L22.8148 18.0869C22.4755 18.4797 22.2345 19.1315 22.2345 19.6493V21.1671C22.2345 21.7474 21.7613 22.2206 21.181 22.2206H19.6632C19.1453 22.2206 18.4936 22.4706 18.1007 22.8009L16.6901 24.0152C16.324 24.3276 15.6812 24.3276 15.3152 24.0152L13.9045 22.8009C13.5117 22.4617 12.8599 22.2206 12.3421 22.2206H10.7975C10.2172 22.2206 9.74398 21.7474 9.74398 21.1671V19.6404C9.74398 19.1315 9.50293 18.4886 9.17258 18.0958L7.96728 16.6762C7.6548 16.3102 7.6548 15.6763 7.96728 15.3102L9.17258 13.8906C9.50293 13.5067 9.74398 12.855 9.74398 12.3461V10.8193ZM15.9856 17.5643C15.6196 17.5643 15.316 17.2607 15.316 16.8947V12.2074C15.316 11.8414 15.6196 11.5378 15.9856 11.5378C16.3517 11.5378 16.6552 11.8414 16.6552 12.2074V16.8947C16.6552 17.2607 16.3517 17.5643 15.9856 17.5643ZM15.9858 20.6892C15.7447 20.6892 15.5215 20.6 15.3519 20.4303C15.2715 20.3411 15.209 20.2428 15.1555 20.1357C15.1108 20.0286 15.093 19.9125 15.093 19.7964C15.093 19.5643 15.1912 19.3321 15.3519 19.1625C15.6822 18.8322 16.2894 18.8322 16.6197 19.1625C16.7804 19.3321 16.8786 19.5643 16.8786 19.7964C16.8786 19.9125 16.8518 20.0286 16.8072 20.1357C16.7625 20.2428 16.7001 20.3411 16.6197 20.4303C16.4501 20.6 16.2268 20.6892 15.9858 20.6892Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$alert_fussy = function (classes) {
    return $author$project$IconSvg$alert_fussy_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$EmptyStates$emptyResult2 = function (cfg) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' fullWidth flexColumn flexAlignCenter '), $elm$html$Html$Attributes$class(cfg.uj)]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('marBottom2 w12 h12 ')]), _List_fromArray([cfg.CV('w12 gray40Fill ')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0 heading2Bold marBottom1 ')]), _List_fromArray([$elm$html$Html$text(cfg.lh)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray60 bodyRegular marBottom3 ')]), _List_fromArray([$elm$html$Html$text(cfg.eS)]))]));
  };
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$FetchPageIfIdleEmpty = {
    $: 2
  };
  var $author$project$ElmFramework$Lib$Ui$EventFull$emitOnChangeToTrue = F2(function (msg, flag) {
    var flagAttribute = flag ? _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'emit-on-change-to-true', 'true')]) : _List_Nil;
    return A2($elm$core$List$cons, A2($author$project$ElmFramework$Lib$Util$onLocal, 'emit-on-change-to-true-event', $elm$json$Json$Decode$succeed(msg)), flagAttribute);
  });
  var $author$project$ElmFramework$Lib$Ui$EventFull$onNearBottom = function (msg) {
    return A2($elm$html$Html$Events$on, 'nearBottom', $elm$json$Json$Decode$succeed(msg));
  };
  var $author$project$ElmFramework$Lib$Ui$EventFull$onScrollNearBottom = function (nearBottomMsg) {
    return _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'emit-scroll', 'true'), $author$project$ElmFramework$Lib$Ui$EventFull$onNearBottom(nearBottomMsg)]);
  };
  var $author$project$ElmFramework$Lib$OrderedCollection$toListSerialized = function (_v0) {
    var list = _v0.e;
    var toId = _v0.G;
    var serializeId = _v0.U;
    return A2($elm$core$List$map, function (i) {
      return _Utils_Tuple2(serializeId(toId(i)), i);
    }, list);
  };
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$toListSerialized = function (endlessList) {
    return $author$project$ElmFramework$Lib$OrderedCollection$toListSerialized(endlessList.c);
  };
  var $author$project$ElmFramework$Lib$UiBehavior$EndlessList$View$viewCustom = function (cfg) {
    return A3($author$project$ElmFramework$Lib$Ui$EventFull$eventFull, _List_fromArray([$author$project$ElmFramework$Lib$Ui$EventFull$onScrollNearBottom(cfg.ps($author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$FetchPage)), A2($author$project$ElmFramework$Lib$Ui$EventFull$emitOnChangeToTrue, cfg.ps($author$project$ElmFramework$Lib$UiBehavior$EndlessList$Msg$FetchPageIfIdleEmpty), cfg.xg)]), _Utils_ap(_List_fromArray([$elm$html$Html$Attributes$class('scrollTarget')]), cfg.lR), cfg.CE($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$toListSerialized(cfg.aC)));
  };
  var $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyEndlessListView = function (cfg) {
    var itemsLayout = function (items) {
      return _List_fromArray([A3($elm$html$Html$Keyed$node, 'keyed-endless-list-items', _List_fromArray([$elm$html$Html$Attributes$class('block')]), A2($elm$core$List$map, $elm$core$Tuple$mapSecond(cfg.CG), items))]);
    };
    var itemsOrEmptyState = function (items) {
      return _Utils_eq($author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$isEmpty(cfg.aC), $elm$core$Maybe$Just(true)) ? cfg.vL : itemsLayout(items);
    };
    var bodyContent = function (items) {
      var _v0 = cfg.xp;
      if (!_v0.$) {
        var wrapper = _v0.a;
        return _Utils_ap(wrapper(itemsOrEmptyState(items)), cfg.tW);
      } else {
        return _Utils_ap(itemsOrEmptyState(items), cfg.tW);
      }
    };
    var toContent = function (items) {
      return _List_fromArray([$author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: cfg.l$,
        tU: bodyContent(items),
        l5: cfg.l5,
        t_: cfg.t_,
        ww: cfg.ww,
        xB: cfg.xB,
        Ck: cfg.Ck,
        CT: cfg.CT
      })]);
    };
    return $author$project$UiWrappers$HeaderAndBodyView$theWrap($author$project$ElmFramework$Lib$UiBehavior$EndlessList$View$viewCustom({
      lR: $author$project$UiWrappers$HeaderAndBodyView$scrollerElementAttrs,
      xg: true,
      ps: cfg.ps,
      aC: cfg.aC,
      CE: toContent
    }));
  };
  var $elm_community$string_extra$String$Extra$pluralize = F3(function (singular, plural, count) {
    return count === 1 ? '1 ' + singular : $elm$core$String$fromInt(count) + (' ' + plural);
  });
  var $author$project$Ui$Notifications$View$view = F2(function (browser, topModel) {
    var _v0 = $author$project$Remote$Model$toSession(topModel.lL.A$);
    if (_v0.$ === 1) {
      return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer]);
    } else {
      var session = _v0.a;
      return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
        Dl: function () {
          var toItemView = function (notification) {
            return $author$project$Ui$NotificationBtn$notificationBtn({
              t_: browser,
              fd: notification,
              uj: 'marBottom2 ',
              fs: topModel.Cy,
              p_: $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$UserSessionMsg($author$project$Ui$Auth$UserSession$Msg$NotificationTappedInNotificationView(notification))),
              DJ: topModel.DJ
            });
          };
          var moduleTag = A2($elm$core$Basics$composeL, $author$project$TopMsg$remoteMsg, $author$project$Remote$Msg$ReadNotificationsEndlessListMsg);
          var isEmptyUnreadNotificationList = $elm$core$List$isEmpty(session.C4);
          var topBar = isEmptyUnreadNotificationList ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
            xC: $elm$core$Maybe$Nothing,
            yo: $elm$core$Maybe$Nothing,
            Bg: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$TextBtn({
              xa: false,
              oR: 'Mark all as read',
              p_: $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$UpdateNotificationsReadStatus(A2($elm$core$List$map, function ($) {
                return $.od;
              }, session.C4)))
            }))
          }));
          var hasUnreadNotificationsMessage = function (count) {
            return 'You have ' + A3($elm_community$string_extra$String$Extra$pluralize, 'unread notification', 'unread notifications', count);
          };
          var _v1 = A2($elm$core$Maybe$withDefault, true, $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$isEmpty(session.AR)) ? _Utils_Tuple3(function (classes) {
            return $author$project$ElmFramework$Lib$Util$noOpEl;
          }, '', true) : _Utils_Tuple3($author$project$IconSvg$calendar, 'Old', false);
          var readNotificationIcon = _v1.a;
          var readNotificationTitle = _v1.b;
          var isEmptyReadNotificationsList = _v1.c;
          var emptyStateText = isEmptyReadNotificationsList ? 'You don\'t have notifications' : 'You don\'t have new notifications';
          var emptyState = {
            fn: _List_fromArray([$author$project$Ui$EmptyStates$emptyResult2({
              uj: '',
              eS: 'Here you will see your upcoming matches, etc.',
              lh: 'You are all set',
              CV: $author$project$IconSvg$notifications
            })]),
            Bg: $elm$core$Maybe$Nothing,
            sA: emptyStateText
          };
          var headerSubtext = isEmptyUnreadNotificationList ? emptyState.sA : hasUnreadNotificationsMessage($elm$core$List$length(session.C4));
          var headerContent = _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' gray0  marTop2 marBottom3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold marBottom1 ')]), _List_fromArray([$elm$html$Html$text('Notifications')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Regular ')]), _List_fromArray([$elm$html$Html$text(headerSubtext)]))]))]);
          var itemsWrapper = function (items) {
            return _List_fromArray([$author$project$UiWrappers$HeaderAndBodyView$multipleBodyContentWithIconAndLabel(_List_fromArray([!isEmptyUnreadNotificationList ? $elm$core$Maybe$Just({
              uj: 'flex1',
              fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom-1')]), A2($elm$core$List$map, toItemView, session.C4)),
              wE: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$IconSvg$alert_fussy, '')),
              lh: $elm$core$Maybe$Just('New')
            }) : $elm$core$Maybe$Nothing, isEmptyUnreadNotificationList || !isEmptyReadNotificationsList ? $elm$core$Maybe$Just({
              uj: 'flex1',
              fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom-1')]), items),
              wE: $elm$core$Maybe$Just(_Utils_Tuple2(readNotificationIcon, '')),
              lh: $elm$core$Maybe$Just(readNotificationTitle)
            }) : $elm$core$Maybe$Nothing]))]);
          };
          return $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyEndlessListView({
            l$: $author$project$UiWrappers$HeaderAndBodyView$ImgOverlay(_List_fromArray([{
              ij: browser.ij,
              eZ: $author$project$AssetsImg$assets.yJ,
              lt: browser.lt
            }])),
            tW: _List_Nil,
            l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$NavBar),
            t_: browser,
            vL: emptyState.fn,
            ww: headerContent,
            xp: $elm$core$Maybe$Just(itemsWrapper),
            xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
            ps: moduleTag,
            aC: session.AR,
            Ck: $elm$core$Maybe$Just(1),
            CG: toItemView,
            CT: topBar
          });
        }()
      })]);
    }
  });
  var $author$project$Ui$NotificationsSettings$Msg$ActivateAllSwitched = function (a) {
    return {
      $: 7,
      a: a
    };
  };
  var $author$project$Ui$NotificationsSettings$Msg$CancellationToggled = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$NotificationsSettings$Msg$EmailNotification = 0;
  var $author$project$Ui$NotificationsSettings$Msg$NewMatchToggled = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Ui$NotificationsSettings$Msg$NoMatchToggled = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $author$project$Ui$NotificationsSettings$Msg$PushNotification = 1;
  var $author$project$Ui$NotificationsSettings$Msg$RateToggled = function (a) {
    return {
      $: 6,
      a: a
    };
  };
  var $author$project$Ui$NotificationsSettings$Msg$SearchInviteToggled = function (a) {
    return {
      $: 5,
      a: a
    };
  };
  var $author$project$Ui$NotificationsSettings$Msg$SettingsSaved = {
    $: 8
  };
  var $elm$core$List$all = F2(function (isOkay, list) {
    return !A2($elm$core$List$any, A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay), list);
  });
  var $author$project$TopMsg$msgNotificationsSettings = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$NotificationsSettingsMsg);
  var $author$project$Ui$NotificationsSettings$View$view = F3(function (browser, state, maybeSession) {
    return _List_fromArray([_Utils_eq(maybeSession, $elm$core$Maybe$Nothing) ? $author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer : $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: function () {
        var settingsSection = F2(function (label, listSettings) {
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' marBottom1 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading3Bold primary0 marBottom2 ')]), _List_fromArray([$elm$html$Html$text(label)])), A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Ui$SwitchLeftLabel$switchLeftLabel('padBottom2'), listSettings))]));
        });
        return $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
          l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
          tU: function () {
            var allActivated = A2($elm$core$List$all, $elm$core$Basics$identity, _List_fromArray([state.pC.ew, state.pC.bZ, state.mb.ew, state.mb.bZ, state.pE.ew, state.pE.bZ, state.qT.ew, state.qT.bZ, state.rs.ew, state.rs.bZ]));
            return _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom3 ')]), _List_fromArray([A2($author$project$Ui$SwitchLeftLabel$switchLeftLabel, '', {
              eg: allActivated,
              oR: 'Activate all',
              zP: $author$project$TopMsg$msgNotificationsSettings($author$project$Ui$NotificationsSettings$Msg$ActivateAllSwitched(!allActivated))
            })])), A2(settingsSection, 'Match found', _List_fromArray([{
              eg: state.pC.ew,
              oR: 'Push (Mobile app)',
              zP: $author$project$TopMsg$msgNotificationsSettings($author$project$Ui$NotificationsSettings$Msg$NewMatchToggled(1))
            }, {
              eg: state.pC.bZ,
              oR: 'Email',
              zP: $author$project$TopMsg$msgNotificationsSettings($author$project$Ui$NotificationsSettings$Msg$NewMatchToggled(0))
            }])), A2(settingsSection, 'Someone canceled their slot', _List_fromArray([{
              eg: state.mb.ew,
              oR: 'Push (Mobile app)',
              zP: $author$project$TopMsg$msgNotificationsSettings($author$project$Ui$NotificationsSettings$Msg$CancellationToggled(1))
            }, {
              eg: state.mb.bZ,
              oR: 'Email',
              zP: $author$project$TopMsg$msgNotificationsSettings($author$project$Ui$NotificationsSettings$Msg$CancellationToggled(0))
            }])), A2(settingsSection, 'No match found', _List_fromArray([{
              eg: state.pE.ew,
              oR: 'Push (Mobile app)',
              zP: $author$project$TopMsg$msgNotificationsSettings($author$project$Ui$NotificationsSettings$Msg$NoMatchToggled(1))
            }, {
              eg: state.pE.bZ,
              oR: 'Email',
              zP: $author$project$TopMsg$msgNotificationsSettings($author$project$Ui$NotificationsSettings$Msg$NoMatchToggled(0))
            }])), A2(settingsSection, 'Rate your match', _List_fromArray([{
              eg: state.qT.ew,
              oR: 'Push (Mobile app)',
              zP: $author$project$TopMsg$msgNotificationsSettings($author$project$Ui$NotificationsSettings$Msg$RateToggled(1))
            }, {
              eg: state.qT.bZ,
              oR: 'Email',
              zP: $author$project$TopMsg$msgNotificationsSettings($author$project$Ui$NotificationsSettings$Msg$RateToggled(0))
            }])), function (searchInvite) {
              return A2(settingsSection, 'Invited for a match', _List_fromArray([{
                eg: searchInvite.ew,
                oR: 'Push (Mobile app)',
                zP: $author$project$TopMsg$msgNotificationsSettings($author$project$Ui$NotificationsSettings$Msg$SearchInviteToggled(1))
              }, {
                eg: searchInvite.bZ,
                oR: 'Email',
                zP: $author$project$TopMsg$msgNotificationsSettings($author$project$Ui$NotificationsSettings$Msg$SearchInviteToggled(0))
              }]));
            }(state.rs)]))]);
          }(),
          l5: $elm$core$Maybe$Nothing,
          t_: browser,
          ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 marBottom3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0  ')]), _List_fromArray([$elm$html$Html$text('Notifications settings')]))]))]),
          xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
          Ck: $elm$core$Maybe$Just(2),
          CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
            xC: $elm$core$Maybe$Just($author$project$TopMsg$routeBack),
            yo: $elm$core$Maybe$Nothing,
            Bg: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$TextBtn({
              xa: false,
              oR: 'Save',
              p_: $author$project$TopMsg$msgNotificationsSettings($author$project$Ui$NotificationsSettings$Msg$SettingsSaved)
            }))
          }))
        });
      }()
    })]);
  });
  var $elm$core$Maybe$map3 = F4(function (func, ma, mb, mc) {
    if (ma.$ === 1) {
      return $elm$core$Maybe$Nothing;
    } else {
      var a = ma.a;
      if (mb.$ === 1) {
        return $elm$core$Maybe$Nothing;
      } else {
        var b = mb.a;
        if (mc.$ === 1) {
          return $elm$core$Maybe$Nothing;
        } else {
          var c = mc.a;
          return $elm$core$Maybe$Just(A3(func, a, b, c));
        }
      }
    }
  });
  var $author$project$Ui$Tags$DotRed = 3;
  var $author$project$Types$Activity$activityToMatchString = F2(function (withSuffix, activity) {
    var suffix = withSuffix ? ' ' + $author$project$Types$Activity$activityToSuffix(activity) : '';
    return A2($author$project$Types$Activity$toString, false, activity) + (' match' + suffix);
  });
  var $author$project$Types$Match$AllConfirmed = {
    $: 0
  };
  var $author$project$Types$Match$Cancelled = {
    $: 2
  };
  var $author$project$Types$Match$Joined = {
    $: 0
  };
  var $author$project$Types$Match$JoinedButUnpaid = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Types$Match$PendingToJoin = {
    $: 2
  };
  var $author$project$Types$Match$SpotLost = {
    $: 1
  };
  var $author$project$Types$Match$WaitingForConfirmation = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Types$Match$cardStatuses = F2(function (match, mySpot) {
    var _v0 = _Utils_Tuple2(match, mySpot);
    _v0$2: while (true) {
      switch (_v0.a.$) {
        case 2:
          var _v1 = _v0.a;
          var allValues = _v0.b;
          return _Utils_Tuple2($elm$core$Maybe$Just($author$project$Types$Match$Cancelled), $elm$core$Maybe$Nothing);
        case 0:
          switch (_v0.b.$) {
            case 1:
              var _v2 = _v0.a;
              var _v3 = _v0.b;
              return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Just($author$project$Types$Match$SpotLost));
            case 3:
              break _v0$2;
            default:
              var _v4 = _v0.a;
              var confirmed = _v0.b;
              return _Utils_Tuple2($elm$core$Maybe$Just($author$project$Types$Match$AllConfirmed), $elm$core$Maybe$Nothing);
          }
        default:
          switch (_v0.b.$) {
            case 3:
              break _v0$2;
            case 0:
              var isMySpotJoined = _v0.a.a;
              var _v5 = _v0.b;
              return _Utils_Tuple2($elm$core$Maybe$Just($author$project$Types$Match$WaitingForConfirmation(isMySpotJoined)), $elm$core$Maybe$Just($author$project$Types$Match$Joined));
            default:
              var mySpotStatus = _v0.b;
              return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Just(mySpotStatus));
          }
      }
    }
    var allConfirmedOrWaitingForOthers = _v0.a;
    var participantPaymentStatus = _v0.b.a;
    return _Utils_Tuple2($elm$core$Maybe$Just(allConfirmedOrWaitingForOthers), $elm$core$Maybe$Just($author$project$Types$Match$JoinedButUnpaid(participantPaymentStatus)));
  });
  var $author$project$Types$UserSession$isThisUserJoiningParticipant = F2(function (session, matchDetails) {
    return $elm_community$maybe_extra$Maybe$Extra$isJust(A2($elm_community$list_extra$List$Extra$find, function (participant) {
      if (!participant.$) {
        var userId = participant.a.e_;
        return _Utils_eq(userId, session.e_);
      } else {
        var userId = participant.a.e_;
        return _Utils_eq(userId, session.e_);
      }
    }, matchDetails.xq));
  });
  var $author$project$Types$UserSession$isThisUserPrivateParticipant = function (matchDetails) {
    return $elm_community$maybe_extra$Maybe$Extra$isJust($author$project$Types$Match$participantsToPrivateParticipant(matchDetails.z8));
  };
  var $author$project$Types$UserSession$isThisUserPublicParticipant = F2(function (session, matchDetails) {
    return $elm_community$maybe_extra$Maybe$Extra$isJust(A2($elm_community$list_extra$List$Extra$find, function (participant) {
      if (!participant.$) {
        var userId = participant.a.e_;
        return _Utils_eq(userId, session.e_);
      } else {
        return false;
      }
    }, $elm_community$maybe_extra$Maybe$Extra$values(matchDetails.z8)));
  });
  var $author$project$Types$UserSession$isThisAvailableSuggestedMatch = F2(function (session, matchDetails) {
    return !A2($author$project$Types$UserSession$isThisUserJoiningParticipant, session, matchDetails) && !A2($author$project$Types$UserSession$isThisUserPublicParticipant, session, matchDetails) && !$author$project$Types$UserSession$isThisUserPrivateParticipant(matchDetails) ? function (allParticipants) {
      return $author$project$Types$Activity$toNumberOfPlayers(matchDetails.xX.du) - $elm$core$List$length(allParticipants) > 0;
    }(_Utils_ap($elm_community$maybe_extra$Maybe$Extra$values(matchDetails.z8), matchDetails.xq)) : false;
  });
  var $author$project$Ui$Tags$DotBlue = 2;
  var $author$project$Ui$MatchmakingCards$matchStatusToDot = function (matchStatus) {
    switch (matchStatus.$) {
      case 0:
        return $elm$core$Maybe$Just(1);
      case 1:
        var isMySpotJoined = matchStatus.a;
        return $elm$core$Maybe$Just(2);
      default:
        return $elm$core$Maybe$Nothing;
    }
  };
  var $author$project$Types$Match$mySpotStatusToString = function (status) {
    switch (status.$) {
      case 0:
        return 'Joined';
      case 1:
        return 'Spot lost';
      case 2:
        return 'Pending to join';
      default:
        var participantPaymentStatus = status.a;
        return 'Unpaid';
    }
  };
  var $author$project$Types$Match$statusForCardToString = function (status) {
    switch (status.$) {
      case 0:
        return 'All Confirmed';
      case 1:
        var isMySpotJoined = status.a;
        return isMySpotJoined ? 'Waiting For Others' : 'Matched';
      default:
        return 'Cancelled';
    }
  };
  var $author$project$Ui$MatchmakingCards$toBlackTag = F2(function (classes, label) {
    return $author$project$Ui$Tags$tag({
      uj: classes,
      cD: 6,
      av: $elm$core$Maybe$Nothing,
      wE: $elm$core$Maybe$Nothing,
      oR: label,
      p_: $elm$core$Maybe$Nothing,
      B3: 0
    });
  });
  var $author$project$Ui$MatchmakingCards$matchStatusRow = F3(function (matchDetails, session, maybeRetryForNewMatchStatusCount) {
    var statusElementBlackWithGradient = F2(function (title, statusText) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold primary0 inlineFlexCenter ellipsis ')]), _List_fromArray([$elm$html$Html$text(title + ':'), A2($author$project$Ui$MatchmakingCards$toBlackTag, ' marLeft1 hairLinePad gradient10Back', statusText)]));
    });
    var statusElement = F3(function (title, statusText, maybeDot) {
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold primary0 inlineFlexCenter ellipsis ')]), _List_fromArray([$elm$html$Html$text(title + ':'), A3($author$project$Ui$MatchmakingCards$toTag, ' marLeft1 ', statusText, maybeDot)]));
    });
    var status = function () {
      var _v8 = matchDetails.xX.Cd;
      switch (_v8.$) {
        case 0:
          var _int = _v8.a;
          return $author$project$Types$Match$AllConfirmed;
        case 1:
          var _int = _v8.a;
          return $author$project$Types$Match$WaitingForConfirmation($author$project$Types$UserSession$isThisUserPrivateParticipant(matchDetails));
        case 2:
          var _int = _v8.a;
          return $author$project$Types$Match$WaitingForConfirmation(false);
        default:
          var _int = _v8.a;
          var instant = _v8.b;
          return $author$project$Types$Match$Cancelled;
      }
    }();
    var maybePaymentStatusOtherThanSuccessOrNotRequired = A2($elm$core$Maybe$andThen, function (_v7) {
      var participantPaymentStatus = _v7.z7;
      return _Utils_eq(participantPaymentStatus, $author$project$Types$Participant$ParticipantPaymentStatusSuccess) || _Utils_eq(participantPaymentStatus, $author$project$Types$Participant$ParticipantPaymentStatusNoPaymentRequired) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(participantPaymentStatus);
    }, $author$project$Types$Match$participantsToPrivateParticipant(matchDetails.z8));
    var mySpot = $author$project$Types$UserSession$isThisUserPrivateParticipant(matchDetails) || A2($author$project$Types$UserSession$isThisUserPublicParticipant, session, matchDetails) ? A2($elm$core$Maybe$withDefault, $author$project$Types$Match$Joined, A2($elm$core$Maybe$map, $author$project$Types$Match$JoinedButUnpaid, maybePaymentStatusOtherThanSuccessOrNotRequired)) : A2($author$project$Types$UserSession$isThisUserJoiningParticipant, session, matchDetails) || A2($author$project$Types$UserSession$isThisAvailableSuggestedMatch, session, matchDetails) ? $author$project$Types$Match$PendingToJoin : $author$project$Types$Match$SpotLost;
    var isRetrying = function (retryCount) {
      return retryCount > 0 ? true : false;
    }(A2($elm$core$Maybe$withDefault, 0, maybeRetryForNewMatchStatusCount));
    var _v0 = A2($author$project$Types$Match$cardStatuses, status, mySpot);
    if (!_v0.a.$) {
      if (!_v0.b.$) {
        var matchStatus = _v0.a.a;
        var mySpotStatus = _v0.b.a;
        var matchStatusHtml = A3(statusElement, 'Status', $author$project$Types$Match$statusForCardToString(matchStatus), $author$project$Ui$MatchmakingCards$matchStatusToDot(matchStatus));
        if (isRetrying) {
          return {
            bq: false,
            a$: _List_Nil
          };
        } else {
          if (mySpot.$ === 2) {
            return {
              bq: true,
              a$: A2($elm$core$List$cons, matchStatusHtml, _List_fromArray([A2(statusElementBlackWithGradient, 'My spot', $author$project$Types$Match$mySpotStatusToString(mySpotStatus))]))
            };
          } else {
            return {
              bq: false,
              a$: A2($elm$core$List$cons, matchStatusHtml, _List_fromArray([A3(statusElement, 'My spot', $author$project$Types$Match$mySpotStatusToString(mySpotStatus), $elm$core$Maybe$Nothing)]))
            };
          }
        }
      } else {
        var matchStatus = _v0.a.a;
        var _v2 = _v0.b;
        return {
          bq: false,
          a$: _List_fromArray([A3(statusElement, 'Status', $author$project$Types$Match$statusForCardToString(matchStatus), $author$project$Ui$MatchmakingCards$matchStatusToDot(matchStatus))])
        };
      }
    } else {
      if (!_v0.b.$) {
        var _v3 = _v0.a;
        var mySpotStatus = _v0.b.a;
        if (mySpotStatus.$ === 2) {
          return {
            bq: true,
            a$: _List_fromArray([A2(statusElementBlackWithGradient, 'My spot', $author$project$Types$Match$mySpotStatusToString(mySpotStatus))])
          };
        } else {
          return {
            bq: false,
            a$: _List_fromArray([A3(statusElement, 'My spot', $author$project$Types$Match$mySpotStatusToString(mySpotStatus), $elm$core$Maybe$Nothing)])
          };
        }
      } else {
        var _v5 = _v0.a;
        var _v6 = _v0.b;
        return {
          bq: false,
          a$: _List_Nil
        };
      }
    }
  });
  var $author$project$Ui$MatchmakingCards$player = F4(function (classes, browser, session, maybeParticipant) {
    var defaultAvatar = $author$project$AssetsSvg$emptyAvatar(' relative block w4 h4 circle noOverflow ');
    var availablePlayerSlotAvatar = $author$project$AssetsSvg$emptyAvatar(' relative block w4 h4 circle noOverflow borderDashed primary40Border borderW125 boxSizingBorder  ');
    var _v0 = _Utils_Tuple2('XRIVALS', A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' relative trans3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' circle primary0Back flexCenter w4 h4')]), _List_fromArray([$author$project$IconSvg$logoIconGrey(' primary20Fill w2')]))])));
    var previewTitle = _v0.a;
    var previewIcon = _v0.b;
    var _v1 = function () {
      if (!maybeParticipant.$) {
        var participant = maybeParticipant.a;
        var _v3 = function () {
          if (!participant.$) {
            var firstName = participant.a.nF;
            var lastNameOrInitial = participant.a.fT;
            var photo = participant.a.c5;
            var userId = participant.a.e_;
            var name = _Utils_eq(session.e_, userId) ? 'Me' : firstName + (' ' + lastNameOrInitial);
            return _Utils_Tuple2(name, photo);
          } else {
            var profile = participant.a.qI;
            return _Utils_Tuple2('Me', profile.qq);
          }
        }();
        var fName = _v3.a;
        var maybePhoto = _v3.b;
        return _Utils_Tuple2(A2($elm$core$Maybe$withDefault, defaultAvatar, A2($elm$core$Maybe$map, function (photoUrl) {
          return $author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
            t_: browser,
            uj: ' circle ',
            wG: _List_fromArray([{
              ij: 13,
              eZ: photoUrl,
              lt: 13
            }]),
            Dq: 4,
            s5: ' relative block w4 h4 circle noOverflow '
          });
        }, maybePhoto)), A2($elm$html$Html$h3, _List_fromArray([$elm$html$Html$Attributes$class(' heading6Regular ellipsis fullWidth center gray90 ')]), _List_fromArray([$elm$html$Html$text(fName)])));
      } else {
        return _Utils_Tuple2(previewIcon, A2($elm$html$Html$h3, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular primary0 ellipsis fullWidth center ')]), _List_fromArray([$elm$html$Html$text(previewTitle)])));
      }
    }();
    var playerAvatar = _v1.a;
    var playerName = _v1.b;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn w8 noOverflow flexAlignCenter '), $elm$html$Html$Attributes$class(classes)]), _List_fromArray([playerAvatar, playerName]));
  });
  var $author$project$Ui$MatchmakingCards$matchPlayersRow = function (_v0) {
    var browser = _v0.t_;
    var matchDetails = _v0.m;
    var session = _v0.rG;
    var showStatus = _v0.B0;
    var maybeRetryForNewMatchStatusCount = _v0.yh;
    var statusRow = showStatus ? A3($author$project$Ui$MatchmakingCards$section, false, ' padLeft2 padRight2 padTop1h flexRow spaceBetween borderTopSolid gray10Border borderTopW125', A3($author$project$Ui$MatchmakingCards$matchStatusRow, matchDetails, session, maybeRetryForNewMatchStatusCount).a$) : $author$project$ElmFramework$Lib$Util$noOpEl;
    var participants = function (interList) {
      return _Utils_ap(interList, A2($elm$core$List$repeat, $author$project$Types$Activity$toNumberOfPlayers(matchDetails.xX.du) - $elm$core$List$length(interList), $elm$core$Maybe$Nothing));
    }(A2($elm$core$List$filter, $elm$core$Basics$neq($elm$core$Maybe$Nothing), _Utils_ap(matchDetails.z8, A2($elm$core$List$map, $elm$core$Maybe$Just, matchDetails.xq))));
    var spacingClasses = $elm$core$List$length($elm_community$maybe_extra$Maybe$Extra$values(participants)) > 4 ? ' spaceBetween ' : ' spaceAround ';
    return $author$project$Ui$Button$button({
      bh: 'fullWidth',
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' radius5 flexColumn secondary800Back  noOverflow  ')]), _List_fromArray([A3($author$project$Ui$MatchmakingCards$section, false, ' spaceBetweenflexRow scrollTargetX noScrollbar padBottom2 padTop2 ' + spacingClasses, A2($elm$core$List$map, A3($author$project$Ui$MatchmakingCards$player, ' marRight1 marLeft1 ', browser, session), participants)), statusRow])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$NoAction
    });
  };
  var $author$project$Types$LocalDateTime$toMonthString = function (dateTime) {
    var _v0 = dateTime.pt;
    switch (_v0) {
      case 1:
        return 'Jan';
      case 2:
        return 'Feb';
      case 3:
        return 'Mar';
      case 4:
        return 'Apr';
      case 5:
        return 'May';
      case 6:
        return 'Jun';
      case 7:
        return 'Jul';
      case 8:
        return 'Aug';
      case 9:
        return 'Sept';
      case 10:
        return 'Oct';
      case 11:
        return 'Nov';
      case 12:
        return 'Dec';
      default:
        return '';
    }
  };
  var $author$project$Types$LocalTimeInterval$toTimeRangeString = function (interval) {
    var timeStart = $author$project$Types$LocalDateTime$toTimeString(interval.wh);
    var timeEnd = $author$project$Types$LocalDateTime$toTimeString(interval.CC);
    return timeStart + (' - ' + timeEnd);
  };
  var $author$project$Types$LocalTimeInterval$toDateString = function (interval) {
    var month = $author$project$Types$LocalDateTime$toMonthString(interval.wh);
    var day = $elm$core$String$fromInt(interval.wh.mO);
    return day + (' ' + (month + (', ' + $author$project$Types$LocalTimeInterval$toTimeRangeString(interval))));
  };
  var $author$project$Ui$MatchmakingCards$matchCard = function (cfg) {
    var matchDetails = cfg.m;
    var session = cfg.rG;
    return $author$project$Ui$Button$button({
      bh: 'fullWidth' + cfg.uj,
      fn: function () {
        var _v0 = A3($author$project$Ui$MatchmakingCards$matchStatusRow, cfg.m, session, $elm$core$Maybe$Nothing);
        var matchStatusRowHtml = _v0.a$;
        var isPendingToJoin = _v0.bq;
        var _v1 = isPendingToJoin ? _Utils_Tuple3(_List_fromArray([$author$project$Ui$Tags$dotToHtml(3)]), 'hairLinePadTop gradient10Back horizontalHairlineMargin', 'secondary800Back negativeHorizontalHairlineMargin') : _Utils_Tuple3(_List_Nil, '', '');
        var pendingToJoinDot = _v1.a;
        var topSectionParentGradientClasses = _v1.b;
        var topSectionChildGradientClasses = _v1.c;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' radius5 flexColumn secondary800Back  noOverflow ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(topSectionParentGradientClasses)]), _List_fromArray([A3($author$project$Ui$MatchmakingCards$section, true, ' spaceBetween ' + topSectionChildGradientClasses, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexCenter noOverflow  ')]), _Utils_ap(pendingToJoinDot, _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w2 h2 marRight0h ')]), _List_fromArray([A2($author$project$Types$Activity$toIcon, cfg.m.xX.du, 'w2 ')])), A2($elm$html$Html$h2, _List_fromArray([$elm$html$Html$Attributes$class('heading6Bold primary0 ellipsis marRight0h ')]), _List_fromArray([$elm$html$Html$text(A2($author$project$Types$Activity$activityToMatchString, true, cfg.m.xX.du))]))]))), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray80 heading6Light whiteSpaceNoWrap  ')]), _List_fromArray([$elm$html$Html$text($author$project$Types$LocalTimeInterval$toDateString(cfg.m.xX.dM.le))]))]))])), A3($author$project$Ui$MatchmakingCards$section, true, ' spaceBetween ', matchStatusRowHtml), A3($author$project$Ui$MatchmakingCards$section, true, '', _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop0h padBottom0h flexRow noOverflow ')]), _List_fromArray([A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, function (photoUrl) {
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight2 ')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
            t_: cfg.t_,
            uj: '',
            wG: _List_fromArray([{
              ij: 13,
              eZ: photoUrl,
              lt: 13
            }]),
            Dq: 9,
            s5: ' relative block w9 h9 radius7 noOverflow '
          })]));
        }, $elm_community$maybe_extra$Maybe$Extra$join(A2($elm$core$Maybe$map, function ($) {
          return $.qq;
        }, cfg.m.Dh)))), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn noOverflow ')]), _List_fromArray([A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$Util$noOpEl, function (venue) {
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold ellipsis left ')]), _List_fromArray([$elm$html$Html$text(venue.i5)]));
        }, cfg.m.Dh), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Regular ellipsis left ')]), _List_fromArray([$elm$html$Html$text(cfg.m.xX.dM.hA)])), A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, function (_v2) {
          var address = _v2.cy;
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading6Regular flexRow flexAlignCenter marBottom1 whiteSpaceNoWrap  ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('gray80 ellipsis ')]), _List_fromArray([$elm$html$Html$text(address.lh)]))]));
        }, cfg.m.Dh))]))]))])), $author$project$Ui$MatchmakingCards$matchPlayersRow({
          t_: cfg.t_,
          m: matchDetails,
          yh: $elm$core$Maybe$Nothing,
          rG: session,
          B0: false
        })]));
      }(),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.p_)
    });
  };
  var $author$project$Ui$MyPlayerStatus$ViewBranch$matchCountBox = F2(function (num, label) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' padLeft ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0 heading1Bold  ')]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(num))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray80 heading4Regular ')]), _List_fromArray([$elm$html$Html$text(label)]))]));
  });
  var $author$project$IconSvg$results_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M22.2565 14.1396H17.7437C16.783 14.1396 15.0855 14.1396 14.7142 11.9971C12.05 12.3063 10.6923 13.4757 10.6923 17.7673V24.465C10.6923 28.5953 11.5159 30.3256 16.6154 30.3256H23.3846C28.4841 30.3256 29.3077 28.5953 29.3077 24.465V17.7673C29.3077 13.4892 27.9585 12.3137 25.3108 12.0001C25.1657 13.0145 24.5846 14.1396 22.2565 14.1396ZM23.6668 11.1305C23.6663 12.1856 23.6406 12.4652 22.2565 12.4652H17.7437C16.6442 12.4652 16.3428 12.4652 16.3337 11.1339C16.3346 11.1098 16.3346 11.0854 16.3334 11.0608C16.3347 9.67444 16.6292 9.67444 17.7437 9.67444H22.2565C23.3669 9.67444 23.6633 9.67444 23.6667 11.0456V11.0472C23.6653 11.0752 23.6653 11.103 23.6668 11.1305ZM25.3124 10.3153C25.0042 8 23.2424 8 22.2565 8H17.7437C16.7565 8 14.9912 8 14.6865 10.3248C10.6558 10.7573 9 12.9666 9 17.7673V24.465C9 29.12 10.2749 32 16.6154 32H23.3846C29.7251 32 31 29.12 31 24.4539V17.7561C31 12.9655 29.344 10.7569 25.3124 10.3153ZM15.4873 21.0606H23.3847C23.8473 21.0606 24.2309 20.6811 24.2309 20.2234C24.2309 19.7657 23.8473 19.3862 23.3847 19.3862H15.4873C15.0247 19.3862 14.6411 19.7657 14.6411 20.2234C14.6411 20.6811 15.0247 21.0606 15.4873 21.0606ZM15.4873 25.5257H20.4288C20.8914 25.5257 21.275 25.1462 21.275 24.6885C21.275 24.2308 20.8914 23.8512 20.4288 23.8512H15.4873C15.0247 23.8512 14.6411 24.2308 14.6411 24.6885C14.6411 25.1462 15.0247 25.5257 15.4873 25.5257Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$results = function (classes) {
    return $author$project$IconSvg$results_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$MyPlayerStatus$ViewBranch$toMatchCountBox = function (_v0) {
    var activity = _v0.du;
    var matchCount = _v0.fZ;
    return A2($author$project$Ui$MyPlayerStatus$ViewBranch$matchCountBox, matchCount, A2($author$project$Types$Activity$toString, false, activity));
  };
  var $author$project$Ui$PlayerProfile$View$myPlayerView = F4(function (browser, profile, statistics, session) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$ImgOverlay(_List_fromArray([{
          ij: browser.ij,
          eZ: $author$project$AssetsImg$assets.AC,
          lt: browser.lt
        }])),
        tU: _List_fromArray([$author$project$UiWrappers$HeaderAndBodyView$multipleBodyContentWithIconAndLabel(_List_fromArray([$elm$core$Maybe$Just({
          uj: '  ',
          fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight-2 marLeft-2 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop1 marBottom1 padRight1 padLeft1 flexRow whiteSpaceNoWrap scrollTargetX noScrollbar spaceBetween  ')]), A2($elm$core$List$cons, A2($author$project$Ui$MyPlayerStatus$ViewBranch$matchCountBox, statistics.fZ, 'All'), A2($elm$core$List$map, $author$project$Ui$MyPlayerStatus$ViewBranch$toMatchCountBox, statistics.tj)))])),
          wE: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$IconSvg$results, '')),
          lh: $elm$core$Maybe$Just('Total matches')
        }), $elm$core$Maybe$Just({
          uj: ' flex1 ',
          fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop1 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), A2($elm$core$List$map, function (matchDetails) {
            return $author$project$Ui$MatchmakingCards$matchCard({
              t_: browser,
              uj: ' marBottom2 ',
              oE: true,
              m: matchDetails,
              p_: $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$NoOp),
              rG: session
            });
          }, _List_Nil))])),
          wE: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$AssetsSvg$logoIconGradient, 'w2h ')),
          lh: $elm$core$Maybe$Just('Matches')
        })]))]),
        l5: $elm$core$Maybe$Nothing,
        t_: browser,
        ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' gray0  marTop3 marBottom3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold marBottom2 ')]), _List_fromArray([$elm$html$Html$text(profile.nF)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow ')]), _List_fromArray([A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$Util$spacer('w8 h8 block radius7'), function (photoUrl) {
          return A2($elm$html$Html$img, _List_fromArray([$elm$html$Html$Attributes$src(photoUrl), $elm$html$Html$Attributes$class('relative block w8 h8 radius7 noOverflow')]), _List_Nil);
        }, profile.qq), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marLeft2 flexColumn justifyCenter')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold gray60 ')]), _List_fromArray([$elm$html$Html$text($author$project$Api$GraphqlSchema$Enum$Gender$toString(profile.nM))]))]))]))]))]),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
        Ck: $elm$core$Maybe$Just(3),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Just($author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$NoOp)),
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  });
  var $author$project$Ui$PlayerProfile$View$view = F3(function (browser, topState, maybeUserId) {
    var maybeSession = $author$project$Types$UserSessionStatus$toSession(topState.lL.A$.sX);
    var maybeStatistics = A2($elm$core$Maybe$map, function ($) {
      return $.r5;
    }, maybeSession);
    var maybeUserProfilePublic = A2($elm$core$Maybe$map, $author$project$Types$UserProfile$toUserProfilePublic, A2($elm$core$Maybe$map, function ($) {
      return $.Db;
    }, maybeSession));
    return _List_fromArray([A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer, A4($elm$core$Maybe$map3, $author$project$Ui$PlayerProfile$View$myPlayerView(browser), maybeUserProfilePublic, maybeStatistics, $author$project$Remote$Model$toSession(topState.lL.A$)))]);
  });
  var $author$project$Ui$PrivacySettings$View$view = _List_Nil;
  var $author$project$Ui$Support$Msg$OnToggleSupportReasonsOverlay = {
    $: 6
  };
  var $author$project$Ui$Support$Msg$ReasonSelected = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Api$GraphqlSchema$Enum$SupportReason$list = _List_fromArray([0, 1, 2]);
  var $elm_community$string_extra$String$Extra$toTitleCase = function (ws) {
    var uppercaseMatch = A2($elm$regex$Regex$replace, $elm_community$string_extra$String$Extra$regexFromString('\\w+'), A2($elm$core$Basics$composeR, function ($) {
      return $.xX;
    }, $elm_community$string_extra$String$Extra$toSentenceCase));
    return A3($elm$regex$Regex$replace, $elm_community$string_extra$String$Extra$regexFromString('^([a-z])|\\s+([a-z])'), A2($elm$core$Basics$composeR, function ($) {
      return $.xX;
    }, uppercaseMatch), ws);
  };
  var $author$project$Ui$Support$View$supportReasonsOverlayView = F2(function (browser, state) {
    return state.oL ? _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: function () {
        var supportReasonsList = A2($krisajenkins$remotedata$RemoteData$withDefault, A2($elm$core$List$map, function (kind) {
          var title = $elm_community$string_extra$String$Extra$toTitleCase($elm$core$String$toLower(A3($elm$core$String$replace, '_', ' ', $author$project$Api$GraphqlSchema$Enum$SupportReason$toString(kind))));
          return {
            vn: {
              mx: '',
              lh: title
            },
            xu: kind
          };
        }, $author$project$Api$GraphqlSchema$Enum$SupportReason$list), state.sf);
        var toOption = function (reason) {
          var itemToString = function (item) {
            return A2($elm$core$Maybe$withDefault, $elm_community$string_extra$String$Extra$toTitleCase($elm$core$String$toLower(A3($elm$core$String$replace, '_', ' ', $author$project$Api$GraphqlSchema$Enum$SupportReason$toString(item.xu)))), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
              return $.vn;
            }, function ($) {
              return $.lh;
            }), A2($elm_community$list_extra$List$Extra$find, function (_v0) {
              var kind = _v0.xu;
              return _Utils_eq(item.xu, kind);
            }, supportReasonsList)));
          };
          return $author$project$Ui$SelectItem$selectOptionBar({
            uj: 'marTop2 ',
            xa: false,
            xj: _Utils_eq(state.sd, $elm$core$Maybe$Just(reason)),
            Cu: $author$project$TopMsg$multiMsg(_List_fromArray([$author$project$TopMsg$msgSupport($author$project$Ui$Support$Msg$ReasonSelected($elm$core$Maybe$Just(reason))), $author$project$TopMsg$msgSupport($author$project$Ui$Support$Msg$OnToggleSupportReasonsOverlay)])),
            lh: itemToString(reason)
          });
        };
        return $author$project$UiWrappers$BottomDrawerOverlayView$bottomDrawerOverlayView({
          l5: $elm$core$Maybe$Nothing,
          t_: browser,
          fn: _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0 heading2Bold marTop1')]), _List_fromArray([$elm$html$Html$text('Select a reason')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), A2($elm$core$List$map, toOption, supportReasonsList))]))]),
          pR: $author$project$TopMsg$msgSupport($author$project$Ui$Support$Msg$OnToggleSupportReasonsOverlay)
        });
      }()
    })]) : _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer]);
  });
  var $author$project$Ui$Support$Msg$CommentTyped = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Ui$Support$Msg$SupportRequestSubmitted = {
    $: 4
  };
  var $author$project$Ui$Support$View$supportView = F2(function (browser, state) {
    var supportReasonsList = A2($krisajenkins$remotedata$RemoteData$withDefault, A2($elm$core$List$map, function (kind) {
      var title = $elm_community$string_extra$String$Extra$toTitleCase($elm$core$String$toLower(A3($elm$core$String$replace, '_', ' ', $author$project$Api$GraphqlSchema$Enum$SupportReason$toString(kind))));
      return {
        vn: {
          mx: '',
          lh: title
        },
        xu: kind
      };
    }, $author$project$Api$GraphqlSchema$Enum$SupportReason$list), state.sf);
    var itemToString = function (item) {
      return A2($elm$core$Maybe$withDefault, $elm_community$string_extra$String$Extra$toTitleCase($elm$core$String$toLower(A3($elm$core$String$replace, '_', ' ', $author$project$Api$GraphqlSchema$Enum$SupportReason$toString(item.xu)))), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
        return $.vn;
      }, function ($) {
        return $.lh;
      }), A2($elm_community$list_extra$List$Extra$find, function (_v0) {
        var kind = _v0.xu;
        return _Utils_eq(item.xu, kind);
      }, supportReasonsList)));
    };
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fontSize2')]), _List_fromArray([$author$project$Ui$Input$labeledDropdown({
          bh: ' marTop2 ',
          od: '',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          oR: 'Reason',
          p_: $elm$core$Maybe$Just($author$project$TopMsg$msgSupport($author$project$Ui$Support$Msg$OnToggleSupportReasonsOverlay)),
          bv: 'Please select reason',
          gw: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', itemToString, state.sd),
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault
        }), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$Input$plainTextarea({
          bP: $elm$core$Maybe$Nothing,
          bh: 'marTop3 minH20  ',
          od: '03',
          wO: ' minH24 ',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgSupport, $author$project$Ui$Support$Msg$CommentTyped),
          bv: state.qv,
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: state.mw
        })]))]))]),
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$NavBar),
        t_: browser,
        ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 marBottom3 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0  ')]), _List_fromArray([$elm$html$Html$text('How can we help?')]))]))]),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
        Ck: $elm$core$Maybe$Just(2),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$TextBtn({
            xa: _Utils_eq(state.sd, $elm$core$Maybe$Nothing) || $elm_community$string_extra$String$Extra$isBlank(state.mw),
            oR: 'Send',
            p_: $author$project$TopMsg$msgSupport($author$project$Ui$Support$Msg$SupportRequestSubmitted)
          }))
        }))
      })
    });
  });
  var $author$project$Ui$Support$View$view = F2(function (browser, state) {
    return _Utils_ap(_List_fromArray([A2($author$project$Ui$Support$View$supportView, browser, state)]), A2($author$project$Ui$Support$View$supportReasonsOverlayView, browser, state));
  });
  var $author$project$UiWrappers$HeaderAndBodyView$Img = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$AppIntro$ViewBranch$appIntroView = F2(function (cfg, browser) {
    var stepsBar = function (currStep) {
      var circle = F2(function (classes, step) {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' circle w1 h1 trans3 '), $elm$html$Html$Attributes$class(classes), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('primary0Back', _Utils_eq(step, currStep)), _Utils_Tuple2(' gray10Back ', !_Utils_eq(step, currStep))]))]), _List_Nil);
      });
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow ')]), _List_fromArray([A2(circle, 'marRight1 ', 1), A2(circle, 'marRight1 ', 2), A2(circle, '', 3)]));
    };
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$Img(cfg.wG),
        tU: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' w14 h14 gray0Back radius5 absoluteCenterX top0 flexCenter emptyCardShadow '), A2($elm$html$Html$Attributes$style, 'transform', 'translateY(-50%) translateX(-50%)')]), _List_fromArray([$author$project$AssetsSvg$logoIconGradient('w7 ')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' marTop7 flexCenterColumn  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn flexAlignCenter minH21 noOverflow ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading2Bold primary0 marBottom1 center padRight4 padLeft4   ')]), _List_fromArray([$elm$html$Html$text(cfg.lh)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' bodyRegular gray80 center   ')]), _List_fromArray([$elm$html$Html$text(cfg.eS)]))])), stepsBar(cfg.a6)]))]),
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$InlineBelowContentBtn({
          xa: false,
          oR: 'Next',
          p_: cfg.en,
          r8: 0
        })),
        t_: browser,
        ww: _List_Nil,
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeHeader({
          xc: true
        }),
        Ck: $elm$core$Maybe$Nothing,
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$IconBtn({
            wE: $author$project$IconSvg$close,
            xa: false,
            p_: cfg.pR
          }))
        }))
      })
    });
  });
  var $author$project$Ui$AppIntro$ViewBranch$historyConfig = {
    wG: _List_fromArray([{
      ij: 8,
      eZ: $author$project$AssetsImg$assets.z2,
      lt: 8
    }]),
    pR: $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$GoBack),
    en: $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$RouteTo($author$project$Route$Route$AppIntro(0))),
    a6: 3,
    eS: 'Computers have become ubiquitous in almost every facet of our lives. At work, desk jockeys spend hours in front of their desktops, while delivery people scan.',
    lh: 'Keep your match history up to date'
  };
  var $author$project$Ui$AppIntro$ViewBranch$locationsConfig = {
    wG: _List_fromArray([{
      ij: 8,
      eZ: $author$project$AssetsImg$assets.z0,
      lt: 8
    }]),
    pR: $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$GoBack),
    en: $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$RouteTo($author$project$Route$Route$AppIntro(1))),
    a6: 1,
    eS: 'Computers have become ubiquitous in almost every facet of our lives. At work, desk jockeys spend hours in front of their desktops, while delivery people scan bar codes with handhelds and workers in.',
    lh: 'Find locations near you'
  };
  var $author$project$Ui$AppIntro$ViewBranch$playersConfig = {
    wG: _List_fromArray([{
      ij: 8,
      eZ: $author$project$AssetsImg$assets.z1,
      lt: 8
    }]),
    pR: $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$GoBack),
    en: $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$RouteTo($author$project$Route$Route$AppIntro(2))),
    a6: 2,
    eS: 'Computers have become ubiquitous in almost every facet of our lives. At work, desk jockeys spend hours in front of their desktops, while delivery people scan.',
    lh: 'Find players of your level to play with'
  };
  var $author$project$Ui$AppIntro$ViewBranch$viewBranch = F2(function (browser, cfg) {
    var branchView = function () {
      var _v0 = cfg.tY;
      switch (_v0) {
        case 0:
          return $author$project$Ui$AppIntro$ViewBranch$locationsConfig;
        case 1:
          return $author$project$Ui$AppIntro$ViewBranch$playersConfig;
        default:
          return $author$project$Ui$AppIntro$ViewBranch$historyConfig;
      }
    }();
    return _List_fromArray([A2($author$project$Ui$AppIntro$ViewBranch$appIntroView, branchView, browser)]);
  });
  var $author$project$Ui$EditUserActivities$EditUserActivities$EditActivityPlayerStatusContext = 1;
  var $author$project$Ui$TopLevelViewsUtil$StickyBtn = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$UiWrappers$PlainWhiteView$TopSection = F2(function (a, b) {
    return {
      $: 0,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$EditUserActivities$Msg$ActivityToggled = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$EditUserActivities$Msg$OnSportSuggestionsInput = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $author$project$Ui$EditUserActivities$Msg$SkillRated = F2(function (a, b) {
    return {
      $: 2,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$EditUserActivities$Msg$SportToggled = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Remote$RequestMsg$UpdateActivities = function (a) {
    return {
      $: 12,
      a: a
    };
  };
  var $author$project$Types$Activity$current = _List_fromArray([0, 3, 1]);
  var $author$project$Types$Activity$activityToIconSublabel = function (activity) {
    return function (_v0) {
      var place = _v0.er;
      var teamSize = _v0.eR;
      var timeSlot = _v0.le;
      return _Utils_Tuple2(place + (' - ' + timeSlot), teamSize);
    }($author$project$Types$Activity$activityToInfoTags(activity));
  };
  var $elm$core$String$filter = _String_filter;
  var $author$project$Ui$OptionLargeSelect$optionLargeSelectActivity = function (cfg) {
    var toTag = function (label) {
      return $author$project$Ui$Tags$tag({
        uj: '',
        cD: 0,
        av: $elm$core$Maybe$Nothing,
        wE: $elm$core$Maybe$Nothing,
        oR: label,
        p_: $elm$core$Maybe$Nothing,
        B3: 0
      });
    };
    var title = A2($author$project$Types$Activity$toString, false, cfg.du);
    var icon = $author$project$Types$Activity$toIcon(cfg.du);
    var _v0 = function (_v1) {
      var place = _v1.er;
      var teamSize = _v1.eR;
      var timeSlot = _v1.le;
      return _Utils_Tuple2(A2($elm$core$String$filter, $elm$core$Basics$neq('.'), A2($elm$core$String$filter, $elm$core$Basics$neq(' '), timeSlot)), teamSize);
    }($author$project$Types$Activity$activityToInfoTags(cfg.du));
    var timeSlotTagText = _v0.a;
    var teamSizeTagText = _v0.b;
    var _v2 = $author$project$Types$Activity$activityToIconSublabel(cfg.du);
    var subLabel1 = _v2.a;
    var subLabel2 = _v2.b;
    var _v3 = cfg.B_ ? _Utils_Tuple2(_List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' gray60 heading6Light ')]), _List_fromArray([$elm$html$Html$text(subLabel1)])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' gray60 heading6Light ')]), _List_fromArray([$elm$html$Html$text(subLabel2)]))]), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceAround marTop1')]), _List_fromArray([toTag(timeSlotTagText), toTag(teamSizeTagText)]))) : _Utils_Tuple2(_List_Nil, $author$project$ElmFramework$Lib$Util$noOpEl);
    var innerTags = _v3.a;
    var outerTags = _v3.b;
    var _v4 = cfg.xj ? {
      cQ: ' primary0Fill ',
      cS: ' gray10Back ',
      bC: ' primary0 ',
      dr: ' gradient10Back '
    } : {
      cQ: ' gray60Fill ',
      cS: ' secondary800Back ',
      bC: ' gray60 ',
      dr: ' secondary800Back '
    };
    var textColor = _v4.bC;
    var innerBackground = _v4.cS;
    var wrapperBackground = _v4.dr;
    var iconFill = _v4.cQ;
    return $author$project$Ui$Button$button({
      bh: ' radius5 maxW14  ' + cfg.uj,
      fn: A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('radius5 hairLinePad w14 h18 '), $elm$html$Html$Attributes$class(wrapperBackground)]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('  flexCenterColumn radius28 fullHeight padTop1 padBottom1  '), $elm$html$Html$Attributes$class(innerBackground)]), _Utils_ap(_List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w8 h8 flexCenter ')]), _List_fromArray([icon('  w8  ' + (iconFill + cfg.ea))])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('bodyBold padRight1 padLeft1 '), $elm$html$Html$Attributes$class(textColor)]), _List_fromArray([$elm$html$Html$text(title)]))]), innerTags))]))])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(cfg.p_)
    });
  };
  var $author$project$Ui$EditUserActivities$EditUserActivities$sportsActivitySelectFlexThreeItemsBar = F2(function (showActivityTags, sportsList) {
    var sportSelectBox = function (_v0) {
      var sport = _v0.dh;
      var onToggle = _v0.zP;
      var selected = _v0.BN;
      return $author$project$Ui$OptionLargeSelect$optionLargeSelectActivity({
        du: sport,
        uj: 'marBottom2  ',
        ea: '',
        xj: selected,
        p_: onToggle(sport),
        B_: showActivityTags
      });
    };
    var fakeElements = function () {
      var fakeElementsCount = function () {
        var remainder = $elm$core$List$length(sportsList) % 3;
        return !remainder ? 0 : 3 - remainder;
      }();
      return A2($elm$core$List$repeat, fakeElementsCount, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('maxW13 h16')]), _List_Nil));
    }();
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow flexItemsPerRow3 spaceBetween')]), A2($elm$core$List$append, A2($elm$core$List$map, sportSelectBox, sportsList), fakeElements));
  });
  var $author$project$Ui$EditUserActivities$EditUserActivities$sportsSelectFlexThreeItemsBar = function (sportsList) {
    var sportSelectBox = function (_v0) {
      var sport = _v0.dh;
      var onToggle = _v0.zP;
      var selected = _v0.BN;
      var label = $author$project$Types$Sport$toString(sport);
      var icon = $author$project$Types$Sport$toIcon(sport);
      return $author$project$Ui$OptionLargeSelect$optionLargeSelect({
        uj: 'marBottom2  ',
        wE: icon,
        ea: '',
        xj: selected,
        p_: onToggle,
        lh: label
      });
    };
    var fakeElements = function () {
      var fakeElementsCount = function () {
        var remainder = $elm$core$List$length(sportsList) % 3;
        return !remainder ? 0 : 3 - remainder;
      }();
      return A2($elm$core$List$repeat, fakeElementsCount, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('maxW13 h16')]), _List_Nil));
    }();
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow flexItemsPerRow3 spaceBetween')]), A2($elm$core$List$append, A2($elm$core$List$map, sportSelectBox, sportsList), fakeElements));
  };
  var $author$project$Types$Sport$Basketball = 4;
  var $author$project$Types$Sport$Cricket = 6;
  var $author$project$Types$Sport$Football = 3;
  var $author$project$Types$Sport$TableTennis = 7;
  var $author$project$Types$Sport$Volleyball = 5;
  var $author$project$Types$Sport$upcoming = _List_fromArray([2, 3, 4, 5, 6, 7]);
  var $author$project$Ui$EditUserActivities$EditUserActivities$editUserActivity = F4(function (editActivityContext, subRoute, editingUserActivitiesState, maybeSession) {
    var updateActivitiesInput = {
      lz: A2($elm$core$List$map, function (_v3) {
        var activity = _v3.a;
        var skillRating = _v3.b;
        return {
          du: activity,
          eH: skillRating
        };
      }, $turboMaCk$any_dict$Dict$Any$toList(editingUserActivitiesState.lz)),
      sL: _Utils_ap(A2($elm$core$List$map, $author$project$Types$Sport$toString, $turboMaCk$any_set$Set$Any$toList(editingUserActivitiesState.fl)), A2($elm$core$List$map, $elm$core$String$trim, A2($elm$core$String$split, ',', editingUserActivitiesState.k5)))
    };
    var playerSportLevel = function (_v2) {
      var activity = _v2.a;
      var level = _v2.b;
      return $author$project$Ui$SportLevelSlider$sportLevelSlider({
        uj: 'marBottom3 ',
        bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingActivities, $author$project$Ui$EditUserActivities$Msg$SkillRated(activity)),
        dh: activity,
        s_: level
      });
    };
    if (!subRoute) {
      var submitMsg = function () {
        if (!editActivityContext) {
          return $turboMaCk$any_dict$Dict$Any$isEmpty(editingUserActivitiesState.lz) ? $author$project$TopMsg$routeTo($author$project$Route$Route$homeRoute) : $author$project$TopMsg$routeTo($author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$EditUserActivities(1)));
        } else {
          return $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$UpdateActivities(updateActivitiesInput));
        }
      }();
      return {
        fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 ')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($author$project$Ui$EditUserActivities$EditUserActivities$sportsActivitySelectFlexThreeItemsBar, false, A2($elm$core$List$map, function (activity) {
          return {
            zP: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingActivities, $author$project$Ui$EditUserActivities$Msg$ActivityToggled),
            BN: A2($turboMaCk$any_dict$Dict$Any$member, activity, editingUserActivitiesState.lz),
            dh: activity
          };
        }, $author$project$Types$Activity$current)), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Regular gray80 marTop1 marBottom2 ')]), _List_fromArray([$elm$html$Html$text('Coming soon...')])), $author$project$Ui$EditUserActivities$EditUserActivities$sportsSelectFlexThreeItemsBar(A2($elm$core$List$map, function (sport) {
          return {
            zP: $author$project$TopMsg$msgEditingActivities($author$project$Ui$EditUserActivities$Msg$SportToggled(sport)),
            BN: A2($turboMaCk$any_set$Set$Any$member, sport, editingUserActivitiesState.fl),
            dh: sport
          };
        }, $author$project$Types$Sport$upcoming)), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$Input$labeledInput({
          bP: $elm$core$Maybe$Nothing,
          bh: ' marBottom3 marTop3  ',
          od: '01',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          oR: 'Suggest a sport',
          bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingActivities, $author$project$Ui$EditUserActivities$Msg$OnSportSuggestionsInput),
          bv: 'Type suggestions separated by comma',
          ch: false,
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
          s_: editingUserActivitiesState.k5
        })]))]))])),
        vn: 'You can choose more than one option.',
        la: submitMsg,
        lh: 'What sports are you interested in playing?'
      };
    } else {
      return {
        fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' marTop3 ')]), A2($elm$core$List$map, playerSportLevel, $turboMaCk$any_dict$Dict$Any$toList(editingUserActivitiesState.lz))),
        vn: 'Select your level for each sport being 1 first-timer and 5 pro.',
        la: $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$UpdateActivities(updateActivitiesInput)),
        lh: 'Level'
      };
    }
  });
  var $author$project$UiWrappers$PlainWhiteView$body = function (cfg) {
    var topSection = function () {
      var top = function () {
        var _v1 = cfg.CW;
        if (!_v1.$) {
          var _v2 = _v1.a;
          var maybeTopBar = _v2.a;
          var maybeStepsBar = _v2.b;
          var topBar = function () {
            if (!maybeTopBar.$) {
              var leftBackBtn = maybeTopBar.a.xC;
              var rightBtn = maybeTopBar.a.Bg;
              var rightCustomBtn = function () {
                if (!rightBtn.$ && rightBtn.a.$ === 1) {
                  var iconbtn = rightBtn.a.a;
                  return $author$project$Ui$Button$button({
                    bh: ' w4 h4 ',
                    fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' w4 h4 flexCenter ')]), _List_fromArray([iconbtn.wE(' w3 primary0Fill ')])),
                    xu: $author$project$ElmFramework$Lib$Ui$Button$Button(iconbtn.p_)
                  });
                } else {
                  return $author$project$ElmFramework$Lib$Util$noOpEl;
                }
              }();
              var leftBtn = function () {
                if (!leftBackBtn.$) {
                  var backMsg = leftBackBtn.a;
                  return $author$project$Ui$Button$button({
                    bh: '  w4 h4',
                    fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w4 h4 flexCenter ')]), _List_fromArray([$author$project$IconSvg$back('w3 primary0Fill')])),
                    xu: $author$project$ElmFramework$Lib$Ui$Button$Button(backMsg)
                  });
                } else {
                  return $author$project$ElmFramework$Lib$Util$noOpEl;
                }
              }();
              return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween fullWidth')]), _List_fromArray([leftBtn, rightCustomBtn]));
            } else {
              return $author$project$ElmFramework$Lib$Util$noOpEl;
            }
          }();
          var stepBar = function () {
            if (!maybeStepsBar.$) {
              var config = maybeStepsBar.a;
              return $author$project$Ui$StepsBar$stepsBar({
                uj: '',
                u1: config.u1,
                oR: config.oR,
                Cg: config.Cg
              });
            } else {
              return $author$project$ElmFramework$Lib$Util$noOpEl;
            }
          }();
          return A2($elm$html$Html$div, _List_Nil, _List_fromArray([topBar, stepBar]));
        } else {
          return $author$project$ElmFramework$Lib$Util$noOpEl;
        }
      }();
      return top;
    }();
    var theBottomSpacerContent = $author$project$Ui$TopLevelViewsUtil$bottomSpacerContent({
      l5: cfg.l5,
      t_: cfg.t_
    });
    var submitHandler = function () {
      var _v0 = cfg.l5;
      if (!_v0.$ && !_v0.a.$) {
        var btnConfig = _v0.a.a;
        return $elm$html$Html$Events$onSubmit(btnConfig.p_);
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpAttr;
      }
    }();
    var bodyContent = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' fullWidth phoneWidthCenter gray0Back pad2 relative flex1')]), A2($elm$core$List$cons, $author$project$ElmFramework$Lib$Util$topAppSpacerCssOnly, A2($elm$core$List$cons, topSection, cfg.fn)));
    return _List_fromArray([A2($elm$html$Html$form, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn fullMinHeight '), submitHandler]), A2($elm$core$List$cons, bodyContent, _List_fromArray([theBottomSpacerContent])))]);
  };
  var $author$project$UiWrappers$PlainWhiteView$scrollerElementAttrs = _List_fromArray([$elm$html$Html$Attributes$class('block absoluteSpread scrollTarget')]);
  var $author$project$UiWrappers$PlainWhiteView$theWrap = function (content) {
    return A3($elm$html$Html$node, 'plain-white-view', _List_fromArray([$elm$html$Html$Attributes$class('block absoluteSpread fullMinHeight ')]), _List_fromArray([content]));
  };
  var $author$project$UiWrappers$PlainWhiteView$plainWhiteView = function (cfg) {
    return $author$project$UiWrappers$PlainWhiteView$theWrap(A3($author$project$ElmFramework$Lib$Ui$EventFull$eventFull, _List_Nil, $author$project$UiWrappers$PlainWhiteView$scrollerElementAttrs, $author$project$UiWrappers$PlainWhiteView$body({
      l5: cfg.l5,
      t_: cfg.t_,
      fn: cfg.fn,
      CW: cfg.CW
    })));
  };
  var $author$project$Ui$EditUserActivities$View$viewBranch = F3(function (branchRoute, browser, topModel) {
    var editingUserActivities = topModel.lL.vF;
    var editConfig = A4($author$project$Ui$EditUserActivities$EditUserActivities$editUserActivity, 1, branchRoute, editingUserActivities, $author$project$Types$UserSessionStatus$toSession(topModel.lL.A$.sX));
    return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$PlainWhiteView$plainWhiteView({
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$StickyBtn({
          xa: false,
          oR: 'Save',
          p_: editConfig.la,
          r8: 0
        })),
        t_: browser,
        fn: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' marTop4 ')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading2Bold primary0 marBottom1 ')]), _List_fromArray([$elm$html$Html$text(editConfig.lh)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' bodyRegular gray80 ')]), _List_fromArray([$elm$html$Html$text(editConfig.vn)]))])), editConfig.fn]))]),
        CW: $elm$core$Maybe$Just(A2($author$project$UiWrappers$PlainWhiteView$TopSection, $elm$core$Maybe$Just({
          xC: $elm$core$Maybe$Just($author$project$ElmFramework$MsgCmd$msgCmd.Bl),
          Bg: $elm$core$Maybe$Nothing
        }), $elm$core$Maybe$Nothing))
      })
    })]);
  });
  var $author$project$Ui$PaymentMethods$Edit$Msg$PaymentMethodContextPayForMatch = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$Match$Msg$PaymentMethodSelected = function (a) {
    return {
      $: 5,
      a: a
    };
  };
  var $author$project$Global$Model$PaymentInformationDialog = {
    $: 18
  };
  var $author$project$ElmFramework$Lib$Stripe$StripeInput$StripeInputType_Payment = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$PaymentMethods$Edit$Msg$StripePaymentElementChanged = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$PaymentMethods$Msg$SubmitPaymentWithSelectedPaymentMethodForMatch = F2(function (a, b) {
    return {
      $: 5,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$RequestMsg$UpdatePaymentPreferences = function (a) {
    return {
      $: 13,
      a: a
    };
  };
  var $author$project$Route$Route$matchMakingAddPaymentMethodRoute = $author$project$Route$Route$matchMakingSingleCheckoutPaymentRoute(1);
  var $author$project$Route$Route$matchMakingSingleRoute = $author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$Main);
  var $author$project$TopMsg$msgPaymentMethods = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$PaymentMethodsMsg);
  var $author$project$TopMsg$msgEditPaymentMethod = A2($elm$core$Basics$composeL, $author$project$TopMsg$msgPaymentMethods, $author$project$Ui$PaymentMethods$Msg$EditMsgReceived);
  var $author$project$Route$Route$paymentMethodsAddPaymentMethodRoute = $author$project$Route$Route$PaymentMethods(1);
  var $author$project$Ui$Curtain$spinnerEl = function (isBright) {
    var colorClass = isBright ? 'whiteBack' : 'blackBack';
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('spinnerContainer relative circle')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-a')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-b')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-c')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-d')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-e')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-f')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-g')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('container-dot dot-h')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('dot'), $elm$html$Html$Attributes$class(colorClass)]), _List_Nil)]))]));
  };
  var $author$project$ElmFramework$Lib$Stripe$StripeInput$StripeInput = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$Stripe$StripeInput$StripeInputError = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$Stripe$StripeInput$stripeInput = function (cfg) {
    var _v0 = function () {
      var _v1 = cfg.wQ;
      if (!_v1.$) {
        var requiredParams = _v1.a;
        return _Utils_Tuple2('payment', requiredParams.ul);
      } else {
        return _Utils_Tuple2('card', '');
      }
    }();
    var elementType = _v0.a;
    var clientSecret = _v0.b;
    return A3($elm$html$Html$node, 'stripe-input', _List_fromArray([$elm$html$Html$Attributes$class(cfg.uj), $elm$html$Html$Attributes$class('block'), A3($author$project$ElmFramework$Lib$WebComponentsUtil$listenWebComponentEvent, 'onValidInput', $elm$json$Json$Decode$value, A2($elm$core$Basics$composeR, $author$project$ElmFramework$Lib$Stripe$StripeInput$StripeInput, cfg.p2)), A3($author$project$ElmFramework$Lib$WebComponentsUtil$listenWebComponentEvent, 'onInputError', $elm$json$Json$Decode$string, A2($elm$core$Basics$composeR, $author$project$ElmFramework$Lib$Stripe$StripeInput$StripeInputError, cfg.p2)), A2($elm$html$Html$Attributes$attribute, 'stripe-classes', cfg.Ci), A2($elm$html$Html$Attributes$attribute, 'element-type', elementType), A2($elm$html$Html$Attributes$attribute, 'client-secret', clientSecret)]), _List_Nil);
  };
  var $author$project$Types$PaymentMethod$toSavedPaymentMethodStripeCard = function (method) {
    var _v0 = method.Cj.vp;
    if (!_v0.$) {
      var savedPaymentMethodStripeCard = _v0.a;
      return $elm$core$Maybe$Just(savedPaymentMethodStripeCard);
    } else {
      return $elm$core$Maybe$Nothing;
    }
  };
  var $turboMaCk$any_dict$Dict$Any$values = A2($elm$core$Basics$composeL, $elm$core$List$map($elm$core$Tuple$second), $turboMaCk$any_dict$Dict$Any$toList);
  var $author$project$Ui$PaymentMethods$ViewBranch$browseView = function (cfg) {
    var state = cfg.CX.lL.Ae;
    var moreInformationElement = function () {
      var _v11 = cfg.qh;
      switch (_v11.$) {
        case 0:
          var maybeSearchParams = _v11.a;
          return _List_Nil;
        case 1:
          return _List_Nil;
        default:
          return _List_Nil;
      }
    }();
    var isAutoPayEnabled = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function (session) {
      return session.qk.w9;
    }, $author$project$Types$UserSessionStatus$toSession(cfg.CX.lL.A$.sX)));
    var holdAmountNote = function () {
      var _v10 = cfg.qh;
      if (!_v10.$ && !_v10.a.$) {
        var searchId = _v10.a.a;
        return _List_Nil;
      } else {
        return _List_Nil;
      }
    }();
    var hiddenPaymentElement = function () {
      var _v8 = cfg.CX.lL.A$.sX;
      if (_v8.$ === 3) {
        var session = _v8.a;
        var _v9 = $krisajenkins$remotedata$RemoteData$toMaybe(session.Al);
        if (!_v9.$) {
          var pendingIntent = _v9.a;
          return _List_fromArray([$author$project$ElmFramework$Lib$Stripe$StripeInput$stripeInput({
            uj: 'hidden',
            wQ: $author$project$ElmFramework$Lib$Stripe$StripeInput$StripeInputType_Payment({
              ul: pendingIntent.ul
            }),
            p2: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditPaymentMethod, $author$project$Ui$PaymentMethods$Edit$Msg$StripePaymentElementChanged),
            Ci: ''
          })]);
        } else {
          return _List_fromArray([$author$project$Ui$Curtain$spinnerEl(true)]);
        }
      } else {
        return _List_Nil;
      }
    }();
    var bottomInteractionButton = function () {
      var _v6 = cfg.qh;
      switch (_v6.$) {
        case 0:
          if (_v6.a.$ === 1) {
            var _v7 = _v6.a;
            return $elm$core$Maybe$Nothing;
          } else {
            var searchParams = _v6.a;
            return $elm$core$Maybe$Nothing;
          }
        case 1:
          return $elm$core$Maybe$Nothing;
        default:
          var matchId = _v6.a;
          var priceStringOrEmpty = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function (holdSuccess) {
            return ' ' + ($elm$core$String$fromFloat(holdSuccess.lH / 100) + (' ' + $author$project$Api$GraphqlSchema$Enum$Currency$toString(holdSuccess.mH)));
          }, A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, function ($) {
            return $.Aj;
          }, A2($elm$core$Basics$composeR, $turboMaCk$any_dict$Dict$Any$get(matchId), $elm$core$Maybe$andThen($krisajenkins$remotedata$RemoteData$toMaybe))), $author$project$Types$UserSessionStatus$toSession(cfg.CX.lL.A$.sX))));
          return $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$InlineBelowContentTextIconBtn({
            xa: $elm_community$maybe_extra$Maybe$Extra$isNothing(cfg.BN) || $elm_community$maybe_extra$Maybe$Extra$isJust(state.qm),
            oR: 'Pay' + priceStringOrEmpty,
            xD: $elm$core$Maybe$Nothing,
            p_: A2($elm$core$Maybe$withDefault, A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Something went wrong', _List_Nil), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$TopMsg$msgPaymentMethods, $author$project$Ui$PaymentMethods$Msg$SubmitPaymentWithSelectedPaymentMethodForMatch(matchId)), cfg.BN)),
            Bh: $elm$core$Maybe$Nothing,
            r8: 0
          }));
      }
    }();
    var baseRoute = function () {
      var _v4 = cfg.qh;
      switch (_v4.$) {
        case 0:
          if (!_v4.a.$) {
            var searchParams = _v4.a.a;
            return $author$project$Route$Route$matchMakingAddPaymentMethodRoute;
          } else {
            var _v5 = _v4.a;
            return $author$project$Route$Route$matchMakingSingleRoute;
          }
        case 1:
          return $author$project$Route$Route$paymentMethodsAddPaymentMethodRoute;
        default:
          var matchId = _v4.a;
          return A2($author$project$Route$Route$Match, matchId, $author$project$Ui$Match$Route$PayMatch(1));
      }
    }();
    var addPaymentMethodRow = _List_fromArray([$author$project$Ui$OptionLargeSelect$iconBtnRow({
      uj: 'marTop4',
      wE: $author$project$IconSvg$plus,
      oR: 'Add payment method',
      p_: $author$project$TopMsg$routeTo(baseRoute)
    })]);
    var _v0 = function () {
      var _v1 = $krisajenkins$remotedata$RemoteData$toMaybe(cfg.qj);
      if (!_v1.$) {
        var paymentMethodsAnyDict = _v1.a;
        return $turboMaCk$any_dict$Dict$Any$isEmpty(paymentMethodsAnyDict) ? _Utils_Tuple2(A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('center')]), _Utils_ap(moreInformationElement, _Utils_ap(addPaymentMethodRow, _Utils_ap(holdAmountNote, hiddenPaymentElement))))])), bottomInteractionButton) : _Utils_Tuple2(A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padLeft3 padRight3 ')]), _Utils_ap($elm_community$maybe_extra$Maybe$Extra$values(A2($elm$core$List$map, function (paymentMethod) {
          return A2($elm$core$Maybe$map, function (card) {
            return $author$project$Ui$PaymentCard$paymentCard({
              tZ: card.tZ,
              uj: 'marTop2',
              v4: $elm$core$String$fromInt(card.v4.pt) + ('/' + $elm$core$String$fromInt(card.v4.ta)),
              oC: false,
              xj: _Utils_eq(cfg.BN, $elm$core$Maybe$Just(paymentMethod.od)),
              xw: $elm$core$Maybe$Just(card.xw),
              i5: '',
              pX: cfg.pX,
              p_: cfg.zG,
              p$: $author$project$TopMsg$noOpMsg,
              Ad: $elm$core$Maybe$Just(paymentMethod.od)
            });
          }, $author$project$Types$PaymentMethod$toSavedPaymentMethodStripeCard(paymentMethod));
        }, $turboMaCk$any_dict$Dict$Any$values(paymentMethodsAnyDict))), _Utils_ap(addPaymentMethodRow, _Utils_ap(holdAmountNote, hiddenPaymentElement))))])), bottomInteractionButton);
      } else {
        return _Utils_Tuple2($elm$html$Html$text(''), $elm$core$Maybe$Nothing);
      }
    }();
    var paymentCardsView = _v0.a;
    var bottomInteraction = _v0.b;
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_fromArray([paymentCardsView]),
        l5: bottomInteraction,
        t_: cfg.t_,
        ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 marBottom3')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0')]), _List_fromArray([$elm$html$Html$text('Payment methods')])), function () {
          var _v2 = cfg.qh;
          switch (_v2.$) {
            case 0:
              return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bodyRegular  gray10  ')]), _List_fromArray([$elm$html$Html$text('We will only charge you if a match is made! We just need your payment information and we will charge you if a match is made, at the match time for the booking. '), $author$project$Ui$Button$textBtn({
                uj: ' secondary100 ',
                p_: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$PaymentInformationDialog)),
                eS: 'More information here.'
              })]));
            case 1:
              return $author$project$ElmFramework$Lib$Util$noOpEl;
            default:
              return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bodyRegular  gray10 marTop1 ')]), _List_fromArray([$elm$html$Html$text('Enabling this option will automatically charge you for matches when we find players.')]));
          }
        }(), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth flexRow flexAlignCenter marTop2 ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('gray0 marRight2 bodyRegular ')]), _List_fromArray([$elm$html$Html$text('Automatically pay for matches')])), $author$project$Ui$Switch$switch({
          uj: '',
          ux: 1,
          eh: isAutoPayEnabled,
          xi: true,
          Cu: $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$UpdatePaymentPreferences(!isAutoPayEnabled))
        })]))]))]),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
        Ck: $elm$core$Maybe$Just(2),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: function () {
            var _v3 = cfg.qh;
            switch (_v3.$) {
              case 0:
                return $elm$core$Maybe$Just($author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$Main)));
              case 1:
                return $elm$core$Maybe$Just($author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$MoreOptions));
              default:
                var matchId = _v3.a;
                return $elm$core$Maybe$Just($author$project$ElmFramework$MsgCmd$msgCmd.Bt(A2($author$project$Route$Route$Match, matchId, $author$project$Ui$Match$Route$Details)));
            }
          }(),
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  };
  var $author$project$Remote$RequestMsg$CancelMatch = F2(function (a, b) {
    return {
      $: 18,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Match$Msg$ExpandCancelllationPolicyCancelMatchView = {
    $: 7
  };
  var $author$project$Ui$TopLevelViewsUtil$InlineBelowContentPairButtons = function (a) {
    return {
      $: 8,
      a: a
    };
  };
  var $author$project$Ui$Match$Msg$OnToggleCancelMatchReasonsOverlay = {
    $: 9
  };
  var $author$project$Types$Match$cancelMatchReasonToString = function (cancelMatchReason) {
    switch (cancelMatchReason) {
      case 0:
        return 'Something urgent came up and I can’t make it';
      case 1:
        return 'I am not satisfied with the venue I was assigned to';
      case 2:
        return 'I am concerned about the players that I was matched with';
      case 3:
        return 'I was expecting XRIVALS to work in a different way';
      default:
        return 'Other personal reasons';
    }
  };
  var $author$project$Ui$MatchmakingCards$cancellationPolicy = function (cfg) {
    var readMoreBtnContent = $author$project$Ui$Button$textBtn({
      uj: ' bodyRegular secondary100 heading5Bold ',
      p_: cfg.pW,
      eS: 'Read more...'
    });
    var _v0 = cfg.oD ? _Utils_Tuple2('', $author$project$ElmFramework$Lib$Util$noOpEl) : _Utils_Tuple2('lineClamp', readMoreBtnContent);
    var lineClampClass = _v0.a;
    var readMoreBtn = _v0.b;
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' pad2 radius7 secondary800Back ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading3Bold primary80 marBottom1 ')]), _List_fromArray([$elm$html$Html$text('Cancellation policy')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' bodyRegular gray80 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(lineClampClass)]), _List_fromArray([$elm$html$Html$text('If not enough players join the match, you will receive a full refund. If you cancel your slot over 24 hours before your match, you will receive a full refund. If you cancel less than 24 hours before your match, you will receive a 50% refund. If you don\'t cancel your slot and you don\'t show up to the match you will not receive a refund.')]))])), readMoreBtn]));
  };
  var $author$project$Api$GraphqlSchema$Enum$CancelMatchReason$list = _List_fromArray([0, 1, 2, 3, 4]);
  var $author$project$Ui$Match$ViewBranch$cancelMatch = F3(function (browser, matchId, state) {
    var cancelMatchReasonsList = A2($krisajenkins$remotedata$RemoteData$withDefault, A2($elm$core$List$map, function (kind) {
      var description = $author$project$Types$Match$cancelMatchReasonToString(kind);
      return _Utils_Tuple2(kind, description);
    }, $author$project$Api$GraphqlSchema$Enum$CancelMatchReason$list), state.ma);
    var itemToString = function (item) {
      return A2($elm$core$Maybe$withDefault, $author$project$Types$Match$cancelMatchReasonToString(item), A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm_community$list_extra$List$Extra$find, function (_v0) {
        var reasonElem = _v0.a;
        return _Utils_eq(item, reasonElem);
      }, cancelMatchReasonsList)));
    };
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$MatchmakingCards$cancellationPolicy({
          oD: state.oA,
          pW: $author$project$TopMsg$msgMatch($author$project$Ui$Match$Msg$ExpandCancelllationPolicyCancelMatchView)
        }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Regular primary0 marBottom1 ')]), _List_fromArray([$elm$html$Html$text('Please select one of the following reasons:')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fontSize2')]), _List_fromArray([$author$project$Ui$Input$labeledDropdown({
          bh: ' marTop2 ',
          od: '',
          wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
          oR: 'Reason',
          p_: $elm$core$Maybe$Just($author$project$TopMsg$msgMatch($author$project$Ui$Match$Msg$OnToggleCancelMatchReasonsOverlay)),
          bv: 'Please select reason',
          gw: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', itemToString, state.l9),
          Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault
        })]))]))]))]),
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$InlineBelowContentPairButtons(_Utils_Tuple2({
          xa: _Utils_eq(state.l9, $elm$core$Maybe$Nothing),
          oR: 'Cancel slot',
          p_: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$TopMsg$noOpMsg, A2($elm$core$Basics$composeL, $author$project$TopMsg$requestMsg, $author$project$Remote$RequestMsg$CancelMatch(matchId)), state.l9),
          r8: 1
        }, {
          xa: false,
          oR: 'Keep my slot',
          p_: $author$project$TopMsg$routeBack,
          r8: 0
        }))),
        t_: browser,
        ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0 marTop3 marBottom3 ')]), _List_fromArray([$elm$html$Html$text('Are you sure you want to cancel your slot?')]))]),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
        Ck: $elm$core$Maybe$Just(2),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Nothing,
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$IconBtn({
            wE: $author$project$IconSvg$close,
            xa: false,
            p_: $author$project$TopMsg$routeBack
          }))
        }))
      })
    });
  });
  var $author$project$Ui$Match$Msg$CancelReasonSelected = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$Match$ViewBranch$cancelMatchReasonsOverlayView = F2(function (browser, state) {
    return state.oy ? _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: function () {
        var cancelMatchReasonsList = A2($krisajenkins$remotedata$RemoteData$withDefault, A2($elm$core$List$map, function (kind) {
          var description = $author$project$Types$Match$cancelMatchReasonToString(kind);
          return _Utils_Tuple2(kind, description);
        }, $author$project$Api$GraphqlSchema$Enum$CancelMatchReason$list), state.ma);
        var toOption = function (reason) {
          var itemToString = function (item) {
            return A2($elm$core$Maybe$withDefault, $author$project$Types$Match$cancelMatchReasonToString(item), A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm_community$list_extra$List$Extra$find, function (_v0) {
              var reasonElem = _v0.a;
              return _Utils_eq(item, reasonElem);
            }, cancelMatchReasonsList)));
          };
          return $author$project$Ui$SelectItem$selectOptionBar({
            uj: 'marTop2 ',
            xa: false,
            xj: _Utils_eq(state.l9, $elm$core$Maybe$Just(reason.a)),
            Cu: $author$project$TopMsg$multiMsg(_List_fromArray([$author$project$TopMsg$msgMatch($author$project$Ui$Match$Msg$CancelReasonSelected($elm$core$Maybe$Just(reason.a))), $author$project$TopMsg$msgMatch($author$project$Ui$Match$Msg$OnToggleCancelMatchReasonsOverlay)])),
            lh: itemToString(reason.a)
          });
        };
        return $author$project$UiWrappers$BottomDrawerOverlayView$bottomDrawerOverlayView({
          l5: $elm$core$Maybe$Nothing,
          t_: browser,
          fn: _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0 heading2Bold marTop1')]), _List_fromArray([$elm$html$Html$text('Select a reason')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), A2($elm$core$List$map, toOption, cancelMatchReasonsList))]))]),
          pR: $author$project$TopMsg$msgMatch($author$project$Ui$Match$Msg$OnToggleCancelMatchReasonsOverlay)
        });
      }()
    })]) : _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer]);
  });
  var $author$project$Ui$PaymentMethods$Edit$Msg$NoOp = {
    $: 8
  };
  var $author$project$Ui$PaymentMethods$Edit$Msg$SavePaymentMethod = function (a) {
    return {
      $: 5,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$Stripe$StripeInput$StripeInputType_Card = {
    $: 1
  };
  var $author$project$Ui$PaymentMethods$Edit$Msg$SubmitPayment = {
    $: 3
  };
  var $author$project$UiWrappers$HeaderAndBodyView$Title = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$PaymentMethods$Edit$Msg$ToggleIsSaveForFuturePurchases = {
    $: 7
  };
  var $author$project$Ui$PaymentMethods$Edit$ViewBranch$creditCardView = function (cfg) {
    var state = cfg.CX.lL.Ae.vE;
    var maybeSession = $author$project$Types$UserSessionStatus$toSession(cfg.CX.lL.A$.sX);
    var isEdit = !_Utils_eq(cfg.Ad, $elm$core$Maybe$Nothing);
    var isAutoPayEnabled = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
      return $.qk;
    }, function ($) {
      return $.w9;
    }), $author$project$Types$UserSessionStatus$toSession(cfg.CX.lL.A$.sX)));
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading2Bold primary0 marBottom3 ')]), _List_fromArray([$elm$html$Html$text('Credit card details')])), A2($elm$html$Html$div, _List_Nil, function () {
          if (!maybeSession.$) {
            var session = maybeSession.a;
            var saveForFutureElement = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' marBottom2 marTop2 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth flexRow flexAlignCenter spaceBetween ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('gray90 marRight2 bodyRegular ')]), _List_fromArray([$elm$html$Html$text('Save for future purchases')])), $author$project$Ui$Switch$switch({
              uj: '',
              ux: 0,
              eh: state.oJ,
              xi: true,
              Cu: $author$project$TopMsg$msgEditPaymentMethod($author$project$Ui$PaymentMethods$Edit$Msg$ToggleIsSaveForFuturePurchases)
            })]))]));
            var autoPayElement = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' secondary800Back pad2 secondary810 marBottom-2 marLeft-2 marRight-2 marTop2 radiusTopLeft5 radiusTopRight5 radiusBottomLeft0 radiusBottomRight0 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading5Regular ')]), _List_fromArray([$elm$html$Html$text('Enabling this option will automatically charge you for matches when we find players so you don’t need to manually confirm every time.')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth flexRow flexAlignCenter marTop1h spaceBetween ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('gray90 marRight2 bodyRegular ')]), _List_fromArray([$elm$html$Html$text('Automatically pay for matches')])), $author$project$Ui$Switch$switch({
              uj: '',
              ux: 2,
              eh: isAutoPayEnabled,
              xi: true,
              Cu: $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$UpdatePaymentPreferences(!isAutoPayEnabled))
            })]))]));
            var _v1 = cfg.qh;
            switch (_v1.$) {
              case 0:
                var maybeSearchParams = _v1.a;
                return _List_fromArray([$author$project$ElmFramework$Lib$Stripe$StripeInput$stripeInput({
                  uj: '',
                  wQ: $author$project$ElmFramework$Lib$Stripe$StripeInput$StripeInputType_Card,
                  p2: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditPaymentMethod, $author$project$Ui$PaymentMethods$Edit$Msg$StripePaymentElementChanged),
                  Ci: ''
                }), autoPayElement]);
              case 2:
                var matchId = _v1.a;
                var _v2 = A2($elm$core$Maybe$andThen, $krisajenkins$remotedata$RemoteData$toMaybe, A2($turboMaCk$any_dict$Dict$Any$get, matchId, session.Aj));
                if (!_v2.$) {
                  var paymentIntent = _v2.a;
                  return _List_fromArray([$author$project$ElmFramework$Lib$Stripe$StripeInput$stripeInput({
                    uj: 'bodyRegular',
                    wQ: $author$project$ElmFramework$Lib$Stripe$StripeInput$StripeInputType_Payment({
                      ul: paymentIntent.ot.ul
                    }),
                    p2: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditPaymentMethod, $author$project$Ui$PaymentMethods$Edit$Msg$StripePaymentElementChanged),
                    Ci: ''
                  }), autoPayElement]);
                } else {
                  return _List_fromArray([$author$project$Ui$Curtain$spinnerEl(true)]);
                }
              default:
                var _v3 = $krisajenkins$remotedata$RemoteData$toMaybe(session.Al);
                if (!_v3.$) {
                  var pendingIntent = _v3.a;
                  return _List_fromArray([$author$project$ElmFramework$Lib$Stripe$StripeInput$stripeInput({
                    uj: '',
                    wQ: $author$project$ElmFramework$Lib$Stripe$StripeInput$StripeInputType_Payment({
                      ul: pendingIntent.ul
                    }),
                    p2: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditPaymentMethod, $author$project$Ui$PaymentMethods$Edit$Msg$StripePaymentElementChanged),
                    Ci: ''
                  }), autoPayElement]);
                } else {
                  return _List_fromArray([$author$project$Ui$Curtain$spinnerEl(true)]);
                }
            }
          } else {
            return _List_fromArray([$elm$html$Html$text('')]);
          }
        }())]))]),
        l5: function () {
          var _v4 = cfg.qh;
          if (_v4.$ === 2) {
            var matchId = _v4.a;
            var priceStringOrEmpty = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function (holdSuccess) {
              return ' ' + ($elm$core$String$fromFloat(holdSuccess.lH / 100) + (' ' + $author$project$Api$GraphqlSchema$Enum$Currency$toString(holdSuccess.mH)));
            }, A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, function ($) {
              return $.Aj;
            }, A2($elm$core$Basics$composeR, $turboMaCk$any_dict$Dict$Any$get(matchId), $elm$core$Maybe$andThen($krisajenkins$remotedata$RemoteData$toMaybe))), $author$project$Types$UserSessionStatus$toSession(cfg.CX.lL.A$.sX))));
            return $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$InlineBelowContentTextIconBtn({
              xa: state.iz || $elm_community$maybe_extra$Maybe$Extra$isNothing(state.qg),
              oR: 'Pay' + priceStringOrEmpty,
              xD: $elm$core$Maybe$Nothing,
              p_: $author$project$TopMsg$msgEditPaymentMethod($author$project$Ui$PaymentMethods$Edit$Msg$SubmitPayment),
              Bh: $elm$core$Maybe$Nothing,
              r8: 0
            }));
          } else {
            return $elm$core$Maybe$Nothing;
          }
        }(),
        t_: cfg.t_,
        ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padLeft3 padRight3 marTop3 marBottom3 ')]), _List_fromArray([$author$project$Ui$PaymentCard$paymentCard({
          tZ: '',
          uj: '',
          v4: '',
          oC: false,
          xj: false,
          xw: $elm$core$Maybe$Just(''),
          i5: '',
          pX: $elm$core$Maybe$Nothing,
          p_: $elm$core$Maybe$Nothing,
          p$: $author$project$TopMsg$msgEditPaymentMethod($author$project$Ui$PaymentMethods$Edit$Msg$NoOp),
          Ad: cfg.Ad
        })]))]),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
        Ck: $elm$core$Maybe$Just(2),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Just($author$project$ElmFramework$MsgCmd$msgCmd.Bl),
          yo: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$Title(A2($elm$core$String$append, A3($author$project$ElmFramework$Lib$Util$ifElse, 'Edit ', 'Add ', isEdit), 'credit card'))),
          Bg: function () {
            var _v5 = cfg.qh;
            switch (_v5.$) {
              case 0:
                return $elm$core$Maybe$Nothing;
              case 2:
                return $elm$core$Maybe$Nothing;
              default:
                return $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$TextBtn({
                  xa: state.iz || $elm_community$maybe_extra$Maybe$Extra$isNothing(state.qg),
                  oR: 'Save',
                  p_: $author$project$TopMsg$msgEditPaymentMethod($author$project$Ui$PaymentMethods$Edit$Msg$SavePaymentMethod(cfg.qh))
                }));
            }
          }()
        }))
      })
    });
  };
  var $author$project$Ui$PaymentMethods$Edit$ViewBranch$editPaymentMethodView = function (cfg) {
    return _List_fromArray([$author$project$Ui$PaymentMethods$Edit$ViewBranch$creditCardView({
      t_: cfg.t_,
      qh: cfg.qh,
      Ad: cfg.Ad,
      CX: cfg.CX
    })]);
  };
  var $author$project$Types$UserSession$isPendingRatingMatch = F2(function (matchId, session) {
    return A2($turboMaCk$any_set$Set$Any$member, matchId, session.Am);
  });
  var $author$project$Ui$Match$Msg$ExpandCancelllationPolicyMatchView = {
    $: 6
  };
  var $author$project$Remote$RequestMsg$JoinMatch = function (a) {
    return {
      $: 16,
      a: a
    };
  };
  var $author$project$Ui$Match$Msg$RatingSelected = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$UiWrappers$HeaderAndBodyView$StripesCenteredLeft = 4;
  var $author$project$Remote$RequestMsg$SubmitMatchRating = F2(function (a, b) {
    return {
      $: 22,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$Match$ViewBranch$bodyWrapper = F5(function (browser, session, matchDetails, retryForNewMatchStatusCount, otherContent) {
    return $author$project$UiWrappers$HeaderAndBodyView$multipleBodyContentWithIconAndLabel(_List_fromArray([$elm$core$Maybe$Just({
      uj: ' flex1 ',
      fn: A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$MatchmakingCards$matchPlayersRow({
        t_: browser,
        m: matchDetails,
        yh: $elm$core$Maybe$Just(retryForNewMatchStatusCount),
        rG: session,
        B0: true
      })])),
      wE: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$IconSvg$people, '')),
      lh: $elm$core$Maybe$Just('Players')
    }), otherContent]));
  });
  var $author$project$Types$Match$isCancelled = function (match) {
    var _v0 = match.Cd;
    if (_v0.$ === 3) {
      return true;
    } else {
      return false;
    }
  };
  var $author$project$Route$Route$matchCancelRoute = function (matchId) {
    return A2($author$project$Route$Route$Match, matchId, $author$project$Ui$Match$Route$Cancel);
  };
  var $elm$core$String$padRight = F3(function (n, _char, string) {
    return _Utils_ap(string, A2($elm$core$String$repeat, n - $elm$core$String$length(string), $elm$core$String$fromChar(_char)));
  });
  var $author$project$CurrencyAmount$remainderInCentsString = function (amount) {
    return A3($elm$core$String$padRight, 2, '0', $elm$core$String$fromInt($elm$core$Basics$abs(amount % 100)));
  };
  var $author$project$CurrencyAmount$whileNumberString = function (amount) {
    return $elm$core$String$fromInt(amount / 100 | 0);
  };
  var $author$project$CurrencyAmount$fillsToDirham = function (amount) {
    var bothZero = $author$project$CurrencyAmount$whileNumberString(amount) === '0' && $author$project$CurrencyAmount$remainderInCentsString(amount) === '0';
    return _Utils_ap($author$project$CurrencyAmount$whileNumberString(amount), $author$project$CurrencyAmount$remainderInCentsString(amount) === 'NaN' || bothZero || $author$project$CurrencyAmount$remainderInCentsString(amount) === '00' ? '' : '.' + $author$project$CurrencyAmount$remainderInCentsString(amount));
  };
  var $author$project$Ui$Tags$SmallLowPad = 2;
  var $author$project$Ui$Match$ViewBranch$infoTag = function (_v0) {
    var label = _v0.a;
    var icon = _v0.b;
    return $author$project$Ui$Tags$tag({
      uj: 'marRight1 ',
      cD: 0,
      av: $elm$core$Maybe$Nothing,
      wE: $elm$core$Maybe$Just(icon),
      oR: label,
      p_: $elm$core$Maybe$Nothing,
      B3: 2
    });
  };
  var $author$project$Types$LocalTimeInterval$toDateStringShort = function (interval) {
    var year = $elm$core$String$fromInt(interval.wh.ta);
    var month = A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt(interval.wh.pt));
    var day = A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt(interval.wh.mO));
    return day + ('/' + (month + ('/' + year)));
  };
  var $author$project$Ui$Match$ViewBranch$matchHeader = function (cfg) {
    var questionsOrConcerns = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('left heading3Regular gray0 ellipsis padTop3')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text('Questions or concerns about your match?')])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text('Contact us on '), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('left heading3Bold')]), _List_fromArray([$elm$html$Html$text('+971 50 4833 836')]))]))]));
    var price = A2($elm$core$Maybe$withDefault, $author$project$CurrencyAmount$fillsToDirham(cfg.m.xX.dM.aO), A2($elm$core$Maybe$map, function (participantPrivate) {
      return $author$project$CurrencyAmount$fillsToDirham(participantPrivate.aO);
    }, $author$project$Types$Match$participantsToPrivateParticipant(cfg.m.z8)));
    var priceTag = cfg.rQ ? _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('inlineFlex flexAlignCenter pad2 padTop1 padBottom1 radius2 secondary810Back')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('marRight3 heading5Regular gray40')]), _List_fromArray([$elm$html$Html$text('Price')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray0')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading2Bold ')]), _List_fromArray([$elm$html$Html$text(price)])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading6Regular marRight3 ')]), _List_fromArray([$elm$html$Html$text($author$project$Api$GraphqlSchema$Enum$Currency$toString(0))]))]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('inlineFlex flexAlignCenter pad2 padTop1 padBottom1 heading5Bold white ')]), _List_fromArray([$elm$html$Html$text('Your slot price')]))]) : _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('h4')]), _List_Nil)]);
    var locationInfo = A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop2 whiteSpaceNoWrap scrollTargetX noScrollbar')]), _List_fromArray([$author$project$Ui$Match$ViewBranch$infoTag(_Utils_Tuple2($author$project$Types$LocalTimeInterval$toDateStringShort(cfg.m.xX.dM.le), $author$project$IconSvg$calendar)), $author$project$ElmFramework$Lib$Util$spacer('marLeft1'), $author$project$Ui$Match$ViewBranch$infoTag(_Utils_Tuple2($author$project$Types$LocalTimeInterval$toTimeRangeString(cfg.m.xX.dM.le), $author$project$IconSvg$clock))])), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$Util$noOpEl, function (venue) {
      var venueAddress = function () {
        var _v2 = _Utils_Tuple2(!_Utils_eq(venue.cy.lh, venue.i5), !_Utils_eq(venue.cy.lb, venue.i5));
        if (_v2.a) {
          if (_v2.b) {
            return venue.cy.lh + (' ' + venue.cy.lb);
          } else {
            return venue.cy.lh;
          }
        } else {
          if (_v2.b) {
            return venue.cy.lb;
          } else {
            return '';
          }
        }
      }();
      var venueAddressForGoogleMapsLink = $elm$core$String$isEmpty(venueAddress) ? '' : ' ' + venueAddress;
      var placeId = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function (placeIdValue) {
        return '&query_place_id=' + placeIdValue;
      }, venue.qu));
      var linkButton = F2(function (text, link) {
        return $author$project$Ui$Button$textLink({
          uj: '',
          im: link,
          xa: false,
          eS: text
        });
      });
      var _v0 = _Utils_Tuple2(venue.iT.oV, venue.iT.o_);
      var lat = _v0.a;
      var lng = _v0.b;
      var mapLink = {
        tw: 'https://maps.apple.com?q=' + (venue.i5 + ('&ll=' + ($elm$core$String$fromFloat(lat) + (',' + $elm$core$String$fromFloat(lng))))),
        ie: 'https://www.google.com/maps/search/?api=1&query=' + (venue.i5 + (venueAddressForGoogleMapsLink + placeId))
      };
      var _v1 = cfg.vS;
      var isAndroid = _v1.fM;
      var isHybrid = _v1.xd;
      var isIos = _v1.fQ;
      var mapsButtons = isAndroid ? isHybrid ? _List_fromArray([A2(linkButton, 'Find it on the map', mapLink.ie)]) : _List_fromArray([A2(linkButton, 'Find it on the map', mapLink.ie)]) : isIos ? _Utils_ap(_List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold gray0')]), _List_fromArray([$elm$html$Html$text('Find it on ')]))]), _Utils_ap(_List_fromArray([A2(linkButton, 'Google maps', mapLink.ie)]), _Utils_ap(_List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold gray0')]), _List_fromArray([$elm$html$Html$text(' or ')]))]), _List_fromArray([A2(linkButton, 'Apple maps', mapLink.tw)])))) : _List_fromArray([A2(linkButton, 'Find it on the map', mapLink.ie)]);
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop3 marBottom3')]), _List_fromArray([A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$ElmFramework$Lib$Util$noOpEl, function (venuePhoto) {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight2')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
          t_: cfg.t_,
          uj: 'w13 h13',
          wG: _List_fromArray([{
            ij: 13,
            eZ: venuePhoto,
            lt: 13
          }]),
          Dq: 13,
          s5: 'relative block w13 h13 radius7 noOverflow'
        })]));
      }, venue.qq), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('noOverflow')]), _Utils_ap(_List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('left heading3Bold gray0 ellipsis')]), _List_fromArray([$elm$html$Html$text(venue.i5)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('left heading4Regular gray0 ellipsis')]), _List_fromArray([$elm$html$Html$text(venueAddress)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('left heading4Regular gray0 ellipsis')]), cfg.nX ? _List_fromArray([$elm$html$Html$text(cfg.m.xX.dM.hA)]) : _List_fromArray([$elm$html$Html$text('Court number will be available after joining')]))]), mapsButtons))]));
    }, cfg.m.Dh)]));
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padTop3 padBottom3 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0 inlineFlexCenter')]), _List_fromArray([A2($elm$html$Html$span, _List_Nil, _List_fromArray([$elm$html$Html$text(A2($author$project$Types$Activity$activityToMatchString, true, cfg.m.xX.du))])), cfg.ql])), locationInfo, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow fullWidth ')]), priceTag), questionsOrConcerns]));
  };
  var $author$project$IconSvg$new_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M18.0386 31.2913C18.5854 31.7601 19.2885 31.9944 19.9916 31.9944C20.6947 31.9944 21.3978 31.7601 21.9447 31.2802L23.708 29.7624C23.8865 29.6173 24.3329 29.4499 24.5673 29.4499H26.4645C28.1163 29.4499 29.4555 28.1107 29.4555 26.459V24.5617C29.4555 24.3274 29.6229 23.881 29.7791 23.7024L31.2969 21.9391C32.2344 20.8454 32.2344 19.1379 31.2969 18.0442L29.7791 16.2809C29.6229 16.1023 29.4555 15.6559 29.4555 15.4215V13.5243C29.4555 11.8726 28.1163 10.5334 26.4645 10.5334H24.5673C24.3329 10.5334 23.8865 10.3771 23.708 10.2209L21.9447 8.70309C20.851 7.76564 19.1435 7.76564 18.0498 8.70309L16.2864 10.2209C16.1079 10.366 15.6615 10.5334 15.4271 10.5334H13.4964C11.8447 10.5334 10.5055 11.8726 10.5055 13.5243V15.4439C10.5055 15.6782 10.3492 16.1135 10.193 16.292L8.68635 18.0665C7.77122 19.149 7.77122 20.8565 8.68635 21.9391L10.193 23.7136C10.3492 23.8921 10.5055 24.3274 10.5055 24.5617V26.4701C10.5055 28.1218 11.8447 29.4611 13.4964 29.4611H15.4159C15.6503 29.4611 16.0967 29.6173 16.2753 29.7735L18.0386 31.2913ZM12.1795 13.5243C12.1795 12.7989 12.771 12.2074 13.4964 12.2074H15.4271C16.0632 12.2074 16.8891 11.9061 17.3801 11.4931L19.1435 9.96419C19.601 9.57359 20.4046 9.57359 20.8621 9.96419L22.6254 11.482C23.1165 11.9061 23.9312 12.2074 24.5785 12.2074H26.4757C27.2011 12.2074 27.7926 12.7989 27.7926 13.5243V15.4104C27.7926 16.0577 28.0939 16.8724 28.518 17.3634L30.0358 19.1267C30.4264 19.5843 30.4264 20.3878 30.0358 20.8454L28.518 22.6087C28.0939 23.0997 27.7926 23.9144 27.7926 24.5617V26.459C27.7926 27.1844 27.2011 27.7759 26.4757 27.7759H24.5785C23.9312 27.7759 23.1165 28.0884 22.6254 28.5013L20.8621 30.0191C20.4046 30.4097 19.601 30.4097 19.1435 30.0191L17.3801 28.5013C16.8891 28.0772 16.0744 27.7759 15.4271 27.7759H13.4964C12.771 27.7759 12.1795 27.1844 12.1795 26.459V24.5506C12.1795 23.9144 11.8782 23.1109 11.4652 22.6199L9.95861 20.8454C9.56801 20.3878 9.56801 19.5954 9.95861 19.1379L11.4652 17.3634C11.8782 16.8835 12.1795 16.0688 12.1795 15.4327V13.5243ZM19.9815 21.9555C19.524 21.9555 19.1445 21.5761 19.1445 21.1185V15.2594C19.1445 14.8018 19.524 14.4224 19.9815 14.4224C20.4391 14.4224 20.8186 14.8018 20.8186 15.2594V21.1185C20.8186 21.5761 20.4391 21.9555 19.9815 21.9555ZM19.9817 25.8617C19.6804 25.8617 19.4014 25.7501 19.1893 25.538C19.0889 25.4264 19.0108 25.3037 18.9439 25.1697C18.8881 25.0358 18.8657 24.8907 18.8657 24.7456C18.8657 24.4555 18.9885 24.1653 19.1893 23.9533C19.6023 23.5403 20.3612 23.5403 20.7741 23.9533C20.975 24.1653 21.0978 24.4555 21.0978 24.7456C21.0978 24.8907 21.0643 25.0358 21.0085 25.1697C20.9527 25.3037 20.8746 25.4264 20.7741 25.538C20.5621 25.7501 20.2831 25.8617 19.9817 25.8617Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$new = function (classes) {
    return $author$project$IconSvg$new_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $elm$core$String$toUpper = _String_toUpper;
  var $author$project$ElmFramework$Lib$Util$toCapital = function (str) {
    return _Utils_ap($elm$core$String$toUpper(A2($elm$core$String$left, 1, str)), A2($elm$core$String$dropLeft, 1, str));
  };
  var $author$project$Ui$Match$ViewBranch$matchView = function (cfg) {
    var state = cfg.aC;
    var matchDetails = cfg.m;
    var session = cfg.rG;
    var browser = cfg.t_;
    var toIndicator = function (label) {
      return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('whiteSpaceNoWrap padRight1 padLeft1 radius2 notesRegular secondary100Back marLeft1 ')]), _List_fromArray([$elm$html$Html$text(label)]));
    };
    var paymentStatusTag = function () {
      if (state.rf > 0) {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      } else {
        var _v11 = $author$project$Types$Match$participantsToPrivateParticipant(cfg.m.z8);
        if (!_v11.$) {
          var participantPrivate = _v11.a;
          var _v12 = participantPrivate.z7;
          switch (_v12.$) {
            case 0:
              return toIndicator('Failed');
            case 9:
              return toIndicator('Unpaid');
            case 2:
              return toIndicator('Pending');
            case 4:
              return toIndicator('Unpaid');
            case 8:
              return toIndicator('');
            case 6:
              return toIndicator('Processing');
            case 7:
              var maybeAction = _v12.a.yb;
              var maybeActionType = _v12.a.yc;
              var _v13 = _Utils_Tuple2(maybeAction, maybeActionType);
              if (!_v13.a.$ && !_v13.b.$) {
                var action = _v13.a.a;
                var actionType = _v13.b.a;
                return toIndicator('Requires action');
              } else {
                return $author$project$ElmFramework$Lib$Util$noOpEl;
              }
            default:
              return $author$project$ElmFramework$Lib$Util$noOpEl;
          }
        } else {
          return $author$project$ElmFramework$Lib$Util$noOpEl;
        }
      }
    }();
    var maybeJoiningForOthersNumber = $elm$core$List$length(cfg.m.xq) > 1 ? $elm$core$Maybe$Just($elm$core$List$length(cfg.m.xq) - 1) : $elm$core$Maybe$Nothing;
    var maybeCancelButton = function () {
      var cancelButtonView = $author$project$Ui$Button$button({
        bh: 'fullWidth ',
        fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexCenter ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w3 h3 marRight1 ')]), _List_fromArray([$author$project$IconSvg$close1('gray60Fill w3 ')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('heading5Bold gray60 ')]), _List_fromArray([$elm$html$Html$text('Cancel my slot')]))])),
        xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$routeTo($author$project$Route$Route$matchCancelRoute(cfg.m.xX.od)))
      });
      if ($author$project$Types$Match$hasThisUserJoined(cfg.m.z8)) {
        var _v10 = cfg.m.xX.Cd;
        switch (_v10.$) {
          case 0:
            return $elm$core$Maybe$Just(cancelButtonView);
          case 1:
            return $elm$core$Maybe$Just(cancelButtonView);
          case 2:
            return $elm$core$Maybe$Just(cancelButtonView);
          default:
            return $elm$core$Maybe$Nothing;
        }
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }();
    var actionBtnLink = F2(function (label, link) {
      return $author$project$Ui$Button$button({
        bh: 'fullWidth marLeft2 primary0Back ',
        fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray0 radius2 heading5Bold primary0 padTop1h padRight1 padLeft1 padBottom1h center ')]), _List_fromArray([$elm$html$Html$text(label)])),
        xu: $author$project$ElmFramework$Lib$Ui$Button$Link(link)
      });
    });
    var maybePaymentButton = function () {
      var payButton = $author$project$Ui$Button$basicButton({
        bh: ' fullWidth  ',
        cD: 0,
        fn: $elm$html$Html$text('Pay'),
        xa: false,
        xu: $author$project$ElmFramework$Lib$Ui$Button$Button(A2($author$project$TopMsg$routeToPayment, session, matchDetails.xX.od))
      });
      return A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, A2($elm$core$Maybe$map, function (participantPaymentStatus) {
        if (state.rf > 0) {
          return $elm$core$Maybe$Nothing;
        } else {
          switch (participantPaymentStatus.$) {
            case 0:
              return $elm$core$Maybe$Just(payButton);
            case 9:
              return $elm$core$Maybe$Just(payButton);
            case 2:
              return $elm$core$Maybe$Just(payButton);
            case 4:
              return $elm$core$Maybe$Just(payButton);
            case 8:
              return $elm$core$Maybe$Just(payButton);
            case 6:
              return $elm$core$Maybe$Nothing;
            case 7:
              var maybeAction = participantPaymentStatus.a.yb;
              var maybeActionType = participantPaymentStatus.a.yc;
              var _v9 = _Utils_Tuple2(maybeAction, maybeActionType);
              if (!_v9.a.$ && !_v9.b.$) {
                var action = _v9.a.a;
                var actionType = _v9.b.a;
                return $elm$core$Maybe$Just(A2(actionBtnLink, $author$project$ElmFramework$Lib$Util$toCapital(actionType), action));
              } else {
                return $elm$core$Maybe$Nothing;
              }
            default:
              return $elm$core$Maybe$Nothing;
          }
        }
      }, $author$project$Types$Match$toParticipantPaymentStatus(matchDetails)));
    }();
    var _v0 = function () {
      var pendingParticipantsEl = function () {
        var playersLookingToJoinEl = function (count) {
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' pad2 radius7 secondary800Back marTop3 bodyRegular gray80 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' primary80 marBottom1 heading3Bold ')]), _List_fromArray([$elm$html$Html$text('Queue')])), $elm$html$Html$text($elm$core$String$fromInt(count) + ' other players are looking to join this match. Join soon to reserve your spot.')]));
        };
        return A2($author$project$Types$UserSession$isThisAvailableSuggestedMatch, session, matchDetails) ? playersLookingToJoinEl(cfg.m.Cp) : cfg.m.Ai > 0 ? playersLookingToJoinEl(cfg.m.Ai) : $author$project$ElmFramework$Lib$Util$noOpEl;
      }();
      var joiningForOthersEl = A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, function (joiningForOthersNumber) {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' center bodyRegular gray80 marTop3 ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w4 h4 marBottom1')]), _List_fromArray([$author$project$IconSvg$new(' w4 ')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' bodyBold ')]), _List_fromArray([$elm$html$Html$text('You’re joining the match on behalf of the other players as well. Keep in mind that the players you invited are also being committed to this match.')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' bodyBold marTop1 ')]), _List_fromArray([$elm$html$Html$text('Invited players will need to log into XRIVALS and complete payment to avoid cancellation.')]))]));
      }, maybeJoiningForOthersNumber));
      var joinForOthersSuffix = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Basics$append(' +'), $elm$core$String$fromInt), maybeJoiningForOthersNumber));
      var joinButtonView = $author$project$Ui$Button$basicButton({
        bh: ' fullWidth  ',
        cD: 0,
        fn: $elm$html$Html$text('Join' + joinForOthersSuffix),
        xa: false,
        xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$JoinMatch(cfg.m.xX.od)))
      });
      if ($author$project$Types$Match$hasThisUserJoined(cfg.m.z8)) {
        var _v1 = cfg.m.xX.Cd;
        if (_v1.$ === 3) {
          return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$ElmFramework$Lib$Util$noOpEl, $author$project$ElmFramework$Lib$Util$noOpEl);
        } else {
          return _Utils_Tuple3(maybePaymentButton, $author$project$ElmFramework$Lib$Util$noOpEl, $author$project$ElmFramework$Lib$Util$noOpEl);
        }
      } else {
        var _v2 = cfg.m.xX.Cd;
        switch (_v2.$) {
          case 0:
            var number = _v2.a;
            return _Utils_cmp(number, $author$project$Types$Activity$toNumberOfPlayers(cfg.m.xX.du)) < 0 ? _Utils_Tuple3($elm$core$Maybe$Just(joinButtonView), pendingParticipantsEl, joiningForOthersEl) : _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$ElmFramework$Lib$Util$noOpEl, $author$project$ElmFramework$Lib$Util$noOpEl);
          case 1:
            return _Utils_Tuple3($elm$core$Maybe$Just(joinButtonView), pendingParticipantsEl, joiningForOthersEl);
          case 2:
            return _Utils_Tuple3($elm$core$Maybe$Just(joinButtonView), pendingParticipantsEl, joiningForOthersEl);
          default:
            return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$ElmFramework$Lib$Util$noOpEl, $author$project$ElmFramework$Lib$Util$noOpEl);
        }
      }
    }();
    var maybeActionBtn = _v0.a;
    var pendingParticipantsElement = _v0.b;
    var joiningForOthersElement = _v0.c;
    var _v3 = $author$project$Types$Match$isCancelled(matchDetails.xX) ? _Utils_Tuple2(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading2Bold primary0 marBottom1 ')]), _List_fromArray([$elm$html$Html$text('This match has been cancelled')]))])), $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$InlineBelowContentBtn({
      xa: false,
      oR: 'Understood',
      p_: $author$project$ElmFramework$MsgCmd$msgCmd.Bl,
      r8: 0
    }))) : cfg.oE ? cfg.oI ? _Utils_Tuple2(A5($author$project$Ui$Match$ViewBranch$bodyWrapper, browser, session, matchDetails, state.rf, $elm$core$Maybe$Nothing), function () {
      if (!maybePaymentButton.$) {
        var paymentButton = maybePaymentButton.a;
        return $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$InlineBelowContentBtn({
          xa: false,
          oR: 'Pay',
          p_: A2($author$project$TopMsg$routeToPayment, session, matchDetails.xX.od),
          r8: 0
        }));
      } else {
        return $elm$core$Maybe$Nothing;
      }
    }()) : _Utils_Tuple2(A5($author$project$Ui$Match$ViewBranch$bodyWrapper, cfg.t_, cfg.rG, cfg.m, state.rf, $elm$core$Maybe$Just({
      uj: 'flex1 padBottom1 ',
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop1 flexColumn flexAlignCenter ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading3Bold primary0  fullWidth')]), _List_fromArray([$elm$html$Html$text('How competitive was your match?')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth marTop3  ')]), _List_fromArray([$author$project$Ui$PlayerLevelSlider$matchRateSlider({
        uj: 'fullWidth',
        bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgMatch, $author$project$Ui$Match$Msg$RatingSelected),
        s_: cfg.aC.AQ
      })]))])),
      wE: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$IconSvg$results, '')),
      lh: $elm$core$Maybe$Just('Rate the match')
    })), $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$InlineBelowContentBtn({
      xa: false,
      oR: 'Submit rating',
      p_: $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$SubmitMatchRating, cfg.aC.AQ, cfg.m.xX.od)),
      r8: 0
    }))) : _Utils_Tuple2(A5($author$project$Ui$Match$ViewBranch$bodyWrapper, cfg.t_, cfg.rG, cfg.m, state.rf, $elm$core$Maybe$Just({
      uj: 'flex1 padBottom1 ',
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop1 flexColumn flexAlignCenter ')]), _List_fromArray([$author$project$Ui$MatchmakingCards$cancellationPolicy({
        oD: cfg.aC.oB,
        pW: $author$project$TopMsg$msgMatch($author$project$Ui$Match$Msg$ExpandCancelllationPolicyMatchView)
      }), pendingParticipantsElement, joiningForOthersElement, function () {
        var _v5 = _Utils_Tuple2(maybeCancelButton, maybeActionBtn);
        if (_v5.a.$ === 1 && _v5.b.$ === 1) {
          var _v6 = _v5.a;
          var _v7 = _v5.b;
          return $author$project$ElmFramework$Lib$Util$noOpEl;
        } else {
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexAlignStretch marTop3h flexRow stretchContent fullWidth ')]), _List_fromArray([A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, maybeCancelButton), A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, maybeActionBtn)]));
        }
      }()])),
      wE: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$IconSvg$calendar, '')),
      lh: $elm$core$Maybe$Just('Date and time')
    })), $elm$core$Maybe$Nothing);
    var bodyContent = _v3.a;
    var bottomInteraction = _v3.b;
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: _List_fromArray([bodyContent]),
        l5: bottomInteraction,
        t_: cfg.t_,
        ww: _List_fromArray([$author$project$Ui$Match$ViewBranch$matchHeader({
          t_: cfg.t_,
          vS: cfg.vS,
          nX: $author$project$Types$Match$hasThisUserJoined(cfg.m.z8),
          m: cfg.m,
          ql: paymentStatusTag,
          rQ: true,
          DJ: cfg.DJ
        })]),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
        Ck: $elm$core$Maybe$Just(4),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Just($author$project$ElmFramework$MsgCmd$msgCmd.Bt($author$project$Route$Route$myPlayerStatusRoute)),
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  };
  var $author$project$Ui$Match$ViewBranch$viewBranch = function (cfg) {
    var matchId = cfg.br;
    var session = cfg.rG;
    var branchRoute = cfg.tY;
    var state = cfg.aC;
    var browser = cfg.t_;
    switch (branchRoute.$) {
      case 0:
        return _List_fromArray([function () {
          var _v1 = A2($author$project$Types$UserSession$findMatch, session, matchId);
          if (!_v1.$) {
            var matchDetails = _v1.a;
            return $author$project$Ui$Match$ViewBranch$matchView({
              t_: cfg.t_,
              vS: cfg.vS,
              oE: matchDetails.ua === 1,
              oI: !A2($author$project$Types$UserSession$isPendingRatingMatch, cfg.br, session),
              m: matchDetails,
              rG: session,
              aC: cfg.aC,
              CX: cfg.CX,
              DJ: cfg.DJ
            });
          } else {
            return $author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer;
          }
        }()]);
      case 2:
        return A2($elm$core$List$append, _List_fromArray([A3($author$project$Ui$Match$ViewBranch$cancelMatch, browser, matchId, state)]), A2($author$project$Ui$Match$ViewBranch$cancelMatchReasonsOverlayView, cfg.t_, cfg.aC));
      case 3:
        return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer]);
      default:
        var paymentMethodsRoute = branchRoute.a;
        if (!paymentMethodsRoute) {
          return _List_fromArray([$author$project$Ui$PaymentMethods$ViewBranch$browseView({
            t_: cfg.t_,
            pX: $elm$core$Maybe$Nothing,
            zG: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$TopMsg$msgMatch, $author$project$Ui$Match$Msg$PaymentMethodSelected)),
            qh: $author$project$Ui$PaymentMethods$Edit$Msg$PaymentMethodContextPayForMatch(cfg.br),
            qj: A2($elm$core$Maybe$withDefault, $krisajenkins$remotedata$RemoteData$NotAsked, A2($elm$core$Maybe$map, function ($) {
              return $.qj;
            }, $author$project$Types$UserSessionStatus$toSession(cfg.CX.lL.A$.sX))),
            BN: cfg.aC.qi,
            CX: cfg.CX
          })]);
        } else {
          return $author$project$Ui$PaymentMethods$Edit$ViewBranch$editPaymentMethodView({
            t_: cfg.t_,
            qh: $author$project$Ui$PaymentMethods$Edit$Msg$PaymentMethodContextPayForMatch(cfg.br),
            Ad: $elm$core$Maybe$Nothing,
            CX: cfg.CX
          });
        }
    }
  };
  var $author$project$Ui$ProvideLocation$Msg$LocationSelected = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$ProvideLocation$Msg$ProvideLocationCreateSearch = 1;
  var $author$project$Ui$CreateOrEditSearch$Msg$ActivityToggled = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$CreateOrEditSearch$Msg$AddDateSlot = {
    $: 5
  };
  var $author$project$Ui$Location$CreateEditMatchLocationContext = 1;
  var $author$project$Remote$RequestMsg$CreateSearch = F2(function (a, b) {
    return {
      $: 20,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$CreateOrEditSearch$Msg$DateSelected = F2(function (a, b) {
    return {
      $: 3,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$MatchmakingCards$InvitedPlayersContextCreateSearchPreview = {
    $: 1
  };
  var $author$project$Ui$CreateOrEditSearch$Msg$RadiusSet = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$CreateOrEditSearch$Msg$RemoveDateSlot = function (a) {
    return {
      $: 6,
      a: a
    };
  };
  var $author$project$Ui$CreateOrEditSearch$Msg$TimeRangeSet = F2(function (a, b) {
    return {
      $: 4,
      a: a,
      b: b
    };
  });
  var $author$project$Remote$RequestMsg$UpdateSearch = F2(function (a, b) {
    return {
      $: 21,
      a: a,
      b: b
    };
  });
  var $justinmimbs$date$Date$day = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toCalendarDate, function ($) {
    return $.mO;
  });
  var $justinmimbs$date$Date$month = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toCalendarDate, function ($) {
    return $.pt;
  });
  var $author$project$Types$SimpleDate$fromDate = function (date) {
    return {
      mO: $justinmimbs$date$Date$day(date),
      pt: $justinmimbs$date$Date$month(date),
      ta: $justinmimbs$date$Date$year(date)
    };
  };
  var $author$project$Types$Search$numberOfEmptySlots = function (list) {
    return $elm$core$List$length(A2($elm$core$List$filter, $elm$core$Basics$eq($author$project$Types$Search$EmptySlot), list));
  };
  var $author$project$Types$Search$isEmptyInvitedPlayers = F2(function (list, activity) {
    return _Utils_eq($author$project$Types$Search$numberOfEmptySlots(list) + 1, $author$project$Types$Activity$toNumberOfPlayers(activity));
  });
  var $author$project$ElmFramework$Lib$Util$conditionalEl = F2(function (element, shouldAdd) {
    return shouldAdd ? element : $author$project$ElmFramework$Lib$Util$noOpEl;
  });
  var $author$project$UiWrappers$HeaderAndBodyView$titledSection = F3(function (title, maybeSubTitle, content) {
    var subTitle = function () {
      if (!maybeSubTitle.$) {
        var subtitle = maybeSubTitle.a;
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bodyRegular primary60 marBottom2 ')]), _List_fromArray([$elm$html$Html$text(subtitle)]));
      } else {
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
    }();
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom4 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading3Bold primary0 marBottom2 ')]), _List_fromArray([$elm$html$Html$text(title)])), subTitle, content]));
  });
  var $author$project$Ui$Location$locationSection = function (cfg) {
    var onTapEmptyLocation = function () {
      var editAddress = $author$project$TopMsg$routeTo(cfg.vR);
      var askGpsPermissionsOnFirstTap = function () {
        var _v2 = cfg.xN;
        if (!_v2) {
          return true;
        } else {
          return false;
        }
      }();
      var _v1 = cfg.wm;
      if (!_v1.$) {
        return askGpsPermissionsOnFirstTap ? $author$project$ElmFramework$MsgCmd$msgCmd.xM : editAddress;
      } else {
        return editAddress;
      }
    }();
    var distanceSliderOrEmpty = A2($author$project$ElmFramework$Lib$Util$conditionalEl, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop2 ')]), _List_fromArray([A3($author$project$UiWrappers$HeaderAndBodyView$titledSection, 'Maximum distance from location', $elm$core$Maybe$Nothing, $author$project$Ui$DistanceSlider$distanceSlider({
      uj: '',
      x4: 50,
      yp: 5,
      bu: cfg.zH,
      s_: cfg.gj
    }))])), cfg.xN === 1);
    return A2($elm$core$Maybe$withDefault, $author$project$Ui$Button$button({
      bh: ' secondary800Back radius7 fullWidth ',
      fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' pad1 flexRow flexAlignCenter ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' w4 h4 marRight2 ')]), _List_fromArray([$author$project$IconSvg$gps('w4 gray80Fill ')])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' heading5Regular gray60 padTop0h padBottom0h ')]), _List_fromArray([$elm$html$Html$text('Area around you')]))])),
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(onTapEmptyLocation)
    }), A2($elm$core$Maybe$map, function (_v0) {
      var geolocation = _v0.a;
      var title = _v0.b.lh;
      var subtitle = _v0.b.lb;
      return A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$LocationCard$userLocation({
        uj: ' ',
        mr: cfg.y4,
        p_: $author$project$ElmFramework$MsgCmd$msgCmd.Bt(cfg.vR),
        lb: subtitle,
        lh: title
      }), distanceSliderOrEmpty]));
    }, cfg.yf));
  };
  var $author$project$Types$CreateOrEditSearchParams$toSearchParams = function (editing) {
    return A2($elm_community$result_extra$Result$Extra$andMap, $elm$core$Result$Ok($elm$core$Basics$round(editing.gj)), A2($elm_community$result_extra$Result$Extra$andMap, A2($elm$core$Result$map, $elm$core$Tuple$second, A2($elm$core$Result$fromMaybe, 'Please select location', editing.iT)), A2($elm_community$result_extra$Result$Extra$andMap, A2($elm$core$Result$map, $elm$core$Tuple$first, A2($elm$core$Result$fromMaybe, 'Please select location', editing.iT)), A2($elm_community$result_extra$Result$Extra$andMap, function (list) {
      return $elm$core$List$isEmpty(list) ? $elm$core$Result$Err('Please select a date and time') : $elm$core$Result$Ok(list);
    }(A2($elm$core$List$map, $elm$core$Tuple$second, $elm_community$maybe_extra$Maybe$Extra$values(editing.tF))), A2($elm_community$result_extra$Result$Extra$andMap, A2($elm$core$Result$fromMaybe, 'Please select a sport', editing.du), $elm$core$Result$Ok($author$project$Types$Search$SearchParams(editing.ox)))))));
  };
  var $author$project$Types$SimpleDate$SimpleDate = F3(function (year, month, day) {
    return {
      mO: day,
      pt: month,
      ta: year
    };
  });
  var $author$project$Types$SimpleDate$fromPosix = F2(function (zone, posix) {
    var _v0 = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, posix);
    var year = _v0.ta;
    var month = _v0.pt;
    var day = _v0.mO;
    return A3($author$project$Types$SimpleDate$SimpleDate, year, month, day);
  });
  var $author$project$Types$SimpleDate$toPosix = F2(function (zone, _v0) {
    var year = _v0.ta;
    var month = _v0.pt;
    var day = _v0.mO;
    return A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, A7($justinmimbs$time_extra$Time$Extra$Parts, year, month, day, 0, 0, 0, 0));
  });
  var $author$project$Types$SimpleDate$toMillis = A2($elm$core$Basics$composeR, $author$project$Types$SimpleDate$toPosix($elm$time$Time$utc), $elm$time$Time$posixToMillis);
  var $author$project$Types$SimpleDate$isLaterOrEqualWith = F2(function (date1, date2) {
    return _Utils_cmp($author$project$Types$SimpleDate$toMillis(date2), $author$project$Types$SimpleDate$toMillis(date1)) > -1;
  });
  var $author$project$Types$LocalDateTime$toSimpleDate = function (_v0) {
    var year = _v0.ta;
    var month = _v0.pt;
    var day = _v0.mO;
    return {
      mO: day,
      pt: $justinmimbs$date$Date$numberToMonth(month),
      ta: year
    };
  };
  var $author$project$Ui$CreateOrEditSearch$Util$isLaterOrEqualWithTime = F3(function (zone, time, localDateTime) {
    return A3($elm$core$Basics$apL, $author$project$Types$SimpleDate$isLaterOrEqualWith, A2($author$project$Types$SimpleDate$fromPosix, zone, time), $author$project$Types$LocalDateTime$toSimpleDate(localDateTime));
  });
  var $author$project$Ui$CreateOrEditSearch$Util$localDateTimeToDate = function (localDateTime) {
    return A3($justinmimbs$date$Date$fromCalendarDate, localDateTime.ta, $justinmimbs$date$Date$numberToMonth(localDateTime.pt), localDateTime.mO);
  };
  var $author$project$Ui$CreateOrEditSearch$Util$hoursAndMinutesToMillis = function (_v0) {
    var hour = _v0.wC;
    var minute = _v0.yu;
    return hour * 60 * 60 * 1000 + minute * 60 * 1000;
  };
  var $author$project$Ui$CreateOrEditSearch$Util$toDayOffset = F5(function (zone, time, max, minRange, offset) {
    var shouldAddDay = _Utils_cmp($author$project$Ui$CreateOrEditSearch$Util$hoursAndMinutesToMillis(offset) + $elm$time$Time$posixToMillis(time), $elm$time$Time$posixToMillis(A2($author$project$Types$LocalDateTime$toPosix, zone, max)) - $author$project$Ui$CreateOrEditSearch$Util$hoursAndMinutesToMillis(minRange)) > 0;
    return A3($author$project$ElmFramework$Lib$Util$ifElse, 1, 0, shouldAddDay);
  });
  var $justinmimbs$date$Date$Day = 11;
  var $justinmimbs$date$Date$Weeks = 2;
  var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
    var rd = _v0;
    var _v1 = A2($elm$core$Basics$modBy, 7, rd);
    if (!_v1) {
      return 7;
    } else {
      var n = _v1;
      return n;
    }
  };
  var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(function (wd, date) {
    return A2($elm$core$Basics$modBy, 7, $justinmimbs$date$Date$weekdayNumber(date) + 7 - $justinmimbs$date$Date$weekdayToNumber(wd));
  });
  var $justinmimbs$date$Date$firstOfMonth = F2(function (y, m) {
    return $justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m) + 1;
  });
  var $justinmimbs$date$Date$firstOfYear = function (y) {
    return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
  };
  var $justinmimbs$date$Date$monthToQuarter = function (m) {
    return ($justinmimbs$date$Date$monthToNumber(m) + 2) / 3 | 0;
  };
  var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
  var $justinmimbs$date$Date$quarterToMonth = function (q) {
    return $justinmimbs$date$Date$numberToMonth(q * 3 - 2);
  };
  var $justinmimbs$date$Date$floor = F2(function (interval, date) {
    var rd = date;
    switch (interval) {
      case 0:
        return $justinmimbs$date$Date$firstOfYear($justinmimbs$date$Date$year(date));
      case 1:
        return A2($justinmimbs$date$Date$firstOfMonth, $justinmimbs$date$Date$year(date), $justinmimbs$date$Date$quarterToMonth($justinmimbs$date$Date$quarter(date)));
      case 2:
        return A2($justinmimbs$date$Date$firstOfMonth, $justinmimbs$date$Date$year(date), $justinmimbs$date$Date$month(date));
      case 3:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
      case 4:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
      case 5:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
      case 6:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
      case 7:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
      case 8:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
      case 9:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
      case 10:
        return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
      default:
        return date;
    }
  });
  var $justinmimbs$date$Date$Years = 0;
  var $justinmimbs$date$Date$intervalToUnits = function (interval) {
    switch (interval) {
      case 0:
        return _Utils_Tuple2(1, 0);
      case 1:
        return _Utils_Tuple2(3, 1);
      case 2:
        return _Utils_Tuple2(1, 1);
      case 11:
        return _Utils_Tuple2(1, 3);
      default:
        var week = interval;
        return _Utils_Tuple2(1, 2);
    }
  };
  var $justinmimbs$date$Date$ceiling = F2(function (interval, date) {
    var floored = A2($justinmimbs$date$Date$floor, interval, date);
    if (_Utils_eq(date, floored)) {
      return date;
    } else {
      var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
      var n = _v0.a;
      var unit = _v0.b;
      return A3($justinmimbs$date$Date$add, unit, n, floored);
    }
  });
  var $justinmimbs$date$Date$rangeHelp = F5(function (unit, step, until, revList, current) {
    rangeHelp: while (true) {
      if (_Utils_cmp(current, until) < 0) {
        var _v0 = A3($justinmimbs$date$Date$add, unit, step, current);
        var next = _v0;
        var $temp$unit = unit,
          $temp$step = step,
          $temp$until = until,
          $temp$revList = A2($elm$core$List$cons, current, revList),
          $temp$current = next;
        unit = $temp$unit;
        step = $temp$step;
        until = $temp$until;
        revList = $temp$revList;
        current = $temp$current;
        continue rangeHelp;
      } else {
        return $elm$core$List$reverse(revList);
      }
    }
  });
  var $justinmimbs$date$Date$range = F4(function (interval, step, _v0, _v1) {
    var start = _v0;
    var until = _v1;
    var _v2 = $justinmimbs$date$Date$intervalToUnits(interval);
    var n = _v2.a;
    var unit = _v2.b;
    var _v3 = A2($justinmimbs$date$Date$ceiling, interval, start);
    var first = _v3;
    return _Utils_cmp(first, until) < 0 ? A5($justinmimbs$date$Date$rangeHelp, unit, A2($elm$core$Basics$max, 1, step) * n, until, _List_Nil, first) : _List_Nil;
  });
  var $author$project$Ui$CreateOrEditSearch$Util$toDefaultDates = F3(function (zone, time, dayOffset) {
    return function (date) {
      return function (dateWeekLater) {
        return A4($justinmimbs$date$Date$range, 11, 1, date, dateWeekLater);
      }(A3($justinmimbs$date$Date$add, 2, 2, date));
    }(A3($elm$core$Basics$apR, !dayOffset, A2($author$project$ElmFramework$Lib$Util$ifElse, $elm$core$Basics$identity, A2($justinmimbs$date$Date$add, 3, dayOffset)), A2($justinmimbs$date$Date$fromPosix, zone, time)));
  });
  var $elm_community$maybe_extra$Maybe$Extra$unpack = F3(function (_default, f, m) {
    if (m.$ === 1) {
      return _default(0);
    } else {
      var a = m.a;
      return f(a);
    }
  });
  var $author$project$Ui$CreateOrEditSearch$Util$toTimeRangeSliderDates = function (cfg) {
    var dayOffset = function (maxDate) {
      return A4($author$project$Ui$CreateOrEditSearch$Util$toDayOffset, cfg.DJ, cfg.b7, cfg.CH(maxDate), cfg.yq);
    };
    return A3($elm_community$maybe_extra$Maybe$Extra$unpack, $elm$core$Basics$always(A3($author$project$Ui$CreateOrEditSearch$Util$toDefaultDates, cfg.DJ, cfg.b7, A2(dayOffset, A2($author$project$Types$LocalDateTime$fromPosix, cfg.DJ, cfg.b7), cfg.jf))), function (selectedDate) {
      return A2($elm$core$List$take, 14, A3($author$project$ElmFramework$Lib$Util$flip, $elm$core$List$cons, A3($author$project$Ui$CreateOrEditSearch$Util$toDefaultDates, cfg.DJ, cfg.b7, A2(dayOffset, selectedDate, cfg.jf)), $author$project$Ui$CreateOrEditSearch$Util$localDateTimeToDate(selectedDate)));
    }, A2($elm_community$maybe_extra$Maybe$Extra$filter, A2($elm$core$Basics$composeL, $elm$core$Basics$not, A2($author$project$Ui$CreateOrEditSearch$Util$isLaterOrEqualWithTime, cfg.DJ, cfg.b7)), cfg.yi));
  };
  var $author$project$Ui$CreateOrEditSearch$Util$addOffsetToPosix = F2(function (offset, time) {
    return $elm$time$Time$millisToPosix($elm$time$Time$posixToMillis(time) + $author$project$Ui$CreateOrEditSearch$Util$hoursAndMinutesToMillis(offset));
  });
  var $author$project$Ui$CreateOrEditSearch$Util$hoursAndMinutesToMinuteValue = function (_v0) {
    var hour = _v0.wC;
    var minute = _v0.yu;
    return hour * 60 + minute;
  };
  var $author$project$Ui$CreateOrEditSearch$Util$isValidStepValue = F2(function (stepMinutes, timeMinutes) {
    return !A2($elm$core$Basics$modBy, stepMinutes, timeMinutes);
  });
  var $author$project$Ui$CreateOrEditSearch$Util$localDateTimeToHoursAndMinutes = function (_v0) {
    var hour = _v0.wC;
    var minute = _v0.yu;
    return {
      wC: hour,
      yu: minute
    };
  };
  var $author$project$Ui$CreateOrEditSearch$Util$minuteValueToHoursAndMinutes = function (minutes) {
    return {
      wC: minutes / 60 | 0,
      yu: A2($elm$core$Basics$modBy, 60, minutes)
    };
  };
  var $author$project$Ui$CreateOrEditSearch$Util$toNextValidStepValue = F2(function (stepMinutes, timeMinutes) {
    return stepMinutes * ((timeMinutes / stepMinutes | 0) + 1);
  });
  var $author$project$Ui$CreateOrEditSearch$Util$updateLocalDateTimeWithHoursAndMinutes = F2(function (localDateTime, _v0) {
    var hour = _v0.wC;
    var minute = _v0.yu;
    return _Utils_update(localDateTime, {
      wC: hour,
      yu: minute
    });
  });
  var $author$project$Ui$CreateOrEditSearch$Util$toStepCorrection = F2(function (step, localDateTime) {
    return function (_v0) {
      var stepMinutes = _v0.a;
      var localMinutes = _v0.b;
      return A2($author$project$Ui$CreateOrEditSearch$Util$isValidStepValue, stepMinutes, localMinutes) ? localDateTime : A2($author$project$Ui$CreateOrEditSearch$Util$updateLocalDateTimeWithHoursAndMinutes, localDateTime, $author$project$Ui$CreateOrEditSearch$Util$minuteValueToHoursAndMinutes(A2($author$project$Ui$CreateOrEditSearch$Util$toNextValidStepValue, stepMinutes, localMinutes)));
    }(_Utils_Tuple2($author$project$Ui$CreateOrEditSearch$Util$hoursAndMinutesToMinuteValue(step), $author$project$Ui$CreateOrEditSearch$Util$hoursAndMinutesToMinuteValue($author$project$Ui$CreateOrEditSearch$Util$localDateTimeToHoursAndMinutes(localDateTime))));
  });
  var $author$project$Ui$CreateOrEditSearch$Util$toTimeRangeSliderMin = function (cfg) {
    var isToday = function (localDateTime) {
      return _Utils_eq($author$project$Types$LocalDateTime$toSimpleDate(localDateTime), A2($author$project$Types$SimpleDate$fromPosix, cfg.DJ, cfg.b7));
    };
    if (isToday(cfg.BO)) {
      var withOffset = A2($author$project$Ui$CreateOrEditSearch$Util$addOffsetToPosix, cfg.jf, cfg.b7);
      var _v0 = _Utils_Tuple2($elm$time$Time$posixToMillis(A2($author$project$Types$LocalDateTime$toPosix, cfg.DJ, cfg.hI)), $elm$time$Time$posixToMillis(A2($author$project$Types$LocalDateTime$toPosix, cfg.DJ, cfg.ay)) - $author$project$Ui$CreateOrEditSearch$Util$hoursAndMinutesToMillis(cfg.yq));
      var defaultMinMillis = _v0.a;
      var limitMillis = _v0.b;
      var beforeMinOrOverLimit = function (x) {
        return _Utils_cmp(x, defaultMinMillis) < 0 || _Utils_cmp(x, limitMillis) > 0;
      }($elm$time$Time$posixToMillis(withOffset));
      return beforeMinOrOverLimit ? cfg.hI : A2($author$project$Ui$CreateOrEditSearch$Util$toStepCorrection, cfg.a6, A2($author$project$Types$LocalDateTime$fromPosix, cfg.DJ, withOffset));
    } else {
      return cfg.hI;
    }
  };
  var $author$project$Types$UserProfile$toUserProfileLimited = function (_v0) {
    var firstName = _v0.nF;
    var lastName = _v0.oU;
    var gender = _v0.nM;
    var photoUrl = _v0.qq;
    return {
      nF: firstName,
      nM: gender,
      fT: lastName,
      qq: photoUrl
    };
  };
  var $author$project$IconSvg$trash_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M16.6038 10.1164L16.6037 10.1165L16.3782 11.4596C17.1108 11.4371 17.8434 11.4258 18.576 11.4258C20.1268 11.4258 21.6792 11.4561 23.2313 11.5161L22.9966 10.1291L22.9959 10.1247C22.8972 9.51966 22.8303 9.25201 22.6806 9.07955C22.5744 8.9571 22.296 8.75 21.3721 8.75H18.2281C17.293 8.75 17.0208 8.95038 16.9202 9.06456C16.7758 9.22825 16.7099 9.48639 16.6038 10.1162V10.1164ZM14.8605 11.4398C14.8558 11.4677 14.8527 11.4955 14.8512 11.5231C13.692 11.5836 12.5329 11.6724 11.3738 11.7895L11.3727 11.7896L8.92688 12.0294C8.51464 12.0698 8.21322 12.4367 8.25363 12.849C8.29405 13.2612 8.661 13.5626 9.07323 13.5222L11.5212 13.2822L11.5234 13.282C13.8745 13.0445 16.2253 12.9258 18.576 12.9258C22.5586 12.9258 26.5539 13.1285 30.5259 13.5221C30.9381 13.563 31.3054 13.2619 31.3463 12.8497C31.3871 12.4375 31.0861 12.0703 30.6739 12.0294C28.7038 11.8342 26.7277 11.6853 24.75 11.5843C24.7512 11.5365 24.7479 11.4878 24.7396 11.4388L24.4763 9.8833L24.476 9.88108L24.4657 9.81788C24.3856 9.32171 24.2733 8.62625 23.8136 8.09644C23.2898 7.4929 22.4763 7.25 21.3721 7.25H18.2281C17.1352 7.25 16.3214 7.47562 15.7951 8.07244C15.3367 8.59233 15.2216 9.28417 15.1376 9.78925L15.1246 9.86742L15.1245 9.86777L14.8605 11.4398ZM28.769 16.6162C28.7956 16.2028 28.4822 15.8461 28.0688 15.8194C27.6555 15.7927 27.2987 16.1062 27.2721 16.5196L26.4923 28.5994L26.4922 28.6014C26.4585 29.0827 26.4293 29.4762 26.3598 29.8216C26.2917 30.1598 26.1941 30.3978 26.0577 30.5754C25.8119 30.8955 25.251 31.2498 23.6525 31.2498H15.9486C14.3502 31.2498 13.7892 30.8955 13.5434 30.5754C13.407 30.3978 13.3095 30.1598 13.2414 29.8216C13.1718 29.4762 13.1427 29.0827 13.1089 28.6014L13.1088 28.5994L12.3291 16.5196C12.3024 16.1062 11.9457 15.7927 11.5323 15.8194C11.119 15.8461 10.8055 16.2028 10.8322 16.6162L11.6122 28.7001L11.6124 28.7042L11.6137 28.7226C11.6456 29.1772 11.6798 29.6654 11.7709 30.1178C11.8648 30.584 12.0282 31.0652 12.3538 31.4891C13.032 32.3721 14.199 32.7498 15.9486 32.7498H23.6525C25.4021 32.7498 26.5691 32.3721 27.2473 31.4891C27.5729 31.0652 27.7364 30.584 27.8303 30.1178C27.9214 29.6654 27.9556 29.1772 27.9874 28.7226L27.9887 28.7042L27.989 28.7001L28.769 16.6162ZM17.046 25.3999C17.046 24.9857 17.3817 24.6499 17.796 24.6499H21.7919C22.2061 24.6499 22.5419 24.9857 22.5419 25.3999C22.5419 25.8141 22.2061 26.1499 21.7919 26.1499H17.796C17.3817 26.1499 17.046 25.8141 17.046 25.3999ZM16.7999 19.8501C16.3856 19.8501 16.0499 20.1859 16.0499 20.6001C16.0499 21.0143 16.3856 21.3501 16.7999 21.3501H22.7998C23.214 21.3501 23.5498 21.0143 23.5498 20.6001C23.5498 20.1859 23.214 19.8501 22.7998 19.8501H16.7999Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$trash = function (classes) {
    return $author$project$IconSvg$trash_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Ui$CreateOrEditSearch$View$view = function (_v0) {
    var topState = _v0.CX;
    var createOrEdit = _v0.uT;
    var browser = _v0.t_;
    var session = _v0.rG;
    var toCalendarCard = F4(function (maybeSelectedDate, classes, index, dateRangeItem) {
      var weekday = A2($elm$core$Maybe$withDefault, '', A3($author$project$ElmFramework$Lib$Util$flip, $elm_community$list_extra$List$Extra$getAt, _List_fromArray(['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']), -1 + $justinmimbs$date$Date$weekdayNumber(dateRangeItem)));
      var day = A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt($justinmimbs$date$Date$day(dateRangeItem)));
      return $author$project$Ui$SelectItem$selectOptionCard({
        uj: classes,
        fn: A2($author$project$Ui$SelectItem$Calendar, day, weekday),
        xa: false,
        xj: _Utils_eq(A2($elm$core$Maybe$map, function ($) {
          return $.mO;
        }, maybeSelectedDate), $elm$core$Maybe$Just($justinmimbs$date$Date$day(dateRangeItem))),
        Cu: $author$project$TopMsg$msgSingleCreateOrEditSearch(A2($author$project$Ui$CreateOrEditSearch$Msg$DateSelected, index, $author$project$Types$SimpleDate$fromDate(dateRangeItem)))
      });
    });
    var isEmptyPaymentMethods = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function ($) {
      return $.qj;
    }, A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$map($turboMaCk$any_dict$Dict$Any$isEmpty), $krisajenkins$remotedata$RemoteData$withDefault(true))), $author$project$Types$UserSessionStatus$toSession(topState.lL.A$.sX)));
    var geolocationAndPermissions = topState.wm;
    var createOrEditSearch = topState.lL.x3.B2.mE;
    var datePickerAndRangeSlider = F2(function (index, maybeSelectedDate) {
      var toMax = function (selectedDate) {
        return A2($author$project$Types$LocalDateTime$addDay, 1, _Utils_update(selectedDate, {
          wC: 3,
          yu: 0
        }));
      };
      var toDefaultMin = function (selectedDate) {
        return _Utils_update(selectedDate, {
          wC: 6,
          yu: 0
        });
      };
      var minOffset = {
        wC: 6,
        yu: 0
      };
      var isNotFirstOption = index > 0;
      var _v5 = isNotFirstOption ? _Utils_Tuple2($author$project$Ui$Button$button({
        bh: '',
        fn: A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' w4 h4 ')]), _List_fromArray([$author$project$IconSvg$trash('w4 gray80Fill')])),
        xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$msgSingleCreateOrEditSearch($author$project$Ui$CreateOrEditSearch$Msg$RemoveDateSlot(index)))
      }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('hairlineHeight fullWidth  padLeft2 padRight2 marBottom3  ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' block fullHeight fullWidth secondary800Back')]), _List_Nil)]))) : _Utils_Tuple2($author$project$ElmFramework$Lib$Util$noOpEl, $author$project$ElmFramework$Lib$Util$noOpEl);
      var removeBtn = _v5.a;
      var topBorderEl = _v5.b;
      var header = $elm$core$List$length(createOrEditSearch.tF) > 1 ? _List_fromArray([topBorderEl, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween flexAlignCenter padLeft2 padRight2 padBottom1 ')]), _List_fromArray([A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold primary0 ')]), _List_fromArray([$elm$html$Html$text('Option ' + $elm$core$String$fromInt(index + 1))])), removeBtn]))]) : _List_Nil;
      var _v6 = _Utils_Tuple2({
        wC: 0,
        yu: 15
      }, {
        wC: 1,
        yu: 0
      });
      var step = _v6.a;
      var minRange = _v6.b;
      var dates = $author$project$Ui$CreateOrEditSearch$Util$toTimeRangeSliderDates({
        yi: A2($elm$core$Maybe$map, $elm$core$Tuple$first, maybeSelectedDate),
        yq: minRange,
        b7: topState.Cy,
        jf: minOffset,
        CH: toMax,
        DJ: topState.DJ
      });
      var toMin = function (selectedDate) {
        return $author$project$Ui$CreateOrEditSearch$Util$toTimeRangeSliderMin({
          hI: toDefaultMin(selectedDate),
          ay: toMax(selectedDate),
          yq: minRange,
          b7: topState.Cy,
          jf: minOffset,
          BO: selectedDate,
          a6: step,
          DJ: topState.DJ
        });
      };
      var selectTimeRangeSlider = F2(function (index_, _v7) {
        var selectedDate = _v7.a;
        var selectedDateInterval = _v7.b;
        return $author$project$Ui$TimeRangeSlider$timeRangeSlider({
          uj: '',
          hS: selectedDateInterval.CC,
          xa: false,
          ay: toMax(selectedDate),
          Q: toMin(selectedDate),
          yq: minRange,
          yV: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgSingleCreateOrEditSearch, $author$project$Ui$CreateOrEditSearch$Msg$TimeRangeSet(index_)),
          k7: selectedDateInterval.wh,
          a6: step
        });
      });
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn '), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('padTop3', isNotFirstOption)]))]), _Utils_ap(header, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('whiteSpaceNoWrap flexRow scrollTargetX noScrollbar padRight2 ')]), A2($elm$core$List$map, A3(toCalendarCard, A2($elm$core$Maybe$map, $elm$core$Tuple$first, maybeSelectedDate), 'marLeft2', index), dates)), A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$Util$noOpEl, A2($elm$core$Maybe$map, function (selectedDate) {
        return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('padRight2 padLeft2 padTop3')]), _List_fromArray([A2(selectTimeRangeSlider, index, selectedDate)]));
      }, maybeSelectedDate))])));
    });
    var datePickers = A2($elm$core$List$indexedMap, datePickerAndRangeSlider, createOrEditSearch.tF);
    var _v1 = function () {
      if (!createOrEdit.$) {
        var _v3 = function () {
          var _v4 = createOrEditSearch.du;
          if (_v4.$ === 1) {
            return _Utils_Tuple2($author$project$ElmFramework$Lib$Util$noOpEl, 'Add players (optional)');
          } else {
            var activity = _v4.a;
            return A2($author$project$Types$Search$isEmptyInvitedPlayers, createOrEditSearch.ox, activity) ? _Utils_Tuple2($author$project$ElmFramework$Lib$Util$noOpEl, 'Add players (optional)') : _Utils_Tuple2(A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$MatchmakingCards$searchPlayersRow({
              t_: browser,
              uj: 'marTop2 marBottom2 ',
              uO: $author$project$Ui$MatchmakingCards$InvitedPlayersContextCreateSearchPreview,
              uX: session.e_,
              uZ: $author$project$Types$UserProfile$toUserProfileLimited(session.Db),
              yj: $elm$core$Maybe$Just(session),
              BH: createOrEditSearch
            })])), 'Manage players');
          }
        }();
        var previewPlayers = _v3.a;
        var label = _v3.b;
        return _Utils_Tuple2(_List_fromArray([A3($author$project$UiWrappers$HeaderAndBodyView$titledSection, 'Players', $elm$core$Maybe$Just('Add other players you know you want to play with, and then we’ll match your entire group with compatible players for the remaining slots.'), A2($elm$html$Html$div, _List_Nil, _List_fromArray([previewPlayers, $author$project$Ui$OptionLargeSelect$iconBtnRow({
          uj: '',
          wE: $author$project$IconSvg$plus,
          oR: label,
          p_: $elm_community$maybe_extra$Maybe$Extra$isJust(createOrEditSearch.du) ? $author$project$TopMsg$routeTo($author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$AddPlayers($author$project$Ui$AddPlayers$Route$Main(createOrEdit)))) : A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Please select activity first', _List_Nil)
        })])))]), _List_fromArray([$author$project$Ui$Button$basicButton({
          bh: ' fullWidth marBottom3  ',
          cD: 0,
          fn: $elm$html$Html$text('Play!'),
          xa: false,
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button(A3($elm_community$result_extra$Result$Extra$unpack, function (error) {
            return A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil);
          }, function (searchParams) {
            return $author$project$TopMsg$requestMsg(A2($author$project$Remote$RequestMsg$CreateSearch, searchParams, isEmptyPaymentMethods));
          }, $author$project$Types$CreateOrEditSearchParams$toSearchParams(createOrEditSearch)))
        })]));
      } else {
        var searchId = createOrEdit.a;
        return _Utils_Tuple2(_List_Nil, _List_fromArray([$author$project$Ui$Button$basicButton({
          bh: ' fullWidth marBottom3  ',
          cD: 1,
          fn: $elm$html$Html$text('Cancel search'),
          xa: false,
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$routeTo($author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Searches($author$project$Ui$MyPlayerStatus$Searches$Route$Cancel(searchId)))))
        }), $author$project$Ui$Button$basicButton({
          bh: ' fullWidth marBottom3  ',
          cD: 0,
          fn: $elm$html$Html$text('Save changes'),
          xa: false,
          xu: $author$project$ElmFramework$Lib$Ui$Button$Button(A3($elm_community$result_extra$Result$Extra$unpack, function (error) {
            return A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, error, _List_Nil);
          }, A2($elm$core$Basics$composeL, $author$project$TopMsg$requestMsg, $author$project$Remote$RequestMsg$UpdateSearch(searchId)), $author$project$Types$CreateOrEditSearchParams$toSearchParams(createOrEditSearch)))
        })]));
      }
    }();
    var addPlayers = _v1.a;
    var bottomButtons = _v1.b;
    return A2($elm$html$Html$div, _List_Nil, _Utils_ap(_List_fromArray([_Utils_eq(createOrEdit, $author$project$Types$CreateOrEditSearch$Create) ? A3($author$project$UiWrappers$HeaderAndBodyView$titledSection, 'Sports', $elm$core$Maybe$Just('What sport would you like to play?'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom-2')]), _List_fromArray([A2($author$project$Ui$EditUserActivities$EditUserActivities$sportsActivitySelectFlexThreeItemsBar, true, A2($elm$core$List$map, function (activity) {
      return {
        zP: A2($elm$core$Basics$composeR, $author$project$Ui$CreateOrEditSearch$Msg$ActivityToggled, $author$project$TopMsg$msgSingleCreateOrEditSearch),
        BN: _Utils_eq(createOrEditSearch.du, $elm$core$Maybe$Just(activity)),
        dh: activity
      };
    }, $author$project$Types$Activity$current))]))) : $author$project$ElmFramework$Lib$Util$noOpEl, _Utils_eq(createOrEdit, $author$project$Types$CreateOrEditSearch$Create) ? A3($author$project$UiWrappers$HeaderAndBodyView$titledSection, 'Location', $elm$core$Maybe$Just('Play within how many kilometers of which location?'), $author$project$Ui$Location$locationSection({
      vR: $author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$ProvideLocation(1)),
      wm: geolocationAndPermissions,
      xN: 1,
      yf: createOrEditSearch.iT,
      y4: $elm$core$Maybe$Just($author$project$TopMsg$msgSingleCreateOrEditSearch($author$project$Ui$CreateOrEditSearch$Msg$LocationSet($elm$core$Maybe$Nothing))),
      zH: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgSingleCreateOrEditSearch, $author$project$Ui$CreateOrEditSearch$Msg$RadiusSet),
      gj: createOrEditSearch.gj
    })) : $author$project$ElmFramework$Lib$Util$noOpEl, A3($author$project$UiWrappers$HeaderAndBodyView$titledSection, 'Date & time', $elm$core$Maybe$Just('When are you available to play? Providing long availabilities will increase the likelihood of finding a match.'), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('noOverflow marLeft-2 marRight-2  ')]), datePickers)), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bodyRegular primary60  marBottom3 ')]), _List_fromArray([$elm$html$Html$text('Are you open to play other dates or times?')])), $author$project$Ui$Button$basicButton({
      bh: ' fullWidth marBottom4 marTop-1 ',
      cD: 1,
      fn: $elm$html$Html$text('Add an alternative date & time'),
      xa: false,
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$msgSingleCreateOrEditSearch($author$project$Ui$CreateOrEditSearch$Msg$AddDateSlot))
    })]), _Utils_ap(addPlayers, bottomButtons)));
  };
  var $author$project$Ui$Matchmaking$Single$ViewBranch$mainView = F4(function (browser, createOrEditSearch, topState, geolocationAndPermissions) {
    var isEmptySearches = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, true, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Maybe$withDefault(true), $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$isEmpty), function ($) {
      return $.BK;
    }), $author$project$Remote$Model$toSession(topState.lL.A$));
    var searchingLabel = isEmptySearches ? '' : 'Searching';
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$ImgOverlay(_List_fromArray([{
          ij: browser.ij,
          eZ: $author$project$AssetsImg$assets.v5,
          lt: browser.lt
        }])),
        tU: A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function (session) {
          return _List_fromArray([$author$project$Ui$CreateOrEditSearch$View$view({
            t_: browser,
            uT: $author$project$Types$CreateOrEditSearch$Create,
            rG: session,
            CX: topState
          })]);
        }, $author$project$Remote$Model$toSession(topState.lL.A$))),
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$NavBar),
        t_: browser,
        ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop6 marBottom4 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0 ')]), _List_fromArray([$elm$html$Html$text('Look for a Match')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray10 bodyRegular marTop1  ')]), _List_fromArray([$elm$html$Html$text('Select your preferences and we\'ll find players at your level.')]))]))]),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
        Ck: $elm$core$Maybe$Just(0),
        CT: $elm$core$Maybe$Nothing
      })
    });
  });
  var $author$project$Ui$AddPlayers$Msg$GoToConfiguration = {
    $: 10
  };
  var $author$project$Ui$AddPlayers$Msg$MeasureScrollCoordinates = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$Ui$AddPlayers$Msg$ScrollCoordinates = F2(function (scrollLeft, offsetWidth) {
    return {
      yM: offsetWidth,
      BG: scrollLeft
    };
  });
  var $author$project$Ui$AddPlayers$View$scrollCoordinates = A3($elm$json$Json$Decode$map2, $author$project$Ui$AddPlayers$Msg$ScrollCoordinates, A2($elm$json$Json$Decode$field, 'scrollLeft', $elm$json$Json$Decode$float), A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float));
  var $debois$elm_dom$DOM$target = function (decoder) {
    return A2($elm$json$Json$Decode$field, 'target', decoder);
  };
  var $author$project$Ui$AddPlayers$View$contactsAccessOverlayView = F2(function (browser, topState) {
    return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: function () {
        var state = topState.lL.tl.kG;
        var slide = function (config) {
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('scrollingSlide whiteSpaceNormal inlineBlock'), A2($elm$html$Html$Attributes$style, 'scroll-snap-align', 'start')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray80 heading4Regular marTop1 minH6 ')]), _List_fromArray([$elm$html$Html$text(config.lb)])), $author$project$ElmFramework$Lib$Ui$PatientBgImg$patientBgImgSmart({
            t_: browser,
            uj: '',
            wG: _List_fromArray([{
              ij: 8,
              eZ: config.aZ,
              lt: 8
            }]),
            Dq: 8,
            s5: ' relative block fullWidth specialAspectRatio radius2 noOverflow marTop3'
          })]));
        };
        var iosSlides = _List_fromArray([{
          aZ: $author$project$AssetsImg$assets.w3,
          lb: 'Go to your iphone settings and look for the privacy option in the settings.'
        }, {
          aZ: $author$project$AssetsImg$assets.w2,
          lb: 'Within the privacy settings you have to find contacts.'
        }, {
          aZ: $author$project$AssetsImg$assets.w4,
          lb: 'In contacts we will find Xrivals, we will give you access again.'
        }]);
        var env = topState.vS;
        var currentScrollRatio = state.BG / state.yM;
        var indicatorBar = function (listSlides) {
          var isActive = function (index) {
            return !(_Utils_cmp(index + 0.5, currentScrollRatio) < 0 || _Utils_cmp(index - 0.5, currentScrollRatio) > 0);
          };
          var indicator = F2(function (index, slide1) {
            return A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('circle w1 h1 marRight1 trans3 '), $elm$html$Html$Attributes$class(A3($author$project$ElmFramework$Lib$Util$ifElse, 'primary0Back ', 'gray10Back', isActive(index)))]), _List_Nil);
          });
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexCenter marTop2 ')]), A2($elm$core$List$indexedMap, indicator, listSlides));
        };
        var androidSlides = _List_fromArray([{
          aZ: $author$project$AssetsImg$assets.w$,
          lb: 'Open the Settings app on your phone. Scroll down and select Apps.'
        }, {
          aZ: $author$project$AssetsImg$assets.w_,
          lb: 'In the app settings you will have to look for the apps management menu.'
        }, {
          aZ: $author$project$AssetsImg$assets.w1,
          lb: 'Tap the app you’d like to manage, then tap Permissions.'
        }, {
          aZ: $author$project$AssetsImg$assets.w0,
          lb: 'Tap the permission you’d like to manage, in this case, tap Contacts.'
        }, {
          aZ: $author$project$AssetsImg$assets.wZ,
          lb: 'Finally, tap the icon to choose whether you’d like to allow or disallow the permission.'
        }]);
        var slidesList = env.fP || env.fQ ? iosSlides : env.fO || env.fM ? androidSlides : _Utils_ap(iosSlides, androidSlides);
        return $author$project$UiWrappers$BottomDrawerOverlayView$bottomDrawerOverlayView({
          l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$StickyBtn({
            xa: false,
            oR: 'Go to configuration',
            p_: $author$project$ElmFramework$MsgCmd$msgCmd.yw(_List_fromArray([$author$project$TopMsg$addPlayersMsg($author$project$Ui$AddPlayers$Msg$GoToConfiguration), $author$project$TopMsg$routeTo($author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$AddPlayers($author$project$Ui$AddPlayers$Route$Main($author$project$Types$CreateOrEditSearch$Create))))])),
            r8: 1
          })),
          t_: browser,
          fn: _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading2Bold primary0 ')]), _List_fromArray([$elm$html$Html$text('Contact access')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative marLeft-2 marRight-2 ')]), _List_fromArray([A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$TopMsg$addPlayersMsg, $author$project$Ui$AddPlayers$Msg$MeasureScrollCoordinates), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' overflow noScrollbar whiteSpaceNoWrap'), A2($elm$html$Html$Attributes$style, 'scroll-snap-type', 'x mandatory'), A2($elm$html$Html$Events$on, 'scroll', $debois$elm_dom$DOM$target($author$project$Ui$AddPlayers$View$scrollCoordinates))]), A2($elm$core$List$map, slide, slidesList)))])), indicatorBar(slidesList)]))]),
          pR: $author$project$TopMsg$routeBack
        });
      }()
    })]);
  });
  var $author$project$Ui$CreateOrEditSearch$Msg$AddExternalInvite = function (a) {
    return {
      $: 9,
      a: a
    };
  };
  var $author$project$Ui$CreateOrEditSearch$Msg$ClearInvitedPlayer = function (a) {
    return {
      $: 11,
      a: a
    };
  };
  var $author$project$Ui$AddPlayers$Msg$ClearScrollState = {
    $: 2
  };
  var $author$project$Ui$MatchmakingCards$InvitedPlayersContextCreateSearchManage = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$AddPlayers$Msg$OnInputSearch = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Ui$AddPlayers$Msg$OnRemoveSearch = {
    $: 4
  };
  var $author$project$Ui$AddPlayers$Msg$RequestContactsFromDevice = {
    $: 7
  };
  var $author$project$Ui$CreateOrEditSearch$Msg$ToggleXrivalsContact = F2(function (a, b) {
    return {
      $: 10,
      a: a,
      b: b
    };
  });
  var $author$project$Ui$AddPlayers$View$mainView = F3(function (browser, topState, activity) {
    var searchState = topState.lL.x3.B2;
    var maybeSession = $author$project$Remote$Model$toSession(topState.lL.A$);
    if (!maybeSession.$) {
      var session = maybeSession.a;
      return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
        Dl: function () {
          var state = topState.lL.tl;
          var isHybrid = topState.vS.xd;
          var contactsPermisssions = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, function ($) {
            return $.uI;
          }, $author$project$Remote$Model$toSession(topState.lL.A$)));
          var _v1 = function () {
            var wrapper = function (contentElement) {
              return A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading2Bold primary0 ')]), _List_fromArray([$elm$html$Html$text('Add from my friends')])), contentElement]));
            };
            var _v2 = _Utils_Tuple2(isHybrid, contactsPermisssions);
            if (!_v2.a) {
              return _Utils_Tuple2(_List_Nil, $elm$core$Maybe$Nothing);
            } else {
              if (_v2.b === 1) {
                var _v3 = _v2.b;
                return _Utils_Tuple2(A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, A2($krisajenkins$remotedata$RemoteData$map, function (xrivalsContactsList) {
                  var filteredContacts = A2($elm$core$List$filter, function (_v5) {
                    var profile = _v5.qI;
                    return A2($elm$core$String$contains, $elm$core$String$toLower(state.gr), $elm$core$String$toLower(profile.fT)) || A2($elm$core$String$contains, $elm$core$String$toLower(state.gr), $elm$core$String$toLower(profile.nF));
                  }, xrivalsContactsList);
                  var selectedButNotPartOfTheFiltered = A2($elm$core$List$filter, function (xContact) {
                    var userId = xContact.e_;
                    return A2($turboMaCk$any_set$Set$Any$member, userId, state.gx) && !A2($elm$core$List$member, xContact, filteredContacts);
                  }, xrivalsContactsList);
                  var xrivalsContacts = state.gr === '' ? xrivalsContactsList : _Utils_ap(filteredContacts, selectedButNotPartOfTheFiltered);
                  return _List_fromArray([wrapper(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop2 ')]), _List_fromArray([$author$project$Ui$Input$searchBar({
                    bh: ' ',
                    od: '',
                    wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
                    pR: $author$project$TopMsg$addPlayersMsg($author$project$Ui$AddPlayers$Msg$OnRemoveSearch),
                    bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$addPlayersMsg, $author$project$Ui$AddPlayers$Msg$OnInputSearch),
                    bv: 'Search',
                    ch: false,
                    Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
                    s_: state.gr
                  }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop2')]), A2($elm$core$List$indexedMap, F2(function (index, _v4) {
                    var userId = _v4.e_;
                    var profile = _v4.qI;
                    var contact = _v4.uG;
                    return $author$project$Ui$SelectItem$selectXrivalsContact({
                      uj: 'marBottom1 ',
                      nM: profile.nM,
                      om: profile.qq,
                      xf: false,
                      xj: A2($turboMaCk$any_set$Set$Any$member, userId, state.gx),
                      At: profile.nF + (' ' + profile.fT),
                      Cu: $author$project$ElmFramework$MsgCmd$msgCmd.yw(_List_fromArray([_Utils_cmp($author$project$Types$Search$numberOfEmptySlots(searchState.mE.ox), $author$project$Types$Activity$toNumberOfPlayers(activity)) < 0 ? $author$project$TopMsg$msgSingleCreateOrEditSearch(A2($author$project$Ui$CreateOrEditSearch$Msg$ToggleXrivalsContact, userId, profile)) : A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Match is full', _List_Nil)]))
                    });
                  }), xrivalsContacts))])))]);
                }, session.DC)), $elm$core$Maybe$Nothing);
              } else {
                return _Utils_Tuple2(_List_fromArray([wrapper(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading4Regular gray80 marTop1 ')]), _List_fromArray([$elm$html$Html$text('To quickly find your friends we need to have access to the contacts in your address book.')])))]), $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$StickyBtn({
                  xa: false,
                  oR: 'Show my contacts list',
                  p_: function () {
                    var showOverlay = $author$project$TopMsg$multiMsg(_List_fromArray([$author$project$TopMsg$routeTo($author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$AddPlayers($author$project$Ui$AddPlayers$Route$ContactsAccessOverlay))), $author$project$TopMsg$addPlayersMsg($author$project$Ui$AddPlayers$Msg$ClearScrollState)]));
                    switch (contactsPermisssions) {
                      case 2:
                        return showOverlay;
                      case 4:
                        return A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Contacts permissions are restricted on this device', _List_fromArray(['Please check parental controls']));
                      default:
                        return $author$project$TopMsg$addPlayersMsg($author$project$Ui$AddPlayers$Msg$RequestContactsFromDevice);
                    }
                  }(),
                  r8: 1
                })));
              }
            }
          }();
          var bodyBottomContent = _v1.a;
          var bottomInteraction = _v1.b;
          return $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
            l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
            tU: bodyBottomContent,
            l5: bottomInteraction,
            t_: browser,
            ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 marBottom3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0  ')]), _List_fromArray([$elm$html$Html$text('Invite a Friend')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bodyRegular gray10 marTop1 ')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text('Select an empty spot to add friends, spots left with the XRIVALS logo will be filled with other app users')])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$elm$html$Html$text('Friends will only be able to accept the invitation after you have completed the search.')]))])), $author$project$Ui$MatchmakingCards$searchPlayersRow({
              t_: browser,
              uj: 'marTop2 ',
              uO: $author$project$Ui$MatchmakingCards$InvitedPlayersContextCreateSearchManage({
                zv: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgSingleCreateOrEditSearch, $author$project$Ui$CreateOrEditSearch$Msg$ClearInvitedPlayer),
                zM: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgSingleCreateOrEditSearch, $author$project$Ui$CreateOrEditSearch$Msg$AddExternalInvite)
              }),
              uX: session.e_,
              uZ: $author$project$Types$UserProfile$toUserProfileLimited(session.Db),
              yj: maybeSession,
              BH: searchState.mE
            })]))]),
            xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
            Ck: $elm$core$Maybe$Nothing,
            CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
              xC: $elm$core$Maybe$Just($author$project$TopMsg$routeBack),
              yo: $elm$core$Maybe$Nothing,
              Bg: $elm$core$Maybe$Nothing
            }))
          });
        }()
      });
    } else {
      return $author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer;
    }
  });
  var $author$project$Ui$AddPlayers$View$view = F4(function (branchRoute, browser, topState, activity) {
    if (!branchRoute.$) {
      return _List_fromArray([A3($author$project$Ui$AddPlayers$View$mainView, browser, topState, activity)]);
    } else {
      return A2($elm$core$List$cons, A3($author$project$Ui$AddPlayers$View$mainView, browser, topState, activity), A2($author$project$Ui$AddPlayers$View$contactsAccessOverlayView, browser, topState));
    }
  });
  var $author$project$Ui$PaymentMethods$Edit$Msg$PaymentMethodContextCreateSearch = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$Matchmaking$Checkout$Msg$PaymentMethodSelected = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Ui$Matchmaking$Checkout$ViewBranch$msgSelf = A2($elm$core$Basics$composeL, $author$project$TopMsg$msgMatchmaking, $author$project$Ui$Matchmaking$Msg$CheckoutMsgReceived);
  var $author$project$Ui$Matchmaking$Checkout$Msg$ConditionsAccepted = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$Matchmaking$Checkout$Msg$ExpandCancellationPolicy = {
    $: 4
  };
  var $author$project$IconSvg$billingAddress_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M20.5 32C19.6146 32 18.7519 31.5535 18.1616 30.7721L17.0151 29.2651C16.7768 28.9526 16.4589 28.774 16.1184 28.7516C15.7778 28.7405 15.4373 28.8856 15.1649 29.1646L14.5178 28.5953L15.1422 29.1646C13.5076 30.8837 12.2476 30.7498 11.6459 30.5153C11.033 30.2809 10 29.5107 10 27.0326V14.4633C10 9.50698 11.453 8 16.2092 8H24.7908C29.547 8 31 9.50698 31 14.4633V27.0326C31 29.4995 29.967 30.2698 29.3541 30.5153C28.7524 30.7498 27.5038 30.8837 25.8578 29.1646C25.5854 28.8744 25.2562 28.7181 24.893 28.7516C24.5524 28.774 24.2232 28.9526 23.9849 29.2651L22.8384 30.7721C22.2481 31.5535 21.3854 32 20.5 32ZM16.0503 27.066H16.1978C17.0378 27.1107 17.8324 27.546 18.3659 28.2493L19.5124 29.7563C20.0686 30.4819 20.92 30.4819 21.4762 29.7563L22.6227 28.2493C23.1676 27.546 23.9508 27.1107 24.8022 27.066C25.6422 27.0214 26.4822 27.3674 27.0951 28.0149C27.9578 28.9191 28.5254 29.0307 28.7184 28.9526C28.9908 28.8409 29.2859 28.1935 29.2859 27.0326V14.4633C29.2859 10.4335 28.5708 9.67442 24.7795 9.67442H16.2092C12.4178 9.67442 11.7027 10.4335 11.7027 14.4633V27.0326C11.7027 28.2047 11.9978 28.8521 12.2703 28.9526C12.4632 29.0307 13.0308 28.9191 13.8935 28.0149C14.5065 27.4009 15.267 27.066 16.0503 27.066ZM25.0405 15.2551H15.9595C15.4941 15.2551 15.1081 14.8755 15.1081 14.4178C15.1081 13.9602 15.4941 13.5806 15.9595 13.5806H25.0405C25.5059 13.5806 25.8919 13.9602 25.8919 14.4178C25.8919 14.8755 25.5059 15.2551 25.0405 15.2551ZM17.0936 19.7209H23.9044C24.3698 19.7209 24.7558 19.3414 24.7558 18.8837C24.7558 18.426 24.3698 18.0465 23.9044 18.0465H17.0936C16.6282 18.0465 16.2423 18.426 16.2423 18.8837C16.2423 19.3414 16.6282 19.7209 17.0936 19.7209Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$billingAddress = function (classes) {
    return $author$project$IconSvg$billingAddress_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$creditCard_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M20.85 9.7H25C27.2764 9.7 29.2176 11.1351 29.9682 13.15H26H25.6479L25.399 13.399L24.399 14.399C24.067 14.7309 24.067 15.2691 24.399 15.601C24.7309 15.933 25.2691 15.933 25.601 15.601L26.3521 14.85H30.2979C30.2993 14.8998 30.3 14.9498 30.3 15V19.15H26C25.5306 19.15 25.15 19.5306 25.15 20C25.15 20.4694 25.5306 20.85 26 20.85H30.3V25C30.3 25.0502 30.2993 25.1002 30.2979 25.15H26.3521L25.601 24.399C25.2691 24.067 24.7309 24.067 24.399 24.399C24.067 24.7309 24.067 25.2691 24.399 25.601L25.399 26.601L25.6479 26.85H26H29.9682C29.2176 28.8649 27.2764 30.3 25 30.3H20.85V26C20.85 25.5306 20.4694 25.15 20 25.15C19.5306 25.15 19.15 25.5306 19.15 26V30.3H15C12.7236 30.3 10.7824 28.8649 10.0318 26.85H15H15.3521L15.601 26.601L16.601 25.601C16.933 25.2691 16.933 24.7309 16.601 24.399C16.2691 24.067 15.7309 24.067 15.399 24.399L14.6479 25.15H10C9.89583 25.15 9.79604 25.1687 9.70382 25.203C9.70128 25.1357 9.7 25.068 9.7 25V20.85H14C14.4694 20.85 14.85 20.4694 14.85 20C14.85 19.5306 14.4694 19.15 14 19.15H9.7V15C9.7 14.932 9.70128 14.8643 9.70382 14.797C9.79604 14.8313 9.89583 14.85 10 14.85H14.6479L15.399 15.601C15.7309 15.933 16.2691 15.933 16.601 15.601C16.933 15.2691 16.933 14.7309 16.601 14.399L15.601 13.399L15.3521 13.15H15H10.0318C10.7824 11.1351 12.7236 9.7 15 9.7H19.15V14C19.15 14.4694 19.5306 14.85 20 14.85C20.4694 14.85 20.85 14.4694 20.85 14V9.7ZM8 15C8 11.134 11.134 8 15 8H25C28.866 8 32 11.134 32 15V25C32 28.866 28.866 32 25 32H15C11.134 32 8 28.866 8 25V15ZM17.7 19C17.7 18.282 18.282 17.7 19 17.7H21C21.718 17.7 22.3 18.282 22.3 19V21C22.3 21.718 21.718 22.3 21 22.3H19C18.282 22.3 17.7 21.718 17.7 21V19ZM16 19C16 17.3431 17.3431 16 19 16H21C22.6569 16 24 17.3431 24 19V21C24 22.6569 22.6569 24 21 24H19C17.3431 24 16 22.6569 16 21V19Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$creditCard = function (classes) {
    return $author$project$IconSvg$creditCard_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Types$PaymentMethod$toStripeAddress = function (method) {
    var _v0 = method.Cj.vp;
    if (!_v0.$) {
      var savedPaymentMethodStripeCard = _v0.a;
      return savedPaymentMethodStripeCard.tR.cy;
    } else {
      var savedPaymentMethodStripeOther = _v0.a;
      return savedPaymentMethodStripeOther.tR.cy;
    }
  };
  var $author$project$Ui$Matchmaking$Checkout$ViewBranch$reviewView = F4(function (browser, state, _v0, paymentMethod) {
    var pricing = _v0.AA;
    var search = _v0.kH;
    var maybeStripeCard = $author$project$Types$PaymentMethod$toSavedPaymentMethodStripeCard(paymentMethod);
    var maybeStripeAddress = $author$project$Types$PaymentMethod$toStripeAddress(paymentMethod);
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: function () {
        var reviewRow = F2(function (classes, label) {
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular primary0 ' + classes)]), _List_fromArray([$elm$html$Html$text(label)]));
        });
        var matchTag = $author$project$Ui$Tags$tag({
          uj: '',
          cD: 2,
          av: $elm$core$Maybe$Nothing,
          wE: $elm$core$Maybe$Nothing,
          oR: A2($author$project$Types$Activity$activityToMatchString, true, search.p8.du),
          p_: $elm$core$Maybe$Nothing,
          B3: 0
        });
        var locationInfo = A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading3Bold primary0 marBottom1')]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(search.p8.Dr) + 'km around me')])), matchTag, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('whiteSpaceNoWrap scrollTargetX noScrollbar')]), A2($elm$core$List$map, function (availability) {
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop1 flexRow')]), _List_fromArray([$author$project$Ui$Match$ViewBranch$infoTag(_Utils_Tuple2($author$project$Types$LocalTimeInterval$toDateStringShort(availability), $author$project$IconSvg$calendar)), $author$project$ElmFramework$Lib$Util$spacer('marLeft1'), $author$project$Ui$Match$ViewBranch$infoTag(_Utils_Tuple2($author$project$Types$LocalTimeInterval$toTimeRangeString(availability), $author$project$IconSvg$clock))]));
        }, search.p8.tF))]));
        var horizontalLine = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('fullWidth hairLineHeight1 secondary800Back marTop2 marBottom2 ')]), _List_Nil);
        return $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
          l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
          tU: _List_fromArray([$author$project$UiWrappers$HeaderAndBodyView$multipleBodyContentMaybeTopbar(_List_fromArray([$elm$core$Maybe$Just({
            uj: '',
            fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom2')]), _List_fromArray([A2(reviewRow, '', A2($elm$core$Maybe$withDefault, 'Username', A2($elm$core$Maybe$map, function (stripeAddress) {
              return A2($elm$core$Maybe$withDefault, 'Username', stripeAddress.xJ);
            }, maybeStripeAddress))), horizontalLine, A2(reviewRow, '', A2($elm$core$Maybe$withDefault, 'Street name', A2($elm$core$Maybe$map, function (stripeAddress) {
              return A2($elm$core$Maybe$withDefault, 'Street name', stripeAddress.xK);
            }, maybeStripeAddress))), horizontalLine, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow')]), _List_fromArray([A2(reviewRow, 'marRight2 flex1', A2($elm$core$Maybe$withDefault, 'Country', A2($elm$core$Maybe$map, function (stripeAddress) {
              return A2($elm$core$Maybe$withDefault, 'Country', stripeAddress.xJ);
            }, maybeStripeAddress))), A2(reviewRow, 'flex1', A2($elm$core$Maybe$withDefault, 'City', A2($elm$core$Maybe$map, function (stripeAddress) {
              return A2($elm$core$Maybe$withDefault, 'City', stripeAddress.xJ);
            }, maybeStripeAddress)))]))])),
            gL: $elm$core$Maybe$Just({
              wE: _Utils_Tuple2($author$project$IconSvg$billingAddress, ''),
              Bg: $elm$core$Maybe$Just(_Utils_Tuple2('Edit', $author$project$TopMsg$routeTo($author$project$Route$Route$matchMakingSingleCheckoutSelectPaymentMethodRoute))),
              lh: 'Billing Address'
            })
          }), $elm$core$Maybe$Just({
            uj: '',
            fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom2')]), A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, function (stripeCard) {
              return _List_fromArray([A2(reviewRow, '', stripeCard.tZ), horizontalLine, A2(reviewRow, '', _Utils_ap(A2($elm$core$String$repeat, 3, '**** '), stripeCard.xw))]);
            }, maybeStripeCard)),
            gL: $elm$core$Maybe$Just({
              wE: _Utils_Tuple2($author$project$IconSvg$paymentMethod, ''),
              Bg: $elm$core$Maybe$Just(_Utils_Tuple2('Edit', $author$project$TopMsg$routeTo($author$project$Route$Route$matchMakingSingleCheckoutSelectPaymentMethodRoute))),
              lh: 'Payment'
            })
          }), $elm$core$Maybe$Just({
            uj: 'flex1',
            fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop1 marBottom2')]), _List_fromArray([locationInfo])),
            gL: $elm$core$Maybe$Just({
              wE: _Utils_Tuple2($author$project$IconSvg$location, ''),
              Bg: $elm$core$Maybe$Just(_Utils_Tuple2('Edit', $author$project$TopMsg$routeBack)),
              lh: 'Where'
            })
          }), $elm$core$Maybe$Just({
            uj: 'flex1 marBottom-5',
            fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop1')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow spaceBetween flexAlignCenter marBottom3')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('gray80 bodyRegular')]), _List_fromArray([$elm$html$Html$text('Total amount to be put on hold')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0 heading1Bold')]), _List_fromArray([$elm$html$Html$text($elm$core$String$fromInt(pricing.AP.CC))]))])), $author$project$Ui$MatchmakingCards$cancellationPolicy({
              oD: state.oz,
              pW: $author$project$Ui$Matchmaking$Checkout$ViewBranch$msgSelf($author$project$Ui$Matchmaking$Checkout$Msg$ExpandCancellationPolicy)
            }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flexAlignCenter marTop2')]), _List_fromArray([$author$project$Ui$CheckBox$checkBox({
              uj: 'marRight1',
              ux: 0,
              od: '',
              eh: state.mz,
              xi: true,
              Cu: $author$project$Ui$Matchmaking$Checkout$ViewBranch$msgSelf($author$project$Ui$Matchmaking$Checkout$Msg$ConditionsAccepted(!state.mz))
            }), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading5Regular primary0 marLeft1')]), _List_fromArray([$elm$html$Html$text('I accept Privacy Policy and Terms of use')]))]))])),
            gL: $elm$core$Maybe$Nothing
          })]))]),
          l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$InlineBelowContentTextIconBtn({
            xa: !state.mz,
            oR: 'Pay with credit card',
            xD: $elm$core$Maybe$Just($author$project$IconSvg$creditCard),
            p_: $author$project$Ui$ComponentsPreview$ComponentsPreview$componentsPreviewMsg($author$project$Ui$ComponentsPreview$Msg$NoOp),
            Bh: $elm$core$Maybe$Nothing,
            r8: 0
          })),
          t_: browser,
          ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop3 marBottom3 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0 ')]), _List_fromArray([$elm$html$Html$text('Review your details')]))]))]),
          xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
          Ck: $elm$core$Maybe$Just(2),
          CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
            xC: $elm$core$Maybe$Just($author$project$ElmFramework$MsgCmd$msgCmd.Bl),
            yo: $elm$core$Maybe$Nothing,
            Bg: $elm$core$Maybe$Nothing
          }))
        });
      }()
    });
  });
  var $author$project$Ui$Matchmaking$Checkout$ViewBranch$viewBranch = function (_v0) {
    var branchRoute = _v0.tY;
    var topState = _v0.CX;
    var browser = _v0.t_;
    var state = _v0.aC;
    if (!branchRoute.$) {
      var subBranch = branchRoute.a;
      var searchParams = $elm$core$Result$toMaybe($author$project$Types$CreateOrEditSearchParams$toSearchParams(topState.lL.x3.B2.mE));
      if (!subBranch) {
        return _List_fromArray([$author$project$Ui$PaymentMethods$ViewBranch$browseView({
          t_: browser,
          pX: $elm$core$Maybe$Nothing,
          zG: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$Ui$Matchmaking$Checkout$ViewBranch$msgSelf, $author$project$Ui$Matchmaking$Checkout$Msg$PaymentMethodSelected)),
          qh: $author$project$Ui$PaymentMethods$Edit$Msg$PaymentMethodContextCreateSearch(searchParams),
          qj: A2($elm$core$Maybe$withDefault, $krisajenkins$remotedata$RemoteData$NotAsked, A2($elm$core$Maybe$map, function ($) {
            return $.qj;
          }, $author$project$Types$UserSessionStatus$toSession(topState.lL.A$.sX))),
          BN: state.qi,
          CX: topState
        })]);
      } else {
        return $author$project$Ui$PaymentMethods$Edit$ViewBranch$editPaymentMethodView({
          t_: browser,
          qh: $author$project$Ui$PaymentMethods$Edit$Msg$PaymentMethodContextCreateSearch(searchParams),
          Ad: $elm$core$Maybe$Nothing,
          CX: topState
        });
      }
    } else {
      var paymentMethodId = branchRoute.a;
      var maybeSession = $author$project$Types$UserSessionStatus$toSession(topState.lL.A$.sX);
      var maybePaymentMethod = A2($elm$core$Maybe$andThen, $turboMaCk$any_dict$Dict$Any$get(paymentMethodId), A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, function ($) {
        return $.qj;
      }, $krisajenkins$remotedata$RemoteData$toMaybe), maybeSession));
      var maybeMatchSearchPricing = $elm$core$Maybe$Nothing;
      return _List_fromArray([A2($elm$core$Maybe$withDefault, $author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer, A3($elm$core$Maybe$map2, A2($author$project$Ui$Matchmaking$Checkout$ViewBranch$reviewView, browser, state), maybeMatchSearchPricing, maybePaymentMethod))]);
    }
  };
  var $author$project$Ui$ProvideLocation$Msg$AddressTyped = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$ProvideLocation$Msg$AddressTypedDebounced = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $author$project$UiWrappers$HeaderAndBodyView$SearchBarWithBackBtn = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$TopMsg$msgProvideLocation = A2($elm$core$Basics$composeL, $author$project$ElmFramework$Msg$AppMsg, $author$project$Msg$ProvideLocationMsg);
  var $author$project$Ui$ProvideLocation$DrawerBranch$ViewBranch$enterAddress = function (cfg) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: function () {
        var location = function (searchResult) {
          var title = searchResult.lh;
          var subtitle = searchResult.lb;
          return $author$project$Ui$LocationCard$userLocation({
            uj: ' marBottom2 ',
            mr: $elm$core$Maybe$Nothing,
            p_: cfg.zO(searchResult),
            lb: subtitle,
            lh: title
          });
        };
        var letUsLocateYou = _List_fromArray([$author$project$Ui$OptionLargeSelect$iconBtnRow({
          uj: '',
          wE: $author$project$IconSvg$arrowRight,
          oR: 'Let us locate you',
          p_: $author$project$ElmFramework$Msg$MultiMsg(_List_fromArray([$author$project$ElmFramework$MsgCmd$msgCmd.xM]))
        })]);
        var searchResults = function () {
          var searchingView = cfg.aC.gW === '' ? letUsLocateYou : _List_fromArray([$author$project$Ui$EmptyStates$emptyResult({
            uj: '',
            eS: '',
            lh: 'Searching location...',
            CV: $elm$core$Maybe$Just($author$project$IconSvg$search)
          })]);
          var _v0 = cfg.xP;
          if (!_v0.$) {
            return searchingView;
          } else {
            var locationSearchResults = _v0.a;
            if (_Utils_eq(locationSearchResults, _List_Nil) && cfg.aC.gW === '') {
              return letUsLocateYou;
            } else {
              if (_Utils_eq(locationSearchResults, _List_Nil)) {
                return _List_fromArray([$author$project$Ui$EmptyStates$emptyResult({
                  uj: '',
                  eS: 'Please make sure you have written correctly',
                  lh: 'No Results Found',
                  CV: $elm$core$Maybe$Nothing
                })]);
              } else {
                var searchResultsData = A2($elm$core$List$map, $elm$core$Tuple$second, A2($elm$core$List$map, function (addr) {
                  var value = addr;
                  var key = _Utils_ap(addr.lh, addr.lb);
                  return _Utils_Tuple2(key, value);
                }, locationSearchResults));
                return _Utils_ap(A2($elm$core$List$map, location, searchResultsData), letUsLocateYou);
              }
            }
          }
        }();
        return $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
          l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
          tU: _List_fromArray([A2($elm$html$Html$div, _List_Nil, searchResults)]),
          l5: $elm$core$Maybe$Nothing,
          t_: cfg.t_,
          ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('h2')]), _List_Nil)]),
          xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
          Ck: $elm$core$Maybe$Nothing,
          CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$SearchBarWithBackBtn({
            wR: cfg.aC.gW,
            i1: $elm$core$Maybe$Just({
              mP: 500,
              mQ: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgProvideLocation, $author$project$Ui$ProvideLocation$Msg$AddressTypedDebounced)
            }),
            yQ: $author$project$ElmFramework$MsgCmd$msgCmd.Bl,
            yX: $author$project$TopMsg$msgProvideLocation($author$project$Ui$ProvideLocation$Msg$AddressTyped('')),
            bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgProvideLocation, $author$project$Ui$ProvideLocation$Msg$AddressTyped)
          }))
        });
      }()
    });
  };
  var $author$project$Ui$ProvideLocation$DrawerBranch$ViewBranch$viewBranch = function (cfg) {
    var _v0 = cfg.tY;
    if (!_v0) {
      return _List_Nil;
    } else {
      return _List_fromArray([$author$project$Ui$ProvideLocation$DrawerBranch$ViewBranch$enterAddress(cfg)]);
    }
  };
  var $author$project$Ui$Matchmaking$Single$ViewBranch$viewBranch = function (cfg) {
    var today = A2($justinmimbs$date$Date$fromPosix, cfg.CX.DJ, cfg.CX.Cy);
    var state = cfg.CX.lL.x3;
    var _v0 = cfg.tY;
    switch (_v0.$) {
      case 0:
        return _List_fromArray([A4($author$project$Ui$Matchmaking$Single$ViewBranch$mainView, cfg.t_, state.B2.mE, cfg.CX, cfg.CX.wm)]);
      case 1:
        var branchRoute = _v0.a;
        return $author$project$Ui$Matchmaking$Checkout$ViewBranch$viewBranch({
          tY: branchRoute,
          t_: cfg.t_,
          aC: cfg.CX.lL.x3.mj,
          CX: cfg.CX
        });
      case 2:
        var branchRoute = _v0.a;
        return A2($elm$core$List$cons, A4($author$project$Ui$Matchmaking$Single$ViewBranch$mainView, cfg.t_, state.B2.mE, cfg.CX, cfg.CX.wm), $author$project$Ui$ProvideLocation$DrawerBranch$ViewBranch$viewBranch({
          tY: branchRoute,
          t_: cfg.t_,
          xP: cfg.CX.lL.AJ.xO,
          yf: state.B2.mE.iT,
          zN: $author$project$ElmFramework$MsgCmd$msgCmd.Bu($author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$ProvideLocation(1))),
          zO: function (searchResult) {
            return $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$ProvideLocationMsg(A2($author$project$Ui$ProvideLocation$Msg$LocationSelected, 1, searchResult)));
          },
          aC: cfg.CX.lL.AJ
        }));
      default:
        var branchRoute = _v0.a;
        var _v1 = cfg.CX.lL.x3.B2.mE.du;
        if (!_v1.$) {
          var activity = _v1.a;
          return A4($author$project$Ui$AddPlayers$View$view, branchRoute, cfg.t_, cfg.CX, activity);
        } else {
          return _List_Nil;
        }
    }
  };
  var $author$project$Ui$Matchmaking$ViewBranch$viewBranch = function (cfg) {
    var _v0 = cfg.tY;
    var branchRoute = _v0;
    return $author$project$Ui$Matchmaking$Single$ViewBranch$viewBranch({
      tY: branchRoute,
      t_: cfg.t_,
      CX: cfg.CX
    });
  };
  var $author$project$Msg$DispatchCmd = function (a) {
    return {
      $: 27,
      a: a
    };
  };
  var $author$project$Ui$SpecialSearchBar$LongRowSearch = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Global$Model$MatchFilters = {
    $: 9
  };
  var $author$project$Ui$RetentionDialog$RegularRetentionBox = 0;
  var $author$project$Ui$MatchmakingCards$SearchCardInMyPlayerStatus = 1;
  var $author$project$Ui$MyPlayerStatus$Msg$TextSearchCleared = {
    $: 3
  };
  var $author$project$Ui$MyPlayerStatus$Msg$TextSearchTyped = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$MyPlayerStatus$Msg$TextSearchTypedDebounced = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $author$project$Remote$RequestMsg$CancelSearch = function (a) {
    return {
      $: 19,
      a: a
    };
  };
  var $author$project$Ui$MyPlayerStatus$Searches$ViewBranch$cancelSearchView = F2(function (browser, matchSearchId) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$BottomDrawerOverlayView$bottomDrawerOverlayView({
        l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$InlineBelowContentPairButtons(_Utils_Tuple2({
          xa: false,
          oR: 'Cancel search',
          p_: $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$CancelSearch(matchSearchId)),
          r8: 1
        }, {
          xa: false,
          oR: 'Keep my search',
          p_: $author$project$ElmFramework$MsgCmd$msgCmd.Bl,
          r8: 0
        }))),
        t_: browser,
        fn: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop2')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading2Bold primary0 marBottom1  ')]), _List_fromArray([$elm$html$Html$text('Are you sure you want to cancel your search?')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Regular gray60  ')]), _List_fromArray([$elm$html$Html$text('We will no longer notify you of matches with your preferences.')]))]))]))]),
        pR: $author$project$ElmFramework$MsgCmd$msgCmd.Bl
      })
    });
  });
  var $author$project$IconSvg$edit_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M8.92589 31.2041C9.46972 31.7214 10.2258 32 11.0349 32C11.1709 32 11.3015 31.9891 11.4371 31.9777C11.5131 31.9714 11.5906 31.9649 11.6716 31.9602L15.9426 31.2306C16.7518 31.098 17.7864 30.5409 18.3435 29.944L29.2334 18.4174C31.9525 15.5391 31.873 12.7005 28.9946 9.98138C26.1163 7.26222 23.2778 7.3418 20.5586 10.2201L9.66868 21.7467C9.09832 22.3304 8.60754 23.4048 8.5147 24.2139L8.02392 28.5115C7.90454 29.5726 8.23615 30.5542 8.92589 31.2041ZM22.0044 11.5598C22.9064 10.6048 23.7951 9.96812 24.8164 9.96812C25.6388 9.96812 26.554 10.3926 27.6152 11.4139C30.016 13.6688 29.4191 15.2871 27.7743 17.0379L26.3082 18.5898C23.4524 18.105 21.1761 15.9318 20.5496 13.1015L22.0044 11.5598ZM18.9651 14.7805L11.1145 23.0997C10.8492 23.3782 10.5441 24.0414 10.4911 24.4261L10.0003 28.7237C9.94723 29.1614 10.0533 29.5196 10.2921 29.745C10.5309 29.9705 10.889 30.0501 11.3267 29.9838L15.5978 29.2543C15.9824 29.188 16.6191 28.8431 16.8844 28.5645L24.7378 20.252C22.0782 19.4113 19.9458 17.3925 18.9651 14.7805Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$edit = function (classes) {
    return $author$project$IconSvg$edit_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Route$Route$editSearchRoute = function (searchId) {
    return $author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Searches($author$project$Ui$MyPlayerStatus$Searches$Route$Edit(searchId)));
  };
  var $author$project$Ui$MyPlayerStatus$Searches$ViewBranch$editSearchView = F3(function (browser, topState, searchId) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyView({
        l$: $author$project$UiWrappers$HeaderAndBodyView$BlackBackground,
        tU: A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function (session) {
          return _List_fromArray([$author$project$Ui$CreateOrEditSearch$View$view({
            t_: browser,
            uT: $author$project$Types$CreateOrEditSearch$Edit(searchId),
            rG: session,
            CX: topState
          })]);
        }, $author$project$Remote$Model$toSession(topState.lL.A$))),
        l5: $elm$core$Maybe$Nothing,
        t_: browser,
        ww: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop6 marBottom3 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold gray0 ')]), _List_fromArray([$elm$html$Html$text('Search in progress Preferences')]))]))]),
        xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
        Ck: $elm$core$Maybe$Just(0),
        CT: $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
          xC: $elm$core$Maybe$Just($author$project$ElmFramework$MsgCmd$msgCmd.yw(_List_fromArray([$author$project$TopMsg$msgSingleCreateOrEditSearch($author$project$Ui$CreateOrEditSearch$Msg$ResetState), $author$project$ElmFramework$MsgCmd$msgCmd.Bl]))),
          yo: $elm$core$Maybe$Nothing,
          Bg: $elm$core$Maybe$Nothing
        }))
      })
    });
  });
  var $author$project$Route$Route$matchDetailsRoute = function (matchId) {
    return A2($author$project$Route$Route$Match, matchId, $author$project$Ui$Match$Route$Details);
  };
  var $author$project$Ui$MyPlayerStatus$ViewBranch$matchesEmptyState = function (title) {
    return A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('bodyRegular gray80 padLeft2 marBottom1 marTop1  ')]), _List_fromArray([$elm$html$Html$text(title)])), $author$project$Ui$Button$basicButton({
      bh: ' fullWidth  ',
      cD: 0,
      fn: $elm$html$Html$text('Matchmaking'),
      xa: false,
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$TopMsg$routeTo($author$project$Route$Route$matchMakingSingleRoute))
    })]));
  };
  var $author$project$ElmFramework$Lib$Util$T6 = F6(function (a, b, c, d, e, f) {
    return {
      $: 0,
      a: a,
      b: b,
      c: c,
      d: d,
      e: e,
      f: f
    };
  });
  var $author$project$UiPrimitives$Primitives$titleCenter = F2(function (classes, string) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('primary0 heading4Regular center'), $elm$html$Html$Attributes$class(classes)]), _List_fromArray([$elm$html$Html$text(string)]));
  });
  var $author$project$Ui$RetentionDialog$messageBox = function (messageText) {
    return A2($author$project$UiPrimitives$Primitives$titleCenter, 'marAuto primary0 maxW36 padBottom2 ', messageText);
  };
  var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
  var $author$project$Ui$RetentionDialog$storeBtnCore = F3(function (classes, appUrl, badgeImageUrl) {
    return A2($elm$html$Html$a, _List_fromArray([$elm$html$Html$Attributes$class('block'), $elm$html$Html$Attributes$class(classes), $elm$html$Html$Attributes$href(appUrl), $elm$html$Html$Attributes$target('_blank')]), _List_fromArray([A2($elm$html$Html$img, _List_fromArray([$elm$html$Html$Attributes$class('block fullWidth'), $elm$html$Html$Attributes$src(badgeImageUrl)]), _List_Nil)]));
  });
  var $author$project$Ui$RetentionDialog$storeBtnCenter = $author$project$Ui$RetentionDialog$storeBtnCore('takeHalf marAuto');
  var $author$project$Ui$RetentionDialog$wrap = F2(function (classes, content) {
    return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(classes), $elm$html$Html$Attributes$class('padBottom1 shade1 radius5')]), content);
  });
  var $author$project$Ui$RetentionDialog$appStoreBox = F4(function (classes, messageText, appUrl, badgeImageUrl) {
    return A2($author$project$Ui$RetentionDialog$wrap, classes, _List_fromArray([$author$project$Ui$RetentionDialog$messageBox(messageText), A2($author$project$Ui$RetentionDialog$storeBtnCenter, appUrl, badgeImageUrl)]));
  });
  var $author$project$ElmFramework$Feature$Pwa$Pwa$installPwa = _Platform_outgoingPort('installPwa', function ($) {
    return $elm$json$Json$Encode$null;
  });
  var $author$project$Phrases$retentionBox = {
    ti: 'Activate Notifications',
    tu: 'Have your app handy',
    vz: 'Don\'t miss out important information, enable notifications',
    wb: 'Fancy app installation without the use of extra storage',
    wT: 'Install!'
  };
  var $author$project$Phrases$workout = {
    vg: 'Mobility',
    vh: 'Activation',
    vi: 'SAQ',
    vj: 'Focus',
    vk: 'Recovery'
  };
  var $author$project$Phrases$phrases = {
    yH: 'You\'ll be able to reassign this trainee once there are more trainers available',
    Be: $author$project$Phrases$retentionBox,
    Ds: $author$project$Phrases$workout
  };
  var $author$project$Ui$RetentionDialog$retentionBox = function (_v0) {
    var env = _v0.vS;
    var global = _v0.nV;
    var isAuthenticated = _v0.w8;
    var classes = _v0.uj;
    var useCase = _v0.C8;
    var dispatchCmd = _v0.vy;
    var receivesPush = _v0.AT;
    var supportsPush = _v0.Cr;
    var doesNotReceivePush_ButSupportsIt = (_Utils_eq(receivesPush, $elm$core$Maybe$Just(false)) || _Utils_eq(receivesPush, $elm$core$Maybe$Nothing)) && (_Utils_eq(supportsPush, $elm$core$Maybe$Just(true)) || _Utils_eq(supportsPush, $elm$core$Maybe$Nothing));
    var _v1 = {
      ny: $author$project$Phrases$phrases.Be.wb,
      nY: $author$project$Phrases$phrases.Be.tu,
      qP: $author$project$Phrases$phrases.Be.vz
    };
    var pushNotifText = _v1.qP;
    var fancyInstallText = _v1.ny;
    var haveItHandyText = _v1.nY;
    var _v3 = A6($author$project$ElmFramework$Lib$Util$T6, isAuthenticated, doesNotReceivePush_ButSupportsIt, env.gi, env.fQ, env.fM, env.xd);
    _v3$0: while (true) {
      _v3$1: while (true) {
        _v3$5: while (true) {
          if (_v3.d) {
            switch (_v3.c) {
              case 1:
                if (_v3.a && _v3.b) {
                  break _v3$0;
                } else {
                  break _v3$1;
                }
              case 0:
                if (_v3.a && _v3.b) {
                  break _v3$0;
                } else {
                  if (!_v3.e && !_v3.f) {
                    var _v5 = _v3.c;
                    return A4($author$project$Ui$RetentionDialog$appStoreBox, classes + ' ', haveItHandyText, global.ar.tx, $author$project$AssetsImg$assets.ty);
                  } else {
                    break _v3$5;
                  }
                }
              default:
                if (_v3.a && _v3.b) {
                  break _v3$0;
                } else {
                  break _v3$5;
                }
            }
          } else {
            if (_v3.e) {
              switch (_v3.c) {
                case 1:
                  if (_v3.a && _v3.b) {
                    break _v3$0;
                  } else {
                    break _v3$1;
                  }
                case 0:
                  if (_v3.a && _v3.b) {
                    break _v3$0;
                  } else {
                    if (!_v3.f) {
                      var _v6 = _v3.c;
                      return A4($author$project$Ui$RetentionDialog$appStoreBox, classes + ' ', haveItHandyText, global.ar.wq, $author$project$AssetsImg$assets.wr);
                    } else {
                      break _v3$5;
                    }
                  }
                default:
                  if (_v3.a && _v3.b) {
                    break _v3$0;
                  } else {
                    break _v3$5;
                  }
              }
            } else {
              if (_v3.a && _v3.b) {
                break _v3$0;
              } else {
                if (_v3.c === 1) {
                  break _v3$1;
                } else {
                  if (!_v3.f) {
                    return A2($author$project$Ui$RetentionDialog$wrap, classes, _List_fromArray([$author$project$Ui$RetentionDialog$messageBox(haveItHandyText), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow marTop2 ')]), _List_fromArray([A3($author$project$Ui$RetentionDialog$storeBtnCore, 'flex1', global.ar.tx, $author$project$AssetsImg$assets.ty), $author$project$ElmFramework$Lib$Util$spacer('w1'), A3($author$project$Ui$RetentionDialog$storeBtnCore, 'flex1', global.ar.wq, $author$project$AssetsImg$assets.wr)]))]));
                  } else {
                    break _v3$5;
                  }
                }
              }
            }
          }
        }
        return $author$project$ElmFramework$Lib$Util$noOpEl;
      }
      var _v4 = _v3.c;
      return A2($author$project$Ui$RetentionDialog$wrap, classes, _List_fromArray([$author$project$Ui$RetentionDialog$messageBox(fancyInstallText), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('center')]), _List_fromArray([$author$project$Ui$Button$basicButton({
        bh: 'fullWidth',
        cD: 0,
        fn: $elm$html$Html$text($author$project$Phrases$phrases.Be.wT),
        xa: false,
        xu: $author$project$ElmFramework$Lib$Ui$Button$Button(dispatchCmd($author$project$ElmFramework$Feature$Pwa$Pwa$installPwa(0)))
      })]))]));
    }
    return A2($author$project$Ui$RetentionDialog$wrap, classes, _List_fromArray([$author$project$Ui$RetentionDialog$messageBox(pushNotifText), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('center')]), _List_fromArray([$author$project$Ui$Button$basicButton({
      bh: 'fullWidth',
      cD: 1,
      fn: $elm$html$Html$text($author$project$Phrases$phrases.Be.ti),
      xa: false,
      xu: $author$project$ElmFramework$Lib$Ui$Button$Button(dispatchCmd($author$project$ElmFramework$Feature$PushMessages$PushMessages$enablePushNotifications(0)))
    })]))]));
  };
  var $author$project$ElmFramework$Feature$PushMessages$PushMessages$supportsPushNotifications = function (pushStatus) {
    switch (pushStatus.$) {
      case 0:
        return $elm$core$Maybe$Nothing;
      case 1:
        return $elm$core$Maybe$Just(true);
      case 2:
        return $elm$core$Maybe$Just(true);
      case 3:
        return $elm$core$Maybe$Just(true);
      default:
        return $elm$core$Maybe$Just(false);
    }
  };
  var $author$project$Ui$MyPlayerStatus$ViewBranch$myPlayerView = F4(function (env, browser, branchRoute, topState) {
    var zone = topState.DJ;
    var state = topState.lL.yy;
    var receivesPushPermissions = function () {
      var _v5 = topState.AO;
      if (_v5.$ === 3) {
        var token = _v5.a;
        var isUserRequestedPermission = _v5.b;
        var _v6 = $author$project$Remote$Model$toSession(topState.lL.A$);
        if (!_v6.$) {
          var session = _v6.a;
          return $elm$core$Maybe$Just(A2($author$project$Types$UserSettings$hasPushDevice, token, session.kO));
        } else {
          return $elm$core$Maybe$Nothing;
        }
      } else {
        return $elm$core$Maybe$Just(false);
      }
    }();
    var maybeSession = $author$project$Remote$Model$toSession(topState.lL.A$);
    var global = topState.lL.nV;
    if (!maybeSession.$) {
      var session = maybeSession.a;
      var userProfile = session.Db;
      var topBar = $elm$core$Maybe$Just($author$project$UiWrappers$HeaderAndBodyView$CustomBar({
        xC: $elm$core$Maybe$Nothing,
        yo: $elm$core$Maybe$Nothing,
        Bg: $elm$core$Maybe$Nothing
      }));
      var statistics = session.r5;
      var retentionDialog = A2($elm$html$Html$map, $author$project$TopMsg$appMsg, $author$project$Ui$RetentionDialog$retentionBox({
        uj: ' primary0',
        vy: $author$project$Msg$DispatchCmd,
        vS: env,
        nV: global,
        w8: true,
        AT: receivesPushPermissions,
        Cr: $author$project$ElmFramework$Feature$PushMessages$PushMessages$supportsPushNotifications(topState.AO),
        C8: 0
      }));
      var itemsWrapper = function (items) {
        return _List_fromArray([$author$project$UiWrappers$HeaderAndBodyView$multipleBodyContentWithIconAndLabel(_List_fromArray([$elm$core$Maybe$Just({
          uj: '  ',
          fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight-2 marLeft-2 ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop1 marBottom1 padRight3 padLeft3 flexRow whiteSpaceNoWrap scrollTargetX noScrollbar spaceBetween  ')]), A2($elm$core$List$cons, A2($author$project$Ui$MyPlayerStatus$ViewBranch$matchCountBox, statistics.fZ, 'All'), A2($elm$core$List$map, $author$project$Ui$MyPlayerStatus$ViewBranch$toMatchCountBox, statistics.tj)))])),
          wE: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$IconSvg$results, '')),
          lh: $elm$core$Maybe$Just('Total matches')
        }), _Utils_eq(receivesPushPermissions, $elm$core$Maybe$Just(true)) ? $elm$core$Maybe$Just({
          uj: '',
          fn: retentionDialog,
          wE: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$IconSvg$notifications, '')),
          lh: $elm$core$Maybe$Just('Notifications')
        }) : $elm$core$Maybe$Nothing, $elm$core$Maybe$Just({
          uj: ' flex1 ',
          fn: A2($elm$html$Html$div, _List_Nil, _Utils_ap(_List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' marBottom2 ')]), _List_fromArray([$author$project$Ui$SliderMultipleSelect$sliderMultipleSelect({
            uj: ' heading5Regular ',
            uy: $elm$core$Maybe$Just(0),
            u$: branchRoute,
            xn: _List_fromArray([_Utils_Tuple3($author$project$Ui$MyPlayerStatus$Route$Searches($author$project$Ui$MyPlayerStatus$Searches$Route$SearchesList), 'Searching', $elm$core$Maybe$Nothing), _Utils_Tuple3($author$project$Ui$MyPlayerStatus$Route$Upcoming, 'Next Matches', $elm$core$Maybe$Just(state.oG)), _Utils_Tuple3($author$project$Ui$MyPlayerStatus$Route$History, 'History', $elm$core$Maybe$Nothing)]),
            zG: function (curr) {
              return $author$project$ElmFramework$MsgCmd$msgCmd.Bu($author$project$Route$Route$MyPlayerStatus(curr));
            },
            zK: ''
          })])), function () {
            switch (branchRoute.$) {
              case 0:
                return $author$project$ElmFramework$Lib$Util$noOpEl;
              case 1:
                var _v4 = $author$project$ElmFramework$Lib$UiBehavior$EndlessList$EndlessList$isEmpty(session.wA);
                if (!_v4.$) {
                  if (_v4.a) {
                    return $author$project$ElmFramework$Lib$Util$noOpEl;
                  } else {
                    return $author$project$Ui$SpecialSearchBar$specialSearchBar({
                      bh: ' marBottom2 ',
                      od: '',
                      i1: $elm$core$Maybe$Just({
                        mP: 500,
                        mQ: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgMyPlayerStatus, $author$project$Ui$MyPlayerStatus$Msg$TextSearchTypedDebounced)
                      }),
                      jq: $elm$core$Maybe$Nothing,
                      bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgMyPlayerStatus, $author$project$Ui$MyPlayerStatus$Msg$TextSearchTyped),
                      bv: 'Search',
                      kI: $author$project$Ui$SpecialSearchBar$LongRowSearch({
                        yW: $author$project$TopMsg$msgMyPlayerStatus($author$project$Ui$MyPlayerStatus$Msg$TextSearchCleared),
                        zb: $author$project$TopMsg$msgGlobal($author$project$Global$Msg$ShowDialog($author$project$Global$Model$MatchFilters))
                      }),
                      s_: state.sn
                    });
                  }
                } else {
                  return $author$project$ElmFramework$Lib$Util$noOpEl;
                }
              default:
                var searchesSubroute = branchRoute.a;
                return $author$project$ElmFramework$Lib$Util$noOpEl;
            }
          }()]), items)),
          wE: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$AssetsSvg$logoIconGradient, 'w2h ')),
          lh: $elm$core$Maybe$Just('Your matches')
        })]))]);
      };
      var headerContent = _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' gray0  marTop3 marBottom3  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading1Bold marBottom2 ')]), _List_fromArray([$elm$html$Html$text(userProfile.nF + (' ' + userProfile.oU))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' flexRow ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marRight2 w8 h8')]), _List_fromArray([A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Ui$EmptyStates$emptyUserAvatar, function (photoUrl) {
        return A2($elm$html$Html$img, _List_fromArray([$elm$html$Html$Attributes$src(photoUrl), $elm$html$Html$Attributes$class('relative block w8 h8 radius7 noOverflow')]), _List_Nil);
      }, userProfile.qq)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexColumn justifyCenter')]), _List_fromArray([$author$project$Ui$Button$button({
        bh: '',
        fn: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow heading3Bold  ')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('left')]), _List_fromArray([$elm$html$Html$text(A2($elm$core$String$join, ', ', A2($elm$core$List$map, A2($elm$core$Basics$composeR, function ($) {
          return $.du;
        }, $author$project$Types$Activity$toString(false)), session.lz)))])), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class('w3 h3 marLeft0h ')]), _List_fromArray([$author$project$IconSvg$edit('secondary100Fill w3')]))])),
        xu: $author$project$ElmFramework$Lib$Ui$Button$Button($author$project$ElmFramework$MsgCmd$msgCmd.yw(_List_fromArray([$author$project$TopMsg$routeTo($author$project$Route$Route$EditUserActivity(0)), A3($elm$core$Basics$composeR, $author$project$Types$EditingUserActivities$fromSession, A2($elm$core$Basics$composeR, $author$project$Ui$EditUserActivities$Msg$SetState, $author$project$TopMsg$msgEditingActivities), session)])))
      }), A2($elm$html$Html$span, _List_fromArray([$elm$html$Html$Attributes$class(' heading4Bold gray60 ')]), _List_fromArray([$elm$html$Html$text(A3($elm$core$Basics$composeR, $author$project$Api$GraphqlSchema$Enum$Gender$toString, A2($elm$core$Basics$composeR, $elm$core$String$toLower, $elm_community$string_extra$String$Extra$toTitleCase), userProfile.nM))]))]))]))]))]);
      var background = $author$project$UiWrappers$HeaderAndBodyView$ImgOverlay(_List_fromArray([{
        ij: browser.ij,
        eZ: $author$project$AssetsImg$assets.AC,
        lt: browser.lt
      }]));
      switch (branchRoute.$) {
        case 0:
          return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
            Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyEndlessListView({
              l$: background,
              tW: _List_Nil,
              l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$NavBar),
              t_: browser,
              vL: _List_fromArray([$author$project$Ui$MyPlayerStatus$ViewBranch$matchesEmptyState('No matches booked.')]),
              ww: headerContent,
              xp: $elm$core$Maybe$Just(itemsWrapper),
              xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
              ps: A2($elm$core$Basics$composeL, $author$project$TopMsg$remoteMsg, $author$project$Remote$Msg$NextMatchesEndlessListMsg(false)),
              aC: session.yC,
              Ck: $elm$core$Maybe$Just(3),
              CG: function (matchDetails) {
                return $author$project$Ui$MatchmakingCards$matchCard({
                  t_: browser,
                  uj: ' marBottom2 ',
                  oE: false,
                  m: matchDetails,
                  p_: $author$project$TopMsg$routeTo($author$project$Route$Route$matchDetailsRoute(matchDetails.xX.od)),
                  rG: session
                });
              },
              CT: topBar
            })
          })]);
        case 1:
          var maybeSearch = $elm_community$string_extra$String$Extra$nonEmpty(state.sn);
          var dateOrder = state.cF;
          return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
            Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyEndlessListView({
              l$: background,
              tW: _List_Nil,
              l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$NavBar),
              t_: browser,
              vL: _List_fromArray([$author$project$Ui$MyPlayerStatus$ViewBranch$matchesEmptyState('No history matches.')]),
              ww: headerContent,
              xp: $elm$core$Maybe$Just(itemsWrapper),
              xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
              ps: A2($elm$core$Basics$composeL, $author$project$TopMsg$remoteMsg, A3($author$project$Remote$Msg$HistoryMatchesEndlessListMsg, false, maybeSearch, dateOrder)),
              aC: session.wA,
              Ck: $elm$core$Maybe$Just(3),
              CG: function (matchDetails) {
                return $author$project$Ui$MatchmakingCards$matchCard({
                  t_: browser,
                  uj: ' marBottom2 ',
                  oE: true,
                  m: matchDetails,
                  p_: $author$project$TopMsg$routeTo($author$project$Route$Route$matchDetailsRoute(matchDetails.xX.od)),
                  rG: session
                });
              },
              CT: topBar
            })
          })]);
        default:
          var searchesSubroute = branchRoute.a;
          switch (searchesSubroute.$) {
            case 0:
              return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
                Dl: $author$project$UiWrappers$HeaderAndBodyView$headerAndBodyEndlessListView({
                  l$: background,
                  tW: _List_Nil,
                  l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$NavBar),
                  t_: browser,
                  vL: _List_fromArray([$author$project$Ui$MyPlayerStatus$ViewBranch$matchesEmptyState('You are not searching for a match at this time.')]),
                  ww: headerContent,
                  xp: $elm$core$Maybe$Just(itemsWrapper),
                  xB: $author$project$UiWrappers$HeaderAndBodyView$PrioritizeBody,
                  ps: A2($elm$core$Basics$composeL, $author$project$TopMsg$remoteMsg, $author$project$Remote$Msg$SearchesEndlessListMsg(false)),
                  aC: session.BK,
                  Ck: $elm$core$Maybe$Just(3),
                  CG: function (searchDetails) {
                    return A2($author$project$Ui$MatchmakingCards$searchCard, {
                      t_: browser,
                      uj: ' marBottom2 ',
                      uO: 1,
                      yj: $elm$core$Maybe$Just(session),
                      p_: _Utils_eq(searchDetails.uW.e_, session.e_) ? $author$project$TopMsg$routeTo($author$project$Route$Route$editSearchRoute(searchDetails.kH.od)) : $author$project$TopMsg$routeTo($author$project$Route$Route$Invitation($author$project$Ui$Invitation$Route$Search(searchDetails.kH.od))),
                      DJ: zone
                    }, searchDetails);
                  },
                  CT: topBar
                })
              })]);
            case 1:
              var searchId = searchesSubroute.a;
              return _List_fromArray([A3($author$project$Ui$MyPlayerStatus$Searches$ViewBranch$editSearchView, browser, topState, searchId)]);
            default:
              var searchId = searchesSubroute.a;
              return _List_fromArray([A3($author$project$Ui$MyPlayerStatus$Searches$ViewBranch$editSearchView, browser, topState, searchId), A2($author$project$Ui$MyPlayerStatus$Searches$ViewBranch$cancelSearchView, browser, searchId)]);
          }
      }
    } else {
      return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
        Dl: $author$project$ElmFramework$Lib$Util$noOpEl
      })]);
    }
  });
  var $author$project$Ui$MyPlayerStatus$ViewBranch$viewBranch = function (cfg) {
    return A4($author$project$Ui$MyPlayerStatus$ViewBranch$myPlayerView, cfg.vS, cfg.t_, cfg.tY, cfg.CX);
  };
  var $author$project$Ui$ProvideLocation$Msg$ProvideLocationOnboardUser = 0;
  var $author$project$Ui$EditUserActivities$EditUserActivities$EditActivityOnboardUserContext = 0;
  var $author$project$Ui$TopLevelViewsUtil$StickyBackAndTextButtons = function (a) {
    return {
      $: 3,
      a: a
    };
  };
  var $author$project$Ui$OnboardUser$ViewBranch$levelView = function (topState) {
    var editConfig = A4($author$project$Ui$EditUserActivities$EditUserActivities$editUserActivity, 0, 1, topState.lL.vF, $author$project$Types$UserSessionStatus$toSession(topState.lL.A$.sX));
    return {
      l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$StickyBackAndTextButtons(_Utils_Tuple2($author$project$TopMsg$routeTo($author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$EditUserActivities(0))), {
        xa: false,
        oR: 'Next',
        p_: editConfig.la,
        r8: 0
      }))),
      vn: editConfig.vn,
      el: editConfig.fn,
      a6: 3,
      lh: editConfig.lh
    };
  };
  var $author$project$UiWrappers$PlainWhiteView$StepsBar = $elm$core$Basics$identity;
  var $author$project$Ui$OnboardUser$ViewBranch$onboardUserView = F2(function (cfg, browser) {
    return $author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
      Dl: $author$project$UiWrappers$PlainWhiteView$plainWhiteView({
        l5: cfg.l5,
        t_: browser,
        fn: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' marTop4 ')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading2Bold primary0 marBottom1 ')]), _List_fromArray([$elm$html$Html$text(cfg.lh)])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' bodyRegular gray80 ')]), _List_fromArray([$elm$html$Html$text(cfg.vn)]))])), cfg.el]))]),
        CW: $elm$core$Maybe$Just(A2($author$project$UiWrappers$PlainWhiteView$TopSection, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just({
          u1: cfg.a6,
          oR: 'About You',
          Cg: 3
        })))
      })
    });
  });
  var $author$project$Remote$RequestMsg$CreateUser = F3(function (a, b, c) {
    return {
      $: 38,
      a: a,
      b: b,
      c: c
    };
  });
  var $author$project$Types$EditingUserProfile$GenderToggled = function (a) {
    return {
      $: 4,
      a: a
    };
  };
  var $author$project$Msg$NoOp = {
    $: 2
  };
  var $author$project$Ui$Location$OnboardUserLocationContext = 0;
  var $author$project$Types$EditingUserProfile$RadiusSet = function (a) {
    return {
      $: 6,
      a: a
    };
  };
  var $author$project$Util$OnRouteCmd$RouteTo = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Types$EditingUserProfile$UpdateEditingUserProfile = function (a) {
    return {
      $: 9,
      a: a
    };
  };
  var $author$project$Ui$OnboardUser$ViewBranch$personalView = F4(function (userSessionStatus, editingUserProfile, geolocationAndPermissions, _v0) {
    var respondToInvitationAfterCreatingUser = _v0.rc;
    return {
      l5: function () {
        var toCreateUserRequest = function (email) {
          if (editingUserProfile.nF === '') {
            return $elm$core$Result$Err('Please enter your name');
          } else {
            if (editingUserProfile.oU === '') {
              return $elm$core$Result$Err('Please enter your last name');
            } else {
              if (editingUserProfile.qo === '') {
                return $elm$core$Result$Err('Please enter your phone number');
              } else {
                if (_Utils_eq(editingUserProfile.nM, $elm$core$Maybe$Nothing)) {
                  return $elm$core$Result$Err('Please select your gender');
                } else {
                  if (_Utils_eq(editingUserProfile.iT, $elm$core$Maybe$Nothing)) {
                    return $elm$core$Result$Err('Please provide your location');
                  } else {
                    var _v3 = _Utils_Tuple2(editingUserProfile.nM, editingUserProfile.iT);
                    if (!_v3.a.$ && !_v3.b.$) {
                      var gender = _v3.a.a;
                      var location = _v3.b.a;
                      return $elm$core$Result$Ok({
                        bZ: email,
                        nF: editingUserProfile.nF,
                        nM: gender,
                        oU: editingUserProfile.oU,
                        iT: $elm$core$Maybe$Just(location),
                        qo: editingUserProfile.qo,
                        qq: editingUserProfile.qq
                      });
                    } else {
                      return $elm$core$Result$Err('Please select your gender');
                    }
                  }
                }
              }
            }
          }
        };
        var submitMsg = function () {
          switch (userSessionStatus.$) {
            case 2:
              var email = userSessionStatus.a.bZ;
              var auth = userSessionStatus.a.bN;
              var _v2 = toCreateUserRequest(email);
              if (!_v2.$) {
                var userProfile = _v2.a;
                return $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$CreateUser, respondToInvitationAfterCreatingUser, userProfile, $elm$core$Maybe$Just($author$project$Util$OnRouteCmd$RouteTo($author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$EditUserActivities(0))))));
              } else {
                var validationError = _v2.a;
                return A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, validationError, _List_Nil);
              }
            case 3:
              var session = userSessionStatus.a;
              return A3($elm_community$result_extra$Result$Extra$unpack, function (validationError) {
                return A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, validationError, _List_Nil);
              }, function (userProfile) {
                return $author$project$TopMsg$requestMsg(A3($author$project$Remote$RequestMsg$UpdateUser, session.e_, userProfile, $elm$core$Maybe$Just($author$project$Util$OnRouteCmd$RouteTo($author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$EditUserActivities(0))))));
              }, $author$project$Types$EditingUserProfile$toUserProfile(editingUserProfile));
            case 0:
              return $author$project$ElmFramework$Msg$MultiMsg(_List_fromArray([$author$project$TopMsg$routeTo($author$project$Route$Route$homeRoute), A3($author$project$ElmFramework$MsgCmd$msgCmd.al, $elm$core$Maybe$Nothing, 'Your session has expired, please log in again.', _List_Nil)]));
            default:
              return $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$NoOp);
          }
        }();
        return $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$StickyBtn({
          xa: false,
          oR: 'Next',
          p_: submitMsg,
          r8: 0
        }));
      }(),
      vn: 'Please fill in the information shown below.',
      el: A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marTop2 ')]), _List_fromArray([A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('heading3Bold primary0 marBottom2  ')]), _List_fromArray([$elm$html$Html$text('Get to know each other')])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$Input$labeledInput({
        bP: $elm$core$Maybe$Nothing,
        bh: ' marBottom3  ',
        od: '01',
        wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
        oR: 'First name',
        bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingUserProfile, $author$project$Types$EditingUserProfile$FirstNameTyped),
        bv: 'Type your name',
        ch: false,
        Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
        s_: editingUserProfile.nF
      }), $author$project$Ui$Input$labeledInput({
        bP: $elm$core$Maybe$Nothing,
        bh: ' marBottom3  ',
        od: '01',
        wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
        oR: 'Last name',
        bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingUserProfile, $author$project$Types$EditingUserProfile$LastNameTyped),
        bv: 'Type your last name',
        ch: false,
        Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
        s_: editingUserProfile.oU
      }), $author$project$Ui$Input$labeledInput({
        bP: $elm$core$Maybe$Nothing,
        bh: ' marBottom3 ',
        od: '01',
        wQ: $author$project$ElmFramework$Lib$Ui$Input$Text,
        oR: 'Phone number',
        bu: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingUserProfile, $author$project$Types$EditingUserProfile$PhoneNumberTyped),
        bv: 'Type your phone number',
        ch: false,
        Cd: $author$project$ElmFramework$Lib$Ui$Input$InputDefault,
        s_: editingUserProfile.qo
      })]))])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('marBottom3')]), _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading3Bold primary0 marBottom2  ')]), _List_fromArray([$elm$html$Html$text('Location')])), $author$project$Ui$Location$locationSection({
        vR: $author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$Personal($elm$core$Maybe$Just(1))),
        wm: geolocationAndPermissions,
        xN: 0,
        yf: A2($elm$core$Maybe$map, $elm$core$Tuple$mapFirst(function ($) {
          return $.es;
        }), editingUserProfile.iT),
        y4: $elm$core$Maybe$Just($author$project$TopMsg$msgEditingUserProfile($author$project$Types$EditingUserProfile$UpdateEditingUserProfile($author$project$Types$EditingUserProfile$LocationSet($elm$core$Maybe$Nothing)))),
        zH: A2($elm$core$Basics$composeL, $author$project$TopMsg$msgEditingUserProfile, $author$project$Types$EditingUserProfile$RadiusSet),
        gj: editingUserProfile.gj
      })])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' heading3Bold primary0 marBottom1 ')]), _List_fromArray([$elm$html$Html$text('Gender')])), A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class(' bodyRegular gray80 marBottom2  ')]), _List_fromArray([$elm$html$Html$text('XRIVALS currently only supports same gender matches.')])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([$author$project$Ui$OptionLargeSelect$optionLargeSelect({
        uj: ' marRight2 ',
        wE: $author$project$AssetsSvg$genderFemale,
        ea: ' h6',
        xj: _Utils_eq(editingUserProfile.nM, $elm$core$Maybe$Just(0)),
        p_: $author$project$TopMsg$msgEditingUserProfile($author$project$Types$EditingUserProfile$GenderToggled(0)),
        lh: 'Female'
      }), $author$project$Ui$OptionLargeSelect$optionLargeSelect({
        uj: '',
        wE: $author$project$AssetsSvg$genderMale,
        ea: 'h6',
        xj: _Utils_eq(editingUserProfile.nM, $elm$core$Maybe$Just(1)),
        p_: $author$project$TopMsg$msgEditingUserProfile($author$project$Types$EditingUserProfile$GenderToggled(1)),
        lh: 'Male'
      })]))]))])),
      a6: 1,
      lh: 'Tell us a bit about yourself'
    };
  });
  var $author$project$Ui$OnboardUser$ViewBranch$sportsView = function (topState) {
    var editConfig = A4($author$project$Ui$EditUserActivities$EditUserActivities$editUserActivity, 0, 0, topState.lL.vF, $author$project$Types$UserSessionStatus$toSession(topState.lL.A$.sX));
    return {
      l5: $elm$core$Maybe$Just($author$project$Ui$TopLevelViewsUtil$StickyBackAndTextButtons(_Utils_Tuple2($author$project$TopMsg$routeTo($author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$Personal($elm$core$Maybe$Nothing))), {
        xa: false,
        oR: 'Next',
        p_: editConfig.la,
        r8: 0
      }))),
      vn: editConfig.vn,
      el: editConfig.fn,
      a6: 2,
      lh: editConfig.lh
    };
  };
  var $author$project$Ui$OnboardUser$ViewBranch$viewBranch = function (cfg) {
    var userSessionStatus = cfg.CX.lL.A$.sX;
    var state = cfg.CX.lL.z$;
    var editingUserProfile = cfg.CX.lL.vG;
    var editingUserActivities = cfg.CX.lL.vF;
    var _v0 = cfg.tY;
    if (!_v0.$) {
      var maybeSubroute = _v0.a;
      return A2($elm$core$List$cons, A2($author$project$Ui$OnboardUser$ViewBranch$onboardUserView, A4($author$project$Ui$OnboardUser$ViewBranch$personalView, userSessionStatus, editingUserProfile, cfg.CX.wm, state), cfg.t_), A3($elm_community$maybe_extra$Maybe$Extra$unpack, $elm$core$Basics$always(_List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer])), function (subroute) {
        return $author$project$Ui$ProvideLocation$DrawerBranch$ViewBranch$viewBranch({
          tY: subroute,
          t_: cfg.t_,
          xP: cfg.CX.lL.AJ.xO,
          yf: A2($elm$core$Maybe$map, $elm$core$Tuple$mapFirst(function ($) {
            return $.es;
          }), editingUserProfile.iT),
          zN: $author$project$ElmFramework$MsgCmd$msgCmd.Bu($author$project$Route$Route$OnboardUser($author$project$Ui$OnboardUser$Route$Personal($elm$core$Maybe$Just(1)))),
          zO: function (searchResult) {
            return $author$project$ElmFramework$Msg$AppMsg($author$project$Msg$ProvideLocationMsg(A2($author$project$Ui$ProvideLocation$Msg$LocationSelected, 0, searchResult)));
          },
          aC: cfg.CX.lL.AJ
        });
      }, maybeSubroute));
    } else {
      var editUserActivityRoute = _v0.a;
      if (!editUserActivityRoute) {
        return _List_fromArray([A2($author$project$Ui$OnboardUser$ViewBranch$onboardUserView, $author$project$Ui$OnboardUser$ViewBranch$sportsView(cfg.CX), cfg.t_)]);
      } else {
        return _List_fromArray([A2($author$project$Ui$OnboardUser$ViewBranch$onboardUserView, $author$project$Ui$OnboardUser$ViewBranch$levelView(cfg.CX), cfg.t_)]);
      }
    }
  };
  var $author$project$Ui$PaymentMethods$Edit$Msg$PaymentMethodContextMoreOptions = {
    $: 1
  };
  var $author$project$Ui$PaymentMethods$Msg$RemovePaymentMethod = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$Ui$PaymentMethods$ViewBranch$viewBranch = function (cfg) {
    var _v0 = cfg.tY;
    if (!_v0) {
      return _List_fromArray([$author$project$Ui$PaymentMethods$ViewBranch$browseView({
        t_: cfg.t_,
        pX: $elm$core$Maybe$Just(A2($elm$core$Basics$composeL, $author$project$TopMsg$msgPaymentMethods, $author$project$Ui$PaymentMethods$Msg$RemovePaymentMethod)),
        zG: $elm$core$Maybe$Nothing,
        qh: $author$project$Ui$PaymentMethods$Edit$Msg$PaymentMethodContextMoreOptions,
        qj: cfg.qj,
        BN: $elm$core$Maybe$Nothing,
        CX: cfg.CX
      })]);
    } else {
      return $author$project$Ui$PaymentMethods$Edit$ViewBranch$editPaymentMethodView({
        t_: cfg.t_,
        qh: $author$project$Ui$PaymentMethods$Edit$Msg$PaymentMethodContextMoreOptions,
        Ad: $elm$core$Maybe$Nothing,
        CX: cfg.CX
      });
    }
  };
  var $author$project$Views$Routed$RoutedViews$routedViews = F4(function (env, browser, route, state) {
    var maybeSession = $author$project$Types$UserSessionStatus$toSession(state.lL.A$.sX);
    var maybeUserProfile = A2($elm$core$Maybe$map, function ($) {
      return $.Db;
    }, maybeSession);
    switch (route.$) {
      case 0:
        var authStep = route.a;
        return A3($author$project$Ui$Auth$View$view, authStep, browser, state);
      case 1:
        return _List_Nil;
      case 2:
        return A2($author$project$Ui$Support$View$view, browser, state.lL.Cq);
      case 3:
        var legalRoute = route.a;
        return A3($author$project$Ui$Legal$View$termsAndPolicyView, legalRoute, browser, state.lL.xF);
      case 5:
        return _List_Nil;
      case 4:
        return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$ViewMatrixLayer({
          Dl: A3($author$project$Ui$ComponentsPreview$ComponentsPreview$view, state.vS, state.t_, state.lL.uE)
        })]);
      case 6:
        return A3($author$project$Ui$MoreOptions$View$view, browser, state.lL.yv, maybeSession);
      case 7:
        return $author$project$Ui$PrivacySettings$View$view;
      case 8:
        return A3($author$project$Ui$NotificationsSettings$View$view, browser, state.lL.yL, maybeSession);
      case 9:
        return A3($author$project$Ui$EditPersonalDetails$View$view, browser, state.lL.vG, A2($elm$core$Maybe$map, function ($) {
          return $.e_;
        }, maybeSession));
      case 10:
        return A3($author$project$Ui$ChangePassword$View$view, browser, state.lL.tD, maybeSession);
      case 11:
        return A2($author$project$Ui$Notifications$View$view, browser, state);
      case 12:
        return A2($author$project$Ui$Feedback$View$view, browser, state.lL.wd);
      case 13:
        var userId = route.a;
        return A3($author$project$Ui$BanUser$View$view, browser, state.DJ, userId);
      case 14:
        return $author$project$Ui$BannedUsers$View$view(browser);
      case 15:
        var branchRoute = route.a;
        return A2($author$project$Ui$AppIntro$ViewBranch$viewBranch, browser, {
          tY: branchRoute
        });
      case 16:
        var branchRoute = route.a;
        return $author$project$Ui$OnboardUser$ViewBranch$viewBranch({
          tY: branchRoute,
          t_: browser,
          CX: state
        });
      case 17:
        var branchRoute = route.a;
        return $author$project$Ui$PaymentMethods$ViewBranch$viewBranch({
          tY: branchRoute,
          t_: browser,
          qj: A2($elm$core$Maybe$withDefault, $krisajenkins$remotedata$RemoteData$NotAsked, A2($elm$core$Maybe$map, function ($) {
            return $.qj;
          }, maybeSession)),
          aC: state.lL.Ae,
          CX: state
        });
      case 18:
        var branchRoute = route.a;
        return $author$project$Ui$Matchmaking$ViewBranch$viewBranch({
          tY: branchRoute,
          t_: browser,
          CX: state
        });
      case 19:
        var branchRoute = route.a;
        return $author$project$Ui$MyPlayerStatus$ViewBranch$viewBranch({
          tY: branchRoute,
          t_: browser,
          vS: env,
          CX: state
        });
      case 20:
        var maybeUserId = route.a;
        return A3($author$project$Ui$PlayerProfile$View$view, browser, state, maybeUserId);
      case 21:
        var matchId = route.a;
        var branchRoute = route.b;
        if (!maybeSession.$) {
          var session = maybeSession.a;
          return $author$project$Ui$Match$ViewBranch$viewBranch({
            tY: branchRoute,
            t_: browser,
            vS: env,
            br: matchId,
            rG: session,
            aC: state.lL.xZ,
            CX: state,
            DJ: state.DJ
          });
        } else {
          return _List_fromArray([$author$project$ElmFramework$Lib$TransitionableViewLayers$EmptyViewLayer]);
        }
      case 22:
        var branchRoute = route.a;
        return A3($author$project$Ui$EditUserActivities$View$viewBranch, branchRoute, browser, state);
      default:
        var subRoute = route.a;
        return A3($author$project$Ui$Invitation$View$view, browser, state, subRoute);
    }
  });
  var $author$project$MainModule$shouldWhiteSplashBackground = function (route) {
    if (!route.$) {
      return false;
    } else {
      return true;
    }
  };
  var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
  var $elm$svg$Svg$Attributes$clipPathUnits = _VirtualDom_attribute('clipPathUnits');
  var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
  var $author$project$Ui$SquircleSvg$squircleSvg = A2($elm$svg$Svg$svg, _List_fromArray([$elm$svg$Svg$Attributes$class(''), $elm$svg$Svg$Attributes$viewBox('0 0 1 1')]), _List_fromArray([A2($elm$svg$Svg$clipPath, _List_fromArray([$elm$svg$Svg$Attributes$id('squirclePath'), $elm$svg$Svg$Attributes$clipPathUnits('objectBoundingBox')]), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M0.5 0C0.0714286 0 -2.77778e-09 0.0714286 0 0.500001C-2.77778e-09 0.928573 0.0714286 1 0.5 1C0.928571 1 1 0.928573 1 0.500001C1 0.0714286 0.928571 0 0.5 0Z')]), _List_Nil)]))]));
  var $elm$svg$Svg$Attributes$colorInterpolationFilters = _VirtualDom_attribute('color-interpolation-filters');
  var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
  var $elm$svg$Svg$feBlend = $elm$svg$Svg$trustedNode('feBlend');
  var $elm$svg$Svg$feColorMatrix = $elm$svg$Svg$trustedNode('feColorMatrix');
  var $elm$svg$Svg$feFlood = $elm$svg$Svg$trustedNode('feFlood');
  var $elm$svg$Svg$feGaussianBlur = $elm$svg$Svg$trustedNode('feGaussianBlur');
  var $elm$svg$Svg$feOffset = $elm$svg$Svg$trustedNode('feOffset');
  var $elm$svg$Svg$filter = $elm$svg$Svg$trustedNode('filter');
  var $elm$svg$Svg$Attributes$filterUnits = _VirtualDom_attribute('filterUnits');
  var $elm$svg$Svg$Attributes$floodOpacity = _VirtualDom_attribute('flood-opacity');
  var $elm$svg$Svg$Attributes$gradientUnits = _VirtualDom_attribute('gradientUnits');
  var $elm$svg$Svg$Attributes$in2 = _VirtualDom_attribute('in2');
  var $elm$svg$Svg$Attributes$in_ = _VirtualDom_attribute('in');
  var $elm$svg$Svg$linearGradient = $elm$svg$Svg$trustedNode('linearGradient');
  var $elm$svg$Svg$mask = $elm$svg$Svg$trustedNode('mask');
  var $elm$svg$Svg$Attributes$maskUnits = _VirtualDom_attribute('maskUnits');
  var $elm$svg$Svg$Attributes$mode = _VirtualDom_attribute('mode');
  var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');
  var $elm$svg$Svg$Attributes$result = _VirtualDom_attribute('result');
  var $elm$svg$Svg$Attributes$stdDeviation = _VirtualDom_attribute('stdDeviation');
  var $elm$svg$Svg$stop = $elm$svg$Svg$trustedNode('stop');
  var $elm$svg$Svg$Attributes$stopColor = _VirtualDom_attribute('stop-color');
  var $elm$svg$Svg$Attributes$stopOpacity = _VirtualDom_attribute('stop-opacity');
  var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
  var $elm$svg$Svg$Attributes$values = function (value) {
    return A2(_VirtualDom_attribute, 'values', _VirtualDom_noJavaScriptUri(value));
  };
  var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
  var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
  var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
  var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
  var $author$project$AssetsSvg$svgDefinitions = A2($elm$svg$Svg$svg, _List_Nil, _List_fromArray([A2($elm$svg$Svg$defs, _List_Nil, _List_fromArray([A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_1'), $elm$svg$Svg$Attributes$x1('-5.00002'), $elm$svg$Svg$Attributes$y1('17.3333'), $elm$svg$Svg$Attributes$x2('57.0765'), $elm$svg$Svg$Attributes$y2('79.7063'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#75F5B1')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('0.505208'), $elm$svg$Svg$Attributes$stopColor('#7488ED')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#EE76D4')]), _List_Nil)])), A2($elm$svg$Svg$mask, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_8'), $elm$svg$Svg$Attributes$style('mask-type:alpha'), $elm$svg$Svg$Attributes$maskUnits('userSpaceOnUse'), $elm$svg$Svg$Attributes$x('655'), $elm$svg$Svg$Attributes$y('373'), $elm$svg$Svg$Attributes$width('299'), $elm$svg$Svg$Attributes$height('300')]), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M811.498 518.161L953.464 373.816V672.024H655.256L811.498 518.161Z'), $elm$svg$Svg$Attributes$fill('white')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_3'), $elm$svg$Svg$Attributes$x1('292.3'), $elm$svg$Svg$Attributes$y1('4.59373'), $elm$svg$Svg$Attributes$x2('-15.5958'), $elm$svg$Svg$Attributes$y2('106.392'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#194175')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#337BD7')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_4'), $elm$svg$Svg$Attributes$x1('59.4338'), $elm$svg$Svg$Attributes$y1('1.16667'), $elm$svg$Svg$Attributes$x2('59.4338'), $elm$svg$Svg$Attributes$y2('168.583'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#4582D1')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#2968B9')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_5'), $elm$svg$Svg$Attributes$x1('263.546'), $elm$svg$Svg$Attributes$y1('178.5'), $elm$svg$Svg$Attributes$x2('263.546'), $elm$svg$Svg$Attributes$y2('-17.7188'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#255CA2')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#255CA2'), $elm$svg$Svg$Attributes$stopOpacity('0')]), _List_Nil)])), A2($elm$svg$Svg$mask, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_6'), $elm$svg$Svg$Attributes$style('mask-type:alpha'), $elm$svg$Svg$Attributes$maskUnits('userSpaceOnUse'), $elm$svg$Svg$Attributes$x('0'), $elm$svg$Svg$Attributes$y('0'), $elm$svg$Svg$Attributes$width('296'), $elm$svg$Svg$Attributes$height('168')]), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$width('296'), $elm$svg$Svg$Attributes$height('168'), $elm$svg$Svg$Attributes$rx('16'), $elm$svg$Svg$Attributes$fill('#E7E7E8')]), _List_Nil)])), A2($elm$svg$Svg$mask, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_7'), $elm$svg$Svg$Attributes$style('mask-type:alpha'), $elm$svg$Svg$Attributes$maskUnits('userSpaceOnUse'), $elm$svg$Svg$Attributes$x('0'), $elm$svg$Svg$Attributes$y('0'), $elm$svg$Svg$Attributes$width('64'), $elm$svg$Svg$Attributes$height('64')]), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$width('64'), $elm$svg$Svg$Attributes$height('64'), $elm$svg$Svg$Attributes$rx('16'), $elm$svg$Svg$Attributes$fill('#C4C4C4')]), _List_Nil)])), A2($elm$svg$Svg$clipPath, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_2')]), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$width('89'), $elm$svg$Svg$Attributes$height('182'), $elm$svg$Svg$Attributes$fill('white')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_10'), $elm$svg$Svg$Attributes$x1('-1.62477e-05'), $elm$svg$Svg$Attributes$y1('18.3334'), $elm$svg$Svg$Attributes$x2('62.0766'), $elm$svg$Svg$Attributes$y2('80.7063'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#75F5B1')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('0.505208'), $elm$svg$Svg$Attributes$stopColor('#7488ED')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#EE76D4')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_9'), $elm$svg$Svg$Attributes$x1('-1.62477e-05'), $elm$svg$Svg$Attributes$y1('18.3334'), $elm$svg$Svg$Attributes$x2('62.0766'), $elm$svg$Svg$Attributes$y2('80.7063'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#75F5B1')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('0.505208'), $elm$svg$Svg$Attributes$stopColor('#7488ED')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#EE76D4')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_11'), $elm$svg$Svg$Attributes$x1('284.4'), $elm$svg$Svg$Attributes$y1('4.59373'), $elm$svg$Svg$Attributes$x2('-16.7568'), $elm$svg$Svg$Attributes$y2('101.472'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#194175')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#337BD7')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_12'), $elm$svg$Svg$Attributes$x1('57.8275'), $elm$svg$Svg$Attributes$y1('1.16667'), $elm$svg$Svg$Attributes$x2('57.8275'), $elm$svg$Svg$Attributes$y2('168.583'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#4582D1')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#2968B9')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_13'), $elm$svg$Svg$Attributes$x1('256.423'), $elm$svg$Svg$Attributes$y1('178.5'), $elm$svg$Svg$Attributes$x2('256.423'), $elm$svg$Svg$Attributes$y2('-17.7188'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#255CA2')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#255CA2'), $elm$svg$Svg$Attributes$stopOpacity('0')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_14'), $elm$svg$Svg$Attributes$x1('-5.84917e-05'), $elm$svg$Svg$Attributes$y1('38.5'), $elm$svg$Svg$Attributes$x2('113.209'), $elm$svg$Svg$Attributes$y2('233.5'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#75F5B1')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('0.505208'), $elm$svg$Svg$Attributes$stopColor('#7488ED')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#EE76D4')]), _List_Nil)])), A2($elm$svg$Svg$mask, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_15'), $elm$svg$Svg$Attributes$style('mask-type:alpha'), $elm$svg$Svg$Attributes$maskUnits('userSpaceOnUse'), $elm$svg$Svg$Attributes$x('0'), $elm$svg$Svg$Attributes$y('0'), $elm$svg$Svg$Attributes$width('288'), $elm$svg$Svg$Attributes$height('168')]), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$width('288'), $elm$svg$Svg$Attributes$height('168'), $elm$svg$Svg$Attributes$rx('16'), $elm$svg$Svg$Attributes$fill('#E7E7E8')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_17'), $elm$svg$Svg$Attributes$x1('284.4'), $elm$svg$Svg$Attributes$y1('4.59373'), $elm$svg$Svg$Attributes$x2('-16.7568'), $elm$svg$Svg$Attributes$y2('101.472'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#194175')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#337BD7')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_18'), $elm$svg$Svg$Attributes$x1('57.827'), $elm$svg$Svg$Attributes$y1('1.16667'), $elm$svg$Svg$Attributes$x2('57.827'), $elm$svg$Svg$Attributes$y2('168.583'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#4582D1')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#2968B9')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_19'), $elm$svg$Svg$Attributes$x1('256.423'), $elm$svg$Svg$Attributes$y1('178.5'), $elm$svg$Svg$Attributes$x2('256.423'), $elm$svg$Svg$Attributes$y2('-17.7188'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#255CA2')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#255CA2'), $elm$svg$Svg$Attributes$stopOpacity('0')]), _List_Nil)])), A2($elm$svg$Svg$mask, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_20'), $elm$svg$Svg$Attributes$style('mask-type:alpha'), $elm$svg$Svg$Attributes$maskUnits('userSpaceOnUse'), $elm$svg$Svg$Attributes$x('0'), $elm$svg$Svg$Attributes$y('0'), $elm$svg$Svg$Attributes$width('288'), $elm$svg$Svg$Attributes$height('168')]), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$width('288'), $elm$svg$Svg$Attributes$height('168'), $elm$svg$Svg$Attributes$rx('16'), $elm$svg$Svg$Attributes$fill('#E7E7E8')]), _List_Nil)])), A2($elm$svg$Svg$filter, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_21'), $elm$svg$Svg$Attributes$x('0.822266'), $elm$svg$Svg$Attributes$y('-3.7624'), $elm$svg$Svg$Attributes$width('94.3555'), $elm$svg$Svg$Attributes$height('101.525'), $elm$svg$Svg$Attributes$filterUnits('userSpaceOnUse'), $elm$svg$Svg$Attributes$colorInterpolationFilters('sRGB')]), _List_fromArray([A2($elm$svg$Svg$feFlood, _List_fromArray([$elm$svg$Svg$Attributes$floodOpacity('0'), $elm$svg$Svg$Attributes$result('BackgroundImageFix')]), _List_Nil), A2($elm$svg$Svg$feColorMatrix, _List_fromArray([$elm$svg$Svg$Attributes$in_('SourceAlpha'), A2($elm$html$Html$Attributes$attribute, 'type', 'matrix'), $elm$svg$Svg$Attributes$values('0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'), $elm$svg$Svg$Attributes$result('hardAlpha')]), _List_Nil), A2($elm$svg$Svg$feOffset, _List_Nil, _List_Nil), A2($elm$svg$Svg$feGaussianBlur, _List_fromArray([$elm$svg$Svg$Attributes$stdDeviation('8')]), _List_Nil), A2($elm$svg$Svg$feColorMatrix, _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'type', 'matrix'), $elm$svg$Svg$Attributes$values('0 0 0 0 0.27451 0 0 0 0 0.321569 0 0 0 0 0.505882 0 0 0 0.15 0')]), _List_Nil), A2($elm$svg$Svg$feBlend, _List_fromArray([$elm$svg$Svg$Attributes$mode('normal'), $elm$svg$Svg$Attributes$in2('BackgroundImageFix'), $elm$svg$Svg$Attributes$result('effect1_dropShadow_6226_34742')]), _List_Nil), A2($elm$svg$Svg$feBlend, _List_fromArray([$elm$svg$Svg$Attributes$mode('normal'), $elm$svg$Svg$Attributes$in_('SourceGraphic'), $elm$svg$Svg$Attributes$in2('effect1_dropShadow_6226_34742'), $elm$svg$Svg$Attributes$result('shape')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_22'), $elm$svg$Svg$Attributes$x1('35.8008'), $elm$svg$Svg$Attributes$y1('34'), $elm$svg$Svg$Attributes$x2('59.3338'), $elm$svg$Svg$Attributes$y2('61.2661'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#75F5B1')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('0.505208'), $elm$svg$Svg$Attributes$stopColor('#7488ED')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#EE76D4')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_16'), $elm$svg$Svg$Attributes$x1('-6.49908e-06'), $elm$svg$Svg$Attributes$y1('7.33334'), $elm$svg$Svg$Attributes$x2('24.8306'), $elm$svg$Svg$Attributes$y2('32.2825'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#75F5B1')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('0.505208'), $elm$svg$Svg$Attributes$stopColor('#7488ED')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#EE76D4')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_23'), $elm$svg$Svg$Attributes$x1('6.64995'), $elm$svg$Svg$Attributes$y1('5.24997'), $elm$svg$Svg$Attributes$x2('47.8327'), $elm$svg$Svg$Attributes$y2('52.9657'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#75F5B1')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('0.505208'), $elm$svg$Svg$Attributes$stopColor('#7488ED')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#EE76D4')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_24'), $elm$svg$Svg$Attributes$x1('24.3158'), $elm$svg$Svg$Attributes$y1('-16.905'), $elm$svg$Svg$Attributes$x2('72.4276'), $elm$svg$Svg$Attributes$y2('12.2782'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#75F5B1')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('0.505208'), $elm$svg$Svg$Attributes$stopColor('#7488ED')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#EE76D4')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_25'), $elm$svg$Svg$Attributes$x1('-1.62477e-05'), $elm$svg$Svg$Attributes$y1('18.3334'), $elm$svg$Svg$Attributes$x2('62.0766'), $elm$svg$Svg$Attributes$y2('80.7063'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#75F5B1')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('0.505208'), $elm$svg$Svg$Attributes$stopColor('#7488ED')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#EE76D4')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_27'), $elm$svg$Svg$Attributes$x1('-1.62477e-05'), $elm$svg$Svg$Attributes$y1('18.3334'), $elm$svg$Svg$Attributes$x2('62.0766'), $elm$svg$Svg$Attributes$y2('80.7063'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#75F5B1')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('0.505208'), $elm$svg$Svg$Attributes$stopColor('#7488ED')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#EE76D4')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_26'), $elm$svg$Svg$Attributes$x1('22.064'), $elm$svg$Svg$Attributes$y1('31.0484'), $elm$svg$Svg$Attributes$x2('36.8582'), $elm$svg$Svg$Attributes$y2('39.5898'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#5B1B1B')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#491616')]), _List_Nil)])), A2($elm$svg$Svg$linearGradient, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1mxat_28'), $elm$svg$Svg$Attributes$x1('-3.52034e-05'), $elm$svg$Svg$Attributes$y1('18.3333'), $elm$svg$Svg$Attributes$x2('47.0932'), $elm$svg$Svg$Attributes$y2('120.856'), $elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse')]), _List_fromArray([A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$stopColor('#75F5B1')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('0.505208'), $elm$svg$Svg$Attributes$stopColor('#7488ED')]), _List_Nil), A2($elm$svg$Svg$stop, _List_fromArray([$elm$svg$Svg$Attributes$offset('1'), $elm$svg$Svg$Attributes$stopColor('#EE76D4')]), _List_Nil)]))]))]));
  var $author$project$IconSvg$svgDefinitions = A2($elm$svg$Svg$svg, _List_Nil, _List_fromArray([A2($elm$svg$Svg$defs, _List_Nil, _List_fromArray([A2($elm$svg$Svg$clipPath, _List_fromArray([$elm$svg$Svg$Attributes$id('generatedSvgId_1cHmF_1')]), _List_fromArray([A2($elm$svg$Svg$rect, _List_fromArray([$elm$svg$Svg$Attributes$width('32'), $elm$svg$Svg$Attributes$height('32'), $elm$svg$Svg$Attributes$transform('translate(4 4)')]), _List_Nil)]))]))]));
  var $author$project$ElmFramework$Lib$Ui$DramaticView$NoElement = {
    $: 0
  };
  var $author$project$ElmFramework$Lib$Ui$DramaticView$Shown = function (a) {
    return {
      $: 2,
      a: a
    };
  };
  var $author$project$ElmFramework$Lib$Ui$DramaticView$dramaticViewCore = F2(function (maybeStyles, element) {
    var toEnteringStyles = function (styles) {
      return _List_fromArray([A2($elm$html$Html$Attributes$attribute, 'entering-styles', styles)]);
    };
    var enteringStyles = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, toEnteringStyles, maybeStyles);
    var classes = _List_fromArray([$elm$html$Html$Attributes$class('inheritRadius')]);
    var _v0 = function () {
      switch (element.$) {
        case 0:
          return _Utils_Tuple2(_List_Nil, _List_Nil);
        case 1:
          var theElement = element.a;
          return _Utils_Tuple2(_List_Nil, _List_fromArray([theElement]));
        default:
          var theElement = element.a;
          return _Utils_Tuple2(_List_fromArray([A2($elm$html$Html$Attributes$attribute, 'child-state', 'shown')]), _List_fromArray([theElement]));
      }
    }();
    var shouldShow = _v0.a;
    var content = _v0.b;
    return A3($elm$html$Html$node, 'dramatic-view', _Utils_ap(classes, _Utils_ap(shouldShow, enteringStyles)), content);
  });
  var $author$project$ElmFramework$Lib$Ui$DramaticView$dramaticView = function (maybeEl) {
    var element = function () {
      if (!maybeEl.$) {
        var el = maybeEl.a;
        return $author$project$ElmFramework$Lib$Ui$DramaticView$Shown(el);
      } else {
        return $author$project$ElmFramework$Lib$Ui$DramaticView$NoElement;
      }
    }();
    return A2($author$project$ElmFramework$Lib$Ui$DramaticView$dramaticViewCore, $elm$core$Maybe$Nothing, element);
  };
  var $author$project$Ui$Curtain$curtain = F2(function (isBright, shouldShow) {
    var backgroundColorClass = isBright ? 'brightBack' : 'darkBack';
    return A3($elm$html$Html$node, 'curtain', _List_fromArray([$elm$html$Html$Attributes$class('inheritRadius')]), _List_fromArray([$author$project$ElmFramework$Lib$Ui$DramaticView$dramaticView(shouldShow ? $elm$core$Maybe$Just(A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('curtainPane z10 o0 flexCenter absoluteSpread inheritRadius'), $elm$html$Html$Attributes$class(backgroundColorClass)]), _List_fromArray([$author$project$Ui$Curtain$spinnerEl(!isBright)]))) : $elm$core$Maybe$Nothing)]));
  });
  var $author$project$Types$UserSessionStatus$isAuthenticating = function (userSessionStatus) {
    switch (userSessionStatus.$) {
      case 0:
        return false;
      case 1:
        return true;
      case 2:
        var authUser = userSessionStatus.a;
        return false;
      default:
        var userSession = userSessionStatus.a;
        return false;
    }
  };
  var $author$project$Ui$Auth$Helpers$shouldShowCurtain = F2(function (userSessionStatus, state) {
    return $author$project$Types$UserSessionStatus$isAuthenticating(userSessionStatus) || state.xm || state.xl;
  });
  var $author$project$MainModule$theCurtain = F2(function (_v0, currRoute) {
    var appState = _v0.lL;
    var shouldShowMain = A2($author$project$Ui$Auth$Helpers$shouldShowCurtain, appState.A$.sX, appState.tD);
    var shouldShowForMutation = A2($elm$core$List$any, function ($) {
      return $.b3;
    }, appState.A$.b9);
    var _v1 = function () {
      _v2$21: while (true) {
        switch (currRoute.$) {
          case 17:
            return _Utils_Tuple2(true, appState.Ae.vE.iz || $elm_community$maybe_extra$Maybe$Extra$isJust(appState.Ae.Ah));
          case 0:
            return _Utils_Tuple2(false, false);
          case 1:
            return _Utils_Tuple2(true, false);
          case 3:
            return _Utils_Tuple2(true, false);
          case 2:
            return _Utils_Tuple2(true, false);
          case 4:
            return _Utils_Tuple2(true, false);
          case 5:
            return _Utils_Tuple2(true, false);
          case 6:
            return _Utils_Tuple2(true, false);
          case 7:
            return _Utils_Tuple2(true, false);
          case 8:
            return _Utils_Tuple2(true, false);
          case 9:
            return _Utils_Tuple2(true, false);
          case 10:
            return _Utils_Tuple2(true, false);
          case 11:
            return _Utils_Tuple2(true, false);
          case 12:
            return _Utils_Tuple2(true, false);
          case 13:
            return _Utils_Tuple2(true, false);
          case 14:
            return _Utils_Tuple2(true, false);
          case 15:
            return _Utils_Tuple2(true, false);
          case 16:
            if (!currRoute.a.$ && !currRoute.a.a.$ && currRoute.a.a.a === 1) {
              var _v5 = currRoute.a.a.a;
              return _Utils_Tuple2(true, appState.AJ.iz);
            } else {
              return _Utils_Tuple2(true, false);
            }
          case 18:
            switch (currRoute.a.$) {
              case 1:
                if (!currRoute.a.a.$ && !currRoute.a.a.a) {
                  var _v3 = currRoute.a.a.a;
                  return _Utils_Tuple2(true, false);
                } else {
                  break _v2$21;
                }
              case 2:
                if (currRoute.a.a === 1) {
                  var _v4 = currRoute.a.a;
                  return _Utils_Tuple2(true, appState.AJ.iz);
                } else {
                  break _v2$21;
                }
              default:
                break _v2$21;
            }
          case 19:
            return _Utils_Tuple2(true, false);
          case 20:
            return _Utils_Tuple2(true, false);
          case 21:
            return _Utils_Tuple2(true, false);
          case 22:
            return _Utils_Tuple2(true, false);
          default:
            var uuid = currRoute.a;
            return _Utils_Tuple2(true, false);
        }
      }
      return _Utils_Tuple2(true, false);
    }();
    var isBright = _v1.a;
    var shouldShowForRoute = _v1.b;
    return A2($author$project$Ui$Curtain$curtain, isBright, shouldShowForRoute || shouldShowMain || shouldShowForMutation);
  });
  var $author$project$Types$General$Imperial = 0;
  var $author$project$MainModelSelectors$toMeasurementSystem = function (state) {
    var _v0 = state.nV.yl;
    if (!_v0.$) {
      var system = _v0.a;
      return system;
    } else {
      return 0;
    }
  };
  var $author$project$ElmFramework$Lib$TransitionableViewLayers$transitionableViewLayers = function (list) {
    var toView = function (kind) {
      if (!kind.$) {
        return A2($elm$html$Html$div, _List_Nil, _List_Nil);
      } else {
        var view = kind.a.Dl;
        return view;
      }
    };
    return A2($elm$core$List$map, toView, list.xA);
  };
  var $author$project$ElmFramework$Lib$Ui$NavBarBottom$SingleItem = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$NavBarBottom$SingleLayerIcon = function (a) {
    return {
      $: 0,
      a: a
    };
  };
  var $author$project$Ui$NavBarBottom$TwoLayersIcon = function (a) {
    return {
      $: 1,
      a: a
    };
  };
  var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
  var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
  var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
  var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
  var $elm$svg$Svg$Attributes$opacity = _VirtualDom_attribute('opacity');
  var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
  var $author$project$IconSvg$activeNotification_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$circle, _List_fromArray([$elm$svg$Svg$Attributes$opacity('0.5'), $elm$svg$Svg$Attributes$cx('20'), $elm$svg$Svg$Attributes$cy('20'), $elm$svg$Svg$Attributes$r('20')]), _List_Nil), A2($elm$svg$Svg$g, _List_fromArray([$elm$svg$Svg$Attributes$clipPath('url(#generatedSvgId_1cHmF_1)')]), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M10.4004 22.679C10.4004 27.5281 12.4722 29.5999 17.3213 29.5999H22.6795C27.5286 29.5999 29.6004 27.5281 29.6004 22.679V18.2139C29.6004 17.8477 29.2968 17.5441 28.9306 17.5441C28.5645 17.5441 28.2609 17.8477 28.2609 18.2139V22.679C28.2609 26.7958 26.7963 28.2604 22.6795 28.2604H17.3213C13.2045 28.2604 11.7399 26.7958 11.7399 22.679V17.3208C11.7399 13.204 13.2045 11.7394 17.3213 11.7394H21.7864C22.1526 11.7394 22.4562 11.4358 22.4562 11.0697C22.4562 10.7035 22.1526 10.3999 21.7864 10.3999H17.3213C12.4722 10.3999 10.4004 12.4717 10.4004 17.3208V22.679ZM22.9027 13.7487C22.9027 15.5973 24.403 17.0976 26.2516 17.0976C28.1001 17.0976 29.6004 15.5973 29.6004 13.7487C29.6004 11.9002 28.1001 10.3999 26.2516 10.3999C24.403 10.3999 22.9027 11.9002 22.9027 13.7487ZM24.2423 13.7487C24.2423 12.6414 25.1442 11.7394 26.2516 11.7394C27.3589 11.7394 28.2609 12.6414 28.2609 13.7487C28.2609 14.8561 27.3589 15.758 26.2516 15.758C25.1442 15.758 24.2423 14.8561 24.2423 13.7487ZM15.5353 21.5627H20.0004C20.3665 21.5627 20.6702 21.2591 20.6702 20.8929C20.6702 20.5268 20.3665 20.2232 20.0004 20.2232H15.5353C15.1691 20.2232 14.8655 20.5268 14.8655 20.8929C14.8655 21.2591 15.1691 21.5627 15.5353 21.5627ZM23.5725 25.1348H15.5353C15.1691 25.1348 14.8655 24.8312 14.8655 24.465C14.8655 24.0989 15.1691 23.7953 15.5353 23.7953H23.5725C23.9386 23.7953 24.2423 24.0989 24.2423 24.465C24.2423 24.8312 23.9386 25.1348 23.5725 25.1348Z')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M26.9004 17.7998C24.4167 17.7998 22.4004 15.7835 22.4004 13.2998C22.4004 10.8161 24.4167 8.7998 26.9004 8.7998C29.3841 8.7998 31.4004 10.8161 31.4004 13.2998C31.4004 15.7835 29.3841 17.7998 26.9004 17.7998Z'), $elm$svg$Svg$Attributes$stroke('white'), $elm$svg$Svg$Attributes$strokeWidth('2')]), _List_Nil)]))]));
  };
  var $author$project$IconSvg$activeNotification = function (classes) {
    return $author$project$IconSvg$activeNotification_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Types$UserSettings$hasUnreadNotifications = function (settings) {
    return settings.C3 > 0;
  };
  var $author$project$IconSvg$home2_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 40 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M25.79 30.75H14.21C11.47 30.75 9.25 28.52 9.25 25.78V18.37C9.25 17.01 10.09 15.3 11.17 14.46L16.56 10.26C18.18 8.99997 20.77 8.93997 22.45 10.12L28.63 14.45C29.82 15.28 30.75 17.06 30.75 18.51V25.79C30.75 28.52 28.53 30.75 25.79 30.75ZM17.48 11.44L12.09 15.64C11.38 16.2 10.75 17.47 10.75 18.37V25.78C10.75 27.69 12.3 29.25 14.21 29.25H25.79C27.7 29.25 29.25 27.7 29.25 25.79V18.51C29.25 17.55 28.56 16.22 27.77 15.68L21.59 11.35C20.45 10.55 18.57 10.59 17.48 11.44Z')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M20 26.75C19.59 26.75 19.25 26.41 19.25 26V23C19.25 22.59 19.59 22.25 20 22.25C20.41 22.25 20.75 22.59 20.75 23V26C20.75 26.41 20.41 26.75 20 26.75Z')]), _List_Nil)]));
  };
  var $author$project$IconSvg$home2 = function (classes) {
    return $author$project$IconSvg$home2_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$Route$RouteUtil$isMatchmakingRoute = function (route) {
    if (route.$ === 18) {
      return true;
    } else {
      return false;
    }
  };
  var $author$project$Route$RouteUtil$isMoreOptionsRoute = function (route) {
    if (route.$ === 6) {
      return true;
    } else {
      return false;
    }
  };
  var $author$project$Route$RouteUtil$isMyPlayerStatusRoute = function (route) {
    if (route.$ === 19) {
      return true;
    } else {
      return false;
    }
  };
  var $author$project$Route$RouteUtil$isNotificationsRoute = function (route) {
    if (route.$ === 11) {
      return true;
    } else {
      return false;
    }
  };
  var $author$project$Route$RouteUtil$isSupportRoute = function (route) {
    if (route.$ === 2) {
      return true;
    } else {
      return false;
    }
  };
  var $author$project$AssetsSvg$matchmakingActive_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 70 78'), $elm$svg$Svg$Attributes$fill('none')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$d('M29 2.4641C32.7128 0.320508 37.2872 0.320508 41 2.4641L63.641 15.5359C67.3538 17.6795 69.641 21.641 69.641 25.9282V52.0718C69.641 56.359 67.3538 60.3205 63.641 62.4641L41 75.5359C37.2872 77.6795 32.7128 77.6795 29 75.5359L6.35898 62.4641C2.64617 60.3205 0.358982 56.359 0.358982 52.0718V25.9282C0.358982 21.641 2.64617 17.6795 6.35898 15.5359L29 2.4641Z'), $elm$svg$Svg$Attributes$fill('url(#generatedSvgId_1mxat_1)')]), _List_Nil)]));
  };
  var $author$project$AssetsSvg$matchmakingActive = function (classes) {
    return $author$project$AssetsSvg$matchmakingActive_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$IconSvg$moreWithIndicator_custom = function (attributes) {
    return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([$elm$svg$Svg$Attributes$viewBox('0 0 41 40')]), attributes), _List_fromArray([A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M20.9587 21.1546C20.3357 21.1546 19.8463 20.654 19.8463 20.0421C19.8463 19.4303 20.3469 18.9297 20.9587 18.9297C21.5705 18.9297 22.0711 19.4303 22.0711 20.0421C22.0711 20.654 21.5817 21.1546 20.9587 21.1546ZM25.408 21.1546C24.7851 21.1546 24.2956 20.654 24.2956 20.0421C24.2956 19.4303 24.7962 18.9297 25.408 18.9297C26.0199 18.9297 26.5205 19.4303 26.5205 20.0421C26.5205 20.654 26.031 21.1546 25.408 21.1546ZM15.3965 20.0422C15.3965 20.654 15.886 21.1546 16.5089 21.1546C17.1319 21.1546 17.6213 20.654 17.6213 20.0422C17.6213 19.4304 17.1208 18.9298 16.5089 18.9298C15.8971 18.9298 15.3965 19.4304 15.3965 20.0422Z')]), _List_Nil), A2($elm$svg$Svg$path, _List_fromArray([$elm$svg$Svg$Attributes$fillRule('evenodd'), $elm$svg$Svg$Attributes$clipRule('evenodd'), $elm$svg$Svg$Attributes$d('M31.8004 14.9943C32.5169 16.5282 32.9173 18.2386 32.9173 20.0412C32.9173 26.6379 27.5554 31.9998 20.9586 31.9998C14.3619 31.9998 9 26.6379 9 20.0412C9 13.4444 14.3619 8.08252 20.9586 8.08252C22.114 8.08252 23.2315 8.247 24.289 8.55379C23.978 9.01839 23.7432 9.53819 23.6022 10.0954C22.7583 9.87086 21.8722 9.75117 20.9586 9.75117C15.2852 9.75117 10.6686 14.3678 10.6686 20.0412C10.6686 25.7146 15.2852 30.3312 20.9586 30.3312C26.632 30.3312 31.2486 25.7146 31.2486 20.0412C31.2486 18.5723 30.9392 17.1742 30.382 15.9088C30.9071 15.6854 31.386 15.3744 31.8004 14.9943Z')]), _List_Nil), A2($elm$svg$Svg$circle, _List_fromArray([$elm$svg$Svg$Attributes$cx('28.4312'), $elm$svg$Svg$Attributes$cy('11.3218'), $elm$svg$Svg$Attributes$r('3.32184')]), _List_Nil), A2($elm$svg$Svg$circle, _List_fromArray([$elm$svg$Svg$Attributes$cx('28.4344'), $elm$svg$Svg$Attributes$cy('11.3221'), $elm$svg$Svg$Attributes$r('1.66092')]), _List_Nil)]));
  };
  var $author$project$IconSvg$moreWithIndicator = function (classes) {
    return $author$project$IconSvg$moreWithIndicator_custom(_List_fromArray([$elm$svg$Svg$Attributes$class(classes)]));
  };
  var $author$project$ElmFramework$Feature$Browser$Browser$heightIsLessThan = F2(function (browser, units) {
    return _Utils_cmp($author$project$ElmFramework$Feature$Browser$Browser$toHeightInUnits(browser), units) < 0;
  });
  var $author$project$ElmFramework$Lib$Ui$NavBarBottom$navBarBtnContentAttrs = F2(function (classes, tapMsg) {
    return _List_fromArray([$elm$html$Html$Attributes$class('navBarBtnContent relative flexCenter center flex1 '), $elm$html$Html$Attributes$class(classes), $author$project$ElmFramework$Lib$Util$onTap(tapMsg)]);
  });
  var $author$project$ElmFramework$Lib$Ui$NavBarBottom$navBarBtnContent = F3(function (classes, tapMsg, content) {
    return A2($elm$html$Html$div, A2($author$project$ElmFramework$Lib$Ui$NavBarBottom$navBarBtnContentAttrs, classes, tapMsg), content);
  });
  var $author$project$ElmFramework$Lib$UiBehavior$SimpleSlider2$indexOf = F2(function (identifier, items) {
    return A2($elm$core$Maybe$withDefault, 0, A2($elm_community$list_extra$List$Extra$findIndex, A2($elm$core$Basics$composeL, $elm$core$Basics$eq(identifier), $elm$core$Tuple$first), items));
  });
  var $author$project$ElmFramework$Lib$UiBehavior$SimpleSlider2$toOffset = F2(function (length, index) {
    return !length ? '0' : $elm$core$String$fromFloat(index / length * 100);
  });
  var $author$project$ElmFramework$Lib$UiBehavior$SimpleSlider2$wrapView = F2(function (heightRatio, _v0) {
    var slide = _v0.b;
    return A3($elm$html$Html$node, 'simple-slider-slide-wrap', _Utils_ap(_List_fromArray([$elm$html$Html$Attributes$class('block relative'), A2($elm$html$Html$Attributes$style, 'height', $elm$core$String$fromFloat(heightRatio * 100) + '%')]), slide.lR), slide.fn);
  });
  var $author$project$ElmFramework$Lib$UiBehavior$SimpleSlider2$verticalSlider = function (config) {
    var viewsLength = $elm$core$List$length(config.B5);
    var wrapperOffset = function (offset) {
      return '-' + (offset + '%');
    }(A2($author$project$ElmFramework$Lib$UiBehavior$SimpleSlider2$toOffset, viewsLength, A2($author$project$ElmFramework$Lib$UiBehavior$SimpleSlider2$indexOf, config.u0, config.B5)));
    var wrapperSize = A3($author$project$ElmFramework$Lib$Util$flip, $elm$core$Basics$append, '00%', $elm$core$String$fromInt(viewsLength));
    return A3($elm$html$Html$node, 'vertical-slider-2', _Utils_ap(_List_fromArray([$elm$html$Html$Attributes$class('block noOverflow'), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('absoluteSpread', config.BX)]))]), config.Dw), _Utils_ap(config.tQ, _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('viewsWrap'), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('absolute top0 right0 left0', config.BX)])), A2($elm$html$Html$Attributes$style, 'height', wrapperSize), A2($elm$html$Html$Attributes$style, 'transform', 'translateY(' + (wrapperOffset + ')'))]), A2($elm$core$List$map, $author$project$ElmFramework$Lib$UiBehavior$SimpleSlider2$wrapView(1 / viewsLength), config.B5))])));
  };
  var $author$project$ElmFramework$Lib$Ui$NavBarBottom$toMenuItem = function (menuItem) {
    if (!menuItem.$) {
      var content = menuItem.a.fn;
      var tapMsg = menuItem.a.Cu;
      var classes = menuItem.a.uj;
      return A3($author$project$ElmFramework$Lib$Ui$NavBarBottom$navBarBtnContent, classes, tapMsg, content);
    } else {
      var topContent = menuItem.a.CU;
      var topTapMsg = menuItem.a.CY;
      var bottomContent = menuItem.a.tW;
      var bottomTapMsg = menuItem.a.tX;
      var showBottomItem = menuItem.a.B$;
      var behindContent = menuItem.a.tP;
      var itemToShow = showBottomItem ? 'bottomBtn' : 'topBtn';
      var btnsSlide = $author$project$ElmFramework$Lib$UiBehavior$SimpleSlider2$verticalSlider({
        tQ: _List_Nil,
        u0: itemToShow,
        BX: true,
        B5: _List_fromArray([_Utils_Tuple2('topBtn', {
          lR: A2($author$project$ElmFramework$Lib$Ui$NavBarBottom$navBarBtnContentAttrs, '', topTapMsg),
          fn: topContent
        }), _Utils_Tuple2('bottomBtn', {
          lR: A2($author$project$ElmFramework$Lib$Ui$NavBarBottom$navBarBtnContentAttrs, '', bottomTapMsg),
          fn: bottomContent
        })]),
        Dw: _List_Nil
      });
      return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('relative flex1')]), _Utils_ap(behindContent, _List_fromArray([btnsSlide])));
    }
  };
  var $author$project$ElmFramework$Lib$Ui$NavBarBottom$navBarBottom = function (config) {
    var shouldHide = function (browser) {
      return A2($author$project$ElmFramework$Feature$Browser$Browser$heightIsLessThan, browser, 33) ? true : config.BY;
    };
    var shouldDetach = $author$project$ElmFramework$Lib$Ui$NavBarBottom$shouldDetachFromEdges(config.t_);
    var heightString = $elm$core$String$fromInt(config.wy);
    var height = 'h' + heightString;
    var attachDetachStyles = shouldDetach ? {
      l4: A2($elm$core$String$join, ' ', _List_fromArray(['marBottom2', height])),
      r9: A2($elm$html$Html$Attributes$style, '', ''),
      s5: 'detached  gray0Back '
    } : {
      l4: height,
      r9: A2($elm$html$Html$Attributes$style, 'height', 'calc(' + (heightString + 'rem + env(safe-area-inset-bottom))')),
      s5: 'attached'
    };
    return A3($elm$html$Html$node, 'nav-bar-bottom', _List_fromArray([$elm$html$Html$Attributes$class('block absolute right0 bottom0 left0 noPointerEvents phoneWidthCenter z1 '), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('moveAwayBottom2', shouldHide(config.t_))]))]), _List_fromArray([A3($elm$html$Html$node, 'nav-bar-body', _List_fromArray([$elm$html$Html$Attributes$class('relative flexRow marLeftAuto marRightAuto yesPointerEvents pointer')]), A2($elm$core$List$cons, A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('flexRow flex1 gray0Back marRight2 marLeft2 h7 radius7 specialSearchShadow spaceBetween padRight1 padLeft1 z1'), $elm$html$Html$Attributes$class(config.s5)]), A2($elm$core$List$map, $author$project$ElmFramework$Lib$Ui$NavBarBottom$toMenuItem, config.ym)), config.uL)), A2($elm$html$Html$div, _List_fromArray([A2($elm$html$Html$Attributes$style, 'height', 'max(2rem, env(safe-area-inset-bottom))')]), _List_Nil)]));
  };
  var $author$project$Ui$NavBarBottom$shouldHide = F2(function (appState, currRoute) {
    var _v0 = appState.nV.dt;
    if (_v0.$ === 1) {
      switch (currRoute.$) {
        case 19:
          var myPlayerStatusRoute = currRoute.a;
          switch (myPlayerStatusRoute.$) {
            case 0:
              return false;
            case 1:
              return false;
            default:
              var searchesRoute = myPlayerStatusRoute.a;
              switch (searchesRoute.$) {
                case 0:
                  return false;
                case 1:
                  var searchId = searchesRoute.a;
                  return true;
                default:
                  var searchId = searchesRoute.a;
                  return true;
              }
          }
        case 11:
          return false;
        case 18:
          var matchMakingRoute = currRoute.a;
          var singleRoute = matchMakingRoute;
          if (!singleRoute.$) {
            return false;
          } else {
            return true;
          }
        case 2:
          return false;
        case 6:
          return false;
        default:
          return true;
      }
    } else {
      var dialog = _v0.a;
      return true;
    }
  });
  var $author$project$Ui$NavBarBottom$view = F5(function (browser, currRoute, maybeRole, maybeSession, appState) {
    var isEmailUnverified = function () {
      if (!maybeSession.$) {
        var userSession = maybeSession.a;
        return !userSession.nd;
      } else {
        return false;
      }
    }();
    var iconClass = function (isActive) {
      return isActive ? 'h4 primary0Fill' : 'h4 gray40Fill';
    };
    var toMenuItem = function (cfg) {
      var itemIcon = function () {
        var _v5 = cfg.wE;
        if (!_v5.$) {
          var _v6 = _v5.a;
          var f = _v6.a;
          var maybeSecond = _v6.b;
          var basicIcon = f;
          if (!maybeSecond.$) {
            var newIcon = maybeSecond.a;
            return A3($author$project$ElmFramework$Lib$Util$ifElse, newIcon, basicIcon, cfg.bA);
          } else {
            return basicIcon;
          }
        } else {
          var _v8 = _v5.a;
          var f = _v8.a;
          var s = _v8.b;
          return f;
        }
      }();
      var isActive = function () {
        var _v4 = cfg.c4;
        if (!_v4.$) {
          var status = _v4.a;
          return status;
        } else {
          return cfg.dc(currRoute);
        }
      }();
      var itemClasses = function () {
        var _v3 = cfg.uj;
        if (!_v3.$) {
          var _class = _v3.a;
          return _Utils_ap(_class, _Utils_ap(A3($author$project$ElmFramework$Lib$Util$ifElse, ' showIndicator ', '', cfg.bA), A3($author$project$ElmFramework$Lib$Util$ifElse, ' ', ' notActive', isActive)));
        } else {
          return '';
        }
      }();
      var additionalLayerIconClasses = 'selectLayer' + A3($author$project$ElmFramework$Lib$Util$ifElse, ' showLayer', '', cfg.bA);
      var additionalLayerIcon = function () {
        var _v1 = cfg.wE;
        if (!_v1.$) {
          var icons = _v1.a;
          return $author$project$ElmFramework$Lib$Util$noOpEl;
        } else {
          var _v2 = _v1.a;
          var f = _v2.a;
          var s = _v2.b;
          return A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('layerContainer')]), _List_fromArray([s(additionalLayerIconClasses)]));
        }
      }();
      return $author$project$ElmFramework$Lib$Ui$NavBarBottom$SingleItem({
        uj: itemClasses,
        fn: _List_fromArray([additionalLayerIcon, itemIcon(iconClass(isActive))]),
        Cu: $author$project$TopMsg$routeTo(cfg.rh)
      });
    };
    var areThereUnreadNotifications = function () {
      if (!maybeSession.$) {
        var userSession = maybeSession.a;
        return $author$project$Types$UserSettings$hasUnreadNotifications(userSession.kO);
      } else {
        return false;
      }
    }();
    var options = {
      n3: {
        uj: $elm$core$Maybe$Nothing,
        wE: $author$project$Ui$NavBarBottom$SingleLayerIcon(_Utils_Tuple2($author$project$IconSvg$home2, $elm$core$Maybe$Nothing)),
        c4: $elm$core$Maybe$Nothing,
        rh: $author$project$Route$Route$MyPlayerStatus($author$project$Ui$MyPlayerStatus$Route$Upcoming),
        dc: $author$project$Route$RouteUtil$isMyPlayerStatusRoute,
        bA: false
      },
      o6: {
        uj: $elm$core$Maybe$Just('midItem'),
        wE: $author$project$Ui$NavBarBottom$TwoLayersIcon(_Utils_Tuple2($author$project$AssetsSvg$matchmaking, $author$project$AssetsSvg$matchmakingActive)),
        c4: $elm$core$Maybe$Nothing,
        rh: $author$project$Route$Route$Matchmaking($author$project$Ui$Matchmaking$Single$Route$Main),
        dc: $author$project$Route$RouteUtil$isMatchmakingRoute,
        bA: $author$project$Route$RouteUtil$isMatchmakingRoute(currRoute)
      },
      pv: {
        uj: $elm$core$Maybe$Just('moreWithIndicatorSpecial'),
        wE: $author$project$Ui$NavBarBottom$SingleLayerIcon(_Utils_Tuple2($author$project$IconSvg$more, $elm$core$Maybe$Just($author$project$IconSvg$moreWithIndicator))),
        c4: $elm$core$Maybe$Nothing,
        rh: $author$project$Route$Route$MoreOptions,
        dc: $author$project$Route$RouteUtil$isMoreOptionsRoute,
        bA: isEmailUnverified
      },
      pK: {
        uj: $elm$core$Maybe$Just('notificationIcon'),
        wE: $author$project$Ui$NavBarBottom$SingleLayerIcon(_Utils_Tuple2($author$project$IconSvg$notifications, $elm$core$Maybe$Just($author$project$IconSvg$activeNotification))),
        c4: $elm$core$Maybe$Nothing,
        rh: $author$project$Route$Route$Notifications,
        dc: $author$project$Route$RouteUtil$isNotificationsRoute,
        bA: areThereUnreadNotifications
      },
      sc: {
        uj: $elm$core$Maybe$Nothing,
        wE: $author$project$Ui$NavBarBottom$SingleLayerIcon(_Utils_Tuple2($author$project$IconSvg$contactHelp, $elm$core$Maybe$Nothing)),
        c4: $elm$core$Maybe$Nothing,
        rh: $author$project$Route$Route$Support,
        dc: $author$project$Route$RouteUtil$isSupportRoute,
        bA: false
      }
    };
    var mvpNavBar = _List_fromArray([options.n3, options.pK, options.o6, options.sc, options.pv]);
    var theMenu = A2($elm$core$List$map, toMenuItem, mvpNavBar);
    return $author$project$ElmFramework$Lib$Ui$NavBarBottom$navBarBottom({
      t_: browser,
      uL: _List_fromArray([A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('navBarShade absoluteSpread radius2')]), _List_Nil)]),
      wy: $author$project$Ui$NavBarBottom$navBarHeight,
      ym: theMenu,
      BY: A2($author$project$Ui$NavBarBottom$shouldHide, appState, currRoute),
      s5: ' z1',
      Dx: ' gray0Back '
    });
  });
  var $author$project$Ui$PreventLandscapeSplash$view = A2($elm$html$Html$div, _List_Nil, _List_Nil);
  var $author$project$MainModule$view = function (topState) {
    var appState = topState.lL;
    var env = topState.vS;
    var browser = topState.t_;
    var geolocationAndPermissions = topState.wm;
    var pushNotificationsPermissions = topState.AO;
    var route = topState.rh;
    var zone = topState.DJ;
    var time = topState.Cy;
    var supportsPush = $author$project$ElmFramework$Feature$PushMessages$PushMessages$supportsPushNotifications(pushNotificationsPermissions);
    var measurementSystem = $author$project$MainModelSelectors$toMeasurementSystem(appState);
    var maybeSession = $author$project$Remote$Model$toSession(appState.A$);
    var maybeRole = $elm$core$Maybe$Just(0);
    var currRoute = $author$project$ElmFramework$Feature$Navigation$RouteHistory$current(route);
    var backgroundColorSplash = A2($elm$html$Html$div, _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread whiteBack'), $elm$html$Html$Attributes$classList(_List_fromArray([_Utils_Tuple2('o0', !$author$project$MainModule$shouldWhiteSplashBackground(currRoute))]))]), _List_Nil);
    return A3($elm$html$Html$node, 'top-app-node', _List_fromArray([$elm$html$Html$Attributes$class('absoluteSpread noOverflow')]), _Utils_ap(_List_fromArray([$author$project$Ui$SquircleSvg$squircleSvg, $author$project$AssetsSvg$svgDefinitions, $author$project$IconSvg$svgDefinitions, A5($author$project$Ui$NavBarBottom$view, browser, currRoute, maybeRole, maybeSession, appState)]), _Utils_ap($author$project$ElmFramework$Lib$TransitionableViewLayers$transitionableViewLayers({
      xA: _Utils_ap(A4($author$project$Views$Routed$RoutedViews$routedViews, env, browser, currRoute, topState), _List_fromArray([A2($author$project$MainModule$modal, topState, browser)]))
    }), _List_fromArray([A2($author$project$MainModule$theCurtain, topState, currRoute), $author$project$Ui$PreventLandscapeSplash$view]))));
  };
  var $author$project$MainModule$config = {
    tM: function (_v0) {
      return $author$project$Ui$Auth$Model$toBadgeCount;
    },
    wo: false,
    wM: $author$project$MainModule$init,
    xt: $elm$core$Basics$always(_List_Nil),
    yZ: F2(function (state, route) {
      return A3($author$project$MainModule$onNewRouteMsgs, state, state.rh, route);
    }),
    y6: F2(function (_v1, _v2) {
      return _List_Nil;
    }),
    y8: F2(function (geolocation, topState) {
      return A2($author$project$MainModule$explicitlyRequestedGeolocation, topState.rh, geolocation);
    }),
    zl: F2(function (geolocation, _v3) {
      return $author$project$MulticastMessages$onNewGeolocation($author$project$Model$Geo$GpsTypeGeolocation(geolocation));
    }),
    zp: F2(function (_v4, _v5) {
      return _List_Nil;
    }),
    zs: $author$project$PushMsgRouter$pushMsgRouter,
    zt: F2(function (permissions, _v6) {
      return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$UserSessionMsg($author$project$Ui$Auth$UserSession$Msg$ReceivePushPermissionsStatus(permissions)))]);
    }),
    zz: F2(function (state, route) {
      return $author$project$Remote$Model$isAuthenticated(state.lL.A$) ? A2($elm$core$List$cons, $author$project$TopMsg$requestMsg($author$project$Remote$RequestMsg$RefreshToken), A3($author$project$MainModule$onNewRouteMsgs, state, state.rh, route)) : _List_Nil;
    }),
    zJ: F3(function (_v7, _v8, event) {
      return _List_fromArray([$author$project$ElmFramework$Msg$AppMsg($author$project$Msg$AuthMsg($author$project$Ui$Auth$Msg$ReceiveSocialAuthEvent(event)))]);
    }),
    Ar: function (_v9) {
      return {
        lM: 'Tap to reload',
        lN: 'New version ready to go!',
        nQ: 'Please let us locate you',
        nR: 'Your location is unavailable at the moment',
        nS: 'Make sure your location services are ON and try again',
        nT: 'Locating you took too long',
        qQ: 'Push notifications do not seem to be supported on your device',
        rL: 'Copied to clipboard'
      };
    },
    Bz: $author$project$MainModule$routingConfig,
    Cb: $elm$core$List$concat(_List_Nil),
    Co: $author$project$MainModule$subscriptions,
    Cz: 60000,
    C5: $author$project$Update$update,
    Dl: $author$project$MainModule$view
  };
  var $author$project$MainModule$main = $author$project$ElmFramework$Main$app($author$project$MainModule$config);
  _Platform_export({
    'MainModule': {
      'init': $author$project$MainModule$main(A2($elm$json$Json$Decode$andThen, function (elmFrameworkArgs) {
        return A2($elm$json$Json$Decode$andThen, function (appArgs) {
          return $elm$json$Json$Decode$succeed({
            tt: appArgs,
            hN: elmFrameworkArgs
          });
        }, A2($elm$json$Json$Decode$field, 'appArgs', A2($elm$json$Json$Decode$andThen, function (preFetchedStaticData) {
          return A2($elm$json$Json$Decode$andThen, function (persistedStaticData) {
            return A2($elm$json$Json$Decode$andThen, function (persisted) {
              return A2($elm$json$Json$Decode$andThen, function (configArgs) {
                return $elm$json$Json$Decode$succeed({
                  uF: configArgs,
                  Ao: persisted,
                  Ap: persistedStaticData,
                  Ax: preFetchedStaticData
                });
              }, A2($elm$json$Json$Decode$field, 'configArgs', A2($elm$json$Json$Decode$andThen, function (termsOfUseUrl) {
                return A2($elm$json$Json$Decode$andThen, function (privacyPolicyUrl) {
                  return A2($elm$json$Json$Decode$andThen, function (googlePlayStoreUrl) {
                    return A2($elm$json$Json$Decode$andThen, function (firebase) {
                      return A2($elm$json$Json$Decode$andThen, function (facebookId) {
                        return A2($elm$json$Json$Decode$andThen, function (appleAppStoreUrl) {
                          return A2($elm$json$Json$Decode$andThen, function (appUrl) {
                            return A2($elm$json$Json$Decode$andThen, function (apiUrl) {
                              return $elm$json$Json$Decode$succeed({
                                ts: apiUrl,
                                tv: appUrl,
                                tx: appleAppStoreUrl,
                                v9: facebookId,
                                wf: firebase,
                                wq: googlePlayStoreUrl,
                                AB: privacyPolicyUrl,
                                Cx: termsOfUseUrl
                              });
                            }, A2($elm$json$Json$Decode$field, 'apiUrl', $elm$json$Json$Decode$string));
                          }, A2($elm$json$Json$Decode$field, 'appUrl', $elm$json$Json$Decode$string));
                        }, A2($elm$json$Json$Decode$field, 'appleAppStoreUrl', $elm$json$Json$Decode$string));
                      }, A2($elm$json$Json$Decode$field, 'facebookId', $elm$json$Json$Decode$string));
                    }, A2($elm$json$Json$Decode$field, 'firebase', A2($elm$json$Json$Decode$andThen, function (apiKey) {
                      return $elm$json$Json$Decode$succeed({
                        Y: apiKey
                      });
                    }, A2($elm$json$Json$Decode$field, 'apiKey', $elm$json$Json$Decode$string))));
                  }, A2($elm$json$Json$Decode$field, 'googlePlayStoreUrl', $elm$json$Json$Decode$string));
                }, A2($elm$json$Json$Decode$field, 'privacyPolicyUrl', $elm$json$Json$Decode$string));
              }, A2($elm$json$Json$Decode$field, 'termsOfUseUrl', $elm$json$Json$Decode$string))));
            }, A2($elm$json$Json$Decode$field, 'persisted', A2($elm$json$Json$Decode$andThen, function (auth) {
              return $elm$json$Json$Decode$succeed({
                bN: auth
              });
            }, A2($elm$json$Json$Decode$field, 'auth', $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, A2($elm$json$Json$Decode$andThen, function (refreshToken) {
              return A2($elm$json$Json$Decode$andThen, function (idToken) {
                return A2($elm$json$Json$Decode$andThen, function (expiresIn) {
                  return $elm$json$Json$Decode$succeed({
                    v3: expiresIn,
                    oe: idToken,
                    qW: refreshToken
                  });
                }, A2($elm$json$Json$Decode$field, 'expiresIn', $elm$json$Json$Decode$int));
              }, A2($elm$json$Json$Decode$field, 'idToken', $elm$json$Json$Decode$string));
            }, A2($elm$json$Json$Decode$field, 'refreshToken', $elm$json$Json$Decode$string)))]))))));
          }, A2($elm$json$Json$Decode$field, 'persistedStaticData', $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)]))));
        }, A2($elm$json$Json$Decode$field, 'preFetchedStaticData', $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)]))))));
      }, A2($elm$json$Json$Decode$field, 'elmFrameworkArgs', A2($elm$json$Json$Decode$andThen, function (timezoneOffset) {
        return A2($elm$json$Json$Decode$andThen, function (seeds) {
          return A2($elm$json$Json$Decode$andThen, function (navigationLocation) {
            return A2($elm$json$Json$Decode$andThen, function (geolocationAccessAllowed) {
              return A2($elm$json$Json$Decode$andThen, function (env) {
                return A2($elm$json$Json$Decode$andThen, function (currTime) {
                  return A2($elm$json$Json$Decode$andThen, function (browser) {
                    return $elm$json$Json$Decode$succeed({
                      t_: browser,
                      u2: currTime,
                      vS: env,
                      wl: geolocationAccessAllowed,
                      yA: navigationLocation,
                      BM: seeds,
                      CB: timezoneOffset
                    });
                  }, A2($elm$json$Json$Decode$field, 'browser', A2($elm$json$Json$Decode$andThen, function (width) {
                    return A2($elm$json$Json$Decode$andThen, function (unitSize) {
                      return A2($elm$json$Json$Decode$andThen, function (pixelRatio) {
                        return A2($elm$json$Json$Decode$andThen, function (height) {
                          return $elm$json$Json$Decode$succeed({
                            ij: height,
                            qs: pixelRatio,
                            gO: unitSize,
                            lt: width
                          });
                        }, A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int));
                      }, A2($elm$json$Json$Decode$field, 'pixelRatio', $elm$json$Json$Decode$float));
                    }, A2($elm$json$Json$Decode$field, 'unitSize', $elm$json$Json$Decode$int));
                  }, A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int))));
                }, A2($elm$json$Json$Decode$field, 'currTime', $elm$json$Json$Decode$int));
              }, A2($elm$json$Json$Decode$field, 'env', A2($elm$json$Json$Decode$andThen, function (supportsWebShare) {
                return A2($elm$json$Json$Decode$andThen, function (supportsWebPayments) {
                  return A2($elm$json$Json$Decode$andThen, function (referrer) {
                    return A2($elm$json$Json$Decode$andThen, function (pwaInstallStatus) {
                      return A2($elm$json$Json$Decode$andThen, function (osVersion) {
                        return A2($elm$json$Json$Decode$andThen, function (isWeb) {
                          return A2($elm$json$Json$Decode$andThen, function (isProd) {
                            return A2($elm$json$Json$Decode$andThen, function (isIos) {
                              return A2($elm$json$Json$Decode$andThen, function (isHybridIos) {
                                return A2($elm$json$Json$Decode$andThen, function (isHybridAndroid) {
                                  return A2($elm$json$Json$Decode$andThen, function (isHybrid) {
                                    return A2($elm$json$Json$Decode$andThen, function (isDev) {
                                      return A2($elm$json$Json$Decode$andThen, function (isAndroid) {
                                        return A2($elm$json$Json$Decode$andThen, function (isActiveDevelopment) {
                                          return A2($elm$json$Json$Decode$andThen, function (browserVersion) {
                                            return A2($elm$json$Json$Decode$andThen, function (browserName) {
                                              return $elm$json$Json$Decode$succeed({
                                                e9: browserName,
                                                fa: browserVersion,
                                                fL: isActiveDevelopment,
                                                fM: isAndroid,
                                                fN: isDev,
                                                xd: isHybrid,
                                                fO: isHybridAndroid,
                                                fP: isHybridIos,
                                                fQ: isIos,
                                                fR: isProd,
                                                fS: isWeb,
                                                f7: osVersion,
                                                gi: pwaInstallStatus,
                                                c8: referrer,
                                                gD: supportsWebPayments,
                                                Cs: supportsWebShare
                                              });
                                            }, A2($elm$json$Json$Decode$field, 'browserName', $elm$json$Json$Decode$string));
                                          }, A2($elm$json$Json$Decode$field, 'browserVersion', $elm$json$Json$Decode$string));
                                        }, A2($elm$json$Json$Decode$field, 'isActiveDevelopment', $elm$json$Json$Decode$bool));
                                      }, A2($elm$json$Json$Decode$field, 'isAndroid', $elm$json$Json$Decode$bool));
                                    }, A2($elm$json$Json$Decode$field, 'isDev', $elm$json$Json$Decode$bool));
                                  }, A2($elm$json$Json$Decode$field, 'isHybrid', $elm$json$Json$Decode$bool));
                                }, A2($elm$json$Json$Decode$field, 'isHybridAndroid', $elm$json$Json$Decode$bool));
                              }, A2($elm$json$Json$Decode$field, 'isHybridIos', $elm$json$Json$Decode$bool));
                            }, A2($elm$json$Json$Decode$field, 'isIos', $elm$json$Json$Decode$bool));
                          }, A2($elm$json$Json$Decode$field, 'isProd', $elm$json$Json$Decode$bool));
                        }, A2($elm$json$Json$Decode$field, 'isWeb', $elm$json$Json$Decode$bool));
                      }, A2($elm$json$Json$Decode$field, 'osVersion', $elm$json$Json$Decode$string));
                    }, A2($elm$json$Json$Decode$field, 'pwaInstallStatus', $elm$json$Json$Decode$bool));
                  }, A2($elm$json$Json$Decode$field, 'referrer', $elm$json$Json$Decode$string));
                }, A2($elm$json$Json$Decode$field, 'supportsWebPayments', $elm$json$Json$Decode$bool));
              }, A2($elm$json$Json$Decode$field, 'supportsWebShare', $elm$json$Json$Decode$bool))));
            }, A2($elm$json$Json$Decode$field, 'geolocationAccessAllowed', $elm$json$Json$Decode$oneOf(_List_fromArray([$elm$json$Json$Decode$null($elm$core$Maybe$Nothing), A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$bool)]))));
          }, A2($elm$json$Json$Decode$field, 'navigationLocation', A2($elm$json$Json$Decode$andThen, function (search) {
            return A2($elm$json$Json$Decode$andThen, function (protocol) {
              return A2($elm$json$Json$Decode$andThen, function (port_) {
                return A2($elm$json$Json$Decode$andThen, function (pathname) {
                  return A2($elm$json$Json$Decode$andThen, function (origin) {
                    return A2($elm$json$Json$Decode$andThen, function (href) {
                      return A2($elm$json$Json$Decode$andThen, function (hostname) {
                        return A2($elm$json$Json$Decode$andThen, function (host) {
                          return A2($elm$json$Json$Decode$andThen, function (hash) {
                            return $elm$json$Json$Decode$succeed({
                              ii: hash,
                              ik: host,
                              il: hostname,
                              im: href,
                              j_: origin,
                              j9: pathname,
                              kc: port_,
                              ke: protocol,
                              kH: search
                            });
                          }, A2($elm$json$Json$Decode$field, 'hash', $elm$json$Json$Decode$string));
                        }, A2($elm$json$Json$Decode$field, 'host', $elm$json$Json$Decode$string));
                      }, A2($elm$json$Json$Decode$field, 'hostname', $elm$json$Json$Decode$string));
                    }, A2($elm$json$Json$Decode$field, 'href', $elm$json$Json$Decode$string));
                  }, A2($elm$json$Json$Decode$field, 'origin', $elm$json$Json$Decode$string));
                }, A2($elm$json$Json$Decode$field, 'pathname', $elm$json$Json$Decode$string));
              }, A2($elm$json$Json$Decode$field, 'port_', $elm$json$Json$Decode$string));
            }, A2($elm$json$Json$Decode$field, 'protocol', $elm$json$Json$Decode$string));
          }, A2($elm$json$Json$Decode$field, 'search', $elm$json$Json$Decode$string))));
        }, A2($elm$json$Json$Decode$field, 'seeds', $elm$json$Json$Decode$list($elm$json$Json$Decode$int)));
      }, A2($elm$json$Json$Decode$field, 'timezoneOffset', $elm$json$Json$Decode$int)))))(0)
    }
  });
})(this);